const words = `
菝__菝 2.53953332627|ba;
鲅__鮁 5.56816311706|ba;
魃__魃 15.0706966208|ba;
岜__岜 17.220353906|ba;
茇__茇 17.8986127844|ba;
笆__笆 23.4271398256|ba;
钯__鈀 47.7250412134|ba;
粑__粑 49.4813119117|ba;
耙__耙 52.3353762659|ba;
跋__跋 88.8805477159|ba;
灞__灞 113.895394799|ba;
叭__叭 131.609045271|ba;
捌__捌 176.827946446|ba;
靶__靶 186.561765129|ba;
疤__疤 250.349428094|ba;
芭__芭 284.636464248|ba;
扒__扒 523.526794166|ba;
坝__壩 701.651845929|ba;
霸__霸 793.781168439|ba;
罢__罷 1274.55334676|ba;
拔__拔 1815.76539105|ba;
巴__巴 3193.1902591|ba;
爸__爸 3625.99770514|ba;
八__八 6677.54934466|ba;
把__把 165484.231697|ba;
吧__吧 385205.434615|ba;
擘__擘 3.22600425573|bai;
捭__捭 12.0125259855|bai;
稗__稗 39.5389038333|bai;
伯__伯 133.758497151|bai;
佰__佰 274.533686805|bai;
呗__唄 309.4219738|bai;
掰__掰 381.481335404|bai;
柏__柏 794.770968525|bai;
败__敗 1469.11294508|bai;
拜__拜 2033.8046114|bai;
摆__擺 2364.80218582|bai;
百__百 4588.96700128|bai;
白__白 15236.7956171|bai;
舨__舨 3.28687345769|ban;
癍__癍 12.2391818769|ban;
瘢__瘢 13.8462289345|ban;
钣__鈑 14.8285158408|ban;
阪__阪 65.6590112015|ban;
坂__坂 155.140277726|ban;
颁__頒 177.269210225|ban;
扳__扳 260.859291326|ban;
绊__絆 365.655730945|ban;
瓣__瓣 404.996293994|ban;
拌__拌 647.865219539|ban;
扮__扮 770.392265767|ban;
斑__斑 989.677650042|ban;
伴__伴 1657.87544242|ban;
搬__搬 3708.2515163|ban;
般__般 4577.54400842|ban;
板__板 5076.35979838|ban;
班__班 11860.7402097|ban;
半__半 13186.0302513|ban;
版__版 17087.7286512|ban;
办__辦 17518.9633248|ban;
蒡__蒡 3.82657101926|bang;
旁__旁 6.03043937487|bang;
梆__梆 36.23601235|bang;
膀__膀 52.3353762659|bang;
谤__謗 57.9660911582|bang;
蚌__蚌 95.3046526662|bang;
镑__鎊 244.186999878|bang;
傍__傍 514.472385324|bang;
磅__磅 528.772109212|bang;
绑__綁 1046.76190254|bang;
浜__浜 1173.92027842|bang;
邦__邦 1708.20809643|bang;
榜__榜 2403.42436786|bang;
棒__棒 2554.75594355|bang;
帮__幫 30125.3295903|bang;
炮__炮 1.00609715056|bao;
趵__趵 3.86009684414|bao;
瀑__瀑 4.18056718353|bao;
褓__褓 6.77143721241|bao;
龅__齙 9.9768871382|bao;
鸨__鴇 10.7113360133|bao;
剥__剝 12.7529922283|bao;
刨__刨 15.2787056066|bao;
雹__雹 35.1683118304|bao;
勹__勹 37.9932216791|bao;
孢__孢 72.3616047933|bao;
葆__葆 167.393257695|bao;
褒__褒 181.742866823|bao;
苞__苞 200.795341333|bao;
曝__曝 263.801426189|bao;
胞__胞 271.810366771|bao;
豹__豹 454.760723981|bao;
煲__煲 584.932834985|bao;
鲍__鮑 607.214449729|bao;
堡__堡 873.722339551|bao;
薄__薄 962.913535809|bao;
饱__飽 1411.68136652|bao;
暴__暴 1813.50405438|bao;
爆__爆 4354.9622946|bao;
保__保 4532.13567457|bao;
抱__抱 4769.71285751|bao;
宝__寶 5580.63786311|bao;
报__報 11312.1738491|bao;
包__包 15389.4559856|bao;
夯__夯 4.87915266687|ben;
坌__坌 6.10605888297|ben;
畚__畚 9.15486694475|ben;
贲__賁 55.4230854052|ben;
锛__錛 110.95347192|ben;
苯__苯 639.044983668|ben;
奔__奔 1469.11294508|ben;
笨__笨 5349.12727725|ben;
本__本 24833.9216685|ben;
甏__甏 4.41619405836|beng;
蚌__蚌 36.9657609447|beng;
嘣__嘣 64.6844514367|beng;
迸__迸 76.9178520459|beng;
绷__綳 134.42690308|beng;
甭__甭 252.228305921|beng;
崩__崩 561.366244489|beng;
蹦__蹦 660.912425973|beng;
泵__泵 852.21539528|beng;
庳__庳 2.63627076316|bei;
鐾__鐾 3.45056259558|bei;
鞴__鞴 3.93293029252|bei;
褙__褙 3.95258357798|bei;
鹎__鵯 4.05738603128|bei;
邶__邶 5.652055113|bei;
碚__碚 13.8462289345|bei;
臂__臂 17.0495313912|bei;
狈__狽 23.7504862321|bei;
孛__孛 28.6677885418|bei;
陂__陂 39.9350516705|bei;
悖__悖 54.0588291018|bei;
钡__鋇 86.8008265922|bei;
惫__憊 87.7798208106|bei;
焙__焙 91.0100983184|bei;
蓓__蓓 163.884358899|bei;
辈__輩 421.472799973|bei;
卑__卑 457.033213363|bei;
碑__碑 550.284199441|bei;
悲__悲 983.530305889|bei;
备__備 1571.37615922|bei;
贝__貝 2074.76292775|bei;
杯__杯 2948.4094145|bei;
倍__倍 3368.96527446|bei;
背__背 5608.52492462|bei;
北__北 6464.66198571|bei;
呗__唄 8019.99283537|bei;
被__被 138128.135659|bei;
舭__舭 1.65210940388|bi;
秘__秘 1.87837688647|bi;
庳__庳 2.63627076316|bi;
狴__狴 2.93449578971|bi;
荸__荸 3.05768819977|bi;
贲__賁 3.31567081789|bi;
睥__睥 3.52883675546|bi;
萆__萆 4.45488576117|bi;
筚__篳 6.36239597244|bi;
愎__愎 6.57191561603|bi;
泌__泌 6.93367876657|bi;
跸__蹕 7.49996990053|bi;
箅__箅 8.19379227141|bi;
裨__裨 8.76415245811|bi;
襞__襞 9.90256815184|bi;
秕__秕 11.0365293033|bi;
毖__毖 12.1783254446|bi;
髀__髀 13.3049425837|bi;
嬖__嬖 13.4717817062|bi;
芘__芘 14.791604259|bi;
蓖__蓖 14.9957611522|bi;
篦__篦 22.3993777295|bi;
薜__薜 27.2059350468|bi;
妣__妣 30.4349047749|bi;
哔__嗶 35.9660861025|bi;
濞__濞 41.9238517455|bi;
匕__匕 41.9238517455|bi;
铋__鉍 43.9568840418|bi;
荜__蓽 47.9635284962|bi;
陛__陛 58.7661515758|bi;
滗__潷 59.8749686961|bi;
婢__婢 67.0648245868|bi;
吡__吡 80.7484275309|bi;
鄙__鄙 87.5613166753|bi;
庇__庇 93.0746135358|bi;
敝__敝 103.474542736|bi;
痹__痹 113.046974828|bi;
弼__弼 113.895394799|bi;
蔽__蔽 122.279808036|bi;
辟__辟 180.839193473|bi;
毙__斃 198.308623594|bi;
璧__璧 212.377144726|bi;
畀__畀 212.907119447|bi;
弊__弊 451.373158744|bi;
臂__臂 655.172250234|bi;
彼__彼 847.977956119|bi;
闭__閉 854.342048866|bi;
鼻__鼻 879.183352683|bi;
避__避 1029.9408079|bi;
壁__壁 1041.55712696|bi;
毕__畢 1112.67124847|bi;
碧__碧 1203.54593192|bi;
俾__俾 1617.0663282|bi;
币__幣 2376.61936257|bi;
逼__逼 3237.26335565|bi;
笔__筆 3249.38851373|bi;
必__必 3878.39911581|bi;
比__比 68654.2045949|bi;
窆__窆 2.79877359639|bian;
缏__緶 2.80925639268|bian;
碥__碥 2.98614117512|bian;
鳊__鯿 4.95266377765|bian;
蝙__蝙 5.70157459376|bian;
忭__忭 7.22475998089|bian;
笾__籩 8.77508085903|bian;
褊__褊 11.7900675064|bian;
砭__砭 27.8230870766|bian;
汴__汴 45.2914032579|bian;
苄__苄 49.2352778104|bian;
弁__弁 54.3289670197|bian;
煸__煸 56.8926243042|bian;
匾__匾 111.230349808|bian;
辫__辮 129.655606164|bian;
卞__卞 249.104624871|bian;
贬__貶 292.183578474|bian;
辨__辨 506.83620443|bian;
鞭__鞭 530.091629029|bian;
辩__辯 587.855808729|bian;
扁__扁 1723.1742594|bian;
编__編 2919.16177455|bian;
遍__遍 3213.14860644|bian;
变__變 13218.9352172|bian;
边__邊 14352.1143909|bian;
便__便 16095.5782598|bian;
瘭__瘭 1.80945021625|biao;
鳔__鰾 8.04205244843|biao;
飑__颮 13.8117624904|biao;
杓__杓 18.4880308256|biao;
镳__鑣 28.2071072894|biao;
骠__驃 38.8066877763|biao;
婊__婊 40.5872748646|biao;
裱__裱 75.2117146793|biao;
膘__膘 110.126966673|biao;
镖__鏢 208.184564378|biao;
飚__飈 261.510250403|biao;
飙__飆 443.014235191|biao;
彪__彪 786.88699725|biao;
标__標 3068.35985866|biao;
表__表 18141.0363608|biao;
蹩__蹩 40.2849355593|bie;
瘪__癟 165.114314527|bie;
鳖__鱉 255.709615075|bie;
憋__憋 1261.91002891|bie;
别__別 48130.926341|bie;
傧__儐 8.24500580364|bin;
髌__髕 13.0585500019|bin;
豳__豳 14.3200322192|bin;
膑__臏 15.1838025222|bin;
玢__玢 15.664286848|bin;
摈__擯 18.6267838935|bin;
槟__檳 25.0578753144|bin;
缤__繽 25.5306747134|bin;
殡__殯 35.2560722919|bin;
濒__瀕 47.8441362574|bin;
镔__鑌 61.6159251321|bin;
鬓__鬢 180.839193473|bin;
滨__濱 643.039196578|bin;
宾__賓 813.813436628|bin;
彬__彬 967.72532071|bin;
斌__斌 1546.12469848|bin;
槟__檳 13.8117624904|bing;
屏__屏 15.7425630131|bing;
邴__邴 20.3753232882|bing;
摒__摒 56.9635661792|bing;
禀__稟 101.938696792|bing;
秉__秉 338.890182508|bing;
炳__炳 439.714170908|bing;
柄__柄 549.598880816|bing;
丙__丙 683.528148986|bing;
饼__餅 1276.14264248|bing;
兵__兵 4611.89857437|bing;
冰__冰 4841.57510783|bing;
病__病 8090.25858348|bing;
并__並 79035.6636846|bing;
鹁__鵓 3.05007691155|bo;
饽__餑 5.58205814187|bo;
檗__檗 6.00793666999|bo;
踣__踣 6.80527482932|bo;
孛__孛 9.69499043963|bo;
魄__魄 10.6315460323|bo;
礴__礴 12.285023688|bo;
擘__擘 14.3557670206|bo;
簸__簸 19.9730898929|bo;
钹__鈸 21.3900319912|bo;
亳__亳 25.4354064912|bo;
菠__菠 30.5488985997|bo;
箔__箔 55.1475072429|bo;
跛__跛 59.4289531284|bo;
舶__舶 70.9330996563|bo;
渤__渤 106.483223576|bo;
帛__帛 120.765453341|bo;
铂__鉑 175.073848088|bo;
脖__脖 175.510734618|bo;
玻__玻 183.563783354|bo;
钵__缽 237.287502254|bo;
卜__卜 246.633556117|bo;
驳__駁 263.472890441|bo;
膊__膊 272.488653616|bo;
泊__泊 339.31275934|bo;
勃__勃 347.442588754|bo;
柏__柏 380.531740742|bo;
搏__搏 455.895552723|bo;
剥__剝 503.060722916|bo;
啵__啵 792.79260104|bo;
薄__薄 1255.63548024|bo;
伯__伯 1525.07528247|bo;
拨__撥 1684.95202731|bo;
播__播 1755.68762073|bo;
博__博 5007.24867861|bo;
波__波 5395.99270938|bo;
醭__醭 3.20996371381|bu;
钸__鈽 5.90402925683|bu;
晡__晡 6.37032951928|bu;
瓿__瓿 8.65561421593|bu;
埔__埔 8.94065167877|bu;
堡__堡 12.4235818981|bu;
逋__逋 17.2633262902|bu;
钚__鈈 60.3995526397|bu;
怖__怖 72.1814801389|bu;
哺__哺 85.4059679188|bu;
卟__卟 139.895806636|bu;
埠__埠 258.593668656|bu;
簿__簿 293.277951001|bu;
捕__捕 420.94790182|bu;
卜__卜 487.62990282|bu;
步__步 3931.92961191|bu;
布__布 4781.61539648|bu;
补__補 7071.51479616|bu;
部__部 13825.4663776|bu;
不__不 590643.069554|bu;
钯__鈀 5.97806362819|pa;
筢__筢 7.02062456687|pa;
杷__杷 12.5793690793|pa;
葩__葩 36.2811966018|pa;
琶__琶 45.2349977818|pa;
耙__耙 63.249666706|pa;
扒__扒 203.060037258|pa;
啪__啪 244.186999878|pa;
趴__趴 680.977550057|pa;
帕__帕 1079.88619313|pa;
爬__爬 3501.65886607|pa;
怕__怕 22787.7939724|pa;
蒎__蒎 7.15309178664|pai;
迫__迫 7.98214626949|pai;
俳__俳 16.9014523075|pai;
徘__徘 26.9025116304|pai;
湃__湃 29.1723246169|pai;
哌__哌 120.765453341|pai;
牌__牌 5771.60137838|pai;
排__排 5969.09946282|pai;
派__派 6066.58738271|pai;
拍__拍 18299.9758408|pai;
蹒__蹣 6.92504363002|pan;
拚__拚 7.15309178664|pan;
襻__襻 7.88329265768|pan;
袢__袢 21.9025305827|pan;
爿__爿 29.611845602|pan;
胖__胖 31.9107983716|pan;
蟠__蟠 32.1102499377|pan;
泮__泮 47.4285989798|pan;
番__番 112.484875527|pan;
磐__磐 119.56748386|pan;
叛__叛 135.94305409|pan;
畔__畔 469.151414294|pan;
攀__攀 534.735933039|pan;
盼__盼 1100.26180506|pan;
判__判 1165.17561047|pan;
潘__潘 2491.86983978|pan;
盘__盤 10536.5270626|pan;
耪__耪 6.62123798367|pang;
螃__螃 9.67085738167|pang;
磅__磅 11.8342271613|pang;
膀__膀 12.2697240382|pang;
彷__彷 18.7665783061|pang;
乓__乓 25.2459352061|pang;
逄__逄 25.5943850163|pang;
滂__滂 32.7161156259|pang;
庞__龐 706.917758081|pang;
旁__旁 2491.86983978|pang;
胖__胖 4710.6431127|pang;
脬__脬 6.49862009853|pao;
匏__匏 12.3926567493|pao;
狍__狍 12.7848165731|pao;
咆__咆 20.2487627616|pao;
庖__庖 25.3720919224|pao;
疱__皰 71.6437919439|pao;
刨__刨 308.651751439|pao;
袍__袍 317.626273928|pao;
炮__炮 1292.14500531|pao;
抛__拋 3004.04087494|pao;
泡__泡 5700.12390567|pao;
跑__跑 21815.2488467|pao;
湓__湓 9.9768871382|pen;
盆__盆 1202.04704744|pen;
喷__噴 2059.3077787|pen;
蟛__蟛 6.83076396136|peng;
抨__抨 9.36254018618|peng;
怦__怦 10.3054353528|peng;
堋__堋 11.1055107505|peng;
嘭__嘭 34.8628669901|peng;
篷__篷 91.123582748|peng;
膨__膨 91.9219458942|peng;
砰__砰 103.732757395|peng;
澎__澎 108.898738333|peng;
硼__硼 130.954650472|peng;
烹__烹 211.321149687|peng;
蓬__蓬 402.480675297|peng;
棚__棚 651.102673334|peng;
朋__朋 706.037369534|peng;
捧__捧 1354.80557722|peng;
鹏__鵬 1549.98296207|peng;
彭__彭 2213.66066021|peng;
碰__碰 2812.04370767|peng;
锫__錇 4.98361933493|pei;
帔__帔 6.14422348771|pei;
旆__旆 12.1177716064|pei;
醅__醅 16.5677973048|pei;
霈__霈 46.0311069133|pei;
辔__轡 49.3581415614|pei;
胚__胚 224.06783424|pei;
沛__沛 290.368691563|pei;
呸__呸 416.772181646|pei;
裴__裴 717.56844134|pei;
佩__佩 919.523371782|pei;
培__培 1119.62576025|pei;
赔__賠 1866.23446282|pei;
配__配 6736.05351167|pei;
陪__陪 9129.7548451|pei;
否__否 0.755375990725|pi;
睥__睥 3.52883675546|pi;
疋__疋 4.1597803036|pi;
貔__貔 4.86700733523|pi;
蚍__蚍 5.22529224041|pi;
埤__埤 5.53357668886|pi;
陴__陴 5.68738206506|pi;
纰__紕 7.7856632826|pi;
郫__郫 7.91281950157|pi;
砒__砒 8.16321697203|pi;
庀__庀 8.72057478626|pi;
裨__裨 8.76415245811|pi;
枇__枇 8.90728945859|pi;
甓__甓 9.70707954272|pi;
淠__淠 10.2032074664|pi;
仳__仳 10.5129741099|pi;
鼙__鼙 11.3150528103|pi;
媲__媲 12.4081096892|pi;
罴__羆 17.0282980696|pi;
蜱__蜱 19.9482155997|pi;
琵__琵 22.9360599347|pi;
霹__霹 24.9022292984|pi;
陂__陂 25.0891210634|pi;
邳__邳 25.7543572024|pi;
铍__鈹 27.1044155572|pi;
圮__圮 34.1746320521|pi;
噼__噼 35.300034614|pi;
譬__譬 38.2306901208|pi;
僻__僻 84.6641975332|pi;
毗__毗 128.689786556|pi;
啤__啤 132.266710153|pi;
丕__丕 143.784200776|pi;
痞__痞 152.267254161|pi;
疲__疲 175.292155245|pi;
辟__辟 180.839193473|pi;
坯__坯 184.251320835|pi;
癖__癖 199.548108896|pi;
匹__匹 432.109303457|pi;
劈__劈 469.736419493|pi;
脾__脾 494.9767145|pi;
披__披 504.316081474|pi;
屁__屁 2822.57620712|pi;
批__批 3519.15704076|pi;
皮__皮 5013.49243365|pi;
犏__犏 4.33981587299|pian;
蹁__蹁 4.48273006426|pian;
胼__胼 6.21352189773|pian;
扁__扁 11.5141910287|pian;
谝__諞 33.0439046436|pian;
骈__駢 39.8356441545|pian;
翩__翩 56.2581100189|pian;
便__便 501.808489233|pian;
偏__偏 3153.64470585|pian;
骗__騙 5243.52906925|pian;
篇__篇 6897.44728323|pian;
片__片 10277.1672064|pian;
莩__莩 2.59067639517|piao;
骠__驃 7.62246014707|piao;
螵__螵 10.644802967|piao;
嘌__嘌 13.1729601771|piao;
殍__殍 14.1426880741|piao;
缥__縹 25.4354064912|piao;
剽__剽 28.1368933208|piao;
瓢__瓢 185.634130949|piao;
瞟__瞟 248.794392378|piao;
嫖__嫖 326.454673948|piao;
朴__朴 351.361264404|piao;
漂__漂 901.370874142|piao;
飘__飄 2376.61936257|piao;
票__票 8191.70747243|piao;
氕__氕 2.997325756|pie;
苤__苤 12.9936194557|pie;
丿__丿 131.937467932|pie;
瞥__瞥 276.249600432|pie;
撇__撇 408.035799866|pie;
榀__榀 10.3827778661|pin;
牝__牝 31.164115738|pin;
拚__拚 52.0751510057|pin;
姘__姘 57.53429504|pin;
颦__顰 87.4522686574|pin;
嫔__嬪 110.815291538|pin;
聘__聘 487.62990282|pin;
贫__貧 633.494731672|pin;
频__頻 806.745280603|pin;
拼__拼 2300.85021536|pin;
品__品 4693.06525391|pin;
俜__俜 4.57300671869|ping;
鲆__鮃 18.9309983612|ping;
枰__枰 25.3720919224|ping;
乒__乒 41.9761284103|ping;
娉__娉 59.3549408843|ping;
苹__蘋 238.770616634|ping;
坪__坪 752.365812175|ping;
萍__萍 1274.55334676|ping;
屏__屏 1954.29771596|ping;
瓶__瓶 2338.42792752|ping;
评__評 2385.52098173|ping;
凭__憑 2937.40736593|ping;
平__平 8010.00481377|ping;
繁__繁 1.4585404586|po;
钷__鉕 2.61989567005|po;
笸__笸 3.85048817651|po;
朴__朴 5.12852570138|po;
泺__濼 11.5573173892|po;
钋__釙 15.8409585096|po;
陂__陂 16.0196227851|po;
鄱__鄱 20.3246044287|po;
叵__叵 31.0478262181|po;
皤__皤 35.3881237821|po;
粕__粕 50.4149399325|po;
珀__珀 128.850255419|po;
泊__泊 164.703307075|po;
魄__魄 213.438416689|po;
迫__迫 334.276427588|po;
泼__潑 655.172250234|po;
婆__婆 1035.08753546|po;
颇__頗 1077.19810837|po;
坡__坡 1135.07907503|po;
破__破 7313.49454057|po;
裒__裒 6.94232467065|pou;
掊__掊 11.7607193204|pou;
剖__剖 251.600451735|pou;
镤__鏷 2.97499832973|pu;
暴__暴 4.11851610332|pu;
匍__匍 9.89023558913|pu;
镨__鐠 11.1055107505|pu;
氆__氆 14.0373375547|pu;
蹼__蹼 20.4007301604|pu;
堡__堡 27.9621221044|pu;
脯__脯 28.0668541308|pu;
菩__菩 41.9238517455|pu;
莆__莆 51.7516882347|pu;
曝__曝 64.8458676952|pu;
溥__溥 79.3518814814|pu;
埔__埔 102.575842641|pu;
濮__濮 119.41857567|pu;
圃__圃 126.306596357|pu;
璞__璞 135.94305409|pu;
葡__葡 174.855812809|pu;
仆__仆 181.064689688|pu;
瀑__瀑 194.636170786|pu;
噗__噗 239.068350048|pu;
朴__朴 438.073368704|pu;
蒲__蒲 557.879339939|pu;
浦__浦 752.365812175|pu;
谱__譜 943.904464128|pu;
扑__撲 1247.83614939|pu;
铺__鋪 1930.09502896|pu;
普__普 2269.5257346|pu;
呒__嘸 17.876322025|m;
摩__摩 1.95479508698|ma;
犸__獁 4.65929156132|ma;
蚂__螞 22.9646599002|ma;
蟆__蟆 30.4349047749|ma;
杩__榪 31.8313650651|ma;
麽__麽 36.1458125926|ma;
么__么 40.7900939435|ma;
抹__抹 84.9813069762|ma;
玛__瑪 1221.67899812|ma;
麻__麻 2635.59999992|ma;
码__碼 4046.2564886|ma;
骂__罵 9163.95030857|ma;
妈__媽 9875.40508331|ma;
马__馬 12498.0520499|ma;
嘛__嘛 70738.5278425|ma;
吗__嗎 220136.550505|ma;
荬__蕒 7.34275547194|mai;
霾__霾 80.8491162392|mai;
唛__嘜 81.0508704717|mai;
劢__勱 85.4059679188|mai;
脉__脈 972.56115063|mai;
迈__邁 1160.82773443|mai;
埋__埋 2001.12208851|mai;
麦__麥 2513.70191646|mai;
卖__賣 35689.0876529|mai;
买__買 100275.057765|mai;
鞔__鞔 0.448124847144|man;
埋__埋 4.8247362622|man;
镘__鏝 5.3638404672|man;
墁__墁 8.25528685814|man;
颟__顢 13.8807813875|man;
缦__縵 22.1771803197|man;
馒__饅 26.3385809681|man;
谩__謾 28.8829409096|man;
鳗__鰻 60.1741705036|man;
幔__幔 81.1519363091|man;
熳__熳 118.676811842|man;
螨__蟎 124.89791921|man;
蔓__蔓 149.447435764|man;
瞒__瞞 398.985038482|man;
漫__漫 945.081459448|man;
曼__曼 1506.18823193|man;
蛮__蠻 9290.4331154|man;
满__滿 12039.4384893|man;
慢__慢 14352.1143909|man;
硭__硭 4.23826826808|mang;
邙__邙 7.09096554672|mang;
漭__漭 8.28620700495|mang;
氓__氓 68.1601339023|mang;
蟒__蟒 92.6118220696|mang;
茫__茫 124.122120652|mang;
莽__莽 135.773751924|mang;
芒__芒 467.983588668|mang;
盲__盲 662.561694208|mang;
忙__忙 29641.2261674|mang;
蝥__蝥 3.28278001724|mao;
瞀__瞀 3.97233507308|mao;
蟊__蟊 4.72360010237|mao;
泖__泖 6.61299195785|mao;
袤__袤 8.30688474903|mao;
牦__氂 14.2310838972|mao;
耄__耄 18.6732659413|mao;
髦__髦 19.8985599093|mao;
峁__峁 21.363393052|mao;
瑁__瑁 24.6859477355|mao;
茆__茆 28.242279952|mao;
旄__旄 36.9657609447|mao;
昴__昴 42.6085562182|mao;
铆__鉚 68.2451257225|mao;
懋__懋 92.6118220696|mao;
锚__錨 163.884358899|mao;
卯__卯 177.711575153|mao;
贸__貿 296.585723861|mao;
貌__貌 389.163898974|mao;
矛__矛 392.573489614|mao;
茅__茅 449.688850794|mao;
帽__帽 810.776675547|mao;
茂__茂 933.377249507|mao;
冒__冒 3290.13465937|mao;
猫__貓 8212.14939846|mao;
毛__毛 10978.8586437|mao;
麽__麽 1766.66116773|me;
么__么 110511.321567|me;
钔__鍆 4.53328910832|men;
鞔__鞔 8.17339604049|men;
懑__懣 8.81893090373|men;
扪__捫 45.8022281391|men;
焖__燜 238.473254015|men;
闷__悶 3034.13893483|men;
门__門 14714.3117017|men;
们__們 65806.1116856|men;
艨__艨 3.5999031752|meng;
氓__氓 5.81639727367|meng;
蜢__蜢 6.64603780638|meng;
艋__艋 9.0866712819|meng;
礞__礞 9.37421474265|meng;
瞢__瞢 9.59881804637|meng;
甍__甍 10.1398306408|meng;
蠓__蠓 10.9679763316|meng;
虻__虻 15.0519277209|meng;
勐__勐 63.5657322507|meng;
朦__朦 74.1877593199|meng;
檬__檬 100.550872098|meng;
懵__懵 184.02185602|meng;
锰__錳 227.443722742|meng;
萌__萌 1004.58849796|meng;
盟__盟 1166.62851836|meng;
孟__孟 2172.66615296|meng;
蒙__蒙 2191.70158301|meng;
猛__猛 4138.04364463|meng;
梦__夢 9302.01775845|meng;
猸__猸 2.51434165649|mei;
镅__鎇 3.89391639961|mei;
鹛__鶥 6.63776089511|mei;
糜__糜 6.75458154992|mei;
嵋__嵋 14.0899143513|mei;
浼__浼 30.8165473692|mei;
楣__楣 70.5804016225|mei;
袂__袂 86.1542371944|mei;
莓__莓 94.7126715303|mei;
湄__湄 109.852835359|mei;
寐__寐 137.991222203|mei;
昧__昧 220.467143161|mei;
魅__魅 313.302012384|mei;
镁__鎂 365.655730945|mei;
玫__玫 366.111682898|mei;
媒__媒 433.727767276|mei;
霉__霉 516.399339766|mei;
媚__媚 730.197220308|mei;
枚__枚 952.17431607|mei;
酶__酶 1067.84239617|mei;
眉__眉 1214.09058664|mei;
煤__煤 1609.02584897|mei;
妹__妹 2507.44473504|mei;
梅__梅 3492.94243288|mei;
美__美 17650.4435203|mei;
每__每 19115.8066585|mei;
没__沒 295035.934626|mei;
猕__獼 3.80754430139|mi;
敉__敉 5.46504699479|mi;
縻__縻 8.36922809722|mi;
汩__汩 12.6264850603|mi;
脒__脒 14.0023953974|mi;
麋__麋 14.4454946476|mi;
嘧__嘧 15.4125672823|mi;
汨__汨 18.7432065908|mi;
芈__羋 20.4516389872|mi;
弭__弭 26.4043073537|mi;
谧__謐 58.5468645084|mi;
蘼__蘼 61.6159251321|mi;
泌__泌 62.4663613407|mi;
宓__宓 69.1008946834|mi;
幂__冪 74.7445400447|mi;
祢__禰 89.4360764191|mi;
醚__醚 112.484875527|mi;
糜__糜 127.254530072|mi;
靡__靡 134.092283643|mi;
眯__眯 242.36802267|mi;
觅__覓 389.649164279|mi;
弥__彌 421.998352644|mi;
谜__謎 529.431458035|mi;
秘__秘 608.72971781|mi;
蜜__蜜 870.462027204|mi;
咪__咪 1406.41364933|mi;
密__密 2338.42792752|mi;
迷__迷 3703.63329569|mi;
米__米 15995.6012027|mi;
渑__澠 2.31870810931|mian;
湎__湎 5.0776517378|mian;
娩__娩 12.1480107954|mian;
腼__靦 13.1074607533|mian;
沔__沔 24.9643713526|mian;
眄__眄 25.6262997624|mian;
冕__冕 84.3482713904|mian;
勉__勉 153.028150386|mian;
缅__緬 167.393257695|mian;
绵__綿 396.506758465|mian;
眠__眠 545.504855178|mian;
棉__棉 1232.38252249|mian;
免__免 2805.04388501|mian;
面__面 13022.7299719|mian;
杪__杪 14.1956594607|miao;
眇__眇 22.5393802113|miao;
鹋__鶓 26.3385809681|miao;
缈__緲 43.1966486461|miao;
藐__藐 51.4943652251|miao;
邈__邈 62.9351727223|miao;
缪__繆 117.061109314|miao;
渺__渺 143.0692679|miao;
淼__淼 224.347234118|miao;
描__描 310.580912674|miao;
瞄__瞄 526.798985534|miao;
喵__喵 696.425160166|miao;
庙__廟 1053.30446216|miao;
妙__妙 1375.21757695|miao;
苗__苗 1723.1742594|miao;
秒__秒 5204.46941467|miao;
蠛__蠛 4.68841345881|mie;
篾__篾 22.2602448677|mie;
蔑__蔑 60.4748674554|mie;
乜__乜 2194.43451055|mie;
灭__滅 3026.58626614|mie;
咩__咩 8191.70747243|mie;
鳘__鰵 3.48513444196|min;
苠__苠 5.43787334329|min;
黾__黽 18.5110843512|min;
玟__玟 19.0255986433|min;
缗__緡 19.554413824|min;
愍__愍 25.8830545594|min;
悯__憫 50.7300476464|min;
岷__岷 60.5502761843|min;
皿__皿 73.8188782619|min;
泯__泯 101.053335871|min;
抿__抿 142.535402072|min;
珉__珉 158.857391092|min;
闽__閩 387.22887368|min;
闵__閔 414.699880708|min;
敏__敏 2573.92944169|min;
民__民 4896.18143157|min;
酩__酩 14.6266358766|ming;
瞑__瞑 28.7751636392|ming;
暝__暝 44.8980370508|ming;
螟__螟 52.7281543871|ming;
溟__溟 330.960471347|ming;
茗__茗 353.117055307|ming;
冥__冥 466.237298568|ming;
铭__銘 1160.82773443|ming;
鸣__鳴 1333.03432936|ming;
命__命 4908.39956546|ming;
明__明 9887.71915322|ming;
名__名 21788.0803466|ming;
谬__謬 137.134095104|miu;
缪__繆 237.287502254|miu;
嘿__嘿 0.315733684847|mo;
瘼__瘼 2.79877359639|mo;
万__萬 4.85489223612|mo;
冒__冒 7.36107888799|mo;
镆__鏌 9.90256815184|mo;
秣__秣 12.2544434424|mo;
貊__貊 13.0585500019|mo;
貘__貘 14.1426880741|mo;
嬷__嬤 23.2526283512|mo;
耱__耱 24.5632027085|mo;
嫫__嫫 26.7021117094|mo;
么__么 30.2081916487|mo;
蓦__驀 30.24585955|mo;
脉__脈 48.3234958062|mo;
寞__寞 52.4659761309|mo;
殁__歿 55.7000406619|mo;
蘑__蘑 63.8833772098|mo;
谟__謨 81.7609833316|mo;
麽__麽 93.5397176219|mo;
摹__摹 112.204874836|mo;
茉__茉 112.906187218|mo;
馍__饃 169.915266157|mo;
漠__漠 204.329220247|mo;
陌__陌 234.64107292|mo;
沫__沫 307.117053725|mo;
没__沒 311.744192349|mo;
默__默 840.61307342|mo;
摩__摩 964.114234362|mo;
抹__抹 1094.79101389|mo;
墨__墨 1585.14349339|mo;
模__模 1689.15672637|mo;
磨__磨 1925.29057912|mo;
膜__膜 2247.01248688|mo;
末__末 2523.11697781|mo;
魔__魔 2922.80180368|mo;
摸__摸 3639.57886632|mo;
莫__莫 4509.6007036|mo;
缪__繆 3.1860523228|mou;
蛑__蛑 3.88906695375|mou;
鍪__鍪 7.57511353292|mou;
侔__侔 21.1251305665|mou;
哞__哞 42.0284702611|mou;
牟__牟 214.772467501|mou;
眸__眸 294.743493195|mou;
谋__謀 1058.56794047|mou;
某__某 12623.272423|mou;
姥__姥 0.687975440323|mu;
毪__毪 2.55859257835|mu;
坶__坶 4.19099954399|mu;
仫__仫 7.62246014707|mu;
呒__嘸 17.876322025|mu;
苜__苜 19.0968589536|mu;
模__模 22.7935934922|mu;
拇__拇 53.1238803167|mu;
牟__牟 73.1777444029|mu;
牡__牡 91.6931310582|mu;
睦__睦 147.229226029|mu;
钼__鉬 163.884358899|mu;
募__募 300.304800557|mu;
沐__沐 427.82286438|mu;
暮__暮 473.851932013|mu;
幕__幕 654.356305043|mu;
牧__牧 720.256091319|mu;
慕__慕 728.379591714|mu;
姆__姆 752.365812175|mu;
墓__墓 943.904464128|mu;
穆__穆 1057.24961018|mu;
亩__畝 1202.04704744|mu;
目__目 1983.741885|mu;
母__母 2619.22907324|mu;
木__木 6480.79417092|mu;
砝__砝 6.56373101581|fa;
垡__垡 20.7597709113|fa;
珐__琺 31.7521294864|fa;
筏__筏 71.1101090504|fa;
乏__乏 328.495108513|fa;
阀__閥 534.069978074|fa;
罚__罰 1329.71610075|fa;
伐__伐 10721.9636895|fa;
法__法 18506.3744576|fa;
发__發 69515.1032555|fa;
蹯__蹯 4.00713798393|fan;
燔__燔 12.6422295709|fan;
蘩__蘩 19.5057383967|fan;
犭__犭 35.609309621|fan;
畈__畈 42.3966952665|fan;
矾__礬 74.1877593199|fan;
攵__攵 75.9652752288|fan;
幡__幡 81.9650130749|fan;
蕃__蕃 97.2239708206|fan;
钒__釩 176.387781073|fan;
藩__藩 187.027319083|fan;
梵__梵 273.168633085|fan;
贩__販 330.136634719|fan;
帆__帆 619.442999798|fan;
樊__樊 633.494731672|fan;
繁__繁 724.757896749|fan;
泛__泛 845.867144221|fan;
番__番 976.203874871|fan;
犯__犯 2350.1133092|fan;
返__返 2406.4213017|fan;
范__范 2843.75970209|fan;
凡__凡 4520.85414793|fan;
翻__翻 5742.90345783|fan;
烦__煩 6871.70932104|fan;
反__反 6966.55412633|fan;
饭__飯 11199.9593153|fan;
邡__邡 4.22245308545|fang;
钫__鈁 7.20677589391|fang;
彷__彷 11.216778986|fang;
鲂__魴 12.3772230543|fang;
肪__肪 19.2401812896|fang;
枋__枋 34.0895635437|fang;
妨__妨 73.086609547|fang;
舫__舫 84.1383091697|fang;
纺__紡 251.600451735|fang;
访__訪 1140.75119008|fang;
仿__仿 1252.50991514|fang;
坊__坊 1509.94683642|fang;
芳__芳 2403.42436786|fang;
防__防 4470.43378899|fang;
房__房 7386.76984068|fang;
方__方 12765.6456146|fang;
放__放 26038.2042593|fang;
棼__棼 6.36239597244|fen;
玢__玢 9.32760368062|fen;
偾__僨 9.67085738167|fen;
鲼__鱝 9.76775155081|fen;
吩__吩 18.8134092027|fen;
瀵__瀵 24.4106293322|fen;
鼢__鼢 28.3480613086|fen;
氛__氛 35.8765582535|fen;
忿__忿 61.2332002144|fen;
汾__汾 86.3692300453|fen;
焚__焚 189.845141544|fen;
纷__紛 212.112652282|fen;
愤__憤 244.491487214|fen;
酚__酚 275.561951728|fen;
奋__奮 277.284292303|fen;
坟__墳 503.060722916|fen;
粪__糞 693.826435782|fen;
芬__芬 1301.84258129|fen;
粉__粉 4338.71166588|fen;
份__份 6408.51491624|fen;
分__分 28803.7140574|fen;
唪__唪 2.27860599526|feng;
酆__酆 13.0911368483|feng;
葑__葑 22.8504735693|feng;
砜__碸 29.9458265878|feng;
俸__俸 56.8217707795|feng;
讽__諷 81.4558905905|feng;
沣__灃 92.3812899733|feng;
烽__烽 93.6563563433|feng;
蜂__蜂 431.571158705|feng;
奉__奉 808.758466182|feng;
缝__縫 1004.58849796|feng;
逢__逢 1058.56794047|feng;
枫__楓 1478.29531884|feng;
锋__鋒 1532.69625148|feng;
丰__豐 1689.15672637|feng;
凤__鳳 2210.90378861|feng;
冯__馮 2510.57137637|feng;
疯__瘋 3471.24615709|feng;
峰__峰 3510.3970506|feng;
封__封 6204.20466036|feng;
风__風 12099.6008883|feng;
鲱__鯡 3.66325933593|fei;
怫__怫 4.16496731365|fei;
榧__榧 10.0142555326|fei;
悱__悱 11.3999725243|fei;
篚__篚 12.8968284813|fei;
镄__鐨 13.6407129304|fei;
狒__狒 14.5902268204|fei;
芾__芾 15.0519277209|fei;
蜚__蜚 18.7432065908|fei;
淝__淝 20.863509771|fei;
痱__痱 24.5326119332|fei;
诽__誹 38.7583583022|fei;
腓__腓 46.5502746368|fei;
啡__啡 70.5804016225|fei;
扉__扉 75.3994011064|fei;
吠__吠 111.230349808|fei;
霏__霏 119.121315407|fei;
翡__翡 121.671800659|fei;
沸__沸 175.948711373|fei;
绯__緋 217.465635832|fei;
斐__斐 334.69325133|fei;
匪__匪 395.027185582|fei;
妃__妃 806.745280603|fei;
肺__肺 1611.03221293|fei;
废__廢 1723.1742594|fei;
菲__菲 1773.27819069|fei;
肥__肥 2808.54161561|fei;
费__費 10112.0167535|fei;
飞__飛 11468.3068978|fei;
非__非 17475.3546014|fei;
佛__佛 4148.36989009|fo;
缶__缶 32.4319686712|fou;
否__否 3931.92961191|fou;
莩__莩 2.59067639517|fu;
鳆__鰒 2.84448344221|fu;
怫__怫 4.16496731365|fu;
蜉__蜉 4.84884600023|fu;
蚨__蚨 4.90353432967|fu;
芾__芾 5.0272824339|fu;
艴__艴 5.28422636689|fu;
菔__菔 5.86735660919|fu;
砩__砩 6.17492684861|fu;
郛__郛 6.4021627569|fu;
稃__稃 7.98214626949|fu;
幞__襆 10.8591761693|fu;
趺__趺 11.2587913908|fu;
袱__袱 11.2587913908|fu;
茯__茯 11.8489837712|fu;
桴__桴 12.4856639039|fu;
跗__跗 13.2058325274|fu;
鲋__鮒 13.3049425837|fu;
驸__駙 14.9398041702|fu;
蝮__蝮 15.5282389303|fu;
绋__紼 16.1398503976|fu;
绂__紱 16.5677973048|fu;
匐__匐 16.7337932337|fu;
黼__黼 18.2818367924|fu;
拊__拊 20.1480805858|fu;
赙__賻 20.2487627616|fu;
咐__咐 20.5794675479|fu;
罘__罘 20.6823054118|fu;
滏__滏 21.1514724059|fu;
黻__黻 22.2880021302|fu;
讣__訃 25.0266684786|fu;
呋__呋 26.2076186139|fu;
麸__麩 27.2398593044|fu;
脯__脯 28.0668541308|fu;
祓__祓 33.8356264416|fu;
涪__涪 34.0471087306|fu;
苻__苻 34.9063390075|fu;
凫__鳧 39.7364840867|fu;
蝠__蝠 57.606037042|fu;
俘__俘 61.1569409784|fu;
辐__輻 62.2332668667|fu;
腑__腑 72.0915860209|fu;
孵__孵 74.1877593199|fu;
釜__釜 92.6118220696|fu;
佛__佛 96.4997382157|fu;
馥__馥 120.615053212|fu;
孚__孚 159.055477247|fu;
缚__縛 163.680258901|fu;
俯__俯 194.393772779|fu;
阜__阜 237.879639313|fu;
斧__斧 254.438159592|fu;
肤__膚 282.516174301|fu;
芙__芙 351.361264404|fu;
氟__氟 409.054029297|fu;
拂__拂 455.895552723|fu;
腐__腐 466.818670029|fu;
抚__撫 491.902185928|fu;
辅__輔 562.76710106|fu;
覆__覆 586.392500602|fu;
妇__婦 620.98878351|fu;
甫__甫 636.660374558|fu;
弗__弗 655.989212862|fu;
赋__賦 671.706512759|fu;
敷__敷 697.293562832|fu;
伏__伏 826.074649543|fu;
腹__腹 870.462027204|fu;
幅__幅 935.706437745|fu;
浮__浮 1008.35118051|fu;
扶__扶 1107.13875428|fu;
傅__傅 1163.72451202|fu;
符__符 1353.11831545|fu;
附__附 1595.05109108|fu;
父__父 1755.68762073|fu;
府__府 1757.8768636|fu;
赴__赴 2178.08791404|fu;
复__復 2272.35570445|fu;
夫__夫 2742.82438642|fu;
负__負 2850.85613781|fu;
富__富 3549.98951246|fu;
福__福 3902.64021341|fu;
服__服 4634.94473906|fu;
付__付 6081.72619607|fu;
副__副 17045.1933699|fu;
簖__籪 4.37783840185|duan;
煅__煅 35.5649621309|duan;
椴__椴 61.0807767149|duan;
缎__緞 105.426930997|duan;
锻__鍛 114.893269147|duan;
端__端 3825.59740032|duan;
断__斷 4835.54545696|duan;
短__短 5185.04883318|duan;
段__段 7980.11532095|duan;
镦__鐓 1.54074732551|dun;
不__不 3.11538156464|dun;
砘__砘 5.17990938094|dun;
礅__礅 11.5285485717|dun;
沌__沌 25.7543572024|dun;
囤__囤 26.6356440204|dun;
趸__躉 27.0369464415|dun;
盹__盹 72.0915860209|dun;
遁__遁 211.057972369|dun;
钝__鈍 234.056997396|dun;
墩__墩 390.135034682|dun;
敦__敦 437.527796363|dun;
蹲__蹲 680.129467195|dun;
炖__燉 840.61307342|dun;
盾__盾 1496.83260243|dun;
顿__頓 1820.2965272|dun;
吨__噸 2100.77969738|dun;
靼__靼 9.42105872529|da;
褡__褡 9.43280625107|da;
瘩__瘩 14.517680374|da;
笪__笪 17.4798020992|da;
耷__耷 19.2641727042|da;
鞑__韃 20.2992923627|da;
沓__沓 30.4728553745|da;
怛__怛 48.1431757172|da;
妲__妲 51.7516882347|da;
嗒__嗒 322.010219858|da;
哒__噠 1540.35530331|da;
搭__搭 2238.62771494|da;
答__答 3087.5379805|da;
达__達 9692.5236812|da;
大__大 106058.887193|da;
打__打 107925.460703|da;
呔__呔 13.6067580629|dai;
绐__紿 15.8015267255|dai;
迨__迨 22.3993777295|dai;
玳__玳 32.8386537177|dai;
埭__埭 43.4125070529|dai;
傣__傣 49.1739606711|dai;
殆__殆 69.9673946745|dai;
怠__怠 77.9794887304|dai;
歹__歹 89.8829983348|dai;
甙__甙 93.890070293|dai;
大__大 157.67404401|dai;
岱__岱 195.365179853|dai;
逮__逮 399.482550191|dai;
黛__黛 461.037428991|dai;
贷__貸 1265.05905145|dai;
袋__袋 1637.34374958|dai;
戴__戴 4306.3921008|dai;
呆__呆 4817.50152258|dai;
代__代 5504.66134704|dai;
待__待 6914.65945879|dai;
带__帶 38459.8547306|dai;
瘅__癉 3.88906695375|dan;
萏__萏 3.88906695375|dan;
疸__疸 7.02937888743|dan;
郸__鄲 7.26991678568|dan;
石__石 9.28122438105|dan;
赕__賧 10.0142555326|dan;
眈__眈 13.5222402155|dan;
聃__聃 18.2818367924|dan;
箪__簞 19.3122453184|dan;
殚__殫 30.7781687388|dan;
惮__憚 31.6730911433|dan;
儋__儋 34.3882332226|dan;
澹__澹 37.15048292|dan;
掸__撣 39.9848484144|dan;
耽__耽 62.4663613407|dan;
啖__啖 115.467403456|dan;
诞__誕 129.010924378|dan;
旦__旦 414.699880708|dan;
氮__氮 516.399339766|dan;
弹__彈 570.534533242|dan;
担__擔 817.880151926|dan;
胆__膽 1035.08753546|dan;
淡__淡 1981.27135202|dan;
丹__丹 2418.44645375|dan;
蛋__蛋 2805.04388501|dan;
单__單 12374.0738382|dan;
但__但 115581.969014|dan;
菪__菪 6.30713710671|dang;
谠__讜 21.363393052|dang;
砀__碭 22.9360599347|dang;
凼__凼 32.8386537177|dang;
宕__宕 86.5847593983|dang;
铛__鐺 103.474542736|dang;
裆__襠 114.037415895|dang;
荡__盪 682.676889633|dang;
挡__擋 1525.07528247|dang;
档__檔 2850.85613781|dang;
党__黨 4354.9622946|dang;
当__當 52846.2849666|dang;
帱__幬 1.94023359226|dao;
焘__燾 3.30741735168|dao;
氘__氘 20.2235451481|dao;
忉__忉 21.2571686411|dao;
纛__纛 22.2325221738|dao;
祷__禱 58.4011279155|dao;
蹈__蹈 82.8894659524|dao;
叨__叨 86.5847593983|dao;
悼__悼 190.793818607|dao;
捣__搗 414.699880708|dao;
稻__稻 434.268601197|dao;
盗__盜 1668.23763548|dao;
导__導 2043.96775685|dao;
岛__島 3026.58626614|dao;
刀__刀 5409.45809302|dao;
倒__倒 13603.2960084|dao;
道__道 16155.8641894|dao;
到__到 296879.993133|dao;
底__底 77.5917541962|de;
锝__鍀 94.9490214527|de;
德__德 7178.0568421|de;
地__地 35028.1658643|de;
得__得 75568.3236687|de;
的__的 4828294.50885|de;
簦__簦 4.87915266687|deng;
戥__戥 6.18262663209|deng;
嶝__嶝 6.39418956526|deng;
磴__磴 15.605835249|deng;
镫__鐙 21.6043428114|deng;
澄__澄 28.9189562984|deng;
噔__噔 78.3691608167|deng;
凳__凳 147.964946673|deng;
蹬__蹬 391.596284031|deng;
瞪__瞪 457.603107852|deng;
邓__鄧 2554.75594355|deng;
登__登 3026.58626614|deng;
灯__燈 4376.72452042|deng;
等__等 182604.582851|deng;
得__得 13791.0516163|dei;
羝__羝 4.1597803036|di;
提__提 4.68841345881|di;
坻__坻 6.07569795171|di;
籴__糴 11.5861579976|di;
柢__柢 14.0548413183|di;
碲__碲 14.4454946476|di;
诋__詆 15.3168327213|di;
翟__翟 16.1801264486|di;
觌__覿 20.7339168932|di;
镝__鏑 21.363393052|di;
砥__砥 25.4354064912|di;
氐__氐 44.8421214693|di;
缔__締 63.963036157|di;
嫡__嫡 69.7063099449|di;
棣__棣 90.8967552212|di;
骶__骶 93.890070293|di;
邸__邸 117.93965545|di;
涤__滌 143.426288875|di;
荻__荻 150.381524744|di;
嘀__嘀 175.073848088|di;
娣__娣 210.270405333|di;
谛__諦 238.176261728|di;
笛__笛 433.187606905|di;
堤__堤 478.003501869|di;
狄__狄 530.752623218|di;
蒂__蒂 885.781642601|di;
递__遞 954.550411286|di;
抵__抵 1028.65812957|di;
敌__敵 1150.74567978|di;
弟__弟 1203.54593192|di;
迪__迪 1408.16736736|di;
的__的 1589.0991261|di;
帝__帝 1718.88488289|di;
睇__睇 4939.07845882|di;
底__底 5497.80589498|di;
滴__滴 11816.4816209|di;
低__低 15738.5575321|di;
第__第 24313.3528053|di;
地__地 101785.838711|di;
嗲__嗲 1341.36617307|dia;
阽__阽 1.21743003707|dian;
坫__坫 7.07331450482|dian;
玷__玷 26.077307439|dian;
惦__惦 26.3714236844|dian;
钿__鈿 27.6158296825|dian;
簟__簟 29.2087008507|dian;
癜__癜 33.0851085181|dian;
佃__佃 48.5044912834|dian;
奠__奠 57.8218002436|dian;
巅__巔 65.169909632|dian;
淀__淀 75.5875558941|dian;
靛__靛 79.7484115654|dian;
踮__踮 98.6887829668|dian;
丶__丶 145.405889264|dian;
癫__癲 166.768626413|dian;
甸__甸 215.845709156|dian;
滇__滇 278.669912425|dian;
碘__碘 343.996026791|dian;
掂__掂 379.584509838|dian;
颠__顛 740.275558891|dian;
典__典 809.766942109|dian;
垫__墊 1057.24961018|dian;
殿__殿 1153.6172982|dian;
电__電 6752.86293853|dian;
店__店 11612.1152793|dian;
点__點 137956.112214|dian;
铫__銚 2.97499832973|diao;
铞__銱 9.28122438105|diao;
鸟__鳥 13.6237249183|diao;
碉__碉 27.4101161728|diao;
鲷__鯛 33.1676704679|diao;
貂__貂 118.381397999|diao;
凋__凋 245.407229187|diao;
刁__刁 376.287731462|diao;
雕__雕 593.745648473|diao;
钓__釣 857.541983893|diao;
叼__叼 1868.56155133|diao;
调__調 2023.69199978|diao;
吊__吊 2033.8046114|diao;
掉__掉 20677.0430806|diao;
瓞__瓞 4.87307621728|die;
蹀__蹀 5.45824087806|die;
垤__垤 7.72766697621|die;
鲽__鰈 10.8862746072|die;
堞__堞 12.1177716064|die;
耋__耋 19.0019043465|die;
喋__喋 39.0492406125|die;
牒__牒 55.4921948486|die;
谍__諜 74.6514539166|die;
迭__迭 207.925293333|die;
叠__疊 743.974797322|die;
蝶__蝶 1018.45404378|die;
爹__爹 1498.69906777|die;
碟__碟 1824.83897052|die;
跌__跌 8772.84815908|die;
耵__耵 6.58011042198|ding;
疔__疔 9.13207837822|ding;
仃__仃 17.0707911897|ding;
玎__玎 25.3720919224|ding;
酊__酊 31.6336457816|ding;
碇__碇 42.1333498461|ding;
啶__啶 48.8685185308|ding;
腚__腚 111.369047744|ding;
町__町 142.357889859|ding;
叮__叮 306.352568839|ding;
锭__錠 347.00988711|ding;
钉__釘 655.172250234|ding;
鼎__鼎 825.045864155|ding;
盯__盯 842.710774091|ding;
订__訂 3616.97176403|ding;
丁__丁 4011.11382459|ding;
顶__頂 12733.8689906|ding;
定__定 14898.8237984|ding;
铥__銩 15.2027358626|diu;
丢__丟 5594.56401791|diu;
读__讀 1.71077341804|dou;
蚪__蚪 7.37025773577|dou;
篼__篼 7.86366933161|dou;
钭__鈄 13.1074607533|dou;
蔸__蔸 41.6115561244|dou;
痘__痘 277.284292303|dou;
陡__陡 330.136634719|dou;
窦__竇 501.808489233|dou;
兜__兜 724.757896749|dou;
抖__抖 976.203874871|dou;
逗__逗 1784.36168375|dou;
豆__豆 1856.95505407|dou;
斗__斗 2548.39656922|dou;
都__都 401877.151555|dou;
胨__腖 4.48831977435|dong;
岽__崬 6.67924878866|dong;
鸫__鶇 9.42105872529|dong;
垌__垌 11.3999725243|dong;
胴__胴 13.5053997481|dong;
恫__恫 24.9643713526|dong;
硐__硐 25.3089349582|dong;
峒__峒 26.109824362|dong;
夂__夂 32.7569107661|dong;
侗__侗 44.1215243906|dong;
氡__氡 50.6668689351|dong;
咚__咚 147.780672558|dong;
冻__凍 967.72532071|dong;
栋__棟 1682.85360433|dong;
冬__冬 1996.14083601|dong;
董__董 2494.97706011|dong;
洞__洞 2922.80180368|dong;
东__東 8696.65396422|dong;
懂__懂 8960.68204728|dong;
动__動 9465.72775386|dong;
髑__髑 3.35724811942|du;
黩__黷 6.4021627569|du;
芏__芏 9.06405247004|du;
椟__櫝 10.7380655247|du;
牍__牘 21.0200908593|du;
顿__頓 25.7222829747|du;
蠹__蠹 37.804309385|du;
渎__瀆 52.4006355111|du;
犊__犢 91.5789373186|du;
妒__妒 141.29744947|du;
笃__篤 171.617679695|du;
睹__睹 174.203334854|du;
镀__鍍 200.29551561|du;
嘟__嘟 237.287502254|du;
督__督 278.322859608|du;
肚__肚 535.402718412|du;
渡__渡 1108.5192935|du;
堵__堵 1280.92243009|du;
赌__賭 1920.49808867|du;
独__獨 2124.47360974|du;
杜__杜 3411.21086903|du;
毒__毒 3811.32210727|du;
都__都 5545.97394851|du;
度__度 11468.3068978|du;
读__讀 12702.171466|du;
度__度 3.52883675546|duo;
裰__裰 3.66782721251|duo;
沲__沲 4.44933768948|duo;
驮__馱 5.05240431744|duo;
柁__柁 15.7229573773|duo;
咄__咄 16.0196227851|duo;
哚__哚 24.8402419302|duo;
掇__掇 29.2087008507|duo;
惰__惰 56.0481817586|duo;
垛__垛 107.684208225|duo;
舵__舵 132.762114633|duo;
踱__踱 151.510141313|duo;
跺__跺 157.2815571|duo;
铎__鐸 163.476413088|duo;
哆__哆 171.831677206|duo;
剁__剁 268.109857044|duo;
堕__墮 272.149298879|duo;
朵__朵 1051.99268696|duo;
夺__奪 1083.93090293|duo;
躲__躲 2188.97205903|duo;
多__多 154137.401791|duo;
憝__憝 5.7229298206|dui;
镦__鐓 10.6580764325|dui;
怼__懟 16.2205030062|dui;
敦__敦 16.8804034021|dui;
碓__碓 30.7398379048|dui;
兑__兌 457.603107852|dui;
堆__堆 2183.52320481|dui;
队__隊 10367.2087883|dui;
对__對 279642.500227|dui;
彖__彖 19.9482155997|tuan;
抟__摶 23.6029610125|tuan;
疃__疃 28.9911218594|tuan;
湍__湍 43.1428519572|tuan;
团__團 7027.59035759|tuan;
褪__褪 4.40520113703|tun;
饨__飩 9.65881338932|tun;
暾__暾 12.7212471015|tun;
氽__氽 55.285124616|tun;
豚__豚 110.815291538|tun;
囤__囤 117.646076559|tun;
臀__臀 369.319305625|tun;
屯__屯 680.129467195|tun;
吞__吞 745.831342837|tun;
嗒__嗒 1.48606063114|ta;
漯__漯 6.88202899139|ta;
拓__拓 9.0414899616|ta;
鳎__鰨 14.2665967332|ta;
趿__趿 14.8285158408|ta;
遢__遢 15.6838193251|ta;
溻__溻 15.9201175224|ta;
闼__闥 22.4273084829|ta;
獭__獺 25.5306747134|ta;
挞__撻 37.804309385|ta;
铊__鉈 44.4526573774|ta;
蹋__蹋 52.859734407|ta;
榻__榻 86.9090622988|ta;
沓__沓 98.8118422805|ta;
塌__塌 503.060722916|ta;
踏__踏 815.844260376|ta;
塔__塔 3616.97176403|ta;
它__它 58897.8095035|ta;
她__她 204022.826566|ta;
他__他 343908.501681|ta;
炱__炱 3.74169272861|tai;
鲐__鮐 5.76588053165|tai;
跆__跆 12.4235818981|tai;
呔__呔 13.3381442884|tai;
薹__薹 15.7818476567|tai;
酞__酞 23.4856008804|tai;
骀__駘 29.8712845475|tai;
邰__邰 46.6664381197|tai;
汰__汰 70.9330996563|tai;
肽__肽 266.112675706|tai;
苔__苔 392.573489614|tai;
钛__鈦 421.472799973|tai;
态__態 883.576728645|tai;
胎__胎 962.913535809|tai;
抬__抬 1363.27349742|tai;
泰__泰 2095.55037421|tai;
台__台 13451.5806367|tai;
太__太 71180.6637614|tai;
锬__錟 3.66325933593|tan;
忐__忐 5.22529224041|tan;
袒__袒 23.2816230596|tan;
郯__郯 24.1986174274|tan;
覃__覃 35.8318779344|tan;
坍__坍 37.1042160675|tan;
澹__澹 37.15048292|tan;
钽__鉭 47.9635284962|tan;
昙__曇 64.122652166|tan;
毯__毯 125.992190229|tan;
瘫__癱 170.551683166|tan;
檀__檀 189.608710238|tan;
炭__炭 349.614203755|tan;
滩__灘 570.534533242|tan;
潭__潭 586.392500602|tan;
痰__痰 620.98878351|tan;
碳__碳 684.380469812|tan;
坦__坦 728.379591714|tan;
摊__攤 791.805264794|tan;
叹__嘆 873.722339551|tan;
坛__壇 910.401881269|tan;
贪__貪 1028.65812957|tan;
谭__譚 1771.06976716|tan;
探__探 1829.39274925|tan;
弹__彈 1988.69219664|tan;
谈__談 13518.7996654|tan;
惝__惝 2.35364261953|tang;
螗__螗 4.47714731555|tang;
羰__羰 5.94093111894|tang;
帑__帑 7.14418339523|tang;
醣__醣 7.84409485251|tang;
铴__鐋 9.70707954272|tang;
螳__螳 9.86561652115|tang;
耥__耥 10.6050816723|tang;
傥__儻 12.7688944861|tang;
瑭__瑭 20.7339168932|tang;
樘__樘 21.3367872887|tang;
搪__搪 31.7521294864|tang;
镗__鏜 48.6861646786|tang;
溏__溏 54.3967121595|tang;
膛__膛 91.5789373186|tang;
倘__倘 183.563783354|tang;
淌__淌 270.458854115|tang;
棠__棠 291.819695868|tang;
塘__塘 1020.99553617|tang;
烫__燙 1200.55002966|tang;
躺__躺 1416.96881393|tang;
趟__趟 1603.0217369|tang;
糖__糖 2840.21811123|tang;
堂__堂 3364.76959766|tang;
唐__唐 4509.6007036|tang;
汤__湯 4871.83632932|tang;
叨__叨 1.4386834413|tao;
鼗__鞀 5.21878471193|tao;
啕__啕 7.29714623248|tao;
饕__饕 19.7996190342|tao;
萄__萄 27.3418860981|tao;
丶__丶 29.5013484091|tao;
洮__洮 35.2560722919|tao;
焘__燾 45.1223974827|tao;
绦__絛 49.2352778104|tao;
滔__滔 118.08671951|tao;
韬__韜 188.430963124|tao;
掏__掏 921.81798848|tao;
淘__淘 943.904464128|tao;
桃__桃 1059.88791463|tao;
讨__討 1067.84239617|tao;
涛__濤 1601.02534912|tao;
陶__陶 1708.20809643|tao;
逃__逃 2129.77510916|tao;
套__套 7960.25098103|tao;
铽__鋱 5.26450817074|te;
慝__慝 13.4215114839|te;
忑__忑 14.3021981894|te;
忒__忒 175.073848088|te;
特__特 9524.89124462|te;
誊__謄 45.9737802175|teng;
滕__滕 482.191444969|teng;
藤__藤 893.542261726|teng;
腾__騰 1209.56018338|teng;
疼__疼 4306.3921008|teng;
忒__忒 425.165459331|tei;
裼__裼 2.09086606044|ti;
荑__荑 3.88422354733|ti;
绨__綈 9.70707954272|ti;
逖__逖 10.0894127351|ti;
嚏__嚏 11.0640703155|ti;
醍__醍 12.0575188578|ti;
鹈__鵜 14.8655195332|ti;
倜__倜 24.5632027085|ti;
悌__悌 26.4701977556|ti;
惕__惕 40.5367278646|ti;
屉__屜 58.0383715854|ti;
锑__銻 72.5421789383|ti;
涕__涕 137.991222203|ti;
缇__緹 141.29744947|ti;
剔__剔 146.132498493|ti;
啼__啼 211.848489234|ti;
蹄__蹄 231.735198139|ti;
剃__剃 268.444174826|ti;
梯__梯 350.486645516|ti;
替__替 3257.49717238|ti;
踢__踢 3745.40519724|ti;
题__題 4442.66586373|ti;
体__體 5566.7463737|ti;
提__提 8578.25504892|ti;
佃__佃 4.56162345463|tian;
畋__畋 12.737109775|tian;
掭__掭 14.9211982824|tian;
腆__腆 19.1683861691|tian;
殄__殄 19.5300609459|tian;
阗__闐 29.759819253|tian;
忝__忝 38.1355251523|tian;
钿__鈿 60.1741705036|tian;
恬__恬 162.258658377|tian;
舔__舔 1418.73569366|tian;
甜__甜 2180.80386611|tian;
添__添 2385.52098173|tian;
填__填 4606.15496045|tian;
田__田 4781.61539648|tian;
天__天 44055.3637296|tian;
鲦__鰷 4.52200471051|tiao;
髫__髫 4.85489223612|tiao;
笤__笤 4.98361933493|tiao;
祧__祧 5.10938850538|tiao;
龆__齠 8.97413885701|tiao;
粜__糶 10.2286689728|tiao;
窕__窕 11.3857751087|tiao;
佻__佻 15.8607112862|tiao;
蜩__蜩 16.7755514342|tiao;
迢__迢 17.8096161726|tiao;
苕__苕 42.3966952665|tiao;
眺__眺 430.496878967|tiao;
挑__挑 4515.22391985|tiao;
调__調 4646.51097209|tiao;
跳__跳 7089.161347|tiao;
条__條 12498.0520499|tiao;
揲__揲 1.80945021625|tie;
餮__餮 11.5717287083|tie;
萜__萜 37.15048292|tie;
铁__鐵 5369.16241395|tie;
帖__帖 5721.47369896|tie;
贴__貼 10562.8203485|tie;
莛__莛 9.1777123788|ting;
铤__鋌 13.4885802538|ting;
町__町 16.8804034021|ting;
蜓__蜓 25.9476442055|ting;
葶__葶 40.1346115182|ting;
梃__梃 66.4823512304|ting;
烃__烴 86.8008265922|ting;
霆__霆 243.57916235|ting;
艇__艇 277.976239008|ting;
汀__汀 360.677581637|ting;
廷__廷 769.432826682|ting;
婷__婷 961.714332594|ting;
亭__亭 1344.71347376|ting;
庭__庭 1513.71482027|ting;
厅__廳 2289.40978274|ting;
停__停 5939.41952983|ting;
挺__挺 20754.48887|ting;
听__聽 31156.1864526|ting;
钭__鈄 12.3618085803|tou;
骰__骰 48.746873564|tou;
透__透 1771.06976716|tou;
偷__偷 3462.60542812|tou;
投__投 6854.60405824|tou;
头__頭 20243.6107394|tou;
垌__垌 9.58686377111|tong;
茼__茼 9.59881804637|tong;
峒__峒 10.7514552832|tong;
僮__僮 17.1989078437|tong;
嗵__嗵 19.0493224855|tong;
侗__侗 30.1329965214|tong;
恸__慟 37.9932216791|tong;
仝__仝 64.122652166|tong;
潼__潼 71.8225748289|tong;
砼__砼 227.727332161|tong;
酮__酮 357.099731154|tong;
佟__佟 395.027185582|tong;
彤__彤 434.268601197|tong;
瞳__瞳 435.352293046|tong;
桐__桐 590.793388895|tong;
捅__捅 600.442284667|tong;
筒__筒 697.293562832|tong;
统__統 776.174076244|tong;
桶__桶 1155.05579352|tong;
童__童 1528.88101848|tong;
铜__銅 2344.2633374|tong;
痛__痛 6235.20775378|tong;
通__通 8398.43759849|tong;
同__同 24012.2479823|tong;
酴__酴 3.73703286063|tu;
堍__堍 8.82992761027|tu;
钍__釷 16.5471639301|tu;
菟__菟 33.7514017959|tu;
荼__荼 150.194241046|tu;
秃__禿 249.415244207|tu;
屠__屠 414.183417482|tu;
途__途 531.41444163|tu;
凸__凸 582.024395035|tu;
徒__徒 614.828697239|tu;
突__突 788.850627646|tu;
兔__兔 1422.27606545|tu;
涂__塗 1910.94886689|tu;
吐__吐 2812.04370767|tu;
土__土 5101.72692692|tu;
图__圖 20548.6084333|tu;
酡__酡 9.01898361643|tuo;
跎__跎 10.3054353528|tuo;
魄__魄 10.6315460323|tuo;
鼍__鼉 11.272830465|tuo;
柝__柝 15.0144600156|tuo;
柁__柁 15.7229573773|tuo;
鸵__鴕 17.0282980696|tuo;
箨__籜 17.436290857|tuo;
椭__橢 17.6109883889|tuo;
橐__橐 23.7504862321|tuo;
铊__鉈 27.0369464415|tuo;
乇__乇 28.9550165963|tuo;
庹__庹 32.1502895978|tuo;
佗__佗 53.7230447916|tuo;
唾__唾 66.0693986966|tuo;
沱__沱 76.8220592961|tuo;
砣__砣 89.4360764191|tuo;
驮__馱 148.519148841|tuo;
驼__駝 200.545272755|tuo;
坨__坨 251.287110964|tuo;
妥__妥 361.577631409|tuo;
陀__陀 420.94790182|tuo;
拓__拓 748.624851411|tuo;
脱__脫 2753.09762515|tuo;
拖__拖 3653.21089568|tuo;
托__托 4107.21887886|tuo;
煺__煺 7.06450546727|tui;
蜕__蛻 81.9650130749|tui;
颓__頹 125.053659829|tui;
忒__忒 153.41002317|tui;
褪__褪 201.296414343|tui;
腿__腿 4066.47607754|tui;
推__推 5296.06498953|tui;
退__退 7395.98072362|tui;
唔__唔 1126.6237397|n;
嗯__嗯 31982.2903695|n;
暖__暖 1474.61550226|nuan;
疟__瘧 48.2032075261|nue;
虐__虐 744.902491688|nue;
恧__恧 4.19622548267|nv;
衄__衄 16.7129531292|nv;
钕__釹 54.1937297424|nv;
女__女 22702.7608644|nv;
镎__鎿 2.76411263312|na;
肭__肭 3.5999031752|na;
衲__衲 26.9360575363|na;
捺__捺 85.4059679188|na;
钠__鈉 586.392500602|na;
呐__吶 1861.58897661|na;
娜__娜 1998.62991039|na;
纳__納 2103.39925049|na;
哪__哪 31902.679103|na;
拿__拿 38603.9059762|na;
那__那 269381.07371|na;
佴__佴 3.95258357798|nai;
艿__艿 9.93965818473|nai;
柰__柰 20.072897621|nai;
鼐__鼐 22.2325221738|nai;
氖__氖 48.6861646786|nai;
萘__萘 72.7232036954|nai;
奈__奈 828.13607043|nai;
耐__耐 2491.86983978|nai;
奶__奶 2952.08591378|nai;
乃__乃 3671.46639254|nai;
蝻__蝻 8.26558073253|nan;
赧__赧 16.6713507502|nan;
囝__囝 24.4410680021|nan;
腩__腩 44.954022356|nan;
囡__囡 169.070402749|nan;
楠__楠 720.256091319|nan;
喃__喃 1485.68252323|nan;
南__南 7350.04087759|nan;
难__難 15640.7980954|nan;
男__男 16792.195962|nan;
攮__攮 7.09096554672|nang;
曩__曩 23.0506739501|nang;
馕__饢 47.0752978598|nang;
囔__囔 56.7510054952|nang;
囊__囊 817.880151926|nang;
硇__硇 3.35724811942|nao;
蛲__蟯 4.77687582994|nao;
猱__猱 11.8194889291|nao;
垴__堖 12.5793690793|nao;
铙__鐃 15.6252948403|nao;
淖__淖 37.6163364125|nao;
呶__呶 42.9283343465|nao;
瑙__瑙 55.908664961|nao;
孬__孬 93.7731405065|nao;
恼__惱 283.221176861|nao;
挠__撓 366.568203397|nao;
脑__腦 2258.24105554|nao;
闹__鬧 4470.43378899|nao;
讷__訥 144.322743975|ne;
呐__吶 188.665925845|ne;
哪__哪 284.991389772|ne;
呢__呢 239902.724161|ne;
恁__恁 267.775955618|nen;
嫩__嫩 2645.47163011|nen;
能__能 161410.786407|neng;
哪__哪 42.2911601543|nei;
馁__餒 47.8441362574|nei;
那__那 832.274357505|nei;
内__內 40881.4788495|nei;
猊__猊 12.4856639039|ni;
伲__伲 14.4996001951|ni;
怩__怩 16.099674603|ni;
鲵__鯢 19.6276548096|ni;
坭__坭 20.8115757033|ni;
旎__旎 29.611845602|ni;
铌__鈮 44.7304991295|ni;
睨__睨 45.6882158734|ni;
溺__溺 64.2826664874|ni;
霓__霓 145.043940608|ni;
匿__匿 149.820373083|ni;
昵__昵 164.498187167|ni;
倪__倪 894.656458236|ni;
逆__逆 981.082073059|ni;
腻__膩 1055.93292173|ni;
妮__妮 1163.72451202|ni;
泥__泥 1944.58043354|ni;
呢__呢 2485.66700342|ni;
尼__尼 2504.32198759|ni;
拟__擬 2833.14815601|ni;
你__你 973526.115694|ni;
埝__埝 16.6713507502|nian;
鲶__鯰 17.2848526788|nian;
鲇__鯰 19.2401812896|nian;
辗__輾 20.0979273856|nian;
辇__輦 66.0693986966|nian;
拈__拈 135.94305409|nian;
撵__攆 137.476305203|nian;
蔫__蔫 148.704343794|nian;
碾__碾 167.184787749|nian;
黏__黏 232.024158785|nian;
捻__捻 308.651751439|nian;
廿__廿 355.324137339|nian;
粘__粘 816.861571886|nian;
念__念 4327.91161602|nian;
年__年 105268.842274|nian;
茑__蔦 33.3749778421|niao;
溺__溺 64.2826664874|niao;
袅__裊 75.3054994207|niao;
脲__脲 128.209578049|niao;
嬲__嬲 277.976239008|niao;
尿__尿 1791.04500392|niao;
鸟__鳥 9418.66166506|niao;
酿__釀 340.583654043|niang;
娘__娘 3079.85238931|niang;
陧__隉 2.96020585532|nie;
摄__攝 4.87307621728|nie;
臬__臬 10.5786831883|nie;
镊__鑷 13.5898123379|nie;
蹑__躡 29.5013484091|nie;
蘖__櫱 30.7398379048|nie;
嗫__囁 53.7230447916|nie;
啮__嚙 57.6778685022|nie;
颞__顳 62.8567938662|nie;
乜__乜 83.3036737352|nie;
孽__孽 197.322580943|nie;
镍__鎳 307.883446338|nie;
涅__涅 767.517531652|nie;
聂__聶 810.776675547|nie;
捏__捏 4237.18989837|nie;
您__您 44386.0001792|nin;
聍__聹 4.53894186266|ning;
泞__濘 9.10934653767|ning;
狞__獰 24.5326119332|ning;
咛__嚀 29.5013484091|ning;
佞__佞 30.4349047749|ning;
甯__甯 47.6062426243|ning;
柠__檸 104.121288059|ning;
拧__擰 686.088301175|ning;
凝__凝 1031.22508566|ning;
宁__寧 3897.77990299|ning;
狃__狃 7.37025773577|niu;
忸__忸 17.7652839474|niu;
拗__拗 69.0148370967|niu;
钮__鈕 297.325836157|niu;
纽__紐 335.946843682|niu;
扭__扭 854.342048866|niu;
妞__妞 1474.61550226|niu;
牛__牛 13739.590032|niu;
耨__耨 63.3285354522|nou;
哝__噥 28.0318999418|nong;
脓__膿 261.184568064|nong;
浓__濃 1519.38443361|nong;
侬__儂 1991.17198299|nong;
农__農 2318.11814557|nong;
弄__弄 24374.0253527|nong;
帑__帑 3.72308804793|nu;
孥__孥 8.14289685005|nu;
胬__胬 19.1206716533|nu;
驽__駑 44.5635863793|nu;
弩__弩 253.488718522|nu;
努__努 418.854838101|nu;
奴__奴 1077.19810837|nu;
怒__怒 2622.4951033|nu;
娜__娜 3.97233507308|nuo;
搦__搦 5.2318078834|nuo;
锘__鍩 6.0004544437|nuo;
懦__懦 34.5600750082|nuo;
傩__儺 47.6656049081|nuo;
糯__糯 138.508067822|nuo;
喏__喏 217.736803143|nuo;
挪__挪 688.658042404|nuo;
诺__諾 2244.21407924|nuo;
脔__臠 5.63798584966|luan;
娈__孌 20.0478990282|luan;
孪__孿 20.3753232882|luan;
挛__攣 22.3714817609|luan;
滦__灤 30.1705706586|luan;
銮__鑾 58.619869127|luan;
峦__巒 109.579386421|luan;
鸾__鸞 197.322580943|luan;
栾__欒 202.554574186|luan;
卵__卵 824.018360007|luan;
乱__亂 12576.16843|luan;
锊__鋝 2.93815493948|lue;
掠__掠 271.810366771|lue;
略__略 2038.87985164|lue;
囵__圇 11.286887045|lun;
沦__淪 97.2239708206|lun;
抡__掄 133.925286409|lun;
仑__侖 200.545272755|lun;
纶__綸 220.742053181|lun;
伦__倫 1356.49494292|lun;
轮__輪 2977.95009215|lun;
论__論 6258.56170167|lun;
稆__穭 3.60888652264|lv;
膂__膂 4.40520113703|lv;
偻__僂 4.60158931136|lv;
榈__櫚 10.1524744344|lv;
褛__褸 15.5476017633|lv;
闾__閭 56.3282606906|lv;
捋__捋 168.649547684|lv;
缕__縷 237.879639313|lv;
侣__侶 241.162905094|lv;
虑__慮 243.57916235|lv;
滤__濾 245.101601395|lv;
履__履 286.058823982|lv;
氯__氯 411.610733326|lv;
屡__屢 554.41409416|lv;
律__律 756.125466931|lv;
旅__旅 1081.23274995|lv;
驴__驢 1162.27522076|lv;
铝__鋁 1318.16721196|lv;
吕__呂 2205.40034128|lv;
绿__綠 4675.55298725|lv;
率__率 6211.94095161|lv;
旯__旯 8.08223946949|la;
瘌__瘌 8.20400946554|la;
砬__砬 33.1263637715|la;
邋__邋 33.8778175482|la;
垃__垃 46.318814424|la;
落__落 56.6097392079|la;
剌__剌 132.266710153|la;
腊__臘 158.857391092|la;
蜡__蠟 454.760723981|la;
辣__辣 1603.0217369|la;
喇__喇 2106.02207003|la;
拉__拉 25270.9839606|la;
啦__啦 102549.743613|la;
崃__崍 6.15188498584|lai;
铼__錸 15.0706966208|lai;
涞__淶 31.5942495447|lai;
籁__籟 32.9206006539|lai;
赉__賚 33.962357657|lai;
徕__徠 35.8765582535|lai;
癞__癩 48.8076581499|lai;
睐__睞 61.769684063|lai;
濑__瀨 171.617679695|lai;
莱__萊 1188.64081012|lai;
赖__賴 2186.24593438|lai;
来__來 233997.444777|lai;
罱__罱 3.97233507308|lan;
漤__灠 6.03795899067|lan;
褴__襤 8.25528685814|lan;
婪__婪 9.61078722794|lan;
镧__鑭 25.7543572024|lan;
斓__斕 25.9476442055|lan;
谰__讕 56.3984988362|lan;
榄__欖 74.2802672471|lan;
缆__纜 149.633788238|lan;
阑__闌 321.208662461|lan;
澜__瀾 376.756940916|lan;
览__覽 401.979429753|lan;
滥__濫 425.69561654|lan;
篮__籃 472.083744072|lan;
揽__攬 548.914415679|lan;
拦__攔 585.662213047|lan;
岚__嵐 648.673070715|lan;
栏__欄 1903.81812306|lan;
懒__懶 3072.18592933|lan;
兰__蘭 4205.62658069|lan;
烂__爛 5013.49243365|lan;
蓝__藍 7677.71288718|lan;
稂__稂 3.68615574871|lang;
蒗__蒗 4.07258295585|lang;
锒__鋃 6.12892910424|lang;
莨__莨 12.7054041832|lang;
阆__閬 16.3830193271|lang;
螂__螂 25.2459352061|lang;
榔__榔 34.259912844|lang;
啷__啷 65.9049367884|lang;
琅__琅 125.522047856|lang;
廊__廊 318.815941979|lang;
朗__朗 1249.39213028|lang;
郎__郎 1793.27833544|lang;
浪__浪 2108.64816008|lang;
狼__狼 4237.18989837|lang;
铹__鐒 3.51566883068|lao;
络__絡 4.01213465767|lao;
潦__潦 4.47714731555|lao;
耢__耮 6.62949429182|lao;
栳__栳 7.58455926976|lao;
崂__嶗 11.1055107505|lao;
醪__醪 22.7085387432|lao;
落__落 23.8394435916|lao;
铑__銠 36.4624977337|lao;
酪__酪 54.8732993277|lao;
痨__癆 65.0076867586|lao;
姥__姥 77.3022190169|lao;
唠__嘮 126.779677253|lao;
涝__澇 177.048440864|lao;
烙__烙 296.585723861|lao;
佬__佬 686.088301175|lao;
牢__牢 811.787668067|lao;
劳__勞 1126.6237397|lao;
捞__撈 1427.60319527|lao;
老__老 39924.8907398|lao;
鳓__鰳 19.2641727042|le;
泐__泐 25.8508200533|le;
肋__肋 135.604660605|le;
仂__仂 139.547573842|le;
叻__叻 827.104717768|le;
勒__勒 3034.13893483|le;
乐__樂 6513.17941256|le;
了__了 1500186.06141|le;
塄__塄 7.57511353292|leng;
棱__棱 252.85772688|leng;
愣__愣 369.779825848|leng;
楞__楞 506.83620443|leng;
冷__冷 6135.01016399|leng;
檑__檑 3.41207902612|lei;
嫘__嫘 6.54739238175|lei;
儡__儡 7.00314861982|lei;
缧__縲 7.34275547194|lei;
诔__誄 18.3503113454|lei;
酹__酹 19.5787970687|lei;
耒__耒 33.2504384462|lei;
羸__羸 38.9520380838|lei;
擂__擂 105.0335283|lei;
肋__肋 107.952927857|lei;
镭__鐳 109.852835359|lei;
勒__勒 120.015323434|lei;
垒__壘 357.99085261|lei;
嘞__嘞 765.607004232|lei;
蕾__蕾 787.868200695|lei;
磊__磊 889.099334512|lei;
泪__淚 2586.79165036|lei;
雷__雷 4231.91294301|lei;
累__累 13301.5573221|lei;
类__類 19235.2858872|lei;
跞__躒 1.4585404586|li;
鲡__鱺 2.5745845097|li;
轹__轢 4.50513075969|li;
篥__篥 4.51074840217|li;
蜊__蜊 5.63798584966|li;
嫠__嫠 5.79469327116|li;
粝__糲 6.83076396136|li;
黧__黧 7.57511353292|li;
猁__猁 8.07217392654|li;
疠__癘 9.29279754133|li;
鳢__鱧 9.55109019762|li;
雳__靂 10.2797827572|li;
苈__藶 10.2926010632|li;
坜__壢 12.6264850603|li;
缡__縭 13.6407129304|li;
鬲__鬲 13.9501451796|li;
蓠__蘺 14.2665967332|li;
逦__邐 14.773182938|li;
疬__癧 15.6447786965|li;
詈__詈 16.9859107246|li;
娌__娌 17.17748849|li;
蛎__蠣 20.1229883609|li;
枥__櫪 21.4434095627|li;
栎__櫟 21.523725775|li;
醴__醴 26.0123950313|li;
鹂__鸝 27.1044155572|li;
唳__唳 27.5127806629|li;
呖__嚦 27.9621221044|li;
蠡__蠡 30.8934482576|li;
罹__罹 31.8710569716|li;
溧__溧 32.5940347875|li;
俚__俚 35.4322507649|li;
莅__蒞 43.3044433518|li;
澧__澧 51.110777742|li;
藜__藜 54.0588291018|li;
漓__漓 57.2482193879|li;
砾__礫 61.5391892542|li;
砺__礪 62.9351727223|li;
戾__戾 64.6844514367|li;
痢__痢 69.0148370967|li;
郦__酈 71.3764517044|li;
喱__喱 76.3448820686|li;
俪__儷 83.1999281447|li;
篱__籬 93.4232241613|li;
鲤__鯉 109.170488754|li;
璃__璃 110.126966673|li;
傈__傈 112.625137786|li;
狸__狸 117.499561272|li;
隶__隸 122.584950132|li;
骊__驪 124.742372548|li;
锂__鋰 127.572086295|li;
笠__笠 128.850255419|li;
荔__荔 153.792848894|li;
俐__俐 176.60772663|li;
犁__犁 217.465635832|li;
励__勵 244.186999878|li;
吏__吏 261.184568064|li;
厘__厘 266.776744296|li;
栗__栗 316.046952528|li;
沥__瀝 346.1460998|li;
厉__厲 528.113581536|li;
历__歷 804.737106306|li;
梨__梨 882.476330723|li;
莉__莉 1093.42757174|li;
粒__粒 1193.09285994|li;
哩__哩 1723.1742594|li;
礼__禮 2255.42866395|li;
黎__黎 2323.90287358|li;
例__例 2655.38023445|li;
丽__麗 3385.80036467|li;
利__利 4951.40363972|li;
立__立 4957.57775917|li;
理__理 7822.57824362|li;
力__力 8983.04290431|li;
离__離 9937.12917391|li;
李__李 14513.9865477|li;
里__里 98050.827389|li;
俩__倆 5217.45686316|lia;
蔹__蘞 3.50255004228|lian;
裣__襝 4.25944736101|lian;
裢__褳 5.02102150492|lian;
臁__臁 8.16321697203|lian;
蠊__蠊 12.8007585141|lian;
奁__奩 19.3363265928|lian;
鲢__鰱 21.523725775|lian;
楝__楝 26.3714236844|lian;
潋__瀲 28.1368933208|lian;
殓__殮 39.3423060008|lian;
镰__鐮 49.4196883638|lian;
琏__璉 67.5681475337|lian;
涟__漣 100.801790908|lian;
濂__濂 107.550099352|lian;
敛__斂 226.595011951|lian;
廉__廉 490.677728407|lian;
怜__憐 498.070459751|lian;
帘__簾 530.752623218|lian;
炼__煉 881.377303227|lian;
链__鏈 1411.68136652|lian;
莲__蓮 1431.1656954|lian;
恋__戀 1521.27901981|lian;
联__聯 3141.87681769|lian;
脸__臉 7322.61405337|lian;
练__練 8718.35595463|lian;
连__連 26463.4627738|lian;
鹩__鷯 7.67010269101|liao;
尥__尥 8.25528685814|liao;
钌__釕 15.6252948403|liao;
镣__鐐 18.9782395584|liao;
獠__獠 23.0219668635|liao;
潦__潦 28.4542388688|liao;
缭__繚 31.9904298992|liao;
嘹__嘹 38.8550775145|liao;
蓼__蓼 49.5430123006|liao;
寥__寥 54.6685385161|liao;
燎__燎 82.0672187964|liao;
僚__僚 88.3284696576|liao;
撂__撂 97.7098097016|liao;
寮__寮 142.891090816|liao;
撩__撩 284.636464248|liao;
疗__療 318.815941979|liao;
辽__遼 530.091629029|liao;
廖__廖 1463.63092081|liao;
料__料 3523.54522994|liao;
聊__聊 15975.6804355|liao;
了__了 16750.3963294|liao;
墚__墚 3.51129045069|liang;
踉__踉 9.25812128184|liang;
魉__魎 18.3731931427|liang;
椋__椋 35.9212942863|liang;
粱__粱 102.831814646|liang;
谅__諒 133.591915611|liang;
晾__晾 390.621510938|liang;
俩__倆 546.866130582|liang;
粮__糧 968.932019286|liang;
靓__靚 1509.94683642|liang;
辆__輛 1820.2965272|liang;
凉__涼 2197.17084589|liang;
良__良 2770.30526836|liang;
梁__梁 4148.36989009|liang;
亮__亮 4387.64638002|liang;
量__量 11116.5295228|liang;
两__兩 16584.235701|liang;
躐__躐 4.55026852613|lie;
埒__埒 10.3054353528|lie;
趔__趔 17.6989924358|lie;
捩__捩 18.4880308256|lie;
鬣__鬣 20.3753232882|lie;
洌__洌 27.2738258636|lie;
冽__冽 61.2332002144|lie;
劣__劣 291.819695868|lie;
猎__獵 377.697115787|lie;
裂__裂 768.474582473|lie;
烈__烈 1000.83985593|lie;
咧__咧 3501.65886607|lie;
列__列 6282.00312169|lie;
瞵__瞵 2.98614117512|lin;
躏__躪 4.20145793779|lin;
辚__轔 10.8051814884|lin;
嶙__嶙 11.216778986|lin;
懔__懍 12.5168211467|lin;
遴__遴 12.7848165731|lin;
檩__檁 13.1401696537|lin;
粼__粼 18.7198639824|lin;
赁__賃 19.5057383967|lin;
廪__廩 22.7652065711|lin;
膦__膦 23.5442078214|lin;
啉__啉 53.9915047583|lin;
吝__吝 68.3302235228|lin;
蔺__藺 99.1819416753|lin;
凛__凜 129.494134325|lin;
鳞__鱗 222.67604562|lin;
拎__拎 505.574572707|lin;
麟__麟 544.825488702|lin;
磷__磷 569.114341748|lin;
邻__鄰 595.22730595|lin;
霖__霖 722.053448193|lin;
淋__淋 781.999279332|lin;
琳__琳 1647.57761372|lin;
临__臨 1838.53442614|lin;
林__林 12069.4822026|lin;
鲮__鯪 5.1928355413|ling;
柃__柃 8.28620700495|ling;
酃__酃 10.4216665228|ling;
囹__囹 10.7113360133|ling;
蛉__蛉 12.1026802507|ling;
瓴__瓴 17.7652839474|ling;
棂__欞 20.0979273856|ling;
棱__棱 22.3714817609|ling;
呤__呤 90.8967552212|ling;
聆__聆 101.053335871|ling;
羚__羚 110.264288753|ling;
苓__苓 131.609045271|ling;
泠__泠 150.194241046|ling;
绫__綾 153.792848894|ling;
伶__伶 174.42055653|ling;
翎__翎 229.722524886|ling;
菱__菱 343.567617462|ling;
龄__齡 582.024395035|ling;
铃__鈴 631.130833438|ling;
陵__陵 732.019384688|ling;
岭__嶺 1178.31719254|ling;
玲__玲 1689.15672637|ling;
凌__凌 1764.46098498|ling;
零__零 3091.3879652|ling;
灵__靈 3722.14075882|ling;
领__領 4061.41172752|ling;
令__令 7764.30695341|ling;
另__另 10842.8927276|ling;
鹨__鷚 5.16058044571|liu;
锍__鋶 6.045487983|liu;
镏__鎦 9.92727943045|liu;
旒__旒 13.8289849747|liu;
骝__騮 19.1922880593|liu;
熘__熘 22.8220158102|liu;
鎏__鎏 23.3106539228|liu;
馏__餾 26.8355451|liu;
绺__綹 30.3591453066|liu;
碌__碌 39.3423060008|liu;
浏__瀏 57.0345965147|liu;
榴__榴 67.8212237837|liu;
琉__琉 105.558392399|liu;
遛__遛 172.690339006|liu;
陆__陸 200.795341333|liu;
硫__硫 387.711726118|liu;
瘤__瘤 843.76158662|liu;
溜__溜 982.305426747|liu;
柳__柳 3130.15284164|liu;
流__流 6305.53234147|liu;
六__六 8090.25858348|liu;
留__留 9584.42452404|liu;
刘__劉 11439.7596478|liu;
咯__咯 27403.1420416|lo;
嵝__嶁 5.54738540526|lou;
髅__髏 5.96318285478|lou;
偻__僂 7.68924298287|lou;
蝼__螻 14.8285158408|lou;
耧__耬 19.8985599093|lou;
蒌__蔞 24.4106293322|lou;
镂__鏤 50.9200568548|lou;
篓__簍 83.096311758|lou;
陋__陋 86.3692300453|lou;
瘘__瘺 116.769717326|lou;
娄__婁 331.37316028|lou;
搂__摟 569.823995046|lou;
露__露 1126.6237397|lou;
漏__漏 1850.02578923|lou;
喽__嘍 2847.30570911|lou;
楼__樓 12718.0103532|lou;
癃__癃 5.3571603921|long;
砻__礱 11.5429240178|long;
茏__蘢 17.3712269897|long;
咙__嚨 18.0554283133|long;
栊__櫳 31.2808408198|long;
窿__窿 39.5389038333|long;
垅__壠 47.2516182162|long;
泷__瀧 48.8076581499|long;
胧__朧 55.7694954528|long;
珑__瓏 119.26985293|long;
垄__壟 120.916041011|long;
陇__隴 155.72135507|long;
聋__聾 178.377193209|long;
拢__攏 248.484546245|long;
笼__籠 625.649317648|long;
弄__弄 927.579613097|long;
隆__隆 1472.77903036|long;
龙__龍 9924.75356924|long;
轳__轤 4.42170080182|lu;
簏__簏 5.1928355413|lu;
镥__鑥 6.49052677985|lu;
栌__櫨 8.13275576498|lu;
六__六 8.5590795432|lu;
辘__轆 10.9134406676|lu;
胪__臚 11.2447698008|lu;
辂__輅 12.7688944861|lu;
舻__艫 13.4215114839|lu;
氇__氌 14.4454946476|lu;
垆__壚 16.9436288914|lu;
鸬__鸕 23.1081955564|lu;
鲈__鱸 28.9911218594|lu;
逯__逯 29.6857402276|lu;
渌__淥 30.2081916487|lu;
赂__賂 31.3198462537|lu;
绿__綠 35.2560722919|lu;
漉__漉 35.3881237821|lu;
碌__碌 39.3423060008|lu;
橹__櫓 46.0311069133|lu;
泸__瀘 47.1927715073|lu;
撸__擼 71.7331276881|lu;
戮__戮 74.9310606649|lu;
掳__擄 99.1819416753|lu;
潞__潞 109.442917312|lu;
虏__虜 124.431860131|lu;
颅__顱 125.992190229|lu;
噜__嚕 177.711575153|lu;
鹭__鷺 184.481071779|lu;
庐__廬 198.803491145|lu;
麓__麓 206.376433771|lu;
卤__鹵 256.028470459|lu;
芦__蘆 306.734573113|lu;
璐__璐 320.409100324|lu;
禄__祿 543.469292924|lu;
鹿__鹿 955.740681497|lu;
炉__爐 982.305426747|lu;
卢__盧 2059.3077787|lu;
露__露 2148.43475692|lu;
鲁__魯 2347.18650079|lu;
录__錄 2662.00658024|lu;
陆__陸 3000.29967146|lu;
路__路 20471.9308908|lu;
硌__硌 0.655338992326|luo;
跞__躒 1.4585404586|luo;
脶__腡 4.44933768948|luo;
猓__猓 6.06813133618|luo;
漯__漯 6.88202899139|luo;
荦__犖 10.1398306408|luo;
瘰__瘰 10.7514552832|luo;
泺__濼 11.5573173892|luo;
捋__捋 12.3772230543|luo;
猡__玀 15.7818476567|luo;
蠃__蠃 16.2205030062|luo;
镙__鏍 17.9209313392|luo;
烙__烙 24.0483086584|luo;
倮__倮 24.1684807031|luo;
逻__邏 33.2090286713|luo;
椤__欏 46.1459748436|luo;
雒__雒 49.7905841849|luo;
骡__騾 66.6482540425|luo;
箩__籮 79.055778352|luo;
珞__珞 92.1513317243|luo;
锣__鑼 114.75018218|luo;
摞__摞 194.151676652|luo;
螺__螺 314.083839199|luo;
萝__蘿 329.314848809|luo;
络__絡 407.527636023|luo;
骆__駱 508.100984482|luo;
裸__裸 795.762002835|luo;
咯__咯 931.053859154|luo;
洛__洛 1822.5663337|luo;
落__落 5191.51429493|luo;
罗__羅 7793.38813678|luo;
括__括 1.61747787344|gua;
鸹__鴰 5.70157459376|gua;
诖__詿 6.15955603742|gua;
栝__栝 19.6766344722|gua;
胍__胍 31.164115738|gua;
褂__褂 70.1419942084|gua;
剐__剮 94.5947172842|gua;
呱__呱 99.30561593|gua;
寡__寡 305.589986932|gua;
卦__卦 641.438524323|gua;
刮__刮 1343.0387806|gua;
瓜__瓜 1641.42964497|gua;
挂__掛 12144.9198993|gua;
矜__矜 7.42557167814|guan;
盥__盥 7.96227687407|guan;
涫__涫 8.26558073253|guan;
鳏__鰥 12.5480561404|guan;
纶__綸 14.3200322192|guan;
鹳__鸛 20.4516389872|guan;
掼__摜 26.3714236844|guan;
倌__倌 56.1880467122|guan;
莞__莞 147.229226029|guan;
棺__棺 270.458854115|guan;
贯__貫 406.513206136|guan;
惯__慣 762.750126416|guan;
罐__罐 831.23785106|guan;
冠__冠 1425.82527204|guan;
灌__灌 2064.44666061|guan;
馆__館 2318.11814557|guan;
观__觀 3281.94475852|guan;
官__官 4437.13301058|guan;
关__關 11612.1152793|guan;
管__管 15029.3572068|guan;
犷__獷 13.3215330924|guang;
胱__胱 19.0730759099|guang;
桄__桄 22.9646599002|guang;
咣__咣 60.7770670229|guang;
逛__逛 3514.77431657|guang;
广__廣 3745.40519724|guang;
光__光 12327.8997347|guang;
磙__磙 4.81872758227|gun;
绲__緄 8.77508085903|gun;
丨__丨 20.3753232882|gun;
鲧__鯀 25.6582543045|gun;
衮__袞 27.9969892844|gun;
辊__輥 213.704562287|gun;
棍__棍 758.957532109|gun;
滚__滾 3811.32210727|gun;
掴__摑 2.20321433492|guai;
拐__拐 873.722339551|guai;
怪__怪 13739.590032|guai;
乖__乖 18529.4508567|guai;
尜__尜 6.97701623098|ga;
夹__夾 7.44410175719|ga;
钆__釓 8.79697855917|ga;
旮__旮 29.5013484091|ga;
轧__軋 52.5969019002|ga;
尕__尕 72.2714863498|ga;
尬__尬 231.735198139|ga;
伽__伽 335.110594827|ga;
咖__咖 725.661628731|ga;
嘎__嘎 3558.84830329|ga;
噶__噶 6258.56170167|ga;
戤__戤 2.30717888254|gai;
芥__芥 7.77596709276|gai;
陔__陔 11.3999725243|gai;
垓__垓 12.1935111255|gai;
赅__賅 19.1922880593|gai;
溉__溉 19.9233722847|gai;
丐__丐 128.369448119|gai;
概__概 363.384474622|gai;
钙__鈣 1165.17561047|gai;
盖__蓋 4231.91294301|gai;
改__改 27437.3122051|gai;
该__該 48251.0342476|gai;
澉__澉 4.64769351448|gan;
旰__旰 5.67322486481|gan;
泔__泔 9.70707954272|gan;
坩__坩 12.5480561404|gan;
尴__尷 13.7430867735|gan;
疳__疳 15.0144600156|gan;
矸__矸 21.7123020898|gan;
酐__酐 22.7935934922|gan;
橄__橄 26.7354077279|gan;
绀__紺 48.5649736324|gan;
擀__擀 76.2498028901|gan;
淦__淦 79.055778352|gan;
秆__稈 79.3518814814|gan;
柑__柑 118.529012887|gan;
乾__乾 142.535402072|gan;
苷__苷 161.653186955|gan;
竿__竿 216.384339476|gan;
赣__贛 254.121284766|gan;
杆__桿 1394.19862478|gan;
肝__肝 1504.31243966|gan;
赶__趕 3694.41410176|gan;
敢__敢 7442.20770676|gan;
感__感 7460.77930003|gan;
甘__甘 9371.82960123|gan;
干__干 22116.3475883|gan;
筻__筻 2.53005700699|gang;
扛__扛 8.74233646968|gang;
戆__戇 114.321989585|gang;
罡__罡 119.56748386|gang;
肛__肛 152.077621994|gang;
杠__杠 298.439468992|gang;
冈__岡 387.22887368|gang;
纲__綱 387.711726118|gang;
缸__缸 620.215410078|gang;
岗__崗 1288.92855961|gang;
钢__鋼 2439.63524442|gang;
港__港 4237.18989837|gang;
刚__剛 33324.9317336|gang;
槔__槔 4.60158931136|gao;
藁__藁 17.0282980696|gao;
槁__槁 17.3064059095|gao;
缟__縞 18.8134092027|gao;
睾__睾 27.3759798789|gao;
杲__杲 27.5127806629|gao;
诰__誥 33.1263637715|gao;
篙__篙 33.2504384462|gao;
羔__羔 43.8474652613|gao;
郜__郜 56.3984988362|gao;
锆__鋯 58.1107421423|gao;
镐__鎬 70.4047107918|gao;
皋__皋 124.122120652|gao;
糕__糕 347.875829952|gao;
膏__膏 703.402776999|gao;
稿__稿 1710.33813502|gao;
告__告 2532.56730325|gao;
搞__搞 39924.8907398|gao;
高__高 45167.1674565|gao;
合__合 1.34673291305|ge;
塥__塥 1.98919832109|ge;
仡__仡 3.64050514333|ge;
蛤__蛤 3.79333637384|ge;
袼__袼 4.43273489709|ge;
虼__虼 4.72949016373|ge;
盖__蓋 4.96502285992|ge;
搿__搿 5.49920509291|ge;
哿__哿 5.86735660919|ge;
颌__頜 8.5590795432|ge;
纥__紇 9.52731534041|ge;
骼__骼 10.7917248198|ge;
鬲__鬲 13.9501451796|ge;
胳__胳 23.5148860924|ge;
圪__圪 34.8194491124|ge;
疙__疙 46.8412270934|ge;
硌__硌 55.1475072429|ge;
膈__膈 66.4823512304|ge;
嗝__嗝 77.3022190169|ge;
舸__舸 78.1740819755|ge;
镉__鎘 127.73116145|ge;
鸽__鴿 240.562595233|ge;
铬__鉻 278.322859608|ge;
革__革 540.767020614|ge;
搁__擱 572.671468255|ge;
咯__咯 590.793388895|ge;
戈__戈 931.053859154|ge;
葛__葛 1383.81307795|ge;
阁__閣 1399.42059064|ge;
割__割 1546.12469848|ge;
隔__隔 1866.23446282|ge;
哥__哥 9418.66166506|ge;
歌__歌 11397.0719564|ge;
格__格 13038.9685774|ge;
各__各 29019.8865492|ge;
个__個 245957.032201|ge;
茛__茛 6.49862009853|gen;
亘__亘 63.3285354522|gen;
哏__哏 64.5234369803|gen;
艮__艮 159.055477247|gen;
根__根 6854.60405824|gen;
跟__跟 74632.4598696|gen;
颈__頸 21.0200908593|geng;
绠__綆 24.8093061328|geng;
赓__賡 25.7543572024|geng;
鲠__鯁 27.1044155572|geng;
埂__埂 51.9455239942|geng;
哽__哽 56.2581100189|geng;
羹__羹 255.073095111|geng;
梗__梗 415.734739962|geng;
耕__耕 439.166555128|geng;
耿__耿 635.867483878|geng;
庚__庚 729.287839744|geng;
更__更 48734.4705851|geng;
给__給 191937.485929|gei;
句__句 0.655338992326|gou;
鞲__韝 5.1928355413|gou;
笱__笱 6.66262260432|gou;
佝__佝 7.83432589256|gou;
遘__遘 10.9816527759|gou;
缑__緱 11.7314441888|gou;
岣__岣 12.5168211467|gou;
彀__彀 13.4215114839|gou;
觏__覯 13.5898123379|gou;
枸__枸 13.6067580629|gou;
篝__篝 14.2133606428|gou;
诟__詬 18.0554283133|gou;
媾__媾 20.2235451481|gou;
垢__垢 203.313241605|gou;
苟__苟 290.0070692|gou;
构__構 479.196331601|gou;
钩__鉤 775.207436548|gou;
勾__勾 1280.92243009|gou;
沟__溝 1802.23954462|gou;
购__購 2028.7420046|gou;
狗__狗 10200.611399|gou;
够__夠 14732.6596137|gou;
红__紅 3.7980664491|gong;
蚣__蚣 5.65910290509|gong;
珙__珙 16.1197499839|gong;
觥__觥 20.3246044287|gong;
肱__肱 42.555491934|gong;
躬__躬 175.292155245|gong;
汞__汞 260.534419685|gong;
巩__鞏 268.109857044|gong;
贡__貢 378.168082664|gong;
恭__恭 432.109303457|gong;
拱__拱 496.21189989|gong;
龚__龔 843.76158662|gong;
弓__弓 1436.52612129|gong;
攻__攻 1880.24059249|gong;
功__功 2090.33406802|gong;
宫__宮 2702.11335163|gong;
供__供 4781.61539648|gong;
公__公 5026.00331027|gong;
工__工 5450.05619202|gong;
共__共 9924.75356924|gong;
牿__牿 3.86009684414|gu;
嘏__嘏 4.72360010237|gu;
贾__賈 5.27764544242|gu;
梏__梏 5.78747661614|gu;
鸪__鴣 6.76300412993|gu;
鲴__鯝 7.51868563597|gu;
鹘__鶻 7.77596709276|gu;
罟__罟 8.64483459761|gu;
酤__酤 9.03022977735|gu;
轱__軲 11.8933640967|gu;
汩__汩 12.6264850603|gu;
蛄__蛄 12.7212471015|gu;
觚__觚 13.7773818413|gu;
锢__錮 13.9154200641|gu;
诂__詁 16.281256841|gu;
痼__痼 17.4580329226|gu;
鹄__鵠 21.658255183|gu;
牯__牯 22.1495610736|gu;
臌__臌 22.2880021302|gu;
菰__菰 22.3436205337|gu;
崮__崮 28.3127569069|gu;
毂__轂 39.6375708511|gu;
瞽__瞽 54.3289670197|gu;
咕__咕 92.3812899733|gu;
呱__呱 99.30561593|gu;
钴__鈷 123.351140937|gu;
辜__辜 168.439513167|gu;
箍__箍 170.977284899|gu;
蛊__蠱 175.729586548|gu;
菇__菇 252.54282031|gu;
沽__沽 308.651751439|gu;
雇__雇 349.178797604|gu;
估__估 426.226434824|gu;
姑__姑 592.267679181|gu;
固__固 977.421145723|gu;
孤__孤 1092.0658276|gu;
鼓__鼓 1232.38252249|gu;
骨__骨 2332.60704332|gu;
谷__谷 2678.64487851|gu;
顾__顧 3015.29249908|gu;
古__古 4404.08029353|gu;
故__故 4669.73009873|gu;
股__股 16667.1089518|gu;
猓__猓 4.06244536148|guo;
蜾__蜾 4.83075243461|guo;
崞__崞 5.12852570138|guo;
馘__馘 7.13528609825|guo;
埚__堝 8.58043822471|guo;
涡__渦 9.61078722794|guo;
聒__聒 14.0198555902|guo;
呙__咼 16.3015586446|guo;
帼__幗 19.5057383967|guo;
蝈__蟈 26.4043073537|guo;
椁__槨 34.8194491124|guo;
虢__虢 36.9657609447|guo;
囗__囗 53.9915047583|guo;
掴__摑 73.9109262154|guo;
裹__裹 469.151414294|guo;
锅__鍋 1884.93262272|guo;
郭__郭 4365.82984783|guo;
果__果 4532.13567457|guo;
国__國 10112.0167535|guo;
过__過 111897.093192|guo;
刽__劊 4.78879624368|gui;
鳜__鱖 5.75152793069|gui;
宄__宄 6.50672350913|gui;
庋__庋 8.40057501053|gui;
晷__晷 14.391590996|gui;
匦__匭 14.9026155662|gui;
皈__皈 15.5282389303|gui;
炅__炅 16.0196227851|gui;
簋__簋 22.0944257288|gui;
刿__劌 22.595625914|gui;
鲑__鮭 24.7784088627|gui;
桧__檜 31.8313650651|gui;
妫__媯 41.1474691339|gui;
瑰__瑰 85.087273845|gui;
诡__詭 98.8118422805|gui;
癸__癸 112.625137786|gui;
闺__閨 118.529012887|gui;
圭__圭 252.54282031|gui;
轨__軌 456.464028614|gui;
跪__跪 532.077085292|gui;
硅__硅 604.195219728|gui;
柜__櫃 994.623178167|gui;
龟__龜 1054.61787307|gui;
规__規 1058.56794047|gui;
桂__桂 1247.83614939|gui;
归__歸 3754.75163646|gui;
鬼__鬼 6652.63193601|gui;
贵__貴 13963.9863686|gui;
侉__侉 9.31598717311|kua;
胯__胯 113.753550575|kua;
挎__挎 119.121315407|kua;
垮__垮 498.070459751|kua;
夸__誇 1613.0410787|kua;
跨__跨 2090.33406802|kua;
髋__髖 45.1786625526|kuan;
宽__寬 3177.31287701|kuan;
款__款 6685.87586988|kuan;
纩__纊 4.06244536148|kuang;
贶__貺 7.9226863386|kuang;
夼__夼 10.2926010632|kuang;
诓__誆 26.077307439|kuang;
哐__哐 35.3440517546|kuang;
诳__誑 37.9932216791|kuang;
眶__眶 68.3302235228|kuang;
邝__鄺 155.140277726|kuang;
圹__壙 176.827946446|kuang;
旷__曠 213.438416689|kuang;
筐__筐 253.488718522|kuang;
匡__匡 295.479008313|kuang;
况__況 402.480675297|kuang;
框__框 1836.24473312|kuang;
矿__礦 2400.43116637|kuang;
狂__狂 4205.62658069|kuang;
阃__閫 10.9406745194|kun;
髡__髡 14.9770855761|kun;
悃__悃 17.3279860159|kun;
醌__醌 42.9818635441|kun;
锟__錕 58.9862599821|kun;
鲲__鯤 79.5498994523|kun;
琨__琨 142.357889859|kun;
捆__捆 378.63963681|kun;
昆__昆 767.517531652|kun;
坤__坤 1221.67899812|kun;
困__困 3946.65663992|kun;
狯__獪 3.20596605601|kuai;
郐__鄶 8.10240822453|kuai;
浍__澮 16.8804034021|kuai;
哙__噲 24.1383815107|kuai;
脍__膾 24.8093061328|kuai;
会__會 44.7304991295|kuai;
蒯__蒯 55.5613904675|kuai;
侩__儈 80.1469231538|kuai;
筷__筷 102.448095678|kuai;
块__塊 16563.5818541|kuai;
快__快 48011.1174106|kuai;
胩__胩 4.32901307451|ka;
咯__咯 6.02292912393|ka;
佧__佧 7.95236073138|ka;
咔__咔 126.937764318|ka;
咖__咖 127.73116145|ka;
喀__喀 211.584655172|ka;
卡__卡 30770.3376525|ka;
锎__鐦 3.46780543658|kai;
垲__塏 5.80915358869|kai;
忾__愾 8.35880514141|kai;
蒈__蒈 11.6440553041|kai;
剀__剴 23.1081955564|kai;
锴__鍇 58.7661515758|kai;
慨__慨 89.4360764191|kai;
揩__揩 106.085879302|kai;
铠__鎧 110.677283245|kai;
恺__愷 159.651218957|kai;
楷__楷 228.011295226|kai;
凯__凱 1983.741885|kai;
开__開 54927.7440449|kai;
莰__莰 4.71771737643|kan;
嵌__嵌 8.77508085903|kan;
戡__戡 16.1398503976|kan;
瞰__瞰 27.2059350468|kan;
龛__龕 53.3893461926|kan;
槛__檻 80.6478642194|kan;
阚__闞 86.8008265922|kan;
勘__勘 133.925286409|kan;
堪__堪 473.261801395|kan;
刊__刊 522.223615731|kan;
侃__侃 543.469292924|kan;
坎__坎 660.089332023|kan;
砍__砍 2746.24453283|kan;
看__看 245039.238627|kan;
闶__閌 10.1145902734|kang;
钪__鈧 12.6264850603|kang;
伉__伉 13.1565546998|kang;
慷__慷 36.5079643999|kang;
糠__糠 141.826678552|kang;
亢__亢 146.862738669|kang;
炕__炕 151.132997772|kang;
扛__扛 796.754272909|kang;
康__康 3377.37232991|kang;
抗__抗 3971.32436646|kang;
犒__犒 9.77993138287|kao;
栲__栲 17.3064059095|kao;
铐__銬 90.2196547772|kao;
尻__尻 181.290467084|kao;
拷__拷 946.259922413|kao;
烤__烤 1546.12469848|kao;
考__考 16604.9153021|kao;
靠__靠 30617.3394381|kao;
锞__錁 5.29741284417|ke;
蚵__蚵 6.36239597244|ke;
钶__鈳 7.20677589391|ke;
骒__騍 7.29714623248|ke;
溘__溘 7.79537156303|ke;
稞__稞 8.7532376673|ke;
疴__痾 8.8851171693|ke;
瞌__瞌 9.87791838528|ke;
岢__岢 16.1599758755|ke;
氪__氪 22.2602448677|ke;
窠__窠 28.0318999418|ke;
蝌__蝌 28.5964278316|ke;
缂__緙 30.4728553745|ke;
颏__頦 34.3882332226|ke;
轲__軻 44.5080873194|ke;
髁__髁 48.8076581499|ke;
坷__坷 89.3246935936|ke;
嗑__嗑 102.320507809|ke;
恪__恪 113.47039186|ke;
苛__苛 119.56748386|ke;
珂__珂 279.365316864|ke;
咳__咳 313.69268222|ke;
磕__磕 420.423657369|ke;
渴__渴 429.425273358|ke;
棵__棵 444.673543393|ke;
柯__柯 1159.38205078|ke;
颗__顆 1246.28210631|ke;
壳__殼 1521.27901981|ke;
刻__刻 2370.70341112|ke;
客__客 4081.70704886|ke;
科__科 5764.41348178|ke;
克__克 7151.27177974|ke;
课__課 7950.33736137|ke;
可__可 68911.3486678|ke;
龈__齦 4.58441838901|ken;
裉__裉 8.85196217725|ken;
恳__懇 73.6351261191|ken;
垦__墾 93.890070293|ken;
啃__啃 1105.75993438|ken;
肯__肯 2642.1769853|ken;
铿__鏗 65.169909632|keng;
吭__吭 97.4665875432|keng;
坑__坑 1708.20809643|keng;
芤__芤 8.00206524781|kou;
筘__筘 9.24659130704|kou;
眍__瞘 17.9656519733|kou;
蔻__蔻 48.746873564|kou;
叩__叩 198.308623594|kou;
寇__寇 397.001179899|kou;
抠__摳 471.495815538|kou;
扣__扣 4258.36360257|kou;
口__口 8827.6809553|kou;
崆__崆 11.5285485717|kong;
箜__箜 12.3926567493|kong;
倥__倥 13.4717817062|kong;
恐__恐 985.98464814|kong;
控__控 1542.27603899|kong;
孔__孔 3045.50329114|kong;
空__空 10992.5486576|kong;
喾__嚳 6.1980550146|ku;
骷__骷 11.3150528103|ku;
绔__絝 17.0920774979|ku;
刳__刳 23.7504862321|ku;
堀__堀 34.6031694612|ku;
窟__窟 189.845141544|ku;
枯__枯 478.003501869|ku;
裤__褲 892.429452826|ku;
酷__酷 2385.52098173|ku;
苦__苦 5038.54540704|ku;
库__庫 5650.61702447|ku;
哭__哭 9073.04572868|ku;
适__適 1.79373472684|kuo;
蛞__蛞 5.09667006386|kuo;
廓__廓 100.550872098|kuo;
括__括 194.393772779|kuo;
阔__闊 504.944935018|kuo;
扩__擴 659.267263146|kuo;
跬__跬 2.56178299815|kui;
暌__暌 4.98361933493|kui;
隗__隗 6.09845445623|kui;
悝__悝 8.14289685005|kui;
睽__睽 8.33799815555|kui;
喟__喟 10.3054353528|kui;
愦__憒 10.8998491741|kui;
傀__傀 12.2697240382|kui;
篑__簣 12.4545842188|kui;
聩__聵 12.6264850603|kui;
馗__馗 12.8007585141|kui;
蝰__蝰 12.8968284813|kui;
蒉__蕢 16.9647566355|kui;
岿__巋 24.9022292984|kui;
喹__喹 36.1458125926|kui;
勹__勹 37.9932216791|kui;
匮__匱 44.2316270695|kui;
揆__揆 46.4923013745|kui;
夔__夔 71.3764517044|kui;
逵__逵 72.1814801389|kui;
馈__饋 85.93977951|kui;
愧__愧 162.663565352|kui;
溃__潰 179.71591787|kui;
盔__盔 209.746993999|kui;
窥__窺 295.111021611|kui;
魁__魁 318.022335873|kui;
葵__葵 397.991873082|kui;
奎__奎 670.869975958|kui;
亏__虧 4988.56403023|kui;
哼__哼 2072.17903804|hng;
砉__砉 3.21396635646|hua;
猾__猾 19.1445140462|hua;
铧__鏵 29.7969280594|hua;
骅__驊 109.170488754|hua;
哗__嘩 208.964318904|hua;
桦__樺 272.149298879|hua;
滑__滑 1467.28332601|hua;
划__划 1591.08064256|hua;
华__華 7045.12729757|hua;
画__畫 8040.00625758|hua;
化__化 11875.5298799|hua;
花__花 23744.443244|hua;
话__話 57807.088273|hua;
锾__鍰 4.2119424299|huan;
萑__萑 4.89132830647|huan;
漶__漶 5.64501609817|huan;
逭__逭 6.41813897895|huan;
鲩__鯇 7.03814412413|huan;
圜__圜 9.13207837822|huan;
擐__擐 10.8862746072|huan;
缳__繯 10.8998491741|huan;
郇__郇 16.6298519291|huan;
痪__瘓 22.9360599347|huan;
豢__豢 25.6582543045|huan;
洹__洹 34.6463176505|huan;
獾__獾 35.4322507649|huan;
鬟__鬟 37.1042160675|huan;
奂__奐 48.0233362952|huan;
涣__渙 50.5407474611|huan;
宦__宦 85.2996041514|huan;
寰__寰 152.647228173|huan;
浣__浣 188.665925845|huan;
桓__桓 311.744192349|huan;
焕__煥 491.902185928|huan;
唤__喚 531.41444163|huan;
缓__緩 921.81798848|huan;
幻__幻 981.082073059|huan;
欢__歡 1313.24844471|huan;
患__患 1729.62840231|huan;
环__環 3091.3879652|huan;
还__還 5685.93498805|huan;
换__換 32585.7416788|huan;
鳇__鰉 2.47085605541|huang;
蟥__蟥 2.59390682166|huang;
癀__癀 4.68257455398|huang;
遑__遑 10.3182856461|huang;
隍__隍 11.6731123618|huang;
潢__潢 23.6618608187|huang;
肓__肓 25.0578753144|huang;
湟__湟 26.7687452646|huang;
徨__徨 27.1044155572|huang;
幌__幌 51.3022129735|huang;
篁__篁 60.099230173|huang;
蝗__蝗 60.2492042805|huang;
惶__惶 61.0047073057|huang;
璜__璜 67.8212237837|huang;
磺__磺 74.0030889474|huang;
簧__簧 91.123582748|huang;
恍__恍 102.575842641|huang;
凰__凰 120.164975734|huang;
谎__謊 177.490254874|huang;
煌__煌 237.287502254|huang;
荒__荒 652.727461906|huang;
慌__慌 886.886162059|huang;
皇__皇 1199.05487625|huang;
晃__晃 1353.11831545|huang;
黄__黃 16135.7438322|huang;
珲__琿 4.49391645449|hun;
诨__諢 7.04692029058|hun;
阍__閽 10.2541940169|hun;
馄__餛 15.8804886934|hun;
溷__溷 20.9416539708|hun;
浑__渾 278.322859608|hun;
荤__葷 453.628720089|hun;
婚__婚 1425.82527204|hun;
魂__魂 1506.18823193|hun;
昏__昏 2021.17171332|hun;
混__混 7535.53027431|hun;
划__划 1.84359145784|huai;
徊__徊 45.2914032579|huai;
踝__踝 61.3095545413|huai;
槐__槐 243.882891747|huai;
淮__淮 403.48504224|huai;
怀__懷 1932.50174796|huai;
坏__壞 10112.0167535|huai;
铪__鉿 20.6565478685|ha;
虾__蝦 68.8430433158|ha;
蛤__蛤 247.866011137|ha;
哈__哈 53642.486556|ha;
胲__胲 4.65348892463|hai;
醢__醢 11.7460726342|hai;
骸__骸 62.2332668667|hai;
氦__氦 75.5875558941|hai;
嘿__嘿 91.0100983184|hai;
骇__駭 122.584950132|hai;
亥__亥 165.73274959|hai;
孩__孩 863.977854874|hai;
咳__咳 1176.84972769|hai;
嗨__嗨 1333.03432936|hai;
害__害 2854.41099368|hai;
海__海 12451.4153192|hai;
还__還 279642.500227|hai;
阚__闞 2.38315643868|han;
撖__撖 2.98242226375|han;
犴__犴 4.78879624368|han;
顸__頇 15.8607112862|han;
蚶__蚶 15.9598452429|han;
邗__邗 17.3928879243|han;
颔__頷 18.0779424081|han;
鼾__鼾 23.7504862321|han;
焓__焓 26.6688571574|han;
邯__邯 34.9063390075|han;
捍__捍 82.0672187964|han;
菡__菡 94.2417352088|han;
酣__酣 111.091824605|han;
晗__晗 123.197520618|han;
憾__憾 137.476305203|han;
悍__悍 139.026849285|han;
撼__撼 142.535402072|han;
罕__罕 214.504991945|han;
瀚__瀚 229.722524886|han;
憨__憨 255.709615075|han;
旱__旱 363.837594448|han;
翰__翰 391.596284031|han;
焊__焊 651.914561431|han;
函__函 949.804135501|han;
涵__涵 1185.68201014|han;
汉__漢 3523.54522994|han;
韩__韓 4279.6431141|han;
寒__寒 4520.85414793|han;
含__含 5223.96273588|han;
喊__喊 7142.36565495|han;
汗__汗 13318.1436095|han;
颃__頏 2.25881578049|hang;
沆__沆 11.8047690518|hang;
绗__絎 15.4510284409|hang;
巷__巷 28.1018519056|hang;
吭__吭 36.1458125926|hang;
夯__夯 135.94305409|hang;
杭__杭 656.807194196|hang;
航__航 1145.0238695|hang;
行__行 3209.14698221|hang;
嚆__嚆 12.3156802448|hao;
貉__貉 18.0329422573|hao;
薅__薅 21.5774369716|hao;
嗥__嗥 26.6024722466|hao;
镐__鎬 31.3980030949|hao;
颢__顥 59.2810208143|hao;
壕__壕 64.2026094756|hao;
蚝__蚝 77.2059475801|hao;
濠__濠 114.75018218|hao;
蒿__蒿 144.863304286|hao;
嚎__嚎 185.634130949|hao;
灏__灝 193.427195796|hao;
毫__毫 281.461959558|hao;
皓__皓 452.499534015|hao;
昊__昊 567.697685436|hao;
郝__郝 1012.12795618|hao;
耗__耗 1100.26180506|hao;
豪__豪 1625.14698659|hao;
浩__浩 1631.2339687|hao;
号__號 70299.1382336|hao;
好__好 378543.297105|hao;
蚵__蚵 6.21352189773|he;
吓__嚇 7.67966687395|he;
纥__紇 9.52731534041|he;
盍__盍 13.6747525303|he;
貉__貉 21.1514724059|he;
曷__曷 21.4969203349|he;
劾__劾 24.6552040947|he;
翮__翮 25.690248692|he;
菏__菏 28.0318999418|he;
阂__閡 28.3127569069|he;
嗬__嗬 30.4728553745|he;
涸__涸 37.7572282633|he;
阖__闔 53.8571075021|he;
颌__頜 81.3544462113|he;
壑__壑 96.6200679148|he;
诃__訶 120.015323434|he;
褐__褐 215.040276584|he;
禾__禾 547.548041623|he;
赫__赫 861.827215553|he;
鹤__鶴 939.211122794|he;
荷__荷 1265.05905145|he;
贺__賀 1538.43695969|he;
盒__盒 2054.18168866|he;
核__核 2445.72321123|he;
呵__呵 3423.98754689|he;
河__河 3946.65663992|he;
合__合 6297.67949241|he;
何__何 6636.07200714|he;
喝__喝 15293.8649795|he;
和__和 664874.105391|he;
痕__痕 777.141921285|hen;
狠__狠 3506.02523602|hen;
恨__恨 4102.10378814|hen;
很__很 160208.418788|hen;
桁__桁 41.4046525194|heng;
蘅__蘅 59.8004009886|heng;
珩__珩 69.1008946834|heng;
亨__亨 489.456318842|heng;
衡__衡 567.697685436|heng;
恒__恆 1589.0991261|heng;
哼__哼 2072.17903804|heng;
横__橫 2622.4951033|heng;
嗨__嗨 85.1933728485|hei;
嘿__嘿 2355.97787927|hei;
黑__黑 14316.3886818|hei;
糇__餱 4.002147533|hou;
瘊__瘊 5.47868469935|hou;
堠__堠 8.96296255118|hou;
逅__逅 14.6997267856|hou;
篌__篌 17.0707911897|hou;
骺__骺 17.0920774979|hou;
鲎__鱟 17.9432777239|hou;
喉__喉 505.574572707|hou;
猴__猴 904.746955463|hou;
候__候 941.55486912|hou;
吼__吼 1376.93239525|hou;
侯__侯 2784.14878864|hou;
後__後 2787.62046424|hou;
厚__厚 3079.85238931|hou;
后__后 134560.280056|hou;
讧__訌 3.60888652264|hong;
蕻__蕻 6.56373101581|hong;
黉__黌 7.75661092468|hong;
訇__訇 11.7607193204|hong;
荭__葒 16.8593807108|hong;
闳__閎 24.8712163027|hong;
薨__薨 30.5108532965|hong;
烘__烘 169.703655326|hong;
泓__泓 239.068350048|hong;
轰__轟 583.476802811|hong;
弘__弘 797.747780288|hong;
虹__虹 1032.51096484|hong;
鸿__鴻 1246.28210631|hong;
哄__哄 1341.36617307|hong;
洪__洪 2297.98475873|hong;
宏__宏 2665.32595143|hong;
红__紅 12941.8397922|hong;
轷__軤 2.2447852343|hu;
冱__冱 2.25881578049|hu;
核__核 2.78485735771|hu;
鹱__鸌 3.93783443348|hu;
岵__岵 4.04728626554|hu;
醐__醐 4.1390967815|hu;
猢__猢 4.49391645449|hu;
烀__烀 5.46504699479|hu;
鹕__鶘 6.64603780638|hu;
囫__囫 6.70426589063|hu;
鹘__鶻 7.77596709276|hu;
觳__觳 9.30438513268|hu;
唿__唿 9.61078722794|hu;
戽__戽 11.8194889291|hu;
煳__煳 16.1801264486|hu;
槲__槲 18.7432065908|hu;
怙__怙 20.1732040993|hu;
惚__惚 20.6051289764|hu;
和__和 20.8375265575|hu;
鹄__鵠 21.658255183|hu;
滹__滹 21.8208008527|hu;
瓠__瓠 22.3157940045|hu;
葫__葫 25.3404937643|hu;
蝴__蝴 25.4354064912|hu;
戏__戲 27.9621221044|hu;
瑚__瑚 28.4542388688|hu;
笏__笏 30.3591453066|hu;
浒__滸 32.1502895978|hu;
许__許 36.3264371957|hu;
琥__琥 44.3972964674|hu;
祜__祜 46.8996354463|hu;
斛__斛 56.1180706617|hu;
扈__扈 89.4360764191|hu;
唬__唬 124.276893895|hu;
弧__弧 237.287502254|hu;
狐__狐 617.901063897|hu;
壶__壺 731.107734818|hu;
糊__糊 732.019384688|hu;
忽__忽 968.932019286|hu;
护__護 1173.92027842|hu;
互__互 1223.20236253|hu;
乎__乎 1311.61293778|hu;
沪__滬 1441.90662463|hu;
呼__呼 1920.49808867|hu;
虎__虎 2911.89531042|hu;
湖__湖 3137.96395466|hu;
户__戶 3479.90844849|hu;
胡__胡 6006.40803223|hu;
锪__鍃 4.00713798393|huo;
劐__劐 4.1390967815|huo;
攉__攉 4.61882454734|huo;
蠖__蠖 6.22126980704|huo;
耠__耠 9.15486694475|huo;
夥__夥 9.89023558913|huo;
钬__鈥 11.4426710798|huo;
藿__藿 11.5285485717|huo;
嚯__嚯 45.1786625526|huo;
镬__鑊 54.6004548464|huo;
和__和 160.849404779|huo;
豁__豁 195.60878915|huo;
伙__伙 271.810366771|huo;
惑__惑 410.07479966|huo;
祸__禍 769.432826682|huo;
霍__霍 1049.37403554|huo;
获__獲 3801.83485115|huo;
火__火 7451.48771757|huo;
货__貨 7754.63736054|huo;
活__活 8740.11210109|huo;
或__或 83282.4782486|huo;
缋__繢 6.33865456489|hui;
徊__徊 6.8478097326|hui;
蟪__蟪 7.72766697621|hui;
诙__詼 9.67085738167|hui;
溃__潰 11.8933640967|hui;
虺__虺 13.1074607533|hui;
咴__咴 13.9327718035|hui;
蛔__蛔 16.5677973048|hui;
隳__隳 16.7546593245|hui;
桧__檜 21.7123020898|hui;
麾__麾 22.0394276285|hui;
洄__洄 24.4715446274|hui;
珲__琿 25.2774154551|hui;
恚__恚 26.8021243714|hui;
彗__彗 44.8980370508|hui;
茴__茴 47.7845516323|hui;
贿__賄 60.7770670229|hui;
喙__喙 71.3764517044|hui;
荟__薈 72.9046801892|hui;
诲__誨 83.3036737352|hui;
烩__燴 89.4360764191|hui;
恢__恢 91.2372086863|hui;
讳__諱 93.6563563433|hui;
晦__晦 103.34567654|hui;
秽__穢 115.323601467|hui;
卉__卉 183.563783354|hui;
蕙__蕙 196.096919422|hui;
悔__悔 367.941183266|hui;
徽__徽 398.985038482|hui;
绘__繪 465.076726846|hui;
晖__暉 557.184562398|hui;
挥__揮 710.450303909|hui;
毁__毀 1200.55002966|hui;
慧__慧 1573.33557614|hui;
惠__惠 1777.70330251|hui;
汇__匯 1959.1745514|hui;
辉__輝 2272.35570445|hui;
灰__灰 2442.67733117|hui;
回__回 31665.0323561|hui;
会__會 208391.122939|hui;
锩__錈 3.87938617285|juan;
桊__桊 6.79679960579|juan;
蠲__蠲 24.4106293322|juan;
鄄__鄄 27.8230870766|juan;
狷__狷 28.5964278316|juan;
镌__鐫 32.8386537177|juan;
隽__雋 56.6803283412|juan;
圈__圈 79.3518814814|juan;
眷__眷 117.353228453|juan;
鹃__鵑 121.066816454|juan;
涓__涓 222.398727024|juan;
绢__絹 259.562230298|juan;
倦__倦 285.346757867|juan;
娟__娟 1004.58849796|juan;
捐__捐 1293.75623683|juan;
卷__卷 3792.371211|juan;
爝__爝 2.1813588832|jue;
觖__觖 3.91825448464|jue;
脚__腳 5.30401841747|jue;
劂__劂 6.28360189872|jue;
獗__獗 7.00314861982|jue;
桷__桷 7.68924298287|jue;
镢__钁 8.47417516203|jue;
矍__矍 10.6979962189|jue;
噱__噱 11.2028097178|jue;
橛__橛 11.4712255951|jue;
抉__抉 19.3363265928|jue;
蹶__蹶 28.277496473|jue;
谲__譎 33.8778175482|jue;
崛__崛 34.2172458796|jue;
攫__攫 35.8765582535|jue;
蕨__蕨 49.1127198955|jue;
噘__噘 51.1745099823|jue;
嚼__嚼 108.627664361|jue;
孓__孓 110.126966673|jue;
撅__撅 123.504952812|jue;
厥__厥 129.979154132|jue;
倔__倔 146.679837233|jue;
珏__珏 198.308623594|jue;
爵__爵 299.557272934|jue;
诀__訣 347.875829952|jue;
掘__掘 402.480675297|jue;
角__角 592.267679181|jue;
决__決 854.342048866|jue;
绝__絕 2382.55007694|jue;
觉__覺 2815.55016665|jue;
皲__皸 3.10762666438|jun;
麇__麇 3.90850104928|jun;
龟__龜 4.81872758227|jun;
捃__捃 16.099674603|jun;
浚__浚 58.7661515758|jun;
竣__竣 62.6222424854|jun;
隽__雋 110.401782066|jun;
筠__筠 130.46599058|jun;
峻__峻 313.69268222|jun;
骏__駿 469.736419493|jun;
钧__鈞 513.191745392|jun;
郡__郡 922.967443217|jun;
菌__菌 1152.18059436|jun;
俊__俊 2406.4213017|jun;
君__君 5013.49243365|jun;
军__軍 5771.60137838|jun;
均__均 9826.30197104|jun;
蒺__蒺 3.65869714815|ji;
犄__犄 3.7980664491|ji;
跽__跽 4.19622548267|ji;
诘__詰 4.39971494209|ji;
鲚__鱭 4.47714731555|ji;
蕺__蕺 6.49052677985|ji;
墼__墼 7.28805843706|ji;
荠__薺 7.49996990053|ji;
岌__岌 8.43203933359|ji;
虮__蟣 8.60185020555|ji;
革__革 8.89619640635|ji;
齑__齏 10.8862746072|ji;
掎__掎 11.2028097178|ji;
乩__乩 11.8785522159|ji;
芰__芰 13.7773818413|ji;
洎__洎 16.8174138399|ji;
芨__芨 16.9014523075|ji;
剞__剞 17.6989924358|ji;
瘠__瘠 18.0779424081|ji;
笄__笄 18.1230548541|ji;
骑__騎 19.4329523446|ji;
给__給 20.7597709113|ji;
圾__圾 20.863509771|ji;
佶__佶 22.0394276285|ji;
跻__躋 24.5938316288|ji;
楫__楫 26.077307439|ji;
戢__戢 26.2402980276|ji;
奇__奇 26.4043073537|ji;
嵴__嵴 26.7687452646|ji;
麂__麂 26.9360575363|ji;
咭__咭 27.5127806629|ji;
其__其 27.9272983477|ji;
笈__笈 29.0634675053|ji;
期__期 29.0997080006|ji;
殛__殛 29.0997080006|ji;
觊__覬 29.2815894523|ji;
赍__齎 31.0478262181|ji;
屐__屐 32.2305187617|ji;
玑__璣 32.3109481328|ji;
悸__悸 36.8737446754|ji;
亟__亟 41.8194936494|ji;
鲫__鯽 42.0284702611|ji;
嵇__嵇 45.1786625526|ji;
缉__緝 45.8593409192|ji;
稷__稷 47.3695318608|ji;
嫉__嫉 52.4659761309|ji;
羁__羈 62.3885663378|ji;
偈__偈 70.4047107918|ji;
系__系 73.3603551764|ji;
稽__稽 74.8377422459|ji;
畿__畿 74.9310606649|ji;
讥__譏 77.2059475801|ji;
唧__唧 78.1740819755|ji;
箕__箕 79.1543564228|ji;
伎__伎 83.5115531721|ji;
畸__畸 87.8892772674|ji;
蓟__薊 111.925571131|ji;
矶__磯 115.755545596|ji;
髻__髻 116.044406778|ji;
棘__棘 130.628674269|ji;
汲__汲 132.266710153|ji;
绩__績 134.259489114|ji;
藉__藉 136.792736844|ji;
骥__驥 147.412812521|ji;
戟__戟 166.353500999|ji;
霁__霽 171.403948695|ji;
饥__飢 197.322580943|ji;
脊__脊 230.008975843|ji;
妓__妓 242.36802267|ji;
寂__寂 307.500011268|ji;
叽__嘰 320.010065926|ji;
冀__冀 432.648119245|ji;
际__際 451.373158744|ji;
辑__輯 505.574572707|ji;
迹__跡 521.573243485|ji;
激__激 594.486015613|ji;
疾__疾 647.865219539|ji;
祭__祭 709.565515965|ji;
忌__忌 840.61307342|ji;
肌__肌 911.537100768|ji;
济__濟 949.804135501|ji;
姬__姬 1070.5071343|ji;
击__擊 1074.51671486|ji;
技__技 1129.43516323|ji;
籍__籍 1229.31483934|ji;
积__積 1323.10440245|ji;
己__己 1476.45426414|ji;
纪__紀 1480.13866924|ji;
暨__暨 1540.35530331|ji;
剂__劑 1693.37191801|ji;
季__季 2300.85021536|ji;
挤__擠 2344.2633374|ji;
计__計 2476.39168739|ji;
吉__吉 2529.4132684|ji;
继__繼 2685.32927986|ji;
基__基 3694.41410176|ji;
寄__寄 4492.77303857|ji;
鸡__雞 4509.6007036|ji;
极__極 5429.71919857|ji;
记__記 6360.77714733|ji;
集__集 7498.06163521|ji;
急__急 7980.11532095|ji;
既__既 9095.68698269|ji;
机__機 11612.1152793|ji;
几__幾 16625.6206895|ji;
即__即 17366.8071173|ji;
级__級 17388.4625406|ji;
及__及 77186.303577|ji;
嘏__嘏 4.72360010237|jia;
蛱__蛺 5.25140360074|jia;
跏__跏 5.27764544242|jia;
恝__恝 5.78026894868|jia;
袈__袈 6.41014589067|jia;
胛__胛 7.65101004374|jia;
浃__浹 8.28620700495|jia;
瘕__瘕 13.4717817062|jia;
郏__郟 19.8490278234|jia;
铗__鋏 19.8985599093|jia;
笳__笳 20.8375265575|jia;
岬__岬 24.0183591271|jia;
镓__鎵 26.0448310122|jia;
戛__戛 28.3127569069|jia;
伽__伽 34.6463176505|jia;
枷__枷 68.07524793|jia;
荚__莢 70.9330996563|jia;
葭__葭 75.776180211|jia;
珈__珈 103.991616413|jia;
痂__痂 110.264288753|jia;
稼__稼 124.122120652|jia;
颊__頰 146.132498493|jia;
茄__茄 231.446597362|jia;
迦__迦 380.531740742|jia;
钾__鉀 484.601008682|jia;
驾__駕 564.874943184|jia;
贾__賈 1845.42065012|jia;
嫁__嫁 1884.93262272|jia;
嘉__嘉 2100.77969738|jia;
夹__夾 2332.60704332|jia;
佳__佳 2904.64693418|jia;
甲__甲 3666.89398377|jia;
架__架 3782.93112802|jia;
价__價 5685.93498805|jia;
假__假 8140.82500071|jia;
加__加 44110.2982689|jia;
家__家 52256.8988529|jia;
浅__淺 4.86094601132|jian;
鲣__鰹 4.87915266687|jian;
鹣__鶼 7.02062456687|jian;
楗__楗 7.26086290155|jian;
趼__趼 7.42557167814|jian;
毽__毽 7.45338412978|jian;
牮__牮 8.37966404988|jian;
搛__搛 8.41105005101|jian;
笕__筧 9.26966563387|jian;
謇__謇 9.75558688739|jian;
踺__踺 10.8186549367|jian;
裥__襇 11.2447698008|jian;
鞯__韉 11.5285485717|jian;
缣__縑 12.3772230543|jian;
枧__梘 12.9451335053|jian;
湔__湔 13.5391016819|jian;
蒹__蒹 14.4996001951|jian;
谫__譾 14.6814198879|jian;
戬__戩 15.1271438601|jian;
囝__囝 15.4125672823|jian;
犍__犍 16.3422382291|jian;
锏__鐧 20.9416539708|jian;
饯__餞 23.6913658168|jian;
硷__礆 24.0183591271|jian;
槛__檻 30.931970635|jian;
缄__緘 33.6673868048|jian;
菅__菅 33.962357657|jian;
僭__僭 37.1968074646|jian;
腱__腱 52.0102971158|jian;
蹇__蹇 80.7484275309|jian;
翦__翦 81.7609833316|jian;
戋__戔 83.5115531721|jian;
睑__瞼 92.8429294452|jian;
艰__艱 104.902720559|jian;
柬__柬 105.0335283|jian;
笺__箋 147.964946673|jian;
践__踐 154.754097942|jian;
谏__諫 188.430963124|jian;
俭__儉 224.907079496|jian;
茧__繭 226.595011951|jian;
歼__殲 226.595011951|jian;
涧__澗 260.859291326|jian;
荐__薦 391.596284031|jian;
溅__濺 416.253137598|jian;
鉴__鑒 443.56664881|jian;
碱__鹼 535.402718412|jian;
奸__奸 548.914415679|jian;
拣__揀 611.009712747|jian;
舰__艦 620.98878351|jian;
监__監 724.757896749|jian;
煎__煎 806.745280603|jian;
坚__堅 894.656458236|jian;
渐__漸 1037.67053575|jian;
尖__尖 1070.5071343|jian;
肩__肩 1126.6237397|jian;
检__檢 1209.56018338|jian;
箭__箭 1233.91923358|jian;
简__簡 1282.5196677|jian;
剪__剪 1712.47082965|jian;
捡__撿 1723.1742594|jian;
健__健 1820.2965272|jian;
贱__賤 2026.2154289|jian;
减__減 2548.39656922|jian;
兼__兼 3049.30086097|jian;
键__鍵 3306.57582432|jian;
剑__劍 5532.16874554|jian;
件__件 7286.20408973|jian;
建__建 9016.68885873|jian;
间__間 10668.6512651|jian;
见__見 26266.3333785|jian;
爝__爝 2.1813588832|jiao;
艽__艽 6.49052677985|jiao;
僬__僬 9.61078722794|jiao;
敫__敫 10.8862746072|jiao;
峤__嶠 11.5573173892|jiao;
噍__噍 11.5717287083|jiao;
挢__撟 12.0125259855|jiao;
鹪__鷦 12.2697240382|jiao;
湫__湫 13.5728877169|jiao;
茭__茭 16.9859107246|jiao;
佼__佼 18.4650060106|jiao;
徼__徼 20.863509771|jiao;
醮__醮 26.8690075024|jiao;
侥__僥 33.7934878793|jiao;
鲛__鮫 35.65371241|jiao;
酵__酵 38.5656415475|jiao;
校__校 48.3837524641|jiao;
跤__跤 55.2162730559|jiao;
狡__狡 55.2162730559|jiao;
剿__剿 57.606037042|jiao;
铰__鉸 60.2492042805|jiao;
皎__皎 64.5234369803|jiao;
饺__餃 75.2117146793|jiao;
蛟__蛟 107.818484324|jiao;
姣__姣 129.171793682|jiao;
蕉__蕉 139.026849285|jiao;
礁__礁 146.132498493|jiao;
窖__窖 148.334184528|jiao;
骄__驕 193.668388536|jiao;
轿__轎 203.313241605|jiao;
郊__郊 215.30841961|jiao;
椒__椒 236.696839161|jiao;
绞__絞 260.209952636|jiao;
矫__矯 367.482952871|jiao;
嚼__嚼 505.574572707|jiao;
缴__繳 571.958268741|jiao;
搅__攪 628.775756137|jiao;
浇__澆 711.336195135|jiao;
觉__覺 786.88699725|jiao;
娇__嬌 926.424414408|jiao;
焦__焦 1205.04668542|jiao;
胶__膠 1356.49494292|jiao;
角__角 2494.97706011|jiao;
脚__腳 5573.68779063|jiao;
较__較 7414.43696017|jiao;
教__教 9371.82960123|jiao;
交__交 14714.3117017|jiao;
叫__叫 55685.8685443|jiao;
强__強 2.56178299815|jiang;
虹__虹 2.83386919548|jiang;
糨__糨 3.5686371919|jiang;
礓__礓 5.90402925683|jiang;
茳__茳 8.63406840412|jiang;
豇__豇 10.6979962189|jiang;
耩__耩 12.4856639039|jiang;
洚__洚 16.6091412722|jiang;
缰__韁 33.002752084|jiang;
犟__犟 98.0757814374|jiang;
桨__槳 134.092283643|jiang;
绛__絳 164.293322714|jiang;
匠__匠 270.796100963|jiang;
疆__疆 295.847453874|jiang;
僵__僵 337.625607028|jiang;
浆__漿 629.559803835|jiang;
酱__醬 874.811821743|jiang;
蒋__蔣 2451.8263702|jiang;
姜__姜 2467.15098238|jiang;
降__降 3488.59235612|jiang;
奖__獎 4629.17242366|jiang;
江__江 5217.45686316|jiang;
讲__講 22589.8767644|jiang;
将__將 119239.506338|jiang;
价__價 1.26538101044|jie;
阂__閡 1.62961707957|jie;
楷__楷 1.66866220388|jie;
鲒__鮚 3.67240078497|jie;
骱__骱 4.58441838901|jie;
家__家 6.33865456489|jie;
拮__拮 13.2718235258|jie;
碣__碣 18.6500104363|jie;
疥__疥 19.4329523446|jie;
偈__偈 20.3246044287|jie;
疖__癤 22.7935934922|jie;
秸__秸 25.0578753144|jie;
讦__訐 27.5127806629|jie;
蚧__蚧 30.0579885721|jie;
桔__桔 37.9459052878|jie;
诘__詰 49.1127198955|jie;
羯__羯 59.2810208143|jie;
颉__頡 64.4430801152|jie;
睫__睫 65.2511728122|jie;
芥__芥 66.7313606344|jie;
诫__誡 70.8447602593|jie;
桀__桀 87.4522686574|jie;
喈__喈 91.8074671909|jie;
孑__孑 120.46484039|jie;
竭__竭 151.888225993|jie;
藉__藉 209.485777119|jie;
嗟__嗟 237.287502254|jie;
婕__婕 461.037428991|jie;
阶__階 567.697685436|jie;
劫__劫 740.275558891|jie;
揭__揭 796.754272909|jie;
捷__捷 851.15405446|jie;
截__截 1108.5192935|jie;
介__介 1122.41972073|jie;
洁__潔 1187.16048834|jie;
戒__戒 1266.63650832|jie;
届__屆 2341.34381449|jie;
皆__皆 2725.78743963|jie;
杰__傑 2963.1429408|jie;
结__結 3484.24769691|jie;
界__界 3961.43882797|jie;
街__街 4420.5757602|jie;
姐__姐 5089.02755683|jie;
节__節 5152.84210443|jie;
解__解 5545.97394851|jie;
借__借 7169.11735945|jie;
接__接 17760.7638126|jie;
廑__廑 4.02214670463|jin;
赆__贐 4.1390967815|jin;
卺__巹 6.59653070199|jin;
馑__饉 6.80527482932|jin;
荩__藎 16.7964695952|jin;
妗__妗 19.4087507335|jin;
觐__覲 31.5942495447|jin;
烬__燼 35.2560722919|jin;
衿__衿 40.5367278646|jin;
缙__縉 50.7300476464|jin;
槿__槿 54.3289670197|jin;
堇__堇 62.0783539716|jin;
矜__矜 72.8138854049|jin;
襟__襟 165.939408926|jin;
噤__噤 167.184787749|jin;
巾__巾 276.249600432|jin;
瑾__瑾 309.036622663|jin;
靳__靳 311.744192349|jin;
谨__謹 398.48814637|jin;
浸__浸 569.114341748|jin;
筋__筋 643.841029976|jin;
津__津 954.550411286|jin;
晋__晉 1032.51096484|jin;
禁__禁 1502.43898348|jin;
锦__錦 1647.57761372|jin;
斤__斤 2111.27752471|jin;
劲__勁 2175.37534439|jin;
今__今 4112.3403478|jin;
紧__緊 4681.38313658|jin;
尽__盡 4781.61539648|jin;
仅__僅 6472.72305247|jin;
近__近 15029.3572068|jin;
金__金 15142.152855|jin;
进__進 24648.9309134|jin;
獍__獍 5.13492068199|jing;
弪__弳 12.1480107954|jing;
靓__靚 13.4382473473|jing;
刭__剄 14.6448744617|jing;
儆__儆 20.5794675479|jing;
憬__憬 29.9831673348|jing;
痉__痙 30.3213363203|jing;
腈__腈 30.931970635|jing;
肼__肼 30.9705410476|jing;
阱__阱 31.3589003252|jing;
粳__粳 32.0303201505|jing;
迳__逕 40.2347650897|jing;
兢__兢 49.2966714087|jing;
胫__脛 63.8833772098|jing;
旌__旌 114.321989585|jing;
泾__涇 116.18910757|jing;
睛__睛 181.064689688|jing;
鲸__鯨 206.89143407|jing;
婧__婧 285.702569086|jing;
菁__菁 356.655002599|jing;
荆__荊 408.544597361|jing;
茎__莖 417.812212206|jing;
劲__勁 585.662213047|jing;
径__徑 596.712660816|jing;
靖__靖 628.775756137|jing;
竞__競 629.559803835|jing;
境__境 761.800204777|jing;
颈__頸 767.517531652|jing;
警__警 778.110973173|jing;
晶__晶 1240.08526378|jing;
敬__敬 1409.92327219|jing;
镜__鏡 1506.18823193|jing;
惊__驚 1611.03221293|jing;
井__井 2051.62343063|jing;
京__京 2347.18650079|jing;
净__凈 2577.13898569|jing;
景__景 2819.06099798|jing;
精__精 3445.38844293|jing;
竟__竟 4453.75227609|jing;
静__靜 4902.28669206|jing;
经__經 13284.9916911|jing;
炅__炅 16.0196227851|jiong;
扃__扃 16.2407290532|jiong;
窘__窘 134.259489114|jiong;
炯__炯 192.705418355|jiong;
迥__迥 403.48504224|jiong;
鬏__鬏 4.63612433783|jiu;
阄__鬮 10.4607008367|jiu;
柩__柩 14.8285158408|jiu;
桕__桕 17.8318237536|jiu;
赳__赳 26.109824362|jiu;
疚__疚 30.1329965214|jiu;
厩__廄 36.055837363|jiu;
啾__啾 36.599067886|jiu;
僦__僦 45.2349977818|jiu;
韭__韭 56.0481817586|jiu;
鹫__鷲 59.2071928037|jiu;
臼__臼 72.6326349201|jiu;
咎__咎 94.7126715303|jiu;
灸__灸 96.8611776331|jiu;
鸠__鳩 146.679837233|jiu;
纠__糾 216.384339476|jiu;
舅__舅 250.349428094|jiu;
究__究 276.594068012|jiu;
玖__玖 331.786363812|jiu;
揪__揪 543.469292924|jiu;
救__救 3373.16618304|jiu;
九__九 5217.45686316|jiu;
旧__舊 5456.85210292|jiu;
久__久 8100.34667698|jiu;
酒__酒 8304.7711752|jiu;
就__就 558432.862021|jiu;
犋__犋 1.95236060406|ju;
车__車 2.68601269925|ju;
且__且 5.3571603921|ju;
踽__踽 5.49920509291|ju;
醵__醵 5.53357668886|ju;
枸__枸 5.56122858051|ju;
窭__窶 6.18262663209|ju;
龃__齟 6.49862009853|ju;
鞫__鞫 7.79537156303|ju;
柜__櫃 7.93256547901|ju;
趄__趄 8.07217392654|ju;
飓__颶 9.25812128184|ju;
榉__櫸 9.95205237461|ju;
屦__屨 12.6422295709|ju;
苣__苣 16.526556252|ju;
倨__倨 16.5884564081|ju;
锔__鋦 18.0779424081|ju;
咀__咀 21.8208008527|ju;
榘__榘 24.078295535|ju;
雎__雎 25.2144941623|ju;
疽__疽 26.3057791538|ju;
琚__琚 29.1359936856|ju;
莒__莒 30.7015548077|ju;
椐__椐 32.4724094962|ju;
苴__苴 33.002752084|ju;
裾__裾 38.326092568|ju;
沮__沮 48.9294548011|ju;
遽__遽 50.983551277|ju;
踞__踞 51.9455239942|ju;
讵__詎 53.2564478474|ju;
掬__掬 88.4386102484|ju;
钜__鉅 92.2662392072|ju;
狙__狙 96.4997382157|ju;
炬__炬 118.23396695|ju;
拘__拘 133.259374649|ju;
驹__駒 137.819369268|ju;
桔__桔 215.845709156|ju;
橘__橘 216.384339476|ju;
惧__懼 221.017305999|ju;
鞠__鞠 227.443722742|ju;
锯__鋸 239.366454718|ju;
矩__矩 301.054193591|ju;
拒__拒 781.999279332|ju;
俱__俱 1027.37704867|ju;
菊__菊 1046.76190254|ju;
举__舉 2164.55880585|ju;
聚__聚 2255.42866395|ju;
剧__劇 2266.69928918|ju;
巨__巨 2292.26454686|ju;
具__具 2344.2633374|ju;
居__居 2926.44637172|ju;
句__句 4021.12332411|ju;
距__距 4448.20561603|ju;
局__局 7098.00112903|ju;
据__據 13756.7225213|ju;
畎__畎 3.33223958983|quan;
辁__輇 4.04224581432|quan;
鬈__鬈 8.34839516624|quan;
悛__悛 10.4216665228|quan;
痊__痊 14.8100485504|quan;
筌__筌 22.6520119746|quan;
颧__顴 30.1329965214|quan;
绻__綣 30.4349047749|quan;
诠__詮 46.2035162564|quan;
犭__犭 47.9635284962|quan;
铨__銓 99.1819416753|quan;
蜷__蜷 107.14877401|quan;
醛__醛 129.655606164|quan;
荃__荃 189.136730609|quan;
券__券 977.421145723|quan;
拳__拳 1079.88619313|quan;
犬__犬 1481.9843182|quan;
泉__泉 1889.63636164|quan;
劝__勸 2132.4308179|quan;
圈__圈 3567.72920071|quan;
权__權 5707.23163681|quan;
全__全 25876.4689683|quan;
悫__愨 11.7022419298|que;
榷__榷 14.9026155662|que;
炔__炔 39.1466857045|que;
阕__闋 52.7939034044|que;
鹊__鵲 99.4294443995|que;
瘸__瘸 154.561368684|que;
阙__闕 239.963779681|que;
雀__雀 469.151414294|que;
确__確 1082.58098585|que;
缺__缺 3991.16951133|que;
却__卻 43347.4095704|que;
麇__麇 3.90850104928|qun;
逡__逡 6.83076396136|qun;
裙__裙 745.831342837|qun;
群__群 13451.5806367|qun;
缉__緝 1.90430264696|qi;
稽__稽 3.9231403257|qi;
亟__亟 4.2119424299|qi;
俟__俟 5.34382518944|qi;
芑__芑 8.08223946949|qi;
萋__萋 9.61078722794|qi;
屺__屺 11.0090568469|qi;
蜞__蜞 12.4390733999|qi;
荠__薺 13.5222402155|qi;
槭__槭 15.4317858793|qi;
蹊__蹊 18.4190423696|qi;
碛__磧 19.7011701191|qi;
蕲__蘄 20.6565478685|qi;
汔__汔 20.9416539708|qi;
桤__榿 21.3367872887|qi;
蛴__蠐 21.4167041476|qi;
萁__萁 22.8220158102|qi;
葺__葺 25.3089349582|qi;
綦__綦 31.0091595553|qi;
芪__芪 31.2029756224|qi;
欹__欹 33.2918998566|qi;
憩__憩 35.8318779344|qi;
颀__頎 39.7364840867|qi;
讫__訖 43.6294441279|qi;
嘁__嘁 43.7383188494|qi;
圻__圻 47.7845516323|qi;
迄__迄 55.6306723694|qi;
耆__耆 60.7770670229|qi;
沏__沏 80.6478642194|qi;
杞__杞 90.4447926395|qi;
骐__騏 106.085879302|qi;
亓__亓 109.852835359|qi;
畦__畦 113.611883002|qi;
凄__凄 125.835280772|qi;
鳍__鰭 133.259374649|qi;
歧__歧 138.85370659|qi;
脐__臍 161.653186955|qi;
麒__麒 166.768626413|qi;
岐__岐 191.508436159|qi;
乞__乞 203.313241605|qi;
栖__棲 232.313479749|qi;
崎__崎 241.162905094|qi;
柒__柒 253.488718522|qi;
淇__淇 257.62872122|qi;
祺__祺 272.828431509|qi;
砌__砌 275.218769535|qi;
祈__祈 284.281980745|qi;
泣__泣 289.645897197|qi;
契__契 295.847453874|qi;
欺__欺 344.85444872|qi;
绮__綺 399.980682268|qi;
汽__汽 416.772181646|qi;
祁__祁 431.571158705|qi;
戚__戚 451.935995467|qi;
岂__豈 503.060722916|qi;
琦__琦 636.660374558|qi;
琪__琪 911.537100768|qi;
弃__棄 920.669965262|qi;
漆__漆 1018.45404378|qi;
棋__棋 1142.1736421|qi;
企__企 1179.78648723|qi;
旗__旗 1329.71610075|qi;
启__啟 1356.49494292|qi;
妻__妻 1463.63092081|qi;
骑__騎 2295.12287071|qi;
奇__奇 2926.44637172|qi;
齐__齊 4112.3403478|qi;
七__七 6313.39498259|qi;
器__器 6578.43620239|qi;
气__氣 9442.16538338|qi;
期__期 9716.71080614|qi;
起__起 29383.7853316|qi;
其__其 58168.3990166|qi;
袷__袷 6.68757743298|qia;
葜__葜 7.06450546727|qia;
髂__髂 52.7939034044|qia;
卡__卡 67.2321809271|qia;
洽__洽 281.812926654|qia;
恰__恰 755.18379558|qia;
掐__掐 789.834279627|qia;
犍__犍 2.91263639113|qian;
岍__岍 3.63144308987|qian;
椠__槧 3.76039037892|qian;
肷__肷 4.72360010237|qian;
掮__掮 7.87347488117|qian;
慊__慊 8.35880514141|qian;
愆__愆 10.8186549367|qian;
缱__繾 10.9679763316|qian;
荨__蕁 14.8470061588|qian;
箝__箝 15.3933726199|qian;
扦__扦 26.077307439|qian;
搴__搴 27.2738258636|qian;
钤__鈐 28.0668541308|qian;
佥__僉 33.541756279|qian;
褰__褰 33.962357657|qian;
悭__慳 34.7760853068|qian;
阡__阡 36.599067886|qian;
堑__塹 40.4358226384|qian;
钎__釺 49.2352778104|qian;
谴__譴 50.4149399325|qian;
芡__芡 55.8390368498|qian;
虔__虔 72.3616047933|qian;
芊__芊 88.2184662348|qian;
骞__騫 121.520271774|qian;
歉__歉 139.026849285|qian;
仟__仟 183.106850936|qian;
钳__鉗 201.296414343|qian;
纤__纖 270.458854115|qian;
嵌__嵌 318.815941979|qian;
黔__黔 320.808632296|qian;
遣__遣 331.786363812|qian;
茜__茜 389.649164279|qian;
乾__乾 516.399339766|qian;
谦__謙 560.667124391|qian;
铅__鉛 593.745648473|qian;
倩__倩 599.694499646|qian;
潜__潛 735.677366107|qian;
迁__遷 775.207436548|qian;
牵__牽 927.579613097|qian;
浅__淺 1637.34374958|qian;
欠__欠 2805.04388501|qian;
签__簽 4658.10606797|qian;
千__千 5217.45686316|qian;
前__前 46770.9882114|qian;
钱__錢 55755.3056633|qian;
雀__雀 1.51221441685|qiao;
缲__繰 1.89719670363|qiao;
鞒__鞽 5.71580253909|qiao;
硗__磽 6.59653070199|qiao;
劁__劁 6.73776784504|qiao;
诮__誚 10.5129741099|qiao;
憔__憔 13.6407129304|qiao;
峤__嶠 31.7917225906|qiao;
荞__蕎 37.3361279713|qiao;
壳__殼 38.4696428079|qiao;
橇__橇 45.404425301|qiao;
锹__鍬 51.4302346401|qiao;
愀__愀 53.8571075021|qiao;
峭__峭 55.285124616|qiao;
谯__譙 62.9351727223|qiao;
跷__蹺 64.5234369803|qiao;
悄__悄 128.529517539|qiao;
樵__樵 162.663565352|qiao;
鞘__鞘 166.97657743|qiao;
撬__撬 221.845125512|qiao;
侨__僑 341.859308876|qiao;
窍__竅 351.361264404|qiao;
俏__俏 369.779825848|qiao;
翘__翹 736.594714048|qiao;
瞧__瞧 1246.28210631|qiao;
乔__喬 1913.33171172|qiao;
巧__巧 2001.12208851|qiao;
敲__敲 2016.1405527|qiao;
桥__橋 4360.39268552|qiao;
锖__錆 4.72360010237|qiang;
襁__襁 5.3238845991|qiang;
蜣__蜣 6.62123798367|qiang;
跄__蹌 13.3547761977|qiang;
戕__戕 16.8174138399|qiang;
镪__鏹 16.8174138399|qiang;
戗__戧 17.0282980696|qiang;
嫱__嬙 24.1083198036|qiang;
樯__檣 33.1263637715|qiang;
锵__鏘 37.0580068352|qiang;
炝__熗 39.1466857045|qiang;
羟__羥 73.1777444029|qiang;
蔷__薔 104.511273964|qiang;
羌__羌 129.655606164|qiang;
呛__嗆 315.653350706|qiang;
腔__腔 812.799921236|qiang;
墙__牆 2861.53400907|qiang;
枪__槍 3453.98620792|qiang;
抢__搶 7639.53727871|qiang;
强__強 19428.0078942|qiang;
伽__伽 0.293718384616|qie;
慊__慊 3.09989106785|qie;
趄__趄 8.07217392654|qie;
郄__郄 17.5234219212|qie;
挈__挈 19.3604378951|qie;
箧__篋 21.6043428114|qie;
锲__鍥 23.0219668635|qie;
惬__愜 24.6552040947|qie;
怯__怯 158.264611567|qie;
茄__茄 197.814987883|qie;
窃__竊 249.726250867|qie;
妾__妾 427.82286438|qie;
切__切 9716.71080614|qie;
且__且 12175.2268353|qie;
矜__矜 2.48629960853|qin;
锓__鋟 3.70457587462|qin;
螓__螓 3.92803225913|qin;
廑__廑 4.02214670463|qin;
檎__檎 4.18056718353|qin;
吣__唚 6.98571617442|qin;
揿__撳 24.1383815107|qin;
溱__溱 29.8340831383|qin;
芩__芩 40.7392943546|qin;
噙__噙 56.3984988362|qin;
衾__衾 62.0783539716|qin;
嗪__嗪 63.8833772098|qin;
擒__擒 225.468321935|qin;
芹__芹 290.0070692|qin;
覃__覃 300.679263607|qin;
禽__禽 318.022335873|qin;
寝__寢 381.006242235|qin;
侵__侵 383.865702254|qin;
沁__沁 523.526794166|qin;
钦__欽 675.063104121|qin;
勤__勤 1394.19862478|qin;
琴__琴 2722.39277029|qin;
秦__秦 3797.10008276|qin;
亲__親 6778.15576203|qin;
綮__綮 5.49920509291|qing;
鲭__鯖 6.20578363759|qing;
蜻__蜻 7.09980757849|qing;
圊__圊 7.58455926976|qing;
檠__檠 9.46813679247|qing;
謦__謦 10.0017838755|qing;
亲__親 12.5793690793|qing;
黥__黥 16.0395983459|qing;
罄__罄 29.7969280594|qing;
箐__箐 93.0746135358|qing;
磬__磬 102.575842641|qing;
苘__苘 105.0335283|qing;
顷__頃 108.763116896|qing;
氰__氰 111.925571131|qing;
擎__擎 179.71591787|qing;
氢__氫 493.744603771|qing;
卿__卿 950.988487375|qing;
倾__傾 1211.06843631|qing;
晴__晴 1513.71482027|qing;
庆__慶 2119.18530697|qing;
青__青 5178.59142346|qing;
轻__輕 5236.9988288|qing;
情__情 6384.60141493|qing;
清__清 8578.25504892|qing;
请__請 55964.1369573|qing;
筇__筇 6.15955603742|qiong;
銎__銎 6.27577636162|qiong;
跫__跫 10.1272025937|qiong;
蛩__蛩 20.5538380778|qiong;
茕__煢 25.4037294817|qiong;
邛__邛 32.0303201505|qiong;
穹__穹 69.1008946834|qiong;
琼__瓊 921.81798848|qiong;
穷__窮 4376.72452042|qiong;
鼽__鼽 3.7650793724|qiu;
蝤__蝤 4.78879624368|qiu;
龟__龜 4.81872758227|qiu;
蚯__蚯 5.33717004118|qiu;
赇__賕 6.4824435405|qiu;
犰__犰 10.0392455205|qiu;
巯__巰 10.2797827572|qiu;
俅__俅 11.2307656731|qiu;
湫__湫 13.5728877169|qiu;
鳅__鰍 19.9979952029|qiu;
逑__逑 28.8110446358|qiu;
楸__楸 31.3198462537|qiu;
遒__遒 39.6869966533|qiu;
虬__虯 42.8748718136|qiu;
酋__酋 43.6294441279|qiu;
泅__泅 50.4778045025|qiu;
糗__糗 105.953760973|qiu;
仇__仇 128.209578049|qiu;
囚__囚 164.293322714|qiu;
裘__裘 294.009808944|qiu;
丘__丘 725.661628731|qiu;
邱__邱 1432.95027783|qiu;
秋__秋 3839.92616142|qiu;
求__求 6812.02695227|qiu;
球__球 8740.11210109|qiu;
苣__苣 2.10393456802|qu;
磲__磲 2.75379829167|qu;
癯__癯 3.37823187506|qu;
蠼__蠼 3.95258357798|qu;
鸲__鴝 5.28422636689|qu;
岖__嶇 5.31063222754|qu;
彡__彡 5.69447390785|qu;
蛐__蛐 6.94232467065|qu;
劬__劬 7.02062456687|qu;
朐__朐 7.49062951047|qu;
蕖__蕖 9.21208746704|qu;
氍__氍 9.33923467325|qu;
诎__詘 11.9975657017|qu;
璩__璩 15.6447786965|qu;
蘧__蘧 16.281256841|qu;
阒__闃 20.2487627616|qu;
麴__麴 27.7884364727|qu;
黢__黢 30.7015548077|qu;
觑__覷 49.5430123006|qu;
衢__衢 77.5917541962|qu;
龋__齲 79.649093664|qu;
躯__軀 114.179614083|qu;
蛆__蛆 239.664931108|qu;
瞿__瞿 251.287110964|qu;
祛__祛 336.365750338|qu;
驱__驅 570.534533242|qu;
趣__趣 584.204365283|qu;
趋__趨 643.039196578|qu;
渠__渠 667.534233933|qu;
屈__屈 973.773879211|qu;
娶__娶 1577.26174289|qu;
曲__曲 3201.15867829|qu;
取__取 15876.4481191|qu;
区__區 25334.0462203|qu;
去__去 330876.262958|qu;
痃__痃 3.15444731206|xuan;
碹__碹 5.79469327116|xuan;
揎__揎 6.72937669406|xuan;
镟__鏇 8.94065167877|xuan;
县__縣 9.40932582977|xuan;
券__券 11.1610062098|xuan;
谖__諼 17.5015984208|xuan;
楦__楦 18.5341666233|xuan;
儇__儇 18.9074218788|xuan;
泫__泫 24.8402419302|xuan;
渲__渲 50.0393932132|xuan;
漩__漩 59.2810208143|xuan;
煊__煊 71.1101090504|xuan;
暄__暄 81.5574614651|xuan;
铉__鉉 88.2184662348|xuan;
绚__絢 101.30550855|xuan;
癣__癬 127.890434962|xuan;
眩__眩 130.791560815|xuan;
喧__喧 206.633773476|xuan;
璇__璇 354.881620091|xuan;
萱__萱 370.240920313|xuan;
炫__炫 617.131535882|xuan;
旋__旋 821.967189047|xuan;
悬__懸 837.47630896|xuan;
宣__宣 1075.85657625|xuan;
轩__軒 1517.49220692|xuan;
玄__玄 1613.0410787|xuan;
选__選 13705.3890367|xuan;
泶__澩 4.04728626554|xue;
噱__噱 11.2028097178|xue;
踅__踅 12.5168211467|xue;
鳕__鱈 13.009821762|xue;
谑__謔 33.4582631438|xue;
削__削 146.862738669|xue;
靴__靴 279.365316864|xue;
穴__穴 1009.60853723|xue;
薛__薛 1889.63636164|xue;
雪__雪 7151.27177974|xue;
血__血 10049.2063556|xue;
学__學 28803.7140574|xue;
荨__蕁 3.93783443348|xun;
郇__郇 4.30212357851|xun;
獯__獯 7.29714623248|xun;
峋__峋 9.40932582977|xun;
窨__窨 9.76775155081|xun;
曛__曛 13.708877074|xun;
醺__醺 17.4145758688|xun;
恂__恂 24.1083198036|xun;
鲟__鱘 29.3912635388|xun;
蕈__蕈 30.2081916487|xun;
埙__塤 37.66324185|xun;
徇__徇 38.8066877763|xun;
浔__潯 43.7928580517|xun;
殉__殉 58.1832029411|xun;
浚__浚 58.7661515758|xun;
洵__洵 74.4656293018|xun;
汛__汛 82.9928244141|xun;
驯__馴 87.9988702102|xun;
巽__巽 94.3592493063|xun;
荀__荀 137.819369268|xun;
询__詢 269.449631503|xun;
旬__旬 351.799391968|xun;
迅__迅 358.437246895|xun;
循__循 363.384474622|xun;
逊__遜 370.240920313|xun;
巡__巡 400.479435488|xun;
勋__勛 530.091629029|xun;
薰__薰 545.504855178|xun;
熏__熏 570.534533242|xun;
训__訓 2132.4308179|xun;
讯__訊 2247.01248688|xun;
寻__尋 2300.85021536|xun;
鼷__鼷 3.58647006465|xi;
蓰__蓰 4.22771824491|xi;
裼__裼 4.24884461821|xi;
歙__歙 5.70868413383|xi;
菥__菥 7.04692029058|xi;
樨__樨 7.93256547901|xi;
穸__穸 8.04205244843|xi;
禊__禊 8.79697855917|xi;
阋__鬩 8.91839634324|xi;
舾__舾 9.37421474265|xi;
蟋__蟋 9.89023558913|xi;
螅__螅 10.1145902734|xi;
饩__餼 11.6295539101|xi;
欷__欷 12.5480561404|xi;
葸__葸 13.009821762|xi;
隰__隰 13.5559841736|xi;
粞__粞 13.9154200641|xi;
蹊__蹊 14.4635073599|xi;
屣__屣 15.5089002115|xi;
舄__舄 17.5890558341|xi;
牺__犧 22.8220158102|xi;
翕__翕 25.2459352061|xi;
檄__檄 25.8186256918|xi;
唏__唏 28.6320859549|xi;
淅__淅 29.759819253|xi;
觋__覡 32.8796016559|xi;
蜥__蜥 34.7327755061|xi;
醯__醯 35.609309621|xi;
郗__郗 39.6375708511|xi;
僖__僖 40.3854642556|xi;
皙__皙 41.767412056|xi;
矽__矽 49.2352778104|xi;
媳__媳 54.7367070823|xi;
浠__浠 56.9635661792|xi;
铣__銑 67.4839988155|xi;
晰__晰 77.6885067119|xi;
茜__茜 93.890070293|xi;
熹__熹 98.8118422805|xi;
羲__羲 101.30550855|xi;
徙__徙 104.511273964|xi;
嬉__嬉 116.333988795|xi;
犀__犀 119.86585751|xi;
栖__棲 126.621787068|xi;
汐__汐 133.259374649|xi;
烯__烯 142.180598718|xi;
禧__禧 151.699065864|xi;
嘻__嘻 153.41002317|xi;
腊__臘 158.857391092|xi;
熄__熄 159.055477247|xi;
隙__隙 169.703655326|xi;
硒__硒 175.729586548|xi;
玺__璽 183.792676978|xi;
奚__奚 215.576896995|xi;
析__析 285.346757867|xi;
膝__膝 341.433560596|xi;
悉__悉 361.577631409|xi;
昔__昔 377.697115787|xi;
曦__曦 444.119751258|xi;
袭__襲 462.764242999|xi;
夕__夕 663.387871054|xi;
习__習 665.872587905|xi;
稀__稀 751.428823061|xi;
惜__惜 753.303969661|xi;
席__席 869.377962205|xi;
熙__熙 965.316430119|xi;
兮__兮 1012.12795618|xi;
息__息 1027.37704867|xi;
锡__錫 1090.70577937|xi;
溪__溪 1301.84258129|xi;
希__希 1784.36168375|xi;
吸__吸 2095.55037421|xi;
细__細 3153.64470585|xi;
喜__喜 3558.84830329|xi;
戏__戲 4360.39268552|xi;
洗__洗 9016.68885873|xi;
西__西 9937.12917391|xi;
系__系 23892.8527678|xi;
唬__唬 8.2758874428|xia;
柙__柙 9.03022977735|xia;
硖__硤 10.0142555326|xia;
罅__罅 14.1779803236|xia;
黠__黠 15.4125672823|xia;
狎__狎 35.9212942863|xia;
瑕__瑕 83.8243453898|xia;
遐__遐 84.4534488997|xia;
呷__呷 98.443123919|xia;
暇__暇 132.596773978|xia;
狭__狹 135.773751924|xia;
匣__匣 190.793818607|xia;
辖__轄 208.44415872|xia;
厦__廈 209.746993999|xia;
峡__峽 340.15949445|xia;
侠__俠 855.407364934|xia;
霞__霞 1240.08526378|xia;
虾__蝦 1515.60233678|xia;
瞎__瞎 2132.4308179|xia;
吓__嚇 3197.1719862|xia;
夏__夏 4503.98449045|xia;
下__下 163638.612686|xia;
猃__獫 1.96456341314|xian;
燹__燹 4.27540110556|xian;
筅__筅 5.31725428465|xian;
洗__洗 5.48551630837|xian;
莶__薟 6.58831544638|xian;
鹇__鷳 7.51868563597|xian;
彡__彡 8.20400946554|xian;
氙__氙 9.49176397308|xian;
跹__躚 10.2286689728|xian;
跣__跣 10.6315460323|xian;
锨__杴 17.1347297758|xian;
暹__暹 17.6769502816|xian;
铣__銑 19.7257363606|xian;
苋__莧 22.1495610736|xian;
岘__峴 27.581437195|xian;
籼__秈 30.4728553745|xian;
蚬__蜆 32.0303201505|xian;
霰__霰 32.3512380521|xian;
痫__癇 35.9660861025|xian;
藓__蘚 36.8737446754|xian;
祆__祆 61.0047073057|xian;
舷__舷 72.8138854049|xian;
涎__涎 76.1548421222|xian;
酰__酰 84.4534488997|xian;
冼__冼 148.149450567|xian;
羡__羨 223.231720645|xian;
纤__纖 239.664931108|xian;
见__見 251.600451735|xian;
娴__嫻 267.109399762|xian;
衔__銜 278.322859608|xian;
腺__腺 283.927938713|xian;
掀__掀 372.091054935|xian;
馅__餡 450.811022973|xian;
宪__憲 525.487661863|xian;
陷__陷 873.722339551|xian;
献__獻 966.520124945|xian;
弦__弦 1029.9408079|xian;
咸__咸 1073.17852213|xian;
险__險 1551.9157029|xian;
鲜__鮮 1571.37615922|xian;
限__限 1635.30461749|xian;
贤__賢 1687.0530669|xian;
嫌__嫌 1751.317311|xian;
显__顯 2300.85021536|xian;
仙__仙 2749.66894397|xian;
闲__閑 3241.3000394|xian;
现__現 7027.59035759|xian;
县__縣 7573.18614833|xian;
线__線 16338.0801689|xian;
先__先 84326.8101201|xian;
枵__枵 4.74720445188|xiao;
蛸__蛸 5.9855179344|xiao;
崤__崤 6.47437036794|xiao;
淆__淆 12.8647253131|xiao;
魈__魈 13.1893861112|xiao;
哓__嘵 50.6668689351|xiao;
哮__哮 53.7900343808|xiao;
绡__綃 71.3764517044|xiao;
嚣__囂 84.9813069762|xiao;
骁__驍 119.26985293|xiao;
逍__逍 130.46599058|xiao;
枭__梟 146.132498493|xiao;
硝__硝 159.651218957|xiao;
宵__宵 200.545272755|xiao;
潇__瀟 250.349428094|xiao;
霄__霄 271.133768339|xiao;
箫__簫 288.565077751|xiao;
削__削 381.957020988|xiao;
筱__筱 463.919044053|xiao;
啸__嘯 604.195219728|xiao;
效__效 858.611290099|xiao;
销__銷 903.620192345|xiao;
孝__孝 1132.25360251|xiao;
消__消 1489.38995692|xiao;
萧__蕭 2092.94059602|xiao;
校__校 2470.2273797|xiao;
肖__肖 2577.13898569|xiao;
晓__曉 2791.09646881|xiao;
笑__笑 14513.9865477|xiao;
小__小 92013.1498935|xiao;
蟓__蟓 6.03043937487|xiang;
鲞__鯗 9.33923467325|xiang;
葙__葙 15.4510284409|xiang;
庠__庠 24.7475500716|xiang;
芗__薌 25.151729495|xiang;
降__降 33.2504384462|xiang;
骧__驤 34.9063390075|xiang;
缃__緗 51.7516882347|xiang;
饷__餉 71.0215492075|xiang;
飨__饗 72.7232036954|xiang;
橡__橡 95.1859611725|xiang;
襄__襄 261.184568064|xiang;
厢__廂 281.111429553|xiang;
镶__鑲 328.086003878|xiang;
详__詳 405.501301397|xiang;
享__享 608.72971781|xiang;
巷__巷 800.735741689|xiang;
翔__翔 1282.5196677|xiang;
湘__湘 1318.16721196|xiang;
祥__祥 1863.91027245|xiang;
响__響 2554.75594355|xiang;
箱__箱 3161.51444144|xiang;
乡__鄉 3961.43882797|xiang;
项__項 4675.55298725|xiang;
香__香 6204.20466036|xiang;
相__相 12374.0738382|xiang;
象__象 13251.9222955|xiang;
像__像 34680.6933667|xiang;
向__向 52126.8194293|xiang;
想__想 141790.592683|xiang;
颉__頡 3.30741735168|xie;
榍__榍 3.45917327236|xie;
叶__葉 3.80754430139|xie;
渫__渫 7.17094190807|xie;
瀣__瀣 9.0414899616|xie;
薤__薤 12.3310371994|xie;
廨__廨 12.8167203338|xie;
獬__獬 12.8647253131|xie;
躞__躞 13.3881022592|xie;
绁__紲 15.2596776543|xie;
勰__勰 16.9859107246|xie;
邂__邂 17.1347297758|xie;
解__解 18.3961034722|xie;
契__契 19.4571841337|xie;
缬__纈 21.7393760988|xie;
亵__褻 30.3970014385|xie;
撷__擷 41.4562817722|xie;
楔__楔 68.671677169|xie;
榭__榭 91.6931310582|xie;
懈__懈 94.8307728587|xie;
燮__燮 114.037415895|xie;
偕__偕 121.368931601|xie;
械__械 153.028150386|xie;
谐__諧 163.272821143|xie;
胁__脅 165.73274959|xie;
蝎__蠍 166.768626413|xie;
挟__挾 208.70407676|xie;
屑__屑 261.510250403|xie;
泄__泄 487.02261325|xie;
卸__卸 502.434215952|xie;
血__血 519.626982517|xie;
泻__瀉 555.797602048|xie;
歇__歇 776.174076244|xie;
蟹__蟹 883.576728645|xie;
协__協 907.004698479|xie;
携__攜 1277.73391996|xie;
斜__斜 1318.16721196|xie;
邪__邪 1380.36844936|xie;
鞋__鞋 3364.76959766|xie;
谢__謝 6505.06796184|xie;
些__些 21951.6003568|xie;
写__寫 40881.4788495|xie;
寻__尋 1.94992915303|xin;
镡__鐔 6.41813897895|xin;
囟__囟 14.8470061588|xin;
衅__釁 23.5148860924|xin;
莘__莘 119.26985293|xin;
忻__忻 131.937467932|xin;
歆__歆 144.502706249|xin;
昕__昕 393.063006485|xin;
薪__薪 462.187920882|xin;
锌__鋅 739.353626862|xin;
芯__芯 1078.5413133|xin;
辛__辛 1361.57568978|xin;
鑫__鑫 1415.20413466|xin;
馨__馨 1521.27901981|xin;
欣__欣 1587.1200774|xin;
信__信 11312.1738491|xin;
心__心 20168.0713019|xin;
新__新 77282.5505188|xin;
荥__滎 6.00793666999|xing;
陉__陘 9.2006148223|xing;
悻__悻 9.91491609255|xing;
饧__餳 12.2087157421|xing;
省__省 17.0495313912|xing;
擤__擤 25.7222829747|xing;
硎__硎 27.5470875396|xing;
猩__猩 40.1346115182|xing;
惺__惺 43.0354594896|xing;
荇__荇 47.2516182162|xing;
腥__腥 240.263000901|xing;
杏__杏 466.237298568|xing;
邢__邢 654.356305043|xing;
刑__刑 819.921123923|xing;
幸__幸 881.377303227|xing;
形__形 2865.10217964|xing;
兴__興 3373.16618304|xing;
醒__醒 3506.02523602|xing;
姓__姓 3576.63225989|xing;
星__星 5735.75130134|xing;
型__型 14298.5591896|xing;
性__性 24434.8493048|xing;
行__行 35822.7610005|xing;
汹__洶 12.6107601578|xiong;
芎__芎 12.9936194557|xiong;
匈__匈 56.1880467122|xiong;
凶__凶 1534.60743675|xiong;
胸__胸 1827.1144412|xiong;
雄__雄 1845.42065012|xiong;
兄__兄 2729.18634194|xiong;
熊__熊 3811.32210727|xiong;
臭__臭 1.79150082694|xiu;
鸺__鵂 3.1900251493|xiu;
髹__髹 7.49996990053|xiu;
馐__饈 11.5141910287|xiu;
庥__庥 13.3215330924|xiu;
貅__貅 15.664286848|xiu;
咻__咻 59.5030576615|xiu;
岫__岫 79.7484115654|xiu;
朽__朽 85.8327509388|xiu;
宿__宿 120.46484039|xiu;
溴__溴 181.969489867|xiu;
锈__銹 218.552335545|xiu;
嗅__嗅 301.805456692|xiu;
羞__羞 435.352293046|xiu;
袖__袖 607.214449729|xiu;
绣__綉 838.520594407|xiu;
休__休 2127.12270781|xiu;
秀__秀 5013.49243365|xiu;
修__修 6710.91779356|xiu;
洫__洫 3.09603049346|xu;
砉__砉 3.21396635646|xu;
糈__糈 3.64050514333|xu;
醑__醑 4.24355314817|xu;
溆__漵 6.21352189773|xu;
蓿__蓿 6.81376062097|xu;
浒__滸 8.44255360829|xu;
酗__酗 9.73130299096|xu;
盱__盱 20.6308224033|xu;
顼__頊 21.9571870644|xu;
诩__詡 32.0702601426|xu;
勖__勖 33.6254577665|xu;
畜__畜 35.5649621309|xu;
栩__栩 46.7246285206|xu;
圩__圩 61.0807767149|xu;
吁__吁 72.5421789383|xu;
婿__婿 76.1548421222|xu;
戌__戌 105.953760973|xu;
煦__煦 108.492380517|xu;
墟__墟 110.539446825|xu;
胥__胥 183.335174792|xu;
絮__絮 196.831399718|xu;
绪__緒 361.12732612|xu;
蓄__蓄 366.568203397|xu;
叙__敘 411.098117295|xu;
嘘__噓 423.578945935|xu;
恤__恤 585.662213047|xu;
序__序 828.13607043|xu;
旭__旭 1145.0238695|xu;
续__續 1364.97342214|xu;
虚__虛 2018.65456559|xu;
许__許 5070.03774893|xu;
徐__徐 5191.51429493|xu;
须__須 5622.52066996|xu;
需__需 6368.70867559|xu;
挝__撾 62.0783539716|zhua;
爪__爪 891.318029807|zhua;
抓__抓 8029.99331146|zhua;
颛__顓 12.0125259855|zhuan;
啭__囀 22.4552740642|zhuan;
馔__饌 38.0880315377|zhuan;
篆__篆 87.0174329691|zhuan;
撰__撰 252.54282031|zhuan;
传__傳 307.500011268|zhuan;
砖__磚 1731.7851508|zhuan;
专__專 2662.00658024|zhuan;
赚__賺 10432.0067919|zhuan;
转__轉 16584.235701|zhuan;
戆__戇 0.586541738169|zhuang;
奘__奘 5.14132363678|zhuang;
僮__僮 11.4712255951|zhuang;
幢__幢 587.855808729|zhuang;
桩__樁 682.676889633|zhuang;
妆__妝 849.035336524|zhuang;
壮__壯 1103.00744393|zhuang;
撞__撞 2258.24105554|zhuang;
庄__庄 3153.64470585|zhuang;
状__狀 3181.27480592|zhuang;
装__裝 20962.4320622|zhuang;
屯__屯 2.7744656069|zhun;
窀__窀 3.3198052713|zhun;
谆__諄 12.5793690793|zhun;
肫__肫 16.4854178576|zhun;
准__准 4543.4453536|zhun;
拽__拽 1139.33050957|zhuai;
蜡__蠟 2.95283722304|zha;
喋__喋 3.15051879385|zha;
齄__齇 5.00228546297|zha;
哳__哳 5.8454624509|zha;
蚱__蚱 8.50591515418|zha;
痄__痄 8.7532376673|zha;
砟__砟 9.89023558913|zha;
楂__楂 13.8462289345|zha;
栅__柵 13.8980899344|zha;
咤__吒 20.6565478685|zha;
柞__柞 20.9677670253|zha;
查__查 24.3498656691|zha;
揸__揸 40.2347650897|zha;
铡__鍘 44.0665758704|zha;
吒__吒 53.7900343808|zha;
喳__喳 83.9288695932|zha;
轧__軋 116.769717326|zha;
咋__咋 134.762357541|zha;
榨__榨 168.020228531|zha;
诈__詐 197.814987883|zha;
札__札 315.653350706|zha;
眨__眨 340.583654043|zha;
乍__乍 432.648119245|zha;
闸__閘 527.455873984|zha;
渣__渣 989.677650042|zha;
扎__扎 1873.22443719|zha;
炸__炸 2358.91565003|zha;
侧__側 4.55594245285|zhai;
瘵__瘵 4.92190049961|zhai;
择__擇 7.30624535987|zhai;
哜__嚌 11.1332239019|zhai;
砦__砦 24.0183591271|zhai;
翟__翟 532.077085292|zhai;
寨__寨 724.757896749|zhai;
斋__齋 753.303969661|zhai;
债__債 898.007390736|zhai;
窄__窄 922.967443217|zhai;
宅__宅 1101.63376911|zhai;
摘__摘 1103.00744393|zhai;
搌__搌 3.65869714815|zhan;
谵__譫 13.255294925|zhan;
崭__嶄 17.5671505938|zhan;
旃__旃 19.7749607799|zhan;
辗__輾 26.8021243714|zhan;
颤__顫 38.4696428079|zhan;
绽__綻 79.1543564228|zhan;
毡__氈 122.890853693|zhan;
瞻__瞻 154.176629937|zhan;
栈__棧 266.444503116|zhan;
湛__湛 284.636464248|zhan;
盏__盞 292.54791482|zhan;
蘸__蘸 351.361264404|zhan;
粘__粘 472.67240572|zhan;
詹__詹 512.55262135|zhan;
沾__沾 737.513205869|zhan;
斩__斬 974.988119996|zhan;
展__展 3377.37232991|zhan;
战__戰 3991.16951133|zhan;
占__占 10562.8203485|zhan;
站__站 13654.247104|zhan;
嫜__嫜 2.76067023395|zhang;
仉__仉 8.8851171693|zhang;
鄣__鄣 16.1398503976|zhang;
獐__獐 22.8504735693|zhang;
幛__幛 25.2144941623|zhang;
蟑__蟑 26.3057791538|zhang;
瘴__瘴 33.4999836998|zhang;
嶂__嶂 44.5635863793|zhang;
漳__漳 101.431830772|zhang;
樟__樟 120.615053212|zhang;
璋__璋 176.60772663|zhang;
彰__彰 230.295783987|zhang;
障__障 270.796100963|zhang;
丈__丈 305.97104031|zhang;
胀__脹 407.527636023|zhang;
仗__仗 541.441326411|zhang;
杖__杖 602.691239054|zhang;
账__賬 794.770968525|zhang;
掌__掌 1063.85772095|zhang;
帐__帳 2156.48171146|zhang;
章__章 5608.52492462|zhang;
长__長 9175.37723473|zhang;
涨__漲 11728.4592825|zhang;
张__張 27300.8866702|zhang;
嘲__嘲 1.69802966896|zhao;
笊__笊 3.35724811942|zhao;
啁__啁 3.81229209313|zhao;
爪__爪 34.0895635437|zhao;
棹__棹 61.8467073549|zhao;
沼__沼 125.992190229|zhao;
钊__釗 187.26053154|zhao;
肇__肇 200.795341333|zhao;
诏__詔 205.862715427|zhao;
召__召 649.481929235|zhao;
罩__罩 783.950712715|zhao;
昭__昭 804.737106306|zhao;
朝__朝 1238.54087357|zhao;
兆__兆 1548.05262827|zhao;
着__着 3976.27638265|zhao;
招__招 6258.56170167|zhao;
赵__趙 6376.65009401|zhao;
照__照 9704.60970837|zhao;
找__找 78056.8591686|zhao;
鹧__鷓 3.99716329712|zhe;
夂__夂 6.13657153114|zhe;
螫__螫 12.0876076896|zhe;
磔__磔 14.4635073599|zhe;
摺__摺 31.3980030949|zhe;
柘__柘 36.5534877604|zhe;
赭__赭 45.517729384|zhe;
谪__謫 51.2383216931|zhe;
蜇__蜇 51.8162196541|zhe;
锗__鍺 58.2557540945|zhe;
蛰__蟄 64.122652166|zhe;
乇__乇 67.9057930023|zhe;
辄__輒 98.1980763731|zhe;
蔗__蔗 100.550872098|zhe;
褶__褶 102.831814646|zhe;
辙__轍 133.758497151|zhe;
浙__浙 402.480675297|zhe;
遮__遮 680.977550057|zhe;
哲__哲 1185.68201014|zhe;
折__折 3927.03282475|zhe;
者__者 29752.2472719|zhe;
着__着 87757.4864293|zhe;
这__這 178109.714849|zhe;
溱__溱 2.51121031968|zhen;
椹__椹 5.29081549739|zhen;
畛__畛 6.1980550146|zhen;
稹__稹 10.8998491741|zhen;
浈__湞 12.7688944861|zhen;
胗__胗 21.0463017202|zhen;
蓁__蓁 24.078295535|zhen;
缜__縝 27.0706599799|zhen;
鸩__鴆 27.6502650555|zhen;
轸__軫 39.6375708511|zhen;
砧__砧 44.6747921981|zhen;
箴__箴 54.8049606508|zhen;
赈__賑 61.769684063|zhen;
榛__榛 65.4140032908|zhen;
圳__圳 66.3168613884|zhen;
侦__偵 100.300577883|zhen;
斟__斟 109.852835359|zhen;
疹__疹 124.431860131|zhen;
桢__楨 183.563783354|zhen;
祯__禎 191.269933402|zhen;
诊__診 310.194118206|zhen;
臻__臻 339.735863102|zhen;
甄__甄 360.677581637|zhen;
贞__貞 640.639682982|zhen;
朕__朕 764.653524665|zhen;
帧__幀 857.541983893|zhen;
枕__枕 1038.96445205|zhen;
珍__珍 1371.79434453|zhen;
振__振 1517.49220692|zhen;
震__震 1549.98296207|zhen;
阵__陣 1729.62840231|zhen;
针__針 2103.39925049|zhen;
镇__鎮 9073.04572868|zhen;
真__真 65153.328035|zhen;
丁__丁 3.37402465772|zheng;
狰__猙 9.45634526638|zheng;
钲__鉦 12.7688944861|zheng;
诤__諍 37.2431897734|zheng;
拯__拯 49.4813119117|zheng;
峥__崢 141.29744947|zheng;
怔__怔 178.377193209|zheng;
筝__箏 205.862715427|zheng;
铮__錚 209.485777119|zheng;
睁__睜 316.441045148|zheng;
蒸__蒸 1404.66211536|zheng;
政__政 1467.28332601|zheng;
征__征 1502.43898348|zheng;
症__症 2079.94037707|zheng;
争__爭 2564.32477261|zheng;
挣__掙 2794.57680777|zheng;
郑__鄭 3941.74151187|zheng;
证__證 5296.06498953|zheng;
整__整 7151.27177974|zheng;
正__正 20523.0173949|zheng;
这__這 2551.57427517|zhei;
识__識 1.29086422324|zhi;
轾__輊 2.38018847868|zhi;
氏__氏 3.23002690002|zhi;
踬__躓 5.14773457569|zhi;
踯__躑 6.5229606564|zhi;
埴__埴 7.02062456687|zhi;
膣__膣 7.18883657345|zhi;
黹__黹 8.00206524781|zhi;
觯__觶 9.28122438105|zhi;
絷__縶 9.30438513268|zhi;
轵__軹 9.75558688739|zhi;
鸷__鷙 10.5129741099|zhi;
蜘__蜘 11.8637587817|zhi;
骘__騭 13.1729601771|zhi;
胝__胝 13.2718235258|zhi;
摭__摭 15.9797462645|zhi;
忮__忮 16.8804034021|zhi;
贽__贄 17.4798020992|zhi;
蛭__蛭 18.1004845767|zhi;
帙__帙 18.7899791646|zhi;
卮__卮 20.3499480574|zhi;
栉__櫛 21.1514724059|zhi;
桎__桎 21.3367872887|zhi;
咫__咫 21.9025305827|zhi;
陟__陟 22.9646599002|zhi;
豸__豸 27.0369464415|zhi;
彘__彘 32.8386537177|zhi;
帜__幟 33.2918998566|zhi;
枳__枳 43.358441536|zhi;
祉__祉 47.1927715073|zhi;
窒__窒 49.6666439849|zhi;
跖__跖 51.6228663963|zhi;
峙__峙 52.7281543871|zhi;
郅__郅 58.619869127|zhi;
祗__祗 68.2451257225|zhi;
雉__雉 68.3302235228|zhi;
殖__殖 74.5584837171|zhi;
栀__梔 76.5353962486|zhi;
秩__秩 81.0508704717|zhi;
挚__摯 82.2720127324|zhi;
徵__徵 86.5847593983|zhi;
侄__侄 100.676253331|zhi;
吱__吱 117.646076559|zhi;
炙__炙 127.254530072|zhi;
稚__稚 161.250795044|zhi;
痔__痔 170.551683166|zhi;
趾__趾 171.403948695|zhi;
肢__肢 184.02185602|zhi;
旨__旨 246.326401069|zhi;
址__址 251.287110964|zhi;
酯__酯 268.778909483|zhi;
掷__擲 282.164331387|zhi;
芷__芷 306.734573113|zhi;
滞__滯 328.495108513|zhi;
痣__痣 379.584509838|zhi;
织__織 569.114341748|zhi;
脂__脂 610.248767154|zhi;
植__植 613.298247397|zhi;
执__執 826.074649543|zhi;
芝__芝 1009.60853723|zhi;
职__職 1051.99268696|zhi;
汁__汁 1193.09285994|zhi;
枝__枝 1309.9794677|zhi;
止__止 1425.82527204|zhi;
置__置 1619.08271818|zhi;
质__質 1873.22443719|zhi;
智__智 2272.35570445|zhi;
致__致 2826.09579953|zhi;
支__支 3428.25706512|zhi;
志__志 3436.81207976|zhi;
治__治 3536.74265575|zhi;
纸__紙 3607.96829056|zhi;
制__制 4902.28669206|zhi;
直__直 5038.54540704|zhi;
知__知 6669.23318922|zhi;
指__指 8783.78740305|zhi;
值__值 9175.37723473|zhi;
至__至 17782.9104775|zhi;
只__只 38748.4967652|zhi;
之__之 49530.406755|zhi;
荮__葤 2.1516611941|zhou;
啁__啁 3.81229209313|zhou;
碡__碡 7.98214626949|zhou;
繇__繇 7.98214626949|zhou;
籀__籀 8.94065167877|zhou;
妯__妯 13.371428846|zhou;
酎__酎 14.4996001951|zhou;
帚__帚 30.0954691787|zhou;
诌__謅 33.962357657|zhou;
胄__胄 40.8409568766|zhou;
纣__紂 46.0885050923|zhou;
绉__縐 59.8004009886|zhou;
宙__宙 106.616002115|zhou;
骤__驟 190.793818607|zhou;
昼__晝 227.160466527|zhou;
肘__肘 263.144763849|zhou;
皱__皺 534.735933039|zhou;
咒__咒 637.454253928|zhou;
舟__舟 894.656458236|zhou;
轴__軸 1287.32334043|zhou;
洲__洲 1298.60199609|zhou;
粥__粥 1498.69906777|zhou;
州__州 3193.1902591|zhou;
周__周 16297.4109348|zhou;
忪__忪 0.93594457611|zhong;
舯__舯 4.78879624368|zhong;
螽__螽 5.83091175227|zhong;
夂__夂 24.9955005074|zhong;
踵__踵 43.3044433518|zhong;
锺__鍾 112.484875527|zhong;
盅__盅 165.526347625|zhong;
衷__衷 209.224885556|zhong;
冢__冢 213.172602547|zhong;
肿__腫 859.681929668|zhong;
终__終 1882.58514584|zhong;
忠__忠 2098.16340664|zhong;
众__眾 3095.24275062|zhong;
仲__仲 3273.77524422|zhong;
钟__鍾 4317.13844997|zhong;
重__重 6392.5626507|zhong;
种__種 12160.0639254|zhong;
中__中 243213.912993|zhong;
属__屬 3.91337472836|zhu;
舳__舳 5.51980234552|zhu;
橥__櫫 6.27577636162|zhu;
疰__疰 6.47437036794|zhu;
术__術 6.62123798367|zhu;
槠__櫧 6.86489804056|zhu;
丶__丶 8.42153815326|zhu;
麈__麈 9.53919536216|zhu;
躅__躅 10.5918742061|zhu;
瘃__瘃 13.009821762|zhu;
褚__褚 13.8634943964|zhu;
杼__杼 16.5059742385|zhu;
翥__翥 18.8368684567|zhu;
邾__邾 20.0979273856|zhu;
炷__炷 20.9155734372|zhu;
苎__苧 21.2306951686|zhu;
瞩__矚 23.1370101653|zhu;
侏__侏 27.1044155572|zhu;
茱__茱 29.7969280594|zhu;
潴__瀦 31.9904298992|zhu;
铢__銖 32.3915782107|zhu;
伫__佇 48.4440842586|zhu;
箸__箸 49.7905841849|zhu;
蛀__蛀 58.1107421423|zhu;
拄__拄 61.2332002144|zhu;
蛛__蛛 61.3095545413|zhu;
嘱__囑 109.442917312|zhu;
洙__洙 117.353228453|zhu;
竺__竺 117.499561272|zhu;
渚__渚 145.950506492|zhu;
贮__貯 162.258658377|zhu;
诛__誅 242.066179876|zhu;
烛__燭 260.859291326|zhu;
铸__鑄 457.033213363|zhu;
筑__築 598.94764591|zhu;
株__株 736.594714048|zhu;
逐__逐 778.110973173|zhu;
柱__柱 1472.77903036|zhu;
诸__諸 1555.7884176|zhu;
助__助 1559.67079644|zhu;
珠__珠 1777.70330251|zhu;
驻__駐 2132.4308179|zhu;
竹__竹 2261.05695403|zhu;
注__注 2808.54161561|zhu;
煮__煮 2836.68093103|zhu;
著__著 3225.18344283|zhu;
祝__祝 4031.15780176|zhu;
朱__朱 5587.59660193|zhu;
主__主 10842.8927276|zhu;
猪__豬 15935.9132976|zhu;
住__住 21924.2620458|zhu;
缴__繳 3.38244433856|zhuo;
禚__禚 5.14773457569|zhuo;
诼__諑 6.93367876657|zhuo;
浞__浞 8.06212091911|zhuo;
涿__涿 18.6732659413|zhuo;
著__著 20.7597709113|zhuo;
琢__琢 21.177847092|zhuo;
茁__茁 24.6244987417|zhuo;
倬__倬 34.1746320521|zhuo;
擢__擢 34.2172458796|zhuo;
斫__斫 39.5882066033|zhuo;
镯__鐲 50.9200568548|zhuo;
焯__焯 58.619869127|zhuo;
濯__濯 72.8138854049|zhuo;
酌__酌 107.550099352|zhuo;
啄__啄 151.699065864|zhuo;
灼__灼 184.941433485|zhuo;
拙__拙 235.519920202|zhuo;
浊__濁 292.912705474|zhuo;
捉__捉 866.133860988|zhuo;
桌__桌 1227.78386251|zhuo;
卓__卓 1329.71610075|zhuo;
着__着 1887.28302677|zhuo;
缒__縋 6.74616945932|zhui;
惴__惴 9.93965818473|zhui;
隹__隹 17.8986127844|zhui;
骓__騅 25.7864714248|zhui;
赘__贅 69.9673946745|zhui;
椎__椎 165.526347625|zhui;
锥__錐 228.8653107|zhui;
缀__綴 239.366454718|zhui;
坠__墜 543.469292924|zhui;
追__追 5643.57980061|zhui;
舡__舡 3.72773052752|chuan;
遄__遄 13.1565546998|chuan;
氚__氚 18.1456532754|chuan;
钏__釧 43.3044433518|chuan;
椽__椽 57.53429504|chuan;
舛__舛 59.4289531284|chuan;
喘__喘 513.191745392|chuan;
串__串 1399.42059064|chuan;
川__川 2883.00988318|chuan;
船__船 4132.89016505|chuan;
穿__穿 14227.4629914|chuan;
传__傳 14495.9109691|chuan;
幢__幢 14.517680374|chuang;
怆__愴 29.9458265878|chuang;
疮__瘡 225.187525865|chuang;
闯__闖 1044.15627174|chuang;
窗__窗 1744.7822355|chuang;
创__創 2712.23410734|chuang;
床__床 3976.27638265|chuang;
鹑__鶉 19.8985599093|chun;
蝽__蝽 21.9571870644|chun;
莼__蒓 26.4043073537|chun;
椿__椿 116.624293448|chun;
淳__淳 323.619340361|chun;
醇__醇 463.919044053|chun;
蠢__蠢 641.438524323|chun;
唇__唇 920.669965262|chun;
纯__純 4448.20561603|chun;
春__春 5269.73156102|chun;
膪__膪 1.54266855002|chuai;
嘬__嘬 1.55231066723|chuai;
搋__搋 3.52883675546|chuai;
啜__啜 10.1019936604|chuai;
揣__揣 270.458854115|chuai;
踹__踹 587.123698784|chuai;
喳__喳 3.11926626872|cha;
馇__餷 3.72308804793|cha;
猹__猹 4.62458395953|cha;
锸__鍤 5.45824087806|cha;
楂__楂 13.8462289345|cha;
衩__衩 16.9225274597|cha;
刹__剎 21.9025305827|cha;
嚓__嚓 25.4671230002|cha;
镲__鑔 28.9189562984|cha;
姹__奼 35.7872532598|cha;
诧__詫 42.3966952665|cha;
杈__杈 46.6083201885|cha;
汊__汊 48.2032075261|cha;
檫__檫 50.983551277|cha;
槎__槎 62.4663613407|cha;
碴__碴 74.8377422459|cha;
岔__岔 161.451865638|cha;
搽__搽 262.489736092|cha;
茬__茬 272.828431509|cha;
察__察 507.468200425|cha;
叉__叉 853.278059532|cha;
插__插 3811.32210727|cha;
茶__茶 4823.50867368|cha;
查__查 13251.9222955|cha;
差__差 16939.3178156|cha;
瘥__瘥 4.86700733523|chai;
虿__蠆 8.36922809722|chai;
侪__儕 15.5476017633|chai;
豺__豺 34.6031694612|chai;
钗__釵 207.666345181|chai;
差__差 281.812926654|chai;
柴__柴 978.639934443|chai;
拆__拆 2529.4132684|chai;
骣__驏 2.11972464207|chan;
冁__囅 3.12705021493|chan;
羼__羼 9.2006148223|chan;
孱__孱 9.38590385664|chan;
廛__廛 12.1631586757|chan;
单__單 13.6237249183|chan;
躔__躔 19.5787970687|chan;
潺__潺 22.1771803197|chan;
蒇__蕆 22.7368550028|chan;
谄__諂 24.4410680021|chan;
觇__覘 26.6688571574|chan;
忏__懺 46.3765713579|chan;
阐__闡 51.9455239942|chan;
澶__澶 65.2511728122|chan;
蟾__蟾 68.1601339023|chan;
搀__攙 116.769717326|chan;
谗__讒 117.792774542|chan;
婵__嬋 145.950506492|chan;
蝉__蟬 274.533686805|chan;
掺__摻 334.276427588|chan;
馋__饞 362.931919108|chan;
颤__顫 379.584509838|chan;
铲__鏟 479.793862242|chan;
禅__禪 650.291796355|chan;
缠__纏 713.111292931|chan;
产__產 2648.77038315|chan;
惝__惝 2.35364261953|chang;
倘__倘 5.83818256844|chang;
鬯__鬯 8.16321697203|chang;
裳__裳 8.45308099369|chang;
菖__菖 9.30438513268|chang;
氅__氅 12.0425025403|chang;
伥__倀 14.3736678476|chang;
鲳__鯧 14.9398041702|chang;
阊__閶 15.5476017633|chang;
徜__徜 16.7964695952|chang;
猖__猖 18.9309983612|chang;
苌__萇 29.3546599431|chang;
嫦__嫦 46.4923013745|chang;
怅__悵 54.0588291018|chang;
昶__昶 80.9499305006|chang;
敞__敞 91.8074671909|chang;
倡__倡 97.1028890266|chang;
娼__娼 128.209578049|chang;
偿__償 192.225730308|chang;
畅__暢 537.40806734|chang;
肠__腸 900.248315564|chang;
尝__嘗 1032.51096484|chang;
昌__昌 1729.62840231|chang;
场__場 5636.55134085|chang;
厂__廠 5991.45670308|chang;
常__常 7630.02307279|chang;
唱__唱 7744.97981009|chang;
长__長 13911.8794748|chang;
怊__怊 3.7980664491|chao;
剿__剿 4.52200471051|chao;
耖__耖 6.58831544638|chao;
晁__晁 65.332537323|chao;
焯__焯 69.187059579|chao;
嘲__嘲 141.473639374|chao;
绰__綽 152.457122789|chao;
钞__鈔 207.925293333|chao;
巢__巢 491.289575698|chao;
潮__潮 1394.19862478|chao;
抄__抄 2467.15098238|chao;
吵__吵 2570.72389483|chao;
朝__朝 3764.12139917|chao;
炒__炒 5276.30261733|chao;
超__超 9875.40508331|chao;
尺__尺 4.38876304107|che;
砗__硨 5.54047674507|che;
坼__坼 18.2363291016|che;
掣__掣 61.3095545413|che;
澈__澈 262.489736092|che;
彻__徹 318.418891685|che;
撤__撤 1563.56286353|che;
扯__扯 2261.05695403|che;
车__車 26005.7765312|che;
肜__肜 1.00860780705|chen;
沈__沈 1.98177558786|chen;
榇__櫬 5.16058044571|chen;
龀__齔 5.29741284417|chen;
伧__傖 5.41083480633|chen;
碜__磣 14.8470061588|chen;
谶__讖 41.4046525194|chen;
忱__忱 66.1517834887|chen;
抻__抻 72.6326349201|chen;
谌__諶 78.9573230494|chen;
郴__郴 97.5881228486|chen;
宸__宸 163.476413088|chen;
嗔__嗔 197.568631008|chen;
琛__琛 288.565077751|chen;
衬__襯 338.468131949|chen;
称__稱 343.567617462|chen;
辰__辰 833.312156414|chen;
臣__臣 1390.72814418|chen;
尘__塵 1493.10664229|chen;
晨__晨 1506.18823193|chen;
沉__沉 1555.7884176|chen;
趁__趁 1684.95202731|chen;
陈__陳 12941.8397922|chen;
铛__鐺 2.71969431786|cheng;
酲__酲 6.71262572986|cheng;
枨__棖 7.90296495261|cheng;
柽__檉 8.39011301557|cheng;
裎__裎 9.61078722794|cheng;
瞠__瞠 14.7364090925|cheng;
蛏__蟶 15.0894889246|cheng;
埕__埕 20.7856571679|cheng;
塍__塍 27.1382132258|cheng;
铖__鋮 42.9283343465|cheng;
骋__騁 56.6803283412|cheng;
惩__懲 117.061109314|cheng;
逞__逞 128.209578049|cheng;
盛__盛 152.267254161|cheng;
丞__丞 160.649084484|cheng;
秤__秤 298.439468992|cheng;
澄__澄 443.014235191|cheng;
橙__橙 483.394725468|cheng;
承__承 1397.67776576|cheng;
诚__誠 1521.27901981|cheng;
撑__撐 1557.7283975|cheng;
乘__乘 2409.42197254|cheng;
程__程 3157.5771219|cheng;
呈__呈 3576.63225989|cheng;
城__城 7812.83608024|cheng;
称__稱 13485.148268|cheng;
成__成 33117.9352189|cheng;
眵__眵 2.56178299815|chi;
踟__踟 3.72773052752|chi;
坻__坻 6.07569795171|chi;
瘛__瘛 7.04692029058|chi;
傺__傺 7.67010269101|chi;
褫__褫 8.16321697203|chi;
媸__媸 8.46362150615|chi;
魑__魑 9.86561652115|chi;
啻__啻 10.7782849099|chi;
茌__茌 14.6266358766|chi;
鸱__鴟 14.9211982824|chi;
蚩__蚩 17.5015984208|chi;
篪__篪 19.2641727042|chi;
笞__笞 19.9979952029|chi;
饬__飭 24.2590036594|chi;
墀__墀 25.6582543045|chi;
哧__哧 29.9831673348|chi;
侈__侈 31.0478262181|chi;
豉__豉 31.1253042493|chi;
匙__匙 37.5694893905|chi;
螭__螭 43.0891222662|chi;
嗤__嗤 51.5585757772|chi;
叱__叱 78.4668827144|chi;
敕__敕 83.4075486906|chi;
彳__彳 84.3482713904|chi;
弛__弛 136.282292017|chi;
炽__熾 142.891090816|chi;
斥__斥 314.475483928|chi;
耻__恥 389.163898974|chi;
翅__翅 412.637883794|chi;
驰__馳 454.194369369|chi;
痴__痴 579.852559389|chi;
齿__齒 711.336195135|chi;
尺__尺 764.653524665|chi;
赤__赤 1130.84350481|chi;
迟__遲 1930.09502896|chi;
池__池 1964.0635567|chi;
持__持 3792.371211|chi;
吃__吃 65315.9143476|chi;
帱__幬 1.94023359226|chou;
瘳__瘳 8.40057501053|chou;
惆__惆 10.1905004904|chou;
雠__讎 11.5573173892|chou;
踌__躊 20.9939126412|chou;
俦__儔 22.0394276285|chou;
绸__綢 142.357889859|chou;
酬__酬 230.582949765|chou;
稠__稠 316.83562918|chou;
瞅__瞅 348.743933702|chou;
畴__疇 354.43965395|chou;
筹__籌 653.541376022|chou;
仇__仇 664.215078095|chou;
愁__愁 1988.69219664|chou;
臭__臭 2596.48046905|chou;
丑__丑 3197.1719862|chou;
抽__抽 4805.5096548|chou;
茺__茺 4.83677610885|chong;
艟__艟 5.48551630837|chong;
种__種 7.22475998089|chong;
忡__忡 14.1603232038|chong;
憧__憧 18.3046332058|chong;
舂__舂 33.2918998566|chong;
铳__銃 35.5649621309|chong;
崇__崇 675.904869515|chong;
宠__寵 1156.49608257|chong;
虫__蟲 1966.51263254|chong;
充__充 2904.64693418|chong;
重__重 4543.4453536|chong;
冲__沖 8294.42849341|chong;
蜍__蜍 2.39805184425|chu;
憷__憷 7.11752473231|chu;
搐__搐 9.22357441751|chu;
躇__躇 12.2391818769|chu;
樗__樗 15.3742018624|chu;
绌__絀 18.1682798757|chu;
蹰__躕 25.9476442055|chu;
楮__楮 26.7021117094|chu;
黜__黜 27.2738258636|chu;
滁__滁 33.9200612648|chu;
础__礎 40.2347650897|chu;
刍__芻 45.3478790684|chu;
矗__矗 51.5585757772|chu;
怵__怵 55.3540620301|chu;
亍__亍 80.3469251045|chu;
橱__櫥 96.4997382157|chu;
杵__杵 130.954650472|chu;
锄__鋤 133.591915611|chu;
雏__雛 141.121478992|chu;
畜__畜 152.457122789|chu;
褚__褚 195.60878915|chu;
厨__廚 306.352568839|chu;
储__儲 685.233853433|chu;
触__觸 815.844260376|chu;
楚__楚 2427.50473612|chu;
初__初 4757.8399467|chu;
除__除 8546.24511901|chu;
处__處 13722.4788793|chu;
出__出 55547.2536275|chu;
踔__踔 6.39418956526|chuo;
龊__齪 18.2818367924|chuo;
辍__輟 41.8194936494|chuo;
啜__啜 113.895394799|chuo;
绰__綽 152.457122789|chuo;
戳__戳 679.282440527|chuo;
椎__椎 4.1597803036|chui;
缍__綞 11.216778986|chui;
陲__陲 17.1133903489|chui;
棰__棰 51.4943652251|chui;
槌__槌 105.690017726|chui;
炊__炊 120.314814642|chui;
捶__捶 237.583386308|chui;
锤__錘 581.299547476|chui;
垂__垂 773.277767188|chui;
吹__吹 5133.61417128|chui;
唰__唰 92.4964842011|shua;
耍__耍 5269.73156102|shua;
刷__刷 14316.3886818|shua;
闩__閂 20.8115757033|shuan;
涮__涮 272.488653616|shuan;
拴__拴 291.093289619|shuan;
栓__栓 479.793862242|shuan;
泷__瀧 7.22475998089|shuang;
孀__孀 12.9936194557|shuang;
霜__霜 1629.20244568|shuang;
双__雙 8838.68857266|shuang;
爽__爽 10536.5270626|shuang;
吮__吮 107.550099352|shun;
瞬__瞬 287.846772995|shun;
舜__舜 396.012952778|shun;
顺__順 3004.04087494|shun;
蟀__蟀 46.8996354463|shuai;
率__率 396.012952778|shuai;
衰__衰 1170.99812122|shuai;
摔__摔 1397.67776576|shuai;
甩__甩 1689.15672637|shuai;
帅__帥 6051.48625333|shuai;
嗄__嗄 0.544964147416|sha;
挲__挲 0.994876310911|sha;
杉__杉 2.37426364287|sha;
歃__歃 3.55975403428|sha;
唼__唼 4.99605566498|sha;
铩__鎩 7.39786300923|sha;
裟__裟 15.3742018624|sha;
霎__霎 19.0019043465|sha;
痧__痧 68.671677169|sha;
鲨__鯊 138.85370659|sha;
厦__廈 150.381524744|sha;
刹__剎 256.987424161|sha;
莎__莎 341.433560596|sha;
煞__煞 420.94790182|sha;
纱__紗 679.282440527|sha;
砂__砂 739.353626862|sha;
沙__沙 4071.54674252|sha;
傻__傻 7160.18900995|sha;
杀__殺 22449.5606252|sha;
啥__啥 40526.4138456|sha;
骰__骰 0.661080628947|shai;
酾__釃 2.997325756|shai;
色__色 7.17988366583|shai;
筛__篩 271.810366771|shai;
晒__曬 3130.15284164|shai;
埏__埏 2.67932659672|shan;
舢__舢 3.63144308987|shan;
禅__禪 5.62395160794|shan;
潸__潸 6.06813133618|shan;
鄯__鄯 7.44410175719|shan;
钐__釤 7.68924298287|shan;
彡__彡 8.07217392654|shan;
芟__芟 8.50591515418|shan;
剡__剡 10.5918742061|shan;
嬗__嬗 11.272830465|shan;
蟮__蟮 16.1801264486|shan;
讪__訕 18.0104842052|shan;
骟__騸 22.1219762242|shan;
苫__苫 28.9189562984|shan;
赡__贍 31.8710569716|shan;
掸__撣 39.9848484144|shan;
膻__膻 43.7928580517|shan;
单__單 47.0166707386|shan;
跚__跚 48.4440842586|shan;
缮__繕 59.059812502|shan;
鳝__鱔 64.3628233258|shan;
汕__汕 105.295633316|shan;
煽__煽 107.015331962|shan;
膳__膳 116.18910757|shan;
疝__疝 124.742372548|shan;
姗__姍 125.835280772|shan;
栅__柵 130.46599058|shan;
擅__擅 184.481071779|shan;
陕__陝 284.281980745|shan;
杉__杉 337.625607028|shan;
珊__珊 627.210588862|shan;
扇__扇 947.439854855|shan;
衫__衫 970.140222547|shan;
善__善 2658.69134296|shan;
闪__閃 3554.41614799|shan;
删__刪 4393.11752614|shan;
山__山 10951.5297429|shan;
汤__湯 3.6953543344|shang;
垧__垧 7.25182029304|shang;
绱__緔 18.0554283133|shang;
晌__晌 47.9037951811|shang;
墒__墒 52.2701982939|shang;
觞__觴 116.044406778|shang;
熵__熵 160.249192015|shang;
裳__裳 173.769702743|shang;
殇__殤 214.2378495|shang;
赏__賞 955.740681497|shang;
尚__尚 3912.37902339|shang;
伤__傷 5552.8894634|shang;
商__商 5650.61702447|shang;
上__上 284918.877589|shang;
鞘__鞘 2.7366931809|shao;
筲__筲 2.997325756|shao;
艄__艄 5.41758181038|shao;
潲__潲 6.37032951928|shao;
蛸__蛸 8.46362150615|shao;
召__召 13.1893861112|shao;
杓__杓 18.4880308256|shao;
苕__苕 42.3966952665|shao;
劭__劭 44.0665758704|shao;
芍__芍 60.0243831723|shao;
捎__捎 201.547419552|shao;
韶__韶 210.795122809|shao;
梢__梢 250.037645335|shao;
哨__哨 250.661599628|shao;
勺__勺 437.527796363|shao;
绍__紹 721.154209805|shao;
邵__邵 1069.17393505|shao;
稍__稍 1887.28302677|shao;
烧__燒 4945.23720947|shao;
少__少 31117.384839|shao;
猞__猞 1.76491004233|she;
揲__揲 3.86491016593|she;
滠__灄 8.46362150615|she;
厍__厙 14.718056511|she;
歙__歙 18.0779424081|she;
麝__麝 33.9200612648|she;
折__折 34.0047067903|she;
畲__畲 35.1245135546|she;
慑__懾 56.4688245648|she;
赊__賒 67.4839988155|she;
赦__赦 96.9819580267|she;
奢__奢 136.112567367|she;
佘__佘 257.3078729|she;
涉__涉 696.425160166|she;
舌__舌 875.902662456|she;
摄__攝 1406.41364933|she;
舍__舍 1452.72816478|she;
蛇__蛇 2059.3077787|she;
射__射 2318.11814557|she;
社__社 2966.83781195|she;
设__設 3787.64822853|she;
葚__葚 3.59541989056|shen;
渖__瀋 3.88906695375|shen;
椹__椹 5.29081549739|shen;
娠__娠 6.29143719382|shen;
胂__胂 9.62277133439|shen;
糁__糝 11.8047690518|shen;
矧__矧 11.8637587817|shen;
诜__詵 13.2222994514|shen;
蜃__蜃 22.3993777295|shen;
呻__呻 24.5020592553|shen;
莘__莘 28.3480613086|shen;
哂__哂 35.1683118304|shen;
绅__紳 76.8220592961|shen;
参__參 96.7405476583|shen;
砷__砷 178.822323044|shen;
婶__嬸 193.427195796|shen;
谂__諗 243.57916235|shen;
渗__滲 314.867617017|shen;
慎__慎 400.479435488|shen;
什__什 890.207990943|shen;
审__審 993.38448407|shen;
伸__伸 997.105202031|shen;
肾__腎 1252.50991514|shen;
申__申 2151.11373318|shen;
甚__甚 2161.86308522|shen;
身__身 5764.41348178|shen;
沈__沈 6710.91779356|shen;
深__深 6820.52116343|shen;
神__神 9418.66166506|shen;
渑__澠 2.31870810931|sheng;
眚__眚 11.6585747805|sheng;
嵊__嵊 12.3926567493|sheng;
乘__乘 13.7773818413|sheng;
甥__甥 22.511309885|sheng;
牲__牲 64.0427944345|sheng;
笙__笙 211.584655172|sheng;
晟__晟 273.850309404|sheng;
绳__繩 635.075580657|sheng;
剩__剩 1579.22849881|sheng;
圣__聖 2529.4132684|sheng;
盛__盛 2773.75968187|sheng;
胜__勝 3699.02082656|sheng;
升__升 6266.36577307|sheng;
声__聲 7169.11735945|sheng;
省__省 13586.354595|sheng;
生__生 20268.8533736|sheng;
谁__誰 11979.5752336|shei;
嘘__噓 0.547005308642|shi;
酾__釃 2.997325756|shi;
贳__貰 4.1390967815|shi;
鲥__鰣 5.54047674507|shi;
螫__螫 7.26086290155|shi;
鲺__鯴 7.60348609303|shi;
炻__炻 7.73730293854|shi;
埘__塒 11.615070576|shi;
殖__殖 13.371428846|shi;
蓍__蓍 15.9399690058|shi;
筮__筮 18.4650060106|shi;
铈__鈰 25.1830922748|shi;
莳__蒔 29.2087008507|shi;
豕__豕 30.6251315862|shi;
舐__舐 34.5600750082|shi;
峙__峙 36.5079643999|shi;
轼__軾 37.4759703024|shi;
谥__謚 75.5875558941|shi;
弑__弒 97.4665875432|shi;
礻__礻 97.9536388067|shi;
柿__柿 108.898738333|shi;
恃__恃 121.368931601|shi;
匙__匙 125.992190229|shi;
噬__噬 141.650048976|shi;
虱__虱 153.028150386|shi;
拭__拭 165.32020271|shi;
什__什 167.810977762|shi;
矢__矢 245.407229187|shi;
蚀__蝕 286.772667017|shi;
驶__駛 287.130256264|shi;
嗜__嗜 325.642053285|shi;
侍__侍 363.384474622|shi;
誓__誓 439.166555128|shi;
狮__獅 501.808489233|shi;
逝__逝 535.402718412|shi;
似__似 582.750146437|shi;
释__釋 612.534451685|shi;
示__示 642.238361775|shi;
拾__拾 706.037369534|shi;
仕__仕 761.800204777|shi;
尸__屍 766.561672733|shi;
适__適 846.921892564|shi;
势__勢 1112.67124847|shi;
屎__屎 1170.99812122|shi;
始__始 1371.79434453|shi;
饰__飾 1525.07528247|shi;
识__識 1779.91999768|shi;
失__失 1804.48683509|shi;
湿__濕 1838.53442614|shi;
士__士 2309.46804145|shi;
氏__氏 2548.39656922|shi;
视__視 2625.76520592|shi;
施__施 2662.00658024|shi;
实__實 3087.5379805|shi;
世__世 3253.44031687|shi;
史__史 3635.04616996|shi;
食__食 3981.23457372|shi;
诗__詩 4945.23720947|shi;
师__師 4963.75957739|shi;
室__室 5463.65648792|shi;
十__十 5976.54259122|shi;
石__石 6204.20466036|shi;
试__試 6578.43620239|shi;
式__式 11075.047971|shi;
市__市 18050.8343551|shi;
使__使 34422.3528702|shi;
事__事 38942.1272676|shi;
时__時 117616.143115|shi;
是__是 1180957.05912|shi;
艏__艏 14.7364090925|shou;
绶__綬 52.0102971158|shou;
狩__狩 58.0383715854|shou;
熟__熟 380.057830188|shou;
授__授 506.83620443|shou;
寿__壽 1058.56794047|shou;
兽__獸 1341.36617307|shou;
售__售 1358.18641516|shou;
守__守 3290.13465937|shou;
瘦__瘦 3488.59235612|shou;
首__首 4344.12179319|shou;
受__受 15389.4559856|shou;
手__手 16196.1802019|shou;
收__收 16855.0910707|shou;
毹__毹 5.47186159836|shu;
摅__攄 6.18262663209|shu;
腧__腧 6.33076046573|shu;
疋__疋 7.19780064483|shu;
秫__秫 14.0198555902|shu;
殳__殳 19.9979952029|shu;
沐__沐 21.8752533827|shu;
沭__沭 27.2738258636|shu;
菽__菽 27.3759798789|shu;
纾__紓 37.6163364125|shu;
倏__倏 44.5080873194|shu;
丨__丨 47.0752978598|shu;
黍__黍 56.9635661792|shu;
塾__塾 64.7651092781|shu;
蔬__蔬 65.169909632|shu;
澍__澍 73.4518313776|shu;
戍__戍 97.8316482913|shu;
曙__曙 99.553427276|shu;
抒__抒 110.401782066|shu;
庶__庶 123.044091616|shu;
枢__樞 130.303509496|shu;
墅__墅 132.927661458|shu;
薯__薯 141.650048976|shu;
漱__漱 141.826678552|shu;
暑__暑 147.596627936|shu;
赎__贖 156.694657831|shu;
恕__恕 203.313241605|shu;
姝__姝 210.008536601|shu;
殊__殊 288.924902033|shu;
孰__孰 459.889800938|shu;
梳__梳 461.037428991|shu;
蜀__蜀 463.919044053|shu;
俞__俞 510.004074866|shu;
竖__豎 546.866130582|shu;
述__述 606.458230719|shu;
署__署 687.800394331|shu;
疏__疏 743.974797322|shu;
束__束 752.365812175|shu;
淑__淑 768.474582473|shu;
叔__叔 1178.31719254|shu;
鼠__鼠 1388.99614478|shu;
舒__舒 1693.37191801|shu;
术__術 2278.02623496|shu;
熟__熟 2735.99686654|shu;
属__屬 4306.3921008|shu;
输__輸 5263.16868825|shu;
树__樹 5939.41952983|shu;
数__數 13153.2071934|shu;
书__書 19044.4756445|shu;
蒴__蒴 6.63776089511|shuo;
妁__妁 6.96832712237|shuo;
搠__搠 10.2414235427|shuo;
槊__槊 23.9585719147|shuo;
铄__鑠 29.427912777|shuo;
数__數 66.3168613884|shuo;
烁__爍 92.9586993113|shuo;
朔__朔 263.144763849|shuo;
硕__碩 555.105417084|shuo;
说__說 338803.956511|shuo;
说__說 218.552335545|shui;
税__稅 2652.07324956|shui;
睡__睡 21225.293307|shui;
水__水 27608.8032103|shui;
谁__誰 41704.7814097|shui;
朊__朊 22.5393802113|ruan;
阮__阮 686.088301175|ruan;
软__軟 3419.72334588|ruan;
闰__閏 90.7835532804|run;
润__潤 1431.1656954|run;
蚺__蚺 10.2032074664|ran;
苒__苒 64.9267268136|ran;
髯__髯 67.6524011805|ran;
冉__冉 442.462509543|ran;
燃__燃 583.476802811|ran;
染__染 1276.14264248|ran;
然__然 4290.32271274|ran;
禳__禳 18.7198639824|rang;
穰__穰 20.502674854|rang;
攘__攘 52.2701982939|rang;
瓤__瓤 65.4955708419|rang;
壤__壤 96.8611776331|rang;
嚷__嚷 201.79873775|rang;
让__讓 97928.7158358|rang;
荛__蕘 8.50591515418|rao;
娆__嬈 43.0891222662|rao;
桡__橈 53.9915047583|rao;
扰__擾 358.437246895|rao;
饶__饒 730.197220308|rao;
绕__繞 1854.64242019|rao;
喏__喏 9.69499043963|re;
惹__惹 2129.77510916|re;
热__熱 12281.8979309|re;
饪__飪 6.79679960579|ren;
葚__葚 7.97220538164|ren;
衽__衽 17.4798020992|ren;
轫__軔 17.6109883889|ren;
纫__紉 19.9979952029|ren;
荏__荏 21.4434095627|ren;
稔__稔 38.326092568|ren;
妊__妊 43.1966486461|ren;
仞__仞 52.7939034044|ren;
壬__壬 139.200207879|ren;
韧__韌 230.582949765|ren;
刃__刃 557.184562398|ren;
仁__仁 2400.43116637|ren;
认__認 2412.42638506|ren;
忍__忍 2612.70921049|ren;
任__任 7851.87768189|ren;
人__人 250285.730087|ren;
扔__扔 2619.22907324|reng;
仍__仍 8751.01052505|reng;
日__日 70124.1475321|ri;
鞣__鞣 15.2216928117|rou;
蹂__蹂 15.9002907619|rou;
糅__糅 20.0478990282|rou;
揉__揉 902.494832488|rou;
柔__柔 1215.60448872|rou;
肉__肉 6416.50597079|rou;
狨__狨 5.3638404672|rong;
肜__肜 7.55625733548|rong;
蝾__蠑 19.0019043465|rong;
冗__冗 42.5024937354|rong;
嵘__嶸 60.7013758508|rong;
茸__茸 142.003528374|rong;
戎__戎 222.398727024|rong;
熔__熔 284.991389772|rong;
榕__榕 299.93080386|rong;
绒__絨 339.31275934|rong;
溶__溶 491.289575698|rong;
蓉__蓉 788.850627646|rong;
融__融 1118.23138914|rong;
容__容 2278.02623496|rong;
荣__榮 3233.23169914|rong;
颥__顬 1.62151419471|ru;
薷__薷 4.11338694315|ru;
蓐__蓐 11.1610062098|ru;
缛__縟 11.1888578468|ru;
铷__銣 11.9975657017|ru;
溽__溽 12.7688944861|ru;
洳__洳 17.876322025|ru;
襦__襦 22.6520119746|ru;
嚅__嚅 22.6802577484|ru;
蠕__蠕 26.3057791538|ru;
褥__褥 36.5079643999|ru;
孺__孺 57.606037042|ru;
濡__濡 93.6563563433|ru;
辱__辱 246.633556117|ru;
茹__茹 574.10053635|ru;
儒__儒 855.407364934|ru;
汝__汝 918.378206258|ru;
乳__乳 1092.0658276|ru;
入__入 10589.1792478|ru;
如__如 37936.2504684|ru;
箬__箬 38.6618798464|ruo;
偌__偌 38.7100890173|ruo;
弱__弱 3273.77524422|ruo;
若__若 11227.9081575|ruo;
枘__枘 4.22245308545|rui;
蚋__蚋 9.58686377111|rui;
蕤__蕤 27.7884364727|rui;
芮__芮 202.807148249|rui;
蕊__蕊 415.734739962|rui;
睿__睿 478.599545119|rui;
锐__銳 699.033618062|rui;
瑞__瑞 2391.47390956|rui;
躜__躦 7.28805843706|zuan;
缵__纘 10.872716946|zuan;
纂__纂 80.5474261484|zuan;
攥__攥 118.676811842|zuan;
赚__賺 586.392500602|zuan;
钻__鑽 2213.66066021|zuan;
撙__撙 2.84448344221|zun;
鳟__鱒 6.9596488351|zun;
樽__樽 146.862738669|zun;
遵__遵 256.987424161|zun;
尊__尊 1653.74860966|zun;
拶__拶 15.4125672823|za;
咂__咂 119.41857567|za;
扎__扎 135.604660605|za;
匝__匝 149.820373083|za;
杂__雜 2519.9747123|za;
砸__砸 6923.28164687|za;
咋__咋 12160.0639254|za;
甾__甾 28.8110446358|zai;
崽__崽 286.415523108|zai;
灾__災 552.345286903|zai;
栽__栽 643.039196578|zai;
哉__哉 712.223191016|zai;
宰__宰 836.433324055|zai;
仔__仔 1416.96881393|zai;
载__載 2159.17072182|zai;
再__再 120734.726214|zai;
在__在 974740.047532|zai;
糌__糌 2.31582041263|zan;
拶__拶 4.90353432967|zan;
趱__趲 12.5793690793|zan;
錾__鏨 17.5234219212|zan;
昝__昝 19.6521293817|zan;
瓒__瓚 60.3995526397|zan;
簪__簪 132.266710153|zan;
攒__攢 900.248315564|zan;
暂__暫 1055.93292173|zan;
赞__贊 3402.71958168|zan;
咱__咱 5532.16874554|zan;
奘__奘 6.47437036794|zang;
驵__駔 8.08223946949|zang;
赃__贓 81.3544462113|zang;
臧__臧 227.443722742|zang;
葬__葬 514.472385324|zang;
藏__藏 598.94764591|zang;
脏__臟 1786.58668154|zang;
唣__唣 4.23298996972|zao;
蚤__蚤 53.4559196785|zao;
躁__躁 178.377193209|zao;
凿__鑿 227.727332161|zao;
皂__皂 261.83633885|zao;
噪__噪 286.058823982|zao;
藻__藻 309.807805448|zao;
枣__棗 445.228026075|zao;
灶__灶 467.983588668|zao;
燥__燥 488.237949645|zao;
糟__糟 584.932834985|zao;
澡__澡 1029.9408079|zao;
遭__遭 3873.56899502|zao;
造__造 4835.54545696|zao;
早__早 25302.4954439|zao;
侧__側 3.555320751|ze;
迮__迮 4.36150241048|ze;
箦__簀 5.70157459376|ze;
舴__舴 6.49862009853|ze;
昃__昃 7.71804301441|ze;
帻__幘 7.97220538164|ze;
赜__賾 17.1347297758|ze;
咋__咋 19.5787970687|ze;
啧__嘖 125.835280772|ze;
仄__仄 152.837570606|ze;
择__擇 552.345286903|ze;
责__責 613.298247397|ze;
泽__澤 2235.83974961|ze;
则__則 28270.3016487|ze;
谮__譖 45.404425301|zen;
怎__怎 1920.49808867|zen;
锃__鋥 8.36922809722|zeng;
罾__罾 9.6829163922|zeng;
缯__繒 15.1648927612|zeng;
甑__甑 36.82782247|zeng;
综__綜 121.520271774|zeng;
憎__憎 139.373782642|zeng;
赠__贈 780.052703516|zeng;
增__增 2658.69134296|zeng;
曾__曾 5422.95707874|zeng;
贼__賊 3971.32436646|zei;
觜__觜 1.67491217207|zi;
锱__錙 5.56122858051|zi;
粢__粢 5.83818256844|zi;
嵫__嵫 5.91876241591|zi;
茈__茈 6.0004544437|zi;
辎__輜 7.18883657345|zi;
秭__秭 7.41632394291|zi;
孳__孳 8.39011301557|zi;
耔__耔 11.4569394415|zi;
赀__貲 12.1631586757|zi;
髭__髭 13.1401696537|zi;
龇__齜 15.4317858793|zi;
谘__諮 16.3626160731|zi;
笫__笫 18.5572776776|zi;
滓__滓 20.9155734372|zi;
鲻__鯔 22.9932955283|zi;
淄__淄 29.538134917|zi;
眦__眥 34.8194491124|zi;
訾__訾 36.1458125926|zi;
吱__吱 48.8076581499|zi;
趑__趑 57.3910789651|zi;
恣__恣 62.2332668667|zi;
呲__呲 65.332537323|zi;
咨__咨 67.6524011805|zi;
缁__緇 81.8629346395|zi;
姊__姊 93.890070293|zi;
孜__孜 122.890853693|zi;
渍__漬 190.556205829|zi;
滋__滋 317.626273928|zi;
籽__籽 341.859308876|zi;
梓__梓 400.479435488|zi;
姿__姿 597.456727653|zi;
兹__茲 955.740681497|zi;
仔__仔 1140.75119008|zi;
资__資 1203.54593192|zi;
紫__紫 3099.10234274|zi;
自__自 14405.870183|zi;
字__字 16750.3963294|zi;
子__子 19769.9293101|zi;
楱__楱 2.72648115568|zou;
鲰__鯫 2.729880923|zou;
鄹__鄹 6.57191561603|zou;
陬__陬 15.7818476567|zou;
驺__騶 23.1081955564|zou;
诹__諏 28.4897196905|zou;
奏__奏 643.039196578|zou;
揍__揍 786.88699725|zou;
邹__鄒 1334.69654755|zou;
走__走 48130.926341|zou;
枞__樅 9.30438513268|zong;
偬__傯 10.4868049027|zong;
腙__腙 19.1922880593|zong;
鬃__鬃 72.9955881896|zong;
综__綜 121.520271774|zong;
粽__粽 235.226605969|zong;
棕__棕 290.0070692|zong;
踪__蹤 305.97104031|zong;
纵__縱 840.61307342|zong;
宗__宗 2593.24683736|zong;
总__總 28517.9868942|zong;
菹__菹 13.6407129304|zu;
镞__鏃 17.0282980696|zu;
诅__詛 19.1922880593|zu;
俎__俎 41.0450436324|zu;
卒__卒 365.655730945|zu;
阻__阻 638.24912322|zu;
祖__祖 1615.05244942|zu;
族__族 2300.85021536|zu;
足__足 3449.68464686|zu;
租__租 4253.06027768|zu;
组__組 22421.6021593|zu;
撮__撮 1.8184922381|zuo;
胙__胙 5.88199825382|zuo;
笮__笮 6.26015451283|zuo;
阼__阼 6.53923832253|zuo;
柞__柞 7.15309178664|zuo;
怍__怍 11.5861579976|zuo;
酢__酢 14.125074907|zuo;
凿__鑿 27.8577808878|zuo;
嘬__嘬 67.1484506185|zuo;
祚__祚 84.0335241323|zuo;
琢__琢 100.425647013|zuo;
唑__唑 187.961915178|zuo;
昨__昨 917.234466913|zuo;
佐__佐 1852.33266643|zuo;
座__座 4409.57193181|zuo;
左__左 7716.07926336|zuo;
坐__坐 11583.2100573|zuo;
作__作 19307.3315803|zuo;
做__做 154137.401791|zuo;
觜__觜 16.281256841|zui;
蕞__蕞 26.9360575363|zui;
咀__咀 96.7405476583|zui;
醉__醉 2491.86983978|zui;
罪__罪 2567.52234013|zui;
嘴__嘴 4583.25194611|zui;
最__最 65806.1116856|zui;
镩__鑹 5.15415350867|cuan;
撺__攛 8.25528685814|cuan;
汆__汆 33.7514017959|cuan;
爨__爨 34.0047067903|cuan;
篡__篡 70.4925014722|cuan;
攒__攢 100.175664512|cuan;
蹿__躥 166.146325956|cuan;
窜__竄 581.299547476|cuan;
蹲__蹲 1.46948683602|cun;
皴__皴 31.0865410961|cun;
忖__忖 44.0116957825|cun;
寸__寸 3068.35985866|cun;
存__存 4982.35132078|cun;
村__村 11088.8579276|cun;
嚓__嚓 7.53744807544|ca;
礤__礤 16.6921389789|ca;
拆__拆 72.2714863498|ca;
擦__擦 2753.09762515|ca;
睬__睬 218.280152578|cai;
裁__裁 526.142915167|cai;
材__材 1005.84116282|cai;
财__財 1906.19207626|cai;
彩__彩 2127.12270781|cai;
采__采 2263.87636378|cai;
蔡__蔡 2526.26316155|cai;
踩__踩 3453.98620792|cai;
猜__猜 3859.11469501|cai;
菜__菜 7620.52071577|cai;
才__才 69949.5924227|cai;
黪__黲 6.03043937487|can;
孱__孱 9.38590385664|can;
骖__驂 15.2406733992|can;
粲__粲 55.3540620301|can;
璨__璨 57.4626423848|can;
惭__慚 69.7063099449|can;
蚕__蠶 308.651751439|can;
灿__燦 468.567137655|can;
参__參 1023.54337071|can;
餐__餐 1272.96603034|can;
残__殘 1738.27154577|can;
惨__慘 3630.51911858|can;
臧__臧 3.3198052713|cang;
伧__傖 5.41083480633|cang;
沧__滄 418.854838101|cang;
舱__艙 587.855808729|cang;
苍__蒼 867.213880777|cang;
仓__倉 2113.91016801|cang;
藏__藏 2119.18530697|cang;
艚__艚 4.50513075969|cao;
螬__螬 9.31598717311|cao;
漕__漕 75.3994011064|cao;
嘈__嘈 84.0335241323|cao;
糙__糙 215.576896995|cao;
槽__槽 997.105202031|cao;
曹__曹 2791.09646881|cao;
操__操 7451.48771757|cao;
草__草 7871.47158259|cao;
恻__惻 31.8313650651|ce;
厕__廁 148.334184528|ce;
策__策 914.951259653|ce;
册__冊 1123.81931445|ce;
侧__側 2221.95191814|ce;
测__測 3189.2134908|ce;
参__參 12.5012328185|cen;
涔__涔 105.821807183|cen;
岑__岑 332.614317243|cen;
噌__噌 105.821807183|ceng;
蹭__蹭 1002.08784645|ceng;
层__層 6480.79417092|ceng;
曾__曾 8019.99283537|ceng;
茈__茈 4.86700733523|ci;
伺__伺 12.2697240382|ci;
鹚__鶿 18.0554283133|ci;
糍__糍 23.720907606|ci;
差__差 47.7250412134|ci;
疵__疵 53.4559196785|ci;
兹__茲 69.1008946834|ci;
祠__祠 301.429591092|ci;
雌__雌 341.433560596|ci;
茨__茨 456.464028614|ci;
慈__慈 496.21189989|ci;
瓷__瓷 530.752623218|ci;
磁__磁 544.825488702|ci;
赐__賜 610.248767154|ci;
辞__辭 1044.15627174|ci;
刺__刺 1445.50481813|ci;
词__詞 5362.47571095|ci;
此__此 17237.4397622|ci;
次__次 21278.2597828|ci;
楱__楱 1.76051677587|cou;
辏__輳 5.92614277687|cou;
腠__腠 27.7884364727|cou;
凑__湊 1847.72178498|cou;
苁__蓯 10.6979962189|cong;
枞__樅 11.3574332994|cong;
囱__囪 13.7430867735|cong;
淙__淙 23.6618608187|cong;
骢__驄 32.0303201505|cong;
匆__匆 39.0492406125|cong;
璁__璁 46.3765713579|cong;
琮__琮 59.8749686961|cong;
丛__叢 550.970372621|cong;
聪__聰 734.761160623|cong;
葱__蔥 869.377962205|cong;
从__從 126905.466731|cong;
酢__酢 4.07766123576|cu;
卒__卒 7.50932193752|cu;
殂__殂 14.3557670206|cu;
蔟__蔟 15.4702949968|cu;
徂__徂 20.5282405264|cu;
猝__猝 37.7572282633|cu;
蹴__蹴 40.184657102|cu;
蹙__蹙 109.716025699|cu;
簇__簇 276.938965124|cu;
醋__醋 1082.58098585|cu;
促__促 1409.92327219|cu;
粗__粗 2172.66615296|cu;
瘥__瘥 4.86700733523|cuo;
脞__脞 5.41083480633|cuo;
嵯__嵯 8.25528685814|cuo;
蹉__蹉 15.2027358626|cuo;
鹾__鹺 16.3626160731|cuo;
痤__痤 34.9934457312|cuo;
矬__矬 37.8514492141|cuo;
磋__磋 40.4358226384|cuo;
锉__銼 61.0807767149|cuo;
厝__厝 65.0887476561|cuo;
挫__挫 401.979429753|cuo;
措__措 545.504855178|cuo;
搓__搓 724.757896749|cuo;
撮__撮 1029.9408079|cuo;
错__錯 22088.8041027|cuo;
榱__榱 5.49920509291|cui;
衰__衰 7.52806101043|cui;
毳__毳 8.0923175636|cui;
悴__悴 17.0920774979|cui;
瘁__瘁 17.3928879243|cui;
璀__璀 48.2032075261|cui;
啐__啐 71.6437919439|cui;
淬__淬 78.271560621|cui;
萃__萃 124.742372548|cui;
粹__粹 139.026849285|cui;
摧__摧 182.651055928|cui;
脆__脆 583.476802811|cui;
翠__翠 1136.49445424|cui;
崔__崔 1836.24473312|cui;
催__催 2436.59694626|cui;
狻__狻 6.85634856286|suan;
蒜__蒜 453.063775264|suan;
酸__酸 2875.83340941|suan;
算__算 29938.2072796|suan;
狲__猻 5.83091175227|sun;
飧__飧 15.6252948403|sun;
榫__榫 35.9212942863|sun;
荪__蓀 75.4934198822|sun;
隼__隼 86.4769275755|sun;
笋__筍 313.302012384|sun;
损__損 1081.23274995|sun;
孙__孫 5484.12059337|sun;
挲__挲 1.68748242385|sa;
脎__脎 2.97129329555|sa;
飒__颯 92.7273037579|sa;
卅__卅 153.792848894|sa;
仨__仨 328.086003878|sa;
洒__灑 828.13607043|sa;
萨__薩 1956.73461434|sa;
撒__撒 18028.3540204|sa;
鳃__鰓 88.1085998092|sai;
腮__腮 209.746993999|sai;
噻__噻 1027.37704867|sai;
塞__塞 2504.32198759|sai;
赛__賽 4086.79670599|sai;
毵__毿 5.23833165103|san;
馓__饊 5.49920509291|san;
糁__糝 8.77508085903|san;
彡__彡 87.9988702102|san;
叁__叄 445.783200166|san;
伞__傘 1190.12297778|san;
散__散 3585.55753613|san;
三__三 26761.9343215|san;
磉__磉 2.63955804324|sang;
颡__顙 7.65101004374|sang;
搡__搡 29.3546599431|sang;
嗓__嗓 99.6775647522|sang;
丧__喪 421.472799973|sang;
桑__桑 1415.20413466|sang;
缲__繰 1.89719670363|sao;
鳋__鰠 5.49920509291|sao;
埽__埽 8.20400946554|sao;
缫__繅 8.80794789238|sao;
瘙__瘙 21.9298417958|sao;
臊__臊 61.3860040777|sao;
搔__搔 141.650048976|sao;
嫂__嫂 451.935995467|sao;
骚__騷 1022.26865969|sao;
扫__掃 2033.8046114|sao;
穑__穡 11.3999725243|se;
铯__銫 20.072897621|se;
啬__嗇 28.3480613086|se;
塞__塞 320.808632296|se;
涩__澀 553.723632203|se;
瑟__瑟 574.10053635|se;
色__色 7601.55148942|se;
森__森 2095.55037421|sen;
僧__僧 792.79260104|seng;
蛳__螄 4.88523669345|si;
鸶__鷥 5.80915358869|si;
缌__緦 7.05570740041|si;
澌__澌 7.48130075284|si;
咝__噝 8.74233646968|si;
兕__兕 15.2596776543|si;
笥__笥 17.1133903489|si;
耜__耜 18.6500104363|si;
汜__汜 23.9287341406|si;
姒__姒 29.611845602|si;
驷__駟 43.4125070529|si;
锶__鍶 48.1431757172|si;
伺__伺 66.4823512304|si;
俟__俟 66.8978848349|si;
嘶__嘶 87.8892772674|si;
厶__厶 89.6592589076|si;
厮__廝 96.4997382157|si;
泗__泗 133.925286409|si;
食__食 138.163289429|si;
祀__祀 147.412812521|si;
饲__飼 154.947067523|si;
嗣__嗣 210.532600599|si;
巳__巳 229.150692759|si;
肆__肆 324.426913464|si;
撕__撕 631.130833438|si;
私__私 1220.1575309|si;
寺__寺 2001.12208851|si;
丝__絲 2479.47960733|si;
司__司 2981.66342698|si;
似__似 3298.34499764|si;
斯__斯 4076.62373033|si;
思__思 4404.08029353|si;
四__四 15010.6397905|si;
死__死 36726.8025477|si;
锼__鎪 3.10762666438|sou;
嗾__嗾 5.5890186517|sou;
瞍__瞍 5.96318285478|sou;
飕__颼 8.66640727583|sou;
螋__螋 8.96296255118|sou;
溲__溲 13.5222402155|sou;
擞__擻 14.2310838972|sou;
薮__藪 24.4410680021|sou;
嗽__嗽 55.4230854052|sou;
嗖__嗖 83.3036737352|sou;
馊__餿 86.3692300453|sou;
叟__叟 112.906187218|sou;
艘__艘 630.344829195|sou;
搜__搜 2944.7374939|sou;
忪__忪 11.272830465|song;
凇__凇 22.511309885|song;
竦__竦 23.8989335263|song;
悚__悚 24.5632027085|song;
菘__菘 31.7521294864|song;
崧__崧 48.3234958062|song;
淞__淞 77.0137642439|song;
讼__訟 100.550872098|song;
怂__慫 123.658956482|song;
嵩__嵩 182.651055928|song;
耸__聳 235.813600182|song;
诵__誦 239.068350048|song;
颂__頌 482.191444969|song;
松__松 3941.74151187|song;
宋__宋 4081.70704886|song;
送__送 19211.330448|song;
觫__觫 4.83075243461|su;
缩__縮 6.53923832253|su;
蔌__蔌 8.77508085903|su;
嗉__嗉 8.82992761027|su;
簌__簌 13.371428846|su;
涑__涑 14.1074836752|su;
僳__僳 15.0519277209|su;
谡__謖 16.3830193271|su;
稣__穌 18.8134092027|su;
愫__愫 20.7856571679|su;
夙__夙 62.7785126223|su;
溯__溯 135.94305409|su;
肃__肅 249.415244207|su;
粟__粟 262.489736092|su;
塑__塑 439.166555128|su;
酥__酥 470.32215416|su;
宿__宿 664.215078095|su;
诉__訴 884.6784987|su;
俗__俗 1370.08592511|su;
速__速 1820.2965272|su;
苏__蘇 4634.94473906|su;
素__素 4957.57775917|su;
唢__嗩 5.05240431744|suo;
睃__睃 6.92504363002|suo;
桫__桫 7.29714623248|suo;
挲__挲 7.84409485251|suo;
嗍__嗍 11.272830465|suo;
羧__羧 35.7872532598|suo;
蓑__蓑 51.2383216931|suo;
娑__娑 66.3168613884|suo;
琐__瑣 131.773154284|suo;
梭__梭 204.839111844|suo;
莎__莎 341.433560596|suo;
唆__唆 359.331706043|suo;
嗦__嗦 443.014235191|suo;
缩__縮 956.932435908|suo;
索__索 2303.71924505|suo;
锁__鎖 3122.36117229|suo;
所__所 44055.3637296|suo;
荽__荽 5.78747661614|sui;
谇__誶 6.89061049113|sui;
尿__尿 7.19780064483|sui;
濉__濉 9.15486694475|sui;
眭__眭 20.0979273856|sui;
燧__燧 28.9550165963|sui;
邃__邃 32.7977567756|sui;
祟__祟 43.0354594896|sui;
隧__隧 47.7250412134|sui;
睢__睢 53.9915047583|sui;
绥__綏 129.332863581|sui;
髓__髓 316.441045148|sui;
隋__隋 339.735863102|sui;
穗__穗 736.594714048|sui;
碎__碎 1392.46230328|sui;
遂__遂 1593.06462986|sui;
虽__雖 4041.21731986|sui;
随__隨 5721.47369896|sui;
岁__歲 10074.2835612|sui;
眢__眢 5.29081549739|yuan;
箢__箢 6.30713710671|yuan;
螈__螈 7.48130075284|yuan;
橼__櫞 10.8186549367|yuan;
圜__圜 14.2133606428|yuan;
掾__掾 18.3046332058|yuan;
芫__芫 19.3122453184|yuan;
鼋__黿 21.8752533827|yuan;
垸__垸 32.3512380521|yuan;
爰__爰 37.2896299182|yuan;
瑗__瑗 37.9932216791|yuan;
辕__轅 54.0588291018|yuan;
塬__塬 60.3243316203|yuan;
鸳__鴛 63.803817469|yuan;
鸢__鳶 104.381116633|yuan;
沅__沅 115.755545596|yuan;
垣__垣 173.769702743|yuan;
猿__猿 213.704562287|yuan;
援__援 373.484720623|yuan;
渊__淵 454.194369369|yuan;
冤__冤 472.083744072|yuan;
媛__媛 504.944935018|yuan;
怨__怨 968.932019286|yuan;
苑__苑 1349.75009317|yuan;
缘__緣 2061.87561868|yuan;
袁__袁 2210.90378861|yuan;
圆__圓 2854.41099368|yuan;
愿__願 3339.70503971|yuan;
院__院 3519.15704076|yuan;
园__園 3927.03282475|yuan;
员__員 4026.13743678|yuan;
源__源 4426.08796739|yuan;
原__原 11213.9250292|yuan;
远__遠 12498.0520499|yuan;
元__元 30885.5878399|yuan;
钥__鑰 8.74233646968|yue;
刖__刖 12.1631586757|yue;
龠__龠 15.8409585096|yue;
哕__噦 18.9074218788|yue;
樾__樾 35.1245135546|yue;
瀹__瀹 61.2332002144|yue;
钺__鉞 75.8706688089|yue;
栎__櫟 90.4447926395|yue;
说__說 218.552335545|yue;
乐__樂 343.139741671|yue;
阅__閱 633.494731672|yue;
跃__躍 657.626195507|yue;
粤__粵 869.377962205|yue;
悦__悅 974.988119996|yue;
岳__岳 1265.05905145|yue;
曰__曰 2224.72256613|yue;
约__約 11468.3068978|yue;
越__越 14156.7203022|yue;
月__月 65397.3595875|yue;
员__員 0.716857183094|yun;
狁__狁 4.28607011852|yun;
纭__紜 13.7773818413|yun;
郓__鄆 14.4454946476|yun;
氲__氳 20.4007301604|yun;
郧__鄖 27.9969892844|yun;
酝__醞 33.0439046436|yun;
殒__殞 39.0979328003|yun;
恽__惲 41.4046525194|yun;
愠__慍 43.4125070529|yun;
韫__韞 44.1765414285|yun;
熨__熨 52.991642777|yun;
陨__隕 64.122652166|yun;
筠__筠 75.0244954467|yun;
耘__耘 84.6641975332|yun;
昀__昀 100.050906707|yun;
蕴__蘊 328.495108513|yun;
匀__勻 343.139741671|yun;
允__允 476.219822262|yun;
孕__孕 578.409173188|yun;
芸__芸 743.974797322|yun;
韵__韻 1115.44785438|yun;
运__運 3011.53728293|yun;
云__雲 8398.43759849|yun;
晕__暈 35555.91311|yun;
疋__疋 2.25038696433|ya;
揠__揠 4.44933768948|ya;
岈__岈 5.76588053165|ya;
迓__迓 5.92614277687|ya;
砑__砑 7.58455926976|ya;
睚__睚 8.37966404988|ya;
痖__瘂 11.7168339616|ya;
琊__琊 11.8637587817|ya;
讶__訝 29.8712845475|ya;
桠__椏 30.5869913432|ya;
氩__氬 36.3717342021|ya;
垭__埡 39.5389038333|ya;
蚜__蚜 60.9287326326|ya;
轧__軋 65.5772401032|ya;
衙__衙 79.8478533105|ya;
伢__伢 85.93977951|ya;
鸦__鴉 232.024158785|ya;
吖__吖 261.510250403|ya;
涯__涯 312.132919672|ya;
哑__啞 382.433299725|ya;
崖__崖 523.526794166|ya;
娅__婭 542.792461517|ya;
芽__芽 600.442284667|ya;
鸭__鴨 1296.98472971|ya;
押__押 2635.59999992|ya;
雅__雅 2996.56312723|ya;
牙__牙 3233.23169914|ya;
亚__亞 4107.21887886|ya;
压__壓 4148.36989009|ya;
丫__丫 5309.28100941|ya;
呀__呀 79232.8925525|ya;
阽__阽 1.21743003707|yan;
殷__殷 2.30430554425|yan;
埏__埏 2.67932659672|yan;
铅__鉛 4.16496731365|yan;
罨__罨 6.27577636162|yan;
鼹__鼴 6.51483702422|yan;
菸__菸 8.01204336922|yan;
餍__饜 9.13207837822|yan;
剡__剡 10.5918742061|yan;
唁__唁 10.7514552832|yan;
崦__崦 11.0778665835|yan;
赝__贗 17.5890558341|yan;
兖__兗 19.1206716533|yan;
厣__厴 20.1480805858|yan;
芫__芫 20.2235451481|yan;
阏__閼 26.1749798989|yan;
胭__胭 27.3759798789|yan;
郾__郾 29.611845602|yan;
酽__釅 30.24585955|yan;
谳__讞 31.6730911433|yan;
湮__湮 31.6730911433|yan;
俨__儼 40.4358226384|yan;
魇__魘 41.5597334944|yan;
奄__奄 41.9761284103|yan;
滟__灧 50.2894455676|yan;
蜒__蜒 50.5407474611|yan;
谚__諺 52.0102971158|yan;
恹__懨 53.7900343808|yan;
偃__偃 78.4668827144|yan;
腌__腌 80.2468618202|yan;
筵__筵 82.0672187964|yan;
鄢__鄢 94.1243674622|yan;
琰__琰 126.149295342|yan;
阉__閹 172.475272126|yan;
檐__檐 187.26053154|yan;
堰__堰 191.031727675|yan;
焱__焱 199.548108896|yan;
砚__硯 239.366454718|yan;
衍__衍 278.322859608|yan;
淹__淹 292.183578474|yan;
嫣__嫣 301.429591092|yan;
晏__晏 311.744192349|yan;
焰__焰 317.626273928|yan;
厌__厭 325.236501817|yan;
掩__掩 358.437246895|yan;
闫__閆 508.100984482|yan;
宴__宴 533.404852483|yan;
咽__咽 542.11647303|yan;
阎__閻 583.476802811|yan;
焉__焉 601.940653207|yan;
验__驗 720.256091319|yan;
雁__雁 926.424414408|yan;
彦__彥 946.259922413|yan;
妍__妍 1097.52300072|yan;
延__延 1233.91923358|yan;
研__研 1354.80557722|yan;
艳__艷 1481.9843182|yan;
炎__炎 1493.10664229|yan;
颜__顏 1613.0410787|yan;
沿__沿 1672.40062475|yan;
岩__岩 2003.61737423|yan;
盐__鹽 2175.37534439|yan;
燕__燕 2261.05695403|yan;
严__嚴 2385.52098173|yan;
言__言 4470.43378899|yan;
演__演 4606.15496045|yan;
烟__煙 4763.7727032|yan;
眼__眼 6142.66017363|yan;
怏__怏 7.98214626949|yang;
蛘__蛘 8.41105005101|yang;
烊__烊 12.657993714|yang;
鸯__鴦 18.2363291016|yang;
徉__徉 24.6552040947|yang;
疡__瘍 25.2774154551|yang;
泱__泱 35.2560722919|yang;
鞅__鞅 38.5656415475|yang;
炀__煬 41.2501502322|yang;
恙__恙 57.2482193879|yang;
殃__殃 58.7661515758|yang;
佯__佯 97.3452035967|yang;
秧__秧 139.026849285|yang;
漾__漾 216.654158472|yang;
仰__仰 425.165459331|yang;
央__央 435.352293046|yang;
氧__氧 762.750126416|yang;
痒__癢 1000.83985593|yang;
扬__揚 1930.09502896|yang;
洋__洋 3567.72920071|yang;
羊__羊 3912.37902339|yang;
阳__陽 6013.89768231|yang;
养__養 7053.91217164|yang;
杨__楊 10328.5233418|yang;
样__樣 14677.6844003|yang;
陶__陶 1.16257102114|yao;
约__約 2.11181484727|yao;
轺__軺 2.69271548656|yao;
铫__銚 2.97499832973|yao;
么__么 3.37402465772|yao;
疟__瘧 4.66510143358|yao;
珧__珧 8.94065167877|yao;
崾__崾 11.0090568469|yao;
繇__繇 15.3742018624|yao;
徭__徭 15.4125672823|yao;
窈__窈 20.6051289764|yao;
鳐__鰩 21.523725775|yao;
侥__僥 25.3720919224|yao;
鹞__鷂 28.3480613086|yao;
肴__餚 58.2557540945|yao;
杳__杳 71.8225748289|yao;
吆__吆 81.0508704717|yao;
钥__鑰 85.4059679188|yao;
夭__夭 118.972962872|yao;
舀__舀 127.254530072|yao;
谣__謠 176.827946446|yao;
爻__爻 198.803491145|yao;
曜__曜 205.094534596|yao;
幺__幺 491.289575698|yao;
窑__窯 559.271495144|yao;
瑶__瑤 672.544092675|yao;
遥__遙 721.154209805|yao;
尧__堯 737.513205869|yao;
邀__邀 910.401881269|yao;
耀__耀 1004.58849796|yao;
摇__搖 1097.52300072|yao;
妖__妖 1653.74860966|yao;
姚__姚 2108.64816008|yao;
腰__腰 2606.20557717|yao;
咬__咬 3558.84830329|yao;
药__葯 7930.54714563|yao;
要__要 396900.168349|yao;
拽__拽 2.89093982573|ye;
邪__邪 10.764861738|ye;
铘__鋣 14.8285158408|ye;
揶__揶 32.6346776999|ye;
靥__靨 35.2560722919|ye;
邺__鄴 45.2349977818|ye;
腋__腋 51.6228663963|ye;
谒__謁 69.3597118323|ye;
咽__咽 70.8447602593|ye;
掖__掖 80.8491162392|ye;
曳__曳 107.14877401|ye;
噎__噎 143.784200776|ye;
晔__曄 163.069482749|ye;
烨__燁 280.411678639|ye;
椰__椰 287.846772995|ye;
冶__冶 326.861744407|ye;
爷__爺 1348.06912745|ye;
液__液 1859.27057168|ye;
耶__耶 3149.7171872|ye;
野__野 4734.18271471|ye;
夜__夜 5146.42480465|ye;
业__業 5470.46935761|ye;
叶__葉 6660.92739064|ye;
页__頁 24679.6667319|ye;
也__也 404388.998057|ye;
蛇__蛇 1.09780232158|yi;
嗌__嗌 1.23577228632|yi;
酏__酏 2.95651924355|yi;
仡__仡 3.64050514333|yi;
眙__眙 4.37238628419|yi;
蜴__蜴 7.21576233461|yi;
肄__肄 8.07217392654|yi;
癔__癔 8.20400946554|yi;
黟__黟 9.0866712819|yi;
舣__艤 10.3957246011|yi;
痍__痍 10.9134406676|yi;
劓__劓 11.9379106485|yi;
荑__荑 12.1480107954|yi;
佾__佾 13.6237249183|yi;
殪__殪 14.1779803236|yi;
瘗__瘞 15.2787056066|yi;
峄__嶧 17.7210620753|yi;
钇__釔 17.7874362487|yi;
呓__囈 20.1732040993|yi;
旖__旖 22.511309885|yi;
镒__鎰 22.6520119746|yi;
饴__飴 23.6029610125|yi;
怿__懌 23.9884468947|yi;
缢__縊 24.5938316288|yi;
悒__悒 24.9643713526|yi;
艾__艾 25.7864714248|yi;
铱__銥 26.1749798989|yi;
圯__圯 26.6688571574|yi;
猗__猗 26.7021117094|yi;
迤__迤 27.3078347773|yi;
嶷__嶷 28.0668541308|yi;
埸__埸 28.9911218594|yi;
薏__薏 29.611845602|yi;
臆__臆 32.1102499377|yi;
挹__挹 35.65371241|yi;
噫__噫 38.1355251523|yi;
镱__鐿 39.4896624644|yi;
苡__苡 40.9428730916|yi;
诒__詒 42.5024937354|yi;
刈__刈 49.1127198955|yi;
绎__繹 50.3521536533|yi;
翳__翳 58.1832029411|yi;
熠__熠 61.9238266904|yi;
翌__翌 63.3285354522|yi;
诣__詣 70.6684113793|yi;
咿__咿 72.1814801389|yi;
羿__羿 73.9109262154|yi;
屹__屹 74.5584837171|yi;
揖__揖 81.5574614651|yi;
佚__佚 83.1999281447|yi;
沂__沂 100.050906707|yi;
弈__弈 122.890853693|yi;
胰__胰 139.026849285|yi;
彝__彝 139.547573842|yi;
疫__疫 148.704343794|yi;
漪__漪 149.261315371|yi;
翊__翊 160.249192015|yi;
贻__貽 164.088713397|yi;
轶__軼 164.703307075|yi;
弋__弋 175.292155245|yi;
谊__誼 181.290467084|yi;
驿__驛 217.736803143|yi;
懿__懿 239.366454718|yi;
蚁__蟻 249.415244207|yi;
邑__邑 283.221176861|yi;
役__役 296.585723861|yi;
裔__裔 299.1842072|yi;
椅__椅 318.022335873|yi;
颐__頤 359.331706043|yi;
抑__抑 382.910172354|yi;
溢__溢 401.478808454|yi;
奕__奕 410.586139672|yi;
夷__夷 424.635962376|yi;
遗__遺 504.316081474|yi;
咦__咦 593.006203378|yi;
姨__姨 605.702953498|yi;
议__議 618.67155147|yi;
倚__倚 622.538424634|yi;
忆__憶 765.607004232|yi;
毅__毅 784.92825478|yi;
疑__疑 784.92825478|yi;
壹__壹 785.907015785|yi;
尾__尾 859.681929668|yi;
怡__怡 1103.00744393|yi;
移__移 1116.83875458|yi;
译__譯 1129.43516323|yi;
翼__翼 1166.62851836|yi;
艺__藝 1221.67899812|yi;
异__異 1249.39213028|yi;
逸__逸 1266.63650832|yi;
矣__矣 1276.14264248|yi;
医__醫 1390.72814418|yi;
益__益 1504.31243966|yi;
乙__乙 1670.31783317|yi;
仪__儀 1797.75335645|yi;
宜__宜 2457.94475925|yi;
义__義 2504.32198759|yi;
衣__衣 2516.83636014|yi;
依__依 3390.02226565|yi;
意__意 3694.41410176|yi;
伊__伊 3849.50847217|yi;
亦__亦 5497.80589498|yi;
易__易 6119.7387146|yi;
亿__億 8567.57177296|yi;
已__已 43347.4095704|yi;
以__以 100400.095074|yi;
一__一 134392.699983|yi;
夤__夤 5.83818256844|yin;
湮__湮 6.36239597244|yin;
狺__狺 7.00314861982|yin;
堙__堙 8.59113754441|yin;
吲__吲 8.91839634324|yin;
窨__窨 9.76775155081|yin;
茚__茚 13.3547761977|yin;
氤__氤 13.5053997481|yin;
鄞__鄞 17.6109883889|yin;
夂__夂 17.7874362487|yin;
霪__霪 20.3499480574|yin;
喑__喑 21.5774369716|yin;
蚓__蚓 25.4354064912|yin;
洇__洇 29.4646077148|yin;
姻__姻 30.9705410476|yin;
龈__齦 32.1102499377|yin;
铟__銦 39.293309473|yin;
垠__垠 39.8853169429|yin;
寅__寅 273.850309404|yin;
荫__蔭 304.449671797|yin;
茵__茵 348.743933702|yin;
胤__胤 354.43965395|yin;
瘾__癮 533.404852483|yin;
吟__吟 719.359091341|yin;
殷__殷 984.756712384|yin;
淫__淫 1150.74567978|yin;
隐__隱 1272.96603034|yin;
尹__尹 1459.98760728|yin;
饮__飲 2026.2154289|yin;
阴__陰 2194.43451055|yin;
印__印 3118.47261385|yin;
音__音 3290.13465937|yin;
银__銀 4061.41172752|yin;
引__引 4195.15781018|yin;
因__因 19893.4969914|yin;
荥__滎 7.37025773577|ying;
媵__媵 10.1019936604|ying;
撄__攖 10.1145902734|ying;
嘤__嚶 11.8047690518|ying;
潆__瀠 14.6084200055|ying;
鹦__鸚 15.2596776543|ying;
罂__罌 16.5471639301|ying;
蓥__鎣 19.1683861691|ying;
瘿__癭 26.6024722466|ying;
茔__塋 28.1719784305|ying;
膺__膺 42.1858877432|ying;
璎__瓔 48.1431757172|ying;
楹__楹 52.7939034044|ying;
荧__熒 62.0010421893|ying;
颍__潁 79.9474190538|ying;
郢__郢 87.2345798746|ying;
萤__螢 89.7710589171|ying;
嬴__嬴 95.5424798428|ying;
萦__縈 99.8018570208|ying;
缨__纓 103.603569621|ying;
滢__瀅 114.321989585|ying;
瀛__瀛 131.937467932|ying;
莺__鶯 216.924313917|ying;
蝇__蠅 240.562595233|ying;
婴__嬰 328.086003878|ying;
瑛__瑛 364.291279287|ying;
樱__櫻 548.914415679|ying;
莹__瑩 824.018360007|ying;
映__映 921.81798848|ying;
颖__穎 949.804135501|ying;
盈__盈 994.623178167|ying;
鹰__鷹 1133.66545852|ying;
迎__迎 1368.37963334|ying;
营__營 1701.83388383|ying;
影__影 3209.14698221|ying;
硬__硬 4526.49139658|ying;
英__英 4588.96700128|ying;
赢__贏 5076.35979838|ying;
应__應 20243.6107394|ying;
唷__唷 254.438159592|yo;
哟__喲 7696.87216983|yo;
蝣__蝣 3.44197335275|you;
蝤__蝤 4.78879624368|you;
繇__繇 7.98214626949|you;
蚰__蚰 9.29279754133|you;
莸__蕕 10.3311519629|you;
莠__莠 14.391590996|you;
鱿__魷 17.3279860159|you;
黝__黝 17.6769502816|you;
牖__牖 18.4650060106|you;
卣__卣 19.9482155997|you;
铕__銪 29.538134917|you;
蚴__蚴 31.164115738|you;
莜__莜 41.6115561244|you;
宥__宥 53.7900343808|you;
猷__猷 58.7661515758|you;
侑__侑 71.5545674575|you;
尢__尢 79.649093664|you;
鼬__鼬 85.72585566|you;
囿__囿 102.575842641|you;
攸__攸 104.511273964|you;
柚__柚 122.584950132|you;
疣__疣 134.259489114|you;
酉__酉 134.762357541|you;
釉__釉 220.742053181|you;
铀__鈾 230.295783987|you;
诱__誘 384.823616623|you;
呦__呦 409.054029297|you;
悠__悠 503.060722916|you;
佑__佑 608.72971781|you;
邮__郵 736.594714048|you;
犹__猶 800.735741689|you;
幼__幼 825.045864155|you;
忧__憂 880.279644448|you;
尤__尤 1339.6956486|you;
幽__幽 1647.57761372|you;
优__優 1968.96476223|you;
右__右 3635.04616996|you;
友__友 4041.21731986|you;
游__游 5120.83542651|you;
油__油 5961.66560402|you;
由__由 46538.4305526|you;
又__又 132893.839823|you;
有__有 613906.755543|you;
喁__喁 2.62970847973|yong;
恿__恿 9.35088016908|yong;
臃__臃 11.8637587817|yong;
饔__饔 13.6067580629|yong;
鳙__鱅 19.6766344722|yong;
踊__踴 21.523725775|yong;
墉__墉 36.23601235|yong;
邕__邕 39.0979328003|yong;
痈__癰 50.6037689061|yong;
壅__壅 56.1180706617|yong;
镛__鏞 57.606037042|yong;
慵__慵 59.2071928037|yong;
俑__俑 80.2468618202|yong;
甬__甬 98.5658769099|yong;
佣__佣 103.991616413|yong;
蛹__蛹 109.579386421|yong;
庸__庸 285.346757867|yong;
雍__雍 301.054193591|yong;
泳__泳 372.555031371|yong;
咏__詠 569.114341748|yong;
涌__涌 736.594714048|yong;
拥__擁 801.734213733|yong;
勇__勇 1939.73992621|yong;
永__永 2712.23410734|yong;
用__用 168186.936456|yong;
菸__菸 1.06678394422|yu;
蓣__蕷 2.39805184425|yu;
谷__谷 2.53005700699|yu;
喁__喁 2.62970847973|yu;
丿__丿 2.67598978926|yu;
蔚__蔚 2.8873394772|yu;
伛__傴 4.22771824491|yu;
蝓__蝓 4.86700733523|yu;
蜮__蜮 5.64501609817|yu;
窬__窬 5.71580253909|yu;
尉__尉 6.67093051674|yu;
舁__舁 6.67924878866|yu;
瘐__瘐 6.67924878866|yu;
臾__臾 6.70426589063|yu;
窳__窳 6.89920269151|yu;
饫__飫 6.98571617442|yu;
揄__揄 7.34275547194|yu;
圄__圄 7.8538759938|yu;
龉__齬 7.88329265768|yu;
燠__燠 8.90728945859|yu;
狳__狳 9.06405247004|yu;
雩__雩 13.2387869087|yu;
俣__俁 14.337888487|yu;
妪__嫗 14.8840559927|yu;
圉__圉 16.6298519291|yu;
纡__紆 16.7755514342|yu;
竽__竽 17.436290857|yu;
鹬__鷸 17.7210620753|yu;
觎__覦 19.4814461385|yu;
嵛__嵛 22.1219762242|yu;
鬻__鬻 25.3089349582|yu;
谀__諛 26.8021243714|yu;
萸__萸 28.7035356477|yu;
禺__禺 39.0006090655|yu;
阈__閾 41.3015868294|yu;
腴__腴 46.1459748436|yu;
庾__庾 48.3234958062|yu;
欤__歟 49.5430123006|yu;
迂__迂 50.3521536533|yu;
鹆__鵒 52.6624872531|yu;
熨__熨 52.991642777|yu;
盂__盂 55.9783798946|yu;
驭__馭 87.9988702102|yu;
聿__聿 92.3812899733|yu;
愉__愉 93.1906722988|yu;
谕__諭 101.179343648|yu;
吁__吁 106.616002115|yu;
芋__芋 109.579386421|yu;
妤__妤 110.677283245|yu;
舆__輿 117.499561272|yu;
隅__隅 132.762114633|yu;
屿__嶼 154.368879448|yu;
瘀__瘀 169.492308033|yu;
昱__昱 175.948711373|yu;
榆__榆 186.794397067|yu;
馀__餘 209.485777119|yu;
峪__峪 224.907079496|yu;
煜__煜 241.463621556|yu;
寓__寓 247.557321202|yu;
毓__毓 259.562230298|yu;
狱__獄 262.817045902|yu;
誉__譽 286.772667017|yu;
钰__鈺 356.655002599|yu;
娱__娛 367.025293151|yu;
淤__淤 379.111778956|yu;
豫__豫 409.054029297|yu;
渔__漁 463.919044053|yu;
禹__禹 490.677728407|yu;
愚__愚 501.183541788|yu;
虞__虞 505.574572707|yu;
俞__俞 510.004074866|yu;
瑜__瑜 539.420927296|yu;
裕__裕 647.865219539|yu;
郁__郁 739.353626862|yu;
喻__喻 766.561672733|yu;
渝__渝 768.474582473|yu;
逾__逾 839.566182019|yu;
育__育 876.994863387|yu;
御__御 924.118331259|yu;
於__於 1014.65366219|yu;
予__予 1126.6237397|yu;
浴__浴 1203.54593192|yu;
预__預 1313.24844471|yu;
愈__愈 1399.42059064|yu;
域__域 1643.47641462|yu;
羽__羽 1682.85360433|yu;
遇__遇 1894.35183846|yu;
宇__宇 2482.57137774|yu;
语__語 3458.29313278|yu;
余__余 4431.607048|yu;
欲__欲 4883.99371143|yu;
玉__玉 5643.57980061|yu;
雨__雨 7744.97981009|yu;
鱼__魚 9175.37723473|yu;
于__於 73708.1861259|yu;
与__與 202250.841605|yu;
腽__膃 5.48551630837|wa;
佤__佤 31.1253042493|wa;
娲__媧 48.1431757172|wa;
洼__窪 170.551683166|wa;
袜__襪 258.916120291|wa;
蛙__蛙 354.881620091|wa;
娃__娃 1868.56155133|wa;
瓦__瓦 3011.53728293|wa;
挖__挖 4566.14945001|wa;
哇__哇 15817.204836|wa;
崴__崴 104.511273964|wai;
歪__歪 1361.57568978|wai;
外__外 20471.9308908|wai;
芄__芄 7.67966687395|wan;
豌__豌 8.032036954|wan;
畹__畹 23.0794168329|wan;
莞__莞 23.3688242938|wan;
惋__惋 24.6552040947|wan;
蜿__蜿 33.2504384462|wan;
纨__紈 33.4999836998|wan;
脘__脘 36.4624977337|wan;
菀__菀 41.4046525194|wan;
琬__琬 61.769684063|wan;
剜__剜 66.4823512304|wan;
烷__烷 96.7405476583|wan;
顽__頑 106.616002115|wan;
绾__綰 136.112567367|wan;
蔓__蔓 149.447435764|wan;
皖__皖 286.415523108|wan;
宛__宛 290.730764849|wan;
挽__挽 317.230705235|wan;
腕__腕 378.63963681|wan;
婉__婉 545.504855178|wan;
丸__丸 1024.81967123|wan;
弯__彎 1244.72999861|wan;
湾__灣 1416.96881393|wan;
碗__碗 1854.64242019|wan;
晚__晚 11186.0109942|wan;
完__完 24072.1691402|wan;
万__萬 25941.0421804|wan;
玩__玩 67131.3656087|wan;
辋__輞 4.46044075099|wang;
魍__魍 10.5129741099|wang;
惘__惘 30.7398379048|wang;
罔__罔 97.3452035967|wang;
枉__枉 207.407719521|wang;
妄__妄 267.775955618|wang;
亡__亡 738.432842998|wang;
旺__旺 1852.33266643|wang;
汪__汪 1887.28302677|wang;
望__望 3996.1462733|wang;
忘__忘 4829.52331536|wang;
往__往 10406.039131|wang;
王__王 20625.5731712|wang;
网__網 21198.8595318|wang;
阌__閿 9.1777123788|wen;
璺__璺 12.2087157421|wen;
紊__紊 25.9799994458|wen;
蕴__蘊 35.2121647201|wen;
玟__玟 58.4011279155|wen;
刎__刎 84.4534488997|wen;
瘟__瘟 150.569041974|wen;
汶__汶 189.136730609|wen;
蚊__蚊 724.757896749|wen;
雯__雯 911.537100768|wen;
纹__紋 1133.66545852|wen;
吻__吻 1838.53442614|wen;
闻__聞 2526.26316155|wen;
稳__穩 2822.57620712|wen;
温__溫 2981.66342698|wen;
文__文 11186.0109942|wen;
问__問 49777.9156481|wen;
蕹__蕹 2.99359291546|weng;
蓊__蓊 8.23473755307|weng;
嗡__嗡 102.960040086|weng;
瓮__瓮 119.86585751|weng;
翁__翁 995.863416846|weng;
軎__軎 2.46163600672|wei;
鲔__鮪 4.22771824491|wei;
崴__崴 7.51868563597|wei;
诿__諉 7.60348609303|wei;
遗__遺 8.84093802908|wei;
涠__潿 8.96296255118|wei;
艉__艉 9.03022977735|wei;
猬__蝟 12.0876076896|wei;
韪__韙 13.0422870099|wei;
沩__溈 13.371428846|wei;
闱__闈 14.8840559927|wei;
逶__逶 15.9996721016|wei;
隈__隈 16.9436288914|wei;
嵬__嵬 18.3731931427|wei;
洧__洧 23.4271398256|wei;
隗__隗 25.5625100165|wei;
娓__娓 30.8549738556|wei;
猥__猥 31.9107983716|wei;
潍__濰 38.9520380838|wei;
帏__幃 42.7148833738|wei;
桅__桅 55.0788270701|wei;
痿__痿 57.4626423848|wei;
葳__葳 62.3885663378|wei;
圩__圩 62.7785126223|wei;
帷__帷 67.8212237837|wei;
囗__囗 78.5647264657|wei;
偎__偎 82.2720127324|wei;
煨__煨 122.279808036|wei;
萎__萎 140.594881376|wei;
渭__渭 157.870654598|wei;
尉__尉 160.249192015|wei;
巍__巍 199.299593609|wei;
违__違 252.85772688|wei;
苇__葦 273.168633085|wei;
畏__畏 285.346757867|wei;
慰__慰 306.352568839|wei;
纬__緯 314.475483928|wei;
蔚__蔚 381.481335404|wei;
玮__瑋 412.12398856|wei;
炜__煒 416.772181646|wei;
危__危 487.02261325|wei;
惟__惟 706.037369534|wei;
谓__謂 732.932171333|wei;
尾__尾 859.681929668|wei;
伪__偽 978.639934443|wei;
薇__薇 1108.5192935|wei;
韦__韋 1349.75009317|wei;
围__圍 1581.19770715|wei;
唯__唯 1815.76539105|wei;
委__委 1840.82697426|wei;
卫__衛 2059.3077787|wei;
胃__胃 2227.49666896|wei;
魏__魏 2238.62771494|wei;
威__威 2373.65954378|wei;
维__維 2445.72321123|wei;
伟__偉 2561.13118731|wei;
微__微 2970.53729039|wei;
味__味 3099.10234274|wei;
喂__喂 3754.75163646|wei;
位__位 14033.7659451|wei;
未__未 17562.6808713|wei;
为__為 210479.033443|wei;
莴__萵 7.72766697621|wo;
龌__齷 21.9571870644|wo;
挝__撾 21.984566431|wo;
幄__幄 26.2730181906|wo;
斡__斡 36.8737446754|wo;
肟__肟 37.0580068352|wo;
蜗__蝸 67.7367598869|wo;
渥__渥 85.087273845|wo;
倭__倭 157.477678279|wo;
涡__渦 162.056583012|wo;
硪__硪 192.465424888|wo;
沃__沃 607.214449729|wo;
卧__卧 639.044983668|wo;
握__握 1081.23274995|wo;
窝__窩 2199.91059329|wo;
喔__喔 3527.93889096|wo;
我__我 1192789.29369|wo;
恶__惡 1.00109457082|wu;
牾__牾 2.46777887515|wu;
迕__迕 3.42912956049|wu;
鹉__鵡 4.04728626554|wu;
亡__亡 4.39423557961|wu;
杌__杌 4.84280729426|wu;
阢__阢 7.45338412978|wu;
鋈__鋈 9.40932582977|wu;
芴__芴 11.4284204878|wu;
鼯__鼯 12.3464133033|wu;
痦__痦 12.6264850603|wu;
圬__圬 15.4702949968|wu;
怃__憮 19.9482155997|wu;
於__於 23.7504862321|wu;
焐__焐 23.9287341406|wu;
寤__寤 24.2287917306|wu;
庑__廡 25.0266684786|wu;
骛__騖 27.6847433674|wu;
仵__仵 28.4542388688|wu;
蜈__蜈 30.5488985997|wu;
鹜__鶩 31.2418839628|wu;
婺__婺 34.9934457312|wu;
妩__嫵 37.1968074646|wu;
忤__忤 38.8550775145|wu;
侮__侮 45.404425301|wu;
诬__誣 68.5861541257|wu;
芜__蕪 106.218162376|wu;
梧__梧 125.992190229|wu;
晤__晤 149.447435764|wu;
坞__塢 160.449013667|wu;
兀__兀 164.498187167|wu;
钨__鎢 169.28122395|wu;
邬__鄔 199.548108896|wu;
戊__戊 205.60633599|wu;
毋__毋 213.971039752|wu;
呜__嗚 314.867617017|wu;
污__污 375.819106356|wu;
巫__巫 470.908619205|wu;
捂__捂 590.793388895|wu;
悟__悟 812.799921236|wu;
午__午 820.943519051|wu;
务__務 885.781642601|wu;
伍__伍 1069.17393505|wu;
勿__勿 1214.09058664|wu;
雾__霧 1346.39025518|wu;
乌__烏 1409.92327219|wu;
误__誤 1463.63092081|wu;
屋__屋 2421.46211928|wu;
武__武 3161.51444144|wu;
舞__舞 3233.23169914|wu;
吾__吾 4951.40363972|wu;
物__物 5615.51843703|wu;
吴__吳 7222.92173899|wu;
唔__唔 9244.23863766|wu;
五__五 12861.4520587|wu;
无__無 32585.7416788|wu;
锕__錒 109.579386421|a;
嗄__嗄 160.449013667|a;
腌__腌 274.876014738|a;
呵__呵 337.205131359|a;
吖__吖 3034.13893483|a;
阿__阿 15389.4559856|a;
啊__啊 83803.0174254|a;
呆__呆 1.91381865685|ai;
锿__鎄 3.17416350497|ai;
砹__砹 3.53323701471|ai;
嗌__嗌 23.7504862321|ai;
瑷__璦 25.8830545594|ai;
嫒__嬡 29.3546599431|ai;
皑__皚 44.1765414285|ai;
蔼__藹 53.4559196785|ai;
捱__捱 77.4951221751|ai;
霭__靄 78.4668827144|ai;
隘__隘 88.6593036185|ai;
嗳__噯 105.558392399|ai;
暧__曖 114.607273411|ai;
碍__礙 248.175085992|ai;
哀__哀 567.697685436|ai;
埃__埃 834.351249399|ai;
癌__癌 853.278059532|ai;
矮__矮 1054.61787307|ai;
挨__挨 1128.02857559|ai;
艾__艾 2586.79165036|ai;
哎__哎 17453.5909636|ai;
唉__唉 27403.1420416|ai;
爱__愛 31546.8736559|ai;
揞__揞 2.46777887515|an;
广__廣 2.95651924355|an;
厂__廠 3.62692052573|an;
埯__垵 3.62692052573|an;
犴__犴 4.07766123576|an;
鹌__鵪 4.39423557961|an;
桉__桉 53.3893461926|an;
谙__諳 57.9660911582|an;
铵__銨 164.293322714|an;
黯__黯 180.389043185|an;
胺__胺 338.890182508|an;
庵__庵 347.00988711|an;
氨__氨 413.152419826|an;
鞍__鞍 580.575602636|an;
岸__岸 1036.37823089|an;
暗__暗 2749.66894397|an;
案__案 4805.5096548|an;
安__安 11597.6536631|an;
俺__俺 16897.1519629|an;
按__按 25812.0564937|an;
肮__骯 15.7621930961|ang;
盎__盎 45.8593409192|ang;
昂__昂 1474.61550226|ang;
聱__聱 3.41207902612|ao;
廒__廒 7.67966687395|ao;
鏖__鏖 7.93256547901|ao;
鏊__鏊 15.0706966208|ao;
懊__懊 18.3961034722|ao;
媪__媼 22.3157940045|ao;
骜__驁 27.1720530381|ao;
遨__遨 32.4319686712|ao;
翱__翱 44.954022356|ao;
螯__螯 67.8212237837|ao;
岙__嶴 74.0953666012|ao;
鳌__鰲 88.4386102484|ao;
坳__坳 92.3812899733|ao;
拗__拗 104.772075724|ao;
獒__獒 136.112567367|ao;
嗷__嗷 205.60633599|ao;
袄__襖 299.93080386|ao;
敖__敖 357.99085261|ao;
凹__凹 526.798985534|ao;
傲__傲 597.456727653|ao;
澳__澳 857.541983893|ao;
熬__熬 1693.37191801|ao;
奥__奧 5814.9173705|ao;
苊__苊 7.68924298287|e;
锇__鋨 15.7818476567|e;
鹗__鶚 17.436290857|e;
阿__阿 17.6109883889|e;
垩__堊 19.1922880593|e;
婀__婀 21.2306951686|e;
轭__軛 25.7543572024|e;
谔__諤 33.3334129671|e;
锷__鍔 42.7681464101|e;
腭__齶 44.7304991295|e;
愕__愕 57.606037042|e;
遏__遏 60.2492042805|e;
讹__訛 69.61949838|e;
颚__顎 69.9673946745|e;
萼__萼 72.8138854049|e;
丨__丨 77.8823738285|e;
屙__屙 83.096311758|e;
鳄__鱷 83.3036737352|e;
噩__噩 86.0469415397|e;
峨__峨 100.300577883|e;
扼__扼 173.121277629|e;
蛾__蛾 232.603161479|e;
莪__莪 431.571158705|e;
娥__娥 525.487661863|e;
鄂__鄂 560.667124391|e;
鹅__鵝 871.547443971|e;
诶__誒 1766.66116773|e;
厄__厄 2289.40978274|e;
哦__哦 5335.81207086|e;
恶__惡 7036.3533641|e;
呃__呃 7259.01547376|e;
饿__餓 8284.0986923|e;
俄__俄 11525.6152893|e;
额__額 12039.4384893|e;
蒽__蒽 137.819369268|en;
摁__摁 319.611528482|en;
唔__唔 1126.6237397|en;
嗯__嗯 31982.2903695|en;
恩__恩 162015.349919|en;
诶__誒 1766.66116773|ei;
佴__佴 3.95258357798|er;
鲕__鮞 4.149425655|er;
鸸__鴯 25.9799994458|er;
铒__鉺 30.3591453066|er;
珥__珥 36.9197241431|er;
洱__洱 38.9035275919|er;
迩__邇 91.3509763097|er;
饵__餌 167.393257695|er;
贰__貳 432.648119245|er;
耳__耳 1740.43907177|er;
尔__爾 2729.18634194|er;
儿__兒 15408.6457642|er;
二__二 20319.4331096|er;
而__而 135908.465229|er;
喔__喔 1939.73992621|o;
噢__噢 7268.06705425|o;
哦__哦 15582.4341451|o;
讴__謳 18.9546042422|ou;
怄__慪 19.9979952029|ou;
区__區 24.0483086584|ou;
沤__漚 49.2352778104|ou;
瓯__甌 53.4559196785|ou;
耦__耦 58.5468645084|ou;
殴__毆 163.069482749|ou;
鸥__鷗 208.184564378|ou;
呕__嘔 357.99085261|ou;
藕__藕 499.3133654|ou;
欧__歐 3041.71045076|ou;
偶__偶 24864.88816|ou;
唔__唔 1126.6237397|ng;
嗯__嗯 31982.2903695|ng;
粑粑__粑粑 149.447435764|ba ba;
巴巴__巴巴 322.411748334|ba ba;
爸爸__爸爸 9814.0643895|ba ba;
八百__八百 373.484720623|ba bai;
八宝__八寶 107.015331962|ba bao;
芭比__芭比 182.651055928|ba bi;
把柄__把柄 220.742053181|ba bing;
八婆__八婆 115.323601467|ba po;
爸妈__爸媽 2586.79165036|ba ma;
把门__把門 260.209952636|ba men;
罢免__罷免 249.415244207|ba mian;
八方__八方 239.664931108|ba fang;
八分__八分 161.451865638|ba fen;
巴顿__巴頓 122.737806611|ba dun;
八大__八大 650.291796355|ba da;
把刀__把刀 157.2815571|ba dao;
霸道__霸道 638.24912322|ba dao;
巴蒂__巴蒂 151.510141313|ba di;
八点__八點 611.771607197|ba dian;
拔掉__拔掉 344.424970321|ba diao;
八度__八度 105.426930997|ba du;
把她__把她 1863.91027245|ba ta;
把他__把他 2989.10399336|ba ta;
把它__把它 4117.46820292|ba ta;
吧台__吧台 187.027319083|ba tai;
巴特__巴特 132.596773978|ba te;
把头__把頭 448.010827873|ba tou;
把那__把那 473.851932013|ba na;
把你__把你 3892.92564555|ba ni;
八年__八年 861.827215553|ba nian;
巴拉__巴拉 154.176629937|ba la;
罢了__罷了 2886.60483295|ba le;
芭蕾__芭蕾 227.727332161|ba lei;
巴里__巴里 145.405889264|ba li;
巴黎__巴黎 2180.80386611|ba li;
把脸__把臉 256.987424161|ba lian;
巴林__巴林 144.502706249|ba lin;
八路__八路 105.295633316|ba lu;
八卦__八卦 2919.16177455|ba gua;
把关__把關 465.076726846|ba guan;
拔高__拔高 114.037415895|ba gao;
八哥__八哥 110.401782066|ba ge;
八个__八個 824.018360007|ba ge;
罢工__罷工 590.793388895|ba gong;
巴克__巴克 113.47039186|ba ke;
把话__把話 131.609045271|ba hua;
八号__八號 105.690017726|ba hao;
把好__把好 149.447435764|ba hao;
巴赫__巴赫 211.057972369|ba he;
疤痕__疤痕 483.997491267|ba hen;
吧唧__吧唧 119.56748386|ba ji;
八级__八級 147.596627936|ba ji;
拔剑__拔劍 123.658956482|ba jian;
芭蕉__芭蕉 143.784200776|ba jiao;
八角__八角 170.339279748|ba jiao;
八届__八屆 120.615053212|ba jie;
巴结__巴結 152.647228173|ba jie;
八戒__八戒 333.029068427|ba jie;
巴金__巴金 217.465635832|ba jin;
把酒__把酒 158.461958559|ba jiu;
八九__八九 298.06779536|ba jiu;
霸权__霸權 288.565077751|ba quan;
霸气__霸氣 380.057830188|ba qi;
八千__八千 304.449671797|ba qian;
把钱__把錢 910.401881269|ba qian;
巴乔__巴喬 335.110594827|ba qiao;
八强__八強 262.817045902|ba qiang;
把球__把球 274.191785204|ba qiu;
把戏__把戲 259.562230298|ba xi;
巴西__巴西 2347.18650079|ba xi;
拔下__拔下 130.628674269|ba xia;
八仙__八仙 115.899886195|ba xian;
八项__八項 136.282292017|ba xiang;
把心__把心 129.494134325|ba xin;
罢休__罷休 221.568841736|ba xiu;
霸占__霸佔 336.365750338|ba zhan;
巴掌__巴掌 574.10053635|ba zhang;
八折__八折 120.46484039|ba zhe;
把这__把這 919.523371782|ba zhe;
八种__八種 130.303509496|ba zhong;
吧主__吧主 273.850309404|ba zhu;
霸主__霸主 410.586139672|ba zhu;
把车__把車 333.444336783|ba che;
八成__八成 526.142915167|ba cheng;
把持__把持 261.184568064|ba chi;
拔出__拔出 331.37316028|ba chu;
坝上__壩上 159.253810404|ba shang;
跋涉__跋涉 182.651055928|ba she;
八十__八十 571.958268741|ba shi;
巴士__巴士 757.068312494|ba shi;
把守__把守 115.323601467|ba shou;
把手__把手 718.463208478|ba shou;
把书__把書 159.253810404|ba shu;
巴蜀__巴蜀 160.649084484|ba shu;
把水__把水 120.765453341|ba shui;
把人__把人 518.979844093|ba ren;
八日__八日 124.89791921|ba ri;
靶子__靶子 135.94305409|ba zi;
八字__八字 594.486015613|ba zi;
八次__八次 111.925571131|ba ci;
巴萨__巴薩 1028.65812957|ba sa;
巴斯__巴斯 218.824857909|ba si;
八岁__八歲 225.187525865|ba sui;
八月__八月 1062.53280282|ba yue;
拔牙__拔牙 167.810977762|ba ya;
巴以__巴以 115.179978568|ba yi;
八一__八一 567.697685436|ba yi;
八万__八萬 158.461958559|ba wan;
把玩__把玩 164.293322714|ba wan;
霸王__霸王 617.131535882|ba wang;
八位__八位 125.209594649|ba wei;
把我__把我 4704.77652327|ba wo;
把握__把握 6173.35572247|ba wo;
巴尔__巴爾 214.2378495|ba er;
掰掰__掰掰 128.850255419|bai bai;
摆摆__擺擺 140.945727665|bai bai;
白白__白白 1348.06912745|bai bai;
拜拜__拜拜 2766.85515694|bai bai;
白班__白班 119.121315407|bai ban;
白板__白板 198.555903198|bai ban;
百般__百般 327.26932246|bai ban;
百倍__百倍 326.048110451|bai bei;
败笔__敗筆 177.933171406|bai bi;
百变__百變 215.845709156|bai bian;
白布__白布 111.925571131|bai bu;
摆布__擺布 157.2815571|bai bu;
摆平__擺平 268.109857044|bai ping;
白马__白馬 562.066236349|bai ma;
摆满__擺滿 142.180598718|bai man;
百忙__百忙 212.112652282|bai mang;
白猫__白貓 138.680779525|bai mao;
百米__百米 364.745529846|bai mi;
摆明__擺明 221.568841736|bai ming;
百名__百名 359.331706043|bai ming;
白发__白髮 486.416079992|bai fa;
白饭__白飯 114.179614083|bai fan;
摆放__擺放 978.639934443|bai fang;
拜访__拜訪 1343.0387806|bai fang;
白粉__白粉 106.218162376|bai fen;
百分__百分 178.822323044|bai fen;
白费__白費 292.54791482|bai fei;
拜佛__拜佛 127.572086295|bai fo;
百搭__百搭 108.492380517|bai da;
白搭__白搭 159.055477247|bai da;
白带__白帶 326.048110451|bai dai;
摆到__擺到 120.46484039|bai dao;
败德__敗德 190.556205829|bai de;
白底__白底 114.46454262|bai di;
摆动__擺動 325.642053285|bai dong;
摆渡__擺渡 163.680258901|bai du;
拜读__拜讀 303.313611771|bai du;
百度__百度 6744.45298826|bai du;
百态__百態 129.171793682|bai tai;
摆摊__擺攤 506.204995518|bai tan;
白糖__白糖 396.012952778|bai tang;
白天__白天 5342.46552582|bai tian;
白头__白頭 196.096919422|bai tou;
拜托__拜託 1978.80389582|bai tuo;
摆脱__擺脫 2725.78743963|bai tuo;
白嫩__白嫩 143.784200776|bai nen;
拜年__拜年 346.1460998|bai nian;
百年__百年 2006.11577143|bai nian;
摆弄__擺弄 274.876014738|bai nong;
摆了__擺了 256.028470459|bai le;
败类__敗類 377.226735448|bai lei;
百里__百里 242.066179876|bai li;
百联__百聯 133.758497151|bai lian;
百灵__百靈 163.272821143|bai ling;
白领__白領 1621.10162248|bai ling;
白露__白露 109.30661816|bai lu;
白鹭__白鷺 129.010924378|bai lu;
白光__白光 222.953710017|bai guang;
百个__百個 148.519148841|bai ge;
败给__敗給 152.837570606|bai gei;
白宫__白宮 499.935980841|bai gong;
白骨__白骨 248.794392378|bai gu;
百果__百果 181.290467084|bai guo;
掰开__掰開 105.295633316|bai kai;
百科__百科 476.813641365|bai ke;
白花__白花 155.527421199|bai hua;
白话__白話 275.561951728|bai hua;
百花__百花 324.426913464|bai hua;
败坏__敗壞 331.37316028|bai huai;
摆好__擺好 122.127521944|bai hao;
白鹤__白鶴 113.187937993|bai he;
百合__百合 1058.56794047|bai he;
白狐__白狐 135.267109459|bai hu;
白虎__白虎 374.883606282|bai hu;
百货__百貨 760.851466162|bai huo;
拜会__拜會 111.786180106|bai hui;
百佳__百佳 111.925571131|bai jia;
败家__敗家 234.056997396|bai jia;
百家__百家 427.82286438|bai jia;
拜见__拜見 137.819369268|bai jian;
白洁__白潔 188.901181552|bai jie;
白金__白金 522.874798954|bai jin;
白净__白凈 127.413209251|bai jing;
白酒__白酒 947.439854855|bai jiu;
百强__百強 221.292902041|bai qiang;
白雪__白雪 436.982903472|bai xue;
白皙__白皙 325.642053285|bai xi;
百姓__百姓 3083.69279052|bai xing;
百兆__百兆 126.937764318|bai zhao;
摆着__擺着 324.426913464|bai zhe;
摆正__擺正 167.601987591|bai zheng;
柏芝__柏芝 204.329220247|bai zhi;
白纸__白紙 387.711726118|bai zhi;
白昼__白晝 137.647730357|bai zhou;
百种__百種 112.906187218|bai zhong;
百川__百川 106.882056102|bai chuan;
白吃__白吃 153.028150386|bai chi;
白痴__白痴 3281.94475852|bai chi;
百出__百出 112.34478795|bai chu;
摆出__擺出 484.601008682|bai chu;
白沙__白沙 267.109399762|bai sha;
摆上__擺上 280.761336094|bai shang;
摆设__擺設 476.813641365|bai she;
百盛__百盛 252.54282031|bai sheng;
拜师__拜師 206.119414554|bai shi;
白石__白石 208.964318904|bai shi;
百事__百事 436.982903472|bai shi;
摆手__擺手 172.260473089|bai shou;
白水__白水 215.040276584|bai shui;
百人__百人 334.69325133|bai ren;
白人__白人 417.291872914|bai ren;
拜仁__拜仁 553.723632203|bai ren;
白日__白日 163.680258901|bai ri;
百日__百日 218.280152578|bai ri;
摆在__擺在 1169.53977147|bai zai;
白菜__白菜 838.520594407|bai cai;
百草__百草 105.164499152|bai cao;
百色__百色 144.502706249|bai se;
白色__白色 5750.06453265|bai se;
百思__百思 131.117943492|bai si;
白送__白送 139.373782642|bai song;
败诉__敗訴 238.770616634|bai su;
百岁__百歲 153.984619852|bai sui;
百元__百元 659.267263146|bai yuan;
白云__白雲 1037.67053575|bai yun;
白眼__白眼 310.194118206|bai yan;
白杨__白楊 133.093414711|bai yang;
白羊__白羊 246.019628549|bai yang;
白蚁__白蟻 117.792774542|bai yi;
百亿__百億 316.441045148|bai yi;
白衣__白衣 606.458230719|bai yi;
白银__白銀 467.400766428|bai yin;
白玉__白玉 347.00988711|bai yu;
百余__百餘 510.004074866|bai yu;
百万__百萬 1647.57761372|bai wan;
百位__百位 109.852835359|bai wei;
斑斑__斑斑 494.9767145|ban ban;
版本__版本 15935.9132976|ban ben;
半杯__半杯 105.953760973|ban bei;
半边__半邊 236.991986692|ban bian;
斑驳__斑駁 188.196293023|ban bo;
半步__半步 148.149450567|ban bu;
颁布__頒布 907.004698479|ban bu;
般配__般配 170.127140854|ban pei;
半瓶__半瓶 115.179978568|ban ping;
扳平__扳平 203.313241605|ban ping;
斑马__斑馬 221.017305999|ban ma;
版面__版面 1793.27833544|ban mian;
颁发__頒發 1465.45598554|ban fa;
办法__辦法 21119.7555644|ban fa;
拌饭__拌飯 188.196293023|ban fan;
半分__半分 124.431860131|ban fen;
半段__半段 183.335174792|ban duan;
绊倒__絆倒 115.755545596|ban dao;
办到__辦到 204.584007193|ban dao;
半岛__半島 686.088301175|ban dao;
搬到__搬到 1254.07172395|ban dao;
办得__辦得 171.831677206|ban de;
般地__般地 406.006938516|ban de;
般的__般的 2952.08591378|ban de;
板凳__板凳 796.754272909|ban deng;
班底__班底 173.553291634|ban di;
斑点__斑點 392.084582382|ban dian;
半点__半點 600.442284667|ban dian;
半天__半天 5764.41348178|ban tian;
版图__版圖 299.1842072|ban tu;
办妥__辦妥 119.56748386|ban tuo;
半年__半年 6028.9050116|ban nian;
伴娘__伴娘 250.661599628|ban niang;
伴侣__伴侶 1018.45404378|ban lv;
搬来__搬來 239.664931108|ban lai;
斑斓__斑斕 136.452228303|ban lan;
伴郎__伴郎 169.070402749|ban lang;
搬了__搬了 255.073095111|ban le;
板栗__板栗 182.196395498|ban li;
班里__班裡 580.575602636|ban li;
办理__辦理 8718.35595463|ban li;
半路__半路 333.029068427|ban lu;
半裸__半裸 144.502706249|ban luo;
办个__辦個 181.516526012|ban ge;
半个__半個 2516.83636014|ban ge;
办公__辦公 3126.25457954|ban gong;
版规__版規 360.228397261|ban gui;
版块__版塊 1279.32718167|ban kuai;
板块__板塊 4226.64255951|ban kuai;
办卡__辦卡 199.548108896|ban ka;
板卡__板卡 321.609191441|ban ka;
半空__半空 313.69268222|ban kong;
版画__版畫 142.357889859|ban hua;
办好__辦好 851.15405446|ban hao;
瘢痕__瘢痕 115.179978568|ban hen;
扳回__扳回 110.401782066|ban hui;
搬回__搬回 132.10198647|ban hui;
班会__班會 137.647730357|ban hui;
扳机__扳機 114.607273411|ban ji;
班机__班機 133.591915611|ban ji;
班级__班級 1998.62991039|ban ji;
板甲__板甲 107.550099352|ban jia;
半价__半價 410.586139672|ban jia;
搬家__搬家 2749.66894397|ban jia;
半角__半角 143.963491517|ban jiao;
颁奖__頒獎 748.624851411|ban jiang;
办结__辦結 138.680779525|ban jie;
半截__半截 271.133768339|ban jie;
半斤__半斤 210.270405333|ban jin;
搬进__搬進 262.489736092|ban jin;
半径__半徑 460.463257431|ban jing;
半句__半句 209.746993999|ban ju;
版权__版權 3868.74488962|ban quan;
办起__辦起 110.539446825|ban qi;
搬迁__搬遷 1094.79101389|ban qian;
板桥__板橋 111.091824605|ban qiao;
半球__半球 178.377193209|ban qiu;
搬去__搬去 105.953760973|ban qu;
办学__辦學 942.728934628|ban xue;
半仙__半仙 112.765574943|ban xian;
扮相__扮相 197.568631008|ban xiang;
板砖__板磚 301.429591092|ban zhuan;
班长__班長 1456.35336279|ban zhang;
伴着__伴着 417.812212206|ban zhe;
办证__辦證 613.298247397|ban zheng;
斑竹__斑竹 2833.14815601|ban zhu;
版主__版主 4387.64638002|ban zhu;
班禅__班禪 105.953760973|ban chan;
半场__半場 310.968189453|ban chang;
搬场__搬場 313.302012384|ban chang;
板车__板車 131.773154284|ban che;
班车__班車 926.424414408|ban che;
半程__半程 107.14877401|ban cheng;
办成__辦成 269.449631503|ban cheng;
搬出__搬出 342.712398751|ban chu;
半山__半山 132.10198647|ban shan;
搬上__搬上 206.119414554|ban shang;
半晌__半晌 255.391156791|ban shang;
板上__板上 352.677286738|ban shang;
班上__班上 843.76158662|ban shang;
半身__半身 173.337150041|ban shen;
半生__半生 165.114314527|ban sheng;
版式__版式 216.654158472|ban shi;
办事__辦事 2498.08815496|ban shi;
扳手__扳手 135.267109459|ban shou;
半数__半數 367.482952871|ban shu;
半日__半日 144.143005824|ban ri;
般若__般若 110.95347192|ban ruo;
板载__板載 138.85370659|ban zai;
班子__班子 865.055186245|ban zi;
板子__板子 932.214830498|ban zi;
搬走__搬走 389.163898974|ban zou;
伴奏__伴奏 665.043316617|ban zou;
班组__班組 286.415523108|ban zu;
板材__板材 388.679238014|ban cai;
班次__班次 217.19480623|ban ci;
半死__半死 297.325836157|ban si;
伴随__伴隨 1922.89284084|ban sui;
半月__半月 727.472474808|ban yue;
拌匀__拌勻 199.051387821|ban yun;
搬运__搬運 365.20034683|ban yun;
扮演__扮演 2615.96711065|ban yan;
半夜__半夜 2418.44645375|ban ye;
伴有__伴有 601.940653207|ban you;
办完__辦完 335.528458728|ban wan;
伴我__伴我 142.891090816|ban wo;
版务__版務 348.309611377|ban wu;
办案__辦案 824.018360007|ban an;
棒棒__棒棒 323.619340361|bang bang;
帮帮__幫幫 913.811788194|bang bang;
帮派__幫派 593.745648473|bang pai;
帮忙__幫忙 9704.60970837|bang mang;
绑匪__綁匪 151.132997772|bang fei;
帮扶__幫扶 493.744603771|bang fu;
榜单__榜單 288.924902033|bang dan;
帮到__幫到 114.179614083|bang dao;
邦德__邦德 164.088713397|bang de;
帮顶__幫頂 204.584007193|bang ding;
绑定__綁定 2023.69199978|bang ding;
帮她__幫她 770.392265767|bang ta;
帮他__幫他 1368.37963334|bang ta;
帮你__幫你 6211.94095161|bang ni;
帮您__幫您 338.890182508|bang nin;
帮了__幫了 174.203334854|bang le;
帮会__幫會 278.322859608|bang hui;
绑架__綁架 953.361623425|bang jia;
棒球__棒球 275.905561849|bang qiu;
帮凶__幫凶 143.426288875|bang xiong;
帮着__幫着 557.879339939|bang zhe;
帮主__幫主 526.142915167|bang zhu;
帮助__幫助 18231.6891158|bang zhu;
榜上__榜上 156.694657831|bang shang;
帮手__幫手 347.442588754|bang shou;
榜首__榜首 556.490650127|bang shou;
帮人__幫人 498.070459751|bang ren;
绑在__綁在 217.736803143|bang zai;
膀子__膀子 133.42554153|bang zi;
棒子__棒子 967.72532071|bang zi;
榜样__榜樣 868.29524729|bang yang;
傍晚__傍晚 1065.18429118|bang wan;
帮我__幫我 9937.12917391|bang wo;
包办__包辦 148.519148841|bao ban;
饱饱__飽飽 119.56748386|bao bao;
包包__包包 1703.95597413|bao bao;
抱抱__抱抱 1762.26354231|bao bao;
宝宝__寶寶 14714.3117017|bao bao;
保本__保本 271.810366771|bao ben;
报备__報備 141.650048976|bao bei;
宝贝__寶貝 10497.2098015|bao bei;
包庇__包庇 143.605133321|bao bi;
保镖__保鏢 539.420927296|bao biao;
报表__報表 3662.32726943|bao biao;
报批__報批 312.522131716|bao pi;
包皮__包皮 493.129699012|bao pi;
爆破__爆破 467.400766428|bao po;
宝马__寶馬 1515.60233678|bao ma;
爆满__爆滿 242.066179876|bao man;
饱满__飽滿 651.102673334|bao man;
保密__保密 1932.50174796|bao mi;
暴民__暴民 114.75018218|bao min;
保命__保命 126.621787068|bao ming;
报名__報名 5998.9277097|bao ming;
保姆__保姆 1265.05905145|bao mu;
暴发__暴發 256.667374505|bao fa;
爆发__爆發 2937.40736593|bao fa;
包房__包房 253.488718522|bao fang;
暴风__暴風 908.135681884|bao feng;
保费__保費 499.3133654|bao fei;
报废__報廢 662.561694208|bao fei;
暴富__暴富 246.633556117|bao fu;
抱负__抱負 298.06779536|bao fu;
包袱__包袱 658.446218066|bao fu;
报复__報復 1343.0387806|bao fu;
暴打__暴打 218.824857909|bao da;
报答__報答 416.772181646|bao da;
保单__保單 435.895152658|bao dan;
宝岛__寶島 106.882056102|bao dao;
报导__報導 911.537100768|bao dao;
报到__報到 1147.88120947|bao dao;
报道__報道 11172.0800441|bao dao;
保底__保底 207.149415951|bao di;
宝地__寶地 208.964318904|bao di;
宝典__寶典 423.578945935|bao dian;
暴跌__暴跌 1027.37704867|bao die;
保定__保定 546.185068786|bao ding;
暴动__暴動 230.295783987|bao dong;
宝塔__寶塔 139.026849285|bao ta;
煲汤__煲湯 183.106850936|bao tang;
包头__包頭 432.648119245|bao tou;
暴徒__暴徒 155.915530766|bao tu;
保暖__保暖 349.614203755|bao nuan;
暴怒__暴怒 228.011295226|bao nu;
暴乱__暴亂 132.762114633|bao luan;
宝来__寶來 291.093289619|bao lai;
包揽__包攬 223.510077937|bao lan;
爆冷__爆冷 108.222318063|bao leng;
堡垒__堡壘 319.213487372|bao lei;
保利__保利 328.086003878|bao li;
包里__包里 476.813641365|bao li;
暴利__暴利 681.82669043|bao li;
暴力__暴力 2580.3525318|bao li;
报料__報料 237.879639313|bao liao;
爆料__爆料 478.003501869|bao liao;
爆裂__爆裂 180.839193473|bao lie;
保留__保留 5807.67552859|bao liu;
暴露__暴露 2067.02090848|bao lu;
保罗__保羅 526.798985534|bao luo;
报关__報關 705.158077415|bao guan;
保管__保管 942.728934628|bao guan;
暴光__暴光 172.475272126|bao guang;
曝光__曝光 2355.97787927|bao guang;
包干__包干 111.091824605|bao gan;
包钢__包鋼 240.862563142|bao gang;
宝钢__寶鋼 855.407364934|bao gang;
报告__報告 15104.4605586|bao gao;
包公__包公 107.550099352|bao gong;
报国__報國 143.784200776|bao guo;
包裹__包裹 1631.2339687|bao guo;
宝贵__寶貴 1850.02578923|bao gui;
报刊__報刊 927.579613097|bao kan;
报考__報考 1791.04500392|bao kao;
宝库__寶庫 218.824857909|bao ku;
包括__包括 28660.4944129|bao kuo;
包换__包換 155.333728851|bao huan;
保函__保函 149.075426771|bao han;
包涵__包涵 225.468321935|bao han;
饱含__飽含 228.8653107|bao han;
包含__包含 5580.63786311|bao han;
包好__包好 169.915266157|bao hao;
饱和__飽和 529.431458035|bao he;
保护__保護 15066.8620871|bao hu;
暴君__暴君 138.163289429|bao jun;
爆击__爆擊 202.554574186|bao ji;
保级__保級 261.83633885|bao ji;
包机__包機 325.642053285|bao ji;
宝鸡__寶雞 329.314848809|bao ji;
暴击__暴擊 413.667597456|bao ji;
报价__報價 6096.90278745|bao jia;
报检__報檢 115.467403456|bao jian;
保荐__保薦 165.526347625|bao jian;
包间__包間 237.287502254|bao jian;
宝剑__寶劍 289.645897197|bao jian;
保健__保健 1515.60233678|bao jian;
宝洁__寶潔 327.26932246|bao jie;
保洁__保潔 341.433560596|bao jie;
抱紧__抱緊 179.492101402|bao jin;
报警__報警 2036.34065037|bao jing;
保全__保全 355.767206381|bao quan;
抱起__抱起 345.715012791|bao qi;
抱歉__抱歉 2501.20312918|bao qian;
报请__報請 120.314814642|bao qing;
暴雪__暴雪 638.24912322|bao xue;
报讯__報訊 209.224885556|bao xun;
保鲜__保鮮 346.1460998|bao xian;
保险__保險 6096.90278745|bao xian;
爆笑__爆笑 566.284555508|bao xiao;
报销__報銷 2652.07324956|bao xiao;
宝箱__寶箱 276.938965124|bao xiang;
包厢__包廂 347.875829952|bao xiang;
暴行__暴行 206.89143407|bao xing;
报修__報修 195.852702213|bao xiu;
保修__保修 1542.27603899|bao xiu;
包装__包裝 5315.90138163|bao zhuang;
包扎__包紮 213.438416689|bao zha;
爆炸__爆炸 2164.55880585|bao zha;
报章__報章 139.547573842|bao zhang;
报账__報賬 149.261315371|bao zhang;
暴涨__暴漲 678.436468738|bao zhang;
保障__保障 7620.52071577|bao zhang;
包着__包着 141.121478992|bao zhe;
抱着__抱着 3653.21089568|bao zhe;
抱枕__抱枕 153.792848894|bao zhen;
暴政__暴政 140.770195218|bao zheng;
保证__保證 17087.7286512|bao zheng;
保值__保值 347.875829952|bao zhi;
报纸__報紙 4829.52331536|bao zhi;
包中__包中 130.954650472|bao zhong;
保重__保重 750.493000864|bao zhong;
爆竹__爆竹 133.591915611|bao zhu;
包住__包住 152.837570606|bao zhu;
宝珠__寶珠 201.296414343|bao zhu;
保住__保住 654.356305043|bao zhu;
抱住__抱住 882.476330723|bao zhu;
宝钗__寶釵 237.287502254|bao chai;
爆炒__爆炒 131.281440129|bao chao;
包车__包車 249.415244207|bao che;
保持__保持 16708.7007457|bao chi;
报仇__報仇 613.298247397|bao chou;
报酬__報酬 1238.54087357|bao chou;
曝出__曝出 108.492380517|bao chu;
报出__報出 210.270405333|bao chu;
爆出__爆出 409.564096466|bao chu;
暴晒__暴晒 137.991222203|bao shai;
宝山__寶山 391.108593802|bao shan;
报上__報上 369.319305625|bao shang;
报社__報社 1029.9408079|bao she;
保湿__保濕 808.758466182|bao shi;
宝石__寶石 2003.61737423|bao shi;
报收__報收 226.312812713|bao shou;
饱受__飽受 399.482550191|bao shou;
保守__保守 1906.19207626|bao shou;
报税__報稅 141.29744947|bao shui;
保税__保稅 207.149415951|bao shui;
包容__包容 962.913535809|bao rong;
抱在__抱在 303.313611771|bao zai;
宝藏__寶藏 357.099731154|bao zang;
暴躁__暴躁 250.661599628|bao zao;
孢子__孢子 223.788782324|bao zi;
豹子__豹子 512.55262135|bao zi;
包子__包子 1894.35183846|bao zi;
暴走__暴走 223.231720645|bao zou;
宝座__寶座 385.303469841|bao zuo;
保存__保存 7304.38638512|bao cun;
报错__報錯 882.476330723|bao cuo;
保送__保送 221.568841736|bao song;
报送__報送 771.352901218|bao song;
抱怨__抱怨 2494.97706011|bao yuan;
包月__包月 990.911721928|bao yue;
保研__保研 215.576896995|bao yan;
包养__包養 359.331706043|bao yang;
保养__保養 1891.99263098|bao yang;
包夜__包夜 259.562230298|bao ye;
报业__報業 355.767206381|bao ye;
报以__報以 138.680779525|bao yi;
报应__報應 472.083744072|bao ying;
保有__保有 309.036622663|bao you;
抱有__抱有 402.480675297|bao you;
保佑__保佑 676.747684543|bao you;
保育__保育 108.627664361|bao yu;
鲍鱼__鮑魚 357.99085261|bao yu;
宝玉__寶玉 643.039196578|bao yu;
暴雨__暴雨 1074.51671486|bao yu;
报文__報文 491.289575698|bao wen;
保温__保溫 532.740555233|bao wen;
保卫__保衛 759.903909096|bao wei;
包围__包圍 1083.93090293|bao wei;
宝物__寶物 310.194118206|bao wu;
宝安__寶安 342.285588041|bao an;
报案__報案 660.912425973|bao an;
保安__保安 2186.24593438|bao an;
保额__保額 449.128812644|bao e;
报恩__報恩 114.75018218|bao en;
保尔__保爾 119.41857567|bao er;
宝儿__寶兒 330.548296374|bao er;
本版__本版 857.541983893|ben ban;
本报__本報 1461.808129|ben bao;
奔奔__奔奔 180.389043185|ben ben;
苯苯__苯苯 188.901181552|ben ben;
本本__本本 2038.87985164|ben ben;
本币__本幣 117.353228453|ben bi;
本病__本病 275.218769535|ben bing;
奔波__奔波 731.107734818|ben bo;
本部__本部 696.425160166|ben bu;
奔跑__奔跑 847.977956119|ben pao;
本篇__本篇 118.381397999|ben pian;
本片__本片 629.559803835|ben pian;
本品__本品 391.596284031|ben pin;
本名__本名 149.261315371|ben ming;
本法__本法 340.15949445|ben fa;
本方__本方 169.28122395|ben fang;
奔放__奔放 416.772181646|ben fang;
本分__本分 263.801426189|ben fen;
奔赴__奔赴 338.468131949|ben fu;
笨蛋__笨蛋 1674.48601346|ben dan;
笨的__笨的 127.73116145|ben de;
本地__本地 5707.23163681|ben di;
本店__本店 421.472799973|ben dian;
奔腾__奔騰 682.676889633|ben teng;
本题__本題 105.164499152|ben ti;
本体__本體 438.619621343|ben ti;
本田__本田 518.979844093|ben tian;
本条__本條 134.930398555|ben tiao;
本贴__本貼 273.168633085|ben tie;
本帖__本帖 589.322768456|ben tie;
本土__本土 2008.61728399|ben tu;
本能__本能 1111.28553845|ben neng;
本年__本年 181.969489867|ben nian;
本轮__本輪 480.991159713|ben lun;
本来__本來 22006.3792893|ben lai;
本领__本領 680.977550057|ben ling;
本该__本該 324.426913464|ben gai;
本国__本國 972.56115063|ben guo;
本刊__本刊 441.361118731|ben kan;
本科__本科 3360.57914611|ben ke;
本行__本行 217.465635832|ben hang;
本季__本季 135.773751924|ben ji;
本级__本級 304.829303266|ben ji;
本机__本機 801.734213733|ben ji;
本节__本節 206.633773476|ben jie;
本届__本屆 1538.43695969|ben jie;
本金__本金 582.750146437|ben jin;
本就__本就 295.847453874|ben jiu;
本剧__本劇 133.591915611|ben ju;
本期__本期 977.421145723|ben qi;
本钱__本錢 655.172250234|ben qian;
奔去__奔去 109.989815613|ben qu;
本区__本區 186.097370046|ben qu;
本息__本息 131.773154284|ben xi;
本溪__本溪 145.768741141|ben xi;
本县__本縣 116.624293448|ben xian;
本校__本校 425.165459331|ben xiao;
奔向__奔向 333.444336783|ben xiang;
本想__本想 664.215078095|ben xiang;
本性__本性 978.639934443|ben xing;
本站__本站 5369.16241395|ben zhan;
本章__本章 272.828431509|ben zhang;
本着__本着 934.541117987|ben zhe;
本职__本職 154.176629937|ben zhi;
本质__本質 3253.44031687|ben zhi;
本周__本周 3458.29313278|ben zhou;
笨重__笨重 155.72135507|ben zhong;
笨猪__笨豬 134.594525802|ben zhu;
笨拙__笨拙 259.885889675|ben zhuo;
本厂__本廠 148.889769675|ben chang;
本场__本場 234.933657026|ben chang;
奔驰__奔馳 1092.0658276|ben chi;
本山__本山 128.369448119|ben shan;
本身__本身 10602.3833536|ben shen;
本省__本省 373.950434882|ben sheng;
本是__本是 587.855808729|ben shi;
本市__本市 1738.27154577|ben shi;
本事__本事 2143.08680935|ben shi;
本书__本書 4231.91294301|ben shu;
本人__本人 12054.4509861|ben ren;
本子__本子 898.007390736|ben zi;
奔走__奔走 297.325836157|ben zou;
本组__本組 165.73274959|ben zu;
本作__本作 265.119670945|ben zuo;
本村__本村 156.109948588|ben cun;
本草__本草 119.86585751|ben cao;
本次__本次 5539.06704613|ben ci;
本色__本色 804.737106306|ben se;
本所__本所 122.127521944|ben suo;
本源__本源 114.75018218|ben yuan;
本院__本院 245.71323808|ben yuan;
本月__本月 1829.39274925|ben yue;
本页__本頁 173.121277629|ben ye;
本已__本已 137.476305203|ben yi;
本意__本意 550.284199441|ben yi;
本应__本應 327.26932246|ben ying;
本网__本網 5001.01269948|ben wang;
本文__本文 4588.96700128|ben wen;
本位__本位 170.551683166|ben wei;
本无__本無 132.10198647|ben wu;
本案__本案 657.626195507|ben an;
蚌埠__蚌埠 230.295783987|beng bu;
崩盘__崩盤 395.027185582|beng pan;
迸发__迸發 222.398727024|beng fa;
绷带__繃帶 467.400766428|beng dai;
崩塌__崩塌 125.053659829|beng ta;
崩溃__崩潰 2551.57427517|beng kui;
绷紧__繃緊 147.229226029|beng jin;
泵站__泵站 124.587019602|beng zhan;
蹦出__蹦出 161.451865638|beng chu;
背板__背板 157.2815571|bei ban;
背包__背包 863.977854874|bei bao;
背背__背背 133.093414711|bei bei;
北北__北北 329.725485744|bei bei;
贝贝__貝貝 816.861571886|bei bei;
被逼__被逼 411.098117295|bei bi;
卑鄙__卑鄙 534.069978074|bei bi;
北边__北邊 335.946843682|bei bian;
被捕__被捕 553.723632203|bei bu;
背部__背部 604.948616891|bei bu;
北部__北部 1150.74567978|bei bu;
被判__被判 733.846096172|bei pan;
背叛__背叛 1122.41972073|bei pan;
被骗__被騙 674.222387052|bei pian;
北漂__北漂 123.658956482|bei piao;
倍频__倍頻 121.671800659|bei pin;
北平__北平 296.585723861|bei ping;
被迫__被迫 1687.0530669|bei po;
被埋__被埋 143.0692679|bei mai;
北门__北門 310.580912674|bei men;
北美__北美 1250.95005139|bei mei;
北面__北面 356.655002599|bei mian;
背面__背面 994.623178167|bei mian;
悲悯__悲憫 112.625137786|bei min;
北伐__北伐 129.010924378|bei fa;
被罚__被罰 248.175085992|bei fa;
北方__北方 3193.1902591|bei fang;
辈份__輩份 127.572086295|bei fen;
悲愤__悲憤 241.764712994|bei fen;
备份__備份 4687.22055578|bei fen;
北风__北風 243.57916235|bei feng;
被封__被封 651.102673334|bei feng;
北非__北非 122.584950132|bei fei;
被俘__被俘 138.335571213|bei fu;
背负__背負 513.831666385|bei fu;
被打__被打 709.565515965|bei da;
北大__北大 2857.97028226|bei da;
被盗__被盜 840.61307342|bei dao;
倍的__倍的 303.313611771|bei de;
北电__北電 182.651055928|bei dian;
北斗__北斗 256.347723437|bei dou;
被动__被動 1918.1063189|bei dong;
背对__背對 182.878811433|bei dui;
被他__被他 1000.83985593|bei ta;
被套__被套 534.735933039|bei tao;
被偷__被偷 271.133768339|bei tou;
悲痛__悲痛 508.734557585|bei tong;
被你__被你 1276.14264248|bei ni;
北仑__北侖 187.727829225|bei lun;
悖论__悖論 222.67604562|bei lun;
贝勒__貝勒 126.621787068|bei le;
贝利__貝利 210.795122809|bei li;
背离__背離 440.262469534|bei li;
悲凉__悲涼 291.093289619|bei liang;
卑劣__卑劣 189.608710238|bei lie;
背篓__背簍 109.170488754|bei lou;
北路__北路 610.248767154|bei lu;
被关__被關 208.70407676|bei guan;
悲观__悲觀 868.29524729|bei guan;
背光__背光 250.349428094|bei guang;
倍感__倍感 546.185068786|bei gan;
被告__被告 1788.81445378|bei gao;
北国__北國 162.258658377|bei guo;
被困__被困 416.772181646|bei kun;
被砍__被砍 119.86585751|bei kan;
背靠__背靠 162.663565352|bei kao;
备考__備考 302.558594526|bei kao;
贝克__貝克 159.253810404|bei ke;
备课__備課 343.567617462|bei ke;
贝壳__貝殼 468.567137655|bei ke;
被扣__被扣 166.768626413|bei kou;
被控__被控 187.4940348|bei kong;
被害__被害 193.427195796|bei hai;
北海__北海 714.89082038|bei hai;
北韩__北韓 126.621787068|bei han;
北航__北航 409.054029297|bei hang;
备好__備好 124.742372548|bei hao;
被黑__被黑 127.096048509|bei hei;
背后__背後 5114.45798754|bei hou;
备货__備貨 145.224802174|bei huo;
被毁__被毀 163.680258901|bei hui;
北极__北極 490.066643104|bei ji;
倍加__倍加 125.678566729|bei jia;
备件__備件 374.41672986|bei jian;
北郊__北郊 131.445140637|bei jiao;
被叫__被叫 230.870473623|bei jiao;
北街__北街 126.306596357|bei jie;
被禁__被禁 193.90988203|bei jin;
背景__背景 8805.70682985|bei jing;
北京__北京 53176.5892785|bei jing;
杯酒__杯酒 138.163289429|bei jiu;
被拒__被拒 153.984619852|bei ju;
悲剧__悲劇 1899.07908248|bei ju;
背起__背起 125.678566729|bei qi;
北桥__北橋 129.817279349|bei qiao;
被抢__被搶 222.67604562|bei qiang;
悲情__悲情 360.677581637|bei qing;
北区__北區 300.304800557|bei qu;
被选__被選 244.186999878|bei xuan;
备选__備選 287.130256264|bei xuan;
悲喜__悲喜 108.087539034|bei xi;
被吓__被嚇 122.279808036|bei xia;
背心__背心 527.455873984|bei xin;
被抓__被抓 584.932834985|bei zhua;
被撞__被撞 190.081867665|bei zhuang;
悲壮__悲壯 341.859308876|bei zhuang;
被炸__被炸 135.604660605|bei zha;
北站__北站 196.341441156|bei zhan;
备战__備戰 698.163048348|bei zhan;
背着__背着 1300.22127911|bei zhe;
被指__被指 287.846772995|bei zhi;
杯中__杯中 189.845141544|bei zhong;
备注__備註 1710.33813502|bei zhu;
北川__北川 224.06783424|bei chuan;
杯茶__杯茶 188.901181552|bei cha;
北辰__北辰 274.533686805|bei chen;
被杀__被殺 512.55262135|bei sha;
北山__北山 122.737806611|bei shan;
被删__被刪 248.794392378|bei shan;
北上__北上 341.433560596|bei shang;
背上__背上 889.099334512|bei shang;
悲伤__悲傷 2028.7420046|bei shang;
倍受__倍受 309.4219738|bei shou;
备受__備受 925.270654393|bei shou;
背书__背書 227.443722742|bei shu;
倍数__倍數 347.00988711|bei shu;
杯水__杯水 155.333728851|bei shui;
被人__被人 5282.88186737|bei ren;
被褥__被褥 162.663565352|bei ru;
被砸__被砸 168.859844103|bei za;
倍增__倍增 233.765505073|bei zeng;
辈子__輩子 1166.62851836|bei zi;
被子__被子 1382.08969051|bei zi;
杯子__杯子 1392.46230328|bei zi;
悲惨__悲慘 793.781168439|bei can;
北侧__北側 255.391156791|bei ce;
杯赛__杯賽 180.839193473|bei sai;
北宋__北宋 313.302012384|bei song;
背诵__背誦 391.596284031|bei song;
北苑__北苑 120.46484039|bei yuan;
北约__北約 374.41672986|bei yue;
被压__被壓 118.824795093|bei ya;
北洋__北洋 172.690339006|bei yang;
背影__背影 1007.09538969|bei ying;
备有__備有 179.71591787|bei you;
北邮__北郵 245.101601395|bei you;
备用__備用 1071.84199596|bei yong;
北外__北外 137.305093541|bei wai;
备忘__備忘 128.689786556|bei wang;
被问__被問 109.989815613|bei wen;
北魏__北魏 111.507918629|bei wei;
北纬__北緯 170.551683166|bei wei;
卑微__卑微 317.230705235|bei wei;
被窝__被窩 386.746622582|bei wo;
被我__被我 1476.45426414|bei wo;
被爱__被愛 219.37092252|bei ai;
悲哀__悲哀 2216.42096948|bei ai;
北岸__北岸 170.551683166|bei an;
备案__備案 1910.94886689|bei an;
贝尔__貝爾 521.573243485|bei er;
北欧__北歐 463.341283758|bei ou;
臂膀__臂膀 120.015323434|bi bang;
必备__必備 1115.44785438|bi bei;
比比__比比 312.911829085|bi bi;
笔笔__筆筆 487.62990282|bi bi;
弊病__弊病 193.186303435|bi bing;
碧波__碧波 165.73274959|bi bo;
比拼__比拼 284.281980745|bi pin;
逼平__逼平 121.368931601|bi ping;
逼迫__逼迫 549.598880816|bi po;
闭门__閉門 158.067510349|bi men;
笔迷__筆迷 152.457122789|bi mi;
避免__避免 7930.54714563|bi mian;
笔名__筆名 257.62872122|bi ming;
笔墨__筆墨 285.346757867|bi mo;
闭幕__閉幕 465.076726846|bi mu;
笔法__筆法 127.73116145|bi fa;
比方__比方 644.643863216|bi fang;
比分__比分 1159.38205078|bi fen;
弊端__弊端 670.034480971|bi duan;
逼到__逼到 109.989815613|bi dao;
逼得__逼得 277.976239008|bi de;
彼得__彼得 431.033684153|bi de;
必定__必定 1425.82527204|bi ding;
必读__必讀 262.162833911|bi du;
比对__比對 349.614203755|bi dui;
比她__比她 397.001179899|bi ta;
比他__比他 764.653524665|bi ta;
比特__比特 351.799391968|bi te;
鼻涕__鼻涕 481.590928402|bi ti;
必填__必填 142.357889859|bi tian;
避难__避難 203.313241605|bi nan;
逼你__逼你 200.29551561|bi ni;
比拟__比擬 377.226735448|bi ni;
比你__比你 2376.61936257|bi ni;
碧绿__碧綠 210.532600599|bi lv;
比率__比率 812.799921236|bi lv;
壁垒__壁壘 347.442588754|bi lei;
比例__比例 8356.67835714|bi li;
鼻梁__鼻樑 219.644465616|bi liang;
秘鲁__秘魯 244.186999878|bi lu;
笔录__筆錄 301.805456692|bi lu;
闭关__閉關 271.810366771|bi guan;
避开__避開 992.147332631|bi kai;
必看__必看 273.168633085|bi kan;
闭口__閉口 112.765574943|bi kou;
鼻孔__鼻孔 354.881620091|bi kong;
笔划__筆劃 112.484875527|bi hua;
比划__比劃 196.096919422|bi hua;
笔画__筆畫 333.444336783|bi hua;
壁画__壁畫 354.43965395|bi hua;
闭环__閉環 115.467403456|bi huan;
碧海__碧海 163.680258901|bi hai;
闭合__閉合 239.664931108|bi he;
壁虎__壁虎 168.859844103|bi hu;
庇护__庇護 236.991986692|bi hu;
避讳__避諱 154.368879448|bi hui;
笔迹__筆跡 131.117943492|bi ji;
笔记__筆記 1664.08500884|bi ji;
比价__比價 415.216987933|bi jia;
鼻尖__鼻尖 115.611384758|bi jian;
比肩__比肩 170.977284899|bi jian;
比较__比較 72343.1933673|bi jiao;
必将__必將 1643.47641462|bi jiang;
逼近__逼近 622.538424634|bi jin;
必经__必經 180.389043185|bi jing;
毕竟__畢竟 11047.4796329|bi jing;
必究__必究 265.119670945|bi jiu;
比起__比起 1725.32295995|bi qi;
比前__比前 162.460985719|bi qian;
笔钱__筆錢 287.846772995|bi qian;
鼻腔__鼻腔 228.580284053|bi qiang;
比丘__比丘 110.401782066|bi qiu;
鼻血__鼻血 231.158356006|bi xue;
陛下__陛下 410.07479966|bi xia;
笔下__筆下 548.230802969|bi xia;
必先__必先 169.703655326|bi xian;
避险__避險 172.475272126|bi xian;
辟邪__辟邪 121.975425508|bi xie;
必修__必修 242.066179876|bi xiu;
必需__必需 1033.79844744|bi xu;
必须__必須 34984.542125|bi xu;
笔账__筆賬 126.464093517|bi zhang;
比照__比照 186.32942291|bi zhao;
闭着__閉着 144.502706249|bi zhe;
逼着__逼着 432.109303457|bi zhe;
笔者__筆者 4061.41172752|bi zhe;
逼真__逼真 461.037428991|bi zhen;
比值__比值 211.321149687|bi zhi;
笔直__筆直 253.488718522|bi zhi;
壁纸__壁紙 1114.0586864|bi zhi;
币种__幣種 163.069482749|bi zhong;
比重__比重 1920.49808867|bi zhong;
笔触__筆觸 153.41002317|bi chu;
必杀__必殺 268.778909483|bi sha;
壁上__壁上 137.647730357|bi shang;
闭上__閉上 443.014235191|bi shang;
比上__比上 566.990680223|bi shang;
毕生__畢生 259.885889675|bi sheng;
必胜__必勝 347.442588754|bi sheng;
彼时__彼時 107.684208225|bi shi;
比试__比試 119.86585751|bi shi;
必是__必是 140.244908425|bi shi;
笔试__筆試 1301.84258129|bi shi;
鄙视__鄙視 3532.33803061|bi shi;
匕首__匕首 788.850627646|bi shou;
避暑__避暑 257.62872122|bi shu;
避税__避稅 147.780672558|bi shui;
比谁__比誰 186.097370046|bi shui;
碧水__碧水 228.295612376|bi shui;
必然__必然 5714.34823089|bi ran;
鄙人__鄙人 283.574337601|bi ren;
逼人__逼人 444.119751258|bi ren;
比如__比如 18414.3558949|bi ru;
鼻子__鼻子 2516.83636014|bi zi;
鼻祖__鼻祖 140.594881376|bi zu;
比作__比作 226.030964922|bi zuo;
闭嘴__閉嘴 372.555031371|bi zui;
彼此__彼此 4829.52331536|bi ci;
比萨__比薩 179.268563673|bi sa;
比赛__比賽 16729.5355476|bi sai;
闭塞__閉塞 210.008536601|bi se;
必死__必死 189.608710238|bi si;
闭锁__閉鎖 106.350610398|bi suo;
碧云__碧雲 264.789493468|bi yun;
避孕__避孕 470.32215416|bi yun;
闭眼__閉眼 219.37092252|bi yan;
鼻炎__鼻炎 321.609191441|bi yan;
必要__必要 10162.547614|bi yao;
毕业__畢業 13911.8794748|bi ye;
鄙夷__鄙夷 181.969489867|bi yi;
必有__必有 722.053448193|bi you;
碧玉__碧玉 170.76435144|bi yu;
比喻__比喻 1298.60199609|bi yu;
逼我__逼我 435.352293046|bi wo;
比我__比我 4914.52006126|bi wo;
笔误__筆誤 112.204874836|bi wu;
比武__比武 258.271618599|bi wu;
彼岸__彼岸 537.40806734|bi an;
比尔__比爾 460.463257431|bi er;
便把__便把 233.474375771|bian ba;
变白__變白 137.476305203|bian bai;
便被__便被 234.056997396|bian bei;
边边__邊邊 167.601987591|bian bian;
便便__便便 191.031727675|bian bian;
辨别__辨別 564.874943184|bian bie;
遍布__遍布 729.287839744|bian bu;
编排__編排 484.601008682|bian pai;
鞭炮__鞭炮 269.114061535|bian pao;
变频__變頻 218.008308584|bian pin;
扁平__扁平 207.666345181|bian ping;
边坡__邊坡 146.679837233|bian po;
编码__編碼 3229.20506361|bian ma;
变卖__變賣 178.59961945|bian mai;
变慢__變慢 178.155043976|bian man;
便秘__便秘 728.379591714|bian mi;
便民__便民 251.287110964|bian min;
变法__變法 153.601316766|bian fa;
边防__邊防 309.807805448|bian fang;
边锋__邊鋒 157.085680168|bian feng;
蝙蝠__蝙蝠 482.191444969|bian fu;
变大__變大 459.889800938|bian da;
便当__便當 195.365179853|bian dang;
编导__編導 365.655730945|bian dao;
变的__變的 800.735741689|bian de;
变得__變得 7910.80619229|bian de;
贬低__貶低 412.12398856|bian di;
遍地__遍地 506.204995518|bian di;
变动__變動 2159.17072182|bian dong;
边度__邊度 451.373158744|bian du;
编队__編隊 201.296414343|bian dui;
变态__變態 5296.06498953|bian tai;
变通__變通 255.709615075|bian tong;
变暖__變暖 158.461958559|bian nuan;
便能__便能 324.83145542|bian neng;
辩论__辯論 1045.45827538|bian lun;
变老__變老 163.272821143|bian lao;
变了__變了 1593.06462986|bian le;
遍历__遍歷 298.439468992|bian li;
便利__便利 1454.53963438|bian li;
变脸__變臉 253.488718522|bian lian;
变量__變量 2367.75095999|bian liang;
边路__邊路 236.696839161|bian lu;
边个__邊個 692.099342424|bian ge;
变革__變革 1538.43695969|bian ge;
变更__變更 3015.29249908|bian geng;
变故__變故 286.772667017|bian gu;
边框__邊框 650.291796355|bian kuang;
边看__邊看 302.558594526|bian kan;
便可__便可 840.61307342|bian ke;
变化__變化 17215.9724212|bian hua;
变幻__變幻 277.284292303|bian huan;
变换__變換 1265.05905145|bian huan;
变黄__變黃 105.295633316|bian huang;
变坏__變壞 241.162905094|bian huai;
变好__變好 184.71110921|bian hao;
编号__編號 3612.46722234|bian hao;
变黑__變黑 181.290467084|bian hei;
变红__變紅 106.483223576|bian hong;
辩护__辯護 603.442760838|bian hu;
变回__變回 159.85029497|bian hui;
便会__便會 1008.35118051|bian hui;
遍及__遍及 301.805456692|bian ji;
边际__邊際 324.426913464|bian ji;
编辑__編輯 7554.33474859|bian ji;
边角__邊角 155.333728851|bian jiao;
变焦__變焦 327.26932246|bian jiao;
边疆__邊疆 240.562595233|bian jiang;
便将__便將 241.162905094|bian jiang;
辩解__辯解 460.463257431|bian jie;
便捷__便捷 924.118331259|bian jie;
边界__邊界 1121.02187006|bian jie;
边境__邊境 819.921123923|bian jing;
编剧__編劇 1132.25360251|bian ju;
变迁__變遷 667.534233933|bian qian;
边区__邊區 115.755545596|bian qu;
编曲__編曲 285.702569086|bian qu;
辨析__辨析 145.587202159|bian xi;
边线__邊線 120.615053212|bian xian;
变现__變現 286.058823982|bian xian;
变小__變小 345.284462654|bian xiao;
便向__便向 111.786180106|bian xiang;
变相__變相 621.763121294|bian xiang;
便携__便攜 1045.45827538|bian xie;
编写__編寫 2609.45536768|bian xie;
变心__變心 216.924313917|bian xin;
变性__變性 449.688850794|bian xing;
变形__變形 2326.80064863|bian xing;
编撰__編撰 118.381397999|bian zhuan;
编者__編者 177.711575153|bian zhe;
辨证__辨證 250.349428094|bian zheng;
辩证__辯證 295.479008313|bian zheng;
便知__便知 130.791560815|bian zhi;
变质__變質 462.764242999|bian zhi;
编织__編織 518.333511609|bian zhi;
贬值__貶值 867.213880777|bian zhi;
编制__編製 2590.0172328|bian zhi;
变种__變種 335.528458728|bian zhong;
变差__變差 123.658956482|bian cha;
变长__變長 107.14877401|bian chang;
便成__便成 173.986383704|bian cheng;
编成__編成 183.335174792|bian cheng;
编程__編程 2937.40736593|bian cheng;
变成__變成 13739.590032|bian cheng;
边吃__邊吃 230.582949765|bian chi;
边上__邊上 2023.69199978|bian shang;
变身__變身 688.658042404|bian shen;
辨识__辨識 224.907079496|bian shi;
便是__便是 2829.61978067|bian shi;
变数__變數 407.527636023|bian shu;
边说__邊說 310.580912674|bian shuo;
辨认__辨認 415.734739962|bian ren;
编入__編入 125.053659829|bian ru;
编纂__編纂 155.527421199|bian zuan;
便在__便在 268.778909483|bian zai;
编造__編造 326.454673948|bian zao;
鞭子__鞭子 238.770616634|bian zi;
辫子__辮子 349.178797604|bian zi;
鞭策__鞭策 168.020228531|bian ce;
变色__變色 444.673543393|bian se;
变速__變速 199.051387821|bian su;
边远__邊遠 143.247667161|bian yuan;
边缘__邊緣 2244.21407924|bian yuan;
边沿__邊沿 110.677283245|bian yan;
变样__變樣 140.244908425|bian yang;
便要__便要 167.393257695|bian yao;
便以__便以 118.529012887|bian yi;
贬义__貶義 137.819369268|bian yi;
便已__便已 141.473639374|bian yi;
便衣__便衣 159.055477247|bian yi;
变异__變異 650.291796355|bian yi;
编译__編譯 2498.08815496|bian yi;
便又__便又 120.015323434|bian you;
便有__便有 398.985038482|bian you;
便于__便於 1891.99263098|bian yu;
变味__變味 146.679837233|bian wei;
变为__變為 1351.43315497|bian wei;
表白__表白 1007.09538969|biao bai;
标榜__標榜 396.506758465|biao bang;
标本__標本 553.034030141|biao ben;
标兵__標兵 179.71591787|biao bing;
标牌__標牌 188.430963124|biao pai;
标配__標配 340.15949445|biao pei;
表皮__表皮 354.881620091|biao pi;
表妹__表妹 806.745280603|biao mei;
表面__表面 5829.42815609|biao mian;
标明__標明 680.977550057|biao ming;
表明__表明 7098.00112903|biao ming;
标段__標段 142.891090816|biao duan;
表达__表達 8161.13995251|biao da;
表单__表單 856.474009391|biao dan;
标的__標的 467.400766428|biao di;
表弟__表弟 574.10053635|biao di;
标点__標點 252.54282031|biao dian;
标定__標定 143.963491517|biao ding;
表态__表態 1019.7239982|biao tai;
标题__標題 4127.74310357|biao ti;
表头__表頭 132.266710153|biao tou;
表里__表裡 147.964946673|biao li;
表露__表露 295.847453874|biao lu;
标杆__標杆 279.713669565|biao gan;
标高__標高 155.72135507|biao gao;
表哥__表哥 757.068312494|biao ge;
表格__表格 3306.57582432|biao ge;
彪悍__彪悍 395.519762073|biao han;
标号__標號 211.584655172|biao hao;
表决__表決 782.974388071|biao jue;
标记__標記 2113.91016801|biao ji;
标价__標價 382.433299725|biao jia;
表姐__表姐 579.852559389|biao jie;
标签__標籤 3406.96257996|biao qian;
表情__表情 6660.92739064|biao qing;
表现__表現 18785.19831|biao xian;
表象__表象 400.978810625|biao xiang;
标准__標準 22561.7435501|biao zhun;
表彰__表彰 920.669965262|biao zhang;
表征__表徵 272.488653616|biao zheng;
标识__標識 124.276893895|biao zhi;
标致__標緻 357.099731154|biao zhi;
标志__標誌 5191.51429493|biao zhi;
表中__表中 528.113581536|biao zhong;
标注__標註 1153.6172982|biao zhu;
飚车__飈車 158.857391092|biao che;
标称__標稱 162.258658377|biao cheng;
标尺__標尺 149.633788238|biao chi;
标出__標出 183.335174792|biao chu;
表率__表率 221.292902041|biao shuai;
飙升__飆升 598.94764591|biao sheng;
标示__標示 362.479927203|biao shi;
标识__標識 2175.37534439|biao shi;
表示__表示 30351.420835|biao shi;
标书__標書 415.216987933|biao shu;
表述__表述 1100.26180506|biao shu;
婊子__婊子 636.660374558|biao zi;
表层__表層 282.164331387|biao ceng;
表演__表演 5836.6971223|biao yan;
表扬__表揚 1233.91923358|biao yang;
标有__標有 145.587202159|biao you;
标语__標語 525.487661863|biao yu;
别把__別把 382.433299725|bie ba;
别怕__別怕 214.504991945|bie pa;
别买__別買 168.020228531|bie mai;
别名__別名 292.912705474|bie ming;
别打__別打 165.114314527|bie da;
别的__別的 9728.82699329|bie de;
别动__別動 192.945711079|bie dong;
别太__別太 297.325836157|bie tai;
别提__別提 431.033684153|bie ti;
别拿__別拿 140.945727665|bie na;
别扭__彆扭 943.904464128|bie niu;
别来__別來 187.727829225|bie lai;
别离__別離 239.366454718|bie li;
别管__別管 266.444503116|bie guan;
别怪__別怪 153.218967809|bie guai;
别个__別個 832.274357505|bie ge;
别国__別國 198.803491145|bie guo;
别看__別看 546.866130582|bie kan;
别克__別克 326.048110451|bie ke;
别哭__別哭 274.876014738|bie ku;
别急__別急 597.456727653|bie ji;
别家__別家 191.98633424|bie jia;
蹩脚__蹩腳 154.561368684|bie jiao;
别具__別具 112.765574943|bie ju;
憋屈__憋屈 129.010924378|bie qu;
别去__別去 353.998238229|bie qu;
别想__別想 562.76710106|bie xiang;
憋着__憋着 205.60633599|bie zhe;
别致__別緻 365.655730945|bie zhi;
别处__別處 458.745029596|bie chu;
别墅__別墅 2461.00967693|bie shu;
别说__別說 1815.76539105|bie shuo;
别让__別讓 546.866130582|bie rang;
别人__別人 40576.9479846|bie ren;
别在__別在 235.813600182|bie zai;
别再__別再 620.98878351|bie zai;
别走__別走 203.820597887|bie zou;
憋死__憋死 162.86639759|bie si;
别样__別樣 356.210827905|bie yang;
别有__別有 315.653350706|bie you;
别用__別用 217.465635832|bie yong;
别忘__別忘 734.761160623|bie wang;
别问__別問 139.547573842|bie wen;
别无__別無 137.476305203|bie wu;
彬彬__彬彬 156.109948588|bin bin;
缤纷__繽紛 377.697115787|bin fen;
宾得__賓得 199.548108896|bin de;
宾利__賓利 123.197520618|bin li;
濒临__瀕臨 287.846772995|bin lin;
宾馆__賓館 3541.1527732|bin guan;
宾客__賓客 324.83145542|bin ke;
滨海__濱海 487.02261325|bin hai;
滨江__濱江 361.12732612|bin jiang;
滨州__濱州 128.209578049|bin zhou;
殡葬__殯葬 136.282292017|bin zang;
宾语__賓語 117.792774542|bin yu;
濒危__瀕危 122.432284019|bin wei;
并把__並把 561.366244489|bing ba;
并报__並報 120.615053212|bing bao;
冰雹__冰雹 207.925293333|bing bao;
并被__並被 348.743933702|bing bei;
病变__病變 925.270654393|bing bian;
冰冰__冰冰 481.590928402|bing bing;
并不__並不 15048.0979626|bing bu;
并排__並排 190.793818607|bing pai;
兵马__兵馬 138.335571213|bing ma;
并没__並沒 765.607004232|bing mei;
病魔__病魔 185.402943996|bing mo;
冰法__冰法 131.117943492|bing fa;
兵法__兵法 167.601987591|bing fa;
并发__併發 666.702893247|bing fa;
病房__病房 745.831342837|bing fang;
冰封__冰封 233.183609039|bing feng;
并非__並非 5063.7235729|bing fei;
病倒__病倒 148.149450567|bing dao;
冰岛__冰島 263.472890441|bing dao;
冰点__冰點 204.07475061|bing dian;
冰冻__冰凍 427.82286438|bing dong;
病毒__病毒 8377.53195835|bing du;
并对__並對 1301.84258129|bing dui;
兵团__兵團 607.214449729|bing tuan;
病态__病態 371.627656329|bing tai;
冰糖__冰糖 301.805456692|bing tang;
病痛__病痛 329.725485744|bing tong;
并能__並能 575.5331706|bing neng;
槟榔__檳榔 116.044406778|bing lang;
冰冷__冰冷 1104.38283164|bing leng;
病历__病歷 352.238065853|bing li;
病理__病理 564.874943184|bing li;
兵力__兵力 620.215410078|bing li;
病例__病例 938.041438335|bing li;
并联__並聯 201.045721733|bing lian;
冰凉__冰涼 491.902185928|bing liang;
并列__並列 481.590928402|bing lie;
冰龙__冰龍 135.435779871|bing long;
冰棍__冰棍 235.813600182|bing gun;
饼干__餅乾 885.781642601|bing gan;
并给__並給 114.893269147|bing gei;
并购__併購 1467.28332601|bing gou;
冰块__冰塊 318.815941979|bing kuai;
并可__並可 452.499534015|bing ke;
并口__並口 124.742372548|bing kou;
病患__病患 128.850255419|bing huan;
病害__病害 273.850309404|bing hai;
冰河__冰河 200.29551561|bing he;
冰火__冰火 179.71591787|bing huo;
病菌__病菌 290.730764849|bing jun;
病假__病假 274.533686805|bing jia;
并肩__並肩 260.209952636|bing jian;
并将__並將 1937.32419285|bing jiang;
并经__並經 225.187525865|bing jing;
并举__並舉 296.585723861|bing ju;
摒弃__摒棄 300.679263607|bing qi;
兵器__兵器 536.070335228|bing qi;
并且__並且 17738.6447289|bing qie;
并请__並請 144.322743975|bing qing;
病情__病情 1621.10162248|bing qing;
冰雪__冰雪 750.493000864|bing xue;
并向__並向 658.446218066|bing xiang;
冰箱__冰箱 2011.12191579|bing xiang;
冰心__冰心 229.150692759|bing xin;
并行__并行 619.442999798|bing xing;
冰镇__冰鎮 111.230349808|bing zhen;
病症__病症 401.979429753|bing zheng;
病重__病重 163.476413088|bing zhong;
兵种__兵種 293.643651968|bing zhong;
并重__並重 315.260239073|bing zhong;
冰川__冰川 410.07479966|bing chuan;
病床__病床 345.715012791|bing chuang;
病程__病程 168.020228531|bing cheng;
并称__並稱 238.770616634|bing cheng;
秉承__秉承 480.991159713|bing cheng;
秉持__秉持 119.716577729|bing chi;
病虫__病蟲 143.605133321|bing chong;
并处__並處 131.609045271|bing chu;
冰霜__冰霜 196.341441156|bing shuang;
冰山__冰山 301.054193591|bing shan;
病史__病史 217.736803143|bing shi;
病逝__病逝 246.94109417|bing shi;
并使__並使 350.050152834|bing shi;
冰水__冰水 185.634130949|bing shui;
并让__並讓 142.535402072|bing rang;
病人__病人 5133.61417128|bing ren;
并入__併入 282.516174301|bing ru;
并在__並在 2648.77038315|bing zai;
病灶__病灶 211.848489234|bing zao;
饼子__餅子 112.484875527|bing zi;
并作__並作 183.792676978|bing zuo;
并存__並存 529.431458035|bing cun;
并从__並從 207.407719521|bing cong;
病死__病死 219.097720093|bing si;
病原__病原 114.037415895|bing yuan;
并已__並已 240.562595233|bing yi;
并以__並以 731.107734818|bing yi;
病因__病因 574.10053635|bing yin;
兵营__兵營 188.901181552|bing ying;
病友__病友 107.14877401|bing you;
并由__並由 417.812212206|bing you;
并有__並有 546.185068786|bing you;
并用__並用 523.526794166|bing yong;
并于__並於 299.93080386|bing yu;
并与__並與 707.799244422|bing yu;
病危__病危 149.261315371|bing wei;
并为__並為 498.070459751|bing wei;
并未__並未 2427.50473612|bing wei;
并无__並無 1185.68201014|bing wu;
并按__並按 248.794392378|bing an;
冰儿__冰兒 144.322743975|bing er;
波霸__波霸 113.611883002|bo ba;
播报__播報 288.924902033|bo bao;
伯伯__伯伯 396.012952778|bo bo;
波波__波波 617.131535882|bo bo;
剥皮__剝皮 245.71323808|bo pi;
薄膜__薄膜 497.450167612|bo mo;
伯母__伯母 143.963491517|bo mu;
播放__播放 4823.50867368|bo fang;
伯父__伯父 209.485777119|bo fu;
拨付__撥付 234.348853194|bo fu;
波段__波段 634.284663664|bo duan;
博大__博大 322.010219858|bo da;
拨打__撥打 1643.47641462|bo da;
博导__博導 171.831677206|bo dao;
波导__波導 264.130371602|bo dao;
博得__博得 340.583654043|bo de;
搏斗__搏鬥 317.626273928|bo dou;
拨动__撥動 135.098649108|bo dong;
波动__波動 2464.07841638|bo dong;
剥夺__剝奪 903.620192345|bo duo;
波涛__波濤 184.251320835|bo tao;
波特__波特 290.368691563|bo te;
拨通__撥通 391.596284031|bo tong;
拨弄__撥弄 107.952927857|bo nong;
博览__博覽 199.796934068|bo lan;
波澜__波瀾 373.950434882|bo lan;
波兰__波蘭 722.953807881|bo lan;
波浪__波浪 378.168082664|bo lang;
伯乐__伯樂 233.183609039|bo le;
波里__波里 454.194369369|bo li;
剥离__剝離 494.9767145|bo li;
玻璃__玻璃 3778.21990214|bo li;
柏林__柏林 694.691597986|bo lin;
剥落__剝落 108.492380517|bo luo;
波罗__波羅 206.376433771|bo luo;
菠萝__菠蘿 566.284555508|bo luo;
博格__博格 121.823518492|bo ge;
伯格__伯格 147.596627936|bo ge;
拨款__撥款 447.452879516|bo kuan;
拨开__撥開 216.384339476|bo kai;
博克__博克 136.792736844|bo ke;
播客__播客 706.917758081|bo ke;
博客__博客 17151.7306766|bo ke;
渤海__渤海 314.475483928|bo hai;
拨号__撥號 1018.45404378|bo hao;
薄荷__薄荷 329.314848809|bo he;
博会__博會 291.819695868|bo hui;
驳回__駁回 387.711726118|bo hui;
伯爵__伯爵 270.796100963|bo jue;
搏击__搏擊 183.106850936|bo ji;
波及__波及 390.621510938|bo ji;
铂金__鉑金 210.532600599|bo jin;
脖颈__脖頸 120.765453341|bo jing;
勃起__勃起 487.62990282|bo qi;
博取__博取 128.209578049|bo qu;
博学__博學 201.79873775|bo xue;
剥削__剝削 665.043316617|bo xue;
波形__波形 360.228397261|bo xing;
波折__波折 275.905561849|bo zhe;
播种__播種 577.688827991|bo zhong;
波长__波長 310.968189453|bo chang;
驳斥__駁斥 192.225730308|bo chi;
拨出__撥出 153.028150386|bo chu;
播出__播出 1782.13945694|bo chu;
搏杀__搏殺 108.763116896|bo sha;
博世__博世 127.413209251|bo shi;
博时__博時 326.861744407|bo shi;
博士__博士 5089.02755683|bo shi;
薄弱__薄弱 824.018360007|bo ruo;
脖子__脖子 2266.69928918|bo zi;
博彩__博彩 263.472890441|bo cai;
菠菜__菠菜 387.22887368|bo cai;
波斯__波斯 269.114061535|bo si;
博雅__博雅 139.200207879|bo ya;
博弈__博弈 885.781642601|bo yi;
播音__播音 190.081867665|bo yin;
波音__波音 275.218769535|bo yin;
博友__博友 653.541376022|bo you;
波纹__波紋 127.413209251|bo wen;
博文__博文 607.214449729|bo wen;
泊位__泊位 149.633788238|bo wei;
博爱__博愛 353.998238229|bo ai;
波尔__波爾 155.140277726|bo er;
不把__不把 499.935980841|bu ba;
不败__不敗 393.063006485|bu bai;
不办__不辦 126.306596357|bu ban;
补办__補辦 310.194118206|bu ban;
不包__不包 105.0335283|bu bao;
不抱__不抱 112.765574943|bu bao;
不保__不保 161.653186955|bu bao;
不报__不報 197.814987883|bu bao;
不被__不被 884.6784987|bu bei;
不比__不比 634.284663664|bu bi;
不必__不必 4442.66586373|bu bi;
不便__不便 1408.16736736|bu bian;
不变__不變 2148.43475692|bu bian;
步兵__步兵 471.495815538|bu bing;
补补__補補 216.924313917|bu bu;
步步__步步 297.325836157|bu bu;
不怕__不怕 5101.72692692|bu pa;
不胖__不胖 216.384339476|bu pang;
不跑__不跑 180.164388413|bu pao;
不碰__不碰 149.261315371|bu peng;
不赔__不賠 168.859844103|bu pei;
不配__不配 445.783200166|bu pei;
补品__補品 151.699065864|bu pin;
不平__不平 530.752623218|bu ping;
不破__不破 134.594525802|bu po;
不卖__不賣 884.6784987|bu mai;
不买__不買 1782.13945694|bu mai;
不慢__不慢 131.609045271|bu man;
布满__布滿 478.003501869|bu man;
不满__不滿 3122.36117229|bu man;
不忙__不忙 1313.24844471|bu mang;
部门__部門 22646.2484782|bu men;
不美__不美 125.053659829|bu mei;
不免__不免 728.379591714|bu mian;
不妙__不妙 320.409100324|bu miao;
不灭__不滅 295.479008313|bu mie;
不明__不明 1274.55334676|bu ming;
补发__補發 262.162833911|bu fa;
不法__不法 443.014235191|bu fa;
不发__不發 566.990680223|bu fa;
不乏__不乏 866.133860988|bu fa;
步伐__步伐 2159.17072182|bu fa;
不烦__不煩 180.613978088|bu fan;
不凡__不凡 426.226434824|bu fan;
不放__不放 891.318029807|bu fang;
不妨__不妨 2367.75095999|bu fang;
部份__部份 992.147332631|bu fen;
不分__不分 1123.81931445|bu fen;
部分__部分 35467.4062758|bu fen;
布冯__布馮 154.754097942|bu feng;
不菲__不菲 448.010827873|bu fei;
不复__不復 188.196293023|bu fu;
不负__不負 372.091054935|bu fu;
部副__部副 397.001179899|bu fu;
不符__不符 758.957532109|bu fu;
不服__不服 952.17431607|bu fu;
不短__不短 155.72135507|bu duan;
不断__不斷 19068.2230252|bu duan;
不答__不答 126.621787068|bu da;
不打__不打 1411.68136652|bu da;
不大__不大 7479.39723763|bu da;
不戴__不戴 128.529517539|bu dai;
布袋__布袋 152.647228173|bu dai;
不带__不帶 1530.78744637|bu dai;
不单__不單 331.786363812|bu dan;
不但__不但 5063.7235729|bu dan;
不当__不當 1525.07528247|bu dang;
不倒__不倒 352.677286738|bu dao;
不到__不到 17258.9338717|bu dao;
不得__不得 9777.44301237|bu de;
不等__不等 789.834279627|bu deng;
不低__不低 382.910172354|bu di;
不敌__不敵 384.344361008|bu di;
布点__布點 118.23396695|bu dian;
步调__步調 106.483223576|bu diao;
不掉__不掉 998.348535653|bu diao;
不跌__不跌 204.329220247|bu die;
布丁__布丁 302.935867929|bu ding;
不定__不定 1261.91002891|bu ding;
补丁__補丁 3314.82719055|bu ding;
布兜__布兜 130.303509496|bu dou;
不动__不動 2326.80064863|bu dong;
不懂__不懂 8621.12153338|bu dong;
不读__不讀 212.907119447|bu du;
不多__不多 7368.38247395|bu duo;
部队__部隊 5969.09946282|bu dui;
不对__不對 6376.65009401|bu dui;
不太__不太 8729.22724991|bu tai;
不谈__不談 722.053448193|bu tan;
不疼__不疼 303.691826638|bu teng;
不提__不提 680.129467195|bu ti;
不跳__不跳 105.295633316|bu tiao;
不调__不調 168.020228531|bu tiao;
补贴__補貼 3083.69279052|bu tie;
不听__不聽 894.656458236|bu ting;
不停__不停 4253.06027768|bu ting;
不透__不透 165.939408926|bu tou;
不痛__不痛 229.436430673|bu tong;
不通__不通 1508.06636321|bu tong;
不同__不同 37559.930345|bu tong;
不脱__不脫 128.529517539|bu tuo;
布托__布托 211.321149687|bu tuo;
不妥__不妥 644.643863216|bu tuo;
不退__不退 249.726250867|bu tui;
不拿__不拿 265.450260135|bu na;
不耐__不耐 107.952927857|bu nai;
不难__不難 1768.86409398|bu nan;
不能__不能 80727.882192|bu neng;
不乱__不亂 267.109399762|bu luan;
不论__不論 2479.47960733|bu lun;
步履__步履 129.332863581|bu lv;
布拉__布拉 160.249192015|bu la;
不拉__不拉 204.839111844|bu la;
不赖__不賴 254.121284766|bu lai;
不来__不來 2930.09548433|bu lai;
布朗__布朗 433.727767276|bu lang;
捕捞__捕撈 188.901181552|bu lao;
不老__不老 293.643651968|bu lao;
不了__不了 1891.99263098|bu le;
不冷__不冷 226.312812713|bu leng;
布雷__布雷 162.258658377|bu lei;
不累__不累 617.131535882|bu lei;
不离__不離 312.132919672|bu li;
不力__不力 386.264972075|bu li;
不理__不理 1549.98296207|bu li;
不利__不利 1824.83897052|bu li;
不练__不練 129.010924378|bu lian;
布料__布料 371.627656329|bu liao;
不料__不料 583.476802811|bu liao;
不了__不了 8070.12007169|bu liao;
不亮__不亮 181.516526012|bu liang;
不良__不良 2216.42096948|bu liang;
不吝__不吝 160.249192015|bu lin;
不灵__不靈 341.433560596|bu ling;
不留__不留 542.11647303|bu liu;
不漏__不漏 132.762114633|bu lou;
不露__不露 112.484875527|bu lu;
补录__補錄 129.010924378|bu lu;
布鲁__布魯 134.930398555|bu lu;
不落__不落 149.820373083|bu luo;
部落__部落 2241.4191567|bu luo;
不惯__不慣 125.835280772|bu guan;
不关__不關 458.745029596|bu guan;
不管__不管 13963.9863686|bu guan;
不光__不光 1093.42757174|bu guang;
不怪__不怪 259.885889675|bu guai;
不乖__不乖 12358.6632862|bu guai;
补钙__補鈣 247.249015706|bu gai;
不改__不改 599.694499646|bu gai;
不该__不該 2272.35570445|bu gai;
不甘__不甘 391.596284031|bu gan;
不干__不幹 1111.28553845|bu gan;
不敢__不敢 10978.8586437|bu gan;
不搞__不搞 481.590928402|bu gao;
不高__不高 3229.20506361|bu gao;
不跟__不跟 547.548041623|bu gen;
补给__補給 107.282382453|bu gei;
不给__不給 2681.98499671|bu gei;
不够__不夠 13038.9685774|bu gou;
不公__不公 497.450167612|bu gong;
不顾__不顧 1901.44712636|bu gu;
不过__不過 103577.209102|bu guo;
不归__不歸 268.109857044|bu gui;
不贵__不貴 981.082073059|bu gui;
不快__不快 699.033618062|bu kuai;
不卡__不卡 405.501301397|bu ka;
不开__不開 1749.13623734|bu kai;
不堪__不堪 1114.0586864|bu kan;
不看__不看 2668.64946169|bu kan;
不靠__不靠 194.636170786|bu kao;
补考__補考 557.184562398|bu kao;
补课__補課 555.797602048|bu ke;
不可__不可 8191.70747243|bu ke;
不肯__不肯 2678.64487851|bu ken;
不扣__不扣 157.870654598|bu kou;
不哭__不哭 590.793388895|bu ku;
不亏__不虧 212.907119447|bu kui;
不愧__不愧 737.513205869|bu kui;
不花__不花 153.792848894|bu hua;
不还__不還 124.742372548|bu huan;
不换__不換 388.679238014|bu huan;
不慌__不慌 105.953760973|bu huang;
不坏__不壞 353.557372243|bu huai;
不含__不含 853.278059532|bu han;
不好__不好 30541.125848|bu hao;
不和__不和 353.117055307|bu he;
不喝__不喝 562.76710106|bu he;
不合__不合 1020.99553617|bu he;
不黑__不黑 175.729586548|bu hei;
补货__補貨 145.587202159|bu huo;
不活__不活 179.492101402|bu huo;
捕获__捕獲 499.3133654|bu huo;
不悔__不悔 167.601987591|bu hui;
不回__不回 1645.52573648|bu hui;
不会__不會 68739.8124933|bu hui;
不绝__不絕 236.991986692|bu jue;
不觉__不覺 525.487661863|bu jue;
不均__不均 193.427195796|bu jun;
部级__部級 136.622376491|bu ji;
布吉__布吉 170.551683166|bu ji;
不济__不濟 186.794397067|bu ji;
不羁__不羈 265.78126155|bu ji;
补给__補給 290.0070692|bu ji;
不计__不計 550.284199441|bu ji;
不及__不及 1152.18059436|bu ji;
不急__不急 2003.61737423|bu ji;
不嫁__不嫁 154.561368684|bu jia;
不假__不假 190.556205829|bu jia;
不加__不加 961.714332594|bu jia;
不佳__不佳 972.56115063|bu jia;
不减__不減 351.361264404|bu jian;
部件__部件 1645.52573648|bu jian;
不见__不見 5165.70071998|bu jian;
补缴__補繳 140.594881376|bu jiao;
补交__補交 186.794397067|bu jiao;
不交__不交 310.194118206|bu jiao;
不叫__不叫 1123.81931445|bu jiao;
不降__不降 139.72158175|bu jiang;
不讲__不講 532.077085292|bu jiang;
不洁__不潔 115.036534536|bu jie;
不接__不接 611.771607197|bu jie;
不解__不解 949.804135501|bu jie;
步进__步進 109.716025699|bu jin;
不进__不進 578.409173188|bu jin;
不尽__不盡 983.530305889|bu jin;
不禁__不禁 2033.8046114|bu jin;
不仅__不僅 15370.2901058|bu jin;
不敬__不敬 149.820373083|bu jing;
布景__布景 154.561368684|bu jing;
不经__不經 265.78126155|bu jing;
不救__不救 124.587019602|bu jiu;
补救__補救 380.531740742|bu jiu;
不就__不就 1609.02584897|bu jiu;
不久__不久 4799.5249195|bu jiu;
不惧__不懼 150.194241046|bu ju;
不具__不具 159.055477247|bu ju;
布局__布局 2989.10399336|bu ju;
不全__不全 728.379591714|bu quan;
不缺__不缺 464.497524783|bu que;
补气__補氣 107.684208225|bu qi;
补齐__補齊 181.742866823|bu qi;
不齐__不齊 199.548108896|bu qi;
不起__不起 2879.41941052|bu qi;
不浅__不淺 117.061109314|bu qian;
不巧__不巧 174.638049069|bu qiao;
步枪__步槍 316.046952528|bu qiang;
不强__不強 673.382717005|bu qiang;
不轻__不輕 233.474375771|bu qing;
不清__不清 1438.31738787|bu qing;
不求__不求 530.091629029|bu qiu;
不屈__不屈 179.045304336|bu qu;
不去__不去 8294.42849341|bu qu;
不选__不選 174.42055653|bu xuan;
不学__不學 305.589986932|bu xue;
补血__補血 424.635962376|bu xue;
不洗__不洗 127.254530072|bu xi;
不喜__不喜 202.302314677|bu xi;
不息__不息 268.444174826|bu xi;
补习__補習 354.881620091|bu xi;
不惜__不惜 1250.95005139|bu xi;
部下__部下 414.699880708|bu xia;
不下__不下 1212.57856995|bu xia;
不嫌__不嫌 195.60878915|bu xian;
布线__布線 520.274927886|bu xian;
不限__不限 756.125466931|bu xian;
不孝__不孝 193.90988203|bu xiao;
不笑__不笑 196.341441156|bu xiao;
不小__不小 1214.09058664|bu xiao;
不祥__不祥 188.430963124|bu xiang;
不相__不相 294.376422496|bu xiang;
不详__不詳 457.603107852|bu xiang;
不象__不象 737.513205869|bu xiang;
不像__不像 4174.29838181|bu xiang;
不想__不想 16834.0999031|bu xiang;
布鞋__布鞋 144.863304286|bu xie;
不谢__不謝 265.450260135|bu xie;
不懈__不懈 430.496878967|bu xie;
不写__不寫 488.237949645|bu xie;
不屑__不屑 987.214115061|bu xie;
不信__不信 3209.14698221|bu xin;
不醒__不醒 184.02185602|bu xing;
步行__步行 932.214830498|bu xing;
不幸__不幸 3462.60542812|bu xing;
不行__不行 23714.8721437|bu xing;
不休__不休 345.284462654|bu xiu;
不朽__不朽 356.210827905|bu xiu;
不须__不須 122.737806611|bu xu;
不需__不需 1098.89154964|bu xu;
不许__不許 2210.90378861|bu xu;
不赚__不賺 130.954650472|bu zhuan;
不转__不轉 155.527421199|bu zhuan;
不装__不裝 219.644465616|bu zhuang;
不准__不準 2794.57680777|bu zhun;
不沾__不沾 118.972962872|bu zhan;
布展__布展 126.306596357|bu zhan;
不占__不佔 129.171793682|bu zhan;
补涨__補漲 195.365179853|bu zhang;
不长__不長 239.068350048|bu zhang;
不涨__不漲 449.688850794|bu zhang;
部长__部長 3161.51444144|bu zhang;
不找__不找 289.645897197|bu zhao;
不着__不着 958.125676369|bu zhao;
不振__不振 133.925286409|bu zhen;
不正__不正 250.974160423|bu zheng;
不争__不爭 377.226735448|bu zheng;
不支__不支 114.179614083|bu zhi;
不治__不治 160.649084484|bu zhi;
不致__不致 213.704562287|bu zhi;
不值__不值 518.333511609|bu zhi;
不只__不只 587.123698784|bu zhi;
布置__布置 2210.90378861|bu zhi;
不止__不止 2692.03036174|bu zhi;
不知__不知 12607.5515214|bu zhi;
步骤__步驟 3294.23727064|bu zhou;
不忠__不忠 115.323601467|bu zhong;
不中__不中 118.23396695|bu zhong;
不重__不重 184.71110921|bu zhong;
补助__補助 1563.56286353|bu zhu;
不住__不住 3381.58372161|bu zhu;
捕捉__捕捉 1073.17852213|bu zhuo;
不穿__不穿 498.070459751|bu chuan;
不差__不差 501.808489233|bu cha;
不常__不常 143.247667161|bu chang;
不畅__不暢 364.291279287|bu chang;
不长__不長 557.879339939|bu chang;
补偿__補償 2609.45536768|bu chang;
不成__不成 2570.72389483|bu cheng;
不齿__不齒 148.519148841|bu chi;
不迟__不遲 254.755429543|bu chi;
不吃__不吃 2186.24593438|bu chi;
不愁__不愁 373.484720623|bu chou;
补充__補充 6250.76734939|bu chong;
不出__不出 4387.64638002|bu chu;
不爽__不爽 3064.53855293|bu shuang;
不顺__不順 458.745029596|bu shun;
不衰__不衰 141.826678552|bu shuai;
不帅__不帥 299.93080386|bu shuai;
捕杀__捕殺 118.08671951|bu sha;
不傻__不傻 133.42554153|bu sha;
不杀__不殺 319.213487372|bu sha;
不善__不善 392.084582382|bu shan;
不伤__不傷 109.170488754|bu shang;
补上__補上 802.733930815|bu shang;
不上__不上 3209.14698221|bu shang;
不少__不少 18691.7933617|bu shao;
不设__不設 232.024158785|bu she;
不舍__不舍 492.515560049|bu she;
不深__不深 197.076837307|bu shen;
补肾__補腎 274.191785204|bu shen;
不甚__不甚 385.78392141|bu shen;
不慎__不慎 521.573243485|bu shen;
不生__不生 134.594525802|bu sheng;
不胜__不勝 551.657401419|bu sheng;
捕食__捕食 106.483223576|bu shi;
布施__布施 142.713135632|bu shi;
不识__不識 299.1842072|bu shi;
不实__不實 318.418891685|bu shi;
不失__不失 637.454253928|bu shi;
不时__不時 1037.67053575|bu shi;
不适__不適 1265.05905145|bu shi;
布什__布什 1906.19207626|bu shi;
不是__不是 173509.133359|bu shi;
不守__不守 116.915322539|bu shou;
不收__不收 567.697685436|bu shou;
不受__不受 1784.36168375|bu shou;
不输__不輸 133.758497151|bu shu;
部属__部屬 161.451865638|bu shu;
不熟__不熟 736.594714048|bu shu;
部署__部署 4498.37527168|bu shu;
不说__不說 6586.63913914|bu shuo;
补水__補水 402.982545867|bu shui;
不睡__不睡 647.058374454|bu shui;
不然__不然 11994.5130843|bu ran;
不让__不讓 3726.78205719|bu rang;
不热__不熱 401.478808454|bu re;
不认__不認 376.756940916|bu ren;
不忍__不忍 620.98878351|bu ren;
不容__不容 702.526765976|bu rong;
不入__不入 138.335571213|bu ru;
哺乳__哺乳 276.938965124|bu ru;
步入__步入 1260.33845835|bu ru;
不如__不如 10965.1856792|bu ru;
不在__不在 7716.07926336|bu zai;
不再__不再 12343.2719264|bu zai;
不早__不早 422.52456065|bu zao;
步子__步子 287.846772995|bu zi;
不走__不走 1005.84116282|bu zou;
部族__部族 155.72135507|bu zu;
补足__補足 194.151676652|bu zu;
不足__不足 8232.64233612|bu zu;
不作__不作 659.267263146|bu zuo;
不做__不做 3209.14698221|bu zuo;
不存__不存 128.369448119|bu cun;
补仓__補倉 349.178797604|bu cang;
不测__不測 159.85029497|bu ce;
不曾__不曾 1122.41972073|bu ceng;
不错__不錯 46770.9882114|bu cuo;
不算__不算 5185.04883318|bu suan;
不散__不散 216.11485651|bu san;
不似__不似 174.203334854|bu si;
不思__不思 317.626273928|bu si;
不死__不死 1263.48355913|bu si;
不送__不送 272.149298879|bu song;
不俗__不俗 568.405572245|bu su;
不远__不遠 1820.2965272|bu yuan;
不愿__不願 3327.2428637|bu yuan;
不悦__不悅 180.839193473|bu yue;
不孕__不孕 259.238974004|bu yun;
不雅__不雅 381.006242235|bu ya;
不厌__不厭 126.937764318|bu yan;
不严__不嚴 182.651055928|bu yan;
不言__不言 322.813777494|bu yan;
不要__不要 65478.9063849|bu yao;
不也__不也 241.764712994|bu ye;
布艺__布藝 138.163289429|bu yi;
不以__不以 179.940013424|bu yi;
不一__不一 382.910172354|bu yi;
布衣__布衣 473.851932013|bu yi;
不已__不已 1441.90662463|bu yi;
不易__不易 1718.88488289|bu yi;
不宜__不宜 1877.89895902|bu yi;
不赢__不贏 125.36572391|bu ying;
不应__不應 1314.88599102|bu ying;
不由__不由 811.787668067|bu you;
不用__不用 30503.0902249|bu yong;
哺育__哺育 106.882056102|bu yu;
不育__不育 136.282292017|bu yu;
捕鱼__捕魚 202.302314677|bu yu;
不语__不語 400.479435488|bu yu;
不予__不予 903.620192345|bu yu;
不晚__不晚 167.184787749|bu wan;
不完__不完 1126.6237397|bu wan;
不玩__不玩 1432.95027783|bu wan;
不枉__不枉 114.46454262|bu wang;
不忘__不忘 805.740567825|bu wang;
不问__不問 551.657401419|bu wen;
不稳__不穩 617.901063897|bu wen;
不畏__不畏 179.71591787|bu wei;
不为__不為 499.935980841|bu wei;
部委__部委 584.204365283|bu wei;
部位__部位 2944.7374939|bu wei;
不误__不誤 149.075426771|bu wu;
不无__不無 176.168109435|bu wu;
不爱__不愛 1597.0400293|bu ai;
不按__不按 216.384339476|bu an;
不安__不安 1583.16937099|bu an;
不饿__不餓 414.699880708|bu e;
布尔__布爾 212.907119447|bu er;
不二__不二 265.450260135|bu er;
啪啪__啪啪 130.628674269|pa pa;
怕怕__怕怕 799.738513132|pa pa;
爬到__爬到 449.128812644|pa dao;
怕了__怕了 264.789493468|pa le;
怕冷__怕冷 173.553291634|pa leng;
爬过__爬過 122.890853693|pa guo;
帕克__帕克 236.402059204|pa ke;
趴下__趴下 233.183609039|pa xia;
爬行__爬行 246.94109417|pa xing;
趴着__趴着 280.761336094|pa zhe;
爬虫__爬蟲 139.547573842|pa chong;
爬出__爬出 136.622376491|pa chu;
怕啥__怕啥 203.060037258|pa sha;
爬山__爬山 845.867144221|pa shan;
爬上__爬上 686.088301175|pa shang;
怕是__怕是 411.610733326|pa shi;
趴在__趴在 843.76158662|pa zai;
怕死__怕死 352.677286738|pa si;
拍板__拍板 167.601987591|pai ban;
排版__排版 728.379591714|pai ban;
牌匾__牌匾 133.591915611|pai bian;
排便__排便 219.644465616|pai bian;
派别__派別 184.481071779|pai bie;
派兵__派兵 135.604660605|pai bing;
拍拍__拍拍 964.114234362|pai pai;
拍片__拍片 322.010219858|pai pian;
拍卖__拍賣 2436.59694626|pai mai;
排名__排名 4926.78395812|pai ming;
派发__派發 323.619340361|pai fa;
牌坊__牌坊 313.69268222|pai fang;
排放__排放 1260.33845835|pai fang;
拍打__拍打 261.83633885|pai da;
派到__派到 147.780672558|pai dao;
排到__排到 270.122027271|pai dao;
拍到__拍到 590.793388895|pai dao;
拍得__拍得 494.9767145|pai de;
拍的__拍的 1643.47641462|pai de;
排毒__排毒 681.82669043|pai du;
派对__派對 564.171453387|pai dui;
排队__排隊 2635.59999992|pai dui;
派头__派頭 109.852835359|pai tou;
拍拖__拍拖 409.054029297|pai tuo;
排尿__排尿 173.337150041|pai niao;
排卵__排卵 395.027185582|pai luan;
派来__派來 218.280152578|pai lai;
排练__排練 480.991159713|pai lian;
排量__排量 470.908619205|pai liang;
排列__排列 1427.60319527|pai lie;
排骨__排骨 705.158077415|pai gu;
拍过__拍過 303.691826638|pai guo;
派克__派克 107.550099352|pai ke;
徘徊__徘徊 1160.82773443|pai huai;
排汗__排汗 657.626195507|pai han;
排行__排行 874.811821743|pai hang;
排好__排好 107.550099352|pai hao;
拍好__拍好 137.476305203|pai hao;
牌号__牌號 190.556205829|pai hao;
排挤__排擠 240.862563142|pai ji;
排解__排解 139.547573842|pai jie;
排起__排起 114.607273411|pai qi;
排期__排期 152.267254161|pai qi;
排气__排氣 271.471856767|pai qi;
派遣__派遣 689.516759915|pai qian;
排球__排球 369.779825848|pai qiu;
派系__派系 175.729586548|pai xi;
拍戏__拍戲 689.516759915|pai xi;
拍下__拍下 796.754272909|pai xia;
排线__排線 106.218162376|pai xian;
排泄__排泄 314.867617017|pai xie;
排序__排序 1544.19916972|pai xu;
拍砖__拍磚 195.365179853|pai zhuan;
排长__排長 197.814987883|pai zhang;
牌照__牌照 1053.30446216|pai zhao;
拍照__拍照 2436.59694626|pai zhao;
排着__排着 140.419785869|pai zhe;
拍着__拍着 295.479008313|pai zhe;
派驻__派駐 236.696839161|pai zhu;
排查__排查 569.114341748|pai cha;
排场__排場 113.611883002|pai chang;
排成__排成 193.668388536|pai cheng;
拍成__拍成 275.218769535|pai cheng;
排斥__排斥 945.081459448|pai chi;
拍出__拍出 445.783200166|pai chu;
派出__派出 1143.59786783|pai chu;
排出__排出 1206.54931027|pai chu;
排除__排除 2966.83781195|pai chu;
拍摄__拍攝 7178.0568421|pai she;
派生__派生 137.647730357|pai sheng;
拍手__拍手 143.963491517|pai shou;
排水__排水 538.078184713|pai shui;
派人__派人 837.47630896|pai ren;
排入__排入 106.882056102|pai ru;
排在__排在 1019.7239982|pai zai;
拍子__拍子 312.132919672|pai zi;
牌子__牌子 4221.3787397|pai zi;
派送__派送 230.870473623|pai song;
派员__派員 144.322743975|pai yuan;
排外__排外 124.587019602|pai wai;
拍完__拍完 332.614317243|pai wan;
派往__派往 135.604660605|pai wang;
排位__排位 152.457122789|pai wei;
排污__排污 373.950434882|pai wu;
攀比__攀比 243.882891747|pan bi;
叛变__叛變 168.020228531|pan bian;
判别__判別 205.862715427|pan bie;
攀爬__攀爬 142.180598718|pan pa;
盼盼__盼盼 162.86639759|pan pan;
盘片__盤片 221.845125512|pan pian;
盘面__盤面 532.740555233|pan mian;
判罚__判罰 228.295612376|pan fa;
盘符__盤符 303.691826638|pan fu;
判断__判斷 8070.12007169|pan duan;
攀登__攀登 341.008342538|pan deng;
盘点__盤點 685.233853433|pan dian;
判定__判定 846.921892564|pan ding;
盼头__盼頭 110.539446825|pan tou;
叛徒__叛徒 269.114061535|pan tu;
叛逆__叛逆 528.113581536|pan ni;
叛乱__叛亂 198.803491145|pan luan;
盘里__盤裡 117.646076559|pan li;
攀钢__攀鋼 181.969489867|pan gang;
盘古__盤古 183.106850936|pan gu;
盘口__盤口 305.589986932|pan kou;
盘活__盤活 179.045304336|pan huo;
判决__判決 1472.77903036|pan jue;
叛军__叛軍 112.906187218|pan jun;
盘锦__盤錦 118.972962872|pan jin;
盘踞__盤踞 107.684208225|pan ju;
盘旋__盤旋 314.867617017|pan xuan;
判刑__判刑 394.043872187|pan xing;
盼着__盼着 350.92368248|pan zhe;
盘整__盤整 365.655730945|pan zheng;
盘中__盤中 953.361623425|pan zhong;
判处__判處 743.048258297|pan chu;
蹒跚__蹣跚 129.655606164|pan shan;
攀上__攀上 112.34478795|pan shang;
盘上__盤上 137.819369268|pan shang;
攀升__攀升 907.004698479|pan sheng;
磐石__磐石 146.314717429|pan shi;
盘子__盤子 843.76158662|pan zi;
盘算__盤算 286.772667017|pan suan;
攀岩__攀岩 178.822323044|pan yan;
番禺__番禺 500.559372647|pan yu;
盼望__盼望 828.13607043|pan wang;
盘问__盤問 130.791560815|pan wen;
旁白__旁白 129.817279349|pang bai;
旁边__旁邊 8621.12153338|pang bian;
胖胖__胖胖 696.425160166|pang pang;
庞大__龐大 2191.70158301|pang da;
旁听__旁聽 314.867617017|pang ting;
旁观__旁觀 230.870473623|pang guan;
膀胱__膀胱 341.859308876|pang guang;
彷徨__彷徨 410.07479966|pang huang;
螃蟹__螃蟹 943.904464128|pang xie;
旁人__旁人 461.61231651|pang ren;
胖子__胖子 2735.99686654|pang zi;
泡吧__泡吧 238.176261728|pao ba;
跑遍__跑遍 109.852835359|pao bian;
炮兵__炮兵 216.654158472|pao bing;
跑步__跑步 1368.37963334|pao bu;
抛盘__拋盤 177.711575153|pao pan;
跑跑__跑跑 1035.08753546|pao pao;
泡泡__泡泡 1436.52612129|pao pao;
跑马__跑馬 118.381397999|pao ma;
泡面__泡麵 540.767020614|pao mian;
泡沫__泡沫 2391.47390956|pao mo;
炮弹__炮彈 338.468131949|pao dan;
跑道__跑道 400.978810625|pao dao;
跑到__跑到 3072.18592933|pao dao;
跑得__跑得 428.890471272|pao de;
抛掉__拋掉 229.436430673|pao diao;
跑掉__跑掉 305.209408115|pao diao;
跑动__跑動 201.296414343|pao dong;
炮台__炮台 184.02185602|pao tai;
泡汤__泡湯 228.295612376|pao tang;
跑题__跑題 222.121753798|pao ti;
跑腿__跑腿 160.449013667|pao tui;
泡妞__泡妞 747.692521253|pao niu;
跑来__跑來 686.088301175|pao lai;
泡了__泡了 158.067510349|pao le;
跑了__跑了 2008.61728399|pao le;
跑路__跑路 411.098117295|pao lu;
抛光__拋光 280.761336094|pao guang;
跑过__跑過 338.468131949|pao guo;
跑开__跑開 148.519148841|pao kai;
抛开__拋開 584.932834985|pao kai;
炮轰__炮轟 258.271618599|pao hong;
炮火__炮火 196.096919422|pao huo;
炮灰__炮灰 226.030964922|pao hui;
跑回__跑回 229.722524886|pao hui;
跑进__跑進 224.06783424|pao jin;
抛弃__拋棄 2056.74313669|pao qi;
跑去__跑去 1276.14264248|pao qu;
抛下__拋下 172.260473089|pao xia;
咆哮__咆哮 371.164834837|pao xiao;
跑鞋__跑鞋 111.230349808|pao xie;
跑着__跑着 181.969489867|pao zhe;
疱疹__皰疹 175.510734618|pao zhen;
炮制__炮製 219.097720093|pao zhi;
泡茶__泡茶 193.427195796|pao cha;
跑车__跑車 801.734213733|pao che;
跑出__跑出 384.344361008|pao chu;
抛出__拋出 753.303969661|pao chu;
跑上__跑上 120.615053212|pao shang;
跑商__跑商 221.292902041|pao shang;
抛售__拋售 493.744603771|pao shou;
抛在__拋在 125.678566729|pao zai;
泡在__泡在 280.062456643|pao zai;
泡澡__泡澡 109.989815613|pao zao;
袍子__袍子 117.646076559|pao zi;
泡菜__泡菜 370.702589737|pao cai;
抛压__拋壓 107.14877401|pao ya;
跑完__跑完 174.42055653|pao wan;
跑位__跑位 112.34478795|pao wei;
喷墨__噴墨 128.689786556|pen mo;
盆地__盆地 456.464028614|pen di;
喷嚏__噴嚏 209.485777119|pen ti;
喷头__噴頭 180.389043185|pen tou;
喷涂__噴塗 213.704562287|pen tu;
盆里__盆里 114.037415895|pen li;
喷火__噴火 114.893269147|pen huo;
喷绘__噴繪 155.72135507|pen hui;
盆景__盆景 187.26053154|pen jing;
喷泉__噴泉 277.284292303|pen quan;
喷漆__噴漆 206.376433771|pen qi;
盆腔__盆腔 177.933171406|pen qiang;
喷血__噴血 127.096048509|pen xue;
喷出__噴出 435.352293046|pen chu;
喷射__噴射 314.867617017|pen she;
喷水__噴水 187.727829225|pen shui;
盆栽__盆栽 150.194241046|pen zai;
盆子__盆子 113.187937993|pen zi;
喷嘴__噴嘴 139.200207879|pen zui;
喷洒__噴洒 212.377144726|pen sa;
喷雾__噴霧 291.819695868|pen wu;
碰壁__碰壁 127.096048509|peng bi;
蓬勃__蓬勃 284.281980745|peng bo;
澎湃__澎湃 309.036622663|peng pai;
碰碰__碰碰 190.081867665|peng peng;
碰面__碰面 253.173026121|peng mian;
鹏飞__鵬飛 120.015323434|peng fei;
碰到__碰到 5127.22081778|peng dao;
烹调__烹調 296.216358865|peng tiao;
碰头__碰頭 401.478808454|peng tou;
蓬莱__蓬萊 226.312812713|peng lai;
碰了__碰了 200.545272755|peng le;
碰过__碰過 178.59961945|peng guo;
朋克__朋克 221.292902041|peng ke;
鹏华__鵬華 113.753550575|peng hua;
抨击__抨擊 440.262469534|peng ji;
碰见__碰見 511.276760152|peng jian;
捧起__捧起 159.452390871|peng qi;
碰巧__碰巧 334.69325133|peng qiao;
碰撞__碰撞 1173.92027842|peng zhuang;
膨胀__膨脹 1203.54593192|peng zhang;
捧着__捧着 487.02261325|peng zhe;
烹制__烹制 122.737806611|peng zhi;
捧场__捧場 675.904869515|peng chang;
碰触__碰觸 138.508067822|peng chu;
碰上__碰上 1077.19810837|peng shang;
烹饪__烹飪 627.992684885|peng ren;
蓬松__蓬鬆 129.010924378|peng song;
朋友__朋友 58897.8095035|peng you;
彭宇__彭宇 157.67404401|peng yu;
陪伴__陪伴 1250.95005139|pei ban;
赔本__賠本 145.405889264|pei ben;
配备__配備 2230.27423094|pei bei;
配比__配比 164.908682755|pei bi;
陪陪__陪陪 341.008342538|pei pei;
配发__配發 109.442917312|pei fa;
配方__配方 1422.27606545|pei fang;
赔付__賠付 319.611528482|pei fu;
佩服__佩服 3233.23169914|pei fu;
佩带__佩帶 164.703307075|pei dai;
佩戴__佩戴 387.711726118|pei dai;
配电__配電 173.337150041|pei dian;
配对__配對 362.479927203|pei dui;
陪他__陪他 349.614203755|pei ta;
陪她__陪她 491.902185928|pei ta;
胚胎__胚胎 375.819106356|pei tai;
配套__配套 3572.17795663|pei tao;
陪同__陪同 1145.0238695|pei tong;
陪你__陪你 1922.89284084|pei ni;
赔率__賠率 315.260239073|pei lv;
赔了__賠了 353.998238229|pei le;
陪练__陪練 144.143005824|pei lian;
配料__配料 304.449671797|pei liao;
培根__培根 113.32907693|pei gen;
配股__配股 308.267359529|pei gu;
赔款__賠款 211.584655172|pei kuan;
配合__配合 9302.01775845|pei he;
配角__配角 476.813641365|pei jue;
配件__配件 2702.11335163|pei jian;
赔钱__賠錢 601.191002133|pei qian;
培训__培訓 14586.5145357|pei xun;
陪着__陪着 931.053859154|pei zhe;
培植__培植 222.121753798|pei zhi;
配制__配製 375.351064872|pei zhi;
配置__配置 13808.2482753|pei zhi;
配种__配種 123.351140937|pei zhong;
赔偿__賠償 2708.85631718|pei chang;
陪衬__陪襯 143.784200776|pei chen;
配上__配上 644.643863216|pei shang;
配饰__配飾 195.365179853|pei shi;
配售__配售 445.228026075|pei shou;
配色__配色 310.968189453|pei se;
配送__配送 872.634214191|pei song;
配乐__配樂 402.982545867|pei yue;
培养__培養 7812.83608024|pei yang;
配以__配以 329.725485744|pei yi;
配音__配音 725.661628731|pei yin;
配有__配有 476.813641365|pei you;
培育__培育 2054.18168866|pei yu;
陪我__陪我 1695.48345672|pei wo;
配伍__配伍 119.26985293|pei wu;
配额__配額 565.579310193|pei e;
配偶__配偶 587.855808729|pei ou;
皮包__皮包 263.144763849|pi bao;
疲惫__疲憊 1269.79732551|pi bei;
批驳__批駁 109.30661816|pi bo;
枇杷__枇杷 176.60772663|pi pa;
琵琶__琵琶 361.577631409|pi pa;
批判__批判 1546.12469848|pi pan;
匹配__匹配 2095.55037421|pi pei;
屁屁__屁屁 333.029068427|pi pi;
皮皮__皮皮 394.043872187|pi pi;
批评__批評 4290.32271274|pi ping;
匹马__匹馬 195.60878915|pi ma;
皮毛__皮毛 370.240920313|pi mao;
媲美__媲美 428.356335222|pi mei;
疲乏__疲乏 134.762357541|pi fa;
批发__批發 1791.04500392|pi fa;
披风__披風 531.41444163|pi feng;
批复__批複 819.921123923|pi fu;
皮肤__皮膚 8761.92253873|pi fu;
皮带__皮帶 577.688827991|pi dai;
皮蛋__皮蛋 186.32942291|pi dan;
匹敌__匹敵 107.14877401|pi di;
批斗__批鬥 184.02185602|pi dou;
皮套__皮套 150.944778196|pi tao;
皮特__皮特 254.438159592|pi te;
劈腿__劈腿 118.529012887|pi tui;
疲劳__疲勞 1757.8768636|pi lao;
霹雳__霹靂 397.496217848|pi li;
批量__批量 1260.33845835|pi liang;
毗邻__毗鄰 298.439468992|pi lin;
披露__披露 2043.96775685|pi lu;
批改__批改 147.780672558|pi gai;
皮革__皮革 455.895552723|pi ge;
屁股__屁股 3726.78205719|pi gu;
皮卡__皮卡 184.02185602|pi ka;
屁话__屁話 187.027319083|pi hua;
癖好__癖好 140.770195218|pi hao;
批号__批號 241.764712994|pi hao;
疲倦__疲倦 614.828697239|pi juan;
皮夹__皮夾 112.34478795|pi jia;
披肩__披肩 224.907079496|pi jian;
啤酒__啤酒 2529.4132684|pi jiu;
皮具__皮具 138.335571213|pi ju;
脾气__脾氣 2865.10217964|pi qi;
皮球__皮球 450.811022973|pi qiu;
皮下__皮下 208.964318904|pi xia;
皮鞋__皮鞋 725.661628731|pi xie;
貔貅__貔貅 139.026849285|pi xiu;
批准__批准 5664.71780817|pi zhun;
披着__披着 371.627656329|pi zhe;
皮疹__皮疹 164.498187167|pi zhen;
皮脂__皮脂 161.653186955|pi zhi;
皮质__皮質 237.287502254|pi zhi;
批注__批註 181.969489867|pi zhu;
砒霜__砒霜 120.765453341|pi shuang;
披上__披上 262.162833911|pi shang;
屁事__屁事 174.855812809|pi shi;
批示__批示 665.872587905|pi shi;
疲软__疲軟 408.544597361|pi ruan;
皮肉__皮肉 141.826678552|pi rou;
譬如__譬如 811.787668067|pi ru;
疲弱__疲弱 105.953760973|pi ruo;
痞子__痞子 346.577724349|pi zi;
皮草__皮草 135.604660605|pi cao;
批次__批次 660.912425973|pi ci;
批萨__批薩 130.303509496|pi sa;
皮炎__皮炎 129.171793682|pi yan;
屁眼__屁眼 374.883606282|pi yan;
辟谣__闢謠 190.793818607|pi yao;
皮衣__皮衣 117.207077876|pi yi;
屁用__屁用 147.045868173|pi yong;
批文__批文 228.580284053|pi wen;
脾胃__脾胃 239.366454718|pi wei;
偏僻__偏僻 532.077085292|pian pi;
便便__便便 191.031727675|pian pian;
翩翩__翩翩 319.611528482|pian pian;
片片__片片 457.033213363|pian pian;
偏偏__偏偏 1651.68904712|pian pian;
偏颇__偏頗 195.60878915|pian po;
片面__片面 593.745648473|pian mian;
片名__片名 227.160466527|pian ming;
偏方__偏方 189.372573382|pian fang;
篇幅__篇幅 534.735933039|pian fu;
片断__片斷 433.727767276|pian duan;
片段__片段 1022.26865969|pian duan;
偏大__偏大 219.37092252|pian da;
骗到__騙到 141.29744947|pian dao;
偏低__偏低 699.033618062|pian di;
偏袒__偏袒 122.127521944|pian tan;
片头__片頭 325.236501817|pian tou;
骗你__騙你 660.912425973|pian ni;
骗了__騙了 441.911471008|pian le;
偏离__偏離 589.322768456|pian li;
偏高__偏高 670.034480971|pian gao;
骗过__騙過 146.132498493|pian guo;
片刻__片刻 894.656458236|pian ke;
片花__片花 144.863304286|pian hua;
偏好__偏好 530.752623218|pian hao;
偏激__偏激 496.830647979|pian ji;
偏见__偏見 680.129467195|pian jian;
骗局__騙局 430.496878967|pian ju;
骗钱__騙錢 364.291279287|pian qian;
骗取__騙取 418.854838101|pian qu;
片区__片區 611.009712747|pian qu;
偏小__偏小 191.031727675|pian xiao;
偏向__偏向 574.81640715|pian xiang;
偏心__偏心 184.02185602|pian xin;
篇章__篇章 390.621510938|pian zhang;
偏执__偏執 274.876014738|pian zhi;
偏重__偏重 400.479435488|pian zhong;
片中__片中 941.55486912|pian zhong;
偏差__偏差 804.737106306|pian cha;
片场__片場 212.641966978|pian chang;
片酬__片酬 167.184787749|pian chou;
偏出__偏出 194.393772779|pian chu;
偏少__偏少 130.141230764|pian shao;
骗术__騙術 395.519762073|pian shu;
骗人__騙人 1733.94458864|pian ren;
骗子__騙子 2746.24453283|pian zi;
片子__片子 5044.82818733|pian zi;
片源__片源 175.948711373|pian yuan;
偏远__偏遠 450.811022973|pian yuan;
偏要__偏要 206.89143407|pian yao;
偏移__偏移 296.216358865|pian yi;
便宜__便宜 14659.4049539|pian yi;
片尾__片尾 169.492308033|pian wei;
骗我__騙我 556.490650127|pian wo;
偏爱__偏愛 452.499534015|pian ai;
漂白__漂白 179.940013424|piao bai;
漂泊__漂泊 562.066236349|piao bo;
票票__票票 145.768741141|piao piao;
漂漂__漂漂 172.905674062|piao piao;
飘飘__飄飄 748.624851411|piao piao;
票面__票面 161.854759309|piao mian;
缥缈__縹緲 156.109948588|piao miao;
飘渺__飄渺 317.230705235|piao miao;
票房__票房 1318.16721196|piao fang;
飘飞__飄飛 115.323601467|piao fei;
飘浮__飄浮 143.426288875|piao fu;
漂浮__漂浮 409.564096466|piao fu;
飘荡__飄蕩 306.734573113|piao dang;
飘来__飄來 212.641966978|piao lai;
漂亮__漂亮 16216.3759198|piao liang;
飘零__飄零 294.743493195|piao ling;
漂流__漂流 644.643863216|piao liu;
飘落__飄落 332.200082586|piao luo;
飘过__飄過 632.705783453|piao guo;
嫖客__嫖客 283.221176861|piao ke;
飘红__飄紅 185.172044961|piao hong;
飘忽__飄忽 224.06783424|piao hu;
嫖妓__嫖妓 140.419785869|piao ji;
票价__票價 1115.44785438|piao jia;
票据__票據 799.738513132|piao ju;
剽窃__剽竊 293.643651968|piao qie;
票选__票選 130.954650472|piao xuan;
飘香__飄香 286.415523108|piao xiang;
飘着__飄着 213.971039752|piao zhe;
嫖娼__嫖娼 341.859308876|piao chang;
票数__票數 417.291872914|piao shu;
飘然__飄然 164.703307075|piao ran;
票子__票子 373.484720623|piao zi;
飘走__飄走 107.015331962|piao zou;
飘散__飄散 135.773751924|piao san;
飘云__飄雲 107.282382453|piao yun;
飘扬__飄揚 283.927938713|piao yang;
飘摇__飄搖 139.895806636|piao yao;
漂移__漂移 357.99085261|piao yi;
飘逸__飄逸 540.767020614|piao yi;
票务__票務 282.868455943|piao wu;
撇开__撇開 188.196293023|pie kai;
瞥见__瞥見 113.753550575|pie jian;
拼搏__拼搏 708.681829926|pin bo;
品牌__品牌 16876.1084131|pin pai;
频频__頻頻 1178.31719254|pin pin;
频谱__頻譜 208.964318904|pin pu;
贫民__貧民 153.792848894|pin min;
品名__品名 273.168633085|pin ming;
拼命__拚命 2532.56730325|pin ming;
频发__頻發 227.727332161|pin fa;
贫乏__貧乏 233.474375771|pin fa;
频繁__頻繁 2599.71813289|pin fan;
贫富__貧富 228.011295226|pin fu;
频段__頻段 247.249015706|pin duan;
频道__頻道 4902.28669206|pin dao;
品德__品德 422.52456065|pin de;
拼图__拼圖 266.444503116|pin tu;
频率__頻率 3209.14698221|pin lv;
拼了__拼了 269.114061535|pin le;
品类__品類 168.859844103|pin lei;
品格__品格 417.812212206|pin ge;
贫困__貧困 1676.57400252|pin kun;
贫苦__貧苦 159.452390871|pin ku;
贫寒__貧寒 160.849404779|pin han;
贫瘠__貧瘠 198.803491145|pin ji;
拼接__拼接 246.633556117|pin jie;
拼抢__拼搶 135.604660605|pin qiang;
聘请__聘請 1035.08753546|pin qing;
贫穷__貧窮 968.932019286|pin qiong;
贫血__貧血 538.078184713|pin xue;
拼写__拼寫 254.438159592|pin xie;
品性__品性 124.89791921|pin xing;
品行__品行 207.407719521|pin xing;
拼装__拼裝 120.314814642|pin zhuang;
品质__品質 4532.13567457|pin zhi;
品种__品種 5552.8894634|pin zhong;
品茶__品茶 130.303509496|pin cha;
品尝__品嘗 988.445115058|pin chang;
拼车__拼車 117.646076559|pin che;
拼杀__拼殺 115.755545596|pin sha;
聘任__聘任 317.230705235|pin ren;
贫嘴__貧嘴 107.550099352|pin zui;
拼凑__拼湊 219.918349804|pin cou;
拼死__拚死 141.826678552|pin si;
拼音__拼音 2564.32477261|pin yin;
聘用__聘用 563.46883971|pin yong;
聘为__聘為 114.46454262|pin wei;
品位__品位 1054.61787307|pin wei;
品味__品味 1695.48345672|pin wei;
平板__平板 473.851932013|ping ban;
屏保__屏保 294.376422496|ping bao;
评比__評比 590.793388895|ping bi;
屏蔽__屏蔽 1971.41994959|ping bi;
评标__評標 275.905561849|ping biao;
评判__評判 668.366611253|ping pan;
乒乓__乒乓 355.324137339|ping pang;
平平__平平 559.968874971|ping ping;
平米__平米 1323.10440245|ping mi;
平面__平面 1795.51445179|ping mian;
平民__平民 1150.74567978|ping min;
屏幕__屏幕 5450.05619202|ping mu;
平反__平反 215.576896995|ping fan;
平凡__平凡 1813.50405438|ping fan;
平房__平房 311.355949144|ping fang;
平方__平方 873.722339551|ping fang;
平分__平分 187.727829225|ping fen;
评分__評分 1038.96445205|ping fen;
屏风__屏風 209.485777119|ping feng;
平复__平復 174.42055653|ping fu;
平淡__平淡 1515.60233678|ping dan;
平等__平等 2749.66894397|ping deng;
平地__平地 247.557321202|ping di;
评点__評點 135.773751924|ping dian;
平定__平定 149.261315371|ping ding;
评定__評定 921.81798848|ping ding;
平度__平度 117.499561272|ping du;
平台__平台 13808.2482753|ping tai;
平坦__平坦 543.469292924|ping tan;
平躺__平躺 106.483223576|ping tang;
平添__平添 153.028150386|ping tian;
平头__平頭 130.791560815|ping tou;
评论__評論 9175.37723473|ping lun;
瓶盖__瓶蓋 161.854759309|ping gai;
平谷__平谷 116.915322539|ping gu;
评估__評估 4847.61227732|ping gu;
苹果__蘋果 4515.22391985|ping guo;
凭空__憑空 265.78126155|ping kong;
平滑__平滑 441.361118731|ping hua;
平缓__平緩 190.793818607|ping huan;
平和__平和 981.082073059|ping he;
平衡__平衡 5429.71919857|ping heng;
平湖__平湖 197.076837307|ping hu;
平均__平均 7470.08246857|ping jun;
评级__評級 643.039196578|ping ji;
平价__平價 270.122027271|ping jia;
评价__評價 9536.76824366|ping jia;
评奖__評獎 229.722524886|ping jiang;
凭借__憑藉 2523.11697781|ping jie;
瓶颈__瓶頸 1203.54593192|ping jing;
平静__平靜 3558.84830329|ping jing;
凭据__憑據 118.972962872|ping ju;
平局__平局 302.181790975|ping ju;
评选__評選 2090.33406802|ping xuan;
评析__評析 146.679837233|ping xi;
平息__平息 501.183541788|ping xi;
平行__平行 707.799244422|ping xing;
瓶装__瓶裝 176.60772663|ping zhuang;
屏障__屏障 383.865702254|ping zhang;
凭着__憑着 742.122873174|ping zhe;
平整__平整 398.48814637|ping zheng;
凭证__憑證 1388.99614478|ping zheng;
平常__平常 2652.07324956|ping chang;
评出__評出 243.275811214|ping chu;
凭啥__憑啥 130.46599058|ping sha;
评审__評審 1949.43302008|ping shen;
平生__平生 450.811022973|ping sheng;
平实__平實 190.793818607|ping shi;
平时__平時 10562.8203485|ping shi;
平手__平手 132.431639237|ping shou;
评书__評書 201.547419552|ping shu;
评述__評述 282.516174301|ping shu;
评说__評說 206.633773476|ping shuo;
平壤__平壤 172.04594156|ping rang;
平日__平日 837.47630896|ping ri;
平仄__平仄 128.369448119|ping ze;
瓶子__瓶子 1313.24844471|ping zi;
平仓__平倉 278.669912425|ping cang;
评测__評測 1625.14698659|ping ce;
平原__平原 816.861571886|ping yuan;
平阳__平陽 159.253810404|ping yang;
平遥__平遙 131.281440129|ping yao;
平抑__平抑 118.824795093|ping yi;
平移__平移 168.439513167|ping yi;
评议__評議 566.990680223|ping yi;
评优__評優 107.818484324|ping you;
平邮__平郵 580.575602636|ping you;
平庸__平庸 534.735933039|ping yong;
评语__評語 410.07479966|ping yu;
平稳__平穩 1827.1144412|ping wen;
评为__評為 1261.91002891|ping wei;
评委__評委 1655.81074036|ping wei;
平安__平安 2424.48154518|ping an;
破败__破敗 130.791560815|po bai;
婆婆__婆婆 1875.5602418|po po;
破门__破門 366.111682898|po men;
破灭__破滅 552.345286903|po mie;
颇丰__頗豐 143.0692679|po feng;
破费__破費 119.56748386|po fei;
泼妇__潑婦 203.060037258|po fu;
坡度__坡度 177.711575153|po du;
颇多__頗多 330.548296374|po duo;
婆娘__婆娘 353.557372243|po niang;
泼辣__潑辣 140.594881376|po la;
破烂__破爛 440.262469534|po lan;
破了__破了 547.548041623|po le;
破例__破例 168.649547684|po li;
魄力__魄力 392.573489614|po li;
破裂__破裂 900.248315564|po lie;
颇感__頗感 109.30661816|po gan;
颇高__頗高 141.826678552|po gao;
破格__破格 127.413209251|po ge;
破坏__破壞 5664.71780817|po huai;
迫害__迫害 663.387871054|po hai;
破获__破獲 309.4219738|po huo;
破甲__破甲 131.445140637|po jia;
婆家__婆家 159.452390871|po jia;
破解__破解 3792.371211|po jie;
破旧__破舊 416.253137598|po jiu;
颇具__頗具 466.818670029|po ju;
迫切__迫切 793.781168439|po qie;
婆媳__婆媳 132.927661458|po xi;
破绽__破綻 270.458854115|po zhan;
破产__破產 1515.60233678|po chan;
破车__破車 136.792736844|po che;
破除__破除 212.112652282|po chu;
颇深__頗深 138.508067822|po shen;
迫使__迫使 780.052703516|po shi;
颇受__頗受 198.803491145|po shou;
破财__破財 123.658956482|po cai;
破损__破損 418.854838101|po sun;
婆娑__婆娑 130.46599058|po suo;
破碎__破碎 1020.99553617|po sui;
破译__破譯 179.492101402|po yi;
颇有__頗有 1162.27522076|po you;
迫于__迫於 323.216307961|po yu;
破网__破網 128.049907079|po wang;
颇为__頗為 955.740681497|po wei;
破案__破案 302.181790975|po an;
剖面__剖面 150.007190589|pou mian;
剖腹__剖腹 110.677283245|pou fu;
剖析__剖析 614.062995519|pou xi;
扑鼻__撲鼻 125.992190229|pu bi;
普遍__普遍 5954.24100327|pu bian;
瀑布__瀑布 846.921892564|pu bu;
铺满__鋪滿 139.026849285|pu man;
铺面__鋪面 122.432284019|pu mian;
扑灭__撲滅 192.945711079|pu mie;
普法__普法 259.238974004|pu fa;
浦发__浦發 436.982903472|pu fa;
匍匐__匍匐 117.646076559|pu fu;
扑倒__撲倒 106.218162376|pu dao;
扑到__撲到 165.73274959|pu dao;
铺垫__鋪墊 385.303469841|pu dian;
浦东__浦東 1768.86409398|pu dong;
葡萄__葡萄 1617.0663282|pu tao;
菩提__菩提 498.070459751|pu ti;
普天__普天 180.389043185|pu tian;
莆田__莆田 269.114061535|pu tian;
扑通__撲通 145.405889264|pu tong;
普通__普通 12266.6021738|pu tong;
普陀__普陀 234.933657026|pu tuo;
铺路__鋪路 139.895806636|pu lu;
普罗__普羅 133.758497151|pu luo;
曝光__曝光 127.572086295|pu guang;
铺开__鋪開 232.893204426|pu kai;
扑克__撲克 346.1460998|pu ke;
铺货__鋪貨 130.46599058|pu huo;
普及__普及 2488.76648916|pu ji;
浦江__浦江 152.837570606|pu jiang;
仆街__仆街 116.18910757|pu jie;
普京__普京 722.953807881|pu jing;
扑救__撲救 175.510734618|pu jiu;
浦西__浦西 152.647228173|pu xi;
扑向__撲向 159.85029497|pu xiang;
谱写__譜寫 262.489736092|pu xie;
铺装__鋪裝 117.061109314|pu zhuang;
普查__普查 680.129467195|pu cha;
扑出__撲出 147.045868173|pu chu;
铺设__鋪設 444.673543393|pu she;
普世__普世 122.890853693|pu shi;
朴实__樸實 617.901063897|pu shi;
朴树__朴樹 150.756793028|pu shu;
仆人__僕人 294.743493195|pu ren;
铺子__鋪子 174.42055653|pu zi;
菩萨__菩薩 1008.35118051|pu sa;
朴素__樸素 674.222387052|pu su;
濮阳__濮陽 139.72158175|pu yang;
溥仪__溥儀 139.200207879|pu yi;
普洱__普洱 248.175085992|pu er;
麻痹__麻痹 1333.03432936|ma bi;
抹布__抹布 279.365316864|ma bu;
马匹__馬匹 218.280152578|ma pi;
马屁__馬屁 273.168633085|ma pi;
麻麻__麻麻 121.823518492|ma ma;
骂骂__罵罵 132.431639237|ma ma;
妈妈__媽媽 20017.8370059|ma ma;
妈咪__媽咪 598.94764591|ma mi;
麻木__麻木 1371.79434453|ma mu;
麻烦__麻煩 18902.6111425|ma fan;
马达__馬達 417.812212206|ma da;
麻袋__麻袋 241.764712994|ma dai;
骂道__罵道 154.561368684|ma dao;
骂得__罵得 199.051387821|ma de;
马丁__馬丁 376.756940916|ma ding;
马特__馬特 127.413209251|ma te;
马蹄__馬蹄 222.121753798|ma ti;
码头__碼頭 1452.72816478|ma tou;
马桶__馬桶 837.47630896|ma tong;
玛瑙__瑪瑙 242.670241844|ma nao;
骂娘__罵娘 124.587019602|ma niang;
码率__碼率 174.42055653|ma lv;
马拉__馬拉 160.049619219|ma la;
麻辣__麻辣 399.482550191|ma la;
马来__馬來 239.366454718|ma lai;
马兰__馬蘭 107.952927857|ma lan;
马里__馬里 106.350610398|ma li;
麻利__麻利 118.08671951|ma li;
马力__馬力 344.424970321|ma li;
玛丽__瑪麗 428.356335222|ma li;
马琳__馬琳 136.792736844|ma lin;
马龙__馬龍 160.649084484|ma long;
马路__馬路 1889.63636164|ma lu;
马钢__馬鋼 259.238974004|ma gang;
马凯__馬凱 121.217779906|ma kai;
马可__馬可 124.587019602|ma ke;
马克__馬克 522.874798954|ma ke;
麻花__麻花 251.287110964|ma hua;
马虎__馬虎 353.998238229|ma hu;
马季__馬季 183.335174792|ma ji;
马甲__馬甲 11397.0719564|ma jia;
麻将__麻將 1368.37963334|ma jiang;
骂街__罵街 179.71591787|ma jie;
麻雀__麻雀 437.527796363|ma que;
麻疹__麻疹 118.529012887|ma zhen;
马场__馬場 105.0335283|ma chang;
马超__馬超 171.190483873|ma chao;
马车__馬車 505.574572707|ma che;
马上__馬上 18050.8343551|ma shang;
骂声__罵聲 197.322580943|ma sheng;
马术__馬術 154.176629937|ma shu;
骂人__罵人 1973.87819843|ma ren;
码字__碼字 175.510734618|ma zi;
麻子__麻子 186.794397067|ma zi;
马子__馬子 235.813600182|ma zi;
麻醉__麻醉 651.914561431|ma zui;
马刺__馬刺 512.55262135|ma ci;
马萨__馬薩 125.36572391|ma sa;
马赛__馬賽 177.269210225|ma sai;
马斯__馬斯 129.655606164|ma si;
骂死__罵死 137.476305203|ma si;
马云__馬雲 646.252534205|ma yun;
妈呀__媽呀 213.971039752|ma ya;
玛雅__瑪雅 309.4219738|ma ya;
麻药__麻藥 134.930398555|ma yao;
麻衣__麻衣 123.658956482|ma yi;
蚂蚁__螞蟻 1508.06636321|ma yi;
麻油__麻油 154.561368684|ma you;
马尾__馬尾 180.164388413|ma wei;
骂我__罵我 854.342048866|ma wo;
马儿__馬兒 168.020228531|ma er;
马尔__馬爾 228.8653107|ma er;
脉搏__脈搏 282.516174301|mai bo;
迈步__邁步 112.484875527|mai bu;
卖盘__賣盤 141.121478992|mai pan;
买盘__買盤 343.567617462|mai pan;
麦片__麥片 125.678566729|mai pian;
卖票__賣票 116.915322539|mai piao;
买票__買票 871.547443971|mai piao;
买卖__買賣 2586.79165036|mai mai;
卖命__賣命 168.229740225|mai ming;
埋没__埋沒 175.510734618|mai mo;
卖房__賣房 196.341441156|mai fang;
卖方__賣方 478.003501869|mai fang;
买方__買方 617.901063897|mai fang;
买房__買房 2244.21407924|mai fang;
埋伏__埋伏 347.00988711|mai fu;
买断__買斷 286.772667017|mai duan;
卖单__賣單 133.591915611|mai dan;
埋单__埋單 221.017305999|mai dan;
买单__買單 954.550411286|mai dan;
卖到__賣到 480.991159713|mai dao;
买到__買到 2061.87561868|mai dao;
买得__買得 129.494134325|mai de;
卖得__賣得 363.384474622|mai de;
卖的__賣的 918.378206258|mai de;
买的__買的 4205.62658069|mai de;
麦迪__麥迪 449.128812644|mai di;
麦蒂__麥蒂 574.10053635|mai di;
卖点__賣點 1135.07907503|mai dian;
买点__買點 1160.82773443|mai dian;
卖掉__賣掉 1496.83260243|mai diao;
麦兜__麥兜 232.313479749|mai dou;
脉动__脈動 141.121478992|mai dong;
麦田__麥田 331.37316028|mai tian;
埋头__埋頭 367.482952871|mai tou;
卖弄__賣弄 230.582949765|mai nong;
买来__買來 967.72532071|mai lai;
买了__買了 9668.39676357|mai le;
卖力__賣力 367.025293151|mai li;
买辆__買輛 108.627664361|mai liang;
脉络__脈絡 303.691826638|mai luo;
买个__買個 2749.66894397|mai ge;
卖给__賣給 1252.50991514|mai gei;
卖过__賣過 119.26985293|mai guo;
卖国__賣國 160.249192015|mai guo;
买过__買過 868.29524729|mai guo;
迈克__邁克 251.600451735|mai ke;
麦克__麥克 728.379591714|mai ke;
买好__買好 438.619621343|mai hao;
买回__買回 329.314848809|mai hui;
卖家__賣家 1932.50174796|mai jia;
买家__買家 2175.37534439|mai jia;
迈进__邁進 512.55262135|mai jin;
买进__買進 1121.02187006|mai jin;
卖钱__賣錢 238.473254015|mai qian;
卖血__賣血 142.713135632|mai xue;
埋下__埋下 310.194118206|mai xia;
买下__買下 667.534233933|mai xia;
迈向__邁向 331.37316028|mai xiang;
买些__買些 279.365316864|mai xie;
买张__買張 116.915322539|mai zhang;
迈着__邁着 116.624293448|mai zhe;
买主__買主 198.308623594|mai zhu;
卖场__賣場 1097.52300072|mai chang;
卖车__賣車 135.435779871|mai che;
买车__買車 1279.32718167|mai che;
脉冲__脈衝 598.201722298|mai chong;
迈出__邁出 604.195219728|mai chu;
卖出__賣出 2106.02207003|mai chu;
迈上__邁上 154.947067523|mai shang;
卖身__賣身 333.029068427|mai shen;
买书__買書 498.070459751|mai shu;
迈入__邁入 177.269210225|mai ru;
买入__買入 2523.11697781|mai ru;
埋在__埋在 478.599545119|mai zai;
埋葬__埋葬 311.744192349|mai zang;
麦子__麥子 424.107124851|mai zi;
卖座__賣座 110.539446825|mai zuo;
卖菜__賣菜 171.190483873|mai cai;
买菜__買菜 833.312156414|mai cai;
埋藏__埋藏 299.557272934|mai cang;
埋怨__埋怨 109.442917312|mai yuan;
麦芽__麥芽 109.442917312|mai ya;
买药__買葯 297.325836157|mai yao;
卖艺__賣藝 119.56748386|mai yi;
买一__買一 189.845141544|mai yi;
卖淫__賣淫 562.76710106|mai yin;
卖完__賣完 250.349428094|mai wan;
漫步__漫步 727.472474808|man bu;
慢跑__慢跑 235.226605969|man pao;
漫骂__漫罵 276.938965124|man ma;
谩骂__謾罵 387.711726118|man ma;
满满__滿滿 457.033213363|man man;
漫漫__漫漫 566.284555508|man man;
慢慢__慢慢 16075.5329821|man man;
满面__滿面 226.877563077|man mian;
曼妙__曼妙 157.2815571|man miao;
满目__滿目 164.703307075|man mu;
满分__滿分 496.21189989|man fen;
满腹__滿腹 137.476305203|man fu;
蛮大__蠻大 242.36802267|man da;
满地__滿地 550.970372621|man di;
慢点__慢點 491.289575698|man dian;
漫谈__漫談 109.852835359|man tan;
满堂__滿堂 119.121315407|man tang;
满天__滿天 388.195180646|man tian;
漫天__漫天 547.548041623|man tian;
满头__滿頭 219.644465616|man tou;
馒头__饅頭 1402.91276273|man tou;
满脸__滿臉 914.951259653|man lian;
曼联__曼聯 1813.50405438|man lian;
曼谷__曼谷 318.418891685|man gu;
蛮快__蠻快 132.10198647|man kuai;
满口__滿口 267.775955618|man kou;
漫画__漫畫 3064.53855293|man hua;
蛮荒__蠻荒 116.769717326|man huang;
满怀__滿懷 542.11647303|man huai;
蛮好__蠻好 1623.12304424|man hao;
蛮横__蠻橫 160.049619219|man heng;
满级__滿級 114.607273411|man ji;
满街__滿街 252.85772688|man jie;
满腔__滿腔 167.810977762|man qiang;
满清__滿清 326.048110451|man qing;
满心__滿心 187.26053154|man xin;
慢性__慢性 1229.31483934|man xing;
瞒着__瞞着 246.019628549|man zhe;
满洲__滿洲 156.499511818|man zhou;
漫长__漫長 1573.33557614|man chang;
曼城__曼城 228.011295226|man cheng;
满城__滿城 247.557321202|man cheng;
满山__滿山 122.432284019|man shan;
满身__滿身 350.92368248|man shen;
满是__滿是 528.113581536|man shi;
满载__滿載 237.879639313|man zai;
慢走__慢走 135.267109459|man zou;
满族__滿族 281.812926654|man zu;
满足__滿足 12702.171466|man zu;
满嘴__滿嘴 253.804804573|man zui;
满仓__滿倉 586.392500602|man cang;
慢速__慢速 130.46599058|man su;
埋怨__埋怨 601.191002133|man yuan;
满月__滿月 359.779772295|man yue;
满眼__滿眼 303.313611771|man yan;
蔓延__蔓延 1114.0586864|man yan;
满意__滿意 6513.17941256|man yi;
漫游__漫遊 909.268075561|man you;
鳗鱼__鰻魚 139.200207879|man yu;
满屋__滿屋 140.594881376|man wu;
茫茫__茫茫 650.291796355|mang mang;
盲目__盲目 1998.62991039|mang mu;
忙到__忙到 152.647228173|mang dao;
忙得__忙得 461.61231651|mang de;
盲点__盲點 142.003528374|mang dian;
忙碌__忙碌 1788.81445378|mang lu;
芒果__芒果 587.855808729|mang guo;
忙活__忙活 415.734739962|mang huo;
盲区__盲區 129.817279349|mang qu;
忙着__忙着 1896.71398774|mang zhe;
茫然__茫然 886.886162059|mang ran;
盲人__盲人 432.648119245|mang ren;
盲从__盲從 125.522047856|mang cong;
忙于__忙於 562.76710106|mang yu;
毛笔__毛筆 220.742053181|mao bi;
毛病__毛病 2766.85515694|mao bing;
冒牌__冒牌 357.099731154|mao pai;
冒泡__冒泡 264.789493468|mao pao;
毛坯__毛坯 119.26985293|mao pi;
毛皮__毛皮 183.792676978|mao pi;
毛片__毛片 373.950434882|mao pian;
猫扑__貓撲 389.649164279|mao pu;
毛毛__毛毛 1404.66211536|mao mao;
猫猫__貓貓 1887.28302677|mao mao;
冒昧__冒昧 243.275811214|mao mei;
茂密__茂密 199.051387821|mao mi;
猫咪__貓咪 722.953807881|mao mi;
茂名__茂名 272.828431509|mao ming;
毛发__毛髮 358.884197808|mao fa;
冒犯__冒犯 200.29551561|mao fan;
矛盾__矛盾 7045.12729757|mao dun;
毛豆__毛豆 131.281440129|mao dou;
茅台__茅台 372.091054935|mao tai;
毛毯__毛毯 116.769717326|mao tan;
矛头__矛頭 279.017397997|mao tou;
毛囊__毛囊 162.056583012|mao nang;
猫腻__貓膩 226.877563077|mao ni;
牦牛__氂牛 162.663565352|mao niu;
毛驴__毛驢 172.905674062|mao lv;
冒了__冒了 120.916041011|mao le;
毛利__毛利 364.291279287|mao li;
毛料__毛料 164.293322714|mao liao;
猫粮__貓糧 134.092283643|mao liang;
猫狗__貓狗 137.134095104|mao gou;
毛孔__毛孔 1059.88791463|mao kong;
冒汗__冒汗 110.815291538|mao han;
毛巾__毛巾 1017.18567095|mao jin;
毛钱__毛錢 444.119751258|mao qian;
毛线__毛線 282.516174301|mao xian;
冒险__冒險 1424.04956302|mao xian;
冒着__冒着 673.382717005|mao zhe;
冒充__冒充 726.566487616|mao chong;
冒出__冒出 961.714332594|mao chu;
茂盛__茂盛 224.347234118|mao sheng;
冒失__冒失 117.792774542|mao shi;
贸然__貿然 249.415244207|mao ran;
毛绒__毛絨 105.295633316|mao rong;
帽子__帽子 2043.96775685|mao zi;
冒死__冒死 111.091824605|mao si;
貌似__貌似 11130.3912045|mao si;
猫眼__貓眼 171.190483873|mao yan;
冒烟__冒煙 176.60772663|mao yan;
毛衣__毛衣 586.392500602|mao yi;
贸易__貿易 3931.92961191|mao yi;
冒用__冒用 105.953760973|mao yong;
冒雨__冒雨 157.870654598|mao yu;
猫儿__貓兒 175.073848088|mao er;
么么__么么 1272.96603034|me me;
么样__么樣 392.573489614|me yang;
门板__門板 158.264611567|men ban;
门边__門邊 145.587202159|men bian;
门牌__門牌 129.979154132|men pai;
门派__門派 691.237408589|men pai;
门票__門票 2172.66615296|men piao;
闷闷__悶悶 120.46484039|men men;
门面__門面 473.851932013|men mian;
门缝__門縫 125.992190229|men feng;
门道__門道 150.569041974|men dao;
们的__們的 2135.08983815|men de;
门店__門店 837.47630896|men dian;
门徒__門徒 198.803491145|men tu;
门类__門類 256.347723437|men lei;
门铃__門鈴 178.155043976|men ling;
门路__門路 251.287110964|men lu;
门框__門框 161.653186955|men kuang;
门开__門開 126.306596357|men kai;
门槛__門檻 1528.88101848|men kan;
门课__門課 215.040276584|men ke;
门口__門口 6975.24102411|men kou;
门后__門后 111.925571131|men hou;
门户__門戶 1773.27819069|men hu;
门将__門將 705.158077415|men jiang;
门禁__門禁 226.595011951|men jin;
们就__們就 211.057972369|men jiu;
门前__門前 1615.05244942|men qian;
门下__門下 228.295612376|men xia;
门诊__門診 907.004698479|men zhen;
门柱__門柱 155.140277726|men zhu;
门窗__門窗 579.852559389|men chuang;
门上__門上 281.111429553|men shang;
门神__門神 120.765453341|men shen;
门市__門市 236.991986692|men shi;
闷热__悶熱 377.697115787|men re;
闷骚__悶騷 259.562230298|men sao;
闷死__悶死 105.558392399|men si;
门锁__門鎖 220.742053181|men suo;
门牙__門牙 158.264611567|men ya;
门外__門外 1272.96603034|men wai;
门卫__門衛 326.861744407|men wei;
蒙蔽__蒙蔽 255.709615075|meng bi;
蒙骗__矇騙 118.824795093|meng pian;
孟买__孟買 116.624293448|meng mai;
梦梦__夢夢 131.117943492|meng meng;
萌萌__萌萌 222.121753798|meng meng;
蒙蒙__蒙蒙 227.160466527|meng meng;
蒙面__蒙面 162.258658377|meng mian;
萌发__萌發 210.795122809|meng fa;
梦到__夢到 672.544092675|meng dao;
猛地__猛地 508.100984482|meng de;
懵懂__懵懂 252.228305921|meng dong;
猛男__猛男 345.715012791|meng nan;
蒙牛__蒙牛 532.077085292|meng niu;
蒙了__蒙了 123.044091616|meng le;
梦里__夢裡 967.72532071|meng li;
猛烈__猛烈 784.92825478|meng lie;
猛龙__猛龍 121.217779906|meng long;
朦胧__朦朧 851.15405446|meng long;
梦露__夢露 135.94305409|meng lu;
蒙古__蒙古 1000.83985593|meng gu;
盟国__盟國 137.991222203|meng guo;
梦幻__夢幻 1427.60319527|meng huan;
猛虎__猛虎 210.795122809|meng hu;
盟军__盟軍 228.580284053|meng jun;
梦见__夢見 1090.70577937|meng jian;
猛将__猛將 117.061109314|meng jiang;
梦境__夢境 661.736546275|meng jing;
梦乡__夢鄉 180.164388413|meng xiang;
梦想__夢想 6051.48625333|meng xiang;
梦醒__夢醒 176.827946446|meng xing;
猛涨__猛漲 151.132997772|meng zhang;
蒙着__矇著 107.282382453|meng zhe;
梦中__夢中 710.450303909|meng zhong;
盟主__盟主 230.008975843|meng zhu;
蒙上__蒙上 239.664931108|meng shang;
萌生__萌生 218.280152578|meng sheng;
猛兽__猛獸 136.112567367|meng shou;
蒙受__蒙受 196.096919422|meng shou;
猛然__猛然 530.752623218|meng ran;
猛增__猛增 227.443722742|meng zeng;
孟子__孟子 277.630050085|meng zi;
萌芽__萌芽 372.555031371|meng ya;
梦魇__夢魘 226.312812713|meng yan;
盟友__盟友 338.046607007|meng you;
梦游__夢遊 339.735863102|meng you;
梦网__夢網 176.60772663|meng wang;
没把__沒把 239.963779681|mei ba;
美白__美白 1109.90155418|mei bai;
美版__美版 235.226605969|mei ban;
没被__沒被 335.110594827|mei bei;
每笔__每筆 165.32020271|mei bi;
没变__沒變 448.010827873|mei bian;
没病__沒病 130.303509496|mei bing;
每部__每部 128.850255419|mei bu;
每篇__每篇 153.218967809|mei pian;
媒婆__媒婆 111.786180106|mei po;
没谱__沒譜 166.768626413|mei pu;
没买__沒買 542.792461517|mei mai;
美满__美滿 446.895626023|mei man;
美貌__美貌 593.745648473|mei mao;
眉毛__眉毛 663.387871054|mei mao;
美梦__美夢 340.15949445|mei meng;
美美__美美 504.316081474|mei mei;
每每__每每 771.352901218|mei mei;
美眉__美眉 828.13607043|mei mei;
妹妹__妹妹 10074.2835612|mei mei;
每秒__每秒 427.82286438|mei miao;
美妙__美妙 1215.60448872|mei miao;
美名__美名 114.893269147|mei ming;
每名__每名 143.605133321|mei ming;
眉目__眉目 230.295783987|mei mu;
每亩__每畝 332.200082586|mei mu;
美发__美髮 401.979429753|mei fa;
没法__沒法 4722.39824658|mei fa;
美方__美方 385.78392141|mei fang;
美分__美分 143.605133321|mei fen;
每份__每份 156.694657831|mei fen;
每逢__每逢 389.649164279|mei feng;
美服__美服 139.373782642|mei fu;
妹夫__妹夫 161.854759309|mei fu;
每段__每段 108.357265155|mei duan;
每吨__每噸 382.433299725|mei dun;
没打__沒打 237.287502254|mei da;
没带__沒帶 546.185068786|mei dai;
每当__每當 1496.83260243|mei dang;
没到__沒到 453.628720089|mei dao;
每到__每到 631.917817783|mei dao;
美得__美得 184.481071779|mei de;
美德__美德 582.024395035|mei de;
美的__美的 958.125676369|mei de;
没得__沒得 2742.82438642|mei de;
没底__沒底 177.933171406|mei di;
美的__美的 251.914183226|mei di;
没点__沒點 125.209594649|mei dian;
煤电__煤電 301.429591092|mei dian;
没电__沒電 616.362966229|mei dian;
没动__沒動 270.458854115|mei dong;
梅毒__梅毒 250.974160423|mei du;
每台__每台 350.486645516|mei tai;
煤炭__煤炭 1601.02534912|mei tan;
每套__每套 160.449013667|mei tao;
美体__美體 132.10198647|mei ti;
媒体__媒體 16256.8429358|mei ti;
每天__每天 24404.4183796|mei tian;
每条__每條 326.861744407|mei tiao;
梅婷__梅婷 119.41857567|mei ting;
没听__沒聽 589.322768456|mei ting;
眉头__眉頭 640.639682982|mei tou;
每桶__每桶 220.742053181|mei tong;
美图__美圖 352.238065853|mei tu;
美腿__美腿 378.63963681|mei tui;
美女__美女 17045.1933699|mei nv;
没拿__沒拿 142.891090816|mei na;
美男__美男 244.796354228|mei nan;
没能__沒能 1645.52573648|mei neng;
煤泥__煤泥 148.704343794|mei ni;
每年__每年 9050.46083396|mei nian;
没来__沒來 1111.28553845|mei lai;
没了__沒了 3298.34499764|mei le;
魅力__魅力 4799.5249195|mei li;
美丽__美麗 10302.813275|mei li;
没脸__沒臉 126.779677253|mei lian;
梅林__梅林 240.862563142|mei lin;
美林__美林 246.94109417|mei lin;
没关__沒關 142.357889859|mei guan;
美观__美觀 926.424414408|mei guan;
没干__沒幹 128.369448119|mei gan;
没敢__沒敢 418.333200332|mei gan;
美感__美感 596.712660816|mei gan;
每隔__每隔 590.793388895|mei ge;
每个__每個 15679.8287906|mei ge;
没给__沒給 314.867617017|mei gei;
美工__美工 973.773879211|mei gong;
美股__美股 275.561951728|mei gu;
每股__每股 883.576728645|mei gu;
没过__沒過 555.797602048|mei guo;
美国__美國 42227.7441425|mei guo;
玫瑰__玫瑰 2286.55857392|mei gui;
煤矿__煤礦 1771.06976716|mei kuang;
没看__沒看 1579.22849881|mei kan;
没空__沒空 1324.75423858|mei kong;
没话__沒話 202.554574186|mei hua;
梅花__梅花 908.135681884|mei hua;
美化__美化 1009.60853723|mei hua;
每行__每行 118.23396695|mei hang;
没好__沒好 140.419785869|mei hao;
美好__美好 5707.23163681|mei hao;
每户__每戶 307.500011268|mei hu;
魅惑__魅惑 275.218769535|mei huo;
每回__每回 131.937467932|mei hui;
没回__沒回 194.636170786|mei hui;
霉菌__黴菌 286.415523108|mei jun;
美军__美軍 1978.80389582|mei jun;
每集__每集 124.276893895|mei ji;
美甲__美甲 115.467403456|mei jia;
每家__每家 380.057830188|mei jia;
每件__每件 323.619340361|mei jian;
没见__沒見 1218.6379585|mei jian;
没交__沒交 112.065135969|mei jiao;
没接__沒接 141.650048976|mei jie;
媒介__媒介 1062.53280282|mei jie;
没进__沒進 141.826678552|mei jin;
没劲__沒勁 1129.43516323|mei jin;
美金__美金 1617.0663282|mei jin;
美景__美景 787.868200695|mei jing;
没救__沒救 150.756793028|mei jiu;
美酒__美酒 579.130416613|mei jiu;
枚举__枚舉 175.729586548|mei ju;
美剧__美劇 620.215410078|mei ju;
每期__每期 346.1460998|mei qi;
煤气__煤氣 602.691239054|mei qi;
没钱__沒錢 4464.86635394|mei qian;
没去__沒去 1718.88488289|mei qu;
没学__沒學 109.579386421|mei xue;
美学__美學 752.365812175|mei xue;
梅西__梅西 331.37316028|mei xi;
没戏__沒戲 981.082073059|mei xi;
媚笑__媚笑 331.786363812|mei xiao;
每项__每項 172.260473089|mei xiang;
没想__沒想 2473.3076131|mei xiang;
没准__沒準 1054.61787307|mei zhun;
每张__每張 404.996293994|mei zhang;
没招__沒招 106.085879302|mei zhao;
没辙__沒轍 361.577631409|mei zhe;
每只__每隻 205.60633599|mei zhi;
梅州__梅州 249.104624871|mei zhou;
美洲__美洲 482.191444969|mei zhou;
每周__每周 2548.39656922|mei zhou;
美中__美中 175.948711373|mei zhong;
每种__每種 452.499534015|mei zhong;
没穿__沒穿 179.492101402|mei chuan;
每场__每場 240.562595233|mei chang;
没吃__沒吃 639.84183651|mei chi;
没出__沒出 284.636464248|mei chu;
没啥__沒啥 3449.68464686|mei sha;
没上__沒上 357.545014261|mei shang;
没少__沒少 222.67604562|mei shao;
美声__美聲 123.813152185|mei sheng;
美式__美式 316.441045148|mei shi;
美食__美食 2482.57137774|mei shi;
没事__沒事 20370.1390643|mei shi;
美术__美術 1351.43315497|mei shu;
没说__沒說 2255.42866395|mei shuo;
没睡__沒睡 462.187920882|mei shui;
媒人__媒人 126.779677253|mei ren;
每人__每人 2729.18634194|mei ren;
美人__美人 3501.65886607|mei ren;
没人__沒人 9430.40620183|mei ren;
美日__美日 320.010065926|mei ri;
每日__每日 2922.80180368|mei ri;
美容__美容 2197.17084589|mei rong;
没再__沒再 135.94305409|mei zai;
没在__沒在 484.601008682|mei zai;
美子__美子 105.953760973|mei zi;
梅子__梅子 309.4219738|mei zi;
妹子__妹子 832.274357505|mei zi;
每组__每組 193.668388536|mei zu;
魅族__魅族 366.111682898|mei zu;
没做__沒做 601.191002133|mei zuo;
煤层__煤層 110.401782066|mei ceng;
每层__每層 111.369047744|mei ceng;
每次__每次 14370.0106634|mei ci;
没错__沒錯 3056.91021261|mei cuo;
美色__美色 187.4940348|mei se;
没死__沒死 328.904723278|mei si;
媚俗__媚俗 107.14877401|mei su;
霉素__黴素 149.261315371|mei su;
美院__美院 191.269933402|mei yuan;
美圆__美圓 212.377144726|mei yuan;
美元__美元 8090.25858348|mei yuan;
每月__每月 4681.38313658|mei yue;
美亚__美亞 123.967540162|mei ya;
眉眼__眉眼 115.179978568|mei yan;
媚眼__媚眼 116.624293448|mei yan;
美艳__美艷 234.056997396|mei yan;
每样__每樣 119.26985293|mei yang;
煤业__煤業 137.476305203|mei ye;
每页__每頁 171.831677206|mei ye;
每一__每一 2008.61728399|mei yi;
魅影__魅影 134.42690308|mei ying;
美英__美英 191.269933402|mei ying;
没有__沒有 325559.198094|mei you;
没用__沒用 4509.6007036|mei yong;
美玉__美玉 113.187937993|mei yu;
美语__美語 128.369448119|mei yu;
美誉__美譽 244.186999878|mei yu;
梅雨__梅雨 455.895552723|mei yu;
没玩__沒玩 204.839111844|mei wan;
每晚__每晚 579.852559389|mei wan;
没完__沒完 687.800394331|mei wan;
美网__美網 106.085879302|mei wang;
美文__美文 255.709615075|mei wen;
每位__每位 824.018360007|mei wei;
美味__美味 1227.78386251|mei wei;
梅尔__梅爾 172.475272126|mei er;
美欧__美歐 466.818670029|mei ou;
密闭__密閉 168.859844103|mi bi;
密布__密布 170.339279748|mi bu;
弥补__彌補 1813.50405438|mi bu;
密码__密碼 16075.5329821|mi ma;
弥漫__瀰漫 846.921892564|mi man;
迷茫__迷茫 1498.69906777|mi mang;
迷们__迷們 272.488653616|mi men;
迷蒙__迷濛 107.282382453|mi meng;
密密__密密 165.526347625|mi mi;
米米__米米 322.010219858|mi mi;
咪咪__咪咪 1097.52300072|mi mi;
秘密__秘密 5019.7439743|mi mi;
密谋__密謀 135.098649108|mi mou;
秘法__秘法 108.763116896|mi fa;
米饭__米飯 822.992135502|mi fan;
秘方__秘方 436.982903472|mi fang;
米粉__米粉 396.012952778|mi fen;
蜜蜂__蜜蜂 543.469292924|mi feng;
密封__密封 810.776675547|mi feng;
迷倒__迷倒 147.412812521|mi dao;
米的__米的 605.702953498|mi de;
谜底__謎底 239.068350048|mi di;
密度__密度 1314.88599102|mi du;
谜团__謎團 198.803491145|mi tuan;
蜜糖__蜜糖 121.823518492|mi tang;
迷途__迷途 145.587202159|mi tu;
迷你__迷你 783.950712715|mi ni;
迷乱__迷亂 112.34478795|mi luan;
米拉__米拉 107.14877401|mi la;
糜烂__糜爛 335.946843682|mi lan;
米兰__米蘭 2692.03036174|mi lan;
米勒__米勒 260.534419685|mi le;
米粒__米粒 171.617679695|mi li;
迷离__迷離 403.48504224|mi li;
迷恋__迷戀 744.902491688|mi lian;
密林__密林 139.026849285|mi lin;
米卢__米盧 125.522047856|mi lu;
迷路__迷路 680.129467195|mi lu;
米高__米高 261.184568064|mi gao;
迷宫__迷宮 884.6784987|mi gong;
米国__米國 276.249600432|mi guo;
迷幻__迷幻 170.977284899|mi huan;
迷糊__迷糊 742.122873174|mi hu;
迷惑__迷惑 908.135681884|mi huo;
秘诀__秘訣 601.940653207|mi jue;
秘笈__秘笈 228.580284053|mi ji;
秘籍__秘籍 581.299547476|mi ji;
密集__密集 1026.09756322|mi ji;
迷津__迷津 145.405889264|mi jin;
米酒__米酒 198.308623594|mi jiu;
米奇__米奇 218.552335545|mi qi;
密切__密切 1942.15867186|mi qie;
米线__米線 268.778909483|mi xian;
迷信__迷信 836.433324055|mi xin;
眯着__眯着 154.561368684|mi zhe;
迷住__迷住 153.028150386|mi zhu;
米处__米處 231.158356006|mi chu;
迷上__迷上 335.110594827|mi shang;
密室__密室 163.884358899|mi shi;
觅食__覓食 203.820597887|mi shi;
迷失__迷失 1166.62851836|mi shi;
秘书__秘書 1925.29057912|mi shu;
迷人__迷人 1409.92327219|mi ren;
密宗__密宗 109.034528882|mi zong;
迷醉__迷醉 114.75018218|mi zui;
迷彩__迷彩 120.015323434|mi cai;
米色__米色 177.269210225|mi se;
密钥__密鑰 283.221176861|mi yue;
蜜月__蜜月 283.574337601|mi yue;
密云__密雲 177.490254874|mi yun;
密钥__密鑰 283.221176861|mi yao;
密友__密友 333.444336783|mi you;
谜语__謎語 189.372573382|mi yu;
迷惘__迷惘 360.677581637|mi wang;
迷雾__迷霧 296.585723861|mi wu;
米尔__米爾 168.439513167|mi er;
面板__面板 2049.06835863|mian ban;
面包__麵包 2289.40978274|mian bao;
棉被__棉被 219.918349804|mian bei;
面壁__面壁 171.190483873|mian bi;
棉布__棉布 173.337150041|mian bu;
面部__面部 1023.54337071|mian bu;
面庞__面龐 130.954650472|mian pang;
面貌__面貌 835.391638074|mian mao;
面面__面面 110.126966673|mian mian;
绵绵__綿綿 364.291279287|mian mian;
面膜__面膜 1205.04668542|mian mo;
面目__面目 512.55262135|mian mu;
面粉__麵粉 675.063104121|mian fen;
免费__免費 13894.5537545|mian fei;
面带__面帶 151.132997772|mian dai;
免得__免得 1870.89154158|mian de;
面的__面的 476.219822262|mian di;
缅甸__緬甸 676.747684543|mian dian;
面对__面對 13120.4658397|mian dui;
面团__麵糰 172.690339006|mian tuan;
免谈__免談 122.127521944|mian tan;
面瘫__面癱 139.72158175|mian tan;
面谈__面談 501.808489233|mian tan;
腼腆__靦腆 367.482952871|mian tian;
面条__麵條 812.799921236|mian tiao;
勉励__勉勵 194.636170786|mian li;
面料__面料 942.728934628|mian liao;
面临__面臨 6529.43267016|mian lin;
面露__面露 108.627664361|mian lu;
面馆__麵館 132.266710153|mian guan;
面广__面廣 178.822323044|mian guang;
面孔__面孔 1162.27522076|mian kong;
棉花__棉花 1235.45786087|mian hua;
缅怀__緬懷 326.454673948|mian huai;
面积__面積 5671.78138992|mian ji;
面颊__面頰 170.127140854|mian jia;
面具__面具 779.081233415|mian ju;
面前__面前 9313.6168469|mian qian;
勉强__勉強 2355.97787927|mian qiang;
免去__免去 400.978810625|mian qu;
面相__面相 191.508436159|mian xiang;
面向__面向 2985.38139212|mian xiang;
面罩__面罩 140.419785869|mian zhao;
免征__免征 212.641966978|mian zheng;
免职__免職 205.350275845|mian zhi;
面值__面值 398.48814637|mian zhi;
绵竹__綿竹 113.187937993|mian zhu;
面朝__面朝 120.46484039|mian chao;
免除__免除 480.991159713|mian chu;
面霜__面霜 170.339279748|mian shuang;
面纱__面紗 305.97104031|mian sha;
面上__面上 737.513205869|mian shang;
免试__免試 125.209594649|mian shi;
面市__面市 177.711575153|mian shi;
面食__麵食 195.852702213|mian shi;
面世__面世 347.00988711|mian shi;
面试__面試 6736.05351167|mian shi;
免收__免收 219.37092252|mian shou;
免受__免受 226.030964922|mian shou;
面熟__面熟 117.792774542|mian shu;
免税__免稅 412.637883794|mian shui;
面容__面容 545.504855178|mian rong;
免责__免責 112.065135969|mian ze;
面子__面子 2822.57620712|mian zi;
面色__面色 365.655730945|mian se;
绵延__綿延 181.290467084|mian yan;
绵羊__綿羊 291.093289619|mian yang;
绵阳__綿陽 596.712660816|mian yang;
棉衣__棉衣 142.535402072|mian yi;
面议__面議 186.32942291|mian yi;
免疫__免疫 1714.60618362|mian yi;
免于__免於 182.651055928|mian yu;
棉袄__棉襖 191.269933402|mian ao;
面额__面額 114.46454262|mian e;
苗圃__苗圃 182.878811433|miao pu;
渺茫__渺茫 348.309611377|miao mang;
苗苗__苗苗 190.793818607|miao miao;
喵喵__喵喵 322.411748334|miao miao;
苗木__苗木 295.111021611|miao mu;
苗条__苗條 587.123698784|miao tiao;
苗头__苗頭 215.845709156|miao tou;
秒内__秒內 127.73116145|miao nei;
庙里__廟裡 160.449013667|miao li;
秒后__秒后 150.381524744|miao hou;
庙会__廟會 224.347234118|miao hui;
描绘__描繪 1062.53280282|miao hui;
渺小__渺小 406.006938516|miao xiao;
描写__描寫 1627.17345269|miao xie;
瞄准__瞄準 911.537100768|miao zhun;
秒钟__秒鐘 1000.83985593|miao zhong;
秒杀__秒殺 282.164331387|miao sha;
藐视__藐視 228.011295226|miao shi;
描述__描述 6871.70932104|miao shu;
苗子__苗子 112.065135969|miao zi;
苗族__苗族 265.78126155|miao zu;
妙用__妙用 107.14877401|miao yong;
庙宇__廟宇 158.264611567|miao yu;
咩咩__咩咩 121.520271774|mie mie;
灭掉__滅掉 122.432284019|mie diao;
灭了__滅了 394.535222541|mie le;
灭火__滅火 347.875829952|mie huo;
灭绝__滅絕 463.919044053|mie jue;
灭菌__滅菌 176.827946446|mie jun;
蔑视__蔑視 298.439468992|mie shi;
灭亡__滅亡 534.735933039|mie wang;
民办__民辦 399.482550191|min ban;
民兵__民兵 335.528458728|min bing;
民盟__民盟 118.676811842|min meng;
泯灭__泯滅 138.85370659|min mie;
敏敏__敏敏 191.747236314|min min;
民法__民法 284.636464248|min fa;
民房__民房 182.651055928|min fang;
民风__民風 191.031727675|min feng;
民调__民調 187.027319083|min diao;
闽台__閩台 125.835280772|min tai;
闽南__閩南 211.057972369|min nan;
敏感__敏感 3956.50529033|min gan;
民歌__民歌 459.317058623|min ge;
民工__民工 1868.56155133|min gong;
民国__民國 615.595353746|min guo;
闵行__閔行 390.135034682|min hang;
民航__民航 635.867483878|min hang;
民间__民間 3122.36117229|min jian;
岷江__岷江 115.323601467|min jiang;
敏捷__敏捷 1050.68254543|min jie;
民警__民警 2309.46804145|min jing;
民居__民居 322.813777494|min ju;
民权__民權 124.276893895|min quan;
民企__民企 374.883606282|min qi;
民情__民情 194.151676652|min qing;
民心__民心 376.287731462|min xin;
民宅__民宅 138.85370659|min zhai;
民政__民政 326.454673948|min zheng;
民众__民眾 3298.34499764|min zhong;
民主__民主 4503.98449045|min zhu;
民生__民生 1749.13623734|min sheng;
民事__民事 711.336195135|min shi;
敏锐__敏銳 722.053448193|min rui;
民族__民族 7488.72362169|min zu;
民俗__民俗 508.100984482|min su;
民乐__民樂 148.149450567|min yue;
民运__民運 116.333988795|min yun;
民谣__民謠 322.411748334|min yao;
民意__民意 767.517531652|min yi;
民营__民營 794.770968525|min ying;
民用__民用 548.230802969|min yong;
明白__明白 19968.0080118|ming bai;
铭牌__銘牌 111.925571131|ming pai;
名牌__名牌 1727.4743398|ming pai;
名片__名片 2085.13074641|ming pian;
名品__名品 122.737806611|ming pin;
命脉__命脈 168.859844103|ming mai;
名门__名門 183.792676978|ming men;
明媚__明媚 395.027185582|ming mei;
冥冥__冥冥 288.205701591|ming ming;
命名__命名 2321.00870739|ming ming;
明明__明明 3269.69811616|ming ming;
名模__名模 290.368691563|ming mo;
明目__明目 125.992190229|ming mu;
名目__名目 163.272821143|ming mu;
名分__名分 127.73116145|ming fen;
明代__明代 569.823995046|ming dai;
名单__名單 4153.542672|ming dan;
明道__明道 232.313479749|ming dao;
明德__明德 106.748946222|ming de;
明灯__明燈 146.679837233|ming deng;
名堂__名堂 298.811606079|ming tang;
命题__命題 1032.51096484|ming ti;
明天__明天 58168.3990166|ming tian;
名头__名頭 174.638049069|ming tou;
明年__明年 8315.12675373|ming nian;
明朗__明朗 781.999279332|ming lang;
命理__命理 131.773154284|ming li;
名利__名利 400.978810625|ming li;
明了__明了 515.113903202|ming liao;
明亮__明亮 1162.27522076|ming liang;
名列__名列 536.738784525|ming lie;
命令__命令 5836.6971223|ming ling;
名流__名流 251.914183226|ming liu;
名录__名錄 498.070459751|ming lu;
名贵__名貴 328.904723278|ming gui;
明快__明快 244.491487214|ming kuai;
命苦__命苦 401.979429753|ming ku;
名号__名號 301.429591092|ming hao;
名妓__名妓 151.321452046|ming ji;
铭记__銘記 282.868455943|ming ji;
明基__明基 706.917758081|ming ji;
名家__名家 590.793388895|ming jia;
鸣叫__鳴叫 122.279808036|ming jiao;
明教__明教 209.746993999|ming jiao;
名叫__名叫 1376.93239525|ming jiao;
名将__名將 436.438689186|ming jiang;
冥界__冥界 123.351140937|ming jie;
明镜__明鏡 131.445140637|ming jing;
名句__名句 176.168109435|ming ju;
明确__明確 10341.4024245|ming que;
名企__名企 140.594881376|ming qi;
名气__名氣 1130.84350481|ming qi;
明清__明清 450.24958728|ming qing;
名曲__名曲 150.756793028|ming qu;
明晰__明晰 345.284462654|ming xi;
明细__明細 1413.4416531|ming xi;
名下__名下 350.92368248|ming xia;
明显__明顯 17805.084758|ming xian;
名校__名校 625.649317648|ming xiao;
冥想__冥想 200.545272755|ming xiang;
明星__明星 6059.03211339|ming xing;
名状__名狀 239.366454718|ming zhuang;
明朝__明朝 185.172044961|ming zhao;
明治__明治 224.626982392|ming zhi;
明知__明知 638.24912322|ming zhi;
明智__明智 760.851466162|ming zhi;
命中__命中 1063.85772095|ming zhong;
名著__名著 360.677581637|ming zhu;
明珠__明珠 770.392265767|ming zhu;
明朝__明朝 781.999279332|ming chao;
名车__名車 179.71591787|ming che;
名城__名城 202.807148249|ming cheng;
名称__名稱 7803.10604967|ming cheng;
名山__名山 195.852702213|ming shan;
名胜__名勝 160.849404779|ming sheng;
名声__名聲 1067.84239617|ming sheng;
名士__名士 124.431860131|ming shi;
明示__明示 224.626982392|ming shi;
名师__名師 449.688850794|ming shi;
明说__明說 260.209952636|ming shuo;
鸣人__鳴人 162.86639759|ming ren;
名人__名人 2087.73078616|ming ren;
明日__明日 1048.06715525|ming ri;
明锐__明銳 186.32942291|ming rui;
明早__明早 720.256091319|ming zao;
名字__名字 23304.722844|ming zi;
名作__名作 150.007190589|ming zuo;
名嘴__名嘴 115.755545596|ming zui;
名菜__名菜 106.350610398|ming cai;
名册__名冊 148.704343794|ming ce;
名次__名次 472.083744072|ming ci;
名词__名詞 1152.18059436|ming ci;
名曰__名曰 123.504952812|ming yue;
明月__明月 1274.55334676|ming yue;
命运__命運 4571.84317933|ming yun;
名言__名言 672.544092675|ming yan;
名医__名醫 163.069482749|ming yi;
名义__名義 2341.34381449|ming yi;
名优__名優 147.045868173|ming you;
名誉__名譽 776.174076244|ming yu;
明晚__明晚 560.667124391|ming wan;
冥王__冥王 116.915322539|ming wang;
明文__明文 196.341441156|ming wen;
名为__名為 1836.24473312|ming wei;
明暗__明暗 129.655606164|ming an;
命案__命案 203.820597887|ming an;
名额__名額 1082.58098585|ming e;
明儿__明兒 297.696584607|ming er;
谬论__謬論 152.267254161|miu lun;
谬误__謬誤 117.207077876|miu wu;
膜拜__膜拜 263.144763849|mo bai;
模版__模版 491.902185928|mo ban;
模板__模板 4571.84317933|mo ban;
莫不__莫不 131.281440129|mo bu;
磨灭__磨滅 166.353500999|mo mie;
莫名__莫名 1268.21593219|mo ming;
嬷嬷__嬤嬤 116.333988795|mo mo;
摸摸__摸摸 1077.19810837|mo mo;
默默__默默 2606.20557717|mo mo;
魔法__魔法 2391.47390956|mo fa;
模范__模範 669.200026501|mo fan;
魔方__魔方 200.545272755|mo fang;
模仿__模仿 2106.02207003|mo fang;
莫非__莫非 1474.61550226|mo fei;
末端__末端 315.260239073|mo duan;
莫大__莫大 441.361118731|mo da;
摸到__摸到 338.046607007|mo dao;
摩登__摩登 175.292155245|mo deng;
摸底__摸底 292.912705474|mo di;
模特__模特 1674.48601346|mo te;
魔头__魔頭 113.32907693|mo tou;
摩托__摩托 846.921892564|mo tuo;
魔女__魔女 358.437246895|mo nv;
磨难__磨難 409.054029297|mo nan;
模拟__模擬 4195.15781018|mo ni;
默念__默念 149.633788238|mo nian;
末年__末年 191.508436159|mo nian;
抹了__抹了 136.963309627|mo le;
摸了__摸了 393.063006485|mo le;
磨砺__磨礪 187.4940348|mo li;
茉莉__茉莉 417.812212206|mo li;
魔力__魔力 769.432826682|mo li;
磨炼__磨鍊 126.149295342|mo lian;
磨练__磨練 519.626982517|mo lian;
陌路__陌路 129.655606164|mo lu;
没落__沒落 353.117055307|mo luo;
摩根__摩根 283.927938713|mo gen;
蘑菇__蘑菇 861.827215553|mo gu;
摸过__摸過 130.46599058|mo guo;
魔鬼__魔鬼 1206.54931027|mo gui;
模块__模塊 6321.26742797|mo kuai;
魔幻__魔幻 363.837594448|mo huan;
墨盒__墨盒 515.113903202|mo he;
磨合__磨合 532.077085292|mo he;
抹黑__抹黑 189.136730609|mo hei;
模糊__模糊 3181.27480592|mo hu;
磨叽__磨嘰 107.015331962|mo ji;
墨迹__墨跡 379.111778956|mo ji;
摩羯__摩羯 118.824795093|mo jie;
魔界__魔界 211.321149687|mo jie;
魔羯__魔羯 211.848489234|mo jie;
魔戒__魔戒 215.040276584|mo jie;
魔镜__魔鏡 115.467403456|mo jing;
墨镜__墨鏡 452.499534015|mo jing;
模具__模具 1002.08784645|mo ju;
末期__末期 298.06779536|mo qi;
默契__默契 1026.09756322|mo qi;
摸清__摸清 246.633556117|mo qing;
抹去__抹去 295.111021611|mo qu;
摩西__摩西 118.08671951|mo xi;
模型__模型 6028.9050116|mo xing;
默许__默許 178.822323044|mo xu;
魔杖__魔杖 226.312812713|mo zhang;
摸着__摸着 439.714170908|mo zhe;
魔咒__魔咒 147.045868173|mo zhou;
摸出__摸出 169.915266157|mo chu;
抹杀__抹殺 204.07475061|mo sha;
磨砂__磨砂 223.788782324|mo sha;
抹上__抹上 130.628674269|mo shang;
陌上__陌上 198.555903198|mo shang;
魔神__魔神 184.02185602|mo shen;
陌生__陌生 3302.45784674|mo sheng;
漠视__漠視 324.02287532|mo shi;
模式__模式 14714.3117017|mo shi;
没收__沒收 787.868200695|mo shou;
魔兽__魔獸 3768.81504502|mo shou;
莫属__莫屬 212.907119447|mo shu;
魔术__魔術 642.238361775|mo shu;
墨水__墨水 476.813641365|mo shui;
默然__默然 148.889769675|mo ran;
蓦然__驀然 157.477678279|mo ran;
漠然__漠然 189.608710238|mo ran;
默认__默認 3897.77990299|mo ren;
末日__末日 387.711726118|mo ri;
墨子__墨子 203.060037258|mo zi;
魔族__魔族 118.529012887|mo zu;
模组__模組 191.98633424|mo zu;
磨擦__磨擦 185.86560618|mo ca;
摩擦__摩擦 1007.09538969|mo ca;
磨蹭__磨蹭 188.196293023|mo ceng;
磨损__磨損 649.481929235|mo sun;
摸索__摸索 879.183352683|mo suo;
磨牙__磨牙 188.665925845|mo ya;
莫言__莫言 110.677283245|mo yan;
模样__模樣 1392.46230328|mo yang;
魔芋__魔芋 108.087539034|mo yu;
魔域__魔域 204.839111844|mo yu;
魔王__魔王 391.108593802|mo wang;
末尾__末尾 258.271618599|mo wei;
默哀__默哀 307.883446338|mo ai;
摩尔__摩爾 256.987424161|mo er;
某部__某部 136.963309627|mou bu;
谋面__謀面 149.447435764|mou mian;
某某__某某 1296.98472971|mou mou;
某地__某地 208.964318904|mou di;
某天__某天 402.982545867|mou tian;
谋略__謀略 194.393772779|mou lue;
牟利__牟利 186.32942291|mou li;
某个__某個 4793.54763754|mou ge;
谋划__謀划 413.667597456|mou hua;
某家__某家 137.991222203|mou jia;
谋求__謀求 532.077085292|mou qiu;
谋取__謀取 309.4219738|mou qu;
某项__某項 189.608710238|mou xiang;
某些__某些 7036.3533641|mou xie;
某种__某種 3257.49717238|mou zhong;
某处__某處 179.268563673|mou chu;
谋杀__謀殺 445.228026075|mou sha;
谋生__謀生 364.745529846|mou sheng;
某市__某市 105.690017726|mou shi;
某事__某事 110.95347192|mou shi;
某人__某人 2318.11814557|mou ren;
某日__某日 220.19257551|mou ri;
眸子__眸子 210.008536601|mou zi;
某次__某次 153.601316766|mou ci;
某一__某一 1609.02584897|mou yi;
某位__某位 361.12732612|mou wei;
模板__模板 273.509258874|mu ban;
木板__木板 477.408200926|mu ban;
墓碑__墓碑 286.772667017|mu bei;
目标__目標 19598.2229476|mu biao;
幕布__幕布 105.821807183|mu bu;
木马__木馬 2197.17084589|mu ma;
木门__木門 224.06783424|mu men;
木棉__木棉 105.0335283|mu mian;
牧民__牧民 259.885889675|mu min;
木木__木木 421.472799973|mu mu;
牡丹__牡丹 1092.0658276|mu dan;
目地__目地 137.991222203|mu de;
墓地__墓地 813.813436628|mu di;
目的__目的 15048.0979626|mu di;
木雕__木雕 161.854759309|mu diao;
目睹__目睹 566.284555508|mu du;
木炭__木炭 109.989815613|mu tan;
母体__母體 236.402059204|mu ti;
木头__木頭 1268.21593219|mu tou;
木桶__木桶 161.049974862|mu tong;
母女__母女 427.290057918|mu nv;
木讷__木訥 172.690339006|mu ne;
母牛__母牛 251.914183226|mu niu;
木兰__木蘭 245.101601395|mu lan;
牡蛎__牡蠣 108.087539034|mu li;
目录__目錄 7062.70799995|mu lu;
木瓜__木瓜 394.043872187|mu gua;
目光__目光 3792.371211|mu guang;
木棍__木棍 159.85029497|mu gun;
母狗__母狗 212.641966978|mu gou;
木工__木工 221.017305999|mu gong;
幕后__幕後 952.17431607|mu hou;
募捐__募捐 378.63963681|mu juan;
目击__目擊 210.270405333|mu ji;
母鸡__母雞 362.028498203|mu ji;
募集__募集 474.442798491|mu ji;
木匠__木匠 204.07475061|mu jiang;
模具__模具 250.974160423|mu ju;
目前__目前 45167.1674565|mu qian;
幕墙__幕牆 148.334184528|mu qiang;
母亲__母親 10642.0945417|mu qin;
牧区__牧區 151.321452046|mu qu;
墓穴__墓穴 134.594525802|mu xue;
母线__母線 108.898738333|mu xian;
母校__母校 499.935980841|mu xiao;
木箱__木箱 116.18910757|mu xiang;
母性__母性 150.569041974|mu xing;
木星__木星 171.831677206|mu xing;
木制__木製 237.879639313|mu zhi;
木质__木質 312.522131716|mu zhi;
拇指__拇指 479.196331601|mu zhi;
母猪__母豬 476.813641365|mu zhu;
亩产__畝產 146.132498493|mu chan;
牧场__牧場 312.911829085|mu chang;
牧师__牧師 2992.83123646|mu shi;
慕容__慕容 648.673070715|mu rong;
母乳__母乳 383.865702254|mu ru;
墓葬__墓葬 159.651218957|mu zang;
木子__木子 203.566761683|mu zi;
母子__母子 537.40806734|mu zi;
木村__木村 142.357889859|mu cun;
木材__木材 761.800204777|mu cai;
牧草__牧草 137.991222203|mu cao;
目测__目測 128.850255419|mu ce;
暮色__暮色 212.641966978|mu se;
目送__目送 168.439513167|mu song;
牧羊__牧羊 122.279808036|mu yang;
模样__模樣 474.442798491|mu yang;
木叶__木葉 114.179614083|mu ye;
牧业__牧業 120.164975734|mu ye;
木业__木業 145.768741141|mu ye;
母婴__母嬰 221.017305999|mu ying;
木鱼__木魚 148.519148841|mu yu;
母语__母語 309.4219738|mu yu;
沐浴__沐浴 603.442760838|mu yu;
木屋__木屋 121.975425508|mu wu;
母爱__母愛 383.865702254|mu ai;
木耳__木耳 227.727332161|mu er;
木偶__木偶 230.582949765|mu ou;
发白__發白 181.516526012|fa bai;
发包__發包 161.049974862|fa bao;
法宝__法寶 750.493000864|fa bao;
发飙__發飆 632.705783453|fa biao;
发表__發表 15504.9541829|fa biao;
发病__發病 1153.6172982|fa bing;
发布__發布 14387.9292515|fa bu;
发胖__發胖 265.119670945|fa pang;
发泡__發泡 130.628674269|fa pao;
发配__發配 108.627664361|fa pei;
发片__發片 232.893204426|fa pian;
发票__發票 5114.45798754|fa piao;
发麻__發麻 146.679837233|fa ma;
砝码__砝碼 206.89143407|fa ma;
发毛__發毛 108.222318063|fa mao;
法门__法門 183.335174792|fa men;
阀门__閥門 522.874798954|fa men;
发霉__發霉 268.778909483|fa mei;
发明__發明 2074.76292775|fa ming;
伐木__伐木 122.279808036|fa mu;
发发__發發 355.767206381|fa fa;
发放__發放 3306.57582432|fa fang;
发奋__發奮 112.34478795|fa fen;
发疯__發瘋 567.697685436|fa feng;
发福__發福 178.59961945|fa fu;
发达__發達 2784.14878864|fa da;
发呆__發獃 1333.03432936|fa dai;
罚单__罰單 175.292155245|fa dan;
发到__發到 1795.51445179|fa dao;
法典__法典 114.46454262|fa dian;
发点__發點 200.795341333|fa dian;
发电__發電 1045.45827538|fa dian;
法定__法定 1420.50477658|fa ding;
发抖__發抖 509.368920718|fa dou;
发动__發動 2353.04376718|fa dong;
发烫__發燙 138.335571213|fa tang;
法条__法條 118.529012887|fa tiao;
发条__發條 166.146325956|fa tiao;
发贴__發貼 1861.58897661|fa tie;
发帖__發帖 2043.96775685|fa tie;
法庭__法庭 1856.95505407|fa ting;
发难__發難 124.89791921|fa nan;
发怒__發怒 199.299593609|fa nu;
法律__法律 11964.6559863|fa lv;
法拉__法拉 128.049907079|fa la;
发来__發來 1173.92027842|fa lai;
法兰__法蘭 222.67604562|fa lan;
发廊__髮廊 304.829303266|fa lang;
法老__法老 118.08671951|fa lao;
法理__法理 237.879639313|fa li;
乏力__乏力 382.910172354|fa li;
法力__法力 592.267679181|fa li;
发力__發力 626.429466854|fa li;
发亮__發亮 267.44247003|fa liang;
法令__法令 292.54791482|fa ling;
法官__法官 2197.17084589|fa guan;
发光__發光 778.110973173|fa guang;
发稿__發稿 235.813600182|fa gao;
发哥__發哥 258.271618599|fa ge;
发个__發個 1481.9843182|fa ge;
发给__發給 3612.46722234|fa gei;
发过__發過 835.391638074|fa guo;
法国__法國 7395.98072362|fa guo;
法规__法規 2442.67733117|fa gui;
罚款__罰款 1710.33813502|fa kuan;
发狂__發狂 174.42055653|fa kuang;
发卡__發卡 240.862563142|fa ka;
发刊__發刊 149.075426771|fa kan;
发话__發話 255.073095111|fa hua;
发黄__發黃 250.349428094|fa huang;
发黑__發黑 182.651055928|fa hei;
发红__發紅 221.017305999|fa hong;
发火__發火 533.404852483|fa huo;
发货__發貨 3585.55753613|fa huo;
发回__發回 213.704562287|fa hui;
发挥__發揮 8783.78740305|fa hui;
发掘__發掘 1260.33845835|fa jue;
发觉__發覺 1870.89154158|fa jue;
发夹__髮夾 118.529012887|fa jia;
发家__發家 136.963309627|fa jia;
发酵__發酵 755.18379558|fa jiao;
罚金__罰金 144.863304286|fa jin;
发起__發起 2148.43475692|fa qi;
发钱__發錢 254.755429543|fa qian;
发情__發情 228.295612376|fa qing;
罚球__罰球 255.073095111|fa qiu;
发球__發球 333.860122955|fa qiu;
法学__法學 675.904869515|fa xue;
法系__法系 234.348853194|fa xi;
罚下__罰下 148.889769675|fa xia;
发现__發現 50590.8934654|fa xian;
发笑__發笑 174.638049069|fa xiao;
发些__發些 119.26985293|fa xie;
发泄__發泄 1674.48601346|fa xie;
发信__發信 563.46883971|fa xin;
发型__髮型 1408.16736736|fa xing;
发行__發行 5902.52705689|fa xing;
发展__發展 54045.0745681|fa zhan;
发张__發張 240.862563142|fa zhang;
法杖__法杖 400.479435488|fa zhang;
发着__發著 145.405889264|fa zhe;
发证__發證 338.890182508|fa zheng;
发至__發至 113.47039186|fa zhi;
发质__發質 121.368931601|fa zhi;
法治__法治 931.053859154|fa zhi;
法制__法制 1193.09285994|fa zhi;
发春__發春 142.357889859|fa chun;
发车__發車 300.304800557|fa che;
发愁__發愁 557.879339939|fa chou;
发出__發出 6786.60773774|fa chu;
发上__發上 105.426930997|fa shang;
发烧__發燒 1420.50477658|fa shao;
发射__發射 2059.3077787|fa she;
发声__發聲 286.415523108|fa sheng;
发生__發生 29900.9225255|fa sheng;
法式__法式 154.368879448|fa shi;
发誓__發誓 976.203874871|fa shi;
法师__法師 5657.66302334|fa shi;
发售__發售 922.967443217|fa shou;
法术__法術 781.999279332|fa shu;
发软__發軟 113.611883002|fa ruan;
发热__發熱 978.639934443|fa re;
法人__法人 1085.28250327|fa ren;
发在__發在 152.647228173|fa zai;
法则__法則 867.213880777|fa ze;
法子__法子 347.00988711|fa zi;
发自__發自 395.027185582|fa zi;
发作__發作 1096.15615618|fa zuo;
发财__發財 1404.66211536|fa cai;
发错__發錯 778.110973173|fa cuo;
发散__發散 187.4940348|fa san;
发骚__發騷 117.061109314|fa sao;
发丝__髮絲 198.555903198|fa si;
发送__發送 6966.55412633|fa song;
法院__法院 4926.78395812|fa yuan;
发运__發運 108.763116896|fa yun;
发芽__發芽 341.008342538|fa ya;
发炎__發炎 547.548041623|fa yan;
发言__發言 5721.47369896|fa yan;
发痒__發癢 129.817279349|fa yang;
发扬__發揚 873.722339551|fa yang;
法医__法醫 272.828431509|fa yi;
发音__發音 1130.84350481|fa yin;
法语__法語 1045.45827538|fa yu;
发育__發育 1981.27135202|fa yu;
法王__法王 169.703655326|fa wang;
法网__法網 193.427195796|fa wang;
发往__發往 219.097720093|fa wang;
法文__法文 211.848489234|fa wen;
发问__發問 268.444174826|fa wen;
发文__發文 504.944935018|fa wen;
发威__發威 251.600451735|fa wei;
乏味__乏味 454.760723981|fa wei;
法务__法務 138.508067822|fa wu;
法案__法案 526.798985534|fa an;
翻版__翻版 289.645897197|fan ban;
范本__範本 243.57916235|fan ben;
反被__反被 109.170488754|fan bei;
翻倍__翻倍 450.811022973|fan bei;
反驳__反駁 794.770968525|fan bo;
帆布__帆布 167.601987591|fan bu;
反派__反派 170.339279748|fan pai;
翻拍__翻拍 179.940013424|fan pai;
翻盘__翻盤 161.451865638|fan pan;
反叛__反叛 254.438159592|fan pan;
反扑__反撲 119.121315407|fan pu;
贩卖__販賣 466.818670029|fan mai;
繁忙__繁忙 838.520594407|fan mang;
烦闷__煩悶 146.497163581|fan men;
反美__反美 191.031727675|fan mei;
反面__反面 520.274927886|fan mian;
犯法__犯法 385.78392141|fan fa;
泛泛__泛泛 125.835280772|fan fan;
饭饭__飯飯 316.441045148|fan fan;
翻翻__翻翻 377.697115787|fan fan;
翻番__翻番 515.756221017|fan fan;
繁复__繁複 171.617679695|fan fu;
反腐__反腐 352.238065853|fan fu;
反复__反覆 3820.83303827|fan fu;
翻到__翻到 260.859291326|fan dao;
反倒__反倒 858.611290099|fan dao;
返点__返點 170.339279748|fan dian;
饭店__飯店 2879.41941052|fan dian;
翻动__翻動 118.676811842|fan dong;
反动__反動 486.416079992|fan dong;
贩毒__販毒 255.709615075|fan du;
繁多__繁多 488.237949645|fan duo;
反对__反對 5532.16874554|fan dui;
饭团__飯糰 147.596627936|fan tuan;
反贪__反貪 125.053659829|fan tan;
反弹__反彈 3782.93112802|fan tan;
饭堂__飯堂 226.312812713|fan tang;
翻腾__翻騰 163.069482749|fan teng;
繁体__繁體 1026.09756322|fan ti;
饭桶__飯桶 130.46599058|fan tong;
烦恼__煩惱 3011.53728293|fan nao;
范尼__范尼 212.641966978|fan ni;
翻来__翻來 160.649084484|fan lai;
泛蓝__泛藍 118.529012887|fan lan;
泛滥__泛濫 1005.84116282|fan lan;
烦了__煩了 290.368691563|fan le;
犯了__犯了 865.055186245|fan le;
翻了__翻了 1009.60853723|fan le;
返利__返利 163.069482749|fan li;
范例__範例 427.82286438|fan li;
翻脸__翻臉 280.761336094|fan lian;
饭量__飯量 120.015323434|fan liang;
反观__反觀 225.749468142|fan guan;
饭馆__飯館 512.55262135|fan guan;
反光__反光 319.213487372|fan guang;
翻滚__翻滾 299.557272934|fan gun;
翻盖__翻蓋 241.764712994|fan gai;
反感__反感 1190.12297778|fan gan;
梵高__梵高 128.049907079|fan gao;
反共__反共 115.611384758|fan gong;
返工__返工 259.238974004|fan gong;
反攻__反攻 296.955549433|fan gong;
犯过__犯過 108.763116896|fan guo;
翻过__翻過 302.181790975|fan guo;
犯规__犯規 902.494832488|fan gui;
犯困__犯困 163.476413088|fan kun;
翻开__翻開 490.066643104|fan kai;
翻看__翻看 318.022335873|fan kan;
反抗__反抗 1319.8108917|fan kang;
反恐__反恐 686.943814365|fan kong;
反馈__反饋 3205.15034156|fan kui;
反华__反華 198.803491145|fan hua;
番话__番話 211.584655172|fan hua;
繁华__繁華 1334.69654755|fan hua;
返还__返還 799.738513132|fan huan;
泛黄__泛黃 117.207077876|fan huang;
饭盒__飯盒 252.228305921|fan he;
饭后__飯後 571.958268741|fan hou;
翻红__翻紅 123.044091616|fan hong;
反悔__反悔 268.109857044|fan hui;
返回__返回 6142.66017363|fan hui;
反击__反擊 1258.76884501|fan ji;
凡间__凡間 142.003528374|fan jian;
犯贱__犯賤 305.97104031|fan jian;
饭局__飯局 388.195180646|fan ju;
泛起__泛起 271.133768339|fan qi;
反潜__反潛 110.95347192|fan qian;
饭钱__飯錢 123.504952812|fan qian;
饭前__飯前 196.341441156|fan qian;
蕃茄__蕃茄 112.484875527|fan qie;
番茄__番茄 1093.42757174|fan qie;
烦请__煩請 318.022335873|fan qing;
犯下__犯下 305.97104031|fan xia;
范县__范縣 108.357265155|fan xian;
返校__返校 147.229226029|fan xiao;
返乡__返鄉 258.593668656|fan xiang;
反向__反向 499.3133654|fan xiang;
反响__反響 825.045864155|fan xiang;
烦心__煩心 301.429591092|fan xin;
翻新__翻新 530.091629029|fan xin;
繁星__繁星 177.269210225|fan xing;
反省__反省 1028.65812957|fan xing;
返修__返修 223.231720645|fan xiu;
翻转__翻轉 285.702569086|fan zhuan;
反转__反轉 414.183417482|fan zhuan;
反战__反戰 204.329220247|fan zhan;
翻着__翻着 125.36572391|fan zhe;
泛着__泛着 246.019628549|fan zhe;
反震__反震 199.299593609|fan zhen;
反正__反正 27816.0078705|fan zheng;
反制__反制 158.264611567|fan zhi;
泛指__泛指 160.649084484|fan zhi;
反之__反之 357.099731154|fan zhi;
繁殖__繁殖 1012.12795618|fan zhi;
繁重__繁重 367.025293151|fan zhong;
饭桌__飯桌 246.326401069|fan zhuo;
帆船__帆船 299.1842072|fan chuan;
反差__反差 507.468200425|fan cha;
反常__反常 318.815941979|fan chang;
翻唱__翻唱 564.874943184|fan chang;
翻炒__翻炒 160.049619219|fan chao;
反超__反超 173.986383704|fan chao;
凡尘__凡塵 114.46454262|fan chen;
返程__返程 204.584007193|fan cheng;
饭吃__飯吃 642.238361775|fan chi;
犯愁__犯愁 106.350610398|fan chou;
范畴__範疇 1107.13875428|fan chou;
翻出__翻出 277.976239008|fan chu;
反射__反射 989.677650042|fan she;
翻身__翻身 686.088301175|fan shen;
繁盛__繁盛 112.204874836|fan sheng;
范式__範式 196.586267794|fan shi;
凡事__凡事 773.277767188|fan shi;
凡是__凡是 1915.71752783|fan shi;
反手__反手 202.302314677|fan shou;
翻书__翻書 111.507918629|fan shu;
番薯__番薯 121.066816454|fan shu;
凡人__凡人 480.991159713|fan ren;
烦人__煩人 607.214449729|fan ren;
犯人__犯人 721.154209805|fan ren;
反日__反日 218.552335545|fan ri;
繁荣__繁榮 1932.50174796|fan rong;
繁杂__繁雜 287.130256264|fan za;
凡在__凡在 139.895806636|fan zai;
烦躁__煩躁 972.56115063|fan zao;
贩子__販子 373.019586361|fan zi;
犯罪__犯罪 3352.21389275|fan zui;
饭菜__飯菜 794.770968525|fan cai;
犯错__犯錯 456.464028614|fan cuo;
反思__反思 1827.1144412|fan si;
烦琐__煩瑣 170.977284899|fan suo;
繁琐__繁瑣 574.81640715|fan suo;
翻越__翻越 137.134095104|fan yue;
翻阅__翻閱 316.046952528|fan yue;
繁衍__繁衍 328.495108513|fan yan;
翻页__翻頁 705.158077415|fan ye;
翻译__翻譯 8794.74028764|fan yi;
翻印__翻印 133.259374649|fan yin;
反应__反應 9371.82960123|fan ying;
反映__反映 10315.6602986|fan ying;
繁育__繁育 242.36802267|fan yu;
饭碗__飯碗 443.56664881|fan wan;
范文__範文 316.441045148|fan wen;
反问__反問 402.480675297|fan wen;
范伟__范偉 162.258658377|fan wei;
反胃__反胃 166.560934377|fan wei;
范围__範圍 13022.7299719|fan wei;
翻案__翻案 117.499561272|fan an;
反而__反而 6036.42271414|fan er;
防爆__防爆 200.04606951|fang bao;
防备__防備 316.83562918|fang bei;
方便__方便 16501.7745179|fang bian;
防病__防病 175.292155245|fang bing;
放炮__放炮 118.23396695|fang pao;
放屁__放屁 960.516622856|fang pi;
放慢__放慢 389.649164279|fang man;
仿冒__仿冒 154.561368684|fang mao;
房门__房門 574.10053635|fang men;
访美__訪美 112.625137786|fang mei;
方面__方面 43347.4095704|fang mian;
放牧__放牧 149.261315371|fang mu;
方法__方法 29383.7853316|fang fa;
防范__防範 1565.51253772|fang fan;
方方__方方 125.835280772|fang fang;
芳芳__芳芳 310.580912674|fang fang;
防风__防風 144.682892926|fang feng;
芳菲__芳菲 113.046974828|fang fei;
房费__房費 133.093414711|fang fei;
放飞__放飛 314.475483928|fang fei;
防腐__防腐 281.461959558|fang fu;
仿佛__彷彿 4920.64818898|fang fu;
放大__放大 2249.81438398|fang da;
放贷__放貸 177.048440864|fang dai;
房贷__房貸 1155.05579352|fang dai;
放荡__放蕩 230.582949765|fang dang;
放倒__放倒 195.60878915|fang dao;
防盗__防盜 447.452879516|fang dao;
放到__放到 3726.78205719|fang dao;
放低__放低 116.333988795|fang di;
房地__房地 123.504952812|fang di;
放点__放點 175.948711373|fang dian;
放电__放電 525.487661863|fang dian;
放掉__放掉 107.952927857|fang diao;
房顶__房頂 224.626982392|fang ding;
防抖__防抖 367.025293151|fang dou;
房东__房東 1339.6956486|fang dong;
防毒__防毒 184.71110921|fang du;
访谈__訪談 1246.28210631|fang tan;
方能__方能 409.054029297|fang neng;
房内__房內 204.07475061|fang nei;
方略__方略 221.292902041|fang lue;
防雷__防雷 219.37092252|fang lei;
房里__房裡 459.889800938|fang li;
放疗__放療 206.376433771|fang liao;
放量__放量 784.92825478|fang liang;
房管__房管 117.646076559|fang guan;
放光__放光 112.065135969|fang guang;
方格__方格 165.114314527|fang ge;
放歌__放歌 213.172602547|fang ge;
放个__放個 220.19257551|fang ge;
仿古__仿古 143.247667161|fang gu;
放过__放過 1415.20413466|fang guo;
放款__放款 128.049907079|fang kuan;
房款__房款 251.600451735|fang kuan;
放宽__放寬 588.588831574|fang kuan;
方框__方框 154.754097942|fang kuang;
方块__方塊 530.752623218|fang kuai;
放开__放開 1498.69906777|fang kai;
房客__房客 198.06165195|fang ke;
访客__訪客 440.811451858|fang ke;
方可__方可 726.566487616|fang ke;
防空__防空 314.083839199|fang kong;
防控__防控 508.734557585|fang kong;
芳华__芳華 117.061109314|fang hua;
防滑__防滑 167.393257695|fang hua;
访华__訪華 450.24958728|fang hua;
放缓__放緩 647.058374454|fang huan;
放号__放號 159.651218957|fang hao;
放好__放好 177.711575153|fang hao;
防洪__防洪 392.084582382|fang hong;
防护__防護 1314.88599102|fang hu;
放火__放火 177.490254874|fang huo;
防火__防火 621.763121294|fang huo;
放回__放回 224.06783424|fang hui;
放假__放假 5302.66888213|fang jia;
房价__房價 6242.98270412|fang jia;
坊间__坊間 195.365179853|fang jian;
房间__房間 8315.12675373|fang jian;
放进__放進 931.053859154|fang jin;
放弃__放棄 10162.547614|fang qi;
放学__放學 774.242000696|fang xue;
防汛__防汛 618.67155147|fang xun;
放下__放下 2454.8836586|fang xia;
防线__防線 786.88699725|fang xian;
仿效__仿效 153.601316766|fang xiao;
芳香__芳香 971.349932368|fang xiang;
方向__方向 12420.4208866|fang xiang;
芳心__芳心 206.633773476|fang xin;
放心__放心 7990.06607204|fang xin;
房型__房型 222.121753798|fang xing;
方形__方形 292.183578474|fang xing;
放行__放行 331.786363812|fang xing;
方庄__方庄 117.499561272|fang zhuang;
房展__房展 113.046974828|fang zhan;
方丈__方丈 209.746993999|fang zhang;
仿照__仿照 172.260473089|fang zhao;
放着__放着 1338.02720458|fang zhe;
防震__防震 156.109948588|fang zhen;
方阵__方陣 218.008308584|fang zhen;
方针__方針 1130.84350481|fang zhen;
仿真__仿真 1383.81307795|fang zhen;
方正__方正 1159.38205078|fang zheng;
方知__方知 135.435779871|fang zhi;
仿制__仿製 271.810366771|fang zhi;
纺织__紡織 909.268075561|fang zhi;
放置__放置 1509.94683642|fang zhi;
防治__防治 2261.05695403|fang zhi;
防止__防止 5843.9751525|fang zhi;
方舟__方舟 205.350275845|fang zhou;
房中__房中 142.535402072|fang zhong;
放逐__放逐 320.808632296|fang zhu;
房主__房主 427.290057918|fang zhu;
方差__方差 141.29744947|fang cha;
房产__房產 2675.30892006|fang chan;
防潮__防潮 148.334184528|fang chao;
房车__房車 175.292155245|fang che;
防尘__防塵 163.069482749|fang chen;
方程__方程 719.359091341|fang cheng;
放出__放出 865.055186245|fang chu;
防晒__防晒 566.990680223|fang shai;
房山__房山 126.464093517|fang shan;
放上__放上 448.56947196|fang shang;
放射__放射 270.796100963|fang she;
防身__防身 140.070248771|fang shen;
放声__放聲 145.587202159|fang sheng;
放生__放生 257.94996962|fang sheng;
房事__房事 163.069482749|fang shi;
房市__房市 341.008342538|fang shi;
方式__方式 33616.9022262|fang shi;
放手__放手 929.894333673|fang shou;
防守__防守 2567.52234013|fang shou;
放水__放水 299.93080386|fang shui;
防水__防水 907.004698479|fang shui;
放人__放人 136.622376491|fang ren;
放任__放任 292.183578474|fang ren;
放入__放入 2535.725271|fang ru;
防灾__防災 223.231720645|fang zai;
放在__放在 11326.2794881|fang zai;
仿造__仿造 152.267254161|fang zao;
方子__方子 195.365179853|fang zi;
房子__房子 17475.3546014|fang zi;
放纵__放縱 664.215078095|fang zong;
房租__房租 1511.82965446|fang zu;
芳村__芳村 106.616002115|fang cun;
方寸__方寸 130.46599058|fang cun;
方才__方才 397.001179899|fang cai;
芳草__芳草 583.476802811|fang cao;
放肆__放肆 403.988165198|fang si;
放送__放送 582.024395035|fang song;
放松__放鬆 3782.93112802|fang song;
方圆__方圓 397.991873082|fang yuan;
房源__房源 651.102673334|fang yuan;
放眼__放眼 328.904723278|fang yan;
方言__方言 990.911721928|fang yan;
放养__放養 162.460985719|fang yang;
放羊__放羊 228.011295226|fang yang;
防疫__防疫 300.304800557|fang yi;
放映__放映 622.538424634|fang ying;
防御__防禦 2551.57427517|fang yu;
放完__放完 112.625137786|fang wan;
访问__訪問 10445.0149126|fang wen;
防卫__防衛 362.028498203|fang wei;
防伪__防偽 428.890471272|fang wei;
方位__方位 649.481929235|fang wei;
防务__防務 169.070402749|fang wu;
房屋__房屋 3863.92679211|fang wu;
妨碍__妨礙 816.861571886|fang ai;
方案__方案 14370.0106634|fang an;
分班__分班 132.266710153|fen ban;
分包__分包 239.664931108|fen bao;
分贝__分貝 208.44415872|fen bei;
粉笔__粉筆 187.26053154|fen bi;
粪便__糞便 445.228026075|fen bian;
分辨__分辨 772.314734527|fen bian;
分别__分別 13104.1257383|fen bie;
粉饼__粉餅 145.043940608|fen bing;
分步__分步 121.217779906|fen bu;
分部__分部 465.65665114|fen bu;
分布__分佈 3835.14395448|fen bu;
分派__分派 148.889769675|fen pai;
分配__分配 5976.54259122|fen pei;
分批__分批 396.506758465|fen pi;
分泌__分泌 1269.79732551|fen mi;
分娩__分娩 440.262469534|fen mian;
分明__分明 1214.09058664|fen ming;
粉末__粉末 413.152419826|fen mo;
坟墓__墳墓 485.810302105|fen mu;
分法__分法 114.893269147|fen fa;
分发__分發 569.114341748|fen fa;
纷繁__紛繁 221.017305999|fen fan;
芬芳__芬芳 431.571158705|fen fang;
粉粉__粉粉 112.625137786|fen fen;
愤愤__憤憤 121.066816454|fen fen;
分分__分分 308.651751439|fen fen;
纷纷__紛紛 4939.07845882|fen fen;
纷飞__紛飛 197.076837307|fen fei;
吩咐__吩咐 595.969520633|fen fu;
分段__分段 417.812212206|fen duan;
分担__分擔 692.099342424|fen dan;
分到__分到 440.262469534|fen dao;
分得__分得 335.946843682|fen de;
粉底__粉底 340.15949445|fen di;
分店__分店 540.093554591|fen dian;
奋斗__奮鬥 2632.31764915|fen dou;
分队__分隊 253.488718522|fen dui;
分摊__分攤 428.890471272|fen tan;
分头__分頭 218.552335545|fen tou;
粉嫩__粉嫩 184.941433485|fen nen;
愤怒__憤怒 2485.66700342|fen nu;
纷乱__紛亂 143.426288875|fen luan;
芬兰__芬蘭 578.409173188|fen lan;
分类__分類 5484.12059337|fen lei;
分立__分立 152.267254161|fen li;
奋力__奮力 528.772109212|fen li;
分离__分離 2688.67773313|fen li;
份量__份量 305.97104031|fen liang;
分量__分量 858.611290099|fen liang;
分列__分列 121.066816454|fen lie;
分裂__分裂 1269.79732551|fen lie;
分流__分流 738.432842998|fen liu;
分管__分管 808.758466182|fen guan;
分隔__分隔 353.998238229|fen ge;
分割__分割 1191.60699362|fen ge;
分给__分給 339.31275934|fen gei;
分工__分工 1519.38443361|fen gong;
愤慨__憤慨 277.284292303|fen kai;
分开__分開 3740.74070579|fen kai;
分化__分化 833.312156414|fen hua;
分行__分行 1782.13945694|fen hang;
分号__分號 137.134095104|fen hao;
愤恨__憤恨 139.026849285|fen hen;
粉红__粉紅 729.287839744|fen hong;
分红__分紅 1559.67079644|fen hong;
分户__分戶 106.748946222|fen hu;
分会__分會 495.593922384|fen hui;
分机__分機 480.991159713|fen ji;
分级__分級 731.107734818|fen ji;
分家__分家 176.387781073|fen jia;
分解__分解 1866.23446282|fen jie;
奋进__奮進 210.532600599|fen jin;
分居__分居 298.811606079|fen ju;
分局__分局 1348.06912745|fen ju;
分权__分權 114.607273411|fen quan;
奋起__奮起 163.680258901|fen qi;
分期__分期 663.387871054|fen qi;
分歧__分歧 1082.58098585|fen qi;
分钱__分錢 1038.96445205|fen qian;
分清__分清 307.883446338|fen qing;
愤青__憤青 724.757896749|fen qing;
分区__分區 2295.12287071|fen qu;
分析__分析 27030.0672583|fen xi;
分校__分校 472.083744072|fen xiao;
分销__分銷 594.486015613|fen xiao;
分项__分項 146.132498493|fen xiang;
分享__分享 6006.40803223|fen xiang;
分心__分心 236.107646363|fen xin;
分形__分形 105.164499152|fen xing;
分站__分站 218.280152578|fen zhan;
奋战__奮戰 353.557372243|fen zhan;
纷争__紛爭 392.573489614|fen zheng;
分值__分值 261.510250403|fen zhi;
分支__分支 862.9018652|fen zhi;
分众__分眾 239.366454718|fen zhong;
分钟__分鐘 16399.2743885|fen zhong;
分叉__分叉 108.357265155|fen cha;
分拆__分拆 254.438159592|fen chai;
分厂__分廠 208.44415872|fen chang;
粉尘__粉塵 233.765505073|fen chen;
分成__分成 1866.23446282|fen cheng;
分出__分出 263.801426189|fen chu;
粉刷__粉刷 146.679837233|fen shua;
份上__份上 374.883606282|fen shang;
焚烧__焚燒 317.230705235|fen shao;
分社__分社 180.839193473|fen she;
分身__分身 301.805456692|fen shen;
粉饰__粉飾 127.413209251|fen shi;
分时__分時 158.264611567|fen shi;
分手__分手 4710.6431127|fen shou;
分数__分數 2619.22907324|fen shu;
愤然__憤然 107.14877401|fen ran;
份子__份子 390.621510938|fen zi;
分子__分子 2933.74914717|fen zi;
分组__分組 1169.53977147|fen zu;
分寸__分寸 287.130256264|fen cun;
分层__分層 439.714170908|fen ceng;
分词__分詞 181.742866823|fen ci;
粉刺__粉刺 331.786363812|fen ci;
分散__分散 1973.87819843|fen san;
粉色__粉色 826.074649543|fen se;
粉丝__粉絲 2532.56730325|fen si;
粉碎__粉碎 629.559803835|fen sui;
分院__分院 310.580912674|fen yuan;
分页__分頁 1199.05487625|fen ye;
奋勇__奮勇 128.529517539|fen yong;
分外__分外 296.585723861|fen wai;
氛围__氛圍 2652.07324956|fen wei;
分为__分為 3625.99770514|fen wei;
份额__份額 1915.71752783|fen e;
份儿__份兒 117.93965545|fen er;
风暴__風暴 1593.06462986|feng bao;
丰碑__豐碑 108.627664361|feng bei;
封闭__封閉 1906.19207626|feng bi;
风波__風波 839.566182019|feng bo;
奉陪__奉陪 132.762114633|feng pei;
丰满__豐滿 967.72532071|feng man;
锋芒__鋒芒 228.8653107|feng mang;
风貌__風貌 563.46883971|feng mao;
风靡__風靡 558.574983827|feng mi;
蜂蜜__蜂蜜 1067.84239617|feng mi;
封面__封面 1822.5663337|feng mian;
奉命__奉命 219.918349804|feng ming;
风帆__風帆 115.036534536|feng fan;
风范__風範 567.697685436|feng fan;
丰富__豐富 9371.82960123|feng fu;
风大__風大 118.824795093|feng da;
风笛__風笛 117.207077876|feng di;
封底__封底 128.209578049|feng di;
逢低__逢低 324.426913464|feng di;
疯癫__瘋癲 135.435779871|feng dian;
风电__風電 235.813600182|feng dian;
疯掉__瘋掉 347.442588754|feng diao;
封顶__封頂 329.725485744|feng ding;
封堵__封堵 175.073848088|feng du;
风度__風度 689.516759915|feng du;
丰台__丰台 274.533686805|feng tai;
丰田__豐田 959.320404733|feng tian;
封条__封條 107.282382453|feng tiao;
风投__風投 207.925293333|feng tou;
风头__風頭 522.223615731|feng tou;
风能__風能 132.596773978|feng neng;
风怒__風怒 122.127521944|feng nu;
风浪__風浪 225.749468142|feng lang;
封了__封了 416.253137598|feng le;
疯了__瘋了 2172.66615296|feng le;
风雷__風雷 127.254530072|feng lei;
风里__風裡 148.889769675|feng li;
风力__風力 264.789493468|feng li;
锋利__鋒利 353.998238229|feng li;
风量__風量 110.401782066|feng liang;
枫林__楓林 135.773751924|feng lin;
风铃__風鈴 292.54791482|feng ling;
风流__風流 998.348535653|feng liu;
风光__風光 1693.37191801|feng guang;
风干__風乾 167.810977762|feng gan;
风格__風格 9513.02903709|feng ge;
疯狗__瘋狗 270.796100963|feng gou;
冯巩__馮鞏 123.504952812|feng gong;
风过__風過 123.813152185|feng guo;
疯狂__瘋狂 5771.60137838|feng kuang;
风口__風口 111.507918629|feng kou;
封口__封口 227.160466527|feng kou;
风化__風化 153.218967809|feng hua;
风华__風華 240.263000901|feng hua;
凤凰__鳳凰 2258.24105554|feng huang;
风寒__風寒 186.794397067|feng han;
封号__封號 295.847453874|feng hao;
缝合__縫合 211.584655172|feng he;
丰厚__豐厚 905.87512359|feng hou;
烽火__烽火 274.876014738|feng huo;
峰会__峰會 718.463208478|feng hui;
风机__風機 352.238065853|feng ji;
封建__封建 927.579613097|feng jian;
蜂胶__蜂膠 123.044091616|feng jiao;
凤姐__鳳姐 169.28122395|feng jie;
风景__風景 3221.16683052|feng jing;
奉劝__奉勸 283.221176861|feng quan;
风起__風起 131.281440129|feng qi;
风气__風氣 634.284663664|feng qi;
风情__風情 1474.61550226|feng qing;
风趣__風趣 316.046952528|feng qu;
风雪__風雪 271.133768339|feng xue;
缝隙__縫隙 566.284555508|feng xi;
奉贤__奉賢 179.940013424|feng xian;
锋线__鋒線 260.209952636|feng xian;
奉献__奉獻 1779.91999768|feng xian;
风险__風險 12236.0677836|feng xian;
风向__風向 239.963779681|feng xiang;
封信__封信 557.184562398|feng xin;
奉行__奉行 316.046952528|feng xing;
风行__風行 402.982545867|feng xing;
丰胸__豐胸 338.468131949|feng xiong;
封装__封裝 1057.24961018|feng zhuang;
疯涨__瘋漲 179.045304336|feng zhang;
风筝__風箏 961.714332594|feng zheng;
缝制__縫製 127.73116145|feng zhi;
风之__風之 200.04606951|feng zhi;
峰值__峰值 340.15949445|feng zhi;
风中__風中 660.089332023|feng zhong;
封住__封住 209.746993999|feng zhu;
丰产__豐產 137.819369268|feng chan;
风潮__風潮 399.980682268|feng chao;
风车__風車 204.329220247|feng che;
风尘__風塵 275.218769535|feng chen;
奉承__奉承 132.431639237|feng cheng;
风吹__風吹 659.267263146|feng chui;
风霜__風霜 198.06165195|feng shuang;
风沙__風沙 236.696839161|feng sha;
封杀__封殺 865.055186245|feng sha;
风扇__風扇 1833.95789167|feng shan;
奉上__奉上 212.641966978|feng shang;
风尚__風尚 411.098117295|feng shang;
风神__風神 129.010924378|feng shen;
丰盛__豐盛 342.285588041|feng sheng;
风声__風聲 439.166555128|feng sheng;
风湿__風濕 290.730764849|feng shi;
丰收__豐收 574.81640715|feng shou;
丰硕__豐碩 206.119414554|feng shuo;
风水__風水 1010.8674618|feng shui;
缝纫__縫紉 109.170488754|feng ren;
风姿__風姿 128.529517539|feng zi;
疯子__瘋子 1434.73708553|feng zi;
封存__封存 269.449631503|feng cun;
风采__風采 1215.60448872|feng cai;
封测__封測 137.819369268|feng ce;
讽刺__諷刺 1089.34742493|feng ci;
风骚__風騷 447.452879516|feng sao;
封死__封死 105.0335283|feng si;
风速__風速 170.551683166|feng su;
风俗__風俗 518.333511609|feng su;
封锁__封鎖 916.092151969|feng suo;
风月__風月 294.376422496|feng yue;
风韵__風韻 212.907119447|feng yun;
风云__風雲 1385.53861435|feng yun;
风雅__風雅 294.376422496|feng ya;
枫叶__楓葉 538.078184713|feng ye;
风衣__風衣 302.935867929|feng yi;
封印__封印 341.008342538|feng yin;
蜂拥__蜂擁 131.117943492|feng yong;
风雨__風雨 1508.06636321|feng yu;
封为__封為 105.164499152|feng wei;
奉为__奉為 161.049974862|feng wei;
风味__風味 780.052703516|feng wei;
蜂窝__蜂窩 193.427195796|feng wo;
风儿__風兒 181.969489867|feng er;
诽谤__誹謗 477.408200926|fei bang;
飞奔__飛奔 338.046607007|fei ben;
肺部__肺部 245.101601395|fei bu;
肥胖__肥胖 908.135681884|fei pang;
废品__廢品 216.654158472|fei pin;
非法__非法 3265.62606571|fei fa;
霏凡__霏凡 184.941433485|fei fan;
非凡__非凡 841.661270235|fei fan;
霏霏__霏霏 105.426930997|fei fei;
狒狒__狒狒 189.136730609|fei fei;
肥肥__肥肥 286.415523108|fei fei;
菲菲__菲菲 640.639682982|fei fei;
飞飞__飛飛 742.122873174|fei fei;
肺腑__肺腑 124.587019602|fei fu;
肥大__肥大 230.295783987|fei da;
飞弹__飛彈 134.259489114|fei dan;
非但__非但 343.996026791|fei dan;
飞刀__飛刀 206.633773476|fei dao;
飞到__飛到 576.250827814|fei dao;
飞得__飛得 110.95347192|fei de;
非得__非得 875.902662456|fei dei;
飞抵__飛抵 119.41857567|fei di;
沸点__沸點 201.296414343|fei dian;
非典__非典 744.902491688|fei dian;
废掉__廢掉 149.261315371|fei diao;
飞碟__飛碟 298.06779536|fei die;
飞度__飛度 260.209952636|fei du;
沸腾__沸騰 576.969379906|fei teng;
飞天__飛天 564.171453387|fei tian;
飞艇__飛艇 166.353500999|fei ting;
匪徒__匪徒 168.020228531|fei tu;
飞鸟__飛鳥 388.195180646|fei niao;
非农__非農 119.121315407|fei nong;
费率__費率 635.075580657|fei lv;
飞来__飛來 381.957020988|fei lai;
废了__廢了 328.904723278|fei le;
非礼__非禮 237.879639313|fei li;
费力__費力 438.073368704|fei li;
废料__廢料 158.857391092|fei liao;
肥料__肥料 413.152419826|fei liao;
飞龙__飛龍 416.253137598|fei long;
菲戈__菲戈 158.067510349|fei ge;
飞鸽__飛鴿 185.86560618|fei ge;
飞过__飛過 476.813641365|fei guo;
飞快__飛快 697.293562832|fei kuai;
飞花__飛花 196.586267794|fei hua;
废话__廢話 3787.64822853|fei hua;
肥厚__肥厚 145.405889264|fei hou;
绯红__緋紅 128.209578049|fei hong;
飞鸿__飛鴻 135.604660605|fei hong;
飞狐__飛狐 115.323601467|fei hu;
飞回__飛回 166.353500999|fei hui;
飞机__飛機 7658.60129638|fei ji;
飞溅__飛濺 129.494134325|fei jian;
肥姐__肥姐 108.357265155|fei jie;
费解__費解 165.114314527|fei jie;
费尽__費盡 168.439513167|fei jin;
费劲__費勁 777.141921285|fei jin;
废旧__廢舊 262.817045902|fei jiu;
飞起__飛起 149.633788238|fei qi;
废气__廢氣 242.36802267|fei qi;
废弃__廢棄 506.83620443|fei qi;
费钱__費錢 139.373782642|fei qian;
飞去__飛去 273.168633085|fei qu;
飞雪__飛雪 357.099731154|fei xue;
飞向__飛向 252.85772688|fei xiang;
飞翔__飛翔 1235.45786087|fei xiang;
费心__費心 376.287731462|fei xin;
飞行__飛行 2442.67733117|fei xing;
废墟__廢墟 1035.08753546|fei xu;
飞涨__飛漲 230.008975843|fei zhang;
废止__廢止 233.765505073|fei zhi;
废纸__廢紙 316.046952528|fei zhi;
非洲__非洲 2412.42638506|fei zhou;
肥猪__肥豬 165.114314527|fei zhu;
飞船__飛船 680.977550057|fei chuan;
废柴__廢柴 169.492308033|fei chai;
非常__非常 41085.7680981|fei chang;
飞车__飛車 402.982545867|fei che;
费城__費城 216.384339476|fei cheng;
飞驰__飛馳 213.971039752|fei chi;
非处__非處 122.737806611|fei chu;
飞出__飛出 251.914183226|fei chu;
废除__廢除 517.043260448|fei chu;
飞上__飛上 109.989815613|fei shang;
飞身__飛身 159.253810404|fei shen;
飞升__飛升 120.314814642|fei sheng;
飞逝__飛逝 113.187937993|fei shi;
费时__費時 253.488718522|fei shi;
费事__費事 265.119670945|fei shi;
肥水__肥水 105.558392399|fei shui;
沸水__沸水 190.081867665|fei shui;
废水__廢水 483.997491267|fei shui;
废人__廢人 149.633788238|fei ren;
飞人__飛人 162.056583012|fei ren;
非人__非人 172.04594156|fei ren;
肥肉__肥肉 379.111778956|fei rou;
肥皂__肥皂 372.555031371|fei zao;
痱子__痱子 108.357265155|fei zi;
妃子__妃子 189.372573382|fei zi;
飞走__飛走 170.127140854|fei zou;
翡翠__翡翠 736.594714048|fei cui;
飞速__飛速 371.164834837|fei su;
飞越__飛越 183.106850936|fei yue;
飞跃__飛躍 681.82669043|fei yue;
飞云__飛雲 113.187937993|fei yun;
飞燕__飛燕 123.658956482|fei yan;
肺炎__肺炎 356.210827905|fei yan;
飞扬__飛揚 966.520124945|fei yang;
非要__非要 2397.44169258|fei yao;
非议__非議 276.938965124|fei yi;
飞鹰__飛鷹 110.539446825|fei ying;
费用__費用 13384.6958387|fei yong;
飞鱼__飛魚 158.461958559|fei yu;
飞往__飛往 376.756940916|fei wang;
绯闻__緋聞 883.576728645|fei wen;
肥沃__肥沃 190.556205829|fei wo;
飞舞__飛舞 532.077085292|fei wu;
废物__廢物 1316.52557925|fei wu;
肺癌__肺癌 496.830647979|fei ai;
飞蛾__飛蛾 113.47039186|fei e;
飞儿__飛兒 105.295633316|fei er;
菲儿__菲兒 109.30661816|fei er;
费尔__費爾 131.117943492|fei er;
菲尔__菲爾 181.969489867|fei er;
佛门__佛門 159.055477247|fo men;
佛法__佛法 484.601008682|fo fa;
佛陀__佛陀 253.173026121|fo tuo;
佛家__佛家 176.60772663|fo jia;
佛教__佛教 1474.61550226|fo jiao;
佛经__佛經 231.735198139|fo jing;
佛学__佛學 193.90988203|fo xue;
佛像__佛像 273.509258874|fo xiang;
佛山__佛山 1373.50489426|fo shan;
佛如__佛如 199.548108896|fo ru;
佛祖__佛祖 355.324137339|fo zu;
否定__否定 1870.89154158|fou ding;
否决__否決 451.935995467|fou jue;
否认__否認 2561.13118731|fou ren;
否则__否則 10668.6512651|fou ze;
腐败__腐敗 3060.72200622|fu bai;
副本__副本 4963.75957739|fu ben;
父辈__父輩 235.519920202|fu bei;
复辟__復辟 108.627664361|fu bi;
伏笔__伏筆 176.168109435|fu bi;
附表__附表 245.407229187|fu biao;
腹部__腹部 1087.99076217|fu bu;
复牌__復牌 467.400766428|fu pai;
扶贫__扶貧 712.223191016|fu pin;
浮萍__浮萍 112.204874836|fu ping;
抚平__撫平 156.694657831|fu ping;
富婆__富婆 458.173712968|fu po;
驸马__駙馬 106.882056102|fu ma;
赴美__赴美 262.489736092|fu mei;
负面__負面 1049.37403554|fu mian;
富民__富民 313.302012384|fu min;
抚摩__撫摩 216.11485651|fu mo;
附魔__附魔 783.950712715|fu mo;
抚摸__撫摸 916.092151969|fu mo;
父母__父母 13268.4466908|fu mu;
复发__複發 699.905273328|fu fa;
复返__復返 170.127140854|fu fan;
复方__復方 337.625607028|fu fang;
付费__付費 1331.37418129|fu fei;
夫妇__夫婦 2129.77510916|fu fu;
附带__附帶 726.566487616|fu dai;
复旦__復旦 1055.93292173|fu dan;
负担__負擔 3479.90844849|fu dan;
辅导__輔導 1334.69654755|fu dao;
福德__福德 150.756793028|fu de;
腹地__腹地 261.184568064|fu di;
浮点__浮點 106.218162376|fu dian;
浮雕__浮雕 206.633773476|fu diao;
浮动__浮動 862.9018652|fu dong;
复读__復讀 470.908619205|fu du;
幅度__幅度 2784.14878864|fu du;
赴台__赴台 157.67404401|fu tai;
福特__福特 741.198640518|fu te;
附体__附體 147.964946673|fu ti;
福田__福田 659.267263146|fu tian;
斧头__斧頭 466.237298568|fu tou;
腹痛__腹痛 345.284462654|fu tong;
附图__附圖 204.839111844|fu tu;
父女__父女 253.488718522|fu nv;
妇女__婦女 3590.02852297|fu nv;
弗兰__弗蘭 105.558392399|fu lan;
腐烂__腐爛 438.619621343|fu lan;
弗雷__弗雷 108.222318063|fu lei;
富力__富力 123.967540162|fu li;
福利__福利 1961.61753092|fu li;
妇联__婦聯 380.531740742|fu lian;
辅料__輔料 295.111021611|fu liao;
涪陵__涪陵 130.46599058|fu ling;
附录__附錄 427.290057918|fu lu;
俘虏__俘虜 429.960742313|fu lu;
覆盖__覆蓋 4122.60245218|fu gai;
赴港__赴港 146.132498493|fu gang;
付给__付給 278.669912425|fu gei;
复古__復古 431.571158705|fu gu;
富国__富國 221.568841736|fu guo;
富贵__富貴 758.012333731|fu gui;
浮夸__浮誇 109.442917312|fu kua;
付款__付款 5750.06453265|fu kuan;
副刊__副刊 112.204874836|fu kan;
俯瞰__俯瞰 198.308623594|fu kan;
富康__富康 237.287502254|fu kang;
妇科__婦科 437.527796363|fu ke;
腐化__腐化 139.200207879|fu hua;
幅画__幅畫 178.59961945|fu hua;
浮华__浮華 203.566761683|fu hua;
孵化__孵化 372.555031371|fu hua;
父皇__父皇 122.890853693|fu huang;
富含__富含 549.598880816|fu han;
富豪__富豪 997.105202031|fu hao;
符号__符號 2303.71924505|fu hao;
附和__附和 220.19257551|fu he;
复核__複核 423.051424808|fu he;
负荷__負荷 1007.09538969|fu he;
复合__複合 1593.06462986|fu he;
符合__符合 10315.6602986|fu he;
俘获__俘獲 121.066816454|fu huo;
复活__復活 2087.73078616|fu huo;
夫君__夫君 149.633788238|fu jun;
腹肌__腹肌 183.563783354|fu ji;
伏击__伏擊 234.933657026|fu ji;
富家__富家 173.337150041|fu jia;
附加__附加 1569.41918253|fu jia;
福建__福建 3492.94243288|fu jian;
附件__附件 7716.07926336|fu jian;
福晋__福晉 110.126966673|fu jin;
附近__附近 9680.45270584|fu jin;
赴京__赴京 121.671800659|fu jing;
浮起__浮起 110.539446825|fu qi;
负起__負起 160.849404779|fu qi;
扶起__扶起 161.049974862|fu qi;
服气__服氣 420.94790182|fu qi;
福气__福氣 647.865219539|fu qi;
夫妻__夫妻 3102.96674755|fu qi;
肤浅__膚淺 493.129699012|fu qian;
付钱__付錢 984.756712384|fu qian;
腹腔__腹腔 246.326401069|fu qiang;
富强__富強 279.713669565|fu qiang;
父亲__父親 10445.0149126|fu qin;
福清__福清 149.075426771|fu qing;
付清__付清 308.651751439|fu qing;
伏羲__伏羲 107.14877401|fu xi;
复习__複習 3034.13893483|fu xi;
浮现__浮現 668.366611253|fu xian;
腹泻__腹瀉 617.131535882|fu xie;
阜新__阜新 200.545272755|fu xin;
服刑__服刑 143.963491517|fu xing;
福星__福星 166.353500999|fu xing;
复兴__復興 806.745280603|fu xing;
腐朽__腐朽 314.867617017|fu xiu;
服装__服裝 4041.21731986|fu zhuang;
负债__負債 791.805264794|fu zhai;
付账__付賬 122.279808036|fu zhang;
腹胀__腹脹 162.86639759|fu zhang;
扶着__扶着 412.12398856|fu zhe;
扶正__扶正 122.127521944|fu zheng;
扶植__扶植 158.067510349|fu zhi;
副职__副職 174.42055653|fu zhi;
肤质__膚質 203.313241605|fu zhi;
福祉__福祉 323.619340361|fu zhi;
赋值__賦值 476.219822262|fu zhi;
复制__複製 5335.81207086|fu zhi;
抚州__撫州 114.037415895|fu zhou;
符咒__符咒 115.179978568|fu zhou;
福州__福州 2708.85631718|fu zhou;
腹中__腹中 167.810977762|fu zhong;
负重__負重 236.107646363|fu zhong;
浮肿__浮腫 265.78126155|fu zhong;
附中__附中 269.449631503|fu zhong;
付诸__付諸 136.112567367|fu zhu;
扶住__扶住 139.200207879|fu zhu;
扶助__扶助 157.477678279|fu zhu;
辅助__輔助 2286.55857392|fu zhu;
附着__附着 268.444174826|fu zhuo;
复查__複查 596.712660816|fu cha;
扶持__扶持 1833.95789167|fu chi;
复仇__復仇 699.033618062|fu chou;
浮出__浮出 137.819369268|fu chu;
复出__復出 743.974797322|fu chu;
付出__付出 5369.16241395|fu chu;
抚顺__撫順 254.438159592|fu shun;
釜山__釜山 163.680258901|fu shan;
浮上__浮上 110.126966673|fu shang;
负伤__負傷 150.007190589|fu shang;
富商__富商 215.576896995|fu shang;
附上__附上 539.420927296|fu shang;
敷设__敷設 123.197520618|fu she;
辐射__輻射 1932.50174796|fu she;
俯身__俯身 138.680779525|fu shen;
复审__複審 215.845709156|fu shen;
浮生__浮生 132.266710153|fu sheng;
辅食__輔食 112.906187218|fu shi;
俯视__俯視 210.532600599|fu shi;
服侍__服侍 213.704562287|fu shi;
复式__複式 250.974160423|fu shi;
富士__富士 607.9716117|fu shi;
复试__複試 705.158077415|fu shi;
腐蚀__腐蝕 708.681829926|fu shi;
服饰__服飾 1376.93239525|fu shi;
扶手__扶手 241.764712994|fu shou;
副手__副手 316.83562918|fu shou;
复述__複述 128.689786556|fu shu;
服输__服輸 144.322743975|fu shu;
复数__複數 169.28122395|fu shu;
负数__負數 282.516174301|fu shu;
附属__附屬 840.61307342|fu shu;
腹水__腹水 112.34478795|fu shui;
富饶__富饒 105.164499152|fu rao;
妇人__婦人 455.895552723|fu ren;
富人__富人 1073.17852213|fu ren;
夫人__夫人 2648.77038315|fu ren;
芙蓉__芙蓉 900.248315564|fu rong;
复杂__複雜 10086.8456213|fu za;
浮在__浮在 125.522047856|fu zai;
附在__附在 149.075426771|fu zai;
伏在__伏在 180.613978088|fu zai;
负载__負載 919.523371782|fu zai;
浮躁__浮躁 903.620192345|fu zao;
负责__負責 21357.9574272|fu ze;
附赠__附贈 137.819369268|fu zeng;
夫子__夫子 167.393257695|fu zi;
斧子__斧子 236.991986692|fu zi;
父子__父子 789.834279627|fu zi;
副总__副總 912.673735821|fu zong;
富足__富足 226.030964922|fu zu;
辅佐__輔佐 137.134095104|fu zuo;
福彩__福彩 214.504991945|fu cai;
服从__服從 1032.51096484|fu cong;
复赛__複賽 188.196293023|fu sai;
肤色__膚色 640.639682982|fu se;
附送__附送 228.011295226|fu song;
复苏__復蘇 615.595353746|fu su;
复原__復原 376.287731462|fu yuan;
浮云__浮雲 475.626742696|fu yun;
敷衍__敷衍 461.61231651|fu yan;
富阳__富陽 129.332863581|fu yang;
阜阳__阜陽 244.491487214|fu yang;
抚养__撫養 497.450167612|fu yang;
服药__服藥 424.107124851|fu yao;
副业__副業 161.250795044|fu ye;
辅以__輔以 203.820597887|fu yi;
复议__複議 232.603161479|fu yi;
服役__服役 314.867617017|fu yi;
福音__福音 459.889800938|fu yin;
复印__複印 971.349932368|fu yin;
妇幼__婦幼 134.092283643|fu you;
附有__附有 206.119414554|fu you;
负有__負有 390.135034682|fu you;
富有__富有 2645.47163011|fu you;
复用__復用 222.953710017|fu yong;
服用__服用 1934.91146801|fu yong;
负于__負於 156.304608838|fu yu;
富余__富餘 286.415523108|fu yu;
富于__富於 324.426913464|fu yu;
富裕__富裕 1351.43315497|fu yu;
赋予__賦予 1927.69130725|fu yu;
福娃__福娃 333.444336783|fu wa;
符文__符文 230.870473623|fu wen;
富翁__富翁 496.21189989|fu weng;
抚慰__撫慰 277.630050085|fu wei;
复位__複位 446.339066527|fu wei;
服务__服務 38555.8290446|fu wu;
父爱__父愛 151.132997772|fu ai;
断臂__斷臂 125.992190229|duan bei;
短篇__短篇 203.060037258|duan pian;
短片__短片 702.526765976|duan pian;
断面__斷面 263.472890441|duan mian;
短命__短命 132.596773978|duan ming;
端木__端木 161.049974862|duan mu;
短发__短髮 475.034401746|duan fa;
短短__短短 1200.55002966|duan duan;
短的__短的 193.427195796|duan de;
端点__端點 107.416157498|duan dian;
断点__斷點 306.352568839|duan dian;
断电__斷電 532.077085292|duan dian;
断掉__斷掉 185.634130949|duan diao;
断定__斷定 419.377126323|duan ding;
短途__短途 142.180598718|duan tu;
断奶__斷奶 216.924313917|duan nai;
端倪__端倪 230.582949765|duan ni;
断了__斷了 1211.06843631|duan le;
锻炼__鍛煉 4716.51701742|duan lian;
断裂__斷裂 747.692521253|duan lie;
断流__斷流 105.690017726|duan liu;
短路__短路 415.216987933|duan lu;
段落__段落 635.075580657|duan luo;
断开__斷開 576.250827814|duan kai;
端口__端口 3541.1527732|duan kou;
短裤__短褲 614.062995519|duan ku;
断货__斷貨 228.580284053|duan huo;
断绝__斷絕 290.0070692|duan jue;
短缺__短缺 828.13607043|duan que;
短裙__短裙 319.213487372|duan qun;
端起__端起 207.407719521|duan qi;
短期__短期 4143.2035503|duan qi;
断桥__斷橋 140.244908425|duan qiao;
断球__斷球 115.179978568|duan qiu;
短讯__短訊 116.044406778|duan xun;
断线__斷線 643.841029976|duan xian;
短线__短線 2879.41941052|duan xian;
短小__短小 173.769702743|duan xiao;
端详__端詳 187.727829225|duan xiang;
短信__短信 12144.9198993|duan xin;
短袖__短袖 456.464028614|duan xiu;
端庄__端莊 286.415523108|duan zhuang;
端着__端着 320.409100324|duan zhe;
端正__端正 439.714170908|duan zheng;
断肠__斷腸 144.682892926|duan chang;
短处__短處 120.314814642|duan chu;
端上__端上 139.026849285|duan shang;
短视__短視 115.755545596|duan shi;
短时__短時 133.925286409|duan shi;
断然__斷然 236.696839161|duan ran;
短暂__短暫 1811.24553395|duan zan;
锻造__鍛造 584.932834985|duan zao;
段子__段子 273.850309404|duan zi;
端子__端子 336.785179346|duan zi;
端坐__端坐 159.253810404|duan zuo;
断层__斷層 246.94109417|duan ceng;
断送__斷送 114.321989585|duan song;
断言__斷言 306.352568839|duan yan;
段誉__段譽 127.890434962|duan yu;
短语__短語 295.479008313|duan yu;
断网__斷網 527.455873984|duan wang;
短文__短文 225.187525865|duan wen;
端午__端午 310.968189453|duan wu;
盾牌__盾牌 434.268601197|dun pai;
顿饭__頓飯 508.100984482|dun fan;
蹲点__蹲點 153.41002317|dun dian;
顿了__頓了 160.049619219|dun le;
敦煌__敦煌 444.673543393|dun huang;
蹲下__蹲下 269.449631503|dun xia;
蹲着__蹲着 168.439513167|dun zhe;
顿时__頓時 1639.38542435|dun shi;
蹲在__蹲在 496.830647979|dun zai;
敦促__敦促 286.415523108|dun cu;
吨位__噸位 153.218967809|dun wei;
顿悟__頓悟 159.452390871|dun wu;
大坝__大壩 362.479927203|da ba;
大把__大把 796.754272909|da ba;
大巴__大巴 826.074649543|da ba;
大败__大敗 153.218967809|da bai;
大白__大白 228.295612376|da bai;
打败__打敗 1002.08784645|da bai;
大板__大板 110.264288753|da ban;
大班__大班 140.945727665|da ban;
大阪__大阪 346.577724349|da ban;
大半__大半 544.825488702|da ban;
打扮__打扮 1771.06976716|da ban;
大棒__大棒 114.893269147|da bang;
大包__大包 409.054029297|da bao;
大宝__大寶 476.219822262|da bao;
打包__打包 1882.58514584|da bao;
大本__大本 115.179978568|da ben;
大悲__大悲 142.357889859|da bei;
大笔__大筆 390.621510938|da bi;
大变__大變 166.146325956|da bian;
大便__大便 1373.50489426|da bian;
答辩__答辯 1847.72178498|da bian;
达标__達標 811.787668067|da biao;
大兵__大兵 190.793818607|da bing;
大饼__大餅 349.178797604|da bing;
大病__大病 426.226434824|da bing;
大波__大波 113.187937993|da bo;
大伯__大伯 264.789493468|da bo;
大部__大部 316.83562918|da bu;
打不__打不 324.02287532|da bu;
大步__大步 379.584509838|da bu;
大牌__大牌 952.17431607|da pai;
打牌__打牌 1555.7884176|da pai;
大盘__大盤 8398.43759849|da pan;
大胖__大胖 106.882056102|da pang;
打炮__打炮 137.476305203|da pao;
大炮__大炮 458.173712968|da pao;
大鹏__大鵬 286.415523108|da peng;
大棚__大棚 307.117053725|da peng;
搭配__搭配 3056.91021261|da pei;
大批__大批 2332.60704332|da pi;
大片__大片 1731.7851508|da pian;
打拼__打拚 446.339066527|da pin;
打平__打平 125.053659829|da ping;
大屏__大屏 202.050369328|da ping;
打破__打破 2625.76520592|da po;
打骂__打罵 145.587202159|da ma;
大麻__大麻 260.859291326|da ma;
大骂__大罵 349.614203755|da ma;
大马__大馬 358.884197808|da ma;
大妈__大媽 1058.56794047|da ma;
大卖__大賣 126.149295342|da mai;
大麦__大麥 163.680258901|da mai;
大忙__大忙 111.091824605|da mang;
大猫__大貓 205.094534596|da mao;
大门__大門 2445.72321123|da men;
大米__大米 1145.0238695|da mi;
大明__大明 307.883446338|da ming;
大名__大名 433.187606905|da ming;
达摩__達摩 126.937764318|da mo;
大漠__大漠 308.267359529|da mo;
打磨__打磨 338.890182508|da mo;
大幕__大幕 144.143005824|da mu;
大发__大發 387.22887368|da fa;
大法__大法 533.404852483|da fa;
打发__打發 789.834279627|da fa;
打法__打法 863.977854874|da fa;
大凡__大凡 151.321452046|da fan;
打翻__打翻 155.333728851|da fan;
大方__大方 1308.34803192|da fang;
打分__打分 511.914293268|da fen;
大风__大風 590.793388895|da feng;
大飞__大飛 109.442917312|da fei;
大佛__大佛 128.850255419|da fo;
大夫__大夫 339.735863102|da fu;
答复__答覆 2872.25187426|da fu;
大幅__大幅 4327.91161602|da fu;
大段__大段 207.925293333|da duan;
打断__打斷 1018.45404378|da duan;
打盹__打盹 122.127521944|da dun;
大打__大打 153.41002317|da da;
达达__達達 154.947067523|da da;
打打__打打 639.84183651|da da;
大大__大大 5742.90345783|da da;
大单__大單 541.441326411|da dan;
大胆__大膽 2382.55007694|da dan;
搭档__搭檔 777.141921285|da dang;
大到__大到 187.26053154|da dao;
大盗__大盜 202.554574186|da dao;
大刀__大刀 282.516174301|da dao;
答道__答道 342.285588041|da dao;
打倒__打倒 977.421145723|da dao;
打到__打到 1394.19862478|da dao;
大道__大道 1863.91027245|da dao;
达到__達到 21518.2493558|da dao;
大德__大德 134.42690308|da de;
打得__打得 1577.26174289|da de;
大的__大的 2606.20557717|da de;
大灯__大燈 221.568841736|da deng;
大堤__大堤 131.609045271|da di;
大抵__大抵 225.749468142|da di;
大帝__大帝 288.924902033|da di;
打的__打的 715.782248677|da di;
大地__大地 2100.77969738|da di;
大典__大典 216.11485651|da dian;
大殿__大殿 232.893204426|da dian;
打点__打點 358.884197808|da dian;
大点__大點 398.48814637|da dian;
打掉__打掉 420.423657369|da diao;
大碟__大碟 239.664931108|da die;
大跌__大跌 1587.1200774|da die;
打斗__打鬥 320.010065926|da dou;
大都__大都 758.012333731|da dou;
大豆__大豆 1411.68136652|da dou;
大东__大東 220.742053181|da dong;
打动__打動 1126.6237397|da dong;
大肚__大肚 134.762357541|da du;
打赌__打賭 308.651751439|da du;
大度__大度 328.495108513|da du;
大都__大都 336.365750338|da du;
大多__大多 4492.77303857|da duo;
大堆__大堆 129.494134325|da dui;
答对__答對 215.576896995|da dui;
大队__大隊 1223.20236253|da dui;
大谈__大談 243.275811214|da tan;
打探__打探 251.600451735|da tan;
大堂__大堂 378.168082664|da tang;
大唐__大唐 1053.30446216|da tang;
答题__答題 687.800394331|da ti;
大体__大體 785.907015785|da ti;
大田__大田 149.261315371|da tian;
大跳__大跳 131.117943492|da tiao;
打听__打聽 1619.08271818|da ting;
大厅__大廳 2442.67733117|da ting;
打头__打頭 140.770195218|da tou;
大头__大頭 1187.16048834|da tou;
大通__大通 153.984619852|da tong;
大同__大同 528.772109212|da tong;
打通__打通 819.921123923|da tong;
大图__大圖 423.051424808|da tu;
大腿__大腿 1438.31738787|da tui;
大奶__大奶 108.357265155|da nai;
打闹__打鬧 151.510141313|da nao;
大闹__大鬧 174.42055653|da nao;
大脑__大腦 2275.1892031|da nao;
达能__達能 298.811606079|da neng;
大鸟__大鳥 195.365179853|da niao;
大娘__大娘 288.924902033|da niang;
大牛__大牛 405.501301397|da niu;
大怒__大怒 230.582949765|da nu;
大乱__大亂 179.045304336|da luan;
打乱__打亂 359.779772295|da luan;
耷拉__耷拉 109.716025699|da la;
达赖__達賴 350.486645516|da lai;
打来__打來 789.834279627|da lai;
大浪__大浪 117.646076559|da lang;
打捞__打撈 297.325836157|da lao;
大佬__大佬 505.574572707|da lao;
大类__大類 348.309611377|da lei;
打雷__打雷 453.063775264|da lei;
大礼__大禮 247.557321202|da li;
搭理__搭理 557.879339939|da li;
打理__打理 614.062995519|da li;
大理__大理 664.215078095|da li;
大力__大力 3015.29249908|da li;
大连__大連 4606.15496045|da lian;
大梁__大梁 120.164975734|da liang;
打量__打量 569.114341748|da liang;
大量__大量 14352.1143909|da liang;
打猎__打獵 219.918349804|da lie;
大龄__大齡 254.438159592|da ling;
大楼__大樓 1712.47082965|da lou;
大龙__大龍 172.260473089|da long;
大路__大路 320.808632296|da lu;
大陆__大陸 7386.76984068|da lu;
大罗__大羅 131.609045271|da luo;
大官__大官 144.322743975|da guan;
大观__大觀 147.045868173|da guan;
大关__大關 401.979429753|da guan;
打滚__打滾 232.313479749|da gun;
打怪__打怪 665.872587905|da guai;
大概__大概 17410.1449669|da gai;
大干__大幹 123.044091616|da gan;
大港__大港 160.849404779|da gang;
大纲__大綱 688.658042404|da gang;
大搞__大搞 154.561368684|da gao;
大个__大個 129.979154132|da ge;
打嗝__打嗝 167.184787749|da ge;
打个__打個 1863.91027245|da ge;
大哥__大哥 5814.9173705|da ge;
打给__打給 237.879639313|da gei;
打狗__打狗 152.077621994|da gou;
打勾__打勾 175.729586548|da gou;
大狗__大狗 209.746993999|da gou;
大公__大公 163.272821143|da gong;
打工__打工 4338.71166588|da gong;
打鼓__打鼓 105.690017726|da gu;
大锅__大鍋 135.435779871|da guo;
打过__打過 1390.72814418|da guo;
大国__大國 1657.87544242|da guo;
大款__大款 559.968874971|da kuan;
大块__大塊 525.487661863|da kuai;
大卡__大卡 135.267109459|da ka;
打卡__打卡 319.611528482|da ka;
大开__大開 264.459727191|da kai;
打开__打開 16876.1084131|da kai;
大可__大可 147.780672558|da ke;
大坑__大坑 159.85029497|da keng;
大口__大口 467.400766428|da kou;
打孔__打孔 163.680258901|da kong;
大哭__大哭 479.793862242|da ku;
大亏__大虧 106.350610398|da kui;
大花__大花 106.882056102|da hua;
打滑__打滑 108.763116896|da hua;
大华__大華 250.974160423|da hua;
大话__大話 770.392265767|da hua;
大黄__大黃 251.287110964|da huang;
大海__大海 1771.06976716|da hai;
大汗__大汗 163.476413088|da han;
大汉__大漢 462.187920882|da han;
大喊__大喊 617.901063897|da han;
打好__打好 664.215078095|da hao;
大好__大好 970.140222547|da hao;
大号__大號 1040.25998178|da hao;
大河__大河 357.099731154|da he;
大亨__大亨 282.164331387|da heng;
大黑__大黑 117.207077876|da hei;
大吼__大吼 224.626982392|da hou;
大红__大紅 404.491915522|da hong;
大呼__大呼 231.158356006|da hu;
大户__大戶 811.787668067|da hu;
大火__大火 673.382717005|da huo;
大伙__大夥 674.222387052|da huo;
大会__大會 4253.06027768|da hui;
答卷__答卷 222.953710017|da juan;
大军__大軍 743.974797322|da jun;
大吉__大吉 138.508067822|da ji;
大忌__大忌 155.915530766|da ji;
打机__打機 182.878811433|da ji;
大计__大計 215.845709156|da ji;
打击__打擊 6392.5626507|da ji;
大加__大加 157.085680168|da jia;
打假__打假 398.985038482|da jia;
打架__打架 2180.80386611|da jia;
大家__大家 67803.9675959|da jia;
大件__大件 188.196293023|da jian;
大剑__大劍 304.829303266|da jian;
搭建__搭建 1657.87544242|da jian;
打搅__打攪 353.117055307|da jiao;
大脚__大腳 419.900065808|da jiao;
大叫__大叫 794.770968525|da jiao;
大江__大江 256.028470459|da jiang;
大将__大將 373.019586361|da jiang;
大奖__大獎 1682.85360433|da jiang;
打劫__打劫 639.044983668|da jie;
大姐__大姐 2082.53394472|da jie;
大街__大街 2169.96033552|da jie;
打进__打進 625.649317648|da jin;
大惊__大驚 158.857391092|da jing;
大舅__大舅 133.591915611|da jiu;
大举__大舉 357.545014261|da ju;
大局__大局 790.819158167|da ju;
大权__大權 205.350275845|da quan;
大全__大全 985.98464814|da quan;
大群__大群 144.502706249|da qun;
搭起__搭起 138.85370659|da qi;
打气__打氣 229.722524886|da qi;
打起__打起 384.823616623|da qi;
大旗__大旗 438.619621343|da qi;
大气__大氣 1515.60233678|da qi;
打钱__打錢 364.745529846|da qian;
大钱__大錢 462.764242999|da qian;
大桥__大橋 1196.07015327|da qiao;
大秦__大秦 181.516526012|da qin;
大清__大清 171.617679695|da qing;
大庆__大慶 528.772109212|da qing;
打球__打球 2538.88717657|da qiu;
打趣__打趣 150.944778196|da qu;
大区__大區 337.205131359|da qu;
大选__大選 683.528148986|da xuan;
大雪__大雪 565.579310193|da xue;
大学__大學 20962.4320622|da xue;
大喜__大喜 273.509258874|da xi;
大戏__大戲 330.960471347|da xi;
大虾__大蝦 605.702953498|da xia;
打下__打下 903.620192345|da xia;
大侠__大俠 1044.15627174|da xia;
大限__大限 109.852835359|da xian;
大显__大顯 114.75018218|da xian;
大仙__大仙 230.870473623|da xian;
大校__大校 111.369047744|da xiao;
打消__打消 353.557372243|da xiao;
大笑__大笑 796.754272909|da xiao;
大小__大小 7470.08246857|da xiao;
打响__打響 438.619621343|da xiang;
大象__大象 953.361623425|da xiang;
大些__大些 236.991986692|da xie;
答谢__答謝 272.828431509|da xie;
大写__大寫 455.895552723|da xie;
大兴__大興 378.63963681|da xing;
大型__大型 7204.94222781|da xing;
大雄__大雄 161.049974862|da xiong;
大熊__大熊 271.471856767|da xiong;
大修__大修 275.905561849|da xiu;
大赚__大賺 134.762357541|da zhuan;
打转__打轉 199.548108896|da zhuan;
大专__大專 1090.70577937|da zhuan;
大展__大展 234.056997396|da zhan;
大战__大戰 1557.7283975|da zhan;
打仗__打仗 769.432826682|da zhang;
大涨__大漲 1269.79732551|da zhang;
打着__打着 1255.63548024|da zhe;
打折__打折 1697.59762841|da zhe;
大震__大震 122.432284019|da zhen;
打针__打針 509.368920718|da zhen;
大志__大志 121.066816454|da zhi;
大郅__大郅 175.292155245|da zhi;
大致__大致 2306.59185226|da zhi;
达州__達州 134.594525802|da zhou;
打中__打中 114.037415895|da zhong;
大中__大中 152.647228173|da zhong;
大众__大眾 4617.64935026|da zhong;
大猪__大豬 180.839193473|da zhu;
打住__打住 186.561765129|da zhu;
大船__大船 130.303509496|da chuan;
大床__大床 192.705418355|da chuang;
大肠__大腸 260.859291326|da chang;
大厂__大廠 338.890182508|da chang;
大吵__大吵 106.882056102|da chao;
大潮__大潮 326.861744407|da chao;
大车__大車 175.948711373|da che;
搭车__搭車 361.12732612|da che;
打车__打車 1323.10440245|da che;
大臣__大臣 863.977854874|da chen;
大乘__大乘 137.647730357|da cheng;
搭乘__搭乘 317.230705235|da cheng;
大成__大成 413.152419826|da cheng;
打成__打成 466.237298568|da cheng;
达成__達成 2963.1429408|da cheng;
大吃__大吃 157.870654598|da chi;
大厨__大廚 197.076837307|da chu;
打出__打出 1454.53963438|da chu;
大傻__大傻 142.357889859|da sha;
大厦__大廈 3694.41410176|da sha;
搭讪__搭訕 376.756940916|da shan;
大山__大山 584.932834985|da shan;
打伤__打傷 250.974160423|da shang;
搭上__搭上 351.361264404|da shang;
打上__打上 569.823995046|da shang;
大蛇__大蛇 111.091824605|da she;
大神__大神 215.30841961|da shen;
大婶__大嬸 300.304800557|da shen;
大圣__大聖 127.096048509|da sheng;
大省__大省 243.275811214|da sheng;
大胜__大勝 304.449671797|da sheng;
大声__大聲 2373.65954378|da sheng;
打湿__打濕 145.405889264|da shi;
大石__大石 205.862715427|da shi;
大市__大市 268.778909483|da shi;
大势__大勢 387.711726118|da shi;
大使__大使 945.081459448|da shi;
大事__大事 2376.61936257|da shi;
大师__大師 4226.64255951|da shi;
大寿__大壽 111.369047744|da shou;
大受__大受 146.497163581|da shou;
大手__大手 255.709615075|da shou;
打手__打手 370.702589737|da shou;
大鼠__大鼠 647.058374454|da shu;
大树__大樹 806.745280603|da shu;
大叔__大叔 1773.27819069|da shu;
打水__打水 199.548108896|da shui;
大水__大水 298.06779536|da shui;
打扰__打擾 2151.11373318|da rao;
大热__大熱 199.548108896|da re;
达人__達人 693.826435782|da ren;
打人__打人 741.198640518|da ren;
大人__大人 3241.3000394|da ren;
打入__打入 765.607004232|da ru;
打杂__打雜 318.022335873|da za;
搭在__搭在 198.803491145|da zai;
打在__打在 280.411678639|da zai;
搭载__搭載 464.497524783|da zai;
大枣__大棗 116.624293448|da zao;
打造__打造 5108.08849097|da zao;
大增__大增 463.919044053|da zeng;
大字__大字 557.184562398|da zi;
打字__打字 2695.38717088|da zi;
大宗__大宗 311.355949144|da zong;
打坐__打坐 145.405889264|da zuo;
大作__大作 678.436468738|da zuo;
大嘴__大嘴 381.481335404|da zui;
大餐__大餐 609.488769235|da can;
大葱__大蔥 198.308623594|da cong;
大错__大錯 292.54791482|da cuo;
打错__打錯 884.6784987|da cuo;
大蒜__大蒜 487.62990282|da suan;
打算__打算 13705.3890367|da suan;
大赛__大賽 2648.77038315|da sai;
打伞__打傘 139.373782642|da san;
大三__大三 912.673735821|da san;
大嫂__大嫂 361.577631409|da sao;
打扫__打掃 878.088426229|da sao;
大肆__大肆 653.541376022|da si;
大四__大四 929.894333673|da si;
打死__打死 2140.41782974|da si;
大宋__大宋 125.835280772|da song;
打碎__打碎 267.775955618|da sui;
大元__大元 112.906187218|da yuan;
大院__大院 559.271495144|da yuan;
大约__大約 4877.91123285|da yue;
大运__大運 134.092283643|da yun;
大牙__大牙 111.786180106|da ya;
打压__打壓 1040.25998178|da ya;
大雁__大雁 159.651218957|da yan;
大眼__大眼 244.796354228|da yan;
打样__打樣 210.270405333|da yang;
大洋__大洋 695.557838999|da yang;
大野__大野 134.259489114|da ye;
大业__大業 290.368691563|da ye;
大爷__大爺 1589.0991261|da ye;
大义__大義 152.457122789|da yi;
打一__打一 157.085680168|da yi;
大姨__大姨 166.353500999|da yi;
大衣__大衣 406.006938516|da yi;
答疑__答疑 449.688850794|da yi;
大意__大意 576.250827814|da yi;
大一__大一 1104.38283164|da yi;
打印__打印 5422.95707874|da yin;
打赢__打贏 290.0070692|da ying;
答应__答應 4745.99659028|da ying;
大有__大有 654.356305043|da you;
大勇__大勇 129.655606164|da yong;
大禹__大禹 130.141230764|da yu;
大宇__大宇 184.941433485|da yu;
大鱼__大魚 309.4219738|da yu;
大雨__大雨 1170.99812122|da yu;
大于__大於 2513.70191646|da yu;
大碗__大碗 209.746993999|da wan;
大腕__大腕 397.496217848|da wan;
打完__打完 1344.71347376|da wan;
大王__大王 933.377249507|da wang;
大伟__大偉 218.008308584|da wei;
大为__大為 516.399339766|da wei;
大卫__大衛 547.548041623|da wei;
打我__打我 775.207436548|da wo;
大雾__大霧 226.312812713|da wu;
大爱__大愛 162.056583012|da ai;
大碍__大礙 213.704562287|da ai;
大案__大案 216.11485651|da an;
答案__答案 6660.92739064|da an;
大鳄__大鱷 169.070402749|da e;
大额__大額 298.811606079|da e;
达尔__達爾 164.908682755|da er;
大二__大二 831.23785106|da er;
呆板__呆板 184.481071779|dai ban;
代办__代辦 524.833224606|dai ban;
代表__代表 19525.0917876|dai biao;
带病__帶病 117.061109314|dai bing;
带兵__帶兵 118.529012887|dai bing;
代步__代步 152.267254161|dai bu;
逮捕__逮捕 800.735741689|dai bu;
代码__代碼 12576.16843|dai ma;
怠慢__怠慢 186.794397067|dai man;
待命__待命 232.024158785|dai ming;
代发__代發 146.497163581|dai fa;
大夫__大夫 926.424414408|dai fu;
带带__帶帶 163.272821143|dai dai;
呆呆__獃獃 583.476802811|dai dai;
逮到__逮到 137.476305203|dai dao;
带刀__帶刀 143.784200776|dai dao;
待到__待到 260.534419685|dai dao;
带到__帶到 1418.73569366|dai dao;
带电__帶電 152.457122789|dai dian;
带点__帶點 581.299547476|dai dian;
待定__待定 511.914293268|dai ding;
带动__帶動 3265.62606571|dai dong;
带队__帶隊 572.671468255|dai dui;
带他__帶他 300.304800557|dai ta;
带她__帶她 420.423657369|dai ta;
代替__代替 2448.77288933|dai ti;
带头__帶頭 1024.81967123|dai tou;
歹徒__歹徒 672.544092675|dai tu;
带你__帶你 1394.19862478|dai ni;
带来__帶來 17650.4435203|dai lai;
代劳__代勞 107.416157498|dai lao;
待了__待了 191.031727675|dai le;
代理__代理 9221.22760447|dai li;
代练__代練 276.594068012|dai lian;
带领__帶領 2815.55016665|dai ling;
带路__帶路 360.228397261|dai lu;
代管__代管 181.064689688|dai guan;
带个__帶個 424.635962376|dai ge;
带给__帶給 2003.61737423|dai gei;
代沟__代溝 353.117055307|dai gou;
代购__代購 518.979844093|dai gou;
代工__代工 426.226434824|dai gong;
呆过__呆過 187.727829225|dai guo;
带过__帶過 222.67604562|dai guo;
带宽__帶寬 1988.69219664|dai kuan;
贷款__貸款 6432.51798548|dai kuan;
代开__代開 159.85029497|dai kai;
代考__代考 307.500011268|dai kao;
代课__代課 114.037415895|dai ke;
带坏__帶壞 143.247667161|dai huai;
带好__帶好 202.302314677|dai hao;
代号__代號 629.559803835|dai hao;
代会__代會 105.953760973|dai hui;
带回__帶回 1010.8674618|dai hui;
待机__待機 618.67155147|dai ji;
代价__代價 3019.05239777|dai jia;
待见__待見 105.821807183|dai jian;
带进__帶進 272.828431509|dai jin;
殆尽__殆盡 282.164331387|dai jin;
带球__帶球 278.322859608|dai qiu;
带去__帶去 519.626982517|dai qu;
代销__代銷 311.744192349|dai xiao;
带些__帶些 119.26985293|dai xie;
代谢__代謝 1046.76190254|dai xie;
带薪__帶薪 198.06165195|dai xin;
袋装__袋裝 147.964946673|dai zhuang;
待着__待着 367.482952871|dai zhe;
戴着__戴着 883.576728645|dai zhe;
呆着__獃著 959.320404733|dai zhe;
带着__帶着 8191.70747243|dai zhe;
代之__代之 126.464093517|dai zhi;
呆滞__獃滯 213.971039752|dai zhi;
呆住__呆住 108.763116896|dai zhu;
逮住__逮住 144.682892926|dai zhu;
带出__帶出 341.433560596|dai chu;
戴上__戴上 748.624851411|dai shang;
带上__帶上 1831.67389823|dai shang;
代收__代收 257.3078729|dai shou;
代数__代數 202.302314677|dai shu;
袋鼠__袋鼠 218.824857909|dai shu;
带人__帶人 206.376433771|dai ren;
代人__代人 230.870473623|dai ren;
待人__待人 351.361264404|dai ren;
代入__代入 120.015323434|dai ru;
带入__帶入 426.757915008|dai ru;
戴在__戴在 160.249192015|dai zai;
待在__待在 403.988165198|dai zai;
呆在__呆在 1295.36947746|dai zai;
呆子__獃子 292.912705474|dai zi;
带子__帶子 338.046607007|dai zi;
袋子__袋子 726.566487616|dai zi;
带走__帶走 1246.28210631|dai zou;
傣族__傣族 117.353228453|dai zu;
怠速__怠速 150.569041974|dai su;
代言__代言 1078.5413133|dai yan;
待业__待業 226.030964922|dai ye;
带有__帶有 2963.1429408|dai you;
带鱼__帶魚 145.405889264|dai yu;
黛玉__黛玉 472.083744072|dai yu;
待遇__待遇 4016.11545597|dai yu;
戴维__戴維 169.492308033|dai wei;
代为__代為 500.559372647|dai wei;
待我__待我 186.097370046|dai wo;
带我__帶我 1257.20118645|dai wo;
戴尔__戴爾 1238.54087357|dai er;
蛋白__蛋白 1454.53963438|dan bai;
单板__單板 142.713135632|dan ban;
担保__擔保 1740.43907177|dan bao;
单边__單邊 301.429591092|dan bian;
淡泊__淡泊 173.986383704|dan bo;
淡薄__淡薄 263.144763849|dan bo;
单薄__單薄 413.667597456|dan bo;
但不__但不 1515.60233678|dan bu;
单片__單片 113.046974828|dan pian;
单品__單品 194.151676652|dan pin;
单凭__單憑 146.314717429|dan ping;
丹麦__丹麥 660.089332023|dan mai;
耽美__耽美 164.908682755|dan mei;
但没__但沒 348.309611377|dan mei;
单面__單面 166.768626413|dan mian;
淡漠__淡漠 241.764712994|dan mo;
但凡__但凡 256.987424161|dan fan;
单反__單反 795.762002835|dan fan;
单方__單方 167.810977762|dan fang;
氮肥__氮肥 120.615053212|dan fei;
单飞__單飛 149.447435764|dan fei;
担负__擔負 566.284555508|dan fu;
胆大__膽大 230.582949765|dan da;
单打__單打 303.313611771|dan da;
丹丹__丹丹 385.303469841|dan dan;
蛋蛋__蛋蛋 689.516759915|dan dan;
单单__單單 704.279880358|dan dan;
淡淡__淡淡 2415.4345439|dan dan;
但当__但當 522.223615731|dan dang;
担当__擔當 841.661270235|dan dang;
单刀__單刀 121.975425508|dan dao;
弹道__彈道 125.053659829|dan dao;
单点__單點 182.423584067|dan dian;
单调__單調 750.493000864|dan diao;
淡定__淡定 344.424970321|dan ding;
但都__但都 138.335571213|dan dou;
丹东__丹東 239.366454718|dan dong;
单独__單獨 4611.89857437|dan du;
但对__但對 810.776675547|dan dui;
蛋挞__蛋撻 112.065135969|dan ta;
但它__但它 1051.99268696|dan ta;
但她__但她 1280.92243009|dan ta;
但他__但他 2749.66894397|dan ta;
单体__單體 399.482550191|dan ti;
丹田__丹田 169.28122395|dan tian;
单条__單條 112.765574943|dan tiao;
单挑__單挑 758.012333731|dan tiao;
弹头__彈頭 283.221176861|dan tou;
但那__但那 346.1460998|dan na;
胆囊__膽囊 165.32020271|dan nang;
但能__但能 129.655606164|dan neng;
丹尼__丹尼 125.522047856|dan ni;
但你__但你 821.967189047|dan ni;
淡蓝__淡藍 122.279808036|dan lan;
淡了__淡了 153.218967809|dan le;
单恋__單戀 117.061109314|dan lian;
胆量__膽量 382.433299725|dan liang;
但该__但該 147.412812521|dan gai;
胆敢__膽敢 123.813152185|dan gan;
单干__單幹 136.792736844|dan gan;
担纲__擔綱 177.490254874|dan gang;
蛋糕__蛋糕 2033.8046114|dan gao;
耽搁__耽擱 320.409100324|dan ge;
单个__單個 1139.33050957|dan ge;
单靠__單靠 180.164388413|dan kao;
蛋壳__蛋殼 128.049907079|dan ke;
淡化__淡化 570.534533242|dan hua;
蛋黄__蛋黃 352.677286738|dan huang;
但还__但還 175.292155245|dan hai;
单号__單號 568.405572245|dan hao;
单核__單核 145.768741141|dan he;
但很__但很 156.109948588|dan hen;
淡季__淡季 467.400766428|dan ji;
单机__單機 793.781168439|dan ji;
单击__單擊 1542.27603899|dan ji;
担架__擔架 125.678566729|dan jia;
单价__單價 1298.60199609|dan jia;
单件__單件 105.821807183|dan jian;
但见__但見 191.031727675|dan jian;
单间__單間 279.017397997|dan jian;
单就__單就 120.615053212|dan jiu;
单据__單據 1003.33739315|dan ju;
但却__但卻 1937.32419285|dan que;
氮气__氮氣 108.222318063|dan qi;
但其__但其 846.921892564|dan qi;
胆怯__膽怯 232.603161479|dan qie;
单亲__單親 116.333988795|dan qin;
丹青__丹青 123.351140937|dan qing;
蛋清__蛋清 129.332863581|dan qing;
但求__但求 212.112652282|dan qiu;
单曲__單曲 631.130833438|dan qu;
单选__單選 139.547573842|dan xuan;
单线__單線 120.765453341|dan xian;
胆小__膽小 577.688827991|dan xiao;
单向__單向 421.472799973|dan xiang;
单项__單項 496.830647979|dan xiang;
担心__擔心 11641.0926326|dan xin;
单行__單行 118.824795093|dan xing;
单张__單張 157.67404401|dan zhang;
但这__但這 1859.27057168|dan zhe;
单证__單證 337.625607028|dan zheng;
胆汁__膽汁 182.651055928|dan zhi;
单纯__單純 4138.04364463|dan chun;
单产__單產 141.826678552|dan chan;
单场__單場 110.677283245|dan chang;
单车__單車 589.322768456|dan che;
诞辰__誕辰 226.595011951|dan chen;
单程__單程 251.914183226|dan cheng;
淡出__淡出 348.309611377|dan chu;
单双__單雙 126.621787068|dan shuang;
单身__單身 2370.70341112|dan shen;
诞生__誕生 2355.97787927|dan sheng;
单是__單是 181.064689688|dan shi;
胆识__膽識 182.423584067|dan shi;
但是__但是 105663.126339|dan shi;
单手__單手 395.519762073|dan shou;
单数__單數 135.773751924|dan shu;
淡水__淡水 346.577724349|dan shui;
淡然__淡然 517.687984062|dan ran;
单人__單人 519.626982517|dan ren;
担任__擔任 4734.18271471|dan ren;
但仍__但仍 563.46883971|dan reng;
单日__單日 170.127140854|dan ri;
但在__但在 3233.23169914|dan zai;
担子__擔子 241.162905094|dan zi;
胆子__膽子 1163.72451202|dan zi;
单子__單子 2323.90287358|dan zi;
但总__但總 282.516174301|dan zong;
单层__單層 145.587202159|dan ceng;
单次__單次 124.89791921|dan ci;
单词__單詞 2001.12208851|dan ci;
单从__單從 191.98633424|dan cong;
但从__但從 899.127155009|dan cong;
单色__單色 196.096919422|dan se;
但愿__但願 1485.68252323|dan yuan;
单元__單元 2843.75970209|dan yuan;
单月__單月 107.684208225|dan yue;
淡雅__淡雅 222.67604562|dan ya;
丹阳__丹陽 216.924313917|dan yang;
弹药__彈藥 341.859308876|dan yao;
但要__但要 771.352901218|dan yao;
单页__單頁 127.096048509|dan ye;
但也__但也 2098.16340664|dan ye;
单一__單一 2108.64816008|dan yi;
但因__但因 420.94790182|dan yin;
但有__但有 660.912425973|dan you;
但又__但又 894.656458236|dan you;
担忧__擔憂 1441.90662463|dan you;
但与__但與 116.044406778|dan yu;
耽于__耽於 204.329220247|dan yu;
淡忘__淡忘 307.117053725|dan wang;
但未__但未 147.412812521|dan wei;
单位__單位 25176.6847796|dan wei;
但我__但我 5395.99270938|dan wo;
耽误__耽誤 1806.7369278|dan wu;
挡板__擋板 145.768741141|dang ban;
党报__黨報 139.895806636|dang bao;
当兵__當兵 527.455873984|dang bing;
党派__黨派 268.109857044|dang pai;
当铺__當鋪 140.945727665|dang pu;
当面__當面 1077.19810837|dang mian;
党费__黨費 142.357889859|dang fei;
荡妇__蕩婦 106.483223576|dang fu;
当代__當代 1623.12304424|dang dai;
当当__噹噹 747.692521253|dang dang;
当道__當道 137.476305203|dang dao;
党的__黨的 4588.96700128|dang de;
当地__當地 9325.23039875|dang di;
党对__黨對 124.276893895|dang dui;
当它__當它 210.270405333|dang ta;
当她__當她 702.526765976|dang ta;
当他__當他 1496.83260243|dang ta;
当天__當天 4453.75227609|dang tian;
当庭__當庭 157.085680168|dang ting;
当头__當頭 224.907079496|dang tou;
党内__黨內 646.252534205|dang nei;
当你__當你 3545.56838982|dang ni;
当年__當年 9095.68698269|dang nian;
当您__當您 325.236501817|dang nin;
当了__當了 396.506758465|dang le;
当官__當官 585.662213047|dang guan;
当个__當個 443.56664881|dang ge;
当过__當過 438.619621343|dang guo;
当归__當歸 147.964946673|dang gui;
党课__黨課 118.972962872|dang ke;
当好__當好 176.387781073|dang hao;
当红__當紅 401.979429753|dang hong;
当即__當即 666.702893247|dang ji;
当家__當家 435.895152658|dang jia;
党建__黨建 312.132919672|dang jian;
当街__當街 167.393257695|dang jie;
当今__當今 1585.14349339|dang jin;
当局__當局 1472.77903036|dang ju;
档期__檔期 284.636464248|dang qi;
当期__當期 356.210827905|dang qi;
当前__當前 8707.49819835|dang qian;
当选__當選 1375.21757695|dang xuan;
当下__當下 978.639934443|dang xia;
党校__黨校 459.317058623|dang xiao;
当心__當心 961.714332594|dang xin;
党性__黨性 170.76435144|dang xing;
党章__黨章 335.528458728|dang zhang;
挡着__擋着 124.431860131|dang zhe;
当着__當著 632.705783453|dang zhe;
当真__當真 698.163048348|dang zhen;
党政__黨政 526.798985534|dang zheng;
当众__當眾 414.183417482|dang zhong;
当中__當中 5416.20338039|dang zhong;
挡住__擋住 729.287839744|dang zhu;
当场__當場 1706.08071057|dang chang;
当成__當成 2321.00870739|dang cheng;
挡出__擋出 116.333988795|dang chu;
当初__當初 6006.40803223|dang chu;
当上__當上 319.611528482|dang shang;
党史__黨史 111.646962678|dang shi;
当事__當事 178.377193209|dang shi;
当时__當時 28947.6493862|dang shi;
当属__當屬 238.473254015|dang shu;
当然__當然 34508.2518349|dang ran;
当人__當人 183.106850936|dang ren;
当日__當日 1573.33557614|dang ri;
党在__黨在 166.353500999|dang zai;
挡在__擋在 252.228305921|dang zai;
党组__黨組 590.057620516|dang zu;
当做__當做 524.179602378|dang zuo;
当作__當作 3273.77524422|dang zuo;
档次__檔次 2059.3077787|dang ci;
党员__黨員 3229.20506361|dang yuan;
当月__當月 573.385557088|dang yue;
荡漾__蕩漾 414.183417482|dang yang;
当晚__當晚 854.342048866|dang wan;
档位__檔位 159.452390871|dang wei;
党委__黨委 1561.61561744|dang wei;
当我__當我 3095.24275062|dang wo;
党务__黨務 115.323601467|dang wu;
档案__檔案 3801.83485115|dang an;
盗版__盜版 2461.00967693|dao ban;
倒闭__倒閉 929.894333673|dao bi;
道别__道別 224.626982392|dao bie;
倒不__倒不 127.096048509|dao bu;
刀片__刀片 367.941183266|dao pian;
倒卖__倒賣 258.271618599|dao mai;
倒霉__倒霉 1856.95505407|dao mei;
稻米__稻米 187.26053154|dao mi;
盗墓__盜墓 206.633773476|dao mu;
刀法__刀法 117.207077876|dao fa;
到访__到訪 209.746993999|dao fang;
刀锋__刀鋒 244.491487214|dao feng;
到达__到達 4284.97958628|dao da;
捣蛋__搗蛋 144.863304286|dao dan;
导弹__導彈 1613.0410787|dao dan;
叨叨__叨叨 124.742372548|dao dao;
道道__道道 196.831399718|dao dao;
刀刀__刀刀 244.796354228|dao dao;
道德__道德 5608.52492462|dao de;
到第__到第 205.094534596|dao di;
倒地__倒地 411.098117295|dao di;
到底__到底 14298.5591896|dao di;
导电__導電 231.446597362|dao dian;
倒掉__倒掉 181.290467084|dao diao;
导读__導讀 171.190483873|dao du;
到他__到他 609.488769235|dao ta;
倒塌__倒塌 690.376548199|dao ta;
倒腾__倒騰 131.937467932|dao teng;
导体__導體 122.279808036|dao ti;
道题__道題 279.365316864|dao ti;
稻田__稻田 215.040276584|dao tian;
倒贴__倒貼 173.553291634|dao tie;
到头__到頭 248.794392378|dao tou;
倒退__倒退 424.107124851|dao tui;
到那__到那 226.595011951|dao na;
到哪__到哪 349.178797604|dao na;
岛内__島內 402.480675297|dao nei;
到你__到你 876.994863387|dao ni;
悼念__悼念 375.819106356|dao nian;
到您__到您 129.655606164|dao nin;
捣乱__搗亂 631.130833438|dao luan;
导论__導論 140.594881376|dao lun;
到来__到來 2692.03036174|dao lai;
刀郎__刀郎 161.854759309|dao lang;
到老__到老 207.149415951|dao lao;
倒了__倒了 660.912425973|dao le;
到了__到了 22702.7608644|dao le;
倒立__倒立 141.121478992|dao li;
道理__道理 6803.54331971|dao li;
盗链__盜鏈 127.413209251|dao lian;
倒流__倒流 140.244908425|dao liu;
道路__道路 5887.83431135|dao lu;
倒挂__倒掛 150.007190589|dao gua;
导管__導管 274.191785204|dao guan;
道光__道光 126.621787068|dao guang;
到该__到該 139.72158175|dao gai;
到港__到港 114.037415895|dao gang;
祷告__禱告 362.028498203|dao gao;
导购__導購 516.399339766|dao gou;
捣鼓__搗鼓 169.28122395|dao gu;
稻谷__稻穀 226.877563077|dao gu;
岛国__島國 138.163289429|dao guo;
到过__到過 526.142915167|dao guo;
导轨__導軌 108.898738333|dao gui;
刀客__刀客 152.267254161|dao ke;
刀口__刀口 115.899886195|dao kou;
道口__道口 153.218967809|dao kou;
倒还__倒還 122.279808036|dao hai;
导航__導航 1870.89154158|dao hang;
倒好__倒好 134.092283643|dao hao;
盗号__盜號 412.637883794|dao hao;
道行__道行 128.850255419|dao heng;
到户__到戶 137.647730357|dao hu;
到货__到貨 1279.32718167|dao huo;
捣毁__搗毀 119.86585751|dao hui;
到会__到會 134.42690308|dao hui;
道家__道家 677.591550514|dao jia;
到家__到家 1641.42964497|dao jia;
刀剑__刀劍 187.727829225|dao jian;
道教__道教 359.779772295|dao jiao;
倒进__倒進 141.650048976|dao jin;
刀具__刀具 390.135034682|dao ju;
道具__道具 1877.89895902|dao ju;
到齐__到齊 151.888225993|dao qi;
到期__到期 1875.5602418|dao qi;
道歉__道歉 2681.98499671|dao qian;
刀鞘__刀鞘 537.40806734|dao qiao;
盗窃__盜竊 641.438524323|dao qie;
盗取__盜取 222.121753798|dao qu;
倒下__倒下 757.068312494|dao xia;
导线__導線 304.070513117|dao xian;
到校__到校 125.053659829|dao xiao;
导向__導向 1295.36947746|dao xiang;
道谢__道謝 131.117943492|dao xie;
到新__到新 116.18910757|dao xin;
到站__到站 137.134095104|dao zhan;
道长__道長 183.106850936|dao zhang;
到帐__到帳 662.561694208|dao zhang;
到这__到這 559.271495144|dao zhe;
倒置__倒置 151.510141313|dao zhi;
导致__導致 16035.5172883|dao zhi;
道场__道場 164.088713397|dao chang;
到场__到場 775.207436548|dao chang;
倒车__倒車 331.37316028|dao che;
道出__道出 341.008342538|dao chu;
导出__導出 1525.07528247|dao chu;
到处__到處 5429.71919857|dao chu;
道上__道上 212.641966978|dao shang;
岛上__島上 651.102673334|dao shang;
道士__道士 633.494731672|dao shi;
导师__導師 2586.79165036|dao shi;
到时__到時 4163.90759438|dao shi;
倒是__倒是 8242.90797407|dao shi;
到手__到手 895.772044085|dao shou;
倒数__倒數 620.98878351|dao shu;
倒水__倒水 215.30841961|dao shui;
刀刃__刀刃 176.387781073|dao ren;
道人__道人 203.313241605|dao ren;
倒入__倒入 574.10053635|dao ru;
导入__導入 2702.11335163|dao ru;
倒在__倒在 882.476330723|dao zai;
盗贼__盜賊 1795.51445179|dao zei;
刀子__刀子 451.373158744|dao zi;
道菜__道菜 197.814987883|dao cai;
稻草__稻草 338.890182508|dao cao;
到此__到此 737.513205869|dao ci;
到死__到死 271.471856767|dao si;
导演__導演 6488.8753536|dao yan;
倒也__倒也 637.454253928|dao ye;
道义__道義 347.00988711|dao yi;
导引__導引 122.432284019|dao yin;
倒影__倒影 211.057972369|dao ying;
导游__導遊 1795.51445179|dao you;
盗用__盜用 351.361264404|dao yong;
岛屿__島嶼 483.394725468|dao yu;
到晚__到晚 270.122027271|dao wan;
到位__到位 3177.31287701|dao wei;
到我__到我 727.472474808|dao wo;
得比__得比 226.595011951|de bi;
德比__德比 264.130371602|de bi;
得病__得病 264.130371602|de bing;
得不__得不 193.427195796|de bu;
得票__得票 124.276893895|de piao;
的吗__的嗎 543.469292924|de ma;
得名__得名 325.642053285|de ming;
得分__得分 2008.61728399|de fen;
的风__的風 345.715012791|de feng;
的大__的大 1363.27349742|de da;
得当__得當 313.302012384|de dang;
得道__得道 133.925286409|de dao;
得到__得到 29752.2472719|de dao;
得得__得得 122.890853693|de de;
的第__的第 2238.62771494|de di;
得多__得多 3037.92233395|de duo;
得体__得體 321.609191441|de ti;
地听__地聽 124.431860131|de ting;
德拉__德拉 172.04594156|de la;
得来__得來 524.179602378|de lai;
的老__的老 636.660374558|de lao;
得了__得了 3091.3879652|de le;
得利__得利 163.884358899|de li;
得力__得力 340.15949445|de li;
的脸__的臉 2545.22282076|de lian;
得了__得了 125.522047856|de liao;
德隆__德隆 197.814987883|de long;
的路__的路 1653.74860966|de lu;
的歌__的歌 2006.11577143|de ge;
得更__得更 475.626742696|de geng;
得过__得過 361.12732612|de guo;
德国__德國 8029.99331146|de guo;
得快__得快 287.846772995|de kuai;
德科__德科 124.587019602|de ke;
的话__的話 30389.267335|de hua;
得好__得好 593.745648473|de hao;
的好__的好 1456.35336279|de hao;
得很__得很 2567.52234013|de hen;
德军__德軍 324.02287532|de jun;
德甲__德甲 292.912705474|de jia;
的家__的家 328.904723278|de jia;
得见__得見 105.0335283|de jian;
得奖__得獎 389.163898974|de jiang;
得救__得救 138.508067822|de jiu;
得起__得起 469.151414294|de qi;
的钱__的錢 3722.14075882|de qian;
德勤__德勤 156.304608838|de qin;
得闲__得閑 627.210588862|de xian;
的信__的信 267.775955618|de xin;
的心__的心 4036.18442686|de xin;
的新__的新 4253.06027768|de xin;
德性__德性 180.389043185|de xing;
德行__德行 465.076726846|de xing;
得志__得志 129.655606164|de zhi;
得知__得知 2974.24138187|de zhi;
德州__德州 361.577631409|de zhou;
得主__得主 281.812926654|de zhu;
得住__得住 388.679238014|de zhu;
得逞__得逞 305.97104031|de cheng;
得出__得出 2321.00870739|de chu;
得上__得上 354.881620091|de shang;
德胜__德勝 130.628674269|de sheng;
得失__得失 443.56664881|de shi;
的是__的是 4041.21731986|de shi;
的事__的事 11482.6072259|de shi;
得手__得手 426.226434824|de shou;
的手__的手 2321.00870739|de shou;
的书__的書 1913.33171172|de shu;
的说__的說 212.907119447|de shuo;
地说__地說 5210.95909278|de shuo;
得人__得人 123.197520618|de ren;
的人__的人 50970.5792059|de ren;
地走__地走 411.610733326|de zou;
地做__地做 153.41002317|de zuo;
得罪__得罪 1197.56158489|de zui;
德斯__德斯 106.483223576|de si;
德阳__德陽 291.819695868|de yang;
得益__得益 491.289575698|de yi;
得意__得意 1793.27833544|de yi;
得以__得以 2746.24453283|de yi;
德育__德育 346.1460998|de yu;
德语__德語 693.826435782|de yu;
德文__德文 313.302012384|de wen;
的爱__的愛 1808.98982626|de ai;
德尔__德爾 232.313479749|de er;
灯泡__燈泡 626.429466854|deng pao;
登门__登門 145.224802174|deng men;
瞪大__瞪大 208.70407676|deng da;
等待__等待 8849.70991589|deng dai;
等到__等到 4205.62658069|deng dao;
等等__等等 12544.8634582|deng deng;
等地__等地 1845.42065012|deng di;
登顶__登頂 203.313241605|deng ding;
灯塔__燈塔 198.308623594|deng ta;
等他__等他 610.248767154|deng ta;
登台__登台 301.429591092|deng tai;
等同__等同 366.111682898|deng tong;
等你__等你 3801.83485115|deng ni;
瞪了__瞪了 200.04606951|deng le;
灯笼__燈籠 305.97104031|deng long;
登陆__登陸 3364.76959766|deng lu;
登录__登錄 10628.84098|deng lu;
灯管__燈管 164.703307075|deng guan;
灯光__燈光 1922.89284084|deng guang;
登高__登高 174.855812809|deng gao;
等国__等國 479.196331601|deng guo;
邓肯__鄧肯 225.468321935|deng ken;
等号__等號 125.209594649|deng hao;
等候__等候 1015.91887775|deng hou;
灯火__燈火 300.679263607|deng huo;
灯会__燈會 614.062995519|deng hui;
等均__等均 162.056583012|deng jun;
登基__登基 137.991222203|deng ji;
登机__登機 300.304800557|deng ji;
登记__登記 4793.54763754|deng ji;
等级__等級 5146.42480465|deng ji;
等价__等價 195.121873946|deng jia;
灯具__燈具 396.506758465|deng ju;
灯下__燈下 756.125466931|deng xia;
等闲__等閑 110.126966673|deng xian;
等效__等效 211.321149687|deng xiao;
灯箱__燈箱 186.794397067|deng xiang;
瞪着__瞪着 450.811022973|deng zhe;
等着__等着 4594.6891828|deng zhe;
等值__等值 121.671800659|deng zhi;
登场__登場 1066.51251556|deng chang;
邓超__鄧超 138.335571213|deng chao;
等车__等車 221.568841736|deng che;
登出__登出 153.792848894|deng chu;
等处__等處 179.492101402|deng chu;
登山__登山 680.977550057|deng shan;
登上__登上 1238.54087357|deng shang;
灯饰__燈飾 219.644465616|deng shi;
等人__等人 2382.55007694|deng ren;
登入__登入 317.626273928|deng ru;
登载__登載 184.02185602|deng zai;
凳子__凳子 540.093554591|deng zi;
等死__等死 215.30841961|deng si;
登月__登月 137.647730357|deng yue;
等于__等於 4338.71166588|deng yu;
等我__等我 3576.63225989|deng wo;
得多__得多 267.44247003|dei duo;
得好__得好 228.295612376|dei hao;
得很__得很 140.419785869|dei hen;
得去__得去 127.413209251|dei qu;
得先__得先 150.944778196|dei xian;
得有__得有 139.895806636|dei you;
第八__第八 726.566487616|di ba;
迪拜__迪拜 348.743933702|di bai;
底板__底板 240.263000901|di ban;
地板__地板 2439.63524442|di ban;
低保__低保 607.9716117|di bao;
地被__地被 353.557372243|di bei;
地标__地標 226.877563077|di biao;
地表__地表 309.807805448|di biao;
底部__底部 1829.39274925|di bu;
地步__地步 1836.24473312|di bu;
底牌__底牌 121.520271774|di pai;
底盘__底盤 690.376548199|di pan;
地盘__地盤 853.278059532|di pan;
地皮__地皮 245.407229187|di pi;
底片__底片 208.70407676|di pian;
低频__低頻 307.500011268|di pin;
地铺__地鋪 106.085879302|di pu;
地貌__地貌 296.216358865|di mao;
弟妹__弟妹 206.376433771|di mei;
低迷__低迷 881.377303227|di mi;
地面__地面 3471.24615709|di mian;
地名__地名 598.94764591|di ming;
堤防__堤防 154.561368684|di fang;
提防__提防 276.594068012|di fang;
敌方__敵方 281.461959558|di fang;
地方__地方 50276.6501023|di fang;
低分__低分 126.306596357|di fen;
地府__地府 142.891090816|di fu;
地段__地段 1121.02187006|di duan;
低端__低端 1187.16048834|di duan;
滴答__滴答 105.821807183|di da;
抵达__抵達 1528.88101848|di da;
地带__地帶 1402.91276273|di dai;
低档__低檔 267.775955618|di dang;
抵挡__抵擋 550.284199441|di dang;
地道__地道 1107.13875428|di dao;
滴滴__滴滴 195.365179853|di di;
低低__低低 225.187525865|di di;
弟弟__弟弟 5490.95898063|di di;
低点__低點 575.5331706|di dian;
地点__地點 4988.56403023|di dian;
低调__低調 2593.24683736|di diao;
敌对__敵對 382.910172354|di dui;
地摊__地攤 263.801426189|di tan;
地毯__地毯 584.204365283|di tan;
地铁__地鐵 3991.16951133|di tie;
迪厅__迪廳 112.204874836|di ting;
地头__地頭 141.121478992|di tou;
低头__低頭 1260.33845835|di tou;
地图__地圖 7249.97516601|di tu;
地暖__地暖 193.186303435|di nuan;
低能__低能 133.42554153|di neng;
涤纶__滌綸 141.473639374|di lun;
地雷__地雷 337.205131359|di lei;
地里__地里 284.281980745|di li;
地理__地理 1680.75779471|di li;
低廉__低廉 709.565515965|di lian;
低劣__低劣 222.67604562|di lie;
第六__第六 1129.43516323|di liu;
地漏__地漏 110.126966673|di lou;
滴落__滴落 110.264288753|di luo;
低落__低落 460.463257431|di luo;
地瓜__地瓜 280.062456643|di gua;
递给__遞給 691.237408589|di gei;
嘀咕__嘀咕 299.93080386|di gu;
低谷__低谷 482.191444969|di gu;
低估__低估 779.081233415|di gu;
帝国__帝國 1802.23954462|di guo;
递归__遞歸 227.443722742|di gui;
地块__地塊 1031.22508566|di kuai;
低开__低開 545.504855178|di kai;
抵抗__抵抗 1459.98760728|di kang;
迪克__迪克 111.230349808|di ke;
抵扣__抵扣 290.368691563|di kou;
低空__低空 106.350610398|di kong;
底裤__底褲 114.607273411|di ku;
诋毁__詆毀 398.985038482|di hui;
敌军__敵軍 284.281980745|di jun;
第几__第幾 187.4940348|di ji;
地基__地基 318.418891685|di ji;
低级__低級 954.550411286|di ji;
底价__底價 317.230705235|di jia;
地价__地價 538.078184713|di jia;
低价__低價 2210.90378861|di jia;
递减__遞減 268.444174826|di jian;
递交__遞交 820.943519051|di jiao;
缔结__締結 136.452228303|di jie;
地精__地精 219.918349804|di jing;
第九__第九 611.009712747|di jiu;
的确__的確 8222.38948289|di que;
底气__底氣 290.0070692|di qi;
第七__第七 920.669965262|di qi;
地壳__地殼 168.439513167|di qiao;
地球__地球 4365.82984783|di qiu;
地区__地區 16667.1089518|di qu;
地穴__地穴 125.36572391|di xue;
滴血__滴血 168.649547684|di xue;
底细__底細 147.045868173|di xi;
低吸__低吸 160.049619219|di xi;
低下__低下 1090.70577937|di xia;
底下__底下 1434.73708553|di xia;
地下__地下 3302.45784674|di xia;
底线__底線 1305.09125317|di xian;
抵消__抵消 396.506758465|di xiao;
底薪__底薪 269.785619908|di xin;
地形__地形 853.278059532|di xing;
低胸__低胸 229.150692759|di xiong;
弟兄__弟兄 566.990680223|di xiong;
地砖__地磚 263.144763849|di zhuan;
抵债__抵債 107.282382453|di zhai;
地震__地震 4745.99659028|di zhen;
地质__地質 1066.51251556|di zhi;
抵制__抵制 1483.83226857|di zhi;
地址__地址 18483.3267977|di zhi;
地主__地主 938.041438335|di zhu;
地产__地產 2883.00988318|di chan;
低潮__低潮 184.941433485|di chao;
低沉__低沉 375.819106356|di chen;
抵触__抵觸 786.88699725|di chu;
地处__地處 955.740681497|di chu;
低垂__低垂 105.0335283|di chui;
递上__遞上 157.67404401|di shang;
地上__地上 4716.51701742|di shang;
低声__低聲 453.063775264|di sheng;
敌视__敵視 124.587019602|di shi;
地势__地勢 301.054193591|di shi;
的士__的士 308.651751439|di shi;
地市__地市 583.476802811|di shi;
第十__第十 693.826435782|di shi;
地说__地說 506.204995518|di shuo;
滴水__滴水 256.987424161|di shui;
地税__地稅 559.271495144|di shui;
地热__地熱 193.668388536|di re;
敌人__敵人 3897.77990299|di ren;
缔造__締造 275.905561849|di zao;
递增__遞增 374.883606282|di zeng;
笛子__笛子 203.313241605|di zi;
底子__底子 291.819695868|di zi;
弟子__弟子 1238.54087357|di zi;
底座__底座 509.368920718|di zuo;
低层__低層 136.282292017|di ceng;
地层__地層 248.175085992|di ceng;
底层__底層 1185.68201014|di ceng;
第三__第三 6096.90278745|di san;
底色__底色 245.407229187|di se;
迪斯__迪斯 119.121315407|di si;
第四__第四 3343.86946243|di si;
低俗__低俗 278.322859608|di su;
低速__低速 333.029068427|di su;
地缘__地緣 132.762114633|di yuan;
底蕴__底蘊 260.859291326|di yun;
迪亚__迪亞 156.89004718|di ya;
低压__低壓 348.309611377|di ya;
抵押__抵押 943.904464128|di ya;
敌意__敵意 221.292902041|di yi;
第一__第一 19403.8124409|di yi;
低音__低音 461.037428991|di yin;
低语__低語 113.611883002|di yu;
抵御__抵禦 575.5331706|di yu;
地狱__地獄 1553.85085374|di yu;
地域__地域 1721.02823483|di yu;
低于__低於 4031.15780176|di yu;
帝王__帝王 670.869975958|di wang;
低温__低溫 686.943814365|di wen;
低位__低位 593.006203378|di wei;
地位__地位 7592.08459063|di wei;
第五__第五 1795.51445179|di wu;
低矮__低矮 146.132498493|di ai;
迪奥__迪奧 142.535402072|di ao;
地儿__地兒 200.29551561|di er;
第二__第二 13284.9916911|di er;
点吧__點吧 373.019586361|dian ba;
点半__點半 1731.7851508|dian ban;
电报__電報 319.213487372|dian bao;
电表__電錶 222.67604562|dian biao;
点拨__點撥 136.792736844|dian bo;
电波__電波 177.933171406|dian bo;
颠簸__顛簸 341.859308876|dian bo;
点播__點播 553.034030141|dian bo;
电瓶__電瓶 185.172044961|dian ping;
电平__電平 312.911829085|dian ping;
点评__點評 2069.59836629|dian ping;
店铺__店鋪 1896.71398774|dian pu;
电煤__電煤 149.633788238|dian mei;
店面__店面 1000.83985593|dian mian;
店名__店名 200.29551561|dian ming;
点名__點名 780.052703516|dian ming;
典范__典範 702.526765976|dian fan;
淀粉__澱粉 568.405572245|dian fen;
颠峰__顛峰 196.096919422|dian feng;
巅峰__巔峰 453.628720089|dian feng;
电费__電費 695.557838999|dian fei;
垫付__墊付 282.868455943|dian fu;
颠覆__顛覆 807.751246202|dian fu;
电大__電大 248.175085992|dian da;
典当__典當 163.476413088|dian dang;
点到__點到 331.37316028|dian dao;
颠倒__顛倒 523.526794166|dian dao;
点灯__點燈 128.209578049|dian deng;
电灯__電燈 199.299593609|dian deng;
垫底__墊底 215.30841961|dian di;
点滴__點滴 707.799244422|dian di;
点点__點點 1424.04956302|dian dian;
奠定__奠定 1295.36947746|dian ding;
电动__電動 878.088426229|dian dong;
电镀__電鍍 289.645897197|dian du;
电台__電台 1597.0400293|dian tai;
殿堂__殿堂 398.985038482|dian tang;
电梯__電梯 2161.86308522|dian ti;
点头__點頭 1567.46464304|dian tou;
电脑__電腦 33035.4970715|dian nao;
电能__電能 250.037645335|dian neng;
店内__店內 399.482550191|dian nei;
电驴__電驢 883.576728645|dian lv;
电缆__電纜 1093.42757174|dian lan;
点了__點了 1450.91895115|dian le;
典礼__典禮 528.772109212|dian li;
店里__店裡 1791.04500392|dian li;
电力__電力 3257.49717238|dian li;
掂量__掂量 162.663565352|dian liang;
电量__電量 409.564096466|dian liang;
点亮__點亮 470.32215416|dian liang;
电流__電流 1587.1200774|dian liu;
电炉__電爐 127.096048509|dian lu;
电路__電路 2312.34781708|dian lu;
电骡__電騾 136.452228303|dian luo;
电感__電感 268.109857044|dian gan;
点歌__點歌 205.350275845|dian ge;
电工__電工 474.442798491|dian gong;
典故__典故 320.409100324|dian gu;
癫狂__癲狂 107.818484324|dian kuang;
点卡__點卡 1193.09285994|dian ka;
点开__點開 304.070513117|dian kai;
电控__電控 144.502706249|dian kong;
电话__電話 49100.223832|dian hua;
电荷__電荷 177.711575153|dian he;
电弧__電弧 233.474375771|dian hu;
点火__點火 477.408200926|dian huo;
电汇__電匯 189.372573382|dian hui;
电击__電擊 161.854759309|dian ji;
典籍__典籍 176.168109435|dian ji;
奠基__奠基 212.907119447|dian ji;
电极__電極 413.667597456|dian ji;
惦记__惦記 607.9716117|dian ji;
电机__電機 1202.04704744|dian ji;
点击__點擊 9668.39676357|dian ji;
店家__店家 317.626273928|dian jia;
电价__電價 409.564096466|dian jia;
电教__電教 110.677283245|dian jiao;
电解__電解 239.068350048|dian jie;
点睛__點睛 124.122120652|dian jing;
电气__電氣 1081.23274995|dian qi;
电器__電器 1784.36168375|dian qi;
点钱__點錢 789.834279627|dian qian;
点球__點球 808.758466182|dian qiu;
点选__點選 125.835280772|dian xuan;
电讯__電訊 354.881620091|dian xun;
殿下__殿下 289.645897197|dian xia;
癫痫__癲癇 238.473254015|dian xian;
电线__電線 605.702953498|dian xian;
点心__點心 965.316430119|dian xin;
电信__電信 7187.00747177|dian xin;
典型__典型 4669.73009873|dian xing;
电站__電站 482.191444969|dian zhan;
店长__店長 334.276427588|dian zhang;
点着__點着 129.817279349|dian zhe;
点阵__點陣 105.953760973|dian zhen;
点钟__點鐘 524.833224606|dian zhong;
店主__店主 927.579613097|dian zhu;
点缀__點綴 599.694499646|dian zhui;
电场__電場 147.780672558|dian chang;
电厂__電廠 883.576728645|dian chang;
电车__電車 301.429591092|dian che;
滇池__滇池 121.823518492|dian chi;
电池__電池 5429.71919857|dian chi;
电扇__電扇 230.582949765|dian shan;
点上__點上 538.749137684|dian shang;
电视__電視 11787.0676841|dian shi;
点数__點數 664.215078095|dian shu;
点水__點水 125.678566729|dian shui;
点燃__點燃 1090.70577937|dian ran;
电热__電熱 149.633788238|dian re;
电容__電容 847.977956119|dian rong;
垫子__墊子 262.817045902|dian zi;
点子__點子 528.113581536|dian zi;
电子__電子 10099.4233456|dian zi;
电阻__電阻 756.125466931|dian zu;
点菜__點菜 296.216358865|dian cai;
电磁__電磁 397.496217848|dian ci;
点此__點此 2361.85708402|dian ci;
店员__店員 463.341283758|dian yuan;
电源__電源 4583.25194611|dian yuan;
典雅__典雅 528.772109212|dian ya;
电压__電壓 2069.59836629|dian ya;
点样__點樣 138.163289429|dian yang;
电音__電音 105.426930997|dian yin;
电影__電影 21545.081392|dian ying;
电邮__電郵 427.290057918|dian you;
电泳__電泳 137.476305203|dian yong;
电玩__電玩 255.709615075|dian wan;
电网__電網 874.811821743|dian wang;
电位__電位 163.272821143|dian wei;
点位__點位 428.890471272|dian wei;
玷污__玷污 268.444174826|dian wu;
点儿__點兒 1288.92855961|dian er;
碉堡__碉堡 127.73116145|diao bao;
调拨__調撥 172.905674062|diao bo;
吊牌__吊牌 134.42690308|diao pai;
调配__調配 109.170488754|diao pei;
吊带__弔帶 332.200082586|diao dai;
掉到__掉到 268.778909483|diao dao;
调到__調到 373.019586361|diao dao;
吊灯__吊燈 116.333988795|diao deng;
调调__調調 251.914183226|diao diao;
吊顶__吊頂 268.109857044|diao ding;
调动__調動 1676.57400252|diao dong;
调度__調度 1313.24844471|diao du;
调头__調頭 108.627664361|diao tou;
掉头__掉頭 307.117053725|diao tou;
刁难__刁難 211.321149687|diao nan;
调离__調離 141.473639374|diao li;
凋零__凋零 244.186999878|diao ling;
掉落__掉落 507.468200425|diao luo;
雕刻__雕刻 622.538424634|diao ke;
雕花__雕花 111.091824605|diao hua;
调换__調換 216.924313917|diao huan;
调集__調集 129.979154132|diao ji;
掉进__掉進 381.006242235|diao jin;
掉下__掉下 244.186999878|diao xia;
掉线__掉線 2018.65456559|diao xian;
吊销__吊銷 239.366454718|diao xiao;
雕像__雕像 480.991159713|diao xiang;
凋谢__凋謝 159.85029497|diao xie;
吊装__吊裝 135.435779871|diao zhuang;
叼着__叼着 146.679837233|diao zhe;
雕琢__雕琢 165.114314527|diao zhuo;
吊坠__吊墜 140.070248771|diao zhui;
调查__調查 13434.8281681|diao cha;
貂蝉__貂蟬 127.572086295|diao chan;
吊车__吊車 145.405889264|diao che;
调出__調出 276.249600432|diao chu;
调水__調水 123.658956482|diao shui;
调任__調任 192.945711079|diao ren;
掉入__掉入 117.792774542|diao ru;
调入__調入 321.208662461|diao ru;
掉在__掉在 205.350275845|diao zai;
调子__調子 224.06783424|diao zi;
吊死__弔死 141.826678552|diao si;
雕塑__雕塑 771.352901218|diao su;
调研__調研 3394.2494311|diao yan;
调用__調用 3806.57552354|diao yong;
钓鱼__釣魚 1209.56018338|diao yu;
凋亡__凋亡 131.609045271|diao wang;
碟片__碟片 293.277951001|die pian;
跌破__跌破 768.474582473|die po;
爹妈__爹媽 245.101601395|die ma;
跌幅__跌幅 981.082073059|die fu;
迭代__迭代 302.558594526|die dai;
跌到__跌到 439.166555128|die dao;
跌倒__跌倒 517.043260448|die dao;
跌得__跌得 139.026849285|die de;
爹爹__爹爹 288.924902033|die die;
跌停__跌停 1577.26174289|die ting;
爹娘__爹娘 205.862715427|die niang;
跌落__跌落 299.93080386|die luo;
跌价__跌價 156.304608838|die jia;
叠加__疊加 478.003501869|die jia;
跌至__跌至 305.97104031|die zhi;
跌势__跌勢 221.017305999|die shi;
跌入__跌入 156.499511818|die ru;
碟子__碟子 362.028498203|die zi;
蝶衣__蝶衣 114.75018218|die yi;
蝶舞__蝶舞 132.762114633|die wu;
顶部__頂部 904.746955463|ding bu;
订票__訂票 686.943814365|ding piao;
订房__訂房 168.439513167|ding fang;
顶风__頂風 107.416157498|ding feng;
顶峰__頂峰 385.78392141|ding feng;
顶端__頂端 465.65665114|ding duan;
定单__定單 342.712398751|ding dan;
订单__訂單 5070.03774893|ding dan;
叮当__叮噹 357.099731154|ding dang;
顶到__頂到 178.377193209|ding dao;
顶点__頂點 388.195180646|ding dian;
定点__定點 788.850627646|ding dian;
定定__定定 113.895394799|ding ding;
顶顶__頂頂 346.1460998|ding ding;
丁丁__丁丁 534.069978074|ding ding;
叮咚__叮咚 136.452228303|ding dong;
定夺__定奪 126.306596357|ding duo;
顶多__頂多 998.348535653|ding duo;
顶替__頂替 228.295612376|ding ti;
叮咛__叮嚀 133.259374649|ding ning;
定论__定論 450.24958728|ding lun;
定律__定律 645.447697543|ding lv;
订了__訂了 343.996026791|ding le;
定了__定了 1182.73057528|ding le;
丁磊__丁磊 172.690339006|ding lei;
鼎力__鼎力 138.335571213|ding li;
定力__定力 163.476413088|ding li;
定理__定理 380.531740742|ding li;
订立__訂立 492.515560049|ding li;
定量__定量 611.771607197|ding liang;
顶楼__頂樓 306.352568839|ding lou;
定稿__定稿 307.117053725|ding gao;
定格__定格 390.135034682|ding ge;
定购__定購 145.587202159|ding gou;
订购__訂購 1401.16558873|ding gou;
订婚__訂婚 419.900065808|ding hun;
鼎好__鼎好 208.964318904|ding hao;
订好__訂好 247.249015706|ding hao;
订货__訂貨 730.197220308|ding huo;
定级__定級 113.046974828|ding ji;
顶级__頂級 1813.50405438|ding ji;
定价__定價 1882.58514584|ding jia;
顶尖__頂尖 745.831342837|ding jian;
订金__訂金 215.576896995|ding jin;
定金__定金 686.943814365|ding jin;
定局__定局 194.636170786|ding ju;
定居__定居 632.705783453|ding ju;
顶起__頂起 188.430963124|ding qi;
定期__定期 3364.76959766|ding qi;
顶下__頂下 160.049619219|ding xia;
定下__定下 558.574983827|ding xia;
丁香__丁香 303.691826638|ding xiang;
定向__定向 789.834279627|ding xiang;
定型__定型 385.78392141|ding xing;
定性__定性 604.948616891|ding xing;
顶着__頂着 663.387871054|ding zhe;
盯着__盯着 2199.91059329|ding zhe;
定植__定植 106.085879302|ding zhi;
订制__訂製 326.861744407|ding zhi;
定制__定製 2043.96775685|ding zhi;
盯住__盯住 253.804804573|ding zhu;
顶住__頂住 392.084582382|ding zhu;
叮嘱__叮囑 434.268601197|ding zhu;
盯上__盯上 229.436430673|ding shang;
顶上__頂上 490.677728407|ding shang;
定神__定神 117.792774542|ding shen;
鼎盛__鼎盛 279.017397997|ding sheng;
定势__定勢 108.492380517|ding shi;
定时__定時 989.677650042|ding shi;
钉在__釘在 110.539446825|ding zai;
定在__定在 408.544597361|ding zai;
钉子__釘子 350.050152834|ding zi;
订做__訂做 207.149415951|ding zuo;
定做__定做 397.496217848|ding zuo;
定罪__定罪 205.862715427|ding zui;
订餐__訂餐 155.527421199|ding can;
顶层__頂層 263.144763849|ding ceng;
订阅__訂閱 1521.27901981|ding yue;
定要__定要 111.369047744|ding yao;
定义__定義 7178.0568421|ding yi;
定于__定於 357.99085261|ding yu;
定为__定為 627.210588862|ding wei;
定位__定位 6250.76734939|ding wei;
顶啊__頂啊 189.845141544|ding a;
定额__定額 451.373158744|ding e;
丢包__丟包 132.266710153|diu bao;
丢掉__丟掉 624.870140032|diu diao;
丢丢__丟丟 158.659551632|diu diu;
丢了__丟了 1583.16937099|diu le;
丢脸__丟臉 633.494731672|diu lian;
丢弃__丟棄 431.033684153|diu qi;
丢下__丟下 359.331706043|diu xia;
丢失__丟失 2028.7420046|diu shi;
丢人__丟人 1059.88791463|diu ren;
都把__都把 544.825488702|dou ba;
豆瓣__豆瓣 606.458230719|dou ban;
都被__都被 2596.48046905|dou bei;
都比__都比 731.107734818|dou bi;
都不__都不 10213.3309828|dou bu;
斗篷__斗篷 142.713135632|dou peng;
豆粕__豆粕 208.964318904|dou po;
都没__都沒 6066.58738271|dou mei;
都发__都發 137.134095104|dou fa;
兜风__兜風 148.334184528|dou feng;
豆腐__豆腐 1450.91895115|dou fu;
都打__都打 212.112652282|dou da;
都到__都到 117.061109314|dou dao;
逗得__逗得 125.992190229|dou de;
都得__都得 636.660374558|dou de;
都得__都得 363.384474622|dou dei;
逗逗__逗逗 142.535402072|dou dou;
兜兜__兜兜 324.426913464|dou dou;
痘痘__痘痘 660.912425973|dou dou;
豆豆__豆豆 1235.45786087|dou dou;
都懂__都懂 141.650048976|dou dong;
抖动__抖動 484.601008682|dou dong;
都对__都對 362.028498203|dou dui;
都听__都聽 184.251320835|dou ting;
都拿__都拿 159.85029497|dou na;
都难__都難 250.037645335|dou nan;
都能__都能 6586.63913914|dou neng;
斗牛__鬥牛 123.197520618|dou niu;
都来__都來 522.223615731|dou lai;
逗乐__逗樂 132.10198647|dou le;
豆类__豆類 181.064689688|dou lei;
兜里__兜里 276.594068012|dou li;
逗留__逗留 305.209408115|dou liu;
都怪__都怪 185.86560618|dou guai;
都搞__都搞 159.85029497|dou gao;
都跟__都跟 251.287110964|dou gen;
都给__都給 696.425160166|dou gei;
都快__都快 1185.68201014|dou kuai;
都看__都看 371.164834837|dou kan;
都可__都可 568.405572245|dou ke;
豆花__豆花 139.373782642|dou hua;
逗号__逗號 318.022335873|dou hao;
都好__都好 1074.51671486|dou hao;
都很__都很 3888.07743356|dou hen;
都会__都會 14477.8579016|dou hui;
豆角__豆角 162.86639759|dou jiao;
都叫__都叫 376.756940916|dou jiao;
豆浆__豆漿 582.750146437|dou jiang;
都将__都將 1361.57568978|dou jiang;
斗气__鬥氣 128.209578049|dou qi;
陡峭__陡峭 164.293322714|dou qiao;
都去__都去 883.576728645|dou qu;
都笑__都笑 125.678566729|dou xiao;
都像__都像 449.688850794|dou xiang;
都想__都想 1265.05905145|dou xiang;
都写__都寫 176.387781073|dou xie;
都行__都行 1165.17561047|dou xing;
都找__都找 333.860122955|dou zhao;
斗争__鬥爭 2280.86680445|dou zheng;
斗智__鬥智 165.939408926|dou zhi;
斗志__鬥志 489.456318842|dou zhi;
都穿__都穿 110.126966673|dou chuan;
都成__都成 294.376422496|dou cheng;
都吃__都吃 256.028470459|dou chi;
豆沙__豆沙 120.765453341|dou sha;
斗士__鬥士 270.122027271|dou shi;
都是__都是 91784.1080297|dou shi;
兜售__兜售 173.986383704|dou shou;
都说__都說 3488.59235612|dou shuo;
陡然__陡然 197.076837307|dou ran;
都让__都讓 299.1842072|dou rang;
都在__都在 11172.0800441|dou zai;
豆子__豆子 451.935995467|dou zi;
都走__都走 124.742372548|dou zou;
斗嘴__鬥嘴 124.431860131|dou zui;
都算__都算 257.94996962|dou suan;
豆芽__豆芽 195.852702213|dou ya;
都要__都要 10775.5425219|dou yao;
都以__都以 620.215410078|dou yi;
都已__都已 854.342048866|dou yi;
都应__都應 348.309611377|dou ying;
豆油__豆油 334.276427588|dou you;
都由__都由 373.019586361|dou you;
都有__都有 18391.4228339|dou you;
都用__都用 1137.91159836|dou yong;
都与__都與 175.073848088|dou yu;
都未__都未 143.605133321|dou wei;
都为__都為 204.584007193|dou wei;
窦唯__竇唯 290.0070692|dou wei;
都无__都無 114.46454262|dou wu;
都爱__都愛 168.439513167|dou ai;
斗殴__鬥毆 131.609045271|dou ou;
东北__東北 3712.87549557|dong bei;
动笔__動筆 152.647228173|dong bi;
东边__東邊 470.32215416|dong bian;
东部__東部 1469.11294508|dong bu;
东坡__東坡 181.064689688|dong po;
懂吗__懂嗎 121.520271774|dong ma;
动脉__動脈 528.772109212|dong mai;
动漫__動漫 2072.17903804|dong man;
东门__東門 569.823995046|dong men;
东盟__東盟 804.737106306|dong meng;
冬梅__冬梅 139.373782642|dong mei;
董秘__董秘 111.091824605|dong mi;
东面__東面 226.877563077|dong mian;
冬眠__冬眠 287.846772995|dong mian;
洞房__洞房 219.37092252|dong fang;
东方__東方 4617.64935026|dong fang;
东风__東風 1246.28210631|dong feng;
东大__東大 206.633773476|dong da;
动荡__動蕩 741.198640518|dong dang;
懂的__懂的 113.187937993|dong de;
冻得__凍得 152.267254161|dong de;
懂得__懂得 3863.92679211|dong de;
洞洞__洞洞 144.502706249|dong dong;
冬冬__冬冬 237.287502254|dong dong;
动动__動動 245.101601395|dong dong;
咚咚__咚咚 265.450260135|dong dong;
东东__東東 3712.87549557|dong dong;
动态__動態 5095.37328549|dong tai;
动弹__動彈 238.473254015|dong tan;
冬天__冬天 3816.07460972|dong tian;
洞庭__洞庭 161.250795044|dong ting;
动听__動聽 423.578945935|dong ting;
东南__東南 1194.58057905|dong nan;
动脑__動腦 115.755545596|dong nao;
动能__動能 286.772667017|dong neng;
动乱__動亂 236.696839161|dong luan;
懂了__懂了 375.351064872|dong le;
洞里__洞里 286.058823982|dong li;
动力__動力 5580.63786311|dong li;
栋梁__棟樑 188.196293023|dong liang;
东路__東路 754.243296976|dong lu;
冬瓜__冬瓜 471.495815538|dong gua;
东莞__東莞 2548.39656922|dong guan;
动感__動感 1078.5413133|dong gan;
动工__動工 410.07479966|dong gong;
动过__動過 258.271618599|dong guo;
洞口__洞口 393.553133755|dong kou;
东华__東華 256.028470459|dong hua;
动画__動畫 4290.32271274|dong hua;
东海__東海 927.579613097|dong hai;
东汉__東漢 259.885889675|dong han;
懂行__懂行 114.037415895|dong hang;
东航__東航 480.991159713|dong hang;
东湖__東湖 330.960471347|dong hu;
动机__動機 1249.39213028|dong ji;
冬季__冬季 1802.23954462|dong ji;
东家__東家 279.017397997|dong jia;
东郊__東郊 165.114314527|dong jiao;
东江__東江 135.098649108|dong jiang;
董洁__董潔 116.333988795|dong jie;
东街__東街 128.369448119|dong jie;
冻结__凍結 942.728934628|dong jie;
东晋__東晉 120.46484039|dong jin;
动静__動靜 1126.6237397|dong jing;
东京__東京 1877.89895902|dong jing;
动迁__動遷 190.318888971|dong qian;
动情__動情 331.37316028|dong qing;
东区__東區 363.837594448|dong qu;
洞穴__洞穴 370.240920313|dong xue;
洞悉__洞悉 140.419785869|dong xi;
东西__東西 77090.1765002|dong xi;
东线__東線 108.763116896|dong xian;
动向__動向 680.977550057|dong xiang;
东信__東信 109.442917312|dong xin;
动心__動心 480.392137969|dong xin;
东站__東站 201.296414343|dong zhan;
动辄__動輒 436.982903472|dong zhe;
东至__東至 110.677283245|dong zhi;
冬至__冬至 209.746993999|dong zhi;
东芝__東芝 717.56844134|dong zhi;
洞中__洞中 116.18910757|dong zhong;
董卓__董卓 171.617679695|dong zhuo;
冻疮__凍瘡 112.765574943|dong chuang;
洞察__洞察 238.770616634|dong cha;
动车__動車 133.591915611|dong che;
东城__東城 298.439468992|dong cheng;
东山__東山 360.677581637|dong shan;
动身__動身 187.027319083|dong shen;
东升__東升 189.608710238|dong sheng;
懂事__懂事 914.951259653|dong shi;
董事__董事 1346.39025518|dong shi;
动手__動手 1714.60618362|dong shou;
东软__東軟 317.230705235|dong ruan;
动人__動人 1203.54593192|dong ren;
冬日__冬日 383.865702254|dong ri;
动容__動容 167.184787749|dong rong;
动作__動作 8080.1830536|dong zuo;
东侧__東側 328.904723278|dong ce;
动词__動詞 556.490650127|dong ci;
冻死__凍死 247.249015706|dong si;
动员__動員 1258.76884501|dong yuan;
东亚__東亞 1014.65366219|dong ya;
东洋__東洋 131.773154284|dong yang;
东阳__東陽 174.855812809|dong yang;
动摇__動搖 825.045864155|dong yao;
动议__動議 105.0335283|dong yi;
动易__動易 215.040276584|dong yi;
动因__動因 156.89004718|dong yin;
东营__東營 219.644465616|dong ying;
动用__動用 822.992135502|dong yong;
动网__動網 251.914183226|dong wang;
动武__動武 121.975425508|dong wu;
东吴__東吳 213.971039752|dong wu;
动物__動物 5991.45670308|dong wu;
东安__東安 106.085879302|dong an;
东岸__東岸 117.792774542|dong an;
东欧__東歐 318.815941979|dong ou;
独霸__獨霸 117.646076559|du ba;
毒霸__毒霸 234.933657026|du ba;
独白__獨白 192.225730308|du bai;
督办__督辦 323.216307961|du ban;
杜邦__杜邦 115.899886195|du bang;
读本__讀本 159.452390871|du ben;
读博__讀博 184.251320835|du bo;
赌博__賭博 1432.95027783|du bo;
独步__獨步 121.368931601|du bu;
读盘__讀盤 111.925571131|du pan;
肚皮__肚皮 432.648119245|du pi;
毒品__毒品 979.860242923|du pin;
独门__獨門 137.134095104|du men;
镀膜__鍍膜 135.94305409|du mo;
毒贩__毒販 108.492380517|du fan;
杜甫__杜甫 279.713669565|du fu;
独大__獨大 116.044406778|du da;
毒打__毒打 254.755429543|du da;
督导__督導 441.361118731|du dao;
独到__獨到 474.442798491|du dao;
读到__讀到 666.702893247|du dao;
读得__讀得 155.915530766|du de;
肚兜__肚兜 113.32907693|du dou;
读懂__讀懂 362.479927203|du dong;
都督__都督 115.611384758|du du;
肚肚__肚肚 132.266710153|du du;
读读__讀讀 216.11485651|du du;
嘟嘟__嘟嘟 638.24912322|du du;
独特__獨特 4847.61227732|du te;
赌徒__賭徒 202.302314677|du tu;
嘟囔__嘟囔 159.055477247|du nang;
读来__讀來 120.164975734|du lai;
肚里__肚裡 161.250795044|du li;
独立__獨立 9255.76567882|du li;
度量__度量 321.609191441|du liang;
都灵__都靈 155.527421199|du ling;
毒瘤__毒瘤 116.044406778|du liu;
镀铬__鍍鉻 119.86585751|du ge;
独孤__獨孤 290.368691563|du gu;
渡过__渡過 521.573243485|du guo;
读过__讀過 720.256091319|du guo;
度过__度過 2261.05695403|du guo;
渡口__渡口 210.795122809|du kou;
毒害__毒害 291.093289619|du hai;
渡河__渡河 120.314814642|du he;
都会__都會 383.387639617|du hui;
杜鹃__杜鵑 282.516174301|du juan;
杜绝__杜絕 908.135681884|du jue;
督军__督軍 201.296414343|du jun;
妒忌__妒忌 324.426913464|du ji;
渡假__渡假 130.628674269|du jia;
度假__度假 936.87321059|du jia;
独家__獨家 1684.95202731|du jia;
渡江__渡江 106.483223576|du jiang;
堵截__堵截 131.117943492|du jie;
镀金__鍍金 192.705418355|du jin;
独居__獨居 123.504952812|du ju;
独具__獨具 239.963779681|du ju;
毒气__毒氣 146.314717429|du qi;
肚脐__肚臍 189.372573382|du qi;
赌气__賭氣 256.028470459|du qi;
赌球__賭球 205.094534596|du qiu;
读取__讀取 1993.6548615|du qu;
独显__獨顯 232.313479749|du xian;
独享__獨享 320.010065926|du xiang;
读写__讀寫 673.382717005|du xie;
镀锌__鍍鋅 139.72158175|du xin;
独行__獨行 227.160466527|du xing;
毒性__毒性 548.230802969|du xing;
杜撰__杜撰 183.563783354|du zhuan;
独占__獨佔 276.594068012|du zhan;
读着__讀着 141.826678552|du zhe;
读者__讀者 5395.99270938|du zhe;
渎职__瀆職 178.822323044|du zhi;
赌注__賭注 302.558594526|du zhu;
堵住__堵住 408.544597361|du zhu;
独创__獨創 276.249600432|du chuang;
督察__督察 297.696584607|du cha;
督查__督查 485.205278648|du cha;
独唱__獨唱 137.819369268|du chang;
赌场__賭場 688.658042404|du chang;
堵车__堵車 608.72971781|du che;
都城__都城 200.04606951|du cheng;
独处__獨處 249.415244207|du chu;
读出__讀出 385.303469841|du chu;
毒蛇__毒蛇 272.828431509|du she;
独身__獨身 193.186303435|du shen;
都是__都是 596.712660816|du shi;
都市__都市 2056.74313669|du shi;
读数__讀數 123.813152185|du shu;
度数__度數 225.187525865|du shu;
读书__讀書 6636.07200714|du shu;
度日__度日 198.555903198|du ri;
读入__讀入 168.229740225|du ru;
堵在__堵在 160.849404779|du zai;
独资__獨資 198.803491145|du zi;
独自__獨自 2341.34381449|du zi;
肚子__肚子 4295.67250177|du zi;
独奏__獨奏 156.109948588|du zou;
独坐__獨坐 116.915322539|du zuo;
独裁__獨裁 358.884197808|du cai;
督促__督促 1035.08753546|du cu;
堵塞__堵塞 133.42554153|du sai;
堵塞__堵塞 500.559372647|du se;
毒死__毒死 159.651218957|du si;
毒素__毒素 722.053448193|du su;
读研__讀研 503.060722916|du yan;
都要__都要 116.333988795|du yao;
毒药__毒藥 569.114341748|du yao;
读音__讀音 298.811606079|du yin;
都有__都有 184.251320835|du you;
独有__獨有 793.781168439|du you;
读完__讀完 680.129467195|du wan;
杜威__杜威 168.859844103|du wei;
独舞__獨舞 118.676811842|du wu;
毒物__毒物 127.096048509|du wu;
读物__讀物 295.847453874|du wu;
多吧__多吧 130.791560815|duo ba;
多半__多半 1230.8477252|duo ban;
多宝__多寶 120.916041011|duo bao;
躲避__躲避 798.742526514|duo bi;
多边__多邊 176.387781073|duo bian;
多变__多變 450.24958728|duo bian;
多部__多部 267.44247003|duo bu;
多篇__多篇 130.954650472|duo pian;
多玛__多瑪 120.164975734|duo ma;
多买__多買 206.89143407|duo mai;
多么__多麼 5463.65648792|duo me;
多美__多美 122.279808036|duo mei;
多米__多米 201.79873775|duo mi;
多名__多名 1672.40062475|duo ming;
夺目__奪目 219.918349804|duo mu;
多发__多發 486.416079992|duo fa;
多方__多方 948.621258606|duo fang;
多分__多分 152.457122789|duo fen;
多打__多打 133.259374649|duo da;
多达__多達 626.429466854|duo da;
多大__多大 5032.27045127|duo da;
多带__多帶 115.179978568|duo dai;
躲到__躲到 216.654158472|duo dao;
多得__多得 287.130256264|duo de;
夺得__奪得 1019.7239982|duo de;
多的__多的 1368.37963334|duo de;
多点__多點 1208.05380881|duo dian;
朵朵__朵朵 689.516759915|duo duo;
多多__多多 3177.31287701|duo duo;
堕胎__墮胎 205.350275845|duo tai;
多台__多台 243.882891747|duo tai;
多糖__多糖 197.814987883|duo tang;
多套__多套 162.056583012|duo tao;
多提__多提 129.171793682|duo ti;
多天__多天 312.911829085|duo tian;
多条__多條 394.535222541|duo tiao;
多听__多聽 105.295633316|duo ting;
多头__多頭 566.990680223|duo tou;
多难__多難 140.070248771|duo nan;
多年__多年 6235.20775378|duo nian;
多虑__多慮 116.47905068|duo lv;
多拉__多拉 105.0335283|duo la;
哆啦__哆啦 194.151676652|duo la;
多来__多來 253.804804573|duo lai;
多了__多了 8707.49819835|duo le;
多累__多累 126.149295342|duo lei;
多了__多了 126.621787068|duo liao;
多路__多路 150.569041974|duo lu;
堕落__墮落 1494.96846157|duo luo;
夺冠__奪冠 1292.14500531|duo guan;
多高__多高 664.215078095|duo gao;
多个__多個 6480.79417092|duo ge;
多给__多給 208.44415872|duo gei;
多国__多國 196.096919422|duo guo;
躲过__躲過 294.376422496|duo guo;
多款__多款 376.756940916|duo kuan;
多块__多塊 294.743493195|duo kuai;
躲开__躲開 342.712398751|duo kai;
多看__多看 457.033213363|duo kan;
多孔__多孔 108.087539034|duo kong;
多空__多空 247.249015706|duo kong;
多亏__多虧 321.208662461|duo kui;
多花__多花 290.368691563|duo hua;
多哈__多哈 252.228305921|duo ha;
多好__多好 2303.71924505|duo hao;
多喝__多喝 278.669912425|duo he;
多户__多戶 127.572086295|duo hu;
夺回__奪回 248.484546245|duo hui;
多级__多級 252.54282031|duo ji;
多加__多加 421.998352644|duo jia;
多家__多家 2092.94059602|duo jia;
多件__多件 110.126966673|duo jian;
多见__多見 530.752623218|duo jian;
多交__多交 111.230349808|duo jiao;
跺脚__跺腳 114.037415895|duo jiao;
夺金__奪金 152.647228173|duo jin;
躲进__躲進 154.754097942|duo jin;
多久__多久 6096.90278745|duo jiu;
多起__多起 175.292155245|duo qi;
多钱__多錢 899.127155009|duo qian;
多情__多情 1487.53508505|duo qing;
多去__多去 114.179614083|duo qu;
夺去__奪去 167.184787749|duo qu;
夺取__奪取 781.025384985|duo qu;
多选__多選 157.870654598|duo xuan;
多想__多想 587.855808729|duo xiang;
多项__多項 1229.31483934|duo xiang;
多写__多寫 120.765453341|duo xie;
多些__多些 480.991159713|duo xie;
多谢__多謝 4487.17778244|duo xie;
多心__多心 111.369047744|duo xin;
惰性__惰性 214.772467501|duo xing;
多赚__多賺 156.109948588|duo zhuan;
多张__多張 233.765505073|duo zhang;
躲着__躲着 249.104624871|duo zhe;
多只__多隻 134.42690308|duo zhi;
多钟__多鍾 224.347234118|duo zhong;
多重__多重 475.626742696|duo zhong;
多种__多種 5484.12059337|duo zhong;
多长__多長 1038.96445205|duo chang;
多吃__多吃 1059.88791463|duo chi;
多重__多重 346.577724349|duo chong;
多处__多處 461.61231651|duo chu;
多出__多出 585.662213047|duo chu;
多杀__多殺 182.423584067|duo sha;
躲闪__躲閃 219.644465616|duo shan;
多少__多少 47891.6067121|duo shao;
多食__多食 126.621787068|duo shi;
多事__多事 213.971039752|duo shi;
多时__多時 234.64107292|duo shi;
多是__多是 631.917817783|duo shi;
舵手__舵手 121.217779906|duo shou;
多收__多收 159.055477247|duo shou;
多数__多數 3859.11469501|duo shu;
多说__多說 977.421145723|duo shuo;
多睡__多睡 110.677283245|duo shui;
多人__多人 2451.8263702|duo ren;
多日__多日 213.438416689|duo ri;
堕入__墮入 105.295633316|duo ru;
躲在__躲在 1118.23138914|duo zai;
多则__多則 105.0335283|duo ze;
多姿__多姿 137.305093541|duo zi;
夺走__奪走 274.876014738|duo zou;
多做__多做 416.253137598|duo zuo;
多嘴__多嘴 113.046974828|duo zui;
多彩__多彩 505.574572707|duo cai;
躲藏__躲藏 167.810977762|duo cang;
多层__多層 521.573243485|duo ceng;
多次__多次 6266.36577307|duo ci;
哆嗦__哆嗦 326.048110451|duo suo;
多岁__多歲 614.062995519|duo sui;
多远__多遠 470.32215416|duo yuan;
多元__多元 1395.93711137|duo yuan;
多月__多月 1607.02198372|duo yue;
多云__多雲 268.109857044|duo yun;
多样__多樣 601.940653207|duo yang;
多页__多頁 116.47905068|duo ye;
多疑__多疑 135.098649108|duo yi;
多以__多以 192.705418355|duo yi;
多亿__多億 263.472890441|duo yi;
多有__多有 327.26932246|duo you;
多用__多用 400.479435488|duo yong;
多于__多於 665.872587905|duo yu;
多余__多餘 1959.1745514|duo yu;
多玩__多玩 195.60878915|duo wan;
多万__多萬 993.38448407|duo wan;
多问__多問 154.754097942|duo wen;
多维__多維 232.313479749|duo wei;
多位__多位 801.734213733|duo wei;
多为__多為 843.76158662|duo wei;
多啊__多啊 243.882891747|duo a;
多尔__多爾 111.369047744|duo er;
对白__對白 518.979844093|dui bai;
对本__對本 203.313241605|dui ben;
对比__對比 4284.97958628|dui bi;
对不__對不 353.117055307|dui bu;
对骂__對罵 143.247667161|dui ma;
对吗__對嗎 560.667124391|dui ma;
堆满__堆滿 191.98633424|dui man;
对么__對么 146.862738669|dui me;
对门__對門 173.553291634|dui men;
对美__對美 174.203334854|dui mei;
对面__對面 3572.17795663|dui mian;
堆放__堆放 253.804804573|dui fang;
对方__對方 14051.2652551|dui fang;
兑付__兌付 118.381397999|dui fu;
队服__隊服 134.930398555|dui fu;
对付__對付 2036.34065037|dui fu;
对待__對待 3820.83303827|dui dai;
对敌__對敵 113.753550575|dui di;
对对__對對 305.209408115|dui dui;
对它__對它 633.494731672|dui ta;
对她__對她 2067.02090848|dui ta;
对他__對他 3419.72334588|dui ta;
对台__對台 253.804804573|dui tai;
对头__對頭 601.940653207|dui tou;
队内__隊內 123.658956482|dui nei;
对内__對內 209.224885556|dui nei;
对你__對你 4195.15781018|dui ni;
对您__對您 220.467143161|dui nin;
对了__對了 9961.92669753|dui le;
堆里__堆里 199.548108896|dui li;
队里__隊里 252.54282031|dui li;
对立__對立 835.391638074|dui li;
对联__對聯 549.598880816|dui lian;
队列__隊列 652.727461906|dui lie;
对流__對流 154.754097942|dui liu;
对抗__對抗 1695.48345672|dui kang;
对口__對口 470.32215416|dui kou;
对华__對華 479.793862242|dui hua;
对话__對話 3996.1462733|dui hua;
兑换__兌換 2529.4132684|dui huan;
对决__對決 485.205278648|dui jue;
堆积__堆積 786.88699725|dui ji;
对家__對家 191.269933402|dui jia;
对价__對價 500.559372647|dui jia;
对焦__對焦 504.316081474|dui jiao;
兑奖__兌獎 176.168109435|dui jiang;
对接__對接 786.88699725|dui jie;
堆砌__堆砌 182.651055928|dui qi;
对齐__對齊 366.111682898|dui qi;
对其__對其 3406.96257996|dui qi;
兑现__兌現 908.135681884|dui xian;
对象__對象 11269.9622466|dui xiang;
对新__對新 383.387639617|dui xin;
对性__對性 113.895394799|dui xing;
队形__隊形 155.333728851|dui xing;
对准__對準 568.405572245|dui zhun;
堆栈__堆棧 210.270405333|dui zhan;
对战__對戰 506.83620443|dui zhan;
对账__對賬 336.365750338|dui zhang;
队长__隊長 3902.64021341|dui zhang;
对照__對照 1401.16558873|dui zhao;
对折__對摺 117.792774542|dui zhe;
对这__對這 566.284555508|dui zhe;
对着__對着 3072.18592933|dui zhe;
对阵__對陣 514.472385324|dui zhen;
对症__對症 191.98633424|dui zheng;
对峙__對峙 347.875829952|dui zhi;
队中__隊中 154.947067523|dui zhong;
对唱__對唱 119.56748386|dui chang;
对称__對稱 435.352293046|dui chen;
对称__對稱 335.946843682|dui cheng;
对冲__對沖 264.130371602|dui chong;
对视__對視 288.205701591|dui shi;
对手__對手 5429.71919857|dui shou;
对数__對數 105.0335283|dui shu;
对谁__對誰 147.964946673|dui shui;
对人__對人 676.747684543|dui ren;
对日__對日 167.393257695|dui ri;
对子__對子 139.026849285|dui zi;
对策__對策 2143.08680935|dui ce;
对此__對此 4107.21887886|dui ci;
对错__對錯 305.209408115|dui cuo;
队员__隊員 4127.74310357|dui yuan;
对呀__對呀 999.59341964|dui ya;
对已__對已 113.611883002|dui yi;
对伊__對伊 113.753550575|dui yi;
对应__對應 4716.51701742|dui ying;
队友__隊友 1425.82527204|dui you;
对于__對於 39578.1339227|dui yu;
对外__對外 3145.79455985|dui wai;
对我__對我 6329.14968985|dui wo;
队伍__隊伍 6250.76734939|dui wu;
对啊__對啊 1993.6548615|dui a;
对岸__對岸 296.216358865|dui an;
对俄__對俄 140.594881376|dui e;
团队__團隊 7507.4112927|tuan dui;
团团__團團 237.879639313|tuan tuan;
团体__團體 2280.86680445|tuan ti;
团里__團里 127.73116145|tuan li;
团购__團購 1465.45598554|tuan gou;
团伙__團伙 698.163048348|tuan huo;
团结__團結 2159.17072182|tuan jie;
团聚__團聚 421.472799973|tuan ju;
团长__團長 1093.42757174|tuan zhang;
团圆__團圓 304.070513117|tuan yuan;
团员__團員 563.46883971|tuan yuan;
团委__團委 503.688011099|tuan wei;
吞并__吞併 128.049907079|tun bing;
臀部__臀部 627.210588862|tun bu;
吞没__吞沒 120.615053212|tun mo;
吞吐__吞吐 192.465424888|tun tu;
囤积__囤積 259.238974004|tun ji;
吞下__吞下 177.048440864|tun xia;
吞食__吞食 109.989815613|tun shi;
吞噬__吞噬 459.317058623|tun shi;
吞咽__吞咽 122.584950132|tun yan;
踏板__踏板 457.603107852|ta ban;
踏步__踏步 124.742372548|ta bu;
它不__它不 387.22887368|ta bu;
她不__她不 826.074649543|ta bu;
他不__他不 1509.94683642|ta bu;
他妈__他媽 2937.40736593|ta ma;
它们__它們 13087.8059867|ta men;
她们__她們 13722.4788793|ta men;
他们__他們 156264.839256|ta men;
塌方__塌方 153.218967809|ta fang;
它的__它的 8805.70682985|ta de;
她的__她的 13401.3857951|ta de;
他的__他的 27030.0672583|ta de;
他对__他對 1889.63636164|ta dui;
他娘__他娘 262.162833911|ta niang;
它来__它來 173.337150041|ta lai;
他了__他了 164.293322714|ta le;
他俩__他倆 713.111292931|ta lia;
塔楼__塔樓 133.591915611|ta lou;
他国__他國 135.773751924|ta guo;
踏空__踏空 290.368691563|ta kong;
它还__它還 530.091629029|ta hai;
他和__他和 825.045864155|ta he;
他会__他會 1873.22443719|ta hui;
她家__她家 686.088301175|ta jia;
他家__他家 1326.40613196|ta jia;
它将__它將 497.450167612|ta jiang;
他将__他將 598.201722298|ta jiang;
踏进__踏進 236.402059204|ta jin;
它就__它就 611.771607197|ta jiu;
他就__他就 2985.38139212|ta jiu;
踏青__踏青 137.647730357|ta qing;
踏雪__踏雪 153.218967809|ta xue;
塌陷__塌陷 179.045304336|ta xian;
他乡__他鄉 317.230705235|ta xiang;
踏着__踏着 205.60633599|ta zhe;
他只__他只 271.133768339|ta zhi;
踏出__踏出 124.276893895|ta chu;
踏上__踏上 948.621258606|ta shang;
它使__它使 118.824795093|ta shi;
塌实__塌實 129.171793682|ta shi;
踏实__踏實 1119.62576025|ta shi;
她是__她是 2244.21407924|ta shi;
它是__它是 3364.76959766|ta shi;
他是__他是 5165.70071998|ta shi;
她说__她說 2955.76699744|ta shuo;
他说__他說 5902.52705689|ta shuo;
他人__他人 4242.4734338|ta ren;
踏入__踏入 377.226735448|ta ru;
他在__他在 4588.96700128|ta zai;
他总__他總 111.091824605|ta zong;
他所__他所 693.826435782|ta suo;
它也__它也 427.82286438|ta ye;
她也__她也 1336.36083843|ta ye;
他也__他也 2655.38023445|ta ye;
他有__他有 791.805264794|ta you;
他又__他又 1450.91895115|ta you;
太白__太白 184.71110921|tai bai;
台胞__台胞 136.622376491|tai bao;
太保__太保 248.175085992|tai bao;
太笨__太笨 118.381397999|tai ben;
台北__台北 1383.81307795|tai bei;
台币__台幣 337.205131359|tai bi;
太不__太不 771.352901218|tai bu;
胎盘__胎盤 260.859291326|tai pan;
太胖__太胖 105.295633316|tai pang;
太平__太平 743.048258297|tai ping;
太慢__太慢 1388.99614478|tai man;
太忙__太忙 746.761352211|tai mang;
太猛__太猛 184.941433485|tai meng;
太美__太美 178.59961945|tai mei;
太没__太沒 185.402943996|tai mei;
台面__檯面 370.702589737|tai mian;
台风__颱風 1712.47082965|tai feng;
台服__台服 779.081233415|tai fu;
太短__太短 395.027185582|tai duan;
泰达__泰達 376.756940916|tai da;
太大__太大 5269.73156102|tai da;
台灯__檯燈 321.208662461|tai deng;
太低__太低 1260.33845835|tai di;
台电__台電 184.941433485|tai dian;
泰斗__泰斗 121.217779906|tai dou;
胎动__胎動 131.609045271|tai dong;
台独__台獨 627.210588862|tai du;
态度__態度 9572.48817433|tai du;
太多__太多 14103.8942179|tai duo;
太太__太太 1813.50405438|tai tai;
泰坦__泰坦 189.845141544|tai tan;
抬头__抬頭 1553.85085374|tai tou;
台南__台南 186.794397067|tai nan;
太难__太難 771.352901218|tai nan;
太乱__太亂 193.90988203|tai luan;
太懒__太懶 106.748946222|tai lan;
太烂__太爛 262.817045902|tai lan;
太郎__太郎 243.275811214|tai lang;
太老__太老 199.051387821|tai lao;
泰勒__泰勒 183.563783354|tai le;
太冷__太冷 197.814987883|tai leng;
太累__太累 1188.64081012|tai lei;
太钢__太鋼 115.179978568|tai gang;
抬杠__抬杠 153.601316766|tai gang;
抬高__抬高 566.990680223|tai gao;
太高__太高 2261.05695403|tai gao;
太古__太古 132.10198647|tai gu;
太过__太過 1544.19916972|tai guo;
泰国__泰國 2255.42866395|tai guo;
太贵__太貴 1331.37418129|tai gui;
太快__太快 1301.84258129|tai kuai;
太空__太空 1465.45598554|tai kong;
太坏__太壞 156.109948588|tai huai;
台海__台海 444.673543393|tai hai;
太行__太行 126.937764318|tai hang;
太好__太好 2388.49559106|tai hao;
泰和__泰和 118.23396695|tai he;
太狠__太狠 194.151676652|tai hen;
太黑__太黑 192.705418355|tai hei;
太厚__太厚 105.821807183|tai hou;
太后__太后 488.846754671|tai hou;
太湖__太湖 630.344829195|tai hu;
台军__台軍 241.764712994|tai jun;
台机__台機 170.76435144|tai ji;
太急__太急 215.576896995|tai ji;
太极__太極 705.158077415|tai ji;
太假__太假 208.964318904|tai jia;
太监__太監 838.520594407|tai jian;
胎教__胎教 145.224802174|tai jiao;
台阶__台階 1293.75623683|tai jie;
太紧__太緊 248.794392378|tai jin;
太近__太近 328.904723278|tai jin;
太久__太久 1279.32718167|tai jiu;
抬举__抬舉 173.769702743|tai ju;
抬起__抬起 616.362966229|tai qi;
台前__台前 232.603161479|tai qian;
太强__太強 761.800204777|tai qiang;
台球__檯球 560.667124391|tai qiu;
台下__台下 637.454253928|tai xia;
太小__太小 1575.29743635|tai xiao;
太想__太想 134.930398555|tai xiang;
泰兴__泰興 107.550099352|tai xing;
太虚__太虛 109.170488754|tai xu;
台长__台長 157.67404401|tai zhang;
台帐__台帳 279.365316864|tai zhang;
抬着__抬着 129.655606164|tai zhe;
泰州__泰州 312.911829085|tai zhou;
台州__台州 593.745648473|tai zhou;
太重__太重 580.575602636|tai zhong;
太差__太差 1303.46590513|tai cha;
太长__太長 1143.59786783|tai chang;
太迟__太遲 180.613978088|tai chi;
太丑__太丑 168.020228531|tai chou;
太帅__太帥 202.302314677|tai shuai;
太傻__太傻 222.953710017|tai sha;
台山__台山 145.768741141|tai shan;
泰山__泰山 875.902662456|tai shan;
台商__台商 446.339066527|tai shang;
台上__台上 1226.25479235|tai shang;
太少__太少 1906.19207626|tai shao;
太深__太深 448.56947196|tai shen;
台式__台式 496.21189989|tai shi;
态势__態勢 1668.23763548|tai shi;
抬手__抬手 144.682892926|tai shou;
太瘦__太瘦 160.049619219|tai shou;
太守__太守 228.295612376|tai shou;
太热__太熱 596.712660816|tai re;
太弱__太弱 173.553291634|tai ruo;
太早__太早 662.561694208|tai zao;
台资__台資 142.180598718|tai zi;
台子__檯子 232.603161479|tai zi;
太子__太子 1197.56158489|tai zi;
太宗__太宗 140.419785869|tai zong;
太祖__太祖 161.451865638|tai zu;
太仓__太倉 232.313479749|tai cang;
台词__台詞 1081.23274995|tai ci;
泰森__泰森 107.416157498|tai sen;
太岁__太歲 164.498187167|tai sui;
太远__太遠 1427.60319527|tai yuan;
太原__太原 1456.35336279|tai yuan;
抬眼__抬眼 181.969489867|tai yan;
太阳__太陽 6545.72648682|tai yang;
太医__太醫 119.716577729|tai yi;
太有__太有 449.688850794|tai you;
太晚__太晚 1103.00744393|tai wan;
台湾__台灣 14405.870183|tai wan;
太爱__太愛 130.303509496|tai ai;
泰安__泰安 294.009808944|tai an;
胎儿__胎兒 1179.78648723|tai er;
坦白__坦白 719.359091341|tan bai;
探班__探班 133.093414711|tan ban;
摊薄__攤薄 111.230349808|tan bo;
摊牌__攤牌 115.755545596|tan pai;
摊派__攤派 119.121315407|tan pai;
谈判__談判 2922.80180368|tan pan;
探秘__探秘 145.587202159|tan mi;
探明__探明 175.292155245|tan ming;
摊贩__攤販 120.015323434|tan fan;
探访__探訪 260.209952636|tan fang;
坦荡__坦蕩 174.638049069|tan dang;
叹道__嘆道 123.351140937|tan dao;
谈到__談到 2280.86680445|tan dao;
谈得__談得 138.85370659|tan de;
探底__探底 226.312812713|tan di;
摊点__攤點 127.413209251|tan dian;
坍塌__坍塌 359.331706043|tan ta;
谈谈__談談 2175.37534439|tan tan;
探讨__探討 4957.57775917|tan tao;
忐忑__忐忑 196.096919422|tan te;
弹跳__彈跳 138.680779525|tan tiao;
探头__探頭 341.433560596|tan tou;
滩涂__灘涂 115.755545596|tan tu;
谈吐__談吐 188.665925845|tan tu;
贪图__貪圖 244.186999878|tan tu;
谈论__談論 1452.72816478|tan lun;
贪婪__貪婪 899.127155009|tan lan;
叹了__嘆了 558.574983827|tan le;
弹力__彈力 199.548108896|tan li;
贪恋__貪戀 115.179978568|tan lian;
探路__探路 142.713135632|tan lu;
贪官__貪官 900.248315564|tan guan;
探戈__探戈 140.770195218|tan ge;
谈过__談過 496.21189989|tan guo;
摊开__攤開 169.703655326|tan kai;
坦克__坦克 1476.45426414|tan ke;
谈话__談話 1978.80389582|tan hua;
瘫痪__癱瘓 682.676889633|tan huan;
弹簧__彈簧 566.284555508|tan huang;
谈好__談好 215.30841961|tan hao;
弹劾__彈劾 128.850255419|tan he;
谈及__談及 432.648119245|tan ji;
探究__探究 664.215078095|tan jiu;
叹气__嘆氣 453.628720089|tan qi;
谈起__談起 781.025384985|tan qi;
弹琴__彈琴 287.846772995|tan qin;
探亲__探親 372.555031371|tan qin;
探求__探求 166.146325956|tan qiu;
探寻__探尋 266.444503116|tan xun;
探析__探析 308.267359529|tan xi;
叹息__嘆息 800.735741689|tan xi;
探险__探險 534.069978074|tan xian;
摊销__攤銷 171.403948695|tan xiao;
谈笑__談笑 179.268563673|tan xiao;
谈心__談心 352.677286738|tan xin;
贪心__貪心 613.298247397|tan xin;
弹性__彈性 1655.81074036|tan xing;
探针__探針 168.229740225|tan zhen;
弹指__彈指 296.955549433|tan zhi;
摊主__攤主 162.258658377|tan zhu;
探查__探查 107.416157498|tan cha;
坦承__坦承 176.60772663|tan cheng;
坦诚__坦誠 524.179602378|tan cheng;
贪吃__貪吃 137.647730357|tan chi;
弹出__彈出 1768.86409398|tan chu;
坦率__坦率 296.955549433|tan shuai;
摊上__攤上 129.010924378|tan shang;
探视__探視 136.452228303|tan shi;
坦然__坦然 682.676889633|tan ran;
谈资__談資 109.579386421|tan zi;
毯子__毯子 173.337150041|tan zi;
摊子__攤子 229.150692759|tan zi;
坛子__罈子 398.48814637|tan zi;
弹奏__彈奏 249.415244207|tan zou;
探测__探測 1096.15615618|tan ce;
碳酸__碳酸 120.765453341|tan suan;
探索__探索 3849.50847217|tan suo;
坦言__坦言 736.594714048|tan yan;
贪欲__貪慾 122.432284019|tan yu;
贪玩__貪玩 229.722524886|tan wan;
探望__探望 464.497524783|tan wang;
摊位__攤位 449.128812644|tan wei;
贪污__貪污 743.048258297|tan wu;
汤姆__湯姆 321.609191441|tang mu;
烫发__燙髮 117.061109314|tang fa;
糖分__糖分 114.75018218|tang fen;
唐代__唐代 553.034030141|tang dai;
堂弟__堂弟 117.207077876|tang di;
堂堂__堂堂 313.69268222|tang tang;
糖糖__糖糖 326.861744407|tang tang;
唐突__唐突 123.658956482|tang tu;
螳螂__螳螂 183.563783354|tang lang;
糖类__糖類 138.335571213|tang lei;
堂哥__堂哥 109.852835359|tang ge;
塘沽__塘沽 220.467143161|tang gu;
糖果__糖果 727.472474808|tang guo;
堂课__堂課 130.141230764|tang ke;
唐骏__唐駿 105.0335283|tang jun;
唐家__唐家 124.431860131|tang jia;
糖浆__糖漿 133.259374649|tang jiang;
躺下__躺下 473.851932013|tang xia;
唐笑__唐笑 135.098649108|tang xiao;
躺着__躺着 803.734894488|tang zhe;
汤汁__湯汁 140.419785869|tang zhi;
堂主__堂主 106.616002115|tang zhu;
唐朝__唐朝 720.256091319|tang chao;
汤匙__湯匙 177.048440864|tang chi;
唐山__唐山 776.174076244|tang shan;
烫伤__燙傷 217.736803143|tang shang;
唐诗__唐詩 234.348853194|tang shi;
烫手__燙手 119.86585751|tang shou;
糖水__糖水 210.270405333|tang shui;
唐人__唐人 109.989815613|tang ren;
倘若__倘若 789.834279627|tang ruo;
躺在__躺在 2596.48046905|tang zai;
搪塞__搪塞 146.132498493|tang se;
唐僧__唐僧 647.865219539|tang seng;
唐宋__唐宋 156.304608838|tang song;
汤圆__湯圓 250.037645335|tang yuan;
汤唯__湯唯 468.567137655|tang wei;
淘宝__淘寶 5302.66888213|tao bao;
逃避__逃避 1613.0410787|tao bi;
逃跑__逃跑 978.639934443|tao pao;
逃命__逃命 200.545272755|tao ming;
讨伐__討伐 232.603161479|tao fa;
讨饭__討飯 105.821807183|tao fan;
逃犯__逃犯 148.704343794|tao fan;
套房__套房 588.588831574|tao fang;
逃到__逃到 238.176261728|tao dao;
淘汰__淘汰 2479.47960733|tao tai;
淘淘__淘淘 132.596773978|tao tao;
涛涛__濤濤 162.663565352|tao tao;
套套__套套 254.438159592|tao tao;
滔滔__滔滔 306.734573113|tao tao;
饕餮__饕餮 205.350275845|tao tie;
套头__套頭 125.522047856|tao tou;
逃脱__逃脫 579.130416613|tao tuo;
讨论__討論 15975.6804355|tao lun;
套牢__套牢 542.792461517|tao lao;
桃李__桃李 140.770195218|tao li;
套利__套利 416.772181646|tao li;
逃离__逃離 732.932171333|tao li;
套路__套路 427.82286438|tao lu;
套管__套管 154.561368684|tao guan;
讨个__討個 122.584950132|tao ge;
逃过__逃過 247.249015706|tao guo;
逃课__逃課 392.573489614|tao ke;
掏空__掏空 169.492308033|tao kong;
桃花__桃花 1682.85360433|tao hua;
讨好__討好 624.091932797|tao hao;
讨回__討回 167.184787749|tao hui;
套机__套機 170.977284899|tao ji;
套件__套件 462.187920882|tao jian;
讨教__討教 160.649084484|tao jiao;
淘金__淘金 247.557321202|tao jin;
陶器__陶器 130.954650472|tao qi;
淘气__淘氣 354.43965395|tao qi;
掏钱__掏錢 624.870140032|tao qian;
套现__套現 404.996293994|tao xian;
讨薪__討薪 123.658956482|tao xin;
套型__套型 112.625137786|tao xing;
套装__套裝 1795.51445179|tao zhuang;
讨债__討債 157.2815571|tao zhai;
套着__套着 124.122120652|tao zhe;
套住__套住 199.796934068|tao zhu;
逃出__逃出 367.482952871|tao chu;
掏出__掏出 1031.22508566|tao chu;
套上__套上 217.465635832|tao shang;
逃生__逃生 324.83145542|tao sheng;
套数__套數 116.47905068|tao shu;
桃树__桃樹 134.930398555|tao shu;
逃税__逃稅 108.357265155|tao shui;
套在__套在 177.490254874|tao zai;
套子__套子 259.238974004|tao zi;
桃子__桃子 798.742526514|tao zi;
逃走__逃走 393.063006485|tao zou;
陶醉__陶醉 630.344829195|tao zui;
逃窜__逃竄 121.823518492|tao cuan;
套餐__套餐 1718.88488289|tao can;
陶瓷__陶瓷 1205.04668542|tao ci;
桃园__桃園 217.19480623|tao yuan;
桃源__桃源 256.028470459|tao yuan;
讨厌__討厭 5998.9277097|tao yan;
讨要__討要 123.197520618|tao yao;
陶冶__陶冶 205.60633599|tao ye;
逃逸__逃逸 228.8653107|tao yi;
套用__套用 391.596284031|tao yong;
逃往__逃往 107.952927857|tao wang;
逃亡__逃亡 328.086003878|tao wang;
特别__特別 32102.0799214|te bie;
特派__特派 190.081867665|te pai;
特码__特碼 139.200207879|te ma;
特卖__特賣 136.452228303|te mai;
特大__特大 781.999279332|te da;
特地__特地 1081.23274995|te di;
特典__特典 387.711726118|te dian;
特点__特點 10187.9076561|te dian;
特定__特定 3277.85745623|te ding;
特多__特多 129.655606164|te duo;
特拉__特拉 136.112567367|te la;
特里__特里 237.583386308|te li;
特例__特例 238.473254015|te li;
特钢__特鋼 139.026849285|te gang;
特供__特供 123.351140937|te gong;
特工__特工 510.004074866|te gong;
特困__特困 292.912705474|te kun;
特快__特快 233.474375771|te kuai;
特刊__特刊 133.259374649|te kan;
特惠__特惠 198.555903198|te hui;
特辑__特輯 133.259374649|te ji;
特级__特級 205.862715427|te ji;
特技__特技 522.874798954|te ji;
特价__特價 1440.11088805|te jia;
特警__特警 248.175085992|te jing;
特权__特權 838.520594407|te quan;
特区__特區 655.172250234|te qu;
特效__特效 1075.85657625|te xiao;
特写__特寫 465.076726846|te xie;
特性__特性 3878.39911581|te xing;
特许__特許 372.555031371|te xu;
特征__特徵 5615.51843703|te zheng;
特指__特指 152.077621994|te zhi;
特制__特製 378.168082664|te zhi;
特质__特質 741.198640518|te zhi;
特种__特種 620.98878351|te zhong;
特产__特產 578.409173188|te chan;
特长__特長 745.831342837|te chang;
特设__特設 118.23396695|te she;
特使__特使 139.373782642|te shi;
特首__特首 106.218162376|te shou;
特殊__特殊 8377.53195835|te shu;
特此__特此 493.744603771|te ci;
特色__特色 6669.23318922|te se;
特约__特約 542.792461517|te yue;
特邀__特邀 319.611528482|te yao;
特异__特異 155.140277726|te yi;
特意__特意 1899.07908248|te yi;
特有__特有 1443.7046004|te you;
特务__特務 433.187606905|te wu;
特奥__特奧 122.432284019|te ao;
特尔__特爾 128.850255419|te er;
腾飞__騰飛 465.65665114|teng fei;
疼得__疼得 185.86560618|teng de;
疼痛__疼痛 2353.04376718|teng tong;
腾龙__騰龍 127.413209251|teng long;
腾空__騰空 142.357889859|teng kong;
腾讯__騰訊 2143.08680935|teng xun;
腾出__騰出 277.976239008|teng chu;
疼爱__疼愛 457.033213363|teng ai;
提拔__提拔 531.41444163|ti ba;
提笔__提筆 116.044406778|ti bi;
体表__體表 116.624293448|ti biao;
替补__替補 927.579613097|ti bu;
体魄__體魄 148.889769675|ti po;
体面__體面 345.715012791|ti mian;
提名__提名 1100.26180506|ti ming;
题目__題目 4387.64638002|ti mu;
体罚__體罰 138.508067822|ti fa;
提法__提法 277.976239008|ti fa;
替代__替代 1959.1745514|ti dai;
提单__提單 548.914415679|ti dan;
踢到__踢到 110.126966673|ti dao;
剃刀__剃刀 159.452390871|ti dao;
提到__提到 5165.70071998|ti dao;
体的__體的 112.34478795|ti de;
踢得__踢得 210.532600599|ti de;
提点__提點 181.064689688|ti dian;
梯度__梯度 250.037645335|ti du;
梯队__梯隊 210.008536601|ti dui;
替他__替他 418.333200332|ti ta;
体态__體態 205.60633599|ti tai;
体坛__體壇 211.321149687|ti tan;
提提__提提 181.290467084|ti ti;
梯田__梯田 123.197520618|ti tian;
体贴__體貼 932.214830498|ti tie;
剃头__剃頭 124.276893895|ti tou;
体能__體能 498.070459751|ti neng;
体内__體內 2658.69134296|ti nei;
替你__替你 560.667124391|ti ni;
体力__體力 1968.96476223|ti li;
提炼__提煉 518.333511609|ti lian;
体谅__體諒 709.565515965|ti liang;
提纲__提綱 505.574572707|ti gang;
提高__提高 26728.6052671|ti gao;
提个__提個 168.649547684|ti ge;
体格__體格 204.839111844|ti ge;
提供__提供 47772.3935032|ti gong;
提过__提過 439.166555128|ti guo;
提款__提款 128.689786556|ti kuan;
题库__題庫 260.859291326|ti ku;
替换__替換 1988.69219664|ti huan;
提货__提貨 418.854838101|ti huo;
体会__體會 5296.06498953|ti hui;
提及__提及 1083.93090293|ti ji;
体积__體積 1551.9157029|ti ji;
提价__提價 394.043872187|ti jia;
体检__體檢 1887.28302677|ti jian;
提交__提交 7080.33257395|ti jiao;
提起__提起 2106.02207003|ti qi;
提前__提前 8253.1864127|ti qian;
提请__提請 388.195180646|ti qing;
踢球__踢球 1296.98472971|ti qiu;
提取__提取 2318.11814557|ti qu;
体系__體系 8019.99283537|ti xi;
提现__提現 280.761336094|ti xian;
体现__體現 8019.99283537|ti xian;
体校__體校 122.432284019|ti xiao;
提携__提攜 137.991222203|ti xie;
梯形__梯形 136.452228303|ti xing;
体形__體形 285.346757867|ti xing;
题型__題型 347.00988711|ti xing;
体型__體型 506.204995518|ti xing;
提醒__提醒 6957.87804712|ti xing;
体恤__體恤 119.86585751|ti xu;
提着__提着 550.284199441|ti zhe;
提振__提振 146.497163581|ti zhen;
体征__體征 157.2815571|ti zheng;
体质__體質 1305.09125317|ti zhi;
体制__體制 3590.02852297|ti zhi;
体重__體重 2172.66615296|ti zhong;
提倡__提倡 1465.45598554|ti chang;
提车__提車 193.186303435|ti che;
提成__提成 1156.49608257|ti cheng;
踢出__踢出 216.384339476|ti chu;
剔除__剔除 429.425273358|ti chu;
提出__提出 21014.7425831|ti chu;
提上__提上 209.746993999|ti shang;
提神__提神 182.196395498|ti shen;
替身__替身 291.819695868|ti shen;
提升__提升 9608.34189386|ti sheng;
提示__提示 8905.02311996|ti shi;
替人__替人 116.769717326|ti ren;
提早__提早 578.409173188|ti zao;
蹄子__蹄子 106.085879302|ti zi;
梯子__梯子 239.068350048|ti zi;
体裁__體裁 161.854759309|ti cai;
体彩__體彩 195.60878915|ti cai;
题材__題材 2735.99686654|ti cai;
体操__體操 564.171453387|ti cao;
题词__題詞 180.839193473|ti ci;
提速__提速 710.450303909|ti su;
体验__體驗 6368.70867559|ti yan;
提要__提要 109.442917312|ti yao;
体液__體液 179.268563673|ti ye;
提议__提議 1359.87999657|ti yi;
体育__體育 4184.71509884|ti yu;
体外__體外 541.441326411|ti wai;
体温__體溫 741.198640518|ti wen;
提问__提問 1964.0635567|ti wen;
体位__體位 233.183609039|ti wei;
体味__體味 400.479435488|ti wei;
题为__題為 411.098117295|ti wei;
替我__替我 576.250827814|ti wo;
提案__提案 1071.84199596|ti an;
天宝__天寶 150.007190589|tian bao;
填报__填報 559.271495144|tian bao;
天边__天邊 388.195180646|tian bian;
填表__填表 242.36802267|tian biao;
填补__填補 660.912425973|tian bu;
甜品__甜品 191.747236314|tian pin;
天平__天平 525.487661863|tian ping;
天马__天馬 276.249600432|tian ma;
填满__填滿 233.474375771|tian man;
天门__天門 171.617679695|tian men;
甜美__甜美 859.681929668|tian mei;
甜蜜__甜蜜 1795.51445179|tian mi;
天命__天命 190.318888971|tian ming;
天明__天明 263.472890441|tian ming;
天分__天分 302.935867929|tian fen;
天府__天府 213.172602547|tian fu;
天赋__天賦 2681.98499671|tian fu;
天大__天大 451.373158744|tian da;
恬淡__恬淡 117.061109314|tian dan;
天道__天道 201.045721733|tian dao;
天的__天的 239.664931108|tian de;
天敌__天敵 163.272821143|tian di;
田地__田地 237.879639313|tian di;
天地__天地 2985.38139212|tian di;
甜点__甜點 195.365179853|tian dian;
天台__天台 331.37316028|tian tai;
天坛__天壇 226.030964922|tian tan;
天堂__天堂 3087.5379805|tian tang;
天体__天體 278.669912425|tian ti;
田田__田田 130.954650472|tian tian;
舔舔__舔舔 139.200207879|tian tian;
甜甜__甜甜 533.404852483|tian tian;
天天__天天 13284.9916911|tian tian;
天庭__天庭 135.098649108|tian ting;
甜头__甜頭 212.641966978|tian tou;
天哪__天哪 529.431458035|tian na;
天内__天內 487.02261325|tian nei;
添乱__添亂 162.258658377|tian luan;
天来__天來 113.187937993|tian lai;
天籁__天籟 451.373158744|tian lai;
天蓝__天藍 177.490254874|tian lan;
天冷__天冷 168.439513167|tian leng;
天雷__天雷 116.044406778|tian lei;
田里__田裡 177.490254874|tian li;
天理__天理 362.931919108|tian li;
填料__填料 137.134095104|tian liao;
天量__天量 107.818484324|tian liang;
田亮__田亮 510.004074866|tian liang;
天亮__天亮 796.754272909|tian liang;
天龙__天龍 560.667124391|tian long;
田螺__田螺 119.56748386|tian luo;
天高__天高 141.650048976|tian gao;
天宫__天宮 152.837570606|tian gong;
天国__天國 344.424970321|tian guo;
填空__填空 180.613978088|tian kong;
天空__天空 4710.6431127|tian kong;
天华__天華 107.015331962|tian hua;
天花__天花 207.666345181|tian hua;
天皇__天皇 318.418891685|tian huang;
天海__天海 105.0335283|tian hai;
填好__填好 239.664931108|tian hao;
天河__天河 737.513205869|tian he;
天黑__天黑 472.67240572|tian hei;
天后__天後 845.867144221|tian hou;
天机__天機 279.365316864|tian ji;
天极__天極 297.696584607|tian ji;
天际__天際 359.331706043|tian ji;
天价__天價 543.469292924|tian jia;
添加__添加 8707.49819835|tian jia;
田间__田間 472.67240572|tian jian;
天骄__天驕 181.290467084|tian jiao;
天降__天降 117.061109314|tian jiang;
天界__天界 146.862738669|tian jie;
天津__天津 7268.06705425|tian jin;
天井__天井 156.694657831|tian jing;
恬静__恬靜 206.633773476|tian jing;
田径__田徑 374.883606282|tian jing;
天就__天就 186.794397067|tian jiu;
天气__天氣 7331.74493768|tian qi;
天前__天前 150.194241046|tian qian;
天桥__天橋 459.889800938|tian qiao;
天晴__天晴 216.654158472|tian qing;
天青__天青 518.333511609|tian qing;
天下__天下 6235.20775378|tian xia;
天仙__天仙 274.191785204|tian xian;
天线__天線 1197.56158489|tian xian;
天香__天香 250.974160423|tian xiang;
天蝎__天蠍 578.409173188|tian xie;
填写__填寫 4349.53866663|tian xie;
甜心__甜心 135.267109459|tian xin;
天心__天心 146.314717429|tian xin;
天行__天行 141.650048976|tian xing;
天性__天性 647.058374454|tian xing;
天真__天真 1364.97342214|tian zhen;
天正__天正 118.08671951|tian zheng;
天之__天之 190.793818607|tian zhi;
添置__添置 203.820597887|tian zhi;
田中__田中 176.60772663|tian zhong;
天竺__天竺 108.763116896|tian zhu;
天柱__天柱 262.489736092|tian zhu;
天窗__天窗 280.411678639|tian chuang;
天朝__天朝 173.769702743|tian chao;
天秤__天秤 173.986383704|tian cheng;
天成__天成 245.407229187|tian cheng;
天池__天池 217.465635832|tian chi;
填充__填充 737.513205869|tian chong;
天山__天山 617.901063897|tian shan;
添上__添上 116.47905068|tian shang;
填上__填上 225.749468142|tian shang;
天上__天上 1799.9950529|tian shang;
天神__天神 284.991389772|tian shen;
天盛__天盛 125.992190229|tian sheng;
天生__天生 2213.66066021|tian sheng;
天时__天時 132.596773978|tian shi;
天师__天師 133.591915611|tian shi;
甜食__甜食 206.376433771|tian shi;
天使__天使 3722.14075882|tian shi;
天书__天書 196.096919422|tian shu;
天数__天數 543.469292924|tian shu;
天水__天水 275.218769535|tian shui;
天然__天然 2615.96711065|tian ran;
天热__天熱 302.558594526|tian re;
填入__填入 376.756940916|tian ru;
天灾__天災 291.093289619|tian zai;
天资__天資 107.14877401|tian zi;
天子__天子 466.237298568|tian zi;
天才__天才 2036.34065037|tian cai;
填词__填詞 143.605133321|tian ci;
天赐__天賜 232.603161479|tian ci;
天色__天色 346.577724349|tian se;
天元__天元 171.403948695|tian yuan;
田园__田園 441.911471008|tian yuan;
天崖__天崖 110.126966673|tian ya;
天涯__天涯 8482.58315054|tian ya;
田野__田野 450.811022973|tian ye;
天一__天一 235.519920202|tian yi;
天意__天意 431.571158705|tian yi;
天音__天音 250.037645335|tian yin;
天佑__天佑 207.666345181|tian you;
天娱__天娛 272.149298879|tian yu;
天宇__天宇 407.020105042|tian yu;
天外__天外 223.231720645|tian wai;
天网__天網 196.096919422|tian wang;
天王__天王 679.282440527|tian wang;
天文__天文 436.438689186|tian wen;
甜味__甜味 146.132498493|tian wei;
天威__天威 234.056997396|tian wei;
天啊__天啊 318.418891685|tian a;
天安__天安 125.992190229|tian an;
天鹅__天鵝 448.010827873|tian e;
跳板__跳板 177.933171406|tiao ban;
挑拨__挑撥 191.031727675|tiao bo;
调配__調配 397.991873082|tiao pei;
调皮__調皮 677.591550514|tiao pi;
调频__調頻 141.826678552|tiao pin;
条码__條碼 482.792710347|tiao ma;
条目__條目 530.752623218|tiao mu;
条幅__條幅 161.250795044|tiao fu;
调到__調到 315.653350706|tiao dao;
跳到__跳到 538.749137684|tiao dao;
跳得__跳得 183.563783354|tiao de;
调低__調低 273.509258874|tiao di;
挑逗__挑逗 512.55262135|tiao dou;
跳动__跳動 586.392500602|tiao dong;
挑剔__挑剔 724.757896749|tiao ti;
条条__條條 162.86639759|tiao tiao;
跳跳__跳跳 211.584655172|tiao tiao;
跳投__跳投 240.562595233|tiao tou;
跳了__跳了 493.744603771|tiao le;
条理__條理 286.415523108|tiao li;
调理__調理 665.043316617|tiao li;
条例__條例 1354.80557722|tiao li;
调料__調料 430.496878967|tiao liao;
跳楼__跳樓 868.29524729|tiao lou;
条路__條路 181.064689688|tiao lu;
跳高__跳高 113.753550575|tiao gao;
调高__調高 426.757915008|tiao gao;
跳过__跳過 542.11647303|tiao guo;
条款__條款 2318.11814557|tiao kuan;
调侃__調侃 577.688827991|tiao kan;
跳空__跳空 271.133768339|tiao kong;
调控__調控 2318.11814557|tiao kong;
调好__調好 180.389043185|tiao hao;
调和__調和 367.482952871|tiao he;
调剂__調劑 555.797602048|tiao ji;
调价__調價 414.183417482|tiao jia;
条件__條件 18437.317552|tiao jian;
调教__調教 494.9767145|tiao jiao;
调解__調解 987.214115061|tiao jie;
调节__調節 3782.93112802|tiao jie;
跳进__跳進 210.270405333|tiao jin;
跳起__跳起 172.475272126|tiao qi;
挑起__挑起 489.456318842|tiao qi;
调情__調情 316.83562918|tiao qing;
挑选__挑選 1910.94886689|tiao xuan;
调戏__調戲 606.458230719|tiao xi;
跳下__跳下 387.711726118|tiao xia;
跳线__跳線 272.828431509|tiao xian;
挑衅__挑釁 569.114341748|tiao xin;
调休__調休 169.070402749|tiao xiu;
跳转__跳轉 516.399339766|tiao zhuan;
挑战__挑戰 5924.63495045|tiao zhan;
挑着__挑着 114.46454262|tiao zhe;
跳着__跳着 173.769702743|tiao zhe;
调整__調整 20420.9715528|tiao zheng;
调至__調至 193.186303435|tiao zhi;
调制__調製 409.054029297|tiao zhi;
调成__調成 203.820597887|tiao cheng;
调处__調處 137.134095104|tiao chu;
挑出__挑出 190.318888971|tiao chu;
跳出__跳出 743.048258297|tiao chu;
跳上__跳上 165.939408926|tiao shang;
跳绳__跳繩 182.878811433|tiao sheng;
挑食__挑食 141.473639374|tiao shi;
调试__調試 2854.41099368|tiao shi;
条数__條數 151.699065864|tiao shu;
跳水__跳水 1241.63157975|tiao shui;
跳入__跳入 120.765453341|tiao ru;
跳蚤__跳蚤 393.063006485|tiao zao;
条子__條子 338.046607007|tiao zi;
跳槽__跳槽 1293.75623683|tiao cao;
跳伞__跳傘 121.823518492|tiao san;
调速__調速 145.224802174|tiao su;
条约__條約 576.969379906|tiao yue;
跳跃__跳躍 775.207436548|tiao yue;
调匀__調勻 119.86585751|tiao yun;
调养__調養 204.07475061|tiao yang;
眺望__眺望 239.664931108|tiao wang;
调温__調溫 109.716025699|tiao wen;
条文__條文 292.54791482|tiao wen;
条纹__條紋 379.584509838|tiao wen;
调味__調味 340.583654043|tiao wei;
跳舞__跳舞 2028.7420046|tiao wu;
贴吧__貼吧 714.89082038|tie ba;
铁板__鐵板 171.190483873|tie ban;
贴牌__貼牌 179.492101402|tie pai;
铁皮__鐵皮 235.813600182|tie pi;
贴片__貼片 175.948711373|tie pian;
铁门__鐵門 252.228305921|tie men;
贴膜__貼膜 283.574337601|tie mo;
贴到__貼到 237.583386308|tie dao;
铁道__鐵道 283.927938713|tie dao;
铁定__鐵定 307.883446338|tie ding;
铁塔__鐵塔 181.516526012|tie ta;
铁通__鐵通 685.233853433|tie tong;
贴图__貼圖 1024.81967123|tie tu;
铁链__鐵鏈 135.604660605|tie lian;
铁岭__鐵嶺 142.535402072|tie ling;
铁路__鐵路 3612.46722234|tie lu;
铁杆__鐵杆 290.0070692|tie gan;
铁锅__鐵鍋 118.23396695|tie guo;
铁轨__鐵軌 175.729586548|tie gui;
铁矿__鐵礦 324.426913464|tie kuang;
贴合__貼合 118.381397999|tie he;
铁甲__鐵甲 110.95347192|tie jia;
铁匠__鐵匠 354.43965395|tie jiang;
贴近__貼近 912.673735821|tie jin;
铁骑__鐵騎 112.34478795|tie qi;
贴切__貼切 438.619621343|tie qie;
铁血__鐵血 300.679263607|tie xue;
贴息__貼息 178.822323044|tie xi;
贴现__貼現 139.72158175|tie xian;
贴心__貼心 491.289575698|tie xin;
贴着__貼着 466.237298568|tie zhe;
贴纸__貼紙 287.130256264|tie zhi;
贴出__貼出 406.006938516|tie chu;
铁锤__鐵鎚 132.762114633|tie chui;
贴上__貼上 638.24912322|tie shang;
贴身__貼身 480.392137969|tie shen;
铁人__鐵人 143.247667161|tie ren;
贴在__貼在 726.566487616|tie zai;
贴子__貼子 1782.13945694|tie zi;
帖子__帖子 13654.247104|tie zi;
铁丝__鐵絲 189.136730609|tie si;
挺拔__挺拔 276.938965124|ting ba;
停播__停播 116.915322539|ting bo;
停泊__停泊 157.085680168|ting bo;
听不__聽不 261.510250403|ting bu;
停牌__停牌 1128.02857559|ting pai;
停盘__停盤 157.085680168|ting pan;
挺忙__挺忙 248.794392378|ting mang;
停放__停放 301.805456692|ting fang;
听风__聽風 146.862738669|ting feng;
霆锋__霆鋒 193.427195796|ting feng;
停顿__停頓 523.526794166|ting dun;
挺大__挺大 502.434215952|ting da;
听到__聽到 10589.1792478|ting dao;
听得__聽得 1276.14264248|ting de;
停电__停電 1041.55712696|ting dian;
停掉__停掉 147.596627936|ting diao;
听懂__聽懂 624.091932797|ting dong;
挺多__挺多 905.87512359|ting duo;
听她__聽她 311.355949144|ting ta;
听他__聽他 556.490650127|ting ta;
厅堂__廳堂 124.742372548|ting tang;
停停__停停 184.251320835|ting ting;
婷婷__婷婷 696.425160166|ting ting;
听听__聽聽 2606.20557717|ting ting;
听筒__聽筒 139.895806636|ting tong;
挺难__挺難 160.449013667|ting nan;
听你__聽你 696.425160166|ting ni;
听来__聽來 236.107646363|ting lai;
挺累__挺累 136.112567367|ting lei;
挺立__挺立 126.937764318|ting li;
厅里__廳里 143.784200776|ting li;
听力__聽力 1235.45786087|ting li;
停留__停留 2784.14878864|ting liu;
挺高__挺高 261.184568064|ting gao;
听歌__聽歌 1085.28250327|ting ge;
停工__停工 274.876014738|ting gong;
听过__聽過 2606.20557717|ting guo;
挺贵__挺貴 136.282292017|ting gui;
挺快__挺快 446.339066527|ting kuai;
停靠__停靠 291.093289619|ting kao;
停课__停課 112.906187218|ting ke;
听课__聽課 587.855808729|ting ke;
听话__聽話 1496.83260243|ting hua;
挺好__挺好 5172.14205573|ting hao;
听后__聽后 237.583386308|ting hou;
停火__停火 142.713135632|ting huo;
听觉__聽覺 365.20034683|ting jue;
停机__停機 869.377962205|ting ji;
听见__聽見 3022.81698484|ting jian;
听讲__聽講 251.600451735|ting jiang;
挺进__挺進 327.677408739|ting jin;
挺起__挺起 125.36572391|ting qi;
庭前__庭前 110.815291538|ting qian;
听清__聽清 108.087539034|ting qing;
听取__聽取 1476.45426414|ting qu;
停下__停下 782.974388071|ting xia;
听写__聽寫 121.217779906|ting xie;
停歇__停歇 140.419785869|ting xie;
听信__聽信 152.267254161|ting xin;
厅长__廳長 681.82669043|ting zhang;
停着__停着 120.164975734|ting zhe;
挺着__挺着 146.314717429|ting zhe;
听者__聽者 177.269210225|ting zhe;
听着__聽着 2026.2154289|ting zhe;
听证__聽證 455.327784806|ting zheng;
停职__停職 108.492380517|ting zhi;
挺直__挺直 181.516526012|ting zhi;
停滞__停滯 430.496878967|ting zhi;
停止__停止 5269.73156102|ting zhi;
听众__聽眾 835.391638074|ting zhong;
挺住__挺住 167.601987591|ting zhu;
停住__停住 312.522131716|ting zhu;
停产__停產 768.474582473|ting chan;
停车__停車 1509.94683642|ting che;
听出__聽出 246.019628549|ting chu;
挺爽__挺爽 137.305093541|ting shuang;
庭审__庭審 409.054029297|ting shen;
听说__聽說 11626.5949283|ting shuo;
停水__停水 207.149415951|ting shui;
听人__聽人 191.269933402|ting ren;
停在__停在 878.088426229|ting zai;
亭子__亭子 169.703655326|ting zi;
听从__聽從 392.573489614|ting cong;
听错__聽錯 125.209594649|ting cuo;
停赛__停賽 160.249192015|ting sai;
挺远__挺遠 105.953760973|ting yuan;
庭院__庭院 511.914293268|ting yuan;
停运__停運 117.499561272|ting yun;
停药__停葯 204.839111844|ting yao;
停业__停業 172.905674062|ting ye;
停用__停用 328.495108513|ting yong;
听雨__聽雨 268.109857044|ting yu;
听完__聽完 619.442999798|ting wan;
听闻__聽聞 220.467143161|ting wen;
听我__聽我 576.969379906|ting wo;
头版__頭版 235.519920202|tou ban;
头孢__頭孢 145.224802174|tou bao;
投保__投保 505.574572707|tou bao;
投奔__投奔 281.461959558|tou ben;
投标__投標 1157.93816758|tou biao;
头部__頭部 1440.11088805|tou bu;
偷拍__偷拍 1071.84199596|tou pai;
头皮__頭皮 487.62990282|tou pi;
投票__投票 3792.371211|tou piao;
透明__透明 3137.96395466|tou ming;
头目__頭目 367.482952871|tou mu;
头发__頭髮 6282.00312169|tou fa;
投放__投放 1647.57761372|tou fang;
头大__頭大 359.779772295|tou da;
头戴__頭戴 201.79873775|tou dai;
投档__投檔 146.497163581|tou dang;
投到__投到 134.42690308|tou dao;
偷盗__偷盜 185.172044961|tou dao;
投递__投遞 368.399985048|tou di;
透顶__透頂 173.337150041|tou ding;
头顶__頭頂 1042.85588961|tou ding;
偷渡__偷渡 215.845709156|tou du;
投胎__投胎 224.347234118|tou tai;
头疼__頭疼 1569.41918253|tou teng;
头天__頭天 114.46454262|tou tian;
头条__頭條 515.113903202|tou tiao;
偷听__偷聽 140.594881376|tou ting;
头头__頭頭 314.083839199|tou tou;
偷偷__偷偷 2593.24683736|tou tou;
头痛__頭痛 1465.45598554|tou tong;
头脑__頭腦 2111.27752471|tou nao;
头牛__頭牛 118.529012887|tou niu;
偷来__偷來 115.467403456|tou lai;
头来__頭來 424.635962376|tou lai;
投篮__投籃 559.968874971|tou lan;
偷懒__偷懶 807.751246202|tou lan;
透了__透了 333.029068427|tou le;
透亮__透亮 114.46454262|tou liang;
头领__頭領 114.037415895|tou ling;
透漏__透漏 114.179614083|tou lou;
头颅__頭顱 361.12732612|tou lu;
透露__透露 6021.39667155|tou lu;
投稿__投稿 722.953807881|tou gao;
头骨__頭骨 156.499511818|tou gu;
透过__透過 1889.63636164|tou guo;
偷看__偷看 441.361118731|tou kan;
投靠__投靠 252.228305921|tou kao;
头盔__頭盔 514.472385324|tou kui;
偷窥__偷窺 598.201722298|tou kui;
头昏__頭昏 130.791560815|tou hun;
投行__投行 486.416079992|tou hang;
头号__頭號 455.895552723|tou hao;
投机__投機 1481.9843182|tou ji;
头奖__頭獎 106.616002115|tou jiang;
投进__投進 125.678566729|tou jin;
头巾__頭巾 186.794397067|tou jin;
透镜__透鏡 149.075426771|tou jing;
透气__透氣 297.696584607|tou qi;
偷窃__偷竊 200.04606951|tou qie;
偷情__偷情 411.610733326|tou qing;
头球__頭球 508.734557585|tou qiu;
透析__透析 269.785619908|tou xi;
偷袭__偷襲 563.46883971|tou xi;
投下__投下 167.810977762|tou xia;
头先__頭先 201.79873775|tou xian;
头衔__頭銜 631.917817783|tou xian;
偷笑__偷笑 299.93080386|tou xiao;
投向__投向 593.006203378|tou xiang;
投降__投降 750.493000864|tou xiang;
头像__頭像 3971.32436646|tou xiang;
头绪__頭緒 362.028498203|tou xu;
偷着__偷着 143.784200776|tou zhe;
透着__透着 486.416079992|tou zhe;
投掷__投擲 190.318888971|tou zhi;
透支__透支 696.425160166|tou zhi;
投中__投中 138.85370659|tou zhong;
投注__投注 655.989212862|tou zhu;
投产__投產 1103.00744393|tou chan;
透彻__透徹 537.40806734|tou che;
偷吃__偷吃 184.71110921|tou chi;
透出__透出 394.043872187|tou chu;
头上__頭上 2545.22282076|tou shang;
投射__投射 234.056997396|tou she;
投身__投身 606.458230719|tou shen;
头饰__頭飾 131.117943492|tou shi;
透视__透視 659.267263146|tou shi;
偷税__偷稅 113.753550575|tou shui;
投入__投入 9974.34865498|tou ru;
头子__頭子 205.862715427|tou zi;
投资__投資 24132.2398279|tou zi;
偷走__偷走 212.907119447|tou zou;
头寸__頭寸 189.136730609|tou cun;
投诉__投訴 4799.5249195|tou su;
投缘__投緣 113.47039186|tou yuan;
头晕__頭暈 952.17431607|tou yun;
头也__頭也 176.60772663|tou ye;
投影__投影 745.831342837|tou ying;
投案__投案 108.357265155|tou an;
头儿__頭兒 206.89143407|tou er;
铜板__銅板 107.282382453|tong ban;
同班__同班 194.151676652|tong ban;
同伴__同伴 880.279644448|tong ban;
通宝__通寶 119.56748386|tong bao;
同胞__同胞 1619.08271818|tong bao;
通报__通報 1721.02823483|tong bao;
同比__同比 1255.63548024|tong bi;
通便__通便 114.179614083|tong bian;
通病__通病 273.509258874|tong bing;
同步__同步 4360.39268552|tong bu;
铜牌__銅牌 196.096919422|tong pai;
通篇__通篇 148.519148841|tong pian;
痛骂__痛罵 143.247667161|tong ma;
同埋__同埋 120.916041011|tong mai;
同门__同門 176.60772663|tong men;
同盟__同盟 498.070459751|tong meng;
同名__同名 648.673070715|tong ming;
同房__同房 159.452390871|tong fang;
同方__同方 277.630050085|tong fang;
痛风__痛風 131.609045271|tong feng;
通风__通風 826.074649543|tong feng;
通达__通達 263.801426189|tong da;
同道__同道 184.02185602|tong dao;
通道__通道 3377.37232991|tong dao;
痛得__痛得 202.554574186|tong de;
同等__同等 882.476330723|tong deng;
通电__通電 318.022335873|tong dian;
同台__同台 281.111429553|tong tai;
通体__通體 134.762357541|tong ti;
通天__通天 173.769702743|tong tian;
通透__通透 256.987424161|tong tou;
童童__童童 136.112567367|tong tong;
通通__通通 397.991873082|tong tong;
统统__統統 1055.93292173|tong tong;
同年__同年 552.345286903|tong nian;
童年__童年 1662.01257345|tong nian;
同乐__同樂 291.456266438|tong le;
同类__同類 1431.1656954|tong lei;
同理__同理 183.792676978|tong li;
铜陵__銅陵 145.587202159|tong ling;
通灵__通靈 185.172044961|tong ling;
同龄__同齡 302.181790975|tong ling;
统领__統領 379.111778956|tong ling;
通路__通路 383.865702254|tong lu;
通络__通絡 137.819369268|tong luo;
通关__通關 636.660374558|tong guan;
痛感__痛感 105.953760973|tong gan;
同感__同感 744.902491688|tong gan;
通告__通告 815.844260376|tong gao;
童工__童工 145.405889264|tong gong;
通过__通過 56313.9287309|tong guo;
铜矿__銅礦 227.443722742|tong kuang;
痛快__痛快 874.811821743|tong kuai;
统考__統考 215.040276584|tong kao;
瞳孔__瞳孔 227.443722742|tong kong;
痛哭__痛哭 435.352293046|tong ku;
痛苦__痛苦 9050.46083396|tong ku;
通化__通化 123.658956482|tong hua;
同化__同化 244.491487214|tong hua;
童话__童話 1432.95027783|tong hua;
通话__通話 1515.60233678|tong hua;
通航__通航 210.008536601|tong hang;
同行__同行 1662.01257345|tong hang;
同好__同好 146.314717429|tong hao;
痛恨__痛恨 555.797602048|tong hen;
通红__通紅 283.221176861|tong hong;
同伙__同夥 221.568841736|tong huo;
通缉__通緝 338.468131949|tong ji;
同级__同級 611.771607197|tong ji;
同济__同濟 683.528148986|tong ji;
统计__統計 9937.12917391|tong ji;
铜价__銅價 213.704562287|tong jia;
痛经__痛經 262.162833911|tong jing;
同居__同居 1036.37823089|tong ju;
通气__通氣 221.845125512|tong qi;
同期__同期 1553.85085374|tong qi;
铜钱__銅錢 129.332863581|tong qian;
同情__同情 2473.3076131|tong qing;
童趣__童趣 121.671800659|tong qu;
同去__同去 201.547419552|tong qu;
同学__同學 29715.1941105|tong xue;
通讯__通訊 2875.83340941|tong xun;
同喜__同喜 125.835280772|tong xi;
通宵__通宵 1981.27135202|tong xiao;
桐乡__桐鄉 115.899886195|tong xiang;
铜像__銅像 153.792848894|tong xiang;
同乡__同鄉 274.533686805|tong xiang;
通向__通向 400.978810625|tong xiang;
童心__童心 212.907119447|tong xin;
同心__同心 254.121284766|tong xin;
痛心__痛心 436.982903472|tong xin;
通信__通信 4503.98449045|tong xin;
同性__同性 611.009712747|tong xing;
同行__同行 808.758466182|tong xing;
通行__通行 878.088426229|tong xing;
通许__通許 169.28122395|tong xu;
童装__童裝 273.509258874|tong zhuang;
统战__統戰 114.607273411|tong zhan;
通胀__通脹 757.068312494|tong zhang;
童真__童真 120.164975734|tong zhen;
统治__統治 1771.06976716|tong zhi;
同志__同志 9232.72595217|tong zhi;
通知__通知 15896.2451492|tong zhi;
通州__通州 463.919044053|tong zhou;
同种__同種 128.529517539|tong zhong;
同住__同住 253.173026121|tong zhu;
同桌__同桌 522.874798954|tong zhuo;
同窗__同窗 157.67404401|tong chuang;
通畅__通暢 375.819106356|tong chang;
通常__通常 7479.39723763|tong chang;
通车__通車 569.114341748|tong che;
统称__統稱 242.972837869|tong cheng;
同城__同城 485.205278648|tong cheng;
痛斥__痛斥 128.049907079|tong chi;
通吃__通吃 284.636464248|tong chi;
统筹__統籌 1008.35118051|tong chou;
痛楚__痛楚 341.008342538|tong chu;
通顺__通順 135.267109459|tong shun;
统帅__統帥 228.580284053|tong shuai;
同上__同上 464.497524783|tong shang;
痛失__痛失 124.742372548|tong shi;
同是__同是 290.368691563|tong shi;
同事__同事 13434.8281681|tong shi;
同时__同時 39627.4856104|tong shi;
同属__同屬 205.862715427|tong shu;
同人__同人 437.527796363|tong ren;
同仁__同仁 557.879339939|tong ren;
同日__同日 230.870473623|tong ri;
同在__同在 353.998238229|tong zai;
童子__童子 257.3078729|tong zi;
筒子__筒子 382.910172354|tong zi;
通俗__通俗 625.649317648|tong su;
同源__同源 125.053659829|tong yuan;
同月__同月 143.426288875|tong yue;
同样__同樣 14316.3886818|tong yang;
童谣__童謠 130.46599058|tong yao;
铜业__銅業 132.10198647|tong ye;
同业__同業 266.776744296|tong ye;
同一__同一 3996.1462733|tong yi;
同意__同意 11860.7402097|tong yi;
统一__統一 12220.829103|tong yi;
通用__通用 2854.41099368|tong yong;
同于__同於 427.82286438|tong yu;
通往__通往 736.594714048|tong wang;
同为__同為 357.545014261|tong wei;
同屋__同屋 135.098649108|tong wu;
突变__突變 415.734739962|tu bian;
图表__圖表 1383.81307795|tu biao;
图标__圖標 3015.29249908|tu biao;
土鳖__土鱉 161.854759309|tu bie;
徒步__徒步 582.024395035|tu bu;
图片__圖片 20218.3995421|tu pian;
突破__突破 7451.48771757|tu po;
图谱__圖譜 191.031727675|tu pu;
涂抹__塗抹 688.658042404|tu mo;
图谋__圖謀 152.457122789|tu mou;
土木__土木 227.443722742|tu mu;
突发__突發 939.211122794|tu fa;
土方__土方 157.2815571|tu fang;
土匪__土匪 529.431458035|tu fei;
屠夫__屠夫 310.194118206|tu fu;
徒弟__徒弟 1199.05487625|tu di;
土地__土地 7832.33255491|tu di;
土豆__土豆 1806.7369278|tu dou;
图腾__圖騰 598.94764591|tu teng;
秃头__禿頭 135.098649108|tu tou;
吐吐__吐吐 123.197520618|tu tu;
图图__圖圖 240.263000901|tu tu;
兔兔__兔兔 502.434215952|tu tu;
徒劳__徒勞 232.893204426|tu lao;
吐了__吐了 465.65665114|tu le;
土里__土裡 109.852835359|tu li;
图例__圖例 376.756940916|tu li;
涂料__塗料 807.751246202|tu liao;
屠龙__屠龍 146.862738669|tu long;
吐露__吐露 136.452228303|tu lu;
图个__圖個 163.069482749|tu ge;
图库__圖庫 429.425273358|tu ku;
图画__圖畫 405.501301397|tu hua;
突厥__突厥 151.888225993|tu jue;
图集__圖集 199.796934068|tu ji;
突击__突擊 747.692521253|tu ji;
土建__土建 290.730764849|tu jian;
图解__圖解 247.249015706|tu jie;
图景__圖景 132.927661458|tu jing;
途经__途經 305.209408115|tu jing;
途径__途徑 3402.71958168|tu jing;
凸起__凸起 154.754097942|tu qi;
突起__突起 246.019628549|tu qi;
吐血__吐血 695.557838999|tu xue;
突袭__突襲 290.730764849|tu xi;
突显__突顯 228.295612376|tu xian;
凸现__凸現 403.988165198|tu xian;
凸显__凸顯 699.033618062|tu xian;
图象__圖象 476.813641365|tu xiang;
图像__圖像 3750.07550505|tu xiang;
吐血__吐血 112.625137786|tu xie;
土星__土星 179.492101402|tu xing;
图形__圖形 2143.08680935|tu xing;
涂装__塗裝 177.269210225|tu zhuang;
图纸__圖紙 1637.34374958|tu zhi;
图中__圖中 625.649317648|tu zhong;
途中__途中 1397.67776576|tu zhong;
土著__土著 283.221176861|tu zhu;
凸出__凸出 110.815291538|tu chu;
吐出__吐出 507.468200425|tu chu;
突出__突出 6392.5626507|tu chu;
屠杀__屠殺 651.914561431|tu sha;
涂上__塗上 326.454673948|tu shang;
图示__圖示 245.407229187|tu shi;
徒手__徒手 110.401782066|tu shou;
图书__圖書 2258.24105554|tu shu;
突然__突然 17871.773638|tu ran;
土壤__土壤 1718.88488289|tu rang;
土人__土人 269.785619908|tu ren;
突入__突入 142.357889859|tu ru;
涂在__塗在 180.164388413|tu zai;
屠宰__屠宰 297.696584607|tu zai;
秃子__禿子 160.649084484|tu zi;
兔子__兔子 2963.1429408|tu zi;
涂层__塗層 375.351064872|tu ceng;
图层__圖層 500.559372647|tu ceng;
土司__土司 110.401782066|tu si;
涂鸦__塗鴉 490.066643104|tu ya;
图样__圖樣 220.19257551|tu yang;
图文__圖文 584.204365283|tu wen;
突围__突圍 330.136634719|tu wei;
图为__圖為 644.643863216|tu wei;
突兀__突兀 296.955549433|tu wu;
途安__途安 121.368931601|tu an;
图案__圖案 1718.88488289|tu an;
拖把__拖把 159.651218957|tuo ba;
驼背__駝背 116.333988795|tuo bei;
托盘__托盤 397.496217848|tuo pan;
脱皮__脫皮 180.164388413|tuo pi;
脱贫__脫貧 151.321452046|tuo pin;
拓扑__拓撲 338.046607007|tuo pu;
脱毛__脫毛 144.502706249|tuo mao;
脱敏__脫敏 170.76435144|tuo min;
唾沫__唾沫 180.164388413|tuo mo;
脱发__脫髮 323.619340361|tuo fa;
托付__託付 229.150692759|tuo fu;
托福__托福 500.559372647|tuo fu;
妥当__妥當 375.819106356|tuo dang;
拖到__拖到 513.831666385|tuo dao;
拖地__拖地 152.267254161|tuo di;
托蒂__托蒂 226.030964922|tuo di;
脱掉__脫掉 427.290057918|tuo diao;
拖动__拖動 387.711726118|tuo dong;
拖沓__拖沓 147.596627936|tuo ta;
脱脱__脫脫 110.126966673|tuo tuo;
托尼__托尼 245.407229187|tuo ni;
鸵鸟__鴕鳥 205.60633599|tuo niao;
拖拉__拖拉 187.961915178|tuo la;
脱了__脫了 506.83620443|tuo le;
拖累__拖累 483.394725468|tuo lei;
脱离__脫離 2145.75911703|tuo li;
脱硫__脫硫 205.350275845|tuo liu;
陀螺__陀螺 162.86639759|tuo luo;
脱落__脫落 746.761352211|tuo luo;
托管__託管 1142.1736421|tuo guan;
脱光__脫光 299.557272934|tuo guang;
拓宽__拓寬 782.974388071|tuo kuan;
拓荒__拓荒 110.401782066|tuo huang;
脱机__脫機 354.43965395|tuo ji;
脱节__脫節 282.164331387|tuo jie;
托起__托起 186.561765129|tuo qi;
唾弃__唾棄 230.295783987|tuo qi;
拖欠__拖欠 700.778015498|tuo qian;
脱去__脫去 170.339279748|tuo qu;
脱下__脫下 472.67240572|tuo xia;
脱险__脫險 106.748946222|tuo xian;
拖鞋__拖鞋 807.751246202|tuo xie;
妥协__妥協 974.988119996|tuo xie;
拖拽__拖拽 140.770195218|tuo zhuai;
拓展__拓展 2671.97711617|tuo zhan;
托着__托着 151.888225993|tuo zhe;
拖着__拖着 780.052703516|tuo zhe;
脱产__脫產 123.658956482|tuo chan;
拖车__拖車 176.60772663|tuo che;
妥善__妥善 493.744603771|tuo shan;
脱身__脫身 204.839111844|tuo shen;
托收__托收 129.655606164|tuo shou;
脱手__脫手 149.447435764|tuo shou;
脱水__脫水 320.010065926|tuo shui;
托人__託人 209.485777119|tuo ren;
脱俗__脫俗 190.318888971|tuo su;
椭圆__橢圓 249.415244207|tuo yuan;
托运__託運 408.035799866|tuo yun;
拖延__拖延 576.250827814|tuo yan;
唾液__唾液 250.661599628|tuo ye;
脱衣__脫衣 201.547419552|tuo yi;
退保__退保 141.29744947|tui bao;
蜕变__蛻變 326.048110451|tui bian;
退步__退步 250.349428094|tui bu;
腿部__腿部 407.020105042|tui bu;
退票__退票 262.817045902|tui piao;
推门__推門 195.365179853|tui men;
推翻__推翻 705.158077415|tui fan;
退房__退房 257.3078729|tui fang;
退费__退費 113.611883002|tui fei;
颓废__頹廢 797.747780288|tui fei;
推断__推斷 557.184562398|tui duan;
退党__退黨 129.817279349|tui dang;
退到__退到 154.176629937|tui dao;
推导__推導 242.36802267|tui dao;
推倒__推倒 385.78392141|tui dao;
推到__推到 623.314694733|tui dao;
退掉__退掉 128.049907079|tui diao;
推掉__推掉 222.953710017|tui diao;
推定__推定 113.611883002|tui ding;
退订__退訂 202.807148249|tui ding;
推动__推動 7687.28655959|tui dong;
推脱__推脫 184.941433485|tui tuo;
推拿__推拿 158.659551632|tui na;
推论__推論 239.068350048|tui lun;
推力__推力 172.475272126|tui li;
推理__推理 758.012333731|tui li;
退路__退路 241.162905094|tui lu;
推广__推廣 7910.80619229|tui guang;
推高__推高 178.155043976|tui gao;
推给__推給 176.387781073|tui gei;
退款__退款 892.429452826|tui kuan;
推开__推開 931.053859154|tui kai;
退化__退化 474.442798491|tui hua;
退换__退換 108.898738333|tui huan;
退还__退還 625.649317648|tui huan;
退后__退後 213.438416689|tui hou;
退火__退火 109.034528882|tui huo;
退货__退貨 1027.37704867|tui huo;
退回__退回 825.045864155|tui hui;
推荐__推薦 17173.1179117|tui jian;
腿脚__腿腳 124.122120652|tui jiao;
推介__推介 824.018360007|tui jie;
推进__推進 7696.87216983|tui jin;
推举__推舉 173.986383704|tui ju;
退却__退卻 139.200207879|tui que;
退钱__退錢 154.368879448|tui qian;
推敲__推敲 269.785619908|tui qiao;
褪去__褪去 162.056583012|tui qu;
退去__退去 163.069482749|tui qu;
推选__推選 209.224885556|tui xuan;
退学__退學 387.711726118|tui xue;
退下__退下 143.963491517|tui xia;
推销__推銷 1288.92855961|tui xiao;
推向__推向 863.977854874|tui xiang;
推卸__推卸 313.302012384|tui xie;
推行__推行 2003.61737423|tui xing;
退休__退休 2132.4308179|tui xiu;
推着__推着 283.927938713|tui zhe;
退场__退場 177.933171406|tui chang;
推车__推車 176.387781073|tui che;
推迟__推遲 1339.6956486|tui chi;
推崇__推崇 655.989212862|tui chong;
退出__退出 4646.51097209|tui chu;
推出__推出 13022.7299719|tui chu;
褪色__褪色 136.112567367|tui shai;
推上__推上 196.096919422|tui shang;
腿上__腿上 443.56664881|tui shang;
颓势__頹勢 133.259374649|tui shi;
退市__退市 331.37316028|tui shi;
推手__推手 118.824795093|tui shou;
退税__退稅 529.431458035|tui shui;
退让__退讓 147.412812521|tui rang;
推测__推測 738.432842998|tui ce;
推辞__推辭 185.86560618|tui ci;
推算__推算 381.006242235|tui suan;
褪色__褪色 136.112567367|tui se;
推送__推送 167.601987591|tui song;
退缩__退縮 330.136634719|tui suo;
推移__推移 315.260239073|tui yi;
退役__退役 814.828215816|tui yi;
推诿__推諉 143.247667161|tui wei;
退伍__退伍 231.446597362|tui wu;
暖风__暖風 113.046974828|nuan feng;
暖暖__暖暖 294.743493195|nuan nuan;
暖流__暖流 112.204874836|nuan liu;
暖和__暖和 183.106850936|nuan he;
暖和__暖和 183.106850936|nuan huo;
暖气__暖氣 475.034401746|nuan qi;
暖身__暖身 118.08671951|nuan shen;
暖意__暖意 148.889769675|nuan yi;
虐待__虐待 824.018360007|nue dai;
疟疾__瘧疾 124.431860131|nue ji;
女伴__女伴 109.852835359|nv ban;
女兵__女兵 194.151676652|nv bing;
女排__女排 407.020105042|nv pai;
女仆__女僕 165.526347625|nv pu;
女方__女方 761.800204777|nv fang;
女单__女單 203.820597887|nv dan;
女的__女的 3563.28598523|nv de;
女队__女隊 143.247667161|nv dui;
女童__女童 228.295612376|nv tong;
女篮__女籃 144.502706249|nv lan;
女郎__女郎 673.382717005|nv lang;
女工__女工 290.730764849|nv gong;
女鬼__女鬼 243.882891747|nv gui;
女皇__女皇 211.321149687|nv huang;
女孩__女孩 11831.2161031|nv hai;
女警__女警 113.47039186|nv jing;
女侠__女俠 132.762114633|nv xia;
女星__女星 890.207990943|nv xing;
女性__女性 8664.20222638|nv xing;
女婿__女婿 519.626982517|nv xu;
女装__女裝 499.935980841|nv zhuang;
女主__女主 185.172044961|nv zhu;
女双__女雙 123.044091616|nv shuang;
女神__女神 1037.67053575|nv shen;
女声__女聲 326.861744407|nv sheng;
女生__女生 9152.53761339|nv sheng;
女尸__女屍 143.0692679|nv shi;
女式__女式 150.569041974|nv shi;
女士__女士 4554.78325527|nv shi;
女人__女人 33076.6904623|nv ren;
女子__女子 6603.07571119|nv zi;
女足__女足 750.493000864|nv zu;
女色__女色 106.882056102|nv se;
女婴__女嬰 165.526347625|nv ying;
女优__女優 692.099342424|nv you;
女友__女友 3878.39911581|nv you;
女娲__女媧 248.175085992|nv wa;
女王__女王 1233.91923358|nv wang;
女巫__女巫 298.439468992|nv wu;
女儿__女兒 9656.35583564|nv er;
那把__那把 311.744192349|na ba;
那般__那般 366.568203397|na ban;
那帮__那幫 642.238361775|na bang;
那本__那本 596.712660816|na ben;
哪边__哪邊 505.574572707|na bian;
那边__那邊 8927.24508339|na bian;
哪部__哪部 105.0335283|na bu;
拿不__拿不 134.762357541|na bu;
那不__那不 320.808632296|na bu;
那部__那部 382.433299725|na bu;
那怕__那怕 145.043940608|na pa;
哪怕__哪怕 2875.83340941|na pa;
那批__那批 156.304608838|na pi;
那片__那片 541.441326411|na pian;
那篇__那篇 597.456727653|na pian;
那么__那麼 76230.4021649|na me;
纳闷__納悶 948.621258606|na men;
纳米__納米 1096.15615618|na mi;
那面__那面 213.971039752|na mian;
那名__那名 215.576896995|na ming;
那末__那末 114.179614083|na mo;
南无__南無 184.251320835|na mo;
那份__那份 1463.63092081|na fen;
那副__那副 211.584655172|na fu;
那段__那段 1915.71752783|na duan;
拿刀__拿刀 110.95347192|na dao;
那倒__那倒 227.443722742|na dao;
那道__那道 228.295612376|na dao;
拿到__拿到 7187.00747177|na dao;
拿得__拿得 126.621787068|na de;
那得__那得 158.067510349|na de;
拿点__拿點 152.077621994|na dian;
那点__那點 818.900002077|na dian;
拿掉__拿掉 235.519920202|na diao;
那多__那多 133.925286409|na duo;
那对__那對 160.649084484|na dui;
那他__那他 348.309611377|na ta;
那台__那台 347.00988711|na tai;
那套__那套 505.574572707|na tao;
哪天__哪天 3245.34175667|na tian;
那天__那天 5210.95909278|na tian;
哪条__哪條 186.794397067|na tiao;
那条__那條 1333.03432936|na tiao;
那头__那頭 544.146968302|na tou;
那女__那女 221.845125512|na nv;
娜娜__娜娜 689.516759915|na na;
那男__那男 125.678566729|na nan;
哪呢__哪呢 180.839193473|na ne;
哪能__哪能 1309.9794677|na neng;
那年__那年 892.429452826|na nian;
拿捏__拿捏 156.109948588|na nie;
那您__那您 145.043940608|na nin;
哪来__哪來 806.745280603|na lai;
拿来__拿來 2445.72321123|na lai;
纳兰__納蘭 263.801426189|na lan;
那里__那裡 33200.5790857|na li;
哪里__哪裡 37936.2504684|na li;
那两__那兩 134.762357541|na liang;
那辆__那輛 305.97104031|na liang;
那该__那該 108.492380517|na gai;
哪敢__哪敢 171.190483873|na gan;
拿个__拿個 557.184562398|na ge;
哪个__哪個 21733.8448103|na ge;
那个__那個 117323.369521|na ge;
那根__那根 354.881620091|na gen;
拿给__拿給 232.603161479|na gei;
那股__那股 264.789493468|na gu;
哪国__哪國 123.197520618|na guo;
拿过__拿過 408.544597361|na guo;
哪款__哪款 312.132919672|na kuan;
那款__那款 426.226434824|na kuan;
那块__那塊 1026.09756322|na kuai;
那棵__那棵 141.826678552|na ke;
那可__那可 405.501301397|na ke;
那颗__那顆 420.423657369|na ke;
那还__那還 630.344829195|na hai;
呐喊__吶喊 664.215078095|na han;
那好__那好 966.520124945|na hao;
拿货__拿貨 308.651751439|na huo;
哪会__哪會 120.765453341|na hui;
拿回__拿回 350.050152834|na hui;
那会__那會 668.366611253|na hui;
那几__那幾 217.19480623|na ji;
那家__那家 729.287839744|na jia;
哪家__哪家 866.133860988|na jia;
那间__那間 307.883446338|na jian;
那件__那件 670.034480971|na jian;
那叫__那叫 727.472474808|na jiao;
那就__那就 13637.2422365|na jiu;
那句__那句 966.520124945|na ju;
那群__那群 347.875829952|na qun;
拿起__拿起 1615.05244942|na qi;
拿钱__拿錢 629.559803835|na qian;
哪去__哪去 409.564096466|na qu;
拿去__拿去 1200.55002966|na qu;
纳西__納西 154.754097942|na xi;
拿下__拿下 1481.9843182|na xia;
哪像__哪像 128.529517539|na xiang;
哪些__哪些 6562.06096374|na xie;
那些__那些 34379.4836044|na xie;
那张__那張 1319.8108917|na zhang;
拿着__拿着 3792.371211|na zhe;
哪只__哪只 121.217779906|na zhi;
哪知__哪知 182.878811433|na zhi;
那支__那支 200.795341333|na zhi;
那只__那隻 1615.05244942|na zhi;
哪种__哪種 1392.46230328|na zhong;
那种__那種 9255.76567882|na zhong;
那场__那場 692.962351041|na chang;
拿出__拿出 3572.17795663|na chu;
那双__那雙 623.314694733|na shuang;
拿上__拿上 125.835280772|na shang;
哪是__哪是 129.655606164|na shi;
纳什__納什 238.176261728|na shi;
那时__那時 5757.23453692|na shi;
那是__那是 16256.8429358|na shi;
拿手__拿手 317.230705235|na shou;
那首__那首 691.237408589|na shou;
纳税__納稅 938.041438335|na shui;
那人__那人 1847.72178498|na ren;
那日__那日 106.748946222|na ri;
纳入__納入 2406.4213017|na ru;
拿走__拿走 797.747780288|na zou;
那座__那座 244.186999878|na zuo;
那才__那才 184.941433485|na cai;
那层__那層 128.529517539|na ceng;
哪次__哪次 209.485777119|na ci;
那次__那次 1083.93090293|na ci;
纳粹__納粹 407.527636023|na cui;
那厮__那廝 107.952927857|na si;
纳斯__納斯 179.045304336|na si;
哪样__哪樣 345.284462654|na yang;
那样__那樣 19307.3315803|na yang;
那要__那要 458.745029596|na yao;
那也__那也 1100.26180506|na ye;
哪一__哪一 407.527636023|na yi;
那一__那一 724.757896749|na yi;
那英__那英 229.436430673|na ying;
那又__那又 181.969489867|na you;
那有__那有 286.058823982|na you;
哪有__哪有 4163.90759438|na you;
那晚__那晚 388.679238014|na wan;
那位__那位 1587.1200774|na wei;
哪位__哪位 2199.91059329|na wei;
纳尔__納爾 106.616002115|na er;
那儿__那兒 2872.25187426|na er;
哪儿__哪兒 5329.16690206|na er;
奶瓶__奶瓶 295.111021611|nai ping;
奶妈__奶媽 765.607004232|nai ma;
耐磨__耐磨 222.398727024|nai mo;
奶粉__奶粉 1480.13866924|nai fen;
奶头__奶頭 145.043940608|nai tou;
奶奶__奶奶 3941.74151187|nai nai;
奶牛__奶牛 747.692521253|nai niu;
奶酪__奶酪 364.745529846|nai lao;
耐力__耐力 853.278059532|nai li;
耐看__耐看 137.991222203|nai kan;
耐克__耐克 300.304800557|nai ke;
奈何__奈何 365.20034683|nai he;
耐久__耐久 200.545272755|nai jiu;
耐心__耐心 3343.86946243|nai xin;
耐性__耐性 316.83562918|nai xing;
乃至__乃至 2241.4191567|nai zhi;
奶茶__奶茶 564.171453387|nai cha;
乃是__乃是 623.314694733|nai shi;
耐受__耐受 113.32907693|nai shou;
奶水__奶水 181.969489867|nai shui;
耐热__耐熱 111.369047744|nai re;
奶子__奶子 304.070513117|nai zi;
奶嘴__奶嘴 165.73274959|nai zui;
耐药__耐葯 164.088713397|nai yao;
奶业__奶業 135.267109459|nai ye;
奶油__奶油 444.119751258|nai you;
耐用__耐用 326.861744407|nai yong;
难办__難辦 218.280152578|nan ban;
难保__難保 168.439513167|nan bao;
南北__南北 1255.63548024|nan bei;
南边__南邊 367.025293151|nan bian;
南部__南部 1378.64935183|nan bu;
男排__男排 108.492380517|nan pai;
南坪__南坪 111.369047744|nan ping;
南平__南平 182.651055928|nan ping;
难买__難買 109.034528882|nan mai;
南门__南門 439.166555128|nan men;
南美__南美 445.783200166|nan mei;
难觅__難覓 121.520271774|nan mi;
南面__南面 288.565077751|nan mian;
难免__難免 1894.35183846|nan mian;
难民__難民 351.361264404|nan min;
男方__男方 616.362966229|nan fang;
南方__南方 3931.92961191|nan fang;
南风__南風 216.654158472|nan feng;
南非__南非 833.312156414|nan fei;
南端__南端 144.863304286|nan duan;
难打__難打 133.591915611|nan da;
南大__南大 411.610733326|nan da;
男单__男單 222.67604562|nan dan;
难倒__難倒 105.426930997|nan dao;
难道__難道 17045.1933699|nan dao;
难得__難得 4805.5096548|nan de;
难点__難點 820.943519051|nan dian;
难懂__難懂 185.86560618|nan dong;
南都__南都 152.457122789|nan du;
难度__難度 4371.27378998|nan du;
难逃__難逃 240.562595233|nan tao;
难题__難題 2224.72256613|nan ti;
南天__南天 109.989815613|nan tian;
难听__難聽 722.053448193|nan ting;
男童__男童 129.817279349|nan tong;
南通__南通 874.811821743|nan tong;
男女__男女 3797.10008276|nan nv;
难耐__難耐 194.393772779|nan nai;
楠楠__楠楠 161.854759309|nan nan;
喃喃__喃喃 362.028498203|nan nan;
囡囡__囡囡 366.568203397|nan nan;
南宁__南寧 1506.18823193|nan ning;
男篮__男籃 336.365750338|nan lan;
南路__南路 737.513205869|nan lu;
南瓜__南瓜 607.9716117|nan gua;
难关__難關 448.010827873|nan guan;
难怪__難怪 2655.38023445|nan guai;
难搞__難搞 107.14877401|nan gao;
南宫__南宮 324.83145542|nan gong;
南国__南國 427.290057918|nan guo;
难过__難過 3034.13893483|nan guo;
南开__南開 343.996026791|nan kai;
难堪__難堪 381.481335404|nan kan;
难看__難看 2202.653757|nan kan;
南华__南華 125.053659829|nan hua;
南海__南海 1238.54087357|nan hai;
男孩__男孩 4258.36360257|nan hai;
南韩__南韓 117.646076559|nan han;
南航__南航 678.436468738|nan hang;
南湖__南湖 318.418891685|nan hu;
南汇__南匯 226.595011951|nan hui;
南极__南極 502.434215952|nan ji;
南郊__南郊 130.954650472|nan jiao;
南疆__南疆 170.127140854|nan jiang;
南街__南街 120.916041011|nan jie;
难解__難解 131.773154284|nan jie;
南京__南京 10668.6512651|nan jing;
南汽__南汽 208.184564378|nan qi;
南桥__南橋 155.915530766|nan qiao;
难求__難求 196.586267794|nan qiu;
南区__南區 282.868455943|nan qu;
南下__南下 448.56947196|nan xia;
男星__男星 167.601987591|nan xing;
男性__男性 3585.55753613|nan xing;
男装__男裝 376.287731462|nan zhuang;
南站__南站 328.495108513|nan zhan;
难找__難找 447.452879516|nan zhao;
南至__南至 106.350610398|nan zhi;
难缠__難纏 115.611384758|nan chan;
难产__難產 177.933171406|nan chan;
南昌__南昌 1706.08071057|nan chang;
南朝__南朝 132.266710153|nan chao;
南城__南城 196.831399718|nan cheng;
难吃__難吃 376.756940916|nan chi;
南充__南充 229.150692759|nan chong;
难处__難處 331.37316028|nan chu;
南沙__南沙 265.78126155|nan sha;
南山__南山 1035.08753546|nan shan;
男声__男聲 369.319305625|nan sheng;
男生__男生 5742.90345783|nan sheng;
男式__男式 114.179614083|nan shi;
难事__難事 256.347723437|nan shi;
男士__男士 1261.91002891|nan shi;
难受__難受 3740.74070579|nan shou;
难说__難說 807.751246202|nan shuo;
难忍__難忍 177.048440864|nan ren;
男人__男人 31039.9265211|nan ren;
男子__男子 5070.03774893|nan zi;
男足__男足 168.859844103|nan zu;
难做__難做 289.285174995|nan zuo;
南侧__南側 237.287502254|nan ce;
南宋__南宋 336.365750338|nan song;
南苑__南苑 113.895394799|nan yuan;
南亚__南亞 301.805456692|nan ya;
难言__難言 108.492380517|nan yan;
难掩__難掩 116.769717326|nan yan;
南洋__南洋 302.181790975|nan yang;
南阳__南陽 468.567137655|nan yang;
难易__難易 130.303509496|nan yi;
难以__難以 7178.0568421|nan yi;
男婴__男嬰 119.86585751|nan ying;
难有__難有 145.224802174|nan you;
男友__男友 2557.94157928|nan you;
难于__難於 345.284462654|nan yu;
难忘__難忘 1260.33845835|nan wang;
难闻__難聞 131.937467932|nan wen;
难为__難為 362.028498203|nan wei;
南无__南無 604.195219728|nan wu;
南岸__南岸 210.532600599|nan an;
难熬__難熬 216.384339476|nan ao;
男儿__男兒 443.014235191|nan er;
囊括__囊括 283.221176861|nang kuo;
囊中__囊中 143.0692679|nang zhong;
囊肿__囊腫 266.112675706|nang zhong;
脑部__腦部 245.407229187|nao bu;
脑门__腦門 224.907079496|nao men;
闹翻__鬧翻 120.46484039|nao fan;
脑袋__腦袋 3201.15867829|nao dai;
闹得__鬧得 413.667597456|nao de;
脑瘫__腦癱 136.792736844|nao tan;
闹腾__鬧騰 173.769702743|nao teng;
闹闹__鬧鬧 184.941433485|nao nao;
恼怒__惱怒 192.705418355|nao nu;
脑力__腦力 203.313241605|nao li;
脑壳__腦殼 324.02287532|nao ke;
脑海__腦海 690.376548199|nao hai;
脑后__腦後 277.976239008|nao hou;
恼火__惱火 617.901063897|nao huo;
脑筋__腦筋 462.764242999|nao jin;
闹剧__鬧劇 316.441045148|nao ju;
闹心__鬧心 279.017397997|nao xin;
闹着__鬧着 133.259374649|nao zhe;
脑中__腦中 382.910172354|nao zhong;
闹钟__鬧鐘 661.736546275|nao zhong;
闹出__鬧出 145.405889264|nao chu;
闹市__鬧市 232.313479749|nao shi;
闹事__鬧事 312.132919672|nao shi;
脑子__腦子 3030.36024751|nao zi;
呢个__呢個 663.387871054|ne ge;
哪吒__哪吒 116.18910757|ne zha;
嫩肤__嫩膚 129.817279349|nen fu;
嫩嫩__嫩嫩 145.405889264|nen nen;
能把__能把 1567.46464304|neng ba;
能帮__能幫 396.012952778|neng bang;
能被__能被 314.475483928|neng bei;
能比__能比 309.807805448|neng bi;
能补__能補 335.946843682|neng bu;
能不__能不 672.544092675|neng bu;
能卖__能賣 243.57916235|neng mai;
能否__能否 6305.53234147|neng fou;
能打__能打 217.19480623|neng da;
能带__能帶 109.034528882|neng dai;
能到__能到 417.291872914|neng dao;
能动__能動 123.813152185|neng dong;
能多__能多 165.114314527|neng duo;
能对__能對 248.484546245|neng dui;
能听__能聽 115.179978568|neng ting;
能耐__能耐 433.187606905|neng nai;
能力__能力 27266.8864097|neng li;
能量__能量 3045.50329114|neng liang;
能改__能改 106.616002115|neng gai;
能干__能幹 677.591550514|neng gan;
能给__能給 1206.54931027|neng gei;
能够__能夠 31823.2660073|neng gou;
能过__能過 198.308623594|neng guo;
能看__能看 339.31275934|neng kan;
能耗__能耗 618.67155147|neng hao;
能活__能活 140.770195218|neng huo;
能将__能將 443.56664881|neng jiang;
能进__能進 221.292902041|neng jin;
能去__能去 287.846772995|neng qu;
能效__能效 140.945727665|neng xiao;
能像__能像 327.26932246|neng xiang;
能写__能寫 136.112567367|neng xie;
能赚__能賺 243.882891747|neng zhuan;
能吃__能吃 450.24958728|neng chi;
能使__能使 1059.88791463|neng shi;
能手__能手 191.508436159|neng shou;
能说__能說 672.544092675|neng shuo;
能让__能讓 2188.97205903|neng rang;
能人__能人 123.658956482|neng ren;
能再__能再 242.972837869|neng zai;
能在__能在 2361.85708402|neng zai;
能走__能走 118.676811842|neng zou;
能做__能做 1292.14500531|neng zuo;
能从__能從 500.559372647|neng cong;
能源__能源 4420.5757602|neng yuan;
能以__能以 238.176261728|neng yi;
能赢__能贏 115.323601467|neng ying;
能有__能有 1887.28302677|neng you;
能用__能用 1298.60199609|neng yong;
能与__能與 367.025293151|neng yu;
能玩__能玩 150.381524744|neng wan;
能为__能為 702.526765976|neng wei;
内壁__內壁 118.23396695|nei bi;
那边__那邊 8927.24508339|nei bian;
内部__內部 10523.4049735|nei bu;
内蒙__內蒙 567.697685436|nei meng;
内膜__內膜 218.008308584|nei mo;
内幕__內幕 1031.22508566|nei mu;
内服__內服 164.498187167|nei fu;
内胆__內膽 111.925571131|nei dan;
内地__內地 4268.99009943|nei di;
内定__內定 136.282292017|nei ding;
那台__那台 347.00988711|nei tai;
那天__那天 5210.95909278|nei tian;
内力__內力 262.817045902|nei li;
内敛__內斂 362.479927203|nei lian;
内陆__內陸 374.41672986|nei lu;
内阁__內閣 472.67240572|nei ge;
内功__內功 267.109399762|nei gong;
内科__內科 312.132919672|nei ke;
内控__內控 206.119414554|nei kong;
内裤__內褲 1476.45426414|nei ku;
内环__內環 149.633788238|nei huan;
内含__內含 283.927938713|nei han;
内涵__內涵 2252.61977488|nei han;
内行__內行 220.742053181|nei hang;
内河__內河 145.950506492|nei he;
内核__內核 1300.22127911|nei he;
内讧__內訌 122.584950132|nei hong;
那家__那家 729.287839744|nei jia;
内建__內建 250.661599628|nei jian;
内江__內江 140.070248771|nei jiang;
内将__內將 163.884358899|nei jiang;
内镜__內鏡 123.813152185|nei jing;
内疚__內疚 598.201722298|nei jiu;
内嵌__內嵌 183.792676978|nei qian;
内勤__內勤 114.179614083|nei qin;
内情__內情 187.027319083|nei qing;
内线__內線 593.006203378|nei xian;
内销__內銷 216.384339476|nei xiao;
内向__內向 651.102673334|nei xiang;
内心__內心 5329.16690206|nei xin;
内需__內需 389.649164279|nei xu;
内战__內戰 428.890471272|nei zhan;
那张__那張 1319.8108917|nei zhang;
内政__內政 224.907079496|nei zheng;
内置__內置 1708.20809643|nei zhi;
那种__那種 9255.76567882|nei zhong;
内伤__內傷 124.89791921|nei shang;
内设__內設 211.057972369|nei she;
内审__內審 114.75018218|nei shen;
内饰__內飾 576.250827814|nei shi;
内容__內容 33241.9783244|nei rong;
内在__內在 1450.91895115|nei zai;
内脏__內臟 409.564096466|nei zang;
内资__內資 171.831677206|nei zi;
内存__內存 8610.38487191|nei cun;
内参__內參 127.73116145|nei can;
内侧__內側 389.649164279|nei ce;
内测__內測 655.172250234|nei ce;
那次__那次 1083.93090293|nei ci;
内页__內頁 216.384339476|nei ye;
内衣__內衣 1544.19916972|nei yi;
内因__內因 114.321989585|nei yin;
内有__內有 508.100984482|nei you;
内外__內外 1323.10440245|nei wai;
内网__內網 972.56115063|nei wang;
那位__那位 1587.1200774|nei wei;
内务__內務 109.442917312|nei wu;
泥巴__泥巴 358.884197808|ni ba;
你比__你比 178.59961945|ni bi;
你不__你不 3976.27638265|ni bu;
你怕__你怕 151.888225993|ni pa;
倪萍__倪萍 119.26985293|ni ping;
你妈__你媽 2705.48273369|ni ma;
你们__你們 95399.2129519|ni men;
你没__你沒 1126.6237397|ni mei;
匿名__匿名 2172.66615296|ni ming;
逆风__逆風 126.937764318|ni feng;
你到__你到 325.236501817|ni dao;
你得__你得 441.361118731|ni de;
你的__你的 39676.8988369|ni de;
你得__你得 327.677408739|ni dei;
拟订__擬訂 142.180598718|ni ding;
拟定__擬定 617.131535882|ni ding;
你懂__你懂 203.060037258|ni dong;
你对__你對 1212.57856995|ni dui;
你太__你太 518.333511609|ni tai;
泥潭__泥潭 189.372573382|ni tan;
逆天__逆天 140.594881376|ni tian;
你听__你聽 203.820597887|ni ting;
泥土__泥土 647.865219539|ni tu;
呢喃__呢喃 176.387781073|ni nan;
你能__你能 3671.46639254|ni neng;
妮妮__妮妮 277.976239008|ni ni;
泥泞__泥濘 192.705418355|ni ning;
你来__你來 1203.54593192|ni lai;
逆流__逆流 160.849404779|ni liu;
尼龙__尼龍 254.121284766|ni long;
逆光__逆光 194.393772779|ni guang;
你该__你該 247.866011137|ni gai;
你敢__你敢 365.655730945|ni gan;
你个__你個 1290.5357804|ni ge;
尼姑__尼姑 317.230705235|ni gu;
你看__你看 3946.65663992|ni kan;
尼康__尼康 699.905273328|ni kang;
妮可__妮可 140.945727665|ni ke;
尼克__尼克 224.626982392|ni ke;
你可__你可 775.207436548|ni ke;
你还__你還 3685.21785652|ni hai;
你好__你好 20728.6414301|ni hao;
拟合__擬合 173.769702743|ni he;
你和__你和 862.9018652|ni he;
你很__你很 503.060722916|ni hen;
霓虹__霓虹 122.584950132|ni hong;
你会__你會 4448.20561603|ni hui;
你家__你家 2722.39277029|ni jia;
拟建__擬建 171.403948695|ni jian;
泥浆__泥漿 129.979154132|ni jiang;
你将__你將 229.722524886|ni jiang;
逆境__逆境 263.472890441|ni jing;
你就__你就 7479.39723763|ni jiu;
泥鳅__泥鰍 208.184564378|ni qiu;
逆向__逆向 213.971039752|ni xiang;
你想__你想 3306.57582432|ni xiang;
逆行__逆行 147.596627936|ni xing;
逆转__逆轉 687.800394331|ni zhuan;
你真__你真 1157.93816758|ni zhen;
你只__你只 162.663565352|ni zhi;
逆差__逆差 113.611883002|ni cha;
昵称__昵稱 800.735741689|ni cheng;
泥沙__泥沙 267.109399762|ni sha;
霓裳__霓裳 176.60772663|ni shang;
逆市__逆市 172.475272126|ni shi;
逆势__逆勢 201.296414343|ni shi;
你是__你是 13006.5115898|ni shi;
你说__你說 8019.99283537|ni shuo;
溺水__溺水 178.377193209|ni shui;
你若__你若 226.877563077|ni ruo;
拟在__擬在 118.08671951|ni zai;
你在__你在 5983.99500079|ni zai;
腻子__膩子 141.826678552|ni zi;
妮子__妮子 148.334184528|ni zi;
你做__你做 740.275558891|ni zuo;
你最__你最 396.506758465|ni zui;
尼采__尼采 208.70407676|ni cai;
你猜__你猜 296.955549433|ni cai;
你才__你才 490.677728407|ni cai;
尼斯__尼斯 252.85772688|ni si;
你所__你所 757.068312494|ni suo;
尼亚__尼亞 312.911829085|ni ya;
你要__你要 8546.24511901|ni yao;
你也__你也 5511.52534746|ni ye;
你一__你一 123.504952812|ni yi;
你有__你有 4371.27378998|ni you;
你用__你用 1126.6237397|ni yong;
你问__你問 431.033684153|ni wen;
腻味__膩味 122.584950132|ni wei;
你我__你我 358.884197808|ni wo;
溺爱__溺愛 174.638049069|ni ai;
你爱__你愛 292.54791482|ni ai;
尼奥__尼奧 232.313479749|ni ao;
尼尔__尼爾 122.890853693|ni er;
你哦__你哦 643.039196578|ni o;
年半__年半 131.937467932|nian ban;
年报__年報 743.048258297|nian bao;
年迈__年邁 197.322580943|nian mai;
年满__年滿 136.112567367|nian man;
黏膜__黏膜 243.882891747|nian mo;
粘膜__粘膜 395.519762073|nian mo;
年末__年末 654.356305043|nian mo;
年份__年份 639.044983668|nian fen;
年费__年費 327.677408739|nian fei;
念佛__念佛 249.726250867|nian fo;
年代__年代 6157.98882218|nian dai;
念叨__念叨 316.441045148|nian dao;
年的__年的 4189.93320117|nian de;
年底__年底 3931.92961191|nian di;
粘度__粘度 205.350275845|nian du;
年度__年度 5566.7463737|nian du;
粘帖__粘帖 176.827946446|nian tie;
年头__年頭 1282.5196677|nian tou;
念头__念頭 1680.75779471|nian tou;
粘土__粘土 154.561368684|nian tu;
年内__年內 1631.2339687|nian nei;
念念__念念 164.908682755|nian nian;
年年__年年 860.753904265|nian nian;
年来__年來 2038.87985164|nian lai;
年老__年老 282.516174301|nian lao;
年里__年裡 239.963779681|nian li;
年龄__年齡 6529.43267016|nian ling;
年关__年關 112.34478795|nian guan;
年糕__年糕 184.941433485|nian gao;
年画__年畫 223.510077937|nian hua;
年华__年華 569.114341748|nian hua;
年后__年後 1782.13945694|nian hou;
年货__年貨 124.587019602|nian huo;
年会__年會 665.872587905|nian hui;
年均__年均 339.735863102|nian jun;
年级__年級 1046.76190254|nian ji;
年纪__年紀 3603.47496171|nian ji;
年假__年假 392.084582382|nian jia;
年鉴__年鑒 208.44415872|nian jian;
年检__年檢 453.628720089|nian jian;
年间__年間 1013.39002232|nian jian;
年近__年近 131.117943492|nian jin;
年金__年金 163.069482749|nian jin;
年仅__年僅 212.907119447|nian jin;
念经__念經 155.527421199|nian jing;
年期__年期 224.347234118|nian qi;
年前__年前 4360.39268552|nian qian;
年青__年青 514.472385324|nian qing;
年轻__年輕 9814.0643895|nian qing;
年限__年限 634.284663664|nian xian;
年薪__年薪 908.135681884|nian xin;
粘性__粘性 170.76435144|nian xing;
年长__年長 247.557321202|nian zhang;
念着__念着 176.168109435|nian zhe;
年中__年中 370.240920313|nian zhong;
年终__年終 571.958268741|nian zhong;
年产__年產 567.697685436|nian chan;
粘稠__粘稠 151.510141313|nian chou;
年初__年初 2156.48171146|nian chu;
年少__年少 626.429466854|nian shao;
年审__年審 226.877563077|nian shen;
念书__念書 508.734557585|nian shu;
年岁__年歲 125.053659829|nian sui;
年月__年月 243.57916235|nian yue;
碾压__碾壓 110.677283245|nian ya;
粘液__粘液 203.820597887|nian ye;
年幼__年幼 244.186999878|nian you;
尿布__尿布 234.933657026|niao bu;
尿频__尿頻 132.927661458|niao pin;
尿道__尿道 301.054193591|niao dao;
袅袅__裊裊 190.081867665|niao niao;
尿尿__尿尿 295.479008313|niao niao;
鸟类__鳥類 342.712398751|niao lei;
鸟巢__鳥巢 259.562230298|niao chao;
鸟人__鳥人 736.594714048|niao ren;
尿酸__尿酸 112.484875527|niao suan;
尿素__尿素 347.00988711|niao su;
尿液__尿液 275.218769535|niao ye;
鸟语__鳥語 184.481071779|niao yu;
鸟儿__鳥兒 456.464028614|niao er;
娘娘__娘娘 464.497524783|niang niang;
娘家__娘家 307.883446338|niang jia;
酿酒__釀酒 260.534419685|niang jiu;
酿成__釀成 235.813600182|niang cheng;
酿造__釀造 203.566761683|niang zao;
娘子__娘子 388.195180646|niang zi;
涅磐__涅磐 179.268563673|nie pan;
捏捏__捏捏 266.112675706|nie nie;
捏了__捏了 126.464093517|nie le;
捏着__捏着 204.839111844|nie zhe;
捏造__捏造 235.226605969|nie zao;
您们__您們 344.85444872|nin men;
您的__您的 12251.325466|nin de;
您对__您對 742.122873174|nin dui;
您能__您能 353.998238229|nin neng;
您老__您老 260.209952636|nin lao;
您看__您看 164.088713397|nin kan;
您可__您可 161.653186955|nin ke;
您还__您還 635.867483878|nin hai;
您好__您好 4623.40729705|nin hao;
您会__您會 216.654158472|nin hui;
您将__您將 389.649164279|nin jiang;
您就__您就 391.596284031|nin jiu;
您想__您想 488.237949645|nin xiang;
您是__您是 667.534233933|nin shi;
您说__您說 308.651751439|nin shuo;
您在__您在 1078.5413133|nin zai;
您所__您所 270.796100963|nin suo;
您要__您要 528.113581536|nin yao;
您也__您也 419.377126323|nin ye;
您已__您已 129.655606164|nin yi;
您有__您有 709.565515965|nin you;
宁波__寧波 3594.50508488|ning bo;
柠檬__檸檬 885.781642601|ning meng;
宁德__寧德 150.944778196|ning de;
宁宁__寧寧 210.270405333|ning ning;
凝固__凝固 489.456318842|ning gu;
宁可__寧可 1015.91887775|ning ke;
宁肯__寧肯 117.93965545|ning ken;
宁海__寧海 132.10198647|ning hai;
凝胶__凝膠 256.028470459|ning jiao;
凝结__凝結 335.110594827|ning jie;
宁静__寧靜 1402.91276273|ning jing;
凝聚__凝聚 874.811821743|ning ju;
宁夏__寧夏 1160.82773443|ning xia;
凝重__凝重 281.111429553|ning zhong;
凝神__凝神 157.085680168|ning shen;
凝视__凝視 462.764242999|ning shi;
宁愿__寧願 1653.74860966|ning yuan;
凝望__凝望 199.548108896|ning wang;
牛比__牛比 235.519920202|niu bi;
牛逼__牛逼 1701.83388383|niu bi;
牛排__牛排 368.85935893|niu pai;
牛皮__牛皮 357.99085261|niu pi;
纽曼__紐曼 249.726250867|niu man;
牛粪__牛糞 159.85029497|niu fen;
牛顿__牛頓 343.567617462|niu dun;
纽带__紐帶 403.48504224|niu dai;
扭动__扭動 275.561951728|niu dong;
牛头__牛頭 318.815941979|niu tou;
扭头__扭頭 347.00988711|niu tou;
牛奶__牛奶 2897.41660082|niu nai;
妞妞__妞妞 681.82669043|niu niu;
牛牛__牛牛 765.607004232|niu niu;
牛郎__牛郎 203.566761683|niu lang;
牛股__牛股 263.472890441|niu gu;
纽扣__紐扣 202.554574186|niu kou;
扭亏__扭虧 121.066816454|niu kui;
牛角__牛角 140.594881376|niu jiao;
牛津__牛津 264.130371602|niu jin;
扭矩__扭矩 293.643651968|niu ju;
牛群__牛群 132.10198647|niu qun;
扭曲__扭曲 1086.63578899|niu qu;
扭转__扭轉 712.223191016|niu zhuan;
牛叉__牛叉 116.915322539|niu cha;
扭伤__扭傷 182.651055928|niu shang;
牛市__牛市 1605.02061407|niu shi;
牛人__牛人 1062.53280282|niu ren;
牛肉__牛肉 1441.90662463|niu rou;
牛仔__牛仔 576.969379906|niu zai;
纽约__紐約 2638.88644361|niu yue;
牛羊__牛羊 271.471856767|niu yang;
浓密__濃密 201.547419552|nong mi;
农民__農民 12190.4086525|nong min;
农牧__農牧 119.121315407|nong mu;
农妇__農婦 143.0692679|nong fu;
农夫__農夫 345.715012791|nong fu;
农大__農大 268.109857044|nong da;
弄到__弄到 700.778015498|nong dao;
弄得__弄得 1894.35183846|nong de;
弄点__弄點 316.441045148|nong dian;
弄丢__弄丟 178.377193209|nong diu;
弄懂__弄懂 128.049907079|nong dong;
浓度__濃度 1493.10664229|nong du;
农田__農田 497.450167612|nong tian;
弄弄__弄弄 192.225730308|nong nong;
浓浓__濃濃 259.562230298|nong nong;
弄来__弄來 187.027319083|nong lai;
农历__農曆 893.542261726|nong li;
浓烈__濃烈 347.875829952|nong lie;
农林__農林 192.465424888|nong lin;
弄个__弄個 1059.88791463|nong ge;
农耕__農耕 149.633788238|nong geng;
弄过__弄過 126.779677253|nong guo;
农垦__農墾 170.76435144|nong ken;
弄坏__弄壞 172.260473089|nong huai;
农行__農行 1153.6172982|nong hang;
侬好__儂好 320.409100324|nong hao;
弄好__弄好 876.994863387|nong hao;
浓厚__濃厚 1069.17393505|nong hou;
农户__農戶 1321.45662101|nong hu;
农活__農活 126.937764318|nong huo;
农技__農技 226.595011951|nong ji;
农机__農機 773.277767188|nong ji;
农家__農家 562.066236349|nong jia;
弄清__弄清 333.444336783|nong qing;
农庄__農莊 165.114314527|nong zhuang;
浓重__濃重 333.444336783|nong zhong;
农场__農場 948.621258606|nong chang;
弄成__弄成 372.091054935|nong cheng;
弄出__弄出 265.78126155|nong chu;
弄湿__弄濕 152.457122789|nong shi;
弄脏__弄髒 159.85029497|nong zang;
农资__農資 493.129699012|nong zi;
农村__農村 11875.5298799|nong cun;
弄错__弄錯 326.048110451|nong cuo;
弄死__弄死 249.415244207|nong si;
浓缩__濃縮 645.447697543|nong suo;
浓烟__濃煙 206.89143407|nong yan;
农药__農藥 1015.91887775|nong yao;
农业__農業 6360.77714733|nong ye;
农用__農用 186.32942291|nong yong;
浓郁__濃郁 725.661628731|nong yu;
农委__農委 120.765453341|nong wei;
奴婢__奴婢 188.665925845|nu bi;
怒放__怒放 162.056583012|nu fang;
奴隶__奴隸 1036.37823089|nu li;
努力__努力 20294.1274839|nu li;
怒吼__怒吼 275.561951728|nu hou;
怒火__怒火 299.93080386|nu huo;
怒江__怒江 134.092283643|nu jiang;
怒气__怒氣 338.468131949|nu qi;
怒斥__怒斥 131.445140637|nu chi;
奴才__奴才 392.573489614|nu cai;
奴役__奴役 269.785619908|nu yi;
糯米__糯米 353.557372243|nuo mi;
懦夫__懦夫 147.412812521|nuo fu;
诺夫__諾夫 210.270405333|nuo fu;
诺顿__諾頓 601.191002133|nuo dun;
挪动__挪動 157.67404401|nuo dong;
懦弱__懦弱 462.764242999|nuo ruo;
诺斯__諾斯 156.304608838|nuo si;
诺言__諾言 465.65665114|nuo yan;
挪用__挪用 478.599545119|nuo yong;
挪威__挪威 550.284199441|nuo wei;
卵泡__卵泡 135.435779871|luan pao;
乱跑__亂跑 327.677408739|luan pao;
乱码__亂碼 1125.22065338|luan ma;
乱发__亂髮 180.164388413|luan fa;
乱飞__亂飛 130.303509496|luan fei;
乱打__亂打 113.895394799|luan da;
乱动__亂動 164.498187167|luan dong;
乱弹__亂彈 123.504952812|luan tan;
乱套__亂套 135.773751924|luan tao;
乱乱__亂亂 105.953760973|luan luan;
乱伦__亂倫 376.756940916|luan lun;
乱来__亂來 308.267359529|luan lai;
乱了__亂了 406.006938516|luan le;
乱搞__亂搞 258.271618599|luan gao;
乱花__亂花 106.748946222|luan hua;
乱叫__亂叫 209.746993999|luan jiao;
乱讲__亂講 163.476413088|luan jiang;
乱象__亂象 109.852835359|luan xiang;
乱想__亂想 225.187525865|luan xiang;
乱写__亂寫 136.112567367|luan xie;
卵巢__卵巢 438.073368704|luan chao;
乱世__亂世 355.324137339|luan shi;
乱说__亂說 704.279880358|luan shuo;
乱扔__亂扔 128.529517539|luan reng;
卵子__卵子 299.557272934|luan zi;
乱用__亂用 126.937764318|luan yong;
乱舞__亂舞 124.742372548|luan wu;
略带__略帶 426.757915008|lue dai;
略低__略低 105.164499152|lue di;
掠夺__掠奪 503.688011099|lue duo;
掠过__掠過 402.982545867|lue guo;
略显__略顯 457.603107852|lue xian;
略有__略有 875.902662456|lue you;
略微__略微 483.997491267|lue wei;
轮盘__輪盤 166.97657743|lun pan;
轮番__輪番 279.365316864|lun fan;
论断__論斷 250.661599628|lun duan;
伦敦__倫敦 1976.33951256|lun dun;
轮到__輪到 826.074649543|lun dao;
论点__論點 356.655002599|lun dian;
论调__論調 228.8653107|lun diao;
轮渡__輪渡 131.609045271|lun du;
轮胎__輪胎 1425.82527204|lun tai;
论谈__論談 373.019586361|lun tan;
论坛__論壇 24162.3313619|lun tan;
论题__論題 292.54791482|lun ti;
伦理__倫理 832.274357505|lun li;
轮流__輪流 813.813436628|lun liu;
沦落__淪落 359.779772295|lun luo;
轮毂__輪轂 159.452390871|lun gu;
轮廓__輪廓 715.782248677|lun kuo;
轮滑__輪滑 153.41002317|lun hua;
轮换__輪換 281.111429553|lun huan;
轮回__輪迴 916.092151969|lun hui;
轮奸__輪姦 250.037645335|lun jian;
论据__論據 230.295783987|lun ju;
沦陷__淪陷 226.877563077|lun xian;
论战__論戰 153.41002317|lun zhan;
论者__論者 152.077621994|lun zhe;
论证__論證 1361.57568978|lun zheng;
轮船__輪船 285.702569086|lun chuan;
论述__論述 1093.42757174|lun shu;
轮子__輪子 457.603107852|lun zi;
沦丧__淪喪 130.141230764|lun sang;
轮椅__輪椅 318.418891685|lun yi;
论语__論語 241.162905094|lun yu;
论文__論文 7649.06334831|lun wen;
沦为__淪為 556.490650127|lun wei;
铝箔__鋁箔 110.677283245|lv bo;
滤波__濾波 273.168633085|lv bo;
吕布__呂布 364.291279287|lv bu;
律法__律法 111.507918629|lv fa;
绿灯__綠燈 220.19257551|lv deng;
率低__率低 128.209578049|lv di;
绿地__綠地 620.98878351|lv di;
旅店__旅店 397.001179899|lv dian;
绿豆__綠豆 449.688850794|lv dou;
旅途__旅途 794.770968525|lv tu;
屡屡__屢屢 513.191745392|lv lv;
履历__履歷 179.045304336|lv li;
旅馆__旅館 1282.5196677|lv guan;
绿光__綠光 161.653186955|lv guang;
率高__率高 186.561765129|lv gao;
绿卡__綠卡 341.433560596|lv ka;
旅客__旅客 1901.44712636|lv ke;
氯化__氯化 118.972962872|lv hua;
绿化__綠化 1301.84258129|lv hua;
滤镜__濾鏡 296.955549433|lv jing;
滤芯__濾芯 119.121315407|lv xin;
旅行__旅行 2695.38717088|lv xing;
履行__履行 2739.40849942|lv xing;
绿装__綠裝 143.247667161|lv zhuang;
绿洲__綠洲 522.223615731|lv zhou;
绿茶__綠茶 775.207436548|lv cha;
绿城__綠城 242.972837869|lv cheng;
旅程__旅程 691.237408589|lv cheng;
旅顺__旅順 106.218162376|lv shun;
旅社__旅社 163.476413088|lv she;
律师__律師 5395.99270938|lv shi;
绿树__綠樹 170.76435144|lv shu;
绿水__綠水 130.141230764|lv shui;
驴子__驢子 350.486645516|lv zi;
绿草__綠草 109.852835359|lv cao;
屡次__屢次 322.010219858|lv ci;
绿色__綠色 5470.46935761|lv se;
履约__履約 154.947067523|lv yue;
绿野__綠野 120.916041011|lv ye;
铝业__鋁業 353.117055307|lv ye;
绿叶__綠葉 454.194369369|lv ye;
绿意__綠意 109.989815613|lv yi;
绿茵__綠茵 169.070402749|lv yin;
驴友__驢友 331.786363812|lv you;
旅游__旅遊 11088.8579276|lv you;
率为__率為 317.626273928|lv wei;
喇叭__喇叭 1078.5413133|la ba;
蜡笔__蠟筆 113.47039186|la bi;
拉票__拉票 298.06779536|la piao;
喇嘛__喇嘛 317.626273928|la ma;
辣妹__辣妹 332.200082586|la mei;
拉美__拉美 342.285588041|la mei;
拉面__拉麵 374.41672986|la mian;
拉姆__拉姆 219.644465616|la mu;
拉风__拉風 351.799391968|la feng;
拉大__拉大 322.813777494|la da;
拉倒__拉倒 370.702589737|la dao;
拉到__拉到 1112.67124847|la dao;
辣的__辣的 148.889769675|la de;
拉得__拉得 149.447435764|la de;
拉登__拉登 383.387639617|la deng;
拉丁__拉丁 298.06779536|la ding;
拉动__拉動 1272.96603034|la dong;
邋遢__邋遢 212.641966978|la ta;
啦啦__啦啦 499.935980841|la la;
拉拉__拉拉 861.827215553|la la;
拉来__拉來 115.611384758|la lai;
拉力__拉力 195.121873946|la li;
拉练__拉練 145.768741141|la lian;
拉链__拉鏈 369.779825848|la lian;
拉拢__拉攏 232.603161479|la long;
拉高__拉高 377.697115787|la gao;
拉过__拉過 154.947067523|la guo;
拉开__拉開 1818.02954749|la kai;
拉客__拉客 142.003528374|la ke;
拉回__拉回 186.32942291|la hui;
垃圾__垃圾 12941.8397922|la ji;
辣椒__辣椒 1129.43516323|la jiao;
拉进__拉進 122.737806611|la jin;
拉近__拉近 362.028498203|la jin;
拉锯__拉鋸 115.611384758|la ju;
拉起__拉起 380.057830188|la qi;
拉去__拉去 139.895806636|la qu;
拉稀__拉稀 133.758497151|la xi;
拉下__拉下 238.473254015|la xia;
落下__落下 583.476802811|la xia;
拉着__拉着 1429.38333547|la zhe;
拉住__拉住 580.575602636|la zhu;
蜡烛__蠟燭 807.751246202|la zhu;
拉长__拉長 305.97104031|la chang;
拉扯__拉扯 245.407229187|la che;
拉出__拉出 275.905561849|la chu;
拉上__拉上 340.15949445|la shang;
拉伸__拉伸 320.808632296|la shen;
拉升__拉升 885.781642601|la sheng;
拉屎__拉屎 463.341283758|la shi;
拉手__拉手 128.689786556|la shou;
拉人__拉人 432.109303457|la ren;
腊肉__臘肉 160.049619219|la rou;
拉走__拉走 123.044091616|la zou;
拉萨__拉薩 998.348535653|la sa;
拉丝__拉絲 199.051387821|la si;
拉斯__拉斯 240.263000901|la si;
腊月__臘月 158.461958559|la yue;
来吧__來吧 1474.61550226|lai ba;
来帮__來幫 120.015323434|lai bang;
来宾__來賓 470.908619205|lai bin;
赖皮__賴皮 224.347234118|lai pi;
来买__來買 192.465424888|lai mai;
来访__來訪 702.526765976|lai fang;
来福__來福 105.295633316|lai fu;
来打__來打 173.121277629|lai da;
来到__來到 8805.70682985|lai dao;
来得__來得 1179.78648723|lai de;
来的__來的 3971.32436646|lai de;
来点__來點 282.164331387|lai dian;
来电__來電 1712.47082965|lai dian;
来谈__來談 132.596773978|lai tan;
莱特__萊特 140.244908425|lai te;
来听__來聽 179.940013424|lai ting;
来头__來頭 159.85029497|lai tou;
来拿__來拿 161.653186955|lai na;
来呢__來呢 145.587202159|lai ne;
来年__來年 246.94109417|lai nian;
来啦__來啦 598.94764591|lai la;
来来__來來 203.313241605|lai lai;
来了__來了 14174.3729293|lai le;
来历__來歷 431.033684153|lai li;
来临__來臨 1561.61561744|lai lin;
来稿__來稿 128.689786556|lai gao;
来个__來個 1573.33557614|lai ge;
来给__來給 292.54791482|lai gei;
来过__來過 977.421145723|lai guo;
徕卡__徠卡 116.624293448|lai ka;
莱卡__萊卡 202.807148249|lai ka;
来看__來看 9668.39676357|lai kan;
来客__來客 158.857391092|lai ke;
来华__來華 296.955549433|lai hua;
来函__來函 284.281980745|lai han;
来回__來回 1968.96476223|lai hui;
来讲__來講 3015.29249908|lai jiang;
来接__來接 410.07479966|lai jie;
来劲__來勁 171.617679695|lai jin;
来京__來京 212.907119447|lai jing;
来救__來救 125.522047856|lai jiu;
来去__來去 225.468321935|lai qu;
来袭__來襲 212.377144726|lai xi;
来写__來寫 300.679263607|lai xie;
来信__來信 878.088426229|lai xin;
来抓__來抓 329.725485744|lai zhua;
来找__來找 914.951259653|lai zhao;
赖着__賴着 108.222318063|lai zhe;
来者__來者 118.676811842|lai zhe;
来这__來這 334.69325133|lai zhe;
来着__來着 2451.8263702|lai zhe;
来潮__來潮 141.121478992|lai chao;
来吃__來吃 221.568841736|lai chi;
来生__來生 216.654158472|lai sheng;
来时__來時 286.772667017|lai shi;
来世__來世 297.325836157|lai shi;
来说__來說 20754.48887|lai shuo;
来人__來人 413.667597456|lai ren;
来自__來自 13071.5065595|lai zi;
来作__來作 129.979154132|lai zuo;
来做__來做 1674.48601346|lai zuo;
来此__來此 253.804804573|lai ci;
莱斯__萊斯 112.906187218|lai si;
赖斯__賴斯 294.009808944|lai si;
来源__來源 4914.52006126|lai yuan;
来呀__來呀 130.303509496|lai ya;
来意__來意 108.357265155|lai yi;
赖以__賴以 303.313611771|lai yi;
莱茵__萊茵 115.755545596|lai yin;
来晚__來晚 179.940013424|lai wan;
来玩__來玩 451.935995467|lai wan;
来往__來往 781.025384985|lai wang;
来问__來問 189.845141544|lai wen;
来为__來為 105.295633316|lai wei;
莱芜__萊蕪 109.442917312|lai wu;
来啊__來啊 227.443722742|lai a;
篮板__籃板 613.298247397|lan ban;
蓝宝__藍寶 114.46454262|lan bao;
蓝本__藍本 138.163289429|lan ben;
烂片__爛片 185.172044961|lan pian;
蓝屏__藍屏 513.191745392|lan ping;
烂漫__爛漫 187.4940348|lan man;
懒猫__懶貓 105.0335283|lan mao;
蓝莓__藍莓 138.680779525|lan mei;
蓝魔__藍魔 124.89791921|lan mo;
栏目__欄目 3458.29313278|lan mu;
懒的__懶的 146.132498493|lan de;
兰德__蘭德 155.915530766|lan de;
懒得__懶得 3000.29967146|lan de;
蓝调__藍調 193.90988203|lan diao;
懒惰__懶惰 614.828697239|lan duo;
蓝田__藍田 109.30661816|lan tian;
蓝天__藍天 1035.08753546|lan tian;
蓝图__藍圖 470.32215416|lan tu;
蓝绿__藍綠 112.204874836|lan lv;
蓝蓝__藍藍 203.313241605|lan lan;
懒懒__懶懶 221.292902041|lan lan;
兰兰__蘭蘭 290.730764849|lan lan;
蓝领__藍領 124.742372548|lan ling;
蓝龙__藍龍 139.200207879|lan long;
蓝光__藍光 470.32215416|lan guang;
栏杆__欄杆 410.07479966|lan gan;
兰蔻__蘭蔻 126.937764318|lan kou;
兰花__蘭花 452.499534015|lan hua;
蓝海__藍海 187.027319083|lan hai;
蓝黑__藍黑 116.915322539|lan hei;
蓝军__藍軍 176.827946446|lan jun;
懒觉__懶覺 300.304800557|lan jiao;
拦截__攔截 831.23785106|lan jie;
篮球__籃球 2341.34381449|lan qiu;
拦下__攔下 105.953760973|lan xia;
篮下__籃下 182.196395498|lan xia;
篮协__籃協 128.689786556|lan xie;
蓝星__藍星 143.426288875|lan xing;
拦着__攔着 105.953760973|lan zhe;
兰芝__蘭芝 109.716025699|lan zhi;
兰州__蘭州 1415.20413466|lan zhou;
栏中__欄中 152.077621994|lan zhong;
拦住__攔住 392.573489614|lan zhu;
缆车__纜車 179.71591787|lan che;
蓝筹__藍籌 904.746955463|lan chou;
懒虫__懶蟲 152.077621994|lan chong;
懒人__懶人 440.262469534|lan ren;
蓝藻__藍藻 113.32907693|lan zao;
篮子__籃子 290.368691563|lan zi;
懒散__懶散 336.785179346|lan san;
蓝色__藍色 4387.64638002|lan se;
蓝牙__藍牙 1674.48601346|lan ya;
滥用__濫用 694.691597986|lan yong;
篮网__籃網 114.607273411|lan wang;
栏位__欄位 108.898738333|lan wei;
狼狈__狼狽 374.883606282|lang bei;
浪漫__浪漫 4163.90759438|lang man;
廊坊__廊坊 350.050152834|lang fang;
浪费__浪費 6829.02596639|lang fei;
朗读__朗讀 449.128812644|lang du;
郎朗__郎朗 113.611883002|lang lang;
朗朗__朗朗 186.561765129|lang lang;
朗阁__朗閣 121.520271774|lang ge;
狼狗__狼狗 107.684208225|lang gou;
浪花__浪花 288.924902033|lang hua;
郎君__郎君 120.46484039|lang jun;
狼群__狼群 139.895806636|lang qun;
朗讯__朗訊 188.430963124|lang xun;
郎中__郎中 124.742372548|lang zhong;
浪潮__浪潮 846.921892564|lang chao;
狼人__狼人 133.591915611|lang ren;
浪人__浪人 287.130256264|lang ren;
浪子__浪子 604.195219728|lang zi;
朗诵__朗誦 307.117053725|lang song;
狼王__狼王 117.353228453|lang wang;
老爸__老爸 2759.96781896|lao ba;
老白__老白 205.862715427|lao bai;
老版__老版 208.44415872|lao ban;
老伴__老伴 350.486645516|lao ban;
老板__老闆 16196.1802019|lao ban;
老鸨__老鴇 111.925571131|lao bao;
劳保__勞保 125.209594649|lao bao;
老兵__老兵 427.82286438|lao bing;
老伯__老伯 200.04606951|lao bo;
老牌__老牌 469.151414294|lao pai;
老潘__老潘 130.628674269|lao pan;
老婆__老婆 29641.2261674|lao po;
老马__老馬 588.588831574|lao ma;
老妈__老媽 2485.66700342|lao ma;
老毛__老毛 257.62872122|lao mao;
老猫__老貓 279.713669565|lao mao;
老妹__老妹 143.605133321|lao mei;
老美__老美 435.895152658|lao mei;
劳模__勞模 253.488718522|lao mo;
老母__老母 336.365750338|lao mu;
牢房__牢房 146.679837233|lao fang;
老夫__老夫 361.12732612|lao fu;
老大__老大 8772.84815908|lao da;
老道__老道 206.376433771|lao dao;
唠叨__嘮叨 651.914561431|lao dao;
老弟__老弟 391.596284031|lao di;
老店__老店 130.303509496|lao dian;
老爹__老爹 513.831666385|lao die;
老豆__老豆 232.603161479|lao dou;
劳动__勞動 4823.50867368|lao dong;
老杜__老杜 116.333988795|lao du;
老太__老太 492.515560049|lao tai;
老套__老套 256.028470459|lao tao;
老天__老天 835.391638074|lao tian;
老头__老頭 2216.42096948|lao tou;
老土__老土 263.801426189|lao tu;
老衲__老衲 163.476413088|lao na;
老年__老年 1116.83875458|lao nian;
老蔫__老蔫 4354.9622946|lao nian;
老鸟__老鳥 129.332863581|lao niao;
老娘__老娘 800.735741689|lao niang;
老牛__老牛 457.033213363|lao niu;
老农__老農 157.2815571|lao nong;
劳拉__勞拉 134.594525802|lao la;
老狼__老狼 271.133768339|lao lang;
牢牢__牢牢 799.738513132|lao lao;
姥姥__姥姥 807.751246202|lao lao;
劳累__勞累 553.723632203|lao lei;
劳力__勞力 277.630050085|lao li;
老李__老李 507.468200425|lao li;
老练__老練 171.831677206|lao lian;
老龄__老齡 131.937467932|lao ling;
老六__老六 206.633773476|lao liu;
老刘__老劉 480.991159713|lao liu;
老路__老路 174.855812809|lao lu;
老罗__老羅 253.804804573|lao luo;
老高__老高 267.44247003|lao gao;
老哥__老哥 453.063775264|lao ge;
老歌__老歌 493.744603771|lao ge;
劳工__勞工 496.830647979|lao gong;
老公__老公 14280.7519022|lao gong;
牢固__牢固 529.431458035|lao gu;
老郭__老郭 151.132997772|lao guo;
老鬼__老鬼 150.756793028|lao gui;
老款__老款 228.8653107|lao kuan;
牢靠__牢靠 113.753550575|lao kao;
劳苦__勞苦 127.572086295|lao ku;
老话__老話 224.907079496|lao hua;
老化__老化 834.351249399|lao hua;
老黄__老黃 236.402059204|lao huang;
落汗__落汗 130.46599058|lao han;
老汉__老漢 584.932834985|lao han;
老何__老何 121.671800659|lao he;
老黑__老黑 159.253810404|lao hei;
老胡__老胡 276.938965124|lao hu;
老虎__老虎 2635.59999992|lao hu;
老火__老火 166.560934377|lao huo;
牢记__牢記 503.060722916|lao ji;
老家__老家 2221.95191814|lao jia;
劳教__勞教 147.045868173|lao jiao;
老蒋__老蔣 208.70407676|lao jiang;
老将__老將 414.183417482|lao jiang;
老街__老街 219.918349804|lao jie;
老姐__老姐 419.377126323|lao jie;
老金__老金 130.954650472|lao jin;
老酒__老酒 107.282382453|lao jiu;
老旧__老舊 173.986383704|lao jiu;
捞起__撈起 114.46454262|lao qi;
老七__老七 131.117943492|lao qi;
捞钱__撈錢 113.187937993|lao qian;
老区__老區 308.651751439|lao qu;
老去__老去 324.83145542|lao qu;
老想__老想 131.609045271|lao xiang;
老乡__老鄉 1791.04500392|lao xiang;
老谢__老謝 135.435779871|lao xie;
老兄__老兄 799.738513132|lao xiong;
老徐__老徐 371.164834837|lao xu;
老庄__老莊 129.332863581|lao zhuang;
老张__老張 710.450303909|lao zhang;
老赵__老趙 378.168082664|lao zhao;
老者__老者 386.746622582|lao zhe;
老周__老周 204.329220247|lao zhou;
老猪__老豬 144.682892926|lao zhu;
老朱__老朱 296.216358865|lao zhu;
老陈__老陳 312.132919672|lao chen;
老城__老城 155.527421199|lao cheng;
捞出__撈出 247.557321202|lao chu;
崂山__嶗山 182.878811433|lao shan;
老少__老少 188.430963124|lao shao;
老舍__老舍 152.267254161|lao she;
老式__老式 360.228397261|lao shi;
老实__老實 2482.57137774|lao shi;
老是__老是 4681.38313658|lao shi;
老师__老師 32262.4975474|lao shi;
老手__老手 276.594068012|lao shou;
老树__老樹 146.679837233|lao shu;
老鼠__老鼠 2464.07841638|lao shu;
老说__老說 272.488653616|lao shuo;
老人__老人 6266.36577307|lao ren;
老早__老早 457.033213363|lao zao;
劳资__勞資 488.237949645|lao zi;
老子__老子 7249.97516601|lao zi;
老总__老總 2335.51567197|lao zong;
劳作__勞作 245.101601395|lao zuo;
老蔡__老蔡 119.121315407|lao cai;
老曹__老曹 110.264288753|lao cao;
老孙__老孫 183.563783354|lao sun;
老三__老三 448.56947196|lao san;
牢骚__牢騷 459.889800938|lao sao;
老死__老死 125.835280772|lao si;
老四__老四 296.216358865|lao si;
老宋__老宋 107.416157498|lao song;
老远__老遠 245.407229187|lao yuan;
老杨__老楊 414.699880708|lao yang;
老妖__老妖 171.831677206|lao yao;
姥爷__姥爺 252.54282031|lao ye;
老爷__老爺 746.761352211|lao ye;
烙印__烙印 330.960471347|lao yin;
老鹰__老鷹 295.111021611|lao ying;
老友__老友 309.036622663|lao you;
老外__老外 2376.61936257|lao wai;
老王__老王 771.352901218|lao wang;
老翁__老翁 124.742372548|lao weng;
老挝__老撾 201.547419552|lao wo;
老屋__老屋 112.34478795|lao wu;
老五__老五 230.295783987|lao wu;
老吴__老吳 285.346757867|lao wu;
劳务__勞務 774.242000696|lao wu;
劳尔__勞爾 390.135034682|lao er;
老二__老二 643.841029976|lao er;
了吗__了嗎 5178.59142346|le ma;
乐风__樂風 132.596773978|le feng;
乐得__樂得 227.160466527|le de;
乐天__樂天 219.37092252|le tian;
乐乐__樂樂 861.827215553|le le;
勒令__勒令 162.460985719|le ling;
乐观__樂觀 2564.32477261|le guan;
乐购__樂購 112.204874836|le gou;
乐趣__樂趣 2826.09579953|le qu;
乐山__樂山 356.210827905|le shan;
乐事__樂事 120.015323434|le shi;
乐子__樂子 162.663565352|le zi;
勒索__勒索 255.391156791|le suo;
乐园__樂園 948.621258606|le yuan;
乐意__樂意 1079.88619313|le yi;
了一__了一 2127.12270781|le yi;
乐于__樂於 491.902185928|le yu;
乐网__樂網 113.753550575|le wang;
冷门__冷門 317.230705235|leng men;
冷面__冷麵 151.888225993|leng mian;
冷漠__冷漠 1196.07015327|leng mo;
冷风__冷風 263.472890441|leng feng;
冷淡__冷淡 665.872587905|leng dan;
冷得__冷得 119.56748386|leng de;
冷冻__冷凍 521.573243485|leng dong;
冷暖__冷暖 235.226605969|leng nuan;
冷了__冷了 205.60633599|leng le;
愣了__愣了 333.444336783|leng le;
愣愣__愣愣 113.046974828|leng leng;
冷冷__冷冷 428.356335222|leng leng;
冷落__冷落 493.129699012|leng luo;
冷库__冷庫 111.507918629|leng ku;
冷酷__冷酷 465.65665114|leng ku;
冷汗__冷汗 428.890471272|leng han;
冷峻__冷峻 125.835280772|leng jun;
棱角__稜角 239.963779681|leng jiao;
冷静__冷靜 2516.83636014|leng jing;
冷却__冷卻 894.656458236|leng que;
冷气__冷氣 302.181790975|leng qi;
冷清__冷清 588.588831574|leng qing;
冷血__冷血 340.15949445|leng xue;
冷笑__冷笑 425.69561654|leng xiao;
冷轧__冷軋 119.41857567|leng zha;
冷战__冷戰 517.687984062|leng zhan;
愣住__愣住 157.477678279|leng zhu;
冷场__冷場 120.765453341|leng chang;
愣是__愣是 135.435779871|leng shi;
冷水__冷水 674.222387052|leng shui;
冷热__冷熱 224.347234118|leng re;
冷藏__冷藏 236.696839161|leng cang;
冷月__冷月 217.19480623|leng yue;
冷眼__冷眼 148.889769675|leng yan;
冷艳__冷艷 188.901181552|leng yan;
冷饮__冷飲 267.109399762|leng yin;
类比__類比 218.008308584|lei bi;
类别__類別 2023.69199978|lei bie;
雷曼__雷曼 110.401782066|lei man;
雷鸣__雷鳴 191.747236314|lei ming;
类目__類目 105.0335283|lei mu;
雷锋__雷鋒 586.392500602|lei feng;
雷达__雷達 940.382265783|lei da;
雷德__雷德 120.615053212|lei de;
累得__累得 369.319305625|lei de;
雷电__雷電 329.314848809|lei dian;
擂台__擂台 207.925293333|lei tai;
雷霆__雷霆 364.291279287|lei ting;
雷同__雷同 360.228397261|lei tong;
类推__類推 123.813152185|lei tui;
雷诺__雷諾 296.955549433|lei nuo;
蕾蕾__蕾蕾 132.927661458|lei lei;
累累__累累 252.85772688|lei lei;
泪流__淚流 120.46484039|lei liu;
泪光__淚光 176.168109435|lei guang;
肋骨__肋骨 251.600451735|lei gu;
类库__類庫 168.020228531|lei ku;
泪花__淚花 125.209594649|lei hua;
累坏__累壞 149.075426771|lei huai;
泪痕__淚痕 166.146325956|lei hen;
雷击__雷擊 180.839193473|lei ji;
累积__累積 918.378206258|lei ji;
累计__累計 2815.55016665|lei ji;
累加__累加 158.067510349|lei jia;
类型__類型 9961.92669753|lei xing;
类中__類中 105.690017726|lei zhong;
泪珠__淚珠 151.510141313|lei zhu;
累赘__累贅 215.845709156|lei zhui;
雷神__雷神 132.266710153|lei shen;
雷声__雷聲 191.508436159|lei sheng;
泪水__淚水 1859.27057168|lei shui;
累人__累人 143.0692679|lei ren;
雷斯__雷斯 134.42690308|lei si;
蕾丝__蕾絲 295.111021611|lei si;
累死__累死 1538.43695969|lei si;
类似__類似 9680.45270584|lei si;
泪眼__淚眼 193.186303435|lei yan;
雷雨__雷雨 261.184568064|lei yu;
篱笆__籬笆 246.326401069|li ba;
李白__李白 728.379591714|li bai;
礼拜__禮拜 3015.29249908|li bai;
礼包__禮包 167.393257695|li bao;
利弊__利弊 284.281980745|li bi;
里边__裡邊 1284.11889697|li bian;
离别__離別 682.676889633|li bie;
李斌__李斌 127.890434962|li bin;
李鹏__李鵬 231.158356006|li peng;
理赔__理賠 355.767206381|li pei;
里皮__里皮 123.351140937|li pi;
礼品__禮品 1687.0530669|li pin;
李平__李平 108.898738333|li ping;
离谱__離譜 706.037369534|li pu;
立马__立馬 1166.62851836|li ma;
礼貌__禮貌 1252.50991514|li mao;
厘米__厘米 1348.06912745|li mi;
立面__立面 204.584007193|li mian;
里面__裡面 40932.4557344|li mian;
李敏__李敏 120.164975734|li min;
利民__利民 176.827946446|li min;
李明__李明 408.544597361|li ming;
黎明__黎明 1258.76884501|li ming;
李某__李某 483.394725468|li mou;
理发__理髮 481.590928402|li fa;
立法__立法 2379.58287209|li fa;
力帆__力帆 246.326401069|li fan;
里放__里放 153.792848894|li fang;
立方__立方 281.812926654|li fang;
礼服__禮服 499.935980841|li fu;
历代__歷代 531.41444163|li dai;
力道__力道 205.350275845|li dao;
李德__李德 136.452228303|li de;
离得__離得 279.365316864|li de;
离地__離地 115.611384758|li di;
里都__里都 129.010924378|li dou;
李东__李東 113.32907693|li dong;
粒度__粒度 188.196293023|li du;
力度__力度 5217.45686316|li du;
利多__利多 129.332863581|li duo;
离队__離隊 145.043940608|li dui;
离他__離他 136.452228303|li ta;
理他__理他 371.627656329|li ta;
礼堂__禮堂 283.927938713|li tang;
李涛__李濤 119.86585751|li tao;
例题__例題 129.332863581|li ti;
立体__立體 1024.81967123|li ti;
李天__李天 173.986383704|li tian;
李铁__李鐵 184.71110921|li tie;
力挺__力挺 277.284292303|li ting;
里头__裡頭 961.714332594|li tou;
力图__力圖 341.859308876|li tu;
力推__力推 195.852702213|li tui;
厉娜__厲娜 161.653186955|li na;
丽娜__麗娜 180.164388413|li na;
李娜__李娜 276.249600432|li na;
李楠__李楠 125.522047856|li nan;
离你__離你 290.730764849|li ni;
理你__理你 312.911829085|li ni;
历年__歷年 517.043260448|li nian;
理念__理念 4769.71285751|li nian;
利尿__利尿 150.569041974|li niao;
李宁__李寧 406.006938516|li ning;
理论__理論 11568.7844394|li lun;
利率__利率 2632.31764915|li lv;
历来__歷來 738.432842998|li lai;
离了__離了 240.263000901|li le;
李磊__李磊 113.47039186|li lei;
李丽__李麗 163.884358899|li li;
莉莉__莉莉 363.384474622|li li;
丽丽__麗麗 427.290057918|li li;
历练__歷練 301.805456692|li lian;
理疗__理療 215.30841961|li liao;
力量__力量 11411.2834586|li liang;
莅临__蒞臨 169.070402749|li lin;
里路__里路 107.015331962|li lu;
利落__利落 151.699065864|li luo;
李广__李廣 144.863304286|li guang;
理光__理光 211.848489234|li guang;
李刚__李剛 182.651055928|li gang;
离歌__離歌 128.529517539|li ge;
里根__里根 122.584950132|li gen;
立功__立功 225.749468142|li gong;
理工__理工 847.977956119|li gong;
立国__立國 127.096048509|li guo;
李国__李國 170.76435144|li guo;
离开__離開 15543.6458876|li kai;
里看__里看 131.117943492|li kan;
里克__里克 126.779677253|li ke;
力克__力克 143.247667161|li ke;
理科__理科 726.566487616|li ke;
立刻__立刻 4932.92737822|li ke;
利空__利空 807.751246202|li kong;
李逵__李逵 121.520271774|li kui;
理化__理化 129.494134325|li hua;
李华__李華 130.628674269|li hua;
丽华__麗華 160.049619219|li hua;
梨花__梨花 442.462509543|li hua;
罹患__罹患 132.266710153|li huan;
离婚__離婚 3406.96257996|li hun;
李海__李海 105.690017726|li hai;
里还__里還 117.792774542|li hai;
利害__利害 240.562595233|li hai;
厉害__厲害 13368.0266678|li hai;
利好__利好 1476.45426414|li hao;
礼盒__禮盒 206.119414554|li he;
离合__離合 232.603161479|li he;
李红__李紅 111.369047744|li hong;
力宏__力宏 129.817279349|li hong;
李辉__李輝 112.34478795|li hui;
例会__例會 604.195219728|li hui;
理会__理會 953.361623425|li hui;
丽娟__麗娟 112.765574943|li juan;
李军__李軍 151.321452046|li jun;
李俊__李俊 213.971039752|li jun;
立即__立即 6863.15136064|li ji;
李佳__李佳 107.416157498|li jia;
例假__例假 207.666345181|li jia;
李家__李家 261.510250403|li jia;
离家__離家 595.22730595|li jia;
李建__李建 136.452228303|li jian;
李健__李健 154.368879448|li jian;
利剑__利劍 157.870654598|li jian;
立交__立交 215.30841961|li jiao;
漓江__灕江 226.312812713|li jiang;
丽江__麗江 1073.17852213|li jiang;
李杰__李傑 159.85029497|li jie;
礼节__禮節 247.866011137|li jie;
历届__歷屆 365.655730945|li jie;
理解__理解 17345.1786635|li jie;
历尽__歷盡 127.73116145|li jin;
礼金__禮金 160.449013667|li jin;
李静__李靜 201.547419552|li jing;
历经__歷經 824.018360007|li jing;
里就__里就 145.405889264|li jiu;
里奇__里奇 150.194241046|li qi;
离奇__離奇 445.228026075|li qi;
利器__利器 452.499534015|li qi;
力气__力氣 1820.2965272|li qi;
力强__力強 148.149450567|li qiang;
李强__李強 280.411678639|li qiang;
理清__理清 243.882891747|li qing;
沥青__瀝青 320.409100324|li qing;
立秋__立秋 130.791560815|li qiu;
力求__力求 812.799921236|li qiu;
里去__里去 421.472799973|li qu;
离去__離去 1607.02198372|li qu;
理学__理學 199.051387821|li xue;
力学__力學 469.151414294|li xue;
利息__利息 2054.18168866|li xi;
立下__立下 283.221176861|li xia;
离线__離線 859.681929668|li xian;
李晓__李曉 134.762357541|li xiao;
李小__李小 179.492101402|li xiao;
离校__離校 281.812926654|li xiao;
李湘__李湘 509.368920718|li xiang;
立项__立項 768.474582473|li xiang;
理想__理想 7677.71288718|li xiang;
立新__立新 129.655606164|li xin;
离心__離心 174.42055653|li xin;
例行__例行 412.637883794|li xing;
理性__理性 3722.14075882|li xing;
离休__離休 106.882056102|li xiu;
李秀__李秀 112.34478795|li xiu;
李旭__李旭 168.859844103|li xu;
立着__立着 119.121315407|li zhe;
例证__例證 201.045721733|li zheng;
力争__力爭 1090.70577937|li zheng;
李志__李志 154.561368684|li zhi;
励志__勵志 383.865702254|li zhi;
立志__立志 439.166555128|li zhi;
荔枝__荔枝 570.534533242|li zhi;
离职__離職 1526.97696483|li zhi;
理智__理智 1824.83897052|li zhi;
立柱__立柱 177.269210225|li zhu;
利差__利差 184.481071779|li cha;
离场__離場 300.679263607|li chang;
立场__立場 3221.16683052|li chang;
李成__李成 123.044091616|li cheng;
里程__里程 512.55262135|li cheng;
历程__歷程 1175.38409041|li cheng;
理顺__理順 395.519762073|li shun;
丽莎__麗莎 119.26985293|li sha;
厉声__厲聲 112.906187218|li sheng;
李氏__李氏 143.784200776|li shi;
力士__力士 145.224802174|li shi;
立式__立式 176.387781073|li shi;
立时__立時 193.186303435|li shi;
理事__理事 388.195180646|li shi;
历时__歷時 560.667124391|li shi;
历史__歷史 19769.9293101|li shi;
隶书__隸書 114.75018218|li shu;
隶属__隸屬 485.205278648|li shu;
里说__里說 194.393772779|li shuo;
利税__利稅 142.180598718|li shui;
丽水__麗水 272.828431509|li shui;
利润__利潤 7488.72362169|li run;
利刃__利刃 108.087539034|li ren;
离任__離任 142.713135632|li ren;
丽人__麗人 172.905674062|li ren;
历任__歷任 305.97104031|li ren;
例如__例如 5355.79733551|li ru;
梨子__梨子 142.535402072|li zi;
黎姿__黎姿 188.196293023|li zi;
李子__李子 220.742053181|li zi;
栗子__栗子 254.755429543|li zi;
离子__離子 658.446218066|li zi;
粒子__粒子 738.432842998|li zi;
例子__例子 4426.08796739|li zi;
李总__李總 416.253137598|li zong;
立足__立足 1227.78386251|li zu;
力作__力作 261.184568064|li zuo;
理睬__理睬 304.449671797|li cai;
理财__理財 2599.71813289|li cai;
历次__歷次 227.160466527|li ci;
离散__離散 316.046952528|li san;
李斯__李斯 119.716577729|li si;
利斯__利斯 123.197520618|li si;
李四__李四 148.149450567|li si;
里斯__里斯 186.097370046|li si;
利索__利索 212.112652282|li suo;
李元__李元 111.646962678|li yuan;
梨园__梨園 120.46484039|li yuan;
李云__李雲 117.792774542|li yun;
力压__力壓 123.504952812|li ya;
里亚__里亞 158.461958559|li ya;
利亚__利亞 250.349428094|li ya;
李阳__李陽 193.427195796|li yang;
立业__立業 108.627664361|li ye;
里也__里也 190.556205829|li ye;
立意__立意 189.372573382|li yi;
离异__離異 237.583386308|li yi;
李毅__李毅 246.633556117|li yi;
礼仪__禮儀 940.382265783|li yi;
利益__利益 10562.8203485|li yi;
理应__理應 434.810109507|li ying;
里有__里有 1458.16935282|li you;
理由__理由 8805.70682985|li you;
李勇__李勇 163.272821143|li yong;
李咏__李詠 260.859291326|li yong;
利用__利用 17431.85443|li yong;
礼遇__禮遇 109.989815613|li yu;
李玉__李玉 178.822323044|li yu;
立于__立於 185.172044961|li yu;
鲤鱼__鯉魚 306.734573113|li yu;
利于__利於 5309.28100941|li yu;
里外__裡外 151.132997772|li wai;
例外__例外 1199.05487625|li wai;
李文__李文 252.85772688|li wen;
立委__立委 122.432284019|li wei;
李伟__李偉 277.630050085|li wei;
离我__離我 723.855290267|li wo;
里屋__裡屋 158.264611567|li wu;
礼物__禮物 3917.25753809|li wu;
离岸__離岸 130.303509496|li an;
立案__立案 604.195219728|li an;
李安__李安 670.034480971|li an;
里昂__里昂 237.583386308|li ang;
里奥__里奧 133.591915611|li ao;
李敖__李敖 480.991159713|li ao;
俩人__倆人 485.205278648|lia ren;
连败__連敗 232.603161479|lian bai;
联邦__聯邦 1044.15627174|lian bang;
联保__聯保 179.71591787|lian bao;
链表__鏈表 195.121873946|lian biao;
练兵__練兵 153.984619852|lian bing;
联播__聯播 108.898738333|lian bo;
脸部__臉部 713.111292931|lian bu;
连拍__連拍 137.476305203|lian pai;
脸庞__臉龐 530.752623218|lian pang;
脸盆__臉盆 174.203334854|lian pen;
莲蓬__蓮蓬 113.046974828|lian peng;
脸皮__臉皮 645.447697543|lian pi;
连篇__連篇 106.748946222|lian pian;
脸谱__臉譜 113.32907693|lian pu;
连忙__連忙 947.439854855|lian mang;
联盟__聯盟 5114.45798754|lian meng;
联袂__聯袂 194.393772779|lian mei;
连绵__連綿 210.008536601|lian mian;
脸面__臉面 230.870473623|lian mian;
怜悯__憐憫 368.399985048|lian min;
联名__聯名 293.643651968|lian ming;
连发__連發 142.003528374|lian fa;
联防__聯防 135.267109459|lian fang;
联大__聯大 144.863304286|lian da;
连带__連帶 315.653350706|lian dai;
脸蛋__臉蛋 570.534533242|lian dan;
连到__連到 130.141230764|lian dao;
练到__練到 226.030964922|lian dao;
镰刀__鐮刀 235.813600182|lian dao;
练得__練得 162.86639759|lian de;
联动__聯動 799.738513132|lian dong;
联队__聯隊 173.337150041|lian dui;
连队__連隊 216.924313917|lian dui;
连体__連體 123.351140937|lian ti;
连天__連天 201.79873775|lian tian;
联调__聯調 170.127140854|lian tiao;
链条__鏈條 520.923681206|lian tiao;
连通__連通 269.449631503|lian tong;
连同__連同 614.062995519|lian tong;
联通__聯通 3402.71958168|lian tong;
连年__連年 225.468321935|lian nian;
连累__連累 239.664931108|lian lei;
恋恋__戀戀 161.451865638|lian lian;
练练__練練 517.687984062|lian lian;
连连__連連 851.15405446|lian lian;
链路__鏈路 455.327784806|lian lu;
联络__聯絡 1891.99263098|lian luo;
连贯__連貫 259.562230298|lian guan;
连杆__連桿 125.992190229|lian gan;
炼钢__鍊鋼 132.10198647|lian gang;
恋歌__戀歌 305.209408115|lian ge;
连个__連個 804.737106306|lian ge;
练功__練功 304.070513117|lian gong;
练过__練過 171.190483873|lian guo;
联考__聯考 160.849404779|lian kao;
脸孔__臉孔 175.510734618|lian kong;
炼化__煉化 125.992190229|lian hua;
联华__聯華 130.628674269|lian hua;
莲花__蓮花 938.041438335|lian hua;
连环__連環 366.568203397|lian huan;
练好__練好 155.140277726|lian hao;
联合__聯合 7010.09707109|lian he;
脸红__臉紅 769.432826682|lian hong;
联军__聯軍 295.479008313|lian jun;
连击__連擊 170.551683166|lian ji;
联机__聯機 555.797602048|lian ji;
练级__練級 1951.86385246|lian ji;
脸颊__臉頰 558.574983827|lian jia;
廉价__廉價 1212.57856995|lian jia;
联结__聯結 202.554574186|lian jie;
连结__連結 259.885889675|lian jie;
联接__聯接 281.461959558|lian jie;
廉洁__廉潔 335.110594827|lian jie;
连接__連接 9418.66166506|lian jie;
链接__鏈接 11439.7596478|lian jie;
炼金__煉金 370.240920313|lian jin;
练就__練就 207.925293333|lian jiu;
恋情__戀情 854.342048866|lian qing;
怜惜__憐惜 251.600451735|lian xi;
练习__練習 4459.30585251|lian xi;
联系__聯繫 32464.1473334|lian xi;
连线__連線 669.200026501|lian xian;
联想__聯想 5013.49243365|lian xiang;
脸型__臉型 287.846772995|lian xing;
连续__連續 9290.4331154|lian xu;
连战__連戰 450.811022973|lian zhan;
连长__連長 332.200082586|lian zhang;
连着__連着 620.215410078|lian zhe;
廉政__廉政 406.006938516|lian zheng;
联众__聯眾 294.009808944|lian zhong;
联创__聯創 133.259374649|lian chuang;
练车__練車 156.109948588|lian che;
连城__連城 114.46454262|lian cheng;
练成__練成 149.820373083|lian cheng;
联城__聯城 158.659551632|lian cheng;
连成__連成 163.680258901|lian cheng;
炼成__煉成 184.941433485|lian cheng;
廉耻__廉恥 124.742372548|lian chi;
恋上__戀上 184.941433485|lian shang;
连上__連上 364.291279287|lian shang;
脸上__臉上 5946.82564905|lian shang;
联社__聯社 172.690339006|lian she;
连声__連聲 180.389043185|lian sheng;
连胜__連勝 478.599545119|lian sheng;
联手__聯手 1306.71862793|lian shou;
连任__連任 212.112652282|lian ren;
恋人__戀人 1271.38069074|lian ren;
连日__連日 116.18910757|lian ri;
连载__連載 663.387871054|lian zai;
帘子__帘子 136.452228303|lian zi;
莲子__蓮子 271.133768339|lian zi;
链子__鏈子 295.479008313|lian zi;
敛财__斂財 164.293322714|lian cai;
联赛__聯賽 2548.39656922|lian sai;
脸色__臉色 1744.7822355|lian se;
连锁__連鎖 1184.20537322|lian suo;
连夜__連夜 404.996293994|lian ye;
联谊__聯誼 247.249015706|lian yi;
涟漪__漣漪 314.475483928|lian yi;
联姻__聯姻 190.556205829|lian yin;
联营__聯營 157.870654598|lian ying;
炼油__煉油 282.868455943|lian you;
炼狱__煉獄 146.497163581|lian yu;
联网__聯網 855.407364934|lian wang;
连我__連我 347.442588754|lian wo;
怜爱__憐愛 148.704343794|lian ai;
恋爱__戀愛 4051.3019409|lian ai;
聊吧__聊吧 167.184787749|liao ba;
疗法__療法 1140.75119008|liao fa;
了断__了斷 107.952927857|liao duan;
聊到__聊到 274.191785204|liao dao;
料到__料到 431.571158705|liao dao;
了得__了得 130.954650472|liao de;
聊得__聊得 289.645897197|liao de;
辽东__遼東 123.351140937|liao dong;
聊天__聊天 12591.8501986|liao tian;
辽宁__遼寧 2001.12208851|liao ning;
料理__料理 597.456727653|liao li;
寥寥__寥寥 272.488653616|liao liao;
聊聊__聊聊 2532.56730325|liao liao;
嘹亮__嘹亮 109.852835359|liao liang;
聊过__聊過 356.210827905|liao guo;
辽阔__遼闊 265.119670945|liao kuo;
了结__了結 277.976239008|liao jie;
了解__了解 31001.2696965|liao jie;
料酒__料酒 123.813152185|liao jiu;
聊起__聊起 205.60633599|liao qi;
疗效__療效 1279.32718167|liao xiao;
聊斋__聊齋 126.621787068|liao zhai;
聊着__聊着 257.62872122|liao zhe;
聊城__聊城 167.184787749|liao cheng;
疗程__療程 523.526794166|liao cheng;
疗伤__療傷 228.011295226|liao shang;
了然__瞭然 137.134095104|liao ran;
缭绕__繚繞 216.384339476|liao rao;
撩人__撩人 152.837570606|liao ren;
料子__料子 119.56748386|liao zi;
辽足__遼足 223.231720645|liao zu;
辽阳__遼陽 136.282292017|liao yang;
疗养__療養 228.295612376|liao yang;
两把__兩把 331.786363812|liang ba;
两百__兩百 593.006203378|liang bai;
两半__兩半 207.407719521|liang ban;
凉拌__涼拌 232.603161479|liang ban;
两包__兩包 113.046974828|liang bao;
两本__兩本 410.07479966|liang ben;
两杯__兩杯 182.423584067|liang bei;
两倍__兩倍 568.405572245|liang bei;
量比__量比 105.821807183|liang bi;
两笔__兩筆 116.769717326|liang bi;
量变__量變 117.207077876|liang bian;
两遍__兩遍 314.083839199|liang bian;
两边__兩邊 1771.06976716|liang bian;
量表__量表 130.791560815|liang biao;
两步__兩步 366.111682898|liang bu;
两部__兩部 855.407364934|liang bu;
两排__兩排 139.547573842|liang pai;
两派__兩派 152.837570606|liang pai;
两盘__兩盤 125.678566729|liang pan;
两旁__兩旁 445.783200166|liang pang;
凉皮__涼皮 151.699065864|liang pi;
两片__兩片 335.528458728|liang pian;
两篇__兩篇 429.425273358|liang pian;
两瓶__兩瓶 273.850309404|liang ping;
两门__兩門 261.510250403|liang men;
两枚__兩枚 121.217779906|liang mei;
两米__兩米 151.699065864|liang mi;
两面__兩面 520.274927886|liang mian;
良民__良民 188.901181552|liang min;
两名__兩名 2016.1405527|liang ming;
两罚__兩罰 127.73116145|liang fa;
两房__兩房 145.950506492|liang fang;
良方__良方 164.293322714|liang fang;
两方__兩方 165.939408926|liang fang;
两分__兩分 217.736803143|liang fen;
凉粉__涼粉 448.56947196|liang fen;
两份__兩份 626.429466854|liang fen;
凉风__涼風 228.011295226|liang feng;
两幅__兩幅 138.85370659|liang fu;
两段__兩段 305.589986932|liang duan;
两端__兩端 493.744603771|liang duan;
量大__量大 383.387639617|liang da;
两大__兩大 2241.4191567|liang da;
两代__兩代 182.651055928|liang dai;
两党__兩黨 231.158356006|liang dang;
两道__兩道 347.875829952|liang dao;
两地__兩地 1050.68254543|liang di;
两点__兩點 1603.0217369|liang dian;
亮点__亮點 2183.52320481|liang dian;
两度__兩度 229.150692759|liang du;
亮度__亮度 822.992135502|liang du;
良多__良多 142.891090816|liang duo;
两对__兩對 118.676811842|liang dui;
两队__兩隊 522.223615731|liang dui;
两台__兩台 941.55486912|liang tai;
两套__兩套 675.063104121|liang tao;
良田__良田 116.769717326|liang tian;
两天__兩天 7169.11735945|liang tian;
两条__兩條 2283.71091596|liang tiao;
两头__兩頭 576.250827814|liang tou;
两腿__兩腿 235.519920202|liang tui;
靓女__靚女 672.544092675|liang nv;
两难__兩難 283.927938713|liang nan;
量能__量能 241.463621556|liang neng;
两年__兩年 6627.80750717|liang nian;
两轮__兩輪 239.366454718|liang lun;
凉了__涼了 227.727332161|liang le;
亮了__亮了 309.036622663|liang le;
两类__兩類 662.561694208|liang lei;
两粒__兩粒 105.690017726|liang li;
靓丽__靚麗 498.070459751|liang li;
亮丽__亮麗 504.944935018|liang li;
凉凉__涼涼 162.460985719|liang liang;
两辆__兩輛 314.867617017|liang liang;
亮亮__亮亮 409.054029297|liang liang;
两路__兩路 186.794397067|liang lu;
亮光__亮光 186.561765129|liang guang;
晾干__晾乾 141.29744947|liang gan;
两个__兩個 39430.4473261|liang ge;
两根__兩根 507.468200425|liang gen;
两国__兩國 2665.32595143|liang guo;
两款__兩款 1093.42757174|liang kuan;
两块__兩塊 1058.56794047|liang kuai;
凉快__涼快 1200.55002966|liang kuai;
两颗__兩顆 511.914293268|liang ke;
两口__兩口 252.85772688|liang kou;
量化__量化 649.481929235|liang hua;
两行__兩行 292.54791482|liang hang;
良好__良好 9753.10471102|liang hao;
两会__兩會 574.81640715|liang hui;
两军__兩軍 161.250795044|liang jun;
两季__兩季 114.179614083|liang ji;
两集__兩集 154.947067523|liang ji;
两极__兩極 163.272821143|liang ji;
良机__良機 365.20034683|liang ji;
两级__兩級 585.662213047|liang ji;
两架__兩架 109.034528882|liang jia;
粮价__糧價 161.854759309|liang jia;
两家__兩家 2161.86308522|liang jia;
两间__兩間 208.964318904|liang jian;
亮剑__亮劍 223.231720645|liang jian;
两件__兩件 790.819158167|liang jian;
两脚__兩腳 230.008975843|liang jiao;
两节__兩節 206.119414554|liang jie;
两届__兩屆 243.275811214|liang jie;
谅解__諒解 711.336195135|liang jie;
良久__良久 252.85772688|liang jiu;
两居__兩居 105.690017726|liang ju;
两句__兩句 1436.52612129|liang ju;
两圈__兩圈 129.171793682|liang quan;
两期__兩期 152.647228173|liang qi;
亮起__亮起 170.339279748|liang qi;
两起__兩起 178.822323044|liang qi;
两千__兩千 784.92825478|liang qian;
踉跄__踉蹌 105.295633316|liang qiang;
两球__兩球 151.132997772|liang qiu;
凉席__涼席 142.891090816|liang xi;
两下__兩下 530.091629029|liang xia;
两相__兩相 148.889769675|liang xiang;
两厢__兩廂 359.331706043|liang xiang;
两项__兩項 962.913535809|liang xiang;
亮相__亮相 2263.87636378|liang xiang;
凉鞋__涼鞋 309.807805448|liang xie;
良心__良心 1511.82965446|liang xin;
量刑__量刑 181.742866823|liang xing;
两性__兩性 347.875829952|liang xing;
良性__良性 741.198640518|liang xing;
两站__兩站 107.550099352|liang zhan;
两张__兩張 1986.21549859|liang zhang;
靓照__靚照 115.899886195|liang zhao;
亮着__亮着 204.07475061|liang zhe;
两者__兩者 2561.13118731|liang zhe;
两支__兩支 404.996293994|liang zhi;
良知__良知 639.044983668|liang zhi;
两只__兩隻 2072.17903804|liang zhi;
两周__兩周 1217.12027856|liang zhou;
良种__良種 375.819106356|liang zhong;
两种__兩種 5389.27259219|liang zhong;
梁祝__梁祝 142.003528374|liang zhu;
凉茶__涼茶 231.735198139|liang cha;
量产__量產 395.519762073|liang chan;
两场__兩場 604.195219728|liang chang;
两车__兩車 117.792774542|liang che;
辆车__輛車 665.872587905|liang che;
两成__兩成 202.554574186|liang cheng;
亮出__亮出 227.160466527|liang chu;
两处__兩處 310.968189453|liang chu;
两双__兩雙 195.365179853|liang shuang;
凉爽__涼爽 429.960742313|liang shuang;
晾晒__晾曬 120.015323434|liang shai;
梁山__梁山 242.066179876|liang shan;
量少__量少 146.497163581|liang shao;
量身__量身 307.500011268|liang shen;
两省__兩省 182.423584067|liang sheng;
两声__兩聲 304.829303266|liang sheng;
两市__兩市 872.634214191|liang shi;
粮食__糧食 3011.53728293|liang shi;
两首__兩首 287.130256264|liang shou;
两手__兩手 652.727461906|liang shou;
凉水__涼水 317.230705235|liang shui;
两人__兩人 7803.10604967|liang ren;
两日__兩日 276.594068012|liang ri;
靓仔__靚仔 179.045304336|liang zai;
两字__兩字 221.292902041|liang zi;
量子__量子 346.1460998|liang zi;
两组__兩組 528.113581536|liang zu;
两座__兩座 310.968189453|liang zuo;
凉菜__涼菜 120.314814642|liang cai;
粮仓__糧倉 140.244908425|liang cang;
粮草__糧草 107.14877401|liang cao;
两侧__兩側 1308.34803192|liang ce;
两层__兩層 498.070459751|liang ceng;
两次__兩次 5902.52705689|liang ci;
两三__兩三 804.737106306|liang san;
两艘__兩艘 107.684208225|liang sou;
两岁__兩歲 373.484720623|liang sui;
两元__兩元 113.046974828|liang yuan;
两月__兩月 183.335174792|liang yue;
两眼__兩眼 603.442760838|liang yan;
两样__兩樣 635.075580657|liang yang;
良药__良藥 207.666345181|liang yao;
两页__兩頁 130.791560815|liang ye;
两亿__兩億 114.607273411|liang yi;
两翼__兩翼 145.043940608|liang yi;
凉意__涼意 177.048440864|liang yi;
靓颖__靚穎 334.69325133|liang ying;
粮油__糧油 403.988165198|liang you;
两用__兩用 214.772467501|liang yong;
两万__兩萬 625.649317648|liang wan;
两委__兩委 106.616002115|liang wei;
量为__量為 173.553291634|liang wei;
两位__兩位 3863.92679211|liang wei;
两岸__兩岸 2049.06835863|liang an;
猎豹__獵豹 131.609045271|lie bao;
列表__列表 4829.52331536|lie biao;
列明__列明 109.30661816|lie ming;
裂缝__裂縫 533.404852483|lie feng;
列队__列隊 112.484875527|lie dui;
猎头__獵頭 619.442999798|lie tou;
列宁__列寧 323.619340361|lie ning;
裂开__裂開 206.633773476|lie kai;
裂痕__裂痕 204.839111844|lie hen;
烈火__烈火 401.979429753|lie huo;
裂解__裂解 131.773154284|lie jie;
列举__列舉 752.365812175|lie ju;
猎奇__獵奇 143.247667161|lie qi;
猎枪__獵槍 124.431860131|lie qiang;
列强__列強 238.176261728|lie qiang;
列席__列席 178.377193209|lie xi;
列传__列傳 110.264288753|lie zhuan;
列支__列支 105.690017726|lie zhi;
劣质__劣質 525.487661863|lie zhi;
列车__列車 1682.85360433|lie che;
列出__列出 1454.53963438|lie chu;
猎杀__獵殺 126.306596357|lie sha;
烈士__烈士 538.078184713|lie shi;
劣势__劣勢 564.874943184|lie shi;
猎手__獵手 185.634130949|lie shou;
猎人__獵人 3118.47261385|lie ren;
烈日__烈日 340.15949445|lie ri;
列入__列入 1729.62840231|lie ru;
咧嘴__咧嘴 112.204874836|lie zui;
烈焰__烈焰 208.184564378|lie yan;
裂纹__裂紋 260.859291326|lie wen;
列为__列為 1103.00744393|lie wei;
猎物__獵物 331.37316028|lie wu;
淋巴__淋巴 219.097720093|lin ba;
林彪__林彪 567.697685436|lin biao;
淋病__淋病 112.065135969|lin bing;
鳞片__鱗片 175.073848088|lin pian;
临摹__臨摹 138.85370659|lin mo;
林木__林木 379.111778956|lin mu;
临汾__臨汾 138.85370659|lin fen;
临风__臨風 130.954650472|lin feng;
林峰__林峰 202.302314677|lin feng;
林丹__林丹 236.991986692|lin dan;
林地__林地 257.94996962|lin di;
琳娜__琳娜 113.611883002|lin na;
邻里__鄰里 216.384339476|lin li;
淋漓__淋漓 228.011295226|lin li;
林立__林立 353.557372243|lin li;
凛冽__凜冽 126.937764318|lin lie;
琳琳__琳琳 203.060037258|lin lin;
临港__臨港 117.499561272|lin gang;
邻国__鄰國 275.561951728|lin guo;
林肯__林肯 350.486645516|lin ken;
临海__臨海 195.852702213|lin hai;
林海__林海 227.727332161|lin hai;
林家__林家 132.927661458|lin jia;
邻家__鄰家 186.097370046|lin jia;
林间__林間 141.650048976|lin jian;
临江__臨江 166.146325956|lin jiang;
临街__臨街 170.551683166|lin jie;
临界__臨界 211.057972369|lin jie;
邻近__鄰近 338.468131949|lin jin;
临近__臨近 1057.24961018|lin jin;
邻居__鄰居 2278.02623496|lin ju;
林奇__林奇 105.295633316|lin qi;
林区__林區 181.516526012|lin qu;
遴选__遴選 158.067510349|lin xuan;
林夕__林夕 236.991986692|lin xi;
临行__臨行 123.813152185|lin xing;
拎着__拎着 339.31275934|lin zhe;
林中__林中 201.296414343|lin zhong;
临终__臨終 259.238974004|lin zhong;
临床__臨床 3076.0167709|lin chuang;
临场__臨場 177.490254874|lin chang;
林场__林場 201.296414343|lin chang;
林冲__林沖 138.85370659|lin chong;
淋湿__淋濕 162.258658377|lin shi;
临时__臨時 4890.08377452|lin shi;
临睡__臨睡 135.435779871|lin shui;
林子__林子 416.253137598|lin zi;
临走__臨走 440.811451858|lin zou;
林总__林總 129.979154132|lin zong;
磷酸__磷酸 253.173026121|lin suan;
吝啬__吝嗇 408.035799866|lin se;
临死__臨死 254.755429543|lin si;
林业__林業 1066.51251556|lin ye;
临沂__臨沂 378.63963681|lin yi;
淋雨__淋雨 198.555903198|lin yu;
淋浴__淋浴 277.976239008|lin yu;
临安__臨安 233.474375771|lin an;
领班__領班 148.149450567|ling ban;
令牌__令牌 166.97657743|ling pai;
领跑__領跑 211.321149687|ling pao;
灵敏__靈敏 407.020105042|ling min;
陵墓__陵墓 213.438416689|ling mu;
铃木__鈴木 330.548296374|ling mu;
领带__領帶 518.979844093|ling dai;
铃铛__鈴鐺 222.67604562|ling dang;
领到__領到 409.054029297|ling dao;
领导__領導 20395.5394721|ling dao;
领地__領地 337.205131359|ling di;
零点__零點 465.65665114|ling dian;
灵动__靈動 323.619340361|ling dong;
零度__零度 150.569041974|ling du;
领队__領隊 499.935980841|ling dui;
令他__令他 433.727767276|ling ta;
灵堂__靈堂 140.070248771|ling tang;
聆听__聆聽 905.87512359|ling ting;
领头__領頭 184.941433485|ling tou;
零头__零頭 186.32942291|ling tou;
灵通__靈通 391.108593802|ling tong;
领土__領土 641.438524323|ling tu;
岭南__嶺南 322.411748334|ling nan;
令你__令你 292.54791482|ling ni;
凌乱__凌亂 392.573489614|ling luan;
领略__領略 579.130416613|ling lue;
另类__另類 1241.63157975|ling lei;
伶俐__伶俐 116.044406778|ling li;
灵力__靈力 154.561368684|ling li;
凌厉__凌厲 216.384339476|ling li;
玲玲__玲玲 291.456266438|ling ling;
玲珑__玲瓏 551.657401419|ling long;
灵光__靈光 279.017397997|ling guang;
灵感__靈感 1287.32334043|ling gan;
领口__領口 156.304608838|ling kou;
凌空__凌空 243.57916235|ling kong;
灵魂__靈魂 4174.29838181|ling hun;
领航__領航 145.224802174|ling hang;
令狐__令狐 158.067510349|ling hu;
灵活__靈活 2722.39277029|ling huo;
领会__領會 724.757896749|ling hui;
领军__領軍 253.488718522|ling jun;
另加__另加 121.368931601|ling jia;
凌驾__凌駕 140.244908425|ling jia;
零件__零件 1187.16048834|ling jian;
领教__領教 216.924313917|ling jiao;
领奖__領獎 302.558594526|ling jiang;
另据__另據 308.651751439|ling ju;
令其__令其 200.04606951|ling qi;
灵气__靈氣 395.027185582|ling qi;
零钱__零錢 301.805456692|ling qian;
灵巧__靈巧 228.295612376|ling qiao;
领情__領情 139.373782642|ling qing;
领取__領取 1768.86409398|ling qu;
灵犀__靈犀 117.93965545|ling xi;
零下__零下 222.121753798|ling xia;
领衔__領銜 247.249015706|ling xian;
领先__領先 3335.54580332|ling xian;
菱形__菱形 147.596627936|ling xing;
灵性__靈性 355.324137339|ling xing;
零星__零星 393.063006485|ling xing;
另行__另行 529.431458035|ling xing;
领袖__領袖 1676.57400252|ling xiu;
领着__領着 364.291279287|ling zhe;
领证__領證 229.722524886|ling zheng;
灵芝__靈芝 319.611528482|ling zhi;
领主__領主 182.196395498|ling zhu;
凌晨__凌晨 2501.20312918|ling chen;
灵山__靈山 172.260473089|ling shan;
铃声__鈴聲 1431.1656954|ling sheng;
零时__零時 172.04594156|ling shi;
领事__領事 196.341441156|ling shi;
零食__零食 869.377962205|ling shi;
零售__零售 1653.74860966|ling shou;
令人__令人 6837.54137436|ling ren;
凌辱__凌辱 148.889769675|ling ru;
领子__領子 168.229740225|ling zi;
另存__另存 146.679837233|ling cun;
零散__零散 258.271618599|ling san;
零碎__零碎 182.196395498|ling sui;
陵园__陵園 145.950506492|ling yuan;
凌云__凌雲 257.3078729|ling yun;
灵验__靈驗 115.755545596|ling yan;
羚羊__羚羊 181.064689688|ling yang;
领养__領養 369.779825848|ling yang;
灵异__靈異 260.534419685|ling yi;
另一__另一 3680.62832181|ling yi;
铃音__鈴音 161.250795044|ling yin;
另有__另有 953.361623425|ling you;
领用__領用 212.112652282|ling yong;
领驭__領馭 106.085879302|ling yu;
领域__領域 12236.0677836|ling yu;
另外__另外 20294.1274839|ling wai;
令我__令我 1092.0658276|ling wo;
领悟__領悟 811.787668067|ling wu;
灵儿__靈兒 282.868455943|ling er;
六百__六百 266.444503116|liu bai;
刘邦__劉邦 390.135034682|liu bang;
刘备__劉備 791.805264794|liu bei;
刘斌__劉斌 117.207077876|liu bin;
溜冰__溜冰 160.449013667|liu bing;
刘波__劉波 105.0335283|liu bo;
流派__流派 353.998238229|liu pai;
刘鹏__劉鵬 124.742372548|liu peng;
流氓__流氓 2784.14878864|liu mang;
留美__留美 111.230349808|liu mei;
刘明__劉明 134.762357541|liu ming;
六名__六名 150.007190589|liu ming;
留名__留名 397.496217848|liu ming;
刘某__劉某 307.117053725|liu mou;
刘芳__劉芳 135.604660605|liu fang;
流放__流放 168.439513167|liu fang;
六大__六大 771.352901218|liu da;
溜达__溜達 803.734894488|liu da;
六道__六道 111.230349808|liu dao;
流到__流到 178.155043976|liu dao;
留到__留到 213.172602547|liu dao;
留得__留得 105.426930997|liu de;
刘德__劉德 112.204874836|liu de;
留点__留點 324.02287532|liu dian;
六点__六點 749.558344131|liu dian;
流动__流動 2501.20312918|liu dong;
流淌__流淌 670.869975958|liu tang;
刘涛__劉濤 226.595011951|liu tao;
流体__流體 317.626273928|liu ti;
六天__六天 176.387781073|liu tian;
六条__六條 199.548108896|liu tiao;
流通__流通 2312.34781708|liu tong;
流年__流年 271.810366771|liu nian;
留念__留念 346.577724349|liu nian;
六年__六年 1128.02857559|liu nian;
浏览__瀏覽 4448.20561603|liu lan;
流浪__流浪 1463.63092081|liu lang;
流了__流了 325.642053285|liu le;
流泪__流淚 1549.98296207|liu lei;
刘力__劉力 105.953760973|liu li;
流利__流利 416.772181646|liu li;
琉璃__琉璃 446.895626023|liu li;
流连__流連 219.37092252|liu lian;
榴莲__榴蓮 219.918349804|liu lian;
留恋__留戀 712.223191016|liu lian;
流量__流量 3892.92564555|liu liang;
溜溜__溜溜 208.964318904|liu liu;
六楼__六樓 197.076837307|liu lou;
流露__流露 404.996293994|liu lu;
流落__流落 199.548108896|liu luo;
流光__流光 181.516526012|liu guang;
流感__流感 330.960471347|liu gan;
刘刚__劉剛 105.295633316|liu gang;
留个__留個 861.827215553|liu ge;
六个__六個 1456.35336279|liu ge;
留给__留給 1742.60930056|liu gei;
遛狗__遛狗 125.522047856|liu gou;
六国__六國 185.402943996|liu guo;
流过__流過 333.444336783|liu guo;
硫化__硫化 149.633788238|liu hua;
刘欢__劉歡 134.930398555|liu huan;
硫磺__硫磺 161.049974862|liu huang;
刘海__劉海 329.725485744|liu hai;
流汗__流汗 262.489736092|liu han;
六号__六號 167.810977762|liu hao;
六合__六合 254.121284766|liu he;
刘军__劉軍 136.963309627|liu jun;
留级__留級 107.14877401|liu ji;
六级__六級 662.561694208|liu ji;
刘佳__劉佳 134.092283643|liu jia;
刘家__劉家 186.561765129|liu jia;
刘建__劉建 119.56748386|liu jian;
流经__流經 128.209578049|liu jing;
六七__六七 467.983588668|liu qi;
六千__六千 265.119670945|liu qian;
留情__留情 160.249192015|liu qing;
琉球__琉球 108.222318063|liu qiu;
流血__流血 810.776675547|liu xue;
留学__留學 1687.0530669|liu xue;
流下__流下 506.83620443|liu xia;
留下__留下 8761.92253873|liu xia;
流线__流線 106.483223576|liu xian;
刘晓__劉曉 159.452390871|liu xiao;
留校__留校 257.3078729|liu xiao;
六项__六項 183.563783354|liu xiang;
流向__流向 550.970372621|liu xiang;
刘翔__劉翔 1467.28332601|liu xiang;
留心__留心 404.491915522|liu xin;
刘星__劉星 192.225730308|liu xing;
流星__流星 904.746955463|liu xing;
流行__流行 5814.9173705|liu xing;
柳絮__柳絮 166.768626413|liu xu;
流转__流轉 618.67155147|liu zhuan;
流着__流着 274.876014738|liu zhe;
留着__留着 2011.12191579|liu zhe;
柳州__柳州 566.990680223|liu zhou;
六种__六種 233.474375771|liu zhong;
留住__留住 682.676889633|liu zhu;
流传__流傳 1824.83897052|liu chuan;
流产__流產 675.904869515|liu chan;
流畅__流暢 1441.90662463|liu chang;
六成__六成 282.516174301|liu cheng;
流程__流程 7187.00747177|liu cheng;
留出__留出 234.933657026|liu chu;
流出__流出 934.541117987|liu chu;
流沙__流沙 158.461958559|liu sha;
留神__留神 231.735198139|liu shen;
流逝__流逝 559.271495144|liu shi;
六十__六十 577.688827991|liu shi;
流失__流失 1181.25761405|liu shi;
留守__留守 319.213487372|liu shou;
柳树__柳樹 240.263000901|liu shu;
流水__流水 1263.48355913|liu shui;
留人__留人 151.510141313|liu ren;
六人__六人 181.969489867|liu ren;
六日__六日 171.403948695|liu ri;
流入__流入 1033.79844744|liu ru;
留在__留在 2883.00988318|liu zai;
溜走__溜走 226.877563077|liu zou;
刘总__劉總 312.911829085|liu zong;
流窜__流竄 118.972962872|liu cuan;
留存__留存 258.271618599|liu cun;
六次__六次 173.769702743|liu ci;
硫酸__硫酸 366.568203397|liu suan;
六四__六四 210.008536601|liu si;
流苏__流蘇 125.522047856|liu su;
流速__流速 155.333728851|liu su;
六岁__六歲 218.008308584|liu sui;
六月__六月 1287.32334043|liu yue;
流云__流雲 197.076837307|liu yun;
流言__流言 299.93080386|liu yan;
留言__留言 7822.57824362|liu yan;
浏阳__瀏陽 112.34478795|liu yang;
留洋__留洋 118.529012887|liu yang;
刘洋__劉洋 175.729586548|liu yang;
刘烨__劉燁 281.461959558|liu ye;
六一__六一 438.619621343|liu yi;
留意__留意 1910.94886689|liu yi;
留影__留影 177.269210225|liu ying;
留有__留有 409.564096466|liu you;
刘玉__劉玉 111.507918629|liu yu;
流于__流於 125.992190229|liu yu;
流域__流域 837.47630896|liu yu;
六万__六萬 113.611883002|liu wan;
流亡__流亡 223.231720645|liu wang;
刘文__劉文 129.655606164|liu wen;
六位__六位 224.626982392|liu wei;
刘伟__劉偉 229.722524886|liu wei;
六安__六安 130.46599058|liu an;
楼板__樓板 146.497163581|lou ban;
楼盘__樓盤 2538.88717657|lou pan;
楼面__樓面 135.773751924|lou mian;
露面__露面 333.860122955|lou mian;
楼房__樓房 706.037369534|lou fang;
楼道__樓道 286.772667017|lou dao;
娄底__婁底 120.615053212|lou di;
漏电__漏電 154.176629937|lou dian;
漏掉__漏掉 204.07475061|lou diao;
楼顶__樓頂 391.108593802|lou ding;
漏斗__漏斗 158.067510349|lou dou;
漏洞__漏洞 2046.51646869|lou dong;
楼梯__樓梯 1336.36083843|lou ti;
楼兰__樓蘭 172.04594156|lou lan;
楼里__樓里 315.260239073|lou li;
露脸__露臉 134.594525802|lou lian;
镂空__鏤空 144.502706249|lou kong;
楼价__樓價 278.669912425|lou jia;
陋习__陋習 143.605133321|lou xi;
楼下__樓下 3603.47496171|lou xia;
露馅__露餡 115.611384758|lou xian;
搂着__摟着 474.442798491|lou zhe;
搂住__摟住 293.277951001|lou zhu;
楼主__樓主 16625.6206895|lou zhu;
露出__露出 643.841029976|lou chu;
楼上__樓上 6392.5626507|lou shang;
楼市__樓市 1699.71443635|lou shi;
漏水__漏水 367.482952871|lou shui;
搂在__摟在 110.126966673|lou zai;
楼层__樓層 588.588831574|lou ceng;
漏油__漏油 119.121315407|lou you;
楼宇__樓宇 353.998238229|lou yu;
龙马__龍馬 113.895394799|long ma;
龙猫__龍貓 140.244908425|long mao;
龙门__龍門 291.819695868|long men;
龙凤__龍鳳 186.794397067|long feng;
龙飞__龍飛 120.46484039|long fei;
垄断__壟斷 2347.18650079|long duan;
龙潭__龍潭 176.60772663|long tan;
龙腾__龍騰 155.333728851|long teng;
龙头__龍頭 1651.68904712|long tou;
笼统__籠統 270.122027271|long tong;
龙女__龍女 113.753550575|long nv;
隆隆__隆隆 141.650048976|long long;
龙龙__龍龍 172.260473089|long long;
龙岗__龍崗 258.916120291|long gang;
龙哥__龍哥 164.088713397|long ge;
龙宫__龍宮 139.026849285|long gong;
龙骨__龍骨 183.792676978|long gu;
龙卡__龍卡 117.792774542|long ka;
龙华__龍華 304.070513117|long hua;
龙虎__龍虎 127.096048509|long hu;
龙湖__龍湖 163.476413088|long hu;
龙江__龍江 171.190483873|long jiang;
龙井__龍井 180.839193473|long jing;
龙泉__龍泉 289.645897197|long quan;
隆起__隆起 238.176261728|long qi;
龙虾__龍蝦 540.093554591|long xia;
龙芯__龍芯 234.933657026|long xin;
隆胸__隆胸 126.149295342|long xiong;
笼罩__籠罩 735.677366107|long zhao;
龙舟__龍舟 202.807148249|long zhou;
隆重__隆重 1172.45828945|long zhong;
龙珠__龍珠 282.164331387|long zhu;
龙城__龍城 177.048440864|long cheng;
龙山__龍山 166.97657743|long shan;
笼子__籠子 433.727767276|long zi;
龙族__龍族 176.168109435|long zu;
龙眼__龍眼 166.768626413|long yan;
龙岩__龍岩 192.945711079|long yan;
龙王__龍王 276.249600432|long wang;
路边__路邊 1773.27819069|lu bian;
路标__路標 142.891090816|lu biao;
卢布__盧布 107.550099352|lu bu;
路牌__路牌 133.591915611|lu pai;
路旁__路旁 248.175085992|lu pang;
鲁莽__魯莽 189.136730609|lu mang;
露面__露面 228.580284053|lu mian;
路面__路面 1130.84350481|lu mian;
路费__路費 616.362966229|lu fei;
路段__路段 920.669965262|lu duan;
路灯__路燈 548.914415679|lu deng;
陆地__陸地 538.749137684|lu di;
露点__露點 290.368691563|lu dian;
露台__露台 169.915266157|lu tai;
陆涛__陸濤 137.991222203|lu tao;
露天__露天 496.21189989|lu tian;
路透__路透 109.989815613|lu tou;
路途__路途 407.020105042|lu tu;
鲁能__魯能 692.099342424|lu neng;
颅内__顱內 119.716577729|lu nei;
鲁尼__魯尼 444.673543393|lu ni;
陆路__陸路 119.56748386|lu lu;
璐璐__璐璐 150.381524744|lu lu;
露露__露露 290.730764849|lu lu;
露骨__露骨 149.447435764|lu gu;
鲁国__魯國 107.818484324|lu guo;
路过__路過 2645.47163011|lu guo;
路况__路況 367.025293151|lu kuang;
路考__路考 132.596773978|lu kao;
路口__路口 1708.20809643|lu kou;
路虎__路虎 137.134095104|lu hu;
芦荟__蘆薈 339.735863102|lu hui;
陆军__陸軍 762.750126416|lu jun;
路基__路基 233.474375771|lu ji;
路径__路徑 3091.3879652|lu jing;
路桥__路橋 315.260239073|lu qiao;
录取__錄取 2255.42866395|lu qu;
鲁迅__魯迅 1416.96881393|lu xun;
路线__路線 3662.32726943|lu xian;
录象__錄象 219.918349804|lu xiang;
录像__錄像 1973.87819843|lu xiang;
陆续__陸續 2312.34781708|lu xu;
录制__錄製 1217.12027856|lu zhi;
泸州__瀘州 275.218769535|lu zhou;
露珠__露珠 149.633788238|lu zhu;
路程__路程 711.336195135|lu cheng;
露出__露出 1753.50110433|lu chu;
庐山__廬山 465.076726846|lu shan;
陆上__陸上 162.258658377|lu shang;
路上__路上 6863.15136064|lu shang;
露水__露水 170.977284899|lu shui;
路人__路人 712.223191016|lu ren;
录入__錄入 1500.56786049|lu ru;
炉子__爐子 292.912705474|lu zi;
路子__路子 769.432826682|lu zi;
露宿__露宿 109.716025699|lu su;
路演__路演 204.839111844|lu yan;
路易__路易 148.704343794|lu yi;
陆毅__陸毅 223.231720645|lu yi;
录音__錄音 1930.09502896|lu yin;
录影__錄影 121.975425508|lu ying;
露营__露營 192.225730308|lu ying;
陆游__陸遊 158.857391092|lu you;
路由__路由 2082.53394472|lu you;
录用__錄用 780.052703516|lu yong;
鲁豫__魯豫 137.819369268|lu yu;
路网__路網 172.690339006|lu wang;
芦苇__蘆葦 284.991389772|lu wei;
落败__落敗 161.451865638|luo bai;
落榜__落榜 107.416157498|luo bang;
罗本__羅本 117.061109314|luo ben;
裸奔__裸奔 581.299547476|luo ben;
罗宾__羅賓 110.126966673|luo bin;
萝卜__蘿蔔 1181.25761405|luo bo;
罗盘__羅盤 135.435779871|luo pan;
落魄__落魄 249.726250867|luo po;
落马__落馬 209.485777119|luo ma;
罗马__羅馬 1804.48683509|luo ma;
落寞__落寞 424.107124851|luo mo;
螺母__螺母 132.762114633|luo mu;
落幕__落幕 375.351064872|luo mu;
罗夫__羅夫 115.323601467|luo fu;
罗孚__羅孚 127.890434962|luo fu;
洛夫__洛夫 158.461958559|luo fu;
罗丹__羅丹 108.222318063|luo dan;
落得__落得 244.796354228|luo de;
落地__落地 1082.58098585|luo di;
落点__落點 109.579386421|luo dian;
螺钉__螺釘 173.553291634|luo ding;
裸体__裸體 1190.12297778|luo ti;
骆驼__駱駝 547.548041623|luo tuo;
裸女__裸女 109.034528882|luo nv;
罗纳__羅納 146.679837233|luo na;
罗尼__羅尼 181.290467084|luo ni;
罗拉__羅拉 123.044091616|luo la;
罗兰__羅蘭 158.461958559|luo lan;
落了__落了 282.868455943|luo le;
落泪__落淚 487.02261325|luo lei;
萝莉__蘿莉 212.641966978|luo li;
裸聊__裸聊 269.114061535|luo liao;
罗列__羅列 319.611528482|luo lie;
裸露__裸露 503.688011099|luo lu;
落落__落落 209.485777119|luo luo;
罗格__羅格 130.791560815|luo ge;
锣鼓__鑼鼓 118.08671951|luo gu;
落款__落款 122.890853693|luo kuan;
洛克__洛克 208.184564378|luo ke;
落空__落空 262.489736092|luo kong;
落花__落花 326.048110451|luo hua;
罗汉__羅漢 313.302012384|luo han;
漯河__漯河 140.770195218|luo he;
落后__落後 3327.2428637|luo hou;
罗湖__羅湖 312.911829085|luo hu;
落户__落戶 993.38448407|luo hu;
罗技__羅技 574.81640715|luo ji;
逻辑__邏輯 4640.72425221|luo ji;
落脚__落腳 183.792676978|luo jiao;
罗杰__羅傑 123.967540162|luo jie;
洛奇__洛奇 116.624293448|luo qi;
落去__落去 108.627664361|luo qu;
落选__落選 219.918349804|luo xuan;
螺旋__螺旋 381.957020988|luo xuan;
罗西__羅西 130.954650472|luo xi;
落下__落下 627.210588862|luo xia;
裸照__裸照 528.113581536|luo zhao;
落差__落差 331.786363812|luo cha;
落成__落成 312.522131716|luo cheng;
螺栓__螺栓 230.008975843|luo shuan;
罗裳__羅裳 169.070402749|luo shang;
罗氏__羅氏 108.087539034|luo shi;
落实__落實 5836.6971223|luo shi;
裸睡__裸睡 214.772467501|luo shui;
落水__落水 275.218769535|luo shui;
落日__落日 302.935867929|luo ri;
落入__落入 518.979844093|luo ru;
落在__落在 1339.6956486|luo zai;
骡子__騾子 224.907079496|luo zi;
罗斯__羅斯 330.548296374|luo si;
螺丝__螺絲 672.544092675|luo si;
罗素__羅素 112.625137786|luo su;
罗嗦__羅嗦 687.800394331|luo suo;
洛阳__洛陽 1339.6956486|luo yang;
落叶__落葉 772.314734527|luo ye;
罗衣__羅衣 221.017305999|luo yi;
落雨__落雨 138.335571213|luo yu;
落于__落於 138.508067822|luo yu;
落网__落網 230.582949765|luo wang;
螺纹__螺紋 226.030964922|luo wen;
落伍__落伍 550.284199441|luo wu;
挂牌__掛牌 1123.81931445|gua pai;
挂满__掛滿 195.365179853|gua man;
瓜分__瓜分 245.101601395|gua fen;
刮风__颳風 146.862738669|gua feng;
寡妇__寡婦 264.130371602|gua fu;
挂断__掛斷 228.011295226|gua duan;
挂单__掛單 155.140277726|gua dan;
挂到__掛到 120.46484039|gua dao;
挂掉__掛掉 294.743493195|gua diao;
寡头__寡頭 162.460985719|gua tou;
挂念__挂念 247.249015706|gua nian;
挂历__掛歷 195.121873946|gua li;
呱呱__呱呱 131.773154284|gua gua;
瓜瓜__瓜瓜 177.933171406|gua gua;
瓜葛__瓜葛 130.141230764|gua ge;
挂钩__掛鈎 884.6784987|gua gou;
瓜果__瓜果 179.268563673|gua guo;
挂靠__掛靠 276.594068012|gua kao;
挂号__挂號 334.69325133|gua hao;
挂机__掛機 1169.53977147|gua ji;
挂件__掛件 201.79873775|gua jian;
刮起__颳起 211.321149687|gua qi;
挂起__掛起 258.271618599|gua qi;
挂着__掛着 1193.09285994|gua zhe;
挂职__掛職 128.689786556|gua zhi;
挂住__掛住 106.882056102|gua zhu;
挂帅__挂帥 117.061109314|gua shuai;
挂上__掛上 409.054029297|gua shang;
挂失__掛失 282.164331387|gua shi;
寡人__寡人 175.292155245|gua ren;
挂载__掛載 126.149295342|gua zai;
挂在__掛在 1390.72814418|gua zai;
瓜子__瓜子 398.48814637|gua zi;
关闭__關閉 5714.34823089|guan bi;
官兵__官兵 1163.72451202|guan bing;
关门__關門 1226.25479235|guan men;
冠名__冠名 254.755429543|guan ming;
观摩__觀摩 418.854838101|guan mo;
灌木__灌木 195.852702213|guan mu;
官方__官方 5250.06745253|guan fang;
官府__官府 215.845709156|guan fu;
管道__管道 1708.20809643|guan dao;
管得__管得 201.79873775|guan de;
关灯__關燈 206.633773476|guan deng;
官邸__官邸 148.149450567|guan di;
观点__觀點 9313.6168469|guan dian;
关掉__關掉 1296.98472971|guan diao;
关东__關東 135.098649108|guan dong;
管它__管它 286.772667017|guan ta;
管他__管他 620.215410078|guan ta;
关停__關停 193.427195796|guan ting;
关头__關頭 294.743493195|guan tou;
罐头__罐頭 470.908619205|guan tou;
贯通__貫通 331.786363812|guan tong;
馆内__館內 106.483223576|guan nei;
管内__管內 120.164975734|guan nei;
关内__關內 134.594525802|guan nei;
观念__觀念 4663.91446198|guan nian;
灌篮__灌籃 151.699065864|guan lan;
惯了__慣了 395.027185582|guan le;
官吏__官吏 210.795122809|guan li;
惯例__慣例 670.869975958|guan li;
管理__管理 39332.2958862|guan li;
关联__關聯 2476.39168739|guan lian;
官僚__官僚 566.990680223|guan liao;
管路__管路 150.194241046|guan lu;
管管__管管 166.768626413|guan guan;
灌灌__灌灌 723.855290267|guan guan;
观光__觀光 721.154209805|guan guang;
灌溉__灌溉 484.601008682|guan gai;
观感__觀感 145.587202159|guan gan;
关公__關公 130.954650472|guan gong;
关卡__關卡 276.938965124|guan ka;
观看__觀看 2952.08591378|guan kan;
管口__管口 111.925571131|guan kou;
关口__關口 426.757915008|guan kou;
管控__管控 227.727332161|guan kong;
关怀__關懷 1375.21757695|guan huai;
管好__管好 281.111429553|guan hao;
管护__管護 107.952927857|guan hu;
关乎__關乎 326.454673948|guan hu;
冠军__冠軍 5594.56401791|guan jun;
关机__關機 2545.22282076|guan ji;
管家__管家 569.823995046|guan jia;
管件__管件 112.204874836|guan jian;
关键__關鍵 14622.914328|guan jian;
管教__管教 277.976239008|guan jiao;
关节__關節 1031.22508566|guan jie;
关进__關進 145.405889264|guan jin;
观景__觀景 136.792736844|guan jing;
关切__關切 459.889800938|guan qie;
灌区__灌區 165.73274959|guan qu;
关西__關西 157.2815571|guan xi;
关系__關係 35644.6408079|guan xi;
管辖__管轄 830.202635471|guan xia;
管线__管線 493.744603771|guan xian;
关心__關心 9887.71915322|guan xin;
惯性__慣性 603.442760838|guan xing;
灌装__灌裝 152.647228173|guan zhuang;
观战__觀戰 177.933171406|guan zhan;
馆长__館長 294.009808944|guan zhang;
关照__關照 724.757896749|guan zhao;
管着__管着 106.616002115|guan zhe;
关着__關着 135.604660605|guan zhe;
观者__觀者 147.780672558|guan zhe;
官职__官職 201.79873775|guan zhi;
管制__管制 948.621258606|guan zhi;
关中__關中 186.097370046|guan zhong;
观众__觀眾 8450.93022222|guan zhong;
管住__管住 144.863304286|guan zhu;
灌注__灌注 246.94109417|guan zhu;
关注__關注 18622.0445617|guan zhu;
贯穿__貫穿 931.053859154|guan chuan;
观察__觀察 7124.58666637|guan cha;
灌肠__灌腸 125.053659829|guan chang;
官场__官場 536.070335228|guan chang;
贯彻__貫徹 1565.51253772|guan che;
关山__關山 130.303509496|guan shan;
关上__關上 630.344829195|guan shang;
观赏__觀賞 943.904464128|guan shang;
管事__管事 177.269210225|guan shi;
灌输__灌輸 410.586139672|guan shu;
关税__關稅 688.658042404|guan shui;
灌水__灌水 2655.38023445|guan shui;
关在__關在 309.807805448|guan zai;
馆子__館子 227.727332161|guan zi;
罐子__罐子 269.449631503|guan zi;
管子__管子 448.010827873|guan zi;
灌醉__灌醉 110.539446825|guan zui;
管材__管材 158.857391092|guan cai;
棺材__棺材 424.635962376|guan cai;
馆藏__館藏 173.337150041|guan cang;
观测__觀測 896.889021007|guan ce;
官司__官司 952.17431607|guan si;
官员__官員 4951.40363972|guan yuan;
关押__關押 366.568203397|guan ya;
冠以__冠以 257.62872122|guan yi;
观音__觀音 569.114341748|guan yin;
观影__觀影 127.73116145|guan ying;
惯用__慣用 242.972837869|guan yong;
管用__管用 579.852559389|guan yong;
关羽__關羽 493.129699012|guan yu;
关于__關於 28983.7454628|guan yu;
关外__關外 184.02185602|guan wai;
管网__管網 296.955549433|guan wang;
官网__官網 1184.20537322|guan wang;
观望__觀望 1431.1656954|guan wang;
关爱__關愛 1140.75119008|guan ai;
广本__廣本 158.067510349|guang ben;
光标__光標 440.811451858|guang biao;
光波__光波 108.087539034|guang bo;
广博__廣博 136.282292017|guang bo;
广播__廣播 1951.86385246|guang bo;
光盘__光盤 3269.69811616|guang pan;
光谱__光譜 267.775955618|guang pu;
光芒__光芒 1305.09125317|guang mang;
广袤__廣袤 151.888225993|guang mao;
光明__光明 2106.02207003|guang ming;
广发__廣發 812.799921236|guang fa;
广泛__廣泛 5924.63495045|guang fan;
光伏__光伏 153.028150386|guang fu;
光大__光大 440.811451858|guang da;
广大__廣大 7479.39723763|guang da;
广岛__廣島 145.405889264|guang dao;
光电__光電 699.033618062|guang dian;
广电__廣電 821.967189047|guang dian;
光雕__光雕 106.085879302|guang diao;
光碟__光碟 326.048110451|guang die;
广东__廣東 8060.06962211|guang dong;
广度__廣度 253.173026121|guang du;
光头__光頭 722.053448193|guang tou;
光年__光年 118.381397999|guang nian;
光缆__光纜 480.392137969|guang lan;
光了__光了 201.296414343|guang le;
光良__光良 170.551683166|guang liang;
光亮__光亮 466.818670029|guang liang;
光临__光臨 870.462027204|guang lin;
光光__光光 315.260239073|guang guang;
逛逛__逛逛 1066.51251556|guang guang;
光棍__光棍 496.21189989|guang gun;
广告__廣告 19307.3315803|guang gao;
光顾__光顧 699.905273328|guang gu;
光看__光看 250.661599628|guang kan;
光靠__光靠 227.443722742|guang kao;
广阔__廣闊 1548.05262827|guang kuo;
光华__光華 521.573243485|guang hua;
光滑__光滑 918.378206258|guang hua;
光环__光環 762.750126416|guang huan;
光辉__光輝 903.620192345|guang hui;
光脚__光腳 112.065135969|guang jiao;
广角__廣角 350.050152834|guang jiao;
光洁__光潔 193.668388536|guang jie;
逛街__逛街 2121.82781083|guang jie;
光景__光景 193.90988203|guang jing;
光圈__光圈 526.142915167|guang quan;
光纤__光纖 185.86560618|guang qian;
光驱__光驅 1838.53442614|guang qu;
光学__光學 829.168709129|guang xue;
广西__廣西 3327.2428637|guang xi;
光鲜__光鮮 237.879639313|guang xian;
光纤__光纖 1038.96445205|guang xian;
光线__光線 1587.1200774|guang xian;
光绪__光緒 260.859291326|guang xu;
光照__光照 381.006242235|guang zhao;
光着__光着 381.481335404|guang zhe;
广州__廣州 16646.3518954|guang zhou;
广场__廣場 4646.51097209|guang chang;
广厦__廣廈 140.419785869|guang sha;
光栅__光柵 121.217779906|guang shan;
广深__廣深 143.247667161|guang shen;
光是__光是 528.113581536|guang shi;
广受__廣受 199.796934068|guang shou;
光束__光束 143.784200776|guang shu;
光荣__光榮 1476.45426414|guang rong;
光泽__光澤 714.000502259|guang ze;
光子__光子 235.519920202|guang zi;
光彩__光彩 757.068312494|guang cai;
光速__光速 176.387781073|guang su;
广元__廣元 184.251320835|guang yuan;
光源__光源 438.619621343|guang yuan;
光晕__光暈 118.08671951|guang yun;
广义__廣義 454.760723981|guang yi;
光阴__光陰 392.084582382|guang yin;
光影__光影 392.573489614|guang ying;
广外__廣外 142.713135632|guang wai;
广为__廣為 381.481335404|guang wei;
广安__廣安 142.891090816|guang an;
滚蛋__滾蛋 414.699880708|gun dan;
滚动__滾動 1051.99268696|gun dong;
滚烫__滾燙 190.793818607|gun tang;
滚筒__滾筒 147.964946673|gun tong;
滚轮__滾輪 193.427195796|gun lun;
滚滚__滾滾 544.825488702|gun gun;
滚出__滾出 130.954650472|gun chu;
滚石__滾石 137.305093541|gun shi;
棍子__棍子 466.818670029|gun zi;
拐卖__拐賣 170.977284899|guai mai;
拐点__拐點 330.548296374|guai dian;
怪胎__怪胎 123.197520618|guai tai;
怪你__怪你 227.727332161|guai ni;
怪怪__怪怪 714.89082038|guai guai;
乖乖__乖乖 2822.57620712|guai guai;
拐角__拐角 115.323601467|guai jiao;
怪圈__怪圈 201.045721733|guai quan;
乖巧__乖巧 303.691826638|guai qiao;
拐杖__拐杖 192.945711079|guai zhang;
怪事__怪事 263.801426189|guai shi;
怪兽__怪獸 446.895626023|guai shou;
怪人__怪人 162.460985719|guai ren;
怪罪__怪罪 124.587019602|guai zui;
怪异__怪異 769.432826682|guai yi;
拐弯__拐彎 220.467143161|guai wan;
怪我__怪我 467.983588668|guai wo;
怪物__怪物 1757.8768636|guai wu;
旮旯__旮旯 124.742372548|ga la;
咖喱__咖喱 350.92368248|ga li;
嘎嘎__嘎嘎 2570.72389483|ga ga;
盖板__蓋板 107.015331962|gai ban;
改版__改版 1214.09058664|gai ban;
丐帮__丐幫 218.824857909|gai bang;
该报__該報 169.28122395|gai bao;
改编__改編 1114.0586864|gai bian;
改变__改變 16876.1084131|gai bian;
该病__該病 142.535402072|gai bing;
该片__該片 680.977550057|gai pian;
盖帽__蓋帽 124.276893895|gai mao;
改名__改名 1147.88120947|gai ming;
该法__該法 133.591915611|gai fa;
改道__改道 118.972962872|gai dao;
改到__改到 160.049619219|gai dao;
改得__改得 228.295612376|gai de;
该店__該店 171.831677206|gai dian;
改掉__改掉 406.513206136|gai diao;
改动__改動 1525.07528247|gai dong;
该队__該隊 117.646076559|gai dui;
改天__改天 2153.79604997|gai tian;
概念__概念 9348.50096482|gai nian;
概论__概論 254.755429543|gai lun;
概率__概率 1731.7851508|gai lv;
该类__該類 312.132919672|gai lei;
改良__改良 745.831342837|gai liang;
盖楼__蓋樓 130.954650472|gai lou;
改观__改觀 439.166555128|gai guan;
改改__改改 743.048258297|gai gai;
改个__改個 128.049907079|gai ge;
改革__改革 9095.68698269|gai ge;
该股__該股 1387.2663024|gai gu;
盖过__蓋過 141.473639374|gai guo;
改过__改過 392.573489614|gai guo;
该国__該國 546.185068786|gai guo;
改款__改款 108.357265155|gai kuan;
该款__該款 251.914183226|gai kuan;
概况__概況 787.868200695|gai kuang;
改口__改口 158.067510349|gai kou;
概括__概括 1290.5357804|gai kuo;
改行__改行 320.808632296|gai hang;
该行__該行 338.468131949|gai hang;
改好__改好 573.385557088|gai hao;
改回__改回 113.611883002|gai hui;
该机__該機 771.352901218|gai ji;
改建__改建 417.812212206|gai jian;
改进__改進 5185.04883318|gai jin;
该局__該局 409.054029297|gai ju;
该剧__該劇 649.481929235|gai ju;
改签__改簽 112.065135969|gai qian;
该去__該去 180.839193473|gai qu;
该区__該區 365.20034683|gai qu;
该县__該縣 604.948616891|gai xian;
该校__該校 721.154209805|gai xiao;
该项__該項 675.063104121|gai xiang;
改写__改寫 494.9767145|gai xie;
改性__改性 223.510077937|gai xing;
改装__改裝 912.673735821|gai zhuang;
盖章__蓋章 961.714332594|gai zhang;
盖着__蓋着 137.819369268|gai zhe;
该镇__該鎮 244.796354228|gai zhen;
改正__改正 940.382265783|gai zheng;
钙质__鈣質 147.596627936|gai zhi;
改制__改制 976.203874871|gai zhi;
盖住__蓋住 196.586267794|gai zhu;
该厂__該廠 256.667374505|gai chang;
该车__該車 368.399985048|gai che;
改称__改稱 147.412812521|gai cheng;
改成__改成 3261.55908656|gai cheng;
该处__該處 159.253810404|gai chu;
改善__改善 8367.09866098|gai shan;
盖上__蓋上 366.111682898|gai shang;
该省__該省 184.941433485|gai sheng;
盖世__蓋世 105.558392399|gai shi;
该是__該是 242.670241844|gai shi;
该市__該市 675.904869515|gai shi;
该书__該書 458.745029596|gai shu;
概述__概述 747.692521253|gai shu;
该说__該說 364.745529846|gai shuo;
盖在__蓋在 115.036534536|gai zai;
改造__改造 5044.82818733|gai zao;
盖子__蓋子 435.895152658|gai zi;
改组__改組 205.60633599|gai zu;
该做__該做 389.163898974|gai zuo;
该村__該村 266.112675706|gai cun;
盖茨__蓋茨 688.658042404|gai ci;
概算__概算 118.23396695|gai suan;
该死__該死 1181.25761405|gai si;
该院__該院 383.865702254|gai yuan;
概要__概要 347.875829952|gai yao;
该有__該有 226.877563077|gai you;
改用__改用 499.3133654|gai yong;
改完__改完 230.008975843|gai wan;
该文__該文 206.633773476|gai wen;
改为__改為 2655.38023445|gai wei;
该案__該案 321.208662461|gai an;
干杯__乾杯 124.276893895|gan bei;
肝病__肝病 238.176261728|gan bing;
干部__幹部 5269.73156102|gan bu;
干妈__乾媽 167.601987591|gan ma;
干吗__幹嗎 7470.08246857|gan ma;
干嘛__幹嘛 17002.7639686|gan ma;
赶忙__趕忙 343.996026791|gan mang;
感冒__感冒 3598.9872288|gan mao;
干么__幹麼 343.996026791|gan me;
赶赴__趕赴 404.491915522|gan fu;
肝胆__肝膽 132.10198647|gan dan;
干道__幹道 166.560934377|gan dao;
赶到__趕到 2167.25788788|gan dao;
感到__感到 11425.5126817|gan dao;
干得__幹得 303.313611771|gan de;
干的__乾的 744.902491688|gan de;
干点__干點 274.533686805|gan dian;
干掉__幹掉 905.87512359|gan diao;
干爹__乾爹 173.769702743|gan die;
感动__感動 6627.80750717|gan dong;
感叹__感嘆 1615.05244942|gan tan;
甘甜__甘甜 163.272821143|gan tian;
赶来__趕來 748.624851411|gan lai;
橄榄__橄欖 227.727332161|gan lan;
赶了__趕了 153.028150386|gan le;
干了__幹了 1232.38252249|gan le;
干练__幹練 180.389043185|gan lian;
干粮__乾糧 169.070402749|gan liang;
干流__幹流 161.250795044|gan liu;
甘露__甘露 196.096919422|gan lu;
赶路__趕路 220.19257551|gan lu;
感官__感官 446.895626023|gan guan;
感光__感光 202.807148249|gan guang;
尴尬__尷尬 2908.26886413|gan ga;
干干__乾乾 125.36572391|gan gan;
干过__干過 368.399985048|gan guo;
赶快__趕快 3265.62606571|gan kuai;
感慨__感慨 1852.33266643|gan kai;
干枯__乾枯 191.508436159|gan ku;
感化__感化 167.601987591|gan hua;
感怀__感懷 107.550099352|gan huai;
干旱__乾旱 590.793388895|gan han;
干好__干好 166.97657743|gan hao;
干涸__乾涸 206.119414554|gan he;
干活__幹活 3141.87681769|gan huo;
赶回__趕回 454.760723981|gan hui;
感觉__感覺 61600.2477981|gan jue;
杆菌__桿菌 291.093289619|gan jun;
赶集__趕集 160.849404779|gan ji;
感激__感激 1806.7369278|gan ji;
干劲__幹勁 225.468321935|gan jin;
赶紧__趕緊 7124.58666637|gan jin;
干警__幹警 383.387639617|gan jing;
干净__乾淨 4669.73009873|gan jing;
柑桔__柑桔 164.703307075|gan ju;
柑橘__柑橘 462.187920882|gan ju;
敢情__敢情 226.312812713|gan qing;
感情__感情 14121.4809739|gan qing;
敢去__敢去 111.507918629|gan qu;
赶去__趕去 241.162905094|gan qu;
干系__干係 132.762114633|gan xi;
干洗__乾洗 177.269210225|gan xi;
干线__幹線 421.998352644|gan xian;
敢想__敢想 107.416157498|gan xiang;
感想__感想 942.728934628|gan xiang;
干些__幹些 120.314814642|gan xie;
感谢__感謝 10226.0664271|gan xie;
甘心__甘心 818.900002077|gan xin;
干性__乾性 116.47905068|gan xing;
感性__感性 1026.09756322|gan xing;
感召__感召 109.852835359|gan zhao;
干着__乾著 153.792848894|gan zhe;
赶着__趕着 323.619340361|gan zhe;
甘蔗__甘蔗 335.528458728|gan zhe;
感知__感知 662.561694208|gan zhi;
赣州__贛州 271.133768339|gan zhou;
赶超__趕超 256.347723437|gan chao;
干出__干出 112.765574943|gan chu;
赶出__趕出 323.216307961|gan chu;
感触__感觸 924.118331259|gan chu;
干啥__幹啥 3563.28598523|gan sha;
感伤__感傷 418.333200332|gan shang;
赶上__趕上 1833.95789167|gan shang;
干涉__干涉 997.105202031|gan she;
肝肾__肝腎 436.438689186|gan shen;
干事__幹事 585.662213047|gan shi;
感受__感受 10315.6602986|gan shou;
敢说__敢說 631.130833438|gan shuo;
感染__感染 4071.54674252|gan ran;
干扰__干擾 2210.90378861|gan rao;
感人__感人 1133.66545852|gan ren;
赶在__趕在 304.070513117|gan zai;
肝脏__肝臟 678.436468738|gan zang;
干燥__乾燥 1579.22849881|gan zao;
杆子__杆子 161.049974862|gan zi;
赶走__趕走 408.544597361|gan zou;
敢做__敢做 136.792736844|gan zuo;
干菜__乾菜 118.972962872|gan cai;
甘草__甘草 213.971039752|gan cao;
干脆__乾脆 3523.54522994|gan cui;
干涩__乾澀 132.10198647|gan se;
干死__乾死 106.350610398|gan si;
甘肃__甘肅 1274.55334676|gan su;
甘愿__甘願 295.847453874|gan yuan;
肝炎__肝炎 324.426913464|gan yan;
感言__感言 1028.65812957|gan yan;
感应__感應 686.943814365|gan ying;
甘油__甘油 145.768741141|gan you;
甘于__甘於 134.930398555|gan yu;
敢于__敢於 1212.57856995|gan yu;
干预__干預 1422.27606545|gan yu;
干完__幹完 219.37092252|gan wan;
赶往__趕往 448.56947196|gan wang;
敢问__敢問 187.26053154|gan wen;
感悟__感悟 1077.19810837|gan wu;
肝癌__肝癌 355.767206381|gan ai;
感恩__感恩 1002.08784645|gan en;
港版__港版 201.045721733|gang ban;
钢板__鋼板 510.004074866|gang ban;
刚被__剛被 127.890434962|gang bei;
钢笔__鋼筆 334.69325133|gang bi;
港币__港幣 555.105417084|gang bi;
港片__港片 138.335571213|gang pian;
刚买__剛買 443.014235191|gang mai;
肛门__肛門 550.970372621|gang men;
港大__港大 122.432284019|gang da;
刚到__剛到 707.799244422|gang dao;
刚度__剛度 194.393772779|gang du;
港台__港台 641.438524323|gang tai;
钢铁__鋼鐵 2269.5257346|gang tie;
刚来__剛來 847.977956119|gang lai;
纲领__綱領 244.186999878|gang ling;
刚落__剛落 110.95347192|gang luo;
钢管__鋼管 512.55262135|gang guan;
杠杆__槓桿 500.559372647|gang gan;
刚刚__剛剛 17849.5163038|gang gang;
钢构__鋼構 156.694657831|gang gou;
港股__港股 672.544092675|gang gu;
刚果__剛果 132.762114633|gang guo;
刚过__剛過 268.778909483|gang guo;
刚看__剛看 171.403948695|gang kan;
港口__港口 1645.52573648|gang kou;
港行__港行 288.565077751|gang hang;
刚好__剛好 2992.83123646|gang hao;
肛交__肛交 116.044406778|gang jiao;
港姐__港姐 144.863304286|gang jie;
刚进__剛進 279.017397997|gang jin;
钢筋__鋼筋 607.214449729|gang jin;
港剧__港劇 107.550099352|gang ju;
刚强__剛強 146.314717429|gang qiang;
钢琴__鋼琴 1643.47641462|gang qin;
刚去__剛去 247.557321202|gang qu;
港区__港區 364.291279287|gang qu;
刚下__剛下 134.259489114|gang xia;
刚想__剛想 257.62872122|gang xiang;
刚性__剛性 381.006242235|gang xing;
钢厂__鋼廠 274.533686805|gang chang;
刚出__剛出 215.040276584|gang chu;
港商__港商 112.625137786|gang shang;
港人__港人 159.651218957|gang ren;
刚在__剛在 222.121753798|gang zai;
刚走__剛走 166.146325956|gang zou;
钢材__鋼材 782.974388071|gang cai;
刚才__剛才 28875.5920382|gang cai;
刚从__剛從 817.880151926|gang cong;
钢丝__鋼絲 266.444503116|gang si;
港元__港元 607.214449729|gang yuan;
刚要__剛要 190.081867665|gang yao;
纲要__綱要 228.580284053|gang yao;
刚毅__剛毅 144.502706249|gang yi;
刚一__剛一 294.743493195|gang yi;
港湾__港灣 496.830647979|gang wan;
岗位__崗位 3820.83303827|gang wei;
港澳__港澳 465.65665114|gang ao;
告白__告白 259.885889675|gao bai;
告别__告別 1910.94886689|gao bie;
高配__高配 106.748946222|gao pei;
高频__高頻 570.534533242|gao pin;
高明__高明 798.742526514|gao ming;
高发__高發 260.859291326|gao fa;
高仿__高仿 115.611384758|gao fang;
高分__高分 665.872587905|gao fen;
高峰__高峰 1882.58514584|gao feng;
高飞__高飛 173.553291634|gao fei;
稿费__稿費 508.734557585|gao fei;
高端__高端 2826.09579953|gao duan;
高大__高大 1022.26865969|gao da;
高达__高達 3402.71958168|gao da;
高档__高檔 2312.34781708|gao dang;
搞到__搞到 921.81798848|gao dao;
搞的__搞的 351.361264404|gao de;
高的__高的 1418.73569366|gao de;
搞得__搞得 2590.0172328|gao de;
高等__高等 577.688827991|gao deng;
高地__高地 485.810302105|gao di;
高低__高低 1328.06008516|gao di;
糕点__糕點 212.641966978|gao dian;
搞点__搞點 291.093289619|gao dian;
搞掂__搞掂 341.859308876|gao dian;
高点__高點 1082.58098585|gao dian;
高调__高調 712.223191016|gao diao;
搞定__搞定 6227.44248628|gao ding;
搞懂__搞懂 192.465424888|gao dong;
高度__高度 6570.2434815|gao du;
高台__高台 138.680779525|gao tai;
高挑__高挑 180.613978088|gao tiao;
高铁__高鐵 111.786180106|gao tie;
搞头__搞頭 148.149450567|gao tou;
高通__高通 225.187525865|gao tong;
高能__高能 124.89791921|gao neng;
高丽__高麗 334.276427588|gao li;
高粱__高粱 136.112567367|gao liang;
高亮__高亮 242.972837869|gao liang;
高龄__高齡 358.437246895|gao ling;
高楼__高樓 599.694499646|gao lou;
高卢__高盧 114.321989585|gao lu;
高炉__高爐 160.849404779|gao lu;
高官__高官 667.534233933|gao guan;
高管__高管 902.494832488|gao guan;
高光__高光 117.207077876|gao guang;
搞怪__搞怪 238.770616634|gao guai;
高干__高幹 119.41857567|gao gan;
搞搞__搞搞 431.571158705|gao gao;
高高__高高 697.293562832|gao gao;
高歌__高歌 298.811606079|gao ge;
高跟__高跟 151.699065864|gao gen;
高工__高工 111.369047744|gao gong;
高估__高估 329.725485744|gao gu;
搞过__搞過 221.017305999|gao guo;
高过__高過 256.028470459|gao guo;
高贵__高貴 1214.09058664|gao gui;
高开__高開 622.538424634|gao kai;
高亢__高亢 140.770195218|gao kang;
高考__高考 4122.60245218|gao kao;
高科__高科 336.365750338|gao ke;
高空__高空 469.151414294|gao kong;
搞坏__搞壞 112.204874836|gao huai;
高喊__高喊 249.104624871|gao han;
搞好__搞好 1896.71398774|gao hao;
高呼__高呼 245.407229187|gao hu;
搞活__搞活 118.381397999|gao huo;
告急__告急 176.387781073|gao ji;
高级__高級 6906.0480087|gao ji;
高架__高架 275.905561849|gao jia;
高价__高價 1349.75009317|gao jia;
高见__高見 173.769702743|gao jian;
稿件__稿件 2819.06099798|gao jian;
高教__高教 192.465424888|gao jiao;
高洁__高潔 141.650048976|gao jie;
高阶__高階 165.939408926|gao jie;
告诫__告誡 566.284555508|gao jie;
告警__告警 641.438524323|gao jing;
高就__高就 112.065135969|gao jiu;
高居__高居 208.70407676|gao ju;
高举__高舉 565.579310193|gao ju;
搞起__搞起 123.813152185|gao qi;
高企__高企 196.586267794|gao qi;
高桥__高橋 188.901181552|gao qiao;
高强__高強 304.449671797|gao qiang;
搞清__搞清 152.647228173|gao qing;
高清__高清 1525.07528247|gao qing;
高下__高下 207.666345181|gao xia;
高效__高效 2415.4345439|gao xiao;
搞笑__搞笑 4646.51097209|gao xiao;
高校__高校 4799.5249195|gao xiao;
高些__高些 166.560934377|gao xie;
高新__高新 532.740555233|gao xin;
高薪__高薪 643.039196578|gao xin;
高兴__高興 8621.12153338|gao xing;
高雄__高雄 237.287502254|gao xiong;
告状__告狀 273.850309404|gao zhuang;
高涨__高漲 762.750126416|gao zhang;
高招__高招 265.119670945|gao zhao;
高知__高知 142.535402072|gao zhi;
告之__告之 232.313479749|gao zhi;
高职__高職 337.625607028|gao zhi;
告知__告知 2865.10217964|gao zhi;
告终__告終 310.580912674|gao zhong;
高中__高中 5416.20338039|gao zhong;
高产__高產 501.808489233|gao chan;
高唱__高唱 133.093414711|gao chang;
高超__高超 483.394725468|gao chao;
高潮__高潮 2300.85021536|gao chao;
高程__高程 166.560934377|gao cheng;
搞成__搞成 335.528458728|gao cheng;
稿酬__稿酬 152.077621994|gao chou;
搞出__搞出 228.011295226|gao chu;
高处__高處 382.433299725|gao chu;
高出__高出 1123.81931445|gao chu;
高山__高山 769.432826682|gao shan;
告上__告上 314.083839199|gao shang;
高尚__高尚 1361.57568978|gao shang;
高烧__高燒 202.302314677|gao shao;
高深__高深 414.699880708|gao shen;
高升__高升 131.773154284|gao sheng;
高声__高聲 311.355949144|gao sheng;
高盛__高盛 421.998352644|gao sheng;
告示__告示 241.162905094|gao shi;
高手__高手 5961.66560402|gao shou;
高数__高數 343.139741671|gao shu;
高热__高熱 147.964946673|gao re;
高人__高人 1162.27522076|gao ren;
稿子__稿子 1107.13875428|gao zi;
高宗__高宗 108.087539034|gao zong;
高层__高層 2872.25187426|gao ceng;
告辞__告辭 157.870654598|gao ci;
搞错__搞錯 1055.93292173|gao cuo;
高三__高三 1055.93292173|gao san;
高僧__高僧 224.347234118|gao seng;
高斯__高斯 219.37092252|gao si;
搞死__搞死 249.726250867|gao si;
高耸__高聳 223.510077937|gao song;
高速__高速 7142.36565495|gao su;
告诉__告訴 33658.8205962|gao su;
高院__高院 164.293322714|gao yuan;
高远__高遠 165.114314527|gao yuan;
高原__高原 1156.49608257|gao yuan;
高雅__高雅 708.681829926|gao ya;
高压__高壓 1178.31719254|gao ya;
高阳__高陽 150.944778196|gao yang;
羔羊__羔羊 299.557272934|gao yang;
膏药__膏藥 152.077621994|gao yao;
高一__高一 679.282440527|gao yi;
高音__高音 464.497524783|gao yin;
高于__高於 3193.1902591|gao yu;
搞完__搞完 257.62872122|gao wan;
睾丸__睾丸 467.983588668|gao wan;
高温__高溫 1561.61561744|gao wen;
高危__高危 217.465635832|gao wei;
高位__高位 1519.38443361|gao wei;
高昂__高昂 541.441326411|gao ang;
高傲__高傲 332.200082586|gao ao;
高额__高額 648.673070715|gao e;
高二__高二 527.455873984|gao er;
各班__各班 106.882056102|ge ban;
个半__個半 193.427195796|ge ban;
戈壁__戈壁 224.347234118|ge bi;
隔壁__隔壁 1771.06976716|ge bi;
个别__個別 2671.97711617|ge bie;
胳膊__胳膊 1276.14264248|ge bo;
各部__各部 163.069482749|ge bu;
各派__各派 129.979154132|ge pai;
哥们__哥們 3310.69893679|ge men;
歌迷__歌迷 1820.2965272|ge mi;
歌名__歌名 316.83562918|ge ming;
革命__革命 4041.21731986|ge ming;
隔膜__隔膜 138.508067822|ge mo;
各方__各方 1749.13623734|ge fang;
割断__割斷 121.368931601|ge duan;
隔断__隔斷 215.576896995|ge duan;
疙瘩__疙瘩 433.727767276|ge da;
个大__個大 665.872587905|ge da;
各大__各大 2551.57427517|ge da;
歌德__歌德 133.093414711|ge de;
各地__各地 5395.99270938|ge di;
割掉__割掉 131.445140637|ge diao;
格调__格調 355.324137339|ge diao;
格斗__格鬥 489.456318842|ge dou;
各队__各隊 109.852835359|ge dui;
歌坛__歌壇 470.32215416|ge tan;
哥特__哥特 146.679837233|ge te;
个体__個體 2161.86308522|ge ti;
隔天__隔天 274.533686805|ge tian;
各条__各條 118.529012887|ge tiao;
歌厅__歌廳 179.71591787|ge ting;
个头__個頭 633.494731672|ge tou;
格尼__格尼 257.3078729|ge ni;
格拉__格拉 173.121277629|ge la;
格兰__格蘭 124.742372548|ge lan;
格雷__格雷 154.176629937|ge lei;
各类__各類 5664.71780817|ge lei;
格里__格里 150.381524744|ge li;
格力__格力 254.438159592|ge li;
隔离__隔離 1427.60319527|ge li;
割裂__割裂 164.293322714|ge lie;
格林__格林 302.935867929|ge lin;
阁楼__閣樓 338.046607007|ge lou;
各路__各路 449.128812644|ge lu;
咯咯__咯咯 249.415244207|ge ge;
格格__格格 597.456727653|ge ge;
个个__個個 1551.9157029|ge ge;
各个__各個 7460.77930003|ge ge;
哥哥__哥哥 10497.2098015|ge ge;
个股__個股 2759.96781896|ge gu;
各国__各國 2406.4213017|ge guo;
隔开__隔開 274.191785204|ge kai;
各科__各科 196.586267794|ge ke;
歌华__歌華 124.587019602|ge hua;
隔阂__隔閡 253.804804573|ge he;
歌喉__歌喉 131.117943492|ge hou;
歌会__歌會 125.992190229|ge hui;
隔绝__隔絕 221.845125512|ge jue;
各级__各級 3277.85745623|ge ji;
各家__各家 804.737106306|ge jia;
割接__割接 386.264972075|ge jie;
各界__各界 747.692521253|ge jie;
割据__割據 137.819369268|ge ju;
歌剧__歌劇 478.003501869|ge ju;
格局__格局 2557.94157928|ge ju;
搁浅__擱淺 257.94996962|ge qian;
各区__各區 279.365316864|ge qu;
歌曲__歌曲 5250.06745253|ge qu;
阁下__閣下 506.204995518|ge xia;
各县__各縣 270.122027271|ge xian;
各校__各校 151.510141313|ge xiao;
各项__各項 4823.50867368|ge xiang;
革新__革新 469.736419493|ge xin;
歌星__歌星 418.333200332|ge xing;
个性__個性 5735.75130134|ge xing;
各占__各占 150.194241046|ge zhan;
歌者__歌者 156.109948588|ge zhe;
隔着__隔着 674.222387052|ge zhe;
各镇__各鎮 130.46599058|ge zhen;
搁置__擱置 310.968189453|ge zhi;
各州__各州 116.624293448|ge zhou;
各种__各種 20574.2313823|ge zhong;
个唱__個唱 184.941433485|ge chang;
歌唱__歌唱 927.579613097|ge chang;
各处__各處 303.691826638|ge chu;
格栅__格柵 142.003528374|ge shan;
割舍__割捨 244.186999878|ge she;
个省__個省 129.332863581|ge sheng;
各省__各省 621.763121294|ge sheng;
歌声__歌聲 1366.67546656|ge sheng;
各市__各市 305.589986932|ge shi;
各式__各式 385.78392141|ge shi;
格式__格式 7832.33255491|ge shi;
歌手__歌手 2865.10217964|ge shou;
个数__個數 654.356305043|ge shu;
个税__個稅 337.625607028|ge shui;
隔热__隔熱 232.024158785|ge re;
各人__各人 662.561694208|ge ren;
个人__個人 32022.1704712|ge ren;
割肉__割肉 647.865219539|ge rou;
个字__個字 619.442999798|ge zi;
个子__個子 696.425160166|ge zi;
格子__格子 706.037369534|ge zi;
鸽子__鴿子 835.391638074|ge zi;
各自__各自 4675.55298725|ge zi;
各组__各組 162.663565352|ge zu;
各族__各族 164.293322714|ge zu;
各村__各村 170.551683166|ge cun;
歌词__歌詞 3076.0167709|ge ci;
各色__各色 305.589986932|ge se;
歌颂__歌頌 339.31275934|ge song;
个月__個月 6488.8753536|ge yue;
格言__格言 226.595011951|ge yan;
各样__各樣 163.680258901|ge yang;
歌谣__歌謠 194.151676652|ge yao;
隔夜__隔夜 202.302314677|ge ye;
各异__各異 397.001179899|ge yi;
隔音__隔音 263.472890441|ge yin;
葛优__葛優 279.365316864|ge you;
各有__各有 1394.19862478|ge you;
格外__格外 1341.36617307|ge wai;
个位__個位 120.164975734|ge wei;
各位__各位 9668.39676357|ge wei;
歌舞__歌舞 484.601008682|ge wu;
个案__個案 498.691525358|ge an;
个儿__個兒 112.34478795|ge er;
戈尔__戈爾 218.280152578|ge er;
格尔__格爾 225.187525865|ge er;
跟班__跟班 164.088713397|gen ban;
根本__根本 18691.7933617|gen ben;
根部__根部 361.577631409|gen bu;
跟风__跟風 540.767020614|gen feng;
跟单__跟單 132.596773978|gen dan;
跟团__跟團 167.810977762|gen tuan;
跟她__跟她 1662.01257345|gen ta;
跟他__跟他 3165.45667059|gen ta;
跟贴__跟貼 620.98878351|gen tie;
跟帖__跟帖 670.869975958|gen tie;
跟头__跟頭 144.863304286|gen tou;
跟你__跟你 6157.98882218|gen ni;
跟您__跟您 164.293322714|gen nin;
亘古__亘古 108.222318063|gen gu;
根基__根基 441.911471008|gen ji;
跟进__跟進 1390.72814418|gen jin;
根据__根據 27677.6993611|gen ju;
跟前__跟前 536.070335228|gen qian;
根系__根系 197.076837307|gen xi;
跟着__跟着 5518.3979069|gen zhe;
根治__根治 329.314848809|gen zhi;
跟住__跟住 169.492308033|gen zhu;
根除__根除 154.947067523|gen chu;
跟上__跟上 734.761160623|gen shang;
跟谁__跟誰 312.132919672|gen shui;
跟人__跟人 478.003501869|gen ren;
跟在__跟在 420.423657369|gen zai;
跟踪__跟蹤 3213.14860644|gen zong;
跟随__跟隨 1515.60233678|gen sui;
根源__根源 1067.84239617|gen yuan;
跟我__跟我 6669.23318922|gen wo;
更不__更不 1339.6956486|geng bu;
更没__更沒 128.049907079|geng mei;
更美__更美 189.608710238|geng mei;
更名__更名 448.56947196|geng ming;
更大__更大 2712.23410734|geng da;
更低__更低 569.823995046|geng di;
耕地__耕地 836.433324055|geng di;
更迭__更迭 106.882056102|geng die;
更多__更多 13186.0302513|geng duo;
更替__更替 173.337150041|geng ti;
更难__更難 477.408200926|geng nan;
更能__更能 1081.23274995|geng neng;
更令__更令 154.561368684|geng ling;
更广__更廣 200.04606951|geng guang;
更改__更改 3541.1527732|geng gai;
更高__更高 2085.13074641|geng gao;
更贵__更貴 152.457122789|geng gui;
更快__更快 1467.28332601|geng kuai;
更可__更可 199.051387821|geng ke;
更换__更換 3676.04450285|geng huan;
更好__更好 5545.97394851|geng hao;
更会__更會 198.06165195|geng hui;
更佳__更佳 337.205131359|geng jia;
更加__更加 15198.8677332|geng jia;
更紧__更緊 107.550099352|geng jin;
更近__更近 218.280152578|geng jin;
更久__更久 110.95347192|geng jiu;
更具__更具 948.621258606|geng ju;
更强__更強 799.738513132|geng qiang;
更显__更顯 324.02287532|geng xian;
更小__更小 301.429591092|geng xiao;
更象__更象 123.197520618|geng xiang;
更像__更像 722.053448193|geng xiang;
更新__更新 16196.1802019|geng xin;
更正__更正 636.660374558|geng zheng;
耿直__耿直 139.895806636|geng zhi;
耕种__耕種 161.250795044|geng zhong;
更重__更重 168.229740225|geng zhong;
更差__更差 128.529517539|geng cha;
更长__更長 443.56664881|geng chang;
更少__更少 444.119751258|geng shao;
更甚__更甚 149.633788238|geng shen;
更深__更深 639.044983668|geng shen;
更是__更是 8325.49524507|geng shi;
更让__更讓 359.779772295|geng rang;
更糟__更糟 116.18910757|geng zao;
更早__更早 305.97104031|geng zao;
梗阻__梗阻 140.945727665|geng zu;
耕作__耕作 226.030964922|geng zuo;
更惨__更慘 187.4940348|geng can;
更远__更遠 458.745029596|geng yuan;
耕耘__耕耘 314.867617017|geng yun;
更要__更要 994.623178167|geng yao;
哽咽__哽咽 294.009808944|geng ye;
更衣__更衣 124.89791921|geng yi;
更易__更易 269.785619908|geng yi;
更应__更應 198.308623594|geng ying;
更有__更有 3373.16618304|geng you;
更为__更為 4200.38893397|geng wei;
更爱__更愛 184.481071779|geng ai;
给付__給付 162.460985719|gei fu;
给点__給點 769.432826682|gei dian;
给定__給定 346.1460998|gei ding;
给它__給它 586.392500602|gei ta;
给她__給她 3946.65663992|gei ta;
给他__給他 7563.75457546|gei ta;
给你__給你 31117.384839|gei ni;
给您__給您 1682.85360433|gei nin;
给了__給了 2746.24453283|gei le;
给个__給個 1306.71862793|gei ge;
给钱__給錢 870.462027204|gei qian;
给出__給出 2805.04388501|gei chu;
给水__給水 123.351140937|gei shui;
给谁__給誰 258.271618599|gei shui;
给人__給人 3034.13893483|gei ren;
给药__給葯 182.196395498|gei yao;
给与__給與 209.485777119|gei yu;
给予__給予 2671.97711617|gei yu;
给我__給我 33658.8205962|gei wo;
购并__購併 114.75018218|gou bing;
诟病__詬病 209.485777119|gou bing;
狗屁__狗屁 699.905273328|gou pi;
购票__購票 318.418891685|gou piao;
购买__購買 15293.8649795|gou mai;
购房__購房 1613.0410787|gou fang;
勾搭__勾搭 221.292902041|gou da;
够大__夠大 246.633556117|gou da;
勾当__勾當 188.196293023|gou dang;
购得__購得 190.318888971|gou de;
够多__夠多 187.4940348|gou duo;
勾兑__勾兌 113.895394799|gou dui;
狗头__狗頭 150.194241046|gou tou;
苟同__苟同 177.269210225|gou tong;
沟通__溝通 9740.95828863|gou tong;
构图__構圖 417.812212206|gou tu;
狗年__狗年 129.655606164|gou nian;
勾勒__勾勒 323.216307961|gou le;
沟里__溝里 124.587019602|gou li;
狗粮__狗糧 155.333728851|gou liang;
狗狗__狗狗 2156.48171146|gou gou;
够快__夠快 128.209578049|gou kuai;
勾画__勾畫 154.947067523|gou hua;
够狠__夠狠 183.563783354|gou hen;
篝火__篝火 161.049974862|gou huo;
购机__購機 303.313611771|gou ji;
构架__構架 426.226434824|gou jia;
构件__構件 486.416079992|gou jian;
构建__構建 3541.1527732|gou jian;
勾结__勾結 395.027185582|gou jie;
购进__購進 304.449671797|gou jin;
枸杞__枸杞 242.972837869|gou qi;
勾起__勾起 353.557372243|gou qi;
够呛__夠嗆 590.793388895|gou qiang;
沟渠__溝渠 112.34478795|gou qu;
勾选__勾選 254.438159592|gou xuan;
购销__購銷 295.479008313|gou xiao;
构想__構想 534.069978074|gou xiang;
狗熊__狗熊 220.467143161|gou xiong;
购置__購置 758.957532109|gou zhi;
构筑__構築 756.125466931|gou zhu;
购车__購車 515.756221017|gou che;
构成__構成 5322.53000909|gou cheng;
狗屎__狗屎 498.691525358|gou shi;
购书__購書 154.561368684|gou shu;
狗日__狗日 639.84183651|gou ri;
狗肉__狗肉 236.107646363|gou rou;
购入__購入 397.001179899|gou ru;
构造__構造 1508.06636321|gou zao;
狗子__狗子 110.539446825|gou zi;
狗仔__狗仔 122.432284019|gou zi;
钩子__鉤子 205.862715427|gou zi;
构思__構思 759.903909096|gou si;
勾引__勾引 894.656458236|gou yin;
够用__夠用 686.943814365|gou yong;
购物__購物 3049.30086097|gou wu;
公版__公版 133.093414711|gong ban;
公办__公辦 224.907079496|gong ban;
工包__工包 126.306596357|gong bao;
公报__公報 210.532600599|gong bao;
工兵__工兵 152.267254161|gong bing;
公布__公布 8751.01052505|gong bu;
公平__公平 3897.77990299|gong ping;
攻破__攻破 223.788782324|gong po;
公婆__公婆 242.066179876|gong po;
公仆__公僕 309.4219738|gong pu;
工贸__工貿 214.504991945|gong mao;
攻门__攻門 173.553291634|gong men;
共勉__共勉 203.060037258|gong mian;
公民__公民 2897.41660082|gong min;
功名__功名 208.964318904|gong ming;
共鸣__共鳴 781.999279332|gong ming;
共谋__共謀 120.015323434|gong mou;
公墓__公墓 197.322580943|gong mu;
功法__功法 120.765453341|gong fa;
供方__供方 125.522047856|gong fang;
公房__公房 155.333728851|gong fang;
攻防__攻防 251.914183226|gong fang;
功放__功放 426.757915008|gong fang;
共分__共分 184.481071779|gong fen;
公分__公分 399.482550191|gong fen;
供奉__供奉 296.955549433|gong feng;
公费__公費 284.991389772|gong fei;
工夫__工夫 858.611290099|gong fu;
功夫__功夫 2989.10399336|gong fu;
工大__工大 280.761336094|gong da;
攻打__攻打 321.609191441|gong da;
工单__工單 573.385557088|gong dan;
工党__工黨 160.249192015|gong dang;
公道__公道 562.066236349|gong dao;
公德__公德 106.882056102|gong de;
功德__功德 345.715012791|gong de;
功底__功底 566.284555508|gong di;
工地__工地 1483.83226857|gong di;
宫殿__宮殿 486.416079992|gong dian;
供电__供電 1597.0400293|gong dian;
共度__共度 223.231720645|gong du;
攻读__攻讀 327.677408739|gong du;
工体__工體 112.065135969|gong ti;
宫廷__宮廷 533.404852483|gong ting;
工头__工頭 145.950506492|gong tou;
公投__公投 296.216358865|gong tou;
共通__共通 173.553291634|gong tong;
共同__共同 11597.6536631|gong tong;
供暖__供暖 403.988165198|gong nuan;
宫女__宮女 333.444336783|gong nv;
功能__功能 34251.1958752|gong neng;
宫内__宮內 182.878811433|gong nei;
公牛__公牛 355.324137339|gong niu;
工农__工農 199.051387821|gong nong;
攻略__攻略 1629.20244568|gong lue;
功率__功率 1498.69906777|gong lv;
功劳__功勞 633.494731672|gong lao;
公历__公曆 131.281440129|gong li;
公理__公理 164.088713397|gong li;
宫里__宮裡 217.736803143|gong li;
公立__公立 245.101601395|gong li;
功利__功利 403.988165198|gong li;
巩俐__鞏俐 485.205278648|gong li;
功力__功力 828.13607043|gong li;
公里__公里 3966.37851746|gong li;
工龄__工齡 258.271618599|gong ling;
公路__公路 3703.63329569|gong lu;
公馆__公館 175.510734618|gong guan;
攻关__攻關 336.785179346|gong guan;
公关__公關 1062.53280282|gong guan;
公干__公幹 115.179978568|gong gan;
供稿__供稿 155.915530766|gong gao;
公告__公告 5518.3979069|gong gao;
供给__供給 261.184568064|gong gei;
公公__公公 686.943814365|gong gong;
公共__公共 3368.96527446|gong gong;
巩固__鞏固 1633.26802492|gong gu;
公款__公款 397.001179899|gong kuan;
工况__工況 177.048440864|gong kuang;
公开__公開 7451.48771757|gong kai;
工科__工科 363.837594448|gong ke;
攻克__攻克 408.544597361|gong ke;
功课__功課 844.813709452|gong ke;
工控__工控 112.484875527|gong kong;
工行__工行 2278.02623496|gong hang;
工号__工號 302.558594526|gong hao;
功耗__功耗 564.874943184|gong hao;
共和__共和 245.407229187|gong he;
恭候__恭候 109.442917312|gong hou;
供货__供貨 752.365812175|gong huo;
公会__公會 2221.95191814|gong hui;
工会__工會 2732.58948248|gong hui;
公爵__公爵 299.1842072|gong jue;
功绩__功績 215.30841961|gong ji;
公鸡__公雞 316.441045148|gong ji;
共计__共計 1038.96445205|gong ji;
供给__供給 1263.48355913|gong ji;
攻击__攻擊 8514.35463478|gong ji;
公家__公家 232.313479749|gong jia;
工件__工件 234.64107292|gong jian;
攻坚__攻堅 256.987424161|gong jian;
弓箭__弓箭 294.376422496|gong jian;
共建__共建 647.058374454|gong jian;
公交__公交 2412.42638506|gong jiao;
工匠__工匠 243.882891747|gong jiang;
共进__共進 233.183609039|gong jin;
公斤__公斤 1986.21549859|gong jin;
恭敬__恭敬 247.557321202|gong jing;
宫颈__宮頸 364.745529846|gong jing;
工具__工具 11860.7402097|gong ju;
供气__供氣 125.36572391|gong qi;
工期__工期 406.513206136|gong qi;
工钱__工錢 263.801426189|gong qian;
公顷__公頃 224.907079496|gong qing;
供求__供求 690.376548199|gong qiu;
工学__工學 155.527421199|gong xue;
功勋__功勛 202.050369328|gong xun;
恭喜__恭喜 3976.27638265|gong xi;
攻下__攻下 128.689786556|gong xia;
贡献__貢獻 5657.66302334|gong xian;
供销__供銷 172.260473089|gong xiao;
功效__功效 2041.42221915|gong xiao;
共享__共享 5822.16824258|gong xiang;
工薪__工薪 153.601316766|gong xin;
共性__共性 425.165459331|gong xing;
供需__供需 686.088301175|gong xu;
工序__工序 696.425160166|gong xu;
工装__工裝 139.72158175|gong zhuang;
攻占__攻佔 204.584007193|gong zhan;
公章__公章 573.385557088|gong zhang;
共振__共振 212.907119447|gong zhen;
工整__工整 170.977284899|gong zheng;
公证__公證 747.692521253|gong zheng;
公正__公正 2085.13074641|gong zheng;
公职__公職 152.647228173|gong zhi;
供职__供職 157.477678279|gong zhi;
工种__工種 292.183578474|gong zhong;
宫中__宮中 307.883446338|gong zhong;
公众__公眾 3671.46639254|gong zhong;
公猪__公豬 120.164975734|gong zhu;
公主__公主 3554.41614799|gong zhu;
共创__共創 310.194118206|gong chuang;
公差__公差 120.765453341|gong cha;
共产__共產 211.848489234|gong chan;
共唱__共唱 126.464093517|gong chang;
工厂__工廠 4982.35132078|gong chang;
公车__公車 926.424414408|gong che;
功臣__功臣 341.008342538|gong chen;
攻城__攻城 257.3078729|gong cheng;
工程__工程 16604.9153021|gong cheng;
公尺__公尺 138.680779525|gong chi;
共处__共處 155.333728851|gong chu;
共赏__共賞 145.768741141|gong shang;
工伤__工傷 380.057830188|gong shang;
工商__工商 2059.3077787|gong shang;
公社__公社 435.895152658|gong she;
共生__共生 213.438416689|gong sheng;
公事__公事 199.299593609|gong shi;
共事__共事 204.839111844|gong shi;
工事__工事 257.62872122|gong shi;
工时__工時 341.008342538|gong shi;
攻势__攻勢 686.088301175|gong shi;
公示__公示 1149.31255222|gong shi;
共识__共識 1346.39025518|gong shi;
公式__公式 2028.7420046|gong shi;
弓手__弓手 111.786180106|gong shou;
拱手__拱手 181.516526012|gong shou;
供述__供述 131.117943492|gong shu;
供水__供水 724.757896749|gong shui;
公然__公然 513.191745392|gong ran;
供热__供熱 488.846754671|gong re;
公认__公認 1123.81931445|gong ren;
工人__工人 4247.7635575|gong ren;
攻入__攻入 203.566761683|gong ru;
公仔__公仔 203.313241605|gong zai;
公子__公子 2561.13118731|gong zi;
工资__工資 13671.2731755|gong zi;
工作__工作 107925.460703|gong zuo;
共存__共存 352.677286738|gong cun;
公厕__公廁 239.664931108|gong ce;
公测__公測 578.409173188|gong ce;
公孙__公孫 268.444174826|gong sun;
公私__公私 116.044406778|gong si;
公司__公司 118498.854792|gong si;
公诉__公訴 222.398727024|gong su;
弓虽__弓雖 115.755545596|gong sui;
公元__公元 424.635962376|gong yuan;
公园__公園 3888.07743356|gong yuan;
公约__公約 496.21189989|gong yue;
公允__公允 108.087539034|gong yun;
供养__供養 418.854838101|gong yang;
公钥__公鑰 109.170488754|gong yao;
工业__工業 6337.04178046|gong ye;
公益__公益 1097.52300072|gong yi;
工艺__工藝 4107.21887886|gong yi;
公映__公映 256.667374505|gong ying;
共赢__共贏 369.319305625|gong ying;
供应__供應 5477.29072256|gong ying;
工友__工友 156.109948588|gong you;
公有__公有 164.703307075|gong you;
共有__共有 2590.0172328|gong you;
功用__功用 202.807148249|gong yong;
公用__公用 692.099342424|gong yong;
共用__共用 781.025384985|gong yong;
公寓__公寓 2082.53394472|gong yu;
公网__公網 304.829303266|gong wang;
公文__公文 504.944935018|gong wen;
工位__工位 129.332863581|gong wei;
工委__工委 287.130256264|gong wei;
恭维__恭維 426.757915008|gong wei;
共舞__共舞 173.553291634|gong wu;
公务__公務 602.691239054|gong wu;
公安__公安 1723.1742594|gong an;
古巴__古巴 506.204995518|gu ba;
古板__古板 108.222318063|gu ban;
古堡__古堡 145.950506492|gu bao;
股本__股本 680.129467195|gu ben;
骨盆__骨盆 129.494134325|gu pen;
孤僻__孤僻 169.703655326|gu pi;
股票__股票 19235.2858872|gu piao;
股评__股評 205.862715427|gu ping;
古朴__古樸 286.772667017|gu pu;
姑妈__姑媽 214.772467501|gu ma;
股民__股民 2164.55880585|gu min;
古墓__古墓 322.411748334|gu mu;
股份__股份 5650.61702447|gu fen;
古风__古風 123.351140937|gu feng;
姑父__姑父 142.357889859|gu fu;
辜负__辜負 628.775756137|gu fu;
古代__古代 2675.30892006|gu dai;
孤单__孤單 1540.35530331|gu dan;
鼓捣__鼓搗 151.132997772|gu dao;
古道__古道 214.504991945|gu dao;
孤岛__孤島 248.484546245|gu dao;
谷底__谷底 236.107646363|gu di;
古典__古典 1295.36947746|gu dian;
固定__固定 6803.54331971|gu ding;
鼓动__鼓動 374.41672986|gu dong;
古董__古董 480.392137969|gu dong;
股东__股東 3917.25753809|gu dong;
古都__古都 173.769702743|gu du;
孤独__孤獨 3657.76624243|gu du;
固态__固態 232.313479749|gu tai;
固体__固體 522.223615731|gu ti;
骨头__骨頭 1538.43695969|gu tou;
故土__故土 129.332863581|gu tu;
姑娘__姑娘 4566.14945001|gu niang;
顾虑__顧慮 744.902491688|gu lv;
古来__古來 202.302314677|gu lai;
古老__古老 1742.60930056|gu lao;
股利__股利 114.607273411|gu li;
古力__古力 148.149450567|gu li;
故里__故里 232.893204426|gu li;
孤立__孤立 540.767020614|gu li;
鼓励__鼓勵 6480.79417092|gu li;
估量__估量 145.043940608|gu liang;
鼓楼__鼓樓 330.548296374|gu lou;
古龙__古龍 356.655002599|gu long;
咕噜__咕嚕 143.784200776|gu lu;
古怪__古怪 653.541376022|gu guai;
股改__股改 1469.11294508|gu gai;
骨干__骨幹 1156.49608257|gu gan;
骨骼__骨骼 512.55262135|gu ge;
谷歌__谷歌 2003.61737423|gu ge;
故宫__故宮 564.874943184|gu gong;
鼓鼓__鼓鼓 115.899886195|gu gu;
咕咕__咕咕 146.679837233|gu gu;
姑姑__姑姑 754.243296976|gu gu;
故国__故國 113.895394799|gu guo;
骨科__骨科 204.839111844|gu ke;
顾客__顧客 4360.39268552|gu ke;
固化__固化 313.302012384|gu hua;
固话__固話 342.285588041|gu hua;
股海__股海 222.398727024|gu hai;
蛊惑__蠱惑 162.86639759|gu huo;
骨灰__骨灰 289.285174995|gu hui;
古迹__古迹 251.287110964|gu ji;
古籍__古籍 270.122027271|gu ji;
顾忌__顧忌 290.368691563|gu ji;
孤寂__孤寂 383.387639617|gu ji;
顾及__顧及 736.594714048|gu ji;
估计__估計 37233.7137504|gu ji;
顾家__顧家 131.445140637|gu jia;
骨架__骨架 376.756940916|gu jia;
估价__估價 408.544597361|gu jia;
股价__股價 4189.93320117|gu jia;
固件__固件 395.519762073|gu jian;
古今__古今 436.438689186|gu jin;
古井__古井 138.85370659|gu jing;
故居__故居 350.486645516|gu ju;
股权__股權 2561.13118731|gu quan;
骨气__骨氣 131.773154284|gu qi;
鼓起__鼓起 369.779825848|gu qi;
姑且__姑且 342.712398751|gu qie;
古琴__古琴 158.264611567|gu qin;
股息__股息 142.180598718|gu xi;
故乡__故鄉 1202.04704744|gu xiang;
孤星__孤星 130.791560815|gu xing;
古装__古裝 407.020105042|gu zhuang;
鼓掌__鼓掌 664.215078095|gu zhang;
故障__故障 3927.03282475|gu zhang;
骨折__骨折 952.17431607|gu zhe;
古镇__古鎮 567.697685436|gu zhen;
古筝__古箏 231.158356006|gu zheng;
固执__固執 810.776675547|gu zhi;
估值__估值 1288.92855961|gu zhi;
股指__股指 1388.99614478|gu zhi;
孤舟__孤舟 201.296414343|gu zhou;
雇主__僱主 534.069978074|gu zhu;
古城__古城 961.714332594|gu cheng;
鼓吹__鼓吹 370.702589737|gu chui;
孤身__孤身 196.831399718|gu shen;
股神__股神 423.578945935|gu shen;
古时__古時 186.561765129|gu shi;
古诗__古詩 243.275811214|gu shi;
股市__股市 10668.6512651|gu shi;
故事__故事 14550.2053507|gu shi;
鼓手__鼓手 132.596773978|gu shou;
固守__固守 185.172044961|gu shou;
股数__股數 131.281440129|gu shu;
古书__古書 133.591915611|gu shu;
古树__古樹 203.060037258|gu shu;
固然__固然 1104.38283164|gu ran;
故人__故人 233.183609039|gu ren;
古人__古人 1137.91159836|gu ren;
骨肉__骨肉 202.554574186|gu rou;
股灾__股災 111.925571131|gu zai;
谷子__穀子 233.183609039|gu zi;
故作__故作 316.83562918|gu zuo;
故此__故此 145.405889264|gu ci;
估算__估算 842.710774091|gu suan;
骨髓__骨髓 458.745029596|gu sui;
雇员__僱員 590.793388895|gu yuan;
古月__古月 123.197520618|gu yue;
孤云__孤雲 168.439513167|gu yun;
故意__故意 4311.76192745|gu yi;
股友__股友 119.26985293|gu you;
故有__故有 147.229226029|gu you;
固有__固有 553.723632203|gu you;
雇用__僱用 347.442588754|gu yong;
雇佣__雇傭 464.497524783|gu yong;
古玩__古玩 177.269210225|gu wan;
固网__固網 297.325836157|gu wang;
古文__古文 285.346757867|gu wen;
顾问__顧問 2421.46211928|gu wen;
谷物__穀物 213.172602547|gu wu;
鼓舞__鼓舞 657.626195507|gu wu;
孤傲__孤傲 137.134095104|gu ao;
故而__故而 227.727332161|gu er;
孤儿__孤兒 553.034030141|gu er;
锅巴__鍋巴 119.41857567|guo ba;
过半__過半 279.713669565|guo ban;
国宝__國寶 312.522131716|guo bao;
国标__國標 328.904723278|guo biao;
果皮__果皮 117.93965545|guo pi;
果品__果品 230.295783987|guo pin;
过吗__過嗎 266.444503116|guo ma;
国贸__國貿 672.544092675|guo mao;
国门__國門 335.946843682|guo men;
国美__國美 1140.75119008|guo mei;
国米__國米 806.745280603|guo mi;
过敏__過敏 1269.79732551|guo min;
国民__國民 1617.0663282|guo min;
过目__過目 250.349428094|guo mu;
国防__國防 837.47630896|guo fang;
国分__國分 154.561368684|guo fen;
过份__過份 290.0070692|guo fen;
过分__過分 2959.45267121|guo fen;
国富__國富 106.085879302|guo fu;
过段__過段 161.653186955|guo duan;
果断__果斷 760.851466162|guo duan;
过大__過大 1203.54593192|guo da;
过道__過道 279.713669565|guo dao;
国道__國道 506.83620443|guo dao;
过得__過得 2430.53169682|guo de;
锅底__鍋底 139.72158175|guo di;
过低__過低 381.957020988|guo di;
国电__國電 219.37092252|guo dian;
过冬__過冬 212.112652282|guo dong;
果冻__果凍 369.779825848|guo dong;
国度__國度 616.362966229|guo du;
过渡__過渡 1436.52612129|guo du;
过度__過度 2678.64487851|guo du;
过多__過多 2826.09579953|guo duo;
国泰__國泰 336.785179346|guo tai;
国投__國投 224.06783424|guo tou;
过头__過頭 645.447697543|guo tou;
国土__國土 829.168709129|guo tu;
锅内__鍋內 242.972837869|guo nei;
国内__國內 25779.9104079|guo nei;
过你__過你 303.313611771|guo ni;
过年__過年 2323.90287358|guo nian;
果农__果農 125.992190229|guo nong;
国旅__國旅 219.097720093|guo lv;
过滤__過濾 1973.87819843|guo lv;
过来__過來 31233.9348904|guo lai;
过了__過了 7169.11735945|guo le;
国力__國力 321.609191441|guo li;
锅里__鍋里 358.884197808|guo li;
国立__國立 364.291279287|guo li;
过量__過量 581.299547476|guo liang;
过路__過路 219.918349804|guo lu;
锅炉__鍋爐 699.033618062|guo lu;
过关__過關 992.147332631|guo guan;
国光__國光 121.975425508|guo guang;
锅盖__鍋蓋 154.561368684|guo gai;
果敢__果敢 119.56748386|guo gan;
过高__過高 1319.8108917|guo gao;
国歌__國歌 309.4219738|guo ge;
国共__國共 189.608710238|guo gong;
过过__過過 146.679837233|guo guo;
蝈蝈__蟈蟈 187.4940348|guo guo;
果果__果果 469.736419493|guo guo;
过快__過快 606.458230719|guo kuai;
过客__過客 559.271495144|guo ke;
国库__國庫 276.938965124|guo ku;
国华__國華 193.90988203|guo hua;
国画__國畫 256.347723437|guo hua;
国航__國航 650.291796355|guo hang;
过好__過好 215.040276584|guo hao;
过河__過河 307.117053725|guo he;
过后__過後 2326.80064863|guo hou;
过户__過戶 616.362966229|guo hu;
过活__過活 110.264288753|guo huo;
过火__過火 197.322580943|guo huo;
国货__國貨 369.779825848|guo huo;
国会__國會 870.462027204|guo hui;
国君__國君 152.077621994|guo jun;
国军__國軍 276.249600432|guo jun;
过激__過激 332.614317243|guo ji;
国籍__國籍 543.469292924|guo ji;
国际__國際 20243.6107394|guo ji;
郭嘉__郭嘉 121.217779906|guo jia;
国家__國家 40475.9426414|guo jia;
国脚__國腳 256.347723437|guo jiao;
果酱__果醬 124.89791921|guo jiang;
过江__過江 153.218967809|guo jiang;
过奖__過獎 252.228305921|guo jiang;
国界__國界 168.020228531|guo jie;
过节__過節 1063.85772095|guo jie;
过境__過境 230.295783987|guo jing;
郭靖__郭靖 300.679263607|guo jing;
过气__過氣 192.705418355|guo qi;
国旗__國旗 665.872587905|guo qi;
过期__過期 1595.05109108|guo qi;
国企__國企 1655.81074036|guo qi;
过桥__過橋 159.253810404|guo qiao;
国强__國強 181.290467084|guo qiang;
国情__國情 770.392265767|guo qing;
国庆__國慶 3072.18592933|guo qing;
过去__過去 31665.0323561|guo qu;
国学__國學 376.287731462|guo xue;
过些__過些 137.305093541|guo xie;
国信__國信 198.06165195|guo xin;
国债__國債 910.401881269|guo zhai;
过招__過招 139.547573842|guo zhao;
裹着__裹着 211.057972369|guo zhe;
过着__過着 822.992135502|guo zhe;
果真__果真 496.830647979|guo zhen;
国之__國之 153.984619852|guo zhi;
果汁__果汁 614.828697239|guo zhi;
锅中__鍋中 246.326401069|guo zhong;
过重__過重 273.168633085|guo zhong;
国产__國產 3153.64470585|guo chan;
过场__過場 111.646962678|guo chang;
过长__過長 514.472385324|guo chang;
过程__過程 27165.1394788|guo cheng;
过上__過上 353.998238229|guo shang;
过少__過少 117.93965545|guo shao;
过剩__過剩 903.620192345|guo sheng;
国士__國士 121.368931601|guo shi;
国事__國事 149.633788238|guo shi;
过世__過世 253.173026121|guo shi;
过失__過失 441.911471008|guo shi;
过时__過時 635.867483878|guo shi;
果实__果實 883.576728645|guo shi;
果蔬__果蔬 203.313241605|guo shu;
果树__果樹 342.285588041|guo shu;
国税__國稅 431.033684153|guo shui;
果然__果然 6150.31972239|guo ran;
过热__過熱 699.033618062|guo re;
过人__過人 423.051424808|guo ren;
国人__國人 2090.33406802|guo ren;
果肉__果肉 119.716577729|guo rou;
过早__過早 528.113581536|guo zao;
国资__國資 313.302012384|guo zi;
果子__果子 571.958268741|guo zi;
国足__國足 517.687984062|guo zu;
国策__國策 117.499561272|guo ce;
过错__過錯 758.012333731|guo cuo;
国粹__國粹 121.368931601|guo cui;
果园__果園 345.715012791|guo yuan;
过夜__過夜 596.712660816|guo ye;
过亿__過億 139.373782642|guo yi;
过瘾__過癮 988.445115058|guo yin;
国营__國營 309.036622663|guo ying;
过硬__過硬 423.051424808|guo ying;
国有__國有 2016.1405527|guo you;
国语__國語 669.200026501|guo yu;
过于__過於 3432.5319072|guo yu;
国外__國外 10200.611399|guo wai;
过万__過萬 109.716025699|guo wan;
过弯__過彎 111.091824605|guo wan;
过完__過完 434.268601197|guo wan;
过往__過往 783.950712715|guo wang;
国王__國王 1674.48601346|guo wang;
过问__過問 278.322859608|guo wen;
过我__過我 377.697115787|guo wo;
国务__國務 107.015331962|guo wu;
国安__國安 490.066643104|guo an;
国奥__國奧 450.24958728|guo ao;
瑰宝__瑰寶 136.282292017|gui bao;
规避__規避 748.624851411|gui bi;
贵宾__貴賓 487.62990282|gui bin;
鬼片__鬼片 162.663565352|gui pian;
鬼魅__鬼魅 157.2815571|gui mei;
规模__規模 8181.50559908|gui mo;
规范__規範 8567.57177296|gui fan;
贵方__貴方 119.86585751|gui fang;
闺房__閨房 130.628674269|gui fang;
规费__規費 120.314814642|gui fei;
贵妃__貴妃 239.963779681|gui fei;
贵妇__貴婦 110.815291538|gui fu;
归档__歸檔 524.179602378|gui dang;
轨道__軌道 1773.27819069|gui dao;
贵的__貴的 266.112675706|gui de;
跪地__跪地 115.899886195|gui di;
贵点__貴點 130.628674269|gui dian;
规定__規定 16419.7233534|gui ding;
归队__歸隊 129.171793682|gui dui;
柜台__櫃檯 1293.75623683|gui tai;
龟头__龜頭 394.535222541|gui tou;
闺女__閨女 359.331706043|gui nv;
归纳__歸納 834.351249399|gui na;
规律__規律 4066.47607754|gui lv;
归来__歸來 1418.73569366|gui lai;
鬼佬__鬼佬 129.332863581|gui lao;
归类__歸類 377.226735448|gui lei;
瑰丽__瑰麗 147.045868173|gui li;
鬼脸__鬼臉 168.859844103|gui lian;
桂林__桂林 1469.11294508|gui lin;
桂冠__桂冠 250.661599628|gui guan;
鬼怪__鬼怪 128.529517539|gui guai;
规格__規格 2808.54161561|gui ge;
归功__歸功 270.796100963|gui gong;
硅谷__硅谷 331.786363812|gui gu;
归国__歸國 196.096919422|gui guo;
龟龟__龜龜 114.46454262|gui gui;
鬼鬼__鬼鬼 166.560934377|gui gui;
归口__歸口 109.716025699|gui kou;
鬼话__鬼話 246.326401069|gui hua;
桂花__桂花 435.352293046|gui hua;
规划__規劃 9850.82293187|gui hua;
归还__歸還 581.299547476|gui huan;
鬼混__鬼混 184.71110921|gui hun;
鬼魂__鬼魂 344.85444872|gui hun;
诡计__詭計 106.085879302|gui ji;
轨迹__軌跡 999.59341964|gui ji;
贵贱__貴賤 136.452228303|gui jian;
硅胶__硅膠 249.104624871|gui jiao;
归结__歸結 455.895552723|gui jie;
归咎__歸咎 206.119414554|gui jiu;
规矩__規矩 1392.46230328|gui ju;
鬼泣__鬼泣 132.762114633|gui qi;
跪求__跪求 211.321149687|gui qiu;
归去__歸去 242.066179876|gui qu;
跪下__跪下 347.875829952|gui xia;
贵校__貴校 124.587019602|gui xiao;
贵姓__貴姓 164.293322714|gui xing;
贵站__貴站 261.510250403|gui zhan;
规章__規章 633.494731672|gui zhang;
跪着__跪着 158.857391092|gui zhe;
规制__規制 167.601987591|gui zhi;
贵州__貴州 1773.27819069|gui zhou;
贵重__貴重 293.643651968|gui zhong;
规程__規程 343.567617462|gui cheng;
鬼神__鬼神 241.463621556|gui shen;
归属__歸屬 751.428823061|gui shu;
贵人__貴人 415.734739962|gui ren;
归入__歸入 190.081867665|gui ru;
跪在__跪在 438.619621343|gui zai;
规则__規則 8050.03168928|gui ze;
柜子__柜子 656.807194196|gui zi;
鬼子__鬼子 869.377962205|gui zi;
贵族__貴族 1591.08064256|gui zu;
归宿__歸宿 520.923681206|gui su;
柜员__櫃員 120.765453341|gui yuan;
贵阳__貴陽 959.320404733|gui yang;
皈依__皈依 207.149415951|gui yi;
诡异__詭異 1086.63578899|gui yi;
归于__歸於 409.054029297|gui yu;
鬼王__鬼王 167.393257695|gui wang;
归为__歸為 167.810977762|gui wei;
归案__歸案 133.925286409|gui an;
挎包__挎包 118.824795093|kua bao;
夸大__誇大 528.772109212|kua da;
垮掉__垮掉 107.684208225|kua diao;
跨度__跨度 319.213487372|kua du;
垮塌__垮塌 128.369448119|kua ta;
垮台__垮台 110.401782066|kua tai;
跨过__跨過 261.510250403|kua guo;
跨国__跨國 749.558344131|kua guo;
跨行__跨行 234.933657026|kua hang;
夸奖__誇獎 670.869975958|kua jiang;
跨境__跨境 120.314814642|kua jing;
跨区__跨區 127.413209251|kua qu;
夸张__誇張 2930.09548433|kua zhang;
跨出__跨出 150.381524744|kua chu;
跨省__跨省 139.72158175|kua sheng;
跨入__跨入 212.377144726|kua ru;
跨越__跨越 1053.30446216|kua yue;
宽频__寬頻 246.326401069|kuan pin;
宽屏__寬屏 1082.58098585|kuan ping;
宽泛__寬泛 160.249192015|kuan fan;
宽幅__寬幅 142.713135632|kuan fu;
宽大__寬大 494.360275282|kuan da;
款待__款待 160.649084484|kuan dai;
宽带__寬帶 2875.83340941|kuan dai;
宽的__寬的 166.97657743|kuan de;
宽度__寬度 1202.04704744|kuan du;
宽广__寬廣 480.991159713|kuan guang;
款款__款款 168.229740225|kuan kuan;
宽阔__寬闊 469.151414294|kuan kuo;
宽厚__寬厚 202.554574186|kuan hou;
款项__款項 1053.30446216|kuan xiang;
宽敞__寬敞 511.914293268|kuan chang;
款式__款式 1472.77903036|kuan shi;
宽恕__寬恕 252.54282031|kuan shu;
宽容__寬容 1601.02534912|kuan rong;
宽松__寬鬆 783.950712715|kuan song;
宽裕__寬裕 268.109857044|kuan yu;
宽慰__寬慰 130.303509496|kuan wei;
狂暴__狂暴 546.185068786|kuang bao;
狂奔__狂奔 399.482550191|kuang ben;
狂飙__狂飆 225.468321935|kuang biao;
狂风__狂風 316.83562918|kuang feng;
狂跌__狂跌 172.260473089|kuang die;
狂顶__狂頂 121.975425508|kuang ding;
框图__框圖 112.765574943|kuang tu;
矿难__礦難 323.619340361|kuang nan;
旷工__曠工 117.061109314|kuang gong;
矿工__礦工 620.98878351|kuang gong;
框框__框框 215.576896995|kuang kuang;
旷课__曠課 110.126966673|kuang ke;
狂欢__狂歡 592.267679181|kuang huan;
框架__框架 3506.02523602|kuang jia;
矿井__礦井 443.56664881|kuang jing;
况且__況且 1308.34803192|kuang qie;
矿区__礦區 346.1460998|kuang qu;
狂喜__狂喜 150.194241046|kuang xi;
狂笑__狂笑 232.024158785|kuang xiao;
狂涨__狂漲 136.963309627|kuang zhang;
框中__框中 161.451865638|kuang zhong;
矿主__礦主 140.945727665|kuang zhu;
矿床__礦床 118.529012887|kuang chuang;
矿产__礦產 331.37316028|kuang chan;
狂潮__狂潮 210.270405333|kuang chao;
矿山__礦山 606.458230719|kuang shan;
矿石__礦石 504.944935018|kuang shi;
狂热__狂熱 801.734213733|kuang re;
狂人__狂人 449.688850794|kuang ren;
狂晕__狂暈 124.587019602|kuang yun;
旷野__曠野 174.855812809|kuang ye;
狂野__狂野 344.85444872|kuang ye;
矿业__礦業 588.588831574|kuang ye;
狂妄__狂妄 246.633556117|kuang wang;
矿物__礦物 518.979844093|kuang wu;
捆绑__捆綁 926.424414408|kun bang;
昆明__昆明 2561.13118731|kun ming;
困顿__困頓 108.222318063|kun dun;
困难__困難 9453.93922796|kun nan;
昆仑__崑崙 410.586139672|kun lun;
困苦__困苦 133.591915611|kun ku;
困惑__困惑 1494.96846157|kun huo;
困境__困境 1427.60319527|kun jing;
困局__困局 131.773154284|kun ju;
昆曲__崑曲 160.249192015|kun qu;
昆虫__昆蟲 509.368920718|kun chong;
昆山__崑山 740.275558891|kun shan;
困扰__困擾 1615.05244942|kun rao;
困在__困在 135.94305409|kun zai;
困死__困死 177.269210225|kun si;
快把__快把 151.699065864|kuai ba;
快报__快報 265.119670945|kuai bao;
快步__快步 268.109857044|kuai bu;
快跑__快跑 252.85772688|kuai pao;
快慢__快慢 169.070402749|kuai man;
快门__快門 625.649317648|kuai men;
快到__快到 773.277767188|kuai dao;
快递__快遞 5917.25646732|kuai di;
快点__快點 4611.89857437|kuai dian;
快艇__快艇 157.477678279|kuai ting;
快来__快來 1003.33739315|kuai lai;
快乐__快樂 16481.2233673|kuai le;
快感__快感 1229.31483934|kuai gan;
快攻__快攻 143.784200776|kuai gong;
快快__快快 675.904869515|kuai kuai;
快看__快看 108.087539034|kuai kan;
快活__快活 378.63963681|kuai huo;
会计__會計 3290.13465937|kuai ji;
快件__快件 228.8653107|kuai jian;
快捷__快捷 1401.16558873|kuai jie;
快进__快進 224.626982392|kuai jin;
快就__快就 254.755429543|kuai jiu;
快钱__快錢 183.335174792|kuai qian;
块钱__塊錢 4216.1214754|kuai qian;
快去__快去 1243.1798239|kuai qu;
快讯__快訊 353.557372243|kuai xun;
快些__快些 295.111021611|kuai xie;
块状__塊狀 133.758497151|kuai zhuang;
快照__快照 234.056997396|kuai zhao;
快车__快車 409.564096466|kuai che;
快成__快成 105.953760973|kuai cheng;
快说__快說 314.867617017|kuai shuo;
筷子__筷子 837.47630896|kuai zi;
快走__快走 196.096919422|kuai zou;
快餐__快餐 734.761160623|kuai can;
快速__快速 7764.30695341|kuai su;
快运__快運 114.607273411|kuai yun;
快要__快要 1343.0387806|kuai yao;
快意__快意 192.465424888|kuai yi;
快又__快又 114.321989585|kuai you;
快啊__快啊 163.884358899|kuai a;
卡吧__卡吧 395.519762073|ka ba;
卡巴__卡巴 1024.81967123|ka ba;
卡片__卡片 1143.59786783|ka pian;
卡门__卡門 177.711575153|ka men;
咖啡__咖啡 3782.93112802|ka fei;
卡特__卡特 337.625607028|ka te;
卡通__卡通 1114.0586864|ka tong;
卡尼__卡尼 168.439513167|ka ni;
卡拉__卡拉 917.234466913|ka la;
卡勒__卡勒 150.194241046|ka le;
卡里__卡里 333.444336783|ka li;
卡罗__卡羅 143.963491517|ka luo;
咔咔__咔咔 1135.07907503|ka ka;
卡卡__卡卡 1593.06462986|ka ka;
卡号__卡號 894.656458236|ka hao;
卡住__卡住 367.482952871|ka zhu;
咔嚓__咔嚓 109.989815613|ka cha;
喀嚓__喀嚓 151.888225993|ka cha;
卡车__卡車 631.130833438|ka che;
卡上__卡上 308.651751439|ka shang;
喀什__喀什 238.176261728|ka shi;
卡在__卡在 180.613978088|ka zai;
卡斯__卡斯 109.716025699|ka si;
卡死__卡死 236.107646363|ka si;
卡恩__卡恩 118.972962872|ka en;
卡尔__卡爾 416.253137598|ka er;
开班__開班 196.341441156|kai ban;
开办__開辦 940.382265783|kai ban;
开标__開標 148.704343794|kai biao;
开播__開播 309.807805448|kai bo;
开拍__開拍 348.743933702|kai pai;
开盘__開盤 2289.40978274|kai pan;
开炮__開炮 113.47039186|kai pao;
开辟__開闢 1140.75119008|kai pi;
开篇__開篇 247.557321202|kai pian;
开票__開票 544.146968302|kai piao;
开平__開平 175.510734618|kai ping;
开骂__開罵 127.254530072|kai ma;
开满__開滿 121.823518492|kai man;
开门__開門 2172.66615296|kai men;
开明__開明 277.976239008|kai ming;
楷模__楷模 270.122027271|kai mo;
开幕__開幕 1609.02584897|kai mu;
开发__開發 23508.9030495|kai fa;
开饭__開飯 208.44415872|kai fan;
开房__開房 427.82286438|kai fang;
开放__開放 7133.47062176|kai fang;
开封__開封 533.404852483|kai feng;
开端__開端 345.715012791|kai duan;
开打__開打 323.216307961|kai da;
开刀__開刀 320.808632296|kai dao;
开导__開導 338.890182508|kai dao;
开到__開到 836.433324055|kai dao;
开得__開得 352.677286738|kai de;
开灯__開燈 242.972837869|kai deng;
凯迪__凱迪 123.351140937|kai di;
开店__開店 989.677650042|kai dian;
开动__開動 217.736803143|kai dong;
慨叹__慨嘆 136.792736844|kai tan;
凯特__凱特 170.977284899|kai te;
楷体__楷體 107.952927857|kai ti;
开题__開題 321.609191441|kai ti;
开庭__開庭 452.499534015|kai ting;
开头__開頭 1981.27135202|kai tou;
开通__開通 4811.50185273|kai tong;
开脱__開脫 153.028150386|kai tuo;
开拓__開拓 1589.0991261|kai tuo;
开来__開來 1087.99076217|kai lai;
开朗__開朗 872.634214191|kai lang;
凯利__凱利 112.484875527|kai li;
开立__開立 268.109857044|kai li;
开裂__開裂 236.107646363|kai lie;
开路__開路 215.040276584|kai lu;
开罗__開羅 123.197520618|kai luo;
开关__開關 2143.08680935|kai guan;
开光__開光 115.036534536|kai guang;
凯歌__凱歌 119.41857567|kai ge;
开个__開個 1523.17596844|kai ge;
开工__開工 1540.35530331|kai gong;
开国__開國 206.119414554|kai guo;
开过__開過 519.626982517|kai guo;
开开__開開 468.567137655|kai kai;
开考__開考 126.149295342|kai kao;
开课__開課 240.862563142|kai ke;
开垦__開墾 129.171793682|kai ken;
开口__開口 2095.55037421|kai kou;
开阔__開闊 714.89082038|kai kuo;
开花__開花 827.104717768|kai hua;
开荒__開荒 439.166555128|kai huang;
开怀__開懷 151.888225993|kai huai;
开好__開好 222.67604562|kai hao;
开户__開戶 1655.81074036|kai hu;
开火__開火 169.492308033|kai huo;
开会__開會 5865.86374011|kai hui;
开卷__開卷 123.658956482|kai juan;
开机__開機 2822.57620712|kai ji;
开家__開家 118.824795093|kai jia;
铠甲__鎧甲 193.186303435|kai jia;
开价__開價 303.313611771|kai jia;
开奖__開獎 271.471856767|kai jiang;
开进__開進 222.953710017|kai jin;
开具__開具 457.033213363|kai ju;
开局__開局 564.171453387|kai ju;
开起__開起 135.773751924|kai qi;
开启__開啟 2668.64946169|kai qi;
开窍__開竅 161.049974862|kai qiao;
开枪__開槍 536.738784525|kai qiang;
开球__開球 121.671800659|kai qiu;
开去__開去 179.045304336|kai qu;
凯旋__凱旋 431.571158705|kai xuan;
开学__開學 2688.67773313|kai xue;
开县__開縣 105.0335283|kai xian;
开销__開銷 775.207436548|kai xiao;
开箱__開箱 110.401782066|kai xiang;
开新__開新 1693.37191801|kai xin;
开心__開心 11934.8732095|kai xin;
开行__開行 275.218769535|kai xing;
开战__開戰 420.423657369|kai zhan;
开展__開展 11875.5298799|kai zhan;
开张__開張 813.813436628|kai zhang;
开着__開着 1856.95505407|kai zhe;
开征__開徵 259.562230298|kai zheng;
开支__開支 1218.6379585|kai zhi;
开窗__開窗 197.814987883|kai chuang;
开创__開創 1303.46590513|kai chuang;
开唱__開唱 118.824795093|kai chang;
开场__開場 715.782248677|kai chang;
开车__開車 3981.23457372|kai che;
开除__開除 814.828215816|kai chu;
开出__開出 1404.66211536|kai chu;
开山__開山 149.447435764|kai shan;
开设__開設 1808.98982626|kai she;
开市__開市 274.876014738|kai shi;
开始__開始 78154.1916438|kai shi;
楷书__楷書 107.14877401|kai shu;
开水__開水 904.746955463|kai shui;
凯子__凱子 117.499561272|kai zi;
开走__開走 111.230349808|kai zou;
开采__開採 884.6784987|kai cai;
凯撒__凱撒 138.680779525|kai sa;
开赛__開賽 255.073095111|kai sai;
开锁__開鎖 277.976239008|kai suo;
开元__開元 299.93080386|kai yuan;
开源__開源 1236.99840673|kai yuan;
凯越__凱越 276.938965124|kai yue;
开业__開業 1378.64935183|kai ye;
开挖__開挖 251.287110964|kai wa;
开外__開外 122.127521944|kai wai;
开完__開完 326.048110451|kai wan;
开往__開往 345.284462654|kai wang;
凯文__凱文 205.60633599|kai wen;
开胃__開胃 160.449013667|kai wei;
看吧__看吧 954.550411286|kan ba;
堪比__堪比 137.476305203|kan bi;
看病__看病 1111.28553845|kan bing;
看不__看不 628.775756137|kan bu;
看盘__看盤 382.433299725|kan pan;
看片__看片 326.861744407|kan pian;
看破__看破 117.792774542|kan po;
看门__看門 195.121873946|kan men;
砍伐__砍伐 160.849404779|kan fa;
刊发__刊發 208.70407676|kan fa;
看法__看法 6432.51798548|kan fa;
看房__看房 454.194369369|kan fang;
看待__看待 1508.06636321|kan dai;
看淡__看淡 134.594525802|kan dan;
砍刀__砍刀 124.89791921|kan dao;
看到__看到 65642.3051592|kan dao;
看得__看得 3095.24275062|kan de;
刊登__刊登 1420.50477658|kan deng;
看点__看點 616.362966229|kan dian;
砍掉__砍掉 211.321149687|kan diao;
看碟__看碟 138.508067822|kan die;
看懂__看懂 1094.79101389|kan dong;
看多__看多 393.063006485|kan duo;
看台__看台 289.645897197|kan tai;
勘探__勘探 387.711726118|kan tan;
看帖__看帖 145.587202159|kan tie;
看贴__看貼 257.62872122|kan tie;
看头__看頭 208.964318904|kan tou;
看透__看透 415.216987933|kan tou;
看图__看圖 260.859291326|kan tu;
看那__看那 533.404852483|kan na;
看你__看你 5044.82818733|kan ni;
看来__看來 20962.4320622|kan lai;
看了__看了 14441.819188|kan le;
看官__看官 148.519148841|kan guan;
看管__看管 176.168109435|kan guan;
看个__看個 372.555031371|kan ge;
看过__看過 8653.41191264|kan guo;
看开__看開 106.748946222|kan kai;
侃侃__侃侃 132.10198647|kan kan;
看看__看看 59859.7343248|kan kan;
看客__看客 309.4219738|kan ke;
坎坷__坎坷 598.94764591|kan ke;
看空__看空 260.534419685|kan kong;
看海__看海 152.457122789|kan hai;
看好__看好 4056.35368459|kan hao;
看后__看后 200.29551561|kan hou;
看护__看護 168.859844103|kan hu;
看家__看家 144.143005824|kan jia;
砍价__砍價 359.779772295|kan jia;
看见__看見 16522.3512945|kan jian;
看齐__看齊 204.07475061|kan qi;
看起__看起 252.85772688|kan qi;
看清__看清 994.623178167|kan qing;
看球__看球 679.282440527|kan qiu;
看去__看去 385.78392141|kan qu;
看戏__看戲 269.114061535|kan xi;
砍下__砍下 151.888225993|kan xia;
看下__看下 1218.6379585|kan xia;
看向__看向 237.583386308|kan xiang;
看准__看準 303.313611771|kan zhun;
看涨__看漲 275.905561849|kan zhang;
看这__看這 330.960471347|kan zhe;
看着__看着 14227.4629914|kan zhe;
看重__看重 1168.08323794|kan zhong;
看中__看中 1250.95005139|kan zhong;
看穿__看穿 239.366454718|kan chuan;
勘查__勘查 264.789493468|kan cha;
勘察__勘察 364.745529846|kan cha;
砍柴__砍柴 134.594525802|kan chai;
看车__看車 151.699065864|kan che;
看成__看成 972.56115063|kan cheng;
堪称__堪稱 1049.37403554|kan cheng;
刊出__刊出 127.254530072|kan chu;
看出__看出 2712.23410734|kan chu;
看上__看上 1029.9408079|kan shang;
看是__看是 129.171793682|kan shi;
看守__看守 278.322859608|kan shou;
看书__看書 3630.51911858|kan shu;
看谁__看誰 339.735863102|kan shui;
砍人__砍人 132.266710153|kan ren;
看人__看人 304.449671797|kan ren;
看在__看在 155.527421199|kan zai;
刊载__刊載 484.601008682|kan zai;
看做__看做 154.368879448|kan zuo;
看作__看作 1077.19810837|kan zuo;
勘测__勘測 184.251320835|kan ce;
看错__看錯 693.826435782|kan cuo;
砍死__砍死 214.2378495|kan si;
看似__看似 1605.02061407|kan si;
堪忧__堪憂 140.945727665|kan you;
刊用__刊用 185.86560618|kan yong;
看完__看完 3907.50658436|kan wan;
看望__看望 1019.7239982|kan wang;
看我__看我 2188.97205903|kan wo;
刊物__刊物 764.653524665|kan wu;
看啊__看啊 272.149298879|kan a;
抗病__抗病 132.266710153|kang bing;
亢奋__亢奮 290.730764849|kang fen;
康复__康復 1037.67053575|kang fu;
康德__康德 193.186303435|kang de;
抗跌__抗跌 144.502706249|kang die;
康定__康定 120.015323434|kang ding;
抗体__抗體 743.974797322|kang ti;
康宁__康寧 105.295633316|kang ning;
康乐__康樂 129.817279349|kang le;
慷慨__慷慨 399.482550191|kang kai;
康康__康康 157.085680168|kang kang;
抗旱__抗旱 382.433299725|kang han;
抗衡__抗衡 423.578945935|kang heng;
抗洪__抗洪 128.209578049|kang hong;
抗菌__抗菌 286.058823982|kang jun;
抗击__抗擊 280.761336094|kang ji;
康佳__康佳 256.667374505|kang jia;
抗拒__抗拒 471.495815538|kang ju;
康桥__康橋 142.003528374|kang qiao;
康熙__康熙 1033.79844744|kang xi;
抗性__抗性 290.730764849|kang xing;
抗战__抗戰 766.561672733|kang zhan;
扛着__扛着 240.862563142|kang zhe;
抗震__抗震 335.110594827|kang zhen;
抗争__抗爭 492.515560049|kang zheng;
抗日__抗日 935.706437745|kang ri;
抗灾__抗災 204.839111844|kang zai;
抗原__抗原 294.009808944|kang yuan;
抗议__抗議 1653.74860966|kang yi;
抗癌__抗癌 239.963779681|kang ai;
靠背__靠背 128.529517539|kao bei;
拷贝__拷貝 1489.38995692|kao bei;
靠边__靠邊 132.596773978|kao bian;
考博__考博 107.416157498|kao bo;
考评__考評 634.284663664|kao ping;
靠谱__靠譜 554.41409416|kao pu;
考得__考得 385.78392141|kao de;
靠垫__靠墊 105.558392399|kao dian;
考点__考點 469.151414294|kao dian;
考题__考題 351.361264404|kao ti;
考虑__考慮 27403.1420416|kao lv;
考拉__考拉 213.172602547|kao la;
犒劳__犒勞 106.882056102|kao lao;
考量__考量 419.900065808|kao liang;
靠拢__靠攏 336.365750338|kao long;
考录__考錄 129.494134325|kao lu;
考官__考官 425.165459331|kao guan;
考古__考古 692.962351041|kao gu;
考过__考過 309.036622663|kao guo;
靠靠__靠靠 115.611384758|kao kao;
考考__考考 146.314717429|kao kao;
考核__考核 4001.129241|kao he;
靠后__靠後 128.049907079|kao hou;
考卷__考卷 159.651218957|kao juan;
考级__考級 125.678566729|kao ji;
靠近__靠近 2344.2633374|kao jin;
考究__考究 235.226605969|kao jiu;
烤漆__烤漆 184.481071779|kao qi;
靠前__靠前 415.216987933|kao qian;
考前__考前 440.262469534|kao qian;
靠墙__靠牆 135.604660605|kao qiang;
考勤__考勤 534.069978074|kao qin;
考取__考取 255.073095111|kao qu;
烤箱__烤箱 209.746993999|kao xiang;
靠着__靠着 695.557838999|kao zhe;
考证__考證 655.989212862|kao zheng;
靠窗__靠窗 138.163289429|kao chuang;
考查__考查 500.559372647|kao cha;
考察__考察 4274.31328791|kao cha;
考场__考場 881.377303227|kao chang;
靠山__靠山 184.02185602|kao shan;
考上__考上 1162.27522076|kao shang;
考生__考生 5063.7235729|kao sheng;
考试__考試 13946.5957549|kao shi;
烤肉__烤肉 479.793862242|kao rou;
考入__考入 353.557372243|kao ru;
靠在__靠在 539.420927296|kao zai;
烤鸭__烤鴨 350.050152834|kao ya;
烤烟__烤煙 130.954650472|kao yan;
考验__考驗 2545.22282076|kao yan;
考研__考研 2729.18634194|kao yan;
烤鱼__烤魚 155.915530766|kao yu;
考完__考完 953.361623425|kao wan;
拷问__拷問 188.901181552|kao wen;
刻板__刻板 112.34478795|ke ban;
课本__課本 835.391638074|ke ben;
可悲__可悲 777.141921285|ke bei;
可比__可比 387.22887368|ke bi;
科比__科比 914.951259653|ke bi;
可变__可變 298.811606079|ke bian;
课表__課表 186.32942291|ke biao;
可别__可別 462.187920882|ke bie;
刻薄__刻薄 299.93080386|ke bo;
可不__可不 997.105202031|ke bu;
可怕__可怕 3648.66122213|ke pa;
刻盘__刻盤 314.867617017|ke pan;
客票__客票 115.611384758|ke piao;
科普__科普 701.651845929|ke pu;
科贸__科貿 109.30661816|ke mao;
可没__可沒 338.890182508|ke mei;
科目__科目 1447.30728064|ke mu;
客房__客房 556.490650127|ke fang;
可分__可分 124.122120652|ke fen;
可否__可否 1115.44785438|ke fou;
科夫__科夫 228.8653107|ke fu;
克服__克服 1744.7822355|ke fu;
客服__客服 2854.41099368|ke fu;
科大__科大 475.626742696|ke da;
柯达__柯達 519.626982517|ke da;
可达__可達 977.421145723|ke da;
可当__可當 127.096048509|ke dang;
可到__可到 220.19257551|ke dao;
可得__可得 432.109303457|ke de;
蝌蚪__蝌蚪 156.694657831|ke dou;
刻度__刻度 158.857391092|ke du;
可多__可多 120.164975734|ke duo;
可对__可對 115.755545596|ke dui;
客队__客隊 185.172044961|ke dui;
可他__可他 439.166555128|ke ta;
课堂__課堂 1899.07908248|ke tang;
客套__客套 132.10198647|ke tao;
客体__客體 249.726250867|ke ti;
课题__課題 2439.63524442|ke ti;
可调__可調 236.402059204|ke tiao;
客厅__客廳 1589.0991261|ke ting;
磕头__磕頭 200.29551561|ke tou;
可那__可那 124.89791921|ke na;
柯南__柯南 615.595353746|ke nan;
可能__可能 100901.805397|ke neng;
可逆__可逆 119.121315407|ke ni;
克拉__克拉 286.415523108|ke la;
克莱__克萊 124.122120652|ke lai;
可乐__可樂 1476.45426414|ke le;
克里__克里 258.271618599|ke li;
颗粒__顆粒 1287.32334043|ke li;
可怜__可憐 8450.93022222|ke lian;
客流__客流 438.619621343|ke liu;
科隆__科隆 137.305093541|ke long;
科龙__科龍 321.208662461|ke long;
克隆__克隆 797.747780288|ke long;
刻录__刻錄 1318.16721196|ke lu;
克罗__克羅 133.925286409|ke luo;
可观__可觀 743.048258297|ke guan;
客观__客觀 4487.17778244|ke guan;
课改__課改 148.149450567|ke gai;
可供__可供 983.530305889|ke gong;
可贵__可貴 484.601008682|ke gui;
可看__可看 175.073848088|ke kan;
科考__科考 141.826678552|ke kao;
可靠__可靠 2535.725271|ke kao;
咳咳__咳咳 397.001179899|ke ke;
可可__可可 615.595353746|ke ke;
苛刻__苛刻 632.705783453|ke ke;
克扣__剋扣 137.991222203|ke kou;
可口__可口 467.983588668|ke kou;
可控__可控 247.866011137|ke kong;
刻苦__刻苦 466.818670029|ke ku;
刻画__刻畫 536.070335228|ke hua;
科幻__科幻 585.662213047|ke huan;
可好__可好 440.262469534|ke hao;
可恨__可恨 343.139741671|ke hen;
课后__課後 243.275811214|ke hou;
客户__客戶 29530.6193404|ke hu;
可获__可獲 164.703307075|ke huo;
客机__客機 376.756940916|ke ji;
科技__科技 10536.5270626|ke ji;
客家__客家 266.112675706|ke jia;
课间__課間 149.447435764|ke jian;
课件__課件 1139.33050957|ke jian;
可见__可見 2926.44637172|ke jian;
科教__科教 233.183609039|ke jiao;
可将__可將 574.10053635|ke jiang;
可敬__可敬 152.647228173|ke jing;
可就__可就 481.590928402|ke jiu;
科举__科舉 188.196293023|ke ju;
可气__可氣 123.044091616|ke qi;
客气__客氣 4487.17778244|ke qi;
课前__課前 118.381397999|ke qian;
可亲__可親 107.684208225|ke qin;
苛求__苛求 213.971039752|ke qiu;
渴求__渴求 298.439468992|ke qiu;
可取__可取 361.577631409|ke qu;
可选__可選 747.692521253|ke xuan;
科学__科學 9608.34189386|ke xue;
可循__可循 130.628674269|ke xun;
可喜__可喜 311.744192349|ke xi;
可惜__可惜 10856.4131997|ke xi;
可先__可先 146.132498493|ke xian;
可笑__可笑 1481.9843182|ke xiao;
可向__可向 254.438159592|ke xiang;
科协__科協 276.249600432|ke xie;
可信__可信 677.591550514|ke xin;
颗星__顆星 128.049907079|ke xing;
克星__剋星 310.194118206|ke xing;
可行__可行 1370.08592511|ke xing;
客栈__客棧 611.009712747|ke zhan;
科长__科長 889.099334512|ke zhang;
刻着__刻着 132.266710153|ke zhe;
可这__可這 181.516526012|ke zhe;
可真__可真 633.494731672|ke zhen;
可治__可治 117.353228453|ke zhi;
可知__可知 653.541376022|ke zhi;
克制__克制 667.534233933|ke zhi;
课桌__課桌 162.663565352|ke zhuo;
客串__客串 378.168082664|ke chuan;
可查__可查 144.502706249|ke cha;
客场__客場 1027.37704867|ke chang;
客车__客車 806.745280603|ke che;
课程__課程 6173.35572247|ke cheng;
可耻__可恥 577.688827991|ke chi;
课上__課上 240.862563142|ke shang;
客商__客商 604.195219728|ke shang;
课时__課時 402.480675297|ke shi;
可视__可視 466.237298568|ke shi;
科室__科室 939.211122794|ke shi;
可使__可使 1137.91159836|ke shi;
可是__可是 34208.5397668|ke shi;
恪守__恪守 185.634130949|ke shou;
棵树__棵樹 225.187525865|ke shu;
可说__可說 695.557838999|ke shuo;
瞌睡__瞌睡 428.356335222|ke shui;
可让__可讓 125.678566729|ke rang;
可人__可人 216.654158472|ke ren;
客人__客人 4883.99371143|ke ren;
刻在__刻在 203.566761683|ke zai;
可在__可在 1375.21757695|ke zai;
壳子__殼子 199.299593609|ke zi;
可作__可作 210.532600599|ke zuo;
可做__可做 343.996026791|ke zuo;
可曾__可曾 158.461958559|ke ceng;
可从__可從 253.804804573|ke cong;
可算__可算 171.831677206|ke suan;
科斯__科斯 107.550099352|ke si;
克斯__克斯 278.669912425|ke si;
咳嗽__咳嗽 1397.67776576|ke sou;
科员__科員 150.944778196|ke yuan;
客源__客源 288.565077751|ke yuan;
客运__客運 771.352901218|ke yun;
可言__可言 665.872587905|ke yan;
科研__科研 2424.48154518|ke yan;
可要__可要 503.060722916|ke yao;
可依__可依 135.267109459|ke yi;
可疑__可疑 798.742526514|ke yi;
刻意__刻意 1693.37191801|ke yi;
可以__可以 304372.20872|ke yi;
刻有__刻有 128.369448119|ke you;
可由__可由 272.828431509|ke you;
可有__可有 426.226434824|ke you;
可用__可用 2491.86983978|ke yong;
课余__課餘 169.28122395|ke yu;
可与__可與 324.83145542|ke yu;
课外__課外 286.058823982|ke wai;
可望__可望 390.135034682|ke wang;
渴望__渴望 3030.36024751|ke wang;
课文__課文 794.770968525|ke wen;
科委__科委 169.492308033|ke wei;
可为__可為 296.955549433|ke wei;
可谓__可謂 2309.46804145|ke wei;
可我__可我 1311.61293778|ke wo;
可恶__可惡 995.863416846|ke wu;
可爱__可愛 10575.9915862|ke ai;
可按__可按 261.184568064|ke an;
可儿__可兒 115.036534536|ke er;
克尔__克爾 129.332863581|ke er;
科尔__科爾 264.130371602|ke er;
肯定__肯定 38942.1272676|ken ding;
恳请__懇請 310.194118206|ken qing;
恳求__懇求 227.160466527|ken qiu;
肯恩__肯恩 153.41002317|ken en;
坑内__坑內 126.937764318|keng nei;
坑里__坑裡 111.925571131|keng li;
铿锵__鏗鏘 158.067510349|keng qiang;
吭声__吭聲 197.322580943|keng sheng;
口碑__口碑 1097.52300072|kou bei;
抠门__摳門 234.348853194|kou men;
扣分__扣分 348.743933702|kou fen;
口福__口福 105.821807183|kou fu;
口服__口服 578.409173188|kou fu;
口袋__口袋 1031.22508566|kou dai;
扣掉__扣掉 133.925286409|kou diao;
口头__口頭 846.921892564|kou tou;
扣篮__扣籃 267.109399762|kou lan;
口里__口裡 231.446597362|kou li;
口粮__口糧 137.305093541|kou liang;
口令__口令 595.969520633|kou ling;
扣留__扣留 194.636170786|kou liu;
口干__口乾 108.898738333|kou gan;
口感__口感 540.093554591|kou gan;
口供__口供 127.413209251|kou gong;
扣款__扣款 242.066179876|kou kuan;
口渴__口渴 232.603161479|kou ke;
口口__口口 162.460985719|kou kou;
口号__口號 1617.0663282|kou hao;
口红__口紅 228.8653107|kou hong;
口诀__口訣 129.655606164|kou jue;
口角__口角 179.045304336|kou jiao;
口交__口交 434.810109507|kou jiao;
口径__口徑 504.944935018|kou jing;
口气__口氣 1930.09502896|kou qi;
扣钱__扣錢 210.270405333|kou qian;
口腔__口腔 835.391638074|kou qiang;
口琴__口琴 132.10198647|kou qin;
口罩__口罩 297.325836157|kou zhao;
口镇__口鎮 105.558392399|kou zhen;
口中__口中 1125.22065338|kou zhong;
口吃__口吃 161.854759309|kou chi;
口臭__口臭 221.292902041|kou chou;
扣除__扣除 1188.64081012|kou chu;
扣上__扣上 109.034528882|kou shang;
口哨__口哨 130.954650472|kou shao;
口舌__口舌 228.011295226|kou she;
口试__口試 161.653186955|kou shi;
口述__口述 165.939408926|kou shu;
扣税__扣稅 118.529012887|kou shui;
口水__口水 1811.24553395|kou shui;
扣肉__扣肉 212.112652282|kou rou;
扣子__扣子 334.69325133|kou zi;
口子__口子 388.195180646|kou zi;
口才__口才 359.779772295|kou cai;
扣押__扣押 255.709615075|kou ya;
口译__口譯 262.162833911|kou yi;
口音__口音 574.10053635|kou yin;
口语__口語 1318.16721196|kou yu;
口吻__口吻 328.904723278|kou wen;
口味__口味 1775.48936799|kou wei;
口岸__口岸 808.758466182|kou an;
空白__空白 1996.14083601|kong bai;
恐怖__恐怖 4740.08597198|kong bu;
恐怕__恐怕 4437.13301058|kong pa;
控盘__控盤 172.04594156|kong pan;
空门__空門 107.684208225|kong men;
孔明__孔明 204.584007193|kong ming;
空方__空方 115.036534536|kong fang;
空腹__空腹 277.976239008|kong fu;
空档__空檔 201.547419552|kong dang;
空地__空地 373.019586361|kong di;
空洞__空洞 554.41409416|kong dong;
空谈__空談 144.502706249|kong tan;
空调__空調 5539.06704613|kong tiao;
空投__空投 113.753550575|kong tou;
空头__空頭 395.519762073|kong tou;
空难__空難 139.72158175|kong nan;
空灵__空靈 202.302314677|kong ling;
恐龙__恐龍 1157.93816758|kong long;
空港__空港 158.659551632|kong gang;
控告__控告 238.770616634|kong gao;
空格__空格 1114.0586864|kong ge;
控股__控股 1824.83897052|kong gu;
空旷__空曠 367.941183266|kong kuang;
空壳__空殼 117.353228453|kong ke;
空客__空客 175.292155245|kong ke;
空空__空空 461.61231651|kong kong;
空话__空話 208.70407676|kong hua;
恐慌__恐慌 894.656458236|kong huang;
恐吓__恐嚇 417.291872914|kong he;
空军__空軍 1197.56158489|kong jun;
控件__控件 2227.49666896|kong jian;
空间__空間 23982.3433607|kong jian;
空降__空降 222.953710017|kong jiang;
空姐__空姐 574.81640715|kong jie;
恐惧__恐懼 2952.08591378|kong ju;
空缺__空缺 372.091054935|kong que;
孔雀__孔雀 488.237949645|kong que;
空气__空氣 4877.91123285|kong qi;
空前__空前 832.274357505|kong qian;
控球__控球 233.183609039|kong qiu;
空袭__空襲 197.076837307|kong xi;
空隙__空隙 315.653350706|kong xi;
空闲__空閑 805.740567825|kong xian;
空想__空想 153.792848894|kong xiang;
空心__空心 276.938965124|kong xin;
空虚__空虛 1079.88619313|kong xu;
空战__空戰 168.439513167|kong zhan;
空着__空着 317.626273928|kong zhe;
空置__空置 179.940013424|kong zhi;
控制__控制 22393.6785126|kong zhi;
空中__空中 2373.65954378|kong zhong;
空手__空手 205.862715427|kong shou;
空子__空子 171.617679695|kong zi;
孔子__孔子 1573.33557614|kong zi;
空仓__空倉 389.649164279|kong cang;
控诉__控訴 251.600451735|kong su;
空运__空運 455.895552723|kong yun;
控油__控油 151.510141313|kong you;
空余__空餘 182.196395498|kong yu;
控温__控溫 207.666345181|kong wen;
空位__空位 230.870473623|kong wei;
哭吧__哭吧 110.95347192|ku ba;
酷派__酷派 111.507918629|ku pai;
酷评__酷評 125.209594649|ku ping;
苦闷__苦悶 370.240920313|ku men;
苦命__苦命 217.465635832|ku ming;
库房__庫房 418.854838101|ku fang;
裤裆__褲襠 133.42554153|ku dang;
哭得__哭得 367.482952871|ku de;
苦读__苦讀 129.817279349|ku du;
苦头__苦頭 219.37092252|ku tou;
苦痛__苦痛 181.290467084|ku tong;
苦难__苦難 971.349932368|ku nan;
哭闹__哭鬧 219.918349804|ku nao;
苦恼__苦惱 881.377303227|ku nao;
苦了__苦了 190.793818607|ku le;
库里__庫里 142.891090816|ku li;
苦力__苦力 347.00988711|ku li;
苦练__苦練 239.664931108|ku lian;
骷髅__骷髏 910.401881269|ku lou;
窟窿__窟窿 200.04606951|ku long;
苦瓜__苦瓜 341.859308876|ku gua;
酷狗__酷狗 151.510141313|ku gou;
苦果__苦果 120.916041011|ku guo;
哭过__哭過 181.064689688|ku guo;
酷酷__酷酷 216.384339476|ku ku;
苦苦__苦苦 808.758466182|ku ku;
枯黄__枯黃 114.179614083|ku huang;
苦海__苦海 126.149295342|ku hai;
哭喊__哭喊 129.332863581|ku han;
枯竭__枯竭 249.104624871|ku jie;
哭泣__哭泣 1366.67546656|ku qi;
库区__庫區 262.489736092|ku qu;
苦笑__苦笑 517.043260448|ku xiao;
苦心__苦心 253.488718522|ku xin;
酷刑__酷刑 191.031727675|ku xing;
苦战__苦戰 120.765453341|ku zhan;
哭着__哭着 599.694499646|ku zhe;
库中__庫中 139.026849285|ku zhong;
苦衷__苦衷 217.736803143|ku zhong;
裤衩__褲衩 215.576896995|ku cha;
哭声__哭聲 368.85935893|ku sheng;
酷暑__酷暑 186.32942291|ku shu;
酷热__酷熱 135.098649108|ku re;
酷睿__酷睿 559.271495144|ku rui;
枯燥__枯燥 641.438524323|ku zao;
裤子__褲子 2883.00988318|ku zi;
库存__庫存 2930.09548433|ku cun;
苦涩__苦澀 477.408200926|ku se;
酷似__酷似 306.734573113|ku si;
哭诉__哭訴 206.89143407|ku su;
枯叶__枯葉 114.037415895|ku ye;
苦于__苦於 271.810366771|ku yu;
酷网__酷網 235.226605969|ku wang;
苦味__苦味 130.303509496|ku wei;
枯萎__枯萎 290.730764849|ku wei;
酷爱__酷愛 268.444174826|ku ai;
扩大__擴大 6803.54331971|kuo da;
括号__括號 370.240920313|kuo hao;
扩建__擴建 552.345286903|kuo jian;
扩展__擴展 3471.24615709|kuo zhan;
扩张__擴張 2338.42792752|kuo zhang;
扩招__擴招 250.037645335|kuo zhao;
扩充__擴充 666.702893247|kuo chong;
扩容__擴容 678.436468738|kuo rong;
扩增__擴增 123.044091616|kuo zeng;
扩散__擴散 987.214115061|kuo san;
亏本__虧本 400.978810625|kui ben;
匮乏__匱乏 489.456318842|kui fa;
亏待__虧待 149.633788238|kui dai;
亏得__虧得 124.122120652|kui de;
愧对__愧對 119.41857567|kui dui;
窥探__窺探 135.267109459|kui tan;
溃烂__潰爛 112.484875527|kui lan;
傀儡__傀儡 234.64107292|kui lei;
葵花__葵花 169.28122395|kui hua;
盔甲__盔甲 235.519920202|kui jia;
愧疚__愧疚 459.889800938|kui jiu;
亏欠__虧欠 144.143005824|kui qian;
亏钱__虧錢 273.850309404|kui qian;
窥视__窺視 187.027319083|kui shi;
馈赠__饋贈 169.070402749|kui zeng;
亏损__虧損 2488.76648916|kui sun;
溃疡__潰瘍 420.423657369|kui yang;
魁梧__魁梧 133.758497151|kui wu;
花白__花白 107.818484324|hua bai;
滑板__滑板 204.584007193|hua ban;
花瓣__花瓣 590.057620516|hua ban;
华宝__華寶 113.895394799|hua bao;
画报__畫報 148.334184528|hua bao;
华北__華北 731.107734818|hua bei;
画笔__畫筆 225.749468142|hua bi;
花边__花邊 242.36802267|hua bian;
滑冰__滑冰 119.56748386|hua bing;
划拨__劃撥 256.987424161|hua bo;
画布__畫布 111.925571131|hua bu;
花盆__花盆 176.60772663|hua pen;
花屏__花屏 152.077621994|hua ping;
花瓶__花瓶 515.756221017|hua ping;
划破__劃破 181.969489867|hua po;
滑坡__滑坡 418.333200332|hua po;
华美__華美 296.585723861|hua mei;
画面__畫面 6013.89768231|hua mian;
化名__化名 208.70407676|hua ming;
花木__花木 274.191785204|hua mu;
画法__畫法 108.492380517|hua fa;
花粉__花粉 367.482952871|hua fen;
划分__劃分 2412.42638506|hua fen;
画风__畫風 179.045304336|hua feng;
化肥__化肥 678.436468738|hua fei;
花费__花費 2391.47390956|hua fei;
话费__話費 3181.27480592|hua fei;
华府__華府 110.815291538|hua fu;
花旦__花旦 187.027319083|hua dan;
话单__話單 326.861744407|hua dan;
画得__畫得 158.067510349|hua de;
华电__華電 155.72135507|hua dian;
花点__花點 172.690339006|hua dian;
花店__花店 385.78392141|hua dian;
花掉__花掉 250.349428094|hua diao;
划定__劃定 337.625607028|hua ding;
话都__話都 137.305093541|hua dou;
滑动__滑動 323.216307961|hua dong;
华东__華東 942.728934628|hua dong;
花都__花都 272.828431509|hua du;
花朵__花朵 929.894333673|hua duo;
华泰__華泰 291.456266438|hua tai;
化痰__化痰 112.765574943|hua tan;
花坛__花壇 163.680258901|hua tan;
话题__話題 6150.31972239|hua ti;
华天__華天 127.572086295|hua tian;
华庭__華庭 113.046974828|hua ting;
花头__花頭 146.862738669|hua tou;
话筒__話筒 811.787668067|hua tong;
画图__畫圖 542.11647303|hua tu;
华纳__華納 259.238974004|hua na;
华南__華南 810.776675547|hua nan;
华能__華能 151.699065864|hua neng;
花鸟__花鳥 112.906187218|hua niao;
华农__華農 111.507918629|hua nong;
话来__話來 445.783200166|hua lai;
花篮__花籃 127.413209251|hua lan;
画廊__畫廊 402.982545867|hua lang;
花蕾__花蕾 143.0692679|hua lei;
华丽__華麗 2180.80386611|hua li;
华联__華聯 284.991389772|hua lian;
化疗__化療 666.702893247|hua liao;
华龙__華龍 121.520271774|hua long;
滑落__滑落 400.978810625|hua luo;
花落__花落 476.219822262|hua luo;
花冠__花冠 242.972837869|hua guan;
华光__華光 137.305093541|hua guang;
花光__花光 154.947067523|hua guang;
滑盖__滑蓋 393.553133755|hua gai;
华工__華工 384.344361008|hua gong;
化工__化工 1627.17345269|hua gong;
滑过__滑過 204.584007193|hua guo;
划过__劃過 395.027185582|hua guo;
华贵__華貴 147.780672558|hua gui;
划归__劃歸 163.884358899|hua gui;
花开__花開 891.318029807|hua kai;
华康__華康 184.941433485|hua kang;
哗哗__嘩嘩 315.653350706|hua hua;
画画__畫畫 785.907015785|hua hua;
花花__花花 1200.55002966|hua hua;
划痕__划痕 246.94109417|hua hen;
花卉__花卉 751.428823061|hua hui;
画卷__畫卷 222.953710017|hua juan;
华军__華軍 248.794392378|hua jun;
花季__花季 133.758497151|hua ji;
话机__話機 159.651218957|hua ji;
滑稽__滑稽 461.037428991|hua ji;
画家__畫家 1018.45404378|hua jia;
花间__花間 167.810977762|hua jian;
花椒__花椒 301.429591092|hua jiao;
化解__化解 1142.1736421|hua jie;
话剧__話劇 718.463208478|hua ju;
花圈__花圈 125.36572391|hua quan;
花期__花期 144.322743975|hua qi;
花旗__花旗 320.808632296|hua qi;
花钱__花錢 3141.87681769|hua qian;
华侨__華僑 627.992684885|hua qiao;
华强__華強 169.703655326|hua qiang;
滑雪__滑雪 551.657401419|hua xue;
化学__化學 2570.72389483|hua xue;
华西__華西 246.633556117|hua xi;
华夏__華夏 1714.60618362|hua xia;
划线__劃線 127.73116145|hua xian;
化纤__化纖 324.83145542|hua xian;
花销__花銷 207.407719521|hua xiao;
画像__畫像 346.577724349|hua xiang;
花香__花香 647.865219539|hua xiang;
花心__花心 751.428823061|hua xin;
华星__華星 172.475272126|hua xing;
滑行__滑行 192.705418355|hua xing;
花絮__花絮 443.56664881|hua xu;
划转__划轉 167.393257695|hua zhuan;
化装__化裝 188.196293023|hua zhuang;
化妆__化妝 1579.22849881|hua zhuang;
画展__畫展 215.845709156|hua zhan;
花招__花招 126.779677253|hua zhao;
画着__畫著 121.975425508|hua zhe;
花枝__花枝 116.18910757|hua zhi;
画质__畫質 569.823995046|hua zhi;
画中__畫中 175.073848088|hua zhong;
华中__華中 416.772181646|hua zhong;
划船__划船 196.096919422|hua chuan;
花茶__花茶 114.037415895|hua cha;
华晨__華晨 214.504991945|hua chen;
花城__花城 120.46484039|hua cheng;
化成__化成 347.442588754|hua cheng;
花痴__花痴 467.983588668|hua chi;
划出__劃出 275.218769535|hua chu;
画出__畫出 376.287731462|hua chu;
华山__華山 496.830647979|hua shan;
花上__花上 140.594881376|hua shang;
划上__劃上 147.964946673|hua shang;
划伤__划傷 180.839193473|hua shang;
画上__畫上 311.355949144|hua shang;
华商__華商 320.409100324|hua shang;
花哨__花哨 298.811606079|hua shao;
化身__化身 606.458230719|hua shen;
花生__花生 947.439854855|hua sheng;
画室__畫室 143.784200776|hua shi;
华师__華師 182.878811433|hua shi;
化石__化石 549.598880816|hua shi;
华硕__華碩 1852.33266643|hua shuo;
话说__話說 3390.02226565|hua shuo;
划水__划水 147.045868173|hua shui;
华润__華潤 374.41672986|hua run;
哗然__嘩然 164.498187167|hua ran;
华人__華人 2289.40978274|hua ren;
划入__划入 155.333728851|hua ru;
花蕊__花蕊 107.015331962|hua rui;
花在__花在 339.735863102|hua zai;
华仔__華仔 371.164834837|hua zai;
华仔__華仔 124.276893895|hua zi;
画作__畫作 157.477678279|hua zuo;
化作__化作 406.006938516|hua zuo;
花草__花草 532.077085292|hua cao;
画册__畫冊 337.625607028|hua ce;
花丛__花叢 153.792848894|hua cong;
划算__划算 1037.67053575|hua suan;
花色__花色 261.510250403|hua se;
花苑__花苑 111.646962678|hua yuan;
华源__華源 151.888225993|hua yuan;
花园__花園 3335.54580332|hua yuan;
化验__化驗 426.226434824|hua yan;
华阳__華陽 136.622376491|hua yang;
花样__花樣 895.772044085|hua yang;
华谊__華誼 170.339279748|hua yi;
华裔__華裔 611.771607197|hua yi;
话音__話音 380.531740742|hua yin;
花语__花語 133.925286409|hua yu;
华宇__華宇 158.067510349|hua yu;
华语__華語 615.595353746|hua yu;
话语__話語 1470.94484558|hua yu;
华文__華文 343.139741671|hua wen;
花纹__花紋 508.734557585|hua wen;
化为__化為 538.078184713|hua wei;
华为__華為 2930.09548433|hua wei;
话务__話務 177.269210225|hua wu;
华安__華安 266.444503116|hua an;
花儿__花兒 819.921123923|hua er;
环抱__環抱 153.41002317|huan bao;
环保__環保 4487.17778244|huan bao;
环比__環比 323.619340361|huan bi;
患病__患病 453.628720089|huan bing;
环评__環評 240.562595233|huan ping;
缓慢__緩慢 1799.9950529|huan man;
幻灭__幻滅 128.850255419|huan mie;
换发__換髮 146.862738669|huan fa;
焕发__煥發 294.743493195|huan fa;
换代__換代 147.780672558|huan dai;
还贷__還貸 377.697115787|huan dai;
换挡__換擋 139.72158175|huan dang;
换档__換檔 189.372573382|huan dang;
环岛__環島 193.668388536|huan dao;
换到__換到 279.365316864|huan dao;
换得__換得 147.412812521|huan de;
幻灯__幻燈 153.601316766|huan deng;
换掉__換掉 410.586139672|huan diao;
患难__患難 117.93965545|huan nan;
还你__還你 110.677283245|huan ni;
换来__換來 971.349932368|huan lai;
患了__患了 242.066179876|huan le;
欢乐__歡樂 1877.89895902|huan le;
环路__環路 170.551683166|huan lu;
宦官__宦官 153.984619852|huan guan;
换个__換個 2119.18530697|huan ge;
还给__還給 557.879339939|huan gei;
环顾__環顧 120.015323434|huan gu;
换过__換過 242.972837869|huan guo;
还款__還款 1123.81931445|huan kuan;
欢快__歡快 468.567137655|huan kuai;
幻化__幻化 161.451865638|huan hua;
欢欢__歡歡 270.796100963|huan huan;
换换__換換 383.865702254|huan huan;
缓缓__緩緩 1519.38443361|huan huan;
换行__換行 276.249600432|huan hang;
换好__換好 148.704343794|huan hao;
换号__換號 375.351064872|huan hao;
缓和__緩和 511.914293268|huan he;
欢呼__歡呼 606.458230719|huan hu;
换货__換貨 135.773751924|huan huo;
换回__換回 277.284292303|huan hui;
幻觉__幻覺 600.442284667|huan jue;
换季__換季 146.314717429|huan ji;
还击__還擊 161.653186955|huan ji;
还价__還價 259.562230298|huan jia;
换届__換屆 360.228397261|huan jie;
缓解__緩解 2361.85708402|huan jie;
环节__環節 3981.23457372|huan jie;
幻境__幻境 114.037415895|huan jing;
环境__環境 21251.7600437|huan jing;
换气__換氣 164.703307075|huan qi;
唤起__喚起 382.910172354|huan qi;
换钱__換錢 106.748946222|huan qian;
还钱__還錢 420.423657369|huan qian;
欢庆__歡慶 185.402943996|huan qing;
还清__還清 306.352568839|huan qing;
环球__環球 843.76158662|huan qiu;
换取__換取 678.436468738|huan qu;
欢喜__歡喜 814.828215816|huan xi;
换下__換下 438.073368704|huan xia;
环线__環線 200.545272755|huan xian;
欢笑__歡笑 490.677728407|huan xiao;
幻象__幻象 155.333728851|huan xiang;
幻想__幻想 3045.50329114|huan xiang;
换新__換新 195.121873946|huan xin;
欢心__歡心 222.67604562|huan xin;
缓刑__緩刑 123.197520618|huan xing;
环形__環形 231.158356006|huan xing;
唤醒__喚醒 671.706512759|huan xing;
环状__環狀 105.426930997|huan zhuang;
换装__換裝 183.106850936|huan zhuang;
还债__還債 257.3078729|huan zhai;
患者__患者 7313.49454057|huan zhe;
换证__換證 131.445140637|huan zheng;
换车__換車 173.986383704|huan che;
环城__環城 127.572086295|huan cheng;
换乘__換乘 351.799391968|huan cheng;
换成__換成 2061.87561868|huan cheng;
缓冲__緩衝 779.081233415|huan chong;
患处__患處 257.3078729|huan chu;
患上__患上 454.194369369|huan shang;
换上__換上 751.428823061|huan shang;
环视__環視 119.26985293|huan shi;
还手__還手 188.665925845|huan shou;
换手__換手 242.972837869|huan shou;
换水__換水 112.765574943|huan shui;
环绕__環繞 606.458230719|huan rao;
换人__換人 463.919044053|huan ren;
缓存__緩存 1447.30728064|huan cun;
换算__換算 347.875829952|huan suan;
涣散__渙散 120.164975734|huan san;
欢送__歡送 132.596773978|huan song;
还原__還原 1689.15672637|huan yuan;
环氧__環氧 106.218162376|huan yang;
换药__換藥 112.065135969|huan yao;
换衣__換衣 116.18910757|huan yi;
幻影__幻影 424.635962376|huan ying;
欢迎__歡迎 11728.4592825|huan ying;
还有__還有 243.882891747|huan you;
患有__患有 759.903909096|huan you;
欢愉__歡愉 129.979154132|huan yu;
换位__換位 133.758497151|huan wei;
环卫__環衛 225.468321935|huan wei;
患儿__患兒 481.590928402|huan er;
黄牌__黃牌 291.093289619|huang pai;
黄片__黃片 148.519148841|huang pian;
黄浦__黃浦 107.14877401|huang pu;
黄埔__黃埔 318.815941979|huang pu;
皇马__皇馬 1366.67546656|huang ma;
慌忙__慌忙 259.562230298|huang mang;
黄毛__黃毛 130.954650472|huang mao;
黄梅__黃梅 109.579386421|huang mei;
荒谬__荒謬 418.333200332|huang miu;
荒漠__荒漠 181.290467084|huang mo;
黄某__黃某 131.609045271|huang mou;
黄蜂__黃蜂 142.891090816|huang feng;
荒废__荒廢 335.110594827|huang fei;
皇甫__皇甫 159.651218957|huang fu;
黄疸__黃疸 193.90988203|huang dan;
荒诞__荒誕 272.828431509|huang dan;
晃荡__晃蕩 163.884358899|huang dang;
荒地__荒地 135.098649108|huang di;
黄帝__黃帝 340.15949445|huang di;
皇帝__皇帝 3377.37232991|huang di;
黄豆__黃豆 327.677408739|huang dou;
晃动__晃動 496.830647979|huang dong;
荒唐__荒唐 574.81640715|huang tang;
黄土__黃土 312.522131716|huang tu;
黄牛__黃牛 382.433299725|huang niu;
慌乱__慌亂 373.950434882|huang luan;
慌了__慌了 184.941433485|huang le;
黄磊__黃磊 136.112567367|huang lei;
黄连__黃連 113.046974828|huang lian;
荒凉__荒涼 338.046607007|huang liang;
黄龙__黃龍 327.26932246|huang long;
黄瓜__黃瓜 925.270654393|huang gua;
皇冠__皇冠 772.314734527|huang guan;
黄冈__黃岡 131.773154284|huang gang;
皇宫__皇宮 553.034030141|huang gong;
惶恐__惶恐 247.249015706|huang kong;
谎话__謊話 187.961915178|huang hua;
黄花__黃花 305.97104031|huang hua;
黄黄__黃黃 116.915322539|huang huang;
晃晃__晃晃 308.267359529|huang huang;
黄昏__黃昏 1078.5413133|huang hun;
黄海__黃海 255.709615075|huang hai;
黄河__黃河 1773.27819069|huang he;
皇后__皇后 1202.04704744|huang hou;
恍惚__恍惚 466.818670029|huang hu;
皇家__皇家 820.943519051|huang jia;
黄建__黃建 124.89791921|huang jian;
黄金__黃金 4775.66041886|huang jin;
黄静__黃靜 229.722524886|huang jing;
黄酒__黃酒 286.415523108|huang jiu;
黄菊__黃菊 256.987424161|huang ju;
皇权__皇權 112.906187218|huang quan;
黄泉__黃泉 114.037415895|huang quan;
黄芪__黃芪 153.218967809|huang qi;
晃去__晃去 113.32907693|huang qu;
慌张__慌張 275.561951728|huang zhang;
黄忠__黃忠 119.26985293|huang zhong;
皇朝__皇朝 119.41857567|huang chao;
谎称__謊稱 150.007190589|huang cheng;
皇城__皇城 176.168109435|huang cheng;
蝗虫__蝗蟲 124.122120652|huang chong;
黄沙__黃沙 221.845125512|huang sha;
黄鳝__黃鱔 109.034528882|huang shan;
荒山__荒山 149.820373083|huang shan;
黄衫__黃衫 184.02185602|huang shan;
黄山__黃山 1100.26180506|huang shan;
皇上__皇上 1061.20953474|huang shang;
皇室__皇室 295.847453874|huang shi;
黄石__黃石 397.001179899|huang shi;
恍然__恍然 176.168109435|huang ran;
黄蓉__黃蓉 310.968189453|huang rong;
黄钻__黃鑽 249.726250867|huang zuan;
皇子__皇子 297.696584607|huang zi;
幌子__幌子 312.911829085|huang zi;
皇族__皇族 114.75018218|huang zu;
黄色__黃色 3298.34499764|huang se;
荒原__荒原 128.049907079|huang yuan;
黄岩__黃岩 118.824795093|huang yan;
谎言__謊言 1108.5192935|huang yan;
黄叶__黃葉 110.401782066|huang ye;
荒野__荒野 232.313479749|huang ye;
黄页__黃頁 354.43965395|huang ye;
黄奕__黃奕 128.689786556|huang yi;
黄油__黃油 221.845125512|huang you;
晃悠__晃悠 235.226605969|huang you;
皇位__皇位 120.765453341|huang wei;
荒芜__荒蕪 336.365750338|huang wu;
黄安__黃安 175.729586548|huang an;
魂魄__魂魄 273.509258874|hun po;
昏迷__昏迷 799.738513132|hun mi;
混沌__混沌 644.643863216|hun dun;
混搭__混搭 106.085879302|hun da;
混蛋__混蛋 660.912425973|hun dan;
混到__混到 176.168109435|hun dao;
昏倒__昏倒 555.797602048|hun dao;
混得__混得 335.946843682|hun de;
馄饨__餛飩 266.444503116|hun tun;
混乱__混亂 2926.44637172|hun luan;
昏了__昏了 154.947067523|hun le;
婚礼__婚禮 2648.77038315|hun li;
婚恋__婚戀 144.863304286|hun lian;
昏黄__昏黃 143.605133321|hun huang;
昏昏__昏昏 114.46454262|hun hun;
混混__混混 583.476802811|hun hun;
混合__混合 2295.12287071|hun he;
浑厚__渾厚 141.650048976|hun hou;
婚后__婚後 714.89082038|hun hou;
混迹__混跡 168.020228531|hun ji;
婚嫁__婚嫁 135.94305409|hun jia;
婚检__婚檢 164.703307075|hun jian;
婚介__婚介 155.915530766|hun jie;
混进__混進 117.061109314|hun jin;
婚期__婚期 109.989815613|hun qi;
婚前__婚前 520.923681206|hun qian;
婚庆__婚慶 333.444336783|hun qing;
混血__混血 247.557321202|hun xue;
混淆__混淆 614.828697239|hun xiao;
混战__混戰 271.471856767|hun zhan;
混着__混着 123.658956482|hun zhe;
混浊__混濁 154.176629937|hun zhuo;
浑浊__渾濁 213.438416689|hun zhuo;
婚纱__婚紗 1003.33739315|hun sha;
浑身__渾身 1542.27603899|hun shen;
婚事__婚事 253.488718522|hun shi;
混水__混水 115.323601467|hun shui;
昏睡__昏睡 177.269210225|hun shui;
混入__混入 163.884358899|hun ru;
混杂__混雜 281.111429553|hun za;
混在__混在 174.638049069|hun zai;
昏死__昏死 187.027319083|hun si;
婚宴__婚宴 324.02287532|hun yan;
混音__混音 127.890434962|hun yin;
婚姻__婚姻 4681.38313658|hun yin;
昏暗__昏暗 377.226735448|hun an;
怀抱__懷抱 846.921892564|huai bao;
淮北__淮北 155.915530766|huai bei;
坏蛋__壞蛋 851.15405446|huai dan;
坏道__壞道 183.792676978|huai dao;
坏点__壞點 178.377193209|huai dian;
坏掉__壞掉 330.960471347|huai diao;
怀特__懷特 111.646962678|huai te;
淮南__淮南 256.028470459|huai nan;
怀念__懷念 2629.03938618|huai nian;
怀了__懷了 109.170488754|huai le;
怀里__懷裡 1601.02534912|huai li;
怀化__懷化 251.914183226|huai hua;
坏话__壞話 427.290057918|huai hua;
坏坏__壞壞 281.812926654|huai huai;
淮海__淮海 180.389043185|huai hai;
淮河__淮河 233.474375771|huai he;
怀旧__懷舊 740.275558891|huai jiu;
坏账__壞賬 171.617679695|huai zhang;
怀着__懷着 836.433324055|huai zhe;
怀中__懷中 472.67240572|huai zhong;
怀揣__懷揣 152.647228173|huai chuai;
坏处__壞處 385.78392141|huai chu;
怀上__懷上 186.097370046|huai shang;
坏事__壞事 1272.96603034|huai shi;
坏人__壞人 1565.51253772|huai ren;
怀柔__懷柔 231.158356006|huai rou;
坏死__壞死 335.110594827|huai si;
怀孕__懷孕 3076.0167709|huai yun;
怀疑__懷疑 7222.92173899|huai yi;
怀有__懷有 275.218769535|huai you;
淮安__淮安 278.669912425|huai an;
哈珀__哈珀 204.839111844|ha po;
蛤蟆__蛤蟆 407.020105042|ha ma;
哈密__哈密 114.321989585|ha mi;
哈飞__哈飛 119.41857567|ha fei;
哈佛__哈佛 534.069978074|ha fo;
哈达__哈達 123.504952812|ha da;
哈特__哈特 113.611883002|ha te;
哈尼__哈尼 176.827946446|ha ni;
哈里__哈里 188.196293023|ha li;
哈利__哈利 455.895552723|ha li;
哈喽__哈嘍 176.387781073|ha lou;
哈罗__哈羅 154.947067523|ha luo;
哈卡__哈卡 178.822323044|ha ka;
哈哈__哈哈 121640.842924|ha ha;
哈韩__哈韓 134.930398555|ha han;
哈欠__哈欠 197.076837307|ha qian;
哈市__哈市 290.730764849|ha shi;
哈尔__哈爾 171.403948695|ha er;
还把__還把 526.142915167|hai ba;
海拔__海拔 631.130833438|hai ba;
海豹__海豹 140.770195218|hai bao;
海报__海報 1385.53861435|hai bao;
还被__還被 552.345286903|hai bei;
海边__海邊 1509.94683642|hai bian;
海滨__海濱 488.237949645|hai bin;
海波__海波 156.304608838|hai bo;
还不__還不 5636.55134085|hai bu;
还怕__還怕 309.036622663|hai pa;
害怕__害怕 5409.45809302|hai pa;
海马__海馬 361.577631409|hai ma;
海门__海門 111.786180106|hai men;
还没__還沒 15621.3191965|hai mei;
海绵__海綿 394.535222541|hai mian;
海面__海面 413.667597456|hai mian;
海峰__海峰 154.754097942|hai feng;
海风__海風 373.484720623|hai feng;
海大__海大 145.043940608|hai da;
还大__還大 172.905674062|hai da;
还带__還帶 278.669912425|hai dai;
海带__海帶 290.0070692|hai dai;
海道__海道 190.081867665|hai dao;
海岛__海島 346.1460998|hai dao;
海盗__海盜 1086.63578899|hai dao;
海德__海德 202.807148249|hai de;
害得__害得 527.455873984|hai de;
还得__還得 3095.24275062|hai de;
还得__還得 1670.31783317|hai dei;
海地__海地 105.558392399|hai di;
海底__海底 757.068312494|hai di;
海淀__海淀 741.198640518|hai dian;
还多__還多 486.416079992|hai duo;
还对__還對 301.805456692|hai dui;
海豚__海豚 427.290057918|hai tun;
海滩__海灘 808.758466182|hai tan;
海棠__海棠 394.043872187|hai tang;
海涛__海濤 227.443722742|hai tao;
海天__海天 304.070513117|hai tian;
还挺__還挺 744.902491688|hai ting;
海通__海通 166.353500999|hai tong;
孩童__孩童 260.534419685|hai tong;
海南__海南 3736.08202346|hai nan;
还能__還能 8938.37685157|hai neng;
海内__海內 106.350610398|hai nei;
海宁__海寧 312.522131716|hai ning;
海伦__海倫 233.474375771|hai lun;
还来__還來 235.226605969|hai lai;
海浪__海浪 331.37316028|hai lang;
海里__海里 443.56664881|hai li;
海量__海量 404.996293994|hai liang;
海龙__海龍 275.905561849|hai long;
海螺__海螺 144.502706249|hai luo;
海关__海關 1843.12238107|hai guan;
还敢__還敢 474.442798491|hai gan;
海港__海港 150.007190589|hai gang;
还高__還高 185.634130949|hai gao;
还给__還給 411.610733326|hai gei;
还贵__還貴 139.72158175|hai gui;
海龟__海龜 270.796100963|hai gui;
海归__海歸 389.649164279|hai gui;
还快__還快 170.977284899|hai kuai;
还看__還看 146.862738669|hai kan;
还可__還可 1194.58057905|hai ke;
海口__海口 1181.25761405|hai kou;
海海__海海 110.126966673|hai hai;
海航__海航 247.557321202|hai hang;
还好__還好 12877.4895598|hai hao;
还和__還和 112.765574943|hai he;
海河__海河 220.19257551|hai he;
还很__還很 826.074649543|hai hen;
还会__還會 6416.50597079|hai hui;
海军__海軍 1422.27606545|hai jun;
海角__海角 164.908682755|hai jiao;
还叫__還叫 302.181790975|hai jiao;
还将__還將 2583.57008503|hai jiang;
海景__海景 186.794397067|hai jing;
还请__還請 441.911471008|hai qing;
海区__海區 212.641966978|hai qu;
还去__還去 470.908619205|hai qu;
海选__海選 414.699880708|hai xuan;
海峡__海峽 374.41672986|hai xia;
还嫌__還嫌 124.276893895|hai xian;
海鲜__海鮮 1200.55002966|hai xian;
还小__還小 391.108593802|hai xiao;
海啸__海嘯 658.446218066|hai xiao;
还像__還像 128.369448119|hai xiang;
还想__還想 2715.6161094|hai xiang;
海欣__海欣 112.765574943|hai xin;
海信__海信 497.450167612|hai xin;
海星__海星 130.141230764|hai xing;
还行__還行 4453.75227609|hai xing;
害羞__害羞 1116.83875458|hai xiu;
还须__還須 147.412812521|hai xu;
还需__還需 751.428823061|hai xu;
海战__海戰 160.449013667|hai zhan;
还找__還找 113.47039186|hai zhao;
还真__還真 2861.53400907|hai zhen;
海之__海之 109.852835359|hai zhi;
海中__海中 232.893204426|hai zhong;
海珠__海珠 130.954650472|hai zhu;
还差__還差 1040.25998178|hai cha;
海潮__海潮 113.753550575|hai chao;
海城__海城 148.704343794|hai cheng;
害虫__害蟲 312.911829085|hai chong;
害处__害處 121.520271774|hai chu;
海上__海上 1485.68252323|hai shang;
还少__還少 258.593668656|hai shao;
海神__海神 109.852835359|hai shen;
海参__海參 234.933657026|hai shen;
还剩__還剩 525.487661863|hai sheng;
海事__海事 364.291279287|hai shi;
还是__還是 166934.092511|hai shi;
还说__還說 2926.44637172|hai shuo;
海水__海水 1027.37704867|hai shui;
还让__還讓 244.491487214|hai rang;
骇人__駭人 107.684208225|hai ren;
害人__害人 510.640021015|hai ren;
还在__還在 16481.2233673|hai zai;
海藻__海藻 264.459727191|hai zao;
还早__還早 629.559803835|hai zao;
海贼__海賊 154.368879448|hai zei;
海子__海子 323.619340361|hai zi;
孩子__孩子 36407.8218587|hai zi;
还算__還算 2464.07841638|hai suan;
害死__害死 574.10053635|hai si;
还远__還遠 188.665925845|hai yuan;
海运__海運 498.070459751|hai yun;
海牙__海牙 112.484875527|hai ya;
海盐__海鹽 118.676811842|hai yan;
海岩__海岩 207.925293333|hai yan;
海燕__海燕 259.238974004|hai yan;
海洋__海洋 2632.31764915|hai yang;
还要__還要 24989.1407424|hai yao;
还以__還以 255.709615075|hai yi;
还应__還應 499.935980841|hai ying;
还有__還有 86132.3164207|hai you;
还用__還用 907.004698479|hai yong;
海域__海域 976.203874871|hai yu;
海外__海外 4242.4734338|hai wai;
还玩__還玩 138.508067822|hai wan;
海湾__海灣 450.24958728|hai wan;
海王__海王 114.46454262|hai wang;
还望__還望 189.608710238|hai wang;
还问__還問 168.859844103|hai wen;
还为__還為 283.574337601|hai wei;
还未__還未 1565.51253772|hai wei;
害我__害我 434.810109507|hai wo;
海岸__海岸 583.476802811|hai an;
孩儿__孩兒 205.350275845|hai er;
海尔__海爾 1373.50489426|hai er;
海鸥__海鷗 320.010065926|hai ou;
韩版__韓版 167.184787749|han ban;
汉堡__漢堡 546.866130582|han bao;
寒冰__寒冰 265.119670945|han bing;
韩鹏__韓鵬 105.953760973|han peng;
悍马__悍馬 280.062456643|han ma;
汗毛__汗毛 125.209594649|han mao;
汉方__漢方 200.795341333|han fang;
焊缝__焊縫 113.895394799|han feng;
寒风__寒風 457.033213363|han feng;
韩服__韓服 142.535402072|han fu;
汉服__漢服 279.713669565|han fu;
汉代__漢代 326.861744407|han dai;
邯郸__邯鄲 471.495815538|han dan;
喊道__喊道 328.495108513|han dao;
憨豆__憨豆 167.810977762|han dou;
撼动__撼動 184.941433485|han dong;
寒冬__寒冬 290.730764849|han dong;
汉唐__漢唐 140.594881376|han tang;
喊了__喊了 326.861744407|han le;
寒冷__寒冷 1146.45164931|han leng;
含泪__含淚 253.488718522|han lei;
含量__含量 2977.95009215|han liang;
翰林__翰林 107.282382453|han lin;
寒流__寒流 132.431639237|han liu;
韩流__韓流 139.547573842|han liu;
涵盖__涵蓋 949.804135501|han gai;
韩国__韓國 9937.12917391|han guo;
汉口__漢口 504.944935018|han kou;
喊话__喊話 153.792848894|han hua;
汉化__漢化 1344.71347376|han hua;
韩寒__韓寒 629.559803835|han han;
憨厚__憨厚 247.249015706|han hou;
韩红__韓紅 176.168109435|han hong;
含糊__含糊 402.982545867|han hu;
汉军__漢軍 113.187937993|han jun;
寒假__寒假 697.293562832|han jia;
函件__函件 109.989815613|han jian;
汉奸__漢奸 789.834279627|han jian;
罕见__罕見 1107.13875428|han jian;
喊叫__喊叫 216.384339476|han jiao;
寒江__寒江 158.461958559|han jiang;
汉江__漢江 164.293322714|han jiang;
焊接__焊接 896.889021007|han jie;
韩剧__韓劇 989.677650042|han ju;
寒气__寒氣 169.492308033|han qi;
旱情__旱情 147.780672558|han qing;
寒暄__寒暄 182.423584067|han xuan;
韩雪__韓雪 156.89004718|han xue;
汗腺__汗腺 178.822323044|han xian;
含笑__含笑 275.905561849|han xiao;
寒心__寒心 172.475272126|han xin;
韩信__韓信 194.636170786|han xin;
含蓄__含蓄 605.702953498|han xu;
含着__含着 383.387639617|han zhe;
喊着__喊着 518.979844093|han zhe;
汉中__漢中 280.411678639|han zhong;
汗珠__汗珠 134.594525802|han zhu;
汉朝__漢朝 232.313479749|han chao;
汉城__漢城 282.164331387|han cheng;
喊出__喊出 255.709615075|han chu;
鼾声__鼾聲 117.646076559|han sheng;
喊声__喊聲 131.609045271|han sheng;
韩式__韓式 153.984619852|han shi;
函授__函授 172.260473089|han shou;
函数__函數 5204.46941467|han shu;
含税__含稅 232.024158785|han shui;
汗水__汗水 966.520124945|han shui;
汉人__漢人 470.908619205|han ren;
韩日__韓日 118.972962872|han ri;
旱灾__旱災 107.282382453|han zai;
汉子__漢子 498.070459751|han zi;
汉字__漢字 1687.0530669|han zi;
汉族__漢族 799.738513132|han zu;
寒酸__寒酸 123.813152185|han suan;
汉斯__漢斯 125.522047856|han si;
韩元__韓元 145.405889264|han yuan;
汗颜__汗顏 305.589986932|han yan;
汉阳__漢陽 162.460985719|han yang;
涵养__涵養 208.964318904|han yang;
寒意__寒意 213.971039752|han yi;
涵义__涵義 226.312812713|han yi;
含义__含義 2188.97205903|han yi;
含有__含有 3095.24275062|han you;
韩语__韓語 494.360275282|han yu;
汉语__漢語 1536.52100517|han yu;
汉王__漢王 158.659551632|han wang;
韩文__韓文 294.009808944|han wen;
捍卫__捍衛 598.94764591|han wei;
航班__航班 1593.06462986|hang ban;
航母__航母 759.903909096|hang mu;
行当__行當 230.870473623|hang dang;
航道__航道 329.725485744|hang dao;
航天__航天 978.639934443|hang tian;
行列__行列 1010.8674618|hang lie;
行规__行規 110.401782066|hang gui;
航空__航空 2519.9747123|hang kong;
航海__航海 381.481335404|hang hai;
行货__行貨 1358.18641516|hang huo;
行会__行會 222.398727024|hang hui;
航嘉__航嘉 119.26985293|hang jia;
行家__行家 290.730764849|hang jia;
行情__行情 5146.42480465|hang qing;
航线__航線 894.656458236|hang xian;
杭萧__杭蕭 145.043940608|hang xiao;
航行__航行 417.812212206|hang xing;
行长__行長 769.432826682|hang zhang;
杭州__杭州 10484.1366779|hang zhou;
航程__航程 133.093414711|hang cheng;
杭城__杭城 140.070248771|hang cheng;
夯实__夯實 251.287110964|hang shi;
行数__行數 153.218967809|hang shu;
航运__航運 388.679238014|hang yun;
行业__行業 20243.6107394|hang ye;
好吧__好吧 8222.38948289|hao ba;
好办__好辦 440.262469534|hao ban;
好棒__好棒 192.945711079|hao bang;
好报__好報 142.357889859|hao bao;
好比__好比 813.813436628|hao bi;
好不__好不 922.967443217|hao bu;
毫不__毫不 1617.0663282|hao bu;
好怕__好怕 208.70407676|hao pa;
号牌__號牌 177.048440864|hao pai;
好片__好片 198.803491145|hao pian;
好评__好評 1525.07528247|hao ping;
好嘛__好嘛 699.905273328|hao ma;
好吗__好嗎 4056.35368459|hao ma;
号码__號碼 11047.4796329|hao ma;
好卖__好賣 197.814987883|hao mai;
豪迈__豪邁 265.450260135|hao mai;
好慢__好慢 764.653524665|hao man;
好忙__好忙 242.670241844|hao mang;
好么__好么 1028.65812957|hao me;
豪门__豪門 503.688011099|hao men;
好梦__好夢 774.242000696|hao meng;
好美__好美 321.609191441|hao mei;
毫米__毫米 686.943814365|hao mi;
毫秒__毫秒 176.387781073|hao miao;
毫发__毫髮 147.412812521|hao fa;
好发__好發 287.130256264|hao fa;
好烦__好煩 294.743493195|hao fan;
豪放__豪放 243.275811214|hao fang;
浩方__浩方 609.488769235|hao fang;
耗费__耗費 635.867483878|hao fei;
号段__號段 169.28122395|hao duan;
浩大__浩大 175.292155245|hao da;
好大__好大 1544.19916972|hao da;
好歹__好歹 1454.53963438|hao dai;
浩荡__浩蕩 338.468131949|hao dang;
好得__好得 230.008975843|hao de;
好的__好的 36136.6157823|hao de;
好地__好地 217.736803143|hao di;
好滴__好滴 455.895552723|hao di;
耗电__耗電 252.85772688|hao dian;
好点__好點 2164.55880585|hao dian;
好动__好動 166.97657743|hao dong;
豪赌__豪賭 164.293322714|hao du;
好多__好多 14695.9866401|hao duo;
好贴__好貼 272.828431509|hao tie;
好帖__好帖 412.12398856|hao tie;
好听__好聽 2836.68093103|hao ting;
好痛__好痛 203.820597887|hao tong;
好图__好圖 150.756793028|hao tu;
好男__好男 160.849404779|hao nan;
好难__好難 574.10053635|hao nan;
好呢__好呢 633.494731672|hao ne;
耗能__耗能 128.049907079|hao neng;
好啦__好啦 1308.34803192|hao la;
好莱__好萊 144.322743975|hao lai;
好了__好了 21545.081392|hao le;
好冷__好冷 249.726250867|hao leng;
好累__好累 901.370874142|hao lei;
号令__號令 147.045868173|hao ling;
号楼__號樓 685.233853433|hao lou;
好感__好感 907.004698479|hao gan;
好歌__好歌 287.846772995|hao ge;
好过__好過 638.24912322|hao guo;
好贵__好貴 566.990680223|hao gui;
好快__好快 781.999279332|hao kuai;
好看__好看 7970.17696242|hao kan;
好客__好客 123.044091616|hao ke;
毫克__毫克 165.73274959|hao ke;
好酷__好酷 128.529517539|hao ku;
好话__好話 440.811451858|hao hua;
豪华__豪華 2230.27423094|hao hua;
好坏__好壞 1165.17561047|hao huai;
浩瀚__浩瀚 286.058823982|hao han;
好汉__好漢 333.860122955|hao han;
浩浩__浩浩 120.164975734|hao hao;
好好__好好 18973.4108035|hao hao;
好喝__好喝 268.778909483|hao he;
好后__好后 244.491487214|hao hou;
好货__好貨 171.190483873|hao huo;
好记__好記 139.72158175|hao ji;
好几__好幾 962.913535809|hao ji;
嚎叫__嚎叫 151.510141313|hao jiao;
好觉__好覺 179.045304336|hao jiao;
号角__號角 246.633556117|hao jiao;
浩劫__浩劫 165.32020271|hao jie;
豪杰__豪傑 289.285174995|hao jie;
耗尽__耗盡 302.935867929|hao jin;
好酒__好酒 152.647228173|hao jiu;
好久__好久 8346.27103065|hao jiu;
豪气__豪氣 173.121277629|hao qi;
好奇__好奇 2580.3525318|hao qi;
好强__好強 358.884197808|hao qiang;
豪情__豪情 303.691826638|hao qing;
好球__好球 170.551683166|hao qiu;
好学__好學 317.230705235|hao xue;
好戏__好戲 363.837594448|hao xi;
好险__好險 180.613978088|hao xian;
号线__號線 921.81798848|hao xian;
好笑__好笑 1109.90155418|hao xiao;
好想__好想 1682.85360433|hao xiang;
好象__好象 5436.48975039|hao xiang;
好像__好像 52780.4707138|hao xiang;
好些__好些 1703.95597413|hao xie;
好心__好心 976.203874871|hao xin;
好转__好轉 1175.38409041|hao zhuan;
豪宅__豪宅 745.831342837|hao zhai;
好找__好找 343.139741671|hao zhao;
号召__號召 1143.59786783|hao zhao;
好长__好長 640.639682982|hao chang;
好车__好車 277.630050085|hao che;
号称__號稱 1736.10671918|hao cheng;
好吃__好吃 3839.92616142|hao chi;
好丑__好醜 152.077621994|hao chou;
好处__好處 5250.06745253|hao chu;
好耍__好耍 223.788782324|hao shua;
好爽__好爽 244.491487214|hao shuang;
豪爽__豪爽 393.063006485|hao shuang;
好傻__好傻 133.259374649|hao sha;
好生__好生 191.98633424|hao sheng;
毫升__毫升 373.484720623|hao sheng;
好诗__好詩 112.906187218|hao shi;
好似__好似 233.183609039|hao shi;
耗时__耗時 309.4219738|hao shi;
好使__好使 333.860122955|hao shi;
好事__好事 2996.56312723|hao shi;
好手__好手 218.824857909|hao shou;
好受__好受 279.017397997|hao shou;
好书__好書 413.152419826|hao shu;
好说__好說 675.904869515|hao shuo;
浩然__浩然 206.376433771|hao ran;
好让__好讓 210.532600599|hao rang;
好热__好熱 364.745529846|hao re;
好人__好人 2510.57137637|hao ren;
好在__好在 1121.02187006|hao zai;
号子__號子 127.254530072|hao zi;
耗资__耗資 261.510250403|hao zi;
耗子__耗子 603.442760838|hao zi;
好做__好做 213.704562287|hao zuo;
好菜__好菜 125.209594649|hao cai;
好彩__好彩 126.149295342|hao cai;
耗材__耗材 443.56664881|hao cai;
好惨__好慘 280.062456643|hao can;
好色__好色 535.402718412|hao se;
好似__好似 2153.79604997|hao si;
好远__好遠 557.879339939|hao yuan;
皓月__皓月 124.742372548|hao yue;
好运__好運 1165.17561047|hao yun;
好呀__好呀 1168.08323794|hao ya;
好样__好樣 308.267359529|hao yang;
好耶__好耶 144.143005824|hao ye;
好意__好意 361.12732612|hao yi;
耗油__耗油 128.049907079|hao you;
好友__好友 5152.84210443|hao you;
好用__好用 1710.33813502|hao yong;
好于__好於 193.90988203|hao yu;
好哇__好哇 370.702589737|hao wa;
好玩__好玩 5120.83542651|hao wan;
好文__好文 288.924902033|hao wen;
毫无__毫無 3149.7171872|hao wu;
好啊__好啊 3699.02082656|hao a;
毫安__毫安 105.690017726|hao an;
好饿__好餓 250.037645335|hao e;
好哦__好哦 554.41409416|hao o;
荷包__荷包 175.510734618|he bao;
赫本__赫本 135.267109459|he ben;
喝杯__喝杯 157.2815571|he bei;
河北__河北 2561.13118731|he bei;
何必__何必 2059.3077787|he bi;
河边__河邊 643.039196578|he bian;
合并__合併 3419.72334588|he bing;
何不__何不 381.957020988|he bu;
合拍__合拍 208.184564378|he pai;
河畔__河畔 273.850309404|he pan;
和平__和平 3290.13465937|he ping;
河马__河馬 276.594068012|he ma;
合买__合買 111.925571131|he mai;
合谋__合謀 113.611883002|he mou;
和睦__和睦 353.117055307|he mu;
核发__核發 256.987424161|he fa;
合法__合法 5172.14205573|he fa;
盒饭__盒飯 502.434215952|he fan;
何妨__何妨 181.969489867|he fang;
何方__何方 376.287731462|he fang;
合肥__合肥 2079.94037707|he fei;
和服__和服 146.132498493|he fu;
河段__河段 137.476305203|he duan;
核弹__核彈 218.280152578|he dan;
喝道__喝道 144.682892926|he dao;
喝到__喝到 172.905674062|he dao;
河道__河道 622.538424634|he dao;
喝的__喝的 205.60633599|he de;
喝得__喝得 258.593668656|he de;
何等__何等 496.21189989|he deng;
何地__何地 170.76435144|he di;
核电__核電 371.164834837|he dian;
喝点__喝點 492.515560049|he dian;
核定__核定 546.185068786|he ding;
河东__河東 242.36802267|he dong;
喝多__喝多 323.216307961|he duo;
核对__核對 1309.9794677|he dui;
和她__和她 2292.26454686|he ta;
和他__和他 3488.59235612|he ta;
喝汤__喝湯 227.160466527|he tang;
核桃__核桃 470.32215416|he tao;
合体__合體 183.792676978|he ti;
和田__和田 125.678566729|he tian;
合同__合同 11875.5298799|he tong;
喝奶__喝奶 119.41857567|he nai;
河南__河南 4046.2564886|he nan;
核能__核能 196.096919422|he neng;
河内__河內 160.849404779|he nei;
和你__和你 5525.27903603|he ni;
何来__何來 287.130256264|he lai;
荷兰__荷蘭 1815.76539105|he lan;
河里__河裡 361.577631409|he li;
合力__合力 629.559803835|he li;
合理__合理 8893.93289019|he li;
河流__河流 982.305426747|he liu;
贺龙__賀龍 144.322743975|he long;
和各__和各 243.882891747|he ge;
合格__合格 3657.76624243|he ge;
河谷__河谷 186.097370046|he gu;
喝过__喝過 265.78126155|he guo;
合规__合規 163.069482749|he gui;
何况__何況 1894.35183846|he kuang;
贺卡__賀卡 381.481335404|he ka;
河口__河口 221.845125512|he kou;
何苦__何苦 373.484720623|he ku;
荷花__荷花 555.105417084|he hua;
合欢__合歡 170.551683166|he huan;
和黄__和黃 125.522047856|he huang;
和好__和好 234.933657026|he hao;
喝喝__喝喝 172.04594156|he he;
嗬嗬__嗬嗬 209.485777119|he he;
赫赫__赫赫 804.737106306|he he;
呵呵__呵呵 249662.711419|he he;
合乎__合乎 305.209408115|he hu;
呵护__呵護 967.72532071|he hu;
合伙__合夥 535.402718412|he huo;
合剂__合劑 115.755545596|he ji;
合集__合集 394.535222541|he ji;
合计__合計 2266.69928918|he ji;
何洁__何潔 445.228026075|he jie;
和解__和解 467.400766428|he jie;
合金__合金 784.92825478|he jin;
何炅__何炅 149.633788238|he jiong;
喝酒__喝酒 4734.18271471|he jiu;
和气__和氣 196.096919422|he qi;
何其__何其 337.205131359|he qi;
和讯__和訊 644.643863216|he xun;
河西__河西 360.677581637|he xi;
喝下__喝下 185.86560618|he xia;
和弦__和弦 231.158356006|he xian;
核销__核銷 286.415523108|he xiao;
河蟹__河蟹 525.487661863|he xie;
和谐__和諧 5946.82564905|he xie;
核心__核心 8040.00625758|he xin;
何须__何須 132.266710153|he xu;
盒装__盒裝 266.112675706|he zhuang;
核准__核准 752.365812175|he zhun;
合照__合照 282.516174301|he zhao;
喝着__喝着 348.743933702|he zhe;
何止__何止 286.772667017|he zhi;
喝粥__喝粥 172.905674062|he zhou;
河中__河中 136.452228303|he zhong;
何种__何種 967.72532071|he zhong;
河床__河床 174.855812809|he chuang;
核查__核查 714.000502259|he cha;
喝茶__喝茶 1086.63578899|he cha;
何尝__何嘗 448.010827873|he chang;
合唱__合唱 595.969520633|he chang;
合成__合成 2445.72321123|he cheng;
呵斥__呵斥 120.314814642|he chi;
何处__何處 1341.36617307|he chu;
河山__河山 123.197520618|he shan;
和善__和善 162.663565352|he shan;
喝上__喝上 141.121478992|he shang;
和尚__和尚 1691.26300898|he shang;
合身__合身 129.655606164|he shen;
和声__和聲 142.357889859|he sheng;
何事__何事 235.226605969|he shi;
和室__和室 454.760723981|he shi;
核实__核實 1913.33171172|he shi;
何时__何時 2655.38023445|he shi;
合适__合適 8718.35595463|he shi;
和谁__和誰 249.415244207|he shui;
河水__河水 683.528148986|he shui;
喝水__喝水 1515.60233678|he shui;
赫然__赫然 398.48814637|he ran;
和人__和人 110.264288753|he ren;
何人__何人 304.070513117|he ren;
何日__何日 111.369047744|he ri;
何如__何如 132.10198647|he ru;
荷载__荷載 206.119414554|he zai;
何在__何在 553.723632203|he zai;
菏泽__菏澤 205.60633599|he ze;
合资__合資 1378.64935183|he zi;
盒子__盒子 1866.23446282|he zi;
合租__合租 896.889021007|he zu;
合作__合作 19647.1291647|he zuo;
喝醉__喝醉 382.433299725|he zui;
喝彩__喝彩 388.195180646|he cai;
何曾__何曾 109.852835359|he ceng;
核酸__核酸 144.322743975|he suan;
合算__合算 428.356335222|he suan;
核算__核算 1162.27522076|he suan;
褐色__褐色 385.303469841|he se;
贺岁__賀歲 275.561951728|he sui;
河源__河源 217.465635832|he yuan;
合约__合約 1387.2663024|he yue;
河阳__河陽 155.333728851|he yang;
荷叶__荷葉 279.713669565|he ye;
合意__合意 129.494134325|he yi;
合一__合一 510.640021015|he yi;
何以__何以 721.154209805|he yi;
合影__合影 1089.34742493|he ying;
何用__何用 129.171793682|he yong;
合用__合用 196.096919422|he yong;
喝完__喝完 409.564096466|he wan;
何谓__何謂 259.885889675|he wei;
何为__何為 321.609191441|he wei;
和我__和我 4757.8399467|he wo;
核武__核武 135.098649108|he wu;
何物__何物 153.41002317|he wu;
和蔼__和藹 223.510077937|he ai;
河岸__河岸 145.768741141|he an;
赫尔__赫爾 131.117943492|he er;
很棒__很棒 686.943814365|hen bang;
很薄__很薄 115.179978568|hen bao;
很笨__很笨 128.689786556|hen ben;
很不__很不 2570.72389483|hen bu;
很怕__很怕 290.0070692|hen pa;
很胖__很胖 109.30661816|hen pang;
很慢__很慢 1309.9794677|hen man;
很忙__很忙 2059.3077787|hen mang;
很闷__很悶 110.401782066|hen men;
很美__很美 847.977956119|hen mei;
很烦__很煩 444.673543393|hen fan;
很短__很短 616.362966229|hen duan;
很大__很大 10549.6655141|hen da;
很淡__很淡 111.369047744|hen dan;
很低__很低 1528.88101848|hen di;
狠毒__狠毒 293.643651968|hen du;
很多__很多 66548.3143282|hen duo;
很疼__很疼 236.107646363|hen teng;
很甜__很甜 113.187937993|hen tian;
很痛__很痛 274.191785204|hen tong;
很难__很難 10484.1366779|hen nan;
很浓__很濃 175.948711373|hen nong;
很烂__很爛 319.213487372|hen lan;
很懒__很懶 863.977854874|hen lan;
很老__很老 262.489736092|hen lao;
很冷__很冷 354.881620091|hen leng;
很累__很累 1509.94683642|hen lei;
很广__很廣 205.60633599|hen guang;
很怪__很怪 116.47905068|hen guai;
很乖__很乖 236.991986692|hen guai;
很高__很高 4734.18271471|hen gao;
很贵__很貴 1040.25998178|hen gui;
很困__很困 119.716577729|hen kun;
很快__很快 10721.9636895|hen kuai;
很苦__很苦 173.769702743|hen ku;
很酷__很酷 280.411678639|hen ku;
很坏__很壞 188.196293023|hen huai;
很好__很好 15995.6012027|hen hao;
恨恨__恨恨 202.302314677|hen hen;
狠狠__狠狠 1555.7884176|hen hen;
很黑__很黑 139.373782642|hen hei;
很厚__很厚 152.647228173|hen hou;
很红__很紅 107.550099352|hen hong;
很火__很火 168.859844103|hen huo;
很会__很會 358.884197808|hen hui;
很急__很急 274.191785204|hen ji;
痕迹__痕迹 2074.76292775|hen ji;
很紧__很緊 292.912705474|hen jin;
很近__很近 1254.07172395|hen jin;
很久__很久 6376.65009401|hen jiu;
很强__很強 2602.95983392|hen qiang;
很轻__很輕 216.654158472|hen qing;
很细__很細 167.810977762|hen xi;
很小__很小 2746.24453283|hen xiao;
很香__很香 149.261315371|hen xiang;
很象__很象 216.384339476|hen xiang;
很像__很像 1324.75423858|hen xiang;
很想__很想 2421.46211928|hen xiang;
狠心__狠心 463.341283758|hen xin;
很凶__很兇 142.357889859|hen xiong;
狠抓__狠抓 355.767206381|hen zhua;
很准__很准 217.19480623|hen zhun;
很重__很重 667.534233933|hen zhong;
很差__很差 1215.60448872|hen cha;
很长__很長 2233.05525639|hen chang;
很丑__很醜 217.736803143|hen chou;
很爽__很爽 871.547443971|hen shuang;
很帅__很帥 566.990680223|hen shuai;
很傻__很傻 255.391156791|hen sha;
很少__很少 9789.63492913|hen shao;
很深__很深 1050.68254543|hen shen;
很是__很是 1217.12027856|hen shi;
很瘦__很瘦 153.601316766|hen shou;
很受__很受 341.859308876|hen shou;
很熟__很熟 434.810109507|hen shu;
很热__很熱 608.72971781|hen re;
很弱__很弱 173.769702743|hen ruo;
很早__很早 1208.05380881|hen zao;
恨死__恨死 151.888225993|hen si;
很远__很遠 1498.69906777|hen yuan;
很严__很嚴 147.780672558|hen yan;
很有__很有 7204.94222781|hen you;
很晚__很晚 995.863416846|hen wan;
恨我__恨我 167.393257695|hen wo;
很爱__很愛 515.756221017|hen ai;
横滨__橫濱 119.121315407|heng bin;
横盘__橫盤 270.796100963|heng pan;
横幅__橫幅 425.165459331|heng fu;
横店__橫店 143.605133321|heng dian;
恒定__恆定 200.795341333|heng ding;
哼了__哼了 134.762357541|heng le;
亨利__亨利 714.89082038|heng li;
横梁__橫樑 216.654158472|heng liang;
衡量__衡量 1485.68252323|heng liang;
横跨__橫跨 233.474375771|heng kua;
哼哼__哼哼 1449.11199071|heng heng;
哼唧__哼唧 141.473639374|heng ji;
恒久__恆久 184.941433485|heng jiu;
横线__橫線 154.368879448|heng xian;
横向__橫向 855.407364934|heng xiang;
恒心__恆心 153.984619852|heng xin;
恒星__恆星 285.346757867|heng xing;
横行__橫行 364.745529846|heng xing;
哼着__哼着 138.508067822|heng zhe;
横着__橫着 148.519148841|heng zhe;
恒指__恆指 129.655606164|heng zhi;
横穿__橫穿 155.915530766|heng chuan;
衡山__衡山 127.254530072|heng shan;
恒生__恆生 155.333728851|heng sheng;
横竖__橫豎 122.584950132|heng shu;
衡水__衡水 142.535402072|heng shui;
横扫__橫掃 369.779825848|heng sao;
衡阳__衡陽 378.168082664|heng yang;
恒温__恆溫 179.492101402|heng wen;
黑白__黑白 1579.22849881|hei bai;
黑板__黑板 366.568203397|hei ban;
黑帮__黑幫 428.890471272|hei bang;
黑豹__黑豹 123.351140937|hei bao;
黑皮__黑皮 140.419785869|hei pi;
黑屏__黑屏 731.107734818|hei ping;
黑马__黑馬 739.353626862|hei ma;
黑猫__黑貓 264.459727191|hei mao;
黑莓__黑莓 496.830647979|hei mei;
黑幕__黑幕 491.902185928|hei mu;
黑发__黑髮 232.024158785|hei fa;
黑道__黑道 320.808632296|hei dao;
黑店__黑店 147.964946673|hei dian;
黑点__黑點 192.465424888|hei dian;
黑豆__黑豆 152.457122789|hei dou;
黑洞__黑洞 473.851932013|hei dong;
黑桃__黑桃 123.351140937|hei tao;
黑体__黑體 150.944778196|hei ti;
黑铁__黑鐵 152.837570606|hei tie;
黑头__黑頭 229.722524886|hei tou;
黑了__黑了 366.111682898|hei le;
黑脸__黑臉 143.426288875|hei lian;
黑龙__黑龍 595.969520633|hei long;
黑客__黑客 1500.56786049|hei ke;
黑河__黑河 231.446597362|hei he;
黑黑__黑黑 288.565077751|hei hei;
嘿嘿__嘿嘿 30087.8117959|hei hei;
黑金__黑金 114.037415895|hei jin;
黑线__黑線 124.587019602|hei xian;
黑心__黑心 332.200082586|hei xin;
黑熊__黑熊 114.607273411|hei xiong;
嘿咻__嘿咻 217.465635832|hei xiu;
黑车__黑車 173.121277629|hei che;
黑山__黑山 175.510734618|hei shan;
黑市__黑市 133.758497151|hei shi;
黑石__黑石 226.312812713|hei shi;
黑手__黑手 455.327784806|hei shou;
黑人__黑人 1260.33845835|hei ren;
黑子__黑子 187.961915178|hei zi;
黑色__黑色 6537.57450229|hei se;
黑烟__黑煙 117.207077876|hei yan;
黑夜__黑夜 910.401881269|hei ye;
黑衣__黑衣 288.924902033|hei yi;
黑影__黑影 235.519920202|hei ying;
黑暗__黑暗 3201.15867829|hei an;
后半__後半 169.915266157|hou ban;
后辈__後輩 159.253810404|hou bei;
后被__后被 307.117053725|hou bei;
后备__後備 450.811022973|hou bei;
后背__後背 484.601008682|hou bei;
后便__后便 323.216307961|hou bian;
后边__後邊 501.808489233|hou bian;
候补__候補 150.007190589|hou bu;
后部__後部 166.560934377|hou bu;
后怕__后怕 138.680779525|hou pa;
后排__後排 425.165459331|hou pai;
后妈__后媽 130.954650472|hou ma;
后门__後門 771.352901218|hou men;
后面__後面 14622.914328|hou mian;
后防__後防 196.586267794|hou fang;
后方__後方 589.322768456|hou fang;
后端__後端 244.796354228|hou duan;
后盾__後盾 311.744192349|hou dun;
后代__後代 981.082073059|hou dai;
吼道__吼道 106.085879302|hou dao;
厚道__厚道 1376.93239525|hou dao;
厚的__厚的 162.663565352|hou de;
厚度__厚度 1142.1736421|hou du;
后台__後台 4365.82984783|hou tai;
后天__後天 3484.24769691|hou tian;
后头__後頭 289.285174995|hou tou;
后腿__後腿 181.290467084|hou tui;
后退__後退 683.528148986|hou tui;
候鸟__候鳥 204.584007193|hou niao;
后轮__後輪 174.203334854|hou lun;
后来__後來 24926.9370315|hou lai;
喉咙__喉嚨 734.761160623|hou long;
后路__後路 209.485777119|hou lu;
后盖__后蓋 148.334184528|hou gai;
后宫__後宮 365.655730945|hou gong;
后果__後果 5165.70071998|hou guo;
后可__后可 222.953710017|hou ke;
后话__后話 108.627664361|hou hua;
后海__后海 227.443722742|hou hai;
厚厚__厚厚 243.882891747|hou hou;
吼吼__吼吼 854.342048866|hou hou;
后会__後會 536.070335228|hou hui;
后悔__後悔 4681.38313658|hou hui;
后记__後記 145.224802174|hou ji;
后继__後繼 153.028150386|hou ji;
吼叫__吼叫 164.703307075|hou jiao;
后将__后將 415.216987933|hou jiang;
后进__後進 112.625137786|hou jin;
后劲__後勁 270.458854115|hou jin;
后经__后經 186.32942291|hou jing;
后就__后就 1179.78648723|hou jiu;
后期__後期 2805.04388501|hou qi;
后勤__後勤 630.344829195|hou qin;
候选__候選 468.567137655|hou xuan;
后续__後續 2583.57008503|hou xu;
后者__後者 2784.14878864|hou zhe;
厚重__厚重 560.667124391|hou zhong;
后缀__後綴 918.378206258|hou zhui;
后场__后場 232.893204426|hou chang;
候车__候車 163.069482749|hou che;
后尘__後塵 114.179614083|hou chen;
后山__後山 163.680258901|hou shan;
喉舌__喉舌 111.369047744|hou she;
后生__後生 195.121873946|hou sheng;
后事__後事 174.203334854|hou shi;
厚实__厚實 281.812926654|hou shi;
后世__後世 422.52456065|hou shi;
后市__後市 1280.92243009|hou shi;
后人__後人 707.799244422|hou ren;
后再__后再 1795.51445179|hou zai;
猴子__猴子 2367.75095999|hou zi;
后座__後座 259.238974004|hou zuo;
后才__后才 720.256091319|hou cai;
后院__後院 321.609191441|hou yuan;
后仰__後仰 135.435779871|hou yang;
后腰__后腰 255.073095111|hou yao;
后羿__后羿 120.015323434|hou yi;
后裔__後裔 381.006242235|hou yi;
后因__后因 152.267254161|hou yin;
后又__后又 727.472474808|hou you;
后用__後用 179.268563673|hou yong;
厚望__厚望 227.160466527|hou wang;
后卫__後衛 1331.37418129|hou wei;
厚爱__厚愛 247.557321202|hou ai;
红白__紅白 164.908682755|hong bai;
红斑__紅斑 154.754097942|hong ban;
红包__紅包 2784.14878864|hong bao;
红遍__紅遍 138.163289429|hong bian;
洪波__洪波 113.753550575|hong bo;
红牌__紅牌 350.486645516|hong pai;
红梅__紅梅 221.017305999|hong mei;
轰鸣__轟鳴 158.659551632|hong ming;
红魔__紅魔 179.71591787|hong mo;
红木__紅木 153.028150386|hong mu;
洪峰__洪峰 118.676811842|hong feng;
宏达__宏達 211.057972369|hong da;
宏大__宏大 457.033213363|hong da;
红灯__紅燈 498.070459751|hong deng;
红点__紅點 153.984619852|hong dian;
红豆__紅豆 487.62990282|hong dou;
轰动__轟動 697.293562832|hong dong;
红糖__紅糖 208.44415872|hong tang;
红桃__紅桃 136.963309627|hong tao;
宏图__宏圖 126.464093517|hong tu;
烘托__烘托 164.498187167|hong tuo;
红娘__紅娘 150.194241046|hong niang;
红牛__紅牛 149.261315371|hong niu;
红了__紅了 731.107734818|hong le;
红利__紅利 598.94764591|hong li;
红脸__紅臉 241.162905094|hong lian;
洪亮__洪亮 128.049907079|hong liang;
洪流__洪流 150.381524744|hong liu;
红楼__紅樓 559.968874971|hong lou;
红龙__紅龍 136.963309627|hong long;
宏观__宏觀 1224.72762648|hong guan;
红光__紅光 254.438159592|hong guang;
烘干__烘乾 211.321149687|hong gan;
鸿沟__鴻溝 161.049974862|hong gou;
烘烤__烘烤 152.647228173|hong kao;
虹口__虹口 281.111429553|hong kou;
红花__紅花 332.614317243|hong hua;
红海__紅海 108.492380517|hong hai;
红河__紅河 145.587202159|hong he;
红黑__紅黑 169.28122395|hong hei;
哄哄__哄哄 145.043940608|hong hong;
红红__紅紅 233.765505073|hong hong;
红火__紅火 423.578945935|hong huo;
红军__紅軍 1172.45828945|hong jun;
宏基__宏基 302.181790975|hong ji;
红警__紅警 210.532600599|hong jing;
红酒__紅酒 914.951259653|hong jiu;
红旗__紅旗 829.168709129|hong qi;
虹桥__虹橋 361.12732612|hong qiao;
红霞__紅霞 130.303509496|hong xia;
红线__紅線 344.85444872|hong xian;
红心__紅心 198.06165195|hong xin;
红杏__紅杏 130.954650472|hong xing;
红星__紅星 421.998352644|hong xing;
红袖__紅袖 259.238974004|hong xiu;
轰炸__轟炸 594.486015613|hong zha;
红肿__紅腫 333.444336783|hong zhong;
红唇__紅唇 130.303509496|hong chun;
红茶__紅茶 400.479435488|hong cha;
红尘__紅塵 674.222387052|hong chen;
红烧__紅燒 343.996026791|hong shao;
红薯__紅薯 300.304800557|hong shu;
洪水__洪水 1000.83985593|hong shui;
红润__紅潤 296.585723861|hong run;
轰然__轟然 184.941433485|hong ran;
红人__紅人 192.465424888|hong ren;
红日__紅日 114.75018218|hong ri;
洪灾__洪災 144.502706249|hong zai;
红枣__紅棗 310.194118206|hong zao;
红字__紅字 239.664931108|hong zi;
红色__紅色 5573.68779063|hong se;
宏远__宏遠 135.604660605|hong yuan;
红云__紅雲 110.539446825|hong yun;
红晕__紅暈 129.010924378|hong yun;
红眼__紅眼 112.906187218|hong yan;
鸿雁__鴻雁 128.529517539|hong yan;
红颜__紅顏 548.230802969|hong yan;
弘扬__弘揚 730.197220308|hong yang;
红叶__紅葉 430.496878967|hong ye;
红衣__紅衣 280.761336094|hong yi;
红外__紅外 670.869975958|hong wai;
宏伟__宏偉 614.062995519|hong wei;
洪武__洪武 125.678566729|hong wu;
湖北__湖北 2883.00988318|hu bei;
湖边__湖邊 467.983588668|hu bian;
湖滨__湖濱 156.109948588|hu bin;
互不__互不 264.130371602|hu bu;
互补__互補 564.171453387|hu bu;
护盘__護盤 141.826678552|hu pan;
湖畔__湖畔 270.122027271|hu pan;
虎皮__虎皮 109.989815613|hu pi;
琥珀__琥珀 312.522131716|hu po;
湖泊__湖泊 454.760723981|hu po;
虎门__虎門 177.711575153|hu men;
湖面__湖面 304.449671797|hu mian;
户名__戶名 122.737806611|hu ming;
护法__護法 246.326401069|hu fa;
互访__互訪 141.121478992|hu fang;
护肤__護膚 496.830647979|hu fu;
湖大__湖大 114.037415895|hu da;
蝴蝶__蝴蝶 1859.27057168|hu die;
互动__互動 3060.72200622|hu dong;
弧度__弧度 193.186303435|hu du;
虎头__虎頭 108.357265155|hu tou;
户头__戶頭 140.594881376|hu tou;
互通__互通 445.783200166|hu tong;
胡同__衚衕 582.750146437|hu tong;
糊涂__糊塗 1474.61550226|hu tu;
湖南__湖南 4242.4734338|hu nan;
胡闹__胡鬧 175.948711373|hu nao;
糊弄__糊弄 334.69325133|hu nong;
胡乱__胡亂 670.869975958|hu luan;
忽略__忽略 2529.4132684|hu lue;
胡来__胡來 206.89143407|hu lai;
护栏__護欄 248.794392378|hu lan;
湖里__湖裡 147.229226029|hu li;
互利__互利 356.210827905|hu li;
狐狸__狐狸 1670.31783317|hu li;
护理__護理 2049.06835863|hu li;
互连__互連 141.473639374|hu lian;
互联__互聯 746.761352211|hu lian;
呼噜__呼嚕 176.60772663|hu lu;
葫芦__葫蘆 546.185068786|hu lu;
胡戈__胡戈 173.986383704|hu ge;
胡歌__胡歌 217.736803143|hu ge;
虎口__虎口 111.230349808|hu kou;
糊口__糊口 144.143005824|hu kou;
户口__戶口 2658.69134296|hu kou;
互换__互換 397.991873082|hu huan;
呼唤__呼喚 1272.96603034|hu huan;
呼喊__呼喊 379.584509838|hu han;
护航__護航 120.46484039|hu hang;
糊糊__糊糊 132.762114633|hu hu;
乎乎__乎乎 136.452228303|hu hu;
忽忽__忽忽 454.760723981|hu hu;
呼呼__呼呼 1392.46230328|hu hu;
互惠__互惠 219.918349804|hu hui;
胡军__胡軍 185.86560618|hu jun;
户籍__戶籍 807.751246202|hu ji;
胡佳__胡佳 124.122120652|hu jia;
护甲__護甲 295.847453874|hu jia;
胡椒__胡椒 156.109948588|hu jiao;
呼叫__呼叫 1276.14264248|hu jiao;
呼救__呼救 118.529012887|hu jiu;
呼气__呼氣 139.547573842|hu qi;
湖区__湖區 147.045868173|hu qu;
呼吸__呼吸 3019.05239777|hu xi;
弧线__弧線 312.132919672|hu xian;
呼啸__呼嘯 374.41672986|hu xiao;
互相__互相 5409.45809302|hu xiang;
互信__互信 159.452390871|hu xin;
弧形__弧形 203.566761683|hu xing;
户型__戶型 968.932019286|hu xing;
胡须__鬍鬚 246.633556117|hu xu;
糊状__糊狀 140.770195218|hu zhuang;
护照__護照 1274.55334676|hu zhao;
护着__護着 169.070402749|hu zhe;
沪指__滬指 270.122027271|hu zhi;
湖州__湖州 413.667597456|hu zhou;
湖中__湖中 146.497163581|hu zhong;
护住__護住 128.529517539|hu zhu;
户主__戶主 167.810977762|hu zhu;
互助__互助 546.185068786|hu zhu;
胡扯__胡扯 449.688850794|hu che;
呼出__呼出 194.393772779|hu chu;
沪上__滬上 311.355949144|hu shang;
沪深__滬深 578.409173188|hu shen;
呼声__呼聲 669.200026501|hu sheng;
呼市__呼市 158.659551632|hu shi;
胡适__胡適 334.69325133|hu shi;
沪市__滬市 344.424970321|hu shi;
忽视__忽視 1775.48936799|hu shi;
护士__護士 1782.13945694|hu shi;
户数__戶數 154.176629937|hu shu;
胡说__胡說 711.336195135|hu shuo;
湖水__湖水 571.245957438|hu shui;
胡润__胡潤 123.504952812|hu run;
忽然__忽然 4509.6007036|hu ran;
湖人__湖人 538.078184713|hu ren;
虎子__虎子 145.043940608|hu zi;
胡子__鬍子 1010.8674618|hu zi;
护送__護送 546.866130582|hu song;
狐疑__狐疑 133.093414711|hu yi;
呼应__呼應 392.084582382|hu ying;
忽悠__忽悠 2719.00232863|hu you;
呼吁__呼籲 2227.49666896|hu yu;
户外__戶外 1290.5357804|hu wai;
护腕__護腕 250.661599628|hu wan;
互为__互為 227.443722742|hu wei;
护卫__護衛 330.960471347|hu wei;
忽而__忽而 121.975425508|hu er;
火把__火把 169.070402749|huo ba;
伙伴__夥伴 1966.51263254|huo ban;
活宝__活寶 117.792774542|huo bao;
火暴__火暴 185.86560618|huo bao;
火爆__火爆 1611.03221293|huo bao;
或被__或被 183.792676978|huo bei;
货币__貨幣 2815.55016665|huo bi;
或不__或不 425.69561654|huo bu;
火炮__火炮 224.907079496|huo pao;
获批__獲批 200.545272755|huo pi;
火拼__火拚 125.209594649|huo pin;
货品__貨品 456.464028614|huo pin;
活泼__活潑 1260.33845835|huo po;
豁免__豁免 198.06165195|huo mian;
火苗__火苗 142.180598718|huo miao;
活命__活命 113.32907693|huo ming;
活佛__活佛 215.845709156|huo fo;
霍夫__霍夫 111.507918629|huo fu;
豁达__豁達 278.669912425|huo da;
货代__貨代 388.195180646|huo dai;
货到__貨到 207.149415951|huo dao;
活到__活到 260.209952636|huo dao;
活得__活得 1035.08753546|huo de;
获得__獲得 22787.7939724|huo de;
火电__火電 151.132997772|huo dian;
活动__活動 35379.1197554|huo dong;
活体__活體 146.862738669|huo ti;
伙同__夥同 152.267254161|huo tong;
火腿__火腿 307.117053725|huo tui;
霍乱__霍亂 106.350610398|huo luan;
火辣__火辣 241.764712994|huo la;
火了__火了 318.815941979|huo le;
活了__活了 574.10053635|huo le;
火力__火力 614.828697239|huo li;
获利__獲利 1502.43898348|huo li;
活力__活力 2966.83781195|huo li;
火龙__火龍 180.613978088|huo long;
活路__活路 112.484875527|huo lu;
火炉__火爐 202.302314677|huo lu;
火光__火光 233.765505073|huo guang;
活该__活該 631.130833438|huo gai;
火锅__火鍋 1416.96881393|huo guo;
货柜__貨櫃 133.758497151|huo gui;
货款__貨款 965.316430119|huo kuan;
火抗__火抗 141.473639374|huo kang;
火化__火化 234.933657026|huo hua;
活化__活化 450.811022973|huo hua;
火花__火花 649.481929235|huo hua;
火海__火海 120.765453341|huo hai;
祸害__禍害 282.164331387|huo hai;
货号__貨號 165.73274959|huo hao;
火候__火候 211.321149687|huo hou;
火红__火紅 249.726250867|huo hong;
火狐__火狐 325.642053285|huo hu;
活活__活活 552.345286903|huo huo;
火鸡__火雞 186.097370046|huo ji;
伙计__夥計 426.226434824|huo ji;
货架__貨架 543.469292924|huo jia;
活检__活檢 119.56748386|huo jian;
火箭__火箭 3327.2428637|huo jian;
或将__或將 179.045304336|huo jiang;
获奖__獲獎 1316.52557925|huo jiang;
霍金__霍金 137.476305203|huo jin;
获救__獲救 169.915266157|huo jiu;
火炬__火炬 960.516622856|huo ju;
活期__活期 187.4940348|huo qi;
或其__或其 229.722524886|huo qi;
火气__火氣 383.865702254|huo qi;
火枪__火槍 207.925293333|huo qiang;
火球__火球 277.630050085|huo qiu;
获取__獲取 5063.7235729|huo qu;
活血__活血 327.677408739|huo xue;
获悉__獲悉 1838.53442614|huo xi;
火线__火線 179.940013424|huo xian;
活性__活性 1066.51251556|huo xing;
火星__火星 1653.74860966|huo xing;
或许__或許 8387.97826544|huo xu;
获准__獲准 324.02287532|huo zhun;
活着__活着 3703.63329569|huo zhe;
或者__或者 54518.5809258|huo zhe;
获知__獲知 282.868455943|huo zhi;
火种__火種 160.849404779|huo zhong;
货主__貨主 133.093414711|huo zhu;
火柴__火柴 418.333200332|huo chai;
货车__貨車 655.989212862|huo che;
火车__火車 4722.39824658|huo che;
火山__火山 483.394725468|huo shan;
火烧__火燒 506.83620443|huo shao;
或少__或少 554.41409416|huo shao;
获胜__獲勝 681.82669043|huo sheng;
获释__獲釋 115.179978568|huo shi;
火势__火勢 126.306596357|huo shi;
伙食__伙食 352.238065853|huo shi;
或是__或是 4805.5096548|huo shi;
火热__火熱 942.728934628|huo re;
活人__活人 312.522131716|huo ren;
活在__活在 764.653524665|huo zai;
火灾__火災 916.092151969|huo zai;
或则__或則 136.622376491|huo ze;
获赠__獲贈 249.104624871|huo zeng;
活塞__活塞 544.146968302|huo sai;
货色__貨色 318.022335873|huo se;
火速__火速 228.011295226|huo su;
货源__貨源 702.526765976|huo yuan;
活跃__活躍 3053.10316616|huo yue;
货运__貨運 768.474582473|huo yun;
火焰__火焰 1276.14264248|huo yan;
火药__火藥 262.489736092|huo yao;
获益__獲益 279.365316864|huo yi;
或以__或以 398.48814637|huo yi;
或因__或因 141.29744947|huo yin;
火影__火影 783.950712715|huo ying;
或有__或有 247.249015706|huo you;
或用__或用 212.377144726|huo yong;
货物__貨物 3015.29249908|huo wu;
霍尔__霍爾 155.527421199|huo er;
活儿__活兒 365.655730945|huo er;
会把__會把 1653.74860966|hui ba;
灰白__灰白 121.368931601|hui bai;
汇报__彙報 3233.23169914|hui bao;
回报__回報 3261.55908656|hui bao;
会被__會被 2742.82438642|hui bei;
会比__會比 657.626195507|hui bi;
回避__迴避 1544.19916972|hui bi;
会变__會變 326.861744407|hui bian;
汇编__彙編 588.588831574|hui bian;
回拨__回撥 153.218967809|hui bo;
回补__回補 237.583386308|hui bu;
汇票__匯票 233.474375771|hui piao;
惠普__惠普 1534.60743675|hui pu;
会面__會面 383.387639617|hui mian;
毁灭__毀滅 1196.07015327|hui mie;
回民__回民 168.859844103|hui min;
惠民__惠民 219.918349804|hui min;
回眸__回眸 255.073095111|hui mou;
会发__會發 112.34478795|hui fa;
挥发__揮發 258.271618599|hui fa;
回放__回放 476.219822262|hui fang;
回访__回訪 590.057620516|hui fang;
汇丰__滙豐 419.900065808|hui feng;
会费__會費 208.184564378|hui fei;
会飞__會飛 218.824857909|hui fei;
会否__會否 305.97104031|hui fou;
回覆__回覆 137.991222203|hui fu;
恢复__恢復 10978.8586437|hui fu;
回复__回復 11354.5435549|hui fu;
回答__回答 16563.5818541|hui da;
回档__回檔 119.56748386|hui dang;
回荡__回蕩 284.991389772|hui dang;
回到__回到 8783.78740305|hui dao;
慧德__慧德 124.89791921|hui de;
回电__回電 115.899886195|hui dian;
回调__回調 200.04606951|hui diao;
毁掉__毀掉 321.609191441|hui diao;
挥动__揮動 191.031727675|hui dong;
灰度__灰度 172.475272126|hui du;
汇兑__匯兌 121.066816454|hui dui;
会对__會對 1609.02584897|hui dui;
会谈__會談 988.445115058|hui tan;
回调__回調 769.432826682|hui tiao;
回贴__回貼 530.091629029|hui tie;
回帖__回帖 2090.33406802|hui tie;
回头__回頭 5998.9277097|hui tou;
汇通__匯通 154.754097942|hui tong;
会同__會同 652.727461906|hui tong;
回吐__回吐 128.689786556|hui tu;
绘图__繪圖 365.655730945|hui tu;
回退__回退 125.053659829|hui tui;
回暖__回暖 238.770616634|hui nuan;
惠农__惠農 143.0692679|hui nong;
汇率__匯率 1764.46098498|hui lv;
会来__會來 330.960471347|hui lai;
回来__回來 47004.7079863|hui lai;
会里__會裡 208.44415872|hui li;
会令__會令 213.704562287|hui ling;
回流__迴流 301.805456692|hui liu;
回笼__回籠 192.945711079|hui long;
回路__迴路 490.066643104|hui lu;
贿赂__賄賂 574.81640715|hui lu;
回落__回落 1621.10162248|hui luo;
会馆__會館 266.112675706|hui guan;
回滚__回滾 110.815291538|hui gun;
悔改__悔改 152.457122789|hui gai;
会跟__會跟 203.820597887|hui gen;
会更__會更 620.98878351|hui geng;
会给__會給 1450.91895115|hui gei;
回购__回購 578.409173188|hui gou;
惠顾__惠顧 105.0335283|hui gu;
灰谷__灰谷 139.026849285|hui gu;
回顾__回顧 1873.22443719|hui gu;
回过__回過 869.377962205|hui guo;
回国__回國 2801.55051046|hui guo;
回归__回歸 2708.85631718|hui gui;
回款__回款 242.36802267|hui kuan;
汇款__匯款 1918.1063189|hui kuan;
会刊__會刊 108.087539034|hui kan;
会考__會考 159.253810404|hui kao;
回扣__回扣 503.688011099|hui kou;
回馈__回饋 563.46883971|hui kui;
回话__回話 450.24958728|hui hua;
会话__會話 607.214449729|hui hua;
绘画__繪畫 1121.02187006|hui hua;
辉煌__輝煌 2289.40978274|hui huang;
毁坏__毀壞 297.696584607|hui huai;
汇合__匯合 192.705418355|hui he;
会合__會合 302.558594526|hui he;
回合__回合 696.425160166|hui he;
悔恨__悔恨 247.249015706|hui hen;
会很__會很 971.349932368|hui hen;
会后__會後 154.754097942|hui hou;
挥霍__揮霍 407.527636023|hui huo;
挥挥__揮揮 111.230349808|hui hui;
慧慧__慧慧 118.676811842|hui hui;
回回__回回 180.839193473|hui hui;
回绝__回絕 198.308623594|hui jue;
徽记__徽記 127.254530072|hui ji;
回击__回擊 163.680258901|hui ji;
惠及__惠及 230.870473623|hui ji;
汇集__彙集 723.855290267|hui ji;
汇价__匯價 202.302314677|hui jia;
回家__回家 23246.7120362|hui jia;
回见__回見 271.133768339|hui jian;
会见__會見 1351.43315497|hui jian;
会叫__會叫 106.085879302|hui jiao;
回教__回教 144.682892926|hui jiao;
会将__會將 522.223615731|hui jiang;
汇金__匯金 153.792848894|hui jin;
灰烬__灰燼 192.945711079|hui jin;
回敬__回敬 111.091824605|hui jing;
回京__回京 148.519148841|hui jing;
汇聚__匯聚 615.595353746|hui ju;
晦气__晦氣 113.611883002|hui qi;
汇钱__匯錢 163.884358899|hui qian;
会去__會去 913.811788194|hui qu;
回去__回去 23044.8090197|hui qu;
回旋__迴旋 252.85772688|hui xuan;
麾下__麾下 149.075426771|hui xia;
回校__回校 130.628674269|hui xiao;
会向__會向 184.481071779|hui xiang;
回响__迴響 210.270405333|hui xiang;
回乡__回鄉 273.168633085|hui xiang;
回想__回想 931.053859154|hui xiang;
诙谐__詼諧 232.024158785|hui xie;
会心__會心 196.586267794|hui xin;
灰心__灰心 266.112675706|hui xin;
回信__回信 884.6784987|hui xin;
彗星__彗星 247.866011137|hui xing;
灰熊__灰熊 129.817279349|hui xiong;
回转__迴轉 227.727332161|hui zhuan;
会战__會戰 183.335174792|hui zhan;
会展__會展 548.914415679|hui zhan;
徽章__徽章 534.069978074|hui zhang;
会长__會長 1996.14083601|hui zhang;
会找__會找 142.357889859|hui zhao;
会诊__會診 240.562595233|hui zhen;
回执__回執 283.574337601|hui zhi;
绘制__繪製 878.088426229|hui zhi;
徽州__徽州 173.986383704|hui zhou;
惠州__惠州 699.033618062|hui zhou;
回传__回傳 248.794392378|hui chuan;
会唱__會唱 112.065135969|hui chang;
会场__會場 793.781168439|hui chang;
回车__回車 600.442284667|hui che;
灰尘__灰塵 994.623178167|hui chen;
汇成__匯成 117.353228453|hui cheng;
回程__回程 493.129699012|hui cheng;
回城__回城 750.493000864|hui cheng;
蛔虫__蛔蟲 147.412812521|hui chong;
汇出__匯出 144.682892926|hui chu;
会上__會上 1575.29743635|hui shang;
回身__回身 140.244908425|hui shen;
回声__回聲 247.866011137|hui sheng;
回升__回升 844.813709452|hui sheng;
会师__會師 142.003528374|hui shi;
汇市__匯市 163.884358899|hui shi;
会是__會是 1409.92327219|hui shi;
会使__會使 1764.46098498|hui shi;
回事__回事 3352.21389275|hui shi;
挥手__揮手 584.204365283|hui shou;
回首__回首 676.747684543|hui shou;
回收__回收 1930.09502896|hui shou;
会说__會說 1214.09058664|hui shuo;
会让__會讓 2018.65456559|hui rang;
毁容__毀容 151.888225993|hui rong;
汇入__匯入 201.79873775|hui ru;
会再__會再 371.627656329|hui zai;
会在__會在 3590.02852297|hui zai;
汇总__匯總 2205.40034128|hui zong;
回族__回族 338.046607007|hui zu;
会做__會做 593.006203378|hui zuo;
慧聪__慧聰 156.499511818|hui cong;
荟萃__薈萃 223.788782324|hui cui;
挥洒__揮灑 216.924313917|hui sa;
晦涩__晦澀 164.498187167|hui se;
灰色__灰色 1727.4743398|hui se;
会死__會死 313.302012384|hui si;
回溯__回溯 110.539446825|hui su;
会所__會所 737.513205869|hui suo;
汇源__匯源 138.335571213|hui yuan;
会员__會員 10086.8456213|hui yuan;
慧眼__慧眼 218.552335545|hui yan;
会以__會以 331.37316028|hui yi;
回忆__回憶 6211.94095161|hui yi;
会议__會議 12236.0677836|hui yi;
会因__會因 296.216358865|hui yin;
回音__迴音 454.194369369|hui yin;
辉映__輝映 110.539446825|hui ying;
回应__回應 2332.60704332|hui ying;
会有__會有 11326.2794881|hui you;
会用__會用 826.074649543|hui yong;
会玩__會玩 132.10198647|hui wan;
回望__回望 175.948711373|hui wang;
会问__會問 299.1842072|hui wen;
惠威__惠威 105.558392399|hui wei;
会为__會為 315.653350706|hui wei;
回味__回味 912.673735821|hui wei;
会务__會務 125.678566729|hui wu;
挥舞__揮舞 372.091054935|hui wu;
会晤__會晤 451.935995467|hui wu;
灰暗__灰暗 293.277951001|hui an;
会儿__會兒 855.407364934|hui er;
卷发__捲髮 280.411678639|juan fa;
倦怠__倦怠 207.149415951|juan dai;
眷恋__眷戀 317.626273928|juan lian;
捐给__捐給 212.377144726|juan gei;
眷顾__眷顧 222.67604562|juan gu;
捐款__捐款 1887.28302677|juan kuan;
娟娟__娟娟 165.939408926|juan juan;
卷起__捲起 201.547419552|juan qi;
捐钱__捐錢 162.86639759|juan qian;
卷曲__捲曲 120.765453341|juan qu;
捐献__捐獻 449.128812644|juan xian;
卷轴__捲軸 244.796354228|juan zhou;
捐助__捐助 660.089332023|juan zhu;
捐出__捐出 206.89143407|juan chu;
眷属__眷屬 202.050369328|juan shu;
倦容__倦容 108.492380517|juan rong;
卷入__捲入 443.014235191|juan ru;
捐赠__捐贈 1197.56158489|juan zeng;
娟子__娟子 118.676811842|juan zi;
捐资__捐資 192.225730308|juan zi;
卷子__卷子 388.679238014|juan zi;
卷烟__捲煙 371.627656329|juan yan;
绝版__絕版 208.964318904|jue ban;
决不__決不 1504.31243966|jue bu;
绝不__絕不 2688.67773313|jue bu;
绝配__絕配 155.72135507|jue pei;
绝美__絕美 182.196395498|jue mei;
绝密__絕密 202.302314677|jue mi;
绝妙__絕妙 222.67604562|jue miao;
绝非__絕非 497.450167612|jue fei;
决断__決斷 184.251320835|jue duan;
绝大__絕大 154.947067523|jue da;
绝代__絕代 105.295633316|jue dai;
觉的__覺的 538.078184713|jue de;
觉得__覺得 83907.515034|jue de;
绝地__絕地 172.905674062|jue di;
绝顶__絕頂 164.088713397|jue ding;
决定__決定 25683.7121577|jue ding;
决斗__決鬥 338.046607007|jue dou;
绝对__絕對 14227.4629914|jue dui;
绝伦__絕倫 180.613978088|jue lun;
决裂__決裂 158.461958559|jue lie;
绝路__絕路 114.46454262|jue lu;
绝好__絕好 146.862738669|jue hao;
绝活__絕活 144.143005824|jue huo;
决绝__決絕 241.764712994|jue jue;
绝技__絕技 313.302012384|jue ji;
绝迹__絕跡 1249.39213028|jue ji;
绝佳__絕佳 361.12732612|jue jia;
绝交__絕交 121.823518492|jue jiao;
倔强__倔強 557.184562398|jue jiang;
掘金__掘金 368.85935893|jue jin;
绝境__絕境 165.939408926|jue jing;
崛起__崛起 1662.01257345|jue qi;
诀窍__訣竅 256.987424161|jue qiao;
绝情__絕情 240.263000901|jue qing;
攫取__攫取 122.890853693|jue qu;
决心__決心 2753.09762515|jue xin;
觉醒__覺醒 469.736419493|jue xing;
决战__決戰 530.752623218|jue zhan;
绝招__絕招 368.399985048|jue zhao;
觉着__覺着 332.200082586|jue zhe;
绝症__絕症 204.839111844|jue zheng;
绝种__絕種 108.492380517|jue zhong;
角逐__角逐 444.673543393|jue zhu;
觉察__覺察 286.415523108|jue cha;
绝尘__絕塵 124.122120652|jue chen;
决出__決出 115.179978568|jue chu;
绝杀__絕殺 190.081867665|jue sha;
绝食__絕食 214.772467501|jue shi;
绝世__絕世 338.890182508|jue shi;
爵士__爵士 872.634214191|jue shi;
抉择__抉擇 574.10053635|jue ze;
决策__決策 3402.71958168|jue ce;
决算__決算 170.127140854|jue suan;
决赛__決賽 2464.07841638|jue sai;
绝色__絕色 250.349428094|jue se;
角色__角色 6940.55829057|jue se;
绝缘__絕緣 438.073368704|jue yuan;
决意__決意 125.835280772|jue yi;
决议__決議 1146.45164931|jue yi;
绝望__絕望 2077.35003942|jue wang;
绝无__絕無 248.484546245|jue wu;
觉悟__覺悟 638.24912322|jue wu;
均被__均被 181.516526012|jun bei;
均不__均不 235.226605969|jun bu;
骏马__駿馬 204.584007193|jun ma;
俊美__俊美 167.393257695|jun mei;
军民__軍民 324.02287532|jun min;
军阀__軍閥 283.927938713|jun fa;
军方__軍方 634.284663664|jun fang;
军费__軍費 133.591915611|jun fei;
军服__軍服 128.529517539|jun fu;
军刀__軍刀 178.822323044|jun dao;
均等__均等 142.180598718|jun deng;
军队__軍隊 3149.7171872|jun dui;
军团__軍團 1086.63578899|jun tuan;
俊男__俊男 142.357889859|jun nan;
均能__均能 171.831677206|jun neng;
军旅__軍旅 162.056583012|jun lv;
俊朗__俊朗 131.773154284|jun lang;
军力__軍力 127.890434962|jun li;
军官__軍官 850.094035423|jun guan;
军工__軍工 407.020105042|jun gong;
竣工__竣工 831.23785106|jun gong;
均可__均可 1227.78386251|jun ke;
均衡__均衡 1422.27606545|jun heng;
军火__軍火 201.547419552|jun huo;
君君__君君 166.97657743|jun jun;
均价__均價 999.59341964|jun jia;
军舰__軍艦 305.209408115|jun jian;
骏捷__駿捷 196.096919422|jun jie;
俊杰__俊傑 212.112652282|jun jie;
军警__軍警 134.930398555|jun jing;
军旗__軍旗 199.796934068|jun qi;
俊俏__俊俏 117.93965545|jun qiao;
军情__軍情 161.854759309|jun qing;
军区__軍區 606.458230719|jun qu;
军训__軍訓 971.349932368|jun xun;
军衔__軍銜 326.454673948|jun xian;
均线__均線 894.656458236|jun xian;
军校__軍校 320.409100324|jun xiao;
俊秀__俊秀 143.426288875|jun xiu;
均需__均需 106.085879302|jun xu;
军装__軍裝 335.528458728|jun zhuang;
军长__軍長 165.32020271|jun zhang;
军政__軍政 168.020228531|jun zheng;
均值__均值 175.510734618|jun zhi;
菌种__菌種 128.369448119|jun zhong;
军中__軍中 199.051387821|jun zhong;
郡主__郡主 120.164975734|jun zhu;
菌株__菌株 121.066816454|jun zhu;
君主__君主 374.41672986|jun zhu;
军车__軍車 137.305093541|jun che;
君臣__君臣 123.351140937|jun chen;
军师__軍師 219.918349804|jun shi;
均是__均是 431.033684153|jun shi;
军事__軍事 3398.48186759|jun shi;
均属__均屬 550.284199441|jun shu;
军人__軍人 1589.0991261|jun ren;
均在__均在 409.054029297|jun zai;
君子__君子 1416.96881393|jun zi;
均匀__均勻 1676.57400252|jun yun;
军演__軍演 141.121478992|jun yan;
军医__軍醫 133.758497151|jun yi;
均以__均以 248.175085992|jun yi;
均已__均已 337.625607028|jun yi;
均应__均應 183.335174792|jun ying;
军营__軍營 314.867617017|jun ying;
均由__均由 714.000502259|jun you;
均有__均有 1109.90155418|jun you;
军用__軍用 428.356335222|jun yong;
君王__君王 249.726250867|jun wang;
军委__軍委 188.196293023|jun wei;
均未__均未 228.295612376|jun wei;
均为__均為 1847.72178498|jun wei;
均无__均無 155.915530766|jun wu;
鸡吧__雞吧 135.267109459|ji ba;
即把__即把 151.132997772|ji ba;
几把__幾把 325.236501817|ji ba;
鸡巴__雞巴 1647.57761372|ji ba;
祭拜__祭拜 111.507918629|ji bai;
击败__擊敗 1199.05487625|ji bai;
几百__幾百 2542.05302484|ji bai;
羁绊__羈絆 144.322743975|ji ban;
基板__基板 173.769702743|ji ban;
季报__季報 312.911829085|ji bao;
几本__幾本 524.833224606|ji ben;
基本__基本 29715.1941105|ji ben;
脊背__脊背 121.520271774|ji bei;
几杯__幾杯 126.149295342|ji bei;
几倍__幾倍 409.564096466|ji bei;
几笔__幾筆 124.122120652|ji bi;
击毙__擊斃 292.183578474|ji bi;
畸变__畸變 109.989815613|ji bian;
几遍__幾遍 485.810302105|ji bian;
即便__即便 3060.72200622|ji bian;
级别__級別 6416.50597079|ji bie;
疾病__疾病 4420.5757602|ji bing;
基部__基部 107.416157498|ji bu;
记不__記不 349.178797604|ji bu;
几部__幾部 500.559372647|ji bu;
几步__幾步 610.248767154|ji bu;
既不__既不 905.87512359|ji bu;
几片__幾片 191.747236314|ji pian;
几篇__幾篇 467.400766428|ji pian;
机票__機票 3169.40381549|ji piao;
极品__極品 1976.33951256|ji pin;
几瓶__幾瓶 144.502706249|ji ping;
急迫__急迫 139.72158175|ji po;
击破__擊破 175.948711373|ji po;
吉普__吉普 146.679837233|ji pu;
挤满__擠滿 234.056997396|ji man;
急忙__急忙 977.421145723|ji mang;
鸡毛__雞毛 246.94109417|ji mao;
几门__幾門 147.045868173|ji men;
集美__集美 146.862738669|ji mei;
吉米__吉米 122.584950132|ji mi;
几米__幾米 232.603161479|ji mi;
机密__機密 636.660374558|ji mi;
几秒__幾秒 338.890182508|ji miao;
几名__幾名 698.163048348|ji ming;
寂寞__寂寞 4908.39956546|ji mo;
计谋__計謀 135.604660605|ji mou;
继母__繼母 138.85370659|ji mu;
吉姆__吉姆 143.426288875|ji mu;
积木__積木 169.070402749|ji mu;
继发__繼發 152.647228173|ji fa;
技法__技法 305.589986932|ji fa;
激发__激發 1708.20809643|ji fa;
几番__幾番 191.508436159|ji fan;
己方__己方 110.401782066|ji fang;
机房__機房 2532.56730325|ji fang;
激愤__激憤 110.401782066|ji fen;
计分__計分 112.625137786|ji fen;
记分__記分 123.658956482|ji fen;
几分__幾分 1338.02720458|ji fen;
积分__積分 4652.30490767|ji fen;
季风__季風 155.333728851|ji feng;
讥讽__譏諷 168.229740225|ji feng;
疾风__疾風 174.203334854|ji feng;
计费__計費 1122.41972073|ji fei;
给付__給付 124.742372548|ji fu;
继父__繼父 154.754097942|ji fu;
极富__極富 309.036622663|ji fu;
肌肤__肌膚 3079.85238931|ji fu;
几段__幾段 208.184564378|ji duan;
极端__極端 2001.12208851|ji duan;
吉大__吉大 122.432284019|ji da;
击打__擊打 200.29551561|ji da;
几大__幾大 670.034480971|ji da;
极大__極大 3912.37902339|ji da;
亟待__亟待 300.679263607|ji dai;
几代__幾代 324.83145542|ji dai;
鸡蛋__雞蛋 2735.99686654|ji dan;
激荡__激蕩 233.765505073|ji dang;
挤到__擠到 159.452390871|ji dao;
击倒__擊倒 188.430963124|ji dao;
几道__幾道 209.485777119|ji dao;
寄到__寄到 444.119751258|ji dao;
挤得__擠得 124.587019602|ji de;
基德__基德 147.596627936|ji de;
急得__急得 255.391156791|ji de;
级的__級的 681.82669043|ji de;
记得__記得 20497.4582273|ji de;
基底__基底 121.520271774|ji di;
几滴__幾滴 167.601987591|ji di;
极地__極地 230.008975843|ji di;
极低__極低 312.911829085|ji di;
基地__基地 5051.11880189|ji di;
祭奠__祭奠 247.557321202|ji dian;
基点__基點 282.868455943|ji dian;
积淀__積澱 321.208662461|ji dian;
极点__極點 552.345286903|ji dian;
机电__機電 987.214115061|ji dian;
几点__幾點 6059.03211339|ji dian;
基调__基調 406.006938516|ji diao;
急跌__急跌 123.351140937|ji die;
既定__既定 446.895626023|ji ding;
悸动__悸動 110.815291538|ji dong;
机动__機動 558.574983827|ji dong;
激动__激動 4415.07041785|ji dong;
几度__幾度 290.730764849|ji du;
基督__基督 499.935980841|ji du;
嫉妒__嫉妒 1508.06636321|ji du;
极度__極度 1753.50110433|ji du;
季度__季度 2061.87561868|ji du;
几多__幾多 849.035336524|ji duo;
及对__及對 106.218162376|ji dui;
挤兑__擠兌 123.504952812|ji dui;
集团__集團 15524.2879811|ji tuan;
吉它__吉它 162.258658377|ji ta;
吉他__吉他 1215.60448872|ji ta;
几台__幾台 339.735863102|ji tai;
祭坛__祭壇 212.112652282|ji tan;
鸡汤__雞湯 275.218769535|ji tang;
几套__幾套 296.955549433|ji tao;
肌体__肌體 133.093414711|ji ti;
计提__計提 382.910172354|ji ti;
机体__機體 895.772044085|ji ti;
集体__集體 4920.64818898|ji ti;
吉田__吉田 813.813436628|ji tian;
几天__幾天 12190.4086525|ji tian;
几条__幾條 909.268075561|ji tiao;
机头__機頭 126.464093517|ji tou;
寄托__寄託 905.87512359|ji tuo;
击退__擊退 153.218967809|ji tui;
鸡腿__雞腿 317.230705235|ji tui;
妓女__妓女 1218.6379585|ji nv;
济南__濟南 3068.35985866|ji nan;
既能__既能 536.070335228|ji neng;
机能__機能 1109.90155418|ji neng;
技能__技能 8080.1830536|ji neng;
纪念__紀念 3787.64822853|ji nian;
几年__幾年 5615.51843703|ji nian;
济宁__濟寧 286.415523108|ji ning;
激怒__激怒 299.93080386|ji nu;
几轮__幾輪 122.584950132|ji lun;
机率__機率 408.544597361|ji lv;
纪律__紀律 1276.14264248|ji lv;
几率__幾率 1336.36083843|ji lv;
寄来__寄來 350.92368248|ji lai;
极乐__極樂 124.276893895|ji le;
几类__幾類 154.754097942|ji lei;
基类__基類 162.86639759|ji lei;
鸡肋__雞肋 310.194118206|ji lei;
积累__積累 4107.21887886|ji lei;
机理__機理 597.456727653|ji li;
极力__極力 878.088426229|ji li;
吉利__吉利 985.98464814|ji li;
激励__激勵 2318.11814557|ji li;
级联__級聯 125.36572391|ji lian;
寂寥__寂寥 177.933171406|ji liao;
几辆__幾輛 141.121478992|ji liang;
脊梁__脊樑 203.313241605|ji liang;
伎俩__伎倆 271.133768339|ji liang;
剂量__劑量 673.382717005|ji liang;
计量__計量 967.72532071|ji liang;
激烈__激烈 3811.32210727|ji lie;
吉林__吉林 1409.92327219|ji lin;
机灵__機靈 252.54282031|ji ling;
激流__激流 164.703307075|ji liu;
肌瘤__肌瘤 201.296414343|ji liu;
几楼__幾樓 171.190483873|ji lou;
纪录__紀錄 1845.42065012|ji lu;
记录__記錄 15010.6397905|ji lu;
击落__擊落 162.663565352|ji luo;
籍贯__籍貫 250.037645335|ji guan;
机关__機關 4793.54763754|ji guan;
极光__極光 119.121315407|ji guang;
激光__激光 1474.61550226|ji guang;
技改__技改 271.471856767|ji gai;
极高__極高 884.6784987|ji gao;
及格__及格 803.734894488|ji ge;
几个__幾個 31704.5168551|ji ge;
几根__幾根 303.313611771|ji gen;
寄给__寄給 550.284199441|ji gei;
机构__機構 13998.8326784|ji gou;
技工__技工 210.532600599|ji gong;
记过__記過 185.634130949|ji guo;
机柜__機櫃 385.78392141|ji gui;
几款__幾款 668.366611253|ji kuan;
极快__極快 162.663565352|ji kuai;
几块__幾塊 576.250827814|ji kuai;
机壳__機殼 105.426930997|ji ke;
几颗__幾顆 213.971039752|ji ke;
即刻__即刻 413.152419826|ji ke;
饥渴__饑渴 443.014235191|ji ke;
既可__既可 465.076726846|ji ke;
即可__即可 9163.95030857|ji ke;
几口__幾口 320.808632296|ji kou;
疾苦__疾苦 159.452390871|ji ku;
击溃__擊潰 127.413209251|ji kui;
极化__極化 117.646076559|ji hua;
激化__激化 276.938965124|ji hua;
计划__計劃 23982.3433607|ji hua;
疾患__疾患 190.081867665|ji huan;
饥荒__飢荒 146.314717429|ji huang;
几行__幾行 175.073848088|ji hang;
几好__幾好 237.287502254|ji hao;
极好__極好 503.688011099|ji hao;
几号__幾號 1196.07015327|ji hao;
记号__記號 1387.2663024|ji hao;
稽核__稽核 186.794397067|ji he;
几何__幾何 817.880151926|ji he;
集合__集合 3037.92233395|ji he;
几乎__幾乎 13791.0516163|ji hu;
激活__激活 2773.75968187|ji huo;
寄回__寄回 187.961915178|ji hui;
几回__幾回 302.181790975|ji hui;
忌讳__忌諱 423.578945935|ji hui;
集会__集會 477.408200926|ji hui;
机会__機會 26962.7832126|ji hui;
季军__季軍 195.121873946|ji jun;
几集__幾集 226.595011951|ji ji;
唧唧__唧唧 235.226605969|ji ji;
急急__急急 252.228305921|ji ji;
鸡鸡__雞雞 425.165459331|ji ji;
几级__幾級 522.223615731|ji ji;
积极__積極 12845.4345306|ji ji;
机甲__機甲 112.625137786|ji jia;
机架__機架 211.057972369|ji jia;
计价__計價 298.811606079|ji jia;
极佳__極佳 334.276427588|ji jia;
技嘉__技嘉 412.637883794|ji jia;
几家__幾家 1476.45426414|ji jia;
几间__幾間 108.087539034|ji jian;
纪检__紀檢 235.519920202|ji jian;
基建__基建 392.084582382|ji jian;
几件__幾件 645.447697543|ji jian;
计较__計較 1135.07907503|ji jiao;
即将__即將 5807.67552859|ji jiang;
集结__集結 597.456727653|ji jie;
季节__季節 2941.07014627|ji jie;
几斤__幾斤 137.305093541|ji jin;
挤进__擠進 188.430963124|ji jin;
极尽__極盡 221.845125512|ji jin;
几近__幾近 299.557272934|ji jin;
集锦__集錦 346.577724349|ji jin;
激进__激進 469.736419493|ji jin;
基金__基金 16176.0096356|ji jin;
鸡精__雞精 121.823518492|ji jing;
己经__己經 151.132997772|ji jing;
几经__幾經 270.458854115|ji jing;
寂静__寂靜 670.869975958|ji jing;
急救__急救 777.141921285|ji jiu;
机具__機具 131.773154284|ji ju;
积聚__積聚 327.677408739|ji ju;
集聚__集聚 490.677728407|ji ju;
急剧__急劇 827.104717768|ji ju;
极具__極具 959.320404733|ji ju;
几句__幾句 2289.40978274|ji ju;
几圈__幾圈 169.492308033|ji quan;
集权__集權 177.933171406|ji quan;
集群__集群 638.24912322|ji qun;
记起__記起 395.519762073|ji qi;
激起__激起 682.676889633|ji qi;
极其__極其 2671.97711617|ji qi;
及其__及其 9572.48817433|ji qi;
机器__機器 14732.6596137|ji qi;
寄钱__寄錢 137.305093541|ji qian;
几千__幾千 1366.67546656|ji qian;
技巧__技巧 4205.62658069|ji qiao;
机枪__機槍 265.119670945|ji qiang;
极强__極強 572.671468255|ji qiang;
急切__急切 531.41444163|ji qie;
激情__激情 5362.47571095|ji qing;
击球__擊球 255.709615075|ji qiu;
汲取__汲取 384.823616623|ji qu;
积雪__積雪 322.411748334|ji xue;
集训__集訓 433.187606905|ji xun;
记下__記下 862.9018652|ji xia;
几下__幾下 994.623178167|ji xia;
基线__基線 143.784200776|ji xian;
极限__極限 1557.7283975|ji xian;
讥笑__譏笑 107.550099352|ji xiao;
技校__技校 231.158356006|ji xiao;
极小__極小 232.603161479|ji xiao;
绩效__績效 1346.39025518|ji xiao;
几项__幾項 358.437246895|ji xiang;
吉祥__吉祥 842.710774091|ji xiang;
迹象__跡象 1532.69625148|ji xiang;
机箱__機箱 1786.58668154|ji xiang;
机械__機械 3630.51911858|ji xie;
机芯__機芯 142.357889859|ji xin;
寄信__寄信 145.587202159|ji xin;
剂型__劑型 117.353228453|ji xing;
极性__極性 130.46599058|ji xing;
即兴__即興 271.810366771|ji xing;
记性__記性 594.486015613|ji xing;
畸形__畸形 771.352901218|ji xing;
急性__急性 1413.4416531|ji xing;
机型__機型 2202.653757|ji xing;
吉凶__吉凶 119.41857567|ji xiong;
亟需__亟需 110.264288753|ji xu;
几许__幾許 173.986383704|ji xu;
积蓄__積蓄 787.868200695|ji xu;
急需__急需 1260.33845835|ji xu;
继续__繼續 37700.6109271|ji xu;
基准__基準 634.284663664|ji zhun;
挤占__擠占 117.93965545|ji zhan;
机战__機戰 148.334184528|ji zhan;
激战__激戰 401.478808454|ji zhan;
基站__基站 802.733930815|ji zhan;
记帐__記帳 127.572086295|ji zhang;
机长__機長 138.680779525|ji zhang;
记账__記賬 426.226434824|ji zhang;
几张__幾張 2619.22907324|ji zhang;
几招__幾招 155.140277726|ji zhao;
几折__幾折 107.684208225|ji zhe;
记着__記着 568.405572245|ji zhe;
急着__急着 1092.0658276|ji zhe;
记者__記者 26005.7765312|ji zhe;
集镇__集鎮 195.60878915|ji zhen;
急诊__急診 307.117053725|ji zhen;
几支__幾支 123.351140937|ji zhi;
极至__極至 125.36572391|ji zhi;
及至__及至 128.689786556|ji zhi;
基质__基質 199.796934068|ji zhi;
机智__機智 280.411678639|ji zhi;
极致__極致 668.366611253|ji zhi;
几只__幾隻 700.778015498|ji zhi;
机制__機制 7322.61405337|ji zhi;
几周__幾周 294.009808944|ji zhou;
机种__機種 170.127140854|ji zhong;
击中__擊中 578.409173188|ji zhong;
几种__幾種 1986.21549859|ji zhong;
集中__集中 9986.78610191|ji zhong;
脊柱__脊柱 295.111021611|ji zhu;
记住__記住 4268.99009943|ji zhu;
脊椎__脊椎 200.04606951|ji zhui;
击穿__擊穿 172.690339006|ji chuan;
机床__機床 588.588831574|ji chuang;
极差__極差 191.747236314|ji cha;
稽查__稽查 401.979429753|ji cha;
几场__幾場 335.528458728|ji chang;
机场__機場 4969.94910399|ji chang;
机车__機車 371.627656329|ji che;
即成__即成 233.765505073|ji cheng;
继承__繼承 2263.87636378|ji cheng;
集成__集成 3630.51911858|ji cheng;
鸡翅__雞翅 507.468200425|ji chi;
记仇__記仇 106.483223576|ji chou;
几处__幾處 244.186999878|ji chu;
挤出__擠出 573.385557088|ji chu;
寄出__寄出 606.458230719|ji chu;
基础__基礎 15896.2451492|ji chu;
击杀__擊殺 116.769717326|ji sha;
机上__機上 315.260239073|ji shang;
极少__極少 724.757896749|ji shao;
跻身__躋身 426.757915008|ji shen;
机身__機身 2021.17171332|ji shen;
寄生__寄生 249.104624871|ji sheng;
几声__幾聲 403.48504224|ji sheng;
计生__計生 536.070335228|ji sheng;
纪事__紀事 119.86585751|ji shi;
记事__記事 267.44247003|ji shi;
集市__集市 285.346757867|ji shi;
技师__技師 350.050152834|ji shi;
基石__基石 373.019586361|ji shi;
急事__急事 386.264972075|ji shi;
计时__計時 387.711726118|ji shi;
纪实__紀實 510.640021015|ji shi;
即是__即是 839.566182019|ji shi;
既是__既是 1338.02720458|ji shi;
几时__幾時 1487.53508505|ji shi;
即时__即時 1500.56786049|ji shi;
几十__幾十 4258.36360257|ji shi;
及时__及時 12420.4208866|ji shi;
即使__即使 13603.2960084|ji shi;
棘手__棘手 354.43965395|ji shou;
几首__幾首 429.960742313|ji shou;
奇数__奇數 143.963491517|ji shu;
级数__級數 206.89143407|ji shu;
记述__記述 264.130371602|ji shu;
计数__計數 538.749137684|ji shu;
基数__基數 707.799244422|ji shu;
技术__技術 43401.461331|ji shu;
计税__計稅 125.678566729|ji shui;
积水__積水 373.019586361|ji shui;
既然__既然 8761.92253873|ji ran;
己任__己任 222.398727024|ji ren;
几人__幾人 478.599545119|ji ren;
即日__即日 240.562595233|ji ri;
几日__幾日 614.062995519|ji ri;
鸡肉__雞肉 511.276760152|ji rou;
肌肉__肌肉 2464.07841638|ji rou;
记入__記入 165.526347625|ji ru;
计入__計入 580.575602636|ji ru;
记在__記在 250.661599628|ji zai;
挤在__擠在 299.557272934|ji zai;
即在__即在 313.302012384|ji zai;
记载__記載 1915.71752783|ji zai;
积攒__積攢 275.905561849|ji zan;
急躁__急躁 304.070513117|ji zao;
及早__及早 451.935995467|ji zao;
激增__激增 267.44247003|ji zeng;
集资__集資 429.960742313|ji zi;
机子__機子 2763.40934226|ji zi;
祭祖__祭祖 124.122120652|ji zu;
几组__幾組 137.134095104|ji zu;
机组__機組 894.656458236|ji zu;
寄存__寄存 121.823518492|ji cun;
集采__集采 188.665925845|ji cai;
机舱__機艙 143.0692679|ji cang;
几层__幾層 165.32020271|ji ceng;
基层__基層 3004.04087494|ji ceng;
几次__幾次 5197.98781874|ji ci;
急促__急促 364.745529846|ji cu;
记错__記錯 680.977550057|ji cuo;
计算__計算 10484.1366779|ji suan;
祭司__祭司 150.944778196|ji si;
急死__急死 228.011295226|ji si;
祭祀__祭祀 602.691239054|ji si;
寄送__寄送 220.467143161|ji song;
寄宿__寄宿 124.89791921|ji su;
极速__極速 387.711726118|ji su;
急速__急速 616.362966229|ji su;
激素__激素 949.804135501|ji su;
脊髓__脊髓 203.313241605|ji sui;
几岁__幾歲 754.243296976|ji sui;
机缘__機緣 166.146325956|ji yuan;
妓院__妓院 242.36802267|ji yuan;
集约__集約 185.402943996|ji yue;
几月__幾月 196.586267794|ji yue;
鸡鸭__雞鴨 148.519148841|ji ya;
羁押__羈押 155.140277726|ji ya;
积压__積壓 333.860122955|ji ya;
挤压__擠壓 700.778015498|ji ya;
几眼__幾眼 229.150692759|ji yan;
寄养__寄養 122.127521944|ji yang;
几样__幾樣 204.329220247|ji yang;
纪要__紀要 389.163898974|ji yao;
既要__既要 958.125676369|ji yao;
积液__積液 106.616002115|ji ye;
基业__基業 124.587019602|ji ye;
几页__幾頁 232.893204426|ji ye;
机翼__機翼 128.529517539|ji yi;
几亿__幾億 138.508067822|ji yi;
即以__即以 179.268563673|ji yi;
极易__極易 413.667597456|ji yi;
技艺__技藝 472.083744072|ji yi;
记忆__記憶 6384.60141493|ji yi;
基因__基因 2445.72321123|ji yin;
即有__即有 158.067510349|ji you;
集邮__集郵 191.031727675|ji you;
绩优__績優 220.19257551|ji you;
机油__機油 490.066643104|ji you;
既有__既有 1565.51253772|ji you;
即用__即用 261.184568064|ji yong;
急用__急用 276.594068012|ji yong;
际遇__際遇 134.42690308|ji yu;
觊觎__覬覦 153.792848894|ji yu;
寄语__寄語 168.859844103|ji yu;
鲫鱼__鯽魚 185.172044961|ji yu;
给与__給與 209.485777119|ji yu;
寄予__寄予 310.194118206|ji yu;
急于__急於 824.018360007|ji yu;
机遇__機遇 2315.23118363|ji yu;
给予__給予 4382.1820476|ji yu;
基于__基於 7249.97516601|ji yu;
几万__幾萬 921.81798848|ji wan;
寄望__寄望 110.95347192|ji wang;
既往__既往 116.915322539|ji wang;
继位__繼位 106.882056102|ji wei;
即位__即位 168.439513167|ji wei;
即为__即為 520.274927886|ji wei;
纪委__紀委 540.093554591|ji wei;
几位__幾位 1966.51263254|ji wei;
极为__極為 2186.24593438|ji wei;
既无__既無 142.891090816|ji wu;
吉安__吉安 123.197520618|ji an;
激昂__激昂 206.376433771|ji ang;
饥饿__飢餓 639.044983668|ji e;
吉尔__吉爾 153.984619852|ji er;
继而__繼而 498.070459751|ji er;
假扮__假扮 128.049907079|jia ban;
甲板__甲板 250.037645335|jia ban;
加班__加班 7793.38813678|jia ban;
加倍__加倍 482.191444969|jia bei;
假币__假幣 199.051387821|jia bi;
嘉宾__嘉賓 1910.94886689|jia bin;
佳品__佳品 176.60772663|jia pin;
家谱__家譜 155.72135507|jia pu;
价码__價碼 105.690017726|jia ma;
加码__加碼 107.282382453|jia ma;
加满__加滿 180.164388413|jia man;
假冒__假冒 695.557838999|jia mao;
家们__家們 114.037415895|jia men;
家门__家門 680.129467195|jia men;
加盟__加盟 2577.13898569|jia meng;
佳美__佳美 115.179978568|jia mei;
加密__加密 2143.08680935|jia mi;
假面__假面 134.42690308|jia mian;
假名__假名 111.091824605|jia ming;
贾母__賈母 127.73116145|jia mu;
假发__假髮 173.769702743|jia fa;
加法__加法 181.290467084|jia fa;
家访__家訪 112.906187218|jia fang;
家纺__家紡 164.088713397|jia fang;
甲方__甲方 1884.93262272|jia fang;
加分__加分 768.474582473|jia fen;
夹缝__夾縫 149.820373083|jia feng;
加菲__加菲 114.46454262|jia fei;
钾肥__鉀肥 214.2378495|jia fei;
加大__加大 6096.90278745|jia da;
家当__家當 181.290467084|jia dang;
嫁到__嫁到 129.979154132|jia dao;
加到__加到 554.41409416|jia dao;
家的__家的 1597.0400293|jia de;
家底__家底 156.109948588|jia di;
家店__家店 281.812926654|jia dian;
加点__加點 722.953807881|jia dian;
家电__家電 1676.57400252|jia dian;
家丁__家丁 130.954650472|jia ding;
嘉定__嘉定 340.583654043|jia ding;
假定__假定 491.289575698|jia ding;
加糖__加糖 122.127521944|jia tang;
家庭__家庭 13153.2071934|jia ting;
加纳__加納 205.350275845|jia na;
戛纳__戛納 213.438416689|jia na;
佳能__佳能 1353.11831545|jia neng;
嫁了__嫁了 254.121284766|jia le;
加里__加里 113.47039186|jia li;
佳丽__佳麗 272.149298879|jia li;
家里__家裡 18208.9835463|jia li;
加盖__加蓋 438.073368704|jia gai;
价高__價高 121.975425508|jia gao;
嫁个__嫁個 139.547573842|jia ge;
加个__加個 809.766942109|jia ge;
价格__價格 42438.7608269|jia ge;
嫁给__嫁給 1143.59786783|jia gei;
架构__架構 2615.96711065|jia gou;
加工__加工 4817.50152258|jia gong;
加固__加固 488.237949645|jia gu;
加国__加國 140.419785869|jia guo;
价款__價款 280.761336094|jia kuan;
加快__加快 5969.09946282|jia kuai;
甲亢__甲亢 142.535402072|jia kang;
夹克__夾克 179.492101402|jia ke;
架空__架空 209.224885556|jia kong;
佳话__佳話 130.954650472|jia hua;
嘉华__嘉華 175.729586548|jia hua;
假话__假話 398.985038482|jia hua;
加号__加號 105.690017726|jia hao;
嘉禾__嘉禾 164.908682755|jia he;
加厚__加厚 117.061109314|jia hou;
假货__假貨 612.534451685|jia huo;
家伙__傢伙 4338.71166588|jia huo;
加急__加急 129.171793682|jia ji;
夹击__夾擊 152.457122789|jia ji;
甲级__甲級 179.045304336|jia ji;
甲基__甲基 223.510077937|jia ji;
佳绩__佳績 239.366454718|jia ji;
嘉嘉__嘉嘉 162.258658377|jia jia;
加加__加加 234.933657026|jia jia;
加价__加價 368.85935893|jia jia;
佳佳__佳佳 407.020105042|jia jia;
家家__家家 428.890471272|jia jia;
加减__加減 210.532600599|jia jian;
家教__家教 781.999279332|jia jiao;
嘉奖__嘉獎 153.601316766|jia jiang;
假借__假借 112.484875527|jia jie;
嫁接__嫁接 239.068350048|jia jie;
佳节__佳節 244.491487214|jia jie;
加进__加進 145.768741141|jia jin;
加紧__加緊 636.660374558|jia jin;
嘉靖__嘉靖 146.862738669|jia jing;
加精__加精 200.795341333|jia jing;
家境__家境 434.810109507|jia jing;
夹具__夾具 131.117943492|jia ju;
家驹__家駒 146.862738669|jia ju;
加剧__加劇 1181.25761405|jia ju;
家居__家居 1579.22849881|jia ju;
家具__傢具 2963.1429408|jia ju;
加权__加權 206.376433771|jia quan;
甲醛__甲醛 493.744603771|jia quan;
架起__架起 216.924313917|jia qi;
假期__假期 2681.98499671|jia qi;
加钱__加錢 271.133768339|jia qian;
价钱__價錢 3298.34499764|jia qian;
加强__加強 15104.4605586|jia qiang;
家禽__家禽 334.69325133|jia qin;
嘉庆__嘉慶 111.925571131|jia qing;
家去__家去 114.037415895|jia qu;
加血__加血 914.951259653|jia xue;
加息__加息 1808.98982626|jia xi;
驾校__駕校 555.105417084|jia xiao;
假想__假想 143.0692679|jia xiang;
假象__假象 362.028498203|jia xiang;
家乡__家鄉 2819.06099798|jia xiang;
加些__加些 107.416157498|jia xie;
加薪__加薪 410.07479966|jia xin;
嘉兴__嘉興 713.111292931|jia xing;
家庄__家莊 136.112567367|jia zhuang;
嫁妆__嫁妝 179.045304336|jia zhuang;
加装__加裝 328.904723278|jia zhuang;
家装__家裝 578.409173188|jia zhuang;
假装__假裝 1075.85657625|jia zhuang;
家长__家長 5594.56401791|jia zhang;
驾照__駕照 833.312156414|jia zhao;
夹着__夾着 295.847453874|jia zhe;
家政__家政 271.133768339|jia zheng;
加之__加之 1055.93292173|jia zhi;
价值__價值 13894.5537545|jia zhi;
加州__加州 600.442284667|jia zhou;
加重__加重 1348.06912745|jia zhong;
家中__家中 2323.90287358|jia zhong;
加注__加註 127.73116145|jia zhu;
夹住__夾住 136.963309627|jia zhu;
家住__家住 700.778015498|jia zhu;
甲醇__甲醇 302.558594526|jia chun;
价差__價差 265.78126155|jia cha;
家产__家產 239.366454718|jia chan;
加长__加長 268.778909483|jia chang;
家常__家常 272.488653616|jia chang;
假钞__假鈔 110.815291538|jia chao;
驾车__駕車 723.855290267|jia che;
加成__加成 260.209952636|jia cheng;
加持__加持 114.037415895|jia chi;
甲虫__甲蟲 138.163289429|jia chong;
家畜__家畜 159.055477247|jia chu;
加沙__加沙 202.302314677|jia sha;
嘉善__嘉善 108.627664361|jia shan;
假山__假山 117.061109314|jia shan;
架上__架上 169.915266157|jia shang;
加上__加上 10602.3833536|jia shang;
架设__架設 449.128812644|jia she;
假设__假設 2370.70341112|jia she;
加深__加深 974.988119996|jia shen;
家世__家世 109.579386421|jia shi;
假使__假使 149.633788238|jia shi;
家事__家事 230.008975843|jia shi;
架势__架勢 341.433560596|jia shi;
嘉实__嘉實 367.482952871|jia shi;
驾驶__駕駛 2208.15035039|jia shi;
加收__加收 179.492101402|jia shou;
家数__家數 118.972962872|jia shu;
家属__家屬 2219.18472069|jia shu;
假说__假說 132.927661458|jia shuo;
加水__加水 399.482550191|jia shui;
加热__加熱 1040.25998178|jia re;
佳人__佳人 504.944935018|jia ren;
嫁人__嫁人 633.494731672|jia ren;
家人__家人 5998.9277097|jia ren;
假日__假日 748.624851411|jia ri;
假如__假如 3327.2428637|jia ru;
加入__加入 13251.9222955|jia ru;
假若__假若 208.964318904|jia ruo;
夹杂__夾雜 494.9767145|jia za;
加在__加在 226.312812713|jia zai;
夹在__夾在 301.054193591|jia zai;
加载__加載 1619.08271818|jia zai;
甲子__甲子 140.945727665|jia zi;
夹子__夾子 260.209952636|jia zi;
架子__架子 822.992135502|jia zi;
家族__家族 3462.60542812|jia zu;
佳作__佳作 336.365750338|jia zuo;
家村__家村 132.431639237|jia cun;
夹层__夾層 156.89004718|jia ceng;
加粗__加粗 119.86585751|jia cu;
家私__家私 154.754097942|jia si;
假死__假死 294.743493195|jia si;
加速__加速 3849.50847217|jia su;
枷锁__枷鎖 214.504991945|jia suo;
嘉园__嘉園 117.353228453|jia yuan;
佳缘__佳緣 134.259489114|jia yuan;
加元__加元 179.045304336|jia yuan;
家园__家園 2036.34065037|jia yuan;
假牙__假牙 109.170488754|jia ya;
加压__加壓 232.313479749|jia ya;
加盐__加鹽 105.690017726|jia yan;
家养__家養 122.890853693|jia yang;
假药__假藥 192.465424888|jia yao;
佳肴__佳肴 229.436430673|jia yao;
嫁衣__嫁衣 123.351140937|jia yi;
加一__加一 126.779677253|jia yi;
甲乙__甲乙 236.107646363|jia yi;
加以__加以 2749.66894397|jia yi;
佳音__佳音 134.092283643|jia yin;
家有__家有 313.302012384|jia you;
加油__加油 8642.63503704|jia you;
家用__家用 1036.37823089|jia yong;
甲鱼__甲魚 173.337150041|jia yu;
驾驭__駕馭 516.399339766|jia yu;
甲烷__甲烷 145.768741141|jia wan;
加温__加溫 132.10198647|jia wen;
价为__價為 106.483223576|jia wei;
加为__加為 139.200207879|jia wei;
价位__價位 2580.3525318|jia wei;
加我__加我 966.520124945|jia wo;
家务__家務 578.409173188|jia wu;
减半__減半 261.510250403|jian ban;
肩膀__肩膀 2041.42221915|jian bang;
见报__見報 107.282382453|jian bao;
简报__簡報 381.957020988|jian bao;
兼备__兼備 204.329220247|jian bei;
渐变__漸變 257.62872122|jian bian;
简便__簡便 555.105417084|jian bian;
鉴别__鑒別 731.107734818|jian bie;
煎饼__煎餅 218.280152578|jian bing;
兼并__兼并 392.573489614|jian bing;
肩部__肩部 172.260473089|jian bu;
减排__減排 694.691597986|jian pai;
键盘__鍵盤 4629.17242366|jian pan;
健脾__健脾 215.576896995|jian pi;
建平__建平 193.427195796|jian ping;
简朴__簡樸 156.109948588|jian pu;
贱卖__賤賣 162.460985719|jian mai;
减慢__減慢 214.772467501|jian man;
健美__健美 365.20034683|jian mei;
减免__減免 659.267263146|jian mian;
见面__見面 5865.86374011|jian mian;
歼灭__殲滅 188.196293023|jian mie;
建明__建明 118.676811842|jian ming;
简明__簡明 230.870473623|jian ming;
缄默__緘默 111.091824605|jian mo;
建模__建模 743.048258297|jian mo;
减法__減法 110.401782066|jian fa;
剑法__劍法 187.4940348|jian fa;
简繁__簡繁 119.86585751|jian fan;
检方__檢方 143.605133321|jian fang;
间房__間房 144.143005824|jian fang;
建房__建房 365.20034683|jian fang;
尖峰__尖峰 119.121315407|jian feng;
剑锋__劍鋒 121.671800659|jian feng;
减肥__減肥 4051.3019409|jian fei;
减负__減負 166.560934377|jian fu;
肩负__肩負 462.764242999|jian fu;
剪断__剪斷 143.426288875|jian duan;
尖端__尖端 338.468131949|jian duan;
简短__簡短 542.11647303|jian duan;
间断__間斷 546.866130582|jian duan;
肩带__肩帶 106.616002115|jian dai;
煎蛋__煎蛋 130.791560815|jian dan;
简单__簡單 22254.5810512|jian dan;
减到__減到 135.773751924|jian dao;
尖刀__尖刀 141.121478992|jian dao;
捡到__撿到 519.626982517|jian dao;
剪刀__剪刀 581.299547476|jian dao;
见到__見到 8588.95164633|jian dao;
兼得__兼得 154.176629937|jian de;
见得__見得 317.626273928|jian de;
间的__間的 1733.94458864|jian de;
见地__見地 141.121478992|jian di;
见底__見底 257.62872122|jian di;
减低__減低 360.228397261|jian di;
检点__檢點 127.890434962|jian dian;
减掉__減掉 174.855812809|jian diao;
剪掉__剪掉 219.097720093|jian diao;
间谍__間諜 714.000502259|jian die;
见顶__見頂 143.963491517|jian ding;
检定__檢定 168.020228531|jian ding;
坚定__堅定 2448.77288933|jian ding;
鉴定__鑒定 3497.29793394|jian ding;
监督__監督 5443.2687447|jian du;
舰队__艦隊 719.359091341|jian dui;
践踏__踐踏 436.438689186|jian ta;
检讨__檢討 775.207436548|jian tao;
简体__簡體 733.846096172|jian ti;
舰艇__艦艇 240.263000901|jian ting;
坚挺__堅挺 420.94790182|jian ting;
监听__監聽 494.9767145|jian ting;
肩头__肩頭 263.144763849|jian tou;
箭头__箭頭 584.932834985|jian tou;
减退__減退 333.029068427|jian tui;
艰难__艱難 2244.21407924|jian nan;
见你__見你 655.989212862|jian ni;
简略__簡略 124.742372548|jian lue;
剪了__剪了 181.064689688|jian le;
监理__監理 891.318029807|jian li;
简历__簡歷 4963.75957739|jian li;
建立__建立 23362.8784144|jian li;
简练__簡練 159.253810404|jian lian;
见谅__見諒 436.438689186|jian liang;
简陋__簡陋 534.735933039|jian lou;
监管__監管 4132.89016505|jian guan;
见怪__見怪 118.381397999|jian guai;
间隔__間隔 1027.37704867|jian ge;
建构__建構 439.166555128|jian gou;
监工__監工 116.915322539|jian gong;
建功__建功 118.381397999|jian gong;
建工__建工 166.353500999|jian gong;
荐股__薦股 119.56748386|jian gu;
坚固__堅固 553.034030141|jian gu;
兼顾__兼顧 827.104717768|jian gu;
坚果__堅果 116.333988795|jian guo;
建国__建國 752.365812175|jian guo;
见过__見過 5566.7463737|jian guo;
见鬼__見鬼 418.333200332|jian gui;
健康__健康 11354.5435549|jian kang;
监考__監考 417.291872914|jian kao;
剑客__劍客 350.486645516|jian ke;
监控__監控 4221.3787397|jian kong;
艰苦__艱苦 1261.91002891|jian ku;
建华__建華 233.183609039|jian hua;
简化__簡化 1346.39025518|jian hua;
减缓__減緩 441.911471008|jian huan;
建行__建行 1822.5663337|jian hang;
见好__見好 118.08671951|jian hao;
建好__建好 311.744192349|jian hao;
监护__監護 262.489736092|jian hu;
间或__間或 138.163289429|jian huo;
贱货__賤貨 174.855812809|jian huo;
坚决__堅決 3936.83250507|jian jue;
建军__建軍 260.209952636|jian jun;
剪辑__剪輯 511.914293268|jian ji;
尖尖__尖尖 168.229740225|jian jian;
贱贱__賤賤 181.969489867|jian jian;
见见__見見 542.11647303|jian jian;
渐渐__漸漸 4086.79670599|jian jian;
建交__建交 194.393772779|jian jiao;
尖叫__尖叫 697.293562832|jian jiao;
见解__見解 971.349932368|jian jie;
简洁__簡潔 1406.41364933|jian jie;
间接__間接 2153.79604997|jian jie;
简介__簡介 3026.58626614|jian jie;
监禁__監禁 199.051387821|jian jin;
渐进__漸進 236.107646363|jian jin;
检举__檢舉 229.722524886|jian ju;
兼具__兼具 267.44247003|jian ju;
间距__間距 418.854838101|jian ju;
艰巨__艱巨 522.874798954|jian ju;
健全__健全 1937.32419285|jian quan;
捡起__撿起 275.218769535|jian qi;
建起__建起 347.875829952|jian qi;
剑桥__劍橋 326.048110451|jian qiao;
坚强__堅強 2930.09548433|jian qiang;
剪切__剪切 330.136634719|jian qie;
减轻__減輕 2361.85708402|jian qing;
渐趋__漸趨 112.065135969|jian qu;
减去__減去 476.813641365|jian qu;
简讯__簡訊 137.647730357|jian xun;
减息__減息 116.624293448|jian xi;
见习__見習 419.900065808|jian xi;
间隙__間隙 621.763121294|jian xi;
剑侠__劍俠 178.155043976|jian xia;
艰险__艱險 106.218162376|jian xian;
奸笑__奸笑 116.18910757|jian xiao;
建校__建校 121.975425508|jian xiao;
见笑__見笑 216.11485651|jian xiao;
见效__見效 441.361118731|jian xiao;
减小__減小 807.751246202|jian xiao;
简写__簡寫 164.088713397|jian xie;
间歇__間歇 184.02185602|jian xie;
建新__建新 147.229226029|jian xin;
艰辛__艱辛 931.053859154|jian xin;
坚信__堅信 983.530305889|jian xin;
渐行__漸行 179.940013424|jian xing;
践行__踐行 248.484546245|jian xing;
碱性__鹼性 322.010219858|jian xing;
检修__檢修 590.793388895|jian xiu;
见状__見狀 234.64107292|jian zhuang;
健壮__健壯 307.883446338|jian zhuang;
奸诈__奸詐 128.850255419|jian zha;
建站__建站 412.12398856|jian zhan;
见长__見長 113.753550575|jian zhang;
简章__簡章 129.494134325|jian zhang;
见着__見着 165.32020271|jian zhe;
减震__減震 130.303509496|jian zhen;
鉴证__鑒證 131.281440129|jian zheng;
见证__見證 1252.50991514|jian zheng;
建制__建制 188.430963124|jian zhi;
剪纸__剪紙 199.051387821|jian zhi;
监制__監製 296.955549433|jian zhi;
键值__鍵值 301.805456692|jian zhi;
兼职__兼職 2739.40849942|jian zhi;
简直__簡直 5742.90345783|jian zhi;
见诸__見諸 133.259374649|jian zhu;
建筑__建築 7544.92665307|jian zhu;
舰船__艦船 128.209578049|jian chuan;
检察__檢察 423.578945935|jian cha;
监察__監察 755.18379558|jian cha;
检查__檢查 15621.3191965|jian cha;
减产__減產 295.847453874|jian chan;
见长__見長 108.898738333|jian chang;
建厂__建廠 211.057972369|jian chang;
坚称__堅稱 107.015331962|jian cheng;
渐成__漸成 115.899886195|jian cheng;
简称__簡稱 1306.71862793|jian cheng;
建成__建成 3343.86946243|jian cheng;
减持__減持 639.84183651|jian chi;
坚持__堅持 14954.6272886|jian chi;
检出__檢出 296.955549433|jian chu;
奸商__奸商 352.677286738|jian shang;
鉴赏__鑒賞 383.865702254|jian shang;
肩上__肩上 558.574983827|jian shang;
减少__減少 11482.6072259|jian shao;
建设__建設 23016.1092372|jian she;
健身__健身 1721.02823483|jian shen;
剑圣__劍聖 215.845709156|jian sheng;
检视__檢視 135.773751924|jian shi;
剑士__劍士 171.617679695|jian shi;
监事__監事 234.933657026|jian shi;
件事__件事 806.745280603|jian shi;
坚实__堅實 1010.8674618|jian shi;
监视__監視 1276.14264248|jian shi;
见识__見識 1380.36844936|jian shi;
坚守__堅守 748.624851411|jian shou;
剑术__劍術 105.953760973|jian shu;
件数__件數 116.47905068|jian shu;
键鼠__鍵鼠 126.779677253|jian shu;
建树__建樹 187.961915178|jian shu;
简述__簡述 274.191785204|jian shu;
减税__減稅 158.659551632|jian shui;
坚韧__堅韌 388.679238014|jian ren;
见人__見人 475.626742696|jian ren;
兼任__兼任 528.113581536|jian ren;
贱人__賤人 1498.69906777|jian ren;
兼容__兼容 1723.1742594|jian rong;
键入__鍵入 289.645897197|jian ru;
减弱__減弱 791.805264794|jian ruo;
尖锐__尖銳 671.706512759|jian rui;
健在__健在 156.304608838|jian zai;
减灾__減災 215.30841961|jian zai;
建在__建在 255.073095111|jian zai;
建造__建造 1619.08271818|jian zao;
剪彩__剪綵 133.093414711|jian cai;
剪裁__剪裁 209.485777119|jian cai;
建材__建材 913.811788194|jian cai;
减仓__減倉 524.179602378|jian cang;
建仓__建倉 756.125466931|jian cang;
监测__監測 3045.50329114|jian ce;
检测__檢測 6488.8753536|jian ce;
减速__減速 579.130416613|jian su;
检索__檢索 1376.93239525|jian suo;
渐远__漸遠 175.510734618|jian yuan;
检阅__檢閱 150.944778196|jian yue;
简约__簡約 624.091932797|jian yue;
减压__減壓 291.819695868|jian ya;
检验__檢驗 3377.37232991|jian yan;
简要__簡要 611.771607197|jian yao;
建业__建業 201.296414343|jian ye;
坚毅__堅毅 207.666345181|jian yi;
检疫__檢疫 434.810109507|jian yi;
简易__簡易 762.750126416|jian yi;
建议__建議 24252.8312859|jian yi;
奸淫__姦淫 111.091824605|jian yin;
剪影__剪影 133.591915611|jian ying;
坚硬__堅硬 502.434215952|jian ying;
兼有__兼有 189.845141544|jian you;
建有__建有 246.326401069|jian you;
建于__建於 209.485777119|jian yu;
见于__見於 282.516174301|jian yu;
鉴于__鑒於 1470.94484558|jian yu;
监狱__監獄 1947.00521503|jian yu;
见外__見外 110.539446825|jian wai;
健忘__健忘 197.076837307|jian wang;
见闻__見聞 249.104624871|jian wen;
键位__鍵位 113.32907693|jian wei;
建委__建委 193.668388536|jian wei;
建安__建安 179.268563673|jian an;
煎熬__煎熬 627.992684885|jian ao;
健儿__健兒 169.703655326|jian er;
交办__交辦 175.948711373|jiao ban;
叫板__叫板 196.341441156|jiao ban;
搅拌__攪拌 683.528148986|jiao ban;
脚本__腳本 2535.725271|jiao ben;
脚边__腳邊 108.763116896|jiao bian;
狡辩__狡辯 270.458854115|jiao bian;
胶布__膠布 123.197520618|jiao bu;
脚步__腳步 1639.38542435|jiao bu;
教派__教派 163.680258901|jiao pai;
交配__交配 263.144763849|jiao pei;
胶片__膠片 573.385557088|jiao pian;
叫卖__叫賣 222.953710017|jiao mai;
较慢__較慢 274.191785204|jiao man;
娇媚__嬌媚 117.207077876|jiao mei;
角膜__角膜 315.653350706|jiao mo;
酵母__酵母 458.173712968|jiao mu;
教法__教法 124.587019602|jiao fa;
叫法__叫法 210.008536601|jiao fa;
交房__交房 371.164834837|jiao fang;
交锋__交鋒 415.734739962|jiao feng;
交费__交費 400.479435488|jiao fei;
缴费__繳費 1300.22127911|jiao fei;
教辅__教輔 116.915322539|jiao fu;
教父__教父 343.139741671|jiao fu;
交付__交付 1090.70577937|jiao fu;
较短__較短 323.216307961|jiao duan;
交大__交大 1012.12795618|jiao da;
较大__較大 5829.42815609|jiao da;
胶带__膠帶 270.458854115|jiao dai;
交待__交待 726.566487616|jiao dai;
交代__交代 1593.06462986|jiao dai;
叫到__叫到 192.945711079|jiao dao;
交道__交道 275.561951728|jiao dao;
叫道__叫道 402.982545867|jiao dao;
交到__交到 427.82286438|jiao dao;
教导__教導 847.977956119|jiao dao;
叫得__叫得 190.081867665|jiao de;
脚底__腳底 205.094534596|jiao di;
较低__較低 2424.48154518|jiao di;
交点__交點 146.497163581|jiao dian;
焦点__焦點 2948.4094145|jiao dian;
搅动__攪動 131.773154284|jiao dong;
角度__角度 8090.25858348|jiao du;
较多__較多 2545.22282076|jiao duo;
校对__校對 373.019586361|jiao dui;
脚踏__腳踏 203.313241605|jiao ta;
教他__教他 214.772467501|jiao ta;
焦炭__焦炭 216.384339476|jiao tan;
交谈__交談 1284.11889697|jiao tan;
教堂__教堂 1104.38283164|jiao tang;
脚踢__腳踢 133.42554153|jiao ti;
交替__交替 599.694499646|jiao ti;
教条__教條 203.566761683|jiao tiao;
叫停__叫停 319.213487372|jiao ting;
交投__交投 132.10198647|jiao tou;
交通__交通 6694.2127778|jiao tong;
教徒__教徒 231.158356006|jiao tu;
交纳__交納 838.520594407|jiao na;
缴纳__繳納 2043.96775685|jiao na;
较难__較難 183.792676978|jiao nan;
胶囊__膠囊 836.433324055|jiao nang;
娇嫩__嬌嫩 189.845141544|jiao nen;
教你__教你 1613.0410787|jiao ni;
焦虑__焦慮 904.746955463|jiao lv;
叫了__叫了 556.490650127|jiao le;
教练__教練 3134.05596467|jiao lian;
较量__較量 726.566487616|jiao liang;
交流__交流 13929.2267993|jiao liu;
蛟龙__蛟龍 110.126966673|jiao long;
角落__角落 1716.74420026|jiao luo;
浇灌__澆灌 167.810977762|jiao guan;
交管__交管 195.365179853|jiao guan;
教官__教官 379.111778956|jiao guan;
教改__教改 114.893269147|jiao gai;
较高__較高 4382.1820476|jiao gao;
叫个__叫個 117.207077876|jiao ge;
交个__交個 298.06779536|jiao ge;
交割__交割 359.779772295|jiao ge;
脚跟__腳跟 276.249600432|jiao gen;
教给__教給 233.765505073|jiao gei;
交给__交給 3567.72920071|jiao gei;
教工__教工 124.431860131|jiao gong;
交过__交過 138.163289429|jiao guo;
教过__教過 204.07475061|jiao guo;
缴款__繳款 107.015331962|jiao kuan;
交款__交款 109.852835359|jiao kuan;
较快__較快 1077.19810837|jiao kuai;
焦化__焦化 127.73116145|jiao hua;
浇花__澆花 134.092283643|jiao hua;
教化__教化 212.377144726|jiao hua;
狡猾__狡猾 527.455873984|jiao hua;
叫唤__叫喚 239.366454718|jiao huan;
交换__交換 3554.41614799|jiao huan;
教皇__教皇 203.313241605|jiao huang;
脚踝__腳踝 248.175085992|jiao huai;
叫喊__叫喊 217.736803143|jiao han;
交行__交行 566.284555508|jiao hang;
叫好__叫好 398.48814637|jiao hao;
较好__較好 1740.43907177|jiao hao;
交互__交互 1085.28250327|jiao hu;
搅和__攪和 111.230349808|jiao huo;
交火__交火 130.954650472|jiao huo;
缴获__繳獲 179.940013424|jiao huo;
交货__交貨 729.287839744|jiao huo;
交会__交會 162.258658377|jiao hui;
交汇__交匯 213.971039752|jiao hui;
教诲__教誨 249.415244207|jiao hui;
教会__教會 1212.57856995|jiao hui;
胶卷__膠捲 275.905561849|jiao juan;
交集__交集 249.104624871|jiao ji;
交际__交際 555.797602048|jiao ji;
焦急__焦急 614.062995519|jiao ji;
脚架__腳架 121.066816454|jiao jia;
矫健__矯健 105.164499152|jiao jian;
脚尖__腳尖 219.918349804|jiao jian;
觉觉__覺覺 113.47039186|jiao jiao;
娇娇__嬌嬌 199.299593609|jiao jiao;
教教__教教 448.010827873|jiao jiao;
皎洁__皎潔 109.442917312|jiao jie;
交界__交界 300.304800557|jiao jie;
交接__交接 1054.61787307|jiao jie;
较近__較近 132.596773978|jiao jin;
较劲__較勁 235.519920202|jiao jin;
交警__交警 1260.33845835|jiao jing;
焦距__焦距 336.365750338|jiao ju;
娇妻__嬌妻 106.748946222|jiao qi;
脚气__腳氣 132.266710153|jiao qi;
娇气__嬌氣 142.357889859|jiao qi;
交钱__交錢 852.21539528|jiao qian;
较强__較強 1149.31255222|jiao qiang;
较轻__較輕 211.848489234|jiao qing;
交情__交情 244.186999878|jiao qing;
矫情__矯情 287.130256264|jiao qing;
角球__角球 282.164331387|jiao qiu;
郊区__郊區 1063.85772095|jiao qu;
教学__教學 6188.76096997|jiao xue;
教训__教訓 2275.1892031|jiao xun;
脚下__腳下 1333.03432936|jiao xia;
娇小__嬌小 238.176261728|jiao xiao;
叫嚣__叫囂 370.240920313|jiao xiao;
较小__較小 1359.87999657|jiao xiao;
交响__交響 134.092283643|jiao xiang;
交心__交心 116.333988795|jiao xin;
叫醒__叫醒 294.009808944|jiao xing;
侥幸__僥倖 387.22887368|jiao xing;
娇羞__嬌羞 119.56748386|jiao xiu;
校准__校準 213.971039752|jiao zhun;
狡诈__狡詐 117.061109314|jiao zha;
交战__交戰 292.54791482|jiao zhan;
脚掌__腳掌 121.217779906|jiao zhang;
叫着__叫着 407.527636023|jiao zhe;
较真__較真 250.037645335|jiao zhen;
校正__校正 381.481335404|jiao zheng;
矫正__矯正 438.619621343|jiao zheng;
胶质__膠質 115.179978568|jiao zhi;
角质__角質 208.184564378|jiao zhi;
较之__較之 273.509258874|jiao zhi;
脚趾__腳趾 329.725485744|jiao zhi;
交织__交織 483.394725468|jiao zhi;
较重__較重 312.911829085|jiao zhong;
浇筑__澆築 118.08671951|jiao zhu;
叫住__叫住 156.499511818|jiao zhu;
教主__教主 690.376548199|jiao zhu;
叫床__叫床 155.915530766|jiao chuang;
较差__較差 759.903909096|jiao cha;
交叉__交叉 1383.81307795|jiao cha;
交差__交差 134.092283643|jiao chai;
较长__較長 920.669965262|jiao chang;
轿车__轎車 2535.725271|jiao che;
教程__教程 2678.64487851|jiao cheng;
交出__交出 348.743933702|jiao chu;
叫啥__叫啥 209.746993999|jiao sha;
交上__交上 187.027319083|jiao shang;
叫上__叫上 382.910172354|jiao shang;
脚上__腳上 426.757915008|jiao shang;
较少__較少 1344.71347376|jiao shao;
交涉__交涉 488.846754671|jiao she;
较深__較深 220.742053181|jiao shen;
叫声__叫聲 564.171453387|jiao sheng;
礁石__礁石 115.899886195|jiao shi;
教室__教室 2379.58287209|jiao shi;
教师__教師 9418.66166506|jiao shi;
交手__交手 263.801426189|jiao shou;
教授__教授 8707.49819835|jiao shou;
教书__教書 517.043260448|jiao shu;
交税__交稅 224.626982392|jiao shui;
胶水__膠水 284.281980745|jiao shui;
缴税__繳稅 291.456266438|jiao shui;
浇水__澆水 396.506758465|jiao shui;
叫嚷__叫嚷 114.75018218|jiao rang;
骄人__驕人 177.269210225|jiao ren;
教人__教人 224.347234118|jiao ren;
叫人__叫人 926.424414408|jiao ren;
交融__交融 276.249600432|jiao rong;
较弱__較弱 381.481335404|jiao ruo;
焦躁__焦躁 133.259374649|jiao zao;
较早__較早 415.216987933|jiao zao;
轿子__轎子 106.085879302|jiao zi;
饺子__餃子 976.203874871|jiao zi;
焦作__焦作 219.37092252|jiao zuo;
叫作__叫作 237.879639313|jiao zuo;
叫做__叫做 3213.14860644|jiao zuo;
缴存__繳存 180.839193473|jiao cun;
脚踩__腳踩 158.659551632|jiao cai;
教材__教材 3079.85238931|jiao cai;
交错__交錯 436.982903472|jiao cuo;
角色__角色 1143.59786783|jiao se;
教唆__教唆 187.727829225|jiao suo;
胶原__膠原 127.413209251|jiao yuan;
较远__較遠 204.329220247|jiao yuan;
教员__教員 246.019628549|jiao yuan;
脚丫__腳丫 149.447435764|jiao ya;
娇艳__嬌艷 180.164388413|jiao yan;
教研__教研 286.415523108|jiao yan;
校验__校驗 574.10053635|jiao yan;
骄阳__驕陽 127.254530072|jiao yang;
教养__教養 349.178797604|jiao yang;
较易__較易 115.179978568|jiao yi;
交椅__交椅 126.464093517|jiao yi;
教义__教義 204.07475061|jiao yi;
交易__交易 13552.5350378|jiao yi;
脚印__腳印 593.745648473|jiao yin;
郊游__郊遊 178.822323044|jiao you;
交由__交由 350.486645516|jiao you;
交友__交友 1190.12297778|jiao you;
教育__教育 17716.5531921|jiao yu;
郊外__郊外 328.086003878|jiao wai;
较晚__較晚 175.948711373|jiao wan;
交往__交往 2712.23410734|jiao wang;
教委__教委 233.474375771|jiao wei;
较为__較為 3331.3917468|jiao wei;
教我__教我 728.379591714|jiao wo;
叫我__叫我 3497.29793394|jiao wo;
教务__教務 164.498187167|jiao wu;
教案__教案 426.757915008|jiao an;
骄傲__驕傲 2445.72321123|jiao ao;
将把__將把 281.111429553|jiang ba;
奖杯__獎盃 349.178797604|jiang bei;
江北__江北 443.56664881|jiang bei;
将被__將被 1193.09285994|jiang bei;
将比__將比 129.979154132|jiang bi;
江边__江邊 346.577724349|jiang bian;
奖牌__獎牌 377.697115787|jiang pai;
奖品__獎品 1038.96445205|jiang pin;
江门__江門 508.100984482|jiang men;
江面__江面 119.56748386|jiang mian;
江民__江民 316.441045148|jiang min;
降幅__降幅 340.15949445|jiang fu;
将达__將達 314.867617017|jiang da;
讲到__講到 696.425160166|jiang dao;
降到__降到 905.87512359|jiang dao;
讲得__講得 423.051424808|jiang de;
讲的__講的 813.813436628|jiang de;
降低__降低 9221.22760447|jiang di;
江东__江東 311.744192349|jiang dong;
将对__將對 1004.58849796|jiang dui;
将她__將她 414.699880708|jiang ta;
将他__將他 542.11647303|jiang ta;
将它__將它 746.761352211|jiang ta;
讲台__講台 410.586139672|jiang tai;
讲坛__講壇 189.136730609|jiang tan;
讲堂__講堂 112.34478795|jiang tang;
江南__江南 2742.82438642|jiang nan;
江宁__江寧 266.776744296|jiang ning;
将来__將來 6142.66017363|jiang lai;
讲理__講理 266.112675706|jiang li;
奖励__獎勵 5750.06453265|jiang li;
降临__降臨 814.828215816|jiang lin;
江陵__江陵 107.550099352|jiang ling;
江铃__江鈴 128.049907079|jiang ling;
将领__將領 440.811451858|jiang ling;
江流__江流 314.867617017|jiang liu;
降落__降落 494.9767145|jiang luo;
将该__將該 320.409100324|jiang gai;
讲稿__講稿 110.815291538|jiang gao;
讲给__講給 136.282292017|jiang gei;
将给__將給 270.122027271|jiang gei;
讲过__講過 595.969520633|jiang guo;
讲课__講課 872.634214191|jiang ke;
僵化__僵化 208.44415872|jiang hua;
讲话__講話 3844.71433151|jiang hua;
江淮__江淮 263.472890441|jiang huai;
江海__江海 479.196331601|jiang hai;
江汉__江漢 113.895394799|jiang han;
江河__江河 405.501301397|jiang he;
浆糊__漿糊 179.492101402|jiang hu;
江湖__江湖 3060.72200622|jiang hu;
将会__將會 6440.53897049|jiang hui;
将军__將軍 2586.79165036|jiang jun;
降级__降級 476.813641365|jiang ji;
讲价__講價 193.668388536|jiang jia;
降价__降價 3126.25457954|jiang jia;
将建__將建 147.596627936|jiang jian;
讲讲__講講 699.905273328|jiang jiang;
降解__降解 276.594068012|jiang jie;
讲解__講解 1731.7851508|jiang jie;
将近__將近 1749.13623734|jiang jin;
奖金__獎金 2981.66342698|jiang jin;
将就__將就 429.960742313|jiang jiu;
讲究__講究 2379.58287209|jiang jiu;
僵局__僵局 219.918349804|jiang ju;
奖券__獎券 127.572086295|jiang quan;
讲起__講起 215.845709156|jiang qi;
将其__將其 3479.90844849|jiang qi;
江青__江青 328.904723278|jiang qing;
讲求__講求 267.44247003|jiang qiu;
将球__將球 470.908619205|jiang qiu;
降雪__降雪 114.179614083|jiang xue;
讲学__講學 180.839193473|jiang xue;
降息__降息 426.757915008|jiang xi;
江西__江西 2729.18634194|jiang xi;
降下__降下 190.318888971|jiang xia;
将向__將向 359.331706043|jiang xiang;
奖项__獎項 1074.51671486|jiang xiang;
奖状__獎狀 157.870654598|jiang zhuang;
奖章__獎章 167.601987591|jiang zhang;
江浙__江浙 290.0070692|jiang zhe;
将之__將之 183.563783354|jiang zhi;
将至__將至 239.963779681|jiang zhi;
降至__降至 564.874943184|jiang zhi;
江中__江中 120.46484039|jiang zhong;
江城__江城 169.28122395|jiang cheng;
将成__將成 182.423584067|jiang cheng;
奖惩__獎懲 257.3078729|jiang cheng;
僵持__僵持 186.794397067|jiang chi;
讲出__講出 140.945727665|jiang chu;
江山__江山 758.012333731|jiang shan;
江上__江上 135.604660605|jiang shang;
奖赏__獎賞 145.768741141|jiang shang;
降生__降生 161.451865638|jiang sheng;
将士__將士 329.725485744|jiang shi;
讲师__講師 671.706512759|jiang shi;
将使__將使 680.977550057|jiang shi;
僵尸__殭屍 687.800394331|jiang shi;
将是__將是 1655.81074036|jiang shi;
将手__將手 128.369448119|jiang shou;
讲授__講授 337.625607028|jiang shou;
讲述__講述 2577.13898569|jiang shu;
降水__降水 371.627656329|jiang shui;
江水__江水 407.020105042|jiang shui;
将在__將在 4698.91724004|jiang zai;
降噪__降噪 141.29744947|jiang zao;
酱紫__醬紫 457.603107852|jiang zi;
讲座__講座 1740.43907177|jiang zuo;
将此__將此 412.12398856|jiang ci;
将从__將從 634.284663664|jiang cong;
江苏__江蘇 4693.06525391|jiang su;
降压__降壓 190.081867665|jiang ya;
讲演__講演 196.586267794|jiang yan;
将要__將要 978.639934443|jiang yao;
讲义__講義 354.43965395|jiang yi;
将以__將以 908.135681884|jiang yi;
江阴__江陰 365.20034683|jiang yin;
僵硬__僵硬 464.497524783|jiang ying;
酱油__醬油 613.298247397|jiang you;
将由__將由 639.84183651|jiang you;
将有__將有 1070.5071343|jiang you;
将与__將與 420.94790182|jiang yu;
降雨__降雨 430.496878967|jiang yu;
将于__將於 2498.08815496|jiang yu;
讲完__講完 282.164331387|jiang wan;
姜文__姜文 304.070513117|jiang wen;
降温__降溫 842.710774091|jiang wen;
降为__降為 133.259374649|jiang wei;
将为__將為 758.957532109|jiang wei;
将按__將按 127.572086295|jiang an;
结巴__結巴 140.945727665|jie ba;
结拜__結拜 121.066816454|jie bai;
洁白__潔白 589.322768456|jie bai;
接班__接班 163.272821143|jie ban;
结伴__結伴 281.812926654|jie ban;
戒备__戒備 226.877563077|jie bei;
街边__街邊 317.626273928|jie bian;
界别__界別 108.627664361|jie bie;
结冰__結冰 170.977284899|jie bing;
揭牌__揭牌 116.624293448|jie pai;
接拍__接拍 160.249192015|jie pai;
节拍__節拍 206.119414554|jie pai;
接盘__接盤 177.711575153|jie pan;
洁癖__潔癖 179.492101402|jie pi;
解聘__解聘 129.817279349|jie pin;
截屏__截屏 222.121753798|jie ping;
解剖__解剖 543.469292924|jie pou;
解码__解碼 723.855290267|jie ma;
届满__屆滿 164.703307075|jie man;
睫毛__睫毛 501.183541788|jie mao;
解闷__解悶 142.713135632|jie men;
姐们__姐們 145.405889264|jie men;
结盟__結盟 284.991389772|jie meng;
姐妹__姐妹 2090.33406802|jie mei;
揭密__揭密 175.948711373|jie mi;
揭秘__揭秘 381.957020988|jie mi;
解密__解密 614.062995519|jie mi;
洁面__潔面 225.187525865|jie mian;
截面__截面 261.510250403|jie mian;
界面__界面 6059.03211339|jie mian;
芥末__芥末 154.754097942|jie mo;
揭幕__揭幕 224.626982392|jie mu;
节目__節目 8960.68204728|jie mu;
解法__解法 142.891090816|jie fa;
揭发__揭發 364.291279287|jie fa;
街坊__街坊 164.498187167|jie fang;
解放__解放 2011.12191579|jie fang;
解封__解封 197.568631008|jie feng;
劫匪__劫匪 243.882891747|jie fei;
杰夫__傑夫 133.42554153|jie fu;
姐夫__姐夫 935.706437745|jie fu;
截断__截斷 192.225730308|jie duan;
阶段__階段 11368.7020266|jie duan;
捷达__捷達 362.028498203|jie da;
解答__解答 1930.09502896|jie da;
借贷__借貸 342.712398751|jie dai;
接待__接待 2409.42197254|jie dai;
接单__接單 153.218967809|jie dan;
借到__借到 125.992190229|jie dao;
街道__街道 3453.98620792|jie dao;
接到__接到 4722.39824658|jie dao;
姐弟__姐弟 233.183609039|jie di;
接地__接地 407.020105042|jie di;
节电__節電 175.948711373|jie dian;
结点__結點 301.429591092|jie dian;
节点__節點 2625.76520592|jie dian;
戒掉__戒掉 150.569041974|jie diao;
界定__界定 999.59341964|jie ding;
解冻__解凍 338.890182508|jie dong;
戒毒__戒毒 222.67604562|jie du;
解毒__解毒 387.711726118|jie du;
解读__解讀 1565.51253772|jie du;
结对__結對 136.112567367|jie dui;
解套__解套 535.402718412|jie tao;
解题__解題 241.463621556|jie ti;
解体__解體 296.216358865|jie ti;
接替__接替 381.481335404|jie ti;
阶梯__階梯 381.957020988|jie ti;
借条__借條 114.037415895|jie tiao;
接听__接聽 747.692521253|jie ting;
接头__接頭 534.735933039|jie tou;
街头__街頭 2186.24593438|jie tou;
接通__接通 504.316081474|jie tong;
截图__截圖 2457.94475925|jie tu;
解脱__解脫 1062.53280282|jie tuo;
接纳__接納 588.588831574|jie na;
劫难__劫難 161.451865638|jie nan;
节能__節能 2309.46804145|jie neng;
杰伦__傑倫 375.351064872|jie lun;
结论__結論 4112.3403478|jie lun;
戒律__戒律 200.795341333|jie lv;
借来__借來 267.775955618|jie lai;
借了__借了 427.290057918|jie le;
借力__借力 129.332863581|jie li;
竭力__竭力 394.535222541|jie li;
接力__接力 419.377126323|jie li;
接连__接連 668.366611253|jie lian;
截留__截留 114.321989585|jie liu;
接龙__接龍 109.442917312|jie long;
揭露__揭露 853.278059532|jie lu;
接管__接管 406.006938516|jie guan;
秸秆__秸稈 320.808632296|jie gan;
借个__借個 248.794392378|jie ge;
借给__借給 416.772181646|jie gei;
解构__解構 172.260473089|jie gou;
结构__結構 13384.6958387|jie gou;
解雇__解僱 291.456266438|jie gu;
接过__接過 1049.37403554|jie guo;
结果__結果 37326.6283014|jie guo;
接轨__接軌 781.025384985|jie gui;
借款__借款 901.370874142|jie kuan;
解开__解開 868.29524729|jie kai;
揭开__揭開 1017.18567095|jie kai;
解渴__解渴 132.596773978|jie ke;
接客__接客 156.694657831|jie ke;
皆可__皆可 214.2378495|jie ke;
借壳__借殼 261.83633885|jie ke;
节课__節課 368.399985048|jie ke;
杰克__傑克 504.944935018|jie ke;
捷克__捷克 546.866130582|jie ke;
借口__借口 2436.59694626|jie kou;
接口__接口 8110.44734975|jie kou;
结婚__結婚 15836.9279932|jie hun;
结核__結核 191.747236314|jie he;
结合__結合 10721.9636895|jie he;
节后__節后 599.694499646|jie hou;
截获__截獲 186.097370046|jie huo;
解惑__解惑 198.06165195|jie huo;
接回__接回 113.046974828|jie hui;
结汇__結匯 149.633788238|jie hui;
解决__解決 28553.547206|jie jue;
接机__接機 202.554574186|jie ji;
街机__街機 226.030964922|jie ji;
借机__藉機 384.823616623|jie ji;
阶级__階級 1114.0586864|jie ji;
节俭__節儉 274.191785204|jie jian;
接见__接見 362.028498203|jie jian;
借鉴__借鑒 2116.54609407|jie jian;
街角__街角 138.85370659|jie jiao;
结交__結交 423.578945935|jie jiao;
结节__結節 154.561368684|jie jie;
结界__結界 172.475272126|jie jie;
节节__節節 253.173026121|jie jie;
姐姐__姐姐 12297.2127608|jie jie;
解禁__解禁 494.9767145|jie jin;
接近__接近 5814.9173705|jie jin;
捷径__捷徑 431.571158705|jie jing;
洁净__潔凈 467.983588668|jie jing;
结晶__結晶 681.82669043|jie jing;
戒酒__戒酒 125.835280772|jie jiu;
解救__解救 506.83620443|jie jiu;
拮据__拮据 148.149450567|jie ju;
洁具__潔具 181.969489867|jie ju;
结局__結局 3049.30086097|jie ju;
节气__節氣 147.045868173|jie qi;
接洽__接洽 184.71110921|jie qia;
节前__節前 536.738784525|jie qian;
借钱__借錢 1004.58849796|jie qian;
节庆__節慶 120.314814642|jie qing;
结清__結清 164.293322714|jie qing;
接球__接球 123.044091616|jie qiu;
截取__截取 387.22887368|jie qu;
街区__街區 396.012952778|jie qu;
节选__節選 119.26985293|jie xuan;
解析__解析 2092.94059602|jie xi;
结下__結下 195.121873946|jie xia;
接下__接下 274.191785204|jie xia;
界线__界線 214.2378495|jie xian;
接线__接線 318.418891685|jie xian;
界限__界限 798.742526514|jie xian;
揭晓__揭曉 700.778015498|jie xiao;
街巷__街巷 113.753550575|jie xiang;
戒心__戒心 112.34478795|jie xin;
接续__接續 139.373782642|jie xu;
结转__結轉 212.907119447|jie zhuan;
结扎__結紮 136.792736844|jie zha;
结账__結賬 179.045304336|jie zhang;
结帐__結帳 375.819106356|jie zhang;
借着__藉著 637.454253928|jie zhe;
接着__接着 5197.98781874|jie zhe;
皆知__皆知 143.784200776|jie zhi;
节制__節制 388.679238014|jie zhi;
介质__介質 745.831342837|jie zhi;
截止__截止 867.213880777|jie zhi;
截至__截至 1476.45426414|jie zhi;
戒指__戒指 2054.18168866|jie zhi;
接种__接種 449.688850794|jie zhong;
接住__接住 154.754097942|jie zhu;
借助__藉助 2180.80386611|jie zhu;
揭穿__揭穿 277.284292303|jie chuan;
结肠__結腸 143.784200776|jie chang;
竭诚__竭誠 188.665925845|jie cheng;
结成__結成 452.499534015|jie cheng;
劫持__劫持 357.99085261|jie chi;
结出__結出 124.587019602|jie chu;
杰出__傑出 1026.09756322|jie chu;
解除__解除 2373.65954378|jie chu;
接触__接觸 7930.54714563|jie chu;
接上__接上 354.881620091|jie shang;
街上__街上 1981.27135202|jie shang;
介绍__介紹 26562.5815771|jie shao;
节省__節省 1996.14083601|jie sheng;
街市__街市 141.121478992|jie shi;
节食__節食 225.749468142|jie shi;
皆是__皆是 270.796100963|jie shi;
结石__結石 436.982903472|jie shi;
结识__結識 668.366611253|jie shi;
结实__結實 744.902491688|jie shi;
揭示__揭示 954.550411286|jie shi;
届时__屆時 1162.27522076|jie shi;
解释__解釋 12266.6021738|jie shi;
接手__接手 712.223191016|jie shou;
接收__接收 4526.49139658|jie shou;
接受__接受 20218.3995421|jie shou;
借书__借書 176.387781073|jie shu;
结束__結束 15836.9279932|jie shu;
解说__解說 1059.88791463|jie shuo;
节水__節水 528.772109212|jie shui;
截然__截然 175.510734618|jie ran;
接壤__接壤 151.699065864|jie rang;
接任__接任 217.465635832|jie ren;
节日__節日 3126.25457954|jie ri;
接入__接入 1922.89284084|jie ru;
介入__介入 2358.91565003|jie ru;
节奏__節奏 2488.76648916|jie zou;
杰作__傑作 384.823616623|jie zuo;
阶层__階層 1353.11831545|jie ceng;
借此__藉此 668.366611253|jie ci;
结算__結算 2491.86983978|jie suan;
解散__解散 830.202635471|jie san;
接送__接送 483.394725468|jie song;
借宿__借宿 235.226605969|jie su;
解锁__解鎖 354.43965395|jie suo;
结缘__結緣 149.075426771|jie yuan;
借阅__借閱 166.146325956|jie yue;
解约__解約 179.045304336|jie yue;
节约__節約 2038.87985164|jie yue;
解压__解壓 1359.87999657|jie ya;
戒严__戒嚴 106.218162376|jie yan;
戒烟__戒煙 531.41444163|jie yan;
揭阳__揭陽 141.121478992|jie yang;
解药__解藥 136.112567367|jie yao;
结业__結業 159.055477247|jie ye;
借以__藉以 179.492101402|jie yi;
介意__介意 1595.05109108|jie yi;
皆因__皆因 105.690017726|jie yin;
接应__接應 259.562230298|jie ying;
节油__節油 191.98633424|jie you;
皆有__皆有 352.238065853|jie you;
借用__借用 942.728934628|jie yong;
结余__結餘 181.290467084|jie yu;
介于__介於 401.478808454|jie yu;
接吻__接吻 569.823995046|jie wen;
结为__結為 161.451865638|jie wei;
解围__解圍 239.963779681|jie wei;
皆为__皆為 257.94996962|jie wei;
结尾__結尾 1255.63548024|jie wei;
街舞__街舞 271.133768339|jie wu;
节哀__節哀 124.431860131|jie ai;
结案__結案 229.150692759|jie an;
近百__近百 551.657401419|jin bai;
近半__近半 128.209578049|jin ban;
金宝__金寶 120.164975734|jin bao;
劲爆__勁爆 124.276893895|jin bao;
紧绷__緊繃 219.644465616|jin beng;
金杯__金杯 506.83620443|jin bei;
紧闭__緊閉 310.580912674|jin bi;
金币__金幣 1399.42059064|jin bi;
金边__金邊 118.08671951|jin bian;
进补__進補 179.045304336|jin bu;
进步__進步 5362.47571095|jin bu;
金牌__金牌 1548.05262827|jin pai;
浸泡__浸泡 715.782248677|jin pao;
金鹏__金鵬 145.405889264|jin peng;
仅凭__僅憑 215.576896995|jin ping;
紧迫__緊迫 445.228026075|jin po;
金马__金馬 226.030964922|jin ma;
金茂__金茂 116.044406778|jin mao;
金毛__金毛 176.827946446|jin mao;
金门__金門 246.94109417|jin men;
进门__進門 891.318029807|jin men;
紧密__緊密 1601.02534912|jin mi;
今明__今明 208.44415872|jin ming;
进发__進發 171.617679695|jin fa;
金发__金髮 433.187606905|jin fa;
谨防__謹防 414.699880708|jin fang;
近代__近代 785.907015785|jin dai;
尽到__盡到 160.649084484|jin dao;
进到__進到 298.439468992|jin dao;
金德__金德 242.972837869|jin de;
金地__金地 128.850255419|jin di;
金蝶__金蝶 362.931919108|jin die;
紧盯__緊盯 135.773751924|jin ding;
今冬__今冬 184.481071779|jin dong;
禁毒__禁毒 246.019628549|jin du;
进度__進度 3360.57914611|jin du;
金泰__金泰 155.915530766|jin tai;
金坛__金壇 125.678566729|jin tan;
今天__今天 109961.830201|jin tian;
金条__金條 210.532600599|jin tiao;
紧贴__緊貼 274.191785204|jin tie;
津贴__津貼 513.831666385|jin tie;
浸透__浸透 185.402943996|jin tou;
劲头__勁頭 271.133768339|jin tou;
尽头__盡頭 971.349932368|jin tou;
进退__進退 197.814987883|jin tui;
锦囊__錦囊 106.748946222|jin nang;
仅能__僅能 226.030964922|jin neng;
近年__近年 922.967443217|jin nian;
今年__今年 26200.9504418|jin nian;
金牛__金牛 472.67240572|jin niu;
近来__近來 1476.45426414|jin lai;
进来__進來 8029.99331146|jin lai;
近了__近了 142.180598718|jin le;
尽了__盡了 249.104624871|jin le;
金利__金利 140.419785869|jin li;
尽力__儘力 1706.08071057|jin li;
金莲__金蓮 112.484875527|jin lian;
近两__近兩 169.070402749|jin liang;
尽量__盡量 8120.56061749|jin liang;
紧邻__緊鄰 205.60633599|jin lin;
禁令__禁令 336.785179346|jin ling;
金陵__金陵 439.166555128|jin ling;
金龙__金龍 327.677408739|jin long;
尽管__儘管 10615.6039241|jin guan;
金光__金光 282.164331387|jin guang;
金刚__金剛 1269.79732551|jin gang;
紧跟__緊跟 433.727767276|jin gen;
进宫__進宮 148.519148841|jin gong;
仅供__僅供 762.750126416|jin gong;
进攻__進攻 3360.57914611|jin gong;
禁锢__禁錮 239.963779681|jin gu;
筋骨__筋骨 390.621510938|jin gu;
进过__進過 145.043940608|jin guo;
巾帼__巾幗 171.190483873|jin guo;
近况__近況 312.911829085|jin kuang;
金矿__金礦 379.111778956|jin kuang;
尽快__儘快 7507.4112927|jin kuai;
金卡__金卡 341.008342538|jin ka;
紧靠__緊靠 129.171793682|jin kao;
仅靠__僅靠 231.158356006|jin kao;
紧扣__緊扣 153.792848894|jin kou;
进口__進口 5044.82818733|jin kou;
金库__金庫 164.498187167|jin ku;
金花__金花 283.221176861|jin hua;
金华__金華 692.099342424|jin hua;
进化__進化 1061.20953474|jin hua;
金黄__金黃 349.178797604|jin huang;
金海__金海 106.882056102|jin hai;
近海__近海 143.0692679|jin hai;
今后__今後 5946.82564905|jin hou;
近乎__近乎 845.867144221|jin hu;
进货__進貨 1135.07907503|jin huo;
进军__進軍 1318.16721196|jin jun;
金鸡__金雞 120.015323434|jin ji;
禁忌__禁忌 524.179602378|jin ji;
晋级__晉級 820.943519051|jin ji;
紧急__緊急 2854.41099368|jin ji;
进价__進價 241.764712994|jin jia;
金价__金價 351.799391968|jin jia;
近郊__近郊 150.194241046|jin jiao;
金奖__金獎 302.558594526|jin jiang;
锦江__錦江 308.651751439|jin jiang;
晋江__晉江 317.230705235|jin jiang;
进阶__進階 156.89004718|jin jie;
紧紧__緊緊 2258.24105554|jin jin;
仅仅__僅僅 6694.2127778|jin jin;
进京__進京 361.12732612|jin jing;
紧缺__緊缺 471.495815538|jin que;
今起__今起 179.492101402|jin qi;
进气__進氣 181.969489867|jin qi;
近期__近期 6537.57450229|jin qi;
近千__近千 312.522131716|jin qian;
金钱__金錢 2944.7374939|jin qian;
紧俏__緊俏 126.779677253|jin qiao;
金桥__金橋 299.93080386|jin qiao;
近亲__近親 110.539446825|jin qin;
尽情__盡情 1316.52557925|jin qing;
金秋__金秋 248.794392378|jin qiu;
进球__進球 2067.02090848|jin qiu;
金曲__金曲 204.584007193|jin qu;
进取__進取 566.990680223|jin qu;
禁区__禁區 1366.67546656|jin qu;
进去__進去 12099.6008883|jin qu;
今夏__今夏 196.341441156|jin xia;
仅限__僅限 206.633773476|jin xian;
尽显__盡顯 322.813777494|jin xian;
尽享__盡享 146.314717429|jin xiang;
金鑫__金鑫 125.053659829|jin xin;
尽心__盡心 158.659551632|jin xin;
尽兴__盡興 273.509258874|jin xing;
金星__金星 425.165459331|jin xing;
进行__進行 84537.2427339|jin xing;
锦绣__錦繡 346.577724349|jin xiu;
进修__進修 480.991159713|jin xiu;
仅需__僅需 179.71591787|jin xu;
进站__進站 253.173026121|jin zhan;
仅占__僅占 260.859291326|jin zhan;
近战__近戰 281.461959558|jin zhan;
进展__進展 4112.3403478|jin zhan;
进账__進賬 157.477678279|jin zhang;
紧张__緊張 8294.42849341|jin zhang;
近照__近照 188.665925845|jin zhao;
今朝__今朝 524.833224606|jin zhao;
尽职__盡職 117.207077876|jin zhi;
紧致__緊緻 123.351140937|jin zhi;
进制__進制 199.548108896|jin zhi;
禁止__禁止 6360.77714733|jin zhi;
锦州__錦州 309.4219738|jin zhou;
金钟__金鐘 121.823518492|jin zhong;
进驻__進駐 692.962351041|jin zhu;
金叉__金叉 109.170488754|jin cha;
进厂__進廠 120.615053212|jin chang;
进场__進場 929.894333673|jin chang;
今晨__今晨 138.163289429|jin chen;
金城__金城 170.76435144|jin cheng;
进城__進城 639.84183651|jin cheng;
进程__進程 5013.49243365|jin cheng;
矜持__矜持 447.452879516|jin chi;
近处__近處 123.044091616|jin chu;
进出__進出 873.722339551|jin chu;
金莎__金莎 146.132498493|jin sha;
金沙__金沙 259.238974004|jin sha;
进山__進山 126.149295342|jin shan;
金山__金山 1956.73461434|jin shan;
晋商__晉商 131.445140637|jin shang;
近身__近身 181.742866823|jin shen;
紧身__緊身 238.770616634|jin shen;
谨慎__謹慎 2292.26454686|jin shen;
仅剩__僅剩 184.251320835|jin sheng;
晋升__晉陞 607.9716117|jin sheng;
今生__今生 797.747780288|jin sheng;
浸湿__浸濕 105.953760973|jin shi;
近十__近十 105.953760973|jin shi;
今世__今世 131.445140637|jin shi;
金石__金石 171.190483873|jin shi;
进士__進士 230.582949765|jin shi;
尽是__儘是 338.890182508|jin shi;
仅是__僅是 534.069978074|jin shi;
进食__進食 605.702953498|jin shi;
近视__近視 614.062995519|jin shi;
仅售__僅售 169.28122395|jin shou;
金属__金屬 3662.32726943|jin shu;
进水__進水 486.416079992|jin shui;
浸润__浸潤 228.580284053|jin run;
尽然__盡然 135.604660605|jin ran;
今人__今人 146.679837233|jin ren;
近日__近日 3607.96829056|jin ri;
今日__今日 7649.06334831|jin ri;
金融__金融 5601.54012187|jin rong;
浸入__浸入 125.522047856|jin ru;
进入__進入 26430.505433|jin ru;
仅在__僅在 373.950434882|jin zai;
尽在__盡在 397.991873082|jin zai;
进藏__進藏 145.224802174|jin zang;
今早__今早 535.402718412|jin zao;
尽早__儘早 958.125676369|jin zao;
尽责__盡責 117.792774542|jin ze;
金子__金子 692.099342424|jin zi;
仅作__僅作 324.02287532|jin zuo;
仅存__僅存 194.393772779|jin cun;
进村__進村 209.746993999|jin cun;
进餐__進餐 148.889769675|jin can;
仅此__僅此 225.468321935|jin ci;
今次__今次 307.117053725|jin ci;
紧凑__緊湊 474.442798491|jin cou;
禁赛__禁賽 136.963309627|jin sai;
近三__近三 139.72158175|jin san;
金色__金色 1298.60199609|jin se;
金丝__金絲 162.056583012|jin si;
近似__近似 546.866130582|jin si;
劲松__勁松 125.678566729|jin song;
紧锁__緊鎖 129.655606164|jin suo;
紧缩__緊縮 567.697685436|jin suo;
紧随__緊隨 266.444503116|jin sui;
金源__金源 135.604660605|jin yuan;
禁烟__禁煙 119.41857567|jin yan;
禁言__禁言 217.19480623|jin yan;
紧要__緊要 218.824857909|jin yao;
今夜__今夜 644.643863216|jin ye;
仅以__僅以 202.554574186|jin yi;
金银__金銀 381.006242235|jin yin;
金鹰__金鷹 202.554574186|jin ying;
仅有__僅有 1349.75009317|jin you;
仅用__僅用 198.06165195|jin yong;
金庸__金庸 872.634214191|jin yong;
禁用__禁用 1413.4416531|jin yong;
金玉__金玉 125.36572391|jin yu;
金鱼__金魚 398.48814637|jin yu;
今晚__今晚 7169.11735945|jin wan;
仅为__僅為 1388.99614478|jin wei;
紧握__緊握 227.160466527|jin wo;
进屋__進屋 304.449671797|jin wu;
劲舞__勁舞 432.109303457|jin wu;
紧挨__緊挨 121.368931601|jin ai;
金额__金額 4969.94910399|jin e;
劲儿__勁兒 368.399985048|jin er;
今儿__今兒 1017.18567095|jin er;
进而__進而 1666.16002844|jin er;
经办__經辦 329.725485744|jing ban;
惊爆__驚爆 118.08671951|jing bao;
劲爆__勁爆 124.276893895|jing bao;
警报__警報 432.109303457|jing bao;
竟被__竟被 139.373782642|jing bei;
竞标__競標 360.677581637|jing biao;
精兵__精兵 122.584950132|jing bing;
颈部__頸部 511.914293268|jing bu;
竞拍__競拍 212.112652282|jing pai;
井喷__井噴 199.051387821|jing pen;
敬佩__敬佩 530.752623218|jing pei;
精辟__精闢 362.931919108|jing pi;
晶片__晶片 106.085879302|jing pian;
镜片__鏡片 443.56664881|jing pian;
竞聘__競聘 210.008536601|jing pin;
精品__精品 2629.03938618|jing pin;
经脉__經脈 133.591915611|jing mai;
竞买__競買 139.895806636|jing mai;
静脉__靜脈 682.676889633|jing mai;
经贸__經貿 754.243296976|jing mao;
荆门__荊門 171.403948695|jing men;
精美__精美 1569.41918253|jing mei;
粳米__粳米 121.520271774|jing mi;
静谧__靜謐 238.176261728|jing mi;
精密__精密 692.962351041|jing mi;
镜面__鏡面 367.025293151|jing mian;
精妙__精妙 180.613978088|jing miao;
精明__精明 700.778015498|jing ming;
静默__靜默 210.795122809|jing mo;
警方__警方 3976.27638265|jing fang;
经费__經費 2197.17084589|jing fei;
警服__警服 129.817279349|jing fu;
惊呆__驚呆 256.347723437|jing dai;
境地__境地 613.298247397|jing di;
静电__靜電 378.168082664|jing dian;
景点__景點 1716.74420026|jing dian;
经典__經典 8315.12675373|jing dian;
惊动__驚動 358.437246895|jing dong;
京东__京東 390.621510938|jing dong;
精读__精讀 106.350610398|jing du;
京都__京都 343.996026791|jing du;
精度__精度 1033.79844744|jing du;
静态__靜態 1540.35530331|jing tai;
惊叹__驚嘆 641.438524323|jing tan;
晶体__晶體 519.626982517|jing ti;
警惕__警惕 1354.80557722|jing ti;
惊天__驚天 382.433299725|jing tian;
静听__靜聽 161.854759309|jing ting;
镜头__鏡頭 5829.42815609|jing tou;
精通__精通 926.424414408|jing tong;
净土__凈土 329.314848809|jing tu;
竟能__竟能 114.75018218|jing neng;
境内__境內 2135.08983815|jing nei;
痉挛__痙攣 353.998238229|jing luan;
劲旅__勁旅 131.445140637|jing lv;
警力__警力 309.4219738|jing li;
敬礼__敬禮 393.553133755|jing li;
精力__精力 3612.46722234|jing li;
经理__經理 9152.53761339|jing li;
经历__經歷 12266.6021738|jing li;
精炼__精鍊 333.444336783|jing lian;
精良__精良 383.865702254|jing liang;
精灵__精靈 2510.57137637|jing ling;
经络__經絡 598.201722298|jing luo;
经管__經管 185.172044961|jing guan;
警官__警官 450.24958728|jing guan;
景观__景觀 1731.7851508|jing guan;
精光__精光 167.184787749|jing guang;
井盖__井蓋 105.0335283|jing gai;
竟敢__竟敢 147.964946673|jing gan;
精干__精幹 154.176629937|jing gan;
警告__警告 2213.66066021|jing gao;
竞购__競購 124.431860131|jing gou;
精工__精工 178.59961945|jing gong;
经过__經過 18598.8528473|jing guo;
境况__境況 214.2378495|jing kuang;
井口__井口 115.611384758|jing kou;
惊恐__驚恐 424.635962376|jing kong;
京华__京華 152.267254161|jing hua;
净化__凈化 978.639934443|jing hua;
精华__精華 2318.11814557|jing hua;
惊慌__驚慌 319.611528482|jing huang;
惊魂__驚魂 174.42055653|jing hun;
京沪__京滬 169.915266157|jing hu;
惊呼__驚呼 343.139741671|jing hu;
竟会__竟會 118.23396695|jing hui;
警觉__警覺 311.355949144|jing jue;
荆棘__荊棘 330.960471347|jing ji;
经纪__經紀 339.735863102|jing ji;
竞技__競技 716.674788535|jing ji;
经济__經濟 22505.5821884|jing ji;
竞价__競價 601.191002133|jing jia;
精简__精簡 605.702953498|jing jian;
京郊__京郊 118.529012887|jing jiao;
惊叫__驚叫 188.665925845|jing jiao;
靖江__靖江 117.353228453|jing jiang;
警戒__警戒 334.69325133|jing jie;
境界__境界 2275.1892031|jing jie;
精进__精進 126.464093517|jing jin;
京津__京津 270.458854115|jing jin;
菁菁__菁菁 107.952927857|jing jing;
晶晶__晶晶 560.667124391|jing jing;
静静__靜靜 1815.76539105|jing jing;
敬酒__敬酒 182.423584067|jing jiu;
警局__警局 133.259374649|jing ju;
京剧__京劇 568.405572245|jing ju;
精确__精確 1718.88488289|jing que;
经期__經期 279.713669565|jing qi;
景气__景氣 414.699880708|jing qi;
惊奇__驚奇 742.122873174|jing qi;
精巧__精巧 314.867617017|jing qiao;
敬请__敬請 701.651845929|jing qing;
景区__景區 1954.29771596|jing qu;
竞选__競選 926.424414408|jing xuan;
精选__精選 1449.11199071|jing xuan;
精细__精細 812.799921236|jing xi;
惊喜__驚喜 2523.11697781|jing xi;
惊吓__驚嚇 289.645897197|jing xia;
井下__井下 294.376422496|jing xia;
惊现__驚現 325.642053285|jing xian;
惊险__驚險 377.226735448|jing xian;
经销__經銷 555.105417084|jing xiao;
竞相__競相 277.284292303|jing xiang;
景象__景象 1087.99076217|jing xiang;
镜像__鏡像 1165.17561047|jing xiang;
静心__靜心 247.249015706|jing xin;
精心__精心 1966.51263254|jing xin;
警醒__警醒 186.794397067|jing xing;
惊醒__驚醒 701.651845929|jing xing;
精装__精裝 256.987424161|jing zhuang;
精准__精準 550.970372621|jing zhun;
精湛__精湛 440.262469534|jing zhan;
警长__警長 131.281440129|jing zhang;
竞争__競爭 8707.49819835|jing zheng;
精制__精製 228.295612376|jing zhi;
景致__景緻 245.101601395|jing zhi;
径直__徑直 297.325836157|jing zhi;
静止__靜止 534.069978074|jing zhi;
净值__凈值 992.147332631|jing zhi;
精致__精緻 1861.58897661|jing zhi;
荆州__荊州 399.482550191|jing zhou;
镜中__鏡中 141.121478992|jing zhong;
警钟__警鐘 230.008975843|jing zhong;
敬重__敬重 245.407229187|jing zhong;
颈椎__頸椎 349.614203755|jing zhui;
惊诧__驚詫 231.446597362|jing cha;
警察__警察 6694.2127778|jing cha;
经常__經常 21172.4586769|jing chang;
警车__警車 606.458230719|jing che;
精诚__精誠 116.769717326|jing cheng;
京城__京城 1334.69654755|jing cheng;
井上__井上 105.295633316|jing shang;
经商__經商 610.248767154|jing shang;
精深__精深 118.529012887|jing shen;
景深__景深 147.780672558|jing shen;
精神__精神 18163.657204|jing shen;
经省__經省 155.915530766|jing sheng;
京师__京師 180.613978088|jing shi;
警示__警示 605.702953498|jing shi;
竟是__竟是 854.342048866|jing shi;
经受__經受 598.201722298|jing shou;
经书__經書 295.847453874|jing shu;
净水__凈水 127.73116145|jing shui;
井水__井水 135.435779871|jing shui;
竟然__竟然 11439.7596478|jing ran;
惊人__驚人 2135.08983815|jing ren;
精锐__精銳 200.545272755|jing rui;
精子__精子 907.004698479|jing zi;
镜子__鏡子 1647.57761372|jing zi;
静坐__靜坐 246.326401069|jing zuo;
精采__精采 118.824795093|jing cai;
竞猜__競猜 266.112675706|jing cai;
精彩__精彩 5750.06453265|jing cai;
精粹__精粹 118.529012887|jing cui;
精算__精算 118.08671951|jing suan;
竞赛__競賽 1328.06008516|jing sai;
景色__景色 1112.67124847|jing se;
惊悚__驚悚 204.839111844|jing song;
竞速__競速 164.293322714|jing su;
精髓__精髓 663.387871054|jing sui;
警员__警員 252.228305921|jing yuan;
惊讶__驚訝 2213.66066021|jing ya;
惊艳__驚艷 614.062995519|jing yan;
经验__經驗 18761.8034055|jing yan;
景仰__景仰 184.481071779|jing yang;
敬仰__敬仰 320.409100324|jing yang;
竟也__竟也 143.0692679|jing ye;
精液__精液 635.867483878|jing ye;
敬业__敬業 712.223191016|jing ye;
惊异__驚異 244.186999878|jing yi;
敬意__敬意 433.727767276|jing yi;
静音__靜音 429.425273358|jing yin;
晶莹__晶瑩 455.327784806|jing ying;
精英__精英 3209.14698221|jing ying;
经营__經營 10802.4322569|jing ying;
竟有__竟有 273.168633085|jing you;
经由__經由 363.837594448|jing you;
精油__精油 667.534233933|jing you;
警用__警用 109.170488754|jing yong;
精于__精於 124.587019602|jing yu;
鲸鱼__鯨魚 172.905674062|jing yu;
境遇__境遇 263.801426189|jing yu;
境外__境外 1662.01257345|jing wai;
经文__經文 182.196395498|jing wen;
经委__經委 175.948711373|jing wei;
经纬__經緯 199.051387821|jing wei;
敬畏__敬畏 356.210827905|jing wei;
警卫__警衛 357.099731154|jing wei;
警务__警務 237.583386308|jing wu;
景物__景物 397.991873082|jing wu;
敬爱__敬愛 214.2378495|jing ai;
静安__靜安 206.119414554|jing an;
净额__凈額 129.494134325|jing e;
惊愕__驚愕 160.649084484|jing e;
窘迫__窘迫 211.848489234|jiong po;
窘境__窘境 173.121277629|jiong jing;
迥异__迥異 224.06783424|jiong yi;
酒吧__酒吧 2840.21811123|jiu ba;
就把__就把 2996.56312723|jiu ba;
九百__九百 185.172044961|jiu bai;
旧版__舊版 254.438159592|jiu ban;
酒杯__酒杯 439.714170908|jiu bei;
就被__就被 2427.50473612|jiu bei;
就别__就別 628.775756137|jiu bie;
就不__就不 7470.08246857|jiu bu;
就怕__就怕 1071.84199596|jiu pa;
就跑__就跑 482.191444969|jiu pao;
就凭__就憑 230.008975843|jiu ping;
酒瓶__酒瓶 262.817045902|jiu ping;
舅妈__舅媽 261.184568064|jiu ma;
就买__就買 566.284555508|jiu mai;
就没__就沒 2648.77038315|jiu mei;
救命__救命 649.481929235|jiu ming;
纠纷__糾紛 1934.91146801|jiu fen;
九段__九段 187.727829225|jiu duan;
就达__就達 176.168109435|jiu da;
九大__九大 242.066179876|jiu da;
就打__就打 383.865702254|jiu da;
就带__就帶 124.431860131|jiu dai;
就当__就當 966.520124945|jiu dang;
就到__就到 671.706512759|jiu dao;
旧的__舊的 574.10053635|jiu de;
就得__就得 1318.16721196|jiu de;
久等__久等 181.742866823|jiu deng;
就得__就得 846.921892564|jiu dei;
九点__九點 691.237408589|jiu dian;
酒店__酒店 8120.56061749|jiu dian;
就读__就讀 813.813436628|jiu du;
就多__就多 177.711575153|jiu duo;
就对__就對 243.882891747|jiu dui;
九天__九天 386.264972075|jiu tian;
九条__九條 136.112567367|jiu tiao;
就听__就聽 205.862715427|jiu ting;
就拿__就拿 629.559803835|jiu na;
就难__就難 145.768741141|jiu nan;
就能__就能 8315.12675373|jiu neng;
九年__九年 414.699880708|jiu nian;
就来__就來 947.439854855|jiu lai;
救了__救了 495.593922384|jiu le;
酒类__酒類 306.352568839|jiu lei;
就连__就連 1631.2339687|jiu lian;
酒量__酒量 326.454673948|jiu liang;
九六__九六 117.93965545|jiu liu;
酒楼__酒樓 523.526794166|jiu lou;
九龙__九龍 415.216987933|jiu long;
酒馆__酒館 148.704343794|jiu guan;
就该__就該 786.88699725|jiu gai;
纠葛__糾葛 260.859291326|jiu ge;
九个__九個 443.56664881|jiu ge;
就跟__就跟 1066.51251556|jiu gen;
就更__就更 895.772044085|jiu geng;
就给__就給 831.23785106|jiu gei;
就够__就夠 331.786363812|jiu gou;
救国__救國 201.296414343|jiu guo;
酒鬼__酒鬼 242.36802267|jiu gui;
就快__就快 367.025293151|jiu kuai;
就开__就開 212.641966978|jiu kai;
就看__就看 939.211122794|jiu kan;
就可__就可 1188.64081012|jiu ke;
就好__就好 7340.88720769|jiu hao;
就和__就和 276.594068012|jiu he;
就很__就很 997.105202031|jiu hen;
酒后__酒後 367.482952871|jiu hou;
救护__救護 269.785619908|jiu hu;
旧货__舊貨 110.815291538|jiu huo;
救活__救活 125.992190229|jiu huo;
救火__救火 184.02185602|jiu huo;
酒会__酒會 228.011295226|jiu hui;
就回__就回 276.249600432|jiu hui;
就会__就會 17431.85443|jiu hui;
救急__救急 134.259489114|jiu ji;
救济__救濟 573.385557088|jiu ji;
酒家__酒家 258.916120291|jiu jia;
就见__就見 150.194241046|jiu jian;
就叫__就叫 1200.55002966|jiu jiao;
九江__九江 496.21189989|jiu jiang;
就将__就將 648.673070715|jiu jiang;
九届__九屆 191.747236314|jiu jie;
纠结__糾結 333.444336783|jiu jie;
就进__就進 142.713135632|jiu jin;
就近__就近 444.673543393|jiu jin;
酒精__酒精 1184.20537322|jiu jing;
究竟__究竟 5302.66888213|jiu jing;
九九__九九 193.668388536|jiu jiu;
救救__救救 351.799391968|jiu jiu;
久久__久久 652.727461906|jiu jiu;
舅舅__舅舅 1132.25360251|jiu jiu;
酒泉__酒泉 143.426288875|jiu quan;
究其__究其 214.504991945|jiu qi;
九千__九千 109.989815613|jiu qian;
旧情__舊情 118.08671951|jiu qing;
就请__就請 219.097720093|jiu qing;
就去__就去 2977.95009215|jiu qu;
就学__就學 182.423584067|jiu xue;
酒席__酒席 269.785619908|jiu xi;
救下__救下 128.529517539|jiu xia;
就先__就先 378.63963681|jiu xian;
就向__就向 186.32942291|jiu xiang;
就想__就想 1716.74420026|jiu xiang;
就象__就象 2197.17084589|jiu xiang;
就像__就像 10367.2087883|jiu xiang;
就写__就寫 269.785619908|jiu xie;
揪心__揪心 202.050369328|jiu xin;
酒醒__酒醒 105.0335283|jiu xing;
救星__救星 132.10198647|jiu xing;
就行__就行 7526.14559771|jiu xing;
就绪__就緒 191.031727675|jiu xu;
九寨__九寨 216.384339476|jiu zhai;
就找__就找 408.035799866|jiu zhao;
就这__就這 340.583654043|jiu zhe;
就诊__就診 506.83620443|jiu zhen;
纠正__糾正 1553.85085374|jiu zheng;
旧址__舊址 181.516526012|jiu zhi;
就只__就只 205.350275845|jiu zhi;
就职__就職 370.702589737|jiu zhi;
救治__救治 621.763121294|jiu zhi;
九州__九州 401.478808454|jiu zhou;
揪住__揪住 139.373782642|jiu zhu;
救助__救助 1526.97696483|jiu zhu;
就差__就差 588.588831574|jiu cha;
纠缠__糾纏 1140.75119008|jiu chan;
酒厂__酒廠 180.164388413|jiu chang;
旧车__舊車 124.431860131|jiu che;
旧城__舊城 111.230349808|jiu cheng;
九城__九城 328.904723278|jiu cheng;
九成__九成 356.655002599|jiu cheng;
就成__就成 627.210588862|jiu cheng;
就吃__就吃 270.796100963|jiu chi;
揪出__揪出 110.126966673|jiu chu;
救出__救出 404.996293994|jiu chu;
救生__救生 109.989815613|jiu sheng;
旧式__舊式 112.625137786|jiu shi;
旧事__舊事 156.694657831|jiu shi;
旧时__舊時 223.231720645|jiu shi;
九十__九十 293.277951001|jiu shi;
救市__救市 562.066236349|jiu shi;
就是__就是 211267.381895|jiu shi;
就收__就收 179.045304336|jiu shou;
旧书__舊書 191.747236314|jiu shu;
救赎__救贖 386.264972075|jiu shu;
就说__就說 3506.02523602|jiu shuo;
酒水__酒水 293.277951001|jiu shui;
就让__就讓 1149.31255222|jiu rang;
就任__就任 194.151676652|jiu ren;
救人__救人 571.245957438|jiu ren;
九日__九日 114.893269147|jiu ri;
旧日__舊日 115.755545596|jiu ri;
就如__就如 569.823995046|jiu ru;
就再__就再 140.244908425|jiu zai;
救灾__救災 974.988119996|jiu zai;
就在__就在 8794.74028764|jiu zai;
就走__就走 1054.61787307|jiu zou;
就坐__就坐 129.979154132|jiu zuo;
就做__就做 307.883446338|jiu zuo;
酒醉__酒醉 177.933171406|jiu zui;
韭菜__韭菜 341.433560596|jiu cai;
就餐__就餐 390.135034682|jiu can;
就曾__就曾 341.433560596|jiu ceng;
就此__就此 1513.71482027|jiu ci;
就从__就從 455.895552723|jiu cong;
纠错__糾錯 258.271618599|jiu cuo;
就算__就算 8718.35595463|jiu suan;
九三__九三 135.098649108|jiu san;
九四__九四 146.132498493|jiu si;
就死__就死 270.458854115|jiu si;
就送__就送 175.073848088|jiu song;
九岁__九歲 147.780672558|jiu sui;
久远__久遠 359.779772295|jiu yuan;
救援__救援 1382.08969051|jiu yuan;
就越__就越 783.950712715|jiu yue;
九月__九月 1040.25998178|jiu yue;
就要__就要 11920.0096337|jiu yao;
酒业__酒業 196.096919422|jiu ye;
就业__就業 5057.41726048|jiu ye;
就以__就以 233.474375771|jiu yi;
就医__就醫 435.895152658|jiu yi;
就已__就已 467.400766428|jiu yi;
就应__就應 187.4940348|jiu ying;
旧有__舊有 125.678566729|jiu you;
就又__就又 242.972837869|jiu you;
就有__就有 7470.08246857|jiu you;
就用__就用 1399.42059064|jiu yong;
就问__就問 429.960742313|jiu wen;
久违__久違 535.402718412|jiu wei;
酒窝__酒窩 176.387781073|jiu wo;
救我__救我 204.584007193|jiu wo;
就我__就我 336.365750338|jiu wo;
九五__九五 200.545272755|jiu wu;
就爱__就愛 201.547419552|jiu ai;
旧爱__舊愛 253.804804573|jiu ai;
就按__就按 131.281440129|jiu an;
举办__舉辦 6157.98882218|ju ban;
举报__舉報 4365.82984783|ju bao;
剧本__劇本 1693.37191801|ju ben;
举杯__舉杯 172.04594156|ju bei;
具备__具備 6376.65009401|ju bei;
巨变__巨變 196.096919422|ju bian;
句柄__句柄 215.845709156|ju bing;
拘捕__拘捕 167.184787749|ju bu;
拒不__拒不 315.260239073|ju bu;
局部__局部 2297.98475873|ju bu;
惧怕__懼怕 377.226735448|ju pa;
局面__局面 3567.72920071|ju mian;
居民__居民 5223.96273588|ju min;
巨魔__巨魔 247.866011137|ju mo;
剧目__劇目 264.789493468|ju mu;
局方__局方 342.285588041|ju fang;
飓风__颶風 445.783200166|ju feng;
巨幅__巨幅 170.127140854|ju fu;
巨大__巨大 9584.42452404|ju da;
据点__據點 245.71323808|ju dian;
举动__舉動 1338.02720458|ju dong;
剧毒__劇毒 172.475272126|ju du;
居多__居多 711.336195135|ju duo;
剧团__劇團 275.561951728|ju tuan;
具体__具體 21384.5895885|ju ti;
巨头__巨頭 1526.97696483|ju tou;
剧痛__劇痛 163.884358899|ju tong;
拘泥__拘泥 189.372573382|ju ni;
巨浪__巨浪 131.445140637|ju lang;
举了__舉了 144.322743975|ju le;
聚类__聚類 162.258658377|ju lei;
局里__局裡 179.940013424|ju li;
举例__舉例 751.428823061|ju li;
距离__距離 7812.83608024|ju li;
巨量__巨量 149.633788238|ju liang;
剧烈__劇烈 1049.37403554|ju lie;
居留__居留 177.048440864|ju liu;
拘留__拘留 457.033213363|ju liu;
巨龙__巨龍 251.914183226|ju long;
举个__舉個 421.472799973|ju ge;
鞠躬__鞠躬 310.194118206|ju gong;
举国__舉國 172.475272126|ju guo;
巨款__巨款 177.048440864|ju kuan;
菊花__菊花 1166.62851836|ju hua;
句话__句話 1197.56158489|ju hua;
句号__句號 391.108593802|ju hao;
聚合__聚合 639.044983668|ju he;
聚会__聚會 3373.16618304|ju hui;
咀嚼__咀嚼 365.655730945|ju jue;
拒绝__拒絕 7544.92665307|ju jue;
狙击__狙擊 377.697115787|ju ji;
剧集__劇集 481.590928402|ju ji;
聚集__聚集 1903.81812306|ju ji;
俱佳__俱佳 105.953760973|ju jia;
举家__舉家 110.815291538|ju jia;
居家__居家 469.151414294|ju jia;
聚焦__聚焦 822.992135502|ju jiao;
距今__距今 165.32020271|ju jin;
拘谨__拘謹 169.915266157|ju jin;
句句__句句 164.703307075|ju ju;
聚居__聚居 176.827946446|ju ju;
聚聚__聚聚 499.3133654|ju ju;
俱全__俱全 125.209594649|ju quan;
举起__舉起 788.850627646|ju qi;
居前__居前 105.558392399|ju qian;
拒签__拒簽 138.680779525|ju qian;
剧情__劇情 2847.30570911|ju qing;
据悉__據悉 284.281980745|ju xi;
局限__局限 1179.78648723|ju xian;
巨响__巨響 189.372573382|ju xiang;
巨蟹__巨蟹 266.444503116|ju xie;
句型__句型 162.663565352|ju xing;
矩形__矩形 347.442588754|ju xing;
巨型__巨型 465.65665114|ju xing;
巨星__巨星 814.828215816|ju xing;
举行__舉行 9620.32295112|ju xing;
局长__局長 3019.05239777|ju zhang;
剧照__劇照 376.756940916|ju zhao;
举着__舉着 346.1460998|ju zhe;
矩阵__矩陣 840.61307342|ju zhen;
举证__舉證 291.819695868|ju zheng;
聚酯__聚酯 148.149450567|ju zhi;
举止__舉止 419.377126323|ju zhi;
聚众__聚眾 152.077621994|ju zhong;
举重__舉重 205.862715427|ju zhong;
居中__居中 305.589986932|ju zhong;
剧中__劇中 1143.59786783|ju zhong;
巨著__巨著 110.95347192|ju zhu;
居住__居住 3269.69811616|ju zhu;
据传__據傳 131.937467932|ju chuan;
剧场__劇場 656.807194196|ju chang;
据称__據稱 298.811606079|ju cheng;
锯齿__鋸齒 178.822323044|ju chi;
举出__舉出 181.742866823|ju chu;
举世__舉世 119.86585751|ju shi;
句式__句式 155.333728851|ju shi;
巨石__巨石 255.073095111|ju shi;
居士__居士 472.083744072|ju shi;
居室__居室 494.9767145|ju shi;
局势__局勢 1015.91887775|ju shi;
拒收__拒收 156.694657831|ju shou;
聚首__聚首 164.703307075|ju shou;
举手__舉手 555.797602048|ju shou;
拘束__拘束 232.893204426|ju shu;
据说__據說 8140.82500071|ju shuo;
居然__居然 15142.152855|ju ran;
巨人__巨人 1035.08753546|ju ren;
巨乳__巨乳 152.837570606|ju ru;
聚在__聚在 346.577724349|ju zai;
剧增__劇增 123.044091616|ju zeng;
桔子__桔子 328.495108513|ju zi;
巨资__巨資 488.846754671|ju zi;
橘子__橘子 615.595353746|ju zi;
句子__句子 1409.92327219|ju zi;
剧组__劇組 1065.18429118|ju zu;
聚餐__聚餐 547.548041623|ju can;
据此__據此 825.045864155|ju ci;
局促__局促 106.483223576|ju cu;
举措__舉措 1440.11088805|ju cuo;
沮丧__沮喪 760.851466162|ju sang;
居所__居所 163.272821143|ju suo;
剧院__劇院 483.394725468|ju yuan;
具有__具有 24042.1898933|ju you;
居于__居於 330.136634719|ju yu;
据我__據我 465.076726846|ju wo;
巨额__巨額 1205.04668542|ju e;
全班__全班 553.723632203|quan ban;
全包__全包 199.548108896|quan bao;
全部__全部 23131.1232678|quan bu;
全盘__全盤 423.578945935|quan pan;
全片__全片 119.121315407|quan pian;
全凭__全憑 137.647730357|quan ping;
全屏__全屏 493.129699012|quan ping;
全貌__全貌 147.596627936|quan mao;
全美__全美 407.527636023|quan mei;
全棉__全棉 116.47905068|quan mian;
全面__全面 12781.5636505|quan mian;
全民__全民 1276.14264248|quan min;
全名__全名 321.609191441|quan ming;
全副__全副 150.381524744|quan fu;
权当__權當 165.526347625|quan dang;
全党__全黨 441.361118731|quan dang;
劝导__勸導 111.230349808|quan dao;
圈地__圈地 170.127140854|quan di;
全都__全都 1786.58668154|quan dou;
全队__全隊 418.333200332|quan dui;
劝他__勸他 231.446597362|quan ta;
圈套__圈套 303.691826638|quan tao;
全套__全套 1123.81931445|quan tao;
全体__全體 3364.76959766|quan ti;
全天__全天 654.356305043|quan tian;
拳头__拳頭 686.943814365|quan tou;
全能__全能 638.24912322|quan neng;
圈内__圈內 373.484720623|quan nei;
全年__全年 2072.17903804|quan nian;
圈里__圈裡 201.79873775|quan li;
全力__全力 2491.86983978|quan li;
权力__權力 4594.6891828|quan li;
权利__權利 6983.93875396|quan li;
全裸__全裸 344.424970321|quan luo;
劝告__勸告 238.770616634|quan gao;
颧骨__顴骨 117.646076559|quan gu;
全国__全國 20471.9308908|quan guo;
权贵__權貴 229.150692759|quan gui;
全款__全款 119.41857567|quan kuan;
全开__全開 184.941433485|quan kai;
全靠__全靠 374.883606282|quan kao;
拳皇__拳皇 132.266710153|quan huang;
权衡__權衡 411.098117295|quan heng;
全黑__全黑 136.622376491|quan hei;
全会__全會 179.940013424|quan hui;
全军__全軍 323.619340361|quan jun;
拳击__拳擊 324.83145542|quan ji;
全集__全集 791.805264794|quan ji;
全价__全價 142.180598718|quan jia;
全家__全家 1802.23954462|quan jia;
全角__全角 143.247667161|quan jiao;
拳脚__拳腳 200.795341333|quan jiao;
全景__全景 401.979429753|quan jing;
全剧__全劇 127.096048509|quan ju;
全局__全局 1459.98760728|quan ju;
劝劝__勸勸 109.989815613|quan quan;
全权__全權 248.484546245|quan quan;
圈圈__圈圈 417.812212206|quan quan;
圈钱__圈錢 205.094534596|quan qian;
全球__全球 12205.6094005|quan qiu;
全区__全區 1356.49494292|quan qu;
全选__全選 141.121478992|quan xuan;
全系__全系 126.621787068|quan xi;
全息__全息 132.596773978|quan xi;
全线__全線 989.677650042|quan xian;
全县__全縣 1509.94683642|quan xian;
权限__權限 5007.24867861|quan xian;
全校__全校 598.201722298|quan xiao;
全乡__全鄉 124.89791921|quan xiang;
全心__全心 196.096919422|quan xin;
全新__全新 4932.92737822|quan xin;
全站__全站 156.694657831|quan zhan;
全镇__全鎮 289.285174995|quan zhen;
权证__權證 2216.42096948|quan zheng;
全职__全職 465.076726846|quan zhi;
全州__全州 211.057972369|quan zhou;
泉州__泉州 924.118331259|quan zhou;
圈中__圈中 179.71591787|quan zhong;
权重__權重 988.445115058|quan zhong;
全长__全長 242.972837869|quan chang;
全场__全場 1170.99812122|quan chang;
全车__全車 137.991222203|quan che;
全城__全城 250.661599628|quan cheng;
全称__全稱 374.883606282|quan cheng;
全程__全程 1859.27057168|quan cheng;
券商__券商 1966.51263254|quan shang;
全身__全身 4437.13301058|quan shen;
全胜__全勝 159.253810404|quan sheng;
全省__全省 4669.73009873|quan sheng;
权势__權勢 294.376422496|quan shi;
诠释__詮釋 1093.42757174|quan shi;
全是__全是 3563.28598523|quan shi;
全市__全市 5636.55134085|quan shi;
全数__全數 107.015331962|quan shu;
权属__權屬 200.545272755|quan shu;
全书__全書 378.63963681|quan shu;
劝说__勸說 538.749137684|quan shuo;
泉水__泉水 443.014235191|quan shui;
全然__全然 493.129699012|quan ran;
全资__全資 163.272821143|quan zi;
圈子__圈子 2016.1405527|quan zi;
劝阻__勸阻 247.557321202|quan zu;
全村__全村 297.696584607|quan cun;
全速__全速 129.171793682|quan su;
蜷缩__蜷縮 188.430963124|quan suo;
全院__全院 192.945711079|quan yuan;
全员__全員 309.036622663|quan yuan;
权益__權益 2041.42221915|quan yi;
痊愈__痊癒 477.408200926|quan yu;
拳王__拳王 106.748946222|quan wang;
全网__全網 269.114061535|quan wang;
全文__全文 1215.60448872|quan wen;
权威__權威 2698.74816577|quan wei;
劝我__勸我 266.776744296|quan wo;
全无__全無 363.384474622|quan wu;
全额__全額 595.969520633|quan e;
却把__卻把 268.444174826|que ba;
雀斑__雀斑 210.795122809|que ban;
确保__確保 7036.3533641|que bao;
却被__卻被 1112.67124847|que bei;
却不__卻不 1521.27901981|que bu;
却没__卻沒 468.567137655|que mei;
缺乏__缺乏 7268.06705425|que fa;
缺的__缺的 138.680779525|que de;
缺德__缺德 262.162833911|que de;
缺点__缺點 3114.58889818|que dian;
确定__確定 19020.7578385|que ding;
却能__卻能 399.980682268|que neng;
确立__確立 1736.10671918|que li;
却连__卻連 121.066816454|que lian;
缺钙__缺鈣 175.073848088|que gai;
缺口__缺口 1200.55002966|que kou;
却还__卻還 267.775955618|que hai;
缺憾__缺憾 247.249015706|que han;
却很__卻很 490.066643104|que hen;
缺货__缺貨 398.48814637|que huo;
却见__卻見 183.335174792|que jian;
缺钱__缺錢 416.253137598|que qian;
确切__確切 1214.09058664|que qie;
缺血__缺血 162.86639759|que xue;
缺席__缺席 550.284199441|que xi;
缺陷__缺陷 2590.0172328|que xian;
确信__確信 467.983588668|que xin;
缺阵__缺陣 168.020228531|que zhen;
确诊__確診 524.179602378|que zhen;
雀巢__雀巢 246.633556117|que chao;
缺少__缺少 3217.15522047|que shao;
缺省__缺省 396.012952778|que sheng;
缺失__缺失 1012.12795618|que shi;
确是__確是 1202.04704744|que shi;
却是__卻是 5402.72120617|que shi;
确实__確實 18345.6423583|que shi;
却说__卻說 444.673543393|que shuo;
缺水__缺水 424.635962376|que shui;
却让__卻讓 383.865702254|que rang;
缺人__缺人 274.533686805|que ren;
确认__確認 13268.4466908|que ren;
却仍__卻仍 187.027319083|que reng;
却在__卻在 1212.57856995|que zai;
缺损__缺損 223.788782324|que sun;
雀跃__雀躍 133.259374649|que yue;
缺氧__缺氧 515.756221017|que yang;
却要__卻要 443.56664881|que yao;
却也__卻也 692.962351041|que ye;
却以__卻以 137.476305203|que yi;
却已__卻已 214.2378495|que yi;
却因__卻因 242.066179876|que yin;
却有__卻有 705.158077415|que you;
确有__確有 1214.09058664|que you;
却又__卻又 1971.41994959|que you;
缺位__缺位 172.690339006|que wei;
却无__卻無 148.704343794|que wu;
群发__群發 822.992135502|qun fa;
群岛__群島 267.44247003|qun dao;
群体__群體 3625.99770514|qun ti;
群内__群內 106.483223576|qun nei;
群里__群里 1804.48683509|qun li;
群聊__群聊 116.47905068|qun liao;
群落__群落 200.545272755|qun luo;
群号__群號 194.636170786|qun hao;
群集__群集 142.003528374|qun ji;
群星__群星 248.794392378|qun xing;
群雄__群雄 168.439513167|qun xiong;
群中__群中 152.267254161|qun zhong;
群众__群眾 8273.78175582|qun zhong;
群山__群山 257.3078729|qun shan;
裙子__裙子 1476.45426414|qun zi;
群组__群組 560.667124391|qun zu;
群英__群英 128.529517539|qun ying;
群殴__群毆 224.907079496|qun ou;
七八__七八 910.401881269|qi ba;
七百__七百 213.172602547|qi bai;
七宝__七寶 178.59961945|qi bao;
齐备__齊備 158.461958559|qi bei;
奇兵__奇兵 105.821807183|qi bing;
骑兵__騎兵 560.667124391|qi bing;
岂不__豈不 494.9767145|qi bu;
起步__起步 1670.31783317|qi bu;
棋牌__棋牌 112.906187218|qi pai;
气派__氣派 356.210827905|qi pai;
企盼__企盼 173.121277629|qi pan;
棋盘__棋盤 206.376433771|qi pan;
期盼__期盼 1105.75993438|qi pan;
起跑__起跑 148.149450567|qi pao;
气泡__氣泡 305.589986932|qi pao;
旗袍__旗袍 459.889800938|qi pao;
汽配__汽配 167.810977762|qi pei;
欺骗__欺騙 2219.18472069|qi pian;
气魄__氣魄 224.347234118|qi po;
骑马__騎馬 862.9018652|qi ma;
起码__起碼 4716.51701742|qi ma;
期满__期滿 368.85935893|qi man;
气门__氣門 187.727829225|qi men;
启蒙__啟蒙 415.734739962|qi meng;
凄美__凄美 275.905561849|qi mei;
奇妙__奇妙 828.13607043|qi miao;
器皿__器皿 159.85029497|qi min;
齐名__齊名 133.42554153|qi ming;
启明__啟明 142.535402072|qi ming;
其名__其名 164.088713397|qi ming;
起名__起名 339.31275934|qi ming;
期末__期末 746.761352211|qi mo;
其母__其母 127.096048509|qi mu;
启发__啟發 1126.6237397|qi fa;
期房__期房 212.377144726|qi fang;
七分__七分 226.877563077|qi fen;
气愤__氣憤 973.773879211|qi fen;
气氛__氣氛 3902.64021341|qi fen;
起飞__起飛 787.868200695|qi fei;
岐阜__岐阜 142.713135632|qi fu;
其父__其父 243.882891747|qi fu;
祈福__祈福 295.479008313|qi fu;
起伏__起伏 945.081459448|qi fu;
欺负__欺負 3394.2494311|qi fu;
骐达__騏達 126.149295342|qi da;
七大__七大 466.818670029|qi da;
脐带__臍帶 127.254530072|qi dai;
期待__期待 8201.92206694|qi dai;
契丹__契丹 151.321452046|qi dan;
气道__氣道 114.179614083|qi dao;
祈祷__祈禱 1318.16721196|qi dao;
起到__起到 3488.59235612|qi dao;
起得__起得 157.2815571|qi de;
气得__氣得 545.504855178|qi de;
启迪__啟迪 295.847453874|qi di;
七点__七點 532.740555233|qi dian;
起点__起點 2098.16340664|qi dian;
启东__啟東 130.791560815|qi dong;
气动__氣動 220.467143161|qi dong;
起动__起動 242.972837869|qi dong;
启动__啟動 10251.5849767|qi dong;
气度__氣度 287.130256264|qi du;
其它__其它 12560.5061913|qi ta;
其他__其他 52912.181286|qi ta;
乞讨__乞討 386.264972075|qi tao;
奇特__奇特 719.359091341|qi te;
气体__氣體 1255.63548024|qi ti;
七天__七天 668.366611253|qi tian;
起跳__起跳 124.89791921|qi tiao;
期铜__期銅 111.786180106|qi tong;
企图__企圖 1366.67546656|qi tu;
气囊__氣囊 203.566761683|qi nang;
岂能__豈能 321.609191441|qi neng;
气馁__氣餒 173.986383704|qi nei;
期内__期內 604.195219728|qi nei;
七年__七年 978.639934443|qi nian;
起来__起來 37936.2504684|qi lai;
凄厉__凄厲 123.967540162|qi li;
起立__起立 167.393257695|qi li;
气力__氣力 184.941433485|qi li;
气量__氣量 112.34478795|qi liang;
凄凉__凄涼 655.172250234|qi liang;
麒麟__麒麟 479.793862242|qi lin;
欺凌__欺凌 105.821807183|qi ling;
气流__氣流 398.985038482|qi liu;
七楼__七樓 105.164499152|qi lou;
齐鲁__齊魯 224.626982392|qi lu;
起落__起落 125.522047856|qi luo;
气管__氣管 221.568841736|qi guan;
奇观__奇觀 262.817045902|qi guan;
器官__器官 1311.61293778|qi guan;
奇怪__奇怪 8273.78175582|qi guai;
气概__氣概 228.295612376|qi gai;
乞丐__乞丐 868.29524729|qi gai;
旗杆__旗杆 113.895394799|qi gan;
气缸__氣缸 150.944778196|qi gang;
七个__七個 810.776675547|qi ge;
气功__氣功 293.643651968|qi gong;
齐国__齊國 217.736803143|qi guo;
期刊__期刊 1033.79844744|qi kan;
气话__氣話 106.218162376|qi hua;
气化__氣化 146.679837233|qi hua;
企划__企劃 311.744192349|qi hua;
奇幻__奇幻 344.424970321|qi huan;
启航__啟航 142.891090816|qi hang;
七号__七號 285.346757867|qi hao;
旗号__旗號 364.291279287|qi hao;
契合__契合 265.78126155|qi he;
漆黑__漆黑 1150.74567978|qi hei;
其后__其後 795.762002835|qi hou;
气候__氣候 1891.99263098|qi hou;
起哄__起鬨 312.132919672|qi hong;
奇虎__奇虎 295.479008313|qi hu;
起火__起火 323.216307961|qi huo;
期货__期貨 2026.2154289|qi huo;
企及__企及 118.824795093|qi ji;
契机__契機 922.967443217|qi ji;
奇迹__奇迹 2729.18634194|qi ji;
起价__起價 161.250795044|qi jia;
期价__期價 185.634130949|qi jia;
起家__起家 345.284462654|qi jia;
起见__起見 258.271618599|qi jian;
旗舰__旗艦 532.077085292|qi jian;
器件__器件 842.710774091|qi jian;
其间__其間 938.041438335|qi jian;
期间__期間 11019.9799187|qi jian;
起脚__起腳 107.282382453|qi jiao;
起降__起降 129.979154132|qi jiang;
气节__氣節 118.824795093|qi jie;
七届__七屆 148.519148841|qi jie;
起劲__起勁 253.488718522|qi jin;
迄今__迄今 453.063775264|qi jin;
起就__起就 196.341441156|qi jiu;
起居__起居 167.601987591|qi ju;
齐聚__齊聚 252.228305921|qi ju;
器具__器具 418.333200332|qi ju;
弃权__棄權 170.76435144|qi quan;
期权__期權 541.441326411|qi quan;
齐全__齊全 1631.2339687|qi quan;
其妻__其妻 106.748946222|qi qi;
琦琦__琦琦 107.952927857|qi qi;
奇奇__奇奇 124.742372548|qi qi;
琪琪__琪琪 200.29551561|qi qi;
齐齐__齊齊 240.263000901|qi qi;
七七__七七 375.819106356|qi qi;
七千__七千 202.050369328|qi qian;
蹊跷__蹊蹺 189.845141544|qi qiao;
气枪__氣槍 164.703307075|qi qiang;
齐秦__齊秦 226.312812713|qi qin;
乞求__乞求 169.703655326|qi qiu;
祈求__祈求 343.567617462|qi qiu;
气球__氣球 579.852559389|qi qiu;
崎岖__崎嶇 177.269210225|qi qu;
气血__氣血 370.240920313|qi xue;
七喜__七喜 198.308623594|qi xi;
栖息__棲息 219.918349804|qi xi;
七夕__七夕 666.702893247|qi xi;
气息__氣息 2213.66066021|qi xi;
旗下__旗下 1639.38542435|qi xia;
起先__起先 144.863304286|qi xian;
期限__期限 2685.32927986|qi xian;
奇想__奇想 145.043940608|qi xiang;
气象__氣象 1139.33050957|qi xiang;
器械__器械 490.066643104|qi xie;
齐心__齊心 106.483223576|qi xin;
骑行__騎行 208.964318904|qi xing;
七星__七星 309.4219738|qi xing;
气虚__氣虛 106.616002115|qi xu;
期许__期許 138.508067822|qi xu;
欺诈__欺詐 700.778015498|qi zha;
起着__起着 485.205278648|qi zhe;
骑着__騎着 674.222387052|qi zhe;
期指__期指 105.821807183|qi zhi;
岂止__豈止 122.584950132|qi zhi;
岂知__豈知 156.499511818|qi zhi;
旗帜__旗幟 1149.31255222|qi zhi;
气质__氣質 3217.15522047|qi zhi;
器重__器重 123.351140937|qi zhong;
七种__七種 160.449013667|qi zhong;
期中__期中 206.376433771|qi zhong;
其中__其中 26299.0860061|qi zhong;
气喘__氣喘 134.930398555|qi chuan;
起床__起床 2780.68143664|qi chuang;
骑车__騎車 1585.14349339|qi che;
汽车__汽車 11845.9689584|qi che;
启程__啟程 284.281980745|qi cheng;
七成__七成 328.495108513|qi cheng;
期初__期初 160.249192015|qi chu;
起初__起初 682.676889633|qi chu;
骑上__騎上 140.594881376|qi shang;
其身__其身 108.357265155|qi shen;
起身__起身 1214.09058664|qi shen;
齐声__齊聲 156.304608838|qi sheng;
其时__其時 118.972962872|qi shi;
其事__其事 127.096048509|qi shi;
启事__啟事 135.267109459|qi shi;
岂是__豈是 163.884358899|qi shi;
奇石__奇石 168.229740225|qi shi;
七十__七十 444.673543393|qi shi;
起始__起始 701.651845929|qi shi;
气势__氣勢 1172.45828945|qi shi;
启示__啟示 1187.16048834|qi shi;
歧视__歧視 1716.74420026|qi shi;
骑士__騎士 3445.38844293|qi shi;
其实__其實 59636.3665316|qi shi;
旗手__旗手 122.432284019|qi shou;
棋手__棋手 358.437246895|qi shou;
骑术__騎術 196.341441156|qi shu;
汽水__汽水 235.519920202|qi shui;
契税__契稅 279.017397997|qi shui;
奇人__奇人 116.47905068|qi ren;
七人__七人 128.529517539|qi ren;
气人__氣人 172.690339006|qi ren;
其人__其人 325.642053285|qi ren;
七日__七日 260.534419685|qi ri;
奇瑞__奇瑞 896.889021007|qi rui;
骑在__騎在 172.260473089|qi zai;
其子__其子 198.06165195|qi zi;
旗子__旗子 433.727767276|qi zi;
棋子__棋子 539.420927296|qi zi;
妻子__妻子 6066.58738271|qi zi;
奇才__奇才 246.019628549|qi cai;
七彩__七彩 326.048110451|qi cai;
器材__器材 1004.58849796|qi cai;
凄惨__凄慘 303.691826638|qi can;
起草__起草 787.868200695|qi cao;
七次__七次 144.502706249|qi ci;
其次__其次 2321.00870739|qi ci;
七色__七色 114.607273411|qi se;
气色__氣色 167.810977762|qi se;
起色__起色 309.036622663|qi se;
气死__氣死 1205.04668542|qi si;
起诉__起訴 1833.95789167|qi su;
其所__其所 480.991159713|qi suo;
七岁__七歲 200.545272755|qi sui;
起源__起源 880.279644448|qi yuan;
器乐__器樂 105.558392399|qi yue;
契约__契約 635.075580657|qi yue;
七月__七月 1096.15615618|qi yue;
起亚__起亞 140.419785869|qi ya;
欺压__欺壓 142.180598718|qi ya;
气压__氣壓 244.491487214|qi ya;
七夜__七夜 111.507918629|qi ye;
企业__企業 54722.7800718|qi ye;
其意__其意 109.579386421|qi yi;
歧义__歧義 226.595011951|qi yi;
其一__其一 364.291279287|qi yi;
起义__起義 478.003501869|qi yi;
奇异__奇異 539.420927296|qi yi;
起因__起因 359.331706043|qi yin;
汽油__汽油 1062.53280282|qi you;
起用__起用 110.677283245|qi yong;
启用__啟用 1508.06636321|qi yong;
奇遇__奇遇 140.945727665|qi yu;
其余__其餘 2715.6161094|qi yu;
期望__期望 3137.96395466|qi wang;
企稳__企穩 229.436430673|qi wen;
气温__氣溫 1232.38252249|qi wen;
七位__七位 105.0335283|qi wei;
其为__其為 126.149295342|qi wei;
气味__氣味 922.967443217|qi wei;
器物__器物 155.527421199|qi wu;
起舞__起舞 255.073095111|qi wu;
企鹅__企鵝 518.333511609|qi e;
妻儿__妻兒 159.055477247|qi er;
其二__其二 202.807148249|qi er;
恰逢__恰逢 200.29551561|qia feng;
恰当__恰當 1071.84199596|qia dang;
洽谈__洽談 884.6784987|qia tan;
恰好__恰好 870.462027204|qia hao;
掐架__掐架 157.870654598|qia jia;
恰恰__恰恰 1465.45598554|qia qia;
恰巧__恰巧 250.974160423|qia qiao;
恰如__恰如 105.953760973|qia ru;
恰似__恰似 138.335571213|qia si;
掐死__掐死 186.097370046|qia si;
千百__千百 151.132997772|qian bai;
前半__前半 201.79873775|qian ban;
钱包__錢包 1265.05905145|qian bao;
谦卑__謙卑 133.925286409|qian bei;
前辈__前輩 1308.34803192|qian bei;
倩碧__倩碧 164.498187167|qian bi;
钱币__錢幣 230.870473623|qian bi;
铅笔__鉛筆 481.590928402|qian bi;
欠扁__欠扁 125.835280772|qian bian;
前边__前邊 326.454673948|qian bian;
浅薄__淺薄 307.883446338|qian bo;
前部__前部 146.679837233|qian bu;
前排__前排 388.195180646|qian pai;
钱买__錢買 318.418891685|qian mai;
前门__前門 300.679263607|qian men;
千米__千米 194.878871049|qian mi;
前面__前面 11511.2613994|qian mian;
千名__千名 206.89143407|qian ming;
签名__簽名 5223.96273588|qian ming;
签发__簽發 435.352293046|qian fa;
遣返__遣返 147.412812521|qian fan;
前方__前方 1169.53977147|qian fang;
前锋__前鋒 1250.95005139|qian feng;
欠费__欠費 517.687984062|qian fei;
千伏__千伏 141.473639374|qian fu;
前夫__前夫 269.449631503|qian fu;
潜伏__潛伏 364.745529846|qian fu;
前段__前段 448.010827873|qian duan;
前端__前端 939.211122794|qian duan;
签单__簽單 180.613978088|qian dan;
迁到__遷到 163.884358899|qian dao;
签到__簽到 395.027185582|qian dao;
签定__簽定 474.442798491|qian ding;
签订__簽訂 3603.47496171|qian ding;
牵动__牽動 390.621510938|qian dong;
迁都__遷都 117.792774542|qian du;
钱多__錢多 381.006242235|qian duo;
前台__前台 1954.29771596|qian tai;
浅谈__淺談 909.268075561|qian tan;
潜逃__潛逃 205.60633599|qian tao;
嵌套__嵌套 223.510077937|qian tao;
前提__前提 4163.90759438|qian ti;
前田__前田 590.057620516|qian tian;
前天__前天 2266.69928918|qian tian;
欠条__欠條 115.467403456|qian tiao;
潜艇__潛艇 670.869975958|qian ting;
前头__前頭 245.71323808|qian tou;
牵头__牽頭 764.653524665|qian tou;
钱途__錢途 162.663565352|qian tu;
前途__前途 2977.95009215|qian tu;
钱呢__錢呢 124.431860131|qian ne;
潜能__潛能 617.131535882|qian neng;
前年__前年 564.874943184|qian nian;
千年__千年 1829.39274925|qian nian;
前轮__前輪 160.449013667|qian lun;
钱来__錢來 226.877563077|qian lai;
前来__前來 2098.16340664|qian lai;
欠了__欠了 204.584007193|qian le;
千里__千里 1181.25761405|qian li;
潜力__潛力 2708.85631718|qian li;
牵连__牽連 315.260239073|qian lian;
前两__前兩 236.402059204|qian liang;
前列__前列 737.513205869|qian lie;
千龙__千龍 118.676811842|qian long;
乾隆__乾隆 504.944935018|qian long;
前路__前路 131.117943492|qian lu;
牵挂__牽挂 898.007390736|qian gua;
千古__千古 565.579310193|qian gu;
钱柜__錢櫃 219.37092252|qian gui;
前款__前款 154.754097942|qian kuan;
欠款__欠款 384.823616623|qian kuan;
乾坤__乾坤 404.491915522|qian kun;
千克__千克 253.173026121|qian ke;
谦和__謙和 107.550099352|qian he;
前后__前後 3102.96674755|qian hou;
前几__前幾 196.586267794|qian ji;
千家__千家 116.624293448|qian jia;
欠佳__欠佳 259.885889675|qian jia;
钱江__錢江 146.314717429|qian jiang;
千斤__千斤 120.164975734|qian jin;
千金__千金 535.402718412|qian jin;
前进__前進 2457.94475925|qian jin;
前景__前景 2529.4132684|qian jing;
钱就__錢就 244.491487214|qian jiu;
前就__前就 313.302012384|qian jiu;
迁就__遷就 343.139741671|qian jiu;
迁居__遷居 108.087539034|qian ju;
欠缺__欠缺 788.850627646|qian que;
前妻__前妻 442.462509543|qian qi;
前期__前期 3820.83303827|qian qi;
倩倩__倩倩 126.306596357|qian qian;
纤纤__纖纖 143.605133321|qian qian;
芊芊__芊芊 163.680258901|qian qian;
浅浅__淺淺 206.119414554|qian qian;
钱钱__錢錢 256.347723437|qian qian;
千千__千千 327.26932246|qian qian;
牵强__牽強 279.713669565|qian qiang;
千秋__千秋 316.83562918|qian qiu;
前去__前去 627.992684885|qian qu;
千寻__千尋 137.134095104|qian xun;
谦逊__謙遜 168.859844103|qian xun;
前戏__前戲 140.945727665|qian xi;
迁徙__遷徙 330.548296374|qian xi;
浅析__淺析 452.499534015|qian xi;
前夕__前夕 692.962351041|qian xi;
欠下__欠下 153.218967809|qian xia;
签下__簽下 361.12732612|qian xia;
前先__前先 152.457122789|qian xian;
浅显__淺顯 183.792676978|qian xian;
前线__前線 686.088301175|qian xian;
浅笑__淺笑 113.187937993|qian xiao;
前些__前些 507.468200425|qian xie;
欠薪__欠薪 171.831677206|qian xin;
潜心__潛心 288.924902033|qian xin;
潜行__潛行 267.775955618|qian xing;
前行__前行 771.352901218|qian xing;
前胸__前胸 105.295633316|qian xiong;
谦虚__謙虛 1408.16736736|qian xu;
前传__前傳 123.504952812|qian zhuan;
钱庄__錢莊 138.335571213|qian zhuang;
欠债__欠債 174.203334854|qian zhai;
前瞻__前瞻 213.704562287|qian zhan;
签章__簽章 134.42690308|qian zhang;
前兆__前兆 187.727829225|qian zhao;
千兆__千兆 231.446597362|qian zhao;
牵着__牽着 712.223191016|qian zhe;
前者__前者 1880.24059249|qian zhe;
签证__簽證 2615.96711065|qian zheng;
迁至__遷至 106.218162376|qian zhi;
牵制__牽制 291.456266438|qian zhi;
潜质__潛質 370.240920313|qian zhi;
前置__前置 446.339066527|qian zhi;
签注__簽注 118.08671951|qian zhu;
前缀__前綴 302.558594526|qian zhui;
前场__前場 418.333200332|qian chang;
牵扯__牽扯 472.083744072|qian che;
前程__前程 362.479927203|qian cheng;
虔诚__虔誠 566.284555508|qian cheng;
迁出__遷出 142.180598718|qian chu;
千山__千山 198.308623594|qian shan;
牵涉__牽涉 480.392137969|qian she;
前身__前身 503.060722916|qian shen;
前生__前生 154.368879448|qian sheng;
钱是__錢是 186.794397067|qian shi;
前十__前十 228.8653107|qian shi;
前世__前世 576.969379906|qian shi;
签售__簽售 217.465635832|qian shou;
签收__簽收 382.910172354|qian shou;
牵手__牽手 659.267263146|qian shou;
前述__前述 226.030964922|qian shu;
签署__簽署 2263.87636378|qian shu;
潜水__潛水 1689.15672637|qian shui;
谦让__謙讓 126.464093517|qian rang;
前人__前人 357.099731154|qian ren;
千人__千人 417.291872914|qian ren;
前任__前任 494.360275282|qian ren;
前日__前日 325.642053285|qian ri;
迁入__遷入 207.925293333|qian ru;
潜入__潛入 383.865702254|qian ru;
嵌入__嵌入 570.534533242|qian ru;
潜在__潛在 2224.72256613|qian zai;
谴责__譴責 1044.15627174|qian ze;
钳子__鉗子 124.587019602|qian zi;
千字__千字 128.369448119|qian zi;
签字__簽字 2249.81438398|qian zi;
前奏__前奏 252.85772688|qian zou;
前作__前作 146.862738669|qian zuo;
钱财__錢財 601.191002133|qian cai;
潜藏__潛藏 165.114314527|qian cang;
千层__千層 112.484875527|qian ceng;
浅层__淺層 160.649084484|qian ceng;
前次__前次 109.716025699|qian ci;
前三__前三 326.048110451|qian san;
浅色__淺色 252.85772688|qian se;
遣送__遣送 116.044406778|qian song;
千元__千元 916.092151969|qian yuan;
签约__簽約 2297.98475873|qian yue;
前言__前言 334.276427588|qian yan;
前沿__前沿 805.740567825|qian yan;
前夜__前夜 211.057972369|qian ye;
前移__前移 118.08671951|qian yi;
浅议__淺議 176.827946446|qian yi;
千亿__千億 221.568841736|qian yi;
歉意__歉意 465.65665114|qian yi;
前一__前一 538.078184713|qian yi;
迁移__遷移 1206.54931027|qian yi;
牵引__牽引 517.043260448|qian yin;
倩影__倩影 110.815291538|qian ying;
千余__千餘 292.183578474|qian yu;
千瓦__千瓦 136.282292017|qian wa;
前晚__前晚 246.326401069|qian wan;
千万__千萬 4031.15780176|qian wan;
迁往__遷往 128.689786556|qian wang;
前往__前往 3445.38844293|qian wang;
前文__前文 149.820373083|qian wen;
前卫__前衛 735.677366107|qian wei;
前五__前五 107.550099352|qian wu;
前额__前額 125.835280772|qian e;
峭壁__峭壁 110.95347192|qiao bi;
壳牌__殼牌 120.164975734|qiao pai;
俏皮__俏皮 213.438416689|qiao pi;
荞麦__蕎麥 109.30661816|qiao mai;
窍门__竅門 246.94109417|qiao men;
敲门__敲門 469.736419493|qiao men;
桥面__橋面 115.899886195|qiao mian;
巧妙__巧妙 1019.7239982|qiao miao;
乔木__喬木 147.964946673|qiao mu;
乔峰__喬峰 138.680779525|qiao feng;
桥段__橋段 147.596627936|qiao duan;
敲打__敲打 358.437246895|qiao da;
乔丹__喬丹 562.066236349|qiao dan;
敲定__敲定 402.480675297|qiao ding;
桥头__橋頭 239.068350048|qiao tou;
敲了__敲了 205.862715427|qiao le;
俏丽__俏麗 115.036534536|qiao li;
桥梁__橋樑 1217.12027856|qiao liang;
敲开__敲開 145.224802174|qiao kai;
巧合__巧合 678.436468738|qiao he;
敲击__敲擊 240.263000901|qiao ji;
瞧见__瞧見 134.930398555|qiao jian;
翘起__翹起 170.977284899|qiao qi;
翘翘__翹翹 112.484875527|qiao qiao;
瞧瞧__瞧瞧 705.158077415|qiao qiao;
悄悄__悄悄 2143.08680935|qiao qiao;
桥下__橋下 189.845141544|qiao xia;
敲响__敲響 297.325836157|qiao xiang;
敲诈__敲詐 429.960742313|qiao zha;
瞧着__瞧着 143.784200776|qiao zhe;
桥镇__橋鎮 158.067510349|qiao zhen;
乔治__喬治 370.702589737|qiao zhi;
桥上__橋上 305.97104031|qiao shang;
翘首__翹首 134.092283643|qiao shou;
悄然__悄然 844.813709452|qiao ran;
憔悴__憔悴 615.595353746|qiao cui;
巧遇__巧遇 136.282292017|qiao yu;
枪版__槍版 116.915322539|qiang ban;
强暴__強暴 375.819106356|qiang bao;
枪毙__槍斃 418.854838101|qiang bi;
墙壁__牆壁 1031.22508566|qiang bi;
墙边__牆邊 109.989815613|qiang bian;
强迫__強迫 1392.46230328|qiang po;
墙面__牆面 563.46883971|qiang mian;
枪法__槍法 107.14877401|qiang fa;
抢断__搶斷 151.321452046|qiang duan;
强大__強大 7204.94222781|qiang da;
抢到__搶到 405.501301397|qiang dao;
强盗__強盜 592.267679181|qiang dao;
强敌__強敵 147.229226029|qiang di;
腔调__腔調 236.991986692|qiang diao;
强调__強調 7744.97981009|qiang diao;
强度__強度 2082.53394472|qiang du;
抢夺__搶奪 396.506758465|qiang duo;
强队__強隊 380.057830188|qiang dui;
抢滩__搶灘 108.357265155|qiang tan;
墙体__牆體 328.904723278|qiang ti;
墙头__牆頭 118.972962872|qiang tou;
腔内__腔內 128.369448119|qiang nei;
抢了__搶了 474.442798491|qiang le;
强力__強力 1172.45828945|qiang li;
强烈__強烈 7479.39723763|qiang lie;
枪管__槍管 134.092283643|qiang guan;
强光__強光 178.377193209|qiang guang;
抢购__搶購 341.433560596|qiang gou;
强攻__強攻 175.510734618|qiang gong;
抢过__搶過 148.519148841|qiang guo;
强国__強國 721.154209805|qiang guo;
枪口__槍口 219.644465616|qiang kou;
强化__強化 4365.82984783|qiang hua;
强悍__強悍 1169.53977147|qiang han;
羟基__羥基 110.95347192|qiang ji;
枪击__槍擊 256.987424161|qiang ji;
强加__強加 308.651751439|qiang jia;
强健__強健 195.60878915|qiang jian;
强奸__強姦 1729.62840231|qiang jian;
墙角__牆角 465.65665114|qiang jiao;
抢劫__搶劫 1293.75623683|qiang jie;
强劲__強勁 627.992684885|qiang jin;
强劲__強勁 1411.68136652|qiang jing;
抢救__搶救 1326.40613196|qiang jiu;
强权__強權 206.89143407|qiang quan;
抢钱__搶錢 271.133768339|qiang qian;
强强__強強 359.779772295|qiang qiang;
强求__強求 536.738784525|qiang qiu;
抢险__搶險 467.400766428|qiang xian;
抢先__搶先 515.756221017|qiang xian;
强效__強效 241.162905094|qiang xiao;
强项__強項 425.165459331|qiang xiang;
枪械__槍械 130.791560815|qiang xie;
强行__強行 1438.31738787|qiang xing;
抢修__搶修 265.78126155|qiang xiu;
强壮__強壯 617.131535882|qiang zhuang;
枪战__槍戰 149.447435764|qiang zhan;
抢占__搶佔 571.958268741|qiang zhan;
抢着__搶着 314.083839199|qiang zhe;
强者__強者 527.455873984|qiang zhe;
墙纸__牆紙 256.347723437|qiang zhi;
枪支__槍支 348.309611377|qiang zhi;
强制__強制 2028.7420046|qiang zhi;
抢注__搶注 265.78126155|qiang zhu;
枪杀__槍殺 209.746993999|qiang sha;
墙上__牆上 1370.08592511|qiang shang;
强身__強身 182.423584067|qiang shen;
强省__強省 166.146325956|qiang sheng;
枪声__槍聲 195.852702213|qiang sheng;
强盛__強盛 228.580284053|qiang sheng;
强生__強生 253.488718522|qiang sheng;
强市__強市 125.678566729|qiang shi;
强势__強勢 2297.98475873|qiang shi;
抢手__搶手 247.866011137|qiang shou;
枪手__槍手 931.053859154|qiang shou;
强忍__強忍 205.862715427|qiang ren;
强人__強人 677.591550514|qiang ren;
强弱__強弱 317.626273928|qiang ruo;
抢走__搶走 446.339066527|qiang zou;
抢眼__搶眼 361.12732612|qiang yan;
强硬__強硬 732.019384688|qiang ying;
强于__強於 249.104624871|qiang yu;
蔷薇__薔薇 557.879339939|qiang wei;
且不__且不 211.057972369|qie bu;
切片__切片 358.884197808|qie pian;
切莫__切莫 129.332863581|qie mo;
切断__切斷 510.640021015|qie duan;
窃听__竊聽 160.649084484|qie ting;
切尼__切尼 105.690017726|qie ni;
怯懦__怯懦 108.763116896|qie nuo;
切割__切割 681.82669043|qie ge;
切开__切開 266.112675706|qie kai;
切口__切口 220.742053181|qie kou;
切换__切換 2235.83974961|qie huan;
切合__切合 236.402059204|qie he;
切记__切記 403.48504224|qie ji;
切忌__切忌 412.637883794|qie ji;
切切__切切 125.209594649|qie qie;
窃取__竊取 287.130256264|qie qu;
窃喜__竊喜 144.863304286|qie xi;
切削__切削 205.350275845|qie xiao;
切成__切成 644.643863216|qie cheng;
切除__切除 624.870140032|qie chu;
切身__切身 237.287502254|qie shen;
切实__切實 2770.30526836|qie shi;
切入__切入 384.344361008|qie ru;
窃贼__竊賊 108.222318063|qie zei;
茄子__茄子 602.691239054|qie zi;
切磋__切磋 371.627656329|qie cuo;
切碎__切碎 149.261315371|qie sui;
惬意__愜意 670.869975958|qie yi;
且有__且有 283.221176861|qie you;
切勿__切勿 299.93080386|qie wu;
亲笔__親筆 156.499511818|qin bi;
亲朋__親朋 139.373782642|qin peng;
钦佩__欽佩 318.022335873|qin pei;
亲们__親們 124.431860131|qin men;
亲密__親密 1172.45828945|qin mi;
勤勉__勤勉 111.369047744|qin mian;
亲民__親民 153.218967809|qin min;
侵犯__侵犯 1901.44712636|qin fan;
勤奋__勤奮 945.081459448|qin fen;
侵吞__侵吞 133.925286409|qin tun;
亲昵__親昵 224.347234118|qin ni;
侵略__侵略 765.607004232|qin lue;
勤劳__勤勞 710.450303909|qin lao;
亲了__親了 141.826678552|qin le;
禽类__禽類 148.889769675|qin lei;
亲历__親歷 237.287502254|qin li;
亲临__親臨 364.291279287|qin lin;
秦岭__秦嶺 222.953710017|qin ling;
秦国__秦國 276.249600432|qin guo;
勤快__勤快 506.83620443|qin kuai;
亲口__親口 269.785619908|qin kou;
秦淮__秦淮 127.096048509|qin huai;
侵害__侵害 1066.51251556|qin hai;
秦汉__秦漢 200.04606951|qin han;
亲和__親和 112.204874836|qin he;
秦桧__秦檜 135.94305409|qin hui;
亲近__親近 793.781168439|qin jin;
侵权__侵權 1109.90155418|qin quan;
亲戚__親戚 2681.98499671|qin qi;
亲切__親切 1854.64242019|qin qie;
亲亲__親親 2353.04376718|qin qin;
亲情__親情 1223.20236253|qin qing;
侵袭__侵襲 362.028498203|qin xi;
琴弦__琴弦 187.027319083|qin xian;
亲信__親信 156.694657831|qin xin;
侵占__侵佔 365.20034683|qin zhan;
钦州__欽州 122.890853693|qin zhou;
秦朝__秦朝 115.323601467|qin chao;
亲身__親身 545.504855178|qin shen;
琴声__琴聲 189.608710238|qin sheng;
亲生__親生 341.433560596|qin sheng;
侵蚀__侵蝕 461.61231651|qin shi;
寝室__寢室 3607.96829056|qin shi;
亲手__親手 795.762002835|qin shou;
禽兽__禽獸 857.541983893|qin shou;
亲属__親屬 760.851466162|qin shu;
亲热__親熱 548.914415679|qin re;
亲人__親人 1998.62991039|qin ren;
侵入__侵入 472.083744072|qin ru;
亲子__親子 256.028470459|qin zi;
亲自__親自 3666.89398377|qin zi;
芹菜__芹菜 330.136634719|qin cai;
亲眼__親眼 524.833224606|qin yan;
亲友__親友 706.037369534|qin you;
勤于__勤於 113.753550575|qin yu;
秦王__秦王 201.547419552|qin wang;
亲王__親王 315.653350706|qin wang;
亲吻__親吻 707.799244422|qin wen;
亲爱__親愛 3541.1527732|qin ai;
请把__請把 318.418891685|qing ba;
清白__清白 483.997491267|qing bai;
情报__情報 1643.47641462|qing bao;
轻便__輕便 241.764712994|qing bian;
请别__請別 143.784200776|qing bie;
轻薄__輕薄 449.688850794|qing bo;
清贫__清貧 153.984619852|qing pin;
青浦__青浦 251.600451735|qing pu;
青梅__青梅 107.684208225|qing mei;
轻蔑__輕蔑 176.60772663|qing mie;
清明__清明 534.069978074|qing ming;
清末__清末 236.991986692|qing mo;
倾慕__傾慕 120.46484039|qing mu;
请发__請發 135.435779871|qing fa;
轻风__輕風 113.187937993|qing feng;
清风__清風 1065.18429118|qing feng;
轻抚__輕撫 120.615053212|qing fu;
轻浮__輕浮 168.020228531|qing fu;
情妇__情婦 420.94790182|qing fu;
清代__清代 618.67155147|qing dai;
清淡__清淡 620.98878351|qing dan;
清单__清單 2289.40978274|qing dan;
倾倒__傾倒 316.441045148|qing dao;
请到__請到 869.377962205|qing dao;
青岛__青島 4757.8399467|qing dao;
情敌__情敵 229.436430673|qing di;
轻点__輕點 168.229740225|qing dian;
清点__清點 204.07475061|qing dian;
庆典__慶典 524.833224606|qing dian;
情调__情調 605.702953498|qing diao;
清毒__清毒 180.613978088|qing du;
轻度__輕度 439.714170908|qing du;
请多__請多 151.321452046|qing duo;
请她__請她 202.302314677|qing ta;
请他__請他 476.813641365|qing ta;
青苔__青苔 122.279808036|qing tai;
清汤__清湯 109.852835359|qing tang;
青天__青天 223.510077937|qing tian;
晴天__晴天 614.062995519|qing tian;
请帖__請帖 108.627664361|qing tie;
清廷__清廷 109.716025699|qing ting;
蜻蜓__蜻蜓 315.260239073|qing ting;
倾听__傾聽 815.844260376|qing ting;
青铜__青銅 401.979429753|qing tong;
请你__請你 3449.68464686|qing ni;
青年__青年 5276.30261733|qing nian;
青鸟__青鳥 225.749468142|qing niao;
请您__請您 4652.30490767|qing nin;
情侣__情侶 1629.20244568|qing lv;
请来__請來 648.673070715|qing lai;
青睐__青睞 1359.87999657|qing lai;
晴朗__晴朗 353.557372243|qing lang;
清冷__清冷 194.393772779|qing leng;
清丽__清麗 148.334184528|qing li;
情理__情理 180.164388413|qing li;
倾力__傾力 199.548108896|qing li;
清理__清理 3594.50508488|qing li;
清廉__清廉 169.915266157|qing lian;
清亮__清亮 137.305093541|qing liang;
清凉__清涼 710.450303909|qing liang;
清零__清零 175.948711373|qing ling;
青楼__青樓 182.423584067|qing lou;
青龙__青龍 414.183417482|qing long;
清关__清關 118.381397999|qing guan;
清官__清官 119.41857567|qing guan;
情感__情感 4829.52331536|qing gan;
清高__清高 293.643651968|qing gao;
情歌__情歌 670.869975958|qing ge;
请给__請給 127.096048509|qing gei;
庆功__慶功 106.218162376|qing gong;
轻功__輕功 153.028150386|qing gong;
清宫__清宮 180.164388413|qing gong;
轻工__輕工 214.2378495|qing gong;
轻轨__輕軌 381.006242235|qing gui;
轻狂__輕狂 250.037645335|qing kuang;
情况__情況 50151.4999726|qing kuang;
轻快__輕快 336.785179346|qing kuai;
请看__請看 688.658042404|qing kan;
请客__請客 2033.8046114|qing ke;
晴空__晴空 151.510141313|qing kong;
清空__清空 692.099342424|qing kong;
青花__青花 144.682892926|qing hua;
情话__情話 171.190483873|qing hua;
清华__清華 2473.3076131|qing hua;
情怀__情懷 788.850627646|qing huai;
青海__青海 988.445115058|qing hai;
庆贺__慶賀 258.271618599|qing he;
清河__清河 310.580912674|qing he;
清军__清軍 141.650048976|qing jun;
情急__情急 144.863304286|qing ji;
请加__請加 159.055477247|qing jia;
请假__請假 2461.00967693|qing jia;
请柬__請柬 146.497163581|qing jian;
请见__請見 263.801426189|qing jian;
青椒__青椒 241.764712994|qing jiao;
请教__請教 3302.45784674|qing jiao;
清江__清江 105.558392399|qing jiang;
请将__請將 478.003501869|qing jiang;
情结__情結 731.107734818|qing jie;
清洁__清潔 2321.00870739|qing jie;
情节__情節 3185.24167512|qing jie;
请进__請進 384.344361008|qing jin;
清静__清靜 324.426913464|qing jing;
情境__情境 472.083744072|qing jing;
清净__清凈 538.749137684|qing jing;
情景__情景 1829.39274925|qing jing;
清泉__清泉 275.561951728|qing quan;
氢气__氫氣 163.272821143|qing qi;
清欠__清欠 202.807148249|qing qian;
轻巧__輕巧 317.626273928|qing qiao;
倾情__傾情 222.953710017|qing qing;
清清__清清 344.424970321|qing qing;
青青__青青 645.447697543|qing qing;
轻轻__輕輕 4963.75957739|qing qing;
清秋__清秋 126.306596357|qing qiu;
请求__請求 4311.76192745|qing qiu;
情趣__情趣 759.903909096|qing qu;
情系__情系 142.003528374|qing xi;
清洗__清洗 1762.26354231|qing xi;
清晰__清晰 4853.65697483|qing xi;
清闲__清閑 491.902185928|qing xian;
请先__請先 525.487661863|qing xian;
倾销__傾銷 168.439513167|qing xiao;
请向__請向 182.423584067|qing xiang;
清香__清香 551.657401419|qing xiang;
倾向__傾向 2749.66894397|qing xiang;
倾泻__傾瀉 123.813152185|qing xie;
倾斜__傾斜 1026.09756322|qing xie;
清心__清心 123.197520618|qing xin;
倾心__傾心 241.162905094|qing xin;
轻信__輕信 483.997491267|qing xin;
清新__清新 1390.72814418|qing xin;
轻型__輕型 278.322859608|qing xing;
庆幸__慶幸 942.728934628|qing xing;
清醒__清醒 2367.75095999|qing xing;
情形__情形 2430.53169682|qing xing;
清秀__清秀 404.996293994|qing xiu;
情绪__情緒 6408.51491624|qing xu;
清真__清真 115.611384758|qing zhen;
清蒸__清蒸 139.72158175|qing zheng;
轻质__輕質 108.763116896|qing zhi;
青州__青州 114.037415895|qing zhou;
轻重__輕重 335.528458728|qing zhong;
倾注__傾注 254.121284766|qing zhu;
庆祝__慶祝 2213.66066021|qing zhu;
清纯__清純 974.988119996|qing chun;
青春__青春 4409.57193181|qing chun;
清茶__清茶 164.703307075|qing cha;
清查__清查 417.291872914|qing cha;
情场__情場 161.653186955|qing chang;
清偿__清償 235.813600182|qing chang;
清朝__清朝 758.012333731|qing chao;
清澈__清澈 744.902491688|qing che;
清晨__清晨 1096.15615618|qing chen;
倾城__傾城 294.376422496|qing cheng;
情仇__情仇 129.655606164|qing chou;
清除__清除 6644.34681247|qing chu;
清楚__清楚 17540.8084783|qing chu;
清爽__清爽 919.523371782|qing shuang;
轻率__輕率 129.655606164|qing shuai;
青山__青山 760.851466162|qing shan;
轻伤__輕傷 155.72135507|qing shang;
情商__情商 253.173026121|qing shang;
情深__情深 237.879639313|qing shen;
情圣__情聖 115.179978568|qing sheng;
轻生__輕生 115.611384758|qing sheng;
庆生__慶生 123.658956482|qing sheng;
轻声__輕聲 475.626742696|qing sheng;
青石__青石 122.890853693|qing shi;
情事__情事 129.817279349|qing shi;
情势__情勢 201.045721733|qing shi;
轻视__輕視 389.649164279|qing shi;
请示__請示 731.107734818|qing shi;
情书__情書 714.89082038|qing shu;
请说__請說 111.091824605|qing shuo;
清水__清水 1209.56018338|qing shui;
清热__清熱 298.439468992|qing re;
请人__請人 265.119670945|qing ren;
情人__情人 3506.02523602|qing ren;
轻柔__輕柔 458.173712968|qing rou;
请在__請在 1338.02720458|qing zai;
青藏__青藏 146.132498493|qing zang;
清早__清早 148.334184528|qing zao;
青菜__青菜 641.438524323|qing cai;
清仓__清倉 507.468200425|qing cang;
青草__青草 258.593668656|qing cao;
情操__情操 291.093289619|qing cao;
青翠__青翠 139.547573842|qing cui;
清脆__清脆 358.884197808|qing cui;
清算__清算 723.855290267|qing suan;
清扫__清掃 304.070513117|qing sao;
青色__青色 283.221176861|qing se;
青涩__青澀 309.036622663|qing se;
情色__情色 783.950712715|qing se;
青丝__青絲 136.452228303|qing si;
青松__青松 162.056583012|qing song;
轻松__輕鬆 8019.99283537|qing song;
情愫__情愫 210.270405333|qing su;
倾诉__傾訴 765.607004232|qing su;
请愿__請願 114.893269147|qing yuan;
清远__清遠 288.205701591|qing yuan;
情缘__情緣 557.879339939|qing yuan;
情愿__情願 781.999279332|qing yuan;
青云__青雲 440.262469534|qing yun;
清雅__清雅 135.435779871|qing ya;
青烟__青煙 130.46599058|qing yan;
轻言__輕言 137.819369268|qing yan;
情义__情義 147.412812521|qing yi;
青衣__青衣 191.98633424|qing yi;
情意__情意 268.778909483|qing yi;
情谊__情誼 336.785179346|qing yi;
请以__請以 538.078184713|qing yi;
轻易__輕易 2712.23410734|qing yi;
轻盈__輕盈 437.527796363|qing ying;
清幽__清幽 133.591915611|qing you;
请用__請用 2335.51567197|qing yong;
请于__請於 112.625137786|qing yu;
请与__請與 337.205131359|qing yu;
情欲__情慾 402.480675297|qing yu;
青蛙__青蛙 1132.25360251|qing wa;
请问__請問 9336.85843203|qing wen;
轻微__輕微 1067.84239617|qing wei;
请我__請我 983.530305889|qing wo;
请勿__請勿 1601.02534912|qing wu;
情爱__情愛 303.313611771|qing ai;
请安__請安 115.323601467|qing an;
请按__請按 157.085680168|qing an;
穷得__窮得 120.765453341|qiong de;
穷困__窮困 117.792774542|qiong kun;
穷苦__窮苦 123.967540162|qiong ku;
穷人__窮人 1782.13945694|qiong ren;
琼斯__瓊斯 271.810366771|qiong si;
琼瑶__瓊瑤 392.573489614|qiong yao;
球拍__球拍 211.057972369|qiu pai;
球门__球門 310.580912674|qiu men;
球迷__球迷 3902.64021341|qiu mi;
囚犯__囚犯 276.938965124|qiu fan;
秋风__秋風 733.846096172|qiu feng;
求得__求得 333.029068427|qiu de;
秋冬__秋冬 451.373158744|qiu dong;
球队__球隊 4793.54763754|qiu dui;
秋田__秋田 149.820373083|qiu tian;
秋天__秋天 1868.56155133|qiu tian;
求你__求你 353.557372243|qiu ni;
丘陵__丘陵 240.862563142|qiu ling;
求购__求購 804.737106306|qiu gou;
求婚__求婚 584.204365283|qiu hun;
球技__球技 175.510734618|qiu ji;
秋季__秋季 960.516622856|qiu ji;
求教__求教 304.070513117|qiu jiao;
求解__求解 391.596284031|qiu jie;
囚禁__囚禁 181.516526012|qiu jin;
求救__求救 408.035799866|qiu jiu;
秋千__鞦韆 268.444174826|qiu qian;
求情__求情 127.73116145|qiu qing;
秋秋__秋秋 156.304608838|qiu qiu;
求求__求求 211.584655172|qiu qiu;
球球__球球 329.314848809|qiu qiu;
求学__求學 486.416079992|qiu xue;
球鞋__球鞋 257.3078729|qiu xie;
球形__球形 157.085680168|qiu xing;
球星__球星 791.805264794|qiu xing;
酋长__酋長 258.593668656|qiu zhang;
丘疹__丘疹 125.678566729|qiu zhen;
求证__求證 351.361264404|qiu zheng;
求知__求知 160.449013667|qiu zhi;
求职__求職 1254.07172395|qiu zhi;
求助__求助 1546.12469848|qiu zhu;
球场__球場 1476.45426414|qiu chang;
求出__求出 124.122120652|qiu chu;
求生__求生 224.06783424|qiu sheng;
求实__求實 119.26985293|qiu shi;
球手__球手 110.677283245|qiu shou;
秋水__秋水 459.889800938|qiu shui;
求饶__求饒 124.276893895|qiu rao;
求人__求人 131.773154284|qiu ren;
秋日__秋日 235.226605969|qiu ri;
求租__求租 260.534419685|qiu zu;
球赛__球賽 341.433560596|qiu sai;
秋色__秋色 135.267109459|qiu se;
求索__求索 126.306596357|qiu suo;
球员__球員 5580.63786311|qiu yuan;
秋月__秋月 213.704562287|qiu yue;
秋叶__秋葉 153.984619852|qiu ye;
求医__求醫 130.791560815|qiu yi;
球衣__球衣 405.501301397|qiu yi;
蚯蚓__蚯蚓 228.580284053|qiu yin;
秋雨__秋雨 335.110594827|qiu yu;
球王__球王 170.977284899|qiu wang;
求爱__求愛 165.73274959|qiu ai;
去把__去把 116.915322539|qu ba;
去吧__去吧 3185.24167512|qu ba;
祛斑__祛斑 165.114314527|qu ban;
去办__去辦 196.586267794|qu ban;
区别__區別 8040.00625758|qu bie;
去皮__去皮 232.893204426|qu pi;
去吗__去嗎 230.582949765|qu ma;
去买__去買 1689.15672637|qu mai;
曲面__曲面 204.07475061|qu mian;
取名__取名 533.404852483|qu ming;
曲目__曲目 564.874943184|qu mu;
区分__區分 1882.58514584|qu fen;
曲风__曲風 256.987424161|qu feng;
曲阜__曲阜 137.134095104|qu fu;
屈服__屈服 399.482550191|qu fu;
区段__區段 125.522047856|qu duan;
去打__去打 395.027185582|qu da;
取代__取代 1829.39274925|qu dai;
去到__去到 234.64107292|qu dao;
渠道__渠道 6013.89768231|qu dao;
去的__去的 468.567137655|qu de;
取得__取得 12513.6364118|qu de;
取缔__取締 479.196331601|qu di;
曲调__曲調 226.312812713|qu diao;
去掉__去掉 2952.08591378|qu diao;
驱动__驅動 5939.41952983|qu dong;
娶她__娶她 147.229226029|qu ta;
躯体__軀體 401.979429753|qu ti;
去听__去聽 265.78126155|qu ting;
趋同__趨同 121.368931601|qu tong;
取暖__取暖 375.819106356|qu nuan;
去那__去那 147.964946673|qu na;
去拿__去拿 314.475483928|qu na;
去哪__去哪 1012.12795618|qu na;
区内__區內 884.6784987|qu nei;
去呢__去呢 113.753550575|qu ni;
娶你__娶你 172.905674062|qu ni;
去年__去年 13006.5115898|qu nian;
娶了__娶了 370.702589737|qu le;
去了__去了 12513.6364118|qu le;
区里__區里 122.279808036|qu li;
去留__去留 145.768741141|qu liu;
去逛__去逛 164.293322714|qu guang;
躯干__軀幹 123.658956482|qu gan;
去干__去干 128.369448119|qu gan;
驱赶__驅趕 187.26053154|qu gan;
娶个__娶個 152.267254161|qu ge;
去跟__去跟 146.497163581|qu gen;
去给__去給 180.164388413|qu gei;
去过__去過 3415.46445546|qu guo;
取款__取款 335.528458728|qu kuan;
区块__區塊 195.60878915|qu kuai;
去看__去看 3563.28598523|qu kan;
区划__區劃 181.742866823|qu hua;
趋缓__趨緩 120.164975734|qu huan;
去换__去換 139.547573842|qu huan;
区号__區號 400.479435488|qu hao;
取货__取貨 141.826678552|qu huo;
取回__取回 254.755429543|qu hui;
取决__取決 1532.69625148|qu jue;
区级__區級 159.253810404|qu ji;
去见__去見 382.910172354|qu jian;
区间__區間 1224.72762648|qu jian;
曲解__曲解 175.729586548|qu jie;
去接__去接 333.860122955|qu jie;
曲靖__曲靖 128.689786556|qu jing;
取经__取經 296.585723861|qu jing;
取景__取景 302.935867929|qu jing;
取其__取其 184.02185602|qu qi;
取钱__取錢 371.164834837|qu qian;
蛐蛐__蛐蛐 115.179978568|qu qu;
去取__去取 150.569041974|qu qu;
区区__區區 425.165459331|qu qu;
取下__取下 373.484720623|qu xia;
取现__取現 157.67404401|qu xian;
区县__區縣 545.504855178|qu xian;
曲线__曲線 1996.14083601|qu xian;
取笑__取笑 292.54791482|qu xiao;
取消__取消 6992.64732939|qu xiao;
去向__去向 523.526794166|qu xiang;
取向__取向 546.185068786|qu xiang;
去想__去想 564.874943184|qu xiang;
趋向__趨向 600.442284667|qu xiang;
去抓__去抓 124.431860131|qu zhua;
区长__區長 480.991159713|qu zhang;
去找__去找 2421.46211928|qu zhao;
曲折__曲折 776.174076244|qu zhe;
取证__取證 333.860122955|qu zheng;
取之__取之 131.937467932|qu zhi;
取值__取值 204.07475061|qu zhi;
衢州__衢州 231.735198139|qu zhou;
去住__去住 120.615053212|qu zhu;
驱逐__驅逐 325.642053285|qu zhu;
去追__去追 169.703655326|qu zhui;
去查__去查 256.987424161|qu cha;
驱车__驅車 327.677408739|qu che;
去吃__去吃 774.242000696|qu chi;
祛除__祛除 136.622376491|qu chu;
驱除__驅除 184.941433485|qu chu;
去处__去處 253.488718522|qu chu;
去除__去除 1295.36947746|qu chu;
取出__取出 1371.79434453|qu chu;
取舍__取捨 400.978810625|qu she;
取胜__取勝 709.565515965|qu sheng;
区市__區市 109.989815613|qu shi;
趣事__趣事 261.510250403|qu shi;
驱使__驅使 366.568203397|qu shi;
去世__去世 1818.02954749|qu shi;
趋势__趨勢 6496.96661305|qu shi;
去睡__去睡 168.649547684|qu shui;
取水__取水 184.941433485|qu shui;
去任__去任 105.821807183|qu ren;
屈辱__屈辱 297.696584607|qu ru;
取自__取自 205.862715427|qu zi;
曲子__曲子 829.168709129|qu zi;
取走__取走 147.412812521|qu zou;
去做__去做 2919.16177455|qu zuo;
取材__取材 202.807148249|qu cai;
驱散__驅散 363.384474622|qu san;
去死__去死 1093.42757174|qu si;
屈原__屈原 313.69268222|qu yuan;
取悦__取悅 211.321149687|qu yue;
取样__取樣 247.866011137|qu yang;
曲艺__曲藝 174.855812809|qu yi;
趋于__趨於 847.977956119|qu yu;
区域__區域 10061.7371458|qu yu;
去玩__去玩 661.736546275|qu wan;
去往__去往 128.209578049|qu wang;
趣闻__趣聞 118.972962872|qu wen;
去问__去問 446.895626023|qu wen;
区位__區位 219.644465616|qu wei;
区委__區委 527.455873984|qu wei;
趣味__趣味 731.107734818|qu wei;
去啊__去啊 274.533686805|qu a;
去爱__去愛 390.621510938|qu ai;
选拔__選拔 1209.56018338|xuan ba;
宣布__宣布 6376.65009401|xuan bu;
选派__選派 267.44247003|xuan pai;
宣判__宣判 408.544597361|xuan pan;
选配__選配 142.891090816|xuan pei;
选票__選票 411.610733326|xuan piao;
选聘__選聘 123.044091616|xuan pin;
选美__選美 239.366454718|xuan mei;
玄妙__玄妙 117.93965545|xuan miao;
选民__選民 674.222387052|xuan min;
眩目__眩目 117.061109314|xuan mu;
炫目__炫目 147.780672558|xuan mu;
选房__選房 116.47905068|xuan fang;
旋风__旋風 526.798985534|xuan feng;
悬浮__懸浮 234.056997396|xuan fu;
玄德__玄德 125.209594649|xuan de;
选定__選定 1020.99553617|xuan ding;
宣读__宣讀 311.744192349|xuan du;
选题__選題 514.472385324|xuan ti;
喧闹__喧鬧 347.00988711|xuan nao;
悬念__懸念 808.758466182|xuan nian;
旋钮__旋鈕 130.954650472|xuan niu;
旋律__旋律 1383.81307795|xuan lv;
绚烂__絢爛 312.911829085|xuan lan;
绚丽__絢麗 522.223615731|xuan li;
悬挂__懸挂 867.213880777|xuan gua;
玄关__玄關 118.676811842|xuan guan;
宣告__宣告 778.110973173|xuan gao;
选个__選個 195.60878915|xuan ge;
选购__選購 1416.96881393|xuan gou;
选股__選股 374.883606282|xuan gu;
选课__選課 274.876014738|xuan ke;
悬空__懸空 139.72158175|xuan kong;
喧哗__喧嘩 256.987424161|xuan hua;
玄幻__玄幻 174.203334854|xuan huan;
选号__選號 108.087539034|xuan hao;
选好__選好 419.900065808|xuan hao;
旋即__旋即 130.46599058|xuan ji;
玄机__玄機 312.522131716|xuan ji;
悬架__懸架 146.132498493|xuan jia;
宣教__宣教 130.954650472|xuan jiao;
宣讲__宣講 362.931919108|xuan jiang;
选举__選舉 2427.50473612|xuan ju;
选区__選區 244.796354228|xuan qu;
选取__選取 943.904464128|xuan qu;
宣萱__宣萱 131.281440129|xuan xuan;
喧嚣__喧囂 551.657401419|xuan xiao;
选项__選項 3662.32726943|xuan xiang;
宣泄__宣洩 417.812212206|xuan xie;
选型__選型 340.15949445|xuan xing;
选修__選修 353.998238229|xuan xiu;
选秀__選秀 961.714332594|xuan xiu;
旋转__旋轉 1806.7369278|xuan zhuan;
宣战__宣戰 196.096919422|xuan zhan;
悬着__懸着 206.119414554|xuan zhe;
选址__選址 499.935980841|xuan zhi;
选中__選中 1699.71443635|xuan zhong;
宣传__宣傳 11468.3068978|xuan chuan;
宣称__宣稱 990.911721928|xuan cheng;
选出__選出 857.541983893|xuan chu;
选上__選上 166.353500999|xuan shang;
悬赏__懸賞 384.823616623|xuan shang;
宣示__宣示 114.321989585|xuan shi;
宣誓__宣誓 296.955549433|xuan shi;
选手__選手 4081.70704886|xuan shou;
悬殊__懸殊 294.743493195|xuan shu;
渲染__渲染 994.623178167|xuan ran;
选人__選人 169.703655326|xuan ren;
悬在__懸在 157.085680168|xuan zai;
玄奘__玄奘 139.547573842|xuan zang;
选择__選擇 41445.7337853|xuan ze;
选自__選自 117.499561272|xuan zi;
选材__選材 155.333728851|xuan cai;
轩辕__軒轅 478.599545119|xuan yuan;
眩晕__眩暈 311.355949144|xuan yun;
悬崖__懸崖 504.944935018|xuan ya;
宣言__宣言 665.043316617|xuan yan;
宣扬__宣揚 671.706512759|xuan yang;
炫耀__炫耀 1046.76190254|xuan yao;
悬疑__懸疑 252.85772688|xuan yi;
选用__選用 1998.62991039|xuan yong;
选育__選育 174.638049069|xuan yu;
选为__選為 133.925286409|xuan wei;
旋涡__旋渦 158.461958559|xuan wo;
漩涡__漩渦 316.441045148|xuan wo;
宣武__宣武 112.065135969|xuan wu;
玄武__玄武 209.485777119|xuan wu;
雪白__雪白 543.469292924|xue bai;
学报__學報 396.012952778|xue bao;
血本__血本 122.584950132|xue ben;
雪崩__雪崩 125.209594649|xue beng;
雪碧__雪碧 186.794397067|xue bi;
学派__學派 333.860122955|xue pai;
血拼__血拚 150.194241046|xue pin;
血脉__血脈 403.48504224|xue mai;
雪梅__雪梅 129.817279349|xue mei;
学妹__學妹 235.813600182|xue mei;
学名__學名 115.611384758|xue ming;
学法__學法 122.737806611|xue fa;
学分__學分 553.034030141|xue fen;
雪峰__雪峰 152.267254161|xue feng;
学风__學風 186.32942291|xue feng;
学费__學費 2208.15035039|xue fei;
学佛__學佛 166.560934377|xue fo;
学府__學府 248.484546245|xue fu;
学到__學到 1779.91999768|xue dao;
学得__學得 358.437246895|xue de;
学弟__學弟 246.326401069|xue di;
雪地__雪地 251.287110964|xue di;
学点__學點 311.744192349|xue dian;
学堂__學堂 380.531740742|xue tang;
血糖__血糖 474.442798491|xue tang;
噱头__噱頭 342.712398751|xue tou;
血统__血統 515.756221017|xue tong;
学徒__學徒 229.722524886|xue tu;
学年__學年 384.344361008|xue nian;
血尿__血尿 108.357265155|xue niao;
血泪__血淚 167.393257695|xue lei;
雪梨__雪梨 123.197520618|xue li;
学历__學歷 2297.98475873|xue li;
雪莲__雪蓮 180.164388413|xue lian;
血量__血量 159.055477247|xue liang;
雪亮__雪亮 206.89143407|xue liang;
血流__血流 346.577724349|xue liu;
血管__血管 1401.16558873|xue guan;
雪糕__雪糕 396.506758465|xue gao;
雪国__雪國 120.46484039|xue guo;
学过__學過 838.520594407|xue guo;
学科__學科 2564.32477261|xue ke;
雪花__雪花 766.561672733|xue hua;
学坏__學壞 131.773154284|xue huai;
血汗__血汗 165.939408926|xue han;
学号__學號 393.063006485|xue hao;
学好__學好 772.314734527|xue hao;
血红__血紅 173.553291634|xue hong;
学会__學會 6710.91779356|xue hui;
学籍__學籍 243.57916235|xue ji;
血迹__血跡 333.029068427|xue ji;
雪茄__雪茄 237.879639313|xue jia;
学家__學家 359.779772295|xue jia;
削减__削減 519.626982517|xue jian;
血浆__血漿 330.136634719|xue jiang;
学姐__學姐 330.960471347|xue jie;
学界__學界 374.41672986|xue jie;
雪景__雪景 118.676811842|xue jing;
学起__學起 108.357265155|xue qi;
血气__血氣 129.332863581|xue qi;
学期__學期 2306.59185226|xue qi;
血清__血清 658.446218066|xue qing;
学区__學區 123.967540162|xue qu;
雪雪__雪雪 151.321452046|xue xue;
学学__學學 901.370874142|xue xue;
学习__學習 31468.3462416|xue xi;
学校__學校 36498.675445|xue xiao;
血性__血性 294.376422496|xue xing;
血型__血型 418.854838101|xue xing;
血腥__血腥 781.025384985|xue xing;
血站__血站 108.898738333|xue zhan;
血战__血戰 153.601316766|xue zhan;
学长__學長 577.688827991|xue zhang;
学着__學着 568.405572245|xue zhe;
学者__學者 3603.47496171|xue zhe;
血症__血症 172.475272126|xue zheng;
学制__學制 153.601316766|xue zhi;
血脂__血脂 239.963779681|xue zhi;
雪中__雪中 116.333988795|xue zhong;
血肿__血腫 119.716577729|xue zhong;
学车__學車 643.841029976|xue che;
学成__學成 169.703655326|xue cheng;
血栓__血栓 204.584007193|xue shuan;
雪山__雪山 692.099342424|xue shan;
学生__學生 33996.0547552|xue sheng;
学时__學時 198.555903198|xue shi;
学识__學識 312.522131716|xue shi;
学士__學士 450.24958728|xue shi;
学术__學術 3249.38851373|xue shu;
学说__學說 591.530074736|xue shuo;
学人__學人 152.457122789|xue ren;
雪人__雪人 215.576896995|xue ren;
血肉__血肉 214.504991945|xue rou;
削弱__削弱 625.649317648|xue ruo;
雪灾__雪災 147.229226029|xue zai;
靴子__靴子 335.528458728|xue zi;
学子__學子 742.122873174|xue zi;
血色__血色 988.445115058|xue se;
血丝__血絲 156.109948588|xue si;
雪松__雪松 112.906187218|xue song;
学园__學園 131.609045271|xue yuan;
血缘__血緣 183.563783354|xue yuan;
学员__學員 2554.75594355|xue yuan;
学院__學院 6820.52116343|xue yuan;
血压__血壓 778.110973173|xue ya;
学业__學業 1014.65366219|xue ye;
血液__血液 2364.80218582|xue ye;
学艺__學藝 121.217779906|xue yi;
学医__學醫 210.270405333|xue yi;
学友__學友 328.904723278|xue you;
雪域__雪域 172.690339006|xue yu;
学问__學問 1132.25360251|xue wen;
穴位__穴位 411.610733326|xue wei;
学位__學位 1383.81307795|xue wei;
血案__血案 182.651055928|xue an;
雪儿__雪兒 440.811451858|xue er;
寻宝__尋寶 181.742866823|xun bao;
寻梦__尋夢 116.18910757|xun meng;
迅猛__迅猛 517.043260448|xun meng;
寻觅__尋覓 532.740555233|xun mi;
寻访__尋訪 162.663565352|xun fang;
巡抚__巡撫 123.658956482|xun fu;
驯服__馴服 135.098649108|xun fu;
熏陶__熏陶 366.568203397|xun tao;
迅雷__迅雷 3079.85238931|xun lei;
训练__訓練 6854.60405824|xun lian;
巡逻__巡邏 728.379591714|xun luo;
寻根__尋根 106.350610398|xun gen;
循环__循環 3007.78674349|xun huan;
巡航__巡航 148.519148841|xun hang;
讯号__訊號 162.258658377|xun hao;
寻呼__尋呼 156.304608838|xun hu;
巡回__巡迴 365.20034683|xun hui;
询价__詢價 786.88699725|xun jia;
巡检__巡檢 249.104624871|xun jian;
迅捷__迅捷 186.561765129|xun jie;
巡警__巡警 205.60633599|xun jing;
汛期__汛期 158.067510349|xun qi;
寻求__尋求 2705.48273369|xun qiu;
讯息__訊息 557.879339939|xun xi;
巡展__巡展 215.040276584|xun zhan;
勋章__勳章 498.070459751|xun zhang;
寻找__尋找 8419.39540744|xun zhao;
熏蒸__熏蒸 424.635962376|xun zheng;
寻址__尋址 129.332863581|xun zhi;
巡查__巡查 376.756940916|xun cha;
寻常__尋常 610.248767154|xun chang;
训斥__訓斥 210.532600599|xun chi;
迅驰__迅馳 409.054029297|xun chi;
巡视__巡視 382.910172354|xun shi;
寻租__尋租 132.927661458|xun zu;
逊色__遜色 416.772181646|xun se;
寻思__尋思 189.608710238|xun si;
迅速__迅速 8367.09866098|xun su;
巡演__巡演 360.228397261|xun yan;
巡游__巡遊 173.553291634|xun you;
逊于__遜於 116.769717326|xun yu;
讯问__訊問 144.502706249|xun wen;
询问__詢問 3419.72334588|xun wen;
细胞__細胞 4594.6891828|xi bao;
西北__西北 1716.74420026|xi bei;
西边__西邊 491.289575698|xi bian;
稀薄__稀薄 145.587202159|xi bo;
西部__西部 2557.94157928|xi bu;
洗牌__洗牌 345.715012791|xi pai;
洗盘__洗盤 408.035799866|xi pan;
西门__西門 878.088426229|xi men;
西蒙__西蒙 176.168109435|xi meng;
细密__細密 151.888225993|xi mi;
西面__西面 215.30841961|xi mian;
熄灭__熄滅 400.978810625|xi mie;
洗发__洗髮 128.369448119|xi fa;
稀饭__稀飯 839.566182019|xi fan;
西方__西方 4704.77652327|xi fang;
戏份__戲份 286.058823982|xi fen;
细分__細分 782.974388071|xi fen;
西风__西風 330.136634719|xi feng;
西服__西服 494.360275282|xi fu;
吸附__吸附 508.100984482|xi fu;
媳妇__媳婦 2121.82781083|xi fu;
西单__西單 428.356335222|xi dan;
洗得__洗得 107.550099352|xi de;
西德__西德 113.895394799|xi de;
熄灯__熄燈 353.117055307|xi deng;
洗涤__洗滌 459.889800938|xi di;
西点__西點 109.579386421|xi dian;
洗掉__洗掉 189.845141544|xi diao;
吸毒__吸毒 647.865219539|xi du;
喜糖__喜糖 186.32942291|xi tang;
西塘__西塘 189.845141544|xi tang;
习题__習題 336.785179346|xi ti;
西天__西天 155.527421199|xi tian;
洗头__洗頭 483.997491267|xi tou;
系统__系統 56454.4568405|xi tong;
稀土__稀土 298.811606079|xi tu;
吸纳__吸納 703.402776999|xi na;
西南__西南 1509.94683642|xi nan;
洗脑__洗腦 327.26932246|xi nao;
细嫩__細嫩 145.405889264|xi nen;
悉尼__悉尼 595.969520633|xi ni;
细腻__細膩 1504.31243966|xi ni;
西宁__西寧 431.033684153|xi ning;
犀牛__犀牛 183.563783354|xi niu;
戏弄__戲弄 166.146325956|xi nong;
希腊__希臘 1082.58098585|xi la;
袭来__襲來 379.584509838|xi lai;
喜乐__喜樂 146.497163581|xi le;
吸了__吸了 250.974160423|xi le;
西里__西里 125.835280772|xi li;
系里__系裡 220.467143161|xi li;
戏里__戲里 226.595011951|xi li;
洗礼__洗禮 482.792710347|xi li;
犀利__犀利 524.179602378|xi li;
洗脸__洗臉 933.377249507|xi lian;
系列__系列 12297.2127608|xi lie;
西林__西林 107.952927857|xi lin;
溪流__溪流 191.747236314|xi liu;
西路__西路 732.932171333|xi lu;
西瓜__西瓜 2046.51646869|xi gua;
吸管__吸管 154.561368684|xi guan;
西关__西關 182.651055928|xi guan;
习惯__習慣 13071.5065595|xi guan;
膝盖__膝蓋 770.392265767|xi gai;
洗个__洗個 218.552335545|xi ge;
硒鼓__硒鼓 183.335174792|xi gu;
洗过__洗過 230.295783987|xi guo;
细看__細看 307.500011268|xi kan;
西裤__西褲 126.306596357|xi ku;
西化__西化 108.222318063|xi hua;
细化__細化 1002.08784645|xi hua;
喜欢__喜歡 72704.7002655|xi huan;
嘻哈__嘻哈 217.736803143|xi ha;
西汉__西漢 258.916120291|xi han;
稀罕__稀罕 400.978810625|xi han;
洗好__洗好 244.491487214|xi hao;
喜好__喜好 1098.89154964|xi hao;
西湖__西湖 1221.67899812|xi hu;
喜获__喜獲 137.134095104|xi huo;
熄火__熄火 294.009808944|xi huo;
席卷__席捲 357.545014261|xi juan;
细菌__細菌 1525.07528247|xi jun;
希冀__希冀 132.10198647|xi ji;
袭击__襲擊 1716.74420026|xi ji;
西甲__西甲 321.609191441|xi jia;
席间__席間 140.945727665|xi jian;
西郊__西郊 190.318888971|xi jiao;
洗脚__洗腳 383.387639617|xi jiao;
西江__西江 126.779677253|xi jiang;
西街__西街 249.726250867|xi jie;
希捷__希捷 311.355949144|xi jie;
细节__細節 5573.68779063|xi jie;
洗净__洗凈 1181.25761405|xi jing;
喜酒__喜酒 232.024158785|xi jiu;
喜剧__喜劇 1109.90155418|xi ju;
戏剧__戲劇 1269.79732551|xi ju;
喜鹊__喜鵲 159.651218957|xi que;
稀缺__稀缺 466.237298568|xi que;
习气__習氣 106.748946222|xi qi;
吸气__吸氣 232.313479749|xi qi;
稀奇__稀奇 324.02287532|xi qi;
洗钱__洗錢 199.796934068|xi qian;
喜庆__喜慶 451.935995467|xi qing;
洗去__洗去 165.526347625|xi qu;
西区__西區 436.982903472|xi qu;
戏曲__戲曲 479.793862242|xi qu;
吸取__吸取 956.932435908|xi qu;
戏谑__戲謔 122.890853693|xi xue;
吸血__吸血 345.284462654|xi xue;
喜讯__喜訊 227.443722742|xi xun;
西溪__西溪 106.483223576|xi xi;
兮兮__兮兮 156.694657831|xi xi;
嬉戏__嬉戲 273.850309404|xi xi;
洗洗__洗洗 535.402718412|xi xi;
西西__西西 744.902491688|xi xi;
细细__細細 992.147332631|xi xi;
嘻嘻__嘻嘻 8201.92206694|xi xi;
西夏__西夏 179.940013424|xi xia;
西线__西線 124.742372548|xi xian;
嬉笑__嬉笑 108.763116896|xi xiao;
细小__細小 505.574572707|xi xiao;
西乡__西鄉 114.179614083|xi xiang;
细想__細想 117.93965545|xi xiang;
悉心__悉心 226.312812713|xi xin;
细心__細心 1314.88599102|xi xin;
西行__西行 133.591915611|xi xing;
习性__習性 226.030964922|xi xing;
唏嘘__唏噓 288.565077751|xi xu;
西装__西裝 819.921123923|xi zhuang;
西站__西站 271.810366771|xi zhan;
溪镇__溪鎮 109.716025699|xi zhen;
西至__西至 109.170488754|xi zhi;
细致__細緻 1721.02823483|xi zhi;
西周__西周 161.653186955|xi zhou;
戏中__戲中 226.595011951|xi zhong;
西昌__西昌 234.933657026|xi chang;
细长__細長 243.57916235|xi chang;
洗车__洗車 289.285174995|xi che;
戏称__戲稱 169.28122395|xi cheng;
西城__西城 273.168633085|xi cheng;
洗刷__洗刷 206.89143407|xi shua;
吸吮__吸吮 147.045868173|xi shun;
蟋蟀__蟋蟀 204.07475061|xi shuai;
西山__西山 397.001179899|xi shan;
席上__席上 111.786180106|xi shang;
稀少__稀少 431.033684153|xi shao;
牺牲__犧牲 3015.29249908|xi sheng;
吸食__吸食 170.551683166|xi shi;
西式__西式 198.308623594|xi shi;
喜事__喜事 231.446597362|xi shi;
西施__西施 331.786363812|xi shi;
稀释__稀釋 466.237298568|xi shi;
洗手__洗手 403.48504224|xi shou;
吸收__吸收 4071.54674252|xi shou;
细数__細數 178.377193209|xi shu;
稀疏__稀疏 210.008536601|xi shu;
悉数__悉數 228.8653107|xi shu;
洗漱__洗漱 322.813777494|xi shu;
系数__係數 1295.36947746|xi shu;
戏说__戲說 123.813152185|xi shuo;
细说__細說 185.402943996|xi shuo;
戏水__戲水 111.230349808|xi shui;
吸水__吸水 148.704343794|xi shui;
溪水__溪水 268.778909483|xi shui;
袭人__襲人 186.794397067|xi ren;
喜人__喜人 205.094534596|xi ren;
昔日__昔日 1046.76190254|xi ri;
息肉__息肉 162.460985719|xi rou;
吸入__吸入 415.734739962|xi ru;
西藏__西藏 3545.56838982|xi zang;
洗澡__洗澡 6570.2434815|xi zao;
细则__細則 636.660374558|xi ze;
席子__席子 123.813152185|xi zi;
戏子__戲子 150.756793028|xi zi;
西子__西子 175.510734618|xi zi;
习作__習作 142.357889859|xi zuo;
西村__西村 121.066816454|xi cun;
西餐__西餐 355.324137339|xi can;
西侧__西側 335.110594827|xi ce;
西祠__西祠 147.045868173|xi ci;
西斯__西斯 171.190483873|xi si;
习俗__習俗 646.252534205|xi su;
细碎__細碎 123.351140937|xi sui;
西苑__西苑 109.579386421|xi yuan;
戏院__戲院 119.121315407|xi yuan;
喜悦__喜悅 1344.71347376|xi yue;
西亚__西亞 338.890182508|xi ya;
吸烟__吸煙 1002.08784645|xi yan;
西洋__西洋 383.865702254|xi yang;
夕阳__夕陽 939.211122794|xi yang;
西药__西藥 335.946843682|xi yao;
蜥蜴__蜥蜴 236.696839161|xi yi;
洗衣__洗衣 375.819106356|xi yi;
西医__西醫 588.588831574|xi yi;
吸引__吸引 7783.68232649|xi yin;
喜迎__喜迎 132.927661458|xi ying;
西游__西遊 225.749468142|xi you;
稀有__稀有 572.671468255|xi you;
细语__細語 115.755545596|xi yu;
西域__西域 350.92368248|xi yu;
洗浴__洗浴 397.991873082|xi yu;
细雨__細雨 482.191444969|xi yu;
洗碗__洗碗 499.935980841|xi wan;
洗完__洗完 781.999279332|xi wan;
希望__希望 50276.6501023|xi wang;
细纹__細紋 147.229226029|xi wen;
席位__席位 503.060722916|xi wei;
细微__細微 558.574983827|xi wei;
习武__習武 147.229226029|xi wu;
喜爱__喜愛 2735.99686654|xi ai;
西岸__西岸 216.384339476|xi an;
西安__西安 5095.37328549|xi an;
希尔__希爾 265.450260135|xi er;
西欧__西歐 333.444336783|xi ou;
下吧__下吧 251.600451735|xia ba;
下巴__下巴 854.342048866|xia ba;
瞎掰__瞎掰 135.773751924|xia bai;
下半__下半 126.306596357|xia ban;
下班__下班 10802.4322569|xia ban;
下笔__下筆 113.753550575|xia bi;
下边__下邊 552.345286903|xia bian;
下表__下表 242.972837869|xia biao;
下部__下部 562.76710106|xia bu;
吓跑__嚇跑 266.776744296|xia pao;
下坡__下坡 202.807148249|xia po;
下铺__下鋪 121.066816454|xia pu;
夏普__夏普 436.982903472|xia pu;
下马__下馬 208.964318904|xia ma;
瞎忙__瞎忙 217.736803143|xia mang;
厦门__廈門 4775.66041886|xia men;
虾米__蝦米 1617.0663282|xia mi;
下面__下面 16646.3518954|xia mian;
下发__下發 1385.53861435|xia fa;
下凡__下凡 146.132498493|xia fan;
下放__下放 262.817045902|xia fang;
下方__下方 1103.00744393|xia fang;
下风__下風 139.026849285|xia feng;
下端__下端 111.925571131|xia duan;
厦大__廈大 269.785619908|xia da;
下达__下達 945.081459448|xia da;
下蛋__下蛋 125.053659829|xia dan;
下单__下單 757.068312494|xia dan;
吓倒__嚇倒 112.204874836|xia dao;
下到__下到 311.355949144|xia dao;
吓到__嚇到 420.94790182|xia dao;
吓得__嚇得 954.550411286|xia de;
下的__下的 1782.13945694|xia de;
下跌__下跌 4757.8399467|xia die;
下定__下定 131.609045271|xia ding;
下肚__下肚 111.786180106|xia du;
下榻__下榻 172.260473089|xia ta;
下台__下台 478.599545119|xia tai;
下探__下探 210.008536601|xia tan;
下体__下體 238.770616634|xia ti;
夏天__夏天 4583.25194611|xia tian;
下调__下調 1178.31719254|xia tiao;
下图__下圖 574.81640715|xia tu;
下拉__下拉 457.603107852|xia la;
下来__下來 20319.4331096|xia lai;
瞎了__瞎了 181.290467084|xia le;
吓了__嚇了 599.694499646|xia le;
下了__下了 4431.607048|xia le;
夏利__夏利 271.810366771|xia li;
下联__下聯 205.094534596|xia lian;
下列__下列 2148.43475692|xia lie;
下令__下令 590.057620516|xia ling;
下流__下流 509.368920718|xia liu;
下楼__下樓 940.382265783|xia lou;
下落__下落 427.82286438|xia luo;
霞光__霞光 105.295633316|xia guang;
下岗__下崗 867.213880777|xia gang;
瞎搞__瞎搞 109.034528882|xia gao;
下个__下個 2427.50473612|xia ge;
峡谷__峽谷 500.559372647|xia gu;
下锅__下鍋 156.694657831|xia guo;
下过__下過 228.580284053|xia guo;
下跪__下跪 283.221176861|xia gui;
侠客__俠客 454.760723981|xia ke;
下课__下課 1037.67053575|xia ke;
厦华__廈華 113.611883002|xia hua;
下滑__下滑 1733.94458864|xia hua;
吓坏__嚇壞 337.625607028|xia huai;
下海__下海 274.191785204|xia hai;
下颌__下頜 156.304608838|xia he;
夏侯__夏侯 179.268563673|xia hou;
吓唬__嚇唬 542.11647303|xia hu;
下回__下回 584.204365283|xia hui;
下级__下級 518.979844093|xia ji;
夏季__夏季 1546.12469848|xia ji;
下家__下家 206.633773476|xia jia;
下架__下架 225.468321935|xia jia;
下贱__下賤 172.04594156|xia jian;
下降__下降 8367.09866098|xia jiang;
下届__下屆 123.813152185|xia jie;
下期__下期 227.443722742|xia qi;
下棋__下棋 421.998352644|xia qi;
辖区__轄區 962.913535809|xia qu;
下去__下去 11583.2100573|xia qu;
下雪__下雪 503.688011099|xia xue;
下旬__下旬 642.238361775|xia xun;
下辖__下轄 184.251320835|xia xia;
下下__下下 292.912705474|xia xia;
下限__下限 336.785179346|xia xian;
下线__下線 1880.24059249|xia xian;
狭小__狹小 389.649164279|xia xiao;
遐想__遐想 375.351064872|xia xiang;
下乡__下鄉 462.764242999|xia xiang;
夏新__夏新 301.429591092|xia xin;
下行__下行 623.314694733|xia xing;
狭窄__狹窄 758.957532109|xia zhai;
吓着__嚇着 170.127140854|xia zhe;
下着__下着 220.467143161|xia zhe;
下至__下至 130.46599058|xia zhi;
下肢__下肢 349.178797604|xia zhi;
下周__下周 5814.9173705|xia zhou;
下注__下注 287.846772995|xia zhu;
下床__下床 211.057972369|xia chuang;
狭长__狹長 144.863304286|xia chang;
下场__下場 950.988487375|xia chang;
瞎扯__瞎扯 201.296414343|xia che;
下车__下車 1910.94886689|xia che;
下沉__下沉 275.561951728|xia chen;
下厨__下廚 153.028150386|xia chu;
下垂__下垂 315.653350706|xia chui;
下沙__下沙 238.176261728|xia sha;
下山__下山 639.84183651|xia shan;
下设__下設 258.593668656|xia she;
下身__下身 405.501301397|xia shen;
下手__下手 1126.6237397|xia shou;
下述__下述 185.634130949|xia shu;
下属__下屬 1771.06976716|xia shu;
瞎说__瞎說 644.643863216|xia shuo;
下水__下水 513.831666385|xia shui;
虾仁__蝦仁 176.168109435|xia ren;
吓人__嚇人 1298.60199609|xia ren;
夏日__夏日 790.819158167|xia ri;
下载__下載 27334.9293271|xia zai;
下子__下子 107.550099352|xia zi;
瞎子__瞎子 439.166555128|xia zi;
瞎猜__瞎猜 132.762114633|xia cai;
下层__下層 346.577724349|xia ceng;
瑕疵__瑕疵 522.874798954|xia ci;
下次__下次 11047.4796329|xia ci;
下挫__下挫 378.168082664|xia cuo;
吓死__嚇死 741.198640518|xia si;
下月__下月 676.747684543|xia yue;
夏夜__夏夜 118.23396695|xia ye;
侠义__俠義 119.716577729|xia yi;
下移__下移 147.045868173|xia yi;
狭义__狹義 210.270405333|xia yi;
下一__下一 866.133860988|xia yi;
下游__下游 887.99205879|xia you;
夏雨__夏雨 356.655002599|xia yu;
下雨__下雨 3750.07550505|xia yu;
夏娃__夏娃 148.704343794|xia wa;
下完__下完 386.746622582|xia wan;
下文__下文 603.442760838|xia wen;
下午__下午 26828.7171606|xia wu;
狭隘__狹隘 510.640021015|xia ai;
先把__先把 1561.61561744|xian ba;
显摆__顯擺 291.093289619|xian bai;
先辈__先輩 138.680779525|xian bei;
先别__先別 185.172044961|xian bie;
馅饼__餡餅 315.653350706|xian bing;
先买__先買 143.784200776|xian mai;
鲜美__鮮美 287.130256264|xian mei;
先民__先民 115.899886195|xian min;
鲜明__鮮明 1607.02198372|xian ming;
羡慕__羨慕 4279.6431141|xian mu;
先发__先發 284.636464248|xian fa;
宪法__憲法 1613.0410787|xian fa;
嫌犯__嫌犯 279.713669565|xian fan;
现房__現房 179.940013424|xian fang;
先锋__先鋒 1308.34803192|xian feng;
先富__先富 148.334184528|xian fu;
线段__線段 131.773154284|xian duan;
先打__先打 209.485777119|xian da;
现代__現代 7716.07926336|xian dai;
先导__先導 188.665925845|xian dao;
先到__先到 546.185068786|xian dao;
先得__先得 170.76435144|xian de;
显得__顯得 6914.65945879|xian de;
限定__限定 781.025384985|xian ding;
限度__限度 554.41409416|xian du;
闲谈__閑談 133.093414711|xian tan;
纤体__纖體 105.821807183|xian ti;
腺体__腺體 115.467403456|xian ti;
先天__先天 652.727461906|xian tian;
线条__線條 1233.91923358|xian tiao;
线图__線圖 172.475272126|xian tu;
仙女__仙女 455.327784806|xian nv;
鲜奶__鮮奶 193.427195796|xian nai;
鲜嫩__鮮嫩 172.260473089|xian nen;
先来__先來 447.452879516|xian lai;
线缆__線纜 255.391156791|xian lan;
献礼__獻禮 120.46484039|xian li;
县里__縣裡 300.679263607|xian li;
先例__先例 343.996026791|xian li;
闲聊__閑聊 504.316081474|xian liao;
鲜亮__鮮亮 116.18910757|xian liang;
限量__限量 699.033618062|xian liang;
先烈__先烈 110.126966673|xian lie;
县令__縣令 116.624293448|xian ling;
显露__顯露 494.360275282|xian lu;
线路__線路 3996.1462733|xian lu;
县官__縣官 140.770195218|xian guan;
闲逛__閑逛 322.411748334|xian guang;
先给__先給 302.558594526|xian gei;
献给__獻給 871.547443971|xian gei;
鲜果__鮮果 277.630050085|xian guo;
显卡__顯卡 4963.75957739|xian ka;
掀开__掀開 296.955549433|xian kai;
先看__先看 510.004074866|xian kan;
线控__線控 158.659551632|xian kong;
献花__獻花 106.882056102|xian hua;
闲话__閑話 300.304800557|xian hua;
鲜花__鮮花 1463.63092081|xian hua;
陷害__陷害 338.468131949|xian hai;
显赫__顯赫 292.54791482|xian he;
先河__先河 300.679263607|xian he;
先后__先後 4263.67354041|xian hou;
鲜红__鮮紅 416.772181646|xian hong;
鲜活__鮮活 546.866130582|xian huo;
现货__現貨 1054.61787307|xian huo;
贤惠__賢惠 293.643651968|xian hui;
先机__先機 306.734573113|xian ji;
县级__縣級 809.766942109|xian ji;
现价__現價 268.109857044|xian jia;
限价__限價 277.284292303|xian jia;
仙剑__仙劍 841.661270235|xian jian;
先将__先將 487.62990282|xian jiang;
现将__現將 501.183541788|xian jiang;
衔接__銜接 809.766942109|xian jie;
陷进__陷進 105.953760973|xian jin;
现今__現今 705.158077415|xian jin;
现金__現金 4623.40729705|xian jin;
先进__先進 5851.26225798|xian jin;
仙境__仙境 271.471856767|xian jing;
陷阱__陷阱 1461.808129|xian jing;
现就__現就 134.259489114|xian jiu;
县局__縣局 116.044406778|xian ju;
线圈__線圈 288.205701591|xian quan;
先期__先期 299.557272934|xian qi;
限期__限期 542.792461517|xian qi;
嫌弃__嫌棄 674.222387052|xian qi;
掀起__掀起 1559.67079644|xian qi;
闲钱__閑錢 214.504991945|xian qian;
先前__先前 1169.53977147|xian qian;
先秦__先秦 152.837570606|xian qin;
闲情__閑情 140.419785869|xian qing;
险情__險情 201.296414343|xian qing;
先驱__先驅 263.472890441|xian qu;
县区__縣區 297.696584607|xian qu;
先取__先取 497.450167612|xian qu;
先去__先去 1718.88488289|xian qu;
献血__獻血 469.736419493|xian xue;
鲜血__鮮血 964.114234362|xian xue;
纤细__纖細 389.163898974|xian xi;
闲暇__閑暇 365.20034683|xian xia;
线下__線下 401.478808454|xian xia;
先贤__先賢 106.616002115|xian xian;
显现__顯現 1331.37418129|xian xian;
县乡__縣鄉 214.504991945|xian xiang;
现象__現象 11597.6536631|xian xiang;
先写__先寫 116.624293448|xian xie;
险些__險些 338.046607007|xian xie;
闲心__閑心 111.646962678|xian xin;
显性__顯性 139.547573842|xian xing;
线性__線性 713.111292931|xian xing;
先行__先行 905.87512359|xian xing;
现行__現行 1615.05244942|xian xing;
现状__現狀 3731.429143|xian zhuang;
县长__縣長 764.653524665|xian zhang;
先兆__先兆 122.279808036|xian zhao;
先找__先找 158.461958559|xian zhao;
闲着__閑着 873.722339551|xian zhe;
显着__顯着 2955.76699744|xian zhe;
现正__現正 133.093414711|xian zheng;
宪政__憲政 298.439468992|xian zheng;
先知__先知 380.057830188|xian zhi;
闲置__閑置 757.068312494|xian zhi;
限制__限制 9961.92669753|xian zhi;
险种__險種 254.121284766|xian zhong;
显著__顯著 459.317058623|xian zhu;
献唱__獻唱 112.765574943|xian chang;
现场__現場 13586.354595|xian chang;
现成__現成 891.318029807|xian cheng;
线程__線程 1413.4416531|xian cheng;
县城__縣城 1509.94683642|xian cheng;
先吃__先吃 175.073848088|xian chi;
线虫__線蟲 105.558392399|xian chong;
现出__現出 196.586267794|xian chu;
献出__獻出 274.533686805|xian chu;
显出__顯出 437.527796363|xian chu;
献上__獻上 365.20034683|xian shang;
线上__線上 1078.5413133|xian shang;
献身__獻身 443.56664881|xian shen;
现身__現身 983.530305889|xian shen;
先声__先聲 114.321989585|xian sheng;
险胜__險勝 124.89791921|xian sheng;
先生__先生 17215.9724212|xian sheng;
闲时__閑時 111.646962678|xian shi;
闲适__閑適 121.671800659|xian shi;
现世__現世 143.426288875|xian shi;
限时__限時 266.444503116|xian shi;
现时__現時 332.614317243|xian shi;
县市__縣市 380.531740742|xian shi;
先是__先是 1348.06912745|xian shi;
现实__現實 12054.4509861|xian shi;
显示__顯示 22987.4451971|xian shi;
娴熟__嫻熟 269.785619908|xian shu;
先说__先說 622.538424634|xian shuo;
显然__顯然 5436.48975039|xian ran;
先让__先讓 231.735198139|xian rang;
先人__先人 191.98633424|xian ren;
仙人__仙人 414.183417482|xian ren;
闲人__閑人 469.151414294|xian ren;
现任__現任 1128.02857559|xian ren;
陷入__陷入 2883.00988318|xian ru;
闲杂__閑雜 449.128812644|xian za;
先在__先在 442.462509543|xian zai;
现在__現在 246263.726667|xian zai;
仙子__仙子 712.223191016|xian zi;
先走__先走 351.799391968|xian zou;
先祖__先祖 136.622376491|xian zu;
先做__先做 436.982903472|xian zuo;
现存__現存 431.571158705|xian cun;
显存__顯存 601.940653207|xian cun;
线材__線材 205.862715427|xian cai;
咸菜__鹹菜 245.407229187|xian cai;
先从__先從 378.63963681|xian cong;
闲散__閑散 145.224802174|xian san;
限速__限速 320.010065926|xian su;
线索__線索 1394.19862478|xian suo;
弦乐__弦樂 111.646962678|xian yue;
显眼__顯眼 413.152419826|xian yan;
鲜艳__鮮艷 714.000502259|xian yan;
咸阳__咸陽 327.677408739|xian yang;
先要__先要 445.228026075|xian yao;
现役__現役 218.280152578|xian yi;
嫌疑__嫌疑 837.47630896|xian yi;
现已__現已 912.673735821|xian yi;
先由__先由 111.091824605|xian you;
鲜有__鮮有 189.372573382|xian you;
先有__先有 231.158356006|xian you;
现有__現有 5678.85377955|xian you;
先用__先用 694.691597986|xian yong;
先于__先於 153.028150386|xian yu;
咸鱼__鹹魚 167.393257695|xian yu;
县域__縣域 171.831677206|xian yu;
陷于__陷於 243.882891747|xian yu;
限于__限於 511.276760152|xian yu;
先问__先問 123.197520618|xian wen;
显微__顯微 145.950506492|xian wei;
现为__現為 280.411678639|xian wei;
县委__縣委 814.828215816|xian wei;
纤维__纖維 1395.93711137|xian wei;
腺癌__腺癌 363.384474622|xian ai;
险恶__險惡 263.144763849|xian e;
限额__限額 635.075580657|xian e;
小白__小白 2278.02623496|xiao bai;
小班__小班 174.203334854|xiao ban;
肖邦__肖邦 162.86639759|xiao bang;
小报__小報 187.4940348|xiao bao;
小包__小包 406.006938516|xiao bao;
小宝__小寶 913.811788194|xiao bao;
小本__小本 139.373782642|xiao ben;
小贝__小貝 612.534451685|xiao bei;
小便__小便 511.914293268|xiao bian;
小编__小編 730.197220308|xiao bian;
小病__小病 161.854759309|xiao bing;
小兵__小兵 473.851932013|xiao bing;
晓波__曉波 121.217779906|xiao bo;
小波__小波 330.136634719|xiao bo;
小布__小布 111.091824605|xiao bu;
小步__小步 176.168109435|xiao bu;
小盘__小盤 281.461959558|xiao pan;
小胖__小胖 660.089332023|xiao pang;
小跑__小跑 140.945727665|xiao pao;
小片__小片 117.061109314|xiao pian;
小票__小票 118.23396695|xiao piao;
小品__小品 692.099342424|xiao pin;
小平__小平 455.895552723|xiao ping;
小马__小馬 650.291796355|xiao ma;
小麦__小麥 1793.27833544|xiao mai;
小曼__小曼 114.893269147|xiao man;
小毛__小毛 212.377144726|xiao mao;
小猫__小貓 1252.50991514|xiao mao;
校门__校門 427.290057918|xiao men;
小梅__小梅 250.349428094|xiao mei;
小美__小美 378.63963681|xiao mei;
小妹__小妹 1187.16048834|xiao mei;
小秘__小秘 119.41857567|xiao mi;
小蜜__小蜜 180.839193473|xiao mi;
小米__小米 743.048258297|xiao mi;
消灭__消滅 1542.27603899|xiao mie;
小民__小民 170.339279748|xiao min;
小敏__小敏 182.196395498|xiao min;
小命__小命 144.502706249|xiao ming;
晓明__曉明 170.977284899|xiao ming;
小名__小名 225.187525865|xiao ming;
小明__小明 729.287839744|xiao ming;
消磨__消磨 352.238065853|xiao mo;
小凡__小凡 149.261315371|xiao fan;
小贩__小販 409.564096466|xiao fan;
小方__小方 155.527421199|xiao fang;
小芳__小芳 224.907079496|xiao fang;
效仿__效仿 345.284462654|xiao fang;
校方__校方 443.56664881|xiao fang;
消防__消防 1413.4416531|xiao fang;
小峰__小峰 114.607273411|xiao feng;
萧峰__蕭峰 115.179978568|xiao feng;
晓风__曉風 122.279808036|xiao feng;
小风__小風 133.758497151|xiao feng;
小凤__小鳳 133.925286409|xiao feng;
晓峰__曉峰 148.889769675|xiao feng;
小非__小非 107.416157498|xiao fei;
小飞__小飛 314.475483928|xiao fei;
小费__小費 330.960471347|xiao fei;
消费__消費 8983.04290431|xiao fei;
校服__校服 299.1842072|xiao fu;
小腹__小腹 319.611528482|xiao fu;
小幅__小幅 879.183352683|xiao fu;
小段__小段 233.474375771|xiao duan;
小到__小到 161.451865638|xiao dao;
小道__小道 367.482952871|xiao dao;
小刀__小刀 426.757915008|xiao dao;
小岛__小島 458.173712968|xiao dao;
笑道__笑道 1062.53280282|xiao dao;
小德__小德 359.779772295|xiao de;
笑得__笑得 1050.68254543|xiao de;
晓得__曉得 7001.36676392|xiao de;
小弟__小弟 1913.33171172|xiao di;
小店__小店 1165.17561047|xiao dian;
小调__小調 157.67404401|xiao diao;
小丁__小丁 210.270405333|xiao ding;
小豆__小豆 110.539446825|xiao dou;
小董__小董 117.792774542|xiao dong;
小东__小東 165.73274959|xiao dong;
晓东__曉東 196.831399718|xiao dong;
消毒__消毒 1252.50991514|xiao du;
小队__小隊 329.314848809|xiao dui;
小摊__小攤 163.476413088|xiao tan;
笑谈__笑談 179.492101402|xiao tan;
小唐__小唐 142.357889859|xiao tang;
小桃__小桃 127.890434962|xiao tao;
小田__小田 131.445140637|xiao tian;
小天__小天 195.365179853|xiao tian;
萧条__蕭條 260.859291326|xiao tiao;
消停__消停 135.604660605|xiao ting;
小偷__小偷 1240.08526378|xiao tou;
小童__小童 113.895394799|xiao tong;
小图__小圖 169.070402749|xiao tu;
小兔__小兔 228.580284053|xiao tu;
消退__消退 326.861744407|xiao tui;
小腿__小腿 640.639682982|xiao tui;
小女__小女 175.729586548|xiao nv;
晓楠__曉楠 135.435779871|xiao nan;
小南__小南 152.837570606|xiao nan;
效能__效能 616.362966229|xiao neng;
校内__校內 1240.08526378|xiao nei;
小鸟__小鳥 795.762002835|xiao niao;
小宁__小寧 153.792848894|xiao ning;
小妞__小妞 456.464028614|xiao niu;
小牛__小牛 758.012333731|xiao niu;
小农__小農 111.646962678|xiao nong;
效率__效率 6266.36577307|xiao lv;
小兰__小蘭 286.415523108|xiao lan;
小狼__小狼 270.458854115|xiao lang;
笑了__笑了 2036.34065037|xiao le;
小雷__小雷 124.587019602|xiao lei;
小丽__小麗 373.950434882|xiao li;
小李__小李 619.442999798|xiao li;
效力__效力 992.147332631|xiao li;
小脸__小臉 286.772667017|xiao lian;
笑脸__笑臉 908.135681884|xiao lian;
笑料__笑料 175.948711373|xiao liao;
小亮__小亮 117.646076559|xiao liang;
销量__銷量 2732.58948248|xiao liang;
小林__小林 495.593922384|xiao lin;
小玲__小玲 189.372573382|xiao ling;
小六__小六 152.077621994|xiao liu;
小刘__小劉 359.779772295|xiao liu;
小楼__小樓 430.496878967|xiao lou;
小龙__小龍 530.752623218|xiao long;
销路__銷路 220.467143161|xiao lu;
小鹿__小鹿 288.205701591|xiao lu;
小路__小路 672.544092675|xiao lu;
小罗__小羅 642.238361775|xiao luo;
小光__小光 106.350610398|xiao guang;
小乖__小乖 441.361118731|xiao guai;
孝感__孝感 123.967540162|xiao gan;
小刚__小剛 251.600451735|xiao gang;
小高__小高 135.604660605|xiao gao;
小哥__小哥 163.476413088|xiao ge;
小狗__小狗 1494.96846157|xiao gou;
小工__小工 110.401782066|xiao gong;
小姑__小姑 108.898738333|xiao gu;
小郭__小郭 211.848489234|xiao guo;
小国__小國 250.661599628|xiao guo;
效果__效果 22006.3792893|xiao guo;
小鬼__小鬼 687.800394331|xiao gui;
小块__小塊 419.900065808|xiao kuai;
小卡__小卡 135.435779871|xiao ka;
笑看__笑看 178.155043976|xiao kan;
小看__小看 355.767206381|xiao kan;
小康__小康 600.442284667|xiao kang;
小克__小克 110.815291538|xiao ke;
小可__小可 116.624293448|xiao ke;
小口__小口 110.677283245|xiao kou;
小孔__小孔 180.389043185|xiao kong;
小华__小華 183.106850936|xiao hua;
校花__校花 244.491487214|xiao hua;
小花__小花 604.195219728|xiao hua;
消化__消化 1925.29057912|xiao hua;
笑话__笑話 3149.7171872|xiao hua;
小黄__小黃 280.062456643|xiao huang;
销魂__銷魂 196.831399718|xiao hun;
小海__小海 178.377193209|xiao hai;
小孩__小孩 7516.77260869|xiao hai;
小号__小號 2655.38023445|xiao hao;
消耗__消耗 2746.24453283|xiao hao;
小河__小河 358.437246895|xiao he;
小黑__小黑 743.048258297|xiao hei;
小猴__小猴 138.335571213|xiao hou;
小红__小紅 539.420927296|xiao hong;
销户__銷戶 159.253810404|xiao hu;
小胡__小胡 242.36802267|xiao hu;
小虎__小虎 306.352568839|xiao hu;
小火__小火 324.83145542|xiao huo;
小伙__小伙 627.210588862|xiao huo;
小慧__小慧 108.898738333|xiao hui;
销毁__銷毀 534.069978074|xiao hui;
小娟__小娟 141.29744947|xiao juan;
小军__小軍 151.888225993|xiao jun;
校级__校級 113.32907693|xiao ji;
小记__小記 118.529012887|xiao ji;
小计__小計 319.213487372|xiao ji;
小鸡__小雞 553.723632203|xiao ji;
消极__消極 1012.12795618|xiao ji;
小家__小家 190.793818607|xiao jia;
小脚__小腳 151.321452046|xiao jiao;
小将__小將 347.442588754|xiao jiang;
小街__小街 106.483223576|xiao jie;
小杰__小傑 137.476305203|xiao jie;
消解__消解 170.76435144|xiao jie;
小节__小節 215.040276584|xiao jie;
小结__小結 534.069978074|xiao jie;
小姐__小姐 7773.98860371|xiao jie;
小金__小金 205.094534596|xiao jin;
小静__小靜 152.267254161|xiao jing;
小径__小徑 167.393257695|xiao jing;
孝敬__孝敬 280.062456643|xiao jing;
小酒__小酒 136.792736844|xiao jiu;
小聚__小聚 109.716025699|xiao ju;
小泉__小泉 630.344829195|xiao quan;
小憩__小憩 125.835280772|xiao qi;
小七__小七 142.535402072|xiao qi;
小气__小氣 1081.23274995|xiao qi;
小倩__小倩 170.127140854|xiao qian;
消遣__消遣 482.792710347|xiao qian;
小钱__小錢 519.626982517|xiao qian;
小桥__小橋 167.810977762|xiao qiao;
小乔__小喬 281.812926654|xiao qiao;
小巧__小巧 861.827215553|xiao qiao;
萧蔷__蕭薔 113.187937993|xiao qiang;
小强__小強 1132.25360251|xiao qiang;
校庆__校慶 250.037645335|xiao qing;
小青__小青 322.813777494|xiao qing;
小球__小球 266.112675706|xiao qiu;
小曲__小曲 107.818484324|xiao qu;
小觑__小覷 139.026849285|xiao qu;
校区__校區 1081.23274995|xiao qu;
小区__小區 5814.9173705|xiao qu;
小穴__小穴 131.117943492|xiao xue;
小雪__小雪 585.662213047|xiao xue;
小学__小學 5051.11880189|xiao xue;
小西__小西 179.045304336|xiao xi;
小溪__小溪 376.756940916|xiao xi;
消息__消息 21040.946775|xiao xi;
小虾__小蝦 114.607273411|xiao xia;
小夏__小夏 132.10198647|xiao xia;
小仙__小仙 144.863304286|xiao xian;
晓晓__曉曉 158.461958559|xiao xiao;
潇潇__瀟瀟 249.726250867|xiao xiao;
萧萧__蕭蕭 291.093289619|xiao xiao;
笑笑__笑笑 1160.82773443|xiao xiao;
小小__小小 2879.41941052|xiao xiao;
潇湘__瀟湘 212.377144726|xiao xiang;
肖像__肖像 249.726250867|xiao xiang;
小巷__小巷 324.02287532|xiao xiang;
小写__小寫 197.568631008|xiao xie;
小谢__小謝 277.284292303|xiao xie;
消协__消協 333.029068427|xiao xie;
孝心__孝心 155.333728851|xiao xin;
小新__小新 454.760723981|xiao xin;
小心__小心 9680.45270584|xiao xin;
小型__小型 1991.17198299|xiao xing;
小熊__小熊 827.104717768|xiao xiong;
小徐__小徐 175.510734618|xiao xu;
小站__小站 234.348853194|xiao zhan;
小张__小張 484.601008682|xiao zhang;
嚣张__囂張 912.673735821|xiao zhang;
校长__校長 3415.46445546|xiao zhang;
小赵__小趙 201.296414343|xiao zhao;
笑着__笑着 1861.58897661|xiao zhe;
小镇__小鎮 1051.99268696|xiao zhen;
小志__小志 105.953760973|xiao zhi;
小指__小指 117.93965545|xiao zhi;
小舟__小舟 138.508067822|xiao zhou;
小周__小周 234.348853194|xiao zhou;
效忠__效忠 132.10198647|xiao zhong;
消肿__消腫 163.069482749|xiao zhong;
小众__小眾 185.402943996|xiao zhong;
小筑__小築 113.611883002|xiao zhu;
小朱__小朱 203.313241605|xiao zhu;
小猪__小豬 2370.70341112|xiao zhu;
小川__小川 114.75018218|xiao chuan;
小船__小船 298.811606079|xiao chuan;
哮喘__哮喘 341.008342538|xiao chuan;
小窗__小窗 115.467403456|xiao chuang;
小春__小春 191.508436159|xiao chun;
小厂__小廠 146.132498493|xiao chang;
小肠__小腸 185.634130949|xiao chang;
校车__校車 205.350275845|xiao che;
小车__小車 765.607004232|xiao che;
消沉__消沉 216.924313917|xiao chen;
小陈__小陳 364.745529846|xiao chen;
小城__小城 473.851932013|xiao cheng;
小池__小池 124.431860131|xiao chi;
小吃__小吃 890.207990943|xiao chi;
小丑__小丑 411.098117295|xiao chou;
小虫__小蟲 340.15949445|xiao chong;
削除__削除 133.758497151|xiao chu;
消除__消除 3432.5319072|xiao chu;
孝顺__孝順 537.40806734|xiao shun;
小山__小山 347.442588754|xiao shan;
萧山__蕭山 356.655002599|xiao shan;
校舍__校舍 231.158356006|xiao she;
小胜__小勝 110.264288753|xiao sheng;
小生__小生 467.983588668|xiao sheng;
小声__小聲 664.215078095|xiao sheng;
笑声__笑聲 973.773879211|xiao sheng;
小视__小視 137.134095104|xiao shi;
小诗__小詩 162.258658377|xiao shi;
消逝__消逝 347.875829952|xiao shi;
小事__小事 1478.29531884|xiao shi;
消失__消失 6744.45298826|xiao shi;
小时__小時 21172.4586769|xiao shi;
消瘦__消瘦 275.218769535|xiao shou;
小手__小手 562.76710106|xiao shou;
销售__銷售 18926.1816262|xiao shou;
小树__小樹 271.810366771|xiao shu;
小数__小數 287.846772995|xiao shu;
小鼠__小鼠 460.463257431|xiao shu;
笑说__笑說 211.321149687|xiao shuo;
小说__小說 8070.12007169|xiao shuo;
小人__小人 1493.10664229|xiao ren;
消融__消融 127.572086295|xiao rong;
笑容__笑容 2784.14878864|xiao rong;
消灾__消災 113.32907693|xiao zai;
小泽__小澤 140.244908425|xiao ze;
小字__小字 135.604660605|xiao zi;
孝子__孝子 153.792848894|xiao zi;
小资__小資 634.284663664|xiao zi;
小子__小子 2879.41941052|xiao zi;
小组__小組 4091.89270964|xiao zu;
小嘴__小嘴 276.249600432|xiao zui;
小蔡__小蔡 148.889769675|xiao cai;
小菜__小菜 446.895626023|xiao cai;
小草__小草 503.060722916|xiao cao;
小葱__小蔥 144.143005824|xiao cong;
小翠__小翠 119.716577729|xiao cui;
小崔__小崔 132.596773978|xiao cui;
硝酸__硝酸 131.773154284|xiao suan;
小孙__小孫 118.529012887|xiao sun;
潇洒__瀟洒 1324.75423858|xiao sa;
消散__消散 212.112652282|xiao san;
小三__小三 418.854838101|xiao san;
萧瑟__蕭瑟 143.963491517|xiao se;
小四__小四 275.905561849|xiao si;
笑死__笑死 658.446218066|xiao si;
小松__小松 135.94305409|xiao song;
小苏__小蘇 107.684208225|xiao su;
小院__小院 182.196395498|xiao yuan;
校园__校園 3458.29313278|xiao yuan;
小月__小月 302.935867929|xiao yue;
小云__小雲 221.017305999|xiao yun;
小鸭__小鴨 112.906187218|xiao ya;
小雅__小雅 202.050369328|xiao ya;
小丫__小丫 223.788782324|xiao ya;
笑颜__笑顏 123.504952812|xiao yan;
笑言__笑言 151.510141313|xiao yan;
小燕__小燕 199.051387821|xiao yan;
硝烟__硝煙 262.162833911|xiao yan;
消炎__消炎 344.424970321|xiao yan;
小羊__小羊 205.862715427|xiao yang;
小杨__小楊 255.391156791|xiao yang;
小样__小樣 1236.99840673|xiao yang;
小妖__小妖 488.846754671|xiao yao;
逍遥__逍遙 1147.88120947|xiao yao;
小野__小野 122.890853693|xiao ye;
小叶__小葉 299.557272934|xiao ye;
宵夜__宵夜 414.699880708|xiao ye;
小姨__小姨 322.411748334|xiao yi;
笑意__笑意 397.991873082|xiao yi;
效益__效益 2798.06148652|xiao yi;
小樱__小櫻 107.282382453|xiao ying;
效应__效應 3217.15522047|xiao ying;
校友__校友 990.911721928|xiao you;
小勇__小勇 107.550099352|xiao yong;
效用__效用 333.029068427|xiao yong;
笑语__笑語 118.23396695|xiao yu;
小宇__小宇 182.423584067|xiao yu;
小玉__小玉 276.938965124|xiao yu;
小鱼__小魚 1169.53977147|xiao yu;
小雨__小雨 1300.22127911|xiao yu;
小于__小於 1526.97696483|xiao yu;
校外__校外 399.980682268|xiao wai;
小碗__小碗 124.122120652|xiao wan;
销往__銷往 231.446597362|xiao wang;
消亡__消亡 271.133768339|xiao wang;
小王__小王 568.405572245|xiao wang;
小文__小文 226.030964922|xiao wen;
小薇__小薇 149.075426771|xiao wei;
小伟__小偉 162.460985719|xiao wei;
笑我__笑我 222.67604562|xiao wo;
小窝__小窩 259.885889675|xiao wo;
小武__小武 146.497163581|xiao wu;
小五__小五 170.339279748|xiao wu;
小吴__小吳 255.073095111|xiao wu;
小屋__小屋 842.710774091|xiao wu;
小爱__小愛 164.908682755|xiao ai;
小艾__小艾 251.287110964|xiao ai;
小安__小安 108.087539034|xiao an;
笑傲__笑傲 167.810977762|xiao ao;
小额__小額 337.205131359|xiao e;
小二__小二 280.761336094|xiao er;
小儿__小兒 912.673735821|xiao er;
想把__想把 1226.25479235|xiang ba;
相伴__相伴 660.912425973|xiang ban;
箱包__箱包 138.85370659|xiang bao;
相悖__相悖 116.769717326|xiang bei;
向北__向北 327.26932246|xiang bei;
想必__想必 894.656458236|xiang bi;
相比__相比 7027.59035759|xiang bi;
香槟__香檳 229.150692759|xiang bin;
相配__相配 191.508436159|xiang pei;
橡皮__橡皮 269.449631503|xiang pi;
相片__相片 2067.02090848|xiang pian;
想买__想買 1319.8108917|xiang mai;
相貌__相貌 686.943814365|xiang mao;
项目__項目 41136.9997201|xiang mu;
想法__想法 11816.4816209|xiang fa;
襄樊__襄樊 385.303469841|xiang fan;
相反__相反 2292.26454686|xiang fan;
相仿__相仿 236.107646363|xiang fang;
相逢__相逢 479.196331601|xiang feng;
想飞__想飛 113.046974828|xiang fei;
享福__享福 154.947067523|xiang fu;
相符__相符 566.990680223|xiang fu;
想打__想打 153.028150386|xiang da;
相待__相待 124.587019602|xiang dai;
想当__想當 320.808632296|xiang dang;
相当__相當 15504.9541829|xiang dang;
向导__嚮導 658.446218066|xiang dao;
想到__想到 11845.9689584|xiang dao;
想得__想得 531.41444163|xiang de;
相等__相等 498.070459751|xiang deng;
向东__向東 487.02261325|xiang dong;
想多__想多 172.690339006|xiang duo;
相对__相對 11088.8579276|xiang dui;
像她__像她 138.508067822|xiang ta;
像他__像他 249.104624871|xiang ta;
向她__向她 555.105417084|xiang ta;
向他__向他 1026.09756322|xiang ta;
详谈__詳談 145.768741141|xiang tan;
湘潭__湘潭 298.06779536|xiang tan;
箱体__箱體 403.988165198|xiang ti;
香甜__香甜 244.491487214|xiang tian;
想听__想聽 300.679263607|xiang ting;
想通__想通 313.69268222|xiang tong;
相通__相通 482.792710347|xiang tong;
相同__相同 6744.45298826|xiang tong;
想吐__想吐 256.987424161|xiang tu;
乡土__鄉土 261.510250403|xiang tu;
向南__向南 390.135034682|xiang nan;
向内__向內 114.46454262|xiang nei;
箱内__箱內 256.028470459|xiang nei;
象你__象你 216.11485651|xiang ni;
像你__像你 679.282440527|xiang ni;
向你__向你 1420.50477658|xiang ni;
想你__想你 1986.21549859|xiang ni;
想念__想念 1771.06976716|xiang nian;
向您__向您 353.557372243|xiang nin;
香浓__香濃 112.765574943|xiang nong;
香辣__香辣 112.34478795|xiang la;
想来__想來 1073.17852213|xiang lai;
向来__向來 1130.84350481|xiang lai;
享乐__享樂 231.446597362|xiang le;
响了__響了 656.807194196|xiang le;
乡里__鄉里 242.36802267|xiang li;
相恋__相戀 320.010065926|xiang lian;
相连__相連 974.988119996|xiang lian;
项链__項鏈 1236.99840673|xiang lian;
香料__香料 336.365750338|xiang liao;
向量__向量 344.424970321|xiang liang;
响亮__響亮 493.129699012|xiang liang;
相邻__相鄰 520.923681206|xiang lin;
香炉__香爐 117.646076559|xiang lu;
相关__相關 25428.934798|xiang guan;
想干__想干 141.29744947|xiang gan;
相干__相干 343.996026791|xiang gan;
香港__香港 17916.371602|xiang gang;
想个__想個 117.207077876|xiang ge;
象个__象個 383.865702254|xiang ge;
相隔__相隔 490.066643104|xiang ge;
像个__像個 1542.27603899|xiang ge;
想跟__想跟 281.111429553|xiang gen;
想给__想給 335.110594827|xiang gei;
相公__相公 202.302314677|xiang gong;
香菇__香菇 336.365750338|xiang gu;
想过__想過 2148.43475692|xiang guo;
相框__相框 277.976239008|xiang kuang;
想开__想開 274.533686805|xiang kai;
想看__想看 1150.74567978|xiang kan;
相克__相剋 136.452228303|xiang ke;
想哭__想哭 478.599545119|xiang ku;
香花__香花 342.285588041|xiang hua;
相好__相好 121.066816454|xiang hao;
向好__向好 184.251320835|xiang hao;
想好__想好 1059.88791463|xiang hao;
祥和__祥和 353.117055307|xiang he;
向后__向後 469.736419493|xiang hou;
相互__相互 5490.95898063|xiang hu;
香火__香火 192.465424888|xiang huo;
想回__想回 109.034528882|xiang hui;
相会__相會 231.446597362|xiang hui;
湘军__湘軍 125.053659829|xiang jun;
相继__相繼 1540.35530331|xiang ji;
相机__相機 5197.98781874|xiang ji;
想家__想家 251.914183226|xiang jia;
相加__相加 301.805456692|xiang jia;
乡间__鄉間 199.299593609|xiang jian;
相间__相間 266.776744296|xiang jian;
想见__想見 344.85444872|xiang jian;
详见__詳見 600.442284667|xiang jian;
相见__相見 704.279880358|xiang jian;
相较__相較 200.545272755|xiang jiao;
相交__相交 302.181790975|xiang jiao;
橡胶__橡膠 878.088426229|xiang jiao;
香蕉__香蕉 1094.79101389|xiang jiao;
香江__香江 160.849404779|xiang jiang;
湘江__湘江 221.292902041|xiang jiang;
想借__想借 127.413209251|xiang jie;
相接__相接 164.908682755|xiang jie;
详解__詳解 377.226735448|xiang jie;
想进__想進 107.015331962|xiang jin;
想尽__想盡 309.036622663|xiang jin;
详尽__詳盡 675.904869515|xiang jin;
相近__相近 706.917758081|xiang jin;
香精__香精 146.497163581|xiang jing;
相距__相距 283.927938713|xiang ju;
相聚__相聚 587.855808729|xiang ju;
向其__向其 256.347723437|xiang qi;
象棋__象棋 396.506758465|xiang qi;
香气__香氣 598.94764591|xiang qi;
响起__響起 1349.75009317|xiang qi;
想起__想起 7764.30695341|xiang qi;
镶嵌__鑲嵌 501.808489233|xiang qian;
向前__向前 1791.04500392|xiang qian;
乡亲__鄉親 425.69561654|xiang qin;
相亲__相親 1199.05487625|xiang qin;
想请__想請 158.857391092|xiang qing;
详情__詳情 1156.49608257|xiang qing;
想去__想去 2787.62046424|xiang qu;
想学__想學 328.495108513|xiang xue;
向西__向西 324.02287532|xiang xi;
湘西__湘西 348.309611377|xiang xi;
详细__詳細 8503.75093978|xiang xi;
项下__項下 180.389043185|xiang xia;
乡下__鄉下 1019.7239982|xiang xia;
向下__向下 1279.32718167|xiang xia;
想笑__想笑 196.096919422|xiang xiao;
相向__相向 140.419785869|xiang xiang;
相像__相像 166.97657743|xiang xiang;
香香__香香 490.066643104|xiang xiang;
想像__想像 2632.31764915|xiang xiang;
想象__想象 5402.72120617|xiang xiang;
想想__想想 7535.53027431|xiang xiang;
想写__想寫 308.267359529|xiang xie;
相信__相信 20728.6414301|xiang xin;
相撞__相撞 301.805456692|xiang zhuang;
乡长__鄉長 164.908682755|xiang zhang;
想找__想找 774.242000696|xiang zhao;
向着__向著 611.771607197|xiang zhe;
想着__想着 3510.3970506|xiang zhe;
乡镇__鄉鎮 2379.58287209|xiang zhen;
象征__象徵 2059.3077787|xiang zheng;
相知__相知 271.810366771|xiang zhi;
相中__相中 204.839111844|xiang zhong;
相助__相助 250.974160423|xiang zhu;
相传__相傳 417.291872914|xiang chuan;
相差__相差 1474.61550226|xiang cha;
香肠__香腸 284.991389772|xiang chang;
响彻__響徹 121.520271774|xiang che;
相称__相稱 121.975425508|xiang chen;
相称__相稱 121.066816454|xiang cheng;
想吃__想吃 919.523371782|xiang chi;
乡愁__鄉愁 109.442917312|xiang chou;
想出__想出 512.55262135|xiang chu;
相处__相處 2151.11373318|xiang chu;
象山__象山 166.768626413|xiang shan;
香山__香山 377.226735448|xiang shan;
向上__向上 2135.08983815|xiang shang;
响声__響聲 322.010219858|xiang sheng;
相声__相聲 952.17431607|xiang sheng;
相视__相視 115.036534536|xiang shi;
翔实__翔實 118.23396695|xiang shi;
象是__象是 451.935995467|xiang shi;
相识__相識 1109.90155418|xiang shi;
像是__像是 2252.61977488|xiang shi;
相守__相守 225.468321935|xiang shou;
享受__享受 10815.9022772|xiang shou;
详述__詳述 113.046974828|xiang shu;
橡树__橡樹 114.75018218|xiang shu;
想说__想說 1394.19862478|xiang shuo;
想睡__想睡 126.464093517|xiang shui;
香水__香水 1521.27901981|xiang shui;
想让__想讓 1318.16721196|xiang rang;
相容__相容 130.628674269|xiang rong;
想再__想再 325.236501817|xiang zai;
想在__想在 840.61307342|xiang zai;
香皂__香皂 215.845709156|xiang zao;
祥子__祥子 155.527421199|xiang zi;
巷子__巷子 280.062456643|xiang zi;
箱子__箱子 2197.17084589|xiang zi;
想走__想走 205.60633599|xiang zou;
向左__向左 317.626273928|xiang zuo;
想做__想做 1235.45786087|xiang zuo;
乡村__鄉村 1721.02823483|xiang cun;
湘菜__湘菜 130.303509496|xiang cai;
香菜__香菜 193.427195796|xiang cai;
香草__香草 254.121284766|xiang cao;
相册__相冊 2746.24453283|xiang ce;
想从__想從 169.28122395|xiang cong;
想死__想死 372.091054935|xiang si;
相思__相思 896.889021007|xiang si;
相似__相似 3011.53728293|xiang si;
象素__象素 136.282292017|xiang su;
像素__像素 1986.21549859|xiang su;
相随__相隨 198.308623594|xiang sui;
相约__相約 594.486015613|xiang yue;
祥云__祥雲 158.264611567|xiang yun;
象牙__象牙 213.438416689|xiang ya;
香艳__香艷 135.604660605|xiang yan;
香烟__香煙 948.621258606|xiang yan;
襄阳__襄陽 214.772467501|xiang yang;
向阳__向陽 284.281980745|xiang yang;
像样__像樣 356.655002599|xiang yang;
想要__想要 6888.85726902|xiang yao;
相宜__相宜 124.742372548|xiang yi;
相依__相依 211.057972369|xiang yi;
响应__響應 2470.2273797|xiang ying;
相应__相應 9163.95030857|xiang ying;
香油__香油 187.961915178|xiang you;
向右__向右 339.735863102|xiang you;
享有__享有 1762.26354231|xiang you;
相拥__相擁 256.667374505|xiang yong;
想用__想用 520.274927886|xiang yong;
享用__享用 574.81640715|xiang yong;
享誉__享譽 214.2378495|xiang yu;
项羽__項羽 365.20034683|xiang yu;
相遇__相遇 1290.5357804|xiang yu;
向外__向外 740.275558891|xiang wai;
想玩__想玩 265.78126155|xiang wan;
相望__相望 212.377144726|xiang wang;
向往__嚮往 1746.95787997|xiang wang;
想问__想問 803.734894488|xiang wen;
相位__相位 278.669912425|xiang wei;
香味__香味 1050.68254543|xiang wei;
象我__象我 249.726250867|xiang wo;
像我__像我 1020.99553617|xiang wo;
向我__向我 1555.7884176|xiang wo;
想啊__想啊 184.71110921|xiang a;
相爱__相愛 1425.82527204|xiang ai;
写吧__寫吧 107.416157498|xie ba;
协办__協辦 265.119670945|xie ban;
谐波__諧波 150.756793028|xie bo;
斜坡__斜坡 210.795122809|xie po;
胁迫__脅迫 251.600451735|xie po;
写满__寫滿 203.820597887|xie man;
邪门__邪門 149.261315371|xie men;
泄密__泄密 226.877563077|xie mi;
写明__寫明 357.545014261|xie ming;
谢幕__謝幕 206.119414554|xie mu;
写法__寫法 468.567137655|xie fa;
协防__協防 114.321989585|xie fang;
鞋带__鞋帶 122.584950132|xie dai;
懈怠__懈怠 179.492101402|xie dai;
携带__攜帶 1777.70330251|xie dai;
写到__寫到 811.787668067|xie dao;
写道__寫道 825.045864155|xie dao;
写得__寫得 1795.51445179|xie de;
写的__寫的 5518.3979069|xie de;
鞋底__鞋底 198.803491145|xie di;
鞋垫__鞋墊 154.754097942|xie dian;
写点__寫點 444.119751258|xie dian;
卸掉__卸掉 117.93965545|xie diao;
协定__協定 494.9767145|xie ding;
亵渎__褻瀆 314.475483928|xie du;
协调__協調 5887.83431135|xie tiao;
协同__協同 1098.89154964|xie tong;
谢娜__謝娜 265.119670945|xie na;
谢拉__謝拉 211.584655172|xie la;
写了__寫了 3201.15867829|xie le;
鞋类__鞋類 118.972962872|xie lei;
协力__協力 119.56748386|xie li;
泄露__泄露 220.742053181|xie lou;
泄漏__泄漏 728.379591714|xie lou;
泄露__泄露 488.237949645|xie lu;
写稿__寫稿 136.963309627|xie gao;
写歌__寫歌 116.915322539|xie ge;
写个__寫個 553.723632203|xie ge;
写给__寫給 714.89082038|xie gei;
谢过__謝過 210.532600599|xie guo;
写过__寫過 862.9018652|xie guo;
写好__寫好 809.766942109|xie hao;
协和__協和 261.184568064|xie he;
邂逅__邂逅 504.316081474|xie hou;
协会__協會 5127.22081778|xie hui;
谢绝__謝絕 317.626273928|xie jue;
邪教__邪教 201.547419552|xie jiao;
写进__寫進 215.576896995|xie jin;
谢晋__謝晉 254.121284766|xie jin;
泄气__泄氣 154.947067523|xie qi;
邪气__邪氣 178.377193209|xie qi;
些钱__些錢 125.36572391|xie qian;
歇息__歇息 381.957020988|xie xi;
卸下__卸下 255.709615075|xie xia;
写下__寫下 1404.66211536|xie xia;
写些__寫些 162.460985719|xie xie;
歇歇__歇歇 227.443722742|xie xie;
写写__寫寫 556.490650127|xie xie;
谢谢__謝謝 47594.1298634|xie xie;
写信__寫信 1122.41972073|xie xin;
些许__些許 714.89082038|xie xu;
卸妆__卸妝 215.040276584|xie zhuang;
写照__寫照 289.285174995|xie zhao;
歇着__歇着 142.003528374|xie zhe;
写着__寫着 1476.45426414|xie zhe;
写真__寫真 1246.28210631|xie zhen;
协助__協助 3888.07743356|xie zhu;
斜插__斜插 322.411748334|xie cha;
携程__攜程 470.32215416|xie cheng;
写成__寫成 852.21539528|xie cheng;
挟持__挾持 128.049907079|xie chi;
写出__寫出 1485.68252323|xie chu;
写上__寫上 612.534451685|xie shang;
协商__協商 2415.4345439|xie shang;
写生__寫生 166.353500999|xie sheng;
写实__寫實 310.968189453|xie shi;
写诗__寫詩 337.625607028|xie shi;
写手__寫手 456.464028614|xie shou;
携手__攜手 1261.91002891|xie shou;
写书__寫書 209.485777119|xie shu;
卸任__卸任 178.59961945|xie ren;
写入__寫入 1136.49445424|xie ru;
写在__寫在 878.088426229|xie zai;
卸载__卸載 1693.37191801|xie zai;
蝎子__蠍子 546.185068786|xie zi;
写字__寫字 745.831342837|xie zi;
鞋子__鞋子 2705.48273369|xie zi;
协作__協作 1351.43315497|xie zuo;
写作__寫作 2974.24138187|xie zuo;
谢罪__謝罪 116.47905068|xie zui;
写错__寫錯 389.649164279|xie cuo;
斜阳__斜陽 181.064689688|xie yang;
鞋业__鞋業 188.196293023|xie ye;
谢意__謝意 182.878811433|xie yi;
写意__寫意 218.008308584|xie yi;
协议__協議 9039.18947747|xie yi;
谐音__諧音 250.661599628|xie yin;
写有__寫有 114.179614083|xie you;
写完__寫完 1132.25360251|xie wan;
邪恶__邪惡 1591.08064256|xie e;
新办__新辦 105.0335283|xin ban;
新版__新版 1755.68762073|xin ban;
新编__新編 162.258658377|xin bian;
心病__心病 167.184787749|xin bing;
新兵__新兵 335.110594827|xin bing;
信步__信步 126.464093517|xin bu;
新盘__新盤 186.561765129|xin pan;
新片__新片 579.130416613|xin pian;
芯片__芯片 3541.1527732|xin pian;
新品__新品 1498.69906777|xin pin;
新买__新買 320.808632296|xin mai;
新民__新民 371.627656329|xin min;
心魔__心魔 119.121315407|xin mo;
心目__心目 1491.2471417|xin mu;
新发__新發 162.663565352|xin fa;
新法__新法 184.481071779|xin fa;
心法__心法 203.566761683|xin fa;
新番__新番 138.335571213|xin fan;
心烦__心煩 544.825488702|xin fan;
心房__心房 176.387781073|xin fang;
信访__信訪 810.776675547|xin fang;
新房__新房 844.813709452|xin fang;
新风__新風 190.081867665|xin feng;
信奉__信奉 341.859308876|xin feng;
信封__信封 591.530074736|xin feng;
心肺__心肺 154.754097942|xin fei;
心扉__心扉 309.036622663|xin fei;
信佛__信佛 134.594525802|xin fo;
新服__新服 107.416157498|xin fu;
心腹__心腹 110.539446825|xin fu;
信服__信服 329.725485744|xin fu;
信达__信達 151.510141313|xin da;
信贷__信貸 1306.71862793|xin dai;
新蛋__新蛋 141.473639374|xin dan;
信道__信道 557.184562398|xin dao;
心得__心得 1577.26174289|xin de;
新的__新的 14954.6272886|xin de;
新低__新低 302.935867929|xin di;
心地__心地 461.037428991|xin di;
心底__心底 1548.05262827|xin di;
新店__新店 184.251320835|xin dian;
心都__心都 129.171793682|xin dou;
心动__心動 1229.31483934|xin dong;
心态__心態 5728.60805208|xin tai;
心疼__心疼 1964.0635567|xin teng;
心田__心田 148.704343794|xin tian;
信条__信條 160.849404779|xin tiao;
心跳__心跳 1013.39002232|xin tiao;
新帖__新帖 126.464093517|xin tie;
心头__心頭 1119.62576025|xin tou;
心痛__心痛 1313.24844471|xin tong;
信徒__信徒 410.07479966|xin tu;
信托__信託 813.813436628|xin tuo;
信念__信念 1380.36844936|xin nian;
新年__新年 1517.49220692|xin nian;
新娘__新娘 1288.92855961|xin niang;
心率__心率 203.313241605|xin lv;
辛辣__辛辣 316.441045148|xin la;
新来__新來 360.677581637|xin lai;
心来__心來 439.166555128|xin lai;
信赖__信賴 896.889021007|xin lai;
新郎__新郎 542.792461517|xin lang;
新浪__新浪 3991.16951133|xin lang;
辛劳__辛勞 195.365179853|xin lao;
新老__新老 419.900065808|xin lao;
心力__心力 173.769702743|xin li;
心理__心理 10937.8908136|xin li;
心里__心裡 16399.2743885|xin li;
信令__信令 243.882891747|xin ling;
心灵__心靈 4543.4453536|xin ling;
新楼__新樓 113.611883002|xin lou;
新路__新路 198.308623594|xin lu;
新光__新光 154.561368684|xin guang;
心肝__心肝 207.149415951|xin gan;
新港__新港 140.594881376|xin gang;
新高__新高 1226.25479235|xin gao;
辛格__辛格 122.737806611|xin ge;
新歌__新歌 684.380469812|xin ge;
新股__新股 1202.04704744|xin gu;
新贵__新貴 212.641966978|xin gui;
新规__新規 244.186999878|xin gui;
新款__新款 1209.56018338|xin kuan;
新开__新開 550.970372621|xin kai;
新科__新科 234.64107292|xin ke;
心口__心口 157.477678279|xin kou;
辛苦__辛苦 8610.38487191|xin ku;
新华__新華 869.377962205|xin hua;
新欢__新歡 217.19480623|xin huan;
心慌__心慌 206.119414554|xin huang;
新婚__新婚 506.83620443|xin hun;
心怀__心懷 264.789493468|xin huai;
信函__信函 225.749468142|xin han;
心寒__心寒 264.789493468|xin han;
信号__信號 6112.11725112|xin hao;
新货__新貨 195.121873946|xin huo;
新军__新軍 117.93965545|xin jun;
心悸__心悸 155.333728851|xin ji;
心计__心計 193.668388536|xin ji;
心肌__心肌 306.352568839|xin ji;
心机__心機 328.904723278|xin ji;
心急__心急 341.859308876|xin ji;
新机__新機 444.673543393|xin ji;
新加__新加 118.824795093|xin jia;
新家__新家 449.128812644|xin jia;
心间__心間 129.010924378|xin jian;
信件__信件 820.943519051|xin jian;
新建__新建 2952.08591378|xin jian;
新疆__新疆 3931.92961191|xin jiang;
心结__心結 183.335174792|xin jie;
新进__新進 245.71323808|xin jin;
薪金__薪金 303.691826638|xin jin;
新近__新近 343.567617462|xin jin;
心惊__心驚 109.034528882|xin jing;
心静__心靜 125.36572391|xin jing;
心经__心經 128.850255419|xin jing;
心境__心境 743.048258297|xin jing;
新旧__新舊 409.564096466|xin jiu;
新剧__新劇 174.42055653|xin ju;
新居__新居 244.491487214|xin ju;
新奇__新奇 581.299547476|xin qi;
新桥__新橋 153.601316766|xin qiao;
心切__心切 184.941433485|xin qie;
辛勤__辛勤 591.530074736|xin qin;
心情__心情 13169.6084966|xin qing;
新曲__新曲 117.353228453|xin qu;
新区__新區 1059.88791463|xin qu;
心血__心血 699.033618062|xin xue;
心系__心繫 190.556205829|xin xi;
欣喜__欣喜 708.681829926|xin xi;
信息__信息 48673.7771463|xin xi;
心下__心下 167.184787749|xin xia;
心弦__心弦 123.504952812|xin xian;
新鲜__新鮮 3759.43359875|xin xian;
新乡__新鄉 241.162905094|xin xiang;
心想__心想 998.348535653|xin xiang;
信箱__信箱 1536.52100517|xin xiang;
新新__新新 132.266710153|xin xin;
心心__心心 232.893204426|xin xin;
欣欣__欣欣 263.144763849|xin xin;
信心__信心 6096.90278745|xin xin;
心性__心性 159.055477247|xin xing;
新星__新星 333.860122955|xin xing;
新兴__新興 1326.40613196|xin xing;
新型__新型 3114.58889818|xin xing;
心胸__心胸 330.960471347|xin xiong;
新秀__新秀 444.673543393|xin xiu;
心绪__心緒 223.231720645|xin xu;
心虚__心虛 415.216987933|xin xu;
莘庄__莘庄 234.348853194|xin zhuang;
新装__新裝 252.85772688|xin zhuang;
新站__新站 107.015331962|xin zhan;
新招__新招 160.849404779|xin zhao;
新政__新政 624.091932797|xin zheng;
新知__新知 110.95347192|xin zhi;
信纸__信紙 138.335571213|xin zhi;
心智__心智 359.331706043|xin zhi;
信中__信中 346.1460998|xin zhong;
心中__心中 7891.11437871|xin zhong;
新春__新春 436.438689186|xin chun;
新昌__新昌 109.170488754|xin chang;
心肠__心腸 243.275811214|xin chang;
新潮__新潮 315.260239073|xin chao;
新车__新車 1368.37963334|xin che;
新城__新城 1003.33739315|xin cheng;
薪酬__薪酬 938.041438335|xin chou;
新宠__新寵 178.377193209|xin chong;
新出__新出 182.651055928|xin chu;
心上__心上 328.904723278|xin shang;
欣赏__欣賞 6219.68688957|xin shang;
心神__心神 219.097720093|xin shen;
心生__心生 352.677286738|xin sheng;
心声__心聲 779.081233415|xin sheng;
新生__新生 1697.59762841|xin sheng;
新诗__新詩 130.628674269|xin shi;
信使__信使 149.447435764|xin shi;
新式__新式 245.71323808|xin shi;
心事__心事 924.118331259|xin shi;
新手__新手 2127.12270781|xin shou;
新书__新書 595.22730595|xin shu;
薪水__薪水 1532.69625148|xin shui;
心软__心軟 235.519920202|xin ruan;
欣然__欣然 399.980682268|xin ran;
新任__新任 389.649164279|xin ren;
新人__新人 3699.02082656|xin ren;
信任__信任 4200.38893397|xin ren;
心如__心如 184.251320835|xin ru;
新锐__新銳 291.819695868|xin rui;
心脏__心臟 2018.65456559|xin zang;
新增__新增 3621.48192263|xin zeng;
薪资__薪資 501.808489233|xin zi;
新作__新作 531.41444163|xin zuo;
心醉__心醉 113.046974828|xin zui;
心存__心存 438.073368704|xin cun;
新村__新村 728.379591714|xin cun;
新词__新詞 144.322743975|xin ci;
辛酸__辛酸 394.043872187|xin suan;
心酸__心酸 439.714170908|xin suan;
心思__心思 2197.17084589|xin si;
心碎__心碎 542.792461517|xin sui;
心愿__心愿 1027.37704867|xin yuan;
新月__新月 228.580284053|xin yue;
心眼__心眼 426.757915008|xin yan;
信阳__信陽 209.485777119|xin yang;
信仰__信仰 2090.33406802|xin yang;
新药__新葯 360.677581637|xin yao;
心也__心也 145.587202159|xin ye;
新衣__新衣 129.979154132|xin yi;
心仪__心儀 389.649164279|xin yi;
新意__新意 583.476802811|xin yi;
心意__心意 859.681929668|xin yi;
新颖__新穎 789.834279627|xin ying;
心有__心有 271.810366771|xin you;
信用__信用 2280.86680445|xin yong;
新宇__新宇 116.044406778|xin yu;
心语__心語 158.857391092|xin yu;
信誉__信譽 1491.2471417|xin yu;
新网__新網 235.226605969|xin wang;
新闻__新聞 13006.5115898|xin wen;
欣慰__欣慰 898.007390736|xin wei;
心爱__心愛 1032.51096484|xin ai;
心安__心安 134.259489114|xin an;
新安__新安 145.950506492|xin an;
兴办__興辦 219.918349804|xing ban;
性别__性別 1740.43907177|xing bie;
性病__性病 528.772109212|xing bing;
行骗__行騙 155.140277726|xing pian;
行吗__行嗎 1129.43516323|xing ma;
幸免__倖免 240.562595233|xing mian;
性命__性命 643.841029976|xing ming;
姓名__姓名 3731.429143|xing ming;
醒目__醒目 895.772044085|xing mu;
刑罚__刑罰 315.653350706|xing fa;
刑法__刑法 642.238361775|xing fa;
兴奋__興奮 4623.40729705|xing fen;
性福__性福 229.150692759|xing fu;
幸福__幸福 16358.452828|xing fu;
行动__行動 8849.70991589|xing dong;
邢台__邢台 182.651055928|xing tai;
形态__形態 2464.07841638|xing tai;
形体__形體 375.351064872|xing ti;
行头__行頭 120.46484039|xing tou;
形同__形同 131.117943492|xing tong;
型男__型男 143.0692679|xing nan;
行囊__行囊 178.377193209|xing nang;
性能__性能 9129.7548451|xing neng;
醒来__醒來 2252.61977488|xing lai;
行礼__行禮 164.908682755|xing li;
行李__行李 1513.71482027|xing li;
兴隆__興隆 260.209952636|xing long;
星光__星光 706.917758081|xing guang;
性感__性感 3830.36770325|xing gan;
性格__性格 6521.3009778|xing ge;
行宫__行宮 140.244908425|xing gong;
兴国__興國 144.682892926|xing guo;
星空__星空 840.61307342|xing kong;
幸亏__幸虧 1055.93292173|xing kui;
杏花__杏花 162.460985719|xing hua;
兴华__興華 228.295612376|xing hua;
星海__星海 174.42055653|xing hai;
幸好__幸好 1766.66116773|xing hao;
型号__型號 4932.92737822|xing hao;
星河__星河 158.659551632|xing he;
星火__星火 181.742866823|xing huo;
行贿__行賄 364.745529846|xing hui;
行军__行軍 175.510734618|xing jun;
星级__星級 529.431458035|xing ji;
星际__星際 1166.62851836|xing ji;
兴建__興建 727.472474808|xing jian;
性交__性交 859.681929668|xing jiao;
行进__行進 379.111778956|xing jin;
刑警__刑警 328.904723278|xing jing;
行径__行徑 366.568203397|xing jing;
刑拘__刑拘 109.034528882|xing ju;
行权__行權 434.268601197|xing quan;
兴起__興起 1149.31255222|xing qi;
星期__星期 10061.7371458|xing qi;
性强__性強 311.355949144|xing qiang;
性情__性情 725.661628731|xing qing;
星球__星球 681.82669043|xing qiu;
性趣__性趣 192.705418355|xing qu;
兴趣__興趣 10238.8177518|xing qu;
性息__性息 128.049907079|xing xi;
星系__星系 315.260239073|xing xi;
性腺__性腺 107.282382453|xing xian;
行销__行銷 365.655730945|xing xiao;
形象__形象 8849.70991589|xing xiang;
行刑__行刑 107.282382453|xing xing;
醒醒__醒醒 205.862715427|xing xing;
行星__行星 483.394725468|xing xing;
猩猩__猩猩 548.914415679|xing xing;
星星__星星 2602.95983392|xing xing;
行凶__行兇 146.497163581|xing xiong;
星宿__星宿 136.452228303|xing xiu;
兴许__興許 175.948711373|xing xu;
性状__性狀 242.36802267|xing zhuang;
形状__形狀 1887.28302677|xing zhuang;
姓张__姓張 108.357265155|xing zhang;
醒着__醒着 108.222318063|xing zhe;
行者__行者 313.302012384|xing zhe;
刑侦__刑偵 244.491487214|xing zhen;
行政__行政 4841.57510783|xing zheng;
行之__行之 124.587019602|xing zhi;
行至__行至 167.393257695|xing zhi;
兴致__興緻 553.723632203|xing zhi;
性质__性質 4393.11752614|xing zhi;
行车__行車 529.431458035|xing che;
星辰__星辰 435.895152658|xing chen;
行程__行程 1873.22443719|xing cheng;
形成__形成 18299.9758408|xing cheng;
兴衰__興衰 187.027319083|xing shuai;
行善__行善 148.704343794|xing shan;
兴盛__興盛 218.280152578|xing sheng;
型式__型式 132.266710153|xing shi;
姓氏__姓氏 466.237298568|xing shi;
刑事__刑事 670.034480971|xing shi;
行事__行事 682.676889633|xing shi;
行使__行使 1303.46590513|xing shi;
行驶__行駛 1799.9950529|xing shi;
形势__形勢 3694.41410176|xing shi;
形式__形式 12205.6094005|xing shi;
杏仁__杏仁 245.71323808|xing ren;
行人__行人 1153.6172982|xing ren;
形容__形容 2129.77510916|xing rong;
形如__形如 112.906187218|xing ru;
性子__性子 413.667597456|xing zi;
行走__行走 1629.20244568|xing zou;
行踪__行蹤 280.761336094|xing zong;
星座__星座 1733.94458864|xing zuo;
幸存__倖存 199.051387821|xing cun;
型材__型材 147.596627936|xing cai;
形似__形似 185.86560618|xing si;
星月__星月 126.149295342|xing yue;
星云__星雲 165.939408926|xing yun;
幸运__幸運 3068.35985866|xing yun;
星爷__星爺 217.736803143|xing ye;
兴业__興業 684.380469812|xing ye;
行医__行醫 141.29744947|xing yi;
性欲__性慾 728.379591714|xing yu;
姓王__姓王 139.026849285|xing wang;
兴旺__興旺 361.12732612|xing wang;
行文__行文 241.463621556|xing wen;
腥味__腥味 160.049619219|xing wei;
行为__行為 17716.5531921|xing wei;
醒悟__醒悟 343.139741671|xing wu;
性爱__性愛 1571.37615922|xing ai;
胸部__胸部 1383.81307795|xiong bu;
胸脯__胸脯 251.914183226|xiong pu;
熊猫__熊貓 1827.1144412|xiong mao;
胸闷__胸悶 231.735198139|xiong men;
凶猛__兇猛 407.020105042|xiong meng;
兄妹__兄妹 468.567137655|xiong mei;
雄风__雄風 172.475272126|xiong feng;
兄弟__兄弟 9477.53097938|xiong di;
兄台__兄台 206.633773476|xiong tai;
胸膛__胸膛 371.627656329|xiong tang;
匈奴__匈奴 439.714170908|xiong nu;
雄鹿__雄鹿 223.231720645|xiong lu;
胸口__胸口 811.787668067|xiong kou;
胸怀__胸懷 542.11647303|xiong huai;
凶悍__兇悍 178.59961945|xiong han;
凶狠__兇狠 268.109857044|xiong hen;
雄厚__雄厚 639.84183651|xiong hou;
胸肌__胸肌 133.925286409|xiong ji;
胸襟__胸襟 200.29551561|xiong jin;
雄起__雄起 118.08671951|xiong qi;
凶器__兇器 142.891090816|xiong qi;
胸前__胸前 824.018360007|xiong qian;
胸腔__胸腔 170.76435144|xiong qiang;
凶险__兇險 151.510141313|xiong xian;
雄心__雄心 221.017305999|xiong xin;
雄性__雄性 266.112675706|xiong xing;
熊熊__熊熊 485.205278648|xiong xiong;
雄壮__雄壯 133.925286409|xiong zhuang;
熊掌__熊掌 181.742866823|xiong zhang;
兄长__兄長 222.953710017|xiong zhang;
胸罩__胸罩 361.577631409|xiong zhao;
胸中__胸中 185.402943996|xiong zhong;
雄狮__雄獅 108.357265155|xiong shi;
熊市__熊市 562.066236349|xiong shi;
凶手__兇手 862.9018652|xiong shou;
凶残__兇殘 192.705418355|xiong can;
雄鹰__雄鷹 202.302314677|xiong ying;
汹涌__洶湧 402.982545867|xiong yong;
胸围__胸圍 261.510250403|xiong wei;
雄伟__雄偉 285.346757867|xiong wei;
凶恶__兇惡 132.431639237|xiong e;
修补__修補 513.831666385|xiu bu;
秀美__秀美 254.755429543|xiu mei;
休眠__休眠 295.111021611|xiu mian;
秀发__秀髮 257.62872122|xiu fa;
修复__修復 3173.35588224|xiu fu;
嗅到__嗅到 139.72158175|xiu dao;
修道__修道 156.89004718|xiu dao;
修得__修得 116.333988795|xiu de;
修订__修訂 1282.5196677|xiu ding;
秀逗__秀逗 105.164499152|xiu dou;
修女__修女 155.140277726|xiu nv;
秀丽__秀麗 468.567137655|xiu li;
修理__修理 1399.42059064|xiu li;
修炼__修鍊 1058.56794047|xiu lian;
修路__修路 287.846772995|xiu lu;
修罗__修羅 227.160466527|xiu luo;
修改__修改 20268.8533736|xiu gai;
休克__休克 304.070513117|xiu ke;
袖口__袖口 136.792736844|xiu kou;
羞愧__羞愧 298.811606079|xiu kui;
绣花__繡花 282.516174301|xiu hua;
修好__修好 648.673070715|xiu hao;
修护__修護 175.292155245|xiu hu;
嗅觉__嗅覺 288.924902033|xiu jue;
休假__休假 1383.81307795|xiu jia;
修剪__修剪 310.194118206|xiu jian;
修建__修建 1173.92027842|xiu jian;
休憩__休憩 106.218162376|xiu qi;
秀气__秀氣 219.097720093|xiu qi;
休学__休學 147.229226029|xiu xue;
修习__修習 115.611384758|xiu xi;
休息__休息 17938.712301|xiu xi;
休闲__休閑 2780.68143664|xiu xian;
休想__休想 107.282382453|xiu xiang;
修行__修行 682.676889633|xiu xing;
秀秀__秀秀 305.589986932|xiu xiu;
袖珍__袖珍 147.229226029|xiu zhen;
修真__修真 160.849404779|xiu zhen;
休整__休整 214.772467501|xiu zheng;
修整__修整 225.468321935|xiu zheng;
修正__修正 2178.08791404|xiu zheng;
修筑__修築 165.73274959|xiu zhu;
秀场__秀場 133.925286409|xiu chang;
修长__修長 387.711726118|xiu chang;
修车__修車 339.735863102|xiu che;
修成__修成 171.403948695|xiu cheng;
羞耻__羞恥 299.93080386|xiu chi;
修缮__修繕 245.101601395|xiu shan;
修身__修身 310.194118206|xiu shen;
休市__休市 116.18910757|xiu shi;
修饰__修飾 746.761352211|xiu shi;
秀水__秀水 112.484875527|xiu shui;
羞辱__羞辱 376.756940916|xiu ru;
袖子__袖子 368.85935893|xiu zi;
秀才__秀才 374.883606282|xiu cai;
修辞__修辭 166.560934377|xiu ci;
羞涩__羞澀 502.434215952|xiu se;
休养__休養 223.510077937|xiu yang;
修养__修養 1009.60853723|xiu yang;
修为__修為 190.318888971|xiu wei;
虚报__虛報 169.492308033|xu bao;
虚名__虛名 117.499561272|xu ming;
徐明__徐明 121.671800659|xu ming;
畜牧__畜牧 360.228397261|xu mu;
序幕__序幕 555.105417084|xu mu;
许飞__許飛 192.465424888|xu fei;
续费__續費 550.284199441|xu fei;
旭东__旭東 107.282382453|xu dong;
虚度__虛度 174.203334854|xu du;
许多__許多 20728.6414301|xu duo;
虚脱__虛脫 151.888225993|xu tuo;
虚拟__虛擬 3441.09758945|xu ni;
许诺__許諾 330.548296374|xu nuo;
序列__序列 1179.78648723|xu lie;
虚高__虛高 189.136730609|xu gao;
虚构__虛構 550.284199441|xu gou;
徐工__徐工 173.769702743|xu gong;
徐克__徐克 172.475272126|xu ke;
许可__許可 2135.08983815|xu ke;
虚空__虛空 704.279880358|xu kong;
虚化__虛化 119.716577729|xu hua;
虚幻__虛幻 619.442999798|xu huan;
续航__續航 166.560934377|xu hang;
序号__序號 1104.38283164|xu hao;
徐汇__徐匯 250.037645335|xu hui;
续集__續集 437.527796363|xu ji;
虚假__虛假 1459.98760728|xu jia;
须经__須經 153.028150386|xu jing;
酗酒__酗酒 201.547419552|xu jiu;
许久__許久 705.158077415|xu jiu;
续签__續簽 247.249015706|xu qian;
需求__需求 19500.7754269|xu qiu;
序曲__序曲 116.915322539|xu qu;
许下__許下 220.742053181|xu xia;
许仙__許仙 118.676811842|xu xian;
虚线__虛線 125.053659829|xu xian;
续写__續寫 139.200207879|xu xie;
虚心__虛心 385.78392141|xu xin;
徐徐__徐徐 391.596284031|xu xu;
须知__須知 462.187920882|xu zhi;
徐州__徐州 1046.76190254|xu zhou;
续传__續傳 145.587202159|xu chuan;
许昌__許昌 164.293322714|xu chang;
嘘声__噓聲 111.091824605|xu sheng;
虚实__虛實 165.32020271|xu shi;
蓄势__蓄勢 172.260473089|xu shi;
叙事__敘事 545.504855178|xu shi;
叙述__敘述 1250.95005139|xu shu;
蓄水__蓄水 236.107646363|xu shui;
旭日__旭日 204.329220247|xu ri;
虚荣__虛榮 475.626742696|xu rong;
虚弱__虛弱 663.387871054|xu ruo;
须在__須在 111.507918629|xu zai;
徐总__徐總 134.259489114|xu zong;
许愿__許願 353.557372243|xu yuan;
续约__續約 353.557372243|xu yue;
序言__序言 152.457122789|xu yan;
须要__須要 113.611883002|xu yao;
需要__需要 82765.1723806|xu yao;
蓄意__蓄意 174.638049069|xu yi;
需用__需用 111.507918629|xu yong;
虚妄__虛妄 109.716025699|xu wang;
许巍__許巍 400.978810625|xu wei;
虚伪__虛偽 1236.99840673|xu wei;
虚无__虛無 436.438689186|xu wu;
抓捕__抓捕 355.324137339|zhua bu;
抓拍__抓拍 245.71323808|zhua pai;
抓到__抓到 599.694499646|zhua dao;
抓得__抓得 112.204874836|zhua de;
抓图__抓圖 175.510734618|zhua tu;
抓狂__抓狂 435.895152658|zhua kuang;
抓好__抓好 2069.59836629|zhua hao;
抓获__抓獲 737.513205869|zhua huo;
抓紧__抓緊 2227.49666896|zhua jin;
抓起__抓起 479.793862242|zhua qi;
抓取__抓取 420.94790182|zhua qu;
抓着__抓着 397.496217848|zhua zhe;
抓住__抓住 4226.64255951|zhua zhu;
抓手__抓手 142.357889859|zhua shou;
抓人__抓人 149.633788238|zhua ren;
爪子__爪子 1147.88120947|zhua zi;
专版__專版 215.040276584|zhuan ban;
转包__轉包 111.091824605|zhuan bao;
转变__轉變 4322.52167671|zhuan bian;
转播__轉播 584.204365283|zhuan bo;
转盘__轉盤 177.490254874|zhuan pan;
专卖__專賣 845.867144221|zhuan mai;
专门__專門 10137.2506989|zhuan men;
转发__轉發 2069.59836629|zhuan fa;
专访__專訪 1071.84199596|zhuan fang;
转达__轉達 267.109399762|zhuan da;
赚到__賺到 664.215078095|zhuan dao;
转到__轉到 1549.98296207|zhuan dao;
赚得__賺得 329.314848809|zhuan de;
专电__專電 160.849404779|zhuan dian;
赚点__賺點 294.743493195|zhuan dian;
转动__轉動 847.977956119|zhuan dong;
转台__轉檯 126.464093517|zhuan tai;
专题__專題 3492.94243288|zhuan ti;
转帖__轉帖 346.577724349|zhuan tie;
转贴__轉貼 753.303969661|zhuan tie;
转投__轉投 149.820373083|zhuan tou;
转头__轉頭 583.476802811|zhuan tou;
砖头__磚頭 662.561694208|zhuan tou;
转念__轉念 110.677283245|zhuan nian;
转来__轉來 181.290467084|zhuan lai;
专栏__專欄 1105.75993438|zhuan lan;
赚了__賺了 1427.60319527|zhuan le;
专利__專利 2476.39168739|zhuan li;
转录__轉錄 126.149295342|zhuan lu;
专稿__專稿 191.031727675|zhuan gao;
转告__轉告 446.339066527|zhuan gao;
转给__轉給 340.583654043|zhuan gei;
专供__專供 136.282292017|zhuan gong;
专攻__專攻 153.028150386|zhuan gong;
转过__轉過 377.226735448|zhuan guo;
转轨__轉軌 181.969489867|zhuan gui;
专柜__專櫃 688.658042404|zhuan gui;
专款__專款 140.945727665|zhuan kuan;
转开__轉開 105.164499152|zhuan kai;
专刊__專刊 135.435779871|zhuan kan;
专科__專科 1071.84199596|zhuan ke;
转化__轉化 2498.08815496|zhuan hua;
转换__轉換 5389.27259219|zhuan huan;
转行__轉行 395.027185582|zhuan hang;
专户__專戶 197.568631008|zhuan hu;
转回__轉回 167.184787749|zhuan hui;
转会__轉會 736.594714048|zhuan hui;
专机__專機 171.617679695|zhuan ji;
专集__專集 274.533686805|zhuan ji;
传记__傳記 348.743933702|zhuan ji;
转机__轉機 503.060722916|zhuan ji;
专辑__專輯 4745.99659028|zhuan ji;
转嫁__轉嫁 275.561951728|zhuan jia;
专家__專家 13637.2422365|zhuan jia;
转角__轉角 262.489736092|zhuan jiao;
转交__轉交 341.859308876|zhuan jiao;
转接__轉接 291.819695868|zhuan jie;
专精__專精 118.824795093|zhuan jing;
转圈__轉圈 140.594881376|zhuan quan;
赚钱__賺錢 7432.93925318|zhuan qian;
赚取__賺取 530.091629029|zhuan qu;
专区__專區 1356.49494292|zhuan qu;
转学__轉學 206.119414554|zhuan xue;
专线__專線 614.828697239|zhuan xian;
专项__專項 2164.55880585|zhuan xiang;
转向__轉向 2266.69928918|zhuan xiang;
撰写__撰寫 1178.31719254|zhuan xie;
专心__專心 1268.21593219|zhuan xin;
转型__轉型 2103.39925049|zhuan xing;
专修__專修 112.765574943|zhuan xiu;
转转__轉轉 875.902662456|zhuan zhuan;
转债__轉債 161.854759309|zhuan zhai;
转战__轉戰 289.645897197|zhuan zhan;
转帐__轉帳 348.743933702|zhuan zhang;
转账__轉賬 1197.56158489|zhuan zhang;
转折__轉折 485.810302105|zhuan zhe;
专政__專政 197.568631008|zhuan zheng;
转正__轉正 922.967443217|zhuan zheng;
转至__轉至 124.742372548|zhuan zhi;
转职__轉職 153.41002317|zhuan zhi;
转制__轉制 172.260473089|zhuan zhi;
专制__專制 704.279880358|zhuan zhi;
专职__專職 945.081459448|zhuan zhi;
专注__專註 1306.71862793|zhuan zhu;
专长__專長 352.677286738|zhuan chang;
专场__專場 477.408200926|zhuan chang;
转车__轉車 164.088713397|zhuan che;
专车__專車 211.584655172|zhuan che;
转成__轉成 383.387639617|zhuan cheng;
专程__專程 568.405572245|zhuan cheng;
转出__轉出 248.484546245|zhuan chu;
专杀__專殺 321.208662461|zhuan sha;
转身__轉身 2216.42096948|zhuan shen;
转生__轉生 175.510734618|zhuan sheng;
砖石__磚石 119.121315407|zhuan shi;
转世__轉世 294.376422496|zhuan shi;
转手__轉手 275.218769535|zhuan shou;
转述__轉述 137.476305203|zhuan shu;
专属__專屬 407.527636023|zhuan shu;
转让__轉讓 3233.23169914|zhuan rang;
专人__專人 729.287839744|zhuan ren;
转入__轉入 981.082073059|zhuan ru;
转载__轉載 6545.72648682|zhuan zai;
转增__轉增 115.899886195|zhuan zeng;
转子__轉子 234.056997396|zhuan zi;
转自__轉自 462.764242999|zhuan zi;
转租__轉租 128.049907079|zhuan zu;
转速__轉速 742.122873174|zhuan su;
专员__專員 514.472385324|zhuan yuan;
转运__轉運 282.164331387|zhuan yun;
转眼__轉眼 572.671468255|zhuan yan;
砖窑__磚窯 169.703655326|zhuan yao;
转业__轉業 244.186999878|zhuan ye;
专业__專業 24772.1043336|zhuan ye;
专一__專一 538.078184713|zhuan yi;
转移__轉移 5707.23163681|zhuan yi;
专营__專營 214.504991945|zhuan ying;
专有__專有 245.407229187|zhuan you;
转悠__轉悠 316.046952528|zhuan you;
专用__專用 5954.24100327|zhuan yong;
转弯__轉彎 445.228026075|zhuan wan;
专网__專網 121.066816454|zhuan wang;
撰文__撰文 294.009808944|zhuan wen;
专为__專為 559.968874971|zhuan wei;
转为__轉為 959.320404733|zhuan wei;
专案__專案 165.114314527|zhuan an;
转而__轉而 496.830647979|zhuan er;
装扮__裝扮 756.125466931|zhuang ban;
装备__裝備 9838.55481216|zhuang bei;
装配__裝配 627.992684885|zhuang pei;
装满__裝滿 360.228397261|zhuang man;
装大__裝大 131.117943492|zhuang da;
壮大__壯大 949.804135501|zhuang da;
装到__裝到 123.197520618|zhuang dao;
撞倒__撞倒 174.855812809|zhuang dao;
撞到__撞到 426.226434824|zhuang dao;
装得__裝得 153.028150386|zhuang de;
装点__裝點 179.940013424|zhuang dian;
装订__裝訂 251.600451735|zhuang ding;
状态__狀態 17109.0360795|zhuang tai;
撞了__撞了 269.449631503|zhuang le;
壮丽__壯麗 252.85772688|zhuang li;
壮烈__壯烈 170.339279748|zhuang lie;
壮观__壯觀 699.033618062|zhuang guan;
状告__狀告 291.456266438|zhuang gao;
状况__狀況 7277.12992155|zhuang kuang;
装潢__裝潢 400.978810625|zhuang huang;
壮汉__壯漢 107.952927857|zhuang han;
装好__裝好 648.673070715|zhuang hao;
撞击__撞擊 697.293562832|zhuang ji;
装机__裝機 708.681829926|zhuang ji;
庄稼__莊稼 303.313611771|zhuang jia;
装甲__裝甲 357.545014261|zhuang jia;
庄家__莊家 2191.70158301|zhuang jia;
撞见__撞見 140.594881376|zhuang jian;
装进__裝進 215.845709156|zhuang jin;
壮举__壯舉 179.045304336|zhuang ju;
撞墙__撞牆 271.471856767|zhuang qiang;
装箱__裝箱 181.064689688|zhuang xiang;
装卸__裝卸 243.275811214|zhuang xie;
装修__裝修 5382.56084417|zhuang xiu;
壮壮__壯壯 130.791560815|zhuang zhuang;
装着__裝着 445.228026075|zhuang zhe;
庄镇__庄鎮 117.792774542|zhuang zhen;
壮志__壯志 142.357889859|zhuang zhi;
装置__裝置 3149.7171872|zhuang zhi;
庄重__莊重 268.444174826|zhuang zhong;
庄主__莊主 125.678566729|zhuang zhu;
装船__裝船 106.483223576|zhuang chuan;
装车__裝車 111.786180106|zhuang che;
撞车__撞車 268.444174826|zhuang che;
装成__裝成 128.850255419|zhuang cheng;
装出__裝出 191.269933402|zhuang chu;
装傻__裝傻 230.870473623|zhuang sha;
撞上__撞上 354.43965395|zhuang shang;
装上__裝上 811.787668067|zhuang shang;
壮士__壯士 210.532600599|zhuang shi;
装饰__裝飾 2622.4951033|zhuang shi;
装束__裝束 206.89143407|zhuang shu;
撞人__撞人 124.276893895|zhuang ren;
妆容__妝容 196.831399718|zhuang rong;
装入__裝入 361.12732612|zhuang ru;
撞在__撞在 149.820373083|zhuang zai;
装在__裝在 422.52456065|zhuang zai;
装载__裝載 511.914293268|zhuang zai;
庄子__莊子 406.513206136|zhuang zi;
壮族__壯族 244.491487214|zhuang zu;
装作__裝作 447.452879516|zhuang zuo;
庄村__庄村 182.878811433|zhuang cun;
装死__裝死 143.426288875|zhuang si;
撞死__撞死 350.486645516|zhuang si;
庄园__莊園 419.377126323|zhuang yuan;
状元__狀元 586.392500602|zhuang yuan;
装运__裝運 135.098649108|zhuang yun;
庄严__莊嚴 523.526794166|zhuang yan;
壮阳__壯陽 185.172044961|zhuang yang;
装有__裝有 424.635962376|zhuang you;
装完__裝完 206.633773476|zhuang wan;
准备__準備 39430.4473261|zhun bei;
准确__準確 5721.47369896|zhun que;
准许__准許 209.485777119|zhun xu;
准时__準時 1292.14500531|zhun shi;
准入__准入 379.584509838|zhun ru;
准则__準則 1032.51096484|zhun ze;
准予__准予 153.41002317|zhun yu;
拽着__拽着 165.939408926|zhuai zhe;
闸北__閘北 166.768626413|zha bei;
诈骗__詐騙 1033.79844744|zha pian;
闸门__閘門 183.106850936|zha men;
渣打__渣打 110.401782066|zha da;
炸弹__炸彈 1577.26174289|zha dan;
炸掉__炸掉 165.32020271|zha diao;
扎堆__扎堆 215.30841961|zha dui;
栅栏__柵欄 178.822323044|zha lan;
炸了__炸了 153.601316766|zha le;
扎根__紮根 314.475483928|zha gen;
炸开__炸開 130.954650472|zha kai;
炸毁__炸毀 123.813152185|zha hui;
扎进__扎進 140.070248771|zha jin;
扎西__扎西 130.628674269|zha xi;
扎实__紮實 1261.91002891|zha shi;
渣滓__渣滓 110.677283245|zha zi;
榨菜__榨菜 129.494134325|zha cai;
炸死__炸死 167.184787749|zha si;
眨眼__眨眼 388.679238014|zha yan;
炸药__炸藥 369.779825848|zha yao;
摘编__摘編 604.195219728|zhai bian;
窄幅__窄幅 111.646962678|zhai fu;
摘得__摘得 108.898738333|zhai de;
摘掉__摘掉 467.400766428|zhai diao;
摘录__摘錄 307.500011268|zhai lu;
债权__債權 578.409173188|zhai quan;
债券__債券 1406.41364933|zhai quan;
摘取__摘取 129.817279349|zhai qu;
摘下__摘下 349.178797604|zhai xia;
债主__債主 124.276893895|zhai zhu;
摘抄__摘抄 135.94305409|zhai chao;
摘除__摘除 136.963309627|zhai chu;
债市__債市 111.646962678|zhai shi;
摘自__摘自 258.593668656|zhai zi;
摘要__摘要 1071.84199596|zhai yao;
债务__債務 1581.19770715|zhai wu;
战败__戰敗 201.296414343|zhan bai;
展板__展板 170.977284899|zhan ban;
战报__戰報 176.827946446|zhan bao;
战备__戰備 128.529517539|zhan bei;
沾边__沾邊 155.140277726|zhan bian;
占卜__占卜 255.391156791|zhan bu;
站牌__站牌 112.204874836|zhan pai;
展品__展品 256.987424161|zhan pin;
战平__戰平 137.991222203|zhan ping;
战马__戰馬 122.432284019|zhan ma;
沾满__沾滿 198.555903198|zhan man;
战法__戰法 138.508067822|zhan fa;
战犯__戰犯 145.587202159|zhan fan;
绽放__綻放 772.314734527|zhan fang;
战俘__戰俘 190.556205829|zhan fu;
斩断__斬斷 136.452228303|zhan duan;
占道__佔道 115.323601467|zhan dao;
站到__站到 352.677286738|zhan dao;
占到__佔到 768.474582473|zhan dao;
站得__站得 118.972962872|zhan de;
战地__戰地 242.670241844|zhan di;
占地__佔地 557.879339939|zhan di;
站点__站點 3177.31287701|zhan dian;
战斗__戰鬥 4210.87075845|zhan dou;
战队__戰隊 428.356335222|zhan dui;
站台__站台 475.034401746|zhan tai;
展台__展台 478.599545119|zhan tai;
粘贴__粘貼 2850.85613781|zhan tie;
展厅__展廳 495.593922384|zhan ting;
站内__站內 693.826435782|zhan nei;
战乱__戰亂 254.121284766|zhan luan;
战略__戰略 8000.02923116|zhan lue;
湛蓝__湛藍 180.839193473|zhan lan;
展览__展覽 1786.58668154|zhan lan;
沾了__沾了 134.762357541|zhan le;
站了__站了 530.091629029|zhan le;
占了__佔了 965.316430119|zhan le;
战栗__戰慄 105.821807183|zhan li;
战力__戰力 111.786180106|zhan li;
站立__站立 654.356305043|zhan li;
粘连__粘連 122.127521944|zhan lian;
占领__佔領 1429.38333547|zhan ling;
展露__展露 172.905674062|zhan lu;
展馆__展館 292.54791482|zhan guan;
站岗__站崗 194.878871049|zhan gang;
战歌__戰歌 526.142915167|zhan ge;
战功__戰功 148.149450567|zhan gong;
战果__戰果 165.939408926|zhan guo;
战国__戰國 387.711726118|zhan guo;
战况__戰況 131.773154284|zhan kuang;
展开__展開 5887.83431135|zhan kai;
战后__戰後 463.341283758|zhan hou;
斩获__斬獲 123.351140937|zhan huo;
战火__戰火 335.528458728|zhan huo;
展会__展會 1523.17596844|zhan hui;
战机__戰機 638.24912322|zhan ji;
战绩__戰績 713.111292931|zhan ji;
战舰__戰艦 292.912705474|zhan jian;
湛江__湛江 516.399339766|zhan jiang;
占尽__佔盡 117.792774542|zhan jin;
战局__戰局 122.279808036|zhan ju;
占据__佔據 2491.86983978|zhan ju;
占全__佔全 105.426930997|zhan quan;
站起__站起 159.253810404|zhan qi;
战前__戰前 155.915530766|zhan qian;
战区__戰區 195.852702213|zhan qu;
展区__展區 330.960471347|zhan qu;
占线__佔線 186.097370046|zhan xian;
战线__戰線 488.846754671|zhan xian;
展现__展現 3079.85238931|zhan xian;
展销__展銷 136.963309627|zhan xiao;
崭新__嶄新 1004.58849796|zhan xin;
占星__占星 171.617679695|zhan xing;
辗转__輾轉 455.895552723|zhan zhuan;
站长__站長 1799.9950529|zhan zhang;
展昭__展昭 112.204874836|zhan zhao;
占着__佔著 115.323601467|zhan zhe;
站着__站着 1249.39213028|zhan zhe;
战争__戰爭 5615.51843703|zhan zheng;
战中__戰中 118.676811842|zhan zhong;
站住__站住 158.461958559|zhan zhu;
战场__戰場 3648.66122213|zhan chang;
战车__戰車 326.861744407|zhan che;
展翅__展翅 159.452390871|zhan chi;
展出__展出 827.104717768|zhan chu;
斩杀__斬殺 123.504952812|zhan sha;
沾上__沾上 209.224885556|zhan shang;
站上__站上 242.36802267|zhan shang;
战神__戰神 476.219822262|zhan shen;
战胜__戰勝 1797.75335645|zhan sheng;
战事__戰事 211.057972369|zhan shi;
战时__戰時 237.287502254|zhan shi;
展示__展示 6778.15576203|zhan shi;
战士__戰士 7442.20770676|zhan shi;
斩首__斬首 126.464093517|zhan shou;
战术__戰術 1961.61753092|zhan shu;
沾染__沾染 180.164388413|zhan ran;
粘在__粘在 187.26053154|zhan zai;
站在__站在 7822.57824362|zhan zai;
占总__佔總 353.117055307|zhan zong;
占座__佔座 106.350610398|zhan zuo;
战死__戰死 186.794397067|zhan si;
瞻仰__瞻仰 203.566761683|zhan yang;
战役__戰役 1105.75993438|zhan yi;
占优__佔優 126.937764318|zhan you;
战友__戰友 927.579613097|zhan you;
占有__佔有 1854.64242019|zhan you;
占用__佔用 2172.66615296|zhan yong;
展望__展望 805.740567825|zhan wang;
站稳__站穩 357.099731154|zhan wen;
占位__佔位 113.895394799|zhan wei;
站位__站位 186.794397067|zhan wei;
展位__展位 471.495815538|zhan wei;
站务__站務 230.295783987|zhan wu;
账本__賬本 126.779677253|zhang ben;
长辈__長輩 665.872587905|zhang bei;
张斌__張斌 251.287110964|zhang bin;
长胖__長胖 205.60633599|zhang pang;
张鹏__張鵬 132.596773978|zhang peng;
帐篷__帳篷 973.773879211|zhang peng;
长满__長滿 231.158356006|zhang man;
掌门__掌門 270.796100963|zhang men;
账面__賬面 333.444336783|zhang mian;
张敏__張敏 143.426288875|zhang min;
张明__張明 234.933657026|zhang ming;
张某__張某 438.619621343|zhang mou;
账目__賬目 168.229740225|zhang mu;
帐目__帳目 314.475483928|zhang mu;
章法__章法 123.813152185|zhang fa;
张飞__張飛 366.111682898|zhang fei;
涨幅__漲幅 2400.43116637|zhang fu;
丈夫__丈夫 5044.82818733|zhang fu;
张大__張大 283.221176861|zhang da;
长大__長大 4221.3787397|zhang da;
帐单__帳單 163.272821143|zhang dan;
账单__賬單 654.356305043|zhang dan;
长到__長到 193.427195796|zhang dao;
涨到__漲到 677.591550514|zhang dao;
涨得__漲得 284.281980745|zhang de;
长的__長的 1136.49445424|zhang de;
长得__長得 3335.54580332|zhang de;
涨跌__漲跌 523.526794166|zhang die;
张涛__張濤 144.863304286|zhang tao;
张贴__張貼 555.105417084|zhang tie;
涨停__漲停 3922.14213601|zhang ting;
胀痛__脹痛 111.646962678|zhang tong;
张宁__張寧 164.908682755|zhang ning;
蟑螂__蟑螂 564.874943184|zhang lang;
长老__長老 460.463257431|zhang lao;
长了__長了 595.22730595|zhang le;
张磊__張磊 198.308623594|zhang lei;
张立__張立 106.085879302|zhang li;
张丽__張麗 151.321452046|zhang li;
张力__張力 571.958268741|zhang li;
张脸__張臉 265.450260135|zhang lian;
张辽__張遼 114.037415895|zhang liao;
张良__張良 143.0692679|zhang liang;
张罗__張羅 224.626982392|zhang luo;
掌管__掌管 288.205701591|zhang guan;
长官__長官 334.69325133|zhang guan;
长高__長高 216.654158472|zhang gao;
张国__張國 129.655606164|zhang guo;
掌柜__掌柜 456.464028614|zhang gui;
账款__賬款 189.845141544|zhang kuan;
张狂__張狂 141.29744947|zhang kuang;
张开__張開 874.811821743|zhang kai;
张口__張口 314.867617017|zhang kou;
掌控__掌控 789.834279627|zhang kong;
张华__張華 153.41002317|zhang hua;
张海__張海 186.32942291|zhang hai;
账号__賬號 1065.18429118|zhang hao;
帐号__帳號 7980.11532095|zhang hao;
张宏__張宏 110.401782066|zhang hong;
帐户__帳戶 2119.18530697|zhang hu;
账户__賬戶 4687.22055578|zhang hu;
张辉__張輝 108.492380517|zhang hui;
张俊__張俊 150.756793028|zhang jun;
张军__張軍 186.794397067|zhang jun;
掌机__掌機 129.171793682|zhang ji;
张家__張家 260.209952636|zhang jia;
涨价__漲價 2577.13898569|zhang jia;
张健__張健 114.46454262|zhang jian;
张建__張建 151.321452046|zhang jian;
张江__張江 532.740555233|zhang jiang;
张杰__張傑 584.204365283|zhang jie;
章节__章節 709.565515965|zhang jie;
长进__長進 270.458854115|zhang jin;
张静__張靜 155.915530766|zhang jing;
掌权__掌權 133.093414711|zhang quan;
张强__張強 142.891090816|zhang qiang;
彰显__彰顯 613.298247397|zhang xian;
张晓__張曉 142.891090816|zhang xiao;
长相__長相 1303.46590513|zhang xiang;
掌心__掌心 311.355949144|zhang xin;
张旭__張旭 114.75018218|zhang xu;
涨涨__漲漲 115.179978568|zhang zhang;
张着__張着 126.937764318|zhang zhe;
仗着__仗着 183.563783354|zhang zhe;
长着__長着 231.158356006|zhang zhe;
长者__長者 247.249015706|zhang zhe;
张震__張震 144.322743975|zhang zhen;
张志__張志 146.314717429|zhang zhi;
漳州__漳州 379.111778956|zhang zhou;
掌中__掌中 153.984619852|zhang zhong;
张超__張超 109.716025699|zhang chao;
长成__長成 322.010219858|zhang cheng;
章程__章程 620.215410078|zhang cheng;
张楚__張楚 136.282292017|zhang chu;
长出__長出 501.183541788|zhang chu;
账上__賬上 172.905674062|zhang shang;
掌上__掌上 236.991986692|zhang shang;
掌声__掌聲 995.863416846|zhang sheng;
张氏__張氏 111.925571131|zhang shi;
长势__長勢 128.049907079|zhang shi;
涨势__漲勢 293.277951001|zhang shi;
长肉__長肉 120.164975734|zhang rou;
长在__長在 257.3078729|zhang zai;
长子__長子 338.046607007|zhang zi;
张嘴__張嘴 312.132919672|zhang zui;
长孙__長孫 130.46599058|zhang sun;
张三__張三 361.12732612|zhang san;
张扬__張揚 934.541117987|zhang yang;
仗义__仗義 200.04606951|zhang yi;
张颖__張穎 107.416157498|zhang ying;
张勇__張勇 168.649547684|zhang yong;
张裕__張裕 108.087539034|zhang yu;
张玉__張玉 145.043940608|zhang yu;
张宇__張宇 197.814987883|zhang yu;
张钰__張鈺 219.644465616|zhang yu;
章鱼__章魚 222.121753798|zhang yu;
张望__張望 340.583654043|zhang wang;
张文__張文 197.076837307|zhang wen;
张伟__張偉 291.819695868|zhang wei;
掌握__掌握 8000.02923116|zhang wo;
帐务__帳務 276.249600432|zhang wu;
障碍__障礙 2773.75968187|zhang ai;
招办__招辦 250.037645335|zhao ban;
照搬__照搬 291.093289619|zhao ban;
罩杯__罩杯 131.281440129|zhao bei;
招标__招標 1840.82697426|zhao biao;
招牌__招牌 846.921892564|zhao pai;
照片__照片 29567.4423474|zhao pian;
招聘__招聘 4920.64818898|zhao pin;
着迷__着迷 386.746622582|zhao mi;
赵敏__趙敏 137.991222203|zhao min;
照明__照明 962.913535809|zhao ming;
赵某__趙某 123.813152185|zhao mou;
招募__招募 865.055186245|zhao mu;
找打__找打 113.611883002|zhao da;
招待__招待 727.472474808|zhao dai;
招到__招到 146.497163581|zhao dao;
找到__找到 22844.6595771|zhao dao;
照得__照得 144.502706249|zhao de;
找的__找的 272.149298879|zhao de;
找他__找他 965.316430119|zhao ta;
找你__找你 3302.45784674|zhao ni;
招来__招來 480.991159713|zhao lai;
找来__找來 660.089332023|zhao lai;
招揽__招攬 178.822323044|zhao lan;
照例__照例 269.449631503|zhao li;
照料__照料 299.557272934|zhao liao;
着凉__着涼 256.347723437|zhao liang;
照亮__照亮 448.010827873|zhao liang;
招录__招錄 144.322743975|zhao lu;
着陆__着陸 144.682892926|zhao lu;
着落__着落 281.461959558|zhao luo;
找个__找個 6578.43620239|zhao ge;
招工__招工 227.443722742|zhao gong;
招股__招股 152.457122789|zhao gu;
照顾__照顧 5714.34823089|zhao gu;
赵国__趙國 283.221176861|zhao guo;
找过__找過 324.83145542|zhao guo;
召开__召開 7881.2868611|zhao kai;
照看__照看 199.299593609|zhao kan;
招考__招考 364.745529846|zhao kao;
召唤__召喚 1542.27603899|zhao huan;
招行__招行 1925.29057912|zhao hang;
找好__找好 307.500011268|zhao hao;
招呼__招呼 2064.44666061|zhao hu;
着火__着火 301.805456692|zhao huo;
朝晖__朝暉 124.587019602|zhao hui;
召回__召回 646.252534205|zhao hui;
找回__找回 945.081459448|zhao hui;
召集__召集 1042.85588961|zhao ji;
着急__着急 4096.99506772|zhao ji;
赵家__趙家 128.529517539|zhao jia;
招架__招架 156.304608838|zhao jia;
召见__召見 118.529012887|zhao jian;
照旧__照舊 178.377193209|zhao jiu;
朝气__朝氣 233.183609039|zhao qi;
沼气__沼氣 353.117055307|zhao qi;
肇庆__肇慶 312.911829085|zhao qing;
找寻__找尋 534.735933039|zhao xun;
朝夕__朝夕 111.091824605|zhao xi;
朝霞__朝霞 128.369448119|zhao xia;
着想__着想 420.94790182|zhao xiang;
照相__照相 1182.73057528|zhao xiang;
找些__找些 259.562230298|zhao xie;
找准__找准 296.955549433|zhao zhun;
找着__找着 112.484875527|zhao zhao;
照照__照照 129.171793682|zhao zhao;
招招__招招 564.171453387|zhao zhao;
找找__找找 2652.07324956|zhao zhao;
罩着__罩着 125.522047856|zhao zhe;
照着__照着 615.595353746|zhao zhe;
招致__招致 237.583386308|zhao zhi;
找茬__找茬 123.504952812|zhao cha;
照常__照常 403.988165198|zhao chang;
照抄__照抄 107.684208225|zhao chao;
找抽__找抽 167.601987591|zhao chou;
找出__找出 1773.27819069|zhao chu;
招商__招商 3022.81698484|zhao shang;
照射__照射 558.574983827|zhao she;
招生__招生 2069.59836629|zhao sheng;
找事__找事 133.925286409|zhao shi;
昭示__昭示 205.350275845|zhao shi;
招式__招式 291.093289619|zhao shi;
肇事__肇事 364.745529846|zhao shi;
着手__着手 177.269210225|zhao shou;
招手__招手 348.309611377|zhao shou;
招收__招收 3007.78674349|zhao shou;
招数__招數 418.854838101|zhao shu;
找谁__找誰 248.484546245|zhao shui;
招惹__招惹 271.471856767|zhao re;
招人__招人 1208.05380881|zhao ren;
找人__找人 1903.81812306|zhao ren;
照在__照在 136.792736844|zhao zai;
沼泽__沼澤 835.391638074|zhao ze;
赵总__趙總 113.187937993|zhao zong;
招租__招租 109.716025699|zhao zu;
招财__招財 107.282382453|zhao cai;
找死__找死 326.861744407|zhao si;
赵云__趙雲 415.734739962|zhao yun;
朝阳__朝陽 386.264972075|zhao yang;
照样__照樣 1452.72816478|zhao yang;
招摇__招搖 187.26053154|zhao yao;
照耀__照耀 370.702589737|zhao yao;
照应__照應 217.465635832|zhao ying;
赵薇__趙薇 1326.40613196|zhao wei;
找我__找我 2959.45267121|zhao wo;
这把__這把 367.941183266|zhe ba;
这般__這般 670.034480971|zhe ban;
这帮__這幫 816.861571886|zhe bang;
这本__這本 947.439854855|zhe ben;
这比__這比 158.264611567|zhe bi;
遮蔽__遮蔽 172.04594156|zhe bi;
这笔__這筆 771.352901218|zhe bi;
这边__這邊 15142.152855|zhe bian;
这步__這步 109.30661816|zhe bu;
这不__這不 1328.06008516|zhe bu;
这部__這部 3951.57789686|zhe bu;
这盘__這盤 183.792676978|zhe pan;
这批__這批 767.517531652|zhe pi;
这片__這片 972.56115063|zhe pian;
这篇__這篇 1896.71398774|zhe pian;
这么__這麼 74446.6825354|zhe me;
这门__這門 328.904723278|zhe men;
这枚__這枚 132.596773978|zhe mei;
这面__這面 197.322580943|zhe mian;
这名__這名 869.377962205|zhe ming;
折磨__折磨 2116.54609407|zhe mo;
这番__這番 199.299593609|zhe fan;
这份__這份 2753.09762515|zhe fen;
这封__這封 221.017305999|zhe feng;
这副__這副 210.795122809|zhe fu;
折服__折服 243.57916235|zhe fu;
这幅__這幅 331.786363812|zhe fu;
折断__折斷 253.804804573|zhe duan;
这段__這段 3331.3917468|zhe duan;
浙大__浙大 646.252534205|zhe da;
遮挡__遮擋 304.070513117|zhe dang;
这倒__這倒 223.788782324|zhe dao;
这道__這道 316.83562918|zhe dao;
这等__這等 136.452228303|zhe deng;
这点__這點 3825.59740032|zhe dian;
折叠__摺疊 917.234466913|zhe die;
这都__這都 398.48814637|zhe dou;
这栋__這棟 176.827946446|zhe dong;
这对__這對 1932.50174796|zhe dui;
这台__這台 856.474009391|zhe tai;
蔗糖__蔗糖 116.18910757|zhe tang;
这趟__這趟 162.86639759|zhe tang;
这套__這套 1290.5357804|zhe tao;
折腾__折騰 2652.07324956|zhe teng;
这天__這天 741.198640518|zhe tian;
这条__這條 2467.15098238|zhe tiao;
这贴__這貼 239.068350048|zhe tie;
这头__這頭 238.473254015|zhe tou;
着呢__着呢 753.303969661|zhe ne;
这轮__這輪 157.67404401|zhe lun;
这类__這類 3811.32210727|zhe lei;
哲理__哲理 478.599545119|zhe li;
这里__這裡 57305.0204761|zhe li;
这俩__這倆 186.561765129|zhe lia;
着脸__着臉 375.819106356|zhe lian;
这辆__這輛 273.168633085|zhe liang;
这两__這兩 1408.16736736|zhe liang;
遮盖__遮蓋 267.775955618|zhe gai;
这歌__這歌 288.924902033|zhe ge;
这个__這個 253424.221766|zhe ge;
这跟__這跟 232.603161479|zhe gen;
这根__這根 246.019628549|zhe gen;
这更__這更 107.14877401|zhe geng;
这给__這給 123.044091616|zhe gei;
这股__這股 387.22887368|zhe gu;
这款__這款 5185.04883318|zhe kuan;
这块__這塊 2318.11814557|zhe kuai;
这棵__這棵 116.18910757|zhe ke;
这颗__這顆 329.725485744|zhe ke;
这可__這可 579.852559389|zhe ke;
这口__這口 122.890853693|zhe kou;
折扣__折扣 1672.40062475|zhe kou;
这话__這話 2013.62967073|zhe hua;
这还__這還 370.240920313|zhe hai;
这行__這行 423.578945935|zhe hang;
这和__這和 147.045868173|zhe he;
折合__摺合 366.111682898|zhe he;
这伙__這伙 113.046974828|zhe huo;
这会__這會 731.107734818|zhe hui;
这回__這回 1591.08064256|zhe hui;
这既__這既 127.254530072|zhe ji;
这几__這幾 470.908619205|zhe ji;
折价__折價 248.484546245|zhe jia;
这家__這家 2427.50473612|zhe jia;
这间__這間 293.277951001|zhe jian;
这件__這件 1119.62576025|zhe jian;
这叫__這叫 878.088426229|zhe jiao;
这将__這將 692.099342424|zhe jiang;
浙江__浙江 5865.86374011|zhe jiang;
这届__這屆 267.775955618|zhe jie;
折旧__折舊 372.555031371|zhe jiu;
这就__這就 5140.01549692|zhe jiu;
这句__這句 1494.96846157|zhe ju;
这群__這群 682.676889633|zhe qun;
这期__這期 270.796100963|zhe qi;
这起__這起 443.014235191|zhe qi;
这钱__這錢 183.563783354|zhe qian;
哲学__哲學 2675.30892006|zhe xue;
浙西__浙西 140.770195218|zhe xi;
这下__這下 1485.68252323|zhe xia;
这项__這項 2596.48046905|zhe xiang;
这些__這些 62997.6163464|zhe xie;
这桩__這樁 107.416157498|zhe zhuang;
这张__這張 3523.54522994|zhe zhang;
这招__這招 335.110594827|zhe zhao;
这真__這真 118.23396695|zhe zhen;
这支__這支 807.751246202|zhe zhi;
这只__這隻 1670.31783317|zhe zhi;
褶皱__褶皺 371.627656329|zhe zhou;
这周__這周 1882.58514584|zhe zhou;
折中__折中 110.264288753|zhe zhong;
这种__這種 51161.4893244|zhe zhong;
遮住__遮住 394.535222541|zhe zhu;
这场__這場 2763.40934226|zhe chang;
这车__這車 298.811606079|zhe che;
这双__這雙 193.90988203|zhe shuang;
浙商__浙商 184.941433485|zhe shang;
折射__折射 359.331706043|zhe she;
这身__這身 152.647228173|zhe shen;
这使__這使 350.92368248|zhe shi;
这事__這事 2491.86983978|zhe shi;
这时__這時 4722.39824658|zhe shi;
这是__這是 38748.4967652|zhe shi;
这首__這首 1129.43516323|zhe shou;
这书__這書 131.937467932|zhe shu;
这让__這讓 699.033618062|zhe rang;
哲人__哲人 142.180598718|zhe ren;
这人__這人 1629.20244568|zhe ren;
这在__這在 374.41672986|zhe zai;
这则__這則 227.160466527|zhe ze;
这组__這組 303.691826638|zhe zu;
这座__這座 1115.44785438|zhe zuo;
这才__這才 1244.72999861|zhe cai;
这层__這層 161.854759309|zhe ceng;
这次__這次 22646.2484782|zhe ci;
这算__這算 145.405889264|zhe suan;
折算__折算 299.557272934|zhe suan;
这三__這三 269.785619908|zhe san;
这四__這四 132.927661458|zhe si;
这厮__這廝 226.595011951|zhe si;
这艘__這艘 110.95347192|zhe sou;
这所__這所 125.053659829|zhe suo;
遮掩__遮掩 458.745029596|zhe yan;
遮阳__遮陽 164.498187167|zhe yang;
这样__這樣 131084.582315|zhe yang;
这要__這要 151.888225993|zhe yao;
者也__者也 216.11485651|zhe ye;
这也__這也 2759.96781896|zhe ye;
这一__這一 19452.2335179|zhe yi;
这有__這有 186.794397067|zhe you;
这又__這又 239.963779681|zhe you;
这与__這與 557.184562398|zhe yu;
这位__這位 7151.27177974|zhe wei;
这儿__這兒 2879.41941052|zhe er;
真棒__真棒 158.659551632|zhen bang;
珍宝__珍寶 219.37092252|zhen bao;
枕边__枕邊 125.36572391|zhen bian;
甄别__甄別 137.647730357|zhen bie;
真不__真不 673.382717005|zhen bu;
真皮__真皮 319.611528482|zhen pi;
真品__真品 179.268563673|zhen pin;
珍品__珍品 265.450260135|zhen pin;
侦破__偵破 328.904723278|zhen po;
真美__真美 274.533686805|zhen mei;
真没__真沒 414.699880708|zhen mei;
缜密__縝密 171.190483873|zhen mi;
真名__真名 411.098117295|zhen ming;
阵法__陣法 107.416157498|zhen fa;
振奋__振奮 385.78392141|zhen fen;
振幅__振幅 172.690339006|zhen fu;
诊断__診斷 2784.14878864|zhen duan;
振荡__振蕩 603.442760838|zhen dang;
震荡__震蕩 2355.97787927|zhen dang;
真得__真得 313.302012384|zhen de;
真的__真的 37606.7654474|zhen de;
真得__真得 125.209594649|zhen dei;
真谛__真諦 397.001179899|zhen di;
阵地__陣地 972.56115063|zhen di;
镇定__鎮定 418.333200332|zhen ding;
振动__振動 973.773879211|zhen dong;
震动__震動 1065.18429118|zhen dong;
真多__真多 584.204365283|zhen duo;
针对__針對 11241.9087221|zhen dui;
侦探__偵探 375.819106356|zhen tan;
真题__真題 406.513206136|zhen ti;
震天__震天 107.416157498|zhen tian;
针头__針頭 151.510141313|zhen tou;
枕头__枕頭 954.550411286|zhen tou;
阵痛__陣痛 179.045304336|zhen tong;
镇痛__鎮痛 184.481071779|zhen tong;
真难__真難 230.295783987|zhen nan;
真能__真能 451.373158744|zhen neng;
珍妮__珍妮 131.937467932|zhen ni;
真牛__真牛 170.127140854|zhen niu;
真累__真累 145.224802174|zhen lei;
镇里__鎮里 129.655606164|zhen li;
真理__真理 1899.07908248|zhen li;
诊疗__診療 356.210827905|zhen liao;
阵列__陣列 372.091054935|zhen lie;
贞观__貞觀 174.42055653|zhen guan;
真乖__真乖 144.502706249|zhen guai;
真个__真箇 196.586267794|zhen ge;
真够__真夠 440.262469534|zhen gou;
珍贵__珍貴 1791.04500392|zhen gui;
真快__真快 580.575602636|zhen kuai;
真空__真空 821.967189047|zhen kong;
振华__振華 276.938965124|zhen hua;
真话__真話 648.673070715|zhen hua;
镇海__鎮海 132.762114633|zhen hai;
震撼__震撼 1993.6548615|zhen han;
真好__真好 2485.66700342|zhen hao;
真会__真會 231.735198139|zhen hui;
真菌__真菌 256.987424161|zhen jun;
真机__真機 148.149450567|zhen ji;
真假__真假 840.61307342|zhen jia;
真叫__真叫 113.47039186|zhen jiao;
镇江__鎮江 565.579310193|zhen jiang;
贞洁__貞潔 108.357265155|zhen jie;
镇静__鎮靜 300.679263607|zhen jing;
震惊__震驚 1265.05905145|zhen jing;
针灸__針灸 374.41672986|zhen jiu;
真气__真氣 229.722524886|zhen qi;
真强__真強 154.176629937|zhen qiang;
真切__真切 460.463257431|zhen qie;
真情__真情 1041.55712696|zhen qing;
镇区__鎮區 144.322743975|zhen qu;
珍稀__珍稀 203.566761683|zhen xi;
珍惜__珍惜 3298.34499764|zhen xi;
阵线__陣線 112.204874836|zhen xian;
真象__真象 141.650048976|zhen xiang;
真像__真像 197.076837307|zhen xiang;
真想__真想 1211.06843631|zhen xiang;
真相__真相 2266.69928918|zhen xiang;
真心__真心 2095.55037421|zhen xin;
阵型__陣型 192.465424888|zhen xing;
振兴__振興 840.61307342|zhen xing;
镇长__鎮長 310.194118206|zhen zhang;
枕着__枕着 160.249192015|zhen zhe;
真真__真真 285.702569086|zhen zhen;
阵阵__陣陣 700.778015498|zhen zhen;
真正__真正 20548.6084333|zhen zheng;
针织__針織 301.805456692|zhen zhi;
诊治__診治 462.187920882|zhen zhi;
真挚__真摯 522.874798954|zhen zhi;
震中__震中 153.218967809|zhen zhong;
珍重__珍重 156.694657831|zhen zhong;
真主__真主 125.522047856|zhen zhu;
珍珠__珍珠 1142.1736421|zhen zhu;
斟酌__斟酌 288.565077751|zhen zhuo;
侦察__偵察 517.687984062|zhen cha;
侦查__偵查 844.813709452|zhen cha;
震颤__震顫 121.217779906|zhen chan;
真诚__真誠 2865.10217964|zhen cheng;
真爽__真爽 247.557321202|zhen shuang;
镇上__鎮上 396.012952778|zhen shang;
震慑__震懾 191.747236314|zhen she;
真身__真身 114.607273411|zhen shen;
阵势__陣勢 150.756793028|zhen shi;
珍视__珍視 163.069482749|zhen shi;
真实__真實 10328.5233418|zhen shi;
真是__真是 21679.7442787|zhen shi;
真人__真人 1241.63157975|zhen ren;
阵容__陣容 1215.60448872|zhen rong;
真如__真如 219.644465616|zhen ru;
赈灾__賑災 267.109399762|zhen zai;
贞子__貞子 128.369448119|zhen zi;
阵子__陣子 263.801426189|zhen zi;
振作__振作 290.0070692|zhen zuo;
珍藏__珍藏 706.917758081|zhen cang;
贞操__貞操 188.665925845|zhen cao;
侦测__偵測 218.008308584|zhen ce;
针刺__針刺 229.436430673|zhen ci;
真丝__真絲 151.132997772|zhen si;
诊所__診所 546.185068786|zhen suo;
真晕__真暈 111.646962678|zhen yun;
镇压__鎮壓 504.944935018|zhen ya;
真言__真言 116.47905068|zhen yan;
箴言__箴言 150.194241046|zhen yan;
真要__真要 582.750146437|zhen yao;
阵营__陣營 825.045864155|zhen ying;
真有__真有 1114.0586864|zhen you;
阵雨__陣雨 242.36802267|zhen yu;
阵亡__陣亡 225.187525865|zhen wang;
真伪__真偽 419.377126323|zhen wei;
珍爱__珍愛 192.465424888|zhen ai;
真爱__真愛 999.59341964|zhen ai;
争霸__爭霸 462.764242999|zheng ba;
整版__整版 128.369448119|zheng ban;
正版__正版 2794.57680777|zheng ban;
正本__正本 210.795122809|zheng ben;
正被__正被 132.10198647|zheng bei;
正比__正比 105.690017726|zheng bi;
政变__政變 220.742053181|zheng bian;
争辩__爭辯 261.83633885|zheng bian;
征兵__徵兵 162.460985719|zheng bing;
整部__整部 255.073095111|zheng bu;
正派__正派 217.465635832|zheng pai;
正品__正品 809.766942109|zheng pin;
正门__正門 248.175085992|zheng men;
正面__正面 2712.23410734|zheng mian;
正名__正名 137.647730357|zheng ming;
证明__證明 11284.0152502|zheng ming;
正法__正法 114.179614083|zheng fa;
政法__政法 403.988165198|zheng fa;
蒸发__蒸發 564.171453387|zheng fa;
正反__正反 221.292902041|zheng fan;
正方__正方 129.010924378|zheng fang;
正负__正負 149.261315371|zheng fu;
征服__征服 1438.31738787|zheng fu;
政府__政府 27677.6993611|zheng fu;
争端__爭端 373.484720623|zheng duan;
整顿__整頓 1135.07907503|zheng dun;
正大__正大 254.755429543|zheng da;
睁大__睜大 300.304800557|zheng da;
争当__爭當 136.112567367|zheng dang;
政党__政黨 832.274357505|zheng dang;
正当__正當 1605.02061407|zheng dang;
挣到__掙到 185.86560618|zheng dao;
正道__正道 294.743493195|zheng dao;
挣得__掙得 169.703655326|zheng de;
争得__爭得 182.196395498|zheng de;
征得__徵得 325.236501817|zheng de;
征地__征地 536.070335228|zheng di;
整点__整點 128.529517539|zheng dian;
正点__正點 197.814987883|zheng dian;
征订__征訂 118.381397999|zheng ding;
争斗__爭鬥 355.324137339|zheng dou;
争夺__爭奪 1523.17596844|zheng duo;
正对__正對 274.191785204|zheng dui;
正太__正太 235.813600182|zheng tai;
政坛__政壇 269.449631503|zheng tan;
整套__整套 323.216307961|zheng tao;
政体__政體 149.447435764|zheng ti;
正题__正題 219.097720093|zheng ti;
整体__整體 10036.691171|zheng ti;
整天__整天 3666.89398377|zheng tian;
整条__整條 206.633773476|zheng tiao;
正统__正統 408.035799866|zheng tong;
征途__征途 642.238361775|zheng tu;
挣脱__掙脫 366.568203397|zheng tuo;
狰狞__猙獰 211.584655172|zheng ning;
争论__爭論 1859.27057168|zheng lun;
整理__整理 8029.99331146|zheng li;
政令__政令 105.0335283|zheng ling;
整流__整流 120.916041011|zheng liu;
蒸馏__蒸餾 121.217779906|zheng liu;
正龙__正龍 264.459727191|zheng long;
征管__征管 217.736803143|zheng guan;
争光__爭光 133.925286409|zheng guang;
整改__整改 1415.20413466|zheng gai;
征稿__徵稿 121.671800659|zheng gao;
整个__整個 18299.9758408|zheng ge;
正果__正果 171.617679695|zheng guo;
正轨__正軌 210.270405333|zheng gui;
正规__正規 2379.58287209|zheng gui;
整块__整塊 117.061109314|zheng kuai;
睁开__睜開 565.579310193|zheng kai;
政客__政客 433.187606905|zheng ke;
征婚__徵婚 451.373158744|zheng hun;
蒸好__蒸好 433.187606905|zheng hao;
正好__正好 7340.88720769|zheng hao;
郑和__鄭和 167.393257695|zheng he;
整合__整合 5342.46552582|zheng he;
证卷__證卷 134.092283643|zheng juan;
郑钧__鄭鈞 194.636170786|zheng jun;
政绩__政績 555.105417084|zheng ji;
整机__整機 697.293562832|zheng ji;
征集__徵集 1266.63650832|zheng ji;
正佳__正佳 128.689786556|zheng jia;
证件__證件 1771.06976716|zheng jian;
正交__正交 157.477678279|zheng jiao;
郑洁__鄭潔 127.413209251|zheng jie;
政界__政界 208.70407676|zheng jie;
正解__正解 240.263000901|zheng jie;
症结__癥結 241.463621556|zheng jie;
整洁__整潔 610.248767154|zheng jie;
政经__政經 130.46599058|zheng jing;
正经__正經 958.125676369|zheng jing;
拯救__拯救 1459.98760728|zheng jiu;
政局__政局 230.870473623|zheng ju;
证据__證據 4426.08796739|zheng ju;
政权__政權 1438.31738787|zheng quan;
证券__證券 4076.62373033|zheng quan;
正确__正確 9937.12917391|zheng que;
正气__正氣 274.533686805|zheng qi;
争气__爭氣 499.935980841|zheng qi;
蒸气__蒸氣 853.278059532|zheng qi;
整齐__整齊 1147.88120947|zheng qi;
蒸汽__蒸汽 1356.49494292|zheng qi;
挣钱__掙錢 2191.70158301|zheng qian;
正巧__正巧 179.492101402|zheng qiao;
争抢__爭搶 241.463621556|zheng qiang;
征求__徵求 913.811788194|zheng qiu;
争取__爭取 6578.43620239|zheng qu;
征询__徵詢 209.224885556|zheng xun;
正像__正像 170.977284899|zheng xiang;
正向__正向 321.208662461|zheng xiang;
正想__正想 354.881620091|zheng xiang;
争相__爭相 414.183417482|zheng xiang;
政协__政協 946.259922413|zheng xie;
征信__徵信 157.870654598|zheng xin;
整形__整形 411.098117295|zheng xing;
整修__整修 171.831677206|zheng xiu;
正装__正裝 210.532600599|zheng zhuang;
症状__癥狀 3961.43882797|zheng zhuang;
挣扎__掙扎 1880.24059249|zheng zha;
征战__征戰 394.043872187|zheng zhan;
整张__整張 172.690339006|zheng zhang;
证照__證照 175.292155245|zheng zhao;
征兆__徵兆 346.1460998|zheng zhao;
争着__爭着 166.97657743|zheng zhe;
睁着__睜着 229.150692759|zheng zhe;
怔怔__怔怔 136.963309627|zheng zheng;
整整__整整 1643.47641462|zheng zheng;
正职__正職 123.044091616|zheng zhi;
郑智__鄭智 420.423657369|zheng zhi;
正直__正直 560.667124391|zheng zhi;
正值__正值 564.874943184|zheng zhi;
争执__爭執 686.943814365|zheng zhi;
整治__整治 1806.7369278|zheng zhi;
政治__政治 10124.6258648|zheng zhi;
郑州__鄭州 2897.41660082|zheng zhou;
正中__正中 331.786363812|zheng zhong;
郑重__鄭重 622.538424634|zheng zhong;
争创__爭創 192.225730308|zheng chuang;
整场__整場 152.077621994|zheng chang;
正常__正常 20446.4353459|zheng chang;
争吵__爭吵 801.734213733|zheng chao;
整车__整車 601.191002133|zheng che;
征程__征程 282.164331387|zheng cheng;
正处__正處 313.69268222|zheng chu;
政审__政審 111.230349808|zheng shen;
政事__政事 107.818484324|zheng shi;
正事__正事 417.291872914|zheng shi;
正视__正視 581.299547476|zheng shi;
证实__證實 3527.93889096|zheng shi;
正是__正是 8546.24511901|zheng shi;
正式__正式 12749.7474029|zheng shi;
征收__徵收 1662.01257345|zheng shou;
蒸熟__蒸熟 131.609045271|zheng shu;
整数__整數 601.940653207|zheng shu;
证书__證書 4061.41172752|zheng shu;
征税__徵稅 437.527796363|zheng shui;
整人__整人 122.279808036|zheng ren;
证人__證人 536.070335228|zheng ren;
整日__整日 309.036622663|zheng ri;
整容__整容 648.673070715|zheng rong;
正如__正如 2224.72256613|zheng ru;
正在__正在 24926.9370315|zheng zai;
正则__正則 219.097720093|zheng ze;
正宗__正宗 954.550411286|zheng zong;
整座__整座 107.416157498|zheng zuo;
争做__爭做 118.381397999|zheng zuo;
正餐__正餐 125.522047856|zheng can;
政策__政策 15274.8181478|zheng ce;
证词__證詞 120.46484039|zheng ci;
正从__正從 121.217779906|zheng cong;
整死__整死 108.087539034|zheng si;
正月__正月 234.933657026|zheng yue;
证言__證言 145.768741141|zheng yan;
睁眼__睜眼 281.461959558|zheng yan;
政要__政要 154.561368684|zheng yao;
正要__正要 583.476802811|zheng yao;
整夜__整夜 184.71110921|zheng ye;
正以__正以 165.32020271|zheng yi;
正义__正義 1956.73461434|zheng yi;
争议__爭議 2523.11697781|zheng yi;
正因__正因 110.815291538|zheng yin;
征友__徵友 105.953760973|zheng you;
征用__徵用 267.775955618|zheng yong;
正与__正與 170.339279748|zheng yu;
整晚__整晚 145.768741141|zheng wan;
征文__徵文 381.957020988|zheng wen;
正文__正文 947.439854855|zheng wen;
正为__正為 107.550099352|zheng wei;
政委__政委 515.113903202|zheng wei;
正午__正午 168.649547684|zheng wu;
政务__政務 685.233853433|zheng wu;
只把__只把 186.561765129|zhi ba;
直白__直白 382.433299725|zhi bai;
制版__製版 140.419785869|zhi ban;
纸板__紙板 169.070402749|zhi ban;
直板__直板 224.347234118|zhi ban;
值班__值班 1939.73992621|zhi ban;
之宝__之寶 133.093414711|zhi bao;
质保__質保 381.957020988|zhi bao;
治本__治本 235.813600182|zhi ben;
之本__之本 303.691826638|zhi ben;
直奔__直奔 558.574983827|zhi ben;
之辈__之輩 205.350275845|zhi bei;
植被__植被 403.988165198|zhi bei;
制备__製備 800.735741689|zhi bei;
只比__只比 105.690017726|zhi bi;
之笔__之筆 107.282382453|zhi bi;
执笔__執筆 110.264288753|zhi bi;
直逼__直逼 157.085680168|zhi bi;
之比__之比 161.451865638|zhi bi;
纸币__紙幣 236.107646363|zhi bi;
之变__之變 113.895394799|zhi bian;
质变__質變 182.423584067|zhi bian;
治标__治標 131.281440129|zhi biao;
指标__指標 6392.5626507|zhi biao;
之滨__之濱 110.126966673|zhi bin;
致病__致病 244.491487214|zhi bing;
治病__治病 722.953807881|zhi bing;
直播__直播 2169.96033552|zhi bo;
止步__止步 228.295612376|zhi bu;
支部__支部 547.548041623|zhi bu;
只怕__只怕 619.442999798|zhi pa;
纸牌__紙牌 113.611883002|zhi pai;
指派__指派 323.619340361|zhi pai;
支配__支配 847.977956119|zhi pei;
制皮__制皮 152.457122789|zhi pi;
纸片__紙片 203.566761683|zhi pian;
制片__製片 257.3078729|zhi pian;
支票__支票 911.537100768|zhi piao;
制品__製品 1187.16048834|zhi pin;
质朴__質樸 299.93080386|zhi pu;
芝麻__芝麻 661.736546275|zhi ma;
只买__只買 170.551683166|zhi mai;
只卖__只賣 248.794392378|zhi mai;
只猫__只貓 117.353228453|zhi mao;
之门__之門 458.173712968|zhi men;
之梦__之夢 208.70407676|zhi meng;
之美__之美 662.561694208|zhi mei;
之谜__之謎 392.084582382|zhi mi;
直面__直面 376.287731462|zhi mian;
之妙__之妙 146.679837233|zhi miao;
殖民__殖民 399.980682268|zhi min;
指名__指名 154.947067523|zhi ming;
之名__之名 461.61231651|zhi ming;
指明__指明 491.902185928|zhi ming;
致命__致命 1241.63157975|zhi ming;
知名__知名 2658.69134296|zhi ming;
之母__之母 132.431639237|zhi mu;
直发__直發 154.754097942|zhi fa;
执法__執法 2448.77288933|zhi fa;
脂肪__脂肪 2227.49666896|zhi fang;
之分__之分 664.215078095|zhi fen;
之风__之風 513.191745392|zhi feng;
直飞__直飛 194.151676652|zhi fei;
知府__知府 109.034528882|zhi fu;
之父__之父 330.548296374|zhi fu;
制服__制服 789.834279627|zhi fu;
致富__致富 914.951259653|zhi fu;
支付__支付 7754.63736054|zhi fu;
只打__只打 116.624293448|zhi da;
直达__直達 749.558344131|zhi da;
之大__之大 785.907015785|zhi da;
只带__只帶 105.690017726|zhi dai;
纸袋__紙袋 148.704343794|zhi dai;
只当__只當 149.820373083|zhi dang;
制导__制導 156.304608838|zhi dao;
执导__執導 448.010827873|zhi dao;
之道__之道 1252.50991514|zhi dao;
直到__直到 6127.3696816|zhi dao;
指导__指導 8377.53195835|zhi dao;
知道__知道 144465.939501|zhi dao;
质的__質的 341.433560596|zhi de;
只得__只得 948.621258606|zhi de;
值得__值得 9371.82960123|zhi de;
置地__置地 121.217779906|zhi di;
质地__質地 737.513205869|zhi di;
之地__之地 1126.6237397|zhi di;
之巅__之巔 151.699065864|zhi dian;
支点__支點 198.803491145|zhi dian;
致电__致電 890.207990943|zhi dian;
指点__指點 1968.96476223|zhi dian;
止跌__止跌 234.348853194|zhi die;
置顶__置頂 741.198640518|zhi ding;
制订__制訂 1425.82527204|zhi ding;
指定__指定 6337.04178046|zhi ding;
制定__制定 8772.84815908|zhi ding;
制动__制動 607.214449729|zhi dong;
之都__之都 223.231720645|zhi du;
只读__只讀 348.309611377|zhi du;
制度__制度 13756.7225213|zhi du;
至多__至多 176.168109435|zhi duo;
之多__之多 574.81640715|zhi duo;
只对__只對 480.392137969|zhi dui;
支队__支隊 762.750126416|zhi dui;
只谈__只談 110.677283245|zhi tan;
肢体__肢體 512.55262135|zhi ti;
枝条__枝條 185.172044961|zhi tiao;
纸条__紙條 602.691239054|zhi tiao;
只听__只聽 516.399339766|zhi ting;
枝头__枝頭 261.184568064|zhi tou;
指头__指頭 428.356335222|zhi tou;
之痛__之痛 221.568841736|zhi tong;
直通__直通 273.168633085|zhi tong;
止痛__止痛 285.702569086|zhi tong;
之徒__之徒 219.918349804|zhi tu;
制图__製圖 219.918349804|zhi tu;
织女__織女 152.457122789|zhi nv;
之女__之女 238.770616634|zhi nv;
侄女__侄女 391.596284031|zhi nv;
支那__支那 142.003528374|zhi na;
指南__指南 1621.10162248|zhi nan;
稚嫩__稚嫩 356.210827905|zhi nen;
职能__職能 2175.37534439|zhi neng;
智能__智能 4169.09975093|zhi neng;
只能__只能 30962.6610147|zhi neng;
之内__之內 2526.26316155|zhi nei;
执拗__執拗 138.680779525|zhi niu;
支农__支農 242.36802267|zhi nong;
之旅__之旅 1487.53508505|zhi lv;
之乐__之樂 156.89004718|zhi le;
制冷__製冷 383.865702254|zhi leng;
之类__之類 7725.70077647|zhi lei;
直立__直立 242.36802267|zhi li;
智利__智利 377.697115787|zhi li;
之力__之力 636.660374558|zhi li;
致力__致力 1815.76539105|zhi li;
智力__智力 2457.94475925|zhi li;
治理__治理 2770.30526836|zhi li;
直连__直連 109.30661816|zhi lian;
智联__智聯 117.792774542|zhi lian;
之恋__之戀 362.931919108|zhi lian;
治疗__治療 15582.4341451|zhi liao;
质量__質量 14991.9456847|zhi liang;
之列__之列 455.327784806|zhi lie;
指令__指令 2121.82781083|zhi ling;
只留__只留 144.502706249|zhi liu;
支流__支流 196.831399718|zhi liu;
之流__之流 344.424970321|zhi liu;
滞留__滯留 414.699880708|zhi liu;
直流__直流 530.091629029|zhi liu;
指路__指路 141.29744947|zhi lu;
之路__之路 2079.94037707|zhi lu;
之冠__之冠 113.895394799|zhi guan;
只管__只管 526.142915167|zhi guan;
直观__直觀 960.516622856|zhi guan;
之光__之光 255.391156791|zhi guang;
只怪__只怪 137.476305203|zhi guai;
之感__之感 432.648119245|zhi gan;
质感__質感 776.174076244|zhi gan;
志刚__志剛 162.460985719|zhi gang;
至高__至高 149.820373083|zhi gao;
之高__之高 244.491487214|zhi gao;
之隔__之隔 167.601987591|zhi ge;
之歌__之歌 395.027185582|zhi ge;
只给__只給 348.743933702|zhi gei;
职工__職工 4652.30490767|zhi gong;
只顾__只顧 412.12398856|zhi gu;
治国__治國 337.205131359|zhi guo;
之快__之快 181.290467084|zhi kuai;
只看__只看 845.867144221|zhi kan;
只靠__只靠 169.070402749|zhi kao;
只可__只可 126.621787068|zhi ke;
止咳__止咳 163.884358899|zhi ke;
之口__之口 139.547573842|zhi kou;
指控__指控 701.651845929|zhi kong;
之苦__之苦 365.655730945|zhi ku;
之花__之花 240.263000901|zhi hua;
指环__指環 149.820373083|zhi huan;
置换__置換 545.504855178|zhi huan;
之魂__之魂 140.594881376|zhi hun;
直航__直航 154.754097942|zhi hang;
支行__支行 1298.60199609|zhi hang;
治好__治好 524.833224606|zhi hao;
只好__只好 6059.03211339|zhi hao;
只喝__只喝 110.95347192|zhi he;
纸盒__紙盒 191.031727675|zhi he;
制衡__制衡 205.60633599|zhi heng;
滞后__滯后 899.127155009|zhi hou;
之后__之後 37747.6214502|zhi hou;
直呼__直呼 110.401782066|zhi hu;
支护__支護 119.26985293|zhi hu;
之火__之火 233.474375771|zhi huo;
知会__知會 157.870654598|zhi hui;
指挥__指揮 2937.40736593|zhi hui;
只会__只會 3806.57552354|zhi hui;
智慧__智慧 4669.73009873|zhi hui;
只觉__只覺 194.151676652|zhi jue;
知觉__知覺 397.991873082|zhi jue;
直觉__直覺 870.462027204|zhi jue;
志军__志軍 155.915530766|zhi jun;
之计__之計 152.457122789|zhi ji;
直击__直擊 183.335174792|zhi ji;
之机__之機 240.263000901|zhi ji;
之极__之極 372.555031371|zhi ji;
至极__至極 381.957020988|zhi ji;
制剂__製劑 457.603107852|zhi ji;
知己__知己 770.392265767|zhi ji;
之际__之際 1964.0635567|zhi ji;
制假__制假 116.47905068|zhi jia;
支架__支架 723.855290267|zhi jia;
指甲__指甲 992.147332631|zhi jia;
之家__之家 1073.17852213|zhi jia;
指间__指間 148.334184528|zhi jian;
之剑__之劍 179.71591787|zhi jian;
质监__質監 277.630050085|zhi jian;
指尖__指尖 407.527636023|zhi jian;
质检__質檢 413.152419826|zhi jian;
只见__只見 1908.56898964|zhi jian;
之间__之間 24556.9529357|zhi jian;
之交__之交 113.611883002|zhi jiao;
职教__職教 132.431639237|zhi jiao;
直角__直角 133.591915611|zhi jiao;
支教__支教 290.368691563|zhi jiao;
执教__執教 479.793862242|zhi jiao;
指教__指教 876.994863387|zhi jiao;
肢解__肢解 130.628674269|zhi jie;
直接__直接 44386.0001792|zhi jie;
纸巾__紙巾 375.351064872|zhi jin;
至今__至今 5728.60805208|zhi jin;
致敬__致敬 604.195219728|zhi jing;
直径__直徑 1033.79844744|zhi jing;
之久__之久 589.322768456|zhi jiu;
之举__之舉 473.261801395|zhi ju;
职权__職權 529.431458035|zhi quan;
之妻__之妻 120.46484039|zhi qi;
稚气__稚氣 159.055477247|zhi qi;
知其__知其 174.638049069|zhi qi;
志气__志氣 378.168082664|zhi qi;
之气__之氣 517.043260448|zhi qi;
致歉__致歉 158.659551632|zhi qian;
值钱__值錢 1371.79434453|zhi qian;
之前__之前 26463.4627738|zhi qian;
至强__至強 118.08671951|zhi qiang;
志强__志強 203.820597887|zhi qiang;
执勤__執勤 244.186999878|zhi qin;
知青__知青 372.555031371|zhi qing;
知情__知情 946.259922413|zhi qing;
之情__之情 1128.02857559|zhi qing;
只求__只求 329.725485744|zhi qiu;
支取__支取 175.292155245|zhi qu;
直选__直選 117.792774542|zhi xuan;
之选__之選 178.155043976|zhi xuan;
治学__治學 149.820373083|zhi xue;
止血__止血 307.117053725|zhi xue;
质询__質詢 171.617679695|zhi xun;
知悉__知悉 172.260473089|zhi xi;
窒息__窒息 687.800394331|zhi xi;
直辖__直轄 118.08671951|zhi xia;
之下__之下 3639.57886632|zhi xia;
知县__知縣 117.353228453|zhi xian;
只限__只限 126.621787068|zhi xian;
支线__支線 314.867617017|zhi xian;
之嫌__之嫌 356.655002599|zhi xian;
直线__直線 1229.31483934|zhi xian;
职校__職校 109.852835359|zhi xiao;
滞销__滯銷 120.015323434|zhi xiao;
知晓__知曉 566.284555508|zhi xiao;
直销__直銷 1063.85772095|zhi xiao;
之乡__之鄉 308.651751439|zhi xiang;
志向__志向 353.117055307|zhi xiang;
纸箱__紙箱 382.910172354|zhi xiang;
指向__指向 1693.37191801|zhi xiang;
只想__只想 1791.04500392|zhi xiang;
制鞋__製鞋 107.015331962|zhi xie;
只写__只寫 130.954650472|zhi xie;
致谢__致謝 242.670241844|zhi xie;
致信__致信 114.321989585|zhi xin;
置信__置信 123.658956482|zhi xin;
知心__知心 224.06783424|zhi xin;
之心__之心 1323.10440245|zhi xin;
直行__直行 107.818484324|zhi xing;
知性__知性 228.011295226|zhi xing;
之星__之星 636.660374558|zhi xing;
之行__之行 818.900002077|zhi xing;
执行__執行 12781.5636505|zhi xing;
只许__只許 123.197520618|zhi xu;
只须__只須 163.680258901|zhi xu;
只需__只需 2064.44666061|zhi xu;
秩序__秩序 2286.55857392|zhi xu;
只占__只佔 365.655730945|zhi zhan;
之战__之戰 751.428823061|zhi zhan;
执掌__執掌 172.260473089|zhi zhang;
智障__智障 191.747236314|zhi zhang;
纸张__紙張 781.025384985|zhi zhang;
支招__支招 228.580284053|zhi zhao;
执照__執照 541.441326411|zhi zhao;
智者__智者 374.41672986|zhi zhe;
指着__指着 1300.22127911|zhi zhe;
指针__指針 1075.85657625|zhi zhen;
指正__指正 349.614203755|zhi zheng;
之争__之爭 788.850627646|zhi zheng;
执政__執政 1062.53280282|zhi zheng;
脂质__脂質 116.624293448|zhi zhi;
指指__指指 126.621787068|zhi zhi;
之至__之至 132.927661458|zhi zhi;
知之__知之 134.259489114|zhi zhi;
只知__只知 150.007190589|zhi zhi;
吱吱__吱吱 168.229740225|zhi zhi;
直直__直直 222.953710017|zhi zhi;
直指__直指 333.860122955|zhi zhi;
纸质__紙質 362.028498203|zhi zhi;
制止__制止 956.932435908|zhi zhi;
直至__直至 1491.2471417|zhi zhi;
之重__之重 119.56748386|zhi zhong;
之中__之中 6710.91779356|zhi zhong;
止住__止住 212.907119447|zhi zhu;
植株__植株 310.580912674|zhi zhu;
支柱__支柱 553.034030141|zhi zhu;
蜘蛛__蜘蛛 1431.1656954|zhi zhu;
执着__執着 2111.27752471|zhi zhuo;
只穿__只穿 148.889769675|zhi chuan;
痔疮__痔瘡 303.313611771|zhi chuang;
之窗__之窗 336.785179346|zhi chuang;
之差__之差 247.249015706|zhi cha;
只差__只差 259.238974004|zhi cha;
之长__之長 186.32942291|zhi chang;
直肠__直腸 212.377144726|zhi chang;
职场__職場 1028.65812957|zhi chang;
制程__製程 167.184787749|zhi cheng;
之城__之城 303.691826638|zhi cheng;
之称__之稱 449.688850794|zhi cheng;
职称__職稱 780.052703516|zhi cheng;
制成__製成 1156.49608257|zhi cheng;
支撑__支撐 4481.58949458|zhi cheng;
咫尺__咫尺 128.529517539|zhi chi;
智齿__智齒 139.373782642|zhi chi;
只吃__只吃 311.744192349|zhi chi;
支持__支持 43078.1588251|zhi chi;
直冲__直衝 208.44415872|zhi chong;
之初__之初 822.992135502|zhi chu;
支出__支出 2596.48046905|zhi chu;
之处__之處 3453.98620792|zhi chu;
指出__指出 7516.77260869|zhi chu;
直爽__直爽 122.584950132|zhi shuang;
直率__直率 194.151676652|zhi shuai;
至上__至上 497.450167612|zhi shang;
纸上__紙上 595.969520633|zhi shang;
智商__智商 1521.27901981|zhi shang;
之上__之上 2186.24593438|zhi shang;
至少__至少 15916.0668651|zhi shao;
直射__直射 163.884358899|zhi she;
之身__之身 187.4940348|zhi shen;
只身__隻身 231.446597362|zhi shen;
之神__之神 370.702589737|zhi shen;
置身__置身 475.034401746|zhi shen;
吱声__吱聲 120.916041011|zhi sheng;
制胜__制勝 205.862715427|zhi sheng;
之声__之聲 542.792461517|zhi sheng;
只剩__只剩 763.701232553|zhi sheng;
之师__之師 112.065135969|zhi shi;
芝士__芝士 116.624293448|zhi shi;
直视__直視 189.136730609|zhi shi;
之士__之士 216.384339476|zhi shi;
制式__制式 238.176261728|zhi shi;
指使__指使 254.438159592|zhi shi;
之势__之勢 713.111292931|zhi shi;
之事__之事 1028.65812957|zhi shi;
致使__致使 1300.22127911|zhi shi;
之时__之時 2006.11577143|zhi shi;
指示__指示 2358.91565003|zhi shi;
知识__知識 13022.7299719|zhi shi;
只是__只是 58095.9566544|zhi shi;
只手__只手 130.628674269|zhi shou;
只收__只收 169.915266157|zhi shou;
之首__之首 474.442798491|zhi shou;
之手__之手 715.782248677|zhi shou;
支书__支書 116.044406778|zhi shu;
之术__之術 180.389043185|zhi shu;
植树__植樹 187.26053154|zhi shu;
直属__直屬 550.284199441|zhi shu;
指数__指數 4932.92737822|zhi shu;
直说__直說 345.715012791|zhi shuo;
只说__只說 597.456727653|zhi shuo;
治水__治水 120.615053212|zhi shui;
炙热__炙熱 119.121315407|zhi re;
之人__之人 1515.60233678|zhi ren;
之日__之日 604.195219728|zhi ri;
置入__置入 191.98633424|zhi ru;
植入__植入 376.756940916|zhi ru;
至尊__至尊 385.303469841|zhi zun;
志在__志在 109.989815613|zhi zai;
旨在__旨在 1202.04704744|zhi zai;
只在__只在 1226.25479235|zhi zai;
织造__織造 110.126966673|zhi zao;
制造__製造 6744.45298826|zhi zao;
指责__指責 1873.22443719|zhi ze;
职责__職責 2535.725271|zhi ze;
质子__質子 113.611883002|zhi zi;
侄子__侄子 378.63963681|zhi zi;
之子__之子 627.992684885|zhi zi;
知足__知足 656.807194196|zhi zu;
只做__只做 553.723632203|zhi zuo;
之作__之作 834.351249399|zhi zuo;
制作__製作 10869.9505311|zhi zuo;
之最__之最 303.313611771|zhi zui;
制裁__制裁 610.248767154|zhi cai;
致残__致殘 105.164499152|zhi can;
之策__之策 169.492308033|zhi ce;
之词__之詞 153.028150386|zhi ci;
致词__致詞 170.76435144|zhi ci;
致辞__致辭 456.464028614|zhi ci;
至此__至此 555.797602048|zhi ci;
知错__知錯 123.197520618|zhi cuo;
止损__止損 545.504855178|zhi sun;
之色__之色 200.795341333|zhi se;
至死__至死 148.149450567|zhi si;
之死__之死 337.205131359|zhi si;
致死__致死 513.831666385|zhi si;
质素__質素 110.264288753|zhi su;
之所__之所 477.408200926|zhi suo;
志远__志遠 114.321989585|zhi yuan;
只愿__只願 126.621787068|zhi yuan;
致远__致遠 135.604660605|zhi yuan;
之源__之源 277.284292303|zhi yuan;
职员__職員 843.76158662|zhi yuan;
志愿__志願 1191.60699362|zhi yuan;
支援__支援 1540.35530331|zhi yuan;
之约__之約 111.230349808|zhi yue;
制约__制約 1961.61753092|zhi yue;
质押__質押 334.276427588|zhi ya;
只眼__隻眼 120.765453341|zhi yan;
之言__之言 263.472890441|zhi yan;
直言__直言 413.152419826|zhi yan;
止痒__止癢 110.95347192|zhi yang;
之遥__之遙 210.008536601|zhi yao;
制药__製藥 562.76710106|zhi yao;
只要__只要 32102.0799214|zhi yao;
汁液__汁液 120.916041011|zhi ye;
枝叶__枝葉 224.907079496|zhi ye;
纸业__紙業 270.122027271|zhi ye;
之夜__之夜 542.11647303|zhi ye;
执业__執業 543.469292924|zhi ye;
置业__置業 792.79260104|zhi ye;
职业__職業 9198.27385102|zhi ye;
直译__直譯 111.786180106|zhi yi;
之义__之義 136.622376491|zhi yi;
致意__致意 147.964946673|zhi yi;
旨意__旨意 163.476413088|zhi yi;
置疑__置疑 178.155043976|zhi yi;
之以__之以 222.67604562|zhi yi;
致以__致以 226.595011951|zhi yi;
执意__執意 341.859308876|zhi yi;
之意__之意 715.782248677|zhi yi;
质疑__質疑 2770.30526836|zhi yi;
之一__之一 13911.8794748|zhi yi;
之音__之音 165.32020271|zhi yin;
只因__只因 435.895152658|zhi yin;
知音__知音 442.462509543|zhi yin;
指引__指引 933.377249507|zhi yin;
之忧__之憂 135.435779871|zhi you;
挚友__摯友 140.945727665|zhi you;
之友__之友 142.180598718|zhi you;
只有__只有 50276.6501023|zhi you;
之用__之用 469.736419493|zhi yong;
只用__只用 1026.09756322|zhi yong;
之语__之語 148.334184528|zhi yu;
止于__止於 166.97657743|zhi yu;
治愈__治癒 793.781168439|zhi yu;
置于__置於 818.900002077|zhi yu;
之余__之餘 1175.38409041|zhi yu;
至于__至於 8010.00481377|zhi yu;
之外__之外 6736.05351167|zhi wai;
之王__之王 686.088301175|zhi wang;
指望__指望 1729.62840231|zhi wang;
之吻__之吻 127.572086295|zhi wen;
质问__質問 526.798985534|zhi wen;
指纹__指紋 666.702893247|zhi wen;
之位__之位 116.044406778|zhi wei;
志伟__志偉 118.529012887|zhi wei;
值为__值為 219.37092252|zhi wei;
只为__只為 1048.06715525|zhi wei;
职位__職位 3912.37902339|zhi wei;
之舞__之舞 116.624293448|zhi wu;
治污__治污 117.207077876|zhi wu;
织物__織物 348.309611377|zhi wu;
之物__之物 433.727767276|zhi wu;
职务__職務 2529.4132684|zhi wu;
植物__植物 3225.18344283|zhi wu;
挚爱__摯愛 191.508436159|zhi ai;
至爱__至愛 192.945711079|zhi ai;
之爱__之愛 200.545272755|zhi ai;
致癌__致癌 236.402059204|zhi ai;
只爱__只愛 302.181790975|zhi ai;
治安__治安 1271.38069074|zhi an;
之恩__之恩 108.763116896|zhi en;
侄儿__侄兒 137.647730357|zhi er;
之二__之二 458.745029596|zhi er;
周报__周報 927.579613097|zhou bao;
周边__周邊 2919.16177455|zhou bian;
咒骂__咒罵 181.064689688|zhou ma;
皱眉__皺眉 252.228305921|zhou mei;
周密__周密 376.287731462|zhou mi;
周末__周末 11241.9087221|zhou mo;
周某__周某 141.473639374|zhou mou;
周到__周到 546.185068786|zhou dao;
周董__周董 322.010219858|zhou dong;
周涛__周濤 117.499561272|zhou tao;
周天__周天 108.763116896|zhou tian;
周内__周內 128.850255419|zhou nei;
周年__周年 1182.73057528|zhou nian;
皱了__皺了 172.475272126|zhou le;
周六__周六 3567.72920071|zhou liu;
周公__周公 225.187525865|zhou gong;
周刊__周刊 813.813436628|zhou kan;
周口__周口 106.218162376|zhou kou;
周后__周后 120.015323434|zhou hou;
洲际__洲際 107.14877401|zhou ji;
周济__周濟 107.818484324|zhou ji;
周家__周家 118.676811842|zhou jia;
周杰__周傑 110.126966673|zhou jie;
轴距__軸距 131.281440129|zhou ju;
周全__周全 257.94996962|zhou quan;
周期__周期 3402.71958168|zhou qi;
周旋__周旋 297.325836157|zhou xuan;
周迅__周迅 567.697685436|zhou xun;
周线__周線 129.494134325|zhou xian;
轴线__軸線 163.069482749|zhou xian;
轴向__軸向 114.75018218|zhou xiang;
轴心__軸心 111.369047744|zhou xin;
周转__周轉 381.481335404|zhou zhuan;
周庄__周庄 199.796934068|zhou zhuang;
州长__州長 232.313479749|zhou zhang;
周折__周折 140.594881376|zhou zhe;
皱着__皺着 198.555903198|zhou zhe;
周正__周正 199.299593609|zhou zheng;
周周__周周 170.127140854|zhou zhou;
周长__周長 120.314814642|zhou chang;
轴承__軸承 786.88699725|zhou cheng;
舟山__舟山 350.050152834|zhou shan;
周身__周身 202.554574186|zhou shen;
骤然__驟然 318.022335873|zhou ran;
周日__周日 2808.54161561|zhou ri;
周遭__周遭 242.670241844|zhou zao;
周三__周三 1476.45426414|zhou san;
宙斯__宙斯 184.71110921|zhou si;
周四__周四 1718.88488289|zhou si;
周岁__周歲 546.866130582|zhou sui;
昼夜__晝夜 384.823616623|zhou ye;
周易__周易 221.017305999|zhou yi;
周一__周一 3689.81311413|zhou yi;
周游__周遊 117.499561272|zhou you;
咒语__咒語 282.868455943|zhou yu;
周瑜__周瑜 303.313611771|zhou yu;
周文__周文 118.08671951|zhou wen;
皱纹__皺紋 733.846096172|zhou wen;
周围__周圍 6545.72648682|zhou wei;
周五__周五 3956.50529033|zhou wu;
周二__周二 1395.93711137|zhou er;
中巴__中巴 214.504991945|zhong ba;
重磅__重磅 175.729586548|zhong bang;
中报__中報 365.20034683|zhong bao;
钟表__鐘錶 282.164331387|zhong biao;
中标__中標 908.135681884|zhong biao;
重病__重病 271.471856767|zhong bing;
中部__中部 987.214115061|zhong bu;
中频__中頻 136.622376491|zhong pin;
中美__中美 1252.50991514|zhong mei;
种苗__種苗 176.168109435|zhong miao;
中法__中法 184.941433485|zhong fa;
中饭__中飯 432.109303457|zhong fan;
中方__中方 1155.05579352|zhong fang;
中风__中風 274.876014738|zhong feng;
中锋__中鋒 501.183541788|zhong feng;
中非__中非 168.020228531|zhong fei;
中段__中段 253.173026121|zhong duan;
中端__中端 289.645897197|zhong duan;
中断__中斷 1811.24553395|zhong duan;
终端__終端 3394.2494311|zhong duan;
肿大__腫大 140.594881376|zhong da;
中大__中大 404.996293994|zhong da;
重大__重大 7133.47062176|zhong da;
中带__中帶 110.95347192|zhong dai;
重担__重擔 226.030964922|zhong dan;
中档__中檔 225.468321935|zhong dang;
中德__中德 154.368879448|zhong de;
中的__中的 28517.9868942|zhong de;
中等__中等 900.248315564|zhong deng;
中的__中的 164.088713397|zhong di;
种地__種地 287.130256264|zhong di;
中电__中電 142.180598718|zhong dian;
终点__終點 912.673735821|zhong dian;
重点__重點 13586.354595|zhong dian;
中东__中東 876.994863387|zhong dong;
中都__中都 148.149450567|zhong du;
中度__中度 165.73274959|zhong du;
重度__重度 316.441045148|zhong du;
中毒__中毒 2513.70191646|zhong du;
众多__眾多 6627.80750717|zhong duo;
中对__中對 136.792736844|zhong dui;
中队__中隊 533.404852483|zhong dui;
种田__種田 299.1842072|zhong tian;
中天__中天 362.931919108|zhong tian;
中铁__中鐵 528.772109212|zhong tie;
中投__中投 276.938965124|zhong tou;
钟头__鐘頭 426.757915008|zhong tou;
中途__中途 1028.65812957|zhong tu;
中南__中南 431.571158705|zhong nan;
中能__中能 111.925571131|zhong neng;
终年__終年 119.716577729|zhong nian;
中年__中年 717.56844134|zhong nian;
中铝__中鋁 345.715012791|zhong lv;
中来__中來 315.260239073|zhong lai;
中了__中了 291.819695868|zhong le;
种类__種類 2476.39168739|zhong lei;
重力__重力 344.424970321|zhong li;
中立__中立 571.245957438|zhong li;
中联__中聯 154.947067523|zhong lian;
种粮__種糧 193.668388536|zhong liang;
中粮__中糧 218.824857909|zhong liang;
重量__重量 2266.69928918|zhong liang;
肿瘤__腫瘤 1509.94683642|zhong liu;
钟楼__鐘樓 191.508436159|zhong lou;
中路__中路 955.740681497|zhong lu;
忠告__忠告 384.823616623|zhong gao;
重工__重工 243.57916235|zhong gong;
中共__中共 3310.69893679|zhong gong;
中古__中古 144.322743975|zhong gu;
中国__中國 106588.875124|zhong guo;
终归__終歸 287.130256264|zhong gui;
肿块__腫塊 230.008975843|zhong kuai;
重卡__重卡 119.86585751|zhong ka;
中考__中考 702.526765976|zhong kao;
中科__中科 205.862715427|zhong ke;
中肯__中肯 251.287110964|zhong ken;
中空__中空 122.890853693|zhong kong;
中化__中化 160.649084484|zhong hua;
种花__種花 166.768626413|zhong hua;
中华__中華 5282.88186737|zhong hua;
中环__中環 296.585723861|zhong huan;
中海__中海 475.626742696|zhong hai;
中含__中含 301.429591092|zhong han;
中韩__中韓 344.85444872|zhong han;
中航__中航 168.020228531|zhong hang;
中行__中行 895.772044085|zhong hang;
中号__中號 147.045868173|zhong hao;
忠厚__忠厚 112.204874836|zhong hou;
终会__終會 117.792774542|zhong hui;
中继__中繼 258.916120291|zhong ji;
中级__中級 934.541117987|zhong ji;
终极__終極 1028.65812957|zhong ji;
中加__中加 129.817279349|zhong jia;
中甲__中甲 154.176629937|zhong jia;
中建__中建 140.770195218|zhong jian;
中坚__中堅 208.44415872|zhong jian;
中间__中間 8805.70682985|zhong jian;
重奖__重獎 114.607273411|zhong jiang;
终将__終將 258.271618599|zhong jiang;
中将__中將 401.478808454|zhong jiang;
中奖__中獎 1059.88791463|zhong jiang;
终结__終結 924.118331259|zhong jie;
中介__中介 2167.25788788|zhong jie;
中金__中金 269.449631503|zhong jin;
重金__重金 300.304800557|zhong jin;
终究__終究 1247.83614939|zhong jiu;
重拳__重拳 128.529517539|zhong quan;
中却__中卻 114.179614083|zhong que;
种群__種群 259.885889675|zhong qun;
中期__中期 1617.0663282|zhong qi;
中签__中籤 213.704562287|zhong qian;
钟情__鍾情 336.365750338|zhong qing;
中秋__中秋 2116.54609407|zhong qiu;
中去__中去 772.314734527|zhong qu;
中选__中選 114.46454262|zhong xuan;
中学__中學 4704.77652327|zhong xue;
中旬__中旬 624.870140032|zhong xun;
中戏__中戲 106.350610398|zhong xi;
中西__中西 359.779772295|zhong xi;
种下__種下 182.423584067|zhong xia;
中仙__中仙 116.18910757|zhong xian;
中线__中線 678.436468738|zhong xian;
中小__中小 1042.85588961|zhong xiao;
忠心__忠心 247.249015706|zhong xin;
衷心__衷心 669.200026501|zhong xin;
重心__重心 1027.37704867|zhong xin;
中信__中信 1339.6956486|zhong xin;
中心__中心 18879.0700132|zhong xin;
中型__中型 369.779825848|zhong xing;
重型__重型 407.020105042|zhong xing;
中性__中性 670.869975958|zhong xing;
中兴__中興 1032.51096484|zhong xing;
中转__中轉 388.679238014|zhong zhuan;
中专__中專 682.676889633|zhong zhuan;
中占__中占 162.056583012|zhong zhan;
肿胀__腫脹 282.516174301|zhong zhang;
中招__中招 275.218769535|zhong zhao;
忠贞__忠貞 158.067510349|zhong zhen;
重镇__重鎮 175.510734618|zhong zhen;
重症__重症 236.107646363|zhong zheng;
中职__中職 127.254530072|zhong zhi;
中指__中指 361.577631409|zhong zhi;
中止__中止 644.643863216|zhong zhi;
终止__終止 1397.67776576|zhong zhi;
种植__種植 2067.02090848|zhong zhi;
重重__重重 368.85935893|zhong zhong;
种种__種種 3394.2494311|zhong zhong;
重创__重創 287.488291405|zhong chuang;
中产__中產 158.857391092|zhong chan;
终场__終場 117.207077876|zhong chang;
中场__中場 1229.31483934|zhong chang;
中超__中超 668.366611253|zhong chao;
中称__中稱 173.121277629|zhong cheng;
终成__終成 206.89143407|zhong cheng;
忠诚__忠誠 1055.93292173|zhong cheng;
中山__中山 1706.08071057|zhong shan;
中伤__中傷 115.467403456|zhong shang;
重伤__重傷 612.534451685|zhong shang;
众神__眾神 143.247667161|zhong shen;
终审__終審 170.977284899|zhong shen;
终身__終身 1339.6956486|zhong shen;
钟声__鐘聲 315.260239073|zhong sheng;
终生__終生 745.831342837|zhong sheng;
众生__眾生 831.23785106|zhong sheng;
中式__中式 317.626273928|zhong shi;
忠实__忠實 967.72532071|zhong shi;
重视__重視 6854.60405824|zhong shi;
种树__種樹 135.098649108|zhong shu;
中枢__中樞 306.352568839|zhong shu;
中暑__中暑 358.884197808|zhong shu;
中说__中說 179.71591787|zhong shuo;
中软__中軟 122.584950132|zhong ruan;
中人__中人 139.895806636|zhong ren;
重任__重任 570.534533242|zhong ren;
众人__眾人 2570.72389483|zhong ren;
终日__終日 343.567617462|zhong ri;
中日__中日 884.6784987|zhong ri;
重在__重在 319.611528482|zhong zai;
中资__中資 188.901181552|zhong zi;
种子__種子 3037.92233395|zhong zi;
种族__種族 1023.54337071|zhong zu;
中最__中最 1364.97342214|zhong zui;
种菜__種菜 116.18910757|zhong cai;
仲裁__仲裁 714.000502259|zhong cai;
中餐__中餐 360.677581637|zhong can;
重仓__重倉 544.825488702|zhong cang;
中层__中層 428.356335222|zhong ceng;
中苏__中蘇 116.044406778|zhong su;
中远__中遠 196.341441156|zhong yuan;
中院__中院 284.281980745|zhong yuan;
中原__中原 1249.39213028|zhong yuan;
中越__中越 139.72158175|zhong yue;
重压__重壓 136.112567367|zhong ya;
中亚__中亞 390.621510938|zhong ya;
中央__中央 7861.66852792|zhong yang;
中药__中藥 2373.65954378|zhong yao;
重要__重要 27643.2298217|zhong yao;
中叶__中葉 129.655606164|zhong ye;
中也__中也 429.425273358|zhong ye;
忠义__忠義 146.497163581|zhong yi;
钟意__鐘意 153.984619852|zhong yi;
中意__中意 1247.83614939|zhong yi;
中医__中醫 2959.45267121|zhong yi;
中银__中銀 163.476413088|zhong yin;
中印__中印 249.415244207|zhong yin;
中应__中應 109.170488754|zhong ying;
中英__中英 295.479008313|zhong ying;
中油__中油 117.93965545|zhong you;
终有__終有 140.419785869|zhong you;
中邮__中郵 182.423584067|zhong you;
仲有__仲有 219.097720093|zhong you;
中游__中游 257.62872122|zhong you;
中有__中有 2840.21811123|zhong you;
重用__重用 125.053659829|zhong yong;
中庸__中庸 264.459727191|zhong yong;
重于__重於 156.499511818|zhong yu;
忠于__忠於 299.1842072|zhong yu;
终于__終於 20574.2313823|zhong yu;
中外__中外 997.105202031|zhong wai;
中文__中文 9371.82960123|zhong wen;
中尉__中尉 180.613978088|zhong wei;
中卫__中衛 205.350275845|zhong wei;
重物__重物 125.209594649|zhong wu;
中午__中午 11831.2161031|zhong wu;
钟爱__鍾愛 326.861744407|zhong ai;
中俄__中俄 515.756221017|zhong e;
中欧__中歐 401.979429753|zhong ou;
主办__主辦 1666.16002844|zhu ban;
主板__主板 5007.24867861|zhu ban;
珠宝__珠寶 909.268075561|zhu bao;
主编__主編 1265.05905145|zhu bian;
主播__主播 276.594068012|zhu bo;
逐步__逐步 5954.24100327|zhu bu;
主频__主頻 292.912705474|zhu pin;
注明__註明 3825.59740032|zhu ming;
著名__著名 6812.02695227|zhu ming;
注目__注目 416.772181646|zhu mu;
瞩目__矚目 670.034480971|zhu mu;
主犯__主犯 131.117943492|zhu fan;
煮饭__煮飯 396.012952778|zhu fan;
住房__住房 3657.76624243|zhu fang;
主峰__主峰 116.18910757|zhu feng;
珠峰__珠峰 318.418891685|zhu feng;
煮沸__煮沸 202.302314677|zhu fei;
诸佛__諸佛 137.991222203|zhu fo;
主妇__主婦 342.285588041|zhu fu;
嘱咐__囑咐 453.063775264|zhu fu;
祝福__祝福 5204.46941467|zhu fu;
主打__主打 721.154209805|zhu da;
住到__住到 169.915266157|zhu dao;
主导__主導 1751.317311|zhu dao;
住得__住得 119.86585751|zhu de;
朱德__朱德 234.348853194|zhu de;
住的__住的 1026.09756322|zhu de;
朱棣__朱棣 114.179614083|zhu di;
驻地__駐地 356.210827905|zhu di;
注定__註定 2258.24105554|zhu ding;
主动__主動 8387.97826544|zhu dong;
诸多__諸多 2580.3525318|zhu duo;
主队__主隊 322.813777494|zhu dui;
竹炭__竹炭 123.658956482|zhu tan;
猪蹄__豬蹄 236.402059204|zhu ti;
主体__主體 4253.06027768|zhu ti;
主题__主題 9278.86289976|zhu ti;
主贴__主貼 130.791560815|zhu tie;
铸铁__鑄鐵 156.89004718|zhu tie;
猪头__豬頭 2625.76520592|zhu tou;
主推__主推 209.224885556|zhu tui;
助推__助推 232.893204426|zhu tui;
祝你__祝你 1706.08071057|zhu ni;
猪年__豬年 250.661599628|zhu nian;
逐年__逐年 770.392265767|zhu nian;
助您__助您 180.389043185|zhu nin;
祝您__祝您 270.796100963|zhu nin;
伫立__佇立 174.638049069|zhu li;
助力__助力 353.557372243|zhu li;
助理__助理 2476.39168739|zhu li;
主力__主力 4317.13844997|zhu li;
竹林__竹林 364.745529846|zhu lin;
朱令__朱令 115.611384758|zhu ling;
驻留__駐留 114.037415895|zhu liu;
主流__主流 3996.1462733|zhu liu;
主楼__主樓 197.322580943|zhu lou;
主观__主觀 1467.28332601|zhu guan;
主管__主管 3764.12139917|zhu guan;
烛光__燭光 301.429591092|zhu guang;
猪肝__豬肝 168.859844103|zhu gan;
竹竿__竹竿 174.855812809|zhu gan;
主干__主幹 279.017397997|zhu gan;
逐个__逐個 321.208662461|zhu ge;
诸葛__諸葛 543.469292924|zhu ge;
主攻__主攻 322.813777494|zhu gong;
助攻__助攻 571.958268741|zhu gong;
住过__住過 282.516174301|zhu guo;
主控__主控 219.097720093|zhu kong;
驻华__駐華 156.499511818|zhu hua;
珠海__珠海 1964.0635567|zhu hai;
煮好__煮好 136.452228303|zhu hao;
祝贺__祝賀 1581.19770715|zhu he;
诸侯__諸侯 393.063006485|zhu hou;
住户__住戶 593.006203378|zhu hu;
猪圈__豬圈 172.690339006|zhu juan;
主角__主角 2297.98475873|zhu jue;
朱骏__朱駿 150.007190589|zhu jun;
驻军__駐軍 193.90988203|zhu jun;
朱军__朱軍 216.384339476|zhu jun;
助剂__助劑 132.266710153|zhu ji;
诸暨__諸暨 186.794397067|zhu ji;
逐级__逐級 189.845141544|zhu ji;
主机__主機 4588.96700128|zhu ji;
朱家__朱家 113.611883002|zhu jia;
住家__住家 120.46484039|zhu jia;
铸件__鑄件 109.30661816|zhu jian;
主键__主鍵 304.070513117|zhu jian;
主见__主見 323.216307961|zhu jian;
逐渐__逐漸 7516.77260869|zhu jian;
猪脚__豬腳 140.419785869|zhu jiao;
主叫__主叫 172.905674062|zhu jiao;
主教__主教 211.584655172|zhu jiao;
主角__主角 309.4219738|zhu jiao;
助教__助教 316.046952528|zhu jiao;
主将__主將 115.323601467|zhu jiang;
主讲__主講 253.488718522|zhu jiang;
珠江__珠江 690.376548199|zhu jiang;
注解__註解 250.661599628|zhu jie;
住进__住進 435.895152658|zhu jin;
铸就__鑄就 167.810977762|zhu jiu;
主权__主權 709.565515965|zhu quan;
朱雀__朱雀 218.008308584|zhu que;
助学__助學 400.978810625|zhu xue;
朱熹__朱熹 154.561368684|zhu xi;
主席__主席 5409.45809302|zhu xi;
住下__住下 151.321452046|zhu xia;
主线__主線 781.999279332|zhu xian;
诛仙__誅仙 843.76158662|zhu xian;
住校__住校 160.249192015|zhu xiao;
注销__註銷 1168.08323794|zhu xiao;
逐项__逐項 106.350610398|zhu xiang;
助兴__助興 129.655606164|zhu xing;
主修__主修 118.824795093|zhu xiu;
驻扎__駐紮 255.391156791|zhu zha;
住宅__住宅 2952.08591378|zhu zhai;
主站__主站 234.348853194|zhu zhan;
助长__助長 255.073095111|zhu zhang;
主张__主張 2430.53169682|zhu zhang;
住着__住着 342.712398751|zhu zhe;
助阵__助陣 256.987424161|zhu zhen;
主治__主治 159.651218957|zhu zhi;
住址__住址 268.778909483|zhu zhi;
主旨__主旨 342.712398751|zhu zhi;
煮粥__煮粥 144.502706249|zhu zhou;
主轴__主軸 196.831399718|zhu zhou;
株洲__株洲 346.577724349|zhu zhou;
注重__注重 4279.6431141|zhu zhong;
猪猪__豬豬 2129.77510916|zhu zhu;
主创__主創 221.845125512|zhu chuang;
主唱__主唱 376.287731462|zhu chang;
主场__主場 1820.2965272|zhu chang;
铸成__鑄成 107.550099352|zhu cheng;
著称__著稱 166.353500999|zhu cheng;
主城__主城 328.495108513|zhu cheng;
主持__主持 3839.92616142|zhu chi;
蛀虫__蛀蟲 110.815291538|zhu chong;
住处__住處 571.245957438|zhu chu;
主帅__主帥 759.903909096|zhu shuai;
住上__住上 126.149295342|zhu shang;
注射__注射 1150.74567978|zhu she;
诸神__諸神 116.915322539|zhu shen;
主食__主食 298.811606079|zhu shi;
注视__注視 872.634214191|zhu shi;
注释__註釋 1156.49608257|zhu shi;
驻守__駐守 155.915530766|zhu shou;
助手__助手 1155.05579352|zhu shou;
著述__著述 126.779677253|zhu shu;
煮熟__煮熟 380.057830188|zhu shu;
注水__注水 141.121478992|zhu shui;
助人__助人 131.609045271|zhu ren;
主人__主人 3745.40519724|zhu ren;
主任__主任 7620.52071577|zhu ren;
猪肉__豬肉 1760.06883632|zhu rou;
侏儒__侏儒 332.200082586|zhu ru;
诸如__諸如 1298.60199609|zhu ru;
注入__注入 2210.90378861|zhu ru;
主宰__主宰 501.183541788|zhu zai;
住在__住在 3445.38844293|zhu zai;
铸造__鑄造 475.626742696|zhu zao;
珠子__珠子 312.522131716|zhu zi;
注资__注資 382.433299725|zhu zi;
主子__主子 467.400766428|zhu zi;
柱子__柱子 571.958268741|zhu zi;
竹子__竹子 594.486015613|zhu zi;
驻足__駐足 313.69268222|zhu zu;
著作__著作 1190.12297778|zhu zuo;
贮存__貯存 264.789493468|zhu cun;
贮藏__貯藏 264.459727191|zhu cang;
注册__註冊 15236.7956171|zhu ce;
主次__主次 143.963491517|zhu ci;
竹笋__竹筍 122.432284019|zhu sun;
注塑__注塑 142.535402072|zhu su;
住宿__住宿 1605.02061407|zhu su;
住所__住所 482.191444969|zhu suo;
祝愿__祝願 992.147332631|zhu yuan;
住院__住院 1689.15672637|zhu yuan;
逐月__逐月 120.015323434|zhu yue;
蛀牙__蛀牙 188.430963124|zhu ya;
主演__主演 1609.02584897|zhu yan;
主要__主要 46887.702472|zhu yao;
竹叶__竹葉 111.091824605|zhu ye;
主业__主業 513.191745392|zhu ye;
主页__主頁 2442.67733117|zhu ye;
逐一__逐一 553.723632203|zhu yi;
主意__主意 1870.89154158|zhu yi;
主义__主義 2323.90287358|zhu yi;
注意__注意 26662.0716295|zhu yi;
朱茵__朱茵 133.093414711|zhu yin;
主因__主因 170.127140854|zhu yin;
主营__主營 511.276760152|zhu ying;
猪油__豬油 164.908682755|zhu you;
主语__主語 196.586267794|zhu yu;
驻外__駐外 148.704343794|zhu wai;
主委__主委 120.765453341|zhu wei;
助威__助威 230.295783987|zhu wei;
诸位__諸位 613.298247397|zhu wei;
主卧__主卧 137.819369268|zhu wo;
主儿__主兒 126.779677253|zhu er;
桌布__桌布 108.898738333|zhuo bu;
桌面__桌面 3736.08202346|zhuo mian;
琢磨__琢磨 744.902491688|zhuo mo;
捉弄__捉弄 230.008975843|zhuo nong;
着力__着力 1341.36617307|zhuo li;
拙劣__拙劣 165.526347625|zhuo lie;
着陆__着陸 135.098649108|zhuo lu;
桌前__桌前 149.820373083|zhuo qian;
酌情__酌情 244.796354228|zhuo qing;
桌球__桌球 241.463621556|zhuo qiu;
着想__着想 323.216307961|zhuo xiang;
着装__着裝 427.82286438|zhuo zhuang;
着重__着重 902.494832488|zhuo zhong;
卓著__卓著 125.835280772|zhuo zhu;
捉住__捉住 164.293322714|zhuo zhu;
灼伤__灼傷 115.036534536|zhuo shang;
桌上__桌上 1187.16048834|zhuo shang;
着实__着實 731.107734818|zhuo shi;
着手__着手 1324.75423858|zhuo shou;
灼热__灼熱 294.376422496|zhuo re;
桌子__桌子 2615.96711065|zhuo zi;
着色__着色 162.460985719|zhuo se;
卓越__卓越 1573.33557614|zhuo yue;
着眼__着眼 702.526765976|zhuo yan;
桌椅__桌椅 220.19257551|zhuo yi;
追捕__追捕 258.271618599|zhui bu;
追捧__追捧 796.754272909|zhui peng;
追风__追風 134.594525802|zhui feng;
追到__追到 281.461959558|zhui dao;
追讨__追討 129.979154132|zhui tao;
追了__追了 206.89143407|zhui le;
坠楼__墜樓 113.47039186|zhui lou;
坠落__墜落 438.073368704|zhui luo;
追赶__追趕 511.276760152|zhui gan;
坠毁__墜毀 187.727829225|zhui hui;
追回__追回 250.349428094|zhui hui;
追击__追擊 232.603161479|zhui ji;
追加__追加 865.055186245|zhui jia;
追缴__追繳 108.763116896|zhui jiao;
追究__追究 1230.8477252|zhui jiu;
追求__追求 8772.84815908|zhui qiu;
追寻__追尋 582.024395035|zhui xun;
追星__追星 273.850309404|zhui xing;
追涨__追漲 214.2378495|zhui zhang;
追着__追着 381.957020988|zhui zhe;
追逐__追逐 1077.19810837|zhui zhu;
追查__追查 314.083839199|zhui cha;
追杀__追殺 470.908619205|zhui sha;
追上__追上 370.240920313|zhui shang;
赘述__贅述 130.954650472|zhui shu;
赘肉__贅肉 143.784200776|zhui rou;
坠入__墜入 199.548108896|zhui ru;
追踪__追蹤 1057.24961018|zhui zong;
追溯__追溯 445.783200166|zhui su;
追随__追隨 512.55262135|zhui sui;
追忆__追憶 343.996026791|zhui yi;
追问__追問 801.734213733|zhui wen;
追尾__追尾 152.837570606|zhui wei;
传遍__傳遍 203.820597887|chuan bian;
船舶__船舶 1143.59786783|chuan bo;
传播__傳播 4811.50185273|chuan bo;
传票__傳票 105.558392399|chuan piao;
船票__船票 111.230349808|chuan piao;
串门__串門 207.149415951|chuan men;
传媒__傳媒 2041.42221915|chuan mei;
川大__川大 233.183609039|chuan da;
传达__傳達 1450.91895115|chuan da;
穿戴__穿戴 218.824857909|chuan dai;
传单__傳單 307.500011268|chuan dan;
传道__傳道 122.279808036|chuan dao;
传导__傳導 318.418891685|chuan dao;
传到__傳到 946.259922413|chuan dao;
传得__傳得 105.295633316|chuan de;
穿得__穿得 356.655002599|chuan de;
穿的__穿的 781.999279332|chuan de;
传递__傳遞 3931.92961191|chuan di;
船东__船東 115.899886195|chuan dong;
传动__傳動 301.429591092|chuan dong;
船队__船隊 159.452390871|chuan dui;
船头__船頭 123.351140937|chuan tou;
穿透__穿透 436.982903472|chuan tou;
串通__串通 168.229740225|chuan tong;
传统__傳統 13434.8281681|chuan tong;
传来__傳來 2303.71924505|chuan lai;
穿了__穿了 776.174076244|chuan le;
串联__串聯 334.69325133|chuan lian;
传感__傳感 109.30661816|chuan gan;
传给__傳給 875.902662456|chuan gei;
穿过__穿過 1635.30461749|chuan guo;
传开__傳開 138.680779525|chuan kai;
串口__串口 651.914561431|chuan kou;
穿孔__穿孔 159.452390871|chuan kong;
传唤__傳喚 125.678566729|chuan huan;
串号__串號 112.484875527|chuan hao;
穿好__穿好 232.024158785|chuan hao;
传回__傳回 155.915530766|chuan hui;
传教__傳教 137.476305203|chuan jiao;
川崎__川崎 108.898738333|chuan qi;
船期__船期 124.276893895|chuan qi;
喘气__喘氣 259.562230298|chuan qi;
传奇__傳奇 2361.85708402|chuan qi;
传球__傳球 715.782248677|chuan qiu;
川西__川西 125.835280772|chuan xi;
喘息__喘息 380.057830188|chuan xi;
传销__傳銷 824.018360007|chuan xiao;
穿鞋__穿鞋 129.171793682|chuan xie;
串行__串行 199.051387821|chuan xing;
穿行__穿行 315.653350706|chuan xing;
船长__船長 476.219822262|chuan zhang;
喘着__喘着 154.947067523|chuan zhe;
穿着__穿着 3011.53728293|chuan zhe;
传真__傳真 2629.03938618|chuan zhen;
船只__船隻 400.479435488|chuan zhi;
传中__傳中 333.444336783|chuan zhong;
穿着__穿着 584.932834985|chuan zhuo;
串串__串串 171.190483873|chuan chuan;
穿插__穿插 372.555031371|chuan cha;
船厂__船廠 142.891090816|chuan chang;
传唱__傳唱 150.756793028|chuan chang;
传承__傳承 874.811821743|chuan cheng;
穿出__穿出 105.558392399|chuan chu;
传出__傳出 1415.20413466|chuan chu;
船上__船上 569.114341748|chuan shang;
穿上__穿上 1519.38443361|chuan shang;
传神__傳神 170.339279748|chuan shen;
传世__傳世 279.713669565|chuan shi;
传授__傳授 741.198640518|chuan shou;
传输__傳輸 3030.36024751|chuan shu;
传说__傳說 4583.25194611|chuan shuo;
传染__傳染 947.439854855|chuan ran;
传热__傳熱 114.46454262|chuan re;
传人__傳人 302.181790975|chuan ren;
传入__傳入 556.490650127|chuan ru;
穿在__穿在 134.762357541|chuan zai;
川菜__川菜 348.309611377|chuan cai;
穿刺__穿刺 286.058823982|chuan ci;
传送__傳送 1986.21549859|chuan song;
穿梭__穿梭 754.243296976|chuan suo;
船员__船員 366.568203397|chuan yuan;
穿越__穿越 1319.8108917|chuan yue;
传言__傳言 956.932435908|chuan yan;
穿衣__穿衣 357.99085261|chuan yi;
传闻__傳聞 1243.1798239|chuan wen;
创办__創辦 1182.73057528|chuang ban;
窗边__窗邊 153.028150386|chuang bian;
床边__床邊 416.253137598|chuang bian;
床铺__床鋪 175.510734618|chuang pu;
创面__創面 135.435779871|chuang mian;
床单__床單 446.895626023|chuang dan;
闯荡__闖蕩 271.810366771|chuang dang;
床垫__床墊 303.313611771|chuang dian;
窗台__窗檯 351.799391968|chuang tai;
窗体__窗體 467.400766428|chuang ti;
创投__創投 298.06779536|chuang tou;
床头__床頭 472.083744072|chuang tou;
创立__創立 954.550411286|chuang li;
窗帘__窗帘 834.351249399|chuang lian;
闯关__闖關 112.34478795|chuang guan;
创刊__創刊 137.991222203|chuang kan;
窗口__窗口 5395.99270938|chuang kou;
窗户__窗戶 1657.87544242|chuang hu;
创建__創建 5998.9277097|chuang jian;
闯进__闖進 311.744192349|chuang jin;
创举__創舉 129.655606164|chuang ju;
床前__床前 197.322580943|chuang qian;
窗前__窗前 371.164834837|chuang qian;
床戏__床戲 175.292155245|chuang xi;
床下__床下 124.587019602|chuang xia;
创下__創下 879.183352683|chuang xia;
创新__創新 8621.12153338|chuang xin;
创出__創出 485.205278648|chuang chu;
创伤__創傷 585.662213047|chuang shang;
床上__床上 3621.48192263|chuang shang;
创设__創設 415.734739962|chuang she;
创世__創世 146.132498493|chuang shi;
创收__創收 204.584007193|chuang shou;
闯入__闖入 410.586139672|chuang ru;
创造__創造 7950.33736137|chuang zao;
窗子__窗子 324.83145542|chuang zi;
创作__創作 4549.1107722|chuang zuo;
创业__創業 5463.65648792|chuang ye;
创意__創意 3839.92616142|chuang yi;
窗外__窗外 1645.52573648|chuang wai;
创卫__創衛 105.690017726|chuang wei;
床位__床位 283.221176861|chuang wei;
创维__創維 296.955549433|chuang wei;
纯白__純白 209.224885556|chun bai;
唇边__唇邊 112.065135969|chun bian;
纯平__純平 117.207077876|chun ping;
纯朴__純樸 238.770616634|chun pu;
淳朴__淳樸 315.260239073|chun pu;
春梦__春夢 161.049974862|chun meng;
纯美__純美 113.32907693|chun mei;
纯棉__純棉 210.270405333|chun mian;
春风__春風 871.547443971|chun feng;
纯度__純度 197.568631008|chun du;
春天__春天 3087.5379805|chun tian;
春来__春來 133.925286409|chun lai;
春兰__春蘭 187.961915178|chun lan;
春联__春聯 129.494134325|chun lian;
春光__春光 403.988165198|chun guang;
唇膏__唇膏 212.641966978|chun gao;
春耕__春耕 191.508436159|chun geng;
春归__春歸 249.415244207|chun gui;
纯化__純化 173.553291634|chun hua;
春花__春花 179.71591787|chun hua;
醇厚__醇厚 117.353228453|chun hou;
春晖__春暉 109.442917312|chun hui;
春季__春季 1033.79844744|chun ji;
春江__春江 113.47039186|chun jiang;
纯洁__純潔 1629.20244568|chun jie;
春节__春節 2801.55051046|chun jie;
纯净__純凈 781.999279332|chun jing;
纯情__純情 457.033213363|chun qing;
春秋__春秋 962.913535809|chun qiu;
春夏__春夏 305.589986932|chun xia;
春晓__春曉 161.854759309|chun xiao;
纯真__純真 843.76158662|chun zhen;
纯正__純正 493.744603771|chun zheng;
纯种__純種 160.449013667|chun zhong;
纯纯__純純 127.254530072|chun chun;
春春__春春 601.940653207|chun chun;
纯属__純屬 1431.1656954|chun shu;
纯水__純水 111.786180106|chun shui;
春水__春水 156.694657831|chun shui;
春日__春日 249.726250867|chun ri;
纯粹__純粹 2794.57680777|chun cui;
春色__春色 432.648119245|chun se;
春运__春運 583.476802811|chun yun;
春药__春藥 129.332863581|chun yao;
春意__春意 114.607273411|chun yi;
纯银__純銀 118.529012887|chun yin;
春游__春遊 289.645897197|chun you;
春雨__春雨 323.216307961|chun yu;
春晚__春晚 876.994863387|chun wan;
纯爱__純愛 114.607273411|chun ai;
揣摩__揣摩 266.444503116|chuai mo;
揣着__揣着 131.609045271|chuai zhe;
揣测__揣測 248.794392378|chuai ce;
插拔__插拔 113.895394799|cha ba;
查办__查辦 253.488718522|cha ban;
茶杯__茶杯 295.479008313|cha bei;
差别__差別 3377.37232991|cha bie;
插播__插播 147.045868173|cha bo;
差评__差評 151.888225993|cha ping;
查明__查明 529.431458035|cha ming;
查分__查分 160.249192015|cha fen;
差分__差分 161.653186955|cha fen;
查封__查封 357.545014261|cha feng;
插到__插到 164.088713397|cha dao;
茶道__茶道 226.312812713|cha dao;
查到__查到 1247.83614939|cha dao;
差得__差得 146.862738669|cha de;
差点__差點 3768.81504502|cha dian;
查毒__查毒 115.467403456|cha du;
插队__插隊 210.270405333|cha dui;
插头__插頭 448.56947196|cha tou;
插图__插圖 343.139741671|cha tu;
刹那__剎那 377.226735448|cha na;
查理__查理 208.184564378|cha li;
茶楼__茶樓 230.870473623|cha lou;
茶馆__茶館 403.988165198|cha guan;
查过__查過 221.292902041|cha guo;
插卡__插卡 120.46484039|cha ka;
察看__察看 469.736419493|cha kan;
查看__查看 6769.71431233|cha kan;
插口__插口 174.638049069|cha kou;
插孔__插孔 144.322743975|cha kong;
插花__插花 128.369448119|cha hua;
插画__插畫 226.312812713|cha hua;
茶壶__茶壺 198.308623594|cha hu;
查获__查獲 369.319305625|cha huo;
察觉__察覺 701.651845929|cha jue;
茶几__茶几 285.346757867|cha ji;
差价__差價 918.378206258|cha jia;
插件__插件 4646.51097209|cha jian;
插进__插進 198.308623594|cha jin;
差劲__差勁 425.69561654|cha jin;
茶具__茶具 152.837570606|cha ju;
差距__差距 4311.76192745|cha ju;
查清__查清 227.443722742|cha qing;
插曲__插曲 375.351064872|cha qu;
查询__查詢 10536.5270626|cha xun;
查找__查找 2675.30892006|cha zhao;
插着__插着 150.569041974|cha zhe;
查证__查證 292.183578474|cha zheng;
差值__差值 116.915322539|cha zhi;
插值__插值 134.930398555|cha zhi;
叉叉__叉叉 465.076726846|cha cha;
查查__查查 1655.81074036|cha cha;
叉车__叉車 164.498187167|cha che;
查出__查出 815.844260376|cha chu;
查处__查處 1856.95505407|cha chu;
查杀__查殺 424.635962376|cha sha;
插上__插上 612.534451685|cha shang;
叉烧__叉燒 132.927661458|cha shao;
查实__查實 197.568631008|cha shi;
插手__插手 317.230705235|cha shou;
查收__查收 1399.42059064|cha shou;
茶树__茶樹 191.269933402|cha shu;
茶水__茶水 355.324137339|cha shui;
插入__插入 2681.98499671|cha ru;
插在__插在 374.883606282|cha zai;
叉子__叉子 136.963309627|cha zi;
插座__插座 584.932834985|cha zuo;
插嘴__插嘴 126.149295342|cha zui;
插槽__插槽 471.495815538|cha cao;
差错__差錯 440.811451858|cha cuo;
茶园__茶園 188.196293023|cha yuan;
查阅__查閱 1070.5071343|cha yue;
查验__查驗 292.54791482|cha yan;
茶叶__茶葉 1532.69625148|cha ye;
诧异__詫異 513.191745392|cha yi;
差异__差異 4231.91294301|cha yi;
差额__差額 529.431458035|cha e;
拆分__拆分 550.970372621|chai fen;
拆掉__拆掉 218.824857909|chai diao;
差旅__差旅 118.676811842|chai lv;
拆了__拆了 379.584509838|chai le;
拆开__拆開 485.205278648|chai kai;
柴火__柴火 158.264611567|chai huo;
拆机__拆機 194.636170786|chai ji;
拆解__拆解 184.251320835|chai jie;
拆迁__拆遷 1496.83260243|chai qian;
拆下__拆下 166.560934377|chai xia;
拆卸__拆卸 246.633556117|chai xie;
拆装__拆裝 185.172044961|chai zhuang;
拆除__拆除 1037.67053575|chai chu;
差事__差事 123.351140937|chai shi;
拆散__拆散 136.963309627|chai san;
柴油__柴油 704.279880358|chai you;
产品__產品 51481.2631843|chan pin;
缠绵__纏綿 628.775756137|chan mian;
阐明__闡明 309.036622663|chan ming;
产房__產房 137.819369268|chan fang;
搀扶__攙扶 227.727332161|chan fu;
产妇__產婦 392.573489614|chan fu;
产地__產地 655.989212862|chan di;
颤抖__顫抖 983.530305889|chan dou;
颤动__顫動 260.534419685|chan dong;
产能__產能 1280.92243009|chan neng;
产卵__產卵 146.679837233|chan luan;
蝉联__蟬聯 172.905674062|chan lian;
产量__產量 2977.95009215|chan liang;
产科__產科 118.676811842|chan ke;
产后__產後 513.831666385|chan hou;
忏悔__懺悔 526.142915167|chan hui;
产假__產假 180.613978088|chan jia;
产权__產權 1567.46464304|chan quan;
产前__產前 137.647730357|chan qian;
产区__產區 268.109857044|chan qu;
产下__產下 118.381397999|chan xia;
产销__產銷 383.387639617|chan xiao;
缠着__纏着 335.946843682|chan zhe;
产值__產值 695.557838999|chan zhi;
缠住__纏住 122.279808036|chan zhu;
潺潺__潺潺 150.381524744|chan chan;
蟾蜍__蟾蜍 162.86639759|chan chu;
铲除__剷除 222.121753798|chan chu;
产出__產出 620.215410078|chan chu;
缠身__纏身 245.71323808|chan shen;
产生__產生 19968.0080118|chan sheng;
禅师__禪師 244.491487214|chan shi;
阐释__闡釋 343.996026791|chan shi;
阐述__闡述 1563.56286353|chan shu;
缠绕__纏繞 609.488769235|chan rao;
掺杂__摻雜 225.468321935|chan za;
铲子__鏟子 113.47039186|chan zi;
产自__產自 115.179978568|chan zi;
禅宗__禪宗 181.969489867|chan zong;
产业__產業 9442.16538338|chan ye;
单于__單于 113.187937993|chan yu;
产于__產於 149.820373083|chan yu;
产物__產物 1227.78386251|chan wu;
常被__常被 212.112652282|chang bei;
场边__場邊 165.73274959|chang bian;
厂牌__廠牌 113.753550575|chang pai;
长袍__長袍 169.703655326|chang pao;
长跑__長跑 309.807805448|chang pao;
长篇__長篇 483.997491267|chang pian;
唱片__唱片 1762.26354231|chang pian;
昌平__昌平 352.238065853|chang ping;
长矛__長矛 120.164975734|chang mao;
场面__場面 2473.3076131|chang mian;
唱法__唱法 152.837570606|chang fa;
长发__長發 1206.54931027|chang fa;
厂方__廠方 163.884358899|chang fang;
厂房__廠房 950.988487375|chang fang;
长风__長風 271.133768339|chang feng;
长短__長短 629.559803835|chang duan;
长达__長達 1368.37963334|chang da;
唱到__唱到 162.86639759|chang dao;
尝到__嘗到 363.837594448|chang dao;
肠道__腸道 508.100984482|chang dao;
倡导__倡導 1292.14500531|chang dao;
常德__常德 392.084582382|chang de;
唱得__唱得 427.290057918|chang de;
唱的__唱的 796.754272909|chang de;
长的__長的 844.813709452|chang de;
场地__場地 2106.02207003|chang di;
长电__長電 132.596773978|chang dian;
长度__長度 2854.41099368|chang du;
长队__長隊 119.41857567|chang dui;
常态__常態 319.611528482|chang tai;
长叹__長嘆 204.07475061|chang tan;
畅谈__暢談 332.614317243|chang tan;
长天__長天 115.179978568|chang tian;
长条__長條 136.792736844|chang tiao;
畅通__暢通 813.813436628|chang tong;
长途__長途 1236.99840673|chang tu;
长腿__長腿 128.850255419|chang tui;
场内__場內 429.960742313|chang nei;
长年__長年 305.209408115|chang nian;
常年__常年 941.55486912|chang nian;
长宁__長寧 187.027319083|chang ning;
常来__常來 463.341283758|chang lai;
长廊__長廊 252.54282031|chang lang;
长了__長了 255.391156791|chang le;
长乐__長樂 309.807805448|chang le;
常理__常理 309.036622663|chang li;
厂里__廠里 518.333511609|chang li;
常量__常量 243.882891747|chang liang;
长龙__長龍 162.663565352|chang long;
场馆__場館 569.114341748|chang guan;
唱歌__唱歌 3820.83303827|chang ge;
长工__長工 107.818484324|chang gong;
唱功__唱功 284.991389772|chang gong;
尝过__嘗過 130.954650472|chang guo;
唱过__唱過 173.337150041|chang guo;
常规__常規 2046.51646869|chang gui;
长宽__長寬 211.848489234|chang kuan;
猖狂__猖狂 244.796354228|chang kuang;
畅快__暢快 248.175085992|chang kuai;
敞开__敞開 617.131535882|chang kai;
常客__常客 205.094534596|chang ke;
长空__長空 176.827946446|chang kong;
长裤__長褲 258.271618599|chang ku;
偿还__償還 726.566487616|chang huan;
常昊__常昊 127.73116145|chang hao;
长河__長河 316.441045148|chang he;
场合__場合 1733.94458864|chang he;
长虹__長虹 842.710774091|chang hong;
常会__常會 253.173026121|chang hui;
猖獗__猖獗 291.819695868|chang jue;
场均__場均 150.944778196|chang jun;
长假__長假 918.378206258|chang jia;
厂家__廠家 4295.67250177|chang jia;
长剑__長劍 308.651751439|chang jian;
常见__常見 3581.09211742|chang jian;
长焦__長焦 311.355949144|chang jiao;
长江__長江 2382.55007694|chang jiang;
长今__長今 110.126966673|chang jin;
场景__場景 3060.72200622|chang jing;
长久__長久 1866.23446282|chang jiu;
长裙__長裙 230.295783987|chang qun;
唱起__唱起 207.925293333|chang qi;
长期__長期 10978.8586437|chang qi;
长枪__長槍 128.529517539|chang qiang;
唱腔__唱腔 205.862715427|chang qiang;
长青__長青 141.29744947|chang qing;
常青__常青 144.143005824|chang qing;
常去__常去 313.69268222|chang qu;
厂区__廠區 344.85444872|chang qu;
唱戏__唱戲 138.335571213|chang xi;
场戏__場戲 232.024158785|chang xi;
长线__長線 1079.88619313|chang xian;
长效__長效 259.885889675|chang xiao;
畅销__暢銷 733.846096172|chang xiao;
畅想__暢想 178.377193209|chang xiang;
唱响__唱響 213.438416689|chang xiang;
长兴__長興 156.89004718|chang xing;
长袖__長袖 331.786363812|chang xiu;
厂长__廠長 506.204995518|chang zhang;
长着__長着 111.646962678|chang zhe;
唱着__唱着 407.020105042|chang zhe;
长征__長征 715.782248677|chang zheng;
长治__長治 130.141230764|chang zhi;
常州__常州 1184.20537322|chang zhou;
常住__常住 241.463621556|chang zhu;
常驻__常駐 339.735863102|chang zhu;
长传__長傳 155.527421199|chang chuan;
长春__長春 1896.71398774|chang chun;
长长__長長 307.883446338|chang chang;
尝尝__嘗嘗 518.333511609|chang chang;
常常__常常 6173.35572247|chang chang;
长城__長城 2238.62771494|chang cheng;
常吃__常吃 167.184787749|chang chi;
唱出__唱出 287.488291405|chang chu;
长处__長處 435.895152658|chang chu;
长沙__長沙 3931.92961191|chang sha;
常山__常山 116.18910757|chang shan;
场上__場上 1132.25360251|chang shang;
厂商__廠商 5450.05619202|chang shang;
昌盛__昌盛 123.813152185|chang sheng;
长生__長生 219.644465616|chang sheng;
常事__常事 106.350610398|chang shi;
常识__常識 1321.45662101|chang shi;
尝试__嘗試 5793.21889028|chang shi;
长寿__長壽 597.456727653|chang shou;
常数__常數 236.402059204|chang shu;
常熟__常熟 355.767206381|chang shu;
常说__常說 550.970372621|chang shuo;
常人__常人 582.750146437|chang ren;
常在__常在 342.285588041|chang zai;
厂子__廠子 186.32942291|chang zi;
肠子__腸子 290.730764849|chang zi;
场子__場子 340.15949445|chang zi;
长足__長足 336.785179346|chang zu;
长策__長策 189.608710238|chang ce;
场次__場次 281.461959558|chang ci;
场所__場所 2364.80218582|chang suo;
长远__長遠 1597.0400293|chang yuan;
长约__長約 203.060037258|chang yue;
肠炎__腸炎 147.045868173|chang yan;
长阳__長陽 143.247667161|chang yang;
徜徉__徜徉 160.449013667|chang yang;
长夜__長夜 160.449013667|chang ye;
常以__常以 110.95347192|chang yi;
长椅__長椅 111.786180106|chang yi;
倡议__倡議 434.810109507|chang yi;
畅游__暢遊 271.810366771|chang you;
常有__常有 635.867483878|chang you;
常用__常用 3432.5319072|chang yong;
长于__長於 137.305093541|chang yu;
场外__場外 419.900065808|chang wai;
唱完__唱完 145.768741141|chang wan;
常温__常溫 170.339279748|chang wen;
长尾__長尾 135.098649108|chang wei;
常委__常委 534.069978074|chang wei;
肠胃__腸胃 562.76710106|chang wei;
常务__常務 844.813709452|chang wu;
长安__長安 1265.05905145|chang an;
嫦娥__嫦娥 750.493000864|chang e;
朝拜__朝拜 117.646076559|chao bai;
超薄__超薄 379.584509838|chao bao;
抄表__抄表 110.126966673|chao biao;
超标__超標 767.517531652|chao biao;
超薄__超薄 243.882891747|chao bo;
钞票__鈔票 970.140222547|chao piao;
超频__超頻 1097.52300072|chao pin;
炒面__炒麵 117.499561272|chao mian;
超凡__超凡 189.845141544|chao fan;
炒饭__炒飯 261.510250403|chao fan;
炒房__炒房 294.743493195|chao fang;
嘲讽__嘲諷 479.793862242|chao feng;
超大__超大 614.062995519|chao da;
朝代__朝代 302.181790975|chao dai;
超导__超導 128.529517539|chao dao;
吵得__吵得 133.093414711|chao de;
炒得__炒得 197.322580943|chao de;
超低__超低 256.028470459|chao di;
抄底__抄底 540.767020614|chao di;
超跌__超跌 312.911829085|chao die;
超多__超多 204.329220247|chao duo;
朝天__朝天 264.130371602|chao tian;
朝廷__朝廷 675.904869515|chao ting;
超脱__超脫 226.312812713|chao tuo;
超女__超女 1647.57761372|chao nv;
朝南__朝南 109.989815613|chao nan;
吵闹__吵鬧 262.817045902|chao nao;
超能__超能 123.197520618|chao neng;
嘲弄__嘲弄 162.663565352|chao nong;
吵了__吵了 256.987424161|chao le;
潮流__潮流 1762.26354231|chao liu;
超高__超高 385.78392141|chao gao;
炒股__炒股 3286.03715745|chao gu;
炒锅__炒鍋 110.401782066|chao guo;
超过__超過 16708.7007457|chao guo;
超酷__超酷 146.679837233|chao ku;
巢湖__巢湖 146.862738669|chao hu;
超乎__超乎 221.845125512|chao hu;
超级__超級 7304.38638512|chao ji;
炒家__炒家 151.510141313|chao jia;
吵架__吵架 2501.20312918|chao jia;
超群__超群 212.907119447|chao qun;
超期__超期 125.678566729|chao qi;
超前__超前 482.191444969|chao qian;
超强__超強 1032.51096484|chao qiang;
巢穴__巢穴 140.594881376|chao xue;
潮汐__潮汐 161.049974862|chao xi;
抄袭__抄襲 1265.05905145|chao xi;
朝下__朝下 143.784200776|chao xia;
超限__超限 184.251320835|chao xian;
朝鲜__朝鮮 2773.75968187|chao xian;
嘲笑__嘲笑 1135.07907503|chao xiao;
朝向__朝向 286.415523108|chao xiang;
抄写__抄寫 135.435779871|chao xie;
超星__超星 182.878811433|chao xing;
吵醒__吵醒 404.996293994|chao xing;
吵着__吵着 151.132997772|chao zhe;
朝着__朝着 787.868200695|chao zhe;
超值__超值 814.828215816|chao zhi;
潮州__潮州 380.531740742|chao zhou;
朝中__朝中 115.467403456|chao zhong;
超重__超重 231.735198139|chao zhong;
超常__超常 199.796934068|chao chang;
超长__超長 242.066179876|chao chang;
超超__超超 128.689786556|chao chao;
吵吵__吵吵 170.551683166|chao chao;
超车__超車 202.302314677|chao che;
超出__超出 1959.1745514|chao chu;
潮汕__潮汕 214.2378495|chao shan;
朝上__朝上 133.093414711|chao shang;
朝圣__朝聖 113.753550575|chao sheng;
超生__超生 228.295612376|chao sheng;
超声__超聲 538.749137684|chao sheng;
超时__超時 731.107734818|chao shi;
潮湿__潮濕 743.974797322|chao shi;
超市__超市 4327.91161602|chao shi;
潮水__潮水 278.669912425|chao shui;
超然__超然 164.703307075|chao ran;
超人__超人 947.439854855|chao ren;
超载__超載 335.110594827|chao zai;
炒作__炒作 2622.4951033|chao zuo;
炒菜__炒菜 394.043872187|chao cai;
抄送__抄送 364.291279287|chao song;
超速__超速 314.867617017|chao su;
超越__超越 3095.24275062|chao yue;
朝阳__朝陽 719.359091341|chao yang;
朝野__朝野 129.494134325|chao ye;
超微__超微 111.369047744|chao wei;
超额__超額 457.033213363|chao e;
车标__車標 126.779677253|che biao;
车牌__車牌 530.752623218|che pai;
扯皮__扯皮 175.073848088|che pi;
车票__車票 1062.53280282|che piao;
车马__車馬 115.036534536|che ma;
车门__車門 627.210588862|che men;
车迷__車迷 188.901181552|che mi;
车模__車模 290.730764849|che mo;
车费__車費 627.210588862|che fei;
车夫__車夫 164.703307075|che fu;
扯蛋__扯蛋 165.32020271|che dan;
撤单__撤單 181.742866823|che dan;
扯淡__扯淡 729.287839744|che dan;
扯到__扯到 170.76435144|che dao;
车道__車道 506.204995518|che dao;
车灯__車燈 161.250795044|che deng;
彻底__徹底 6846.06740057|che di;
撤掉__撤掉 143.605133321|che diao;
车顶__車頂 171.403948695|che ding;
车队__車隊 1296.98472971|che dui;
车坛__車壇 122.432284019|che tan;
车体__車體 209.746993999|che ti;
车停__車停 156.109948588|che ting;
车头__車頭 331.37316028|che tou;
撤退__撤退 601.940653207|che tui;
车内__車內 780.052703516|che nei;
车轮__車輪 557.184562398|che lun;
撤离__撤離 590.057620516|che li;
车里__車裡 604.948616891|che li;
车辆__車輛 5243.52906925|che liang;
车流__車流 207.407719521|che liu;
车况__車況 110.95347192|che kuang;
扯开__扯開 106.218162376|che kai;
车库__車庫 461.037428991|che ku;
车行__車行 167.184787749|che hang;
车后__車后 150.381524744|che hou;
车祸__車禍 1013.39002232|che huo;
撤回__撤回 239.963779681|che hui;
撤军__撤軍 186.794397067|che jun;
车架__車架 161.854759309|che jia;
车价__車價 205.094534596|che jia;
车间__車間 1409.92327219|che jian;
车前__車前 128.689786556|che qian;
撤下__撤下 115.467403456|che xia;
车险__車險 254.121284766|che xian;
撤消__撤消 254.755429543|che xiao;
撤销__撤銷 1166.62851836|che xiao;
车厢__車廂 861.827215553|che xiang;
车型__車型 3343.86946243|che xing;
车撞__車撞 110.539446825|che zhuang;
车展__車展 952.17431607|che zhan;
车站__車站 2011.12191579|che zhan;
扯着__扯着 160.249192015|che zhe;
撤职__撤職 153.41002317|che zhi;
车中__車中 109.989815613|che zhong;
车主__車主 1577.26174289|che zhu;
车床__車床 116.044406778|che chuang;
车窗__車窗 446.895626023|che chuang;
车车__車車 205.862715427|che che;
车臣__車臣 167.810977762|che chen;
车程__車程 310.194118206|che cheng;
撤出__撤出 377.697115787|che chu;
扯上__扯上 226.595011951|che shang;
车上__車上 1991.17198299|che shang;
车身__車身 1152.18059436|che shen;
车市__車市 610.248767154|che shi;
车手__車手 570.534533242|che shou;
车载__車載 496.21189989|che zai;
车子__車子 2854.41099368|che zi;
车次__車次 235.813600182|che ci;
车速__車速 449.128812644|che su;
彻夜__徹夜 155.527421199|che ye;
车友__車友 343.139741671|che you;
车用__車用 174.638049069|che yong;
车外__車外 126.149295342|che wai;
车尾__車尾 154.561368684|che wei;
车位__車位 476.219822262|che wei;
晨报__晨報 308.267359529|chen bao;
陈平__陳平 124.89791921|chen ping;
沉闷__沉悶 456.464028614|chen men;
沉迷__沉迷 722.953807881|chen mi;
陈明__陳明 179.940013424|chen ming;
沉没__沉沒 272.488653616|chen mo;
沉默__沉默 3368.96527446|chen mo;
陈某__陳某 284.991389772|chen mou;
尘封__塵封 234.933657026|chen feng;
沉浮__沉浮 189.372573382|chen fu;
沉淀__沉澱 822.992135502|chen dian;
陈涛__陳濤 185.172044961|chen tao;
沉痛__沉痛 211.848489234|chen tong;
尘土__塵土 398.985038482|chen tu;
衬托__襯托 438.619621343|chen tuo;
沉溺__沉溺 279.017397997|chen ni;
陈年__陳年 205.862715427|chen nian;
沉沦__沉淪 341.008342538|chen lun;
沉了__沉了 196.096919422|chen le;
晨练__晨練 155.140277726|chen lian;
陈列__陳列 514.472385324|chen lie;
晨光__晨光 248.175085992|chen guang;
陈刚__陳剛 138.680779525|chen gang;
陈宫__陳宮 129.010924378|chen gong;
陈国__陳國 164.293322714|chen guo;
陈坤__陳坤 368.399985048|chen kun;
陈浩__陳浩 126.621787068|chen hao;
陈好__陳好 149.633788238|chen hao;
陈红__陳紅 179.940013424|chen hong;
陈俊__陳俊 109.989815613|chen jun;
沉寂__沉寂 451.373158744|chen ji;
沉积__沉積 473.261801395|chen ji;
趁机__趁機 599.694499646|chen ji;
陈家__陳家 241.463621556|chen jia;
沉降__沉降 210.795122809|chen jiang;
沉浸__沉浸 773.277767188|chen jin;
陈静__陳靜 118.972962872|chen jing;
沉静__沉靜 327.677408739|chen jing;
陈旧__陳舊 461.61231651|chen jiu;
晨曦__晨曦 251.287110964|chen xi;
陈晓__陳曉 153.41002317|chen xiao;
沉香__沉香 148.149450567|chen xiang;
晨星__晨星 157.085680168|chen xing;
趁着__趁着 677.591550514|chen zhe;
陈志__陳志 116.18910757|chen zhi;
称职__稱職 276.938965124|chen zhi;
郴州__郴州 240.562595233|chen zhou;
沉重__沉重 2069.59836629|chen zhong;
沉着__沉着 395.027185582|chen zhuo;
沉船__沉船 157.2815571|chen chuan;
晨晨__晨晨 129.979154132|chen chen;
沉沉__沉沉 338.890182508|chen chen;
陈楚__陳楚 136.963309627|chen chu;
衬衫__襯衫 965.316430119|chen shan;
陈设__陳設 125.053659829|chen she;
陈升__陳升 110.539446825|chen sheng;
尘世__塵世 369.779825848|chen shi;
陈述__陳述 1194.58057905|chen shu;
沉睡__沉睡 456.464028614|chen shui;
趁热__趁熱 116.624293448|chen re;
沉入__沉入 162.663565352|chen ru;
趁早__趁早 286.772667017|chen zao;
沉醉__沉醉 436.438689186|chen zui;
沉思__沉思 506.83620443|chen si;
尘缘__塵緣 121.975425508|chen yuan;
陈云__陳雲 180.613978088|chen yun;
陈毅__陳毅 177.269210225|chen yi;
衬衣__襯衣 542.11647303|chen yi;
沉吟__沉吟 203.820597887|chen yin;
陈勇__陳勇 107.684208225|chen yong;
陈文__陳文 170.339279748|chen wen;
沉稳__沉穩 434.810109507|chen wen;
陈伟__陳偉 179.492101402|chen wei;
尘埃__塵埃 543.469292924|chen ai;
称霸__稱霸 247.249015706|cheng ba;
成败__成敗 480.991159713|cheng bai;
承办__承辦 1020.99553617|cheng ban;
城邦__城邦 118.381397999|cheng bang;
承保__承保 148.704343794|cheng bao;
城堡__城堡 812.799921236|cheng bao;
承包__承包 1005.84116282|cheng bao;
成本__成本 13808.2482753|cheng ben;
成倍__成倍 211.321149687|cheng bei;
城北__城北 251.914183226|cheng bei;
成片__成片 219.644465616|cheng pian;
诚聘__誠聘 219.37092252|cheng pin;
成品__成品 1100.26180506|cheng pin;
城门__城門 291.819695868|cheng men;
成名__成名 960.516622856|cheng ming;
乘法__乘法 165.939408926|cheng fa;
惩罚__懲罰 1689.15672637|cheng fa;
成份__成份 611.009712747|cheng fen;
成分__成分 2937.40736593|cheng fen;
乘风__乘風 123.813152185|cheng feng;
成风__成風 129.494134325|cheng feng;
成佛__成佛 201.79873775|cheng fo;
城府__城府 123.351140937|cheng fu;
成大__成大 183.563783354|cheng da;
承担__承擔 7479.39723763|cheng dan;
称道__稱道 241.463621556|cheng dao;
承德__承德 312.911829085|cheng de;
称帝__稱帝 113.753550575|cheng di;
成都__成都 170.127140854|cheng dou;
城东__城東 223.231720645|cheng dong;
成都__成都 9608.34189386|cheng du;
程度__程度 10061.7371458|cheng du;
成堆__成堆 120.765453341|cheng dui;
承兑__承兌 134.092283643|cheng dui;
称他__稱他 167.601987591|cheng ta;
成套__成套 304.829303266|cheng tao;
成天__成天 872.634214191|cheng tian;
城铁__城鐵 260.209952636|cheng tie;
城南__城南 324.83145542|cheng nan;
城内__城內 296.216358865|cheng nei;
成年__成年 895.772044085|cheng nian;
承诺__承諾 5289.46932136|cheng nuo;
承揽__承攬 137.819369268|cheng lan;
成了__成了 10802.4322569|cheng le;
城里__城裡 1392.46230328|cheng li;
成立__成立 9572.48817433|cheng li;
乘凉__乘涼 137.305093541|cheng liang;
成龙__成龍 919.523371782|cheng long;
城关__城關 140.770195218|cheng guan;
城管__城管 981.082073059|cheng guan;
成功__成功 27437.3122051|cheng gong;
成果__成果 5032.27045127|cheng guo;
撑开__撐開 178.822323044|cheng kai;
乘客__乘客 1866.23446282|cheng ke;
诚恳__誠懇 608.72971781|cheng ken;
成婚__成婚 125.678566729|cheng hun;
澄海__澄海 134.259489114|cheng hai;
称号__稱號 1265.05905145|cheng hao;
称呼__稱呼 1666.16002844|cheng hu;
城际__城際 139.547573842|cheng ji;
乘机__乘機 408.035799866|cheng ji;
成绩__成績 9716.71080614|cheng ji;
成家__成家 372.555031371|cheng jia;
成见__成見 157.2815571|cheng jian;
承建__承建 212.377144726|cheng jian;
城建__城建 410.07479966|cheng jian;
成教__成教 109.30661816|cheng jiao;
城郊__城郊 197.568631008|cheng jiao;
成交__成交 2868.67479953|cheng jiao;
惩戒__懲戒 329.725485744|cheng jie;
承接__承接 763.701232553|cheng jie;
成就__成就 4081.70704886|cheng jiu;
成全__成全 421.998352644|cheng quan;
成群__成群 238.473254015|cheng qun;
撑起__撐起 319.213487372|cheng qi;
称其__稱其 367.025293151|cheng qi;
城墙__城牆 791.805264794|cheng qiang;
成亲__成親 118.529012887|cheng qin;
澄清__澄清 1053.30446216|cheng qing;
城区__城區 1845.42065012|cheng qu;
城西__城西 269.114061535|cheng xi;
成仙__成仙 162.663565352|cheng xian;
呈现__呈現 3122.36117229|cheng xian;
承销__承銷 140.945727665|cheng xiao;
成效__成效 1749.13623734|cheng xiao;
丞相__丞相 279.713669565|cheng xiang;
成像__成像 755.18379558|cheng xiang;
城乡__城鄉 1549.98296207|cheng xiang;
成新__成新 123.658956482|cheng xin;
诚心__誠心 476.813641365|cheng xin;
诚信__誠信 2409.42197254|cheng xin;
成行__成行 206.633773476|cheng xing;
成形__成形 472.67240572|cheng xing;
成型__成型 700.778015498|cheng xing;
程序__程序 22310.1160543|cheng xu;
成长__成長 7053.91217164|cheng zhang;
诚招__誠招 182.196395498|cheng zhao;
乘着__乘着 193.427195796|cheng zhe;
撑着__撐着 366.568203397|cheng zhe;
成真__成真 185.86560618|cheng zhen;
城镇__城鎮 1939.73992621|cheng zhen;
诚征__誠徵 145.950506492|cheng zheng;
橙汁__橙汁 146.679837233|cheng zhi;
惩治__懲治 264.789493468|cheng zhi;
诚挚__誠摯 328.495108513|cheng zhi;
称重__稱重 117.353228453|cheng zhong;
承重__承重 122.737806611|cheng zhong;
城中__城中 285.702569086|cheng zhong;
城主__城主 107.14877401|cheng zhu;
乘船__乘船 142.713135632|cheng chuan;
乘车__乘車 703.402776999|cheng che;
城池__城池 141.29744947|cheng chi;
惩处__懲處 217.19480623|cheng chu;
程式__程式 390.135034682|cheng shi;
诚实__誠實 1123.81931445|cheng shi;
城市__城市 21733.8448103|cheng shi;
成熟__成熟 182.423584067|cheng shou;
承受__承受 3261.55908656|cheng shou;
成熟__成熟 8718.35595463|cheng shu;
成人__成人 3778.21990214|cheng ren;
承认__承認 6786.60773774|cheng ren;
成日__成日 482.191444969|cheng ri;
承载__承載 870.462027204|cheng zai;
称赞__稱讚 806.745280603|cheng zan;
橙子__橙子 317.230705235|cheng zi;
承租__承租 142.003528374|cheng zu;
称做__稱做 112.204874836|cheng zuo;
称作__稱作 662.561694208|cheng zuo;
乘坐__乘坐 1202.04704744|cheng zuo;
成才__成才 376.287731462|cheng cai;
成色__成色 350.92368248|cheng se;
橙色__橙色 601.940653207|cheng se;
撑死__撐死 198.803491145|cheng si;
乘员__乘員 106.218162376|cheng yuan;
成员__成員 7062.70799995|cheng yuan;
承运__承運 125.209594649|cheng yun;
撑腰__撐腰 155.527421199|cheng yao;
诚邀__誠邀 191.031727675|cheng yao;
成一__成一 109.442917312|cheng yi;
成衣__成衣 142.003528374|cheng yi;
乘以__乘以 277.630050085|cheng yi;
诚意__誠意 1238.54087357|cheng yi;
成瘾__成癮 145.768741141|cheng yin;
成因__成因 403.988165198|cheng yin;
成语__成語 639.044983668|cheng yu;
城外__城外 266.112675706|cheng wai;
成文__成文 147.229226029|cheng wen;
称谓__稱謂 425.165459331|cheng wei;
称为__稱為 5443.2687447|cheng wei;
成为__成為 38459.8547306|cheng wei;
吃吧__吃吧 335.946843682|chi ba;
翅膀__翅膀 1762.26354231|chi bang;
吃饱__吃飽 887.99205879|chi bao;
持币__持幣 152.267254161|chi bi;
赤壁__赤壁 210.270405333|chi bi;
吃不__吃不 243.57916235|chi bu;
持平__持平 579.130416613|chi ping;
尺码__尺碼 427.290057918|chi ma;
痴迷__痴迷 480.392137969|chi mi;
吃面__吃面 212.112652282|chi mian;
驰名__馳名 109.989815613|chi ming;
吃法__吃法 372.555031371|chi fa;
吃饭__吃飯 30885.5878399|chi fan;
赤峰__赤峰 175.729586548|chi feng;
吃顿__吃頓 125.835280772|chi dun;
迟钝__遲鈍 575.5331706|chi dun;
痴呆__痴獃 237.287502254|chi dai;
赤道__赤道 184.02185602|chi dao;
持刀__持刀 188.430963124|chi dao;
吃到__吃到 1019.7239982|chi dao;
迟到__遲到 2061.87561868|chi dao;
吃得__吃得 1474.61550226|chi de;
吃点__吃點 1249.39213028|chi dian;
吃掉__吃掉 732.932171333|chi diao;
尺度__尺度 837.47630896|chi du;
吃多__吃多 120.015323434|chi duo;
吃糖__吃糖 116.18910757|chi tang;
池塘__池塘 513.831666385|chi tang;
吃透__吃透 109.989815613|chi tou;
吃奶__吃奶 249.104624871|chi nai;
齿轮__齒輪 556.490650127|chi lun;
吃辣__吃辣 167.393257695|chi la;
迟来__遲來 123.967540162|chi lai;
吃了__吃了 5643.57980061|chi le;
吃力__吃力 668.366611253|chi li;
赤裸__赤裸 467.983588668|chi luo;
吃光__吃光 145.224802174|chi guang;
吃个__吃個 470.908619205|chi ge;
持股__持股 1182.73057528|chi gu;
吃过__吃過 2199.91059329|chi guo;
吃苦__吃苦 533.404852483|chi ku;
吃亏__吃虧 1073.17852213|chi kui;
迟缓__遲緩 230.582949765|chi huan;
吃好__吃好 607.9716117|chi hao;
吃喝__吃喝 537.40806734|chi he;
赤脚__赤腳 176.827946446|chi jiao;
吃进__吃進 155.140277726|chi jin;
吃紧__吃緊 156.109948588|chi jin;
吃惊__吃驚 1066.51251556|chi jing;
持久__持久 1004.58849796|chi jiu;
持枪__持槍 220.19257551|chi qiang;
痴情__痴情 487.02261325|chi qing;
吃下__吃下 154.176629937|chi xia;
耻笑__恥笑 126.779677253|chi xiao;
吃香__吃香 335.946843682|chi xiang;
吃些__吃些 238.473254015|chi xie;
痴心__痴心 244.491487214|chi xin;
持续__持續 8783.78740305|chi xu;
吃着__吃着 501.808489233|chi zhe;
持证__持證 114.607273411|chi zheng;
迟滞__遲滯 109.30661816|chi zhi;
池中__池中 134.930398555|chi zhong;
吃住__吃住 309.807805448|chi zhu;
驰骋__馳騁 292.183578474|chi cheng;
痴痴__痴痴 150.756793028|chi chi;
吃吃__吃吃 394.043872187|chi chi;
迟迟__遲遲 977.421145723|chi chi;
吃出__吃出 124.742372548|chi chu;
吃上__吃上 239.068350048|chi shang;
赤身__赤身 118.381397999|chi shen;
吃屎__吃屎 275.905561849|chi shi;
炽热__熾熱 219.918349804|chi re;
吃人__吃人 253.488718522|chi ren;
吃肉__吃肉 607.214449729|chi rou;
耻辱__恥辱 692.962351041|chi ru;
迟早__遲早 1140.75119008|chi zao;
斥责__斥責 190.318888971|chi ze;
尺子__尺子 135.604660605|chi zi;
池子__池子 169.070402749|chi zi;
斥资__斥資 185.172044961|chi zi;
赤字__赤字 221.568841736|chi zi;
尺寸__尺寸 3956.50529033|chi cun;
持仓__持倉 468.567137655|chi cang;
吃草__吃草 181.516526012|chi cao;
吃醋__吃醋 624.091932797|chi cu;
吃素__吃素 245.407229187|chi su;
吃药__吃藥 1214.09058664|chi yao;
迟疑__遲疑 363.384474622|chi yi;
蚩尤__蚩尤 131.281440129|chi you;
持有__持有 4583.25194611|chi you;
吃鱼__吃魚 283.927938713|chi yu;
吃完__吃完 2564.32477261|chi wan;
筹办__籌辦 201.045721733|chou ban;
筹备__籌備 1069.17393505|chou bei;
臭屁__臭屁 162.663565352|chou pi;
筹码__籌碼 1145.0238695|chou ma;
臭美__臭美 307.500011268|chou mei;
抽风__抽風 270.796100963|chou feng;
绸缎__綢緞 105.426930997|chou duan;
抽到__抽到 192.225730308|chou dao;
抽调__抽調 319.213487372|chou diao;
抽动__抽動 161.250795044|chou dong;
抽屉__抽屜 662.561694208|chou ti;
丑女__醜女 320.808632296|chou nv;
酬劳__酬勞 148.519148841|chou lao;
丑陋__醜陋 779.081233415|chou lou;
筹款__籌款 148.149450567|chou kuan;
抽空__抽空 707.799244422|chou kong;
丑化__醜化 155.527421199|chou hua;
筹划__籌劃 468.567137655|chou hua;
仇恨__仇恨 1458.16935282|chou hen;
筹集__籌集 441.361118731|chou ji;
仇家__仇家 128.850255419|chou jia;
抽检__抽檢 312.911829085|chou jian;
筹建__籌建 464.497524783|chou jian;
抽奖__抽獎 513.831666385|chou jiang;
酬金__酬金 127.096048509|chou jin;
抽筋__抽筋 429.960742313|chou jin;
臭气__臭氣 117.93965545|chou qi;
抽泣__抽泣 143.784200776|chou qi;
抽签__抽籤 436.982903472|chou qian;
抽取__抽取 614.828697239|chou qu;
抽血__抽血 186.32942291|chou xue;
抽象__抽象 1217.12027856|chou xiang;
抽着__抽着 120.164975734|chou zhe;
瞅着__瞅着 136.452228303|chou zhe;
抽插__抽插 174.203334854|chou cha;
抽查__抽查 655.989212862|chou cha;
惆怅__惆悵 440.811451858|chou chang;
丑丑__醜醜 132.596773978|chou chou;
瞅瞅__瞅瞅 319.611528482|chou chou;
臭臭__臭臭 426.226434824|chou chou;
臭虫__臭蟲 158.857391092|chou chong;
踌躇__躊躇 134.762357541|chou chu;
抽搐__抽搐 288.205701591|chou chu;
抽出__抽出 860.753904265|chou chu;
抽射__抽射 156.89004718|chou she;
抽身__抽身 154.561368684|chou shen;
仇视__仇視 164.088713397|chou shi;
仇人__仇人 320.409100324|chou ren;
筹资__籌資 362.479927203|chou zi;
筹措__籌措 265.78126155|chou cuo;
抽烟__抽煙 1873.22443719|chou yan;
臭氧__臭氧 175.510734618|chou yang;
抽样__抽樣 347.00988711|chou yang;
丑闻__醜聞 587.855808729|chou wen;
臭味__臭味 292.183578474|chou wei;
丑恶__醜惡 391.596284031|chou e;
崇拜__崇拜 2202.653757|chong bai;
重播__重播 287.846772995|chong bo;
重拍__重拍 157.085680168|chong pai;
冲泡__沖泡 170.551683166|chong pao;
充沛__充沛 429.960742313|chong pei;
冲破__衝破 409.564096466|chong po;
充满__充滿 7368.38247395|chong man;
重名__重名 195.365179853|chong ming;
崇明__崇明 262.817045902|chong ming;
重罚__重罰 121.217779906|chong fa;
重发__重發 350.92368248|chong fa;
重返__重返 680.977550057|chong fan;
充分__充分 7891.11437871|chong fen;
重逢__重逢 351.799391968|chong feng;
冲锋__衝鋒 426.226434824|chong feng;
重复__重複 5296.06498953|chong fu;
冲淡__沖淡 227.160466527|chong dan;
充当__充當 892.429452826|chong dang;
重蹈__重蹈 117.207077876|chong dao;
冲到__衝到 551.657401419|chong dao;
充电__充電 1609.02584897|chong dian;
重叠__重疊 570.534533242|chong die;
冲动__衝動 3290.13465937|chong dong;
重读__重讀 138.85370659|chong du;
充填__充填 110.95347192|chong tian;
冲天__衝天 200.04606951|chong tian;
冲突__衝突 4026.13743678|chong tu;
重来__重來 665.872587905|chong lai;
冲浪__衝浪 336.365750338|chong lang;
冲了__沖了 451.373158744|chong le;
冲凉__沖涼 598.201722298|chong liang;
冲高__沖高 400.978810625|chong gao;
崇高__崇高 759.903909096|chong gao;
重构__重構 421.998352644|chong gou;
重估__重估 175.510734618|chong gu;
冲过__衝過 230.582949765|chong guo;
重开__重開 213.172602547|chong kai;
宠坏__寵壞 113.753550575|chong huai;
充好__充好 140.244908425|chong hao;
重合__重合 243.57916235|chong he;
重回__重回 375.819106356|chong hui;
充饥__充饑 121.217779906|chong ji;
冲剂__沖劑 126.621787068|chong ji;
冲级__沖級 135.267109459|chong ji;
冲击__衝擊 3261.55908656|chong ji;
重建__重建 1795.51445179|chong jian;
冲劲__衝勁 110.677283245|chong jin;
冲进__衝進 592.267679181|chong jin;
崇敬__崇敬 530.091629029|chong jing;
憧憬__憧憬 830.202635471|chong jing;
充气__充氣 305.209408115|chong qi;
重启__重啟 4107.21887886|chong qi;
重庆__重慶 8546.24511901|chong qing;
冲去__衝去 120.615053212|chong qu;
充血__充血 304.449671797|chong xue;
冲洗__沖洗 714.89082038|chong xi;
重现__重現 705.158077415|chong xian;
冲向__沖向 283.574337601|chong xiang;
重写__重寫 401.979429753|chong xie;
重新__重新 17410.1449669|chong xin;
重修__重修 334.276427588|chong xiu;
冲撞__衝撞 204.329220247|chong zhuang;
重装__重裝 1947.00521503|chong zhuang;
冲着__衝著 816.861571886|chong zhe;
崇祯__崇禎 139.72158175|chong zhen;
重振__重振 147.229226029|chong zhen;
重整__重整 187.727829225|chong zheng;
重置__重置 626.429466854|chong zhi;
充值__充值 1961.61753092|chong zhi;
充斥__充斥 745.831342837|chong chi;
冲冲__沖沖 105.821807183|chong chong;
虫虫__蟲蟲 374.41672986|chong chong;
重重__重重 832.274357505|chong chong;
冲出__衝出 548.230802969|chong chu;
冲刷__沖刷 218.552335545|chong shua;
冲上__衝上 336.365750338|chong shang;
崇尚__崇尚 599.694499646|chong shang;
重申__重申 532.077085292|chong shen;
冲绳__沖繩 131.937467932|chong sheng;
重生__重生 534.069978074|chong sheng;
重试__重試 150.944778196|chong shi;
重拾__重拾 203.820597887|chong shi;
充实__充實 1777.70330251|chong shi;
冲入__沖入 187.961915178|chong ru;
重载__重載 189.372573382|chong zai;
虫子__蟲子 1085.28250327|chong zi;
充足__充足 1757.8768636|chong zu;
重组__重組 2952.08591378|chong zu;
重做__重做 285.702569086|chong zuo;
虫草__蟲草 143.784200776|chong cao;
冲刺__衝刺 574.81640715|chong ci;
重塑__重塑 242.36802267|chong su;
冲压__衝壓 161.049974862|chong ya;
重演__重演 357.99085261|chong yan;
重阳__重陽 157.67404401|chong yang;
冲印__沖印 152.647228173|chong yin;
充盈__充盈 152.077621994|chong ying;
重用__重用 313.302012384|chong yong;
充裕__充裕 476.813641365|chong yu;
重温__重溫 470.908619205|chong wen;
冲我__沖我 206.376433771|chong wo;
宠物__寵物 3281.94475852|chong wu;
宠爱__寵愛 532.077085292|chong ai;
宠儿__寵兒 217.736803143|chong er;
除斑__除斑 170.76435144|chu ban;
出版__出版 3816.07460972|chu ban;
储备__儲備 1459.98760728|chu bei;
出兵__出兵 366.568203397|chu bing;
初步__初步 4112.3403478|chu bu;
出牌__出牌 186.561765129|chu pai;
触碰__觸碰 204.839111844|chu peng;
出票__出票 254.438159592|chu piao;
出品__出品 648.673070715|chu pin;
出马__出馬 244.186999878|chu ma;
出卖__出賣 934.541117987|chu mai;
出门__出門 4481.58949458|chu men;
出面__出面 959.320404733|chu mian;
出名__出名 1718.88488289|chu ming;
出没__出沒 333.029068427|chu mo;
触摸__觸摸 889.099334512|chu mo;
触发__觸發 1037.67053575|chu fa;
处罚__處罰 2516.83636014|chu fa;
出发__出發 5678.85377955|chu fa;
触犯__觸犯 356.210827905|chu fan;
出访__出訪 304.829303266|chu fang;
处方__處方 487.62990282|chu fang;
厨房__廚房 2501.20312918|chu fang;
处分__處分 757.068312494|chu fen;
除非__除非 5355.79733551|chu fei;
触到__觸到 123.197520618|chu dao;
初到__初到 150.194241046|chu dao;
出道__出道 598.94764591|chu dao;
出的__出的 899.127155009|chu de;
触点__觸點 132.266710153|chu dian;
触电__觸電 240.263000901|chu dian;
除掉__除掉 276.938965124|chu diao;
初定__初定 120.916041011|chu ding;
出动__出動 681.82669043|chu dong;
触动__觸動 699.033618062|chu dong;
出台__出台 4704.77652327|chu tai;
初探__初探 485.205278648|chu tan;
出逃__出逃 247.249015706|chu tao;
出题__出題 291.093289619|chu ti;
楚天__楚天 152.647228173|chu tian;
出庭__出庭 229.150692759|chu ting;
锄头__鋤頭 155.140277726|chu tou;
出头__出頭 887.99205879|chu tou;
出土__出土 479.793862242|chu tu;
处女__處女 1815.76539105|chu nv;
出纳__出納 320.808632296|chu na;
处男__處男 587.123698784|chu nan;
初年__初年 138.335571213|chu nian;
初来__初來 121.520271774|chu lai;
出来__出來 59118.4110341|chu lai;
出栏__出欄 120.916041011|chu lan;
出了__出了 7498.06163521|chu le;
除了__除了 24283.0731907|chu le;
矗立__矗立 221.568841736|chu li;
出力__出力 384.344361008|chu li;
处理__處理 29715.1941105|chu li;
初恋__初戀 1092.0658276|chu lian;
储量__儲量 500.559372647|chu liang;
出笼__出籠 108.222318063|chu long;
出炉__出爐 928.736252253|chu lu;
出路__出路 1111.28553845|chu lu;
出关__出關 116.915322539|chu guan;
触感__觸感 146.862738669|chu gan;
初稿__初稿 560.667124391|chu gao;
出格__出格 127.572086295|chu ge;
出个__出個 531.41444163|chu ge;
出锅__出鍋 135.94305409|chu guo;
楚国__楚國 262.489736092|chu guo;
出过__出過 510.640021015|chu guo;
出国__出國 3102.96674755|chu guo;
出轨__出軌 632.705783453|chu gui;
橱柜__櫥櫃 731.107734818|chu gui;
出口__出口 8000.02923116|chu kou;
出库__出庫 441.361118731|chu ku;
出海__出海 333.860122955|chu hai;
出汗__出汗 603.442760838|chu han;
储户__儲戶 220.19257551|chu hu;
出乎__出乎 394.043872187|chu hu;
出货__出貨 1861.58897661|chu huo;
处决__處決 148.334184528|chu jue;
触觉__觸覺 157.67404401|chu jue;
触及__觸及 605.702953498|chu ji;
出击__出擊 870.462027204|chu ji;
初级__初級 1319.8108917|chu ji;
出嫁__出嫁 242.36802267|chu jia;
出家__出家 516.399339766|chu jia;
出价__出價 1065.18429118|chu jia;
初见__初見 384.344361008|chu jian;
触角__觸角 202.050369328|chu jiao;
出尽__出盡 122.279808036|chu jin;
出镜__出鏡 157.67404401|chu jing;
出境__出境 475.034401746|chu jing;
处境__處境 803.734894488|chu jing;
厨具__廚具 126.149295342|chu ju;
出局__出局 787.868200695|chu ju;
出具__出具 1318.16721196|chu ju;
除权__除權 288.205701591|chu quan;
出气__出氣 237.287502254|chu qi;
出奇__出奇 520.274927886|chu qi;
初期__初期 2164.55880585|chu qi;
出钱__出錢 950.988487375|chu qian;
出勤__出勤 156.304608838|chu qin;
畜禽__畜禽 409.564096466|chu qin;
初秋__初秋 117.353228453|chu qiu;
除去__除去 4787.57779962|chu qu;
出去__出去 25973.3891884|chu qu;
初选__初選 185.402943996|chu xuan;
初学__初學 215.845709156|chu xue;
出血__出血 1339.6956486|chu xue;
出戏__齣戲 123.504952812|chu xi;
除夕__除夕 245.71323808|chu xi;
出息__出息 527.455873984|chu xi;
出席__出席 3532.33803061|chu xi;
初夏__初夏 189.136730609|chu xia;
初现__初現 110.401782066|chu xian;
出线__出線 639.84183651|chu xian;
出现__出現 43293.4251253|chu xian;
出血__出血 181.742866823|chu xie;
出新__出新 249.726250867|chu xin;
雏形__雛形 292.912705474|chu xing;
出行__出行 1277.73391996|chu xing;
储蓄__儲蓄 1089.34742493|chu xu;
出站__出站 137.991222203|chu zhan;
出战__出戰 282.164331387|chu zhan;
处长__處長 1049.37403554|chu zhang;
出招__出招 168.859844103|chu zhao;
出征__出征 324.426913464|chu zheng;
处置__處置 1311.61293778|chu zhi;
滁州__滁州 118.23396695|chu zhou;
出众__出眾 681.82669043|chu zhong;
初衷__初衷 752.365812175|chu zhong;
初中__初中 3045.50329114|chu zhong;
橱窗__櫥窗 275.905561849|chu chuang;
初春__初春 140.945727665|chu chun;
出差__出差 5643.57980061|chu chai;
出产__出產 250.349428094|chu chan;
出厂__出廠 547.548041623|chu chang;
出场__出場 1744.7822355|chu chang;
除尘__除塵 185.402943996|chu chen;
出城__出城 139.200207879|chu cheng;
出丑__出醜 127.890434962|chu chou;
楚楚__楚楚 219.918349804|chu chu;
处处__處處 1392.46230328|chu chu;
出处__出處 2406.4213017|chu chu;
出山__出山 214.772467501|chu shan;
出神__出神 122.890853693|chu shen;
初审__初審 322.010219858|chu shen;
出身__出身 1723.1742594|chu shen;
畜牲__畜牲 116.044406778|chu sheng;
初生__初生 138.335571213|chu sheng;
出声__出聲 609.488769235|chu sheng;
畜生__畜生 674.222387052|chu sheng;
出生__出生 4687.22055578|chu sheng;
出师__出師 143.605133321|chu shi;
处室__處室 214.772467501|chu shi;
初试__初試 225.749468142|chu shi;
处世__處世 225.749468142|chu shi;
处事__處事 343.567617462|chu shi;
出世__出世 467.983588668|chu shi;
厨师__廚師 756.125466931|chu shi;
出示__出示 781.025384985|chu shi;
出事__出事 1243.1798239|chu shi;
初始__初始 1247.83614939|chu shi;
触手__觸手 106.218162376|chu shou;
出手__出手 2208.15035039|chu shou;
出售__出售 4284.97958628|chu shou;
出书__出書 451.935995467|chu shu;
出水__出水 304.829303266|chu shui;
出让__出讓 727.472474808|chu rang;
出任__出任 918.378206258|chu ren;
出入__出入 1208.05380881|chu ru;
处在__處在 1793.27833544|chu zai;
处子__處子 107.14877401|chu zi;
厨子__廚子 128.209578049|chu zi;
出资__出資 1206.54931027|chu zi;
出自__出自 1309.9794677|chu zi;
出走__出走 335.110594827|chu zou;
出租__出租 1880.24059249|chu zu;
储存__儲存 1212.57856995|chu cun;
出彩__出彩 389.163898974|chu cai;
储藏__儲藏 213.172602547|chu cang;
除此__除此 123.504952812|chu ci;
初次__初次 850.094035423|chu ci;
出错__出錯 2350.1133092|chu cuo;
初赛__初賽 131.609045271|chu sai;
初三__初三 537.40806734|chu san;
出色__出色 3630.51911858|chu se;
处死__處死 205.862715427|chu si;
出院__出院 660.089332023|chu yuan;
储运__儲運 126.621787068|chu yun;
出演__出演 1042.85588961|chu yan;
初夜__初夜 159.452390871|chu ye;
刍议__芻議 110.677283245|chu yi;
厨艺__廚藝 251.914183226|chu yi;
除以__除以 273.509258874|chu yi;
处以__處以 398.985038482|chu yi;
初一__初一 517.043260448|chu yi;
出油__出油 109.716025699|chu you;
出游__出遊 803.734894488|chu you;
出狱__出獄 195.121873946|chu yu;
出于__出於 2959.45267121|chu yu;
处于__處於 8253.1864127|chu yu;
出外__出外 205.60633599|chu wai;
除外__除外 1036.37823089|chu wai;
楚王__楚王 111.507918629|chu wang;
初吻__初吻 187.961915178|chu wen;
厨卫__廚衛 121.066816454|chu wei;
出位__出位 137.819369268|chu wei;
初二__初二 373.950434882|chu er;
绰号__綽號 277.630050085|chuo hao;
辍学__輟學 261.83633885|chuo xue;
吹捧__吹捧 290.368691563|chui peng;
吹风__吹風 236.696839161|chui feng;
吹拂__吹拂 110.677283245|chui fu;
吹得__吹得 230.008975843|chui de;
垂钓__垂釣 176.827946446|chui diao;
吹牛__吹牛 694.691597986|chui niu;
吹来__吹來 140.070248771|chui lai;
锤炼__錘鍊 137.305093541|chui lian;
吹过__吹過 258.916120291|chui guo;
吹起__吹起 140.070248771|chui qi;
垂青__垂青 121.975425508|chui qing;
垂下__垂下 214.504991945|chui xia;
垂涎__垂涎 134.259489114|chui xian;
吹响__吹響 180.839193473|chui xiang;
吹嘘__吹噓 308.267359529|chui xu;
吹着__吹着 202.554574186|chui zhe;
垂直__垂直 1261.91002891|chui zhi;
吹吹__吹吹 173.121277629|chui chui;
吹水__吹水 153.984619852|chui shui;
锤子__鎚子 1212.57856995|chui zi;
炊烟__炊煙 117.646076559|chui yan;
刷屏__刷屏 558.574983827|shua ping;
刷分__刷分 129.655606164|shua fen;
耍赖__耍賴 215.040276584|shua lai;
刷卡__刷卡 812.799921236|shua ka;
刷机__刷機 563.46883971|shua ji;
刷新__刷新 2297.98475873|shua xin;
耍耍__耍耍 115.611384758|shua shua;
刷刷__刷刷 237.287502254|shua shua;
刷子__刷子 268.444174826|shua zi;
刷牙__刷牙 710.450303909|shua ya;
双倍__雙倍 697.293562832|shuang bei;
双臂__雙臂 409.054029297|shuang bi;
双边__雙邊 490.677728407|shuang bian;
双面__雙面 415.734739962|shuang mian;
双敏__雙敏 129.655606164|shuang min;
双模__雙模 145.768741141|shuang mo;
双眸__雙眸 153.028150386|shuang mou;
双目__雙目 264.789493468|shuang mu;
双方__雙方 9692.5236812|shuang fang;
双峰__雙峰 160.249192015|shuang feng;
双飞__雙飛 291.456266438|shuang fei;
双打__雙打 215.576896995|shuang da;
双头__雙頭 146.314717429|shuang tou;
双腿__雙腿 706.037369534|shuang tui;
爽朗__爽朗 239.664931108|shuang lang;
爽了__爽了 298.811606079|shuang le;
双流__雙流 115.036534536|shuang liu;
双龙__雙龍 223.231720645|shuang long;
爽快__爽快 594.486015613|shuang kuai;
双卡__雙卡 120.765453341|shuang ka;
双开__雙開 361.12732612|shuang kai;
爽口__爽口 147.596627936|shuang kou;
双核__雙核 1382.08969051|shuang he;
双汇__雙匯 166.768626413|shuang hui;
双机__雙機 166.560934377|shuang ji;
双击__雙擊 1214.09058664|shuang ji;
双肩__雙肩 172.04594156|shuang jian;
双脚__雙腳 546.185068786|shuang jiao;
双亲__雙親 186.32942291|shuang qin;
双线__雙線 337.625607028|shuang xian;
双向__雙向 894.656458236|shuang xiang;
双星__雙星 161.049974862|shuang xing;
双雄__雙雄 116.769717326|shuang xiong;
双修__雙修 150.381524744|shuang xiu;
双休__雙休 220.742053181|shuang xiu;
双唇__雙唇 164.908682755|shuang chun;
双重__雙重 1344.71347376|shuang chong;
爽爽__爽爽 148.889769675|shuang shuang;
双双__雙雙 741.198640518|shuang shuang;
双手__雙手 3290.13465937|shuang shou;
双人__雙人 466.818670029|shuang ren;
双子__雙子 602.691239054|shuang zi;
双侧__雙側 182.423584067|shuang ce;
双层__雙層 417.291872914|shuang ceng;
双色__雙色 183.106850936|shuang se;
爽死__爽死 145.405889264|shuang si;
双眼__雙眼 1221.67899812|shuang yan;
双赢__雙贏 564.171453387|shuang ying;
双语__雙語 285.346757867|shuang yu;
双鱼__雙魚 375.351064872|shuang yu;
爽啊__爽啊 154.176629937|shuang a;
顺便__順便 5236.9988288|shun bian;
顺发__順發 108.898738333|shun fa;
顺风__順風 360.677581637|shun feng;
顺丰__順豐 472.083744072|shun feng;
顺带__順帶 255.073095111|shun dai;
顺道__順道 169.703655326|shun dao;
顺德__順德 568.405572245|shun de;
舜天__舜天 107.14877401|shun tian;
顺利__順利 6496.96661305|shun li;
顺路__順路 351.361264404|shun lu;
顺口__順口 165.526347625|shun kou;
瞬间__瞬間 3126.25457954|shun jian;
吮吸__吮吸 148.334184528|shun xi;
顺心__順心 311.744192349|shun xin;
顺序__順序 2638.88644361|shun xu;
顺着__順着 1181.25761405|shun zhe;
顺治__順治 130.303509496|shun zhi;
顺祝__順祝 110.815291538|shun zhu;
顺差__順差 270.122027271|shun cha;
顺产__順產 140.945727665|shun chan;
顺畅__順暢 665.872587905|shun chang;
顺驰__順馳 206.119414554|shun chi;
瞬时__瞬時 190.081867665|shun shi;
顺势__順勢 522.223615731|shun shi;
顺手__順手 783.950712715|shun shou;
顺子__順子 170.76435144|shun zi;
顺从__順從 267.109399762|shun cong;
顺延__順延 184.941433485|shun yan;
顺眼__順眼 578.409173188|shun yan;
顺义__順義 215.845709156|shun yi;
顺应__順應 666.702893247|shun ying;
衰败__衰敗 166.560934377|shuai bai;
甩卖__甩賣 161.250795044|shuai mai;
率达__率達 362.479927203|shuai da;
摔倒__摔倒 441.911471008|shuai dao;
甩掉__甩掉 221.568841736|shuai diao;
率队__率隊 112.906187218|shuai dui;
衰退__衰退 538.749137684|shuai tui;
衰老__衰老 645.447697543|shuai lao;
甩了__甩了 248.794392378|shuai le;
摔了__摔了 276.249600432|shuai le;
率领__率領 857.541983893|shuai ling;
衰落__衰落 356.655002599|shuai luo;
帅哥__帥哥 4415.07041785|shuai ge;
甩开__甩開 191.508436159|shuai kai;
衰减__衰減 263.801426189|shuai jian;
摔跤__摔跤 273.509258874|shuai jiao;
衰竭__衰竭 191.031727675|shuai jie;
帅气__帥氣 811.787668067|shuai qi;
摔下__摔下 117.499561272|shuai xia;
率先__率先 1961.61753092|shuai xian;
率性__率性 118.23396695|shuai xing;
率真__率真 125.209594649|shuai zhen;
帅帅__帥帥 229.150692759|shuai shuai;
摔伤__摔傷 107.550099352|shuai shang;
衰弱__衰弱 187.26053154|shuai ruo;
摔在__摔在 129.817279349|shuai zai;
摔死__摔死 185.634130949|shuai si;
煞笔__煞筆 207.407719521|sha bi;
傻逼__傻逼 1836.24473312|sha bi;
纱布__紗布 496.21189989|sha bu;
沙盘__沙盤 117.792774542|sha pan;
傻冒__傻冒 137.476305203|sha mao;
杀灭__殺滅 171.831677206|sha mie;
沙漠__沙漠 1378.64935183|sha mo;
沙发__沙發 4393.11752614|sha fa;
傻蛋__傻蛋 230.008975843|sha dan;
杀到__殺到 175.948711373|sha dao;
杀得__殺得 158.264611567|sha de;
沙地__沙地 121.520271774|sha di;
杀敌__殺敵 123.044091616|sha di;
杀掉__殺掉 559.271495144|sha diao;
杀跌__殺跌 321.208662461|sha die;
杀毒__殺毒 2479.47960733|sha du;
沙滩__沙灘 978.639934443|sha tan;
沙特__沙特 462.187920882|sha te;
莎拉__莎拉 105.295633316|sha la;
沙拉__沙拉 269.449631503|sha la;
傻了__傻了 496.21189989|sha le;
杀了__殺了 1687.0530669|sha le;
沙漏__沙漏 105.821807183|sha lou;
沙龙__沙龍 796.754272909|sha long;
杀戮__殺戮 320.808632296|sha lu;
傻瓜__傻瓜 1822.5663337|sha gua;
杀光__殺光 200.545272755|sha guang;
砂锅__砂鍋 197.814987883|sha guo;
沙皇__沙皇 106.748946222|sha huang;
杀害__殺害 714.000502259|sha hai;
沙河__沙河 207.925293333|sha he;
杀菌__殺菌 511.914293268|sha jun;
杀鸡__殺雞 114.607273411|sha ji;
杀机__殺機 122.279808036|sha ji;
砂浆__砂漿 156.304608838|sha jiang;
杀进__殺進 116.915322539|sha jin;
杀气__殺氣 213.438416689|sha qi;
杀青__殺青 131.773154284|sha qing;
沙丘__沙丘 129.494134325|sha qiu;
纱线__紗線 112.204874836|sha xian;
傻笑__傻笑 478.003501869|sha xiao;
杀猪__殺豬 304.829303266|sha zhu;
纱窗__紗窗 120.164975734|sha chuang;
沙场__沙場 163.272821143|sha chang;
刹车__剎車 932.214830498|sha che;
沙尘__沙塵 178.155043976|sha chen;
沙城__沙城 123.044091616|sha cheng;
杀虫__殺蟲 124.431860131|sha chong;
杀出__殺出 192.465424888|sha chu;
杀杀__殺殺 283.221176861|sha sha;
沙沙__沙沙 291.093289619|sha sha;
莎莎__莎莎 317.230705235|sha sha;
傻傻__傻傻 486.416079992|sha sha;
杀伤__殺傷 209.746993999|sha shang;
砂石__砂石 143.426288875|sha shi;
傻事__傻事 173.121277629|sha shi;
啥时__啥時 399.980682268|sha shi;
啥事__啥事 744.902491688|sha shi;
杀手__殺手 2038.87985164|sha shou;
杀软__殺軟 197.814987883|sha ruan;
杀人__殺人 2904.64693418|sha ren;
杀入__殺入 335.528458728|sha ru;
沙子__沙子 699.905273328|sha zi;
傻子__傻子 1235.45786087|sha zi;
啥子__啥子 3941.74151187|sha zi;
杀死__殺死 1575.29743635|sha si;
沙哑__沙啞 238.176261728|sha ya;
傻眼__傻眼 177.048440864|sha yan;
啥样__啥樣 401.478808454|sha yang;
鲨鱼__鯊魚 462.764242999|sha yu;
晒得__曬得 111.786180106|shai de;
晒干__晒乾 168.649547684|shai gan;
晒黑__晒黑 134.930398555|shai hei;
筛选__篩選 1250.95005139|shai xuan;
筛查__篩查 153.41002317|shai cha;
晒晒__晒晒 190.793818607|shai shai;
山本__山本 115.899886195|shan ben;
陕北__陝北 276.938965124|shan bei;
闪避__閃避 233.183609039|shan bi;
善变__善變 173.553291634|shan bian;
山坡__山坡 504.316081474|shan po;
山脉__山脈 384.823616623|shan mai;
山猫__山貓 108.222318063|shan mao;
山门__山門 107.818484324|shan men;
扇门__扇門 115.611384758|shan men;
山峰__山峰 346.1460998|shan feng;
山大__山大 177.711575153|shan da;
善待__善待 363.837594448|shan dai;
山地__山地 422.52456065|shan di;
闪电__閃電 1065.18429118|shan dian;
删掉__刪掉 1508.06636321|shan diao;
山顶__山頂 805.740567825|shan ding;
闪动__閃動 272.488653616|shan dong;
山洞__山洞 402.982545867|shan dong;
煽动__煽動 482.792710347|shan dong;
山东__山東 5456.85210292|shan dong;
山体__山體 268.109857044|shan ti;
山田__山田 118.529012887|shan tian;
删帖__刪帖 218.552335545|shan tie;
删贴__刪貼 271.810366771|shan tie;
山头__山頭 341.433560596|shan tou;
汕头__汕頭 840.61307342|shan tou;
山峦__山巒 116.333988795|shan luan;
山里__山裡 448.010827873|shan li;
闪亮__閃亮 595.22730595|shan liang;
善良__善良 3095.24275062|shan liang;
山林__山林 428.356335222|shan lin;
山岭__山嶺 110.539446825|shan ling;
山路__山路 660.089332023|shan lu;
闪光__閃光 647.058374454|shan guang;
山高__山高 122.127521944|shan gao;
山歌__山歌 175.292155245|shan ge;
山沟__山溝 129.655606164|shan gou;
山谷__山谷 506.204995518|shan gu;
闪过__閃過 453.063775264|shan guo;
善款__善款 178.377193209|shan kuan;
闪开__閃開 110.677283245|shan kai;
山口__山口 244.796354228|shan kou;
山海__山海 125.209594649|shan hai;
山河__山河 331.786363812|shan he;
善后__善後 262.489736092|shan hou;
山洪__山洪 110.264288753|shan hong;
珊瑚__珊瑚 419.900065808|shan hu;
删减__刪減 191.031727675|shan jian;
山间__山間 210.795122809|shan jian;
山脚__山腳 132.266710153|shan jiao;
山泉__山泉 125.36572391|shan quan;
煽情__煽情 434.268601197|shan qing;
山丘__山丘 231.735198139|shan qiu;
删去__刪去 183.335174792|shan qu;
扇区__扇區 190.318888971|shan qu;
山区__山區 1274.55334676|shan qu;
陕西__陝西 2698.74816577|shan xi;
山西__山西 2883.00988318|shan xi;
山下__山下 623.314694733|shan xia;
闪现__閃現 376.756940916|shan xian;
善心__善心 151.132997772|shan xin;
山庄__山莊 683.528148986|shan zhuang;
山楂__山楂 215.576896995|shan zha;
山寨__山寨 296.585723861|shan zhai;
闪着__閃着 264.130371602|shan zhe;
山镇__山鎮 160.049619219|shan zhen;
山中__山中 335.110594827|shan zhong;
山川__山川 254.438159592|shan chuan;
擅长__擅長 1555.7884176|shan chang;
山城__山城 198.803491145|shan cheng;
闪出__閃出 107.416157498|shan chu;
删除__刪除 10965.1856792|shan chu;
杉杉__杉杉 136.112567367|shan shan;
姗姗__姍姍 200.29551561|shan shan;
珊珊__珊珊 206.376433771|shan shan;
闪闪__閃閃 313.69268222|shan shan;
山上__山上 1368.37963334|shan shang;
山石__山石 123.197520618|shan shi;
善事__善事 171.190483873|shan shi;
膳食__膳食 311.355949144|shan shi;
闪烁__閃爍 1066.51251556|shan shuo;
山水__山水 1181.25761405|shan shui;
山人__山人 174.42055653|shan ren;
闪人__閃人 558.574983827|shan ren;
山贼__山賊 139.72158175|shan zei;
扇子__扇子 402.480675297|shan zi;
擅自__擅自 1037.67053575|shan zi;
山村__山村 394.043872187|shan cun;
闪存__閃存 398.48814637|shan cun;
山崖__山崖 140.419785869|shan ya;
赡养__贍養 183.106850936|shan yang;
山羊__山羊 345.715012791|shan yang;
山药__山藥 215.576896995|shan yao;
闪耀__閃耀 459.317058623|shan yao;
山野__山野 330.136634719|shan ye;
善意__善意 704.279880358|shan yi;
善用__善用 178.59961945|shan yong;
山芋__山芋 112.765574943|shan yu;
善于__善於 2082.53394472|shan yu;
汕尾__汕尾 127.413209251|shan wei;
善恶__善惡 335.528458728|shan e;
伤疤__傷疤 386.746622582|shang ba;
上百__上百 509.368920718|shang bai;
上班__上班 21869.687522|shang ban;
上榜__上榜 457.603107852|shang bang;
商报__商報 223.788782324|shang bao;
上报__上報 1901.44712636|shang bao;
伤悲__傷悲 238.770616634|shang bei;
上边__上邊 680.977550057|shang bian;
商标__商標 2106.02207003|shang biao;
伤病__傷病 439.714170908|shang bing;
上部__上部 454.760723981|shang bu;
上牌__上牌 195.60878915|shang pai;
上皮__上皮 181.064689688|shang pi;
上品__上品 157.870654598|shang pin;
商品__商品 8938.37685157|shang pin;
上坡__上坡 136.963309627|shang po;
上铺__上鋪 218.008308584|shang pu;
商铺__商鋪 949.804135501|shang pu;
上马__上馬 437.527796363|shang ma;
商贸__商貿 837.47630896|shang mao;
上门__上門 2332.60704332|shang men;
上面__上面 19794.5812904|shang mian;
商贩__商販 220.467143161|shang fan;
上访__上訪 669.200026501|shang fang;
上方__上方 1271.38069074|shang fang;
伤风__傷風 106.218162376|shang feng;
上风__上風 203.313241605|shang feng;
上浮__上浮 257.3078729|shang fu;
上端__上端 118.972962872|shang duan;
尚待__尚待 126.779677253|shang dai;
上当__上當 870.462027204|shang dang;
上岛__上島 121.975425508|shang dao;
伤到__傷到 166.146325956|shang dao;
上到__上到 186.561765129|shang dao;
上的__上的 17540.8084783|shang de;
上地__上地 254.755429543|shang di;
上帝__上帝 3951.57789686|shang di;
上电__上電 122.432284019|shang dian;
商店__商店 2148.43475692|shang dian;
上调__上調 168.229740225|shang diao;
上吊__上吊 239.068350048|shang diao;
商定__商定 276.249600432|shang ding;
上都__上都 432.648119245|shang dou;
上都__上都 205.60633599|shang du;
上台__上台 924.118331259|shang tai;
商谈__商談 347.875829952|shang tan;
商讨__商討 443.014235191|shang tao;
上天__上天 1191.60699362|shang tian;
上调__上調 1104.38283164|shang tiao;
伤透__傷透 119.716577729|shang tou;
上头__上頭 274.191785204|shang tou;
上投__上投 328.904723278|shang tou;
伤痛__傷痛 649.481929235|shang tong;
上图__上圖 2321.00870739|shang tu;
上哪__上哪 136.112567367|shang na;
尚能__尚能 105.953760973|shang neng;
上年__上年 489.456318842|shang nian;
上轮__上輪 130.954650472|shang lun;
商旅__商旅 157.67404401|shang lv;
上来__上來 8949.52250043|shang lai;
上篮__上籃 296.585723861|shang lan;
上了__上了 4464.86635394|shang le;
上联__上聯 195.60878915|shang lian;
商量__商量 3787.64822853|shang liang;
上楼__上樓 480.991159713|shang lou;
上路__上路 908.135681884|shang lu;
上官__上官 472.67240572|shang guan;
上盖__上蓋 153.218967809|shang gai;
伤感__傷感 1494.96846157|shang gan;
上岗__上崗 560.667124391|shang gang;
上个__上個 1540.35530331|shang ge;
上钩__上鉤 162.258658377|shang gou;
上攻__上攻 404.996293994|shang gong;
上古__上古 259.562230298|shang gu;
上过__上過 660.089332023|shang guo;
上看__上看 1742.60930056|shang kan;
商科__商科 125.835280772|shang ke;
尚可__尚可 298.439468992|shang ke;
上课__上課 6464.66198571|shang ke;
伤口__傷口 1461.808129|shang kou;
上空__上空 665.872587905|shang kong;
上画__上畫 116.044406778|shang hua;
赏花__賞花 117.353228453|shang hua;
上还__上還 393.553133755|shang hai;
伤害__傷害 8212.14939846|shang hai;
上海__上海 46654.5644793|shang hai;
伤寒__傷寒 107.14877401|shang han;
上航__上航 114.607273411|shang hang;
商行__商行 361.577631409|shang hang;
商号__商號 116.769717326|shang hao;
上好__上好 164.703307075|shang hao;
伤痕__傷痕 486.416079992|shang hen;
商户__商戶 721.154209805|shang hu;
上火__上火 716.674788535|shang huo;
上回__上回 453.063775264|shang hui;
商会__商會 758.012333731|shang hui;
伤及__傷及 147.045868173|shang ji;
上机__上機 314.475483928|shang ji;
商机__商機 1311.61293778|shang ji;
上级__上級 2261.05695403|shang ji;
上家__上家 107.14877401|shang jia;
上佳__上佳 117.499561272|shang jia;
上加__上加 253.804804573|shang jia;
上架__上架 420.423657369|shang jia;
商家__商家 3449.68464686|shang jia;
商检__商檢 186.794397067|shang jian;
上缴__上繳 364.291279287|shang jiao;
上交__上交 532.077085292|shang jiao;
上将__上將 249.726250867|shang jiang;
上讲__上講 665.043316617|shang jiang;
上届__上屆 288.565077751|shang jie;
商界__商界 397.496217848|shang jie;
上街__上街 741.198640518|shang jie;
赏金__賞金 163.680258901|shang jin;
上进__上進 394.043872187|shang jin;
上镜__上鏡 151.699065864|shang jing;
上就__上就 185.86560618|shang jiu;
商圈__商圈 498.691525358|shang quan;
上却__上卻 171.190483873|shang que;
商榷__商榷 254.755429543|shang que;
商祺__商祺 119.41857567|shang qi;
上期__上期 222.398727024|shang qi;
上汽__上汽 384.344361008|shang qi;
上千__上千 561.366244489|shang qian;
上前__上前 890.207990943|shang qian;
尚且__尚且 294.376422496|shang qie;
伤情__傷情 173.986383704|shang qing;
商丘__商丘 144.322743975|shang qiu;
上去__上去 8315.12675373|shang qu;
上学__上學 3976.27638265|shang xue;
上旬__上旬 112.906187218|shang xun;
赏析__賞析 239.664931108|shang xi;
上下__上下 3532.33803061|shang xia;
上限__上限 1277.73391996|shang xian;
上线__上線 5165.70071998|shang xian;
上校__上校 200.04606951|shang xiao;
上写__上寫 277.630050085|shang xie;
上心__上心 127.254530072|shang xin;
伤心__傷心 4829.52331536|shang xin;
上行__上行 799.738513132|shang xing;
尚需__尚需 193.90988203|shang xu;
上装__上裝 118.676811842|shang zhuang;
商战__商戰 109.716025699|shang zhan;
上站__上站 264.789493468|shang zhan;
上涨__上漲 7479.39723763|shang zhang;
伤者__傷者 353.117055307|shang zhe;
上阵__上陣 473.851932013|shang zhen;
上证__上證 525.487661863|shang zheng;
上至__上至 106.085879302|shang zhi;
上肢__上肢 125.678566729|shang zhi;
上周__上周 3323.09914758|shang zhou;
上桌__上桌 118.972962872|shang zhuo;
上船__上船 153.601316766|shang chuan;
上传__上傳 5902.52705689|shang chuan;
上床__上床 1348.06912745|shang chuang;
上场__上場 1009.60853723|shang chang;
商场__商場 2840.21811123|shang chang;
上车__上車 1274.55334676|shang che;
上乘__上乘 191.269933402|shang cheng;
商城__商城 1309.9794677|shang cheng;
上冲__上沖 121.066816454|shang chong;
商厦__商廈 214.772467501|shang sha;
上山__上山 662.561694208|shang shan;
上上__上上 300.679263607|shang shang;
伤身__傷身 128.209578049|shang shen;
上身__上身 545.504855178|shang shen;
上升__上升 6931.91458633|shang sheng;
上师__上師 163.069482749|shang shi;
赏识__賞識 302.935867929|shang shi;
伤势__傷勢 382.433299725|shang shi;
上市__上市 9887.71915322|shang shi;
上手__上手 579.852559389|shang shou;
尚属__尚屬 153.601316766|shang shu;
上书__上書 242.670241844|shang shu;
尚书__尚書 269.449631503|shang shu;
上述__上述 7304.38638512|shang shu;
上说__上說 921.81798848|shang shuo;
上饶__上饒 135.098649108|shang rao;
伤人__傷人 510.004074866|shang ren;
上任__上任 699.033618062|shang ren;
商人__商人 2074.76292775|shang ren;
上载__上載 193.427195796|shang zai;
尚在__尚在 278.322859608|shang zai;
上做__上做 155.527421199|shang zuo;
尚存__尚存 154.754097942|shang cun;
上菜__上菜 116.915322539|shang cai;
伤残__傷殘 271.133768339|shang can;
上苍__上蒼 159.253810404|shang cang;
上策__上策 109.442917312|shang ce;
上层__上層 671.706512759|shang ceng;
赏赐__賞賜 140.070248771|shang ci;
上次__上次 15524.2879811|shang ci;
上色__上色 141.650048976|shang se;
上司__上司 936.87321059|shang si;
上诉__上訴 749.558344131|shang su;
伤员__傷員 346.577724349|shang yuan;
赏月__賞月 179.045304336|shang yue;
上月__上月 598.94764591|shang yue;
上演__上演 1706.08071057|shang yan;
上扬__上揚 1046.76190254|shang yang;
上也__上也 835.391638074|shang ye;
商业__商業 8346.27103065|shang ye;
上亿__上億 193.668388536|shang yi;
商议__商議 394.043872187|shang yi;
上一__上一 595.969520633|shang yi;
上衣__上衣 748.624851411|shang yi;
上瘾__上癮 518.333511609|shang yin;
上映__上映 1179.78648723|shang ying;
商友__商友 116.47905068|shang you;
尚有__尚有 470.908619205|shang you;
上游__上游 995.863416846|shang you;
上有__上有 2712.23410734|shang you;
商用__商用 879.183352683|shang yong;
伤愈__傷愈 115.323601467|shang yu;
上虞__上虞 117.646076559|shang yu;
上万__上萬 408.035799866|shang wan;
伤亡__傷亡 639.84183651|shang wang;
上网__上網 15935.9132976|shang wang;
上文__上文 194.393772779|shang wen;
上尉__上尉 176.827946446|shang wei;
上位__上位 205.862715427|shang wei;
尚未__尚未 3648.66122213|shang wei;
尚无__尚無 415.734739962|shang wu;
商务__商務 6795.07025259|shang wu;
上午__上午 10354.2975666|shang wu;
上岸__上岸 291.456266438|shang an;
哨兵__哨兵 146.314717429|shao bing;
烧饼__燒餅 309.036622663|shao bing;
烧饭__燒飯 220.19257551|shao fan;
少妇__少婦 666.702893247|shao fu;
稍大__稍大 186.097370046|shao da;
烧得__燒得 156.304608838|shao de;
稍等__稍等 3348.03907796|shao deng;
少点__少點 313.302012384|shao dian;
烧掉__燒掉 219.37092252|shao diao;
少女__少女 2915.52627868|shao nv;
少男__少男 113.895394799|shao nan;
少年__少年 3598.9872288|shao nian;
少来__少來 345.284462654|shao lai;
少量__少量 1577.26174289|shao liang;
少林__少林 463.919044053|shao lin;
烧录__燒錄 126.621787068|shao lu;
韶关__韶關 322.411748334|shao guan;
稍高__稍高 124.122120652|shao gao;
烧开__燒開 213.971039752|shao kai;
烧烤__燒烤 1250.95005139|shao kao;
烧坏__燒壞 125.678566729|shao huai;
稍后__稍後 812.799921236|shao hou;
烧毁__燒毀 295.847453874|shao hui;
烧鸡__燒雞 130.628674269|shao ji;
稍加__稍加 198.308623594|shao jia;
少见__少見 934.541117987|shao jian;
烧焦__燒焦 125.209594649|shao jiao;
少将__少將 381.957020988|shao jiang;
烧结__燒結 178.59961945|shao jie;
烧钱__燒錢 270.796100963|shao qian;
稍显__稍顯 169.492308033|shao xian;
少校__少校 136.282292017|shao xiao;
烧香__燒香 468.567137655|shao xiang;
少些__少些 185.402943996|shao xie;
绍兴__紹興 967.72532071|shao xing;
少许__少許 867.213880777|shao xu;
烧纸__燒紙 110.677283245|shao zhi;
烧制__燒制 118.08671951|shao zhi;
烧成__燒成 118.529012887|shao cheng;
少吃__少吃 582.750146437|shao chi;
韶山__韶山 132.927661458|shao shan;
烧伤__燒傷 329.725485744|shao shang;
少少__少少 189.845141544|shao shao;
稍稍__稍稍 749.558344131|shao shao;
少数__少數 2439.63524442|shao shu;
少说__少說 309.036622663|shao shuo;
烧水__燒水 138.85370659|shao shui;
烧热__燒熱 127.890434962|shao re;
少则__少則 129.332863581|shao ze;
勺子__勺子 266.444503116|shao zi;
稍作__稍作 156.109948588|shao zuo;
烧菜__燒菜 135.435779871|shao cai;
烧死__燒死 179.268563673|shao si;
邵阳__邵陽 170.127140854|shao yang;
芍药__芍藥 106.483223576|shao yao;
少爷__少爺 793.781168439|shao ye;
少有__少有 691.237408589|shao you;
稍有__稍有 753.303969661|shao you;
少用__少用 194.878871049|shao yong;
少于__少於 647.058374454|shao yu;
稍微__稍微 4681.38313658|shao wei;
少儿__少兒 415.216987933|shao er;
社保__社保 1176.84972769|she bao;
设备__設備 16338.0801689|she bei;
射频__射頻 342.712398751|she pin;
射门__射門 970.140222547|she men;
赦免__赦免 105.953760973|she mian;
社名__社名 198.803491145|she ming;
设法__設法 513.831666385|she fa;
设防__設防 196.586267794|she fang;
舍得__捨得 1318.16721196|she de;
射雕__射鵰 205.094534596|she diao;
设定__設定 4138.04364463|she ding;
社团__社團 1061.20953474|she tuan;
舌苔__舌苔 131.117943492|she tai;
舌头__舌頭 1309.9794677|she tou;
涉农__涉農 192.225730308|she nong;
社论__社論 187.26053154|she lun;
舍利__舍利 110.539446825|she li;
设立__設立 4769.71285751|she li;
涉猎__涉獵 142.535402072|she lie;
社科__社科 153.028150386|she ke;
蛇口__蛇口 196.831399718|she kou;
奢华__奢華 632.705783453|she hua;
社会__社會 31390.0143002|she hui;
射击__射擊 993.38448407|she ji;
涉及__涉及 7620.52071577|she ji;
设计__設計 36001.7712793|she ji;
射箭__射箭 189.136730609|she jian;
舌尖__舌尖 195.365179853|she jian;
社交__社交 668.366611253|she jiao;
射精__射精 441.361118731|she jing;
社群__社群 147.229226029|she qun;
舍弃__捨棄 465.076726846|she qi;
奢求__奢求 165.32020271|she qiu;
设区__設區 122.737806611|she qu;
摄取__攝取 401.478808454|she qu;
社区__社區 10149.8912754|she qu;
设下__設下 116.915322539|she xia;
设限__設限 137.819369268|she xian;
射线__射線 336.365750338|she xian;
涉嫌__涉嫌 1691.26300898|she xian;
摄像__攝像 649.481929235|she xiang;
设想__設想 1359.87999657|she xiang;
社长__社長 557.184562398|she zhang;
摄制__攝製 130.791560815|she zhi;
设置__設置 20067.7903452|she zhi;
设成__設成 174.42055653|she cheng;
射程__射程 273.168633085|she cheng;
奢侈__奢侈 1193.09285994|she chi;
射出__射出 279.713669565|she chu;
射杀__射殺 112.484875527|she sha;
舍身__捨身 132.266710153|she shen;
设施__設施 4081.70704886|she shi;
射手__射手 816.861571886|she shou;
摄入__攝入 578.409173188|she ru;
设在__設在 903.620192345|she zai;
涉足__涉足 558.574983827|she zu;
社员__社員 263.801426189|she yuan;
摄影__攝影 3273.77524422|she ying;
舍友__舍友 220.19257551|she you;
设有__設有 1285.72012038|she you;
舍瓦__舍瓦 198.555903198|she wa;
涉外__涉外 394.043872187|she wai;
奢望__奢望 524.179602378|she wang;
设为__設為 576.250827814|she wei;
涉案__涉案 443.56664881|she an;
申办__申辦 417.812212206|shen ban;
申报__申報 2970.53729039|shen bao;
身边__身邊 10708.6106595|shen bian;
深表__深表 243.882891747|shen biao;
神兵__神兵 135.773751924|shen bing;
肾病__腎病 186.32942291|shen bing;
深部__深部 111.230349808|shen bu;
审判__審判 1454.53963438|shen pan;
身旁__身旁 931.053859154|shen pang;
身披__身披 125.522047856|shen pi;
审批__審批 3825.59740032|shen pi;
神码__神碼 206.119414554|shen ma;
深埋__深埋 146.679837233|shen mai;
什么__什麼 295403.827699|shen me;
审美__審美 1349.75009317|shen mei;
神秘__神秘 3854.30859085|shen mi;
神庙__神廟 464.497524783|shen miao;
神明__神明 151.510141313|shen ming;
申明__申明 382.910172354|shen ming;
神魔__神魔 109.442917312|shen mo;
身分__身分 234.933657026|shen fen;
身份__身份 6803.54331971|shen fen;
神父__神父 223.788782324|shen fu;
身段__身段 210.270405333|shen duan;
伸到__伸到 164.088713397|shen dao;
深得__深得 300.679263607|shen de;
神殿__神殿 262.817045902|shen dian;
神雕__神鵰 173.986383704|shen diao;
审定__審定 446.895626023|shen ding;
深度__深度 2749.66894397|shen du;
甚多__甚多 184.71110921|shen duo;
神态__神態 390.621510938|shen tai;
神探__神探 120.314814642|shen tan;
身体__身體 18163.657204|shen ti;
渗透__滲透 1370.08592511|shen tou;
神童__神童 212.907119447|shen tong;
神通__神通 213.704562287|shen tong;
深南__深南 107.684208225|shen nan;
神农__神農 136.622376491|shen nong;
申论__申論 176.827946446|shen lun;
神来__神來 299.557272934|shen lai;
深蓝__深藍 462.764242999|shen lan;
神力__神力 130.46599058|shen li;
审理__審理 810.776675547|shen li;
神灵__神靈 260.859291326|shen ling;
申领__申領 281.111429553|shen ling;
神六__神六 143.247667161|shen liu;
渗漏__滲漏 173.769702743|shen lou;
神龙__神龍 353.557372243|shen long;
深感__深感 506.83620443|shen gan;
深港__深港 125.522047856|shen gang;
审稿__審稿 162.258658377|shen gao;
身高__身高 1845.42065012|shen gao;
申购__申購 1913.33171172|shen gou;
神功__神功 199.548108896|shen gong;
深刻__深刻 5070.03774893|shen ke;
神化__神化 122.890853693|shen hua;
神华__神華 242.972837869|shen hua;
申花__申花 670.869975958|shen hua;
深化__深化 1721.02823483|shen hua;
神话__神話 1973.87819843|shen hua;
身患__身患 168.020228531|shen huan;
深海__深海 378.168082664|shen hai;
审核__審核 4914.52006126|shen he;
深厚__深厚 1125.22065338|shen hou;
身后__身後 2473.3076131|shen hou;
甚或__甚或 154.176629937|shen huo;
审计__審計 3145.79455985|shen ji;
身家__身家 244.796354228|shen jia;
身价__身價 751.428823061|shen jia;
神剑__神劍 115.179978568|shen jian;
身兼__身兼 140.594881376|shen jian;
伸进__伸進 196.831399718|shen jin;
神经__神經 3281.94475852|shen jing;
深究__深究 153.792848894|shen jiu;
神起__神起 133.758497151|shen qi;
神器__神器 199.299593609|shen qi;
神气__神氣 222.121753798|shen qi;
神奇__神奇 2712.23410734|shen qi;
深浅__深淺 234.64107292|shen qian;
身前__身前 239.963779681|shen qian;
深切__深切 492.515560049|shen qie;
神情__神情 1168.08323794|shen qing;
深情__深情 1168.08323794|shen qing;
申请__申請 20988.5710258|shen qing;
深秋__深秋 274.191785204|shen qiu;
身躯__身軀 560.667124391|shen qu;
神学__神學 178.377193209|shen xue;
审讯__審訊 287.846772995|shen xun;
深吸__深吸 127.572086295|shen xi;
身下__身下 247.557321202|shen xia;
身陷__身陷 156.304608838|shen xian;
深陷__深陷 281.111429553|shen xian;
神仙__神仙 1431.1656954|shen xian;
神像__神像 161.451865638|shen xiang;
伸向__伸向 242.066179876|shen xiang;
深信__深信 236.107646363|shen xin;
身心__身心 1243.1798239|shen xin;
身形__身形 338.468131949|shen xing;
肾虚__腎虛 205.350275845|shen xu;
伸展__伸展 373.950434882|shen zhan;
伸张__伸張 126.779677253|shen zhang;
深圳__深圳 17475.3546014|shen zhen;
深证__深證 248.484546245|shen zheng;
神志__神志 154.947067523|shen zhi;
伸直__伸直 206.89143407|shen zhi;
深知__深知 467.983588668|shen zhi;
甚至__甚至 22901.6670866|shen zhi;
神州__神州 582.024395035|shen zhou;
神舟__神舟 833.312156414|shen zhou;
深重__深重 160.649084484|shen zhong;
慎重__慎重 1058.56794047|shen zhong;
身着__身着 498.691525358|shen zhuo;
身穿__身穿 627.992684885|shen chuan;
审查__審查 2868.67479953|shen cha;
伸长__伸長 136.622376491|shen chang;
深沉__深沉 748.624851411|shen chen;
申城__申城 150.569041974|shen cheng;
渗出__滲出 261.184568064|shen chu;
身处__身處 616.362966229|shen chu;
伸出__伸出 1221.67899812|shen chu;
深处__深處 2121.82781083|shen chu;
神山__神山 108.898738333|shen shan;
深山__深山 320.409100324|shen shan;
身上__身上 13169.6084966|shen shang;
甚少__甚少 207.407719521|shen shao;
婶婶__嬸嬸 164.498187167|shen shen;
审慎__審慎 228.011295226|shen shen;
深深__深深 3621.48192263|shen shen;
神圣__神聖 1424.04956302|shen sheng;
深市__深市 190.556205829|shen shi;
甚是__甚是 257.62872122|shen shi;
身世__身世 365.655730945|shen shi;
绅士__紳士 615.595353746|shen shi;
审视__審視 737.513205869|shen shi;
神兽__神獸 164.908682755|shen shou;
身手__身手 251.914183226|shen shou;
深受__深受 1136.49445424|shen shou;
伸手__伸手 1341.36617307|shen shou;
渗水__滲水 109.989815613|shen shui;
深水__深水 247.249015706|shen shui;
神人__神人 200.545272755|shen ren;
渗入__滲入 337.625607028|shen ru;
深入__深入 6906.0480087|shen ru;
身在__身在 638.24912322|shen zai;
肾脏__腎臟 453.628720089|shen zang;
深造__深造 365.655730945|shen zao;
身姿__身姿 166.97657743|shen zi;
身子__身子 1942.15867186|shen zi;
神族__神族 107.282382453|shen zu;
神采__神采 127.890434962|shen cai;
身材__身材 3927.03282475|shen cai;
深藏__深藏 188.196293023|shen cang;
深层__深層 673.382717005|shen ceng;
深色__深色 357.99085261|shen se;
神色__神色 610.248767154|shen se;
神似__神似 139.026849285|shen si;
深思__深思 377.226735448|shen si;
神速__神速 178.59961945|shen su;
申诉__申訴 798.742526514|shen su;
伸缩__伸縮 192.705418355|shen suo;
深邃__深邃 447.452879516|shen sui;
甚远__甚遠 192.705418355|shen yuan;
深渊__深淵 753.303969661|shen yuan;
深远__深遠 856.474009391|shen yuan;
审阅__審閱 441.911471008|shen yue;
身孕__身孕 113.046974828|shen yun;
神韵__神韻 252.85772688|shen yun;
肾炎__腎炎 141.826678552|shen yan;
沈阳__瀋陽 1891.99263098|shen yang;
深夜__深夜 1309.9794677|shen ye;
神医__神醫 116.044406778|shen yi;
深意__深意 198.06165195|shen yi;
审议__審議 1459.98760728|shen yi;
呻吟__呻吟 722.953807881|shen yin;
身影__身影 1891.99263098|shen ying;
神游__神遊 207.925293333|shen you;
深有__深有 245.71323808|shen you;
慎用__慎用 163.884358899|shen yong;
神勇__神勇 165.114314527|shen yong;
神往__神往 126.306596357|shen wang;
身亡__身亡 631.130833438|shen wang;
审问__審問 146.497163581|shen wen;
甚为__甚為 184.251320835|shen wei;
身为__身為 1305.09125317|shen wei;
深爱__深愛 659.267263146|shen ai;
深谙__深諳 135.773751924|shen an;
申奥__申奧 141.826678552|shen ao;
深奥__深奧 417.291872914|shen ao;
生病__生病 2038.87985164|sheng bing;
声波__聲波 148.519148841|sheng bo;
生怕__生怕 656.807194196|sheng pa;
生平__生平 417.812212206|sheng ping;
生猛__生猛 153.41002317|sheng meng;
声名__聲名 197.076837307|sheng ming;
盛名__盛名 198.308623594|sheng ming;
声明__聲明 3792.371211|sheng ming;
生命__生命 13791.0516163|sheng ming;
生母__生母 106.350610398|sheng mu;
圣母__聖母 201.79873775|sheng mu;
生发__生髮 119.716577729|sheng fa;
剩饭__剩飯 133.093414711|sheng fan;
省份__省份 964.114234362|sheng fen;
升幅__升幅 219.37092252|sheng fu;
胜负__勝負 722.953807881|sheng fu;
盛大__盛大 1664.08500884|sheng da;
声带__聲帶 133.925286409|sheng dai;
圣诞__聖誕 1309.9794677|sheng dan;
省道__省道 122.584950132|sheng dao;
声道__聲道 401.979429753|sheng dao;
升到__升到 430.496878967|sheng dao;
生得__生得 116.769717326|sheng de;
省得__省得 470.908619205|sheng de;
胜地__勝地 218.824857909|sheng di;
圣地__聖地 401.979429753|sheng di;
圣殿__聖殿 151.321452046|sheng dian;
盛典__盛典 251.287110964|sheng dian;
省电__省電 295.847453874|sheng dian;
声调__聲調 184.71110921|sheng diao;
生动__生動 1474.61550226|sheng dong;
生态__生態 2981.66342698|sheng tai;
盛唐__盛唐 128.689786556|sheng tang;
声讨__聲討 281.812926654|sheng tao;
升腾__升騰 135.773751924|sheng teng;
升天__升天 152.647228173|sheng tian;
省厅__省廳 147.596627936|sheng ting;
圣女__聖女 189.136730609|sheng nv;
省内__省內 769.432826682|sheng nei;
省略__省略 520.274927886|sheng lue;
胜率__勝率 175.948711373|sheng lv;
生来__生來 225.187525865|sheng lai;
省力__省力 214.772467501|sheng li;
省里__省里 260.534419685|sheng li;
生理__生理 1949.43302008|sheng li;
胜利__勝利 4640.72425221|sheng li;
圣灵__聖靈 176.827946446|sheng ling;
生灵__生靈 186.794397067|sheng ling;
生路__生路 116.769717326|sheng lu;
升官__陞官 188.665925845|sheng guan;
圣光__聖光 168.859844103|sheng guang;
升高__升高 1156.49608257|sheng gao;
笙歌__笙歌 110.264288753|sheng ge;
升格__升格 148.889769675|sheng ge;
生根__生根 169.915266157|sheng gen;
胜过__勝過 504.316081474|sheng guo;
盛况__盛況 194.393772779|sheng kuang;
声卡__聲卡 1082.58098585|sheng ka;
盛开__盛開 583.476802811|sheng kai;
牲口__牲口 170.551683166|sheng kou;
升空__升空 205.862715427|sheng kong;
升华__升華 657.626195507|sheng hua;
生化__生化 718.463208478|sheng hua;
生还__生還 128.209578049|sheng huan;
圣火__聖火 422.52456065|sheng huo;
生活__生活 46770.9882114|sheng huo;
省会__省會 335.110594827|sheng hui;
盛会__盛會 605.702953498|sheng hui;
升技__升技 110.401782066|sheng ji;
生计__生計 401.979429753|sheng ji;
生机__生機 569.114341748|sheng ji;
省级__省級 2033.8046114|sheng ji;
升级__升級 13705.3890367|sheng ji;
升降__升降 303.313611771|sheng jiang;
生姜__生薑 391.108593802|sheng jiang;
圣洁__聖潔 335.946843682|sheng jie;
生津__生津 106.085879302|sheng jin;
圣经__聖經 762.750126416|sheng jing;
省局__省局 265.78126155|sheng ju;
圣骑__聖騎 233.474375771|sheng qi;
升起__升起 758.012333731|sheng qi;
生气__生氣 6289.83642321|sheng qi;
升迁__升遷 214.2378495|sheng qian;
生前__生前 789.834279627|sheng qian;
省钱__省錢 1048.06715525|sheng qian;
盛情__盛情 165.32020271|sheng qing;
省去__省去 277.976239008|sheng qu;
省区__省區 325.236501817|sheng qu;
声学__聲學 120.615053212|sheng xue;
升学__升學 250.661599628|sheng xue;
生息__生息 128.850255419|sheng xi;
升息__升息 169.915266157|sheng xi;
盛夏__盛夏 314.475483928|sheng xia;
省下__省下 357.099731154|sheng xia;
生下__生下 505.574572707|sheng xia;
剩下__剩下 4835.54545696|sheng xia;
声线__聲線 162.86639759|sheng xian;
圣贤__聖賢 208.964318904|sheng xian;
生肖__生肖 376.287731462|sheng xiao;
生效__生效 1382.08969051|sheng xiao;
声响__聲響 544.825488702|sheng xiang;
省心__省心 348.309611377|sheng xin;
生性__生性 261.83633885|sheng xing;
盛行__盛行 589.322768456|sheng xing;
生锈__生鏽 219.097720093|sheng xiu;
盛装__盛裝 216.384339476|sheng zhuang;
圣战__聖戰 148.149450567|sheng zhan;
省长__省長 1139.33050957|sheng zhang;
生长__生長 3076.0167709|sheng zhang;
生者__生者 129.494134325|sheng zhe;
胜者__勝者 141.473639374|sheng zhe;
圣旨__聖旨 124.122120652|sheng zhi;
省直__省直 203.313241605|sheng zhi;
升职__升職 291.093289619|sheng zhi;
生殖__生殖 330.960471347|sheng zhi;
升至__升至 404.491915522|sheng zhi;
升值__升值 1976.33951256|sheng zhi;
声中__聲中 415.216987933|sheng zhong;
生猪__生豬 582.024395035|sheng zhu;
盛传__盛傳 176.168109435|sheng chuan;
盛产__盛產 230.295783987|sheng chan;
生产__生產 21014.7425831|sheng chan;
声场__聲場 141.29744947|sheng chang;
生辰__生辰 108.222318063|sheng chen;
省城__省城 315.260239073|sheng cheng;
声称__聲稱 1205.04668542|sheng cheng;
生成__生成 5443.2687447|sheng cheng;
生吃__生吃 165.939408926|sheng chi;
牲畜__牲畜 259.885889675|sheng chu;
胜出__勝出 467.400766428|sheng chu;
生出__生出 531.41444163|sheng chu;
省省__省省 115.179978568|sheng sheng;
声声__聲聲 227.160466527|sheng sheng;
生生__生生 319.213487372|sheng sheng;
省时__省時 107.416157498|sheng shi;
升势__升勢 131.937467932|sheng shi;
盛事__盛事 187.027319083|sheng shi;
声势__聲勢 242.066179876|sheng shi;
省事__省事 397.001179899|sheng shi;
盛世__盛世 645.447697543|sheng shi;
省市__省市 1128.02857559|sheng shi;
省属__省屬 153.601316766|sheng shu;
生疏__生疏 201.296414343|sheng shu;
升任__升任 141.29744947|sheng ren;
生人__生人 219.37092252|sheng ren;
胜任__勝任 569.114341748|sheng ren;
圣人__聖人 660.912425973|sheng ren;
生日__生日 6282.00312169|sheng ri;
升入__升入 140.945727665|sheng ru;
生在__生在 359.331706043|sheng zai;
盛赞__盛讚 148.519148841|sheng zan;
生子__生子 388.195180646|sheng zi;
绳子__繩子 772.314734527|sheng zi;
生存__生存 4859.70920973|sheng cun;
生菜__生菜 160.849404779|sheng cai;
胜算__勝算 184.481071779|sheng suan;
声色__聲色 149.633788238|sheng se;
生死__生死 1536.52100517|sheng si;
胜诉__勝訴 215.576896995|sheng su;
绳索__繩索 229.722524886|sheng suo;
声援__聲援 236.402059204|sheng yuan;
生源__生源 504.944935018|sheng yuan;
声乐__聲樂 239.664931108|sheng yue;
生涯__生涯 1432.95027783|sheng ya;
盛宴__盛宴 463.341283758|sheng yan;
生意__生意 6235.20775378|sheng yi;
声音__聲音 16399.2743885|sheng yin;
生硬__生硬 382.433299725|sheng ying;
声优__聲優 184.481071779|sheng you;
省油__省油 346.577724349|sheng you;
胜于__勝於 205.094534596|sheng yu;
声誉__聲譽 737.513205869|sheng yu;
生于__生於 856.474009391|sheng yu;
生育__生育 1385.53861435|sheng yu;
剩余__剩餘 1699.71443635|sheng yu;
省外__省外 238.770616634|sheng wai;
声望__聲望 2263.87636378|sheng wang;
升温__升溫 616.362966229|sheng wen;
升为__升為 130.954650472|sheng wei;
省委__省委 973.773879211|sheng wei;
生物__生物 4036.18442686|sheng wu;
谁的__誰的 164.703307075|shei de;
谁都__誰都 560.667124391|shei dou;
谁能__誰能 476.813641365|shei neng;
谁来__誰來 239.366454718|shei lai;
谁会__誰會 191.031727675|shei hui;
谁家__誰家 108.222318063|shei jia;
谁就__誰就 107.015331962|shei jiu;
谁知__誰知 225.749468142|shei zhi;
谁是__誰是 253.804804573|shei shi;
谁说__誰說 389.649164279|shei shuo;
谁让__誰讓 133.093414711|shei rang;
谁要__誰要 157.67404401|shei yao;
谁也__誰也 133.259374649|shei ye;
谁又__誰又 114.179614083|shei you;
谁有__誰有 244.796354228|shei you;
事吧__事吧 106.748946222|shi ba;
十八__十八 1252.50991514|shi ba;
是把__是把 1306.71862793|shi ba;
是吧__是吧 3554.41614799|shi ba;
失败__失敗 11144.2701709|shi bai;
石板__石板 241.162905094|shi ban;
时报__時報 338.468131949|shi bao;
石碑__石碑 200.04606951|shi bei;
十倍__十倍 312.911829085|shi bei;
是被__是被 955.740681497|shi bei;
石壁__石壁 129.171793682|shi bi;
势必__勢必 954.550411286|shi bi;
事变__事變 171.403948695|shi bian;
识别__識別 2879.41941052|shi bie;
士兵__士兵 2406.4213017|shi bing;
世博__世博 222.398727024|shi bo;
是不__是不 4431.607048|shi bu;
实拍__實拍 240.862563142|shi pai;
实盘__實盤 136.112567367|shi pan;
适配__適配 133.758497151|shi pei;
诗篇__詩篇 192.945711079|shi pian;
饰品__飾品 1190.12297778|shi pin;
食品__食品 5793.21889028|shi pin;
视频__視頻 16584.235701|shi pin;
视屏__視屏 199.299593609|shi ping;
时评__時評 240.562595233|shi ping;
识破__識破 247.866011137|shi po;
食谱__食譜 326.861744407|shi pu;
是吗__是嗎 4268.99009943|shi ma;
世贸__世貿 298.06779536|shi mao;
时髦__時髦 682.676889633|shi mao;
石门__石門 238.176261728|shi men;
师门__師門 372.555031371|shi men;
师妹__師妹 583.476802811|shi mei;
十米__十米 147.045868173|shi mi;
世面__世面 108.492380517|shi mian;
市面__市面 907.004698479|shi mian;
失眠__失眠 1390.72814418|shi mian;
市民__市民 6227.44248628|shi min;
十名__十名 142.180598718|shi ming;
失明__失明 299.93080386|shi ming;
实名__實名 459.889800938|shi ming;
使命__使命 1217.12027856|shi ming;
始末__始末 133.42554153|shi mo;
石墨__石墨 168.859844103|shi mo;
师母__師母 133.42554153|shi mu;
实木__實木 243.882891747|shi mu;
始发__始發 161.653186955|shi fa;
施法__施法 258.271618599|shi fa;
事发__事發 711.336195135|shi fa;
师范__師範 732.932171333|shi fan;
示范__示範 1854.64242019|shi fan;
十方__十方 117.207077876|shi fang;
施放__施放 184.481071779|shi fang;
释放__釋放 3385.80036467|shi fang;
时分__時分 518.979844093|shi fen;
十分__十分 12607.5515214|shi fen;
适逢__適逢 127.413209251|shi feng;
试飞__試飛 130.954650472|shi fei;
施肥__施肥 509.368920718|shi fei;
是非__是非 1082.58098585|shi fei;
是否__是否 33035.4970715|shi fou;
市府__市府 136.792736844|shi fu;
师父__師父 1937.32419285|shi fu;
师傅__師傅 3479.90844849|shi fu;
事端__事端 137.991222203|shi duan;
时段__時段 979.860242923|shi duan;
是大__是大 148.519148841|shi da;
师大__師大 437.527796363|shi da;
十大__十大 2564.32477261|shi da;
世代__世代 357.545014261|shi dai;
时代__時代 11875.5298799|shi dai;
适当__適當 4976.14634858|shi dang;
食道__食道 177.933171406|shi dao;
世道__世道 603.442760838|shi dao;
识得__識得 129.817279349|shi de;
师德__師德 164.498187167|shi de;
似地__似地 260.859291326|shi de;
实德__實德 303.691826638|shi de;
似的__似的 4117.46820292|shi de;
使得__使得 8578.25504892|shi de;
失地__失地 111.646962678|shi di;
师弟__師弟 611.009712747|shi di;
湿地__濕地 700.778015498|shi di;
实地__實地 1136.49445424|shi di;
视点__視點 221.292902041|shi dian;
十点__十點 675.904869515|shi dian;
试点__試點 2235.83974961|shi dian;
失掉__失掉 135.94305409|shi diao;
石雕__石雕 136.622376491|shi diao;
时都__時都 119.26985293|shi dou;
事都__事都 560.667124391|shi dou;
湿度__濕度 472.67240572|shi du;
适度__適度 859.681929668|shi du;
十多__十多 854.342048866|shi duo;
是对__是對 3265.62606571|shi dui;
师团__師團 150.756793028|shi tuan;
使它__使它 414.699880708|shi ta;
使他__使他 968.932019286|shi ta;
是他__是他 2219.18472069|shi ta;
时态__時態 106.616002115|shi tai;
失态__失態 173.121277629|shi tai;
师太__師太 187.961915178|shi tai;
事态__事態 427.290057918|shi tai;
试探__試探 570.534533242|shi tan;
食糖__食糖 113.611883002|shi tang;
食堂__食堂 2227.49666896|shi tang;
事体__事體 140.070248771|shi ti;
试题__試題 1241.63157975|shi ti;
实体__實體 1843.12238107|shi ti;
尸体__屍體 3064.53855293|shi ti;
十天__十天 630.344829195|shi tian;
十条__十條 279.017397997|shi tiao;
失调__失調 530.091629029|shi tiao;
视听__視聽 476.813641365|shi ting;
试听__試聽 536.070335228|shi ting;
湿透__濕透 240.562595233|shi tou;
势头__勢頭 1672.40062475|shi tou;
石头__石頭 5342.46552582|shi tou;
视同__視同 136.112567367|shi tong;
仕途__仕途 207.925293333|shi tu;
师徒__師徒 256.028470459|shi tu;
视图__視圖 896.889021007|shi tu;
试图__試圖 2996.56312723|shi tu;
侍女__侍女 170.76435144|shi nv;
时能__時能 118.824795093|shi neng;
市内__市內 925.270654393|shi nei;
室内__室內 2504.32198759|shi nei;
使你__使你 642.238361775|shi ni;
是你__是你 3897.77990299|shi ni;
十年__十年 4184.71509884|shi nian;
是您__是您 191.747236314|shi nin;
使您__使您 246.019628549|shi nin;
试论__試論 425.69561654|shi lun;
十来__十來 389.163898974|shi lai;
侍郎__侍郎 120.765453341|shi lang;
是老__是老 182.423584067|shi lao;
湿了__濕了 313.69268222|shi le;
石磊__石磊 107.14877401|shi lei;
事理__事理 106.882056102|shi li;
失礼__失禮 123.813152185|shi li;
势利__勢利 148.519148841|shi li;
室里__室里 162.86639759|shi li;
十里__十里 256.028470459|shi li;
市里__市裡 509.368920718|shi li;
事例__事例 529.431458035|shi li;
失利__失利 533.404852483|shi li;
示例__示例 604.195219728|shi li;
视力__視力 745.831342837|shi li;
实例__實例 1744.7822355|shi li;
势力__勢力 2161.86308522|shi li;
实力__實力 7195.96926237|shi li;
试炼__試煉 111.646962678|shi lian;
失恋__失戀 994.623178167|shi lian;
石料__石料 107.818484324|shi liao;
食疗__食療 225.468321935|shi liao;
史料__史料 446.339066527|shi liao;
食量__食量 151.699065864|shi liang;
矢量__矢量 417.291872914|shi liang;
适量__適量 1328.06008516|shi liang;
石林__石林 200.04606951|shi lin;
适龄__適齡 152.647228173|shi ling;
失灵__失靈 318.418891685|shi ling;
石榴__石榴 299.93080386|shi liu;
十六__十六 867.213880777|shi liu;
实录__實錄 465.65665114|shi lu;
失落__失落 1382.08969051|shi luo;
试管__試管 148.334184528|shi guan;
士官__士官 182.651055928|shi guan;
食管__食管 207.149415951|shi guan;
事关__事關 406.006938516|shi guan;
使馆__使館 646.252534205|shi guan;
时光__時光 2854.41099368|shi guang;
是该__是該 340.15949445|shi gai;
实干__實幹 133.259374649|shi gan;
石膏__石膏 261.184568064|shi gao;
师哥__師哥 109.170488754|shi ge;
时隔__時隔 230.295783987|shi ge;
十个__十個 1339.6956486|shi ge;
诗歌__詩歌 2280.86680445|shi ge;
是个__是個 17849.5163038|shi ge;
是给__是給 283.927938713|shi gei;
施工__施工 4354.9622946|shi gong;
世故__世故 143.784200776|shi gu;
尸骨__屍骨 149.261315371|shi gu;
事故__事故 3745.40519724|shi gu;
驶过__駛過 125.678566729|shi guo;
试过__試過 1788.81445378|shi guo;
实况__實況 810.776675547|shi kuang;
十块__十塊 152.837570606|shi kuai;
石块__石塊 274.191785204|shi kuai;
试看__試看 108.492380517|shi kan;
是看__是看 198.555903198|shi kan;
是靠__是靠 841.661270235|shi kao;
石刻__石刻 148.334184528|shi ke;
食客__食客 249.104624871|shi ke;
时可__時可 277.976239008|shi ke;
时刻__時刻 4371.27378998|shi ke;
失控__失控 627.210588862|shi kong;
时空__時空 1425.82527204|shi kong;
石窟__石窟 137.991222203|shi ku;
市话__市話 188.665925845|shi hua;
石化__石化 1301.84258129|shi hua;
实话__實話 3265.62606571|shi hua;
使唤__使喚 147.964946673|shi huan;
是坏__是壞 112.065135969|shi huai;
释怀__釋懷 229.722524886|shi huai;
世行__世行 145.768741141|shi hang;
十号__十號 106.616002115|shi hao;
嗜好__嗜好 413.152419826|shi hao;
是好__是好 457.033213363|shi hao;
是何__是何 154.368879448|shi he;
适合__適合 12829.4369505|shi he;
是很__是很 3122.36117229|shi hen;
失衡__失衡 623.314694733|shi heng;
事后__事後 1474.61550226|shi hou;
时候__時候 143389.796007|shi hou;
石斛__石斛 135.94305409|shi hu;
失火__失火 188.665925845|shi huo;
石灰__石灰 206.119414554|shi hui;
时会__時會 714.89082038|shi hui;
实惠__實惠 1504.31243966|shi hui;
试卷__試卷 1038.96445205|shi juan;
视觉__視覺 2241.4191567|shi jue;
史记__史記 149.261315371|shi ji;
实绩__實績 168.229740225|shi ji;
诗集__詩集 243.57916235|shi ji;
试剂__試劑 303.691826638|shi ji;
事迹__事迹 680.129467195|shi ji;
市级__市級 858.611290099|shi ji;
时机__時機 2742.82438642|shi ji;
十几__十幾 3348.03907796|shi ji;
世纪__世紀 6570.2434815|shi ji;
实际__實際 15312.9355615|shi ji;
是假__是假 173.121277629|shi jia;
市价__市價 357.099731154|shi jia;
十佳__十佳 373.484720623|shi jia;
世家__世家 461.037428991|shi jia;
施加__施加 491.902185928|shi jia;
试驾__試駕 576.250827814|shi jia;
尸检__屍檢 150.569041974|shi jian;
始建__始建 214.2378495|shi jian;
是件__是件 668.366611253|shi jian;
世间__世間 1387.2663024|shi jian;
实践__實踐 7027.59035759|shi jian;
事件__事件 13022.7299719|shi jian;
时间__時間 92935.0472348|shi jian;
市郊__市郊 149.820373083|shi jiao;
视角__視角 1258.76884501|shi jiao;
是将__是將 128.529517539|shi jiang;
视界__視界 149.633788238|shi jie;
十届__十屆 419.377126323|shi jie;
时节__時節 617.131535882|shi jie;
师姐__師姐 1156.49608257|shi jie;
世界__世界 30808.7065179|shi jie;
使劲__使勁 1321.45662101|shi jin;
诗经__詩經 110.264288753|shi jing;
市井__市井 193.668388536|shi jing;
实景__實景 211.321149687|shi jing;
十九__十九 425.165459331|shi jiu;
时就__時就 948.621258606|shi jiu;
诗句__詩句 448.56947196|shi ju;
市局__市局 522.874798954|shi ju;
实权__實權 128.369448119|shi quan;
时却__時卻 177.933171406|shi que;
石器__石器 124.742372548|shi qi;
拾起__拾起 212.641966978|shi qi;
士气__士氣 432.648119245|shi qi;
十七__十七 732.019384688|shi qi;
使其__使其 1954.29771596|shi qi;
时期__時期 7950.33736137|shi qi;
史前__史前 123.967540162|shi qian;
事前__事前 462.764242999|shi qian;
石桥__石橋 153.984619852|shi qiao;
十强__十強 166.97657743|shi qiang;
失窃__失竊 114.037415895|shi qie;
时请__時請 121.823518492|shi qing;
实情__實情 283.221176861|shi qing;
事情__事情 51097.7732998|shi qing;
失球__失球 136.622376491|shi qiu;
时区__時區 179.940013424|shi qu;
拾取__拾取 199.796934068|shi qu;
逝去__逝去 611.771607197|shi qu;
市区__市區 3225.18344283|shi qu;
失去__失去 9656.35583564|shi qu;
失学__失學 105.821807183|shi xue;
失血__失血 171.831677206|shi xue;
史学__史學 220.742053181|shi xue;
嗜血__嗜血 251.287110964|shi xue;
试训__試訓 114.893269147|shi xun;
视讯__視訊 192.705418355|shi xun;
实训__實訓 228.580284053|shi xun;
世袭__世襲 106.616002115|shi xi;
市西__市西 144.502706249|shi xi;
实习__實習 4811.50185273|shi xi;
时下__時下 470.32215416|shi xia;
试下__試下 475.626742696|shi xia;
市县__市縣 333.444336783|shi xian;
时限__時限 470.908619205|shi xian;
视线__視線 1431.1656954|shi xian;
事先__事先 2183.52320481|shi xian;
实现__實現 28767.8421902|shi xian;
时效__時效 258.916120291|shi xiao;
实效__實效 492.515560049|shi xiao;
失效__失效 1015.91887775|shi xiao;
十项__十項 115.179978568|shi xiang;
驶向__駛向 120.46484039|shi xiang;
石像__石像 120.916041011|shi xiang;
试想__試想 271.471856767|shi xiang;
是想__是想 1467.28332601|shi xiang;
事项__事項 2523.11697781|shi xiang;
是些__是些 126.621787068|shi xie;
实心__實心 127.572086295|shi xin;
失信__失信 155.72135507|shi xin;
试行__試行 391.596284031|shi xing;
施行__施行 829.168709129|shi xing;
实行__實行 7920.67051883|shi xing;
师兄__師兄 1966.51263254|shi xiong;
时许__時許 122.127521944|shi xu;
时序__時序 205.094534596|shi xu;
时装__時裝 707.799244422|shi zhuang;
施展__施展 515.756221017|shi zhan;
实战__實戰 1140.75119008|shi zhan;
师长__師長 326.861744407|shi zhang;
市长__市長 3118.47261385|shi zhang;
逝者__逝者 105.690017726|shi zhe;
侍者__侍者 128.689786556|shi zhe;
使者__使者 642.238361775|shi zhe;
试着__試着 1425.82527204|shi zhe;
市镇__市鎮 107.015331962|shi zhen;
失真__失真 420.94790182|shi zhen;
是真__是真 434.810109507|shi zhen;
湿疹__濕疹 448.010827873|shi zhen;
施政__施政 159.85029497|shi zheng;
时政__時政 174.855812809|shi zheng;
实证__實證 218.008308584|shi zheng;
市政__市政 710.450303909|shi zheng;
试制__試製 129.817279349|shi zhi;
视之__視之 130.303509496|shi zhi;
食之__食之 143.605133321|shi zhi;
十指__十指 156.89004718|shi zhi;
试纸__試紙 239.664931108|shi zhi;
市直__市直 249.104624871|shi zhi;
失职__失職 304.449671797|shi zhi;
食指__食指 472.083744072|shi zhi;
使之__使之 1018.45404378|shi zhi;
市值__市值 1416.96881393|shi zhi;
实质__實質 1824.83897052|shi zhi;
是指__是指 4769.71285751|shi zhi;
市州__市州 116.769717326|shi zhou;
诗中__詩中 226.312812713|shi zhong;
是种__是種 345.715012791|shi zhong;
十种__十種 369.779825848|shi zhong;
适中__適中 471.495815538|shi zhong;
时钟__時鐘 788.850627646|shi zhong;
始终__始終 6464.66198571|shi zhong;
事主__事主 118.529012887|shi zhu;
失主__失主 126.306596357|shi zhu;
是猪__是豬 136.282292017|shi zhu;
石柱__石柱 155.140277726|shi zhu;
施主__施主 168.859844103|shi zhu;
失传__失傳 133.758497151|shi chuan;
试穿__試穿 144.322743975|shi chuan;
视窗__視窗 301.805456692|shi chuang;
时差__時差 486.416079992|shi cha;
视察__視察 985.98464814|shi cha;
失常__失常 229.150692759|shi chang;
时长__時長 287.130256264|shi chang;
时常__時常 1607.02198372|shi chang;
市场__市場 54045.0745681|shi chang;
试车__試車 239.068350048|shi che;
时辰__時辰 293.277951001|shi chen;
时称__時稱 142.713135632|shi cheng;
使出__使出 339.735863102|shi chu;
是啥__是啥 730.197220308|shi sha;
史上__史上 1185.68201014|shi shang;
世上__世上 1603.0217369|shi shang;
时尚__時尚 6456.61095813|shi shang;
试射__試射 108.222318063|shi she;
施舍__施捨 248.794392378|shi she;
食神__食神 118.972962872|shi shen;
失身__失身 128.369448119|shi shen;
失声__失聲 194.393772779|shi sheng;
师生__師生 1250.95005139|shi sheng;
是谁__是誰 1135.07907503|shi shei;
失实__失實 107.416157498|shi shi;
湿湿__濕濕 131.281440129|shi shi;
失事__失事 154.368879448|shi shi;
石狮__石獅 171.403948695|shi shi;
史实__史實 234.933657026|shi shi;
时事__時事 317.230705235|shi shi;
实事__實事 378.63963681|shi shi;
史诗__史詩 389.649164279|shi shi;
事事__事事 428.356335222|shi shi;
世事__世事 479.196331601|shi shi;
逝世__逝世 581.299547476|shi shi;
时时__時時 722.053448193|shi shi;
适时__適時 952.17431607|shi shi;
实时__實時 2476.39168739|shi shi;
试试__試試 10897.0758557|shi shi;
事实__事實 11583.2100573|shi shi;
实施__實施 14714.3117017|shi shi;
市售__市售 109.716025699|shi shou;
失守__失守 136.282292017|shi shou;
失手__失手 236.991986692|shi shou;
是受__是受 347.00988711|shi shou;
十数__十數 122.890853693|shi shu;
市属__市屬 148.889769675|shi shu;
史书__史書 237.879639313|shi shu;
实属__實屬 287.846772995|shi shu;
是说__是說 751.428823061|shi shuo;
时说__時說 1069.17393505|shi shuo;
试水__試水 140.244908425|shi shui;
是谁__是誰 3398.48186759|shi shui;
湿润__濕潤 730.197220308|shi run;
释然__釋然 200.29551561|shi ran;
使然__使然 274.191785204|shi ran;
是让__是讓 371.627656329|shi rang;
湿热__濕熱 242.972837869|shi re;
十人__十人 159.85029497|shi ren;
示人__示人 161.854759309|shi ren;
是人__是人 271.810366771|shi ren;
时任__時任 356.655002599|shi ren;
世人__世人 1366.67546656|shi ren;
使人__使人 1651.68904712|shi ren;
诗人__詩人 2564.32477261|shi ren;
十日__十日 249.726250867|shi ri;
时日__時日 305.97104031|shi ri;
市容__市容 315.260239073|shi rong;
驶入__駛入 183.792676978|shi ru;
示弱__示弱 134.092283643|shi ruo;
是在__是在 11326.2794881|shi zai;
实在__實在 16176.0096356|shi zai;
实则__實則 277.976239008|shi ze;
虱子__虱子 119.716577729|shi zi;
柿子__柿子 225.187525865|shi zi;
石子__石子 294.743493195|shi zi;
识字__識字 330.548296374|shi zi;
师资__師資 384.344361008|shi zi;
十字__十字 666.702893247|shi zi;
狮子__獅子 1459.98760728|shi zi;
失踪__失蹤 1418.73569366|shi zong;
失足__失足 140.419785869|shi zu;
始祖__始祖 192.225730308|shi zu;
氏族__氏族 197.814987883|shi zu;
十足__十足 1498.69906777|shi zu;
诗作__詩作 132.596773978|shi zuo;
视作__視作 241.162905094|shi zuo;
是做__是做 566.990680223|shi zuo;
是最__是最 3265.62606571|shi zui;
时才__時才 391.596284031|shi cai;
石材__石材 398.48814637|shi cai;
史册__史冊 124.89791921|shi ce;
实测__實測 213.704562287|shi ce;
时曾__時曾 208.44415872|shi ceng;
十次__十次 258.271618599|shi ci;
诗词__詩詞 660.912425973|shi ci;
师从__師從 107.952927857|shi cong;
是从__是從 4571.84317933|shi cong;
是错__是錯 296.955549433|shi cuo;
失散__失散 128.850255419|shi san;
十三__十三 1431.1656954|shi san;
失色__失色 117.646076559|shi se;
誓死__誓死 155.72135507|shi si;
十四__十四 909.268075561|shi si;
食宿__食宿 224.626982392|shi su;
时速__時速 430.496878967|shi su;
世俗__世俗 863.977854874|shi su;
十岁__十歲 318.815941979|shi sui;
十元__十元 232.313479749|shi yuan;
十月__十月 1070.5071343|shi yue;
施压__施壓 255.391156791|shi ya;
是呀__是呀 3657.76624243|shi ya;
时延__時延 125.522047856|shi yan;
十堰__十堰 191.269933402|shi yan;
食盐__食鹽 293.277951001|shi yan;
誓言__誓言 598.201722298|shi yan;
饰演__飾演 1178.31719254|shi yan;
试验__試驗 5204.46941467|shi yan;
实验__實驗 6586.63913914|shi yan;
试样__試樣 177.933171406|shi yang;
式样__式樣 542.792461517|shi yang;
时要__時要 659.267263146|shi yao;
是要__是要 4031.15780176|shi yao;
时也__時也 369.779825848|shi ye;
实业__實業 1114.0586864|shi ye;
失业__失業 1432.95027783|shi ye;
视野__視野 1687.0530669|shi ye;
事业__事業 8783.78740305|shi ye;
释义__釋義 124.431860131|shi yi;
施以__施以 140.594881376|shi yi;
十亿__十億 152.647228173|shi yi;
失忆__失憶 259.238974004|shi yi;
失意__失意 417.812212206|shi yi;
诗意__詩意 553.723632203|shi yi;
是一__是一 654.356305043|shi yi;
示意__示意 656.807194196|shi yi;
适宜__適宜 1380.36844936|shi yi;
事宜__事宜 2016.1405527|shi yi;
是以__是以 2791.09646881|shi yi;
十一__十一 3165.45667059|shi yi;
石英__石英 172.475272126|shi ying;
时应__時應 391.596284031|shi ying;
适应__適應 6906.0480087|shi ying;
事由__事由 137.476305203|shi you;
时有__時有 274.533686805|shi you;
室友__室友 907.004698479|shi you;
是有__是有 3056.91021261|shi you;
是由__是由 4006.11842218|shi you;
石油__石油 4360.39268552|shi you;
时用__時用 180.389043185|shi yong;
施用__施用 244.186999878|shi yong;
是用__是用 1827.1144412|shi yong;
食用__食用 1956.73461434|shi yong;
试用__試用 2491.86983978|shi yong;
实用__實用 3532.33803061|shi yong;
适用__適用 4459.30585251|shi yong;
使用__使用 55824.8293665|shi yong;
适于__適於 274.533686805|shi yu;
始于__始於 448.56947196|shi yu;
十余__十餘 707.799244422|shi yu;
食欲__食慾 832.274357505|shi yu;
室外__室外 860.753904265|shi wai;
试玩__試玩 197.814987883|shi wan;
十万__十萬 841.661270235|shi wan;
失望__失望 4442.66586373|shi wang;
诗文__詩文 230.008975843|shi wen;
室温__室溫 259.885889675|shi wen;
试问__試問 307.883446338|shi wen;
十位__十位 191.98633424|shi wei;
是位__是位 206.119414554|shi wei;
实为__實為 261.83633885|shi wei;
侍卫__侍衛 282.516174301|shi wei;
示威__示威 408.544597361|shi wei;
是为__是為 1014.65366219|shi wei;
市委__市委 1447.30728064|shi wei;
视为__視為 2303.71924505|shi wei;
使我__使我 1313.24844471|shi wo;
是我__是我 6448.56995722|shi wo;
饰物__飾物 211.848489234|shi wu;
实务__實務 358.884197808|shi wu;
实物__實物 1333.03432936|shi wu;
十五__十五 1591.08064256|shi wu;
失误__失誤 2367.75095999|shi wu;
事务__事務 2791.09646881|shi wu;
事物__事物 3390.02226565|shi wu;
食物__食物 5742.90345783|shi wu;
是啊__是啊 14695.9866401|shi a;
示爱__示愛 126.621787068|shi ai;
是爱__是愛 175.510734618|shi ai;
是按__是按 306.734573113|shi an;
时而__時而 619.442999798|shi er;
十二__十二 1850.02578923|shi er;
事儿__事兒 2178.08791404|shi er;
手背__手背 176.168109435|shou bei;
手笔__手筆 134.762357541|shou bi;
手臂__手臂 1305.09125317|shou bi;
收编__收編 109.170488754|shou bian;
手边__手邊 225.749468142|shou bian;
手表__手錶 1098.89154964|shou biao;
手柄__手柄 711.336195135|shou bing;
首播__首播 211.057972369|shou bo;
手部__手部 160.249192015|shou bu;
首部__首部 296.216358865|shou bu;
手帕__手帕 213.704562287|shou pa;
收盘__收盤 1409.92327219|shou pan;
手捧__手捧 157.67404401|shou peng;
首批__首批 1137.91159836|shou pi;
受骗__受騙 531.41444163|shou pian;
售票__售票 465.076726846|shou piao;
受聘__受聘 147.229226029|shou pin;
售卖__售賣 188.196293023|shou mai;
收买__收買 271.810366771|shou mai;
守门__守門 105.690017726|shou men;
受命__受命 128.369448119|shou ming;
寿命__壽命 1331.37418129|shou ming;
受罚__受罰 112.484875527|shou fa;
守法__守法 266.444503116|shou fa;
收发__收發 470.32215416|shou fa;
首发__首發 1190.12297778|shou fa;
手法__手法 2087.73078616|shou fa;
售房__售房 136.963309627|shou fang;
受访__受訪 139.200207879|shou fang;
收房__收房 193.90988203|shou fang;
收费__收費 6594.85230449|shou fei;
首府__首府 247.557321202|shou fu;
收复__收復 276.249600432|shou fu;
首富__首富 413.152419826|shou fu;
首付__首付 767.517531652|shou fu;
手段__手段 8019.99283537|shou duan;
手袋__手袋 189.372573382|shou dai;
受到__受到 14262.9667917|shou dao;
收到__收到 17782.9104775|shou dao;
手电__手電 191.031727675|shou dian;
手动__手動 2278.02623496|shou dong;
首度__首度 489.456318842|shou du;
首都__首都 2145.75911703|shou du;
手套__手套 1058.56794047|shou tao;
受体__受體 391.108593802|shou ti;
手提__手提 433.187606905|shou ti;
收听__收聽 351.799391968|shou ting;
手头__手頭 1308.34803192|shou tou;
受托__受託 143.963491517|shou tuo;
首推__首推 193.668388536|shou tui;
受虐__受虐 122.890853693|shou nue;
收纳__收納 116.769717326|shou na;
手拿__手拿 239.068350048|shou na;
受难__受難 161.049974862|shou nan;
首脑__首腦 301.429591092|shou nao;
首轮__首輪 410.586139672|shou lun;
手雷__手雷 128.209578049|shou lei;
受累__受累 221.017305999|shou lei;
受力__受力 186.32942291|shou li;
首例__首例 261.83633885|shou li;
受理__受理 1983.741885|shou li;
手里__手裡 4382.1820476|shou li;
手链__手鏈 335.110594827|shou lian;
收敛__收斂 670.869975958|shou lian;
狩猎__狩獵 323.619340361|shou lie;
首领__首領 482.191444969|shou ling;
收留__收留 310.194118206|shou liu;
售楼__售樓 201.296414343|shou lou;
收录__收錄 1589.0991261|shou lu;
手感__手感 965.316430119|shou gan;
首钢__首鋼 271.471856767|shou gang;
手稿__手稿 166.353500999|shou gao;
收割__收割 347.00988711|shou ge;
首歌__首歌 546.866130582|shou ge;
首个__首個 885.781642601|shou ge;
收购__收購 6282.00312169|shou gou;
收工__收工 302.181790975|shou gong;
手工__手工 2018.65456559|shou gong;
受过__受過 868.29524729|shou guo;
首款__首款 543.469292924|shou kuan;
收款__收款 593.006203378|shou kuan;
受困__受困 105.0335283|shou kun;
首开__首開 121.066816454|shou kai;
收看__收看 628.775756137|shou kan;
手铐__手銬 175.073848088|shou kao;
授课__授課 699.033618062|shou ke;
受控__受控 120.765453341|shou kong;
受苦__受苦 455.895552723|shou ku;
受害__受害 432.109303457|shou hai;
收好__收好 125.36572391|shou hao;
守恒__守恆 118.08671951|shou heng;
守候__守候 488.237949645|shou hou;
售后__售後 1202.04704744|shou hou;
守护__守護 1094.79101389|shou hu;
收货__收貨 646.252534205|shou huo;
收获__收穫 3549.98951246|shou huo;
受惠__受惠 182.651055928|shou hui;
手绘__手繪 316.046952528|shou hui;
受贿__受賄 534.069978074|shou hui;
收回__收回 1753.50110433|shou hui;
手绢__手絹 115.611384758|shou juan;
守军__守軍 105.164499152|shou jun;
手记__手記 234.348853194|shou ji;
收集__收集 4781.61539648|shou ji;
手机__手機 37653.6589505|shou ji;
首家__首家 758.012333731|shou jia;
售价__售價 2119.18530697|shou jia;
收件__收件 181.969489867|shou jian;
收缴__收繳 316.83562918|shou jiao;
手脚__手腳 959.320404733|shou jiao;
首届__首屆 1092.0658276|shou jie;
受尽__受盡 173.337150041|shou jin;
收紧__收緊 321.609191441|shou jin;
受惊__受驚 109.442917312|shou jing;
受精__受精 124.587019602|shou jing;
收据__收據 611.771607197|shou ju;
授权__授權 5230.47672106|shou quan;
受其__受其 130.46599058|shou qi;
手气__手氣 139.026849285|shou qi;
受气__受氣 163.476413088|shou qi;
收起__收起 335.110594827|shou qi;
首期__首期 387.711726118|shou qi;
售前__售前 425.165459331|shou qian;
收钱__收錢 781.999279332|shou qian;
手枪__手槍 656.807194196|shou qiang;
收取__收取 2735.99686654|shou qu;
首选__首選 1485.68252323|shou xuan;
首席__首席 1498.69906777|shou xi;
收下__收下 369.319305625|shou xia;
手下__手下 1306.71862793|shou xia;
受限__受限 343.996026791|shou xian;
寿险__壽險 394.043872187|shou xian;
首先__首先 13756.7225213|shou xian;
收效__收效 110.677283245|shou xiao;
瘦小__瘦小 213.438416689|shou xiao;
首相__首相 584.932834985|shou xiang;
手写__手寫 686.088301175|shou xie;
守信__守信 112.484875527|shou xin;
收信__收信 144.502706249|shou xin;
授信__授信 203.820597887|shou xin;
手心__手心 414.699880708|shou xin;
兽性__獸性 110.401782066|shou xing;
寿星__壽星 128.049907079|shou xing;
手续__手續 4132.89016505|shou xu;
首战__首戰 160.249192015|shou zhan;
首张__首張 341.433560596|shou zhang;
首长__首長 444.119751258|shou zhang;
手掌__手掌 698.163048348|shou zhang;
守着__守着 571.958268741|shou zhe;
手纸__手紙 107.015331962|shou zhi;
收治__收治 130.141230764|shou zhi;
受制__受制 214.772467501|shou zhi;
收支__收支 397.991873082|shou zhi;
手指__手指 3173.35588224|shou zhi;
受众__受眾 799.738513132|shou zhong;
手中__手中 4560.46281159|shou zhong;
守住__守住 381.006242235|shou zhu;
手镯__手鐲 279.017397997|shou zhuo;
首创__首創 583.476802811|shou chuang;
首场__首場 324.02287532|shou chang;
收场__收場 335.528458728|shou chang;
收成__收成 223.788782324|shou cheng;
手持__手持 777.141921285|shou chi;
受宠__受寵 109.170488754|shou chong;
收出__收出 110.401782066|shou chu;
售出__售出 389.649164279|shou chu;
手刹__手剎 105.0335283|shou sha;
手上__手上 3083.69279052|shou shang;
受伤__受傷 3811.32210727|shou shang;
手伸__手伸 116.47905068|shou shen;
受审__受審 190.081867665|shou shen;
瘦身__瘦身 655.989212862|shou shen;
首诗__首詩 120.46484039|shou shi;
收市__收市 237.287502254|shou shi;
手势__手勢 493.744603771|shou shi;
收视__收視 670.034480971|shou shi;
首饰__首飾 922.967443217|shou shi;
收拾__收拾 3022.81698484|shou shi;
瘦瘦__瘦瘦 108.357265155|shou shou;
收手__收手 131.609045271|shou shou;
收受__收受 392.084582382|shou shou;
手术__手術 4811.50185273|shou shu;
手软__手軟 204.329220247|shou ruan;
受让__受讓 314.867617017|shou rang;
受热__受熱 119.121315407|shou re;
收人__收人 110.264288753|shou ren;
手刃__手刃 146.862738669|shou ren;
兽人__獸人 347.442588754|shou ren;
受人__受人 435.895152658|shou ren;
首日__首日 530.752623218|shou ri;
瘦肉__瘦肉 228.8653107|shou rou;
收容__收容 208.70407676|shou rong;
收入__收入 12639.0129275|shou ru;
瘦弱__瘦弱 284.281980745|shou ruo;
守在__守在 330.548296374|shou zai;
受灾__受災 692.962351041|shou zai;
守则__守則 280.062456643|shou ze;
瘦子__瘦子 114.037415895|shou zi;
手足__手足 254.755429543|shou zu;
受阻__受阻 383.865702254|shou zu;
受罪__受罪 310.194118206|shou zui;
收藏__收藏 5349.12727725|shou cang;
手册__手冊 2323.90287358|shou ce;
受此__受此 156.694657831|shou ci;
首次__首次 6242.98270412|shou ci;
受挫__受挫 254.121284766|shou cuo;
受损__受損 898.007390736|shou sun;
寿司__壽司 330.136634719|shou si;
收缩__收縮 1143.59786783|shou suo;
受孕__受孕 257.62872122|shou yun;
受压__受壓 133.093414711|shou ya;
首演__首演 137.819369268|shou yan;
收养__收養 484.601008682|shou yang;
兽药__獸葯 178.377193209|shou yao;
受邀__受邀 193.427195796|shou yao;
首要__首要 958.125676369|shou yao;
首页__首頁 4566.14945001|shou ye;
授意__授意 112.625137786|shou yi;
兽医__獸醫 361.12732612|shou yi;
手艺__手藝 506.204995518|shou yi;
受益__受益 1399.42059064|shou yi;
收益__收益 5477.29072256|shou yi;
收音__收音 120.916041011|shou yin;
手印__手印 169.492308033|shou yin;
收银__收銀 183.792676978|shou yin;
手淫__手淫 712.223191016|shou yin;
首映__首映 497.450167612|shou ying;
受用__受用 185.402943996|shou yong;
手语__手語 147.596627936|shou yu;
授予__授予 1371.79434453|shou yu;
手腕__手腕 829.168709129|shou wan;
兽王__獸王 249.104624871|shou wang;
守望__守望 349.178797604|shou wang;
收尾__收尾 270.122027271|shou wei;
守卫__守衛 472.083744072|shou wei;
首位__首位 954.550411286|shou wei;
手握__手握 301.805456692|shou wo;
首尔__首爾 314.083839199|shou er;
数百__數百 1097.52300072|shu bai;
书包__書包 632.705783453|shu bao;
书本__書本 671.706512759|shu ben;
数倍__數倍 191.508436159|shu bei;
鼠标__鼠標 4338.71166588|shu biao;
树皮__樹皮 160.649084484|shu pi;
薯片__薯片 207.149415951|shu pian;
述评__述評 122.279808036|shu ping;
书评__書評 286.058823982|shu ping;
数码__數碼 3323.09914758|shu ma;
书面__書面 1721.02823483|shu mian;
树苗__樹苗 114.893269147|shu miao;
数名__數名 168.020228531|shu ming;
书名__書名 380.057830188|shu ming;
署名__署名 463.919044053|shu ming;
书目__書目 348.743933702|shu mu;
树木__樹木 887.99205879|shu mu;
数目__數目 1441.90662463|shu mu;
抒发__抒發 338.890182508|shu fa;
书法__書法 1103.00744393|shu fa;
书房__書房 707.799244422|shu fang;
束缚__束縛 1009.60853723|shu fu;
舒服__舒服 7423.68234244|shu fu;
疏导__疏導 308.651751439|shu dao;
输得__輸得 201.79873775|shu de;
属地__屬地 147.964946673|shu di;
输电__輸電 105.164499152|shu dian;
书店__書店 1615.05244942|shu dian;
输掉__輸掉 329.314848809|shu diao;
数度__數度 176.827946446|shu du;
舒坦__舒坦 250.349428094|shu tan;
数天__數天 141.650048976|shu tian;
薯条__薯條 153.792848894|shu tiao;
熟透__熟透 107.684208225|shu tou;
梳头__梳頭 155.333728851|shu tou;
疏通__疏通 448.010827873|shu tong;
熟女__熟女 378.63963681|shu nv;
淑女__淑女 815.844260376|shu nv;
数年__數年 540.767020614|shu nian;
枢纽__樞紐 434.810109507|shu niu;
熟了__熟了 250.349428094|shu le;
疏离__疏離 111.091824605|shu li;
竖立__豎立 153.41002317|shu li;
数理__數理 206.376433771|shu li;
书里__書里 296.585723861|shu li;
梳理__梳理 764.653524665|shu li;
树立__樹立 2385.52098173|shu li;
熟练__熟練 1485.68252323|shu lian;
数量__數量 11199.9593153|shu liang;
数列__數列 127.096048509|shu lie;
树林__樹林 559.968874971|shu lin;
疏漏__疏漏 136.452228303|shu lou;
数落__數落 181.064689688|shu luo;
曙光__曙光 675.063104121|shu guang;
树干__樹榦 239.068350048|shu gan;
书稿__書稿 144.143005824|shu gao;
数个__數個 292.183578474|shu ge;
树根__樹根 127.096048509|shu gen;
输给__輸給 698.163048348|shu gei;
蔬果__蔬果 133.758497151|shu guo;
蜀国__蜀國 154.754097942|shu guo;
书柜__書櫃 181.516526012|shu gui;
书刊__書刊 212.377144726|shu kan;
漱口__漱口 159.452390871|shu kou;
数控__數控 397.496217848|shu kong;
书库__書庫 150.194241046|shu ku;
书画__書畫 602.691239054|shu hua;
舒缓__舒緩 441.361118731|shu huan;
术后__術后 973.773879211|shu hou;
疏忽__疏忽 484.601008682|shu hu;
赎回__贖回 1020.99553617|shu hui;
书籍__書籍 2191.70158301|shu ji;
书记__書記 2989.10399336|shu ji;
数家__數家 130.954650472|shu jia;
书架__書架 440.811451858|shu jia;
暑假__暑假 3352.21389275|shu jia;
树胶__樹膠 105.558392399|shu jiao;
书局__書局 131.773154284|shu ju;
数据__數據 33827.0174267|shu ju;
竖起__豎起 324.83145542|shu qi;
舒淇__舒淇 367.941183266|shu qi;
暑期__暑期 784.92825478|shu qi;
术前__術前 219.097720093|shu qian;
数钱__數錢 238.473254015|shu qian;
书签__書籤 534.735933039|shu qian;
数千__數千 820.943519051|shu qian;
抒情__抒情 527.455873984|shu qing;
输球__輸球 345.284462654|shu qiu;
输血__輸血 271.810366771|shu xue;
数学__數學 4091.89270964|shu xue;
熟悉__熟悉 10149.8912754|shu xi;
属下__屬下 257.62872122|shu xia;
树下__樹下 383.865702254|shu xia;
属相__屬相 113.611883002|shu xiang;
书香__書香 170.551683166|shu xiang;
书写__書寫 1168.08323794|shu xie;
舒心__舒心 246.326401069|shu xin;
书信__書信 331.37316028|shu xin;
树形__樹形 179.940013424|shu xing;
属性__屬性 6028.9050116|shu xing;
舒展__舒展 333.444336783|shu zhan;
数着__數着 123.813152185|shu zhe;
竖着__豎著 135.435779871|shu zhe;
述职__述職 121.823518492|shu zhi;
熟知__熟知 438.619621343|shu zhi;
树枝__樹枝 528.772109212|shu zhi;
树脂__樹脂 649.481929235|shu zhi;
数值__數值 1553.85085374|shu zhi;
术中__術中 189.845141544|shu zhong;
树种__樹種 267.44247003|shu zhong;
书中__書中 1382.08969051|shu zhong;
书桌__書桌 274.191785204|shu zhuo;
舒畅__舒暢 493.129699012|shu chang;
书城__書城 249.104624871|shu cheng;
输出__輸出 5497.80589498|shu chu;
蜀山__蜀山 199.051387821|shu shan;
书商__書商 108.898738333|shu shang;
书上__書上 665.872587905|shu shang;
树上__樹上 692.099342424|shu shang;
树梢__樹梢 113.32907693|shu shao;
书生__書生 685.233853433|shu sheng;
熟食__熟食 114.037415895|shu shi;
书市__書市 141.650048976|shu shi;
熟识__熟識 173.121277629|shu shi;
属实__屬實 482.792710347|shu shi;
数十__數十 1382.08969051|shu shi;
术士__術士 1542.27603899|shu shi;
舒适__舒適 2067.02090848|shu shi;
数数__數數 221.568841736|shu shu;
叔叔__叔叔 2766.85515694|shu shu;
述说__述說 217.736803143|shu shuo;
熟睡__熟睡 291.819695868|shu shui;
数人__數人 175.510734618|shu ren;
熟人__熟人 1146.45164931|shu ren;
数日__數日 229.150692759|shu ri;
殊荣__殊榮 291.456266438|shu rong;
输入__輸入 10924.26887|shu ru;
梳子__梳子 269.114061535|shu zi;
数字__數字 9680.45270584|shu zi;
数组__數組 1152.18059436|shu zu;
赎罪__贖罪 132.762114633|shu zui;
蔬菜__蔬菜 2959.45267121|shu cai;
数次__數次 540.767020614|shu ci;
树丛__樹叢 109.442917312|shu cong;
暑促__暑促 131.773154284|shu cu;
疏散__疏散 392.084582382|shu san;
疏松__疏鬆 108.357265155|shu song;
输送__輸送 689.516759915|shu song;
疏远__疏遠 324.426913464|shu yuan;
书院__書院 344.424970321|shu yuan;
数月__數月 369.779825848|shu yue;
输液__輸液 385.303469841|shu ye;
树叶__樹葉 732.932171333|shu ye;
数亿__數億 131.609045271|shu yi;
树荫__樹蔭 118.08671951|shu yin;
输赢__輸贏 320.010065926|shu ying;
书友__書友 137.134095104|shu you;
疏于__疏於 127.572086295|shu yu;
术语__術語 882.476330723|shu yu;
属于__屬於 15332.0299235|shu yu;
数万__數萬 381.006242235|shu wan;
数为__數為 157.2815571|shu wei;
数位__數位 187.727829225|shu wei;
恕我__恕我 114.46454262|shu wo;
书屋__書屋 172.690339006|shu wu;
数额__數額 1066.51251556|shu e;
说罢__說罷 114.46454262|shuo ba;
说吧__說吧 1169.53977147|shuo ba;
说不__說不 569.114341748|shuo bu;
说明__說明 20702.8261803|shuo ming;
说法__說法 6021.39667155|shuo fa;
说服__說服 1172.45828945|shuo fu;
硕大__碩大 326.048110451|shuo da;
说到__說到 2442.67733117|shuo dao;
说道__說道 3428.25706512|shuo dao;
说得__說得 2688.67773313|shuo de;
说的__說的 5076.35979838|shuo de;
说点__說點 301.805456692|shuo dian;
说那__說那 170.977284899|shuo na;
说呢__說呢 479.196331601|shuo ne;
说来__說來 831.23785106|shuo lai;
说了__說了 6752.86293853|shuo le;
说理__說理 136.112567367|shuo li;
说个__說個 243.275811214|shuo ge;
说给__說給 134.594525802|shuo gei;
硕果__碩果 139.72158175|shuo guo;
说过__說過 5843.9751525|shuo guo;
说话__說話 20962.4320622|shuo hua;
说谎__說謊 572.671468255|shuo huang;
说好__說好 1085.28250327|shuo hao;
说教__說教 259.238974004|shuo jiao;
说句__說句 618.67155147|shuo ju;
说起__說起 1918.1063189|shuo qi;
说清__說清 107.818484324|shuo qing;
说笑__說笑 249.104624871|shuo xiao;
说些__說些 336.785179346|shuo xie;
说着__說著 1873.22443719|shuo zhe;
说唱__說唱 186.794397067|shuo chang;
说成__說成 582.750146437|shuo cheng;
说出__說出 2457.94475925|shuo chu;
说啥__說啥 451.935995467|shuo sha;
说声__說聲 413.152419826|shuo sheng;
说事__說事 350.050152834|shuo shi;
硕士__碩士 2373.65954378|shuo shi;
说是__說是 4793.54763754|shuo shi;
说说__說說 4566.14945001|shuo shuo;
说辞__說辭 132.927661458|shuo ci;
说错__說錯 691.237408589|shuo cuo;
说要__說要 1109.90155418|shuo yao;
说有__說有 207.666345181|shuo you;
说完__說完 1802.23954462|shuo wan;
睡吧__睡吧 949.804135501|shui ba;
水泵__水泵 353.557372243|shui beng;
水杯__水杯 169.070402749|shui bei;
水边__水邊 206.376433771|shui bian;
水表__水表 120.916041011|shui biao;
水波__水波 108.357265155|shui bo;
谁不__誰不 357.99085261|shui bu;
水泡__水泡 307.117053725|shui pao;
水瓶__水瓶 419.377126323|shui ping;
水平__水平 18118.4436894|shui ping;
睡梦__睡夢 261.510250403|shui meng;
水面__水面 1062.53280282|shui mian;
睡眠__睡眠 2551.57427517|shui mian;
水墨__水墨 194.636170786|shui mo;
水母__水母 138.680779525|shui mu;
水木__水木 376.756940916|shui mu;
税法__稅法 328.495108513|shui fa;
水分__水分 1509.94683642|shui fen;
水费__水費 231.158356006|shui fei;
税费__稅費 565.579310193|shui fei;
税负__稅負 221.292902041|shui fu;
说服__說服 221.845125512|shui fu;
睡袋__睡袋 209.485777119|shui dai;
水道__水道 186.794397067|shui dao;
睡到__睡到 579.130416613|shui dao;
水稻__水稻 865.055186245|shui dao;
谁的__誰的 511.914293268|shui de;
睡得__睡得 648.673070715|shui de;
水底__水底 187.727829225|shui di;
水滴__水滴 243.275811214|shui di;
水电__水電 985.98464814|shui dian;
水痘__水痘 119.121315407|shui dou;
谁都__誰都 1336.36083843|shui dou;
水塘__水塘 126.779677253|shui tang;
水体__水體 288.924902033|shui ti;
水田__水田 112.906187218|shui tian;
水贴__水貼 138.680779525|shui tie;
水桶__水桶 230.008975843|shui tong;
水土__水土 178.155043976|shui tu;
谁呢__誰呢 243.275811214|shui ne;
谁能__誰能 1493.10664229|shui neng;
水泥__水泥 1944.58043354|shui ni;
水牛__水牛 139.72158175|shui niu;
税率__稅率 846.921892564|shui lv;
谁来__誰來 821.967189047|shui lai;
水冷__水冷 190.081867665|shui leng;
水力__水力 118.08671951|shui li;
水里__水裡 586.392500602|shui li;
水利__水利 1209.56018338|shui li;
水量__水量 360.677581637|shui liang;
水灵__水靈 148.704343794|shui ling;
水流__水流 523.526794166|shui liu;
水路__水路 223.788782324|shui lu;
水管__水管 472.67240572|shui guan;
谁敢__誰敢 328.495108513|shui gan;
睡个__睡個 217.736803143|shui ge;
水沟__水溝 142.891090816|shui gou;
睡过__睡過 210.008536601|shui guo;
水果__水果 3488.59235612|shui guo;
税款__稅款 489.456318842|shui kuan;
水库__水庫 1459.98760728|shui ku;
水花__水花 154.176629937|shui hua;
谁还__誰還 212.377144726|shui hai;
睡好__睡好 292.912705474|shui hao;
水和__水和 117.061109314|shui he;
税后__稅後 329.725485744|shui hou;
水浒__水滸 239.664931108|shui hu;
水壶__水壺 264.130371602|shui hu;
水火__水火 170.551683166|shui huo;
水货__水貨 1470.94484558|shui huo;
谁会__誰會 534.735933039|shui hui;
水军__水軍 119.716577729|shui jun;
水价__水價 260.209952636|shui jia;
谁家__誰家 575.5331706|shui jia;
水煎__水煎 117.792774542|shui jian;
水饺__水餃 224.626982392|shui jiao;
谁叫__誰叫 391.596284031|shui jiao;
睡觉__睡覺 23044.8090197|shui jiao;
水解__水解 171.403948695|shui jie;
税金__稅金 331.37316028|shui jin;
水景__水景 114.321989585|shui jing;
水井__水井 169.915266157|shui jing;
水晶__水晶 2379.58287209|shui jing;
谁就__誰就 164.498187167|shui jiu;
水气__水氣 115.755545596|shui qi;
水汽__水汽 142.891090816|shui qi;
税前__稅前 320.409100324|shui qian;
睡前__睡前 547.548041623|shui qian;
谁去__誰去 163.680258901|shui qu;
睡去__睡去 385.303469841|shui qu;
水区__水區 428.356335222|shui qu;
水洗__水洗 226.312812713|shui xi;
水系__水系 234.64107292|shui xi;
睡下__睡下 144.863304286|shui xia;
水下__水下 472.67240572|shui xia;
谁先__誰先 118.972962872|shui xian;
水仙__水仙 223.231720645|shui xian;
水乡__水鄉 261.184568064|shui xiang;
水箱__水箱 300.679263607|shui xiang;
水星__水星 184.481071779|shui xing;
水性__水性 199.548108896|shui xing;
睡醒__睡醒 682.676889633|shui xing;
水准__水準 1441.90662463|shui zhun;
水闸__水閘 117.207077876|shui zha;
睡着__睡着 2090.33406802|shui zhao;
睡着__睡着 370.702589737|shui zhe;
税制__稅制 142.357889859|shui zhi;
谁知__誰知 531.41444163|shui zhi;
水质__水質 949.804135501|shui zhi;
税种__稅種 175.729586548|shui zhong;
水肿__水腫 550.970372621|shui zhong;
水中__水中 1559.67079644|shui zhong;
水珠__水珠 191.747236314|shui zhu;
水煮__水煮 277.284292303|shui zhu;
水产__水產 499.935980841|shui chan;
水厂__水廠 210.532600599|shui chang;
水城__水城 131.117943492|shui cheng;
水池__水池 389.163898974|shui chi;
水上__水上 629.559803835|shui shang;
水深__水深 192.225730308|shui shen;
水生__水生 134.594525802|shui sheng;
水声__水聲 147.964946673|shui sheng;
谁是__誰是 800.735741689|shui shi;
水手__水手 314.475483928|shui shou;
税收__稅收 2072.17903804|shui shou;
谁说__誰說 1024.81967123|shui shuo;
睡睡__睡睡 118.529012887|shui shui;
谁谁__誰誰 133.758497151|shui shui;
水水__水水 425.165459331|shui shui;
谁让__誰讓 376.756940916|shui rang;
水灾__水災 153.601316766|shui zai;
谁在__誰在 410.07479966|shui zai;
睡在__睡在 506.204995518|shui zai;
水族__水族 115.755545596|shui zu;
水槽__水槽 158.067510349|shui cao;
水草__水草 250.974160423|shui cao;
水色__水色 127.890434962|shui se;
税源__稅源 144.863304286|shui yuan;
水源__水源 628.775756137|shui yuan;
水月__水月 151.699065864|shui yue;
水运__水運 191.031727675|shui yun;
水压__水壓 109.579386421|shui ya;
谁呀__誰呀 203.820597887|shui ya;
水样__水樣 106.085879302|shui yang;
谁要__誰要 503.688011099|shui yao;
谁也__誰也 1086.63578899|shui ye;
睡意__睡意 324.02287532|shui yi;
睡衣__睡衣 718.463208478|shui yi;
水银__水銀 158.067510349|shui yin;
水印__水印 464.497524783|shui yin;
谁又__誰又 270.122027271|shui you;
谁有__誰有 703.402776999|shui you;
水域__水域 481.590928402|shui yu;
水文__水文 300.679263607|shui wen;
水温__水溫 377.697115787|shui wen;
水位__水位 614.828697239|shui wei;
水务__水務 287.846772995|shui wu;
税务__稅務 1163.72451202|shui wu;
谁啊__誰啊 344.85444872|shui a;
水岸__水岸 114.607273411|shui an;
税额__稅額 198.06165195|shui e;
软盘__軟盤 318.815941979|ruan pan;
软体__軟體 230.008975843|ruan ti;
软肋__軟肋 210.008536601|ruan lei;
软管__軟管 135.098649108|ruan guan;
软膏__軟膏 141.29744947|ruan gao;
软骨__軟骨 211.057972369|ruan gu;
软化__軟化 454.760723981|ruan hua;
软件__軟件 31744.050589|ruan jian;
软禁__軟禁 139.200207879|ruan jin;
软驱__軟驅 245.407229187|ruan qu;
软性__軟性 109.30661816|ruan xing;
软软__軟軟 277.630050085|ruan ruan;
软弱__軟弱 581.299547476|ruan ruo;
软银__軟銀 109.716025699|ruan yin;
软硬__軟硬 165.114314527|ruan ying;
软文__軟文 230.295783987|ruan wen;
软卧__軟卧 117.499561272|ruan wo;
润肺__潤肺 123.813152185|run fei;
润肤__潤膚 116.915322539|run fu;
润滑__潤滑 429.425273358|run hua;
润泽__潤澤 154.368879448|run ze;
润色__潤色 125.992190229|run se;
燃煤__燃煤 162.258658377|ran mei;
染发__染髮 196.341441156|ran fa;
燃放__燃放 195.365179853|ran fang;
染料__染料 316.83562918|ran liao;
燃料__燃料 1045.45827538|ran liao;
然后__然後 69601.7846456|ran hou;
染红__染紅 141.121478992|ran hong;
燃起__燃起 264.789493468|ran qi;
燃气__燃氣 699.905273328|ran qi;
染指__染指 106.882056102|ran zhi;
染成__染成 127.890434962|ran cheng;
染上__染上 314.867617017|ran shang;
燃烧__燃燒 2373.65954378|ran shao;
冉冉__冉冉 159.055477247|ran ran;
染色__染色 457.033213363|ran se;
燃油__燃油 742.122873174|ran you;
然而__然而 5807.67552859|ran er;
让步__讓步 499.935980841|rang bu;
让它__讓它 1519.38443361|rang ta;
让她__讓她 4263.67354041|rang ta;
让他__讓他 7960.25098103|rang ta;
让你__讓你 11172.0800441|rang ni;
让您__讓您 1166.62851836|rang nin;
让利__讓利 253.173026121|rang li;
让路__讓路 121.823518492|rang lu;
让给__讓給 223.788782324|rang gei;
让其__讓其 482.191444969|rang qi;
让这__讓這 120.916041011|rang zhe;
嚷着__嚷着 151.510141313|rang zhe;
让出__讓出 115.611384758|rang chu;
嚷嚷__嚷嚷 425.69561654|rang rang;
让人__讓人 14659.4049539|rang ren;
让座__讓座 236.696839161|rang zuo;
让我__讓我 22143.9254191|rang wo;
让爱__讓愛 137.991222203|rang ai;
扰民__擾民 151.321452046|rao min;
绕到__繞到 105.426930997|rao dao;
绕道__繞道 198.06165195|rao dao;
扰乱__擾亂 536.070335228|rao luan;
饶了__饒了 114.46454262|rao le;
绕过__繞過 426.226434824|rao guo;
绕开__繞開 134.594525802|rao kai;
绕行__繞行 133.093414711|rao xing;
绕着__繞着 269.785619908|rao zhe;
绕组__繞組 105.426930997|rao zu;
绕月__繞月 108.898738333|rao yue;
热播__熱播 357.99085261|re bo;
热卖__熱賣 396.012952778|re mai;
热门__熱門 1680.75779471|re men;
热风__熱風 121.368931601|re feng;
热带__熱帶 532.740555233|re dai;
热得__熱得 133.42554153|re de;
惹得__惹得 239.366454718|re de;
热电__熱電 247.866011137|re dian;
热点__熱點 2570.72389483|re dian;
热度__熱度 328.086003878|re du;
热土__熱土 121.520271774|re tu;
热闹__熱鬧 3030.36024751|re nao;
热能__熱能 233.765505073|re neng;
热辣__熱辣 136.622376491|re la;
惹来__惹來 138.508067822|re lai;
热浪__熱浪 167.184787749|re lang;
热泪__熱淚 194.636170786|re lei;
热力__熱力 260.209952636|re li;
热恋__熱戀 316.046952528|re lian;
热疗__熱療 106.882056102|re liao;
热量__熱量 1454.53963438|re liang;
热烈__熱烈 2153.79604997|re lie;
热管__熱管 170.339279748|re guan;
惹火__惹火 148.704343794|re huo;
热火__熱火 242.972837869|re huo;
热键__熱鍵 148.519148841|re jian;
热气__熱氣 420.423657369|re qi;
热钱__熱錢 337.205131359|re qian;
热切__熱切 308.651751439|re qie;
热情__熱情 5807.67552859|re qing;
热血__熱血 748.624851411|re xue;
热线__熱線 1399.42059064|re xian;
热销__熱銷 610.248767154|re xiao;
热心__熱心 1394.19862478|re xin;
热轧__熱軋 111.507918629|re zha;
热衷__熱衷 814.828215816|re zhong;
热炒__熱炒 110.126966673|re chao;
热潮__熱潮 874.811821743|re chao;
热忱__熱忱 256.028470459|re chen;
热诚__熱誠 142.535402072|re cheng;
热身__熱身 352.238065853|re shen;
惹事__惹事 127.254530072|re shi;
热水__熱水 1081.23274995|re shui;
热热__熱熱 173.986383704|re re;
惹人__惹人 296.585723861|re ren;
热刺__熱刺 163.272821143|re ci;
热源__熱源 106.748946222|re yuan;
热议__熱議 218.280152578|re yi;
热吻__熱吻 121.671800659|re wen;
热舞__熱舞 190.556205829|re wu;
热爱__熱愛 2244.21407924|re ai;
人保__人保 127.572086295|ren bao;
人不__人不 635.075580657|ren bu;
人品__人品 1797.75335645|ren pin;
任凭__任憑 369.779825848|ren ping;
人骂__人罵 116.333988795|ren ma;
人吗__人嗎 339.31275934|ren ma;
人马__人馬 459.889800938|ren ma;
人脉__人脈 452.499534015|ren mai;
人们__人們 22618.0450592|ren men;
人面__人面 107.015331962|ren mian;
任免__任免 202.807148249|ren mian;
人民__人民 11554.376787|ren min;
认命__認命 180.839193473|ren ming;
人命__人命 340.15949445|ren ming;
人名__人名 435.352293046|ren ming;
任命__任命 1178.31719254|ren ming;
人防__人防 133.259374649|ren fang;
任副__任副 143.247667161|ren fu;
人大__人大 1567.46464304|ren da;
韧带__韌帶 276.249600432|ren dai;
人道__人道 381.481335404|ren dao;
认得__認得 656.807194196|ren de;
人的__人的 9313.6168469|ren de;
认定__認定 3310.69893679|ren ding;
人都__人都 3479.90844849|ren dou;
人多__人多 1802.23954462|ren duo;
人对__人對 427.290057918|ren dui;
人体__人體 5019.7439743|ren ti;
人头__人頭 429.425273358|ren tou;
忍痛__忍痛 186.794397067|ren tong;
认同__認同 2542.05302484|ren tong;
忍耐__忍耐 669.200026501|ren nai;
人脑__人腦 183.335174792|ren nao;
人呢__人呢 1868.56155133|ren ne;
人能__人能 737.513205869|ren neng;
任你__任你 163.884358899|ren ni;
人来__人來 854.342048866|ren lai;
忍了__忍了 295.479008313|ren le;
认了__認了 306.734573113|ren le;
人类__人類 9656.35583564|ren lei;
人力__人力 1714.60618362|ren li;
人脸__人臉 154.176629937|ren lian;
认领__認領 148.334184528|ren ling;
人流__人流 701.651845929|ren liu;
人敢__人敢 283.221176861|ren gan;
人格__人格 1833.95789167|ren ge;
认购__認購 1085.28250327|ren gou;
人工__人工 2532.56730325|ren gong;
认沽__認沽 281.812926654|ren gu;
人看__人看 252.54282031|ren kan;
任课__任課 126.621787068|ren ke;
认可__認可 3458.29313278|ren ke;
人口__人口 5470.46935761|ren kou;
人话__人話 190.081867665|ren hua;
人海__人海 139.200207879|ren hai;
人还__人還 156.109948588|ren hai;
人行__人行 185.172044961|ren hang;
仁和__仁和 123.967540162|ren he;
人和__人和 255.709615075|ren he;
任何__任何 24926.9370315|ren he;
人很__人很 127.73116145|ren hen;
人会__人會 450.811022973|ren hui;
人均__人均 1859.27057168|ren jun;
人机__人機 108.357265155|ren ji;
人际__人際 443.014235191|ren ji;
人家__人家 25556.0059835|ren jia;
人间__人間 2409.42197254|ren jian;
任教__任教 386.264972075|ren jiao;
人皆__人皆 136.112567367|ren jie;
人就__人就 423.051424808|ren jiu;
人居__人居 177.933171406|ren ju;
人权__人權 1413.4416531|ren quan;
人却__人卻 173.121277629|ren que;
人群__人群 4611.89857437|ren qun;
人妻__人妻 119.41857567|ren qi;
任其__任其 146.679837233|ren qi;
任期__任期 458.745029596|ren qi;
人气__人氣 3585.55753613|ren qi;
人前__人前 124.431860131|ren qian;
认清__認清 477.408200926|ren qing;
人情__人情 748.624851411|ren qing;
人去__人去 564.171453387|ren qu;
任选__任選 188.901181552|ren xuan;
人选__人選 1232.38252249|ren xuan;
人像__人像 381.481335404|ren xiang;
忍心__忍心 759.903909096|ren xin;
人心__人心 1463.63092081|ren xin;
人形__人形 324.02287532|ren xing;
韧性__韌性 393.063006485|ren xing;
任性__任性 746.761352211|ren xing;
人性__人性 2564.32477261|ren xing;
仁兄__仁兄 329.314848809|ren xiong;
认准__認準 192.705418355|ren zhun;
人渣__人渣 453.063775264|ren zha;
忍着__忍着 373.019586361|ren zhe;
忍者__忍者 590.057620516|ren zhe;
认真__認真 10510.2992267|ren zhen;
认证__認證 4122.60245218|ren zheng;
人治__人治 108.627664361|ren zhi;
人之__人之 469.151414294|ren zhi;
人质__人質 517.687984062|ren zhi;
任职__任職 931.053859154|ren zhi;
认知__認知 1413.4416531|ren zhi;
人种__人種 217.19480623|ren zhong;
忍住__忍住 483.394725468|ren zhu;
人潮__人潮 193.90988203|ren chao;
人称__人稱 336.785179346|ren cheng;
人畜__人畜 159.253810404|ren chu;
认出__認出 587.123698784|ren chu;
人少__人少 594.486015613|ren shao;
人参__人蔘 460.463257431|ren shen;
人身__人身 563.46883971|ren shen;
妊娠__妊娠 706.037369534|ren shen;
人声__人聲 286.772667017|ren sheng;
人生__人生 12765.6456146|ren sheng;
人世__人世 453.063775264|ren shi;
人是__人是 553.034030141|ren shi;
人事__人事 2519.9747123|ren shi;
人士__人士 7658.60129638|ren shi;
认识__認識 26695.3177203|ren shi;
人寿__人壽 450.24958728|ren shou;
人手__人手 722.953807881|ren shou;
忍受__忍受 2051.62343063|ren shou;
认输__認輸 293.643651968|ren shu;
人数__人數 4799.5249195|ren shu;
人说__人說 1623.12304424|ren shuo;
忍让__忍讓 171.403948695|ren rang;
人人__人人 2427.50473612|ren ren;
人肉__人肉 311.744192349|ren rou;
人在__人在 2485.66700342|ren zai;
人造__人造 459.889800938|ren zao;
人族__人族 229.436430673|ren zu;
人做__人做 157.085680168|ren zuo;
认罪__認罪 179.71591787|ren zui;
人才__人才 8461.46805279|ren cai;
仁慈__仁慈 298.06779536|ren ci;
人次__人次 381.006242235|ren ci;
认错__認錯 504.944935018|ren cuo;
人死__人死 133.259374649|ren si;
人所__人所 407.527636023|ren suo;
人缘__人緣 383.387639617|ren yuan;
人员__人員 23159.9664663|ren yuan;
人眼__人眼 138.335571213|ren yan;
人要__人要 447.452879516|ren yao;
人妖__人妖 728.379591714|ren yao;
人也__人也 890.207990943|ren ye;
人意__人意 200.04606951|ren yi;
仁义__仁義 206.376433771|ren yi;
任一__任一 271.133768339|ren yi;
任意__任意 2292.26454686|ren yi;
人影__人影 455.895552723|ren ying;
人有__人有 330.136634719|ren you;
任由__任由 425.165459331|ren you;
人用__人用 108.087539034|ren yong;
任用__任用 158.659551632|ren yong;
人鱼__人魚 160.249192015|ren yu;
人与__人與 162.258658377|ren yu;
人文__人文 1380.36844936|ren wen;
人为__人為 1341.36617307|ren wei;
认为__認為 38603.9059762|ren wei;
人无__人無 131.117943492|ren wu;
人物__人物 9620.32295112|ren wu;
任务__任務 35912.1546016|ren wu;
人啊__人啊 743.048258297|ren a;
仁爱__仁愛 147.964946673|ren ai;
人儿__人兒 175.073848088|ren er;
仍不__仍不 367.482952871|reng bu;
扔到__扔到 380.057830188|reng dao;
扔掉__扔掉 556.490650127|reng diao;
扔了__扔了 498.691525358|reng le;
扔给__扔給 135.773751924|reng gei;
仍可__仍可 256.028470459|reng ke;
仍将__仍將 839.566182019|reng jiang;
扔进__扔進 248.484546245|reng jin;
仍旧__仍舊 990.911721928|reng jiu;
扔下__扔下 289.645897197|reng xia;
仍需__仍需 293.643651968|reng xu;
扔出__扔出 109.442917312|reng chu;
仍是__仍是 1532.69625148|reng shi;
仍然__仍然 11213.9250292|reng ran;
扔在__扔在 287.846772995|reng zai;
仍在__仍在 1575.29743635|reng zai;
仍要__仍要 126.621787068|reng yao;
仍以__仍以 215.30841961|reng yi;
仍有__仍有 1411.68136652|reng you;
仍为__仍為 205.094534596|reng wei;
仍未__仍未 661.736546275|reng wei;
日版__日版 235.226605969|ri ban;
日报__日報 1205.04668542|ri bao;
日本__日本 26430.505433|ri ben;
日美__日美 160.249192015|ri mei;
日暮__日暮 542.11647303|ri mu;
日方__日方 294.376422496|ri fang;
日电__日電 1069.17393505|ri dian;
日内__日內 1049.37403554|ri nei;
日立__日立 564.171453387|ri li;
日历__日曆 751.428823061|ri li;
日落__日落 332.614317243|ri luo;
日光__日光 310.968189453|ri guang;
日寇__日寇 158.264611567|ri kou;
日化__日化 124.587019602|ri hua;
日韩__日韓 544.825488702|ri han;
日后__日後 1498.69906777|ri hou;
日货__日貨 371.627656329|ri huo;
日均__日均 289.285174995|ri jun;
日军__日軍 1193.09285994|ri jun;
日记__日記 2635.59999992|ri ji;
日间__日間 107.14877401|ri jian;
日渐__日漸 914.951259653|ri jian;
日久__日久 138.335571213|ri jiu;
日剧__日劇 624.870140032|ri ju;
日起__日起 1293.75623683|ri qi;
日期__日期 5629.53163427|ri qi;
日前__日前 3854.30859085|ri qian;
日趋__日趨 894.656458236|ri qu;
日讯__日訊 194.151676652|ri xun;
日系__日系 341.433560596|ri xi;
日线__日線 248.175085992|ri xian;
日向__日向 160.849404779|ri xiang;
日照__日照 604.195219728|ri zhao;
日志__日誌 5197.98781874|ri zhi;
日中__日中 117.353228453|ri zhong;
日产__日產 449.128812644|ri chan;
日常__日常 3137.96395466|ri chang;
日程__日程 794.770968525|ri cheng;
日出__日出 591.530074736|ri chu;
日式__日式 219.37092252|ri shi;
日日__日日 865.055186245|ri ri;
日子__日子 10277.1672064|ri zi;
日圆__日圓 227.443722742|ri yuan;
日元__日元 1008.35118051|ri yuan;
日月__日月 477.408200926|ri yue;
日夜__日夜 492.515560049|ri ye;
日益__日益 3281.94475852|ri yi;
日用__日用 134.762357541|ri yong;
日语__日語 2202.653757|ri yu;
日晚__日晚 575.5331706|ri wan;
日文__日文 994.623178167|ri wen;
肉棒__肉棒 169.492308033|rou bang;
肉搏__肉搏 137.647730357|rou bo;
肉片__肉片 150.007190589|rou pian;
肉麻__肉麻 449.688850794|rou ma;
柔美__柔美 263.801426189|rou mei;
柔道__柔道 141.121478992|rou dao;
肉体__肉體 1069.17393505|rou ti;
柔嫩__柔嫩 110.126966673|rou nen;
肉牛__肉牛 109.852835359|rou niu;
肉类__肉類 432.648119245|rou lei;
蹂躏__蹂躪 463.341283758|rou lin;
柔和__柔和 840.61307342|rou he;
肉鸡__肉雞 232.893204426|rou ji;
柔情__柔情 568.405572245|rou qing;
肉馅__肉餡 111.091824605|rou xian;
柔性__柔性 242.36802267|rou xing;
揉着__揉着 105.821807183|rou zhe;
肉质__肉質 200.545272755|rou zhi;
柔顺__柔順 131.281440129|rou shun;
肉身__肉身 173.986383704|rou shen;
肉食__肉食 175.073848088|rou shi;
柔软__柔軟 1233.91923358|rou ruan;
揉揉__揉揉 220.467143161|rou rou;
柔柔__柔柔 256.347723437|rou rou;
肉肉__肉肉 368.399985048|rou rou;
柔弱__柔弱 398.48814637|rou ruo;
揉搓__揉搓 154.368879448|rou cuo;
肉丝__肉絲 198.308623594|rou si;
肉眼__肉眼 291.819695868|rou yan;
绒布__絨布 106.483223576|rong bu;
绒毛__絨毛 178.377193209|rong mao;
容貌__容貌 540.767020614|rong mao;
荣登__榮登 128.529517539|rong deng;
溶洞__溶洞 113.895394799|rong dong;
融通__融通 217.736803143|rong tong;
容纳__容納 560.667124391|rong na;
容量__容量 2619.22907324|rong liang;
熔炉__熔爐 239.963779681|rong lu;
熔化__熔化 132.762114633|rong hua;
溶化__溶化 141.121478992|rong hua;
荣华__榮華 168.020228531|rong hua;
融化__融化 607.214449729|rong hua;
融合__融合 2791.09646881|rong he;
荣获__榮獲 965.316430119|rong huo;
容积__容積 245.71323808|rong ji;
溶剂__溶劑 307.883446338|rong ji;
溶解__溶解 493.744603771|rong jie;
融券__融券 194.151676652|rong quan;
容器__容器 1028.65812957|rong qi;
融洽__融洽 440.811451858|rong qia;
荣幸__榮幸 760.851466162|rong xing;
容许__容許 327.677408739|rong xu;
冗长__冗長 161.250795044|rong chang;
榕树__榕樹 185.402943996|rong shu;
容忍__容忍 690.376548199|rong ren;
蓉蓉__蓉蓉 158.264611567|rong rong;
溶入__溶入 119.121315407|rong ru;
荣辱__榮辱 171.190483873|rong ru;
融入__融入 1880.24059249|rong ru;
容灾__容災 128.369448119|rong zai;
融资__融資 2476.39168739|rong zi;
容错__容錯 110.401782066|rong cuo;
容颜__容顏 457.603107852|rong yan;
荣耀__榮耀 700.778015498|rong yao;
溶液__溶液 716.674788535|rong ye;
容易__容易 20142.9541807|rong yi;
荣膺__榮膺 116.915322539|rong ying;
溶于__溶於 182.196395498|rong yu;
冗余__冗餘 395.519762073|rong yu;
荣誉__榮譽 2763.40934226|rong yu;
如不__如不 247.866011137|ru bu;
乳品__乳品 251.914183226|ru pin;
辱骂__辱罵 406.006938516|ru ma;
入门__入門 1338.02720458|ru men;
入梦__入夢 136.112567367|ru meng;
如梦__如夢 246.633556117|ru meng;
入眠__入眠 540.093554591|ru mian;
乳房__乳房 1609.02584897|ru fang;
如风__如風 341.008342538|ru feng;
入党__入黨 579.130416613|ru dang;
蠕动__蠕動 345.715012791|ru dong;
如对__如對 190.081867665|ru dui;
如题__如題 286.415523108|ru ti;
乳头__乳頭 652.727461906|ru tou;
如同__如同 3471.24615709|ru tong;
如图__如圖 766.561672733|ru tu;
如能__如能 224.06783424|ru neng;
入内__入內 155.915530766|ru nei;
如你__如你 187.961915178|ru ni;
如您__如您 194.878871049|ru nin;
如来__如來 358.437246895|ru lai;
入关__入關 156.694657831|ru guan;
如歌__如歌 159.452390871|ru ge;
乳沟__乳溝 284.636464248|ru gou;
入宫__入宮 118.824795093|ru gong;
如故__如故 139.200207879|ru gu;
入股__入股 890.207990943|ru gu;
如果__如果 155100.804393|ru guo;
入口__入口 1506.18823193|ru kou;
入库__入庫 974.988119996|ru ku;
如画__如畫 128.850255419|ru hua;
乳化__乳化 132.431639237|ru hua;
如花__如花 466.237298568|ru hua;
入海__入海 114.607273411|ru hai;
如何__如何 34508.2518349|ru he;
入户__入戶 440.811451858|ru hu;
如火__如火 135.94305409|ru huo;
入伙__入伙 143.247667161|ru huo;
入会__入會 288.205701591|ru hui;
如家__如家 292.183578474|ru jia;
儒家__儒家 646.252534205|ru jia;
如今__如今 5643.57980061|ru jin;
入境__入境 588.588831574|ru jing;
如期__如期 534.735933039|ru qi;
入侵__入侵 1211.06843631|ru qin;
入球__入球 160.449013667|ru qiu;
入选__入選 1070.5071343|ru xuan;
如雪__如雪 207.925293333|ru xue;
儒学__儒學 284.991389772|ru xue;
入学__入學 1093.42757174|ru xue;
如下__如下 7249.97516601|ru xia;
乳腺__乳腺 282.516174301|ru xian;
如新__如新 105.690017726|ru xin;
如需__如需 545.504855178|ru xu;
入账__入賬 250.349428094|ru zhang;
乳汁__乳汁 239.366454718|ru zhi;
入职__入職 474.442798491|ru zhi;
入主__入主 343.139741671|ru zhu;
入驻__入駐 349.178797604|ru zhu;
入住__入住 1197.56158489|ru zhu;
如常__如常 109.579386421|ru chang;
入场__入場 526.142915167|ru chang;
如潮__如潮 222.398727024|ru chao;
蠕虫__蠕蟲 205.60633599|ru chong;
如初__如初 151.510141313|ru chu;
如山__如山 136.282292017|ru shan;
如上__如上 120.765453341|ru shang;
入室__入室 106.748946222|ru shi;
入世__入世 303.691826638|ru shi;
如是__如是 306.352568839|ru shi;
如实__如實 527.455873984|ru shi;
入市__入市 1067.84239617|ru shi;
入手__入手 1458.16935282|ru shou;
如水__如水 524.179602378|ru shui;
入睡__入睡 727.472474808|ru shui;
如若__如若 254.121284766|ru ruo;
如在__如在 291.093289619|ru zai;
如此__如此 18761.8034055|ru ci;
乳酸__乳酸 162.663565352|ru suan;
如斯__如斯 129.655606164|ru si;
入园__入園 149.075426771|ru yuan;
入院__入院 285.346757867|ru yuan;
如愿__如願 404.996293994|ru yuan;
如约__如約 114.893269147|ru yue;
如月__如月 131.281440129|ru yue;
如云__如雲 224.626982392|ru yun;
儒雅__儒雅 208.44415872|ru ya;
如烟__如煙 223.510077937|ru yan;
如要__如要 518.979844093|ru yao;
乳业__乳業 255.391156791|ru ye;
乳液__乳液 380.531740742|ru ye;
如意__如意 934.541117987|ru yi;
如因__如因 410.07479966|ru yin;
如有__如有 2026.2154289|ru you;
如遇__如遇 159.651218957|ru yu;
入狱__入獄 297.325836157|ru yu;
如玉__如玉 451.935995467|ru yu;
入网__入網 309.036622663|ru wang;
入微__入微 107.684208225|ru wei;
入味__入味 119.716577729|ru wei;
入围__入圍 716.674788535|ru wei;
如无__如無 168.229740225|ru wu;
入伍__入伍 247.866011137|ru wu;
入耳__入耳 124.587019602|ru er;
若不__若不 339.735863102|ruo bu;
若非__若非 152.837570606|ruo fei;
偌大__偌大 211.321149687|ruo da;
弱电__弱電 138.163289429|ruo dian;
弱点__弱點 908.135681884|ruo dian;
若能__若能 305.209408115|ruo neng;
若干__若干 2476.39168739|ruo gan;
弱国__弱國 150.944778196|ruo guo;
弱化__弱化 286.058823982|ruo hua;
弱小__弱小 364.745529846|ruo xiao;
弱项__弱項 107.818484324|ruo xiang;
若想__若想 188.901181552|ruo xiang;
弱者__弱者 488.237949645|ruo zhe;
弱智__弱智 878.088426229|ruo zhi;
弱势__弱勢 837.47630896|ruo shi;
若是__若是 1483.83226857|ruo shi;
若水__若水 161.250795044|ruo shui;
若要__若要 458.173712968|ruo yao;
若有__若有 643.039196578|ruo you;
若无__若無 205.350275845|ruo wu;
瑞典__瑞典 1140.75119008|rui dian;
瑞丽__瑞麗 227.443722742|rui li;
锐利__銳利 295.479008313|rui li;
锐减__銳減 173.337150041|rui jian;
瑞金__瑞金 143.0692679|rui jin;
锐气__銳氣 117.061109314|rui qi;
瑞星__瑞星 1659.94271905|rui xing;
锐志__銳志 173.121277629|rui zhi;
睿智__睿智 371.164834837|rui zhi;
瑞士__瑞士 1416.96881393|rui shi;
锐意__銳意 145.768741141|rui yi;
瑞银__瑞銀 176.827946446|rui yin;
瑞安__瑞安 239.963779681|rui an;
钻到__鑽到 119.86585751|zuan dao;
钻头__鑽頭 125.36572391|zuan tou;
钻孔__鑽孔 186.561765129|zuan kong;
钻戒__鑽戒 387.711726118|zuan jie;
钻进__鑽進 548.230802969|zuan jin;
钻井__鑽井 161.049974862|zuan jing;
赚钱__賺錢 264.459727191|zuan qian;
钻出__鑽出 123.504952812|zuan chu;
钻石__鑽石 1687.0530669|zuan shi;
钻研__鑽研 413.667597456|zuan yan;
遵命__遵命 121.217779906|zun ming;
尊贵__尊貴 499.935980841|zun gui;
尊敬__尊敬 1922.89284084|zun jing;
遵循__遵循 1463.63092081|zun xun;
遵照__遵照 277.976239008|zun zhao;
尊者__尊者 118.676811842|zun zhe;
尊重__尊重 5197.98781874|zun zhong;
尊称__尊稱 139.72158175|zun cheng;
尊崇__尊崇 128.529517539|zun chong;
遵守__遵守 3007.78674349|zun shou;
遵从__遵從 246.633556117|zun cong;
尊严__尊嚴 1509.94683642|zun yan;
遵义__遵義 228.295612376|zun yi;
咋办__咋辦 965.316430119|za ban;
杂牌__雜牌 224.06783424|za pai;
砸门__砸門 131.281440129|za men;
咱们__咱們 363.837594448|za men;
杂费__雜費 157.67404401|za fei;
杂谈__雜談 813.813436628|za tan;
杂念__雜念 136.792736844|za nian;
杂乱__雜亂 300.679263607|za luan;
砸了__砸了 566.284555508|za le;
咋个__咋個 1090.70577937|za ge;
杂货__雜貨 153.218967809|za huo;
杂技__雜技 194.393772779|za ji;
杂交__雜交 435.895152658|za jiao;
杂质__雜質 390.135034682|za zhi;
杂志__雜誌 5843.9751525|za zhi;
杂种__雜種 314.083839199|za zhong;
杂事__雜事 174.638049069|za shi;
砸在__砸在 125.209594649|za zai;
杂草__雜草 320.010065926|za cao;
砸死__砸死 195.852702213|za si;
杂碎__雜碎 114.037415895|za sui;
咋样__咋樣 1710.33813502|za yang;
杂音__雜音 224.626982392|za yin;
杂文__雜文 207.149415951|za wen;
杂物__雜物 320.010065926|za wu;
再把__再把 728.379591714|zai ba;
载波__載波 166.146325956|zai bo;
再不__再不 910.401881269|zai bu;
在旁__在旁 117.353228453|zai pang;
栽培__栽培 929.894333673|zai pei;
在马__在馬 1000.83985593|zai ma;
再买__再買 571.958268741|zai mai;
再忙__再忙 198.308623594|zai mang;
在美__在美 145.587202159|zai mei;
再没__再沒 169.070402749|zai mei;
灾民__災民 483.394725468|zai min;
载明__載明 110.401782066|zai ming;
在某__在某 526.798985534|zai mou;
再发__再發 2715.6161094|zai fa;
再放__再放 178.822323044|zai fang;
在大__在大 179.71591787|zai da;
再大__再大 260.209952636|zai da;
再打__再打 388.195180646|zai da;
再到__再到 972.56115063|zai dao;
再等__再等 312.522131716|zai deng;
再点__再點 139.72158175|zai dian;
再顶__再頂 122.127521944|zai ding;
再读__再讀 114.893269147|zai du;
在读__在讀 434.268601197|zai du;
再度__再度 2415.4345439|zai du;
再多__再多 905.87512359|zai duo;
在她__在她 988.445115058|zai ta;
在他__在他 2129.77510916|zai ta;
再谈__再談 240.862563142|zai tan;
再提__再提 218.280152578|zai ti;
载体__載體 1348.06912745|zai ti;
再添__再添 173.769702743|zai tian;
再听__再聽 120.015323434|zai ting;
在听__在聽 195.852702213|zai ting;
再拿__再拿 143.247667161|zai na;
在那__在那 1932.50174796|zai na;
在哪__在哪 2798.06148652|zai na;
灾难__災難 1827.1144412|zai nan;
在内__在內 2586.79165036|zai nei;
在您__在您 105.821807183|zai nin;
再来__再來 2901.02951495|zai lai;
再改__再改 128.209578049|zai gai;
在岗__在崗 175.292155245|zai gang;
再高__再高 173.553291634|zai gao;
在各__在各 343.996026791|zai ge;
再跟__再跟 131.609045271|zai gen;
再给__再給 482.792710347|zai gei;
再过__再過 631.130833438|zai guo;
再开__再開 224.626982392|zai kai;
在看__在看 764.653524665|zai kan;
再看__再看 1621.10162248|zai kan;
载客__載客 117.061109314|zai ke;
在华__在華 579.852559389|zai hua;
再婚__再婚 180.839193473|zai hun;
灾害__災害 1020.99553617|zai hai;
在行__在行 136.452228303|zai hang;
再好__再好 623.314694733|zai hao;
载荷__載荷 230.582949765|zai he;
灾后__災后 341.859308876|zai hou;
在乎__在乎 2400.43116637|zai hu;
灾祸__災禍 109.852835359|zai huo;
再回__再回 294.743493195|zai hui;
在即__在即 363.384474622|zai ji;
再加__再加 2318.11814557|zai jia;
在家__在家 7405.20309201|zai jia;
在建__在建 309.807805448|zai jian;
再建__再建 329.314848809|zai jian;
再见__再見 3114.58889818|zai jian;
再讲__再講 120.015323434|zai jiang;
再降__再降 130.303509496|zai jiang;
再将__再將 387.22887368|zai jiang;
再接__再接 115.036534536|zai jie;
再进__再進 173.553291634|zai jin;
在京__在京 767.517531652|zai jing;
再起__再起 175.948711373|zai qi;
在其__在其 1232.38252249|zai qi;
在前__在前 301.054193591|zai qian;
灾情__災情 384.823616623|zai qing;
灾区__災區 1760.06883632|zai qu;
再去__再去 2577.13898569|zai qu;
再下__再下 108.492380517|zai xia;
在下__在下 395.027185582|zai xia;
再掀__再掀 139.895806636|zai xian;
再现__再現 981.082073059|zai xian;
在线__在線 9814.0643895|zai xian;
在校__在校 817.880151926|zai xiao;
再向__再向 208.70407676|zai xiang;
再想__再想 278.669912425|zai xiang;
宰相__宰相 286.772667017|zai xiang;
在想__在想 953.361623425|zai xiang;
在写__在寫 225.187525865|zai xie;
再写__再寫 243.57916235|zai xie;
在心__在心 133.758497151|zai xin;
在新__在新 328.495108513|zai xin;
再行__再行 148.519148841|zai xing;
再装__再裝 129.817279349|zai zhuang;
再战__再戰 147.964946673|zai zhan;
再找__再找 544.146968302|zai zhao;
再者__再者 188.430963124|zai zhe;
载着__載着 223.788782324|zai zhe;
在这__在這 4200.38893397|zai zhe;
栽植__栽植 152.837570606|zai zhi;
在职__在職 682.676889633|zai zhi;
载重__載重 117.499561272|zai zhong;
栽种__栽種 143.0692679|zai zhong;
仔猪__仔豬 105.426930997|zai zhu;
再传__再傳 131.445140637|zai chuan;
在床__在床 129.171793682|zai chuang;
再创__再創 305.209408115|zai chuang;
在场__在場 1217.12027856|zai chang;
再吃__再吃 292.183578474|zai chi;
再出__再出 175.510734618|zai chu;
宰杀__宰殺 145.405889264|zai sha;
再上__再上 245.407229187|zai shang;
在身__在身 170.76435144|zai shen;
再审__再審 191.269933402|zai shen;
再生__再生 892.429452826|zai sheng;
在世__在世 205.094534596|zai shi;
再试__再試 211.848489234|zai shi;
在手__在手 209.224885556|zai shou;
在说__在說 120.015323434|zai shuo;
再说__再說 10897.0758557|zai shuo;
再让__再讓 233.474375771|zai rang;
载人__載人 129.817279349|zai ren;
载入__載入 547.548041623|zai ru;
仔仔__仔仔 390.135034682|zai zai;
再造__再造 327.677408739|zai zao;
再走__再走 301.805456692|zai zou;
再作__再作 141.29744947|zai zuo;
在座__在座 417.812212206|zai zuo;
再做__再做 667.534233933|zai zuo;
在做__在做 1078.5413133|zai zuo;
在此__在此 4823.50867368|zai ci;
再次__再次 12266.6021738|zai ci;
再从__再從 258.593668656|zai cong;
再三__再三 538.078184713|zai san;
再送__再送 113.611883002|zai song;
再也__再也 3091.3879652|zai ye;
再议__再議 126.937764318|zai yi;
在一__在一 155.333728851|zai yi;
再以__再以 181.290467084|zai yi;
在意__在意 2194.43451055|zai yi;
再由__再由 258.916120291|zai you;
再有__再有 977.421145723|zai you;
在用__在用 179.71591787|zai yong;
再用__再用 1282.5196677|zai yong;
在于__在於 7649.06334831|zai yu;
在外__在外 1326.40613196|zai wai;
再往__再往 239.366454718|zai wang;
再问__再問 374.41672986|zai wen;
在我__在我 3907.50658436|zai wo;
再无__再無 199.051387821|zai wu;
再按__再按 186.097370046|zai an;
暂不__暫不 394.043872187|zan bu;
咱们__咱們 9900.04857808|zan men;
赞美__讚美 970.140222547|zan mei;
暂定__暫定 375.351064872|zan ding;
赞叹__讚歎 485.205278648|zan tan;
暂停__暫停 1824.83897052|zan ting;
赞同__贊同 2143.08680935|zan tong;
咱俩__咱倆 1409.92327219|zan lia;
咱俩__咱倆 130.303509496|zan liang;
赞歌__讚歌 123.504952812|zan ge;
暂缓__暫緩 238.770616634|zan huan;
咱家__咱家 299.1842072|zan jia;
攒钱__攢錢 358.437246895|zan qian;
暂且__暫且 384.344361008|zan qie;
赞许__讚許 202.050369328|zan xu;
暂住__暫住 218.008308584|zan zhu;
赞助__贊助 1370.08592511|zan zhu;
赞成__贊成 1221.67899812|zan cheng;
赞赏__讚賞 732.932171333|zan shang;
暂时__暫時 9740.95828863|zan shi;
赞扬__讚揚 628.775756137|zan yang;
赞誉__讚譽 345.284462654|zan yu;
暂未__暫未 320.010065926|zan wei;
暂无__暫無 539.420927296|zan wu;
藏民__藏民 153.601316766|zang min;
脏腑__臟腑 140.419785869|zang fu;
葬礼__葬禮 355.767206381|zang li;
赃款__贓款 135.098649108|zang kuan;
脏话__髒話 520.274927886|zang hua;
脏器__臟器 189.608710238|zang qi;
藏区__藏區 120.615053212|zang qu;
藏人__藏人 157.2815571|zang ren;
藏族__藏族 569.114341748|zang zu;
葬送__葬送 118.381397999|zang song;
赃物__贓物 111.507918629|zang wu;
藏獒__藏獒 306.352568839|zang ao;
早班__早班 136.792736844|zao ban;
早报__早報 262.489736092|zao bao;
早盘__早盤 399.980682268|zao pan;
糟粕__糟粕 127.73116145|zao po;
造反__造反 603.442760838|zao fan;
早饭__早飯 1128.02857559|zao fan;
造访__造訪 210.270405333|zao fang;
造福__造福 374.41672986|zao fu;
早稻__早稻 117.353228453|zao dao;
遭到__遭到 2826.09579953|zao dao;
噪点__噪點 178.377193209|zao dian;
早点__早點 6242.98270412|zao dian;
躁动__躁動 201.045721733|zao dong;
糟蹋__糟蹋 571.245957438|zao ta;
澡堂__澡堂 181.290467084|zao tang;
早退__早退 135.267109459|zao tui;
早年__早年 584.932834985|zao nian;
造孽__造孽 159.055477247|zao nie;
早恋__早戀 191.98633424|zao lian;
造林__造林 353.117055307|zao lin;
早该__早該 180.389043185|zao gai;
糟糕__糟糕 1513.71482027|zao gao;
造化__造化 230.870473623|zao hua;
造价__造價 506.204995518|zao jia;
造假__造假 728.379591714|zao jia;
造就__造就 1182.73057528|zao jiu;
早就__早就 5395.99270938|zao jiu;
早起__早起 826.074649543|zao qi;
早期__早期 3041.71045076|zao qi;
早前__早前 347.00988711|zao qian;
造血__造血 168.649547684|zao xue;
早先__早先 215.040276584|zao xian;
早泄__早泄 252.85772688|zao xie;
早些__早些 495.593922384|zao xie;
造型__造型 3657.76624243|zao xing;
枣庄__棗莊 135.604660605|zao zhuang;
早知__早知 152.077621994|zao zhi;
造纸__造紙 298.06779536|zao zhi;
造船__造船 313.69268222|zao chuan;
早春__早春 177.269210225|zao chun;
早茶__早茶 108.763116896|zao cha;
早产__早產 141.650048976|zao chan;
造车__造車 118.08671951|zao che;
早晨__早晨 2698.74816577|zao chen;
造成__造成 17606.5075124|zao cheng;
造出__造出 232.893204426|zao chu;
早上__早上 12909.6245805|zao shang;
噪声__噪聲 876.994863387|zao sheng;
早逝__早逝 146.132498493|zao shi;
造势__造勢 316.441045148|zao shi;
遭受__遭受 1824.83897052|zao shou;
早熟__早熟 297.325836157|zao shu;
早说__早說 424.107124851|zao shuo;
早睡__早睡 287.488291405|zao shui;
燥热__燥熱 159.253810404|zao re;
遭人__遭人 191.269933402|zao ren;
早日__早日 1440.11088805|zao ri;
早在__早在 1361.57568978|zao zai;
早早__早早 1126.6237397|zao zao;
造作__造作 143.784200776|zao zuo;
早餐__早餐 1607.02198372|zao can;
早死__早死 114.46454262|zao si;
早孕__早孕 116.915322539|zao yun;
遭殃__遭殃 166.353500999|zao yang;
造谣__造謠 362.479927203|zao yao;
造诣__造詣 249.726250867|zao yi;
早已__早已 4107.21887886|zao yi;
噪音__噪音 1187.16048834|zao yin;
造影__造影 160.649084484|zao ying;
早有__早有 473.261801395|zao you;
早于__早於 132.431639237|zao yu;
遭遇__遭遇 3773.51454358|zao yu;
早晚__早晚 1257.20118645|zao wan;
早安__早安 228.295612376|zao an;
责备__責備 320.010065926|ze bei;
责编__責編 134.42690308|ze bian;
则不__則不 233.765505073|ze bu;
责骂__責罵 140.244908425|ze ma;
泽民__澤民 165.526347625|ze min;
责难__責難 116.47905068|ze nan;
则能__則能 167.184787749|ze neng;
责令__責令 757.068312494|ze ling;
责怪__責怪 445.228026075|ze guai;
则可__則可 367.482952871|ze ke;
则会__則會 554.41409416|ze hui;
择机__擇機 113.32907693|ze ji;
则将__則將 242.36802267|ze jiang;
择校__擇校 107.282382453|ze xiao;
则需__則需 119.716577729|ze xu;
责成__責成 186.097370046|ze cheng;
则是__則是 4617.64935026|ze shi;
则说__則說 109.30661816|ze shuo;
责任__責任 11033.7212085|ze ren;
则在__則在 511.276760152|ze zai;
啧啧__嘖嘖 527.455873984|ze ze;
则从__則從 111.230349808|ze cong;
则要__則要 323.216307961|ze yao;
择业__擇業 173.769702743|ze ye;
则以__則以 363.837594448|ze yi;
则应__則應 229.150692759|ze ying;
择优__擇優 209.746993999|ze you;
则由__則由 263.472890441|ze you;
则有__則有 390.621510938|ze you;
则用__則用 107.952927857|ze yong;
责问__責問 107.818484324|ze wen;
则为__則為 472.67240572|ze wei;
择偶__擇偶 153.41002317|ze ou;
怎么__怎麼 173077.229275|zen me;
怎能__怎能 725.661628731|zen neng;
怎会__怎會 312.522131716|zen hui;
怎样__怎樣 14659.4049539|zen yang;
增白__增白 125.835280772|zeng bai;
增补__增補 175.292155245|zeng bu;
赠品__贈品 536.070335228|zeng pin;
增发__增發 861.827215553|zeng fa;
增肥__增肥 195.365179853|zeng fei;
增幅__增幅 1202.04704744|zeng fu;
增大__增大 1672.40062475|zeng da;
增多__增多 1829.39274925|zeng duo;
增添__增添 1243.1798239|zeng tian;
增量__增量 569.823995046|zeng liang;
增高__增高 597.456727653|zeng gao;
憎恨__憎恨 275.905561849|zeng hen;
增厚__增厚 151.132997772|zeng hou;
增加__增加 26070.6724228|zeng jia;
增减__增減 275.561951728|zeng jian;
增进__增進 831.23785106|zeng jin;
增强__增強 6448.56995722|zeng qiang;
增效__增效 204.07475061|zeng xiao;
增长__增長 12069.4822026|zeng zhang;
增殖__增殖 260.209952636|zeng zhi;
增至__增至 326.454673948|zeng zhi;
增值__增值 1585.14349339|zeng zhi;
增产__增產 431.033684153|zeng chan;
增城__增城 128.529517539|zeng cheng;
增持__增持 499.935980841|zeng chi;
增设__增設 416.772181646|zeng she;
增生__增生 401.478808454|zeng sheng;
增收__增收 610.248767154|zeng shou;
增资__增資 383.865702254|zeng zi;
增仓__增倉 184.71110921|zeng cang;
增色__增色 107.818484324|zeng se;
赠送__贈送 1850.02578923|zeng song;
增速__增速 1136.49445424|zeng su;
增援__增援 202.807148249|zeng yuan;
增压__增壓 111.091824605|zeng ya;
增益__增益 301.805456692|zeng yi;
赠与__贈與 178.155043976|zeng yu;
憎恶__憎惡 137.134095104|zeng wu;
自拔__自拔 261.83633885|zi ba;
自白__自白 124.122120652|zi bai;
自保__自保 167.810977762|zi bao;
自曝__自曝 209.224885556|zi bao;
自爆__自爆 318.022335873|zi bao;
资本__資本 4902.28669206|zi ben;
自备__自備 248.175085992|zi bei;
自卑__自卑 974.988119996|zi bei;
自闭__自閉 182.651055928|zi bi;
自编__自編 207.149415951|zi bian;
淄博__淄博 429.960742313|zi bo;
滋补__滋補 302.181790975|zi bu;
自拍__自拍 795.762002835|zi pai;
自评__自評 112.765574943|zi ping;
姊妹__姊妹 388.679238014|zi mei;
字面__字面 277.630050085|zi mian;
子民__子民 134.594525802|zi min;
自明__自明 127.572086295|zi ming;
自摸__自摸 181.064689688|zi mo;
字幕__字幕 1983.741885|zi mu;
字母__字母 4571.84317933|zi mu;
自发__自發 819.921123923|zi fa;
自焚__自焚 148.334184528|zi fen;
自费__自費 520.923681206|zi fei;
资费__資費 967.72532071|zi fei;
自负__自負 802.733930815|zi fu;
字符__字符 1998.62991039|zi fu;
字段__字段 2358.91565003|zi duan;
自打__自打 149.447435764|zi da;
自大__自大 280.761336094|zi da;
自带__自帶 1513.71482027|zi dai;
自担__自擔 532.077085292|zi dan;
子弹__子彈 1118.23138914|zi dan;
自导__自導 121.520271774|zi dao;
子弟__子弟 503.688011099|zi di;
字典__字典 982.305426747|zi dian;
自定__自定 163.272821143|zi ding;
自动__自動 13006.5115898|zi dong;
姿态__姿態 1619.08271818|zi tai;
自提__自提 116.18910757|zi ti;
自体__自體 138.335571213|zi ti;
字体__字體 3462.60542812|zi ti;
字条__字條 131.281440129|zi tiao;
字头__字頭 210.795122809|zi tou;
自虐__自虐 254.121284766|zi nue;
子女__子女 2662.00658024|zi nv;
自律__自律 546.185068786|zi lv;
自来__自來 110.539446825|zi lai;
子类__子類 202.554574186|zi lei;
自理__自理 357.099731154|zi li;
自立__自立 387.22887368|zi li;
资历__資歷 392.573489614|zi li;
自恋__自戀 716.674788535|zi lian;
资料__資料 20370.1390643|zi liao;
子龙__子龍 138.163289429|zi long;
子路__子路 137.476305203|zi lu;
紫光__紫光 643.841029976|zi guang;
自个__自個 220.19257551|zi ge;
资格__資格 4835.54545696|zi ge;
自宫__自宮 111.369047744|zi gong;
自贡__自貢 211.057972369|zi gong;
子宫__子宮 1321.45662101|zi gong;
自顾__自顧 226.877563077|zi gu;
自古__自古 547.548041623|zi gu;
自考__自考 724.757896749|zi kao;
自控__自控 222.398727024|zi kong;
字库__字庫 298.439468992|zi ku;
字画__字畫 167.184787749|zi hua;
字号__字號 327.677408739|zi hao;
自豪__自豪 1308.34803192|zi hao;
自毁__自毀 108.627664361|zi hui;
自觉__自覺 2735.99686654|zi jue;
子集__子集 112.065135969|zi ji;
字迹__字跡 251.914183226|zi ji;
自己__自己 239007.522358|zi ji;
自驾__自駕 260.209952636|zi jia;
自家__自家 1157.93816758|zi jia;
自荐__自薦 156.694657831|zi jian;
自建__自建 253.173026121|zi jian;
自检__自檢 255.073095111|zi jian;
字节__字節 993.38448407|zi jie;
自尽__自盡 178.377193209|zi jin;
紫金__紫金 244.186999878|zi jin;
资金__資金 17280.4547831|zi jin;
紫荆__紫荊 141.826678552|zi jing;
自救__自救 456.464028614|zi jiu;
字句__字句 153.792848894|zi ju;
自居__自居 211.848489234|zi ju;
自强__自強 305.589986932|zi qiang;
自取__自取 143.0692679|zi qu;
自选__自選 295.479008313|zi xuan;
自学__自學 881.377303227|zi xue;
资讯__資訊 3754.75163646|zi xun;
咨询__諮詢 7395.98072362|zi xun;
自习__自習 787.868200695|zi xi;
仔细__仔細 6059.03211339|zi xi;
紫霞__紫霞 159.253810404|zi xia;
自小__自小 237.583386308|zi xiao;
资信__資信 170.551683166|zi xin;
自信__自信 3976.27638265|zi xin;
字型__字型 142.891090816|zi xing;
自省__自省 152.837570606|zi xing;
字形__字形 240.263000901|zi xing;
自行__自行 2966.83781195|zi xing;
自修__自修 163.680258901|zi xiu;
自诩__自詡 181.290467084|zi xu;
自传__自傳 336.785179346|zi zhuan;
自找__自找 200.29551561|zi zhao;
自知__自知 319.611528482|zi zhi;
自治__自治 575.5331706|zi zhi;
自制__自製 822.992135502|zi zhi;
资质__資質 1334.69654755|zi zhi;
自重__自重 262.162833911|zi zhong;
仔猪__仔豬 105.426930997|zi zhu;
紫竹__紫竹 109.30661816|zi zhu;
自住__自住 230.295783987|zi zhu;
自助__自助 1002.08784645|zi zhu;
资助__資助 1813.50405438|zi zhu;
自主__自主 2031.27173079|zi zhu;
字串__字串 106.748946222|zi chuan;
自创__自創 293.643651968|zi chuang;
自查__自查 312.522131716|zi cha;
自产__自產 150.944778196|zi chan;
资产__資產 7706.46973279|zi chan;
自嘲__自嘲 257.94996962|zi chao;
自成__自成 195.365179853|zi cheng;
自称__自稱 1458.16935282|zi cheng;
自筹__自籌 122.127521944|zi chou;
紫砂__紫砂 128.850255419|zi sha;
自杀__自殺 3102.96674755|zi sha;
资深__資深 1651.68904712|zi shen;
自身__自身 8060.06962211|zi shen;
滋生__滋生 423.578945935|zi sheng;
自是__自是 130.791560815|zi shi;
姿势__姿勢 1988.69219664|zi shi;
自首__自首 285.702569086|zi shou;
自述__自述 208.70407676|zi shu;
字数__字數 675.063104121|zi shu;
滋润__滋潤 1184.20537322|zi run;
自燃__自燃 119.56748386|zi ran;
自然__自然 16522.3512945|zi ran;
自认__自認 314.475483928|zi ren;
自如__自如 498.691525358|zi ru;
自尊__自尊 781.025384985|zi zun;
自在__自在 913.811788194|zi zai;
自责__自責 457.033213363|zi ze;
字字__字字 117.646076559|zi zi;
姊姊__姊姊 128.529517539|zi zi;
紫菜__紫菜 190.793818607|zi cai;
自残__自殘 138.680779525|zi can;
自测__自測 110.264288753|zi ce;
字词__字詞 130.141230764|zi ci;
自此__自此 275.561951728|zi ci;
自从__自從 3161.51444144|zi cong;
子孙__子孫 603.442760838|zi sun;
姿色__姿色 225.749468142|zi se;
紫色__紫色 1611.03221293|zi se;
自私__自私 1461.808129|zi si;
自愿__自願 1441.90662463|zi yuan;
资源__資源 18118.4436894|zi yuan;
紫云__紫雲 105.0335283|zi yun;
字眼__字眼 625.649317648|zi yan;
滋养__滋養 366.111682898|zi yang;
字样__字樣 785.907015785|zi yang;
子夜__子夜 157.67404401|zi ye;
紫衣__紫衣 127.572086295|zi yi;
恣意__恣意 132.266710153|zi yi;
子怡__子怡 151.321452046|zi yi;
自已__自已 1470.94484558|zi yi;
滋阴__滋陰 160.649084484|zi yin;
自营__自營 279.713669565|zi ying;
自幼__自幼 259.562230298|zi you;
自有__自有 1055.93292173|zi you;
自由__自由 11801.7654889|zi you;
自用__自用 322.813777494|zi yong;
紫外__紫外 128.850255419|zi wai;
子网__子網 204.584007193|zi wang;
自问__自問 148.334184528|zi wen;
自卫__自衛 202.807148249|zi wei;
紫薇__紫薇 233.474375771|zi wei;
自慰__自慰 693.826435782|zi wei;
滋味__滋味 1472.77903036|zi wei;
自我__自我 7891.11437871|zi wo;
自爱__自愛 130.303509496|zi ai;
自傲__自傲 105.821807183|zi ao;
走吧__走吧 1000.83985593|zou ba;
走遍__走遍 261.83633885|zou bian;
走马__走馬 106.882056102|zou ma;
走访__走訪 952.17431607|zou fang;
走道__走道 145.224802174|zou dao;
走到__走到 4311.76192745|zou dao;
走得__走得 859.681929668|zou de;
走的__走的 1173.92027842|zou de;
走低__走低 480.392137969|zou di;
走掉__走掉 196.096919422|zou diao;
走动__走動 501.183541788|zou dong;
走来__走來 623.314694733|zou lai;
走廊__走廊 1054.61787307|zou lang;
走了__走了 8450.93022222|zou le;
走路__走路 2167.25788788|zou lu;
走光__走光 557.879339939|zou guang;
走高__走高 651.102673334|zou gao;
走狗__走狗 232.313479749|zou gou;
走过__走過 2507.44473504|zou guo;
走开__走開 758.957532109|zou kai;
走好__走好 513.831666385|zou hao;
走后__走後 346.577724349|zou hou;
走红__走紅 438.619621343|zou hong;
走回__走回 172.475272126|zou hui;
走近__走近 647.058374454|zou jin;
走进__走進 3703.63329569|zou jin;
走俏__走俏 138.680779525|zou qiao;
走强__走強 494.360275282|zou qiang;
走去__走去 908.135681884|zou qu;
走下__走下 220.742053181|zou xia;
奏效__奏效 224.06783424|zou xiao;
奏响__奏響 126.621787068|zou xiang;
走向__走向 4076.62373033|zou xiang;
走秀__走秀 150.569041974|zou xiu;
走着__走着 686.088301175|zou zhe;
走出__走出 3157.5771219|zou chu;
走上__走上 1530.78744637|zou shang;
走神__走神 158.264611567|zou shen;
走失__走失 111.230349808|zou shi;
走时__走時 139.72158175|zou shi;
走势__走勢 3381.58372161|zou shi;
走人__走人 1276.14264248|zou ren;
走入__走入 568.405572245|zou ru;
走弱__走弱 113.187937993|zou ruo;
走在__走在 1762.26354231|zou zai;
走走__走走 1152.18059436|zou zou;
走错__走錯 284.281980745|zou cuo;
走私__走私 697.293562832|zou si;
走远__走遠 228.295612376|zou yuan;
走运__走運 149.261315371|zou yun;
走完__走完 367.941183266|zou wan;
总比__總比 899.127155009|zong bi;
总编__總編 225.187525865|zong bian;
总不__總不 127.890434962|zong bu;
总部__總部 3625.99770514|zong bu;
总分__總分 463.341283758|zong fen;
总代__總代 167.601987591|zong dai;
总的__總的 325.236501817|zong de;
总得__總得 520.923681206|zong dei;
总店__總店 146.132498493|zong dian;
总督__總督 245.101601395|zong du;
纵队__縱隊 184.02185602|zong dui;
总队__總隊 433.187606905|zong dui;
总体__總體 4698.91724004|zong ti;
总统__總統 3475.57460412|zong tong;
总能__總能 778.110973173|zong neng;
棕榈__棕櫚 105.690017726|zong lv;
总理__總理 2908.26886413|zong li;
总量__總量 2077.35003942|zong liang;
综观__綜觀 118.23396695|zong guan;
总管__總管 318.815941979|zong guan;
纵观__縱觀 374.883606282|zong guan;
总工__總工 105.426930997|zong gong;
总共__總共 2087.73078616|zong gong;
总归__總歸 734.761160623|zong gui;
总行__總行 475.626742696|zong hang;
总和__總和 445.228026075|zong he;
综合__綜合 9129.7548451|zong he;
纵横__縱橫 656.807194196|zong heng;
总汇__總匯 131.937467932|zong hui;
总会__總會 2485.66700342|zong hui;
总觉__總覺 111.091824605|zong jue;
总机__總機 218.280152578|zong ji;
踪迹__蹤跡 275.218769535|zong ji;
总计__總計 950.988487375|zong ji;
总价__總價 686.943814365|zong jia;
总监__總監 1723.1742594|zong jian;
宗教__宗教 2488.76648916|zong jiao;
总结__總結 7142.36565495|zong jie;
总局__總局 727.472474808|zong ju;
纵情__縱情 115.899886195|zong qing;
总线__總線 666.702893247|zong xian;
总想__總想 448.010827873|zong xiang;
纵向__縱向 528.113581536|zong xiang;
总装__總裝 123.044091616|zong zhuang;
总站__總站 315.653350706|zong zhan;
综指__綜指 310.194118206|zong zhi;
总值__總值 314.475483928|zong zhi;
宗旨__宗旨 1416.96881393|zong zhi;
总之__總之 2770.30526836|zong zhi;
总长__總長 120.015323434|zong chang;
总厂__總廠 187.26053154|zong chang;
总称__總稱 106.616002115|zong cheng;
总成__總成 205.094534596|zong cheng;
总社__總社 107.550099352|zong she;
纵身__縱身 144.682892926|zong shen;
纵深__縱深 285.346757867|zong shen;
宗师__宗師 193.186303435|zong shi;
纵使__縱使 268.444174826|zong shi;
总是__總是 19476.4893496|zong shi;
总署__總署 108.627664361|zong shu;
综述__綜述 692.962351041|zong shu;
总数__總數 1782.13945694|zong shu;
总说__總說 300.304800557|zong shuo;
纵然__縱然 394.043872187|zong ran;
纵容__縱容 384.823616623|zong rong;
总在__總在 466.237298568|zong zai;
总则__總則 112.484875527|zong ze;
粽子__粽子 942.728934628|zong zi;
宗族__宗族 121.520271774|zong zu;
总裁__總裁 3327.2428637|zong cai;
总算__總算 2095.55037421|zong suan;
棕色__棕色 349.614203755|zong se;
总要__總要 1298.60199609|zong yao;
总也__總也 119.56748386|zong ye;
综艺__綜藝 338.046607007|zong yi;
踪影__蹤影 342.285588041|zong ying;
总有__總有 1996.14083601|zong you;
纵欲__縱慾 169.28122395|zong yu;
总务__總務 120.314814642|zong wu;
总爱__總愛 143.963491517|zong ai;
总额__總額 1555.7884176|zong e;
祖辈__祖輩 117.792774542|zu bei;
组别__組別 111.646962678|zu bie;
组播__組播 143.426288875|zu bo;
足部__足部 123.967540162|zu bu;
祖母__祖母 295.847453874|zu mu;
租房__租房 1408.16736736|zu fang;
组分__組分 193.427195796|zu fen;
祖父__祖父 393.553133755|zu fu;
阻断__阻斷 307.500011268|zu duan;
阻挡__阻擋 709.565515965|zu dang;
祖德__祖德 116.915322539|zu de;
足底__足底 240.862563142|zu di;
组队__組隊 1282.5196677|zu dui;
组团__組團 607.9716117|zu tuan;
足坛__足壇 330.136634719|zu tan;
组图__組圖 243.275811214|zu tu;
阻挠__阻撓 318.815941979|zu nao;
阻尼__阻尼 154.947067523|zu ni;
阻拦__阻攔 273.850309404|zu lan;
租了__租了 294.009808944|zu le;
足了__足了 301.429591092|zu le;
组里__組裡 113.895394799|zu li;
阻力__阻力 1046.76190254|zu li;
租赁__租賃 1358.18641516|zu lin;
阻隔__阻隔 263.801426189|zu ge;
租给__租給 148.334184528|zu gei;
足够__足夠 5976.54259122|zu gou;
祖国__祖國 2702.11335163|zu guo;
阻抗__阻抗 243.882891747|zu kang;
组合__組合 5895.17610672|zu he;
租户__租戶 113.187937993|zu hu;
祖籍__祖籍 238.176261728|zu ji;
阻击__阻擊 238.770616634|zu ji;
足迹__足跡 651.102673334|zu ji;
足见__足見 176.60772663|zu jian;
组件__組件 2224.72256613|zu jian;
组建__組建 2385.52098173|zu jian;
租界__租界 132.266710153|zu jie;
租借__租借 270.122027271|zu jie;
租金__租金 1496.83260243|zu jin;
族群__族群 285.702569086|zu qun;
足球__足球 4470.43378899|zu qiu;
祖先__祖先 793.781168439|zu xian;
足协__足協 826.074649543|zu xie;
组装__組裝 962.913535809|zu zhuang;
族长__族長 203.820597887|zu zhang;
组长__組長 1277.73391996|zu zhang;
阻滞__阻滯 156.499511818|zu zhi;
阻止__阻止 2403.42436786|zu zhi;
组织__組織 25176.6847796|zu zhi;
诅咒__詛咒 1356.49494292|zu zhou;
租住__租住 220.19257551|zu zhu;
祖传__祖傳 116.47905068|zu chuan;
租车__租車 380.531740742|zu che;
组成__組成 6553.88863641|zu cheng;
祖上__祖上 155.140277726|zu shang;
祖师__祖師 174.638049069|zu shi;
租售__租售 120.314814642|zu shou;
阻燃__阻燃 125.36572391|zu ran;
族人__族人 315.653350706|zu ren;
祖宗__祖宗 516.399339766|zu zong;
足足__足足 521.573243485|zu zu;
足彩__足彩 225.187525865|zu cai;
阻塞__阻塞 129.979154132|zu sai;
阻塞__阻塞 426.226434824|zu se;
组员__組員 241.162905094|zu yuan;
足矣__足矣 175.729586548|zu yi;
足以__足以 2561.13118731|zu yi;
足有__足有 174.42055653|zu you;
租用__租用 774.242000696|zu yong;
组网__組網 231.735198139|zu wang;
阻碍__阻礙 1182.73057528|zu ai;
足额__足額 284.636464248|zu e;
作罢__作罷 207.149415951|zuo ba;
左臂__左臂 109.170488754|zuo bi;
作弊__作弊 1298.60199609|zuo bi;
左边__左邊 2801.55051046|zuo bian;
坐标__坐標 1425.82527204|zuo biao;
左派__左派 268.109857044|zuo pai;
作品__作品 13301.5573221|zuo pin;
坐满__坐滿 146.497163581|zuo man;
做梦__做夢 1749.13623734|zuo meng;
左面__左面 241.764712994|zuo mian;
琢磨__琢磨 627.210588862|zuo mo;
作法__作法 347.875829952|zuo fa;
做法__做法 5497.80589498|zuo fa;
做饭__做飯 2833.14815601|zuo fan;
作坊__作坊 268.444174826|zuo fang;
作风__作風 1469.11294508|zuo feng;
作废__作廢 450.24958728|zuo fei;
作答__作答 189.136730609|zuo da;
做大__做大 730.197220308|zuo da;
坐到__坐到 661.736546275|zuo dao;
做到__做到 8514.35463478|zuo dao;
做得__做得 2564.32477261|zuo de;
做的__做的 6242.98270412|zuo de;
坐垫__坐墊 122.584950132|zuo dian;
做点__做點 970.140222547|zuo dian;
做掉__做掉 130.46599058|zuo diao;
做多__做多 482.191444969|zuo duo;
作对__作對 212.641966978|zuo dui;
坐台__坐台 107.550099352|zuo tai;
座谈__座談 504.316081474|zuo tan;
佐藤__佐藤 141.826678552|zuo teng;
做题__做題 361.577631409|zuo ti;
昨天__昨天 38603.9059762|zuo tian;
做图__做圖 150.944778196|zuo tu;
左腿__左腿 172.260473089|zuo tui;
作孽__作孽 313.69268222|zuo nie;
坐牢__坐牢 282.516174301|zuo lao;
坐了__坐了 853.278059532|zuo le;
作了__作了 2461.00967693|zuo le;
做了__做了 9924.75356924|zuo le;
佐料__佐料 136.282292017|zuo liao;
左路__左路 350.486645516|zuo lu;
坐落__坐落 435.895152658|zuo luo;
做官__做官 221.292902041|zuo guan;
作怪__作怪 260.209952636|zuo guai;
作个__作個 187.961915178|zuo ge;
做个__做個 3253.44031687|zuo ge;
做工__做工 1194.58057905|zuo gong;
坐过__坐過 252.85772688|zuo guo;
做过__做過 3750.07550505|zuo guo;
作客__作客 295.847453874|zuo ke;
做客__做客 905.87512359|zuo ke;
做空__做空 350.92368248|zuo kong;
作画__作畫 189.845141544|zuo hua;
作好__作好 364.291279287|zuo hao;
做好__做好 10549.6655141|zuo hao;
做回__做回 110.95347192|zuo hui;
座机__座機 487.02261325|zuo ji;
作价__作價 118.381397999|zuo jia;
作假__作假 219.097720093|zuo jia;
作家__作家 2875.83340941|zuo jia;
左键__左鍵 241.463621556|zuo jian;
左脚__左腳 444.119751258|zuo jiao;
坐骑__坐騎 504.944935018|zuo qi;
做起__做起 1086.63578899|zuo qi;
做强__做強 254.438159592|zuo qiang;
作曲__作曲 393.553133755|zuo qu;
作息__作息 284.281980745|zuo xi;
座席__座席 296.585723861|zuo xi;
左下__左下 150.756793028|zuo xia;
坐下__坐下 1247.83614939|zuo xia;
作响__作響 243.57916235|zuo xiang;
作协__作協 191.031727675|zuo xie;
做些__做些 806.745280603|zuo xie;
做秀__做秀 123.658956482|zuo xiu;
作秀__作秀 284.636464248|zuo xiu;
左转__左轉 206.376433771|zuo zhuan;
坐庄__坐莊 132.431639237|zuo zhuang;
作战__作戰 2583.57008503|zuo zhan;
做帐__做帳 157.67404401|zuo zhang;
做着__做着 675.063104121|zuo zhe;
坐着__坐着 1740.43907177|zuo zhe;
作者__作者 10681.954468|zuo zhe;
坐镇__坐鎮 179.268563673|zuo zhen;
佐证__佐證 199.796934068|zuo zheng;
作证__作證 325.236501817|zuo zheng;
佐助__佐助 114.893269147|zuo zhu;
作主__作主 141.473639374|zuo zhu;
做主__做主 427.290057918|zuo zhu;
坐船__坐船 219.097720093|zuo chuan;
坐车__坐車 1641.42964497|zuo che;
作成__作成 433.727767276|zuo cheng;
做成__做成 1836.24473312|zuo cheng;
座充__座充 133.259374649|zuo chong;
做出__做出 7259.01547376|zuo chu;
作出__作出 7460.77930003|zuo chu;
座山__座山 135.604660605|zuo shan;
座上__座上 107.684208225|zuo shang;
左上__左上 166.146325956|zuo shang;
坐上__坐上 587.855808729|zuo shang;
作诗__作詩 112.065135969|zuo shi;
做事__做事 3141.87681769|zuo shi;
左手__左手 1708.20809643|zuo shou;
做人__做人 2172.66615296|zuo ren;
昨日__昨日 4263.67354041|zuo ri;
坐在__坐在 7331.74493768|zuo zai;
坐姿__坐姿 178.377193209|zuo zi;
做足__做足 178.155043976|zuo zu;
做作__做作 449.688850794|zuo zuo;
坐坐__坐坐 688.658042404|zuo zuo;
做做__做做 833.312156414|zuo zuo;
做菜__做菜 382.433299725|zuo cai;
左侧__左側 1257.20118645|zuo ce;
作词__作詞 192.465424888|zuo ci;
做错__做錯 623.314694733|zuo cuo;
作祟__作祟 183.792676978|zuo sui;
左眼__左眼 217.465635832|zuo yan;
昨夜__昨夜 526.142915167|zuo ye;
作业__作業 5757.23453692|zuo ye;
做一__做一 152.647228173|zuo yi;
左翼__左翼 263.801426189|zuo yi;
座椅__座椅 810.776675547|zuo yi;
左右__左右 18902.6111425|zuo you;
作用__作用 20651.2920909|zuo yong;
做完__做完 2545.22282076|zuo wan;
昨晚__昨晚 5991.45670308|zuo wan;
作文__作文 1731.7851508|zuo wen;
做为__做為 1649.63204954|zuo wei;
座位__座位 2183.52320481|zuo wei;
作为__作為 37936.2504684|zuo wei;
作物__作物 716.674788535|zuo wu;
做爱__做愛 2306.59185226|zuo ai;
左岸__左岸 290.730764849|zuo an;
作案__作案 655.989212862|zuo an;
作恶__作惡 137.647730357|zuo e;
昨儿__昨兒 109.716025699|zuo er;
嘴巴__嘴巴 2016.1405527|zui ba;
最棒__最棒 393.063006485|zui bang;
嘴边__嘴邊 489.456318842|zui bian;
最不__最不 517.687984062|zui bu;
最怕__最怕 744.902491688|zui pa;
最慢__最慢 134.762357541|zui man;
最美__最美 1029.9408079|zui mei;
罪名__罪名 615.595353746|zui ming;
最烦__最煩 169.915266157|zui fan;
罪犯__罪犯 661.736546275|zui fan;
最富__最富 145.224802174|zui fu;
最短__最短 268.109857044|zui duan;
最大__最大 10708.6106595|zui da;
醉倒__醉倒 106.218162376|zui dao;
最低__最低 4799.5249195|zui di;
最多__最多 6644.34681247|zui duo;
最难__最難 638.24912322|zui nan;
最能__最能 580.575602636|zui neng;
罪孽__罪孽 118.08671951|zui nie;
最牛__最牛 310.968189453|zui niu;
醉了__醉了 285.346757867|zui le;
嘴里__嘴裡 2103.39925049|zui li;
嘴脸__嘴臉 410.07479966|zui lian;
最令__最令 130.791560815|zui ling;
最广__最廣 163.476413088|zui guang;
最高__最高 9692.5236812|zui gao;
罪过__罪過 472.083744072|zui guo;
最贵__最貴 518.333511609|zui gui;
最快__最快 1438.31738787|zui kuai;
最酷__最酷 106.085879302|zui ku;
最坏__最壞 373.484720623|zui huai;
最好__最好 22844.6595771|zui hao;
最恨__最恨 150.381524744|zui hen;
最后__最後 38459.8547306|zui hou;
最红__最紅 140.770195218|zui hong;
最火__最火 127.572086295|zui huo;
最忌__最忌 180.613978088|zui ji;
最佳__最佳 6043.94979081|zui jia;
嘴角__嘴角 862.9018652|zui jiao;
最近__最近 36818.4521315|zui jin;
最精__最精 146.679837233|zui jing;
醉酒__醉酒 301.054193591|zui jiu;
最具__最具 1359.87999657|zui ju;
最强__最強 1375.21757695|zui qiang;
最先__最先 789.834279627|zui xian;
最小__最小 1530.78744637|zui xiao;
最想__最想 451.935995467|zui xiang;
最新__最新 10602.3833536|zui xin;
罪行__罪行 545.504855178|zui xing;
最重__最重 267.109399762|zui zhong;
最终__最終 13136.8263162|zui zhong;
嘴唇__嘴唇 1301.84258129|zui chun;
最差__最差 387.711726118|zui cha;
最常__最常 287.130256264|zui chang;
最长__最長 633.494731672|zui chang;
最迟__最遲 367.482952871|zui chi;
最初__最初 3037.92233395|zui chu;
最帅__最帥 213.704562287|zui shuai;
嘴上__嘴上 632.705783453|zui shang;
最少__最少 1697.59762841|zui shao;
最深__最深 274.191785204|zui shen;
最受__最受 494.360275282|zui shou;
最让__最讓 146.862738669|zui rang;
最热__最熱 255.709615075|zui re;
罪人__罪人 272.149298879|zui ren;
醉人__醉人 338.046607007|zui ren;
最早__最早 2350.1133092|zui zao;
最最__最最 611.771607197|zui zui;
最惨__最慘 134.930398555|zui can;
最远__最遠 271.133768339|zui yuan;
最易__最易 154.176629937|zui yi;
嘴硬__嘴硬 112.906187218|zui ying;
最优__最優 530.752623218|zui you;
最有__最有 1736.10671918|zui you;
最晚__最晚 472.67240572|zui wan;
最为__最為 3257.49717238|zui wei;
最爱__最愛 2532.56730325|zui ai;
罪恶__罪惡 783.950712715|zui e;
篡改__篡改 440.262469534|cuan gai;
存盘__存盤 110.126966673|cun pan;
村民__村民 3458.29313278|cun min;
存放__存放 1542.27603899|cun fang;
存单__存單 109.170488754|cun dan;
存档__存檔 3004.04087494|cun dang;
村里__村裡 1476.45426414|cun li;
存量__存量 455.895552723|cun liang;
村落__村落 305.97104031|cun luo;
村官__村官 138.508067822|cun guan;
存管__存管 158.857391092|cun guan;
村姑__村姑 132.266710153|cun gu;
存款__存款 1991.17198299|cun kuan;
村口__村口 159.452390871|cun kou;
存活__存活 468.567137655|cun huo;
存货__存貨 604.195219728|cun huo;
村级__村級 480.991159713|cun ji;
存钱__存錢 532.077085292|cun qian;
存取__存取 363.384474622|cun qu;
存心__存心 219.37092252|cun xin;
存续__存續 122.890853693|cun xu;
村庄__村莊 1081.23274995|cun zhuang;
村长__村長 577.688827991|cun zhang;
存着__存着 133.259374649|cun zhe;
存折__存摺 567.697685436|cun zhe;
村镇__村鎮 343.139741671|cun zhen;
存储__存儲 4071.54674252|cun chu;
村上__村上 142.180598718|cun shang;
村人__村人 140.070248771|cun ren;
存入__存入 465.076726846|cun ru;
存在__存在 26430.505433|cun zai;
村子__村子 1009.60853723|cun zi;
村村__村村 111.230349808|cun cun;
存有__存有 324.83145542|cun you;
存亡__存亡 204.07475061|cun wang;
村委__村委 133.259374649|cun wei;
擦掉__擦掉 135.773751924|ca diao;
擦了__擦了 228.580284053|ca le;
擦亮__擦亮 163.884358899|ca liang;
擦干__擦乾 292.54791482|ca gan;
擦汗__擦汗 109.170488754|ca han;
擦去__擦去 124.587019602|ca qu;
擦洗__擦洗 152.647228173|ca xi;
擦着__擦着 126.621787068|ca zhe;
擦拭__擦拭 424.635962376|ca shi;
擦擦__擦擦 249.104624871|ca ca;
才把__才把 269.449631503|cai ba;
财宝__財寶 121.671800659|cai bao;
财报__財報 302.558594526|cai bao;
才被__才被 262.489736092|cai bei;
采编__采編 174.42055653|cai bian;
才不__才不 181.969489867|cai bu;
彩排__綵排 328.086003878|cai pai;
裁判__裁判 1637.34374958|cai pan;
彩票__彩票 1476.45426414|cai piao;
菜品__菜品 176.387781073|cai pin;
彩屏__彩屏 185.634130949|cai ping;
菜谱__菜譜 331.786363812|cai pu;
才买__才買 159.651218957|cai mai;
彩民__彩民 471.495815538|cai min;
采伐__採伐 132.927661458|cai fa;
采访__採訪 6211.94095161|cai fang;
采风__採風 214.772467501|cai feng;
裁缝__裁縫 591.530074736|cai feng;
财富__財富 4675.55298725|cai fu;
财大__財大 187.027319083|cai da;
菜单__菜單 3339.70503971|cai dan;
踩到__踩到 191.269933402|cai dao;
才到__才到 264.459727191|cai dao;
猜到__猜到 476.219822262|cai dao;
菜刀__菜刀 535.402718412|cai dao;
才得__才得 107.015331962|cai de;
菜地__菜地 119.86585751|cai di;
彩电__彩電 861.827215553|cai dian;
裁定__裁定 459.317058623|cai ding;
猜对__猜對 181.516526012|cai dui;
才对__才對 924.118331259|cai dui;
财团__財團 327.677408739|cai tuan;
踩踏__踩踏 140.945727665|cai ta;
采暖__採暖 274.533686805|cai nuan;
才女__才女 459.889800938|cai nv;
采纳__採納 2056.74313669|cai na;
才能__才能 20142.9541807|cai neng;
财年__財年 211.321149687|cai nian;
菜鸟__菜鳥 1344.71347376|cai niao;
菜农__菜農 114.179614083|cai nong;
才来__才來 475.034401746|cai lai;
财力__財力 687.800394331|cai li;
材料__材料 13485.148268|cai liao;
彩铃__彩鈴 770.392265767|cai ling;
菜馆__菜館 137.305093541|cai guan;
采光__採光 225.468321935|cai guang;
才怪__才怪 496.830647979|cai guai;
才敢__才敢 163.069482749|cai gan;
才干__才幹 189.845141544|cai gan;
才刚__才剛 173.121277629|cai gang;
才给__才給 108.357265155|cai gei;
采购__採購 5764.41348178|cai gou;
采矿__採礦 503.060722916|cai kuang;
财会__財會 207.666345181|cai kuai;
才可__才可 330.548296374|cai ke;
才肯__才肯 127.254530072|cai ken;
采花__採花 112.34478795|cai hua;
菜花__菜花 157.67404401|cai hua;
才华__才華 1130.84350481|cai hua;
才好__才好 1046.76190254|cai hao;
彩盒__彩盒 112.204874836|cai he;
彩虹__彩虹 1165.17561047|cai hong;
才回__才回 142.003528374|cai hui;
彩绘__彩繪 194.878871049|cai hui;
才会__才會 4988.56403023|cai hui;
裁决__裁決 516.399339766|cai jue;
猜忌__猜忌 111.091824605|cai ji;
采集__採集 2385.52098173|cai ji;
菜价__菜價 114.179614083|cai jia;
裁减__裁減 146.132498493|cai jian;
裁剪__裁剪 279.713669565|cai jian;
才叫__才叫 559.271495144|cai jiao;
财经__財經 1217.12027856|cai jing;
才气__才氣 196.586267794|cai qi;
蔡琴__蔡琴 226.595011951|cai qin;
才情__才情 142.713135632|cai qing;
才去__才去 365.655730945|cai qu;
采取__採取 9863.10634923|cai qu;
菜系__菜系 105.821807183|cai xi;
彩霞__彩霞 149.447435764|cai xia;
财险__財險 126.306596357|cai xian;
猜想__猜想 744.902491688|cai xiang;
采写__采寫 105.164499152|cai xie;
彩信__彩信 978.639934443|cai xin;
才行__才行 2249.81438398|cai xing;
彩妆__彩妝 357.099731154|cai zhuang;
采摘__採摘 340.583654043|cai zhai;
财长__財長 165.939408926|cai zhang;
踩着__踩着 335.528458728|cai zhe;
财政__財政 3352.21389275|cai zheng;
才智__才智 162.460985719|cai zhi;
才知__才知 174.855812809|cai zhi;
材质__材質 1303.46590513|cai zhi;
猜中__猜中 146.497163581|cai zhong;
财主__財主 150.756793028|cai zhu;
财产__財產 3134.05596467|cai chan;
菜场__菜場 215.845709156|cai chang;
猜出__猜出 157.870654598|cai chu;
财神__財神 876.994863387|cai shen;
才使__才使 164.088713397|cai shi;
菜式__菜式 167.393257695|cai shi;
才是__才是 8429.89391588|cai shi;
采收__採收 156.89004718|cai shou;
才说__才說 286.772667017|cai shuo;
才睡__才睡 159.055477247|cai shui;
财税__財稅 344.85444872|cai shui;
才让__才讓 204.584007193|cai rang;
踩在__踩在 207.666345181|cai zai;
才子__才子 478.003501869|cai zi;
才走__才走 119.56748386|cai zou;
菜菜__菜菜 222.398727024|cai cai;
猜猜__猜猜 471.495815538|cai cai;
踩踩__踩踩 1066.51251556|cai cai;
猜测__猜測 1818.02954749|cai ce;
才从__才從 159.651218957|cai cong;
猜错__猜錯 129.817279349|cai cuo;
才算__才算 619.442999798|cai suan;
彩色__彩色 1875.5602418|cai se;
踩死__踩死 138.508067822|cai si;
菜园__菜園 118.08671951|cai yuan;
财源__財源 188.901181552|cai yuan;
裁员__裁員 684.380469812|cai yuan;
彩云__彩雲 212.377144726|cai yun;
财运__財運 326.861744407|cai yun;
采样__採樣 469.736419493|cai yang;
才要__才要 116.044406778|cai yao;
采药__採藥 222.953710017|cai yao;
菜肴__菜肴 531.41444163|cai yao;
彩页__彩頁 140.945727665|cai ye;
猜疑__猜疑 234.348853194|cai yi;
才艺__才藝 236.107646363|cai yi;
才有__才有 3946.65663992|cai you;
才用__才用 131.937467932|cai yong;
采用__採用 20370.1390643|cai yong;
财物__財物 546.185068786|cai wu;
财务__財務 5355.79733551|cai wu;
惨白__慘白 166.97657743|can bai;
参拜__參拜 240.263000901|can bai;
惨败__慘敗 276.249600432|can bai;
残暴__殘暴 239.664931108|can bao;
参保__參保 571.958268741|can bao;
参评__參評 160.249192015|can ping;
残破__殘破 112.625137786|can po;
参谋__參謀 457.033213363|can mou;
餐费__餐費 215.040276584|can fei;
残废__殘廢 265.78126155|can fei;
惨淡__慘淡 286.415523108|can dan;
蚕豆__蠶豆 118.08671951|can dou;
餐厅__餐廳 2593.24683736|can ting;
惨痛__慘痛 275.218769535|can tong;
灿烂__燦爛 1915.71752783|can lan;
残联__殘聯 194.878871049|can lian;
惨烈__慘烈 420.94790182|can lie;
残留__殘留 724.757896749|can liu;
餐馆__餐館 1254.07172395|can guan;
参观__參觀 3118.47261385|can guan;
参股__參股 813.813436628|can gu;
参看__參看 245.407229187|can kan;
参考__參考 8010.00481377|can kao;
残酷__殘酷 1882.58514584|can ku;
惭愧__慚愧 887.99205879|can kui;
残害__殘害 160.649084484|can hai;
残骸__殘骸 171.190483873|can hai;
参合__參合 125.992190229|can he;
餐后__餐后 115.323601467|can hou;
参会__參會 525.487661863|can hui;
参军__參軍 242.36802267|can jun;
残疾__殘疾 732.932171333|can ji;
参加__參加 23246.7120362|can jia;
参见__參見 811.787668067|can jian;
惨叫__慘叫 234.64107292|can jiao;
惨剧__慘劇 204.329220247|can ju;
餐具__餐具 373.019586361|can ju;
残缺__殘缺 287.488291405|can que;
参选__參選 329.725485744|can xuan;
残渣__殘渣 120.615053212|can zha;
参战__參戰 243.275811214|can zhan;
参展__參展 962.913535809|can zhan;
参照__參照 1744.7822355|can zhao;
参政__參政 111.230349808|can zheng;
惨重__慘重 435.352293046|can zhong;
餐桌__餐桌 587.855808729|can zhuo;
残杀__殘殺 120.164975734|can sha;
蚕食__蠶食 141.121478992|can shi;
参数__參數 6949.21277302|can shu;
残忍__殘忍 1285.72012038|can ren;
惨遭__慘遭 350.92368248|can zao;
残存__殘存 181.969489867|can cun;
参赛__參賽 1643.47641462|can sai;
惨死__慘死 151.321452046|can si;
参阅__參閱 212.112652282|can yue;
参演__參演 190.556205829|can yan;
残阳__殘陽 109.170488754|can yang;
餐饮__餐飲 1232.38252249|can yin;
残余__殘餘 238.176261728|can yu;
参与__參與 13485.148268|can yu;
惨案__慘案 201.045721733|can an;
苍白__蒼白 1042.85588961|cang bai;
藏宝__藏寶 129.171793682|cang bao;
藏品__藏品 247.557321202|cang pin;
苍茫__蒼茫 190.793818607|cang mang;
苍天__蒼天 377.697115787|cang tian;
藏匿__藏匿 156.499511818|cang ni;
苍老__蒼老 264.459727191|cang lao;
苍凉__蒼涼 219.918349804|cang liang;
仓库__倉庫 3197.1719862|cang ku;
仓皇__倉皇 107.416157498|cang huang;
沧海__滄海 530.752623218|cang hai;
苍穹__蒼穹 203.060037258|cang qiong;
藏着__藏着 359.779772295|cang zhe;
沧州__滄州 213.971039752|cang zhou;
仓储__倉儲 459.889800938|cang chu;
苍山__蒼山 132.431639237|cang shan;
藏身__藏身 181.742866823|cang shen;
苍生__蒼生 133.093414711|cang sheng;
仓鼠__倉鼠 121.066816454|cang shu;
藏书__藏書 284.991389772|cang shu;
藏在__藏在 651.914561431|cang zai;
仓促__倉促 403.48504224|cang cu;
沧桑__滄桑 746.761352211|cang sang;
苍鹰__蒼鷹 175.292155245|cang ying;
苍蝇__蒼蠅 898.007390736|cang ying;
藏有__藏有 109.579386421|cang you;
舱位__艙位 159.055477247|cang wei;
仓位__倉位 761.800204777|cang wei;
操办__操辦 125.678566729|cao ban;
草本__草本 110.126966673|cao ben;
操盘__操盤 397.496217848|cao pan;
草皮__草皮 120.916041011|cao pi;
草坪__草坪 567.697685436|cao ping;
草帽__草帽 122.890853693|cao mao;
草莓__草莓 910.401881269|cao mei;
草民__草民 119.26985293|cao min;
草木__草木 285.346757867|cao mu;
操刀__操刀 161.854759309|cao dao;
草地__草地 870.462027204|cao di;
草堂__草堂 121.520271774|cao tang;
草图__草圖 169.070402749|cao tu;
草拟__草擬 213.438416689|cao ni;
操劳__操勞 172.690339006|cao lao;
操练__操練 170.339279748|cao lian;
草稿__草稿 371.164834837|cao gao;
草根__草根 667.534233933|cao gen;
操控__操控 702.526765976|cao kong;
操心__操心 905.87512359|cao xin;
操着__操着 105.295633316|cao zhe;
草场__草場 200.545272755|cao chang;
操场__操場 626.429466854|cao chang;
草率__草率 240.263000901|cao shuai;
操守__操守 131.281440129|cao shou;
嘈杂__嘈雜 315.260239073|cao za;
操纵__操縱 1005.84116282|cao zong;
操作__操作 20395.5394721|cao zuo;
草草__草草 419.377126323|cao cao;
曹操__曹操 1205.04668542|cao cao;
草丛__草叢 247.249015706|cao cong;
草原__草原 1508.06636321|cao yuan;
草药__草藥 305.97104031|cao yao;
草案__草案 946.259922413|cao an;
测评__測評 774.242000696|ce ping;
侧面__側面 1359.87999657|ce mian;
侧目__側目 119.56748386|ce mu;
测得__測得 146.132498493|ce de;
测定__測定 1607.02198372|ce ding;
测土__測土 123.197520618|ce tu;
策略__策略 5504.66134704|ce lue;
测量__測量 2732.58948248|ce liang;
测光__測光 216.654158472|ce guang;
测控__測控 217.19480623|ce kong;
策划__策劃 3941.74151187|ce hua;
测绘__測繪 477.408200926|ce hui;
测序__測序 107.952927857|ce xu;
侧重__側重 616.362966229|ce zhong;
测出__測出 161.854759309|ce chu;
侧身__側身 192.705418355|ce shen;
测试__測試 24989.1407424|ce shi;
册子__冊子 108.087539034|ce zi;
测测__測測 154.947067523|ce ce;
测算__測算 688.658042404|ce suan;
测速__測速 181.969489867|ce su;
厕所__廁所 3356.39391331|ce suo;
测验__測驗 396.506758465|ce yan;
参差__參差 121.671800659|cen ci;
曾被__曾被 524.833224606|ceng bei;
层面__層面 2787.62046424|ceng mian;
曾对__曾對 243.57916235|ceng dui;
层楼__層樓 301.054193591|ceng lou;
层高__層高 130.303509496|ceng gao;
曾获__曾獲 125.678566729|ceng huo;
层级__層級 261.184568064|ceng ji;
曾经__曾經 15582.4341451|ceng jing;
曾想__曾想 127.096048509|ceng xiang;
曾向__曾向 208.44415872|ceng xiang;
曾是__曾是 549.598880816|ceng shi;
曾说__曾說 312.132919672|ceng shuo;
曾任__曾任 459.317058623|ceng ren;
曾在__曾在 1517.49220692|ceng zai;
层层__層層 868.29524729|ceng ceng;
层次__層次 3153.64470585|ceng ci;
曾以__曾以 133.591915611|ceng yi;
曾因__曾因 165.73274959|ceng yin;
曾有__曾有 727.472474808|ceng you;
曾于__曾於 122.432284019|ceng yu;
曾与__曾與 251.914183226|ceng yu;
曾为__曾為 284.636464248|ceng wei;
词霸__詞霸 425.69561654|ci ba;
此版__此版 193.668388536|ci ban;
慈悲__慈悲 345.284462654|ci bei;
刺鼻__刺鼻 121.520271774|ci bi;
此病__此病 143.605133321|ci bing;
磁盘__磁盤 1491.2471417|ci pan;
此片__此片 261.83633885|ci pian;
次品__次品 112.204874836|ci pin;
此法__此法 346.577724349|ci fa;
此番__此番 331.37316028|ci fan;
磁带__磁帶 657.626195507|ci dai;
刺刀__刺刀 145.224802174|ci dao;
此等__此等 123.504952812|ci deng;
次第__次第 128.369448119|ci di;
此地__此地 457.603107852|ci di;
辞典__辭典 513.191745392|ci dian;
词典__詞典 650.291796355|ci dian;
辞掉__辭掉 126.306596357|ci diao;
祠堂__祠堂 161.653186955|ci tang;
词条__詞條 170.127140854|ci tiao;
磁铁__磁鐵 165.73274959|ci tie;
此贴__此貼 383.387639617|ci tie;
此帖__此帖 454.194369369|ci tie;
磁头__磁頭 134.259489114|ci tou;
刺痛__刺痛 343.567617462|ci tong;
辞退__辭退 353.117055307|ci tui;
此女__此女 129.655606164|ci nv;
此乃__此乃 184.71110921|ci nai;
次年__次年 214.772467501|ci nian;
此类__此類 2003.61737423|ci lei;
赐给__賜給 185.402943996|ci gei;
刺骨__刺骨 140.419785869|ci gu;
此款__此款 281.111429553|ci kuan;
磁卡__磁卡 111.786180106|ci ka;
刺客__刺客 551.657401419|ci ke;
此刻__此刻 1515.60233678|ci ke;
词库__詞庫 510.004074866|ci ku;
此话__此話 199.299593609|ci hua;
伺候__伺候 694.691597986|ci hou;
此后__此後 1309.9794677|ci hou;
词汇__詞彙 1637.34374958|ci hui;
次级__次級 399.482550191|ci ji;
刺激__刺激 7295.28957289|ci ji;
此间__此間 325.642053285|ci jian;
赐教__賜教 305.97104031|ci jiao;
此剧__此劇 111.369047744|ci ju;
词句__詞句 200.545272755|ci ju;
此举__此舉 953.361623425|ci ju;
瓷器__瓷器 417.291872914|ci qi;
此前__此前 2457.94475925|ci qian;
刺青__刺青 175.073848088|ci qing;
词曲__詞曲 171.403948695|ci qu;
辞去__辭去 434.268601197|ci qu;
慈溪__慈溪 243.57916235|ci xi;
慈禧__慈禧 255.073095111|ci xi;
慈祥__慈祥 263.801426189|ci xiang;
此项__此項 984.756712384|ci xiang;
雌性__雌性 189.372573382|ci xing;
此行__此行 265.450260135|ci xing;
磁性__磁性 401.478808454|ci xing;
雌雄__雌雄 116.915322539|ci xiong;
刺绣__刺繡 228.011295226|ci xiu;
次序__次序 381.957020988|ci xu;
瓷砖__瓷磚 564.171453387|ci zhuan;
次之__次之 153.41002317|ci zhi;
此致__此致 284.636464248|ci zhi;
辞职__辭職 3475.57460412|ci zhi;
此种__此種 655.989212862|ci zhong;
磁场__磁場 463.341283758|ci chang;
此处__此處 1130.84350481|ci chu;
刺杀__刺殺 357.99085261|ci sha;
慈善__慈善 1125.22065338|ci shan;
刺伤__刺傷 144.143005824|ci shang;
此生__此生 300.679263607|ci sheng;
辞世__辭世 117.061109314|ci shi;
刺史__刺史 159.253810404|ci shi;
此事__此事 2708.85631718|ci shi;
此时__此時 5664.71780817|ci shi;
此书__此書 415.734739962|ci shu;
次数__次數 2784.14878864|ci shu;
词人__詞人 140.244908425|ci ren;
此人__此人 1308.34803192|ci ren;
次日__次日 552.345286903|ci ri;
次子__次子 120.015323434|ci zi;
词组__詞組 302.181790975|ci zu;
次次__次次 211.057972369|ci ci;
此次__此次 7592.08459063|ci ci;
此言__此言 202.807148249|ci yan;
刺眼__刺眼 314.867617017|ci yan;
次要__次要 441.361118731|ci yao;
此一__此一 165.939408926|ci yi;
赐予__賜予 274.191785204|ci yu;
词语__詞語 1209.56018338|ci yu;
此外__此外 1659.94271905|ci wai;
此文__此文 734.761160623|ci wen;
此为__此為 302.935867929|ci wei;
刺猬__刺蝟 318.815941979|ci wei;
慈爱__慈愛 163.476413088|ci ai;
此案__此案 811.787668067|ci an;
词儿__詞兒 105.426930997|ci er;
刺耳__刺耳 250.037645335|ci er;
凑到__湊到 177.711575153|cou dao;
凑合__湊合 1162.27522076|cou he;
凑近__湊近 107.416157498|cou jin;
凑齐__湊齊 122.127521944|cou qi;
凑巧__湊巧 166.768626413|cou qiao;
从不__從不 1366.67546656|cong bu;
匆忙__匆忙 693.826435782|cong mang;
从没__從沒 712.223191016|cong mei;
聪明__聰明 5757.23453692|cong ming;
丛飞__叢飛 128.209578049|cong fei;
从头__從頭 595.22730595|cong tou;
从那__從那 339.735863102|cong na;
从来__從來 9186.81840963|cong lai;
丛林__叢林 538.749137684|cong lin;
从化__從化 107.015331962|cong hua;
葱花__蔥花 129.979154132|cong hua;
从何__從何 191.747236314|cong he;
聪慧__聰慧 215.576896995|cong hui;
从紧__從緊 172.04594156|cong jin;
从句__從句 116.333988795|cong ju;
从其__從其 211.057972369|cong qi;
从前__從前 1782.13945694|cong qian;
从轻__從輕 110.815291538|cong qing;
从小__從小 3331.3917468|cong xiao;
从新__從新 592.267679181|cong xin;
从这__從這 322.813777494|cong zhe;
从政__從政 194.151676652|cong zheng;
丛中__叢中 175.510734618|cong zhong;
从中__從中 1532.69625148|cong zhong;
丛生__叢生 154.561368684|cong sheng;
从事__從事 7295.28957289|cong shi;
丛书__叢書 453.628720089|cong shu;
从容__從容 900.248315564|cong rong;
从早__從早 109.442917312|cong zao;
从左__從左 135.773751924|cong zuo;
从此__從此 3161.51444144|cong ci;
匆匆__匆匆 1538.43695969|cong cong;
从严__從嚴 190.318888971|cong yan;
从业__從業 508.734557585|cong ye;
从文__從文 169.28122395|cong wen;
从未__從未 2403.42436786|cong wei;
从我__從我 424.635962376|cong wo;
从无__從無 160.049619219|cong wu;
从而__從而 9095.68698269|cong er;
粗暴__粗暴 395.519762073|cu bao;
粗放__粗放 136.963309627|cu fang;
粗大__粗大 260.859291326|cu da;
粗略__粗略 351.799391968|cu lue;
粗鲁__粗魯 337.205131359|cu lu;
粗犷__粗獷 199.299593609|cu guang;
粗口__粗口 258.593668656|cu kou;
粗话__粗話 181.742866823|cu hua;
促进__促進 10978.8586437|cu jin;
粗气__粗氣 107.416157498|cu qi;
粗细__粗細 189.608710238|cu xi;
促销__促銷 2510.57137637|cu xiao;
粗心__粗心 252.85772688|cu xin;
粗壮__粗壯 204.329220247|cu zhuang;
促成__促成 638.24912322|cu cheng;
促使__促使 1768.86409398|cu shi;
粗糙__粗糙 1093.42757174|cu cao;
醋酸__醋酸 168.859844103|cu suan;
猝死__猝死 222.398727024|cu si;
粗俗__粗俗 242.066179876|cu su;
簇拥__簇擁 180.839193473|cu yong;
挫败__挫敗 201.296414343|cuo bai;
错的__錯的 264.459727191|cuo de;
错乱__錯亂 166.146325956|cuo luan;
错落__錯落 118.23396695|cuo luo;
错过__錯過 2675.30892006|cuo guo;
错开__錯開 135.773751924|cuo kai;
撮合__撮合 232.024158785|cuo he;
错觉__錯覺 488.846754671|cuo jue;
挫折__挫折 1101.63376911|cuo zhe;
痤疮__痤瘡 208.964318904|cuo chuang;
挫伤__挫傷 158.857391092|cuo shang;
磋商__磋商 497.450167612|cuo shang;
错事__錯事 153.41002317|cuo shi;
错失__錯失 273.168633085|cuo shi;
措施__措施 8335.87666534|cuo shi;
错在__錯在 153.218967809|cuo zai;
错字__錯字 244.186999878|cuo zi;
措辞__措辭 213.704562287|cuo ci;
错位__錯位 406.513206136|cuo wei;
错误__錯誤 13552.5350378|cuo wu;
催眠__催眠 453.063775264|cui mian;
翠绿__翠綠 181.969489867|cui lv;
翠花__翠花 150.569041974|cui hua;
催化__催化 436.982903472|cui hua;
摧毁__摧毀 838.520594407|cui hui;
崔健__崔健 202.807148249|cui jian;
萃取__萃取 241.764712994|cui qu;
催生__催生 344.424970321|cui sheng;
脆弱__脆弱 1964.0635567|cui ruo;
摧残__摧殘 410.586139672|cui can;
璀璨__璀璨 413.667597456|cui can;
催促__催促 450.811022973|cui cu;
翠翠__翠翠 122.432284019|cui cui;
算盘__算盤 170.977284899|suan pan;
算命__算命 544.825488702|suan ming;
算法__算法 3621.48192263|suan fa;
算得__算得 511.276760152|suan de;
酸甜__酸甜 123.044091616|suan tian;
酸痛__酸痛 287.130256264|suan tong;
酸奶__酸奶 825.045864155|suan nai;
算你__算你 186.32942291|suan ni;
酸辣__酸辣 196.096919422|suan la;
算啦__算啦 275.561951728|suan la;
算来__算來 114.179614083|suan lai;
算了__算了 10978.8586437|suan le;
算个__算個 312.911829085|suan ge;
算好__算好 175.510734618|suan hao;
算计__算計 375.819106356|suan ji;
算起__算起 212.112652282|suan qi;
酸性__酸性 427.82286438|suan xing;
算账__算賬 274.191785204|suan zhang;
酸楚__酸楚 155.915530766|suan chu;
算出__算出 255.709615075|suan chu;
算上__算上 378.168082664|suan shang;
算是__算是 5814.9173705|suan shi;
算术__算術 172.690339006|suan shu;
算数__算數 290.0070692|suan shu;
算作__算作 202.554574186|suan zuo;
酸菜__酸菜 184.941433485|suan cai;
算错__算錯 105.821807183|suan cuo;
酸酸__酸酸 264.459727191|suan suan;
算算__算算 606.458230719|suan suan;
酸味__酸味 122.432284019|suan wei;
算我__算我 177.933171406|suan wo;
孙女__孫女 314.475483928|sun nv;
孙楠__孫楠 143.0692679|sun nan;
孙俪__孫儷 281.812926654|sun li;
损坏__損壞 1820.2965272|sun huai;
损害__損害 2847.30570911|sun hai;
损耗__損耗 505.574572707|sun hao;
损毁__損毀 178.822323044|sun hui;
孙权__孫權 272.828431509|sun quan;
孙祥__孫祥 180.839193473|sun xiang;
损伤__損傷 1641.42964497|sun shang;
损失__損失 6854.60405824|sun shi;
孙子__孫子 1385.53861435|sun zi;
孙悦__孫悅 326.454673948|sun yue;
损益__損益 260.534419685|sun yi;
萨满__薩滿 759.903909096|sa man;
撒旦__撒旦 299.93080386|sa dan;
萨特__薩特 120.314814642|sa te;
洒脱__洒脫 443.56664881|sa tuo;
撒尿__撒尿 203.820597887|sa niao;
萨拉__薩拉 173.986383704|sa la;
洒落__灑落 110.677283245|sa luo;
撒谎__撒謊 726.566487616|sa huang;
撒娇__撒嬌 667.534233933|sa jiao;
撒在__撒在 108.627664361|sa zai;
洒在__灑在 178.377193209|sa zai;
撒野__撒野 124.89791921|sa ye;
萨尔__薩爾 305.209408115|sa er;
塞班__塞班 154.176629937|sai ban;
赛博__賽博 112.484875527|sai bo;
赛跑__賽跑 193.186303435|sai pao;
赛马__賽馬 192.465424888|sai ma;
塞满__塞滿 160.049619219|sai man;
塞到__塞到 142.891090816|sai dao;
赛道__賽道 418.333200332|sai dao;
赛迪__賽迪 138.163289429|sai di;
赛格__賽格 199.796934068|sai ge;
塞给__塞給 113.046974828|sai gei;
塞黑__塞黑 114.179614083|sai hei;
赛后__賽后 604.948616891|sai hou;
腮红__腮紅 116.915322539|sai hong;
赛季__賽季 2221.95191814|sai ji;
塞进__塞進 341.008342538|sai jin;
赛前__賽前 527.455873984|sai qian;
赛区__賽區 532.077085292|sai qu;
赛制__賽制 135.604660605|sai zhi;
赛场__賽場 1022.26865969|sai chang;
塞车__塞車 151.321452046|sai che;
赛车__賽車 1182.73057528|sai che;
赛程__賽程 305.97104031|sai cheng;
赛事__賽事 1429.38333547|sai shi;
赛扬__賽揚 297.325836157|sai yang;
塞外__塞外 114.321989585|sai wai;
赛尔__賽爾 111.091824605|sai er;
塞尔__塞爾 188.430963124|sai er;
三八__三八 259.238974004|san ba;
三百__三百 769.432826682|san bai;
三班__三班 118.529012887|san ban;
三包__三包 216.384339476|san bao;
三宝__三寶 241.463621556|san bao;
三本__三本 227.160466527|san ben;
三杯__三杯 107.818484324|san bei;
三倍__三倍 331.37316028|san bei;
三遍__三遍 195.121873946|san bian;
散播__散播 131.937467932|san bo;
三步__三步 302.558594526|san bu;
三部__三部 350.92368248|san bu;
散布__散布 657.626195507|san bu;
散步__散步 1132.25360251|san bu;
三陪__三陪 116.18910757|san pei;
三篇__三篇 128.369448119|san pian;
散漫__散漫 159.651218957|san man;
三毛__三毛 333.029068427|san mao;
三门__三門 226.595011951|san men;
三枚__三枚 110.539446825|san mei;
三面__三面 209.224885556|san mian;
三明__三明 178.155043976|san ming;
三名__三名 613.298247397|san ming;
散发__散發 1142.1736421|san fa;
三番__三番 113.32907693|san fan;
三房__三房 132.596773978|san fang;
三方__三方 600.442284667|san fang;
三份__三份 151.132997772|san fen;
三分__三分 1319.8108917|san fen;
三段__三段 194.636170786|san duan;
散打__散打 153.792848894|san da;
三大__三大 3339.70503971|san da;
三代__三代 499.935980841|san dai;
三到__三到 131.609045271|san dao;
三道__三道 185.86560618|san dao;
三等__三等 127.096048509|san deng;
三地__三地 240.562595233|san di;
三点__三點 1208.05380881|san dian;
三度__三度 118.972962872|san du;
三多__三多 347.00988711|san duo;
三台__三台 239.664931108|san tai;
三套__三套 180.839193473|san tao;
三天__三天 2732.58948248|san tian;
三条__三條 734.761160623|san tiao;
三通__三通 137.819369268|san tong;
三年__三年 5044.82818733|san nian;
三农__三農 182.423584067|san nong;
散乱__散亂 174.42055653|san luan;
三轮__三輪 257.62872122|san lun;
三郎__三郎 121.671800659|san lang;
散了__散了 368.399985048|san le;
三类__三類 547.548041623|san lei;
三联__三聯 328.904723278|san lian;
三两__三兩 129.010924378|san liang;
三菱__三菱 633.494731672|san ling;
三流__三流 234.348853194|san liu;
三楼__三樓 699.033618062|san lou;
三路__三路 179.492101402|san lu;
三鹿__三鹿 410.586139672|san lu;
散落__散落 430.496878967|san luo;
三哥__三哥 216.654158472|san ge;
三个__三個 11554.376787|san ge;
三根__三根 153.41002317|san gen;
三更__三更 116.044406778|san geng;
三国__三國 1797.75335645|san guo;
三款__三款 419.900065808|san kuan;
三块__三塊 236.696839161|san kuai;
散开__散開 208.70407676|san kai;
三颗__三顆 118.529012887|san ke;
散客__散客 163.680258901|san ke;
三口__三口 322.010219858|san kou;
三环__三環 351.799391968|san huan;
三号__三號 385.303469841|san hao;
散户__散戶 2153.79604997|san hu;
散货__散貨 129.494134325|san huo;
散伙__散夥 178.377193209|san huo;
三军__三軍 183.106850936|san jun;
三级__三級 1465.45598554|san ji;
三甲__三甲 194.636170786|san jia;
三家__三家 880.279644448|san jia;
三间__三間 110.264288753|san jian;
散件__散件 112.765574943|san jian;
三件__三件 213.704562287|san jian;
三角__三角 876.994863387|san jiao;
三江__三江 201.547419552|san jiang;
三姐__三姐 116.044406778|san jie;
三界__三界 150.194241046|san jie;
三届__三屆 190.556205829|san jie;
散尽__散盡 128.529517539|san jin;
三井__三井 122.432284019|san jing;
三九__三九 186.561765129|san jiu;
三七__三七 197.814987883|san qi;
三期__三期 614.828697239|san qi;
三千__三千 907.004698479|san qian;
三强__三強 163.272821143|san qiang;
三区__三區 230.295783987|san qu;
散去__散去 291.456266438|san qu;
三下__三下 105.821807183|san xia;
三峡__三峽 891.318029807|san xia;
三线__三線 263.144763849|san xian;
三厢__三廂 212.641966978|san xiang;
三相__三相 234.933657026|san xiang;
三项__三項 754.243296976|san xiang;
散心__散心 176.60772663|san xin;
三星__三星 3492.94243288|san xing;
散装__散裝 254.121284766|san zhuang;
三张__三張 451.373158744|san zhang;
三者__三者 480.392137969|san zhe;
三至__三至 105.690017726|san zhi;
三支__三支 160.849404779|san zhi;
三只__三隻 370.702589737|san zhi;
三周__三周 259.238974004|san zhou;
三中__三中 138.85370659|san zhong;
三种__三種 2194.43451055|san zhong;
散场__散場 115.755545596|san chang;
三场__三場 222.67604562|san chang;
三成__三成 328.495108513|san cheng;
三尺__三尺 221.845125512|san chi;
三重__三重 207.407719521|san chong;
三处__三處 122.890853693|san chu;
散射__散射 174.203334854|san she;
三声__三聲 128.529517539|san sheng;
三世__三世 182.878811433|san shi;
三十__三十 2491.86983978|san shi;
三是__三是 3106.83597105|san shi;
三首__三首 118.381397999|san shou;
三水__三水 162.86639759|san shui;
散热__散熱 1370.08592511|san re;
三人__三人 1870.89154158|san ren;
三日__三日 370.702589737|san ri;
三字__三字 107.14877401|san zi;
三组__三組 166.560934377|san zu;
三座__三座 118.381397999|san zuo;
三餐__三餐 184.02185602|san can;
三层__三層 788.850627646|san ceng;
三次__三次 2244.21407924|san ci;
三三__三三 152.457122789|san san;
三色__三色 172.905674062|san se;
三思__三思 158.067510349|san si;
三四__三四 892.429452826|san si;
三岁__三歲 451.935995467|san sui;
三元__三元 388.679238014|san yuan;
三月__三月 1085.28250327|san yue;
三亚__三亞 1033.79844744|san ya;
三洋__三洋 276.594068012|san yang;
三要__三要 168.859844103|san yao;
三夜__三夜 122.584950132|san ye;
三一__三一 185.86560618|san yi;
三万__三萬 401.979429753|san wan;
散文__散文 840.61307342|san wen;
三围__三圍 233.765505073|san wei;
三维__三維 1157.93816758|san wei;
三位__三位 1215.60448872|san wei;
三五__三五 422.52456065|san wu;
嗓门__嗓門 171.831677206|sang men;
丧命__喪命 123.197520618|sang ming;
桑拿__桑拿 1799.9950529|sang na;
丧生__喪生 205.862715427|sang sheng;
丧失__喪失 1779.91999768|sang shi;
嗓子__嗓子 1027.37704867|sang zi;
嗓音__嗓音 589.322768456|sang yin;
扫把__掃把 128.529517539|sao ba;
扫盲__掃盲 156.304608838|sao mang;
扫描__掃描 2981.66342698|sao miao;
扫墓__掃墓 178.377193209|sao mu;
扫荡__掃蕩 189.845141544|sao dang;
扫地__掃地 323.216307961|sao di;
骚动__騷動 240.263000901|sao dong;
骚乱__騷亂 293.277951001|sao luan;
扫雷__掃雷 119.56748386|sao lei;
扫过__掃過 120.916041011|sao guo;
骚货__騷貨 159.85029497|sao huo;
扫兴__掃興 150.381524744|sao xing;
扫帚__掃帚 147.229226029|sao zhou;
扫除__掃除 153.601316766|sao chu;
扫射__掃射 140.070248771|sao she;
骚扰__騷擾 1906.19207626|sao rao;
嫂子__嫂子 1107.13875428|sao zi;
嫂嫂__嫂嫂 126.937764318|sao sao;
瘙痒__瘙癢 226.312812713|sao yang;
色斑__色斑 329.725485744|se ban;
色谱__色譜 123.044091616|se pu;
色盲__色盲 130.141230764|se mang;
色魔__色魔 114.321989585|se mo;
色调__色調 694.691597986|se diao;
色狼__色狼 883.576728645|se lang;
色鬼__色鬼 140.594881376|se gui;
色戒__色戒 271.133768339|se jie;
色情__色情 2306.59185226|se qing;
色系__色系 125.522047856|se xi;
色相__色相 164.703307075|se xiang;
色差__色差 232.603161479|se cha;
色泽__色澤 525.487661863|se ze;
色彩__色彩 5089.02755683|se cai;
瑟瑟__瑟瑟 226.877563077|se se;
色色__色色 234.64107292|se se;
色素__色素 535.402718412|se su;
色诱__色誘 122.584950132|se you;
森林__森林 2586.79165036|sen lin;
森森__森森 134.092283643|sen sen;
僧侣__僧侶 154.754097942|seng lv;
僧人__僧人 295.111021611|seng ren;
四百__四百 367.941183266|si bai;
死板__死板 211.321149687|si ban;
私奔__私奔 303.691826638|si ben;
四倍__四倍 114.607273411|si bei;
四部__四部 142.180598718|si bu;
死不__死不 219.644465616|si bu;
四平__四平 147.596627936|si ping;
司马__司馬 756.125466931|si ma;
四门__四門 141.473639374|si men;
私密__私密 290.730764849|si mi;
四面__四面 341.433560596|si mian;
寺庙__寺廟 576.969379906|si miao;
死命__死命 169.703655326|si ming;
四名__四名 346.577724349|si ming;
私募__私募 483.997491267|si mu;
司法__司法 2143.08680935|si fa;
私房__私房 201.79873775|si fang;
四方__四方 738.432842998|si fang;
四分__四分 114.179614083|si fen;
司副__司副 141.121478992|si fu;
私服__私服 694.691597986|si fu;
四大__四大 2312.34781708|si da;
四代__四代 131.117943492|si dai;
丝带__絲帶 131.117943492|si dai;
死党__死黨 319.611528482|si dang;
死得__死得 253.173026121|si de;
死的__死的 706.917758081|si de;
似的__似的 1236.99840673|si de;
死地__死地 187.26053154|si di;
四点__四點 677.591550514|si dian;
撕掉__撕掉 127.254530072|si diao;
死掉__死掉 678.436468738|si diao;
斯塔__斯塔 140.419785869|si ta;
斯坦__斯坦 323.216307961|si tan;
四套__四套 109.30661816|si tao;
斯特__斯特 391.108593802|si te;
四天__四天 605.702953498|si tian;
四条__四條 349.614203755|si tiao;
四通__四通 127.73116145|si tong;
斯通__斯通 133.591915611|si tong;
司徒__司徒 334.276427588|si tu;
斯托__斯托 115.467403456|si tuo;
肆虐__肆虐 296.585723861|si nue;
死你__死你 333.444336783|si ni;
思念__思念 2252.61977488|si nian;
四年__四年 2548.39656922|si nian;
斯诺__斯諾 119.41857567|si nuo;
四轮__四輪 151.699065864|si lun;
死了__死了 6219.68688957|si le;
四类__四類 201.296414343|si lei;
死里__死里 121.823518492|si li;
私立__私立 226.312812713|si li;
私利__私利 247.866011137|si li;
私聊__私聊 380.531740742|si liao;
饲料__飼料 1418.73569366|si liao;
思量__思量 234.933657026|si liang;
撕裂__撕裂 366.568203397|si lie;
死灵__死靈 131.937467932|si ling;
司令__司令 563.46883971|si ling;
四楼__四樓 357.545014261|si lou;
四路__四路 109.170488754|si lu;
丝路__絲路 135.94305409|si lu;
思路__思路 4745.99659028|si lu;
丝瓜__絲瓜 187.4940348|si gua;
死光__死光 135.94305409|si guang;
四哥__四哥 108.898738333|si ge;
四个__四個 5250.06745253|si ge;
四国__四國 294.376422496|si guo;
四款__四款 170.76435144|si kuan;
斯卡__斯卡 106.483223576|si ka;
撕开__撕開 228.011295226|si kai;
司考__司考 145.950506492|si kao;
思考__思考 7920.67051883|si kao;
斯克__斯克 159.253810404|si ke;
斯科__斯科 187.027319083|si ke;
思科__思科 725.661628731|si ke;
四口__四口 105.690017726|si kou;
四环__四環 296.216358865|si huan;
四海__四海 509.368920718|si hai;
四号__四號 262.162833911|si hao;
丝毫__絲毫 1609.02584897|si hao;
四核__四核 219.644465616|si he;
死后__死後 1073.17852213|si hou;
似乎__似乎 17983.4773065|si hu;
似火__似火 124.587019602|si huo;
私活__私活 141.826678552|si huo;
死活__死活 713.111292931|si huo;
伺机__伺機 165.526347625|si ji;
死寂__死寂 236.402059204|si ji;
斯基__斯基 579.130416613|si ji;
四季__四季 889.099334512|si ji;
四级__四級 1184.20537322|si ji;
死机__死機 1771.06976716|si ji;
司机__司機 4476.00816632|si ji;
思佳__思佳 110.401782066|si jia;
私家__私家 201.547419552|si jia;
四家__四家 347.875829952|si jia;
四角__四角 172.260473089|si jiao;
死角__死角 212.112652282|si jiao;
四届__四屆 125.053659829|si jie;
丝巾__絲巾 153.792848894|si jin;
四句__四句 114.607273411|si ju;
四期__四期 159.85029497|si qi;
四起__四起 197.076837307|si qi;
私企__私企 210.008536601|si qi;
死前__死前 161.653186955|si qian;
四千__四千 390.135034682|si qian;
四强__四強 370.702589737|si qiang;
四区__四區 123.658956482|si qu;
四驱__四驅 128.209578049|si qu;
死去__死去 1409.92327219|si qu;
撕下__撕下 119.41857567|si xia;
四下__四下 160.249192015|si xia;
私下__私下 1051.99268696|si xia;
丝线__絲線 127.890434962|si xian;
思乡__思鄉 122.279808036|si xiang;
四项__四項 476.813641365|si xiang;
思想__思想 12205.6094005|si xiang;
私心__私心 238.770616634|si xin;
死心__死心 296.955549433|si xin;
四星__四星 130.954650472|si xing;
死刑__死刑 995.863416846|si xing;
思绪__思緒 808.758466182|si xu;
四张__四張 176.60772663|si zhang;
司长__司長 351.361264404|si zhang;
死者__死者 1383.81307795|si zhe;
四只__四隻 192.225730308|si zhi;
四肢__四肢 621.763121294|si zhi;
四周__四周 1627.17345269|si zhou;
四种__四種 881.377303227|si zhong;
死猪__死豬 183.106850936|si zhu;
四川__四川 5946.82564905|si chuan;
死缠__死纏 108.763116896|si chan;
思潮__思潮 326.861744407|si chao;
撕扯__撕扯 109.716025699|si che;
私车__私車 110.401782066|si che;
四成__四成 244.186999878|si cheng;
丝绸__絲綢 693.826435782|si chou;
私处__私處 120.015323434|si chu;
四处__四處 1695.48345672|si chu;
厮杀__廝殺 193.186303435|si sha;
死伤__死傷 182.196395498|si shang;
四射__四射 242.36802267|si she;
死神__死神 1073.17852213|si shen;
四时__四時 115.179978568|si shi;
死尸__死屍 116.624293448|si shi;
似是__似是 120.765453341|si shi;
私事__私事 252.54282031|si shi;
四十__四十 1292.14500531|si shi;
四是__四是 1424.04956302|si shi;
厮守__廝守 139.373782642|si shou;
死守__死守 161.854759309|si shou;
私塾__私塾 116.624293448|si shu;
死水__死水 110.677283245|si shui;
似水__似水 150.381524744|si shui;
四人__四人 753.303969661|si ren;
死人__死人 1416.96881393|si ren;
私人__私人 3277.85745623|si ren;
四日__四日 120.46484039|si ri;
死在__死在 654.356305043|si zai;
四字__四字 140.594881376|si zi;
私自__私自 465.65665114|si zi;
四座__四座 123.967540162|si zuo;
四层__四層 224.347234118|si ceng;
四次__四次 650.291796355|si ci;
四散__四散 110.677283245|si san;
思思__思思 213.172602547|si si;
丝丝__絲絲 388.195180646|si si;
死死__死死 509.368920718|si si;
思索__思索 693.826435782|si suo;
撕碎__撕碎 105.690017726|si sui;
四岁__四歲 220.467143161|si sui;
思远__思遠 109.442917312|si yuan;
思源__思源 129.817279349|si yuan;
寺院__寺院 376.756940916|si yuan;
四月__四月 1100.26180506|si yue;
嘶哑__嘶啞 114.893269147|si ya;
四眼__四眼 119.716577729|si yan;
饲养__飼養 847.977956119|si yang;
四爷__四爺 105.558392399|si ye;
死也__死也 170.76435144|si ye;
四溢__四溢 159.85029497|si yi;
司仪__司儀 169.070402749|si yi;
肆意__肆意 480.392137969|si yi;
死因__死因 282.164331387|si yin;
私营__私營 366.568203397|si ying;
似有__似有 200.545272755|si you;
私有__私有 478.003501869|si you;
私欲__私慾 119.41857567|si yu;
死鱼__死魚 129.817279349|si yu;
思域__思域 148.889769675|si yu;
私语__私語 264.130371602|si yu;
死于__死於 693.826435782|si yu;
丝袜__絲襪 762.750126416|si wa;
四万__四萬 173.986383704|si wan;
死亡__死亡 5917.25646732|si wang;
斯文__斯文 474.442798491|si wen;
饲喂__飼餵 113.895394799|si wei;
四维__四維 145.768741141|si wei;
四位__四位 666.702893247|si wei;
思维__思維 4263.67354041|si wei;
四五__四五 793.781168439|si wu;
搜房__搜房 514.472385324|sou fang;
搜罗__搜羅 166.353500999|sou luo;
搜刮__搜刮 131.117943492|sou gua;
搜狗__搜狗 1434.73708553|sou gou;
搜狐__搜狐 1425.82527204|sou hu;
搜集__搜集 1190.12297778|sou ji;
搜救__搜救 323.619340361|sou jiu;
搜寻__搜尋 617.131535882|sou xun;
搜查__搜查 289.285174995|sou cha;
搜出__搜出 136.282292017|sou chu;
嗖嗖__嗖嗖 152.077621994|sou sou;
搜索__搜索 10602.3833536|sou suo;
松柏__松柏 142.535402072|song bai;
送别__送別 228.8653107|song bie;
送票__送票 108.898738333|song piao;
送饭__送飯 115.323601467|song fan;
送达__送達 479.793862242|song da;
宋代__宋代 439.166555128|song dai;
送到__送到 2890.20426542|song dao;
松动__鬆動 452.499534015|song dong;
诵读__誦讀 120.916041011|song du;
送他__送他 300.304800557|song ta;
送她__送她 361.577631409|song ta;
宋体__宋體 266.444503116|song ti;
送你__送你 988.445115058|song ni;
送来__送來 881.377303227|song lai;
耸立__聳立 159.85029497|song li;
送礼__送禮 604.195219728|song li;
松林__松林 139.547573842|song lin;
松岭__松嶺 137.819369268|song ling;
颂歌__頌歌 109.442917312|song ge;
送给__送給 2893.80818618|song gei;
送股__送股 204.329220247|song gu;
送过__送過 153.601316766|song guo;
松开__鬆開 431.033684153|song kai;
送花__送花 243.882891747|song hua;
送货__送貨 995.863416846|song huo;
送回__送回 314.083839199|song hui;
送检__送檢 107.14877401|song jian;
送交__送交 156.499511818|song jiao;
宋江__宋江 254.121284766|song jiang;
松江__松江 473.261801395|song jiang;
送进__送進 392.084582382|song jin;
送钱__送錢 248.175085992|song qian;
送去__送去 644.643863216|song qu;
松下__松下 1066.51251556|song xia;
松懈__鬆懈 243.57916235|song xie;
送行__送行 250.661599628|song xing;
送修__送修 117.061109314|song xiu;
送至__送至 178.59961945|song zhi;
宋朝__宋朝 298.811606079|song chao;
松弛__鬆弛 406.513206136|song chi;
送出__送出 462.187920882|song chu;
嵩山__嵩山 134.259489114|song shan;
送上__送上 873.722339551|song shang;
送审__送審 107.015331962|song shen;
松手__鬆手 139.895806636|song shou;
松树__松樹 193.186303435|song shu;
松鼠__松鼠 282.516174301|song shu;
送水__送水 119.56748386|song shui;
松软__鬆軟 242.066179876|song ruan;
送人__送人 481.590928402|song ren;
送入__送入 279.017397997|song ru;
松子__松子 113.753550575|song zi;
送走__送走 320.808632296|song zou;
宋词__宋詞 107.818484324|song ci;
松散__鬆散 282.164331387|song san;
送死__送死 182.651055928|song si;
松松__鬆鬆 150.944778196|song song;
怂恿__慫恿 253.488718522|song yong;
送往__送往 516.399339766|song wang;
送我__送我 927.579613097|song wo;
苏北__蘇北 320.010065926|su bei;
素描__素描 307.883446338|su miao;
宿命__宿命 575.5331706|su ming;
肃穆__肅穆 153.218967809|su mu;
苏菲__蘇菲 163.069482749|su fei;
苏丹__蘇丹 430.496878967|su dan;
速递__速遞 275.561951728|su di;
速冻__速凍 121.520271774|su dong;
速度__速度 21384.5895885|su du;
俗套__俗套 143.247667161|su tao;
速腾__速騰 350.92368248|su teng;
苏南__蘇南 205.350275845|su nan;
苏宁__蘇寧 856.474009391|su ning;
速率__速率 852.21539528|su lv;
素来__素來 142.713135632|su lai;
苏联__蘇聯 1939.73992621|su lian;
塑料__塑料 2188.97205903|su liao;
诉苦__訴苦 258.916120291|su ku;
俗话__俗話 159.452390871|su hua;
苏军__蘇軍 222.953710017|su jun;
塑胶__塑膠 389.649164279|su jiao;
俗气__俗氣 240.562595233|su qi;
宿迁__宿遷 287.846772995|su qian;
诉求__訴求 655.172250234|su qiu;
苏区__蘇區 126.621787068|su qu;
塑像__塑像 221.568841736|su xiang;
塑性__塑性 117.792774542|su xing;
苏醒__蘇醒 615.595353746|su xing;
诉状__訴狀 127.254530072|su zhuang;
素质__素質 5057.41726048|su zhi;
宿州__宿州 146.132498493|su zhou;
苏州__蘇州 4823.50867368|su zhou;
诉诸__訴諸 146.862738669|su zhu;
宿主__宿主 165.114314527|su zhu;
速成__速成 167.184787749|su cheng;
俗称__俗稱 562.76710106|su cheng;
苏珊__蘇珊 114.321989585|su shan;
宿舍__宿舍 7249.97516601|su she;
塑身__塑身 105.0335283|su shen;
素食__素食 248.794392378|su shi;
苏轼__蘇軾 288.565077751|su shi;
诉说__訴說 692.962351041|su shuo;
俗人__俗人 228.011295226|su ren;
塑造__塑造 1394.19862478|su zao;
素菜__素菜 142.003528374|su cai;
素材__素材 1607.02198372|su cai;
诉讼__訴訟 1818.02954749|su song;
素素__素素 151.321452046|su su;
苏苏__蘇蘇 156.109948588|su su;
素养__素養 550.284199441|su yang;
素以__素以 174.855812809|su yi;
素有__素有 264.789493468|su you;
粟裕__粟裕 118.529012887|su yu;
俗语__俗語 210.008536601|su yu;
索赔__索賠 713.111292931|suo pei;
所迫__所迫 129.171793682|suo po;
锁门__鎖門 128.369448119|suo men;
所发__所發 307.500011268|suo fa;
所犯__所犯 105.558392399|suo fan;
缩放__縮放 269.785619908|suo fang;
缩短__縮短 1326.40613196|suo duan;
所带__所帶 149.075426771|suo dai;
索道__索道 186.097370046|suo dao;
所得__所得 1581.19770715|suo de;
所定__所定 109.170488754|suo ding;
锁定__鎖定 1687.0530669|suo ding;
所提__所提 163.272821143|suo ti;
所能__所能 1235.45786087|suo neng;
索尼__索尼 1971.41994959|suo ni;
所里__所里 199.548108896|suo li;
所料__所料 130.628674269|suo liao;
缩量__縮量 246.019628549|suo liang;
所列__所列 296.955549433|suo lie;
所购__所購 121.217779906|suo gou;
锁骨__鎖骨 167.184787749|suo gu;
所含__所含 386.746622582|suo han;
所获__所獲 162.460985719|suo huo;
缩减__縮減 375.351064872|suo jian;
所见__所見 568.405572245|suo jian;
所讲__所講 257.94996962|suo jiang;
缩进__縮進 128.689786556|suo jin;
所起__所起 141.29744947|suo qi;
索取__索取 617.901063897|suo qu;
所选__所選 274.876014738|suo xuan;
所学__所學 532.740555233|suo xue;
所辖__所轄 185.402943996|suo xia;
所限__所限 153.601316766|suo xian;
缩小__縮小 1768.86409398|suo xiao;
所想__所想 366.111682898|suo xiang;
所写__所寫 389.163898974|suo xie;
缩写__縮寫 733.846096172|suo xie;
所幸__所幸 245.101601395|suo xing;
索性__索性 769.432826682|suo xing;
所需__所需 2665.32595143|suo xu;
所占__所佔 845.867144221|suo zhan;
所长__所長 847.977956119|suo zhang;
所指__所指 400.978810625|suo zhi;
所知__所知 722.053448193|suo zhi;
所致__所致 1282.5196677|suo zhi;
所著__所著 126.621787068|suo zhu;
锁住__鎖住 208.184564378|suo zhu;
所长__所長 166.97657743|suo chang;
所称__所稱 348.309611377|suo cheng;
所持__所持 457.033213363|suo chi;
所处__所處 815.844260376|suo chu;
所生__所生 191.747236314|suo sheng;
琐事__瑣事 352.677286738|suo shi;
所示__所示 1169.53977147|suo shi;
所受__所受 253.804804573|suo shou;
所述__所述 647.058374454|suo shu;
所属__所屬 1742.60930056|suo shu;
所说__所說 3699.02082656|suo shuo;
缩水__縮水 703.402776999|suo shui;
缩在__縮在 112.484875527|suo zai;
锁在__鎖在 131.117943492|suo zai;
所载__所載 483.394725468|suo zai;
所在__所在 5728.60805208|suo zai;
所作__所作 715.782248677|suo zuo;
所做__所做 1194.58057905|suo zuo;
所赐__所賜 114.321989585|suo ci;
所思__所思 117.207077876|suo si;
琐碎__瑣碎 441.361118731|suo sui;
所愿__所願 195.365179853|suo yuan;
所言__所言 587.123698784|suo yan;
索要__索要 453.063775264|suo yao;
所要__所要 651.914561431|suo yao;
所以__所以 95995.4851669|suo yi;
索引__索引 1450.91895115|suo yin;
缩影__縮影 294.743493195|suo ying;
所有__所有 44275.5132302|suo you;
所用__所用 1090.70577937|suo yong;
所欲__所欲 179.268563673|suo yu;
所为__所為 396.012952778|suo wei;
所谓__所謂 12024.4446889|suo wei;
所爱__所愛 381.957020988|suo ai;
索爱__索愛 1129.43516323|suo ai;
索尔__索爾 124.742372548|suo er;
岁半__歲半 110.126966673|sui ban;
随笔__隨筆 856.474009391|sui bi;
随便__隨便 15582.4341451|sui bian;
虽不__雖不 404.491915522|sui bu;
碎片__碎片 1194.58057905|sui pian;
岁末__歲末 239.068350048|sui mo;
随访__隨訪 176.60772663|sui fang;
随风__隨風 679.282440527|sui feng;
隧道__隧道 1165.17561047|sui dao;
岁的__歲的 4841.57510783|sui de;
随地__隨地 154.947067523|sui di;
隋唐__隋唐 150.569041974|sui tang;
随同__隨同 160.049619219|sui tong;
随你__隨你 576.969379906|sui ni;
遂宁__遂寧 115.036534536|sui ning;
碎了__碎了 325.236501817|sui le;
碎裂__碎裂 117.646076559|sui lie;
随口__隨口 372.091054935|sui kou;
随和__隨和 216.11485651|sui he;
随后__隨後 3912.37902339|sui hou;
随即__隨即 1571.37615922|sui ji;
随机__隨機 2665.32595143|sui ji;
虽小__雖小 145.405889264|sui xiao;
随想__隨想 125.992190229|sui xiang;
随心__隨心 343.567617462|sui xin;
随性__隨性 184.71110921|sui xing;
随行__隨行 266.444503116|sui xing;
随着__隨着 14033.7659451|sui zhe;
随之__隨之 1351.43315497|sui zhi;
随处__隨處 194.636170786|sui chu;
随身__隨身 676.747684543|sui shen;
碎石__碎石 263.472890441|sui shi;
虽是__雖是 431.571158705|sui shi;
岁时__歲時 532.077085292|sui shi;
随时__隨時 5932.02263413|sui shi;
随手__隨手 780.052703516|sui shou;
岁数__歲數 456.464028614|sui shu;
虽说__雖說 1316.52557925|sui shuo;
虽然__雖然 43131.8748454|sui ran;
随从__隨從 142.180598718|sui cong;
碎碎__碎碎 122.432284019|sui sui;
岁岁__歲歲 188.430963124|sui sui;
随缘__隨緣 372.555031371|sui yuan;
岁月__歲月 2648.77038315|sui yue;
虽已__雖已 156.89004718|sui yi;
随意__隨意 3471.24615709|sui yi;
虽有__雖有 513.831666385|sui you;
虽未__雖未 140.594881376|sui wei;
原版__原版 1054.61787307|yuan ban;
元宝__元寶 672.544092675|yuan bao;
原本__原本 4263.67354041|yuan ben;
远比__遠比 513.831666385|yuan bi;
渊博__淵博 152.267254161|yuan bo;
圆盘__圓盤 123.351140937|yuan pan;
原配__原配 232.603161479|yuan pei;
源码__源碼 1026.09756322|yuan ma;
圆满__圓滿 883.576728645|yuan man;
原貌__原貌 118.824795093|yuan mao;
圆梦__圓夢 141.29744947|yuan meng;
原名__原名 373.950434882|yuan ming;
原木__原木 128.529517539|yuan mu;
院方__院方 152.647228173|yuan fang;
远方__遠方 1100.26180506|yuan fang;
缘份__緣份 307.500011268|yuan fen;
缘分__緣分 1822.5663337|yuan fen;
远非__遠非 109.989815613|yuan fei;
远赴__遠赴 159.055477247|yuan fu;
怨妇__怨婦 171.831677206|yuan fu;
原副__原副 217.19480623|yuan fu;
远端__遠端 213.438416689|yuan duan;
远大__遠大 464.497524783|yuan da;
元代__元代 196.586267794|yuan dai;
原单__原單 139.026849285|yuan dan;
元旦__元旦 861.827215553|yuan dan;
园地__園地 322.813777494|yuan di;
原地__原地 758.957532109|yuan di;
原点__原點 252.228305921|yuan dian;
远点__遠點 316.441045148|yuan dian;
园丁__園丁 137.647730357|yuan ding;
原定__原定 461.61231651|yuan ding;
远东__遠東 470.32215416|yuan dong;
远眺__遠眺 151.321452046|yuan tiao;
原帖__原帖 429.960742313|yuan tie;
源头__源頭 1070.5071343|yuan tou;
圆通__圓通 575.5331706|yuan tong;
原图__原圖 282.164331387|yuan tu;
园内__園內 200.29551561|yuan nei;
院内__院內 326.861744407|yuan nei;
怨念__怨念 245.71323808|yuan nian;
元年__元年 309.807805448|yuan nian;
原来__原來 28696.2324236|yuan lai;
元老__元老 353.117055307|yuan lao;
圆了__圓了 147.412812521|yuan le;
院里__院里 381.006242235|yuan li;
远离__遠離 2038.87985164|yuan li;
原理__原理 3708.2515163|yuan li;
原料__原料 2705.48273369|yuan liao;
原谅__原諒 2394.45594186|yuan liang;
园林__園林 977.421145723|yuan lin;
原路__原路 110.677283245|yuan lu;
院落__院落 236.696839161|yuan luo;
原稿__原稿 170.339279748|yuan gao;
原告__原告 1456.35336279|yuan gao;
员工__員工 12190.4086525|yuan gong;
远古__遠古 400.978810625|yuan gu;
缘故__緣故 1643.47641462|yuan gu;
远看__遠看 110.264288753|yuan kan;
原画__原畫 115.467403456|yuan hua;
圆滑__圓滑 275.218769535|yuan hua;
原话__原話 294.743493195|yuan hua;
冤魂__冤魂 116.333988795|yuan hun;
远航__遠航 152.647228173|yuan hang;
缘何__緣何 202.554574186|yuan he;
怨恨__怨恨 439.166555128|yuan hen;
圆弧__圓弧 164.498187167|yuan hu;
原籍__原籍 197.568631008|yuan ji;
冤家__冤家 184.02185602|yuan jia;
原价__原價 619.442999798|yuan jia;
援建__援建 129.817279349|yuan jian;
远见__遠見 257.3078729|yuan jian;
原件__原件 886.886162059|yuan jian;
元件__元件 985.98464814|yuan jian;
圆角__圓角 114.179614083|yuan jiao;
远近__遠近 266.776744296|yuan jin;
愿景__願景 242.972837869|yuan jing;
远景__遠景 416.253137598|yuan jing;
袁泉__袁泉 164.908682755|yuan quan;
圆圈__圓圈 265.119670945|yuan quan;
源泉__源泉 527.455873984|yuan quan;
缘起__緣起 175.073848088|yuan qi;
怨气__怨氣 246.633556117|yuan qi;
元气__元氣 279.713669565|yuan qi;
远期__遠期 392.084582382|yuan qi;
元钱__元錢 780.052703516|yuan qian;
远去__遠去 600.442284667|yuan qu;
园区__園區 1487.53508505|yuan qu;
院系__院系 338.046607007|yuan xi;
院线__院線 219.918349804|yuan xian;
原先__原先 1891.99263098|yuan xian;
远销__遠銷 127.254530072|yuan xiao;
元宵__元宵 224.626982392|yuan xiao;
院校__院校 1445.50481813|yuan xiao;
圆心__圓心 106.882056102|yuan xin;
原形__原形 198.308623594|yuan xing;
远行__遠行 273.168633085|yuan xing;
圆形__圓形 776.174076244|yuan xing;
原型__原型 839.566182019|yuan xing;
元凶__元兇 120.164975734|yuan xiong;
原装__原裝 1489.38995692|yuan zhuang;
园长__園長 107.684208225|yuan zhang;
院长__院長 2116.54609407|yuan zhang;
远征__遠征 348.309611377|yuan zheng;
园中__園中 112.625137786|yuan zhong;
圆柱__圓柱 153.792848894|yuan zhu;
原著__原著 686.943814365|yuan zhu;
援助__援助 1443.7046004|yuan zhu;
圆桌__圓桌 118.23396695|yuan zhuo;
圆锥__圓錐 125.992190229|yuan zhui;
原创__原創 2763.40934226|yuan chuang;
原产__原產 224.06783424|yuan chan;
原唱__原唱 210.270405333|yuan chang;
原厂__原廠 547.548041623|yuan chang;
元朝__元朝 186.097370046|yuan chao;
远程__遠程 4026.13743678|yuan cheng;
远处__遠處 1129.43516323|yuan chu;
元帅__元帥 550.284199441|yuan shuai;
远山__遠山 163.272821143|yuan shan;
袁绍__袁紹 149.447435764|yuan shao;
远射__遠射 263.472890441|yuan she;
原审__原審 108.763116896|yuan shen;
元神__元神 185.172044961|yuan shen;
原生__原生 238.176261728|yuan sheng;
原声__原聲 325.236501817|yuan sheng;
原是__原是 329.314848809|yuan shi;
院士__院士 1086.63578899|yuan shi;
原始__原始 3149.7171872|yuan shi;
援手__援手 157.870654598|yuan shou;
元首__元首 228.295612376|yuan shou;
原水__原水 123.197520618|yuan shui;
圆润__圓潤 298.06779536|yuan run;
远在__遠在 441.361118731|yuan zai;
援藏__援藏 115.755545596|yuan zang;
原则__原則 9129.7548451|yuan ze;
园子__園子 269.785619908|yuan zi;
院子__院子 599.694499646|yuan zi;
源自__源自 650.291796355|yuan zi;
原子__原子 681.82669043|yuan zi;
远走__遠走 137.991222203|yuan zou;
原作__原作 284.991389772|yuan zuo;
原罪__原罪 128.369448119|yuan zui;
原色__原色 110.264288753|yuan se;
元素__元素 4404.08029353|yuan su;
元元__元元 120.164975734|yuan yuan;
媛媛__媛媛 203.566761683|yuan yuan;
渊源__淵源 375.351064872|yuan yuan;
圆圆__圓圓 424.107124851|yuan yuan;
远远__遠遠 3581.09211742|yuan yuan;
元月__元月 166.146325956|yuan yue;
怨言__怨言 272.488653616|yuan yan;
原样__原樣 179.492101402|yuan yang;
远洋__遠洋 318.022335873|yuan yang;
鸳鸯__鴛鴦 399.980682268|yuan yang;
原野__原野 221.845125512|yuan ye;
原意__原意 239.963779681|yuan yi;
园艺__園藝 257.3078729|yuan yi;
愿意__願意 14068.7863858|yuan yi;
援引__援引 283.574337601|yuan yin;
原因__原因 23567.5681396|yuan yin;
原由__原由 126.937764318|yuan you;
缘由__緣由 279.017397997|yuan you;
原油__原油 1112.67124847|yuan you;
原有__原有 2619.22907324|yuan you;
愿与__願與 208.44415872|yuan yu;
缘于__緣於 245.101601395|yuan yu;
源于__源於 1388.99614478|yuan yu;
员外__員外 111.091824605|yuan wai;
远望__遠望 163.069482749|yuan wang;
冤枉__冤枉 917.234466913|yuan wang;
愿望__願望 3007.78674349|yuan wang;
原文__原文 1285.72012038|yuan wen;
远未__遠未 111.369047744|yuan wei;
原委__原委 122.890853693|yuan wei;
愿为__願為 131.937467932|yuan wei;
原为__原為 158.067510349|yuan wei;
原位__原位 160.849404779|yuan wei;
原味__原味 195.121873946|yuan wei;
冤案__冤案 128.850255419|yuan an;
月报__月報 269.785619908|yue bao;
阅兵__閱兵 108.087539034|yue bing;
月饼__月餅 1861.58897661|yue bing;
月票__月票 179.492101402|yue piao;
乐谱__樂譜 123.967540162|yue pu;
乐迷__樂迷 183.563783354|yue mi;
月明__月明 181.969489867|yue ming;
月末__月末 397.991873082|yue mo;
岳母__岳母 311.744192349|yue mu;
越发__越發 760.851466162|yue fa;
月份__月份 9152.53761339|yue fen;
岳飞__岳飛 336.365750338|yue fei;
岳父__岳父 307.883446338|yue fu;
越大__越大 1587.1200774|yue da;
约旦__約旦 212.377144726|yue dan;
越低__越低 249.104624871|yue di;
月底__月底 3241.3000394|yue di;
约定__約定 2801.55051046|yue ding;
越冬__越冬 199.548108896|yue dong;
月度__月度 425.165459331|yue du;
阅读__閱讀 5873.17813943|yue du;
越多__越多 1777.70330251|yue duo;
乐队__樂隊 2172.66615296|yue dui;
乐团__樂團 503.688011099|yue tuan;
乐坛__樂壇 575.5331706|yue tan;
越南__越南 2098.16340664|yue nan;
悦来__悅來 125.835280772|yue lai;
阅览__閱覽 128.529517539|yue lan;
阅历__閱歷 415.216987933|yue li;
月亮__月亮 2615.96711065|yue liang;
月光__月光 1559.67079644|yue guang;
约稿__約稿 118.23396695|yue gao;
越高__越高 1079.88619313|yue gao;
月供__月供 198.555903198|yue gong;
越过__越過 574.81640715|yue guo;
越快__越快 353.117055307|yue kuai;
月卡__月卡 239.664931108|yue ka;
月刊__月刊 232.603161479|yue kan;
越看__越看 372.555031371|yue kan;
约克__約克 110.677283245|yue ke;
月华__月華 172.690339006|yue hua;
约翰__約翰 668.366611253|yue han;
月号__月號 129.171793682|yue hao;
约好__約好 532.077085292|yue hao;
越好__越好 1569.41918253|yue hao;
约合__約合 105.821807183|yue he;
约会__約會 1777.70330251|yue hui;
阅卷__閱卷 251.914183226|yue juan;
月季__月季 168.020228531|yue ji;
月间__月間 120.615053212|yue jian;
约见__約見 188.196293023|yue jian;
月结__月結 136.282292017|yue jie;
越近__越近 125.678566729|yue jin;
跃进__躍進 160.649084484|yue jin;
月经__月經 1822.5663337|yue jing;
越久__越久 135.267109459|yue jiu;
跃居__躍居 144.863304286|yue ju;
越剧__越劇 192.465424888|yue ju;
乐器__樂器 846.921892564|yue qi;
月前__月前 387.22887368|yue qian;
越强__越強 162.258658377|yue qiang;
乐清__樂清 150.756793028|yue qing;
月球__月球 1153.6172982|yue qiu;
乐曲__樂曲 441.911471008|yue qu;
月下__月下 448.010827873|yue xia;
越小__越小 314.867617017|yue xiao;
越想__越想 331.786363812|yue xiang;
月薪__月薪 759.903909096|yue xin;
越秀__越秀 134.930398555|yue xiu;
越战__越戰 138.335571213|yue zhan;
约占__約佔 571.245957438|yue zhan;
乐章__樂章 284.281980745|yue zhang;
月中__月中 131.117943492|yue zhong;
越长__越長 283.574337601|yue chang;
月初__月初 1209.56018338|yue chu;
跃上__躍上 106.218162376|yue shang;
越少__越少 318.815941979|yue shao;
越深__越深 225.468321935|yue shen;
跃升__躍升 133.093414711|yue sheng;
越是__越是 1411.68136652|yue shi;
乐手__樂手 151.132997772|yue shou;
约束__約束 2143.08680935|yue shu;
越说__越說 186.097370046|yue shuo;
月入__月入 182.423584067|yue ru;
约在__約在 156.109948588|yue zai;
越早__越早 211.057972369|yue zao;
月子__月子 143.426288875|yue zi;
越走__越走 279.017397997|yue zou;
月租__月租 301.054193591|yue zu;
越做__越做 200.545272755|yue zuo;
粤菜__粵菜 128.209578049|yue cai;
月嫂__月嫂 110.677283245|yue sao;
月色__月色 305.97104031|yue se;
月圆__月圓 207.407719521|yue yuan;
越远__越遠 263.144763849|yue yuan;
月月__月月 503.060722916|yue yue;
月牙__月牙 132.10198647|yue ya;
岳阳__岳陽 332.200082586|yue yang;
月夜__月夜 214.2378495|yue ye;
越野__越野 464.497524783|yue ye;
月影__月影 198.803491145|yue ying;
越有__越有 150.007190589|yue you;
约有__約有 480.991159713|yue you;
粤语__粵語 838.520594407|yue yu;
越狱__越獄 1625.14698659|yue yu;
越位__越位 228.011295226|yue wei;
约为__約為 1093.42757174|yue wei;
月儿__月兒 223.510077937|yue er;
悦耳__悅耳 230.008975843|yue er;
云梦__雲夢 108.357265155|yun meng;
云峰__雲峰 190.793818607|yun feng;
云飞__雲飛 245.101601395|yun fei;
运费__運費 1815.76539105|yun fei;
孕妇__孕婦 1691.26300898|yun fu;
云端__雲端 180.839193473|yun duan;
运到__運到 321.609191441|yun dao;
晕倒__暈倒 2590.0172328|yun dao;
运动__運動 11186.0109942|yun dong;
云朵__雲朵 163.884358899|yun duo;
云台__雲台 143.605133321|yun tai;
云天__雲天 156.499511818|yun tian;
运通__運通 141.121478992|yun tong;
云南__雲南 3644.11721469|yun nan;
酝酿__醞釀 1015.91887775|yun niang;
韵律__韻律 200.29551561|yun lv;
运来__運來 137.134095104|yun lai;
云里__雲里 108.492380517|yun li;
运力__運力 275.905561849|yun li;
云龙__雲龍 137.476305203|yun long;
云海__雲海 203.820597887|yun hai;
蕴涵__蘊涵 277.630050085|yun han;
蕴含__蘊含 453.628720089|yun han;
允浩__允浩 126.464093517|yun hao;
运河__運河 411.610733326|yun he;
云集__雲集 515.113903202|yun ji;
运价__運價 258.593668656|yun jia;
孕期__孕期 287.130256264|yun qi;
运气__運氣 3428.25706512|yun qi;
运球__運球 120.314814642|yun qiu;
晕眩__暈眩 122.737806611|yun xuan;
云霞__雲霞 147.412812521|yun xia;
云霄__雲霄 171.403948695|yun xiao;
运行__運行 12670.5528438|yun xing;
允许__允許 7304.38638512|yun xu;
运转__運轉 1266.63650832|yun zhuan;
云中__雲中 245.101601395|yun zhong;
晕车__暈車 177.490254874|yun che;
匀称__勻稱 183.563783354|yun chen;
运程__運程 105.0335283|yun cheng;
运城__運城 157.67404401|yun cheng;
云山__雲山 150.944778196|yun shan;
陨石__隕石 208.964318904|yun shi;
运势__運勢 237.287502254|yun shi;
运输__運輸 3233.23169914|yun shu;
运载__運載 128.049907079|yun zai;
运作__運作 3764.12139917|yun zuo;
晕菜__暈菜 152.267254161|yun cai;
云彩__雲彩 299.1842072|yun cai;
蕴藏__蘊藏 331.37316028|yun cang;
云层__雲層 202.807148249|yun ceng;
运算__運算 909.268075561|yun suan;
晕死__暈死 2554.75594355|yun si;
运送__運送 553.723632203|yun song;
晕晕__暈暈 347.875829952|yun yun;
云云__云云 370.240920313|yun yun;
云烟__雲煙 163.272821143|yun yan;
运营__運營 4327.91161602|yun ying;
运用__運用 6059.03211339|yun yong;
孕育__孕育 518.979844093|yun yu;
运往__運往 174.855812809|yun wang;
运维__運維 418.333200332|yun wei;
韵味__韻味 504.944935018|yun wei;
云雾__雲霧 306.734573113|yun wu;
云儿__雲兒 145.768741141|yun er;
哑巴__啞巴 400.978810625|ya ba;
鸦片__鴉片 265.450260135|ya pian;
压迫__壓迫 1057.24961018|ya po;
亚麻__亞麻 221.568841736|ya ma;
衙门__衙門 243.275811214|ya men;
雅芳__雅芳 201.296414343|ya fang;
鸭蛋__鴨蛋 197.814987883|ya dan;
亚当__亞當 228.011295226|ya dang;
压倒__壓倒 353.117055307|ya dao;
压得__壓得 227.727332161|ya de;
压低__壓低 347.00988711|ya di;
雅典__雅典 511.914293268|ya dian;
亚东__亞東 105.821807183|ya dong;
亚泰__亞泰 265.78126155|ya tai;
亚太__亞太 666.702893247|ya tai;
牙疼__牙疼 186.097370046|ya teng;
丫头__丫頭 2695.38717088|ya tou;
牙痛__牙痛 129.171793682|ya tong;
压力__壓力 14033.7659451|ya li;
哑铃__啞鈴 172.475272126|ya ling;
亚冠__亞冠 192.705418355|ya guan;
牙膏__牙膏 593.006203378|ya gao;
雅阁__雅閣 404.491915522|ya ge;
压根__壓根 538.749137684|ya gen;
亚克__亞克 105.821807183|ya ke;
牙科__牙科 135.773751924|ya ke;
丫鬟__丫鬟 224.907079496|ya huan;
雅虎__雅虎 2309.46804145|ya hu;
亚军__亞軍 565.579310193|ya jun;
压价__壓價 110.677283245|ya jia;
押金__押金 673.382717005|ya jin;
牙签__牙籤 197.322580943|ya qian;
压下__壓下 130.954650472|ya xia;
亚信__亞信 175.292155245|ya xin;
压榨__壓榨 277.630050085|ya zha;
压着__壓着 296.585723861|ya zhe;
雅致__雅緻 277.630050085|ya zhi;
压制__壓制 1036.37823089|ya zhi;
压轴__壓軸 140.945727665|ya zhou;
亚洲__亞洲 4988.56403023|ya zhou;
压住__壓住 241.162905094|ya zhu;
牙齿__牙齒 1875.5602418|ya chi;
牙刷__牙刷 319.213487372|ya shua;
亚视__亞視 109.034528882|ya shi;
压在__壓在 585.662213047|ya zai;
鸭子__鴨子 1103.00744393|ya zi;
亚瑟__亞瑟 118.529012887|ya se;
压死__壓死 145.587202159|ya si;
雅思__雅思 1082.58098585|ya si;
压缩__壓縮 3118.47261385|ya suo;
亚运__亞運 217.19480623|ya yun;
牙牙__牙牙 116.18910757|ya ya;
呀呀__呀呀 190.081867665|ya ya;
丫丫__丫丫 515.756221017|ya ya;
亚裔__亞裔 168.229740225|ya yi;
牙医__牙醫 187.727829225|ya yi;
压抑__壓抑 1768.86409398|ya yi;
牙龈__牙齦 209.485777119|ya yin;
亚于__亞於 362.028498203|ya yu;
雅安__雅安 167.393257695|ya an;
亚欧__亞歐 198.803491145|ya ou;
严把__嚴把 174.203334854|yan ba;
延边__延邊 196.831399718|yan bian;
演变__演變 1059.88791463|yan bian;
眼部__眼部 491.289575698|yan bu;
研判__研判 135.098649108|yan pan;
眼皮__眼皮 459.317058623|yan pi;
赝品__贗品 110.95347192|yan pin;
燕麦__燕麥 109.034528882|yan mai;
掩埋__掩埋 236.991986692|yan mai;
严密__嚴密 771.352901218|yan mi;
颜面__顏面 207.666345181|yan mian;
湮灭__湮滅 113.47039186|yan mie;
严明__嚴明 130.791560815|yan ming;
研磨__研磨 181.516526012|yan mo;
淹没__淹沒 755.18379558|yan mo;
眼眸__眼眸 207.666345181|yan mou;
研发__研發 4734.18271471|yan fa;
厌烦__厭煩 424.635962376|yan fan;
验房__驗房 135.94305409|yan fang;
严防__嚴防 225.187525865|yan fang;
严打__嚴打 258.916120291|yan da;
眼袋__眼袋 226.312812713|yan dai;
演得__演得 308.651751439|yan de;
演的__演的 845.867144221|yan de;
炎帝__炎帝 107.550099352|yan di;
眼底__眼底 213.438416689|yan di;
烟斗__煙斗 121.520271774|yan dou;
严冬__嚴冬 112.484875527|yan dong;
研读__研讀 200.545272755|yan du;
烟台__煙台 1104.38283164|yan tai;
言谈__言談 187.4940348|yan tan;
研讨__研討 766.561672733|yan tao;
烟头__煙頭 233.474375771|yan tou;
沿途__沿途 574.10053635|yan tu;
言论__言論 2850.85613781|yan lun;
眼泪__眼淚 3806.57552354|yan lei;
眼力__眼力 181.742866823|yan li;
艳丽__艷麗 538.749137684|yan li;
严厉__嚴厲 1214.09058664|yan li;
眼里__眼裡 2922.80180368|yan li;
眼帘__眼帘 190.081867665|yan lian;
演练__演練 611.771607197|yan lian;
颜料__顏料 317.230705235|yan liao;
沿路__沿路 155.915530766|yan lu;
眼光__眼光 3323.09914758|yan guang;
掩盖__掩蓋 979.860242923|yan gai;
阉割__閹割 247.249015706|yan ge;
严格__嚴格 6258.56170167|yan ge;
演过__演過 276.249600432|yan guo;
眼眶__眼眶 419.900065808|yan kuang;
眼看__眼看 958.125676369|yan kan;
眼科__眼科 226.312812713|yan ke;
严酷__嚴酷 175.510734618|yan ku;
眼花__眼花 253.804804573|yan hua;
演化__演化 465.65665114|yan hua;
烟花__煙花 900.248315564|yan hua;
延缓__延緩 294.009808944|yan huan;
炎黄__炎黃 152.457122789|yan huang;
沿海__沿海 1271.38069074|yan hai;
严寒__嚴寒 217.19480623|yan han;
沿河__沿河 129.979154132|yan he;
延后__延後 212.641966978|yan hou;
咽喉__咽喉 302.558594526|yan hou;
眼红__眼紅 289.285174995|yan hong;
掩护__掩護 515.756221017|yan hu;
焰火__焰火 227.160466527|yan huo;
验货__驗貨 266.776744296|yan huo;
烟火__煙火 540.093554591|yan huo;
烟灰__煙灰 159.055477247|yan hui;
宴会__宴會 429.960742313|yan hui;
厌倦__厭倦 749.558344131|yan juan;
严峻__嚴峻 1130.84350481|yan jun;
延吉__延吉 107.14877401|yan ji;
演技__演技 1196.07015327|yan ji;
眼睑__眼瞼 190.081867665|yan jian;
眼见__眼見 327.677408739|yan jian;
燕郊__燕郊 149.447435764|yan jiao;
眼角__眼角 608.72971781|yan jiao;
岩浆__岩漿 130.628674269|yan jiang;
沿江__沿江 310.194118206|yan jiang;
演讲__演講 2300.85021536|yan jiang;
沿街__沿街 178.59961945|yan jie;
眼界__眼界 355.767206381|yan jie;
演进__演進 332.200082586|yan jin;
严谨__嚴謹 1096.15615618|yan jin;
严禁__嚴禁 1265.05905145|yan jin;
燕京__燕京 166.353500999|yan jing;
眼镜__眼鏡 2681.98499671|yan jing;
眼睛__眼睛 13218.9352172|yan jing;
烟酒__煙酒 271.810366771|yan jiu;
研究__研究 34680.6933667|yan jiu;
眼圈__眼圈 211.057972369|yan quan;
烟气__煙氣 162.258658377|yan qi;
延期__延期 859.681929668|yan qi;
眼前__眼前 4442.66586373|yan qian;
延庆__延慶 131.773154284|yan qing;
言情__言情 203.820597887|yan qing;
宴请__宴請 245.101601395|yan qing;
眼球__眼球 1363.27349742|yan qiu;
烟熏__煙熏 110.815291538|yan xun;
宴席__宴席 191.508436159|yan xi;
沿袭__沿襲 205.60633599|yan xi;
演戏__演戲 645.447697543|yan xi;
演习__演習 713.111292931|yan xi;
咽下__咽下 145.768741141|yan xia;
眼下__眼下 665.043316617|yan xia;
艳羡__艷羨 125.992190229|yan xian;
眼线__眼線 199.299593609|yan xian;
沿线__沿線 633.494731672|yan xian;
言行__言行 587.123698784|yan xing;
研修__研修 151.510141313|yan xiu;
延续__延續 2439.63524442|yan xu;
延展__延展 111.230349808|yan zhan;
艳照__艷照 288.205701591|yan zhao;
沿着__沿着 1494.96846157|yan zhe;
严正__嚴正 113.47039186|yan zheng;
炎症__炎症 852.21539528|yan zheng;
验证__驗證 4716.51701742|yan zheng;
言之__言之 149.820373083|yan zhi;
腌制__腌制 179.268563673|yan zhi;
胭脂__胭脂 256.987424161|yan zhi;
研制__研製 2090.33406802|yan zhi;
兖州__兗州 127.413209251|yan zhou;
眼中__眼中 2412.42638506|yan zhong;
严重__嚴重 15504.9541829|yan zhong;
眼珠__眼珠 212.377144726|yan zhu;
严查__嚴查 211.848489234|yan cha;
演唱__演唱 1676.57400252|yan chang;
延长__延長 2013.62967073|yan chang;
烟尘__煙塵 176.827946446|yan chen;
严惩__嚴懲 308.651751439|yan cheng;
盐城__鹽城 335.946843682|yan cheng;
延迟__延遲 1725.32295995|yan chi;
演出__演出 4817.50152258|yan chu;
眼霜__眼霜 403.988165198|yan shuang;
燕山__燕山 166.768626413|yan shan;
衍射__衍射 110.677283245|yan she;
延伸__延伸 1954.29771596|yan shen;
眼神__眼神 3768.81504502|yan shen;
衍生__衍生 436.982903472|yan sheng;
延时__延時 650.291796355|yan shi;
岩石__岩石 784.92825478|yan shi;
掩饰__掩飾 1114.0586864|yan shi;
演示__演示 2051.62343063|yan shi;
验收__驗收 2289.40978274|yan shou;
眼熟__眼熟 275.905561849|yan shu;
言说__言說 176.60772663|yan shuo;
演说__演說 256.987424161|yan shuo;
盐水__鹽水 394.535222541|yan shui;
嫣然__嫣然 204.839111844|yan ran;
俨然__儼然 501.808489233|yan ran;
炎热__炎熱 519.626982517|yan re;
晏紫__晏紫 110.264288753|yan zi;
验资__驗資 147.964946673|yan zi;
燕姿__燕姿 220.742053181|yan zi;
燕子__燕子 946.259922413|yan zi;
演奏__演奏 974.988119996|yan zou;
掩藏__掩藏 115.467403456|yan cang;
烟草__煙草 811.787668067|yan cao;
言词__言詞 116.624293448|yan ci;
言辞__言辭 406.006938516|yan ci;
烟囱__煙囪 246.019628549|yan cong;
盐酸__鹽酸 310.580912674|yan suan;
眼色__眼色 178.155043976|yan se;
颜色__顏色 9560.56669003|yan se;
淹死__淹死 377.697115787|yan si;
严肃__嚴肅 2323.90287358|yan su;
演员__演員 5127.22081778|yan yuan;
燕燕__燕燕 120.615053212|yan yan;
炎炎__炎炎 148.889769675|yan yan;
艳阳__艷陽 169.28122395|yan yang;
烟叶__煙葉 237.879639313|yan ye;
演义__演義 188.901181552|yan yi;
演艺__演藝 627.992684885|yan yi;
演绎__演繹 2077.35003942|yan yi;
掩映__掩映 131.773154284|yan ying;
眼影__眼影 311.355949144|yan ying;
沿用__沿用 434.810109507|yan yong;
谚语__諺語 225.187525865|yan yu;
烟雨__煙雨 321.609191441|yan yu;
艳遇__艷遇 382.433299725|yan yu;
言语__言語 2347.18650079|yan yu;
阎王__閻王 163.884358899|yan wang;
烟味__煙味 132.762114633|yan wei;
燕窝__燕窩 268.778909483|yan wo;
延误__延誤 466.818670029|yan wu;
烟雾__煙霧 509.368920718|yan wu;
厌恶__厭惡 904.746955463|yan wu;
沿岸__沿岸 324.426913464|yan an;
延安__延安 664.215078095|yan an;
样板__樣板 518.979844093|yang ban;
样本__樣本 1326.40613196|yang ben;
养病__養病 137.991222203|yang bing;
羊皮__羊皮 166.97657743|yang pi;
样片__樣片 138.680779525|yang pian;
样品__樣品 2300.85021536|yang pin;
杨浦__楊浦 246.019628549|yang pu;
样貌__樣貌 133.925286409|yang mao;
羊毛__羊毛 378.63963681|yang mao;
杨梅__楊梅 347.442588754|yang mei;
杨明__楊明 111.786180106|yang ming;
阳明__陽明 113.611883002|yang ming;
扬名__揚名 127.413209251|yang ming;
杨某__楊某 175.729586548|yang mou;
仰慕__仰慕 314.867617017|yang mu;
扬帆__揚帆 162.056583012|yang fan;
杨帆__楊帆 162.460985719|yang fan;
洋房__洋房 178.822323044|yang fang;
养分__養分 313.69268222|yang fen;
养大__養大 151.699065864|yang da;
养的__養的 389.163898974|yang de;
阳台__陽台 1581.19770715|yang tai;
仰天__仰天 145.768741141|yang tian;
仰头__仰頭 156.499511818|yang tou;
养牛__養牛 106.085879302|yang niu;
杨澜__楊瀾 180.839193473|yang lan;
养老__養老 1086.63578899|yang lao;
阳历__陽曆 275.561951728|yang li;
杨林__楊林 105.164499152|yang lin;
杨凌__楊凌 137.476305203|yang ling;
杨柳__楊柳 341.008342538|yang liu;
阳关__陽關 127.73116145|yang guan;
杨光__楊光 130.628674269|yang guang;
阳光__陽光 7793.38813678|yang guang;
阳刚__陽剛 243.57916235|yang gang;
养狗__養狗 338.046607007|yang gou;
杨过__楊過 476.219822262|yang guo;
氧化__氧化 834.351249399|yang hua;
央行__央行 2367.75095999|yang hang;
养好__養好 157.870654598|yang hao;
养护__養護 550.284199441|yang hu;
养活__養活 720.256091319|yang huo;
阳极__陽極 109.989815613|yang ji;
养鸡__養雞 150.944778196|yang ji;
样机__樣機 446.339066527|yang ji;
养家__養家 200.545272755|yang jia;
杨家__楊家 213.704562287|yang jia;
杨佳__楊佳 281.111429553|yang jia;
阳江__陽江 249.104624871|yang jiang;
洋酒__洋酒 147.596627936|yang jiu;
阳具__陽具 181.969489867|yang ju;
养犬__養犬 142.180598718|yang quan;
羊群__羊群 173.337150041|yang qun;
仰起__仰起 113.187937993|yang qi;
洋气__洋氣 114.893269147|yang qi;
阳气__陽氣 177.048440864|yang qi;
扬起__揚起 306.352568839|yang qi;
央企__央企 402.982545867|yang qi;
氧气__氧氣 597.456727653|yang qi;
央求__央求 107.684208225|yang qiu;
养血__養血 120.314814642|yang xue;
阳线__陽線 256.347723437|yang xian;
杨晓__楊曉 127.572086295|yang xiao;
阳性__陽性 562.76710106|yang xing;
样张__樣張 123.504952812|yang zhang;
养着__養着 261.510250403|yang zhe;
养殖__養殖 1513.71482027|yang zhi;
扬州__揚州 1373.50489426|yang zhou;
养猪__養豬 452.499534015|yang zhu;
阳春__陽春 110.126966673|yang chun;
羊城__羊城 140.945727665|yang cheng;
养成__養成 1301.84258129|yang cheng;
养伤__養傷 110.815291538|yang shang;
养神__養神 195.60878915|yang shen;
养生__養生 724.757896749|yang sheng;
仰视__仰視 158.067510349|yang shi;
样式__樣式 1684.95202731|yang shi;
央视__央視 2564.32477261|yang shi;
杨树__楊樹 206.633773476|yang shu;
阳朔__陽朔 320.409100324|yang shuo;
羊水__羊水 147.964946673|yang shui;
洋人__洋人 311.744192349|yang ren;
羊肉__羊肉 662.561694208|yang rou;
羊绒__羊絨 148.519148841|yang rong;
扬子__揚子 115.467403456|yang zi;
杨子__楊子 170.127140854|yang zi;
洋子__洋子 1725.32295995|yang zi;
样子__樣子 13284.9916911|yang zi;
洋葱__洋蔥 417.812212206|yang cong;
养颜__養顏 180.613978088|yang yan;
扬言__揚言 268.778909483|yang yan;
养眼__養眼 314.475483928|yang yan;
扬扬__揚揚 111.230349808|yang yang;
羊羊__羊羊 169.915266157|yang yang;
阳阳__陽陽 200.545272755|yang yang;
洋洋__洋洋 294.743493195|yang yang;
样样__樣樣 306.352568839|yang yang;
痒痒__痒痒 355.767206381|yang yang;
洋溢__洋溢 480.392137969|yang yi;
养鱼__養魚 210.008536601|yang yu;
养育__養育 336.785179346|yang yu;
仰望__仰望 443.014235191|yang wang;
杨威__楊威 135.94305409|yang wei;
阳痿__陽痿 386.264972075|yang wei;
仰卧__仰卧 152.647228173|yang wo;
样儿__樣兒 116.18910757|yang er;
要把__要把 3639.57886632|yao ba;
摇摆__搖擺 579.852559389|yao bai;
要办__要辦 224.626982392|yao ban;
腰包__腰包 324.83145542|yao bao;
要被__要被 390.135034682|yao bei;
要比__要比 1779.91999768|yao bi;
腰部__腰部 513.191745392|yao bu;
要不__要不 11227.9081575|yao bu;
要拍__要拍 164.703307075|yao pai;
药片__藥片 126.464093517|yao pian;
药品__藥品 2966.83781195|yao pin;
要吗__要嗎 244.796354228|yao ma;
姚麦__姚麥 141.29744947|yao mai;
要卖__要賣 201.547419552|yao mai;
要买__要買 1249.39213028|yao mai;
要么__要麼 5622.52066996|yao me;
要命__要命 1168.08323794|yao ming;
姚明__姚明 3079.85238931|yao ming;
妖魔__妖魔 165.526347625|yao mo;
要饭__要飯 202.050369328|yao fan;
药方__藥方 241.162905094|yao fang;
药房__藥房 332.200082586|yao fang;
药费__藥費 113.47039186|yao fei;
要打__要打 499.3133654|yao da;
要带__要帶 377.226735448|yao dai;
腰带__腰帶 800.735741689|yao dai;
要当__要當 230.008975843|yao dang;
要到__要到 1353.11831545|yao dao;
要得__要得 1331.37418129|yao de;
要等__要等 390.621510938|yao deng;
要低__要低 177.490254874|yao di;
药店__藥店 890.207990943|yao dian;
要点__要點 1193.09285994|yao dian;
窑洞__窯洞 106.748946222|yao dong;
摇动__搖動 183.335174792|yao dong;
要多__要多 1014.65366219|yao duo;
要对__要對 812.799921236|yao dui;
腰疼__腰疼 171.403948695|yao teng;
窈窕__窈窕 149.075426771|yao tiao;
要听__要聽 210.008536601|yao ting;
摇头__搖頭 1049.37403554|yao tou;
腰痛__腰痛 274.191785204|yao tong;
要拿__要拿 242.972837869|yao na;
要能__要能 157.870654598|yao neng;
要你__要你 617.901063897|yao ni;
妖孽__妖孽 149.075426771|yao nie;
要来__要來 851.15405446|yao lai;
摇篮__搖籃 318.815941979|yao lan;
咬了__咬了 269.785619908|yao le;
要了__要了 274.533686805|yao le;
摇了__搖了 369.779825848|yao le;
药理__藥理 143.426288875|yao li;
要领__要領 218.280152578|yao ling;
药罐__藥罐 173.553291634|yao guan;
摇滚__搖滾 1469.11294508|yao gun;
妖怪__妖怪 728.379591714|yao guai;
要干__要干 107.416157498|yao gan;
摇杆__搖桿 195.60878915|yao gan;
遥感__遙感 305.589986932|yao gan;
药膏__藥膏 176.827946446|yao gao;
要搞__要搞 288.205701591|yao gao;
要高__要高 366.111682898|yao gao;
要跟__要跟 453.063775264|yao gen;
要给__要給 938.041438335|yao gei;
要过__要過 249.415244207|yao guo;
要快__要快 250.974160423|yao kuai;
要开__要開 275.218769535|yao kai;
要看__要看 2685.32927986|yao kan;
要考__要考 224.626982392|yao kao;
要靠__要靠 927.579613097|yao kao;
遥控__遙控 731.107734818|yao kong;
要哭__要哭 126.621787068|yao ku;
要花__要花 392.084582382|yao hua;
摇晃__搖晃 449.688850794|yao huang;
要害__要害 345.284462654|yao hai;
摇号__搖號 122.584950132|yao hao;
要好__要好 1159.38205078|yao hao;
要喝__要喝 158.857391092|yao he;
要和__要和 228.011295226|yao he;
吆喝__吆喝 351.799391968|yao he;
要回__要回 417.291872914|yao hui;
药剂__藥劑 417.812212206|yao ji;
药价__葯價 165.526347625|yao jia;
要价__要價 171.617679695|yao jia;
要加__要加 279.713669565|yao jia;
要见__要見 132.266710153|yao jian;
药监__葯監 147.229226029|yao jian;
要件__要件 181.969489867|yao jian;
腰间__腰間 292.183578474|yao jian;
要叫__要叫 107.416157498|yao jiao;
要交__要交 394.535222541|yao jiao;
要讲__要講 311.744192349|yao jiang;
要将__要將 706.037369534|yao jiang;
要紧__要緊 786.88699725|yao jin;
妖精__妖精 841.661270235|yao jing;
药酒__藥酒 111.091824605|yao jiu;
药企__葯企 117.207077876|yao qi;
要钱__要錢 970.140222547|yao qian;
要强__要強 294.376422496|yao qiang;
要请__要請 155.140277726|yao qing;
邀请__邀請 5829.42815609|yao qing;
要求__要求 49284.1285413|yao qiu;
要去__要去 5001.01269948|yao qu;
药学__藥學 184.251320835|yao xue;
要学__要學 360.677581637|yao xue;
要先__要先 790.819158167|yao xian;
药效__藥效 203.313241605|yao xiao;
要像__要像 205.094534596|yao xiang;
要向__要向 563.46883971|yao xiang;
要想__要想 2729.18634194|yao xiang;
要挟__要挾 242.36802267|yao xie;
要写__要寫 513.831666385|yao xie;
要抓__要抓 111.369047744|yao zhua;
要找__要找 1000.83985593|yao zhao;
摇着__搖着 213.172602547|yao zhe;
夭折__夭折 257.94996962|yao zhe;
咬着__咬着 335.528458728|yao zhe;
咬住__咬住 215.576896995|yao zhu;
腰椎__腰椎 233.765505073|yao zhui;
谣传__謠傳 169.915266157|yao chuan;
要穿__要穿 170.127140854|yao chuan;
药厂__藥廠 219.644465616|yao chang;
瑶池__瑤池 264.789493468|yao chi;
要吃__要吃 710.450303909|yao chi;
要出__要出 254.121284766|yao chu;
要杀__要殺 260.209952636|yao sha;
药膳__葯膳 107.015331962|yao shan;
腰上__腰上 176.827946446|yao shang;
咬伤__咬傷 194.393772779|yao shang;
要少__要少 182.196395498|yao shao;
药师__藥師 227.727332161|yao shi;
要使__要使 365.20034683|yao shi;
钥匙__鑰匙 3986.19894738|yao shi;
要是__要是 17628.4618285|yao shi;
要说__要說 1966.51263254|yao shuo;
药水__藥水 847.977956119|yao shui;
要让__要讓 1637.34374958|yao rang;
妖娆__妖嬈 281.812926654|yao rao;
咬人__咬人 272.149298879|yao ren;
要再__要再 197.568631008|yao zai;
要在__要在 2735.99686654|yao zai;
要走__要走 1217.12027856|yao zou;
要做__要做 3428.25706512|yao zuo;
药材__藥材 433.187606905|yao cai;
药草__藥草 221.017305999|yao cao;
要从__要從 1153.6172982|yao cong;
腰酸__腰酸 106.085879302|yao suan;
要塞__要塞 316.441045148|yao sai;
咬死__咬死 175.729586548|yao si;
要死__要死 1511.82965446|yao si;
要送__要送 151.888225993|yao song;
要素__要素 1818.02954749|yao su;
遥远__遙遠 1986.21549859|yao yuan;
邀约__邀約 158.659551632|yao yue;
要约__要約 163.069482749|yao yue;
咬牙__咬牙 383.865702254|yao ya;
妖艳__妖艷 218.008308584|yao yan;
谣言__謠言 719.359091341|yao yan;
耀眼__耀眼 723.855290267|yao yan;
瑶瑶__瑤瑤 129.979154132|yao yao;
遥遥__遙遙 237.287502254|yao yao;
摇摇__搖搖 263.801426189|yao yao;
妖妖__妖妖 316.441045148|yao yao;
药液__藥液 128.049907079|yao ye;
摇曳__搖曳 323.216307961|yao ye;
药业__葯業 626.429466854|yao ye;
要义__要義 108.222318063|yao yi;
要以__要以 978.639934443|yao yi;
要由__要由 123.658956482|yao you;
要有__要有 4470.43378899|yao you;
药用__藥用 207.149415951|yao yong;
要用__要用 2554.75594355|yao yong;
要与__要與 264.789493468|yao yu;
药丸__藥丸 132.927661458|yao wan;
要玩__要玩 161.653186955|yao wan;
遥望__遙望 260.859291326|yao wang;
要闻__要聞 224.626982392|yao wen;
要问__要問 499.935980841|yao wen;
腰围__腰圍 261.83633885|yao wei;
要为__要為 530.752623218|yao wei;
要我__要我 1119.62576025|yao wo;
药物__藥物 4174.29838181|yao wu;
要按__要按 196.831399718|yao an;
也把__也把 192.225730308|ye ba;
也罢__也罷 847.977956119|ye ba;
夜半__夜半 250.974160423|ye ban;
夜班__夜班 522.874798954|ye ban;
也被__也被 1833.95789167|ye bei;
也比__也比 729.287839744|ye bi;
也别__也別 458.745029596|ye bie;
也不__也不 19139.642985|ye bu;
也怕__也怕 142.357889859|ye pa;
叶片__葉片 601.940653207|ye pian;
野马__野馬 204.07475061|ye ma;
页码__頁碼 273.850309404|ye ma;
野蛮__野蠻 816.861571886|ye man;
野猫__野貓 148.334184528|ye mao;
爷们__爺們 388.679238014|ye men;
页眉__頁眉 158.857391092|ye mei;
也没__也沒 7900.95415068|ye mei;
页面__頁面 11312.1738491|ye mian;
夜幕__夜幕 307.500011268|ye mu;
夜风__夜風 137.305093541|ye feng;
也非__也非 114.75018218|ye fei;
耶夫__耶夫 166.97657743|ye fu;
也大__也大 132.596773978|ye da;
也得__也得 1108.5192935|ye de;
也得__也得 871.547443971|ye dei;
夜店__夜店 207.666345181|ye dian;
也都__也都 1766.66116773|ye dou;
也多__也多 373.950434882|ye duo;
也对__也對 643.841029976|ye dui;
液态__液態 173.769702743|ye tai;
业态__業態 317.230705235|ye tai;
也太__也太 836.433324055|ye tai;
液体__液體 1429.38333547|ye ti;
也挺__也挺 615.595353746|ye ting;
也难__也難 282.868455943|ye nan;
也能__也能 5178.59142346|ye neng;
业内__業內 1408.16736736|ye nei;
耶律__耶律 116.333988795|ye lv;
也来__也來 434.810109507|ye lai;
野狼__野狼 107.952927857|ye lang;
夜里__夜裡 1579.22849881|ye li;
冶炼__冶鍊 266.776744296|ye lian;
耶鲁__耶魯 107.952927857|ye lu;
也该__也該 608.72971781|ye gai;
也敢__也敢 142.180598718|ye gan;
也跟__也跟 248.794392378|ye gen;
也更__也更 262.817045902|ye geng;
也给__也給 814.828215816|ye gei;
野狗__野狗 117.792774542|ye gou;
也够__也夠 284.991389772|ye gou;
也快__也快 426.757915008|ye kuai;
也可__也可 2564.32477261|ye ke;
夜空__夜空 514.472385324|ye kong;
液化__液化 163.069482749|ye hua;
野花__野花 237.879639313|ye hua;
也还__也還 309.4219738|ye hai;
也好__也好 4594.6891828|ye hao;
也很__也很 4560.46281159|ye hen;
业户__業戶 113.32907693|ye hu;
也会__也會 10615.6039241|ye hui;
也即__也即 116.18910757|ye ji;
野鸡__野雞 131.281440129|ye ji;
业绩__業績 5210.95909278|ye ji;
夜间__夜間 1260.33845835|ye jian;
页脚__頁腳 110.264288753|ye jiao;
也较__也較 147.229226029|ye jiao;
也叫__也叫 664.215078095|ye jiao;
也将__也將 2695.38717088|ye jiang;
业界__業界 1861.58897661|ye jie;
冶金__冶金 373.950434882|ye jin;
夜景__夜景 476.219822262|ye jing;
液晶__液晶 1991.17198299|ye jing;
也就__也就 11312.1738491|ye jiu;
也请__也請 264.789493468|ye qing;
夜曲__夜曲 244.796354228|ye qu;
也去__也去 537.40806734|ye qu;
也学__也學 170.127140854|ye xue;
腋下__腋下 169.915266157|ye xia;
夜宵__夜宵 500.559372647|ye xiao;
也向__也向 142.891090816|ye xiang;
也像__也像 277.284292303|ye xiang;
也想__也想 1303.46590513|ye xiang;
野心__野心 607.9716117|ye xin;
夜行__夜行 211.057972369|ye xing;
野性__野性 572.671468255|ye xing;
也行__也行 2732.58948248|ye xing;
也许__也許 21545.081392|ye xu;
野战__野戰 248.484546245|ye zhan;
业者__業者 238.770616634|ye zhe;
也正__也正 400.978810625|ye zheng;
也只__也只 508.100984482|ye zhi;
野猪__野豬 608.72971781|ye zhu;
业主__業主 4532.13567457|ye zhu;
夜叉__夜叉 121.368931601|ye cha;
也常__也常 158.659551632|ye chang;
也称__也稱 305.589986932|ye cheng;
也少__也少 212.112652282|ye shao;
夜深__夜深 197.076837307|ye shen;
野生__野生 757.068312494|ye sheng;
夜市__夜市 287.488291405|ye shi;
也使__也使 511.914293268|ye shi;
也是__也是 62372.6924157|ye shi;
页首__頁首 168.439513167|ye shou;
野兽__野獸 654.356305043|ye shou;
页数__頁數 178.822323044|ye shu;
也说__也說 567.697685436|ye shuo;
也让__也讓 940.382265783|ye rang;
野人__野人 303.313611771|ye ren;
也在__也在 4865.76899142|ye zai;
椰子__椰子 318.418891685|ye zi;
叶子__葉子 1964.0635567|ye zi;
也做__也做 172.905674062|ye zuo;
也才__也才 161.653186955|ye cai;
野菜__野菜 202.050369328|ye cai;
野草__野草 200.29551561|ye cao;
也曾__也曾 1226.25479235|ye ceng;
也从__也從 373.484720623|ye cong;
叶酸__葉酸 204.839111844|ye suan;
也算__也算 2153.79604997|ye suan;
夜色__夜色 773.277767188|ye se;
耶稣__耶穌 818.900002077|ye su;
液压__液壓 475.626742696|ye ya;
夜宴__夜宴 147.229226029|ye yan;
也要__也要 10510.2992267|ye yao;
夜夜__夜夜 303.313611771|ye ye;
爷爷__爺爺 3004.04087494|ye ye;
业已__業已 244.491487214|ye yi;
也已__也已 581.299547476|ye yi;
也因__也因 224.907079496|ye yin;
也应__也應 549.598880816|ye ying;
夜游__夜遊 136.792736844|ye you;
也由__也由 171.190483873|ye you;
也有__也有 19187.4048426|ye you;
也用__也用 245.71323808|ye yong;
夜雨__夜雨 208.70407676|ye yu;
业余__業餘 1209.56018338|ye yu;
野外__野外 932.214830498|ye wai;
夜晚__夜晚 2180.80386611|ye wan;
页尾__頁尾 150.569041974|ye wei;
也未__也未 326.048110451|ye wei;
也为__也為 882.476330723|ye wei;
也无__也無 305.589986932|ye wu;
业务__業務 24958.0195079|ye wu;
一把__一把 5924.63495045|yi ba;
一百__一百 1840.82697426|yi bai;
一版__一版 186.32942291|yi ban;
一班__一班 744.902491688|yi ban;
一半__一半 6975.24102411|yi ban;
一般__一般 47653.4770433|yi ban;
一帮__一幫 1165.17561047|yi bang;
一包__一包 690.376548199|yi bao;
医保__醫保 788.850627646|yi bao;
译本__譯本 155.140277726|yi ben;
一本__一本 3703.63329569|yi ben;
一辈__一輩 197.568631008|yi bei;
易被__易被 211.057972369|yi bei;
以备__以備 267.775955618|yi bei;
以北__以北 313.69268222|yi bei;
一倍__一倍 1004.58849796|yi bei;
一杯__一杯 1703.95597413|yi bei;
已被__已被 2072.17903804|yi bei;
一比__一比 236.107646363|yi bi;
一笔__一筆 2199.91059329|yi bi;
一变__一變 170.551683166|yi bian;
以便__以便 3185.24167512|yi bian;
一遍__一遍 4554.78325527|yi bian;
一边__一邊 10277.1672064|yi bian;
仪表__儀錶 715.782248677|yi biao;
宜宾__宜賓 299.93080386|yi bin;
疫病__疫病 261.83633885|yi bing;
一并__一併 745.831342837|yi bing;
一拨__一撥 224.347234118|yi bo;
一波__一波 916.092151969|yi bo;
伊布__伊布 119.26985293|yi bu;
亦不__亦不 250.349428094|yi bu;
异步__異步 318.022335873|yi bu;
已不__已不 380.057830188|yi bu;
一步__一步 3087.5379805|yi bu;
一部__一部 5858.55845008|yi bu;
一拍__一拍 242.670241844|yi pai;
一派__一派 571.245957438|yi pai;
一排__一排 732.932171333|yi pai;
一盘__一盤 726.566487616|yi pan;
一旁__一旁 1169.53977147|yi pang;
一炮__一炮 171.617679695|yi pao;
一盆__一盆 324.83145542|yi pen;
一碰__一碰 129.494134325|yi peng;
一匹__一匹 388.195180646|yi pi;
一批__一批 5013.49243365|yi pi;
一篇__一篇 3806.57552354|yi pian;
一片__一片 7442.20770676|yi pian;
一票__一票 734.761160623|yi piao;
一瞥__一瞥 158.857391092|yi pie;
一拼__一拼 222.121753798|yi pin;
一品__一品 239.068350048|yi pin;
一平__一平 235.226605969|yi ping;
一瓶__一瓶 1280.92243009|yi ping;
一马__一馬 174.638049069|yi ma;
姨妈__姨媽 491.902185928|yi ma;
义卖__義賣 141.29744947|yi mai;
已满__已滿 176.60772663|yi man;
一毛__一毛 176.168109435|yi mao;
一门__一門 1092.0658276|yi men;
亿美__億美 557.184562398|yi mei;
一枚__一枚 858.611290099|yi mei;
一米__一米 588.588831574|yi mi;
以免__以免 1877.89895902|yi mian;
一面__一面 4138.04364463|yi mian;
一秒__一秒 553.723632203|yi miao;
疫苗__疫苗 1115.44785438|yi miao;
益民__益民 106.748946222|yi min;
移民__移民 2739.40849942|yi min;
译名__譯名 138.163289429|yi ming;
一命__一命 144.863304286|yi ming;
一名__一名 6846.06740057|yi ming;
一摸__一摸 185.172044961|yi mo;
一抹__一抹 515.756221017|yi mo;
一亩__一畝 139.373782642|yi mu;
一幕__一幕 1212.57856995|yi mu;
一发__一發 232.893204426|yi fa;
已发__已發 234.348853194|yi fa;
依法__依法 4317.13844997|yi fa;
疑犯__疑犯 170.127140854|yi fan;
一翻__一翻 217.19480623|yi fan;
一番__一番 3415.46445546|yi fan;
一放__一放 159.452390871|yi fang;
以防__以防 583.476802811|yi fang;
乙方__乙方 1714.60618362|yi fang;
一方__一方 2622.4951033|yi fang;
一分__一分 1659.94271905|yi fen;
一份__一份 10112.0167535|yi fen;
一封__一封 1170.99812122|yi feng;
已付__已付 107.550099352|yi fu;
一夫__一夫 127.096048509|yi fu;
姨夫__姨夫 130.791560815|yi fu;
依附__依附 321.208662461|yi fu;
一幅__一幅 1454.53963438|yi fu;
一副__一副 2470.2273797|yi fu;
衣服__衣服 15351.148095|yi fu;
一端__一端 362.931919108|yi duan;
一段__一段 7970.17696242|yi duan;
一吨__一噸 125.053659829|yi dun;
亿吨__億噸 174.855812809|yi dun;
一顿__一頓 2538.88717657|yi dun;
一打__一打 281.812926654|yi da;
已达__已達 1418.73569366|yi da;
一大__一大 3261.55908656|yi da;
以待__以待 105.164499152|yi dai;
一袋__一袋 314.083839199|yi dai;
一带__一帶 1425.82527204|yi dai;
一代__一代 3778.21990214|yi dai;
一旦__一旦 7716.07926336|yi dan;
一党__一黨 125.053659829|yi dang;
一档__一檔 314.083839199|yi dang;
已到__已到 247.866011137|yi dao;
移到__移到 541.441326411|yi dao;
一刀__一刀 811.787668067|yi dao;
一到__一到 1003.33739315|yi dao;
一道__一道 3572.17795663|yi dao;
医德__醫德 121.823518492|yi de;
一等__一等 347.875829952|yi deng;
一地__一地 391.108593802|yi di;
一滴__一滴 429.960742313|yi di;
异地__異地 1028.65812957|yi di;
疑点__疑點 279.017397997|yi dian;
一点__一點 39136.7253629|yi dian;
一碟__一碟 143.784200776|yi die;
一叠__一疊 180.839193473|yi die;
已定__已定 179.045304336|yi ding;
一顶__一頂 443.56664881|yi ding;
一定__一定 56103.792182|yi ding;
一抖__一抖 113.753550575|yi dou;
易懂__易懂 162.258658377|yi dong;
以东__以東 184.02185602|yi dong;
异动__異動 240.562595233|yi dong;
一动__一動 438.073368704|yi dong;
一栋__一棟 523.526794166|yi dong;
移动__移動 11905.1645689|yi dong;
一睹__一睹 194.151676652|yi du;
一度__一度 2433.56243196|yi du;
亿多__億多 189.845141544|yi duo;
一朵__一朵 881.377303227|yi duo;
一队__一隊 439.714170908|yi dui;
一对__一對 2861.53400907|yi dui;
一堆__一堆 3390.02226565|yi dui;
一团__一團 917.234466913|yi tuan;
一台__一台 4349.53866663|yi tai;
一探__一探 105.690017726|yi tan;
一堂__一堂 306.734573113|yi tang;
一趟__一趟 2156.48171146|yi tang;
一套__一套 6949.21277302|yi tao;
伊藤__伊藤 114.321989585|yi teng;
一题__一題 140.770195218|yi ti;
一提__一提 231.735198139|yi ti;
遗体__遺體 548.230802969|yi ti;
议题__議題 745.831342837|yi ti;
一体__一體 2213.66066021|yi ti;
倚天__倚天 144.143005824|yi tian;
一天__一天 17849.5163038|yi tian;
一跳__一跳 1104.38283164|yi tiao;
一条__一條 11006.2557422|yi tiao;
一贴__一貼 166.97657743|yi tie;
一帖__一帖 182.423584067|yi tie;
一厅__一廳 119.56748386|yi ting;
一听__一聽 1300.22127911|yi ting;
一头__一頭 1966.51263254|yi tou;
异同__異同 139.200207879|yi tong;
一统__一統 190.318888971|yi tong;
一桶__一桶 280.411678639|yi tong;
一通__一通 647.058374454|yi tong;
一同__一同 1687.0530669|yi tong;
意图__意圖 1217.12027856|yi tu;
一拖__一拖 118.08671951|yi tuo;
依托__依託 1422.27606545|yi tuo;
一腿__一腿 114.037415895|yi tui;
一推__一推 176.827946446|yi tui;
一女__一女 241.463621556|yi nv;
一男__一男 133.925286409|yi nan;
疑难__疑難 233.474375771|yi nan;
以南__以南 326.048110451|yi nan;
异能__異能 105.0335283|yi neng;
以内__以內 1764.46098498|yi nei;
旖旎__旖旎 246.94109417|yi ni;
一念__一念 210.270405333|yi nian;
意念__意念 346.1460998|yi nian;
一年__一年 13825.4663776|yi nian;
议论__議論 1002.08784645|yi lun;
一轮__一輪 1385.53861435|yi lun;
疑虑__疑慮 438.073368704|yi lv;
一缕__一縷 487.62990282|yi lv;
一律__一律 1573.33557614|yi lv;
一拉__一拉 173.769702743|yi la;
一来__一來 887.99205879|yi lai;
依赖__依賴 3302.45784674|yi lai;
以来__以來 8201.92206694|yi lai;
一栏__一欄 320.409100324|yi lan;
一览__一覽 459.317058623|yi lan;
一郎__一郎 204.07475061|yi lang;
一浪__一浪 222.67604562|yi lang;
伊朗__伊朗 2526.26316155|yi lang;
一愣__一愣 326.048110451|yi leng;
异类__異類 173.986383704|yi lei;
一类__一類 2079.94037707|yi lei;
伊犁__伊犁 107.818484324|yi li;
以利__以利 136.112567367|yi li;
屹立__屹立 233.474375771|yi li;
伊利__伊利 453.063775264|yi li;
一例__一例 490.066643104|yi li;
一粒__一粒 556.490650127|yi li;
毅力__毅力 747.692521253|yi li;
依恋__依戀 320.010065926|yi lian;
一连__一連 386.264972075|yi lian;
一脸__一臉 1651.68904712|yi lian;
意料__意料 445.783200166|yi liao;
医疗__醫療 3432.5319072|yi liao;
一亮__一亮 470.908619205|yi liang;
一两__一兩 663.387871054|yi liang;
一辆__一輛 3257.49717238|yi liang;
一列__一列 293.643651968|yi lie;
衣领__衣領 176.60772663|yi ling;
一溜__一溜 106.882056102|yi liu;
遗留__遺留 607.9716117|yi liu;
一流__一流 2087.73078616|yi liu;
遗漏__遺漏 586.392500602|yi lou;
一楼__一樓 1202.04704744|yi lou;
一路__一路 5133.61417128|yi lu;
衣冠__衣冠 106.882056102|yi guan;
一罐__一罐 159.85029497|yi guan;
一关__一關 227.443722742|yi guan;
一贯__一貫 1561.61561744|yi guan;
医改__醫改 296.585723861|yi gai;
一概__一概 422.52456065|yi gai;
一改__一改 488.846754671|yi gai;
一杆__一桿 141.650048976|yi gan;
一干__一干 221.017305999|yi gan;
乙肝__乙肝 692.099342424|yi gan;
一缸__一缸 110.126966673|yi gang;
一刚__一剛 184.941433485|yi gang;
一格__一格 239.664931108|yi ge;
一个__一個 373855.288281|yi ge;
一根__一根 2847.30570911|yi gen;
异构__異構 143.247667161|yi gou;
以供__以供 272.828431509|yi gong;
义工__義工 446.895626023|yi gong;
一共__一共 4066.47607754|yi gong;
亿股__億股 155.140277726|yi gu;
已故__已故 194.636170786|yi gu;
一股__一股 2513.70191646|yi gu;
一过__一過 175.948711373|yi guo;
一锅__一鍋 224.347234118|yi guo;
异国__異國 242.066179876|yi guo;
已过__已過 310.968189453|yi guo;
一国__一國 353.998238229|yi guo;
衣柜__衣櫃 425.69561654|yi gui;
一款__一款 4453.75227609|yi kuan;
一块__一塊 7498.06163521|yi kuai;
一卡__一卡 129.171793682|yi ka;
移开__移開 172.905674062|yi kai;
一开__一開 309.036622663|yi kai;
一看__一看 4883.99371143|yi kan;
依靠__依靠 3825.59740032|yi kao;
一科__一科 142.535402072|yi ke;
一课__一課 209.485777119|yi ke;
亦可__亦可 522.223615731|yi ke;
一棵__一棵 781.025384985|yi ke;
一刻__一刻 1581.19770715|yi ke;
一颗__一顆 3233.23169914|yi ke;
一口__一口 2805.04388501|yi kou;
一空__一空 172.260473089|yi kong;
衣裤__衣褲 129.494134325|yi ku;
异化__異化 206.376433771|yi hua;
医患__醫患 108.492380517|yi huan;
易患__易患 140.419785869|yi huan;
一环__一環 419.377126323|yi huan;
一晃__一晃 324.426913464|yi huang;
已婚__已婚 561.366244489|yi hun;
遗憾__遺憾 4205.62658069|yi han;
一行__一行 2197.17084589|yi hang;
一号__一號 1768.86409398|yi hao;
一盒__一盒 624.091932797|yi he;
以后__以後 58095.9566544|yi hou;
一红__一紅 123.504952812|yi hong;
一壶__一壺 261.83633885|yi hu;
一户__一戶 416.772181646|yi hu;
已获__已獲 142.713135632|yi huo;
亦或__亦或 147.045868173|yi huo;
一伙__一夥 478.599545119|yi huo;
抑或__抑或 531.41444163|yi huo;
疑惑__疑惑 1319.8108917|yi huo;
亦会__亦會 108.898738333|yi hui;
一挥__一揮 223.788782324|yi hui;
议会__議會 992.147332631|yi hui;
一回__一回 2519.9747123|yi hui;
一会__一會 11670.1422972|yi hui;
一卷__一卷 232.024158785|yi juan;
一绝__一絕 118.676811842|yi jue;
以军__以軍 172.260473089|yi jun;
乙级__乙級 118.381397999|yi ji;
一剂__一劑 144.863304286|yi ji;
一己__一己 158.461958559|yi ji;
亦即__亦即 179.268563673|yi ji;
一季__一季 268.444174826|yi ji;
一击__一擊 343.567617462|yi ji;
遗迹__遺迹 423.051424808|yi ji;
一记__一記 495.593922384|yi ji;
一集__一集 587.123698784|yi ji;
一级__一級 3030.36024751|yi ji;
以及__以及 39676.8988369|yi ji;
议价__議價 141.650048976|yi jia;
衣架__衣架 185.402943996|yi jia;
溢价__溢價 454.194369369|yi jia;
意甲__意甲 596.712660816|yi jia;
一架__一架 733.846096172|yi jia;
宜家__宜家 1053.30446216|yi jia;
一家__一家 13688.3204776|yi jia;
一剑__一劍 347.442588754|yi jian;
一键__一鍵 396.012952778|yi jian;
一见__一見 615.595353746|yi jian;
一间__一間 2003.61737423|yi jian;
一件__一件 5880.50165938|yi jian;
意见__意見 14532.0846656|yi jian;
衣角__衣角 105.164499152|yi jiao;
一跤__一跤 107.416157498|yi jiao;
一觉__一覺 663.387871054|yi jiao;
一角__一角 726.566487616|yi jiao;
移交__移交 787.868200695|yi jiao;
一脚__一腳 1258.76884501|yi jiao;
一讲__一講 124.89791921|yi jiang;
已将__已將 462.764242999|yi jiang;
异界__異界 107.684208225|yi jie;
一介__一介 129.655606164|yi jie;
一劫__一劫 132.596773978|yi jie;
一截__一截 222.398727024|yi jie;
一节__一節 658.446218066|yi jie;
一届__一屆 718.463208478|yi jie;
衣襟__衣襟 137.647730357|yi jin;
已尽__已盡 161.653186955|yi jin;
已近__已近 266.444503116|yi jin;
一进__一進 381.006242235|yi jin;
一斤__一斤 790.819158167|yi jin;
遗精__遺精 126.464093517|yi jing;
易经__易經 173.769702743|yi jing;
一惊__一驚 511.914293268|yi jing;
一经__一經 604.195219728|yi jing;
意境__意境 847.977956119|yi jing;
已经__已經 129784.249109|yi jing;
一九__一九 157.870654598|yi jiu;
已久__已久 933.377249507|yi jiu;
依旧__依舊 3648.66122213|yi jiu;
宜居__宜居 115.899886195|yi ju;
一居__一居 118.676811842|yi ju;
移居__移居 198.803491145|yi ju;
一具__一具 311.744192349|yi ju;
一局__一局 331.37316028|yi ju;
一举__一舉 880.279644448|yi ju;
依据__依據 4939.07845882|yi ju;
一句__一句 7764.30695341|yi ju;
一拳__一拳 312.132919672|yi quan;
一圈__一圈 1927.69130725|yi quan;
一群__一群 3680.62832181|yi qun;
忆起__憶起 124.276893895|yi qi;
意气__意氣 179.492101402|yi qi;
益气__益氣 222.398727024|yi qi;
一气__一氣 239.068350048|yi qi;
义气__義氣 303.691826638|yi qi;
以期__以期 372.555031371|yi qi;
遗弃__遺棄 421.998352644|yi qi;
一汽__一汽 566.284555508|yi qi;
一齐__一齊 811.787668067|yi qi;
以其__以其 1122.41972073|yi qi;
仪器__儀器 1721.02823483|yi qi;
一期__一期 2090.33406802|yi qi;
一起__一起 55755.3056633|yi qi;
一千__一千 1674.48601346|yi qian;
以前__以前 41394.1176688|yi qian;
一腔__一腔 120.765453341|yi qiang;
一枪__一槍 371.627656329|yi qiang;
一切__一切 22116.3475883|yi qie;
移情__移情 116.044406778|yi qing;
疫情__疫情 738.432842998|yi qing;
以求__以求 347.875829952|yi qiu;
一球__一球 461.037428991|yi qiu;
疫区__疫區 133.259374649|yi qu;
一去__一去 348.743933702|yi qu;
一区__一區 350.92368248|yi qu;
易趣__易趣 569.114341748|yi qu;
一曲__一曲 595.22730595|yi qu;
易学__易學 177.490254874|yi xue;
医学__醫學 2197.17084589|yi xue;
一席__一席 110.126966673|yi xi;
一袭__一襲 208.184564378|yi xi;
乙烯__乙烯 372.555031371|yi xi;
以西__以西 400.978810625|yi xi;
依稀__依稀 527.455873984|yi xi;
以下__以下 15856.6757439|yi xia;
一下__一下 94335.2408789|yi xia;
胰腺__胰腺 122.127521944|yi xian;
一线__一線 2353.04376718|yi xian;
一小__一小 1107.13875428|yi xiao;
一笑__一笑 1981.27135202|yi xiao;
一响__一響 105.164499152|yi xiang;
臆想__臆想 127.413209251|yi xiang;
已向__已向 268.444174826|yi xiang;
一箱__一箱 291.093289619|yi xiang;
异乡__異鄉 291.456266438|yi xiang;
意象__意象 312.132919672|yi xiang;
一想__一想 520.274927886|yi xiang;
意向__意向 1274.55334676|yi xiang;
一向__一向 2513.70191646|yi xiang;
一项__一項 5382.56084417|yi xiang;
一些__一些 69428.5298174|yi xie;
疑心__疑心 175.948711373|yi xin;
一心__一心 889.099334512|yi xin;
异形__異形 185.86560618|yi xing;
宜兴__宜興 214.504991945|yi xing;
一行__一行 384.344361008|yi xing;
异性__異性 1092.0658276|yi xing;
一宿__一宿 190.081867665|yi xiu;
衣袖__衣袖 197.568631008|yi xiu;
一转__一轉 295.111021611|yi zhuan;
亦庄__亦庄 208.184564378|yi zhuang;
一桩__一樁 301.805456692|yi zhuang;
一幢__一幢 350.486645516|yi zhuang;
一展__一展 109.170488754|yi zhan;
已占__已佔 116.624293448|yi zhan;
一盏__一盞 271.810366771|yi zhan;
驿站__驛站 347.00988711|yi zhan;
一战__一戰 385.303469841|yi zhan;
一站__一站 440.811451858|yi zhan;
议长__議長 163.884358899|yi zhang;
一掌__一掌 173.553291634|yi zhang;
一章__一章 382.433299725|yi zhang;
一张__一張 11539.9870778|yi zhang;
一朝__一朝 159.055477247|yi zhao;
一招__一招 651.102673334|yi zhao;
依照__依照 1506.18823193|yi zhao;
译者__譯者 222.398727024|yi zhe;
一震__一震 182.651055928|yi zhen;
一针__一針 215.845709156|yi zhen;
一阵__一陣 4317.13844997|yi zhen;
一怔__一怔 152.077621994|yi zheng;
一整__一整 155.140277726|yi zheng;
益智__益智 131.773154284|yi zhi;
一指__一指 167.810977762|yi zhi;
移至__移至 176.827946446|yi zhi;
一纸__一紙 297.696584607|yi zhi;
一枝__一枝 313.302012384|yi zhi;
一职__一職 316.441045148|yi zhi;
医治__醫治 382.910172354|yi zhi;
以至__以至 673.382717005|yi zhi;
已知__已知 674.222387052|yi zhi;
遗址__遺址 902.494832488|yi zhi;
以致__以致 908.135681884|yi zhi;
移植__移植 1383.81307795|yi zhi;
意志__意志 1875.5602418|yi zhi;
抑制__抑制 2794.57680777|yi zhi;
一支__一支 3141.87681769|yi zhi;
一致__一致 6786.60773774|yi zhi;
一只__一隻 7071.51479616|yi zhi;
一直__一直 53242.8974687|yi zhi;
一周__一周 4583.25194611|yi zhou;
一中__一中 641.438524323|yi zhong;
一种__一種 28059.7129015|yi zhong;
医嘱__醫囑 150.756793028|yi zhu;
一株__一株 307.117053725|yi zhu;
遗嘱__遺囑 320.409100324|yi zhu;
一桌__一桌 378.63963681|yi zhuo;
衣着__衣着 488.237949645|yi zhuo;
一串__一串 563.46883971|yi chuan;
遗传__遺傳 1199.05487625|yi chuan;
一床__一床 112.625137786|yi chuang;
宜春__宜春 124.587019602|yi chun;
乙醇__乙醇 353.117055307|yi chun;
一查__一查 295.847453874|yi cha;
遗产__遺產 740.275558891|yi chan;
一长__一長 176.60772663|yi chang;
宜昌__宜昌 545.504855178|yi chang;
异常__異常 5236.9988288|yi chang;
一场__一場 7544.92665307|yi chang;
一车__一車 233.765505073|yi che;
一城__一城 105.690017726|yi cheng;
亦称__亦稱 117.93965545|yi cheng;
一程__一程 146.132498493|yi cheng;
译成__譯成 165.114314527|yi cheng;
一成__一成 189.845141544|yi cheng;
议程__議程 318.022335873|yi cheng;
已成__已成 959.320404733|yi cheng;
一尺__一尺 183.563783354|yi chi;
一筹__一籌 123.504952812|yi chou;
衣橱__衣櫥 171.831677206|yi chu;
移除__移除 267.44247003|yi chu;
益处__益處 278.322859608|yi chu;
溢出__溢出 544.825488702|yi chu;
一出__一出 780.052703516|yi chu;
一处__一處 1639.38542435|yi chu;
一吹__一吹 109.442917312|yi chui;
一双__一雙 1993.6548615|yi shuang;
一瞬__一瞬 248.794392378|yi shun;
依山__依山 113.32907693|yi shan;
一山__一山 147.045868173|yi shan;
衣衫__衣衫 238.176261728|yi shan;
一扇__一扇 323.216307961|yi shan;
一闪__一閃 362.028498203|yi shan;
椅上__椅上 113.32907693|yi shang;
衣裳__衣裳 480.392137969|yi shang;
以上__以上 20218.3995421|yi shang;
一勺__一勺 127.413209251|yi shao;
一审__一審 517.043260448|yi shen;
一身__一身 2992.83123646|yi shen;
一生__一生 6344.94371206|yi sheng;
一声__一聲 6392.5626507|yi sheng;
医生__醫生 11269.9622466|yi sheng;
一式__一式 112.625137786|yi shi;
衣食__衣食 123.044091616|yi shi;
一石__一石 136.282292017|yi shi;
议事__議事 155.527421199|yi shi;
一室__一室 156.694657831|yi shi;
伊始__伊始 208.964318904|yi shi;
以使__以使 221.292902041|yi shi;
一试__一試 250.661599628|yi shi;
以示__以示 347.875829952|yi shi;
亦是__亦是 475.034401746|yi shi;
遗失__遺失 506.83620443|yi shi;
一世__一世 536.070335228|yi shi;
医师__醫師 873.722339551|yi shi;
一事__一事 1082.58098585|yi shi;
已是__已是 1605.02061407|yi shi;
仪式__儀式 2295.12287071|yi shi;
一时__一時 3545.56838982|yi shi;
一是__一是 6089.30976362|yi shi;
意识__意識 9039.18947747|yi shi;
一手__一手 1991.17198299|yi shou;
一首__一首 2685.32927986|yi shou;
一树__一樹 108.763116896|yi shu;
医术__醫術 209.485777119|yi shu;
遗书__遺書 226.030964922|yi shu;
一束__一束 395.519762073|yi shu;
一书__一書 415.216987933|yi shu;
艺术__藝術 9050.46083396|yi shu;
一说__一說 1422.27606545|yi shuo;
一水__一水 106.748946222|yi shui;
亦然__亦然 121.217779906|yi ran;
毅然__毅然 508.100984482|yi ran;
已然__已然 710.450303909|yi ran;
依然__依然 10061.7371458|yi ran;
一热__一熱 120.314814642|yi re;
怡人__怡人 114.321989585|yi ren;
一任__一任 145.043940608|yi ren;
宜人__宜人 183.563783354|yi ren;
亿人__億人 218.008308584|yi ren;
伊人__伊人 394.535222541|yi ren;
艺人__藝人 1930.09502896|yi ren;
一人__一人 4611.89857437|yi ren;
一扔__一扔 106.085879302|yi reng;
一日__一日 1643.47641462|yi ri;
一如__一如 560.667124391|yi ru;
一尊__一尊 178.822323044|yi zun;
移栽__移栽 137.305093541|yi zai;
意在__意在 321.609191441|yi zai;
已在__已在 1048.06715525|yi zai;
一再__一再 1313.24844471|yi zai;
一早__一早 1096.15615618|yi zao;
一则__一則 767.517531652|yi ze;
一字__一字 516.399339766|yi zi;
椅子__椅子 1603.0217369|yi zi;
一走__一走 294.743493195|yi zou;
一宗__一宗 152.647228173|yi zong;
异族__異族 114.46454262|yi zu;
彝族__彝族 207.407719521|yi zu;
一族__一族 998.348535653|yi zu;
一组__一組 2373.65954378|yi zu;
一坐__一坐 140.945727665|yi zuo;
一座__一座 2504.32198759|yi zuo;
遗存__遺存 109.170488754|yi cun;
一村__一村 133.42554153|yi cun;
依存__依存 173.337150041|yi cun;
一寸__一寸 442.462509543|yi cun;
一餐__一餐 196.586267794|yi can;
一侧__一側 625.649317648|yi ce;
一层__一層 2904.64693418|yi ceng;
一词__一詞 593.006203378|yi ci;
依次__依次 1279.32718167|yi ci;
以此__以此 2283.71091596|yi ci;
一次__一次 33200.5790857|yi ci;
已从__已從 286.772667017|yi cong;
一扫__一掃 163.680258901|yi sao;
一色__一色 206.376433771|yi se;
已死__已死 204.329220247|yi si;
一死__一死 213.438416689|yi si;
疑似__疑似 464.497524783|yi si;
一丝__一絲 2338.42792752|yi si;
意思__意思 32504.6282834|yi si;
一艘__一艘 485.205278648|yi sou;
移送__移送 259.885889675|yi song;
一所__一所 1122.41972073|yi suo;
一岁__一歲 623.314694733|yi sui;
一员__一員 268.109857044|yi yuan;
一元__一元 486.416079992|yi yuan;
议员__議員 799.738513132|yi yuan;
意愿__意願 1420.50477658|yi yuan;
亿元__億元 3625.99770514|yi yuan;
医院__醫院 15543.6458876|yi yuan;
已阅__已閱 129.817279349|yi yue;
一跃__一躍 348.309611377|yi yue;
一月__一月 1057.24961018|yi yue;
咿呀__咿呀 114.607273411|yi ya;
遗言__遺言 166.353500999|yi yan;
一言__一言 410.586139672|yi yan;
一眼__一眼 3327.2428637|yi yan;
益阳__益陽 168.649547684|yi yang;
异样__異樣 472.083744072|yi yang;
一样__一樣 64748.630677|yi yang;
医药__醫藥 1708.20809643|yi yao;
一叶__一葉 241.162905094|yi ye;
一页__一頁 837.47630896|yi ye;
一夜__一夜 1991.17198299|yi ye;
疑议__疑議 156.304608838|yi yi;
一亿__一億 332.614317243|yi yi;
依依__依依 388.679238014|yi yi;
异议__異議 992.147332631|yi yi;
一一__一一 2079.94037707|yi yi;
意义__意義 12893.5470587|yi yi;
意淫__意淫 520.923681206|yi yin;
一游__一游 196.096919422|yi you;
已由__已由 266.112675706|yi you;
亦有__亦有 485.205278648|yi you;
已有__已有 3722.14075882|yi you;
易用__易用 280.411678639|yi yong;
医用__醫用 282.516174301|yi yong;
异于__異於 108.492380517|yi yu;
一隅__一隅 128.850255419|yi yu;
异域__異域 152.837570606|yi yu;
一遇__一遇 184.481071779|yi yu;
已与__已與 202.050369328|yi yu;
意欲__意欲 204.584007193|yi yu;
一语__一語 257.3078729|yi yu;
益于__益於 312.911829085|yi yu;
抑郁__抑鬱 592.267679181|yi yu;
已于__已於 648.673070715|yi yu;
易于__易於 810.776675547|yi yu;
以外__以外 4442.66586373|yi wai;
意外__意外 4543.4453536|yi wai;
亿万__億萬 510.640021015|yi wan;
一晚__一晚 754.243296976|yi wan;
一碗__一碗 966.520124945|yi wan;
一万__一萬 1718.88488289|yi wan;
一望__一望 116.044406778|yi wang;
遗忘__遺忘 1459.98760728|yi wang;
以往__以往 3563.28598523|yi wang;
一吻__一吻 105.821807183|yi wen;
一文__一文 344.85444872|yi wen;
译文__譯文 374.41672986|yi wen;
一问__一問 454.760723981|yi wen;
疑问__疑問 2577.13898569|yi wen;
亦为__亦為 116.624293448|yi wei;
一维__一維 118.381397999|yi wei;
译为__譯為 129.817279349|yi wei;
已为__已為 151.888225993|yi wei;
异位__異位 168.439513167|yi wei;
移位__移位 230.295783987|yi wei;
意为__意為 235.226605969|yi wei;
依偎__依偎 273.850309404|yi wei;
异味__異味 280.062456643|yi wei;
一味__一味 1244.72999861|yi wei;
意味__意味 2573.92944169|yi wei;
一位__一位 13104.1257383|yi wei;
以为__以為 19968.0080118|yi wei;
一窝__一窩 143.247667161|yi wo;
亦无__亦無 158.264611567|yi wu;
遗物__遺物 173.337150041|yi wu;
已无__已無 227.443722742|yi wu;
异物__異物 261.83633885|yi wu;
义乌__義烏 656.807194196|yi wu;
衣物__衣物 736.594714048|yi wu;
义务__義務 3462.60542812|yi wu;
一案__一案 360.677581637|yi an;
议案__議案 1205.04668542|yi an;
伊尔__伊爾 110.95347192|yi er;
一二__一二 584.932834985|yi er;
引爆__引爆 425.69561654|yin bao;
银币__銀幣 192.705418355|yin bi;
隐蔽__隱蔽 657.626195507|yin bi;
音标__音標 133.259374649|yin biao;
因病__因病 286.415523108|yin bing;
阴部__陰部 292.54791482|yin bu;
银牌__銀牌 181.742866823|yin pai;
饮品__飲品 261.83633885|yin pin;
音频__音頻 1565.51253772|yin pin;
阴霾__陰霾 302.935867929|yin mai;
隐瞒__隱瞞 857.541983893|yin man;
阴毛__陰毛 185.402943996|yin mao;
隐秘__隱秘 315.653350706|yin mi;
阴谋__陰謀 863.977854874|yin mou;
银幕__銀幕 562.76710106|yin mu;
印发__印發 357.545014261|yin fa;
引发__引發 4459.30585251|yin fa;
音符__音符 454.194369369|yin fu;
淫荡__淫蕩 772.314734527|yin dang;
引到__引到 165.73274959|yin dao;
阴道__陰道 1313.24844471|yin dao;
引导__引導 5146.42480465|yin dao;
引得__引得 270.458854115|yin de;
阴蒂__陰蒂 267.775955618|yin di;
音调__音調 175.948711373|yin diao;
引渡__引渡 131.117943492|yin du;
印度__印度 5282.88186737|yin du;
银泰__銀泰 141.473639374|yin tai;
阴天__陰天 439.714170908|yin tian;
阴囊__陰囊 159.055477247|yin nang;
隐匿__隱匿 154.176629937|yin ni;
印尼__印尼 1163.72451202|yin ni;
因您__因您 640.639682982|yin nin;
淫乱__淫亂 258.916120291|yin luan;
引来__引來 917.234466913|yin lai;
阴冷__陰冷 194.636170786|yin leng;
引力__引力 298.811606079|yin li;
阴历__陰曆 315.260239073|yin li;
银联__銀聯 360.228397261|yin lian;
饮料__飲料 1903.81812306|yin liao;
银两__銀兩 115.611384758|yin liang;
阴凉__陰涼 123.813152185|yin liang;
音量__音量 732.019384688|yin liang;
引领__引領 1181.25761405|yin ling;
引流__引流 129.494134325|yin liu;
因公__因公 125.522047856|yin gong;
因故__因故 152.457122789|yin gu;
因果__因果 412.12398856|yin guo;
音轨__音軌 141.121478992|yin gui;
银华__銀華 141.650048976|yin hua;
印花__印花 353.998238229|yin hua;
隐患__隱患 1168.08323794|yin huan;
隐含__隱含 404.491915522|yin han;
银行__銀行 21172.4586769|yin hang;
引号__引號 236.402059204|yin hao;
银河__銀河 918.378206258|yin he;
隐晦__隱晦 146.132498493|yin hui;
淫秽__淫穢 627.210588862|yin hui;
印记__印記 446.339066527|yin ji;
引荐__引薦 146.679837233|yin jian;
引脚__引腳 213.172602547|yin jiao;
音节__音節 183.106850936|yin jie;
引进__引進 3863.92679211|yin jin;
阴茎__陰莖 988.445115058|yin jing;
饮酒__飲酒 619.442999798|yin jiu;
隐居__隱居 278.322859608|yin ju;
阴气__陰氣 114.46454262|yin qi;
因其__因其 724.757896749|yin qi;
引起__引起 13202.472483|yin qi;
殷切__殷切 153.601316766|yin qie;
殷勤__殷勤 221.568841736|yin qin;
引擎__引擎 2485.66700342|yin qing;
隐去__隱去 110.264288753|yin qu;
音讯__音訊 147.045868173|yin xun;
引线__引線 122.584950132|yin xian;
阴线__陰線 260.209952636|yin xian;
阴险__陰險 384.344361008|yin xian;
音效__音效 593.006203378|yin xiao;
引向__引向 203.820597887|yin xiang;
音像__音像 444.673543393|yin xiang;
音响__音響 1229.31483934|yin xiang;
音箱__音箱 1733.94458864|yin xiang;
印象__印象 6829.02596639|yin xiang;
音信__音信 110.401782066|yin xin;
银杏__銀杏 265.119670945|yin xing;
隐性__隱性 342.285588041|yin xing;
阴性__陰性 348.309611377|yin xing;
隐形__隱形 815.844260376|yin xing;
阴虚__陰虛 140.594881376|yin xu;
印章__印章 538.749137684|yin zhang;
印着__印着 166.353500999|yin zhe;
印证__印證 542.11647303|yin zheng;
引致__引致 141.826678552|yin zhi;
印制__印製 454.194369369|yin zhi;
音质__音質 952.17431607|yin zhi;
引种__引種 134.930398555|yin zhong;
银川__銀川 353.117055307|yin chuan;
阴唇__陰唇 209.746993999|yin chun;
饮茶__飲茶 230.295783987|yin cha;
吟唱__吟唱 259.885889675|yin chang;
阴沉__陰沉 232.313479749|yin chen;
银城__銀城 105.690017726|yin cheng;
引出__引出 450.24958728|yin chu;
印刷__印刷 2106.02207003|yin shua;
因伤__因傷 163.476413088|yin shang;
引申__引申 206.633773476|yin shen;
隐身__隱身 2645.47163011|yin shen;
吟诗__吟詩 119.41857567|yin shi;
银饰__銀飾 127.254530072|yin shi;
隐士__隱士 147.596627936|yin shi;
饮食__飲食 2787.62046424|yin shi;
引述__引述 186.561765129|yin shu;
淫水__淫水 117.646076559|yin shui;
引水__引水 123.197520618|yin shui;
饮水__飲水 749.558344131|yin shui;
印染__印染 135.94305409|yin ran;
隐忍__隱忍 201.79873775|yin ren;
阴柔__陰柔 109.852835359|yin rou;
引入__引入 2255.42866395|yin ru;
印在__印在 215.30841961|yin zai;
引自__引自 124.89791921|yin zi;
引子__引子 129.817279349|yin zi;
引资__引資 221.845125512|yin zi;
因子__因子 978.639934443|yin zi;
银子__銀子 1206.54931027|yin zi;
银座__銀座 202.050369328|yin zuo;
隐藏__隱藏 3662.32726943|yin cang;
因此__因此 20936.3256518|yin ci;
音色__音色 454.760723981|yin se;
银色__銀色 1096.15615618|yin se;
阴森__陰森 149.261315371|yin sen;
隐私__隱私 1329.71610075|yin si;
音速__音速 276.594068012|yin su;
因素__因素 10367.2087883|yin su;
音源__音源 118.23396695|yin yuan;
因缘__因緣 212.641966978|yin yuan;
姻缘__姻緣 271.471856767|yin yuan;
银月__銀月 120.916041011|yin yue;
隐约__隱約 655.172250234|yin yue;
音乐__音樂 16358.452828|yin yue;
氤氲__氤氳 113.32907693|yin yun;
引言__引言 195.365179853|yin yan;
阴阳__陰陽 812.799921236|yin yang;
音译__音譯 157.085680168|yin yi;
隐隐__隱隱 686.943814365|yin yin;
阴影__陰影 1749.13623734|yin ying;
隐忧__隱憂 141.29744947|yin you;
印有__印有 306.734573113|yin you;
引诱__引誘 478.003501869|yin you;
饮用__飲用 845.867144221|yin yong;
引用__引用 5615.51843703|yin yong;
音域__音域 127.572086295|yin yu;
阴郁__陰鬱 159.85029497|yin yu;
隐喻__隱喻 197.568631008|yin yu;
阴雨__陰雨 285.346757867|yin yu;
引文__引文 308.267359529|yin wen;
因为__因為 121338.050927|yin wei;
阴暗__陰暗 670.869975958|yin an;
银耳__銀耳 153.41002317|yin er;
因而__因而 2822.57620712|yin er;
英镑__英鎊 802.733930815|ying bang;
硬币__硬幣 747.692521253|ying bi;
应变__應變 367.025293151|ying bian;
迎宾__迎賓 188.430963124|ying bin;
硬盘__硬盤 8535.6017079|ying pan;
影片__影片 5976.54259122|ying pian;
应聘__應聘 1863.91027245|ying pin;
影评__影評 336.785179346|ying ping;
荧屏__熒屏 365.20034683|ying ping;
英美__英美 308.651751439|ying mei;
影迷__影迷 685.233853433|ying mi;
迎面__迎面 359.331706043|ying mian;
英明__英明 401.478808454|ying ming;
荧幕__熒幕 146.314717429|ying mu;
英法__英法 120.916041011|ying fa;
迎风__迎風 191.508436159|ying feng;
应付__應付 1939.73992621|ying fu;
应答__應答 471.495815538|ying da;
应当__應當 8871.79384846|ying dang;
应得__應得 199.051387821|ying de;
赢得__贏得 3458.29313278|ying de;
影帝__影帝 275.218769535|ying di;
营地__營地 651.914561431|ying di;
影碟__影碟 141.121478992|ying die;
硬度__硬度 433.727767276|ying du;
应多__應多 108.222318063|ying duo;
应对__應對 2865.10217964|ying dui;
映泰__映泰 159.452390871|ying tai;
影坛__影壇 270.458854115|ying tan;
樱桃__櫻桃 723.855290267|ying tao;
英伦__英倫 267.109399762|ying lun;
迎来__迎來 1786.58668154|ying lai;
硬朗__硬朗 232.893204426|ying lang;
营利__營利 129.655606164|ying li;
英里__英里 201.045721733|ying li;
应力__應力 483.394725468|ying li;
赢利__贏利 853.278059532|ying li;
盈利__盈利 3157.5771219|ying li;
影楼__影樓 238.770616634|ying lou;
荧光__熒光 390.621510938|ying guang;
应该__應該 97684.9487697|ying gai;
英国__英國 8983.04290431|ying guo;
营口__營口 179.045304336|ying kou;
盈亏__盈虧 239.068350048|ying kui;
硬化__硬化 311.744192349|ying hua;
樱花__櫻花 754.243296976|ying hua;
英皇__英皇 253.488718522|ying huang;
英汉__英漢 177.269210225|ying han;
英航__英航 143.784200776|ying hang;
英豪__英豪 120.46484039|ying hao;
迎合__迎合 673.382717005|ying he;
影后__影后 254.121284766|ying hou;
萦回__縈迴 160.849404779|ying hui;
英军__英軍 218.824857909|ying jun;
英俊__英俊 792.79260104|ying jun;
影集__影集 106.483223576|ying ji;
应激__應激 155.527421199|ying ji;
应急__應急 1443.7046004|ying ji;
赢家__贏家 347.442588754|ying jia;
硬件__硬件 5159.26740621|ying jian;
应将__應將 280.761336094|ying jiang;
英杰__英傑 126.937764318|ying jie;
应届__應屆 472.083744072|ying jie;
迎接__迎接 1903.81812306|ying jie;
应尽__應盡 190.081867665|ying jin;
营救__營救 363.384474622|ying jiu;
赢球__贏球 244.491487214|ying qiu;
迎娶__迎娶 123.967540162|ying qu;
赢取__贏取 267.109399762|ying qu;
应先__應先 203.820597887|ying xian;
营销__營銷 5657.66302334|ying xiao;
影象__影象 132.266710153|ying xiang;
应向__應向 204.07475061|ying xiang;
映像__映像 1097.52300072|ying xiang;
影像__影像 1824.83897052|ying xiang;
影响__影響 36726.8025477|ying xiang;
迎新__迎新 175.073848088|ying xin;
硬性__硬性 234.056997396|ying xing;
影星__影星 367.941183266|ying xing;
英雄__英雄 6752.86293853|ying xiong;
应战__應戰 112.204874836|ying zhan;
影展__影展 207.149415951|ying zhan;
迎战__迎戰 399.980682268|ying zhan;
营帐__營帳 113.753550575|ying zhang;
营长__營長 137.647730357|ying zhang;
映照__映照 155.72135507|ying zhao;
迎着__迎着 224.626982392|ying zhe;
应征__應徵 288.565077751|ying zheng;
迎春__迎春 226.877563077|ying chun;
英超__英超 1055.93292173|ying chao;
映衬__映襯 199.548108896|ying chen;
影城__影城 304.829303266|ying cheng;
影驰__影馳 129.332863581|ying chi;
英尺__英尺 201.045721733|ying chi;
应酬__應酬 542.792461517|ying chou;
迎上__迎上 114.893269147|ying shang;
硬伤__硬傷 144.863304286|ying shang;
影射__影射 147.964946673|ying she;
映射__映射 1028.65812957|ying she;
应声__應聲 216.924313917|ying sheng;
英式__英式 146.497163581|ying shi;
应试__應試 291.456266438|ying shi;
硬是__硬是 550.970372621|ying shi;
应是__應是 598.201722298|ying shi;
影视__影視 1687.0530669|ying shi;
应收__應收 380.531740742|ying shou;
营收__營收 411.610733326|ying shou;
应税__應稅 116.47905068|ying shui;
萦绕__縈繞 241.463621556|ying rao;
应在__應在 1257.20118645|ying zai;
营造__營造 2361.85708402|ying zao;
英姿__英姿 136.112567367|ying zi;
英子__英子 218.280152578|ying zi;
影子__影子 2510.57137637|ying zi;
硬座__硬座 205.350275845|ying zuo;
英寸__英寸 1303.46590513|ying cun;
英才__英才 292.183578474|ying cai;
应从__應從 245.71323808|ying cong;
罂粟__罌粟 136.112567367|ying su;
应诉__應訴 174.638049069|ying su;
影院__影院 1027.37704867|ying yuan;
映月__映月 122.737806611|ying yue;
营运__營運 697.293562832|ying yun;
应验__應驗 153.41002317|ying yan;
营养__營養 4138.04364463|ying yang;
硬要__硬要 246.019628549|ying yao;
应邀__應邀 488.237949645|ying yao;
营业__營業 1738.27154577|ying ye;
应以__應以 476.219822262|ying yi;
影印__影印 109.852835359|ying yin;
影音__影音 880.279644448|ying yin;
莺莺__鶯鶯 183.335174792|ying ying;
莹莹__瑩瑩 264.459727191|ying ying;
盈盈__盈盈 365.655730945|ying ying;
应由__應由 395.027185582|ying you;
应有__應有 1779.91999768|ying you;
英勇__英勇 501.808489233|ying yong;
应用__應用 18808.6223866|ying yong;
应予__應予 147.045868173|ying yu;
应与__應與 191.747236314|ying yu;
盈余__盈餘 258.271618599|ying yu;
英语__英語 10523.4049735|ying yu;
英文__英文 9073.04572868|ying wen;
应为__應為 1125.22065338|ying wei;
硬卧__硬卧 130.141230764|ying wo;
鹦鹉__鸚鵡 386.264972075|ying wu;
应按__應按 313.69268222|ying an;
婴儿__嬰兒 2448.77288933|ying er;
又把__又把 620.98878351|you ba;
友邦__友邦 198.308623594|you bang;
又被__又被 1209.56018338|you bei;
右臂__右臂 117.93965545|you bi;
有变__有變 135.773751924|you bian;
邮编__郵編 1108.5192935|you bian;
右边__右邊 2759.96781896|you bian;
游标__游標 125.36572391|you biao;
有别__有別 411.098117295|you bie;
有病__有病 1132.25360251|you bing;
又不__又不 1760.06883632|you bu;
又怕__又怕 447.452879516|you pa;
优派__優派 271.810366771|you pai;
右派__右派 317.230705235|you pai;
优盘__優盤 296.216358865|you pan;
诱骗__誘騙 129.979154132|you pian;
邮票__郵票 660.089332023|you piao;
油品__油品 249.415244207|you pin;
邮码__郵碼 162.86639759|you ma;
友们__友們 278.669912425|you men;
油门__油門 544.146968302|you men;
由美__由美 242.670241844|you mei;
又没__又沒 759.903909096|you mei;
优美__優美 1525.07528247|you mei;
右面__右面 155.333728851|you mian;
幼苗__幼苗 169.070402749|you miao;
又名__又名 378.168082664|you ming;
有名__有名 1565.51253772|you ming;
油墨__油墨 312.522131716|you mo;
幽默__幽默 2127.12270781|you mo;
游牧__游牧 129.817279349|you mu;
诱发__誘發 636.660374558|you fa;
有房__有房 251.600451735|you fang;
有份__有份 208.964318904|you fen;
有风__有風 146.132498493|you feng;
油费__油費 109.852835359|you fei;
邮费__郵費 1229.31483934|you fei;
有否__有否 188.430963124|you fou;
有福__有福 191.747236314|you fu;
又打__又打 150.194241046|you da;
又大__又大 187.727829225|you da;
有大__有大 208.964318904|you da;
优待__優待 186.097370046|you dai;
有待__有待 1022.26865969|you dai;
游荡__遊盪 463.919044053|you dang;
有道__有道 204.584007193|you dao;
又到__又到 255.391156791|you dao;
诱导__誘導 725.661628731|you dao;
又得__又得 202.807148249|you de;
有得__有得 343.139741671|you de;
有的__有的 3558.84830329|you de;
油灯__油燈 105.953760973|you deng;
又得__又得 116.044406778|you dei;
邮递__郵遞 128.369448119|you di;
邮电__郵電 354.881620091|you dian;
优点__優點 3161.51444144|you dian;
有点__有點 31823.2660073|you dian;
游动__遊動 145.587202159|you dong;
有毒__有毒 638.24912322|you du;
又多__又多 305.209408115|you duo;
有多__有多 1467.28332601|you duo;
由他__由他 294.009808944|you ta;
犹太__猶太 295.111021611|you tai;
又添__又添 134.259489114|you tian;
有天__有天 338.890182508|you tian;
油田__油田 773.277767188|you tian;
油条__油條 286.415523108|you tiao;
游艇__遊艇 307.117053725|you ting;
右腿__右腿 183.563783354|you tui;
幼女__幼女 210.795122809|you nv;
有哪__有哪 151.321452046|you na;
有难__有難 115.179978568|you nan;
右脑__右腦 114.321989585|you nao;
又能__又能 1569.41918253|you neng;
由你__由你 186.32942291|you ni;
油腻__油膩 409.054029297|you ni;
有你__有你 459.889800938|you ni;
幼年__幼年 231.735198139|you nian;
油轮__油輪 133.925286409|you lun;
忧虑__憂慮 724.757896749|you lv;
由来__由來 457.603107852|you lai;
又来__又來 876.994863387|you lai;
幽兰__幽蘭 114.75018218|you lan;
游览__遊覽 910.401881269|you lan;
游乐__遊樂 188.430963124|you le;
有了__有了 9313.6168469|you le;
有泪__有淚 130.791560815|you lei;
有礼__有禮 187.727829225|you li;
游历__遊歷 191.031727675|you li;
游离__遊離 463.341283758|you li;
有理__有理 761.800204777|you li;
有利__有利 2454.8836586|you li;
有力__有力 2561.13118731|you li;
油料__油料 178.155043976|you liao;
有两__有兩 360.228397261|you liang;
优良__優良 1309.9794677|you liang;
优劣__優劣 407.527636023|you lie;
幽灵__幽靈 692.962351041|you ling;
右路__右路 358.437246895|you lu;
有关__有關 20243.6107394|you guan;
又该__又該 169.28122395|you gai;
有感__有感 381.006242235|you gan;
有个__有個 16750.3963294|you ge;
又给__又給 299.1842072|you gei;
邮购__郵購 246.326401069|you gou;
有功__有功 239.366454718|you gong;
幽谷__幽谷 105.295633316|you gu;
油锅__油鍋 142.535402072|you guo;
有过__有過 3007.78674349|you guo;
有鬼__有鬼 186.32942291|you gui;
有课__有課 225.749468142|you ke;
又可__又可 362.931919108|you ke;
游客__遊客 4174.29838181|you ke;
有空__有空 7053.91217164|you kong;
油库__油庫 121.217779906|you ku;
有话__有話 286.058823982|you hua;
油画__油畫 657.626195507|you hua;
优化__優化 5793.21889028|you hua;
忧患__憂患 131.937467932|you huan;
有害__有害 927.579613097|you hai;
又好__又好 700.778015498|you hao;
油耗__油耗 744.902491688|you hao;
有好__有好 780.052703516|you hao;
友好__友好 1806.7369278|you hao;
又何__又何 107.684208225|you he;
有何__有何 1055.93292173|you he;
有很__有很 199.051387821|you hen;
黝黑__黝黑 157.870654598|you hei;
优厚__優厚 184.251320835|you hou;
有货__有貨 722.953807881|you huo;
诱惑__誘惑 2904.64693418|you huo;
幽会__幽會 129.171793682|you hui;
又会__又會 1194.58057905|you hui;
优惠__優惠 5038.54540704|you hui;
游击__游擊 146.132498493|you ji;
右击__右擊 287.846772995|you ji;
游记__遊記 650.291796355|you ji;
有机__有機 1519.38443361|you ji;
邮寄__郵寄 1740.43907177|you ji;
有加__有加 262.162833911|you jia;
有家__有家 302.181790975|you jia;
油价__油價 1203.54593192|you jia;
又见__又見 566.990680223|you jian;
右键__右鍵 1986.21549859|you jian;
邮件__郵件 12312.5466875|you jian;
幼教__幼教 108.357265155|you jiao;
又叫__又叫 370.240920313|you jiao;
右脚__右腳 426.226434824|you jiao;
有奖__有獎 324.83145542|you jiang;
又将__又將 706.037369534|you jiang;
有劲__有勁 177.933171406|you jin;
幽静__幽靜 204.329220247|you jing;
悠久__悠久 533.404852483|you jiu;
有句__有句 331.37316028|you ju;
邮局__郵局 1328.06008516|you ju;
幼犬__幼犬 115.611384758|you quan;
有权__有權 2439.63524442|you quan;
由其__由其 270.796100963|you qi;
油气__油氣 469.151414294|you qi;
有其__有其 508.100984482|you qi;
油漆__油漆 711.336195135|you qi;
尤其__尤其 13318.1436095|you qi;
有钱__有錢 5961.66560402|you qian;
有请__有請 106.616002115|you qing;
有情__有情 397.001179899|you qing;
友情__友情 1753.50110433|you qing;
又去__又去 660.912425973|you qu;
有趣__有趣 3298.34499764|you qu;
优选__優選 272.149298879|you xuan;
有戏__有戲 318.418891685|you xi;
游戏__遊戲 32383.3366143|you xi;
右下__右下 232.893204426|you xia;
游侠__遊俠 610.248767154|you xia;
由县__由縣 113.187937993|you xian;
有线__有線 725.661628731|you xian;
悠闲__悠閑 869.377962205|you xian;
优先__優先 2759.96781896|you xian;
有限__有限 8263.47766795|you xian;
幼小__幼小 285.346757867|you xiao;
有效__有效 15104.4605586|you xiao;
幽香__幽香 133.093414711|you xiang;
又向__又向 152.077621994|you xiang;
又像__又像 227.443722742|you xiang;
油箱__油箱 243.275811214|you xiang;
邮箱__郵箱 8010.00481377|you xiang;
有些__有些 28983.7454628|you xie;
忧心__憂心 150.381524744|you xin;
有新__有新 337.205131359|you xin;
有心__有心 550.970372621|you xin;
油性__油性 228.011295226|you xing;
有形__有形 510.004074866|you xing;
游行__遊行 698.163048348|you xing;
有幸__有幸 745.831342837|you xing;
优秀__優秀 8304.7711752|you xiu;
有序__有序 3390.02226565|you xu;
右转__右轉 193.186303435|you zhuan;
油炸__油炸 310.194118206|you zha;
有着__有着 7423.68234244|you zhe;
邮政__郵政 1205.04668542|you zheng;
有志__有志 266.444503116|you zhi;
油脂__油脂 818.900002077|you zhi;
幼稚__幼稚 1493.10664229|you zhi;
优质__優質 3666.89398377|you zhi;
由衷__由衷 431.571158705|you zhong;
有种__有種 1868.56155133|you zhong;
有助__有助 270.458854115|you zhu;
游船__遊船 181.516526012|you chuan;
油厂__油廠 107.550099352|you chang;
悠长__悠長 174.855812809|you chang;
有偿__有償 336.365750338|you chang;
有车__有車 578.409173188|you che;
又称__又稱 698.163048348|you cheng;
幼齿__幼齒 134.259489114|you chi;
有仇__有仇 150.944778196|you chou;
忧愁__憂愁 381.006242235|you chou;
幼虫__幼蟲 186.794397067|you chong;
又出__又出 134.42690308|you chu;
有啥__有啥 1918.1063189|you sha;
友善__友善 475.626742696|you shan;
有伤__有傷 109.034528882|you shang;
右上__右上 161.451865638|you shang;
忧伤__憂傷 1361.57568978|you shang;
有神__有神 117.93965545|you shen;
幽深__幽深 131.937467932|you shen;
有什__有什 151.888225993|you shen;
有声__有聲 246.633556117|you sheng;
由省__由省 264.789493468|you sheng;
有谁__有誰 236.107646363|you shei;
有失__有失 244.186999878|you shi;
由市__由市 359.331706043|you shi;
有事__有事 5282.88186737|you shi;
又是__又是 8429.89391588|you shi;
有时__有時 8440.40551537|you shi;
优势__優勢 12544.8634582|you shi;
右手__右手 1738.27154577|you shou;
有数__有數 340.583654043|you shu;
又说__又說 1041.55712696|you shuo;
游水__游水 115.179978568|you shui;
由谁__由誰 120.015323434|you shui;
有水__有水 207.925293333|you shui;
油水__油水 234.64107292|you shui;
游说__遊說 273.509258874|you shui;
有谁__有誰 811.787668067|you shui;
悠然__悠然 370.702589737|you ran;
又让__又讓 227.443722742|you rang;
游人__遊人 602.691239054|you ren;
诱人__誘人 1101.63376911|you ren;
友人__友人 1899.07908248|you ren;
有人__有人 25051.4996789|you ren;
又如__又如 182.196395498|you ru;
有如__有如 433.187606905|you ru;
犹如__猶如 1470.94484558|you ru;
又在__又在 1546.12469848|you zai;
又怎__又怎 106.350610398|you zen;
邮资__郵資 129.655606164|you zi;
柚子__柚子 229.436430673|you zi;
游资__遊資 259.562230298|you zi;
游子__遊子 287.130256264|you zi;
游走__遊走 503.688011099|you zou;
有罪__有罪 411.610733326|you zui;
油菜__油菜 414.183417482|you cai;
有才__有才 601.191002133|you cai;
右侧__右側 1376.93239525|you ce;
有此__有此 368.399985048|you ci;
有次__有次 453.628720089|you ci;
由此__由此 3056.91021261|you ci;
又从__又從 272.828431509|you cong;
有错__有錯 404.996293994|you cuo;
有损__有損 317.626273928|you sun;
有色__有色 531.41444163|you se;
有所__有所 6562.06096374|you suo;
游园__遊園 117.061109314|you yuan;
有源__有源 126.779677253|you yuan;
悠远__悠遠 133.591915611|you yuan;
幽怨__幽怨 138.680779525|you yuan;
由原__由原 146.679837233|you yuan;
有缘__有緣 682.676889633|you yuan;
有约__有約 211.584655172|you yue;
优越__優越 779.081233415|you yue;
幽雅__幽雅 196.831399718|you ya;
优雅__優雅 1744.7822355|you ya;
右眼__右眼 185.86560618|you yan;
油烟__油煙 192.465424888|you yan;
有氧__有氧 194.636170786|you yang;
悠扬__悠揚 299.1842072|you yang;
又要__又要 4107.21887886|you yao;
尤以__尤以 224.907079496|you yi;
又以__又以 256.347723437|you yi;
右翼__右翼 388.679238014|you yi;
又一__又一 765.607004232|you yi;
优异__優異 891.318029807|you yi;
有益__有益 1200.55002966|you yi;
友谊__友誼 1845.42065012|you yi;
有一__有一 2028.7420046|you yi;
有意__有意 2113.91016801|you yi;
又因__又因 151.510141313|you yin;
诱因__誘因 224.06783424|you yin;
幽幽__幽幽 476.219822262|you you;
悠悠__悠悠 936.87321059|you you;
又有__又有 4988.56403023|you you;
又用__又用 164.293322714|you yong;
有用__有用 2564.32477261|you yong;
游泳__游泳 3708.2515163|you yong;
有雨__有雨 130.954650472|you yu;
鱿鱼__魷魚 305.589986932|you yu;
有余__有餘 446.895626023|you yu;
优于__優於 532.077085292|you yu;
忧郁__憂鬱 1504.31243966|you yu;
犹豫__猶豫 2175.37534439|you yu;
由于__由於 37419.7747153|you yu;
游玩__遊玩 719.359091341|you wan;
有望__有望 2829.61978067|you wang;
又问__又問 360.228397261|you wen;
尤文__尤文 628.775756137|you wen;
又为__又為 107.550099352|you wei;
有违__有違 159.253810404|you wei;
有位__有位 557.879339939|you wei;
尤为__尤為 784.92825478|you wei;
有我__有我 233.183609039|you wo;
油污__油污 137.134095104|you wu;
尤物__尤物 173.553291634|you wu;
有误__有誤 469.151414294|you wu;
有无__有無 2140.41782974|you wu;
有啊__有啊 380.057830188|you a;
友爱__友愛 160.449013667|you ai;
有爱__有愛 316.046952528|you ai;
右岸__右岸 191.98633424|you an;
幽暗__幽暗 445.228026075|you an;
诱饵__誘餌 298.811606079|you er;
幼儿__幼兒 1246.28210631|you er;
拥抱__擁抱 1797.75335645|yong bao;
用笔__用筆 177.711575153|yong bi;
永别__永別 115.467403456|yong bie;
用兵__用兵 117.061109314|yong bing;
佣兵__傭兵 134.762357541|yong bing;
永不__永不 889.099334512|yong bu;
用品__用品 1701.83388383|yong pin;
勇猛__勇猛 242.36802267|yong meng;
用法__用法 832.274357505|yong fa;
用房__用房 263.144763849|yong fang;
拥戴__擁戴 110.264288753|yong dai;
用刀__用刀 235.226605969|yong dao;
用到__用到 1399.42059064|yong dao;
用得__用得 406.006938516|yong de;
用的__用的 2156.48171146|yong de;
用地__用地 1329.71610075|yong di;
用电__用電 776.174076244|yong dian;
用掉__用掉 160.649084484|yong diao;
涌动__涌動 350.92368248|yong dong;
拥堵__擁堵 328.904723278|yong du;
勇夺__勇奪 130.954650472|yong duo;
用它__用它 593.745648473|yong ta;
用途__用途 1714.60618362|yong tu;
涌来__湧來 115.899886195|yong lai;
用来__用來 5750.06453265|yong lai;
慵懒__慵懶 276.938965124|yong lan;
永乐__永樂 506.204995518|yong le;
用例__用例 469.151414294|yong li;
用力__用力 1930.09502896|yong li;
用料__用料 410.586139672|yong liao;
用量__用量 667.534233933|yong liang;
用光__用光 170.977284899|yong guang;
勇敢__勇敢 2238.62771494|yong gan;
永刚__永剛 130.954650472|yong gang;
用功__用功 340.583654043|yong gong;
用工__用工 674.222387052|yong gong;
用过__用過 2780.68143664|yong guo;
永康__永康 224.626982392|yong kang;
用好__用好 223.231720645|yong hao;
永和__永和 127.890434962|yong he;
永恒__永恆 1806.7369278|yong heng;
拥护__擁護 582.750146437|yong hu;
用户__用戶 37419.7747153|yong hu;
拥挤__擁擠 934.541117987|yong ji;
用脚__用腳 197.322580943|yong jiao;
涌进__湧進 115.323601467|yong jin;
用尽__用盡 408.035799866|yong jin;
佣金__傭金 787.868200695|yong jin;
永久__永久 1689.15672637|yong jiu;
用具__用具 330.960471347|yong ju;
涌起__湧起 164.703307075|yong qi;
勇气__勇氣 3298.34499764|yong qi;
用钱__用錢 373.950434882|yong qian;
涌现__湧現 479.793862242|yong xian;
涌向__湧向 149.633788238|yong xiang;
用心__用心 2079.94037707|yong xin;
永兴__永興 113.32907693|yong xing;
泳装__泳裝 277.976239008|yong zhuang;
拥着__擁着 142.003528374|yong zhe;
勇者__勇者 229.722524886|yong zhe;
用着__用着 319.213487372|yong zhe;
雍正__雍正 275.561951728|yong zheng;
用之__用之 115.323601467|yong zhi;
用纸__用紙 136.792736844|yong zhi;
永州__永州 212.377144726|yong zhou;
臃肿__臃腫 201.79873775|yong zhong;
用场__用場 129.979154132|yong chang;
用车__用車 434.810109507|yong che;
泳池__泳池 239.068350048|yong chi;
涌出__湧出 292.912705474|yong chu;
用处__用處 884.6784987|yong chu;
涌上__湧上 156.499511818|yong shang;
用上__用上 336.785179346|yong shang;
永生__永生 325.236501817|yong sheng;
用时__用時 105.0335283|yong shi;
永世__永世 112.484875527|yong shi;
勇士__勇士 929.894333673|yong shi;
用手__用手 1852.33266643|yong shou;
用书__用書 121.217779906|yong shu;
用水__用水 973.773879211|yong shui;
佣人__傭人 138.335571213|yong ren;
用人__用人 623.314694733|yong ren;
涌入__湧入 539.420927296|yong ru;
用在__用在 406.006938516|yong zai;
用作__用作 659.267263146|yong zuo;
用嘴__用嘴 176.60772663|yong zui;
永存__永存 111.925571131|yong cun;
用餐__用餐 480.392137969|yong can;
用此__用此 140.244908425|yong ci;
用词__用詞 337.625607028|yong ci;
庸俗__庸俗 402.480675297|yong su;
永远__永遠 14280.7519022|yong yuan;
踊跃__踴躍 638.24912322|yong yue;
用药__用藥 1173.92027842|yong yao;
泳衣__泳衣 219.644465616|yong yi;
用意__用意 396.012952778|yong yi;
用以__用以 616.362966229|yong yi;
用油__用油 143.784200776|yong you;
用友__用友 488.237949645|yong you;
拥有__擁有 17173.1179117|yong you;
用用__用用 455.327784806|yong yong;
用语__用語 453.628720089|yong yu;
勇于__勇於 653.541376022|yong yu;
用于__用於 8882.8564721|yong yu;
用完__用完 714.000502259|yong wan;
永安__永安 228.011295226|yong an;
预报__預報 1149.31255222|yu bao;
预备__預備 718.463208478|yu bei;
玉佩__玉佩 110.677283245|yu pei;
鱼片__魚片 152.647228173|yu pian;
羽毛__羽毛 843.76158662|yu mao;
郁闷__鬱悶 14732.6596137|yu men;
愚昧__愚昧 392.084582382|yu mei;
玉米__玉米 3653.21089568|yu mi;
育苗__育苗 263.472890441|yu miao;
愚民__愚民 125.522047856|yu min;
于民__於民 186.794397067|yu min;
渔民__漁民 483.997491267|yu min;
余名__余名 384.823616623|yu ming;
域名__域名 11890.337992|yu ming;
预谋__預謀 228.011295226|yu mou;
愈发__愈發 314.083839199|yu fa;
语法__語法 1456.35336279|yu fa;
预防__預防 3294.23727064|yu fang;
鱼粉__魚粉 142.003528374|yu fen;
与非__與非 253.488718522|yu fei;
与否__與否 1146.45164931|yu fou;
迂腐__迂腐 107.14877401|yu fu;
渔夫__漁夫 177.711575153|yu fu;
预付__預付 380.531740742|yu fu;
于丹__于丹 372.091054935|yu dan;
遇到__遇到 12576.16843|yu dao;
玉帝__玉帝 146.862738669|yu di;
雨滴__雨滴 167.810977762|yu di;
余地__餘地 815.844260376|yu di;
雨点__雨點 213.172602547|yu dian;
语调__語調 315.653350706|yu diao;
预定__預定 1265.05905145|yu ding;
预订__預訂 1799.9950529|yu ding;
与她__與她 399.980682268|yu ta;
与他__與他 956.932435908|yu ta;
鱼塘__魚塘 146.314717429|yu tang;
雨天__雨天 424.107124851|yu tian;
芋头__芋頭 194.393772779|yu tou;
鱼头__魚頭 284.281980745|yu tou;
玉女__玉女 258.916120291|yu nv;
遇难__遇難 577.688827991|yu nan;
淤泥__淤泥 183.563783354|yu ni;
与你__與你 770.392265767|yu ni;
余年__余年 276.594068012|yu nian;
与您__與您 377.697115787|yu nin;
愚弄__愚弄 232.893204426|yu nong;
舆论__輿論 1836.24473312|yu lun;
玉兰__玉蘭 181.742866823|yu lan;
预览__預覽 806.745280603|yu lan;
娱乐__娛樂 5851.26225798|yu le;
鱼雷__魚雷 165.32020271|yu lei;
鱼类__魚類 465.076726846|yu lei;
语聊__語聊 149.820373083|yu liao;
预料__預料 925.270654393|yu liao;
雨量__雨量 139.72158175|yu liang;
榆林__榆林 154.368879448|yu lin;
雨林__雨林 193.90988203|yu lin;
玉林__玉林 262.162833911|yu lin;
预留__預留 658.446218066|yu liu;
玉龙__玉龍 246.94109417|yu long;
雨露__雨露 196.341441156|yu lu;
语录__語錄 574.10053635|yu lu;
余光__餘光 127.254530072|yu guang;
与该__與該 114.607273411|yu gai;
语感__語感 106.085879302|yu gan;
预感__預感 534.069978074|yu gan;
渔港__漁港 117.061109314|yu gang;
鱼缸__魚缸 261.510250403|yu gang;
浴缸__浴缸 413.152419826|yu gang;
预告__預告 625.649317648|yu gao;
余个__余個 149.447435764|yu ge;
预购__預購 139.200207879|yu gou;
预估__預估 371.164834837|yu gu;
雨果__雨果 110.95347192|yu guo;
余款__餘款 239.963779681|yu kuan;
愉快__愉快 3314.82719055|yu kuai;
预科__預科 205.862715427|yu ke;
余华__余華 179.492101402|yu hua;
玉环__玉環 132.431639237|yu huan;
遇害__遇害 169.28122395|yu hai;
御寒__禦寒 109.579386421|yu han;
宇航__宇航 134.42690308|yu hang;
余杭__餘杭 140.244908425|yu hang;
愈合__癒合 457.033213363|yu he;
预后__預后 249.104624871|yu hou;
雨后__雨後 329.725485744|yu hou;
欲火__慾火 152.077621994|yu huo;
迂回__迂迴 201.045721733|yu hui;
与会__與會 596.712660816|yu hui;
与君__與君 120.615053212|yu jun;
淤积__淤積 113.895394799|yu ji;
雨季__雨季 309.036622663|yu ji;
预计__預計 6173.35572247|yu ji;
余家__余家 221.568841736|yu jia;
瑜珈__瑜珈 232.024158785|yu jia;
愈加__愈加 274.533686805|yu jia;
瑜伽__瑜伽 781.025384985|yu jia;
预见__預見 624.091932797|yu jian;
遇见__遇見 1922.89284084|yu jian;
御姐__御姐 152.457122789|yu jie;
浴巾__浴巾 155.72135507|yu jin;
语境__語境 335.110594827|yu jing;
预警__預警 892.429452826|yu jing;
语句__語句 1813.50405438|yu ju;
羽泉__羽泉 145.224802174|yu quan;
玉泉__玉泉 161.653186955|yu quan;
玉器__玉器 277.976239008|yu qi;
于其__於其 284.281980745|yu qi;
逾期__逾期 511.914293268|yu qi;
语气__語氣 1615.05244942|yu qi;
与其__與其 2169.96033552|yu qi;
预期__預期 5007.24867861|yu qi;
欲求__欲求 135.773751924|yu qiu;
雨雪__雨雪 222.67604562|yu xue;
预习__預習 163.272821143|yu xi;
玉溪__玉溪 218.280152578|yu xi;
鱼虾__魚蝦 120.314814642|yu xia;
余下__餘下 378.168082664|yu xia;
遇险__遇險 114.037415895|yu xian;
预先__預先 896.889021007|yu xian;
预想__預想 318.815941979|yu xiang;
于心__於心 191.508436159|yu xin;
预装__預裝 277.284292303|yu zhuang;
玉照__玉照 119.121315407|yu zhao;
预兆__預兆 176.387781073|yu zhao;
余震__餘震 275.905561849|yu zhen;
预支__預支 105.0335283|yu zhi;
预置__預置 108.763116896|yu zhi;
欲知__欲知 112.34478795|yu zhi;
预制__預製 122.890853693|yu zhi;
阈值__閾值 185.172044961|yu zhi;
预知__預知 327.677408739|yu zhi;
与之__與之 1170.99812122|yu zhi;
宇宙__宇宙 2329.70203704|yu zhou;
余种__余種 106.748946222|yu zhong;
语种__語種 189.372573382|yu zhong;
狱中__獄中 210.008536601|yu zhong;
育种__育種 270.796100963|yu zhong;
雨中__雨中 377.697115787|yu zhong;
预祝__預祝 318.815941979|yu zhu;
渔船__漁船 341.008342538|yu chuan;
宇春__宇春 165.526347625|yu chun;
愚蠢__愚蠢 997.105202031|yu chun;
浴场__浴場 122.432284019|yu chang;
浴池__浴池 134.930398555|yu chi;
鱼翅__魚翅 213.438416689|yu chi;
遇上__遇上 1305.09125317|yu shang;
预设__預設 343.567617462|yu she;
预审__預審 149.075426771|yu shen;
余生__餘生 132.596773978|yu sheng;
雨声__雨聲 161.653186955|yu sheng;
御史__御史 138.680779525|yu shi;
遇事__遇事 178.377193209|yu shi;
于世__於世 233.765505073|yu shi;
玉石__玉石 328.904723278|yu shi;
预示__預示 638.24912322|yu shi;
浴室__浴室 742.122873174|yu shi;
于是__於是 14121.4809739|yu shi;
预收__預收 111.925571131|yu shou;
预售__預售 495.593922384|yu shou;
玉树__玉樹 130.303509496|yu shu;
雨水__雨水 938.041438335|yu shui;
余热__餘熱 122.737806611|yu re;
预热__預熱 263.144763849|yu re;
渔人__漁人 108.357265155|yu ren;
愚人__愚人 111.646962678|yu ren;
育人__育人 215.040276584|yu ren;
于人__於人 215.576896995|yu ren;
余人__餘人 406.513206136|yu ren;
与人__與人 698.163048348|yu ren;
鱼肉__魚肉 330.548296374|yu rou;
羽绒__羽絨 121.823518492|yu rong;
预增__預增 174.855812809|yu zeng;
预存__預存 147.780672558|yu cun;
渔村__漁村 159.651218957|yu cun;
育才__育才 109.442917312|yu cai;
预测__預測 5217.45686316|yu ce;
遇刺__遇刺 116.18910757|yu ci;
与此__與此 526.142915167|yu ci;
于此__於此 912.673735821|yu ci;
预算__預算 3545.56838982|yu suan;
预赛__預賽 210.008536601|yu sai;
雨伞__雨傘 388.679238014|yu san;
语速__語速 156.109948588|yu su;
寓所__寓所 118.23396695|yu suo;
余元__余元 142.535402072|yu yuan;
逾越__逾越 181.290467084|yu yue;
愉悦__愉悅 718.463208478|yu yue;
预约__預約 1139.33050957|yu yue;
预演__預演 133.591915611|yu yan;
浴盐__浴鹽 191.508436159|yu yan;
雨燕__雨燕 233.765505073|yu yan;
寓言__寓言 279.713669565|yu yan;
预言__預言 955.740681497|yu yan;
语言__語言 11354.5435549|yu yan;
余姚__餘姚 212.377144726|yu yao;
雨夜__雨夜 212.641966978|yu ye;
渔业__漁業 574.10053635|yu ye;
羽衣__羽衣 162.86639759|yu yi;
羽翼__羽翼 192.465424888|yu yi;
雨衣__雨衣 198.06165195|yu yi;
语义__語義 337.625607028|yu yi;
寓意__寓意 411.610733326|yu yi;
予以__予以 3277.85745623|yu yi;
语音__語音 3045.50329114|yu yin;
遇有__遇有 105.953760973|yu you;
御用__御用 208.44415872|yu yong;
郁郁__鬱郁 196.586267794|yu yu;
鱼丸__魚丸 114.179614083|yu wan;
余万__余萬 169.703655326|yu wan;
欲望__慾望 3343.86946243|yu wang;
宇文__宇文 234.933657026|yu wen;
语文__語文 1659.94271905|yu wen;
誉为__譽為 789.834279627|yu wei;
与我__與我 540.767020614|yu wo;
预案__預案 563.46883971|yu an;
余额__餘額 1272.96603034|yu e;
育儿__育兒 234.348853194|yu er;
鱼儿__魚兒 590.057620516|yu er;
瓦片__瓦片 107.416157498|wa pian;
挖到__挖到 124.89791921|wa dao;
洼地__窪地 113.895394799|wa di;
挖矿__挖礦 338.046607007|wa kuang;
哇靠__哇靠 301.054193591|wa kao;
挖坑__挖坑 264.789493468|wa keng;
挖苦__挖苦 187.027319083|wa ku;
挖掘__挖掘 2008.61728399|wa jue;
瓦解__瓦解 275.561951728|wa jie;
挖出__挖出 313.302012384|wa chu;
娃子__娃子 147.412812521|wa zi;
袜子__襪子 935.706437745|wa zi;
哇塞__哇塞 601.191002133|wa sai;
瓦斯__瓦斯 373.950434882|wa si;
哇哇__哇哇 365.655730945|wa wa;
娃娃__娃娃 2532.56730325|wa wa;
瓦尔__瓦爾 171.190483873|wa er;
娃儿__娃兒 255.391156791|wa er;
外包__外包 1296.98472971|wai bao;
外币__外幣 382.910172354|wai bi;
外边__外邊 717.56844134|wai bian;
外表__外表 2028.7420046|wai biao;
外宾__外賓 117.93965545|wai bin;
外部__外部 2963.1429408|wai bu;
外拍__外拍 146.132498493|wai pai;
外派__外派 225.468321935|wai pai;
外盘__外盤 174.203334854|wai pan;
外皮__外皮 113.753550575|wai pi;
外频__外頻 192.945711079|wai pin;
外婆__外婆 1565.51253772|wai po;
外卖__外賣 614.062995519|wai mai;
外貌__外貌 446.895626023|wai mao;
外贸__外貿 2227.49666896|wai mao;
外面__外面 10602.3833536|wai mian;
外方__外方 228.295612376|wai fang;
外敷__外敷 114.037415895|wai fu;
外服__外服 118.23396695|wai fu;
外地__外地 3348.03907796|wai di;
外电__外電 122.279808036|wai dian;
外滩__外灘 395.519762073|wai tan;
外逃__外逃 156.89004718|wai tao;
外套__外套 947.439854855|wai tao;
外头__外頭 274.533686805|wai tou;
外来__外來 1133.66545852|wai lai;
歪了__歪了 170.76435144|wai le;
外力__外力 275.561951728|wai li;
外联__外聯 119.56748386|wai lian;
外流__外流 166.768626413|wai liu;
外露__外露 146.679837233|wai lu;
外挂__外掛 1493.10664229|wai gua;
外观__外觀 3095.24275062|wai guan;
外购__外購 131.937467932|wai gou;
外公__外公 610.248767154|wai gong;
外国__外國 4163.90759438|wai guo;
外快__外快 196.586267794|wai kuai;
外科__外科 667.534233933|wai ke;
外壳__外殼 1176.84972769|wai ke;
外环__外環 162.663565352|wai huan;
外行__外行 363.837594448|wai hang;
外号__外號 506.204995518|wai hao;
外汇__外匯 1597.0400293|wai hui;
外籍__外籍 418.854838101|wai ji;
外加__外加 762.750126416|wai jia;
外教__外教 274.533686805|wai jiao;
外交__外交 1553.85085374|wai jiao;
外接__外接 403.48504224|wai jie;
外界__外界 2266.69928918|wai jie;
外景__外景 346.577724349|wai jing;
外企__外企 1128.02857559|wai qi;
外墙__外牆 332.200082586|wai qiang;
歪曲__歪曲 366.111682898|wai qu;
外线__外線 382.910172354|wai xian;
外校__外校 107.818484324|wai xiao;
外销__外銷 269.449631503|wai xiao;
外相__外相 113.611883002|wai xiang;
外向__外向 263.801426189|wai xiang;
外泄__外泄 154.368879448|wai xie;
外星__外星 220.742053181|wai xing;
外型__外型 567.697685436|wai xing;
外形__外形 1764.46098498|wai xing;
外传__外傳 267.775955618|wai zhuan;
外债__外債 203.313241605|wai zhai;
外长__外長 391.596284031|wai zhang;
歪着__歪着 125.835280772|wai zhe;
外置__外置 314.867617017|wai zhi;
外传__外傳 119.86585751|wai chuan;
外出__外出 1915.71752783|wai chu;
外伤__外傷 269.785619908|wai shang;
外商__外商 655.172250234|wai shang;
外设__外設 350.486645516|wai she;
外甥__外甥 287.488291405|wai sheng;
外省__外省 384.344361008|wai sheng;
外事__外事 230.582949765|wai shi;
外人__外人 894.656458236|wai ren;
外在__外在 511.276760152|wai zai;
外资__外資 2897.41660082|wai zi;
外侧__外側 322.813777494|wai ce;
外层__外層 180.164388413|wai ceng;
外孙__外孫 109.716025699|wai sun;
外援__外援 538.078184713|wai yuan;
外运__外運 116.915322539|wai yun;
外延__外延 237.583386308|wai yan;
外衣__外衣 535.402718412|wai yi;
外阴__外陰 220.467143161|wai yin;
外用__外用 230.870473623|wai yong;
外遇__外遇 337.625607028|wai yu;
外域__外域 605.702953498|wai yu;
外语__外語 1284.11889697|wai yu;
歪歪__歪歪 324.426913464|wai wai;
外网__外網 744.902491688|wai wang;
外文__外文 328.495108513|wai wen;
外围__外圍 806.745280603|wai wei;
玩吧__玩吧 308.651751439|wan ba;
玩伴__玩伴 135.773751924|wan ban;
万般__萬般 159.85029497|wan ban;
晚班__晚班 232.024158785|wan ban;
晚报__晚報 441.361118731|wan bao;
晚辈__晚輩 175.292155245|wan bei;
完备__完備 604.195219728|wan bei;
完璧__完璧 378.168082664|wan bi;
完毕__完畢 3411.21086903|wan bi;
腕表__腕錶 119.716577729|wan biao;
顽皮__頑皮 314.867617017|wan pi;
完满__完滿 113.753550575|wan man;
完美__完美 7395.98072362|wan mei;
玩命__玩命 223.510077937|wan ming;
万名__萬名 604.195219728|wan ming;
万亩__萬畝 428.890471272|wan mu;
玩法__玩法 467.983588668|wan fa;
碗饭__碗飯 112.625137786|wan fan;
晚饭__晚飯 2312.34781708|wan fan;
万方__萬方 172.475272126|wan fang;
万分__萬分 976.203874871|wan fen;
晚风__晚風 149.447435764|wan feng;
万吨__萬噸 1295.36947746|wan dun;
万达__萬達 333.029068427|wan da;
完蛋__完蛋 984.756712384|wan dan;
弯道__彎道 217.465635832|wan dao;
玩到__玩到 352.677286738|wan dao;
玩得__玩得 654.356305043|wan de;
玩的__玩的 1218.6379585|wan de;
晚点__晚點 1427.60319527|wan dian;
豌豆__豌豆 264.789493468|wan dou;
万多__萬多 855.407364934|wan duo;
万台__萬台 208.964318904|wan tai;
万通__萬通 190.556205829|wan tong;
万能__萬能 714.000502259|wan neng;
万年__萬年 508.100984482|wan nian;
晚年__晚年 1155.05579352|wan nian;
玩弄__玩弄 573.385557088|wan nong;
玩乐__玩樂 211.848489234|wan le;
完了__完了 6196.47800381|wan le;
万历__萬曆 147.412812521|wan li;
碗里__碗里 287.130256264|wan li;
万里__萬里 1003.33739315|wan li;
万辆__萬輛 304.829303266|wan liang;
挽留__挽留 467.400766428|wan liu;
弯路__彎路 249.104624871|wan lu;
万个__萬個 401.478808454|wan ge;
完工__完工 893.542261726|wan gong;
万古__萬古 106.085879302|wan gu;
顽固__頑固 379.111778956|wan gu;
万股__萬股 454.760723981|wan gu;
万国__萬國 292.912705474|wan guo;
玩过__玩過 1119.62576025|wan guo;
碗筷__碗筷 121.671800659|wan kuai;
万块__萬塊 146.132498493|wan kuai;
万科__萬科 1716.74420026|wan ke;
完好__完好 562.066236349|wan hao;
完后__完后 746.761352211|wan hou;
万户__萬戶 203.566761683|wan hu;
挽回__挽回 814.828215816|wan hui;
晚会__晚會 1491.2471417|wan hui;
顽疾__頑疾 116.044406778|wan ji;
万家__萬家 297.325836157|wan jia;
玩家__玩家 6949.21277302|wan jia;
晚间__晚間 434.810109507|wan jian;
完结__完結 356.655002599|wan jie;
挽救__挽救 691.237408589|wan jiu;
婉拒__婉拒 116.624293448|wan ju;
玩具__玩具 2388.49559106|wan ju;
完全__完全 25334.0462203|wan quan;
玩起__玩起 160.449013667|wan qi;
晚期__晚期 588.588831574|wan qi;
万千__萬千 417.812212206|wan qian;
顽强__頑強 832.274357505|wan qiang;
晚清__晚清 153.218967809|wan qing;
弯曲__彎曲 747.692521253|wan qu;
惋惜__惋惜 444.119751258|wan xi;
弯下__彎下 122.890853693|wan xia;
晚霞__晚霞 195.365179853|wan xia;
玩笑__玩笑 2632.31764915|wan xiao;
万象__萬象 181.969489867|wan xiang;
晚些__晚些 178.377193209|wan xie;
万幸__萬幸 144.143005824|wan xing;
玩转__玩轉 243.57916235|wan zhuan;
婉转__婉轉 277.976239008|wan zhuan;
万张__萬張 169.070402749|wan zhang;
万丈__萬丈 184.02185602|wan zhang;
挽着__挽着 174.855812809|wan zhe;
玩着__玩着 202.302314677|wan zhe;
完整__完整 6028.9050116|wan zheng;
万州__萬州 148.149450567|wan zhou;
万种__萬種 167.393257695|wan zhong;
万众__萬眾 231.158356006|wan zhong;
完成__完成 29347.1910492|wan cheng;
玩耍__玩耍 582.024395035|wan shua;
完善__完善 10497.2098015|wan shan;
晚上__晚上 43945.6998106|wan shang;
完胜__完勝 180.839193473|wan sheng;
完事__完事 528.113581536|wan shi;
万事__萬事 556.490650127|wan shi;
晚睡__晚睡 152.457122789|wan shui;
完人__完人 108.357265155|wan ren;
万人__萬人 1714.60618362|wan ren;
宛如__宛如 445.783200166|wan ru;
宛若__宛若 149.633788238|wan ruo;
万字__萬字 242.066179876|wan zi;
丸子__丸子 437.527796363|wan zi;
晚餐__晚餐 1263.48355913|wan can;
万岁__萬歲 907.004698479|wan sui;
万元__萬元 6736.05351167|wan yuan;
婉约__婉約 141.121478992|wan yue;
完颜__完顏 105.558392399|wan yan;
蜿蜒__蜿蜒 284.991389772|wan yan;
晚宴__晚宴 366.568203397|wan yan;
弯腰__彎腰 307.883446338|wan yao;
玩艺__玩藝 122.584950132|wan yi;
万亿__萬億 632.705783453|wan yi;
玩意__玩意 1797.75335645|wan yi;
万一__萬一 3441.09758945|wan yi;
万余__萬餘 544.146968302|wan yu;
弯弯__彎彎 252.228305921|wan wan;
玩完__玩完 261.83633885|wan wan;
万万__萬萬 443.014235191|wan wan;
玩玩__玩玩 3118.47261385|wan wan;
万网__萬網 270.122027271|wan wang;
玩味__玩味 135.098649108|wan wei;
玩物__玩物 115.323601467|wan wu;
万物__萬物 894.656458236|wan wu;
湾岸__灣岸 305.97104031|wan an;
晚安__晚安 6119.7387146|wan an;
万恶__萬惡 426.226434824|wan e;
婉儿__婉兒 117.93965545|wan er;
玩儿__玩兒 985.98464814|wan er;
玩偶__玩偶 222.398727024|wan ou;
王八__王八 331.37316028|wang ba;
网吧__網吧 5880.50165938|wang ba;
往北__往北 170.127140854|wang bei;
王斌__王斌 185.634130949|wang bin;
王牌__王牌 376.756940916|wang pai;
网盘__網盤 153.028150386|wang pan;
王鹏__王鵬 191.747236314|wang peng;
王平__王平 122.584950132|wang ping;
王蒙__王蒙 124.742372548|wang meng;
网民__網民 4393.11752614|wang min;
王明__王明 188.901181552|wang ming;
网名__網名 655.172250234|wang ming;
王某__王某 462.764242999|wang mou;
往返__往返 854.342048866|wang fan;
王芳__王芳 115.179978568|wang fang;
汪峰__汪峰 114.75018218|wang feng;
网费__網費 165.73274959|wang fei;
王妃__王妃 271.810366771|wang fei;
王菲__王菲 1706.08071057|wang fei;
王府__王府 330.960471347|wang fu;
网段__網段 307.883446338|wang duan;
王丹__王丹 117.061109314|wang dan;
王道__王道 844.813709452|wang dao;
网店__網店 588.588831574|wang dian;
网点__網點 1096.15615618|wang dian;
忘掉__忘掉 618.67155147|wang diao;
王东__王東 117.499561272|wang dong;
往东__往東 136.622376491|wang dong;
王涛__王濤 156.499511818|wang tao;
网通__網通 3141.87681769|wang tong;
妄图__妄圖 190.318888971|wang tu;
往南__往南 154.368879448|wang nan;
王楠__王楠 215.845709156|wang nan;
网内__網內 145.043940608|wang nei;
往年__往年 741.198640518|wang nian;
往来__往來 1139.33050957|wang lai;
望了__望了 241.764712994|wang le;
忘了__忘了 7554.33474859|wang le;
王磊__王磊 265.78126155|wang lei;
王力__王力 107.015331962|wang li;
王立__王立 128.689786556|wang li;
王丽__王麗 153.028150386|wang li;
往里__往裡 340.15949445|wang li;
网恋__網戀 480.991159713|wang lian;
王亮__王亮 120.916041011|wang liang;
亡灵__亡靈 631.917817783|wang ling;
网路__網路 633.494731672|wang lu;
网罗__網羅 126.464093517|wang luo;
网络__網絡 34723.9382239|wang luo;
王冠__王冠 124.587019602|wang guan;
网关__網關 1160.82773443|wang guan;
网管__網管 1563.56286353|wang guan;
王刚__王剛 238.473254015|wang gang;
网格__網格 593.006203378|wang ge;
网购__網購 265.119670945|wang gou;
王宫__王宮 162.460985719|wang gong;
亡国__亡國 204.07475061|wang guo;
王国__王國 910.401881269|wang guo;
网卡__網卡 1959.1745514|wang ka;
忘怀__忘懷 149.261315371|wang huai;
王海__王海 171.403948695|wang hai;
汪涵__汪涵 178.377193209|wang han;
王浩__王浩 107.14877401|wang hao;
王皓__王皓 144.322743975|wang hao;
王后__王后 194.393772779|wang hou;
往后__往後 764.653524665|wang hou;
王辉__王輝 108.763116896|wang hui;
往回__往回 301.429591092|wang hui;
王俊__王俊 119.86585751|wang jun;
王军__王軍 194.151676652|wang jun;
旺季__旺季 650.291796355|wang ji;
忘记__忘記 10937.8908136|wang ji;
王佳__王佳 246.019628549|wang jia;
王家__王家 307.500011268|wang jia;
网监__網監 123.197520618|wang jian;
望见__望見 150.569041974|wang jian;
王建__王建 202.302314677|wang jian;
旺角__旺角 136.282292017|wang jiao;
往届__往屆 145.768741141|wang jie;
王杰__王傑 195.852702213|wang jie;
王静__王靜 168.439513167|wang jing;
王晶__王晶 256.667374505|wang jing;
望京__望京 377.226735448|wang jing;
忘却__忘卻 584.932834985|wang que;
往前__往前 720.256091319|wang qian;
王强__王強 184.02185602|wang qiang;
忘情__忘情 194.878871049|wang qing;
网球__網球 1067.84239617|wang qiu;
望去__望去 456.464028614|wang qu;
网讯__網訊 304.070513117|wang xun;
往西__往西 145.224802174|wang xi;
往昔__往昔 227.160466527|wang xi;
网下__網下 392.573489614|wang xia;
往下__往下 1376.93239525|wang xia;
网线__網線 1153.6172982|wang xian;
网校__網校 152.647228173|wang xiao;
王晓__王曉 182.878811433|wang xiao;
王小__王小 191.508436159|wang xiao;
望向__望向 245.101601395|wang xiang;
妄想__妄想 364.745529846|wang xiang;
王新__王新 106.616002115|wang xin;
网赚__網賺 273.168633085|wang zhuan;
网状__網狀 155.72135507|wang zhuang;
网摘__網摘 154.176629937|wang zhai;
网站__網站 38411.9571991|wang zhan;
王者__王者 847.977956119|wang zhe;
望着__望着 2494.97706011|wang zhe;
王振__王振 123.044091616|wang zhen;
王志__王志 191.508436159|wang zhi;
网志__網誌 231.446597362|wang zhi;
网址__網址 4520.85414793|wang zhi;
往常__往常 496.830647979|wang chang;
王超__王超 184.251320835|wang chao;
王朝__王朝 1024.81967123|wang chao;
王城__王城 127.73116145|wang cheng;
网虫__網蟲 115.755545596|wang chong;
网商__網商 233.765505073|wang shang;
往上__往上 968.932019286|wang shang;
网上__網上 22365.7896417|wang shang;
往生__往生 159.253810404|wang sheng;
旺盛__旺盛 1009.60853723|wang sheng;
王世__王世 107.015331962|wang shi;
王氏__王氏 123.658956482|wang shi;
王室__王室 242.066179876|wang shi;
王石__王石 313.302012384|wang shi;
往事__往事 1528.88101848|wang shi;
王朔__王朔 482.792710347|wang shuo;
往日__往日 585.662213047|wang ri;
王子__王子 2590.0172328|wang zi;
王总__王總 477.408200926|wang zong;
旺财__旺財 204.584007193|wang cai;
网速__網速 1880.24059249|wang su;
望月__望月 194.878871049|wang yue;
王燕__王燕 138.163289429|wang yan;
汪洋__汪洋 325.642053285|wang yang;
王爷__王爺 463.341283758|wang ye;
网页__網頁 7582.62948183|wang ye;
王毅__王毅 106.882056102|wang yi;
网易__網易 1868.56155133|wang yi;
网瘾__網癮 140.070248771|wang yin;
网银__網銀 726.566487616|wang yin;
网游__網游 2159.17072182|wang you;
网友__網友 14016.2884286|wang you;
王永__王永 122.890853693|wang yong;
王勇__王勇 154.754097942|wang yong;
王宇__王宇 110.539446825|wang yu;
网域__網域 118.824795093|wang yu;
王玉__王玉 136.282292017|wang yu;
往外__往外 655.172250234|wang wai;
望望__望望 120.765453341|wang wang;
汪汪__汪汪 201.547419552|wang wang;
旺旺__旺旺 1028.65812957|wang wang;
往往__往往 10200.611399|wang wang;
王文__王文 173.769702743|wang wen;
王位__王位 166.560934377|wang wei;
王维__王維 191.747236314|wang wei;
王伟__王偉 316.83562918|wang wei;
忘我__忘我 199.548108896|wang wo;
王二__王二 135.94305409|wang er;
温饱__溫飽 387.22887368|wen bao;
文本__文本 2725.78743963|wen ben;
文笔__文筆 773.277767188|wen bi;
稳步__穩步 1028.65812957|wen bu;
文凭__文憑 1026.09756322|wen ping;
文盲__文盲 450.24958728|wen mang;
文秘__文秘 205.862715427|wen mi;
闻名__聞名 643.841029976|wen ming;
文明__文明 4751.91457879|wen ming;
文法__文法 107.282382453|wen fa;
文峰__文峰 110.677283245|wen feng;
文风__文風 184.941433485|wen feng;
问答__問答 799.738513132|wen da;
稳当__穩當 205.350275845|wen dang;
文档__文檔 7488.72362169|wen dang;
闻到__聞到 610.248767154|wen dao;
问到__問到 655.989212862|wen dao;
问道__問道 1579.22849881|wen dao;
问得__問得 142.003528374|wen de;
文帝__文帝 105.690017726|wen di;
问鼎__問鼎 140.070248771|wen ding;
稳定__穩定 13688.3204776|wen ding;
温度__溫度 5108.08849097|wen du;
问他__問他 1899.07908248|wen ta;
稳态__穩態 107.818484324|wen tai;
文坛__文壇 322.010219858|wen tan;
文体__文體 448.010827873|wen ti;
问题__問題 137270.158128|wen ti;
稳妥__穩妥 449.688850794|wen tuo;
温暖__溫暖 4169.09975093|wen nuan;
吻你__吻你 254.121284766|wen ni;
问你__問你 2648.77038315|wen ni;
紊乱__紊亂 503.688011099|wen luan;
文莱__文萊 108.492380517|wen lai;
吻了__吻了 187.4940348|wen le;
文理__文理 170.76435144|wen li;
纹理__紋理 416.772181646|wen li;
文联__文聯 153.601316766|wen lian;
温岭__溫嶺 125.209594649|wen ling;
文龙__文龍 119.26985293|wen long;
纹路__紋路 165.114314527|wen lu;
问路__問路 169.492308033|wen lu;
文稿__文稿 247.557321202|wen gao;
温格__溫格 190.081867665|wen ge;
问个__問個 359.331706043|wen ge;
文革__文革 1098.89154964|wen ge;
稳固__穩固 470.908619205|wen gu;
问过__問過 1129.43516323|wen guo;
文科__文科 854.342048866|wen ke;
文库__文庫 129.655606164|wen ku;
文华__文華 199.051387821|wen hua;
问话__問話 213.438416689|wen hua;
文化__文化 19115.8066585|wen hua;
问号__問號 444.673543393|wen hao;
问好__問好 713.111292931|wen hao;
吻合__吻合 633.494731672|wen he;
温和__溫和 1300.22127911|wen he;
问候__問候 1613.0410787|wen hou;
文火__文火 140.419785869|wen huo;
问卷__問卷 809.766942109|wen juan;
问及__問及 341.859308876|wen ji;
文集__文集 589.322768456|wen ji;
稳健__穩健 1173.92027842|wen jian;
文件__文件 31862.9478147|wen jian;
文教__文教 143.784200776|wen jiao;
温江__溫江 133.093414711|wen jiang;
文静__文靜 377.697115787|wen jing;
稳居__穩居 148.704343794|wen ju;
文具__文具 328.904723278|wen ju;
温泉__溫泉 1128.02857559|wen quan;
问起__問起 391.108593802|wen qi;
温情__溫情 582.750146437|wen qing;
文学__文學 3991.16951133|wen xue;
问询__問詢 114.321989585|wen xun;
闻讯__聞訊 231.158356006|wen xun;
温习__溫習 190.793818607|wen xi;
文献__文獻 2031.27173079|wen xian;
蚊香__蚊香 227.443722742|wen xiang;
温馨__溫馨 1845.42065012|wen xin;
文胸__文胸 158.857391092|wen xiong;
文摘__文摘 193.186303435|wen zhai;
蚊帐__蚊帳 205.862715427|wen zhang;
文章__文章 18598.8528473|wen zhang;
吻着__吻着 122.890853693|wen zhe;
闻之__聞之 159.452390871|wen zhi;
温州__溫州 2461.00967693|wen zhou;
稳重__穩重 638.24912322|wen zhong;
文中__文中 1331.37418129|wen zhong;
稳住__穩住 256.987424161|wen zhu;
汶川__汶川 723.855290267|wen chuan;
温床__溫床 118.529012887|wen chuang;
温差__溫差 240.862563142|wen cha;
文昌__文昌 259.238974004|wen chang;
蚊虫__蚊蟲 142.003528374|wen chong;
温顺__溫順 230.295783987|wen shun;
文山__文山 111.646962678|wen shan;
纹身__紋身 332.614317243|wen shen;
文史__文史 150.944778196|wen shi;
温室__溫室 275.905561849|wen shi;
问世__問世 623.314694733|wen shi;
文书__文書 573.385557088|wen shu;
温水__溫水 462.764242999|wen shui;
温润__溫潤 167.810977762|wen run;
温热__溫熱 465.076726846|wen re;
文人__文人 952.17431607|wen ren;
温柔__溫柔 4112.3403478|wen rou;
问责__問責 220.467143161|wen ze;
蚊子__蚊子 1877.89895902|wen zi;
文字__文字 11728.4592825|wen zi;
温存__溫存 168.439513167|wen cun;
文采__文采 412.12398856|wen cai;
文员__文員 329.314848809|wen yuan;
文雅__文雅 218.552335545|wen ya;
文言__文言 105.295633316|wen yan;
闻言__聞言 179.940013424|wen yan;
瘟疫__瘟疫 482.792710347|wen yi;
文艺__文藝 1235.45786087|wen yi;
温婉__溫婉 169.492308033|wen wan;
温网__溫網 108.087539034|wen wang;
闻闻__聞聞 116.18910757|wen wen;
稳稳__穩穩 191.031727675|wen wen;
雯雯__雯雯 216.654158472|wen wen;
文文__文文 310.194118206|wen wen;
问问__問問 10602.3833536|wen wen;
问我__問我 4333.30827629|wen wo;
文武__文武 202.050369328|wen wu;
文物__文物 1517.49220692|wen wu;
文案__文案 360.228397261|wen an;
嗡嗡__嗡嗡 188.901181552|weng weng;
尾巴__尾巴 1277.73391996|wei ba;
为伴__為伴 122.279808036|wei ban;
为本__為本 526.798985534|wei ben;
未被__未被 385.303469841|wei bei;
违背__違背 1162.27522076|wei bei;
未必__未必 2819.06099798|wei bi;
未变__未變 116.769717326|wei bian;
卫兵__衛兵 257.62872122|wei bing;
胃病__胃病 258.916120291|wei bing;
韦伯__韋伯 204.07475061|wei bo;
微薄__微薄 323.216307961|wei bo;
微波__微波 546.185068786|wei bo;
胃部__胃部 142.535402072|wei bu;
尾部__尾部 358.884197808|wei bu;
委派__委派 227.160466527|wei pai;
尾盘__尾盤 494.9767145|wei pan;
未满__未滿 212.377144726|wei man;
威猛__威猛 159.253810404|wei meng;
为每__為每 243.882891747|wei mei;
唯美__唯美 611.009712747|wei mei;
微米__微米 150.007190589|wei mi;
萎靡__萎靡 180.839193473|wei mi;
卫冕__衛冕 331.37316028|wei mian;
未免__未免 542.11647303|wei mian;
为妙__為妙 156.89004718|wei miao;
微妙__微妙 686.088301175|wei miao;
为民__為民 494.9767145|wei min;
为名__為名 338.046607007|wei ming;
帷幕__帷幕 567.697685436|wei mu;
违法__違法 4537.78699065|wei fa;
违反__違反 3277.85745623|wei fan;
危房__危房 158.857391092|wei fang;
潍坊__濰坊 498.070459751|wei fang;
微分__微分 116.624293448|wei fen;
威风__威風 301.805456692|wei feng;
微风__微風 465.65665114|wei feng;
为辅__為輔 224.347234118|wei fu;
伟大__偉大 5909.88717328|wei da;
未到__未到 312.522131716|wei dao;
味道__味道 6949.21277302|wei dao;
韦德__韋德 197.568631008|wei de;
尾灯__尾燈 132.431639237|wei deng;
为敌__為敵 136.963309627|wei di;
位点__位點 118.23396695|wei dian;
未定__未定 284.991389772|wei ding;
卫东__衛東 147.045868173|wei dong;
围堵__圍堵 111.369047744|wei du;
纬度__緯度 158.857391092|wei du;
惟独__惟獨 195.852702213|wei du;
维度__維度 364.745529846|wei du;
唯独__唯獨 445.228026075|wei du;
卫队__衛隊 284.991389772|wei dui;
为它__為它 158.659551632|wei ta;
为她__為她 903.620192345|wei ta;
为他__為他 1480.13866924|wei ta;
维特__維特 136.622376491|wei te;
胃疼__胃疼 139.026849285|wei teng;
为题__為題 214.504991945|wei ti;
微调__微調 214.504991945|wei tiao;
胃痛__胃痛 177.048440864|wei tong;
位图__位圖 191.747236314|wei tu;
委托__委託 3712.87549557|wei tuo;
喂奶__餵奶 266.776744296|wei nai;
危难__危難 216.11485651|wei nan;
为难__為難 970.140222547|wei nan;
未能__未能 2498.08815496|wei neng;
维尼__維尼 127.413209251|wei ni;
为你__為你 2606.20557717|wei ni;
为您__為您 1927.69130725|wei nin;
维拉__維拉 215.040276584|wei la;
未来__未來 15797.5062419|wei lai;
围栏__圍欄 260.534419685|wei lan;
蔚蓝__蔚藍 329.314848809|wei lan;
为乐__為樂 145.768741141|wei le;
为了__為了 43078.1588251|wei le;
微利__微利 154.176629937|wei li;
微粒__微粒 251.287110964|wei li;
威力__威力 1193.09285994|wei li;
为例__為例 1619.08271818|wei li;
威廉__威廉 345.284462654|wei lian;
微量__微量 234.348853194|wei liang;
伪劣__偽劣 138.335571213|wei lie;
位列__位列 342.712398751|wei lie;
为零__為零 432.648119245|wei ling;
为官__為官 158.067510349|wei guan;
围观__圍觀 479.793862242|wei guan;
微观__微觀 503.060722916|wei guan;
为该__為該 136.792736844|wei gai;
味甘__味甘 142.180598718|wei gan;
威刚__威剛 139.72158175|wei gang;
伟哥__偉哥 394.535222541|wei ge;
围攻__圍攻 372.091054935|wei gong;
魏国__魏國 165.32020271|wei guo;
卫国__衛國 183.106850936|wei guo;
为国__為國 199.051387821|wei guo;
未果__未果 303.691826638|wei guo;
未归__未歸 296.216358865|wei gui;
违规__違規 1746.95787997|wei gui;
围困__圍困 137.991222203|wei kun;
胃口__胃口 1309.9794677|wei kou;
惟恐__惟恐 127.73116145|wei kong;
唯恐__唯恐 205.862715427|wei kong;
为空__為空 398.48814637|wei kong;
未婚__未婚 689.516759915|wei hun;
为害__為害 145.587202159|wei hai;
威海__威海 795.762002835|wei hai;
危害__危害 2773.75968187|wei hai;
为好__為好 368.85935893|wei hao;
维和__維和 215.040276584|wei he;
为何__為何 5422.95707874|wei he;
维护__維護 10721.9636895|wei hu;
未获__未獲 142.357889859|wei huo;
委会__委會 189.136730609|wei hui;
味觉__味覺 174.855812809|wei jue;
为君__為君 123.044091616|wei jun;
维基__維基 210.795122809|wei ji;
危急__危急 266.112675706|wei ji;
微机__微機 352.677286738|wei ji;
危及__危及 371.627656329|wei ji;
违纪__違紀 450.811022973|wei ji;
危机__危機 3991.16951133|wei ji;
为佳__為佳 183.792676978|wei jia;
未见__未見 660.912425973|wei jian;
围剿__圍剿 165.939408926|wei jiao;
慰藉__慰藉 208.44415872|wei jie;
魏晋__魏晉 135.94305409|wei jin;
违禁__違禁 156.109948588|wei jin;
未尽__未盡 185.402943996|wei jin;
围巾__圍巾 471.495815538|wei jin;
味精__味精 332.614317243|wei jing;
未经__未經 2373.65954378|wei jing;
微距__微距 256.667374505|wei ju;
畏惧__畏懼 410.07479966|wei ju;
位居__位居 740.275558891|wei ju;
维权__維權 1282.5196677|wei quan;
围裙__圍裙 128.689786556|wei qun;
为妻__為妻 141.121478992|wei qi;
尾气__尾氣 193.427195796|wei qi;
维奇__維奇 198.803491145|wei qi;
围棋__圍棋 635.075580657|wei qi;
为期__為期 837.47630896|wei qi;
为其__為其 1370.08592511|wei qi;
围墙__圍牆 514.472385324|wei qiang;
为情__為情 111.786180106|wei qing;
卫青__衛青 145.587202159|wei qing;
为求__為求 118.529012887|wei qiu;
委屈__委屈 1768.86409398|wei qu;
维系__維繫 432.109303457|wei xi;
为先__為先 177.269210225|wei xian;
危险__危險 6173.35572247|wei xian;
微小__微小 453.063775264|wei xiao;
微笑__微笑 4453.75227609|wei xiao;
猥亵__猥褻 335.528458728|wei xie;
威胁__威脅 4371.27378998|wei xie;
违心__違心 134.42690308|wei xin;
威信__威信 287.130256264|wei xin;
微星__微星 335.110594827|wei xing;
微型__微型 559.968874971|wei xing;
卫星__衛星 2338.42792752|wei xing;
维修__維修 3966.37851746|wei xiu;
伪装__偽裝 769.432826682|wei zhuang;
为准__為準 1101.63376911|wei zhun;
违章__違章 627.992684885|wei zhang;
违者__違者 576.250827814|wei zhe;
围着__圍着 785.907015785|wei zhe;
为证__為證 208.964318904|wei zheng;
谓之__謂之 268.109857044|wei zhi;
为之__為之 1493.10664229|wei zhi;
未知__未知 1521.27901981|wei zhi;
为止__為止 2580.3525318|wei zhi;
位置__位置 16584.235701|wei zhi;
为重__為重 303.313611771|wei zhong;
围住__圍住 183.792676978|wei zhu;
为主__為主 7204.94222781|wei zhu;
微创__微創 148.704343794|wei chuang;
未尝__未嘗 217.19480623|wei chang;
胃肠__胃腸 366.111682898|wei chang;
围成__圍成 125.678566729|wei cheng;
围城__圍城 301.429591092|wei cheng;
为耻__為恥 214.2378495|wei chi;
维持__維持 5013.49243365|wei chi;
为啥__為啥 6448.56995722|wei sha;
伪善__偽善 109.30661816|wei shan;
威慑__威懾 217.19480623|wei she;
为什__為什 218.280152578|wei shen;
威盛__威盛 115.467403456|wei sheng;
为生__為生 340.583654043|wei sheng;
尾声__尾聲 474.442798491|wei sheng;
卫生__衛生 3883.23525949|wei sheng;
尾市__尾市 163.069482749|wei shi;
喂食__餵食 195.60878915|wei shi;
为使__為使 222.121753798|wei shi;
为师__為師 255.073095111|wei shi;
卫士__衛士 514.472385324|wei shi;
卫视__衛視 646.252534205|wei shi;
为首__為首 764.653524665|wei shou;
尾数__尾數 137.819369268|wei shu;
位数__位數 508.734557585|wei shu;
为谁__為誰 263.472890441|wei shui;
微软__微軟 7062.70799995|wei ruan;
围绕__圍繞 3165.45667059|wei rao;
委任__委任 199.548108896|wei ren;
伟人__偉人 454.760723981|wei ren;
为人__為人 1569.41918253|wei ren;
为荣__為榮 412.637883794|wei rong;
微弱__微弱 541.441326411|wei ruo;
围在__圍在 230.582949765|wei zai;
伪造__偽造 682.676889633|wei zao;
位子__位子 1012.12795618|wei zi;
维族__維族 107.416157498|wei zu;
围坐__圍坐 127.890434962|wei zuo;
未作__未作 140.594881376|wei zuo;
未曾__未曾 680.977550057|wei ceng;
为此__為此 2501.20312918|wei ci;
胃酸__胃酸 166.560934377|wei suan;
维萨__維薩 143.784200776|wei sa;
维斯__維斯 165.73274959|wei si;
猥琐__猥瑣 784.92825478|wei suo;
萎缩__萎縮 1083.93090293|wei suo;
尾随__尾隨 186.097370046|wei sui;
未遂__未遂 244.796354228|wei sui;
委员__委員 2100.77969738|wei yuan;
违约__違約 706.037369534|wei yue;
维亚__維亞 136.963309627|wei ya;
胃炎__胃炎 123.504952812|wei yan;
威严__威嚴 330.960471347|wei yan;
未央__未央 160.449013667|wei yang;
喂养__餵養 367.482952871|wei yang;
伟业__偉業 284.636464248|wei ye;
为一__為一 169.703655326|wei yi;
位移__位移 324.83145542|wei yi;
为宜__為宜 376.756940916|wei yi;
惟一__惟一 1179.78648723|wei yi;
唯一__唯一 9999.23905763|wei yi;
未有__未有 392.573489614|wei you;
惟有__惟有 449.128812644|wei you;
为由__為由 701.651845929|wei you;
唯有__唯有 1024.81967123|wei you;
微雨__微雨 110.95347192|wei yu;
卫浴__衛浴 300.304800557|wei yu;
未予__未予 790.819158167|wei yu;
位于__位於 6480.79417092|wei yu;
未完__未完 132.10198647|wei wan;
委婉__委婉 330.960471347|wei wan;
为王__為王 184.02185602|wei wang;
威望__威望 406.513206136|wei wang;
慰问__慰問 1031.22508566|wei wen;
巍巍__巍巍 125.209594649|wei wei;
维维__維維 152.647228173|wei wei;
喂喂__喂喂 212.641966978|wei wei;
薇薇__薇薇 291.819695868|wei wei;
微微__微微 1751.317311|wei wei;
为我__為我 961.714332594|wei wo;
为伍__為伍 119.121315407|wei wu;
威武__威武 215.30841961|wei wu;
胃癌__胃癌 300.679263607|wei ai;
为爱__為愛 356.210827905|wei ai;
伟岸__偉岸 107.416157498|wei an;
未按__未按 154.947067523|wei an;
巍峨__巍峨 513.191745392|wei e;
味儿__味兒 258.271618599|wei er;
威尔__威爾 290.0070692|wei er;
维尔__維爾 303.313611771|wei er;
我吧__我吧 401.478808454|wo ba;
我爸__我爸 1318.16721196|wo ba;
我把__我把 3114.58889818|wo ba;
我帮__我幫 168.020228531|wo bang;
我本__我本 191.747236314|wo ben;
我辈__我輩 124.122120652|wo bei;
我部__我部 171.831677206|wo bu;
我不__我不 10187.9076561|wo bu;
我怕__我怕 1557.7283975|wo pa;
我拍__我拍 166.768626413|wo pai;
卧铺__卧鋪 373.484720623|wo pu;
我吗__我嗎 280.761336094|wo ma;
我妈__我媽 2970.53729039|wo ma;
我们__我們 322329.715051|wo men;
我没__我沒 3106.83597105|wo mei;
我发__我發 387.22887368|wo fa;
我方__我方 643.039196578|wo fang;
我打__我打 414.699880708|wo da;
我带__我帶 266.444503116|wo dai;
我党__我黨 144.863304286|wo dang;
我倒__我倒 1014.65366219|wo dao;
我得__我得 597.456727653|wo de;
我的__我的 41860.9865163|wo de;
我等__我等 161.451865638|wo deng;
我得__我得 389.163898974|wo dei;
卧底__卧底 386.264972075|wo di;
窝点__窩點 197.076837307|wo dian;
我顶__我頂 232.603161479|wo ding;
我都__我都 5525.27903603|wo dou;
我对__我對 2933.74914717|wo dui;
我听__我聽 770.392265767|wo ting;
沃土__沃土 114.607273411|wo tu;
我拿__我拿 279.365316864|wo na;
我那__我那 476.219822262|wo na;
窝囊__窩囊 242.670241844|wo nang;
我能__我能 1831.67389823|wo neng;
蜗牛__蝸牛 717.56844134|wo niu;
涡轮__渦輪 191.98633424|wo lun;
我来__我來 1915.71752783|wo lai;
我老__我老 142.713135632|wo lao;
我了__我了 523.526794166|wo le;
窝里__窩裡 264.789493468|wo li;
我俩__我倆 727.472474808|wo lia;
卧龙__卧龍 234.64107292|wo long;
我该__我該 290.730764849|wo gai;
我敢__我敢 230.008975843|wo gan;
我刚__我剛 983.530305889|wo gang;
我跟__我跟 1517.49220692|wo gen;
我更__我更 416.772181646|wo geng;
我国__我國 22844.6595771|wo guo;
我看__我看 4588.96700128|wo kan;
我可__我可 750.493000864|wo ke;
倭寇__倭寇 169.703655326|wo kou;
我还__我還 6313.39498259|wo hai;
我行__我行 202.050369328|wo hang;
我好__我好 553.723632203|wo hao;
我和__我和 3106.83597105|wo he;
我恨__我恨 260.534419685|wo hen;
我很__我很 3157.5771219|wo hen;
我军__我軍 533.404852483|wo jun;
我家__我家 4926.78395812|wo jia;
我见__我見 205.60633599|wo jian;
我叫__我叫 1100.26180506|wo jiao;
我讲__我講 254.121284766|wo jiang;
我将__我將 596.712660816|wo jiang;
握紧__握緊 175.073848088|wo jin;
我就__我就 15010.6397905|wo jiu;
我局__我局 550.970372621|wo ju;
我却__我卻 1321.45662101|wo que;
我区__我區 860.753904265|wo qu;
我去__我去 5369.16241395|wo qu;
斡旋__斡旋 110.95347192|wo xuan;
我县__我縣 837.47630896|wo xian;
我先__我先 1551.9157029|wo xian;
我笑__我笑 199.548108896|wo xiao;
我校__我校 1313.24844471|wo xiao;
我想__我想 15660.3012833|wo xiang;
我写__我寫 524.833224606|wo xie;
我心__我心 754.243296976|wo xin;
我找__我找 679.282440527|wo zhao;
握着__握着 601.191002133|wo zhe;
我这__我這 1831.67389823|wo zhe;
我真__我真 2143.08680935|wo zhen;
我正__我正 403.988165198|wo zheng;
我只__我只 1831.67389823|wo zhi;
握住__握住 581.299547476|wo zhu;
卧床__卧床 205.350275845|wo chuang;
我常__我常 119.26985293|wo chang;
我厂__我廠 183.792676978|wo chang;
龌龊__齷齪 476.813641365|wo chuo;
我上__我上 130.141230764|wo shang;
我省__我省 2705.48273369|wo sheng;
卧式__卧式 109.989815613|wo shi;
卧室__卧室 1290.5357804|wo shi;
我市__我市 4333.30827629|wo shi;
我是__我是 20858.2013348|wo shi;
握手__握手 816.861571886|wo shou;
我说__我說 7754.63736054|wo shuo;
我再__我再 1399.42059064|wo zai;
我在__我在 11172.0800441|wo zai;
我早__我早 261.83633885|wo zao;
我走__我走 277.630050085|wo zou;
我总__我總 639.84183651|wo zong;
我做__我做 892.429452826|wo zuo;
我最__我最 1308.34803192|wo zui;
我猜__我猜 676.747684543|wo cai;
我才__我才 1866.23446282|wo cai;
我曾__我曾 586.392500602|wo ceng;
我所__我所 1022.26865969|wo suo;
我愿__我願 305.209408115|wo yuan;
我院__我院 691.237408589|wo yuan;
我要__我要 10393.0795504|wo yao;
我也__我也 19500.7754269|wo ye;
我已__我已 624.870140032|wo yi;
我一__我一 846.921892564|wo yi;
握有__握有 116.044406778|wo you;
我又__我又 3225.18344283|wo you;
我有__我有 3364.76959766|wo you;
我用__我用 1934.91146801|wo yong;
我往__我往 105.0335283|wo wang;
我问__我問 1212.57856995|wo wen;
我为__我為 113.187937993|wo wei;
窝窝__窩窩 121.671800659|wo wo;
喔喔__喔喔 127.73116145|wo wo;
我啊__我啊 296.585723861|wo a;
我爱__我愛 2153.79604997|wo ai;
沃恩__沃恩 191.98633424|wo en;
沃尔__沃爾 157.477678279|wo er;
伍佰__伍佰 155.140277726|wu bai;
五百__五百 965.316430119|wu bai;
误报__誤報 138.680779525|wu bao;
五倍__五倍 111.091824605|wu bei;
舞弊__舞弊 162.460985719|wu bi;
五笔__五筆 573.385557088|wu bi;
务必__務必 995.863416846|wu bi;
无比__無比 2756.53058171|wu bi;
无边__無邊 542.792461517|wu bian;
舞步__舞步 228.8653107|wu bu;
无不__無不 849.035336524|wu bu;
无派__無派 145.587202159|wu pai;
误判__誤判 127.096048509|wu pan;
物品__物品 4652.30490767|wu pin;
巫婆__巫婆 254.438159592|wu po;
无码__無碼 342.285588041|wu ma;
五毛__五毛 136.282292017|wu mao;
无门__無門 186.794397067|wu men;
物美__物美 135.098649108|wu mei;
妩媚__嫵媚 631.917817783|wu mei;
无眠__無眠 141.121478992|wu mian;
屋面__屋面 186.794397067|wu mian;
诬蔑__誣衊 117.061109314|wu mie;
污蔑__污衊 232.603161479|wu mie;
五名__五名 187.4940348|wu ming;
无名__無名 799.738513132|wu ming;
吴某__吳某 118.381397999|wu mou;
无法__無法 25973.3891884|wu fa;
午饭__午飯 1508.06636321|wu fan;
无妨__無妨 256.987424161|wu fang;
五分__五分 174.638049069|wu fen;
无风__無風 129.817279349|wu feng;
无缝__無縫 386.746622582|wu feng;
无非__無非 1532.69625148|wu fei;
武断__武斷 160.049619219|wu duan;
无端__無端 349.178797604|wu duan;
武打__武打 195.60878915|wu da;
武大__武大 388.679238014|wu da;
五大__五大 1305.09125317|wu da;
五代__五代 186.097370046|wu dai;
武当__武當 274.533686805|wu dang;
误导__誤導 946.259922413|wu dao;
舞蹈__舞蹈 2038.87985164|wu dao;
伍德__伍德 132.762114633|wu de;
武帝__武帝 172.475272126|wu di;
无敌__無敵 2735.99686654|wu di;
污点__污點 143.426288875|wu dian;
五点__五點 597.456727653|wu dian;
屋顶__屋頂 850.094035423|wu ding;
舞动__舞動 350.92368248|wu dong;
无度__無度 107.416157498|wu du;
误读__誤讀 162.056583012|wu du;
无毒__無毒 245.71323808|wu du;
舞台__舞台 3398.48186759|wu tai;
无题__無題 116.044406778|wu ti;
物体__物體 1440.11088805|wu ti;
五天__五天 521.573243485|wu tian;
五条__五條 173.337150041|wu tiao;
舞厅__舞廳 227.727332161|wu ting;
无头__無頭 130.791560815|wu tou;
梧桐__梧桐 361.12732612|wu tong;
舞女__舞女 127.890434962|wu nv;
无奈__無奈 5450.05619202|wu nai;
无能__無能 672.544092675|wu neng;
屋内__屋內 389.649164279|wu nei;
污泥__污泥 247.557321202|wu ni;
五年__五年 2812.04370767|wu nian;
务农__務農 151.510141313|wu nong;
无论__無論 12205.6094005|wu lun;
无赖__無賴 569.114341748|wu lai;
误了__誤了 109.170488754|wu le;
无泪__無淚 132.266710153|wu lei;
五类__五類 144.502706249|wu lei;
雾里__霧裡 151.699065864|wu li;
无礼__無禮 170.977284899|wu li;
物力__物力 279.017397997|wu li;
无理__無理 340.583654043|wu li;
武力__武力 637.454253928|wu li;
屋里__屋裡 1474.61550226|wu li;
无力__無力 1861.58897661|wu li;
物理__物理 3318.96059201|wu li;
物料__物料 1226.25479235|wu liao;
无聊__無聊 11684.6943026|wu liao;
无良__無良 248.175085992|wu liang;
无量__無量 404.491915522|wu liang;
舞林__舞林 117.93965545|wu lin;
武林__武林 857.541983893|wu lin;
五六__五六 844.813709452|wu liu;
物流__物流 3161.51444144|wu liu;
五楼__五樓 242.066179876|wu lou;
乌龙__烏龍 218.008308584|wu long;
无路__無路 155.527421199|wu lu;
物管__物管 270.796100963|wu guan;
五官__五官 495.593922384|wu guan;
无关__無關 3849.50847217|wu guan;
无光__無光 112.34478795|wu guang;
吴刚__吳剛 121.066816454|wu gang;
武钢__武鋼 380.057830188|wu gang;
五个__五個 2140.41782974|wu ge;
污垢__污垢 480.991159713|wu gou;
无功__無功 120.164975734|wu gong;
蜈蚣__蜈蚣 190.793818607|wu gong;
务工__務工 212.907119447|wu gong;
武功__武功 999.59341964|wu gong;
无故__無故 431.033684153|wu gu;
无辜__無辜 1221.67899812|wu gu;
无果__無果 160.049619219|wu guo;
吴国__吳國 200.545272755|wu guo;
乌龟__烏龜 1017.18567095|wu gui;
五矿__五礦 118.676811842|wu kuang;
无可__無可 421.472799973|wu ke;
悟空__悟空 424.635962376|wu kong;
无愧__無愧 110.815291538|wu kui;
雾化__霧化 113.187937993|wu hua;
物化__物化 144.143005824|wu hua;
无话__無話 449.688850794|wu hua;
五环__五環 308.267359529|wu huan;
无害__無害 249.104624871|wu hai;
武汉__武漢 7725.70077647|wu han;
五号__五號 223.510077937|wu hao;
唔好__唔好 590.057620516|wu hao;
无痕__無痕 421.998352644|wu hen;
乌黑__烏黑 234.348853194|wu hei;
午后__午後 653.541376022|wu hou;
五湖__五湖 149.447435764|wu hu;
芜湖__蕪湖 453.628720089|wu hu;
污秽__污穢 143.784200776|wu hui;
无悔__無悔 277.630050085|wu hui;
舞会__舞會 282.516174301|wu hui;
误会__誤會 1988.69219664|wu hui;
无菌__無菌 206.119414554|wu jun;
无计__無計 117.646076559|wu ji;
五级__五級 178.377193209|wu ji;
无机__無機 220.19257551|wu ji;
无忌__無忌 347.875829952|wu ji;
无极__無極 419.377126323|wu ji;
五家__五家 162.86639759|wu jia;
无价__無價 170.977284899|wu jia;
物价__物價 1481.9843182|wu jia;
无间__無間 310.968189453|wu jian;
物件__物件 342.285588041|wu jian;
午觉__午覺 250.349428094|wu jiao;
吴江__吳江 213.971039752|wu jiang;
武将__武將 288.924902033|wu jiang;
无解__無解 105.164499152|wu jie;
五届__五屆 111.786180106|wu jie;
无界__無界 211.057972369|wu jie;
误解__誤解 1254.07172395|wu jie;
五金__五金 531.41444163|wu jin;
无尽__無盡 846.921892564|wu jin;
武警__武警 835.391638074|wu jing;
物权__物權 293.277951001|wu quan;
无权__無權 501.808489233|wu quan;
无期__無期 135.604660605|wu qi;
雾气__霧氣 254.438159592|wu qi;
屋企__屋企 777.141921285|wu qi;
武器__武器 6196.47800381|wu qi;
无铅__無鉛 138.163289429|wu qian;
无钱__無錢 226.030964922|wu qian;
五千__五千 835.391638074|wu qian;
无情__無情 1583.16937099|wu qing;
无穷__無窮 831.23785106|wu qiong;
务求__務求 109.716025699|wu qiu;
无趣__無趣 455.895552723|wu qu;
舞曲__舞曲 461.037428991|wu qu;
误区__誤區 863.977854874|wu qu;
武学__武學 147.596627936|wu xue;
唔系__唔系 974.988119996|wu xi;
无锡__無錫 2397.44169258|wu xi;
无瑕__無瑕 117.353228453|wu xia;
无暇__無暇 414.183417482|wu xia;
武侠__武俠 735.677366107|wu xia;
诬陷__誣陷 195.365179853|wu xian;
无限__無限 4349.53866663|wu xian;
无线__無線 4871.83632932|wu xian;
无效__無效 2202.653757|wu xiao;
五项__五項 335.110594827|wu xiang;
无邪__無邪 131.773154284|wu xie;
无心__無心 892.429452826|wu xin;
悟性__悟性 264.130371602|wu xing;
五星__五星 426.757915008|wu xing;
五行__五行 552.345286903|wu xing;
无形__無形 904.746955463|wu xing;
午休__午休 347.875829952|wu xiu;
无序__無序 344.85444872|wu xu;
无须__無須 1077.19810837|wu xu;
无需__無需 1795.51445179|wu xu;
武装__武裝 1635.30461749|wu zhuang;
五折__五折 118.676811842|wu zhe;
舞者__舞者 269.785619908|wu zhe;
捂着__捂着 415.216987933|wu zhe;
乌镇__烏鎮 211.584655172|wu zhen;
误诊__誤診 253.488718522|wu zhen;
物证__物證 123.967540162|wu zheng;
无证__無證 326.454673948|wu zheng;
五指__五指 156.499511818|wu zhi;
唔知__唔知 765.607004232|wu zhi;
无知__無知 1595.05109108|wu zhi;
物质__物質 5269.73156102|wu zhi;
梧州__梧州 155.72135507|wu zhou;
五洲__五洲 167.601987591|wu zhou;
五种__五種 474.442798491|wu zhong;
物种__物種 625.649317648|wu zhong;
无主__無主 106.483223576|wu zhu;
捂住__捂住 331.37316028|wu zhu;
无助__無助 867.213880777|wu zhu;
污浊__污濁 122.737806611|wu zhuo;
误差__誤差 1031.22508566|wu cha;
物产__物產 130.46599058|wu chan;
无常__無常 420.423657369|wu chang;
武昌__武昌 551.657401419|wu chang;
无偿__無償 626.429466854|wu chang;
无尘__無塵 155.140277726|wu chen;
五成__五成 166.768626413|wu cheng;
舞池__舞池 116.333988795|wu chi;
无耻__無恥 1718.88488289|wu chi;
悟出__悟出 143.0692679|wu chu;
无处__無處 643.841029976|wu chu;
无双__無雙 561.366244489|wu shuang;
误杀__誤殺 136.452228303|wu sha;
巫山__巫山 151.132997772|wu shan;
误伤__誤傷 106.616002115|wu shang;
无上__無上 135.435779871|wu shang;
无声__無聲 988.445115058|wu sheng;
巫师__巫師 362.028498203|wu shi;
无事__無事 475.034401746|wu shi;
武士__武士 574.81640715|wu shi;
务实__務實 808.758466182|wu shi;
无视__無視 1368.37963334|wu shi;
五十__五十 1392.46230328|wu shi;
巫术__巫術 131.773154284|wu shu;
武术__武術 866.133860988|wu shu;
无数__無數 4268.99009943|wu shu;
无水__無水 127.73116145|wu shui;
午睡__午睡 353.117055307|wu shui;
污水__污水 817.880151926|wu shui;
污染__污染 3616.97176403|wu ran;
勿扰__勿擾 186.32942291|wu rao;
五人__五人 287.846772995|wu ren;
无人__無人 2561.13118731|wu ren;
五日__五日 217.465635832|wu ri;
污辱__污辱 108.222318063|wu ru;
误入__誤入 137.819369268|wu ru;
侮辱__侮辱 1429.38333547|wu ru;
五脏__五臟 128.529517539|wu zang;
伍兹__伍茲 126.306596357|wu zi;
污渍__污漬 133.42554153|wu zi;
舞姿__舞姿 175.948711373|wu zi;
屋子__屋子 1349.75009317|wu zi;
物资__物資 1647.57761372|wu zi;
无踪__無蹤 115.611384758|wu zong;
无罪__無罪 672.544092675|wu zui;
五彩__五彩 282.868455943|wu cai;
午餐__午餐 1036.37823089|wu can;
五层__五層 149.820373083|wu ceng;
无此__無此 113.47039186|wu ci;
五次__五次 347.875829952|wu ci;
无从__無從 571.958268741|wu cong;
无损__無損 253.173026121|wu sun;
五色__五色 194.393772779|wu se;
物色__物色 275.905561849|wu se;
无色__無色 307.500011268|wu se;
五四__五四 292.54791482|wu si;
无私__無私 619.442999798|wu si;
武松__武松 246.019628549|wu song;
无所__無所 582.024395035|wu suo;
五岁__五歲 254.121284766|wu sui;
五元__五元 107.015331962|wu yuan;
婺源__婺源 180.389043185|wu yuan;
无缘__無緣 766.561672733|wu yuan;
吴越__吳越 119.41857567|wu yue;
五岳__五嶽 168.020228531|wu yue;
五月__五月 1443.7046004|wu yue;
乌云__烏雲 364.745529846|wu yun;
无涯__無涯 160.449013667|wu ya;
乌鸦__烏鴉 965.316430119|wu ya;
无烟__無煙 139.200207879|wu yan;
屋檐__屋檐 280.761336094|wu yan;
无言__無言 687.800394331|wu yan;
无业__無業 202.807148249|wu ye;
午夜__午夜 896.889021007|wu ye;
物业__物業 2364.80218582|wu ye;
武夷__武夷 124.587019602|wu yi;
无遗__無遺 133.925286409|wu yi;
武艺__武藝 185.172044961|wu yi;
无益__無益 199.548108896|wu yi;
吴仪__吳儀 211.057972369|wu yi;
无以__無以 226.595011951|wu yi;
无异__無異 446.339066527|wu yi;
无一__無一 826.074649543|wu yi;
无意__無意 1806.7369278|wu yi;
无疑__無疑 3854.30859085|wu yi;
五一__五一 4537.78699065|wu yi;
无垠__無垠 111.646962678|wu yin;
无影__無影 164.703307075|wu ying;
无忧__無憂 582.024395035|wu you;
无用__無用 569.114341748|wu yong;
物欲__物慾 110.401782066|wu yu;
无欲__無欲 116.044406778|wu yu;
物语__物語 362.931919108|wu yu;
无语__無語 2593.24683736|wu yu;
屋外__屋外 197.322580943|wu wai;
五万__五萬 269.114061535|wu wan;
吴王__吳王 110.401782066|wu wang;
无望__無望 354.881620091|wu wang;
五味__五味 151.132997772|wu wei;
无味__無味 232.893204426|wu wei;
无为__無為 284.281980745|wu wei;
五位__五位 325.642053285|wu wei;
无谓__無謂 362.028498203|wu wei;
无畏__無畏 383.865702254|wu wei;
无误__無誤 536.070335228|wu wu;
呜呜__嗚嗚 1150.74567978|wu wu;
无碍__無礙 122.737806611|wu ai;
午安__午安 107.684208225|wu an;
阿坝__阿壩 123.658956482|a ba;
阿宝__阿寶 258.916120291|a bao;
阿扁__阿扁 276.938965124|a bian;
阿布__阿布 593.006203378|a bu;
阿婆__阿婆 251.914183226|a po;
阿妈__阿媽 190.318888971|a ma;
阿曼__阿曼 495.593922384|a man;
阿毛__阿毛 113.753550575|a mao;
阿门__阿門 339.735863102|a men;
阿梅__阿梅 125.992190229|a mei;
阿妹__阿妹 190.318888971|a mei;
阿米__阿米 145.405889264|a mi;
阿弥__阿彌 644.643863216|a mi;
阿明__阿明 115.036534536|a ming;
阿木__阿木 118.676811842|a mu;
阿飞__阿飛 258.593668656|a fei;
阿福__阿福 115.611384758|a fu;
阿达__阿達 119.716577729|a da;
阿呆__阿獃 259.885889675|a dai;
阿德__阿德 390.135034682|a de;
阿迪__阿迪 176.387781073|a di;
阿斗__阿斗 116.333988795|a dou;
阿杜__阿杜 195.852702213|a du;
阿朵__阿朵 106.218162376|a duo;
阿土__阿土 151.321452046|a tu;
阿尼__阿尼 112.625137786|a ni;
阿诺__阿諾 109.852835359|a nuo;
阿伦__阿倫 166.97657743|a lun;
阿拉__阿拉 730.197220308|a la;
阿兰__阿蘭 173.769702743|a lan;
阿里__阿里 1664.08500884|a li;
阿联__阿聯 236.402059204|a lian;
阿龙__阿龍 106.882056102|a long;
阿甘__阿甘 237.287502254|a gan;
阿哥__阿哥 452.499534015|a ge;
阿卡__阿卡 135.604660605|a ka;
阿华__阿華 107.015331962|a hua;
啊哈__啊哈 455.327784806|a ha;
阿含__阿含 184.941433485|a han;
阿娇__阿嬌 441.361118731|a jiao;
阿姐__阿姐 128.049907079|a jie;
阿强__阿強 146.132498493|a qiang;
阿信__阿信 159.253810404|a xin;
阿朱__阿朱 112.765574943|a zhu;
阿紫__阿紫 177.933171406|a zi;
阿三__阿三 237.879639313|a san;
阿斯__阿斯 409.054029297|a si;
阿雅__阿雅 176.827946446|a ya;
啊呀__啊呀 228.295612376|a ya;
阿姨__阿姨 3064.53855293|a yi;
啊哟__啊喲 128.209578049|a yo;
阿文__阿文 121.975425508|a wen;
啊啊__啊啊 801.734213733|a a;
阿尔__阿爾 477.408200926|a er;
挨骂__挨罵 267.44247003|ai ma;
爱美__愛美 393.063006485|ai mei;
暧昧__曖昧 1532.69625148|ai mei;
爱民__愛民 175.073848088|ai min;
爱慕__愛慕 355.767206381|ai mu;
爱抚__愛撫 259.562230298|ai fu;
挨打__挨打 407.020105042|ai da;
爱戴__愛戴 271.133768339|ai dai;
爱到__愛到 169.703655326|ai dao;
哀悼__哀悼 328.495108513|ai dao;
爱得__愛得 327.677408739|ai de;
爱的__愛的 1749.13623734|ai de;
爱她__愛她 761.800204777|ai ta;
爱他__愛他 771.352901218|ai ta;
哀叹__哀嘆 120.015323434|ai tan;
爱听__愛聽 257.94996962|ai ting;
爱你__愛你 3976.27638265|ai ni;
艾伦__艾倫 152.647228173|ai lun;
挨了__挨了 202.302314677|ai le;
爱怜__愛憐 117.93965545|ai lian;
爱恋__愛戀 392.084582382|ai lian;
挨个__挨個 246.94109417|ai ge;
爱过__愛過 539.420927296|ai guo;
爱国__愛國 1757.8768636|ai guo;
爱卡__愛卡 130.46599058|ai ka;
爱看__愛看 365.20034683|ai kan;
爱华__愛華 110.401782066|ai hua;
哀嚎__哀嚎 143.0692679|ai hao;
爱好__愛好 2473.3076131|ai hao;
爱恨__愛恨 218.280152578|ai hen;
爱护__愛護 796.754272909|ai hu;
埃及__埃及 1055.93292173|ai ji;
爱家__愛家 116.18910757|ai jia;
爱犬__愛犬 105.558392399|ai quan;
爱妻__愛妻 137.991222203|ai qi;
爱情__愛情 14477.8579016|ai qing;
哀求__哀求 286.058823982|ai qiu;
爱惜__愛惜 338.046607007|ai xi;
爱笑__愛笑 117.93965545|ai xiao;
矮小__矮小 195.121873946|ai xiao;
爱心__愛心 2430.53169682|ai xin;
挨着__挨着 278.322859608|ai zhe;
爱着__愛着 662.561694208|ai zhe;
癌症__癌症 1147.88120947|ai zheng;
爱之__愛之 140.419785869|ai zhi;
爱车__愛車 355.324137339|ai che;
爱城__愛城 185.172044961|ai cheng;
爱吃__愛吃 934.541117987|ai chi;
哀愁__哀愁 139.026849285|ai chou;
哀伤__哀傷 361.12732612|ai shang;
爱上__愛上 2812.04370767|ai shang;
爱神__愛神 112.204874836|ai shen;
爱是__愛是 543.469292924|ai shi;
矮人__矮人 316.046952528|ai ren;
爱人__愛人 2205.40034128|ai ren;
艾瑞__艾瑞 150.756793028|ai rui;
爱在__愛在 150.756793028|ai zai;
爱子__愛子 107.015331962|ai zi;
艾滋__艾滋 258.271618599|ai zi;
矮子__矮子 289.645897197|ai zi;
爱死__愛死 165.939408926|ai si;
哀怨__哀怨 227.443722742|ai yuan;
哎呀__哎呀 3079.85238931|ai ya;
爱意__愛意 398.48814637|ai yi;
哎哟__哎喲 506.83620443|ai yo;
哎呦__哎呦 189.372573382|ai you;
碍于__礙於 178.377193209|ai yu;
爱与__愛與 278.322859608|ai yu;
爱玩__愛玩 182.196395498|ai wan;
爱我__愛我 1218.6379585|ai wo;
唉唉__唉唉 136.622376491|ai ai;
皑皑__皚皚 137.819369268|ai ai;
爱爱__愛愛 263.472890441|ai ai;
挨饿__挨餓 123.813152185|ai e;
艾尔__艾爾 131.117943492|ai er;
埃尔__埃爾 229.436430673|ai er;
安保__安保 265.119670945|an bao;
安倍__安倍 264.130371602|an bei;
岸边__岸邊 466.237298568|an bian;
安排__安排 17388.4625406|an pai;
俺们__俺們 1368.37963334|an men;
按摩__按摩 2847.30570911|an mo;
暗牧__暗牧 387.711726118|an mu;
案发__案發 354.43965395|an fa;
暗访__暗訪 220.742053181|an fang;
安放__安放 227.160466527|an fang;
安防__安防 309.4219738|an fang;
安分__安分 198.803491145|an fen;
安抚__安撫 517.687984062|an fu;
安顿__安頓 268.778909483|an dun;
安达__安達 108.087539034|an da;
暗淡__暗淡 278.669912425|an dan;
黯淡__黯淡 295.111021611|an dan;
安德__安德 113.753550575|an de;
安得__安得 149.447435764|an de;
暗地__暗地 119.56748386|an di;
安迪__安迪 187.26053154|an di;
安定__安定 1293.75623683|an ding;
安泰__安泰 142.891090816|an tai;
安娜__安娜 381.957020988|an na;
安南__安南 263.144763849|an nan;
安妮__安妮 385.78392141|an ni;
安宁__安寧 647.865219539|an ning;
按钮__按鈕 4056.35368459|an niu;
安乐__安樂 205.350275845|an le;
按理__按理 142.713135632|an li;
安利__安利 849.035336524|an li;
案例__案例 2966.83781195|an li;
暗恋__暗戀 829.168709129|an lian;
暗流__暗流 114.46454262|an liu;
安陆__安陸 146.679837233|an lu;
鞍钢__鞍鋼 257.94996962|an gang;
安格__安格 221.017305999|an ge;
安康__安康 341.008342538|an kang;
安好__安好 136.792736844|an hao;
暗号__暗號 190.318888971|an hao;
暗黑__暗黑 530.752623218|an hei;
安徽__安徽 2777.21840284|an hui;
案卷__案卷 161.451865638|an juan;
氨基__氨基 174.42055653|an ji;
安吉__安吉 225.187525865|an ji;
俺家__俺家 302.558594526|an jia;
安家__安家 309.036622663|an jia;
安监__安監 204.839111844|an jian;
安检__安檢 268.109857044|an jian;
按键__按鍵 1742.60930056|an jian;
案件__案件 5101.72692692|an jian;
按揭__按揭 634.284663664|an jie;
安静__安靜 3689.81311413|an jing;
安居__安居 179.71591787|an ju;
安全__安全 20599.8862817|an quan;
暗器__暗器 154.368879448|an qi;
安琪__安琪 155.72135507|an qi;
按其__按其 170.551683166|an qi;
按期__按期 279.017397997|an qi;
安庆__安慶 332.200082586|an qing;
案情__案情 360.228397261|an qing;
安溪__安溪 116.915322539|an xi;
安息__安息 230.295783987|an xi;
按下__按下 851.15405446|an xia;
岸线__岸線 112.065135969|an xian;
暗香__暗香 146.314717429|an xiang;
安详__安詳 290.730764849|an xiang;
安信__安信 177.269210225|an xin;
安心__安心 1723.1742594|an xin;
按需__按需 144.863304286|an xu;
安装__安裝 19379.6471203|an zhuang;
按照__按照 19307.3315803|an zhao;
按着__按着 294.743493195|an zhe;
安贞__安貞 109.442917312|an zhen;
安置__安置 1397.67776576|an zhi;
案中__案中 137.819369268|an zhong;
暗中__暗中 510.004074866|an zhong;
按住__按住 547.548041623|an zhu;
暗疮__暗瘡 113.753550575|an chuang;
鹌鹑__鵪鶉 113.611883002|an chun;
暗处__暗處 156.304608838|an chu;
安顺__安順 120.314814642|an shun;
暗杀__暗殺 368.399985048|an sha;
鞍山__鞍山 363.384474622|an shan;
岸上__岸上 243.275811214|an shang;
安神__安神 138.508067822|an shen;
安生__安生 132.266710153|an sheng;
按时__按時 1431.1656954|an shi;
暗示__暗示 1655.81074036|an shi;
按说__按說 188.665925845|an shuo;
黯然__黯然 359.331706043|an ran;
安然__安然 438.073368704|an ran;
安在__安在 123.044091616|an zai;
安葬__安葬 164.088713397|an zang;
暗自__暗自 461.037428991|an zi;
案子__案子 966.520124945|an zi;
暗藏__暗藏 243.275811214|an cang;
按此__按此 170.977284899|an ci;
暗算__暗算 153.218967809|an suan;
按原__按原 120.015323434|an yuan;
按月__按月 277.976239008|an yue;
按压__按壓 191.269933402|an ya;
安阳__安陽 273.509258874|an yang;
暗夜__暗夜 469.151414294|an ye;
安逸__安逸 1282.5196677|an yi;
暗影__暗影 689.516759915|an ying;
安稳__安穩 466.818670029|an wen;
安危__安危 203.566761683|an wei;
安慰__安慰 3419.72334588|an wei;
暗暗__暗暗 701.651845929|an an;
安安__安安 731.107734818|an an;
昂达__昂達 257.3078729|ang da;
昂贵__昂貴 1036.37823089|ang gui;
盎然__盎然 144.143005824|ang ran;
肮脏__骯髒 572.671468255|ang zang;
盎司__盎司 171.831677206|ang si;
昂扬__昂揚 126.464093517|ang yang;
奥巴__奧巴 475.034401746|ao ba;
傲慢__傲慢 387.711726118|ao man;
澳门__澳門 1978.80389582|ao men;
奥美__奧美 157.477678279|ao mei;
奥秘__奧秘 326.048110451|ao mi;
奥妙__奧妙 210.532600599|ao miao;
熬到__熬到 178.155043976|ao dao;
奥迪__奧迪 829.168709129|ao di;
敖东__敖東 115.899886195|ao dong;
奥特__奧特 124.587019602|ao te;
凹凸__凹凸 357.99085261|ao tu;
奥拓__奧拓 122.279808036|ao tuo;
懊恼__懊惱 238.770616634|ao nao;
奥拉__奧拉 108.357265155|ao la;
奥格__奧格 125.992190229|ao ge;
熬过__熬過 187.961915178|ao guo;
懊悔__懊悔 162.460985719|ao hui;
傲气__傲氣 157.2815571|ao qi;
凹陷__凹陷 249.104624871|ao xian;
翱翔__翱翔 266.112675706|ao xiang;
澳洲__澳洲 1775.48936799|ao zhou;
奥山__奧山 289.285174995|ao shan;
傲视__傲視 108.763116896|ao shi;
奥数__奧數 105.821807183|ao shu;
奥术__奧術 144.863304286|ao shu;
澳元__澳元 293.277951001|ao yuan;
奥运__奧運 5664.71780817|ao yun;
熬夜__熬夜 955.740681497|ao ye;
遨游__遨遊 258.271618599|ao you;
傲游__傲游 355.767206381|ao you;
澳网__澳網 118.972962872|ao wang;
嗷嗷__嗷嗷 415.216987933|ao ao;
奥尔__奧爾 131.445140637|ao er;
恶霸__惡霸 210.795122809|e ba;
恶报__惡報 352.238065853|e bao;
恶补__惡補 149.261315371|e bu;
恶梦__惡夢 326.454673948|e meng;
噩梦__噩夢 780.052703516|e meng;
峨嵋__峨嵋 386.746622582|e mei;
恶魔__惡魔 1918.1063189|e mo;
俄方__俄方 143.784200776|e fang;
饿得__餓得 132.431639237|e de;
额定__額定 210.008536601|e ding;
恶毒__惡毒 650.291796355|e du;
额度__額度 1420.50477658|e du;
额头__額頭 887.99205879|e tou;
婀娜__婀娜 111.786180106|e nuo;
恶狼__惡狼 179.940013424|e lang;
恶劣__惡劣 2926.44637172|e lie;
恶灵__惡靈 106.218162376|e ling;
恶搞__惡搞 1005.84116282|e gao;
恶果__惡果 195.121873946|e guo;
俄国__俄國 774.242000696|e guo;
恶化__惡化 1236.99840673|e hua;
噩耗__噩耗 195.852702213|e hao;
俄军__俄軍 130.303509496|e jun;
恶习__惡習 195.852702213|e xi;
恶心__噁心 5089.02755683|e xin;
恶行__惡行 135.604660605|e xing;
恶性__惡性 718.463208478|e xing;
饿着__餓着 192.465424888|e zhe;
遏止__遏止 138.163289429|e zhi;
遏制__遏制 999.59341964|e zhi;
恶臭__惡臭 145.405889264|e chou;
扼杀__扼殺 354.43965395|e sha;
愕然__愕然 169.070402749|e ran;
恶人__惡人 406.513206136|e ren;
饿死__餓死 924.118331259|e si;
恶俗__惡俗 199.796934068|e su;
厄运__厄運 507.468200425|e yun;
恶意__惡意 2186.24593438|e yi;
俄语__俄語 325.642053285|e yu;
鳄鱼__鱷魚 566.990680223|e yu;
额外__額外 1449.11199071|e wai;
俄文__俄文 107.015331962|e wen;
哦哦__哦哦 160.049619219|e e;
恩典__恩典 135.94305409|en dian;
恩纳__恩納 324.426913464|en na;
恩惠__恩惠 149.261315371|en hui;
恩情__恩情 114.321989585|en qing;
恩仇__恩仇 110.264288753|en chou;
恩施__恩施 132.10198647|en shi;
恩师__恩師 193.427195796|en shi;
恩人__恩人 114.46454262|en ren;
恩赐__恩賜 188.430963124|en ci;
恩怨__恩怨 370.240920313|en yuan;
嗯啊__嗯啊 191.269933402|en a;
恩爱__恩愛 344.424970321|en ai;
恩恩__恩恩 1065.18429118|en en;
嗯嗯__嗯嗯 1993.6548615|en en;
而把__而把 105.164499152|er ba;
二八__二八 165.526347625|er ba;
二百__二百 703.402776999|er bai;
二班__二班 116.624293448|er ban;
二本__二本 173.121277629|er ben;
而被__而被 791.805264794|er bei;
耳边__耳邊 1067.84239617|er bian;
二部__二部 143.784200776|er bu;
而不__而不 2756.53058171|er bu;
耳畔__耳畔 123.351140937|er pan;
耳麦__耳麥 320.010065926|er mai;
耳鸣__耳鳴 197.322580943|er ming;
耳目__耳目 117.499561272|er mu;
二分__二分 107.282382453|er fen;
而非__而非 1197.56158489|er fei;
二代__二代 383.387639617|er dai;
而当__而當 454.194369369|er dang;
尔德__爾德 116.624293448|er de;
二等__二等 179.940013424|er deng;
尔迪__爾迪 130.954650472|er di;
耳钉__耳釘 112.484875527|er ding;
而定__而定 667.534233933|er ding;
而动__而動 145.587202159|er dong;
二度__二度 139.547573842|er du;
耳朵__耳朵 2526.26316155|er duo;
二队__二隊 127.890434962|er dui;
而对__而對 502.434215952|er dui;
而她__而她 344.424970321|er ta;
而他__而他 618.67155147|er ta;
二天__二天 219.097720093|er tian;
儿童__兒童 5089.02755683|er tong;
而退__而退 145.405889264|er tui;
儿女__兒女 1173.92027842|er nv;
二奶__二奶 607.9716117|er nai;
而你__而你 330.136634719|er ni;
二年__二年 835.391638074|er nian;
而论__而論 165.526347625|er lun;
二来__二來 361.12732612|er lai;
而来__而來 1949.43302008|er lai;
二老__二老 119.26985293|er lao;
二类__二類 179.045304336|er lei;
而立__而立 208.184564378|er li;
二两__二兩 186.32942291|er liang;
二流__二流 233.183609039|er liu;
二楼__二樓 1233.91923358|er lou;
耳聋__耳聾 119.121315407|er long;
二路__二路 138.335571213|er lu;
耳光__耳光 681.82669043|er guang;
儿歌__兒歌 268.109857044|er ge;
二哥__二哥 478.003501869|er ge;
二个__二個 699.033618062|er ge;
而过__而過 577.688827991|er guo;
而归__而歸 268.778909483|er gui;
儿科__兒科 218.824857909|er ke;
二环__二環 195.121873946|er huan;
耳环__耳環 465.076726846|er huan;
二号__二號 533.404852483|er hao;
而后__而後 842.710774091|er hou;
二胡__二胡 250.661599628|er hu;
二级__二級 1822.5663337|er ji;
耳机__耳機 3153.64470585|er ji;
而建__而建 137.134095104|er jian;
二姐__二姐 278.669912425|er jie;
而今__而今 352.677286738|er jin;
而其__而其 298.439468992|er qi;
而起__而起 413.667597456|er qi;
二期__二期 1387.2663024|er qi;
二千__二千 343.567617462|er qian;
而且__而且 56949.0725747|er qie;
二区__二區 189.372573382|er qu;
而去__而去 1364.97342214|er qu;
儿戏__兒戲 161.854759309|er xi;
儿媳__兒媳 267.775955618|er xi;
而下__而下 444.673543393|er xia;
二线__二線 553.034030141|er xian;
而行__而行 431.033684153|er xing;
而战__而戰 177.490254874|er zhan;
二战__二戰 827.104717768|er zhan;
而这__而這 911.537100768|er zhe;
二者__二者 1107.13875428|er zhe;
而致__而致 125.992190229|er zhi;
而至__而至 364.291279287|er zhi;
二种__二種 134.092283643|er zhong;
二中__二中 341.433560596|er zhong;
而成__而成 1689.15672637|er cheng;
而出__而出 699.905273328|er chu;
而上__而上 257.62872122|er shang;
二审__二審 330.960471347|er shen;
而生__而生 442.462509543|er sheng;
二世__二世 294.743493195|er shi;
而使__而使 393.553133755|er shi;
儿时__兒時 462.187920882|er shi;
二十__二十 3233.23169914|er shi;
二是__二是 5650.61702447|er shi;
而是__而是 13368.0266678|er shi;
二手__二手 1918.1063189|er shou;
耳熟__耳熟 106.350610398|er shu;
二叔__二叔 129.171793682|er shu;
二人__二人 2224.72256613|er ren;
二日__二日 108.898738333|er ri;
而入__而入 194.636170786|er ru;
而在__而在 2739.40849942|er zai;
二字__二字 568.405572245|er zi;
儿子__兒子 11787.0676841|er zi;
而作__而作 110.677283245|er zuo;
而坐__而坐 115.467403456|er zuo;
二层__二層 488.846754671|er ceng;
二次__二次 1659.94271905|er ci;
而从__而從 262.817045902|er cong;
儿孙__兒孫 105.0335283|er sun;
耳塞__耳塞 398.48814637|er sai;
二三__二三 458.173712968|er san;
尔森__爾森 139.72158175|er sen;
尔斯__爾斯 139.547573842|er si;
而死__而死 521.573243485|er si;
二院__二院 122.432284019|er yuan;
二元__二元 397.001179899|er yuan;
二月__二月 573.385557088|er yue;
而言__而言 6368.70867559|er yan;
而要__而要 131.445140637|er yao;
二要__二要 213.172602547|er yao;
二爷__二爺 142.535402072|er ye;
而异__而異 140.070248771|er yi;
而以__而以 167.810977762|er yi;
而已__而已 14806.280335|er yi;
而应__而應 131.773154284|er ying;
而有__而有 288.205701591|er you;
而又__而又 2036.34065037|er you;
耳语__耳語 116.044406778|er yu;
而外__而外 174.203334854|er wai;
而亡__而亡 134.594525802|er wang;
耳闻__耳聞 163.680258901|er wen;
而为__而為 154.754097942|er wei;
而未__而未 227.727332161|er wei;
二维__二維 357.545014261|er wei;
二位__二位 464.497524783|er wei;
而我__而我 1209.56018338|er wo;
而无__而無 291.456266438|er wu;
哦哟__哦喲 391.108593802|o yo;
噢噢__噢噢 525.487661863|o o;
哦哦__哦哦 1169.53977147|o o;
欧版__歐版 212.112652282|ou ban;
偶们__偶們 1100.26180506|ou men;
欧盟__歐盟 2457.94475925|ou meng;
欧美__歐美 2379.58287209|ou mei;
殴打__毆打 603.442760838|ou da;
偶滴__偶滴 158.264611567|ou di;
呕吐__嘔吐 756.125466931|ou tu;
欧陆__歐陸 118.676811842|ou lu;
欧冠__歐冠 467.400766428|ou guan;
讴歌__謳歌 126.779677253|ou ge;
耦合__耦合 360.677581637|ou he;
偶家__偶家 183.563783354|ou jia;
偶像__偶像 2665.32595143|ou xiang;
欧洲__歐洲 7803.10604967|ou zhou;
欧式__歐式 324.426913464|ou shi;
偶数__偶數 131.773154284|ou shu;
偶然__偶然 2153.79604997|ou ran;
欧元__歐元 1651.68904712|ou yuan;
欧亚__歐亞 223.231720645|ou ya;
欧阳__歐陽 1126.6237397|ou yang;
偶有__偶有 202.302314677|ou you;
偶遇__偶遇 292.183578474|ou yu;
欧文__歐文 305.209408115|ou wen;
偶尔__偶爾 4939.07845882|ou er;
巴比伦__巴比倫 125.36572391|ba bi lun;
巴不得__巴不得 244.186999878|ba bu de;
巴菲特__巴菲特 615.595353746|ba fei te;
八达岭__八達嶺 128.850255419|ba da ling;
巴蒂尔__巴蒂爾 171.617679695|ba di er;
八点半__八點半 147.412812521|ba dian ban;
巴拿马__巴拿馬 173.553291634|ba na ma;
巴拉克__巴拉克 230.582949765|ba la ke;
芭蕾舞__芭蕾舞 143.0692679|ba lei wu;
巴厘岛__巴厘島 196.341441156|ba li dao;
八路军__八路軍 307.500011268|ba lu jun;
巴格达__巴格達 378.63963681|ba ge da;
八个月__八個月 137.991222203|ba ge yue;
巴西队__巴西隊 284.991389772|ba xi dui;
巴西人__巴西人 150.007190589|ba xi ren;
八小时__八小時 111.091824605|ba xiao shi;
巴斯滕__巴斯滕 108.357265155|ba si teng;
八月份__八月份 168.649547684|ba yue fen;
把衣服__把衣服 171.831677206|ba yi fu;
八一队__八一隊 141.826678552|ba yi dui;
把握好__把握好 340.583654043|ba wo hao;
把握住__把握住 304.449671797|ba wo zhu;
百八十__百八十 192.705418355|bai ba shi;
白白的__白白的 161.049974862|bai bai de;
百宝箱__百寶箱 122.432284019|bai bao xiang;
白皮书__白皮書 250.349428094|bai pi shu;
白平衡__白平衡 166.146325956|bai ping heng;
百分百__百分百 384.344361008|bai fen bai;
百分比__百分比 518.979844093|bai fen bi;
百分点__百分點 964.114234362|bai fen dian;
百分之__百分之 475.626742696|bai fen zhi;
白癜风__白癜風 105.426930997|bai dian feng;
拜托了__拜託了 140.419785869|bai tuo le;
百脑汇__百腦匯 189.845141544|bai nao hui;
白内障__白內障 216.384339476|bai nei zhang;
百年来__百年來 110.264288753|bai nian lai;
白兰地__白蘭地 107.282382453|bai lan di;
百老汇__百老匯 164.908682755|bai lao hui;
白萝卜__白蘿蔔 124.89791921|bai luo bo;
百公里__百公里 217.465635832|bai gong li;
白开水__白開水 326.454673948|bai kai shui;
白花花__白花花 140.945727665|bai hua hua;
百合花__百合花 133.259374649|bai he hua;
白居易__白居易 191.269933402|bai ju yi;
白血病__白血病 518.979844093|bai xue bing;
白细胞__白細胞 269.114061535|bai xi bao;
白小姐__白小姐 105.164499152|bai xiao jie;
白热化__白熱化 192.465424888|bai re hua;
白日梦__白日夢 182.651055928|bai ri meng;
百思买__百思買 107.416157498|bai si mai;
白云区__白雲區 178.59961945|bai yun qu;
白云山__白雲山 170.977284899|bai yun shan;
白岩松__白岩松 108.357265155|bai yan song;
白羊座__白羊座 216.924313917|bai yang zuo;
百万元__百萬元 219.37092252|bai wan yuan;
百安居__百安居 241.463621556|bai an ju;
版本号__版本號 232.893204426|ban ben hao;
半辈子__半輩子 134.762357541|ban bei zi;
半边天__半邊天 110.815291538|ban bian tian;
半导体__半導體 747.692521253|ban dao ti;
半年报__半年報 157.477678279|ban nian bao;
班干部__班幹部 121.671800659|ban gan bu;
半个月__半個月 1493.10664229|ban ge yue;
办公厅__辦公廳 469.151414294|ban gong ting;
办公楼__辦公樓 743.048258297|ban gong lou;
办公会__辦公會 108.898738333|ban gong hui;
办公区__辦公區 123.813152185|ban gong qu;
办公桌__辦公桌 417.291872914|ban gong zhuo;
办公室__辦公室 11368.7020266|ban gong shi;
办公司__辦公司 148.519148841|ban gong si;
半决赛__半決賽 532.077085292|ban jue sai;
颁奖礼__頒獎禮 256.987424161|ban jiang li;
版权归__版權歸 246.94109417|ban quan gui;
版下载__版下載 129.979154132|ban xia zai;
班主任__班主任 1502.43898348|ban zhu ren;
半成品__半成品 264.130371602|ban cheng pin;
半山腰__半山腰 116.915322539|ban shan yao;
办事处__辦事處 1623.12304424|ban shi chu;
办实事__辦實事 175.073848088|ban shi shi;
办手续__辦手續 121.217779906|ban shou xu;
半自动__半自動 109.989815613|ban zi dong;
搬运工__搬運工 107.818484324|ban yun gong;
扮演者__扮演者 215.845709156|ban yan zhe;
帮帮忙__幫幫忙 620.215410078|bang bang mang;
棒棒糖__棒棒糖 242.36802267|bang bang tang;
薄薄的__薄薄的 254.121284766|bao bao de;
宝贝儿__寶貝兒 459.317058623|bao bei er;
宝马车__寶馬車 110.677283245|bao ma che;
爆米花__爆米花 204.839111844|bao mi hua;
报名表__報名表 236.402059204|bao ming biao;
报名费__報名費 158.067510349|bao ming fei;
报名点__報名點 114.321989585|bao ming dian;
报名者__報名者 121.823518492|bao ming zhe;
爆发力__爆發力 258.916120291|bao fa li;
暴发户__暴發戶 233.474375771|bao fa hu;
暴风雪__暴風雪 202.554574186|bao feng xue;
暴风雨__暴風雨 279.713669565|bao feng yu;
保定市__保定市 118.972962872|bao ding shi;
包头市__包頭市 111.230349808|bao tou shi;
保龄球__保齡球 159.85029497|bao ling qiu;
暴露出__暴露出 342.285588041|bao lu chu;
报关单__報關單 157.67404401|bao guan dan;
报关员__報關員 151.321452046|bao guan yuan;
报告会__報告會 277.284292303|bao gao hui;
报告书__報告書 223.231720645|bao gao shu;
包工头__包工頭 200.29551561|bao gong tou;
饱和度__飽和度 148.519148841|bao he du;
保护膜__保護膜 167.601987591|bao hu mo;
保护费__保護費 153.601316766|bao hu fei;
保护好__保護好 273.509258874|bao hu hao;
保护区__保護區 388.195180646|bao hu qu;
保护性__保護性 163.680258901|bao hu xing;
保护伞__保護傘 144.322743975|bao hu san;
报价单__報價單 292.912705474|bao jia dan;
保健品__保健品 648.673070715|bao jian pin;
保监会__保監會 253.488718522|bao jian hui;
保荐人__保薦人 137.305093541|bao jian ren;
包饺子__包餃子 109.852835359|bao jiao zi;
报警器__報警器 132.596773978|bao jing qi;
保鲜膜__保鮮膜 127.096048509|bao xian mo;
保险费__保險費 289.645897197|bao xian fei;
保险杠__保險杠 134.42690308|bao xian gang;
保险柜__保險柜 135.604660605|bao xian gui;
保险金__保險金 157.085680168|bao xian jin;
保险箱__保險箱 158.461958559|bao xian xiang;
保险人__保險人 118.08671951|bao xian ren;
保险丝__保險絲 125.992190229|bao xian si;
保险业__保險業 344.424970321|bao xian ye;
保修卡__保修卡 137.991222203|bao xiu ka;
保修期__保修期 242.670241844|bao xiu qi;
包装袋__包裝袋 138.85370659|bao zhuang dai;
包装盒__包裝盒 262.817045902|bao zhuang he;
包装机__包裝機 132.762114633|bao zhuang ji;
爆炸性__爆炸性 126.464093517|bao zha xing;
爆炸案__爆炸案 136.963309627|bao zha an;
保障性__保障性 117.499561272|bao zhang xing;
抱着你__抱着你 134.259489114|bao zhe ni;
保证金__保證金 1010.8674618|bao zheng jin;
保证其__保證其 233.765505073|bao zheng qi;
保证书__保證書 108.222318063|bao zheng shu;
保质期__保質期 277.976239008|bao zhi qi;
保时捷__保時捷 340.583654043|bao shi jie;
保守派__保守派 106.616002115|bao shou pai;
保税区__保稅區 276.938965124|bao shui qu;
保养品__保養品 230.870473623|bao yang pin;
保有量__保有量 127.254530072|bao you liang;
保卫战__保衛戰 135.604660605|bao wei zhan;
鲍威尔__鮑威爾 125.835280772|bao wei er;
宝安区__寶安區 168.859844103|bao an qu;
包二奶__包二奶 126.621787068|bao er nai;
本办法__本辦法 496.21189989|ben ban fa;
本报讯__本報訊 958.125676369|ben bao xun;
本部门__本部門 253.173026121|ben bu men;
本命年__本命年 255.073095111|ben ming nian;
本单位__本單位 546.866130582|ben dan wei;
本地化__本地化 389.163898974|ben di hua;
本地区__本地區 441.911471008|ben di qu;
本地人__本地人 410.586139672|ben di ren;
本地网__本地網 127.413209251|ben di wang;
本条例__本條例 277.284292303|ben tiao li;
本土化__本土化 335.110594827|ben tu hua;
本年度__本年度 413.152419826|ben nian du;
本论坛__本論壇 795.762002835|ben lun tan;
本栏目__本欄目 105.0335283|ben lan mu;
本公司__本公司 2464.07841638|ben gong si;
本规定__本規定 256.347723437|ben gui ding;
本科生__本科生 860.753904265|ben ke sheng;
本合同__本合同 204.329220247|ben he tong;
本基金__本基金 240.862563142|ben ji jin;
本企业__本企業 187.26053154|ben qi ye;
本学期__本學期 164.908682755|ben xue qi;
本系统__本系統 313.69268222|ben xi tong;
奔小康__奔小康 106.882056102|ben xiao kang;
本项目__本項目 305.209408115|ben xiang mu;
本协议__本協議 156.89004718|ben xie yi;
本专业__本專業 255.073095111|ben zhuan ye;
本周末__本周末 195.60878915|ben zhou mo;
本产品__本產品 204.329220247|ben chan pin;
本社区__本社區 112.204874836|ben she qu;
本世纪__本世紀 166.768626413|ben shi ji;
本软件__本軟件 198.803491145|ben ruan jian;
本赛季__本賽季 796.754272909|ben sai ji;
本月底__本月底 140.070248771|ben yue di;
本网站__本網站 1751.317311|ben wang zhan;
北部湾__北部灣 190.081867665|bei bu wan;
北方人__北方人 308.651751439|bei fang ren;
被风吹__被風吹 136.112567367|bei feng chui;
北大荒__北大荒 131.773154284|bei da huang;
北戴河__北戴河 321.208662461|bei dai he;
背单词__背單詞 230.008975843|bei dan ci;
贝多芬__貝多芬 342.712398751|bei duo fen;
被偷拍__被偷拍 113.611883002|bei tou pai;
被告人__被告人 866.133860988|bei gao ren;
北海道__北海道 132.10198647|bei hai dao;
被害人__被害人 472.083744072|bei hai ren;
北极熊__北極熊 140.594881376|bei ji xiong;
北京队__北京隊 111.925571131|bei jing dui;
北京路__北京路 140.594881376|bei jing lu;
北京站__北京站 220.467143161|bei jing zhan;
北京城__北京城 173.337150041|bei jing cheng;
北京市__北京市 4805.5096548|bei jing shi;
北京人__北京人 669.200026501|bei jing ren;
背景色__背景色 118.08671951|bei jing se;
北朝鲜__北朝鮮 132.266710153|bei chao xian;
被删除__被刪除 296.955549433|bei shan chu;
北师大__北師大 256.987424161|bei shi da;
被子里__被子里 119.716577729|bei zi li;
倍以上__倍以上 200.545272755|bei yi shang;
备用金__備用金 107.015331962|bei yong jin;
备忘录__備忘錄 302.181790975|bei wang lu;
比不上__比不上 686.943814365|bi bu shang;
闭幕式__閉幕式 315.653350706|bi mu shi;
避风塘__避風塘 106.616002115|bi feng tang;
比得上__比得上 119.86585751|bi de shang;
比利时__比利時 580.575602636|bi li shi;
碧桂园__碧桂園 189.136730609|bi gui yuan;
笔记本__筆記本 8461.46805279|bi ji ben;
比基尼__比基尼 288.205701591|bi ji ni;
毕加索__畢加索 235.226605969|bi jia suo;
比较大__比較大 1799.9950529|bi jiao da;
比较低__比較低 518.979844093|bi jiao di;
比较多__比較多 1836.24473312|bi jiao duo;
比较好__比較好 3360.57914611|bi jiao hao;
必修课__必修課 221.845125512|bi xiu ke;
必需品__必需品 114.893269147|bi xu pin;
闭上眼__閉上眼 149.447435764|bi shang yan;
必胜客__必勝客 292.912705474|bi sheng ke;
必然性__必然性 166.768626413|bi ran xing;
比如说__比如說 2297.98475873|bi ru shuo;
避孕套__避孕套 396.012952778|bi yun tao;
避孕药__避孕藥 316.83562918|bi yun yao;
比亚迪__比亞迪 370.240920313|bi ya di;
必要性__必要性 501.183541788|bi yao xing;
毕业前__畢業前 130.791560815|bi ye qian;
毕业照__畢業照 166.560934377|bi ye zhao;
毕业证__畢業證 719.359091341|bi ye zheng;
毕业生__畢業生 2532.56730325|bi ye sheng;
比我大__比我大 228.8653107|bi wo da;
比我好__比我好 125.053659829|bi wo hao;
变频器__變頻器 268.778909483|bian pin qi;
编码器__編碼器 178.155043976|bian ma qi;
蝙蝠侠__蝙蝠俠 114.321989585|bian fu xia;
变电站__變電站 296.955549433|bian dian zhan;
扁桃体__扁桃體 152.837570606|bian tao ti;
辩论赛__辯論賽 111.369047744|bian lun sai;
便利店__便利店 277.630050085|bian li dian;
便可以__便可以 370.702589737|bian ke yi;
辩护人__辯護人 123.197520618|bian hu ren;
编辑部__編輯部 499.935980841|bian ji bu;
编辑器__編輯器 899.127155009|bian ji qi;
便携式__便攜式 426.226434824|bian xie shi;
辩证法__辯證法 177.490254874|bian zheng fa;
边走边__邊走邊 223.231720645|bian zou bian;
变速器__變速器 199.548108896|bian su qi;
变速箱__變速箱 340.15949445|bian su xiang;
边缘化__邊緣化 195.365179853|bian yuan hua;
变压器__變壓器 745.831342837|bian ya qi;
编译器__編譯器 500.559372647|bian yi qi;
表达式__表達式 569.823995046|biao da shi;
标题栏__標題欄 152.267254161|biao ti lan;
表空间__表空間 123.504952812|biao kong jian;
表决权__表決權 127.413209251|biao jue quan;
表现力__表現力 267.775955618|biao xian li;
表现出__表現出 2046.51646869|biao xian chu;
标准版__標準版 215.30841961|biao zhun ban;
标准化__標準化 1318.16721196|biao zhun hua;
标志性__標誌性 406.006938516|biao zhi xing;
标识符__標識符 138.163289429|biao shi fu;
表演者__表演者 114.037415895|biao yan zhe;
憋不住__憋不住 109.579386421|bie bu zhu;
别客气__別客氣 205.350275845|bie ke qi;
别墅区__別墅區 114.607273411|bie shu qu;
别以为__別以為 343.567617462|bie yi wei;
滨崎步__濱崎步 168.020228531|bin qi bu;
殡仪馆__殯儀館 221.017305999|bin yi guan;
并不多__並不多 584.204365283|bing bu duo;
并不难__並不難 207.666345181|bing bu nan;
并不会__並不會 593.745648473|bing bu hui;
并不像__並不像 274.876014738|bing bu xiang;
并不是__並不是 8120.56061749|bing bu shi;
兵马俑__兵馬俑 203.313241605|bing ma yong;
并发症__併發症 553.034030141|bing fa zheng;
病房里__病房裡 114.46454262|bing fang li;
病毒库__病毒庫 322.411748334|bing du ku;
病毒性__病毒性 123.813152185|bing du xing;
病理学__病理學 108.627664361|bing li xue;
病患者__病患者 106.218162376|bing huan zhe;
冰激凌__冰激凌 310.580912674|bing ji ling;
并将其__並將其 271.133768339|bing jiang qi;
冰淇淋__冰淇淋 631.130833438|bing qi lin;
冰箱里__冰箱里 226.312812713|bing xiang li;
病虫害__病蟲害 339.31275934|bing chong hai;
并自负__並自負 245.71323808|bing zi fu;
病原体__病原體 142.535402072|bing yuan ti;
伯明翰__伯明翰 113.187937993|bo ming han;
播放机__播放機 123.813152185|bo fang ji;
播放器__播放器 2041.42221915|bo fang qi;
柏拉图__柏拉圖 280.062456643|bo la tu;
博览会__博覽會 879.183352683|bo lan hui;
玻璃杯__玻璃杯 147.780672558|bo li bei;
玻璃瓶__玻璃瓶 161.854759309|bo li ping;
玻璃门__玻璃門 118.824795093|bo li men;
玻璃钢__玻璃鋼 145.043940608|bo li gang;
玻璃窗__玻璃窗 207.666345181|bo li chuang;
博客圈__博客圈 266.444503116|bo ke quan;
博客群__博客群 105.295633316|bo ke qun;
博客网__博客網 255.073095111|bo ke wang;
薄熙来__薄熙來 148.889769675|bo xi lai;
波士顿__波士頓 338.890182508|bo shi dun;
博士后__博士后 460.463257431|bo shi hou;
博士生__博士生 685.233853433|bo shi sheng;
播音员__播音員 184.251320835|bo yin yuan;
博物馆__博物館 1978.80389582|bo wu guan;
博尔顿__博爾頓 109.442917312|bo er dun;
不包含__不包含 177.933171406|bu bao han;
不保证__不保證 413.667597456|bu bao zheng;
不变的__不變的 565.579310193|bu bian de;
步步高__步步高 160.449013667|bu bu gao;
部部长__部部長 576.969379906|bu bu zhang;
不匹配__不匹配 157.67404401|bu pi pei;
不便宜__不便宜 244.491487214|bu pian yi;
不道德__不道德 239.963779681|bu dao de;
不得不__不得不 5573.68779063|bu de bu;
不得已__不得已 426.226434824|bu de yi;
部电影__部電影 514.472385324|bu dian ying;
不定时__不定時 126.621787068|bu ding shi;
不动了__不動了 329.314848809|bu dong le;
不动产__不動產 435.352293046|bu dong chan;
不对劲__不對勁 410.07479966|bu dui jin;
不太好__不太好 1546.12469848|bu tai hao;
不停的__不停的 1160.82773443|bu ting de;
不耐烦__不耐煩 583.476802811|bu nai fan;
不能动__不能動 161.653186955|bu neng dong;
不能看__不能看 143.0692679|bu neng kan;
不能吃__不能吃 264.130371602|bu neng chi;
不能做__不能做 346.577724349|bu neng zuo;
不能用__不能用 1285.72012038|bu neng yong;
不论是__不論是 834.351249399|bu lun shi;
布拉格__布拉格 226.030964922|bu la ge;
不来梅__不來梅 144.143005824|bu lai mei;
布莱尔__布萊爾 396.506758465|bu lai er;
布兰妮__布蘭妮 262.817045902|bu lan ni;
不理我__不理我 829.168709129|bu li wo;
不了了__不了了 166.146325956|bu liao le;
布鲁斯__布魯斯 197.076837307|bu lu si;
部落格__部落格 249.104624871|bu luo ge;
不管用__不管用 281.461959558|bu guan yong;
不敢当__不敢當 146.679837233|bu gan dang;
不干胶__不幹膠 120.314814642|bu gan jiao;
不归路__不歸路 119.41857567|bu gui lu;
不规则__不規則 339.31275934|bu gui ze;
不快乐__不快樂 339.735863102|bu kuai le;
不好吗__不好嗎 203.820597887|bu hao ma;
不好过__不好過 182.423584067|bu hao guo;
不好用__不好用 446.339066527|bu hao yong;
不会吧__不會吧 2191.70158301|bu hui ba;
不会变__不會變 149.633788238|bu hui bian;
不会用__不會用 341.859308876|bu hui yong;
不记得__不記得 1561.61561744|bu ji de;
不见得__不見得 886.886162059|bu jian de;
不仅仅__不僅僅 3193.1902591|bu jin jin;
部经理__部經理 272.828431509|bu jing li;
不景气__不景氣 289.645897197|bu jing qi;
不经意__不經意 658.446218066|bu jing yi;
不久前__不久前 679.282440527|bu jiu qian;
不起眼__不起眼 368.399985048|bu qi yan;
补习班__補習班 132.266710153|bu xi ban;
不下雨__不下雨 146.132498493|bu xia yu;
不显示__不顯示 399.482550191|bu xian shi;
不小的__不小的 866.133860988|bu xiao de;
不想做__不想做 267.109399762|bu xiang zuo;
不想要__不想要 230.582949765|bu xiang yao;
不幸福__不幸福 117.646076559|bu xing fu;
步行街__步行街 399.980682268|bu xing jie;
不锈钢__不鏽鋼 1159.38205078|bu xiu gang;
不至于__不至於 1721.02823483|bu zhi yu;
部主任__部主任 326.454673948|bu zhu ren;
补偿费__補償費 130.303509496|bu chang fei;
补偿金__補償金 118.972962872|bu chang jin;
不出声__不出聲 114.037415895|bu chu sheng;
不少人__不少人 1221.67899812|bu shao ren;
不是不__不是不 130.46599058|bu shi bu;
不是吗__不是嗎 448.010827873|bu shi ma;
不是你__不是你 795.762002835|bu shi ni;
不是很__不是很 2266.69928918|bu shi hen;
不是说__不是說 1725.32295995|bu shi shuo;
不失为__不失為 301.054193591|bu shi wei;
不是我__不是我 1432.95027783|bu shi wo;
不睡觉__不睡覺 403.988165198|bu shui jiao;
哺乳期__哺乳期 111.230349808|bu ru qi;
不如说__不如說 349.178797604|bu ru shuo;
不在乎__不在乎 1296.98472971|bu zai hu;
不在线__不在線 384.823616623|bu zai xian;
不自然__不自然 175.073848088|bu zi ran;
不作为__不作為 338.890182508|bu zuo wei;
不错啊__不錯啊 816.861571886|bu cuo a;
不死心__不死心 114.46454262|bu si xin;
不远处__不遠處 485.205278648|bu yuan chu;
不孕症__不孕症 110.264288753|bu yun zheng;
不要太__不要太 708.681829926|bu yao tai;
不要脸__不要臉 693.826435782|bu yao lian;
不要紧__不要緊 1168.08323794|bu yao jin;
不要钱__不要錢 538.078184713|bu yao qian;
不要去__不要去 517.687984062|bu yao qu;
不要做__不要做 242.670241844|bu yao zuo;
不要用__不要用 523.526794166|bu yao yong;
不要问__不要問 114.893269147|bu yao wen;
不一会__不一會 173.553291634|bu yi hui;
不由得__不由得 665.872587905|bu you de;
不外乎__不外乎 214.2378495|bu wai hu;
不完美__不完美 177.711575153|bu wan mei;
不爱你__不愛你 294.743493195|bu ai ni;
不爱我__不愛我 194.151676652|bu ai wo;
爬起来__爬起來 513.191745392|pa qi lai;
怕什么__怕什麼 369.779825848|pa shen me;
帕萨特__帕薩特 242.972837869|pa sa te;
拍马屁__拍馬屁 150.194241046|pai ma pi;
拍卖行__拍賣行 244.186999878|pai mai hang;
拍卖会__拍賣會 226.030964922|pai mai hui;
排名前__排名前 128.049907079|pai ming qian;
排放量__排放量 206.633773476|pai fang liang;
拍电影__拍電影 306.734573113|pai dian ying;
排头兵__排頭兵 138.85370659|pai tou bing;
排卵期__排卵期 180.164388413|pai luan qi;
拍了拍__拍了拍 226.877563077|pai le pai;
拍广告__拍廣告 127.890434962|pai guang gao;
排行榜__排行榜 1241.63157975|pai hang bang;
排气管__排氣管 118.08671951|pai qi guan;
拍照片__拍照片 146.314717429|pai zhao pian;
派出所__派出所 2263.87636378|pai chu suo;
判断力__判斷力 190.081867665|pan duan li;
判决书__判決書 251.914183226|pan jue shu;
潘基文__潘基文 113.32907693|pan ji wen;
潘金莲__潘金蓮 199.796934068|pan jin lian;
攀枝花__攀枝花 196.096919422|pan zhi hua;
潘石屹__潘石屹 177.048440864|pan shi yi;
番禺区__番禺區 124.89791921|pan yu qu;
潘玮柏__潘瑋柏 117.207077876|pan wei bo;
旁观者__旁觀者 320.409100324|pang guan zhe;
跑步机__跑步機 117.353228453|pao bu ji;
泡泡堂__泡泡堂 151.510141313|pao pao tang;
跑得快__跑得快 116.915322539|pao de kuai;
跑出去__跑出去 250.037645335|pao chu qu;
彭德怀__彭德懷 245.407229187|peng de huai;
棚户区__棚戶區 113.895394799|peng hu qu;
配不上__配不上 150.756793028|pei bu shang;
培训班__培訓班 1211.06843631|pei xun ban;
培训费__培訓費 117.061109314|pei xun fei;
培训师__培訓師 181.742866823|pei xun shi;
陪着你__陪着你 139.895806636|pei zhe ni;
陪着我__陪着我 166.560934377|pei zhe wo;
赔偿金__賠償金 170.76435144|pei chang jin;
陪审团__陪審團 113.187937993|pei shen tuan;
培养基__培養基 155.333728851|pei yang ji;
培养出__培養出 332.614317243|pei yang chu;
裴勇俊__裴勇俊 117.499561272|pei yong jun;
培育出__培育出 136.622376491|pei yu chu;
批评家__批評家 116.624293448|pi ping jia;
批发价__批發價 232.024158785|pi fa jia;
批发商__批發商 231.446597362|pi fa shang;
皮肤病__皮膚病 299.1842072|pi fu bing;
皮肤科__皮膚科 175.510734618|pi fu ke;
啤酒节__啤酒節 115.899886195|pi jiu jie;
皮脂腺__皮脂腺 122.584950132|pi zhi xian;
批处理__批處理 267.775955618|pi chu li;
皮耶罗__皮耶羅 160.449013667|pi ye luo;
皮尔洛__皮爾洛 151.699065864|pi er luo;
皮尔斯__皮爾斯 106.882056102|pi er si;
偏头痛__偏頭痛 110.539446825|pian tou tong;
便宜货__便宜貨 120.015323434|pian yi huo;
篇文章__篇文章 1824.83897052|pian wen zhang;
片尾曲__片尾曲 213.172602547|pian wei qu;
票贩子__票販子 123.967540162|piao fan zi;
品牌机__品牌機 258.593668656|pin pai ji;
贫民窟__貧民窟 120.916041011|pin min ku;
贫困户__貧困戶 122.279808036|pin kun hu;
贫困县__貧困縣 130.303509496|pin kun xian;
贫困生__貧困生 283.927938713|pin kun sheng;
乒乓球__乒乓球 706.917758081|ping pang qiu;
平面图__平面圖 243.882891747|ping mian tu;
平民化__平民化 133.591915611|ping min hua;
平方米__平方米 3971.32436646|ping fang mi;
平顶山__平頂山 145.043940608|ping ding shan;
评论家__評論家 281.111429553|ping lun jia;
评论员__評論員 259.562230298|ping lun yuan;
平滑肌__平滑肌 113.187937993|ping hua ji;
平衡点__平衡點 183.563783354|ping heng dian;
平均分__平均分 162.460985719|ping jun fen;
平均值__平均值 329.314848809|ping jun zhi;
平均数__平均數 125.36572391|ping jun shu;
平行线__平行線 108.222318063|ping xing xian;
平常心__平常心 292.54791482|ping chang xin;
平常人__平常人 105.690017726|ping chang ren;
凭什么__憑什麼 1252.50991514|ping shen me;
评委会__評委會 157.477678279|ping wei hui;
平安夜__平安夜 230.295783987|ping an ye;
破天荒__破天荒 158.659551632|po tian huang;
破坏力__破壞力 118.08671951|po huai li;
破坏性__破壞性 212.112652282|po huai xing;
破解版__破解版 601.940653207|po jie ban;
破碎机__破碎機 336.365750338|po sui ji;
剖腹产__剖腹產 198.308623594|pou fu chan;
剖宫产__剖宮產 116.18910757|pou gong chan;
普遍性__普遍性 245.101601395|pu bian xing;
葡萄糖__葡萄糖 377.226735448|pu tao tang;
葡萄酒__葡萄酒 921.81798848|pu tao jiu;
葡萄牙__葡萄牙 672.544092675|pu tao ya;
普通版__普通版 118.08671951|pu tong ban;
普通股__普通股 122.279808036|pu tong gu;
普通话__普通話 1371.79434453|pu tong hua;
普通人__普通人 1054.61787307|pu tong ren;
普陀区__普陀區 160.249192015|pu tuo qu;
普陀山__普陀山 127.413209251|pu tuo shan;
蒲公英__蒲公英 209.746993999|pu gong ying;
扑克牌__撲克牌 170.339279748|pu ke pai;
普及率__普及率 210.008536601|pu ji lv;
普洱茶__普洱茶 410.586139672|pu er cha;
麻烦事__麻煩事 118.824795093|ma fan shi;
马德里__馬德里 299.557272934|ma de li;
马天宇__馬天宇 227.160466527|ma tian yu;
马尼拉__馬尼拉 112.065135969|ma ni la;
麻辣烫__麻辣燙 250.974160423|ma la tang;
马拉松__馬拉松 341.433560596|ma la song;
玛丽亚__瑪麗亞 200.29551561|ma li ya;
马里奥__馬里奧 132.266710153|ma li ao;
马良行__馬良行 115.036534536|ma liang xing;
马铃薯__馬鈴薯 327.26932246|ma ling shu;
马路边__馬路邊 133.758497151|ma lu bian;
马克思__馬克思 879.183352683|ma ke si;
马化腾__馬化騰 126.937764318|ma hua teng;
马加爵__馬加爵 141.29744947|ma jia jue;
马戏团__馬戲團 167.184787749|ma xi tuan;
马晓旭__馬曉旭 120.765453341|ma xiao xu;
马自达__馬自達 534.735933039|ma zi da;
马刺队__馬刺隊 112.625137786|ma ci dui;
马赛克__馬賽克 293.643651968|ma sai ke;
马英九__馬英九 793.781168439|ma ying jiu;
马鞍山__馬鞍山 262.817045902|ma an shan;
买保险__買保險 132.762114633|mai bao xian;
买不到__買不到 867.213880777|mai bu dao;
买不起__買不起 1008.35118051|mai bu qi;
买房子__買房子 688.658042404|mai fang zi;
麦当娜__麥當娜 172.04594156|mai dang na;
麦当劳__麥當勞 1156.49608257|mai dang lao;
麦德龙__麥德龍 124.431860131|mai de long;
买得起__買得起 284.636464248|mai de qi;
买电脑__買電腦 168.859844103|mai dian nao;
卖东西__賣東西 148.334184528|mai dong xi;
买东西__買東西 992.147332631|mai dong xi;
买股票__買股票 286.058823982|mai gu piao;
迈凯轮__邁凱輪 112.484875527|mai kai lun;
麦凯恩__麥凱恩 164.703307075|mai kai en;
麦克风__麥克風 662.561694208|mai ke feng;
迈克尔__邁克爾 412.12398856|mai ke er;
麦肯锡__麥肯錫 145.043940608|mai ken xi;
买基金__買基金 223.231720645|mai ji jin;
买什么__買什麼 436.438689186|mai shen me;
买手机__買手機 168.859844103|mai shou ji;
买受人__買受人 115.611384758|mai shou ren;
买彩票__買彩票 184.71110921|mai cai piao;
买衣服__買衣服 396.506758465|mai yi fu;
迈阿密__邁阿密 162.056583012|mai a mi;
漫步者__漫步者 177.490254874|man bu zhe;
满满的__滿滿的 336.785179346|man man de;
慢慢来__慢慢來 660.912425973|man man lai;
满天飞__滿天飛 260.859291326|man tian fei;
满脑子__滿腦子 207.407719521|man nao zi;
漫画家__漫畫家 131.445140637|man hua jia;
曼哈顿__曼哈頓 212.641966978|man ha dun;
曼奇尼__曼奇尼 141.650048976|man qi ni;
慢性病__慢性病 182.196395498|man xing bing;
满世界__滿世界 169.492308033|man shi jie;
满足感__滿足感 174.855812809|man zu gan;
满意度__滿意度 540.093554591|man yi du;
漫游费__漫遊費 133.758497151|man you fei;
慢悠悠__慢悠悠 107.818484324|man you you;
毛毛虫__毛毛蟲 218.824857909|mao mao chong;
猫头鹰__貓頭鷹 173.986383704|mao tou ying;
毛利率__毛利率 424.635962376|mao li lv;
毛细孔__毛細孔 110.401782066|mao xi kong;
冒险岛__冒險島 199.051387821|mao xian dao;
毛主席__毛主席 1366.67546656|mao zhu xi;
毛茸茸__毛茸茸 107.550099352|mao rong rong;
毛泽东__毛澤東 3536.74265575|mao ze dong;
贸易通__貿易通 145.043940608|mao yi tong;
贸易商__貿易商 196.831399718|mao yi shang;
贸易额__貿易額 120.615053212|mao yi e;
门课程__門課程 149.075426771|men ke cheng;
门诊部__門診部 121.217779906|men zhen bu;
蒙迪欧__蒙迪歐 175.073848088|meng di ou;
梦工厂__夢工廠 139.200207879|meng gong chang;
蒙古人__蒙古人 203.313241605|meng gu ren;
蒙古族__蒙古族 210.270405333|meng gu zu;
孟加拉__孟加拉 143.426288875|meng jia la;
梦中的__夢中的 180.389043185|meng zhong de;
每平米__每平米 114.893269147|mei ping mi;
没法子__沒法子 151.510141313|mei fa zi;
没道理__沒道理 150.007190589|mei dao li;
没得说__沒得說 109.034528882|mei de shuo;
美能达__美能達 112.484875527|mei neng da;
梅兰芳__梅蘭芳 189.845141544|mei lan fang;
美联储__美聯儲 584.204365283|mei lian chu;
美联社__美聯社 181.742866823|mei lian she;
没良心__沒良心 150.007190589|mei liang xin;
玫琳凯__玫琳凱 109.579386421|mei lin kai;
没关系__沒關係 5552.8894634|mei guan xi;
没感觉__沒感覺 486.416079992|mei gan jue;
每个人__每個人 4629.17242366|mei ge ren;
每个月__每個月 2074.76292775|mei ge yue;
美国队__美國隊 282.868455943|mei guo dui;
美国人__美國人 2548.39656922|mei guo ren;
玫瑰花__玫瑰花 434.810109507|mei gui hua;
煤化工__煤化工 142.713135632|mei hua gong;
没话说__沒話說 304.070513117|mei hua shuo;
没好气__沒好氣 119.86585751|mei hao qi;
没见过__沒見過 1680.75779471|mei jian guo;
枚金牌__枚金牌 200.795341333|mei jin pai;
没想过__沒想過 513.831666385|mei xiang guo;
美洲杯__美洲杯 121.368931601|mei zhou bei;
没出息__沒出息 228.295612376|mei chu xi;
没商量__沒商量 107.282382453|mei shang liang;
美少女__美少女 486.416079992|mei shao nv;
美少年__美少年 134.930398555|mei shao nian;
没什么__沒什麼 11019.9799187|mei shen me;
没声音__沒聲音 108.357265155|mei sheng yin;
没事儿__沒事兒 813.813436628|mei shi er;
美术馆__美術館 304.449671797|mei shu guan;
美人鱼__美人魚 243.275811214|mei ren yu;
美容师__美容師 111.646962678|mei rong shi;
美容院__美容院 401.478808454|mei rong yuan;
美元兑__美元兌 247.557321202|mei yuan dui;
梅艳芳__梅艷芳 200.04606951|mei yan fang;
每一步__每一步 272.828431509|mei yi bu;
每一天__每一天 851.15405446|mei yi tian;
每一种__每一種 283.574337601|mei yi zhong;
每一次__每一次 1285.72012038|mei yi ci;
没意思__沒意思 1762.26354231|mei yi si;
每一位__每一位 800.735741689|mei yi wei;
没有钱__沒有錢 670.869975958|mei you qian;
没有错__沒有錯 454.194369369|mei you cuo;
没有用__沒有用 860.753904265|mei you yong;
美誉度__美譽度 155.72135507|mei yu du;
米老鼠__米老鼠 162.460985719|mi lao shu;
猕猴桃__獼猴桃 183.563783354|mi hou tao;
密集型__密集型 120.916041011|mi ji xing;
米其林__米其林 109.579386421|mi qi lin;
秘书长__秘書長 1689.15672637|mi shu zhang;
秘书处__秘書處 256.347723437|mi shu chu;
米左右__米左右 207.925293333|mi zuo you;
米以上__米以上 143.426288875|mi yi shang;
面包车__麵包車 301.429591092|mian bao che;
免不了__免不了 349.614203755|mian bu liao;
免费版__免費版 123.351140937|mian fei ban;
免费送__免費送 122.279808036|mian fei song;
面对面__面對面 867.213880777|mian dui mian;
棉花糖__棉花糖 194.636170786|mian hua tang;
面试官__面試官 207.925293333|mian shi guan;
面试时__面試時 108.492380517|mian shi shi;
面授权__面授權 265.450260135|mian shou quan;
绵阳市__綿陽市 132.10198647|mian yang shi;
免疫力__免疫力 391.596284031|mian yi li;
灭火器__滅火器 153.792848894|mie huo qi;
敏感度__敏感度 141.826678552|min gan du;
敏感性__敏感性 316.441045148|min gan xing;
闵行区__閔行區 156.109948588|min hang qu;
民进党__民進黨 900.248315564|min jin dang;
民政部__民政部 234.348853194|min zheng bu;
民政局__民政局 383.387639617|min zheng ju;
民主党__民主黨 487.02261325|min zhu dang;
民主化__民主化 229.722524886|min zhu hua;
明摆着__明擺着 199.299593609|ming bai zhe;
命令行__命令行 535.402718412|ming ling hang;
明后天__明後天 316.441045148|ming hou tian;
名学生__名學生 338.468131949|ming xue sheng;
明细表__明細表 160.849404779|ming xi biao;
明信片__明信片 290.368691563|ming xin pian;
明知道__明知道 388.679238014|ming zhi dao;
命中率__命中率 336.365750338|ming zhong lv;
名字叫__名字叫 507.468200425|ming zi jiao;
明月照__明月照 204.329220247|ming yue zhao;
明眼人__明眼人 108.087539034|ming yan ren;
名誉权__名譽權 126.779677253|ming yu quan;
冥王星__冥王星 153.792848894|ming wang xing;
末班车__末班車 131.117943492|mo ban che;
魔法师__魔法師 293.643651968|mo fa shi;
默多克__默多克 124.431860131|mo duo ke;
模特儿__模特兒 210.008536601|mo te er;
摩天轮__摩天輪 129.010924378|mo tian lun;
摩托车__摩托車 1773.27819069|mo tuo che;
摩纳哥__摩納哥 145.587202159|mo na ge;
模拟题__模擬題 114.179614083|mo ni ti;
模拟器__模擬器 784.92825478|mo ni qi;
茉莉花__茉莉花 211.321149687|mo li hua;
摩洛哥__摩洛哥 160.849404779|mo luo ge;
莫过于__莫過於 562.066236349|mo guo yu;
模块化__模塊化 182.878811433|mo kuai hua;
默克尔__默克爾 152.647228173|mo ke er;
磨合期__磨合期 121.671800659|mo he qi;
摩羯座__摩羯座 167.601987591|mo jie zuo;
墨西哥__墨西哥 893.542261726|mo xi ge;
莫须有__莫須有 114.46454262|mo xu you;
莫扎特__莫扎特 258.916120291|mo zha te;
陌生人__陌生人 1411.68136652|mo sheng ren;
魔术师__魔術師 243.882891747|mo shu shi;
默认的__默認的 342.712398751|mo ren de;
默认值__默認值 237.583386308|mo ren zhi;
莫斯科__莫斯科 872.634214191|mo si ke;
莫文蔚__莫文蔚 319.213487372|mo wen wei;
墨尔本__墨爾本 324.426913464|mo er ben;
某某某__某某某 125.053659829|mou mou mou;
某大学__某大學 122.279808036|mou da xue;
某个人__某個人 334.276427588|mou ge ren;
某公司__某公司 194.393772779|mou gong si;
某些人__某些人 887.99205879|mou xie ren;
某一天__某一天 374.41672986|mou yi tian;
目标价__目標價 243.882891747|mu biao jia;
牡丹江__牡丹江 201.79873775|mu dan jiang;
木地板__木地板 242.066179876|mu di ban;
目的性__目的性 150.569041974|mu di xing;
木乃伊__木乃伊 252.228305921|mu nai yi;
慕尼黑__慕尼黑 317.230705235|mu ni hei;
目录下__目錄下 654.356305043|mu lu xia;
母公司__母公司 397.496217848|mu gong si;
目击者__目擊者 264.130371602|mu ji zhe;
母亲节__母親節 468.567137655|mu qin jie;
木子美__木子美 144.863304286|mu zi mei;
穆斯林__穆斯林 478.003501869|mu si lin;
沐浴露__沐浴露 138.508067822|mu yu lu;
发表者__發表者 164.293322714|fa biao zhe;
发病率__發病率 460.463257431|fa bing lv;
发布会__發布會 1061.20953474|fa bu hui;
发布者__發布者 188.901181552|fa bu zhe;
发不出__發不出 198.555903198|fa bu chu;
发脾气__發脾氣 446.895626023|fa pi qi;
发短信__發短信 1508.06636321|fa duan xin;
发大财__發大財 112.204874836|fa da cai;
发电量__發電量 113.32907693|fa dian liang;
发电机__發電機 387.22887368|fa dian ji;
发电厂__發電廠 221.845125512|fa dian chang;
发动机__發動機 3644.11721469|fa dong ji;
发帖子__發帖子 286.415523108|fa tie zi;
法轮功__法輪功 619.442999798|fa lun gong;
法拉利__法拉利 711.336195135|fa la li;
法兰西__法蘭西 185.172044961|fa lan xi;
发牢骚__發牢騷 244.796354228|fa lao sao;
发广告__發廣告 124.742372548|fa guang gao;
发改委__發改委 855.407364934|fa gai wei;
发给你__發給你 1305.09125317|fa gei ni;
发工资__發工資 411.610733326|fa gong zi;
法国队__法國隊 290.0070692|fa guo dui;
法国人__法國人 615.595353746|fa guo ren;
发起人__發起人 298.811606079|fa qi ren;
法学家__法學家 107.952927857|fa xue jia;
法学院__法學院 398.48814637|fa xue yuan;
法西斯__法西斯 249.726250867|fa xi si;
发消息__發消息 382.910172354|fa xiao xi;
发信息__發信息 407.527636023|fa xin xi;
法新社__法新社 115.611384758|fa xin she;
发行量__發行量 330.960471347|fa xing liang;
发行价__發行價 237.583386308|fa xing jia;
发型师__髮型師 126.149295342|fa xing shi;
发行人__發行人 241.463621556|fa xing ren;
发展观__發展觀 169.28122395|fa zhan guan;
发展商__發展商 297.325836157|fa zhan shang;
发展史__發展史 281.111429553|fa zhan shi;
法制办__法制辦 170.551683166|fa zhi ban;
法制化__法制化 138.508067822|fa zhi hua;
发烧友__發燒友 342.712398751|fa shao you;
发射器__發射器 125.835280772|fa she qi;
发生率__發生率 300.679263607|fa sheng lv;
发生器__發生器 246.326401069|fa sheng qi;
发热量__發熱量 159.452390871|fa re liang;
法人股__法人股 231.735198139|fa ren gu;
法草案__法草案 133.758497151|fa cao an;
发送给__發送給 185.634130949|fa song gei;
发送者__發送者 108.357265155|fa song zhe;
发源地__發源地 239.068350048|fa yuan di;
发言权__發言權 810.776675547|fa yan quan;
发言人__發言人 1035.08753546|fa yan ren;
发邮件__發郵件 922.967443217|fa you jian;
范冰冰__范冰冰 941.55486912|fan bing bing;
反病毒__反病毒 251.287110964|fan bing du;
犯不着__犯不着 114.037415895|fan bu zhao;
反腐败__反腐敗 406.513206136|fan fu bai;
范德萨__范德薩 126.306596357|fan de sa;
梵蒂冈__梵蒂岡 118.824795093|fan di gang;
反对派__反對派 200.29551561|fan dui pai;
反对党__反對黨 148.889769675|fan dui dang;
反对者__反對者 132.431639237|fan dui zhe;
繁体字__繁體字 358.437246895|fan ti zi;
反垄断__反壟斷 191.747236314|fan long duan;
范甘迪__范甘迪 234.933657026|fan gan di;
反革命__反革命 254.755429543|fan ge ming;
翻过来__翻過來 105.0335283|fan guo lai;
反过来__反過來 909.268075561|fan guo lai;
返回值__返回值 270.458854115|fan hui zhi;
番茄酱__番茄醬 110.126966673|fan qie jiang;
反倾销__反傾銷 535.402718412|fan qing xiao;
反洗钱__反洗錢 155.140277726|fan xi qian;
范晓萱__范曉萱 106.350610398|fan xiao xuan;
反政府__反政府 118.972962872|fan zheng fu;
范志毅__范志毅 108.222318063|fan zhi yi;
翻出来__翻出來 249.726250867|fan chu lai;
反作用__反作用 113.753550575|fan zuo yong;
犯错误__犯錯誤 378.63963681|fan cuo wu;
翻译成__翻譯成 394.535222541|fan yi cheng;
反应堆__反應堆 106.085879302|fan ying dui;
反应器__反應器 111.369047744|fan ying qi;
反映出__反映出 698.163048348|fan ying chu;
范玮琪__范瑋琪 110.401782066|fan wei qi;
方便面__方便麵 936.87321059|fang bian mian;
防病毒__防病毒 168.859844103|fang bing du;
放不下__放不下 587.855808729|fang bu xia;
方面军__方面軍 148.149450567|fang mian jun;
方法论__方法論 311.744192349|fang fa lun;
方法来__方法來 477.408200926|fang fa lai;
放风筝__放風箏 125.053659829|fang feng zheng;
防腐剂__防腐劑 158.659551632|fang fu ji;
防辐射__防輻射 140.770195218|fang fu she;
放大镜__放大鏡 221.292902041|fang da jing;
放大器__放大器 317.626273928|fang da qi;
防盗门__防盜門 249.726250867|fang dao men;
房地产__房地產 5165.70071998|fang di chan;
房管局__房管局 244.491487214|fang guan ju;
防火墙__防火牆 2688.67773313|fang huo qiang;
房间里__房間里 1086.63578899|fang jian li;
房交会__房交會 185.634130949|fang jiao hui;
防静电__防靜電 128.529517539|fang jing dian;
方向盘__方向盤 659.267263146|fang xiang pan;
方向键__方向鍵 176.168109435|fang xiang jian;
方向性__方向性 110.401782066|fang xiang xing;
纺织品__紡織品 636.660374558|fang zhi pin;
纺织业__紡織業 136.622376491|fang zhi ye;
方舟子__方舟子 197.814987883|fang zhou zi;
房产证__房產證 446.339066527|fang chan zheng;
房产商__房產商 129.655606164|fang chan shang;
防沉迷__防沉迷 150.007190589|fang chen mi;
方程式__方程式 167.393257695|fang cheng shi;
防晒霜__防晒霜 242.066179876|fang shai shuang;
放上去__放上去 265.119670945|fang shang qu;
放射性__放射性 312.522131716|fang she xing;
放暑假__放暑假 130.46599058|fang shu jia;
房子里__房子里 407.020105042|fang zi li;
访问量__訪問量 608.72971781|fang wen liang;
访问者__訪問者 225.749468142|fang wen zhe;
分辨率__分辨率 1947.00521503|fen bian lv;
分布图__分布圖 117.061109314|fen bu tu;
分不开__分不開 322.010219858|fen bu kai;
分不清__分不清 485.810302105|fen bu qing;
分布式__分佈式 522.874798954|fen bu shi;
粉煤灰__粉煤灰 123.658956482|fen mei hui;
分泌物__分泌物 358.437246895|fen mi wu;
分理处__分理處 146.314717429|fen li chu;
分割线__分割線 134.259489114|fen ge xian;
分公司__分公司 3169.40381549|fen gong si;
粉红色__粉紅色 587.855808729|fen hong se;
分会场__分會場 115.179978568|fen hui chang;
分阶段__分階段 137.305093541|fen jie duan;
分界线__分界線 136.792736844|fen jie xian;
分区表__分區表 107.416157498|fen qu biao;
分析法__分析法 147.964946673|fen xi fa;
分析家__分析家 149.075426771|fen xi jia;
分析师__分析師 1277.73391996|fen xi shi;
分析仪__分析儀 174.638049069|fen xi yi;
分销商__分銷商 304.829303266|fen xiao shang;
分之一__分之一 143.784200776|fen zhi yi;
分中心__分中心 112.34478795|fen zhong xin;
分数线__分數線 625.649317648|fen shu xian;
分水岭__分水嶺 147.780672558|fen shui ling;
分子量__分子量 118.824795093|fen zi liang;
分左右__分左右 239.664931108|fen zuo you;
粉丝们__粉絲們 181.064689688|fen si men;
分以上__分以上 136.112567367|fen yi shang;
封闭式__封閉式 277.284292303|feng bi shi;
丰台区__丰台區 221.845125512|feng tai qu;
凤凰城__鳳凰城 120.164975734|feng huang cheng;
凤凰网__鳳凰網 138.680779525|feng huang wang;
风景区__風景區 582.750146437|feng jing qu;
风景线__風景線 193.186303435|feng jing xian;
冯小刚__馮小剛 538.078184713|feng xiao gang;
风向标__風向標 184.941433485|feng xiang biao;
风吹过__風吹過 171.831677206|feng chui guo;
封神榜__封神榜 116.769717326|feng shen bang;
风湿病__風濕病 148.149450567|feng shi bing;
缝纫机__縫紉機 142.180598718|feng ren ji;
飞毛腿__飛毛腿 142.357889859|fei mao tui;
费德勒__費德勒 361.12732612|fei de le;
非典型__非典型 109.579386421|fei dian xing;
飞轮海__飛輪海 224.626982392|fei lun hai;
菲律宾__菲律賓 822.992135502|fei lv bin;
菲利普__菲利普 132.266710153|fei li pu;
飞利浦__飛利浦 952.17431607|fei li pu;
非理性__非理性 277.976239008|fei li xing;
非官方__非官方 119.121315407|fei guan fang;
非公开__非公開 125.522047856|fei gong kai;
飞机票__飛機票 363.837594448|fei ji piao;
飞机场__飛機場 193.90988203|fei ji chang;
肺结核__肺結核 225.749468142|fei jie he;
飞起来__飛起來 153.41002317|fei qi lai;
废弃物__廢棄物 241.463621556|fei qi wu;
非线性__非線性 399.980682268|fei xian xing;
飞行器__飛行器 217.736803143|fei xing qi;
飞行员__飛行員 704.279880358|fei xing yuan;
非专业__非專業 106.748946222|fei zhuan ye;
非正常__非正常 268.109857044|fei zheng chang;
非正式__非正式 224.06783424|fei zheng shi;
非主流__非主流 576.250827814|fei zhu liu;
非常大__非常大 999.59341964|fei chang da;
非常好__非常好 2098.16340664|fei chang hao;
肥皂剧__肥皂劇 125.36572391|fei zao ju;
菲亚特__菲亞特 175.729586548|fei ya te;
非物质__非物質 278.669912425|fei wu zhi;
佛教徒__佛教徒 108.898738333|fo jiao tu;
佛山市__佛山市 510.004074866|fo shan shi;
福布斯__福布斯 245.71323808|fu bu si;
福美来__福美來 118.972962872|fu mei lai;
父母亲__父母親 259.562230298|fu mu qin;
辅导班__輔導班 233.474375771|fu dao ban;
辅导员__輔導員 619.442999798|fu dao yuan;
福田区__福田區 221.292902041|fu tian qu;
弗兰克__弗蘭克 128.850255419|fu lan ke;
负离子__負離子 136.792736844|fu li zi;
福利院__福利院 143.605133321|fu li yuan;
覆盖面__覆蓋面 318.418891685|fu gai mian;
覆盖率__覆蓋率 285.702569086|fu gai lv;
弗格森__弗格森 245.101601395|fu ge sen;
妇科病__婦科病 264.130371602|fu ke bing;
福克斯__福克斯 641.438524323|fu ke si;
孵化器__孵化器 142.003528374|fu hua qi;
富豪榜__富豪榜 121.975425508|fu hao bang;
复合肥__複合肥 125.678566729|fu he fei;
复合型__複合型 125.992190229|fu he xing;
复活节__復活節 138.163289429|fu huo jie;
附加费__附加費 108.492380517|fu jia fei;
附加值__附加值 318.418891685|fu jia zhi;
福建省__福建省 1094.79101389|fu jian sheng;
副教授__副教授 574.81640715|fu jiao shou;
腹腔镜__腹腔鏡 168.649547684|fu qiang jing;
父亲节__父親節 191.031727675|fu qin jie;
复选框__複選框 206.376433771|fu xuan kuang;
服装店__服裝店 198.308623594|fu zhuang dian;
复制到__複製到 461.61231651|fu zhi dao;
福州市__福州市 313.69268222|fu zhou shi;
副产品__副產品 138.680779525|fu chan pin;
妇产科__婦產科 364.745529846|fu chan ke;
富士通__富士通 415.734739962|fu shi tong;
富士康__富士康 565.579310193|fu shi kang;
腐蚀性__腐蝕性 111.091824605|fu shi xing;
富士山__富士山 108.222318063|fu shi shan;
复杂度__複雜度 190.793818607|fu za du;
复杂化__複雜化 156.304608838|fu za hua;
复杂性__複雜性 448.010827873|fu za xing;
负责制__負責制 166.97657743|fu ze zhi;
负责人__負責人 7268.06705425|fu ze ren;
负增长__負增長 150.007190589|fu zeng zhang;
副作用__副作用 804.737106306|fu zuo yong;
夫斯基__夫斯基 185.402943996|fu si ji;
复印机__複印機 281.812926654|fu yin ji;
复印件__複印件 1349.75009317|fu yin jian;
符文布__符文布 144.863304286|fu wen bu;
俯卧撑__俯卧撐 171.617679695|fu wo cheng;
服务部__服務部 241.463621556|fu wu bu;
服务费__服務費 406.006938516|fu wu fei;
服务端__服務端 379.584509838|fu wu duan;
服务台__服務台 125.835280772|fu wu tai;
服务器__服務器 18997.0695704|fu wu qi;
服务区__服務區 229.436430673|fu wu qu;
服务型__服務型 107.282382453|fu wu xing;
服务性__服務性 132.431639237|fu wu xing;
服务站__服務站 355.324137339|fu wu zhan;
服务商__服務商 743.048258297|fu wu shang;
服务生__服務生 358.437246895|fu wu sheng;
服务员__服務員 1306.71862793|fu wu yuan;
服务业__服務業 1115.44785438|fu wu ye;
断背山__斷背山 113.47039186|duan bei shan;
短短的__短短的 570.534533242|duan duan de;
断路器__斷路器 141.121478992|duan lu qi;
端口号__端口號 135.773751924|duan kou hao;
短消息__短消息 784.92825478|duan xiao xi;
短信息__短信息 197.814987883|duan xin xi;
短时间__短時間 374.41672986|duan shi jian;
段时间__段時間 799.738513132|duan shi jian;
端午节__端午節 540.767020614|duan wu jie;
大白天__大白天 158.857391092|da bai tian;
大白菜__大白菜 248.175085992|da bai cai;
大半天__大半天 127.73116145|da ban tian;
大暴雨__大暴雨 107.416157498|da bao yu;
大本营__大本營 361.577631409|da ben ying;
大比拼__大比拼 164.908682755|da bi pin;
大部分__大部分 8729.22724991|da bu fen;
达不到__達不到 949.804135501|da bu dao;
打补丁__打補丁 112.906187218|da bu ding;
大部队__大部隊 176.387781073|da bu dui;
大不了__大不了 1382.08969051|da bu liao;
打不开__打不開 2135.08983815|da bu kai;
大排档__大排檔 154.368879448|da pai dang;
大盘股__大盤股 316.83562918|da pan gu;
打喷嚏__打噴嚏 167.393257695|da pen ti;
大批量__大批量 198.06165195|da pi liang;
大品牌__大品牌 226.877563077|da pin pai;
大屏幕__大屏幕 509.368920718|da ping mu;
打麻将__打麻將 493.129699012|da ma jiang;
大卖场__大賣場 237.583386308|da mai chang;
大满贯__大滿貫 153.601316766|da man guan;
大忙人__大忙人 111.786180106|da mang ren;
大门口__大門口 264.459727191|da men kou;
大美女__大美女 341.008342538|da mei nv;
大面积__大面積 1000.83985593|da mian ji;
大明星__大明星 210.532600599|da ming xing;
大拇指__大拇指 359.331706043|da mu zhi;
大法官__大法官 150.007190589|da fa guan;
大发展__大發展 290.0070692|da fa zhan;
大饭店__大飯店 193.186303435|da fan dian;
大范围__大範圍 337.205131359|da fan wei;
大方向__大方向 168.020228531|da fang xiang;
达芬奇__達芬奇 146.132498493|da fen qi;
打飞机__打飛機 185.402943996|da fei ji;
大幅度__大幅度 1613.0410787|da fu du;
大富翁__大富翁 295.111021611|da fu weng;
大道理__大道理 173.986383704|da dao li;
大地震__大地震 565.579310193|da di zhen;
打电话__打電話 10226.0664271|da dian hua;
大动作__大動作 110.539446825|da dong zuo;
大都市__大都市 426.757915008|da du shi;
大肚子__大肚子 167.184787749|da du zi;
大多数__大多數 5559.81360155|da duo shu;
大队长__大隊長 236.696839161|da dui zhang;
大讨论__大討論 233.183609039|da tao lun;
大提琴__大提琴 141.473639374|da ti qin;
大体上__大體上 187.027319083|da ti shang;
大头贴__大頭貼 259.238974004|da tou tie;
大屠杀__大屠殺 250.037645335|da tu sha;
大女儿__大女兒 117.353228453|da nv er;
大男孩__大男孩 142.535402072|da nan hai;
大男人__大男人 311.744192349|da nan ren;
大牛市__大牛市 235.226605969|da niu shi;
达拉斯__達拉斯 115.467403456|da la si;
打篮球__打籃球 376.756940916|da lan qiu;
大老远__大老遠 137.305093541|da lao yuan;
打了个__打了個 616.362966229|da le ge;
大礼包__大禮包 140.594881376|da li bao;
大理石__大理石 373.950434882|da li shi;
大连市__大連市 399.980682268|da lian shi;
大陆人__大陸人 189.136730609|da lu ren;
打官司__打官司 383.387639617|da guan si;
大观园__大觀園 200.04606951|da guan yuan;
大革命__大革命 116.18910757|da ge ming;
大哥大__大哥大 127.096048509|da ge da;
大哥哥__大哥哥 166.560934377|da ge ge;
大个子__大個子 136.792736844|da ge zi;
打工妹__打工妹 109.034528882|da gong mei;
大功率__大功率 238.770616634|da gong lv;
打工者__打工者 192.705418355|da gong zhe;
打工仔__打工仔 180.839193473|da gong zai;
大公司__大公司 973.773879211|da gong si;
大股东__大股東 1536.52100517|da gu dong;
大姑娘__大姑娘 116.915322539|da gu niang;
大规模__大規模 2963.1429408|da gui mo;
大客户__大客戶 543.469292924|da ke hu;
大客车__大客車 114.179614083|da ke che;
打瞌睡__打瞌睡 170.551683166|da ke shui;
大环境__大環境 462.187920882|da huan jing;
大黄蜂__大黃蜂 134.092283643|da huang feng;
大航海__大航海 155.333728851|da hang hai;
大河网__大河網 191.508436159|da he wang;
大户型__大戶型 149.447435764|da hu xing;
大胡子__大鬍子 178.377193209|da hu zi;
打火机__打火機 423.578945935|da huo ji;
大货车__大貨車 175.073848088|da huo che;
大伙儿__大伙兒 191.98633424|da huo er;
大灰狼__大灰狼 177.711575153|da hui lang;
大集团__大集團 105.821807183|da ji tuan;
大剂量__大劑量 120.765453341|da ji liang;
大纪元__大紀元 276.249600432|da ji yuan;
大家庭__大家庭 407.020105042|da jia ting;
大家看__大家看 367.941183266|da jia kan;
大家好__大家好 1115.44785438|da jia hao;
大检查__大檢查 178.377193209|da jian cha;
打交道__打交道 834.351249399|da jiao dao;
大教堂__大教堂 142.003528374|da jiao tang;
大将军__大將軍 320.808632296|da jiang jun;
大奖赛__大獎賽 381.006242235|da jiang sai;
大江网__大江網 118.824795093|da jiang wang;
大姐姐__大姐姐 124.431860131|da jie jie;
大结局__大結局 216.384339476|da jie ju;
大酒店__大酒店 1024.81967123|da jiu dian;
大剧院__大劇院 184.481071779|da ju yuan;
大气层__大氣層 130.46599058|da qi ceng;
大企业__大企業 665.872587905|da qi ye;
大前锋__大前鋒 113.046974828|da qian feng;
大清早__大清早 172.260473089|da qing zao;
大趋势__大趨勢 206.119414554|da qu shi;
大学里__大學里 540.767020614|da xue li;
大学城__大學城 548.230802969|da xue cheng;
大学生__大學生 6165.6674849|da xue sheng;
大西洋__大西洋 314.867617017|da xi yang;
大峡谷__大峽谷 217.19480623|da xia gu;
大小便__大小便 177.269210225|da xiao bian;
大小姐__大小姐 343.996026791|da xiao jie;
大小写__大小寫 216.924313917|da xiao xie;
大项目__大項目 271.810366771|da xiang mu;
大兴区__大興區 115.755545596|da xing qu;
大猩猩__大猩猩 121.520271774|da xing xing;
大熊猫__大熊貓 535.402718412|da xiong mao;
大闸蟹__大閘蟹 230.582949765|da zha xie;
大丈夫__大丈夫 152.267254161|da zhang fu;
打招呼__打招呼 964.114234362|da zhao hu;
大智慧__大智慧 681.82669043|da zhi hui;
大中华__大中華 148.334184528|da zhong hua;
大众化__大眾化 350.050152834|da zhong hua;
大中型__大中型 305.97104031|da zhong xing;
大中专__大中專 156.89004718|da zhong zhuan;
大场面__大場面 128.529517539|da chang mian;
大长今__大長今 180.389043185|da chang jin;
大城市__大城市 1218.6379585|da cheng shi;
打出来__打出來 408.035799866|da chu lai;
大出血__大出血 196.586267794|da chu xue;
大商场__大商場 105.164499152|da shang chang;
打什么__打什麼 142.713135632|da shen me;
大时代__大時代 165.939408926|da shi dai;
大石头__大石頭 161.854759309|da shi tou;
大使馆__大使館 582.750146437|da shi guan;
大师级__大師級 141.29744947|da shi ji;
大事记__大事記 152.267254161|da shi ji;
大世界__大世界 131.445140637|da shi jie;
大师兄__大師兄 149.633788238|da shi xiong;
大市场__大市場 228.580284053|da shi chang;
大师赛__大師賽 120.015323434|da shi sai;
大手笔__大手筆 311.744192349|da shou bi;
打手机__打手機 133.093414711|da shou ji;
大热天__大熱天 165.526347625|da re tian;
大人物__大人物 220.742053181|da ren wu;
大容量__大容量 416.253137598|da rong liang;
大杂烩__大雜燴 128.369448119|da za hui;
打造成__打造成 269.114061535|da zao cheng;
打造出__打造出 177.711575153|da zao chu;
大字报__大字報 123.351140937|da zi bao;
大自然__大自然 1173.92027842|da zi ran;
大嘴巴__大嘴巴 142.003528374|da zui ba;
大草原__大草原 155.140277726|da cao yuan;
大扫除__大掃除 107.015331962|da sao chu;
大元帅__大元帥 137.647730357|da yuan shuai;
大跃进__大躍進 200.04606951|da yue jin;
大亚湾__大亞灣 107.684208225|da ya wan;
大眼睛__大眼睛 463.341283758|da yan jing;
大药房__大藥房 166.353500999|da yao fang;
大姨妈__大姨媽 201.547419552|da yi ma;
大医院__大醫院 265.450260135|da yi yuan;
打印机__打印機 2056.74313669|da yin ji;
大赢家__大贏家 161.451865638|da ying jia;
答应我__答應我 210.270405333|da ying wo;
打游戏__打遊戲 493.129699012|da you xi;
大问题__大問題 627.992684885|da wen ti;
大舞台__大舞台 145.043940608|da wu tai;
大儿子__大兒子 166.97657743|da er zi;
达尔文__達爾文 159.253810404|da er wen;
代表队__代表隊 197.568631008|dai biao dui;
代表团__代表團 1416.96881393|dai biao tuan;
代表性__代表性 891.318029807|dai biao xing;
代表处__代表處 243.57916235|dai biao chu;
代表作__代表作 437.527796363|dai biao zuo;
代名词__代名詞 400.978810625|dai ming ci;
呆呆的__獃獃的 167.810977762|dai dai de;
带头人__帶頭人 181.064689688|dai tou ren;
代理费__代理費 128.850255419|dai li fei;
代理商__代理商 1674.48601346|dai li shang;
代理人__代理人 692.962351041|dai li ren;
带给你__帶給你 318.815941979|dai gei ni;
带孩子__帶孩子 318.418891685|dai hai zi;
带回家__帶回家 343.567617462|dai hui jia;
待会儿__待會兒 580.575602636|dai hui er;
戴眼镜__戴眼鏡 272.149298879|dai yan jing;
代言人__代言人 644.643863216|dai yan ren;
戴维斯__戴維斯 206.376433771|dai wei si;
戴安娜__戴安娜 121.823518492|dai an na;
蛋白质__蛋白質 1808.98982626|dan bai zhi;
担保人__擔保人 125.992190229|dan bao ren;
但不能__但不能 582.750146437|dan bu neng;
单片机__單片機 647.865219539|dan pian ji;
但目前__但目前 469.151414294|dan mu qian;
单方面__單方面 401.979429753|dan fang mian;
但对于__但對於 762.750126416|dan dui yu;
但他们__但他們 1065.18429118|dan ta men;
但他却__但他卻 174.42055653|dan ta que;
但同时__但同時 460.463257431|dan tong shi;
丹尼斯__丹尼斯 118.972962872|dan ni si;
丹尼尔__丹尼爾 170.977284899|dan ni er;
淡蓝色__淡藍色 112.484875527|dan lan se;
胆固醇__膽固醇 548.230802969|dan gu chun;
但可以__但可以 168.020228531|dan ke yi;
淡黄色__淡黃色 133.758497151|dan huang se;
但还是__但還是 1142.1736421|dan hai shi;
胆红素__膽紅素 125.209594649|dan hong su;
单机版__單機版 187.26053154|dan ji ban;
但现在__但現在 1014.65366219|dan xian zai;
胆小鬼__膽小鬼 112.625137786|dan xiao gui;
蛋炒饭__蛋炒飯 137.134095104|dan chao fan;
单身汉__單身漢 108.763116896|dan shen han;
单元格__單元格 419.900065808|dan yuan ge;
单眼皮__單眼皮 171.403948695|dan yan pi;
但由于__但由於 1903.81812306|dan you yu;
挡不住__擋不住 287.488291405|dang bu zhu;
党代表__黨代表 125.209594649|dang dai biao;
党代会__黨代會 440.262469534|dang dai hui;
当当网__噹噹網 170.339279748|dang dang wang;
当地人__當地人 555.105417084|dang di ren;
当老板__當老闆 221.568841736|dang lao ban;
党工委__黨工委 127.413209251|dang gong wei;
当权者__當權者 119.716577729|dang quan zhe;
党支部__黨支部 630.344829195|dang zhi bu;
党中央__黨中央 902.494832488|dang zhong yang;
党主席__黨主席 120.765453341|dang zhu xi;
当上了__當上了 206.119414554|dang shang le;
当事人__當事人 3102.96674755|dang shi ren;
党总支__黨總支 172.475272126|dang zong zhi;
党组织__黨組織 1017.18567095|dang zu zhi;
档案馆__檔案館 268.778909483|dang an guan;
档案局__檔案局 168.229740225|dang an ju;
到不了__到不了 191.508436159|dao bu liao;
倒不是__倒不是 373.019586361|dao bu shi;
倒不如__倒不如 234.933657026|dao bu ru;
道德观__道德觀 109.852835359|dao de guan;
到底谁__到底誰 132.10198647|dao di shui;
到头来__到頭來 369.319305625|dao tou lai;
到哪去__到哪去 156.89004718|dao na qu;
倒过来__倒過來 175.948711373|dao guo lai;
导航键__導航鍵 106.218162376|dao hang jian;
导火线__導火線 283.927938713|dao huo xian;
导火索__導火索 201.045721733|dao huo suo;
倒计时__倒計時 554.41409416|dao ji shi;
道琼斯__道瓊斯 157.2815571|dao qiong si;
稻草人__稻草人 147.964946673|dao cao ren;
的博客__的博客 3265.62606571|de bo ke;
得不到__得不到 1875.5602418|de bu dao;
德鲁伊__德魯伊 353.998238229|de lu yi;
德罗巴__德羅巴 158.264611567|de luo ba;
德国队__德國隊 385.303469841|de guo dui;
德国人__德國人 719.359091341|de guo ren;
得很好__得很好 696.425160166|de hen hao;
德意志__德意志 192.705418355|de yi zhi;
的一种__的一種 3787.64822853|de yi zhong;
的一员__的一員 494.9767145|de yi yuan;
的用法__的用法 163.476413088|de yong fa;
德尔曼__德爾曼 149.820373083|de er man;
邓丽君__鄧麗君 397.496217848|deng li jun;
等离子__等離子 491.289575698|deng li zi;
登陆器__登陸器 134.259489114|deng lu qi;
登记表__登記表 409.564096466|deng ji biao;
登记证__登記證 106.748946222|deng ji zheng;
邓小平__鄧小平 1170.99812122|deng xiao ping;
等着你__等着你 340.583654043|deng zhe ni;
第八条__第八條 234.056997396|di ba tiao;
第八届__第八屆 227.727332161|di ba jie;
第八章__第八章 201.547419552|di ba zhang;
第八次__第八次 109.442917312|di ba ci;
低保户__低保戶 107.952927857|di bao hu;
地平线__地平線 231.446597362|di ping xian;
低密度__低密度 139.895806636|di mi du;
地方性__地方性 260.859291326|di fang xing;
底特律__底特律 136.963309627|di te lv;
地铁站__地鐵站 471.495815538|di tie zhan;
第六条__第六條 247.866011137|di liu tiao;
第六感__第六感 121.520271774|di liu gan;
第六届__第六屆 354.43965395|di liu jie;
第六章__第六章 297.325836157|di liu zhang;
第六次__第六次 239.963779681|di liu ci;
低功耗__低功耗 161.451865638|di gong hao;
抵抗力__抵抗力 534.069978074|di kang li;
地级市__地級市 185.402943996|di ji shi;
低价股__低價股 188.665925845|di jia gu;
低价位__低價位 190.793818607|di jia wei;
第九条__第九條 231.446597362|di jiu tiao;
第九届__第九屆 242.36802267|di jiu jie;
第九章__第九章 166.560934377|di jiu zhang;
第九次__第九次 117.353228453|di jiu ci;
第七条__第七條 239.664931108|di qi tiao;
第七届__第七屆 286.415523108|di qi jie;
第七章__第七章 253.488718522|di qi zhang;
第七次__第七次 144.322743975|di qi ci;
地球人__地球人 310.194118206|di qiu ren;
地区性__地區性 113.895394799|di qu xing;
低血糖__低血糖 112.065135969|di xue tang;
低下头__低下頭 344.85444872|di xia tou;
地下城__地下城 155.527421199|di xia cheng;
地下室__地下室 593.006203378|di xia shi;
地下水__地下水 443.56664881|di xia shui;
低着头__低着頭 390.621510938|di zhe tou;
地震局__地震局 165.73274959|di zhen ju;
地址栏__地址欄 344.85444872|di zhi lan;
地中海__地中海 364.291279287|di zhong hai;
地产股__地產股 320.808632296|di chan gu;
地产商__地產商 254.121284766|di chan shang;
低成本__低成本 635.075580657|di cheng ben;
第十条__第十條 214.2378495|di shi tiao;
迪士尼__迪士尼 356.210827905|di shi ni;
第十届__第十屆 232.313479749|di shi jie;
第十七__第十七 172.260473089|di shi qi;
第十章__第十章 141.29744947|di shi zhang;
第十次__第十次 108.357265155|di shi ci;
第十三__第十三 130.141230764|di shi san;
第十四__第十四 124.122120652|di shi si;
第十一__第十一 134.762357541|di shi yi;
第十五__第十五 108.222318063|di shi wu;
第十二__第十二 217.465635832|di shi er;
低收入__低收入 595.969520633|di shou ru;
低水平__低水平 183.106850936|di shui ping;
地税局__地稅局 332.614317243|di shui ju;
第三版__第三版 171.190483873|di san ban;
第三部__第三部 206.376433771|di san bu;
第三批__第三批 208.70407676|di san pi;
第三名__第三名 287.130256264|di san ming;
第三方__第三方 1695.48345672|di san fang;
第三大__第三大 263.144763849|di san da;
第三代__第三代 455.327784806|di san dai;
第三天__第三天 504.316081474|di san tian;
第三条__第三條 372.091054935|di san tiao;
第三轮__第三輪 172.905674062|di san lun;
第三集__第三集 109.579386421|di san ji;
第三季__第三季 459.889800938|di san ji;
第三节__第三節 410.07479966|di san jie;
第三届__第三屆 647.865219539|di san jie;
第三期__第三期 160.049619219|di san qi;
第三章__第三章 533.404852483|di san zhang;
第三者__第三者 721.154209805|di san zhe;
第三种__第三種 305.209408115|di san zhong;
第三十__第三十 124.89791921|di san shi;
第三人__第三人 284.281980745|di san ren;
第三次__第三次 1313.24844471|di san ci;
第四大__第四大 117.646076559|di si da;
第四代__第四代 171.617679695|di si dai;
第四条__第四條 277.976239008|di si tiao;
迪斯尼__迪斯尼 528.113581536|di si ni;
第四季__第四季 163.272821143|di si ji;
第四届__第四屆 500.559372647|di si jie;
第四章__第四章 441.911471008|di si zhang;
第四次__第四次 416.253137598|di si ci;
缔约国__締約國 112.765574943|di yue guo;
抵押物__抵押物 108.222318063|di ya wu;
第一百__第一百 422.52456065|di yi bai;
第一版__第一版 219.644465616|di yi ban;
第一本__第一本 170.977284899|di yi ben;
第一笔__第一筆 190.556205829|di yi bi;
第一部__第一部 1000.83985593|di yi bu;
第一步__第一步 1265.05905145|di yi bu;
第一批__第一批 1063.85772095|di yi pi;
第一篇__第一篇 311.355949144|di yi pian;
第一名__第一名 940.382265783|di yi ming;
第一份__第一份 318.418891685|di yi fen;
第一大__第一大 395.519762073|di yi da;
第一代__第一代 425.165459331|di yi dai;
第一点__第一點 164.703307075|di yi dian;
第一套__第一套 157.085680168|di yi tao;
第一天__第一天 1877.89895902|di yi tian;
第一条__第一條 778.110973173|di yi tiao;
第一轮__第一輪 457.603107852|di yi lun;
第一关__第一關 130.791560815|di yi guan;
第一款__第一款 546.866130582|di yi kuan;
第一颗__第一顆 111.369047744|di yi ke;
第一行__第一行 195.121873946|di yi hang;
第一卷__第一卷 179.268563673|di yi juan;
第一集__第一集 401.979429753|di yi ji;
第一季__第一季 452.499534015|di yi ji;
第一家__第一家 783.950712715|di yi jia;
第一节__第一節 508.100984482|di yi jie;
第一届__第一屆 513.191745392|di yi jie;
第一期__第一期 475.626742696|di yi qi;
第一线__第一線 364.291279287|di yi xian;
第一项__第一項 201.296414343|di yi xiang;
第一站__第一站 221.568841736|di yi zhan;
第一章__第一章 802.733930815|di yi zhang;
第一支__第一支 145.950506492|di yi zhi;
第一周__第一周 181.969489867|di yi zhou;
第一种__第一種 546.185068786|di yi zhong;
第一场__第一場 414.183417482|di yi chang;
第一首__第一首 148.149450567|di yi shou;
第一手__第一手 160.649084484|di yi shou;
第一任__第一任 148.889769675|di yi ren;
第一人__第一人 362.479927203|di yi ren;
第一座__第一座 112.34478795|di yi zuo;
第一次__第一次 16075.5329821|di yi ci;
第一眼__第一眼 480.991159713|di yi yan;
第一页__第一頁 412.12398856|di yi ye;
第一位__第一位 1316.52557925|di yi wei;
低音炮__低音炮 109.579386421|di yin pao;
地狱火__地獄火 304.829303266|di yu huo;
第五代__第五代 140.070248771|di wu dai;
第五条__第五條 260.859291326|di wu tiao;
第五届__第五屆 416.253137598|di wu jie;
第五章__第五章 369.319305625|di wu zhang;
第五次__第五次 293.277951001|di wu ci;
第二版__第二版 202.050369328|di er ban;
第二部__第二部 425.69561654|di er bu;
第二批__第二批 479.196331601|di er pi;
第二名__第二名 367.941183266|di er ming;
第二大__第二大 525.487661863|di er da;
第二代__第二代 524.833224606|di er dai;
第二点__第二點 142.003528374|di er dian;
第二套__第二套 225.187525865|di er tao;
第二天__第二天 4470.43378899|di er tian;
第二条__第二條 480.392137969|di er tiao;
第二轮__第二輪 513.831666385|di er lun;
第二款__第二款 163.884358899|di er kuan;
第二卷__第二卷 131.281440129|di er juan;
第二季__第二季 475.626742696|di er ji;
第二节__第二節 444.673543393|di er jie;
第二届__第二屆 712.223191016|di er jie;
第二期__第二期 287.846772995|di er qi;
第二章__第二章 631.917817783|di er zhang;
第二种__第二種 538.078184713|di er zhong;
第二场__第二場 186.097370046|di er chang;
第二层__第二層 167.184787749|di er ceng;
第二次__第二次 3225.18344283|di er ci;
第二页__第二頁 151.132997772|di er ye;
第二位__第二位 398.48814637|di er wei;
电冰箱__電冰箱 143.0692679|dian bing xiang;
电瓶车__電瓶車 117.499561272|dian ping che;
电饭煲__電飯煲 149.633788238|dian fan bao;
电饭锅__電飯鍋 121.217779906|dian fan guo;
电风扇__電風扇 215.040276584|dian feng shan;
电灯泡__電燈泡 115.036534536|dian deng pao;
点点头__點點頭 715.782248677|dian dian tou;
电动机__電動機 284.991389772|dian dong ji;
电动车__電動車 673.382717005|dian dong che;
点对点__點對點 235.519920202|dian dui dian;
电脑报__電腦報 168.439513167|dian nao bao;
电脑里__電腦里 387.22887368|dian nao li;
电脑前__電腦前 452.499534015|dian nao qian;
电脑桌__電腦桌 144.143005824|dian nao zhuo;
电脑城__電腦城 544.146968302|dian nao cheng;
电路板__電路板 308.267359529|dian lu ban;
电路图__電路圖 118.529012887|dian lu tu;
电话本__電話本 131.609045271|dian hua ben;
电话簿__電話簿 125.36572391|dian hua bu;
电话费__電話費 475.626742696|dian hua fei;
电话里__電話里 635.867483878|dian hua li;
电话卡__電話卡 246.94109417|dian hua ka;
电话机__電話機 208.184564378|dian hua ji;
电化学__電化學 111.786180106|dian hua xue;
电话线__電話線 314.867617017|dian hua xian;
点击率__點擊率 602.691239054|dian ji lv;
电解铝__電解鋁 152.077621994|dian jie lv;
电解质__電解質 149.075426771|dian jie zhi;
电线杆__電線杆 176.60772663|dian xian gan;
电信局__電信局 141.473639374|dian xin ju;
电信业__電信業 255.709615075|dian xin ye;
点这里__點這裡 245.71323808|dian zhe li;
电视台__電視台 3126.25457954|dian shi tai;
电视里__電視里 391.596284031|dian shi li;
电视卡__電視卡 167.393257695|dian shi ka;
电视机__電視機 1266.63650832|dian shi ji;
电视剧__電視劇 4317.13844997|dian shi ju;
电容器__電容器 209.485777119|dian rong qi;
电子版__電子版 574.10053635|dian zi ban;
电子化__電子化 198.308623594|dian zi hua;
电子琴__電子琴 107.818484324|dian zi qin;
电子城__電子城 126.937764318|dian zi cheng;
电子书__電子書 1116.83875458|dian zi shu;
电磁波__電磁波 204.584007193|dian ci bo;
电磁阀__電磁閥 110.401782066|dian ci fa;
电磁炉__電磁爐 221.568841736|dian ci lu;
电磁场__電磁場 113.611883002|dian ci chang;
电源线__電源線 257.62872122|dian yuan xian;
电影版__電影版 189.372573382|dian ying ban;
电影票__電影票 247.557321202|dian ying piao;
电影里__電影里 467.400766428|dian ying li;
电影节__電影節 573.385557088|dian ying jie;
电影人__電影人 116.624293448|dian ying ren;
电影院__電影院 1288.92855961|dian ying yuan;
掉下来__掉下來 518.979844093|diao xia lai;
掉下去__掉下去 173.769702743|diao xia qu;
调查表__調查表 206.376433771|diao cha biao;
调查组__調查組 273.509258874|diao cha zu;
掉眼泪__掉眼淚 155.140277726|diao yan lei;
调研组__調研組 141.650048976|diao yan zu;
钓鱼岛__釣魚島 242.066179876|diao yu dao;
钓鱼台__釣魚台 142.713135632|diao yu tai;
跌停板__跌停板 138.163289429|die ting ban;
跌眼镜__跌眼鏡 124.431860131|die yan jing;
订单号__訂單號 133.925286409|ding dan hao;
顶顶顶__頂頂頂 210.795122809|ding ding ding;
丁俊晖__丁俊暉 397.496217848|ding jun hui;
定价权__定價權 107.952927857|ding jia quan;
顶上去__頂上去 226.030964922|ding shang qu;
定时器__定時器 220.742053181|ding shi qi;
丁字裤__丁字褲 130.141230764|ding zi ku;
钉子户__釘子戶 222.67604562|ding zi hu;
顶一下__頂一下 1109.90155418|ding yi xia;
都不敢__都不敢 816.861571886|dou bu gan;
都不是__都不是 1882.58514584|dou bu shi;
豆腐干__豆腐乾 106.218162376|dou fu gan;
斗地主__鬥地主 582.024395035|dou di zhu;
逗你玩__逗你玩 115.899886195|dou ni wan;
豆制品__豆製品 184.941433485|dou zhi pin;
东北部__東北部 207.925293333|dong bei bu;
东北虎__東北虎 105.164499152|dong bei hu;
东北人__東北人 479.196331601|dong bei ren;
东北亚__東北亞 192.705418355|dong bei ya;
动不动__動不動 847.977956119|dong bu dong;
东方红__東方紅 141.650048976|dong fang hong;
董方卓__董方卓 242.066179876|dong fang zhuo;
东方人__東方人 143.963491517|dong fang ren;
东方网__東方網 113.611883002|dong fang wang;
东道主__東道主 278.669912425|dong dao zhu;
洞庭湖__洞庭湖 151.132997772|dong ting hu;
东南部__東南部 183.335174792|dong nan bu;
东南亚__東南亞 1070.5071343|dong nan ya;
动脑筋__動腦筋 155.527421199|dong nao jin;
动力学__動力學 412.637883794|dong li xue;
东莞市__東莞市 534.069978074|dong guan shi;
动画片__動畫片 1136.49445424|dong hua pian;
动起来__動起來 162.86639759|dong qi lai;
东西方__東西方 166.768626413|dong xi fang;
东直门__東直門 267.775955618|dong zhi men;
动植物__動植物 250.037645335|dong zhi wu;
洞察力__洞察力 162.258658377|dong cha li;
动车组__動車組 276.594068012|dong che zu;
东城区__東城區 227.443722742|dong cheng qu;
董事会__董事會 2003.61737423|dong shi hui;
董事局__董事局 169.703655326|dong shi ju;
董事长__董事長 3153.64470585|dong shi zhang;
动手术__動手術 147.045868173|dong shou shu;
动作片__動作片 203.313241605|dong zuo pian;
动员会__動員會 113.046974828|dong yuan hui;
动物性__動物性 119.41857567|dong wu xing;
动物园__動物園 843.76158662|dong wu yuan;
冬奥会__冬奧會 123.197520618|dong ao hui;
读博士__讀博士 131.773154284|du bo shi;
肚皮舞__肚皮舞 116.47905068|du pi wu;
读大学__讀大學 311.355949144|du da xue;
督导组__督導組 117.93965545|du dao zu;
独特性__獨特性 121.520271774|du te xing;
独立性__獨立性 376.287731462|du li xing;
读卡器__讀卡器 673.382717005|du ka qi;
读后感__讀後感 145.224802174|du hou gan;
度假区__度假區 113.187937993|du jia qu;
度假村__度假村 318.022335873|du jia cun;
都江堰__都江堰 381.006242235|du jiang yan;
杜琪峰__杜琪峰 131.117943492|du qi feng;
督查组__督查組 123.658956482|du cha zu;
都市报__都市報 109.989815613|du shi bao;
读书人__讀書人 228.580284053|du shu ren;
肚子疼__肚子疼 188.665925845|du zi teng;
肚子痛__肚子痛 132.596773978|du zi tong;
肚子里__肚子里 529.431458035|du zi li;
肚子上__肚子上 116.333988795|du zi shang;
独裁者__獨裁者 118.676811842|du cai zhe;
多边形__多邊形 150.007190589|duo bian xing;
多不多__多不多 224.347234118|duo bu duo;
多普达__多普達 1092.0658276|duo pu da;
多普勒__多普勒 148.889769675|duo pu le;
多媒体__多媒體 1986.21549859|duo mei ti;
多方面__多方面 841.661270235|duo fang mian;
多得多__多得多 159.651218957|duo de duo;
多得是__多得是 125.992190229|duo de shi;
多年来__多年來 1422.27606545|duo nian lai;
多年前__多年前 651.102673334|duo nian qian;
多伦多__多倫多 439.714170908|duo lun duo;
多功能__多功能 1050.68254543|duo gong neng;
多喝水__多喝水 277.630050085|duo he shui;
多角度__多角度 152.457122789|duo jiao du;
多晶硅__多晶硅 183.106850936|duo jing gui;
多渠道__多渠道 212.377144726|duo qu dao;
多学科__多學科 106.350610398|duo xue ke;
多线程__多線程 299.1842072|duo xian cheng;
多小时__多小時 959.320404733|duo xiao shi;
多少分__多少分 189.372573382|duo shao fen;
多少天__多少天 153.218967809|duo shao tian;
多少级__多少級 280.761336094|duo shao ji;
多少钱__多少錢 5076.35979838|duo shao qian;
多少人__多少人 997.105202031|duo shao ren;
多少次__多少次 582.750146437|duo shao ci;
多数人__多數人 494.360275282|duo shu ren;
多层次__多層次 417.291872914|duo ceng ci;
多元化__多元化 1296.98472971|duo yuan hua;
多样化__多樣化 722.053448193|duo yang hua;
多样性__多樣性 461.037428991|duo yang xing;
多一点__多一點 819.921123923|duo yi dian;
多用途__多用途 193.427195796|duo yong tu;
多用户__多用戶 186.794397067|duo yong hu;
多尔衮__多爾袞 111.369047744|duo er gun;
对比度__對比度 402.480675297|dui bi du;
对不起__對不起 6282.00312169|dui bu qi;
对不住__對不住 276.594068012|dui bu zhu;
对不上__對不上 140.594881376|dui bu shang;
兑美元__兌美元 230.582949765|dui mei yuan;
对得起__對得起 566.990680223|dui de qi;
对她说__對她說 410.586139672|dui ta shuo;
对他说__對他說 522.874798954|dui ta shuo;
对你说__對你說 409.564096466|dui ni shuo;
对立面__對立面 140.594881376|dui li mian;
对抗赛__對抗賽 120.46484039|dui kang sai;
对话框__對話框 1319.8108917|dui hua kuang;
对讲机__對講機 268.778909483|dui jiang ji;
对账单__對賬單 151.510141313|dui zhang dan;
对照组__對照組 325.642053285|dui zhao zu;
对手戏__對手戲 148.149450567|dui shou xi;
对我说__對我說 1538.43695969|dui wo shuo;
团团转__團團轉 114.179614083|tuan tuan zhuan;
团支部__團支部 131.445140637|tuan zhi bu;
团中央__團中央 105.426930997|tuan zhong yang;
团市委__團市委 107.14877401|tuan shi wei;
团组织__團組織 174.855812809|tuan zu zhi;
吞吐量__吞吐量 302.935867929|tun tu liang;
他妈的__他媽的 1725.32295995|ta ma de;
他们俩__他們倆 280.761336094|ta men lia;
他们将__他們將 445.228026075|ta men jiang;
他的心__他的心 263.144763849|ta de xin;
她的手__她的手 455.895552723|ta de shou;
他的手__他的手 501.183541788|ta de shou;
塔利班__塔利班 243.57916235|ta li ban;
他和她__他和她 116.044406778|ta he ta;
他一眼__他一眼 294.009808944|ta yi yan;
太棒了__太棒了 243.57916235|tai bang le;
台北市__台北市 228.011295226|tai bei shi;
太平洋__太平洋 1723.1742594|tai ping yang;
太大的__太大的 607.214449729|tai da de;
太多的__太多的 1526.97696483|tai duo de;
抬头看__抬頭看 281.812926654|tai tou kan;
太行山__太行山 107.684208225|tai hang shan;
钛合金__鈦合金 108.087539034|tai he jin;
太极拳__太極拳 346.577724349|tai ji quan;
跆拳道__跆拳道 364.291279287|tai quan dao;
抬起头__抬起頭 672.544092675|tai qi tou;
台州市__台州市 174.203334854|tai zhou shi;
太少了__太少了 627.992684885|tai shao le;
台式机__台式機 1078.5413133|tai shi ji;
太在意__太在意 240.562595233|tai zai yi;
太原市__太原市 299.1842072|tai yuan shi;
太阳队__太陽隊 142.357889859|tai yang dui;
太阳能__太陽能 1122.41972073|tai yang neng;
太阳光__太陽光 125.053659829|tai yang guang;
太阳镜__太陽鏡 164.703307075|tai yang jing;
太阳穴__太陽穴 136.452228303|tai yang xue;
太阳系__太陽系 245.407229187|tai yang xi;
太阳神__太陽神 111.369047744|tai yang shen;
台湾省__台灣省 154.176629937|tai wan sheng;
台湾人__台灣人 706.037369534|tai wan ren;
谈不上__談不上 833.312156414|tan bu shang;
谈恋爱__談戀愛 1022.26865969|tan lian ai;
弹钢琴__彈鋼琴 127.890434962|tan gang qin;
叹口气__嘆口氣 129.494134325|tan kou qi;
碳纤维__碳纖維 139.200207879|tan xian wei;
弹出来__彈出來 115.611384758|tan chu lai;
坛子里__罈子里 150.756793028|tan zi li;
探测器__探測器 381.481335404|tan ce qi;
谈一谈__談一談 166.560934377|tan yi tan;
谭咏麟__譚詠麟 277.284292303|tan yong lin;
唐伯虎__唐伯虎 183.563783354|tang bo hu;
唐太宗__唐太宗 170.76435144|tang tai zong;
糖尿病__糖尿病 1083.93090293|tang niao bing;
唐山市__唐山市 156.109948588|tang shan shi;
唐人街__唐人街 155.72135507|tang ren jie;
淘宝网__淘寶網 393.553133755|tao bao wang;
淘汰赛__淘汰賽 152.837570606|tao tai sai;
讨论会__討論會 155.915530766|tao lun hui;
讨论区__討論區 381.957020988|tao lun qu;
桃花源__桃花源 161.854759309|tao hua yuan;
桃花运__桃花運 129.817279349|tao hua yun;
陶渊明__陶淵明 146.679837233|tao yuan ming;
掏腰包__掏腰包 118.824795093|tao yao bao;
特别版__特別版 136.792736844|te bie ban;
特大型__特大型 105.690017726|te da xing;
特洛伊__特洛伊 122.279808036|te luo yi;
特种兵__特種兵 113.895394799|te zhong bing;
特殊性__特殊性 465.076726846|te shu xing;
特异性__特異性 260.534419685|te yi xing;
特奥会__特奧會 107.550099352|te ao hui;
替代品__替代品 220.19257551|ti dai pin;
提供者__提供者 278.322859608|ti gong zhe;
提供商__提供商 792.79260104|ti gong shang;
体积小__體積小 134.930398555|ti ji xiao;
提取物__提取物 169.915266157|ti qu wu;
体现出__體現出 781.999279332|ti xian chu;
剃须刀__剃鬚刀 156.304608838|ti xu dao;
提出来__提出來 728.379591714|ti chu lai;
踢足球__踢足球 147.412812521|ti zu qiu;
替罪羊__替罪羊 111.925571131|ti zui yang;
提意见__提意見 266.444503116|ti yi jian;
体育馆__體育館 765.607004232|ti yu guan;
体育课__體育課 224.347234118|ti yu ke;
体育局__體育局 211.848489234|ti yu ju;
体育场__體育場 642.238361775|ti yu chang;
题外话__題外話 127.73116145|ti wai hua;
添麻烦__添麻煩 128.529517539|tian ma fan;
甜蜜蜜__甜蜜蜜 137.476305203|tian mi mi;
天地间__天地間 169.492308033|tian di jian;
天底下__天底下 169.070402749|tian di xia;
甜甜的__甜甜的 223.231720645|tian tian de;
天通苑__天通苑 178.155043976|tian tong yuan;
天花板__天花板 459.317058623|tian hua ban;
天河区__天河區 195.121873946|tian he qu;
添加剂__添加劑 391.596284031|tian jia ji;
天津队__天津隊 149.447435764|tian jin dui;
天津港__天津港 210.270405333|tian jin gang;
天津市__天津市 1263.48355913|tian jin shi;
天下人__天下人 134.762357541|tian xia ren;
天蝎座__天蠍座 340.583654043|tian xie zuo;
天知道__天知道 192.945711079|tian zhi dao;
天之内__天之內 170.977284899|tian zhi nei;
天主教__天主教 266.112675706|tian zhu jiao;
天秤座__天秤座 227.160466527|tian cheng zuo;
天上掉__天上掉 116.044406778|tian shang diao;
天然气__天然氣 1227.78386251|tian ran qi;
天涯路__天涯路 257.94996962|tian ya lu;
天文台__天文台 127.73116145|tian wen tai;
天文学__天文學 139.373782642|tian wen xue;
天安门__天安門 524.833224606|tian an men;
条短信__條短信 250.037645335|tiao duan xin;
条规定__條規定 426.226434824|tiao gui ding;
跳起来__跳起來 306.352568839|tiao qi lai;
跳下去__跳下去 206.89143407|tiao xia qu;
条形码__條形碼 250.349428094|tiao xing ma;
挑战性__挑戰性 318.418891685|tiao zhan xing;
挑战赛__挑戰賽 156.109948588|tiao zhan sai;
跳出来__跳出來 548.914415679|tiao chu lai;
调味品__調味品 190.556205829|tiao wei pin;
调味料__調味料 122.890853693|tiao wei liao;
铁道部__鐵道部 467.400766428|tie dao bu;
铁炉堡__鐵爐堡 121.520271774|tie lu bao;
铁路局__鐵路局 184.71110921|tie lu ju;
铁观音__鐵觀音 187.26053154|tie guan yin;
铁矿石__鐵礦石 451.373158744|tie kuang shi;
铁三角__鐵三角 150.194241046|tie san jiao;
听不到__聽不到 774.242000696|ting bu dao;
听不懂__聽不懂 893.542261726|ting bu dong;
听不见__聽不見 431.571158705|ting bu jian;
听起来__聽起來 1175.38409041|ting qi lai;
停下来__停下來 785.907015785|ting xia lai;
听证会__聽證會 489.456318842|ting zheng hui;
停车费__停車費 169.070402749|ting che fei;
停车场__停車場 878.088426229|ting che chang;
停车位__停車位 208.184564378|ting che wei;
听上去__聽上去 263.144763849|ting shang qu;
听音乐__聽音樂 419.900065808|ting yin yue;
听我说__聽我說 147.045868173|ting wo shuo;
投保人__投保人 220.467143161|tou bao ren;
投标人__投標人 259.562230298|tou biao ren;
透明度__透明度 526.798985534|tou ming du;
头等舱__頭等艙 117.499561272|tou deng cang;
偷东西__偷東西 108.357265155|tou dong xi;
偷偷的__偷偷的 177.933171406|tou tou de;
投机性__投機性 107.818484324|tou ji xing;
投机者__投機者 148.149450567|tou ji zhe;
投简历__投簡歷 119.86585751|tou jian li;
偷着乐__偷着樂 113.47039186|tou zhe le;
投注站__投注站 110.401782066|tou zhu zhan;
投融资__投融資 200.545272755|tou rong zi;
投资方__投資方 267.44247003|tou zi fang;
投资者__投資者 8242.90797407|tou zi zhe;
投资商__投資商 234.056997396|tou zi shang;
投资人__投資人 830.202635471|tou zi ren;
投资额__投資額 273.168633085|tou zi e;
投影机__投影機 665.043316617|tou ying ji;
投影仪__投影儀 257.94996962|tou ying yi;
头文件__頭文件 180.164388413|tou wen jian;
头文字__頭文字 130.791560815|tou wen zi;
佟大为__佟大為 194.151676652|tong da wei;
通电话__通電話 318.022335873|tong dian hua;
同类型__同類型 158.461958559|tong lei xing;
同龄人__同齡人 311.744192349|tong ling ren;
铜锣湾__銅鑼灣 130.954650472|tong luo wan;
通过率__通過率 118.08671951|tong guo lv;
同花顺__同花順 301.054193591|tong hua shun;
同行业__同行業 359.779772295|tong hang ye;
统计表__統計表 242.066179876|tong ji biao;
通缉令__通緝令 123.044091616|tong ji ling;
统计局__統計局 389.163898974|tong ji ju;
统计学__統計學 282.868455943|tong ji xue;
同情心__同情心 297.325836157|tong qing xin;
同学录__同學錄 187.727829225|tong xue lu;
同学会__同學會 176.827946446|tong xue hui;
通讯录__通訊錄 642.238361775|tong xun lu;
通讯社__通訊社 172.04594156|tong xun she;
通讯员__通訊員 786.88699725|tong xun yuan;
通行费__通行費 106.616002115|tong xing fei;
同性恋__同性戀 1866.23446282|tong xing lian;
通行证__通行證 581.299547476|tong xing zheng;
统战部__統戰部 146.314717429|tong zhan bu;
通知单__通知單 230.870473623|tong zhi dan;
同质化__同質化 237.879639313|tong zhi hua;
统治者__統治者 519.626982517|tong zhi zhe;
通知书__通知書 771.352901218|tong zhi shu;
通州区__通州區 136.452228303|tong zhou qu;
同时代__同時代 122.432284019|tong shi dai;
同时又__同時又 643.039196578|tong shi you;
同仁堂__同仁堂 140.419785869|tong ren tang;
同人女__同人女 130.791560815|tong ren nv;
同一天__同一天 288.924902033|tong yi tian;
同一条__同一條 112.484875527|tong yi tiao;
同一种__同一種 223.231720645|tong yi zhong;
同义词__同義詞 128.850255419|tong yi ci;
同位素__同位素 142.180598718|tong wei su;
突破口__突破口 439.166555128|tu po kou;
突破性__突破性 303.313611771|tu po xing;
突发性__突發性 172.475272126|tu fa xing;
土豆丝__土豆絲 111.646962678|tu dou si;
土豆网__土豆網 268.109857044|tu dou wang;
土特产__土特產 118.381397999|tu te chan;
突尼斯__突尼斯 133.925286409|tu ni si;
吐鲁番__吐魯番 134.930398555|tu lu fan;
突击队__突擊隊 106.085879302|tu ji dui;
土家族__土家族 109.716025699|tu jia zu;
图形化__圖形化 121.975425508|tu xing hua;
图书馆__圖書館 3527.93889096|tu shu guan;
突然间__突然間 496.21189989|tu ran jian;
屠宰场__屠宰場 105.558392399|tu zai chang;
图文版__圖文版 147.964946673|tu wen ban;
土耳其__土耳其 852.21539528|tu er qi;
托马斯__托馬斯 250.349428094|tuo ma si;
拖拉机__拖拉機 590.057620516|tuo la ji;
托管人__託管人 129.332863581|tuo guan ren;
脱光了__脫光了 108.087539034|tuo guang le;
拖出去__拖出去 134.259489114|tuo chu qu;
椭圆形__橢圓形 191.031727675|tuo yuan xing;
脱衣服__脫衣服 205.094534596|tuo yi fu;
脱衣舞__脫衣舞 123.813152185|tuo yi wu;
推动力__推動力 208.184564378|tui dong li;
推土机__推土機 109.852835359|tui tu ji;
退回来__退回來 118.676811842|tui hui lai;
推荐信__推薦信 173.121277629|tui jian xin;
推介会__推介會 225.749468142|tui jie hui;
推销员__推銷員 232.313479749|tui xiao yuan;
退休金__退休金 203.313241605|tui xiu jin;
退一步__退一步 188.665925845|tui yi bu;
暖暖的__暖暖的 250.037645335|nuan nuan de;
女博士__女博士 132.762114633|nv bo shi;
女朋友__女朋友 6432.51798548|nv peng you;
女秘书__女秘書 107.416157498|nv mi shu;
女明星__女明星 354.881620091|nv ming xing;
女同学__女同學 448.010827873|nv tong xue;
女同志__女同志 183.792676978|nv tong zhi;
女同事__女同事 244.796354228|nv tong shi;
女老板__女老闆 113.187937993|nv lao ban;
女老师__女老師 169.492308033|nv lao shi;
女歌手__女歌手 332.614317243|nv ge shou;
女孩子__女孩子 6013.89768231|nv hai zi;
女孩儿__女孩兒 417.812212206|nv hai er;
女记者__女記者 163.476413088|nv ji zhe;
女教师__女教師 253.488718522|nv jiao shi;
女强人__女強人 267.109399762|nv qiang ren;
女青年__女青年 242.36802267|nv qing nian;
女学生__女學生 309.807805448|nv xue sheng;
女性化__女性化 145.043940608|nv xing hua;
女职工__女職工 180.613978088|nv zhi gong;
女主播__女主播 112.625137786|nv zhu bo;
女主角__女主角 1440.11088805|nv zhu jue;
女主人__女主人 248.175085992|nv zhu ren;
女人是__女人是 211.584655172|nv ren shi;
女人味__女人味 348.309611377|nv ren wei;
女作家__女作家 192.945711079|nv zuo jia;
女演员__女演員 569.114341748|nv yan yuan;
女艺人__女藝人 187.961915178|nv yi ren;
拿不到__拿不到 506.204995518|na bu dao;
拿破仑__拿破崙 316.046952528|na po lun;
那么大__那麼大 1123.81931445|na me da;
那么难__那麼難 156.109948588|na me nan;
那么好__那麼好 808.758466182|na me hao;
那么远__那麼遠 291.093289619|na me yuan;
纳达尔__納達爾 194.636170786|na da er;
那女人__那女人 256.987424161|na nv ren;
哪里去__哪裡去 282.516174301|na li qu;
哪里人__哪裡人 203.566761683|na li ren;
哪个好__哪個好 158.264611567|na ge hao;
那个人__那個人 2038.87985164|na ge ren;
拿回去__拿回去 159.85029497|na hui qu;
那会儿__那會兒 349.614203755|na hui er;
那几个__那幾個 972.56115063|na ji ge;
那家伙__那傢伙 386.746622582|na jia huo;
那就是__那就是 4769.71285751|na jiu shi;
那句话__那句話 891.318029807|na ju hua;
那小子__那小子 271.133768339|na xiao zi;
哪些人__哪些人 205.862715427|na xie ren;
那些人__那些人 890.207990943|na xie ren;
拿出来__拿出來 1808.98982626|na chu lai;
拿什么__拿什麼 403.48504224|na shen me;
那时候__那時候 2180.80386611|na shi hou;
那是我__那是我 431.571158705|na shi wo;
那首歌__那首歌 242.36802267|na shou ge;
纳税人__納稅人 1254.07172395|na shui ren;
那样子__那樣子 241.463621556|na yang zi;
那也是__那也是 587.855808729|na ye shi;
哪一天__哪一天 293.643651968|na yi tian;
那一天__那一天 1066.51251556|na yi tian;
那一年__那一年 485.205278648|na yi nian;
那一刻__那一刻 1359.87999657|na yi ke;
那一种__那一種 174.638049069|na yi zhong;
那一次__那一次 201.79873775|na yi ci;
那一夜__那一夜 176.827946446|na yi ye;
那我就__那我就 658.446218066|na wo jiu;
耐不住__耐不住 181.969489867|nai bu zhu;
耐高温__耐高溫 108.222318063|nai gao wen;
奶制品__奶製品 150.569041974|nai zhi pin;
耐药性__耐藥性 108.898738333|nai yao xing;
南北朝__南北朝 123.967540162|nan bei chao;
难不成__難不成 323.216307961|nan bu cheng;
男朋友__男朋友 5289.46932136|nan peng you;
南美洲__南美洲 141.29744947|nan mei zhou;
南方人__南方人 277.976239008|nan fang ren;
男同学__男同學 214.504991945|nan tong xue;
南通市__南通市 172.260473089|nan tong shi;
南宁市__南寧市 367.482952871|nan ning shi;
男歌手__男歌手 138.680779525|nan ge shou;
男孩子__男孩子 1209.56018338|nan hai zi;
男孩儿__男孩兒 119.56748386|nan hai er;
南京路__南京路 212.112652282|nan jing lu;
南京市__南京市 802.733930815|nan jing shi;
南京人__南京人 122.279808036|nan jing ren;
男青年__男青年 178.155043976|nan qing nian;
男主角__男主角 1109.90155418|nan zhu jue;
南昌市__南昌市 288.924902033|nan chang shi;
南山区__南山區 190.318888971|nan shan qu;
男人不__男人不 125.678566729|nan ren bu;
男人都__男人都 303.313611771|nan ren dou;
男人味__男人味 118.381397999|nan ren wei;
男子汉__男子漢 298.439468992|nan zi han;
男演员__男演員 225.749468142|nan yan yuan;
难为情__難為情 141.650048976|nan wei qing;
脑白金__腦白金 197.568631008|nao bai jin;
脑梗死__腦梗死 119.121315407|nao geng si;
脑海里__腦海里 532.740555233|nao hai li;
脑细胞__腦細胞 234.64107292|nao xi bao;
脑出血__腦出血 133.259374649|nao chu xue;
脑子里__腦子裡 803.734894488|nao zi li;
能买到__能買到 335.110594827|neng mai dao;
能拿到__能拿到 250.974160423|neng na dao;
能力强__能力強 451.935995467|neng li qiang;
能力差__能力差 128.689786556|neng li cha;
能见度__能見度 157.477678279|neng jian du;
能上网__能上網 175.948711373|neng shang wang;
内蒙古__內蒙古 1509.94683642|nei meng gu;
内分泌__內分泌 440.811451858|nei fen mi;
内贾德__內賈德 126.779677253|nei jia de;
那时候__那時候 2180.80386611|nei shi hou;
内燃机__內燃機 107.818484324|nei ran ji;
内容均__內容均 659.267263146|nei rong jun;
内存条__內存條 270.458854115|nei cun tiao;
内斯塔__內斯塔 127.890434962|nei si ta;
尼泊尔__尼泊爾 356.655002599|ni bo er;
你不是__你不是 3510.3970506|ni bu shi;
你不在__你不在 216.924313917|ni bu zai;
你们好__你們好 179.492101402|ni men hao;
你的心__你的心 475.626742696|ni de xin;
你的手__你的手 328.086003878|ni de shou;
你的爱__你的愛 279.017397997|ni de ai;
尼罗河__尼羅河 117.207077876|ni luo he;
尼古丁__尼古丁 119.26985293|ni gu ding;
你快乐__你快樂 130.141230764|ni kuai le;
尼克斯__尼克斯 110.264288753|ni ke si;
尼克松__尼克松 141.29744947|ni ke song;
你还会__你還會 214.772467501|ni hai hui;
你好吗__你好嗎 182.423584067|ni hao ma;
你好啊__你好啊 307.883446338|ni hao a;
霓虹灯__霓虹燈 163.476413088|ni hong deng;
你就会__你就會 713.111292931|ni jiu hui;
你想要__你想要 579.130416613|ni xiang yao;
泥石流__泥石流 194.878871049|ni shi liu;
逆时针__逆時針 140.070248771|ni shi zhen;
你是谁__你是誰 134.930398555|ni shi shei;
你是谁__你是誰 461.61231651|ni shi shui;
你是我__你是我 562.066236349|ni shi wo;
你说的__你說的 1850.02578923|ni shuo de;
你说过__你說過 203.313241605|ni shuo guo;
你说我__你說我 363.384474622|ni shuo wo;
你走了__你走了 116.915322539|ni zou le;
你以为__你以為 1358.18641516|ni yi wei;
你爱我__你愛我 135.773751924|ni ai wo;
尼尔森__尼爾森 116.333988795|ni er sen;
年代末__年代末 277.630050085|nian dai mo;
年代初__年代初 432.109303457|nian dai chu;
年底前__年底前 386.264972075|nian di qian;
年龄段__年齡段 347.00988711|nian ling duan;
年轻化__年輕化 128.209578049|nian qing hua;
年轻人__年輕人 4127.74310357|nian qing ren;
年休假__年休假 188.665925845|nian xiu jia;
年终奖__年終獎 267.109399762|nian zhong jiang;
年产值__年產值 140.945727665|nian chan zhi;
年月日__年月日 128.209578049|nian yue ri;
年夜饭__年夜飯 194.878871049|nian ye fan;
尿毒症__尿毒症 120.765453341|niao du zheng;
娘娘腔__娘娘腔 106.350610398|niang niang qiang;
您必须__您必須 198.308623594|nin bi xu;
您没有__您沒有 220.19257551|nin mei you;
您需要__您需要 720.256091319|nin xu yao;
您尚未__您尚未 189.608710238|nin shang wei;
宁波市__寧波市 488.846754671|ning bo shi;
柠檬汁__檸檬汁 118.529012887|ning meng zhi;
凝聚力__凝聚力 522.223615731|ning ju li;
牛皮癣__牛皮癬 125.678566729|niu pi xuan;
牛魔王__牛魔王 111.646962678|niu mo wang;
牛肉面__牛肉麵 185.634130949|niu rou mian;
牛肉干__牛肉乾 167.393257695|niu rou gan;
牛仔裤__牛仔褲 773.277767188|niu zai ku;
纽约市__紐約市 122.279808036|niu yue shi;
农民工__農民工 2470.2273797|nong min gong;
农牧民__農牧民 259.238974004|nong mu min;
农牧业__農牧業 160.449013667|nong mu ye;
浓浓的__濃濃的 490.066643104|nong nong de;
农科院__農科院 148.704343794|nong ke yuan;
农家乐__農家樂 237.879639313|nong jia le;
农信社__農信社 119.716577729|nong xin she;
农产品__農產品 2306.59185226|nong chan pin;
农作物__農作物 499.935980841|nong zuo wu;
农业部__農業部 668.366611253|nong ye bu;
农业厅__農業廳 138.335571213|nong ye ting;
农业局__農業局 302.558594526|nong ye ju;
农业税__農業稅 205.862715427|nong ye shui;
诺贝尔__諾貝爾 372.091054935|nuo bei er;
诺基亚__諾基亞 3030.36024751|nuo ji ya;
乱收费__亂收費 338.890182508|luan shou fei;
乱糟糟__亂糟糟 129.817279349|luan zao zao;
论坛里__論壇里 461.037428991|lun tan li;
伦理学__倫理學 144.322743975|lun li xue;
论文集__論文集 134.259489114|lun wen ji;
滤波器__濾波器 328.495108513|lv bo qi;
绿帽子__綠帽子 129.979154132|lv mao zi;
绿豆汤__綠豆湯 113.47039186|lv dou tang;
绿化带__綠化帶 143.605133321|lv hua dai;
铝合金__鋁合金 491.289575698|lv he jin;
旅行团__旅行團 164.088713397|lv xing tuan;
旅行者__旅行者 148.704343794|lv xing zhe;
旅行社__旅行社 2006.11577143|lv xing she;
吕秀莲__呂秀蓮 114.179614083|lv xiu lian;
绿色版__綠色版 239.068350048|lv se ban;
旅游团__旅遊團 179.71591787|lv you tuan;
旅游节__旅遊節 135.435779871|lv you jie;
旅游局__旅遊局 491.902185928|lv you ju;
旅游区__旅遊區 293.643651968|lv you qu;
旅游者__旅遊者 312.911829085|lv you zhe;
旅游业__旅遊業 738.432842998|lv you ye;
绿油油__綠油油 106.218162376|lv you you;
旅游网__旅遊網 130.303509496|lv you wang;
拉肚子__拉肚子 476.219822262|la du zi;
啦啦队__啦啦隊 151.888225993|la la dui;
啦啦啦__啦啦啦 604.195219728|la la la;
垃圾堆__垃圾堆 144.682892926|la ji dui;
垃圾桶__垃圾桶 378.63963681|la ji tong;
垃圾股__垃圾股 282.868455943|la ji gu;
垃圾箱__垃圾箱 179.71591787|la ji xiang;
垃圾场__垃圾場 117.353228453|la ji chang;
拉齐奥__拉齊奧 160.649084484|la qi ao;
拉出去__拉出去 151.699065864|la chu qu;
来表示__來表示 242.670241844|lai biao shi;
来不及__來不及 2332.60704332|lai bu ji;
来访者__來訪者 112.34478795|lai fang zhe;
来得及__來得及 1637.34374958|lai de ji;
来电话__來電話 394.535222541|lai dian hua;
来看你__來看你 194.151676652|lai kan ni;
来看看__來看看 1623.12304424|lai kan kan;
癞蛤蟆__癩蛤蟆 122.890853693|lai ha ma;
来衡量__來衡量 387.711726118|lai heng liang;
来形容__來形容 849.035336524|lai xing rong;
来这里__來這裡 1107.13875428|lai zhe li;
赖昌星__賴昌星 129.010924378|lai chang xing;
来实现__來實現 837.47630896|lai shi xian;
来参加__來參加 290.0070692|lai can jia;
来源于__來源於 1128.02857559|lai yuan yu;
来月经__來月經 155.72135507|lai yue jing;
来完成__來完成 516.399339766|lai wan cheng;
蓝宝石__藍寶石 254.438159592|lan bao shi;
兰帕德__蘭帕德 188.196293023|lan pa de;
篮球队__籃球隊 143.247667161|lan qiu dui;
篮球场__籃球場 257.94996962|lan qiu chang;
篮球赛__籃球賽 119.41857567|lan qiu sai;
兰州市__蘭州市 236.696839161|lan zhou shi;
蓝筹股__藍籌股 655.989212862|lan chou gu;
懒洋洋__懶洋洋 223.510077937|lan yang yang;
烂尾楼__爛尾樓 106.350610398|lan wei lou;
郎咸平__郎咸平 309.807805448|lang xian ping;
老百姓__老百姓 4543.4453536|lao bai xing;
老版本__老版本 147.229226029|lao ban ben;
老半天__老半天 117.353228453|lao ban tian;
老板娘__老闆娘 657.626195507|lao ban niang;
老北京__老北京 162.460985719|lao bei jing;
老朋友__老朋友 625.649317648|lao peng you;
老婆婆__老婆婆 251.287110964|lao po po;
老房子__老房子 234.933657026|lao fang zi;
老妇人__老婦人 118.972962872|lao fu ren;
老大哥__老大哥 131.445140637|lao da ge;
老大爷__老大爺 124.89791921|lao da ye;
老党员__老黨員 109.30661816|lao dang yuan;
老地方__老地方 197.322580943|lao di fang;
劳动法__勞動法 429.425273358|lao dong fa;
劳动力__勞動力 1753.50110433|lao dong li;
劳动节__勞動節 167.393257695|lao dong jie;
劳动局__勞動局 209.224885556|lao dong ju;
劳动者__勞動者 1815.76539105|lao dong zhe;
老太婆__老太婆 328.904723278|lao tai po;
老太太__老太太 1258.76884501|lao tai tai;
老天爷__老天爺 285.346757867|lao tian ye;
老头子__老頭子 483.394725468|lao tou zi;
老头儿__老頭兒 117.353228453|lao tou er;
老同学__老同學 353.998238229|lao tong xue;
老同志__老同志 297.325836157|lao tong zhi;
老女人__老女人 230.582949765|lao nv ren;
老奶奶__老奶奶 180.839193473|lao nai nai;
老男人__老男人 341.433560596|lao nan ren;
老年人__老年人 1334.69654755|lao nian ren;
劳伦斯__勞倫斯 142.003528374|lao lun si;
老龄化__老齡化 150.569041974|lao ling hua;
老干部__老幹部 324.83145542|lao gan bu;
老股民__老股民 145.043940608|lao gu min;
老客户__老客戶 333.860122955|lao ke hu;
老和尚__老和尚 163.680258901|lao he shang;
老虎机__老虎機 181.742866823|lao hu ji;
老教授__老教授 112.765574943|lao jiao shou;
老前辈__老前輩 121.217779906|lao qian bei;
老先生__老先生 559.968874971|lao xian sheng;
老照片__老照片 157.67404401|lao zhao pian;
老城区__老城區 194.636170786|lao cheng qu;
老实话__老實話 129.332863581|lao shi hua;
老师教__老師教 105.953760973|lao shi jiao;
老实人__老實人 223.788782324|lao shi ren;
老人家__老人家 1493.10664229|lao ren jia;
老字号__老字號 275.905561849|lao zi hao;
老祖宗__老祖宗 209.224885556|lao zu zong;
老样子__老樣子 450.24958728|lao yang zi;
老爷子__老爺子 392.084582382|lao ye zi;
老爷爷__老爺爺 156.304608838|lao ye ye;
老一辈__老一輩 242.36802267|lao yi bei;
老友记__老友記 150.194241046|lao you ji;
劳务费__勞務費 128.049907079|lao wu fei;
乐呵呵__樂呵呵 143.963491517|le he he;
了新的__了新的 1474.61550226|le xin de;
了一场__了一場 948.621258606|le yi chang;
冷冰冰__冷冰冰 186.794397067|leng bing bing;
冷冷的__冷冷的 327.677408739|leng leng de;
冷空气__冷空氣 305.589986932|leng kong qi;
冷笑话__冷笑話 169.915266157|leng xiao hua;
类风湿__類風濕 114.893269147|lei feng shi;
雷阵雨__雷陣雨 128.529517539|lei zhen yu;
黎巴嫩__黎巴嫩 435.352293046|li ba nen;
礼拜天__禮拜天 247.557321202|li bai tian;
礼拜六__禮拜六 196.341441156|li bai liu;
礼拜一__禮拜一 178.155043976|li bai yi;
礼拜五__禮拜五 150.944778196|li bai wu;
利比亚__利比亞 172.475272126|li bi ya;
李冰冰__李冰冰 257.3078729|li bing bing;
离不开__離不開 1354.80557722|li bu kai;
里没有__里沒有 266.112675706|li mei you;
理发店__理髮店 189.136730609|li fa dian;
理发师__理髮師 156.499511818|li fa shi;
立方米__立方米 513.191745392|li fang mi;
李登辉__李登輝 296.216358865|li deng hui;
锂电池__鋰電池 312.132919672|li dian chi;
立陶宛__立陶宛 109.716025699|li tao wan;
立体感__立體感 132.596773978|li ti gan;
立体声__立體聲 355.324137339|li ti sheng;
离退休__離退休 197.322580943|li tui xiu;
历年来__歷年來 114.46454262|li nian lai;
理论家__理論家 113.046974828|li lun jia;
李老师__李老師 450.24958728|li lao shi;
李连杰__李連杰 609.488769235|li lian jie;
理工科__理工科 181.742866823|li gong ke;
李开复__李開復 257.62872122|li kai fu;
离开家__離開家 135.94305409|li kai jia;
李克勤__李克勤 110.401782066|li ke qin;
离婚了__離婚了 187.4940348|li hun le;
离合器__離合器 287.130256264|li he qi;
李鸿章__李鴻章 187.727829225|li hong zhang;
李俊基__李俊基 134.930398555|li jun ji;
李嘉欣__李嘉欣 215.040276584|li jia xin;
李嘉诚__李嘉誠 414.699880708|li jia cheng;
立交桥__立交橋 281.812926654|li jiao qiao;
李金羽__李金羽 130.46599058|li jin yu;
李清照__李清照 136.792736844|li qing zhao;
利息税__利息稅 211.057972369|li xi shui;
李先生__李先生 525.487661863|li xian sheng;
李孝利__李孝利 108.357265155|li xiao li;
李小龙__李小龍 655.989212862|li xiao long;
理想化__理想化 180.839193473|li xiang hua;
离心机__離心機 114.607273411|li xin ji;
李肇星__李肇星 148.334184528|li zhao xing;
理查德__理查德 179.492101402|li cha de;
李昌镐__李昌鎬 153.41002317|li chang hao;
李长春__李長春 110.264288753|li chang chun;
里程碑__里程碑 461.61231651|li cheng bei;
李世民__李世民 308.267359529|li shi min;
理事会__理事會 587.123698784|li shi hui;
历史剧__歷史劇 105.295633316|li shi ju;
历史学__歷史學 110.401782066|li shi xue;
历史系__歷史系 129.171793682|li shi xi;
历史性__歷史性 590.793388895|li shi xing;
理事长__理事長 376.287731462|li shi zhang;
利润率__利潤率 449.688850794|li run lv;
李自成__李自成 131.609045271|li zi cheng;
李宗盛__李宗盛 128.850255419|li zong sheng;
里斯本__里斯本 129.332863581|li si ben;
李云龙__李雲龍 107.818484324|li yun long;
李亚鹏__李亞鵬 463.919044053|li ya peng;
李彦宏__李彥宏 172.04594156|li yan hong;
李银河__李銀河 162.460985719|li yin he;
里有个__里有個 123.197520618|li you ge;
利用率__利用率 569.823995046|li yong lv;
李宇春__李宇春 1532.69625148|li yu chun;
李玮峰__李瑋峰 153.218967809|li wei feng;
利物浦__利物浦 812.799921236|li wu pu;
连不上__連不上 370.702589737|lian bu shang;
脸皮厚__臉皮厚 110.815291538|lian pi hou;
联盟杯__聯盟杯 133.758497151|lian meng bei;
连连看__連連看 232.893204426|lian lian kan;
联络员__聯絡員 145.950506492|lian luo yuan;
连环画__連環畫 153.41002317|lian huan hua;
联欢会__聯歡會 109.716025699|lian huan hui;
联合体__聯合體 158.857391092|lian he ti;
联合国__聯合國 2532.56730325|lian he guo;
联合会__聯合會 632.705783453|lian he hui;
连接器__連接器 258.271618599|lian jie qi;
连接线__連接線 188.196293023|lian jie xian;
连接池__連接池 114.321989585|lian jie chi;
连接数__連接數 173.553291634|lian jie shu;
练习题__練習題 107.015331962|lian xi ti;
联系人__聯繫人 1569.41918253|lian xi ren;
连续剧__連續劇 643.841029976|lian xu ju;
连续性__連續性 300.679263607|lian xu xing;
连日来__連日來 171.190483873|lian ri lai;
廉租房__廉租房 401.478808454|lian zu fang;
连锁店__連鎖店 444.119751258|lian suo dian;
连云港__連雲港 443.014235191|lian yun gang;
联谊会__聯誼會 263.801426189|lian yi hui;
连衣裙__連衣裙 304.070513117|lian yi qun;
炼油厂__煉油廠 149.447435764|lian you chang;
了不起__了不起 954.550411286|liao bu qi;
聊天室__聊天室 1111.28553845|liao tian shi;
辽宁队__遼寧隊 170.339279748|liao ning dui;
辽宁省__遼寧省 836.433324055|liao ning sheng;
聊聊天__聊聊天 383.387639617|liao liao tian;
疗养院__療養院 122.279808036|liao yang yuan;
两部分__兩部分 473.851932013|liang bu fen;
两不误__兩不誤 125.678566729|liang bu wu;
两码事__兩碼事 176.60772663|liang ma shi;
两方面__兩方面 688.658042404|liang fang mian;
两分钟__兩分鐘 390.621510938|liang fen zhong;
两大类__兩大類 196.586267794|liang da lei;
两年内__兩年內 281.812926654|liang nian nei;
两年后__兩年後 317.626273928|liang nian hou;
两年前__兩年前 685.233853433|liang nian qian;
两个人__兩個人 5335.81207086|liang ge ren;
两个字__兩個字 1048.06715525|liang ge zi;
两个月__兩個月 2309.46804145|liang ge yue;
两口子__兩口子 290.0070692|liang kou zi;
两回事__兩回事 202.050369328|liang hui shi;
梁家辉__梁家輝 165.32020271|liang jia hui;
亮晶晶__亮晶晶 119.86585751|liang jing jing;
梁静茹__梁靜茹 276.938965124|liang jing ru;
梁启超__梁啟超 146.862738669|liang qi chao;
两千多__兩千多 231.158356006|liang qian duo;
两小时__兩小時 357.545014261|liang xiao shi;
两厢车__兩廂車 143.605133321|liang xiang che;
两兄弟__兩兄弟 132.927661458|liang xiong di;
梁朝伟__梁朝偉 727.472474808|liang chao wei;
梁山伯__梁山伯 125.209594649|liang shan bo;
粮食局__糧食局 125.209594649|liang shi ju;
两三天__兩三天 270.458854115|liang san tian;
两银子__兩銀子 132.266710153|liang yin zi;
梁咏琪__梁詠琪 278.322859608|liang yong qi;
两万元__兩萬元 107.952927857|liang wan yuan;
两位数__兩位數 227.727332161|liang wei shu;
列表中__列表中 317.230705235|lie biao zhong;
劣根性__劣根性 127.254530072|lie gen xing;
淋巴结__淋巴結 256.667374505|lin ba jie;
林妹妹__林妹妹 223.788782324|lin mei mei;
林黛玉__林黛玉 337.625607028|lin dai yu;
林俊杰__林俊傑 290.730764849|lin jun jie;
临界点__臨界點 125.522047856|lin jie dian;
邻居家__鄰居家 159.452390871|lin ju jia;
林青霞__林青霞 246.94109417|lin qing xia;
林心如__林心如 251.600451735|lin xin ru;
林志玲__林志玲 532.740555233|lin zhi ling;
林志颖__林志穎 150.756793028|lin zhi ying;
临时工__臨時工 200.29551561|lin shi gong;
临时性__臨時性 132.762114633|lin shi xing;
林业厅__林業廳 187.26053154|lin ye ting;
林业局__林業局 305.97104031|lin ye ju;
林忆莲__林憶蓮 144.863304286|lin yi lian;
临沂市__臨沂市 117.207077876|lin yi shi;
零部件__零部件 781.025384985|ling bu jian;
零配件__零配件 183.335174792|ling pei jian;
灵敏度__靈敏度 260.859291326|ling min du;
领导力__領導力 166.97657743|ling dao li;
领导者__領導者 725.661628731|ling dao zhe;
领导人__領導人 2072.17903804|ling dao ren;
领导层__領導層 212.641966978|ling dao ceng;
领头羊__領頭羊 220.742053181|ling tou yang;
零花钱__零花錢 247.866011137|ling hua qian;
令狐冲__令狐沖 226.030964922|ling hu chong;
灵活性__靈活性 598.201722298|ling huo xing;
领奖台__領獎台 123.967540162|ling jiang tai;
零距离__零距離 238.176261728|ling ju li;
领事馆__領事館 247.866011137|ling shi guan;
零售店__零售店 112.765574943|ling shou dian;
零售价__零售價 328.086003878|ling shou jia;
零售商__零售商 502.434215952|ling shou shang;
零售业__零售業 359.779772295|ling shou ye;
零售额__零售額 127.413209251|ling shou e;
另存为__另存為 264.789493468|ling cun wei;
另一半__另一半 607.214449729|ling yi ban;
另一边__另一邊 350.486645516|ling yi bian;
另一面__另一面 278.669912425|ling yi mian;
另一方__另一方 370.702589737|ling yi fang;
另一端__另一端 228.011295226|ling yi duan;
另一台__另一台 139.200207879|ling yi tai;
另一只__另一隻 256.987424161|ling yi zhi;
另一种__另一種 1672.40062475|ling yi zhong;
另一位__另一位 598.201722298|ling yi wei;
零用钱__零用錢 113.32907693|ling yong qian;
流鼻涕__流鼻涕 115.323601467|liu bi ti;
流鼻血__流鼻血 154.176629937|liu bi xue;
留不住__留不住 176.60772663|liu bu zhu;
流媒体__流媒體 415.734739962|liu mei ti;
刘德华__劉德華 2129.77510916|liu de hua;
六点半__六點半 145.768741141|liu dian ban;
流动性__流動性 1406.41364933|liu dong xing;
流通股__流通股 448.56947196|liu tong gu;
六年级__六年級 156.304608838|liu nian ji;
浏览量__瀏覽量 166.146325956|liu lan liang;
浏览器__瀏覽器 4349.53866663|liu lan qi;
浏览者__瀏覽者 132.762114633|liu lan zhe;
流浪猫__流浪貓 117.499561272|liu lang mao;
流浪狗__流浪狗 123.197520618|liu lang gou;
流浪汉__流浪漢 145.043940608|liu lang han;
流浪者__流浪者 105.295633316|liu lang zhe;
流量计__流量計 122.432284019|liu liang ji;
流露出__流露出 474.442798491|liu lu chu;
六个月__六個月 428.356335222|liu ge yue;
流口水__流口水 354.43965395|liu kou shui;
六合彩__六合彩 706.037369534|liu he cai;
刘嘉玲__劉嘉玲 426.226434824|liu jia ling;
刘青云__劉青雲 112.065135969|liu qing yun;
留学生__留學生 1027.37704867|liu xue sheng;
留下来__留下來 884.6784987|liu xia lai;
刘先生__劉先生 370.702589737|liu xian sheng;
刘晓庆__劉曉慶 239.664931108|liu xiao qing;
流行性__流行性 105.953760973|liu xing xing;
流星雨__流星雨 237.879639313|liu xing yu;
流着泪__流着淚 132.10198647|liu zhe lei;
柳州市__柳州市 120.916041011|liu zhou shi;
柳传志__柳傳志 128.049907079|liu chuan zhi;
流程图__流程圖 383.865702254|liu cheng tu;
流出来__流出來 241.764712994|liu chu lai;
刘少奇__劉少奇 273.168633085|liu shao qi;
流水号__流水號 105.0335283|liu shui hao;
流水线__流水線 300.304800557|liu shui xian;
流水帐__流水帳 185.86560618|liu shui zhang;
刘若英__劉若英 399.482550191|liu ruo ying;
六月份__六月份 187.027319083|liu yue fen;
留言板__留言板 540.093554591|liu yan ban;
留言本__留言本 238.473254015|liu yan ben;
流眼泪__流眼淚 145.405889264|liu yan lei;
刘亦菲__劉亦菲 569.823995046|liu yi fei;
刘易斯__劉易斯 106.483223576|liu yi si;
楼道里__樓道里 119.716577729|lou dao li;
垄断性__壟斷性 126.149295342|long duan xing;
龙岗区__龍崗區 127.413209251|long gang qu;
龙卷风__龍捲風 323.216307961|long juan feng;
龙骑士__龍騎士 132.762114633|long qi shi;
卢浮宫__盧浮宮 108.627664361|lu fu gong;
鹿鼎记__鹿鼎記 175.729586548|lu ding ji;
路透社__路透社 185.634130949|lu tou she;
泸沽湖__瀘沽湖 157.477678279|lu gu hu;
陆家嘴__陸家嘴 328.495108513|lu jia zui;
路线图__路線圖 195.60878915|lu xian tu;
录像带__錄像帶 280.062456643|lu xiang dai;
录像机__錄像機 151.321452046|lu xiang ji;
路传中__路傳中 118.23396695|lu chuan zhong;
卢森堡__盧森堡 117.353228453|lu sen bao;
路易斯__路易斯 128.049907079|lu yi si;
录音笔__錄音筆 118.676811842|lu yin bi;
录音带__錄音帶 111.230349808|lu yin dai;
录音机__錄音機 218.280152578|lu yin ji;
录音室__錄音室 106.616002115|lu yin shi;
路由器__路由器 2312.34781708|lu you qi;
卢武铉__盧武鉉 114.037415895|lu wu xuan;
罗伯特__羅伯特 344.424970321|luo bo te;
罗布泊__羅布泊 107.550099352|luo bu po;
罗密欧__羅密歐 129.171793682|luo mi ou;
罗大佑__羅大佑 188.901181552|luo da you;
罗湖区__羅湖區 157.477678279|luo hu qu;
逻辑性__邏輯性 119.26985293|luo ji xing;
落脚点__落腳點 221.845125512|luo jiao dian;
罗杰斯__羅傑斯 169.703655326|luo jie si;
螺旋藻__螺旋藻 124.89791921|luo xuan zao;
罗志祥__羅志祥 173.337150041|luo zhi xiang;
洛杉矶__洛杉磯 762.750126416|luo shan ji;
罗斯福__羅斯福 181.742866823|luo si fu;
螺丝刀__螺絲刀 130.141230764|luo si dao;
洛阳市__洛陽市 136.282292017|luo yang shi;
管不了__管不了 236.696839161|guan bu liao;
管理部__管理部 268.778909483|guan li bu;
管理费__管理費 478.003501869|guan li fei;
管理科__管理科 127.096048509|guan li ke;
管理局__管理局 1048.06715525|guan li ju;
管理器__管理器 512.55262135|guan li qi;
管理区__管理區 106.085879302|guan li qu;
管理学__管理學 303.691826638|guan li xue;
管理者__管理者 1313.24844471|guan li zhe;
管理处__管理處 522.223615731|guan li chu;
管理人__管理人 176.827946446|guan li ren;
管理层__管理層 1521.27901981|guan li ceng;
管理员__管理員 4841.57510783|guan li yuan;
关联方__關聯方 134.594525802|guan lian fang;
关联性__關聯性 118.381397999|guan lian xing;
观后感__觀后感 108.222318063|guan hou gan;
冠军杯__冠軍杯 434.810109507|guan jun bei;
关键点__關鍵點 175.510734618|guan jian dian;
关键性__關鍵性 246.633556117|guan jian xing;
关键字__關鍵字 1504.31243966|guan jian zi;
关键词__關鍵詞 1896.71398774|guan jian ci;
关节炎__關節炎 148.149450567|guan jie yan;
管辖权__管轄權 138.508067822|guan xia quan;
冠心病__冠心病 397.991873082|guan xin bing;
关之琳__關之琳 116.769717326|guan zhi lin;
观众席__觀眾席 123.967540162|guan zhong xi;
关注点__關注點 121.520271774|guan zhu dian;
关注度__關注度 322.010219858|guan zhu du;
观察者__觀察者 107.015331962|guan cha zhe;
观察员__觀察員 141.29744947|guan cha yuan;
观赏性__觀賞性 142.535402072|guan shang xing;
管委会__管委會 494.9767145|guan wei hui;
广东话__廣東話 265.78126155|guang dong hua;
广东省__廣東省 2619.22907324|guang dong sheng;
广东人__廣東人 368.399985048|guang dong ren;
广告牌__廣告牌 290.368691563|guang gao pai;
广告片__廣告片 110.264288753|guang gao pian;
广告费__廣告費 249.726250867|guang gao fei;
广告条__廣告條 120.164975734|guang gao tiao;
广告主__廣告主 296.585723861|guang gao zhu;
广告商__廣告商 252.228305921|guang gao shang;
广告词__廣告詞 209.485777119|guang gao ci;
广告语__廣告語 256.347723437|guang gao yu;
广告位__廣告位 371.164834837|guang gao wei;
广交会__廣交會 436.438689186|guang jiao hui;
广州市__廣州市 2235.83974961|guang zhou shi;
广州人__廣州人 151.321452046|guang zhou ren;
广域网__廣域網 136.963309627|guang yu wang;
滚动条__滾動條 241.764712994|gun dong tiao;
怪不得__怪不得 1859.27057168|guai bu de;
乖乖的__乖乖的 187.027319083|guai guai de;
改编自__改編自 157.085680168|gai bian zi;
改不了__改不了 213.704562287|gai bu liao;
该不该__該不該 465.076726846|gai bu gai;
改名字__改名字 162.663565352|gai ming zi;
盖房子__蓋房子 128.850255419|gai fang zi;
该地区__該地區 377.226735448|gai di qu;
概念股__概念股 274.876014738|gai nian gu;
概念车__概念車 217.736803143|gai nian che;
该公司__該公司 2840.21811123|gai gong si;
改扩建__改擴建 126.779677253|gai kuo jian;
该企业__該企業 262.817045902|gai qi ye;
该项目__該項目 977.421145723|gai xiang mu;
该软件__該軟件 295.111021611|gai ruan jian;
该如何__該如何 942.728934628|gai ru he;
改造成__改造成 139.026849285|gai zao cheng;
该怎么__該怎麼 905.87512359|gai zen me;
该怎样__該怎樣 308.267359529|gai zen yang;
该用户__該用戶 202.050369328|gai yong hu;
该文件__該文件 310.968189453|gai wen jian;
敢不敢__敢不敢 221.017305999|gan bu gan;
赶不上__趕不上 423.578945935|gan bu shang;
感冒了__感冒了 320.808632296|gan mao le;
感冒药__感冒藥 148.519148841|gan mao yao;
感到很__感到很 492.515560049|gan dao hen;
感叹号__感嘆號 131.117943492|gan tan hao;
橄榄球__橄欖球 147.412812521|gan lan qiu;
橄榄油__橄欖油 291.819695868|gan lan you;
感光度__感光度 118.08671951|gan guang du;
肝功能__肝功能 229.722524886|gan gong neng;
肝细胞__肝細胞 152.837570606|gan xi bao;
干细胞__幹細胞 300.304800557|gan xi bao;
感兴趣__感興趣 3253.44031687|gan xing qu;
干什么__幹什麼 8816.68704672|gan shen me;
赶时间__趕時間 111.786180106|gan shi jian;
感染力__感染力 269.114061535|gan ran li;
感染者__感染者 266.444503116|gan ran zhe;
干扰素__干擾素 136.282292017|gan rao su;
敢死队__敢死隊 146.132498493|gan si dui;
甘肃省__甘肅省 636.660374558|gan su sheng;
肝硬化__肝硬化 243.275811214|gan ying hua;
感应器__感應器 122.890853693|gan ying qi;
感恩节__感恩節 165.526347625|gan en jie;
刚毕业__剛畢業 469.736419493|gang bi ye;
钢铁业__鋼鐵業 105.295633316|gang tie ye;
刚刚好__剛剛好 160.449013667|gang gang hao;
刚开始__剛開始 2219.18472069|gang kai shi;
钢结构__鋼結構 294.009808944|gang jie gou;
钢琴家__鋼琴家 131.281440129|gang qin jia;
钢琴曲__鋼琴曲 152.647228173|gang qin qu;
刚出道__剛出道 114.607273411|gang chu dao;
刚出生__剛出生 161.250795044|gang chu sheng;
港澳台__港澳台 277.976239008|gang ao tai;
高标准__高標準 318.418891685|gao biao zhun;
搞不懂__搞不懂 728.379591714|gao bu dong;
搞不好__搞不好 616.362966229|gao bu hao;
高品质__高品質 781.999279332|gao pin zhi;
高密度__高密度 228.8653107|gao mi du;
高房价__高房價 202.050369328|gao fang jia;
高分子__高分子 243.57916235|gao fen zi;
高峰期__高峰期 503.060722916|gao feng qi;
高风险__高風險 282.516174301|gao feng xian;
高蛋白__高蛋白 145.768741141|gao dan bai;
高难度__高難度 226.030964922|gao nan du;
高年级__高年級 136.452228303|gao nian ji;
高浓度__高濃度 124.742372548|gao nong du;
高利贷__高利貸 160.249192015|gao li dai;
高高的__高高的 366.568203397|gao gao de;
高个子__高個子 113.753550575|gao ge zi;
高跟鞋__高跟鞋 578.409173188|gao gen xie;
高科技__高科技 1548.05262827|gao ke ji;
高耗能__高耗能 148.519148841|gao hao neng;
高技术__高技術 304.070513117|gao ji shu;
高精度__高精度 264.789493468|gao jing du;
高起点__高起點 130.954650472|gao qi dian;
高强度__高強度 320.010065926|gao qiang du;
高清晰__高清晰 281.111429553|gao qing xi;
搞清楚__搞清楚 711.336195135|gao qing chu;
高学历__高學歷 233.765505073|gao xue li;
高血压__高血壓 939.211122794|gao xue ya;
高消费__高消費 109.034528882|gao xiao fei;
高效率__高效率 329.725485744|gao xiao lv;
高新区__高新區 551.657401419|gao xin qu;
高性能__高性能 773.277767188|gao xing neng;
高质量__高質量 992.147332631|gao zhi liang;
高中生__高中生 557.879339939|gao zhong sheng;
搞什么__搞什麼 574.10053635|gao shen me;
高收入__高收入 294.009808944|gao shou ru;
高水平__高水平 678.436468738|gao shui ping;
高水准__高水準 113.47039186|gao shui zhun;
高增长__高增長 241.162905094|gao zeng zhang;
高材生__高材生 113.895394799|gao cai sheng;
高层次__高層次 494.360275282|gao ceng ci;
告诉您__告訴您 151.699065864|gao su nin;
高速路__高速路 266.444503116|gao su lu;
高素质__高素質 600.442284667|gao su zhi;
高圆圆__高圓圓 162.460985719|gao yuan yuan;
高压锅__高壓鍋 113.187937993|gao ya guo;
高压线__高壓線 107.550099352|gao ya xian;
高油价__高油價 149.261315371|gao you jia;
高尔夫__高爾夫 940.382265783|gao er fu;
哥们儿__哥們兒 398.985038482|ge men er;
革命性__革命性 266.776744296|ge ming xing;
个体户__個體戶 217.736803143|ge ti hu;
个女人__個女人 274.876014738|ge nv ren;
格兰仕__格蘭仕 146.497163581|ge lan shi;
隔离霜__隔離霜 114.179614083|ge li shuang;
个理由__個理由 140.070248771|ge li you;
歌剧院__歌劇院 155.72135507|ge ju yuan;
各区县__各區縣 187.4940348|ge qu xian;
个性化__個性化 1420.50477658|ge xing hua;
葛洲坝__葛洲壩 256.347723437|ge zhou ba;
歌唱家__歌唱家 156.694657831|ge chang jia;
各省市__各省市 188.901181552|ge sheng shi;
格式化__格式化 1049.37403554|ge shi hua;
个字符__個字符 110.126966673|ge zi fu;
歌友会__歌友會 165.526347625|ge you hui;
歌舞团__歌舞團 140.945727665|ge wu tuan;
格尔木__格爾木 111.925571131|ge er mu;
根本性__根本性 342.712398751|gen ben xing;
跟别人__跟別人 344.85444872|gen bie ren;
跟不上__跟不上 604.195219728|gen bu shang;
根目录__根目錄 279.017397997|gen mu lu;
根据地__根據地 272.828431509|gen ju di;
跟我来__跟我來 108.222318063|gen wo lai;
跟我说__跟我說 1209.56018338|gen wo shuo;
更漂亮__更漂亮 159.452390871|geng piao liang;
更美好__更美好 176.60772663|geng mei hao;
更方便__更方便 360.677581637|geng fang bian;
更大的__更大的 2167.25788788|geng da de;
更多的__更多的 9442.16538338|geng duo de;
更年期__更年期 382.910172354|geng nian qi;
更厉害__更厲害 201.547419552|geng li hai;
更高的__更高的 1199.05487625|geng gao de;
更可怕__更可怕 185.86560618|geng ke pa;
更好地__更好地 1723.1742594|geng hao de;
更好的__更好的 3095.24275062|geng hao de;
更好地__更好地 2224.72256613|geng hao di;
更何况__更何況 1004.58849796|geng he kuang;
更精彩__更精彩 222.121753798|geng jing cai;
更清晰__更清晰 142.713135632|geng qing xi;
更喜欢__更喜歡 697.293562832|geng xi huan;
更详细__更詳細 180.389043185|geng xiang xi;
更需要__更需要 546.866130582|geng xu yao;
更重要__更重要 1934.91146801|geng zhong yao;
更适合__更適合 559.271495144|geng shi he;
更容易__更容易 1082.58098585|geng rong yi;
更衣室__更衣室 219.37092252|geng yi shi;
更有效__更有效 372.555031371|geng you xiao;
更安全__更安全 186.794397067|geng an quan;
给宝宝__給寶寶 249.726250867|gei bao bao;
给排水__給排水 124.587019602|gei pai shui;
给你的__給你的 271.810366771|gei ni de;
给你看__給你看 318.418891685|gei ni kan;
给了他__給了他 423.051424808|gei le ta;
给了你__給了你 169.492308033|gei le ni;
给了我__給了我 972.56115063|gei le wo;
给客户__給客戶 353.117055307|gei ke hu;
给人以__給人以 388.679238014|gei ren yi;
给我发__給我發 404.996293994|gei wo fa;
够不够__夠不夠 320.409100324|gou bu gou;
购买力__購買力 370.240920313|gou mai li;
购买者__購買者 267.775955618|gou mai zhe;
购房者__購房者 972.56115063|gou fang zhe;
枸杞子__枸杞子 105.690017726|gou qi zi;
狗仔队__狗仔隊 168.649547684|gou zai dui;
购物车__購物車 173.337150041|gou wu che;
工本费__工本費 126.621787068|gong ben fei;
公平性__公平性 128.369448119|gong ping xing;
供电局__供電局 202.554574186|gong dian ju;
共同点__共同點 274.533686805|gong tong dian;
共同体__共同體 299.93080386|gong tong ti;
功能键__功能鍵 140.594881376|gong neng jian;
功能区__功能區 192.705418355|gong neng qu;
功能性__功能性 363.384474622|gong neng xing;
公里处__公里處 157.870654598|gong li chu;
公关部__公關部 122.890853693|gong guan bu;
公开课__公開課 146.679837233|gong kai ke;
公开信__公開信 203.060037258|gong kai xin;
公开赛__公開賽 333.860122955|gong kai sai;
共和党__共和黨 354.43965395|gong he dang;
共和国__共和國 806.745280603|gong he guo;
供货商__供貨商 434.268601197|gong huo shang;
攻击力__攻擊力 479.793862242|gong ji li;
公积金__公積金 1394.19862478|gong ji jin;
攻击性__攻擊性 203.820597887|gong ji xing;
攻击者__攻擊者 195.121873946|gong ji zhe;
弓箭手__弓箭手 154.754097942|gong jian shou;
公交车__公交車 1784.36168375|gong jiao che;
宫颈癌__宮頸癌 182.878811433|gong jing ai;
工具条__工具條 226.312812713|gong ju tiao;
工具栏__工具欄 522.223615731|gong ju lan;
工具箱__工具箱 202.302314677|gong ju xiang;
公权力__公權力 105.558392399|gong quan li;
宫崎骏__宮崎駿 172.260473089|gong qi jun;
共青团__共青團 424.107124851|gong qing tuan;
工学院__工學院 182.878811433|gong xue yuan;
恭喜你__恭喜你 367.482952871|gong xi ni;
贡献率__貢獻率 164.293322714|gong xian lv;
供销社__供銷社 192.945711079|gong xiao she;
公信力__公信力 267.109399762|gong xin li;
公正性__公正性 155.915530766|gong zheng xing;
公证处__公證處 202.302314677|gong zheng chu;
公主坟__公主墳 108.492380517|gong zhu fen;
共产党__共產黨 1889.63636164|gong chan dang;
工程部__工程部 242.972837869|gong cheng bu;
工程量__工程量 185.86560618|gong cheng liang;
工程款__工程款 200.795341333|gong cheng kuan;
工程学__工程學 126.464093517|gong cheng xue;
工程系__工程系 131.445140637|gong cheng xi;
工程师__工程師 3740.74070579|gong cheng shi;
工商联__工商聯 195.365179853|gong shang lian;
工商局__工商局 759.903909096|gong shang ju;
工商所__工商所 191.747236314|gong shang suo;
工商业__工商業 161.653186955|gong shang ye;
工资单__工資單 105.295633316|gong zi dan;
工资卡__工資卡 154.176629937|gong zi ka;
工作表__工作表 131.445140637|gong zuo biao;
工作服__工作服 201.296414343|gong zuo fu;
工作台__工作台 125.835280772|gong zuo tai;
工作量__工作量 1096.15615618|gong zuo liang;
工作流__工作流 464.497524783|gong zuo liu;
工作狂__工作狂 128.049907079|gong zuo kuang;
工作站__工作站 601.191002133|gong zuo zhan;
工作者__工作者 920.669965262|gong zuo zhe;
工作证__工作證 116.915322539|gong zuo zheng;
工作室__工作室 1472.77903036|gong zuo shi;
工作日__工作日 758.012333731|gong zuo ri;
工作组__工作組 739.353626862|gong zuo zu;
公司法__公司法 256.347723437|gong si fa;
公园里__公園裡 196.831399718|gong yuan li;
公元前__公元前 401.478808454|gong yuan qian;
工业品__工業品 182.423584067|gong ye pin;
工业化__工業化 1012.12795618|gong ye hua;
工业区__工業區 643.039196578|gong ye qu;
工业园__工業園 564.874943184|gong ye yuan;
工艺品__工藝品 520.274927886|gong yi pin;
公益性__公益性 475.034401746|gong yi xing;
供应链__供應鏈 642.238361775|gong ying lian;
供应量__供應量 365.655730945|gong ying liang;
供应商__供應商 3398.48186759|gong ying shang;
公有制__公有制 245.407229187|gong you zhi;
宫外孕__宮外孕 153.218967809|gong wai yun;
公文包__公文包 122.432284019|gong wen bao;
公务员__公務員 3731.429143|gong wu yuan;
公安部__公安部 760.851466162|gong an bu;
公安厅__公安廳 144.682892926|gong an ting;
公安局__公安局 2326.80064863|gong an ju;
顾不得__顧不得 195.852702213|gu bu de;
顾不上__顧不上 322.411748334|gu bu shang;
股份制__股份制 284.991389772|gu fen zhi;
股东会__股東會 129.171793682|gu dong hui;
古天乐__古天樂 264.459727191|gu tian le;
鼓浪屿__鼓浪嶼 173.337150041|gu lang yu;
孤零零__孤零零 179.71591787|gu ling ling;
古罗马__古羅馬 169.915266157|gu luo ma;
古惑仔__古惑仔 115.036534536|gu huo zai;
古建筑__古建築 159.253810404|gu jian zhu;
古巨基__古巨基 135.435779871|gu ju ji;
古希腊__古希臘 320.808632296|gu xi la;
顾雏军__顧雛軍 171.403948695|gu chu jun;
故事片__故事片 107.282382453|gu shi pian;
古时候__古時候 114.179614083|gu shi hou;
股市场__股市場 676.747684543|gu shi chang;
骨子里__骨子裡 564.171453387|gu zi li;
古埃及__古埃及 117.499561272|gu ai ji;
孤儿院__孤兒院 142.003528374|gu er yuan;
过不了__過不了 336.365750338|guo bu liao;
过不去__過不去 627.210588862|guo bu qu;
国民党__國民黨 2121.82781083|guo min dang;
过敏性__過敏性 175.729586548|guo min xing;
郭沫若__郭沫若 175.292155245|guo mo ruo;
国防部__國防部 335.110594827|guo fang bu;
国防生__國防生 121.975425508|guo fang sheng;
郭富城__郭富城 295.479008313|guo fu cheng;
郭德纲__郭德綱 747.692521253|guo de gang;
过得去__過得去 250.037645335|guo de qu;
过渡期__過渡期 172.905674062|guo du qi;
郭台铭__郭台銘 139.547573842|guo tai ming;
国土局__國土局 193.186303435|guo tu ju;
国内外__國內外 2798.06148652|guo nei wai;
过滤器__過濾器 362.028498203|guo lv qi;
过来人__過來人 193.427195796|guo lai ren;
过两天__過兩天 695.557838999|guo liang tian;
过会儿__過會兒 173.769702743|guo hui er;
国际法__國際法 193.668388536|guo ji fa;
过几天__過幾天 1326.40613196|guo ji tian;
国际化__國際化 1597.0400293|guo ji hua;
国际性__國際性 343.139741671|guo ji xing;
过几次__過幾次 342.712398751|guo ji ci;
国家队__國家隊 1901.44712636|guo jia dui;
国家级__國家級 1149.31255222|guo jia ji;
国家局__國家局 107.015331962|guo jia ju;
郭敬明__郭敬明 337.205131359|guo jing ming;
郭晶晶__郭晶晶 286.058823982|guo jing jing;
国庆节__國慶節 568.405572245|guo qing jie;
国产化__國產化 210.008536601|guo chan hua;
国产车__國產車 142.357889859|guo chan che;
过山车__過山車 239.963779681|guo shan che;
过生日__過生日 704.279880358|guo sheng ri;
国税局__國稅局 341.008342538|guo shui ju;
果然是__果然是 710.450303909|guo ran shi;
过日子__過日子 691.237408589|guo ri zi;
国资委__國資委 1062.53280282|guo zi wei;
国有股__國有股 188.430963124|guo you gu;
国务卿__國務卿 162.86639759|guo wu qing;
国务院__國務院 3922.14213601|guo wu yuan;
国奥队__國奧隊 358.437246895|guo ao dui;
规模化__規模化 395.027185582|gui mo hua;
规范化__規範化 751.428823061|gui fan hua;
规范性__規範性 144.143005824|gui fan xing;
规律性__規律性 169.070402749|gui lv xing;
桂林市__桂林市 130.303509496|gui lin shi;
贵公司__貴公司 839.566182019|gui gong si;
鬼故事__鬼故事 168.859844103|gui gu shi;
规划局__規劃局 246.633556117|gui hua ju;
贵金属__貴金屬 143.605133321|gui jin shu;
贵州省__貴州省 491.289575698|gui zhou sheng;
鬼吹灯__鬼吹燈 370.702589737|gui chui deng;
归属地__歸屬地 112.34478795|gui shu di;
归属感__歸屬感 191.031727675|gui shu gan;
刽子手__劊子手 112.204874836|gui zi shou;
贵阳市__貴陽市 222.67604562|gui yang shi;
跨平台__跨平台 158.857391092|kua ping tai;
跨地区__跨地區 110.677283245|kua di qu;
款车型__款車型 401.478808454|kuan che xing;
狂犬病__狂犬病 266.776744296|kuang quan bing;
矿泉水__礦泉水 563.46883971|kuang quan shui;
矿物质__礦物質 419.377126323|kuang wu zhi;
昆明市__昆明市 325.236501817|kun ming shi;
快递费__快遞費 263.472890441|kuai di fei;
会计学__會計學 108.627664361|kuai ji xue;
会计师__會計師 418.333200332|kuai ji shi;
快捷键__快捷鍵 743.974797322|kuai jie jian;
快节奏__快節奏 160.449013667|kuai jie zou;
快车道__快車道 130.46599058|kuai che dao;
快餐店__快餐店 169.28122395|kuai can dian;
快速路__快速路 113.47039186|kuai su lu;
快一点__快一點 253.804804573|kuai yi dian;
卡佩罗__卡佩羅 224.347234118|ka pei luo;
卡片机__卡片機 202.807148249|ka pian ji;
喀麦隆__喀麥隆 111.646962678|ka mai long;
咖啡店__咖啡店 179.71591787|ka fei dian;
咖啡厅__咖啡廳 305.589986932|ka fei ting;
咖啡馆__咖啡館 353.557372243|ka fei guan;
咖啡色__咖啡色 172.475272126|ka fei se;
咖啡因__咖啡因 162.663565352|ka fei yin;
卡夫卡__卡夫卡 140.419785869|ka fu ka;
卡丁车__卡丁車 415.216987933|ka ding che;
卡塔尔__卡塔爾 250.037645335|ka ta er;
卡路里__卡路里 228.8653107|ka lu li;
卡洛斯__卡洛斯 207.666345181|ka luo si;
卡卡西__卡卡西 106.616002115|ka ka xi;
卡西欧__卡西歐 153.41002317|ka xi ou;
卡哇伊__卡哇伊 106.218162376|ka wa yi;
卡尔德__卡爾德 110.677283245|ka er de;
开盘价__開盤價 160.649084484|kai pan jia;
开门红__開門紅 159.452390871|kai men hong;
凯美瑞__凱美瑞 284.636464248|kai mei rui;
开幕式__開幕式 1257.20118645|kai mu shi;
开发板__開發板 119.86585751|kai fa ban;
开发部__開發部 188.430963124|kai fa bu;
开发票__開發票 308.651751439|kai fa piao;
开发区__開發區 1996.14083601|kai fa qu;
开发者__開發者 545.504855178|kai fa zhe;
开发出__開發出 511.914293268|kai fa chu;
开发商__開發商 4409.57193181|kai fa shang;
开放性__開放性 292.54791482|kai fang xing;
开放式__開放式 509.368920718|kai fang shi;
开拓者__開拓者 204.584007193|kai tuo zhe;
开公司__開公司 178.822323044|kai gong si;
开户行__開戶行 160.449013667|kai hu hang;
开心果__開心果 115.611384758|kai xin guo;
开场白__開場白 169.28122395|kai chang bai;
开车去__開車去 124.122120652|kai che qu;
开什么__開什麼 132.10198647|kai shen me;
开始做__開始做 248.175085992|kai shi zuo;
凯瑟琳__凱瑟琳 123.044091616|kai se lin;
开一家__開一家 146.314717429|kai yi jia;
开玩笑__開玩笑 2857.97028226|kai wan xiao;
凯恩斯__凱恩斯 107.14877401|kai en si;
看病难__看病難 130.46599058|kan bing nan;
看不到__看不到 5728.60805208|kan bu dao;
看不懂__看不懂 1880.24059249|kan bu dong;
看不惯__看不慣 436.438689186|kan bu guan;
看不见__看不見 2230.27423094|kan bu jian;
看不起__看不起 917.234466913|kan bu qi;
看不清__看不清 717.56844134|kan bu qing;
看不出__看不出 1137.91159836|kan bu chu;
看不上__看不上 332.614317243|kan bu shang;
看美女__看美女 120.164975734|kan mei nv;
看风景__看風景 130.628674269|kan feng jing;
看得到__看得到 450.24958728|kan de dao;
看得见__看得見 458.173712968|kan de jian;
看得起__看得起 163.069482749|kan de qi;
看得出__看得出 571.958268741|kan de chu;
看电视__看電視 1725.32295995|kan dian shi;
看电影__看電影 1693.37191801|kan dian ying;
看了看__看了看 1445.50481813|kan le kan;
看过来__看過來 125.992190229|kan guo lai;
看看吧__看看吧 702.526765976|kan kan ba;
看起来__看起來 5545.97394851|kan qi lai;
看清楚__看清楚 752.365812175|kan qing chu;
看下去__看下去 231.735198139|kan xia qu;
看小说__看小說 200.795341333|kan xiao shuo;
看新闻__看新聞 236.402059204|kan xin wen;
看着办__看着辦 281.111429553|kan zhe ban;
看着他__看着他 984.756712384|kan zhe ta;
看着你__看着你 390.135034682|kan zhe ni;
看着我__看着我 1318.16721196|kan zhe wo;
看出来__看出來 1530.78744637|kan chu lai;
看上去__看上去 3000.29967146|kan shang qu;
看什么__看什麼 534.735933039|kan shen me;
看守所__看守所 379.584509838|kan shou suo;
看热闹__看熱鬧 334.276427588|kan re nao;
看样子__看樣子 997.105202031|kan yang zi;
看一看__看一看 759.903909096|kan yi kan;
看一下__看一下 2424.48154518|kan yi xia;
看医生__看醫生 176.60772663|kan yi sheng;
看完了__看完了 853.278059532|kan wan le;
看问题__看問題 183.792676978|kan wen ti;
抗病毒__抗病毒 213.172602547|kang bing du;
抗干扰__抗干擾 120.46484039|kang gan rao;
抗衰老__抗衰老 138.163289429|kang shuai lao;
抗生素__抗生素 714.000502259|kang sheng su;
康师傅__康師傅 232.603161479|kang shi fu;
抗氧化__抗氧化 247.866011137|kang yang hua;
拷贝到__拷貝到 160.649084484|kao bei dao;
靠不住__靠不住 187.26053154|kao bu zhu;
考大学__考大學 145.224802174|kao da xue;
考察团__考察團 236.696839161|kao cha tuan;
可比性__可比性 290.368691563|ke bi xing;
可编程__可編程 174.638049069|ke bian cheng;
可分为__可分為 584.932834985|ke fen wei;
可达到__可達到 250.974160423|ke da dao;
可读性__可讀性 154.561368684|ke du xing;
可提供__可提供 259.238974004|ke ti gong;
课题组__課題組 373.484720623|ke ti zu;
客厅里__客廳里 225.749468142|ke ting li;
可能性__可能性 3492.94243288|ke neng xing;
克拉克__克拉克 132.266710153|ke la ke;
克里斯__克里斯 186.561765129|ke li si;
可利用__可利用 239.068350048|ke li yong;
克林顿__克林頓 432.109303457|ke lin dun;
客流量__客流量 166.353500999|ke liu liang;
刻录盘__刻錄盤 117.061109314|ke lu pan;
刻录机__刻錄機 653.541376022|ke lu ji;
克鲁斯__克魯斯 164.088713397|ke lu si;
客观性__客觀性 135.267109459|ke guan xing;
可根据__可根據 670.869975958|ke gen ju;
可靠性__可靠性 1101.63376911|ke kao xing;
可扩展__可擴展 119.41857567|ke kuo zhan;
科幻片__科幻片 105.558392399|ke huan pian;
客户端__客戶端 3951.57789686|ke hu duan;
客户机__客戶機 318.022335873|ke hu ji;
客户群__客戶群 266.444503116|ke hu qun;
可获得__可獲得 333.029068427|ke huo de;
科技部__科技部 348.743933702|ke ji bu;
科技馆__科技館 157.085680168|ke ji guan;
科技股__科技股 181.290467084|ke ji gu;
科技局__科技局 208.184564378|ke ji ju;
科技型__科技型 112.204874836|ke ji xing;
科技园__科技園 411.098117295|ke ji yuan;
客家人__客家人 123.044091616|ke jia ren;
课教学__課教學 119.716577729|ke jiao xue;
可接受__可接受 122.890853693|ke jie shou;
可选择__可選擇 400.978810625|ke xuan ze;
科学化__科學化 209.746993999|ke xue hua;
科学家__科學家 2577.13898569|ke xue jia;
科学界__科學界 143.0692679|ke xue jie;
科学性__科學性 328.495108513|ke xue xing;
科学院__科學院 428.356335222|ke xue yuan;
可享受__可享受 298.811606079|ke xiang shou;
可信度__可信度 275.905561849|ke xin du;
可行性__可行性 783.950712715|ke xing xing;
可转债__可轉債 163.069482749|ke zhuan zhai;
可直接__可直接 493.129699012|ke zhi jie;
可执行__可執行 163.884358899|ke zhi xing;
科植物__科植物 118.529012887|ke zhi wu;
可持续__可持續 437.527796363|ke chi xu;
可申请__可申請 137.991222203|ke shen qing;
可视化__可視化 376.756940916|ke shi hua;
可实现__可實現 260.209952636|ke shi xian;
可使用__可使用 268.444174826|ke shi yong;
可采用__可採用 238.473254015|ke cai yong;
可塑性__可塑性 114.46454262|ke su xing;
科索沃__科索沃 143.605133321|ke suo wo;
客运站__客運站 244.796354228|ke yun zhan;
可以吗__可以嗎 763.701232553|ke yi ma;
可以买__可以買 422.52456065|ke yi mai;
柯以敏__柯以敏 110.677283245|ke yi min;
可以放__可以放 159.651218957|ke yi fang;
可以打__可以打 246.633556117|ke yi da;
可以拿__可以拿 218.824857909|ke yi na;
可以换__可以換 178.155043976|ke yi huan;
可以吃__可以吃 305.589986932|ke yi chi;
可以用__可以用 3458.29313278|ke yi yong;
可用性__可用性 309.4219738|ke yong xing;
可用于__可用於 484.601008682|ke yong yu;
科威特__科威特 225.187525865|ke wei te;
科维奇__科維奇 154.176629937|ke wei qi;
肯德基__肯德基 810.776675547|ken de ji;
肯尼迪__肯尼迪 204.584007193|ken ni di;
肯尼亚__肯尼亞 230.295783987|ken ni ya;
口服液__口服液 216.384339476|kou fu ye;
口袋里__口袋裡 573.385557088|kou dai li;
口头禅__口頭禪 237.583386308|kou tou chan;
口香糖__口香糖 299.93080386|kou xiang tang;
口水战__口水戰 107.952927857|kou shui zhan;
恐怖片__恐怖片 497.450167612|kong bu pian;
空荡荡__空蕩蕩 277.630050085|kong dang dang;
空间站__空間站 223.231720645|kong jian zhan;
恐惧感__恐懼感 117.792774542|kong ju gan;
恐惧症__恐懼症 110.95347192|kong ju zheng;
控制台__控制台 467.983588668|kong zhi tai;
控制力__控制力 176.60772663|kong zhi li;
控制权__控制權 347.00988711|kong zhi quan;
控制器__控制器 1133.66545852|kong zhi qi;
控制住__控制住 242.972837869|kong zhi zhu;
空手道__空手道 131.937467932|kong shou dao;
库尔德__庫爾德 136.792736844|ku er de;
扩展名__擴展名 272.149298879|kuo zhan ming;
扩展性__擴展性 186.794397067|kuo zhan xing;
划不来__划不來 162.258658377|hua bu lai;
华南虎__華南虎 609.488769235|hua nan hu;
哗啦啦__嘩啦啦 110.401782066|hua la la;
华莱士__華萊士 131.609045271|hua lai shi;
花露水__花露水 105.164499152|hua lu shui;
花岗岩__花崗岩 192.465424888|hua gang yan;
化工厂__化工廠 234.64107292|hua gong chang;
华国锋__華國鋒 143.247667161|hua guo feng;
花果山__花果山 115.755545596|hua guo shan;
化合物__化合物 489.456318842|hua he wu;
花钱买__花錢買 251.914183226|hua qian mai;
华侨城__華僑城 231.158356006|hua qiao cheng;
华强北__華強北 199.051387821|hua qiang bei;
化学品__化學品 264.130371602|hua xue pin;
滑雪场__滑雪場 172.690339006|hua xue chang;
化妆品__化妝品 2210.90378861|hua zhuang pin;
化妆师__化妝師 218.008308584|hua zhuang shi;
化妆水__化妝水 166.768626413|hua zhuang shui;
华商报__華商報 108.898738333|hua shang bao;
花生米__花生米 197.814987883|hua sheng mi;
华盛顿__華盛頓 898.007390736|hua sheng dun;
花生壳__花生殼 128.529517539|hua sheng ke;
花生油__花生油 156.694657831|hua sheng you;
华师大__華師大 156.694657831|hua shi da;
划时代__劃時代 165.939408926|hua shi dai;
话语权__話語權 416.772181646|hua yu quan;
华尔街__華爾街 660.912425973|hua er jie;
环保局__環保局 568.405572245|huan bao ju;
环保型__環保型 130.46599058|huan bao xing;
环渤海__環渤海 204.329220247|huan bo hai;
幻灯片__幻燈片 412.12398856|huan deng pian;
欢乐谷__歡樂谷 286.772667017|huan le gu;
换工作__換工作 160.649084484|huan gong zuo;
欢呼声__歡呼聲 122.279808036|huan hu sheng;
环形山__環形山 106.748946222|huan xing shan;
缓冲区__緩衝區 354.43965395|huan chong qu;
换手率__換手率 259.885889675|huan shou lv;
换热器__換熱器 125.209594649|huan re qi;
换言之__換言之 164.293322714|huan yan zhi;
换衣服__換衣服 240.263000901|huan yi fu;
欢迎来__歡迎來 170.76435144|huan ying lai;
黄浦江__黃浦江 182.651055928|huang pu jiang;
黄浦区__黃浦區 113.753550575|huang pu qu;
黄飞鸿__黃飛鴻 111.507918629|huang fei hong;
皇太极__皇太極 111.230349808|huang tai ji;
黄老师__黃老師 131.609045271|huang lao shi;
黄光裕__黃光裕 157.870654598|huang guang yu;
黄褐斑__黃褐斑 111.786180106|huang he ban;
黄鹤楼__黃鶴樓 150.756793028|huang he lou;
黄家驹__黃家駒 152.837570606|huang jia ju;
黄健翔__黃健翔 675.904869515|huang jian xiang;
黄金甲__黃金甲 305.209408115|huang jin jia;
黄金周__黃金周 1346.39025518|huang jin zhou;
黄秋生__黃秋生 173.769702743|huang qiu sheng;
黄晓明__黃曉明 409.564096466|huang xiao ming;
黄圣依__黃聖依 244.491487214|huang sheng yi;
混凝土__混凝土 1107.13875428|hun ning tu;
混合型__混合型 194.878871049|hun he xing;
混合物__混合物 178.377193209|hun he wu;
婚纱照__婚紗照 319.213487372|hun sha zhao;
混日子__混日子 166.768626413|hun ri zi;
婚姻法__婚姻法 137.647730357|hun yin fa;
婚外恋__婚外戀 171.403948695|hun wai lian;
婚外情__婚外情 250.349428094|hun wai qing;
坏女人__壞女人 105.558392399|huai nv ren;
坏男人__壞男人 110.401782066|huai nan ren;
淮海路__淮海路 210.532600599|huai hai lu;
坏习惯__壞習慣 162.663565352|huai xi guan;
怀孕后__懷孕后 117.93965545|huai yun hou;
哈马斯__哈馬斯 221.845125512|ha ma si;
哈密瓜__哈密瓜 111.646962678|ha mi gua;
哈工大__哈工大 149.075426771|ha gong da;
哈哈哈__哈哈哈 12529.2402065|ha ha ha;
哈士奇__哈士奇 122.127521944|ha shi qi;
哈尔滨__哈爾濱 2329.70203704|ha er bin;
还不是__還不是 3030.36024751|hai bu shi;
海明威__海明威 118.824795093|hai ming wei;
海盗船__海盜船 122.890853693|hai dao chuan;
海淀区__海淀區 747.692521253|hai dian qu;
海南岛__海南島 207.925293333|hai nan dao;
海南省__海南省 557.184562398|hai nan sheng;
海内外__海內外 642.238361775|hai nei wai;
海洛因__海洛因 140.244908425|hai luo yin;
海口市__海口市 290.730764849|hai kou shi;
还好吗__還好嗎 231.735198139|hai hao ma;
还会有__還會有 758.957532109|hai hui you;
还真是__還真是 1218.6379585|hai zhen shi;
海珠区__海珠區 186.794397067|hai zhu qu;
海产品__海產品 105.164499152|hai chan pin;
还是很__還是很 1399.42059064|hai shi hen;
海事局__海事局 174.42055653|hai shi ju;
还是用__還是用 263.144763849|hai shi yong;
海贼王__海賊王 404.491915522|hai zei wang;
孩子气__孩子氣 223.788782324|hai zi qi;
还有谁__還有誰 249.726250867|hai you shui;
海岸线__海岸線 211.848489234|hai an xian;
邯郸市__邯鄲市 118.08671951|han dan shi;
韩国队__韓國隊 205.350275845|han guo dui;
韩国人__韓國人 1178.31719254|han guo ren;
汉化版__漢化版 159.253810404|han hua ban;
含金量__含金量 263.144763849|han jin liang;
寒暑假__寒暑假 130.791560815|han shu jia;
含水量__含水量 136.452228303|han shui liang;
汉武帝__漢武帝 289.645897197|han wu di;
航天员__航天員 366.568203397|hang tian yuan;
航空业__航空業 115.467403456|hang kong ye;
航站楼__航站樓 113.753550575|hang zhan lou;
杭州市__杭州市 826.074649543|hang zhou shi;
好办法__好辦法 357.99085261|hao ban fa;
好半天__好半天 120.765453341|hao ban tian;
好帮手__好幫手 145.587202159|hao bang shou;
好不好__好不好 4376.72452042|hao bu hao;
好朋友__好朋友 2095.55037421|hao peng you;
好漂亮__好漂亮 446.339066527|hao piao liang;
好名字__好名字 120.46484039|hao ming zi;
好方法__好方法 215.845709156|hao fang fa;
好端端__好端端 115.899886195|hao duan duan;
好地方__好地方 703.402776999|hao di fang;
耗电量__耗電量 140.945727665|hao dian liang;
好电影__好電影 118.824795093|hao dian ying;
好东东__好東東 210.270405333|hao dong dong;
好东西__好東西 1797.75335645|hao dong xi;
好多人__好多人 1085.28250327|hao duo ren;
好女孩__好女孩 140.945727665|hao nv hai;
好女人__好女人 186.097370046|hao nv ren;
好男人__好男人 643.039196578|hao nan ren;
好男儿__好男兒 426.757915008|hao nan er;
好莱坞__好萊塢 1285.72012038|hao lai wu;
好老婆__好老婆 153.41002317|hao lao po;
好老师__好老師 120.916041011|hao lao shi;
好工作__好工作 224.06783424|hao gong zuo;
好看吗__好看嗎 135.773751924|hao kan ma;
好可爱__好可愛 593.006203378|hao ke ai;
豪华版__豪華版 187.961915178|hao hua ban;
豪华型__豪華型 123.813152185|hao hua xing;
豪华车__豪華車 205.094534596|hao hua che;
好孩子__好孩子 635.867483878|hao hai zi;
好好好__好好好 381.957020988|hao hao hao;
好好玩__好好玩 176.60772663|hao hao wan;
好几百__好幾百 171.617679695|hao ji bai;
好几天__好幾天 933.377249507|hao ji tian;
好机会__好機會 399.482550191|hao ji hui;
好几次__好幾次 1065.18429118|hao ji ci;
好起来__好起來 487.62990282|hao qi lai;
好奇心__好奇心 635.867483878|hao qi xin;
好去处__好去處 178.155043976|hao qu chu;
好学生__好學生 214.772467501|hao xue sheng;
好习惯__好習慣 248.175085992|hao xi guan;
好喜欢__好喜歡 450.24958728|hao xi huan;
好消息__好消息 1121.02187006|hao xiao xi;
好想你__好想你 193.668388536|hao xiang ni;
好象是__好象是 918.378206258|hao xiang shi;
好心情__好心情 359.331706043|hao xin qing;
好心人__好心人 410.07479966|hao xin ren;
好兄弟__好兄弟 191.747236314|hao xiong di;
号召力__號召力 310.968189453|hao zhao li;
好主意__好主意 294.009808944|hao zhu yi;
好舒服__好舒服 130.954650472|hao shu fu;
好日子__好日子 515.113903202|hao ri zi;
好容易__好容易 190.793818607|hao rong yi;
好运气__好運氣 121.975425508|hao yun qi;
好意思__好意思 947.439854855|hao yi si;
好又多__好又多 151.888225993|hao you duo;
好玩的__好玩的 652.727461906|hao wan de;
好文章__好文章 353.998238229|hao wen zhang;
河北省__河北省 1156.49608257|he bei sheng;
喝啤酒__喝啤酒 147.045868173|he pi jiu;
和平区__和平區 117.499561272|he ping qu;
合法化__合法化 198.803491145|he fa hua;
合法性__合法性 504.944935018|he fa xing;
合肥市__合肥市 341.859308876|he fei shi;
核电站__核電站 279.365316864|he dian zhan;
喝多了__喝多了 385.78392141|he duo le;
合同法__合同法 206.119414554|he tong fa;
河南省__河南省 1354.80557722|he nan sheng;
河南人__河南人 415.216987933|he nan ren;
和男友__和男友 130.303509496|he nan you;
喝牛奶__喝牛奶 208.70407676|he niu nai;
荷兰队__荷蘭隊 138.508067822|he lan dui;
荷兰人__荷蘭人 167.810977762|he lan ren;
合理化__合理化 137.647730357|he li hua;
合理性__合理性 476.219822262|he li xing;
合格率__合格率 262.162833911|he ge lv;
合格者__合格者 128.209578049|he ge zhe;
合格证__合格證 241.764712994|he ge zheng;
喝咖啡__喝咖啡 377.226735448|he ka fei;
呵呵呵__呵呵呵 2542.05302484|he he he;
合伙人__合伙人 492.515560049|he huo ren;
和姐姐__和姐姐 127.413209251|he jie jie;
合起来__合起來 174.638049069|he qi lai;
核潜艇__核潛艇 212.112652282|he qian ting;
核心区__核心區 139.026849285|he xin qu;
核心网__核心網 111.230349808|he xin wang;
合唱团__合唱團 195.60878915|he chang tuan;
核试验__核試驗 122.127521944|he shi yan;
何润东__何潤東 110.126966673|he run dong;
合作方__合作方 154.754097942|he zuo fang;
合作者__合作者 200.795341333|he zuo zhe;
合作社__合作社 476.219822262|he zuo she;
喝醉了__喝醉了 222.953710017|he zui le;
喝一杯__喝一杯 208.70407676|he yi bei;
合议庭__合議庭 107.416157498|he yi ting;
核问题__核問題 147.596627936|he wen ti;
河务局__河務局 116.624293448|he wu ju;
核武器__核武器 494.9767145|he wu qi;
荷尔蒙__荷爾蒙 336.785179346|he er meng;
何而来__何而來 179.71591787|he er lai;
很抱歉__很抱歉 316.046952528|hen bao qian;
恨不得__恨不得 696.425160166|hen bu de;
恨不能__恨不能 108.087539034|hen bu neng;
很不错__很不錯 3026.58626614|hen bu cuo;
很漂亮__很漂亮 1305.09125317|hen piao liang;
很满意__很滿意 422.52456065|hen man yi;
很明显__很明顯 1150.74567978|hen ming xian;
很方便__很方便 801.734213733|hen fang bian;
很大的__很大的 3863.92679211|hen da de;
很多人__很多人 6227.44248628|hen duo ren;
很多次__很多次 605.702953498|hen duo ci;
很痛苦__很痛苦 393.063006485|hen tong ku;
很难说__很難說 472.67240572|hen nan shuo;
很厉害__很厲害 879.183352683|hen li hai;
很高兴__很高興 1820.2965272|hen gao xing;
很快乐__很快樂 328.904723278|hen kuai le;
很开心__很開心 1170.99812122|hen kai xin;
很可能__很可能 2418.44645375|hen ke neng;
很可爱__很可愛 694.691597986|hen ke ai;
很好的__很好的 4279.6431141|hen hao de;
很好听__很好聽 536.070335228|hen hao ting;
很好看__很好看 814.828215816|hen hao kan;
很简单__很簡單 2580.3525318|hen jian dan;
很久了__很久了 527.455873984|hen jiu le;
很奇怪__很奇怪 1092.0658276|hen qi guai;
很清楚__很清楚 1597.0400293|hen qing chu;
很喜欢__很喜歡 3594.50508488|hen xi huan;
很想你__很想你 125.835280772|hen xiang ni;
很辛苦__很辛苦 534.735933039|hen xin ku;
很幸福__很幸福 542.11647303|hen xing fu;
很正常__很正常 1301.84258129|hen zheng chang;
很重要__很重要 2886.60483295|hen zhong yao;
很生气__很生氣 395.027185582|hen sheng qi;
很舒服__很舒服 628.775756137|hen shu fu;
很容易__很容易 4200.38893397|hen rong yi;
很早就__很早就 493.129699012|hen zao jiu;
很自然__很自然 516.399339766|hen zi ran;
很严重__很嚴重 577.688827991|hen yan zhong;
很无聊__很無聊 437.527796363|hen wu liao;
很爱你__很愛你 108.898738333|hen ai ni;
黑板报__黑板報 120.164975734|hei ban bao;
黑名单__黑名單 723.855290267|hei ming dan;
黑木耳__黑木耳 162.460985719|hei mu er;
黑龙江__黑龍江 1404.66211536|hei long jiang;
黑格尔__黑格爾 149.633788238|hei ge er;
黑黑的__黑黑的 173.769702743|hei hei de;
黑乎乎__黑乎乎 142.535402072|hei hu hu;
黑猩猩__黑猩猩 105.164499152|hei xing xing;
黑芝麻__黑芝麻 105.690017726|hei zhi ma;
黑社会__黑社會 938.041438335|hei she hui;
黑色素__黑色素 231.158356006|hei se su;
黑压压__黑壓壓 115.036534536|hei ya ya;
黑眼圈__黑眼圈 393.553133755|hei yan quan;
黑夜里__黑夜裡 144.502706249|hei ye li;
黑衣人__黑衣人 187.4940348|hei yi ren;
后半夜__後半夜 105.0335283|hou ban ye;
后备箱__後備箱 148.334184528|hou bei xiang;
侯佩岑__侯佩岑 136.112567367|hou pei cen;
后脑勺__後腦勺 130.303509496|hou nao shao;
后来者__後來者 173.121277629|hou lai zhe;
厚厚的__厚厚的 555.105417084|hou hou de;
候选人__候選人 1176.84972769|hou xuan ren;
后现代__後現代 239.963779681|hou xian dai;
后缀名__後綴名 153.218967809|hou zhui ming;
后视镜__後視鏡 222.67604562|hou shi jing;
后才能__后才能 423.051424808|hou cai neng;
侯耀文__侯耀文 122.432284019|hou yao wen;
后遗症__後遺症 467.400766428|hou yi zheng;
红宝石__紅寶石 194.393772779|hong bao shi;
红玫瑰__紅玫瑰 163.476413088|hong mei gui;
红灯区__紅燈區 144.502706249|hong deng qu;
红地毯__紅地毯 242.066179876|hong di tan;
红绿灯__紅綠燈 253.488718522|hong lv deng;
红领巾__紅領巾 145.768741141|hong ling jin;
红楼梦__紅樓夢 960.516622856|hong lou meng;
红红的__紅紅的 288.565077751|hong hong de;
红血丝__紅血絲 265.78126155|hong xue si;
红细胞__紅細胞 296.216358865|hong xi bao;
轰炸机__轟炸機 265.78126155|hong zha ji;
红烧肉__紅燒肉 223.231720645|hong shao rou;
红十字__紅十字 193.427195796|hong shi zi;
红树林__紅樹林 127.572086295|hong shu lin;
红外线__紅外線 325.236501817|hong wai xian;
红卫兵__紅衛兵 245.101601395|hong wei bing;
湖北省__湖北省 1065.18429118|hu bei sheng;
湖北人__湖北人 111.507918629|hu bei ren;
互补性__互補性 112.204874836|hu bu xing;
琥珀色__琥珀色 257.3078729|hu po se;
护肤品__護膚品 506.204995518|hu fu pin;
蝴蝶结__蝴蝶結 180.613978088|hu die jie;
互动性__互動性 140.419785869|hu dong xing;
胡同里__衚衕里 112.34478795|hu tong li;
湖南台__湖南台 122.890853693|hu nan tai;
湖南省__湖南省 1071.84199596|hu nan sheng;
湖南人__湖南人 237.583386308|hu nan ren;
狐狸精__狐狸精 227.160466527|hu li jing;
互联网__互聯網 8567.57177296|hu lian wang;
葫芦岛__葫蘆島 153.028150386|hu lu dao;
胡萝卜__胡蘿蔔 585.662213047|hu luo bo;
户口本__戶口本 207.925293333|hu kou ben;
户口簿__戶口簿 135.773751924|hu kou bu;
胡椒粉__胡椒粉 143.605133321|hu jiao fen;
胡锦涛__胡錦濤 1300.22127911|hu jin tao;
呼吸道__呼吸道 303.313611771|hu xi dao;
户型图__戶型圖 111.925571131|hu xing tu;
胡主席__胡主席 142.713135632|hu zhu xi;
护身符__護身符 128.689786556|hu shen fu;
护士长__護士長 138.508067822|hu shi zhang;
忽然间__忽然間 169.28122395|hu ran jian;
湖人队__湖人隊 197.322580943|hu ren dui;
胡彦斌__胡彥斌 111.507918629|hu yan bin;
胡耀邦__胡耀邦 144.682892926|hu yao bang;
获得者__獲得者 230.582949765|huo de zhe;
火腿肠__火腿腸 120.314814642|huo tui chang;
火辣辣__火辣辣 137.134095104|huo la la;
获利盘__獲利盤 111.646962678|huo li pan;
火锅店__火鍋店 131.445140637|huo guo dian;
霍华德__霍華德 313.302012384|huo hua de;
火花塞__火花塞 111.230349808|huo hua sai;
火箭队__火箭隊 573.385557088|huo jian dui;
获奖者__獲獎者 211.848489234|huo jiang zhe;
火炬手__火炬手 262.817045902|huo ju shou;
或其它__或其它 348.309611377|huo qi ta;
或其他__或其他 933.377249507|huo qi ta;
活下去__活下去 451.373158744|huo xia qu;
活性炭__活性炭 219.37092252|huo xing tan;
火星人__火星人 251.914183226|huo xing ren;
火车票__火車票 946.259922413|huo che piao;
火车头__火車頭 141.29744947|huo che tou;
火车站__火車站 2119.18530697|huo che zhan;
豁出去__豁出去 181.516526012|huo chu qu;
或删除__或刪除 391.108593802|huo shan chu;
活生生__活生生 403.48504224|huo sheng sheng;
伙食费__伙食費 123.044091616|huo shi fei;
霍元甲__霍元甲 236.696839161|huo yuan jia;
或以上__或以上 120.916041011|huo yi shang;
霍英东__霍英東 122.737806611|huo ying dong;
回报率__回報率 350.486645516|hui bao lv;
会不会__會不會 7010.09707109|hui bu hui;
回不去__回不去 348.309611377|hui bu qu;
灰蒙蒙__灰濛濛 119.26985293|hui meng meng;
毁灭性__毀滅性 169.28122395|hui mie xing;
挥发油__揮髮油 131.281440129|hui fa you;
回到家__回到家 987.214115061|hui dao jia;
回头看__回頭看 420.94790182|hui tou kan;
回娘家__回娘家 105.558392399|hui niang jia;
回来吧__回來吧 178.377193209|hui lai ba;
回老家__回老家 369.779825848|hui lao jia;
回龙观__回龍觀 287.488291405|hui long guan;
灰鸽子__灰鴿子 202.807148249|hui ge zi;
会更好__會更好 313.69268222|hui geng hao;
灰姑娘__灰姑娘 280.761336094|hui gu niang;
回锅肉__回鍋肉 106.483223576|hui guo rou;
会回来__會回來 166.353500999|hui hui lai;
惠州市__惠州市 168.859844103|hui zhou shi;
回收站__回收站 257.62872122|hui shou zhan;
汇总表__匯總表 155.915530766|hui zong biao;
会员卡__會員卡 329.725485744|hui yuan ka;
回忆录__回憶錄 299.557272934|hui yi lu;
会议室__會議室 1272.96603034|hui yi shi;
卷烟厂__捲煙廠 138.163289429|juan yan chang;
决不能__決不能 328.086003878|jue bu neng;
觉得很__覺得很 1200.55002966|jue de hen;
决定权__決定權 166.146325956|jue ding quan;
决定性__決定性 433.187606905|jue ding xing;
决定书__決定書 130.791560815|jue ding shu;
绝对值__絕對值 140.070248771|jue dui zhi;
爵士乐__爵士樂 150.569041974|jue shi yue;
决策者__決策者 347.00988711|jue ce zhe;
决策层__決策層 173.986383704|jue ce ceng;
君不见__君不見 140.070248771|jun bu jian;
军分区__軍分區 137.647730357|jun fen qu;
几百万__幾百萬 479.196331601|ji bai wan;
基本面__基本面 929.894333673|ji ben mian;
基本法__基本法 133.093414711|ji ben fa;
基本功__基本功 324.426913464|ji ben gong;
基本上__基本上 7735.33428706|ji ben shang;
即表明__即表明 170.977284899|ji biao ming;
记不清__記不清 450.811022973|ji bu qing;
吉普车__吉普車 144.863304286|ji pu che;
既没有__既沒有 306.734573113|ji mei you;
继发性__繼發性 106.616002115|ji fa xing;
积分榜__積分榜 144.143005824|ji fen bang;
记得你__記得你 224.347234118|ji de ni;
继电器__繼電器 272.488653616|ji dian qi;
几点钟__幾點鐘 114.46454262|ji dian zhong;
机顶盒__機頂盒 535.402718412|ji ding he;
机动车__機動車 1162.27522076|ji dong che;
基督徒__基督徒 385.303469841|ji du tu;
基督教__基督教 820.943519051|ji du jiao;
集团军__集團軍 258.916120291|ji tuan jun;
吉他手__吉他手 147.964946673|ji ta shou;
几天后__幾天後 270.796100963|ji tian hou;
济南市__濟南市 410.07479966|ji nan shi;
纪念碑__紀念碑 316.046952528|ji nian bei;
纪念币__紀念幣 123.351140937|ji nian bi;
纪念品__紀念品 362.028498203|ji nian pin;
几年的__幾年的 366.568203397|ji nian de;
几年来__幾年來 388.195180646|ji nian lai;
纪念馆__紀念館 501.183541788|ji nian guan;
几年前__幾年前 919.523371782|ji nian qian;
纪念日__紀念日 352.238065853|ji nian ri;
吉林省__吉林省 781.999279332|ji lin sheng;
吉林市__吉林市 191.508436159|ji lin shi;
吉隆坡__吉隆坡 190.556205829|ji long po;
记录片__記錄片 122.432284019|ji lu pian;
纪录片__紀錄片 703.402776999|ji lu pian;
激光器__激光器 141.473639374|ji guang qi;
及各种__及各種 181.290467084|ji ge zhong;
几个人__幾個人 2415.4345439|ji ge ren;
几个字__幾個字 484.601008682|ji ge zi;
几个月__幾個月 2593.24683736|ji ge yue;
既可以__既可以 535.402718412|ji ke yi;
计划书__計劃書 254.438159592|ji hua shu;
季后赛__季後賽 600.442284667|ji hou sai;
激活码__激活碼 354.43965395|ji huo ma;
积极性__積極性 1689.15672637|ji ji xing;
季节性__季節性 258.271618599|ji jie xing;
基金会__基金會 1086.63578899|ji jin hui;
基金业__基金業 114.321989585|ji jin ye;
几句话__幾句話 665.043316617|ji ju hua;
机器猫__機器貓 345.284462654|ji qi mao;
及其它__及其它 447.452879516|ji qi ta;
机器人__機器人 2013.62967073|ji qi ren;
几千年__幾千年 609.488769235|ji qian nian;
几千万__幾千萬 314.475483928|ji qian wan;
激情戏__激情戲 171.403948695|ji qing xi;
集线器__集線器 149.075426771|ji xian qi;
吉祥物__吉祥物 353.998238229|ji xiang wu;
机械化__機械化 389.649164279|ji xie hua;
机械厂__機械廠 226.595011951|ji xie chang;
集装箱__集裝箱 718.463208478|ji zhuang xiang;
技战术__技戰術 136.112567367|ji zhan shu;
记者李__記者李 149.447435764|ji zhe li;
记者刘__記者劉 199.051387821|ji zhe liu;
记者会__記者會 381.957020988|ji zhe hui;
记者张__記者張 130.791560815|ji zhe zhang;
记者王__記者王 167.184787749|ji zhe wang;
记者问__記者問 407.020105042|ji zhe wen;
集中度__集中度 214.772467501|ji zhong du;
集中营__集中營 248.175085992|ji zhong ying;
记住我__記住我 284.281980745|ji zhu wo;
继承人__繼承人 269.449631503|ji cheng ren;
基础课__基礎課 123.658956482|ji chu ke;
基础性__基礎性 375.351064872|ji chu xing;
极少数__極少數 380.531740742|ji shao shu;
寄生虫__寄生蟲 272.828431509|ji sheng chong;
计生委__計生委 242.066179876|ji sheng wei;
记事本__記事本 564.874943184|ji shi ben;
计时器__計時器 112.765574943|ji shi qi;
及时性__及時性 343.567617462|ji shi xing;
几十亿__幾十億 122.584950132|ji shi yi;
几十万__幾十萬 670.034480971|ji shi wan;
技术部__技術部 508.734557585|ji shu bu;
计数器__計數器 345.715012791|ji shu qi;
技术性__技術性 432.109303457|ji shu xing;
技术员__技術員 352.238065853|ji shu yuan;
机子上__機子上 112.906187218|ji zi shang;
寄存器__寄存器 466.237298568|ji cun qi;
急匆匆__急匆匆 171.831677206|ji cong cong;
计算机__計算機 10137.2506989|ji suan ji;
计算器__計算器 465.076726846|ji suan qi;
计算出__計算出 286.415523108|ji suan chu;
集散地__集散地 174.42055653|ji san di;
集约化__集約化 144.502706249|ji yue hua;
记忆棒__記憶棒 268.444174826|ji yi bang;
记忆力__記憶力 436.982903472|ji yi li;
记忆卡__記憶卡 121.368931601|ji yi ka;
级以上__級以上 438.073368704|ji yi shang;
基因组__基因組 196.096919422|ji yin zu;
绩优股__績優股 169.28122395|ji you gu;
鸡尾酒__雞尾酒 142.180598718|ji wei jiu;
加班费__加班費 371.164834837|jia ban fei;
贾宝玉__賈寶玉 218.552335545|jia bao yu;
家门口__家門口 612.534451685|jia men kou;
加盟店__加盟店 239.068350048|jia meng dian;
加盟商__加盟商 261.83633885|jia meng shang;
加密狗__加密狗 127.73116145|jia mi gou;
佳木斯__佳木斯 134.762357541|jia mu si;
加菲猫__加菲貓 167.393257695|jia fei mao;
架飞机__架飛機 224.626982392|jia fei ji;
加图索__加圖索 115.467403456|jia tu suo;
加拿大__加拿大 3572.17795663|jia na da;
加内特__加內特 181.969489867|jia nei te;
嘉年华__嘉年華 355.767206381|jia nian hua;
加勒比__加勒比 422.52456065|jia le bi;
家乐福__家樂福 900.248315564|jia le fu;
家里面__家裡面 171.617679695|jia li mian;
伽利略__伽利略 111.230349808|jia li lue;
家里人__家裡人 734.761160623|jia li ren;
价格表__價格表 113.753550575|jia ge biao;
价格低__價格低 183.563783354|jia ge di;
价格战__價格戰 443.014235191|jia ge zhan;
嫁给你__嫁給你 116.915322539|jia gei ni;
嫁给我__嫁給我 232.893204426|jia gei wo;
架构师__架構師 125.209594649|jia gou shi;
加工费__加工費 116.18910757|jia gong fei;
加工厂__加工廠 384.823616623|jia gong chang;
加工业__加工業 234.933657026|jia gong ye;
甲骨文__甲骨文 341.433560596|jia gu wen;
甲壳虫__甲殼蟲 180.389043185|jia ke chong;
加起来__加起來 837.47630896|jia qi lai;
家企业__家企業 695.557838999|jia qi ye;
贾庆林__賈慶林 151.132997772|jia qing lin;
家协会__家協會 109.989815613|jia xie hui;
假新闻__假新聞 169.28122395|jia xin wen;
嘉兴市__嘉興市 156.89004718|jia xing shi;
甲状腺__甲狀腺 234.64107292|jia zhuang xian;
贾樟柯__賈樟柯 166.768626413|jia zhang ke;
价值链__價值鏈 248.175085992|jia zhi lian;
价值观__價值觀 1370.08592511|jia zhi guan;
家常菜__家常菜 129.332863581|jia chang cai;
嫁出去__嫁出去 134.762357541|jia chu qu;
加上去__加上去 147.229226029|jia shang qu;
加湿器__加濕器 109.034528882|jia shi qi;
驾驶者__駕駛者 218.552335545|jia shi zhe;
驾驶证__駕駛證 333.444336783|jia shi zheng;
驾驶室__駕駛室 139.895806636|jia shi shi;
驾驶人__駕駛人 122.432284019|jia shi ren;
加时赛__加時賽 109.30661816|jia shi sai;
驾驶员__駕駛員 1023.54337071|jia shi yuan;
加速度__加速度 229.436430673|jia su du;
加速器__加速器 203.820597887|jia su qi;
加油吧__加油吧 172.04594156|jia you ba;
加油站__加油站 962.913535809|jia you zhan;
加油啊__加油啊 253.488718522|jia you a;
见不到__見不到 593.745648473|jian bu dao;
见不得__見不得 168.439513167|jian bu de;
柬埔寨__柬埔寨 343.996026791|jian pu zhai;
健美操__健美操 125.36572391|jian mei cao;
见面会__見面會 351.799391968|jian mian hui;
减免税__減免稅 120.314814642|jian mian shui;
减肥法__減肥法 181.742866823|jian fei fa;
减肥药__減肥藥 143.0692679|jian fei yao;
简单化__簡單化 166.768626413|jian dan hua;
监督员__監督員 280.761336094|jian du yuan;
简体字__簡體字 122.127521944|jian ti zi;
剪贴板__剪貼板 138.680779525|jian tie ban;
剪头发__剪頭髮 160.649084484|jian tou fa;
健力宝__健力寶 210.008536601|jian li bao;
监管局__監管局 113.753550575|jian guan ju;
建国门__建國門 122.584950132|jian guo men;
建国后__建國后 116.333988795|jian guo hou;
健康网__健康網 328.904723278|jian kang wang;
件好事__件好事 283.927938713|jian hao shi;
监护人__監護人 221.292902041|jian hu ren;
尖叫声__尖叫聲 118.529012887|jian jiao sheng;
间歇性__間歇性 136.622376491|jian xie xing;
建筑群__建築群 148.889769675|jian zhu qun;
建筑学__建築學 113.611883002|jian zhu xue;
建筑师__建築師 401.979429753|jian zhu shi;
建筑业__建築業 354.881620091|jian zhu ye;
建筑物__建築物 1160.82773443|jian zhu wu;
监察部__監察部 129.171793682|jian cha bu;
检察官__檢察官 438.619621343|jian cha guan;
监察局__監察局 181.064689688|jian cha ju;
检察长__檢察長 263.472890441|jian cha zhang;
检查组__檢查組 289.285174995|jian cha zu;
检察院__檢察院 940.382265783|jian cha yuan;
坚持走__堅持走 129.494134325|jian chi zou;
建设部__建設部 656.807194196|jian she bu;
建设厅__建設廳 181.516526012|jian she ting;
建设局__建設局 261.83633885|jian she ju;
建设性__建設性 346.577724349|jian she xing;
建设者__建設者 186.794397067|jian she zhe;
健身房__健身房 399.482550191|jian shen fang;
监事会__監事會 346.1460998|jian shi hui;
监视器__監視器 255.391156791|jian shi qi;
件事情__件事情 228.295612376|jian shi qing;
兼容性__兼容性 681.82669043|jian rong xing;
检测出__檢測出 113.895394799|jian ce chu;
减速机__減速機 110.401782066|jian su ji;
建议您__建議您 652.727461906|jian yi nin;
建议书__建議書 183.792676978|jian yi shu;
监狱里__監獄里 147.780672558|jian yu li;
搅拌机__攪拌機 130.628674269|jiao ban ji;
脚步声__腳步聲 314.083839199|jiao bu sheng;
交朋友__交朋友 382.910172354|jiao peng you;
角度看__角度看 675.063104121|jiao du kan;
交通部__交通部 380.531740742|jiao tong bu;
交通费__交通費 310.580912674|jiao tong fei;
交通厅__交通廳 240.862563142|jiao tong ting;
交通局__交通局 316.046952528|jiao tong ju;
教练组__教練組 156.109948588|jiao lian zu;
教练员__教練員 207.666345181|jiao lian yuan;
交流会__交流會 243.882891747|jiao liu hui;
角落里__角落裡 493.744603771|jiao luo li;
教科书__教科書 692.962351041|jiao ke shu;
交换机__交換機 1744.7822355|jiao huan ji;
较好的__較好的 1193.09285994|jiao hao de;
脚后跟__腳後跟 117.353228453|jiao hou gen;
交互式__交互式 180.389043185|jiao hu shi;
交货期__交貨期 132.762114633|jiao huo qi;
交汇处__交匯處 139.895806636|jiao hui chu;
佼佼者__佼佼者 253.173026121|jiao jiao zhe;
交界处__交界處 230.870473623|jiao jie chu;
教学法__教學法 134.092283643|jiao xue fa;
交学费__交學費 137.305093541|jiao xue fei;
教学楼__教學樓 502.434215952|jiao xue lou;
交响曲__交響曲 165.526347625|jiao xiang qu;
交响乐__交響樂 194.878871049|jiao xiang yue;
脚趾头__腳趾頭 111.925571131|jiao zhi tou;
教职工__教職工 301.054193591|jiao zhi gong;
角质层__角質層 206.119414554|jiao zhi ceng;
交叉口__交叉口 173.986383704|jiao cha kou;
交出来__交出來 105.295633316|jiao chu lai;
叫什么__叫什麼 1240.08526378|jiao shen me;
教室里__教室里 391.108593802|jiao shi li;
教师节__教師節 374.41672986|jiao shi jie;
脚手架__腳手架 124.276893895|jiao shou jia;
教研室__教研室 422.52456065|jiao yan shi;
交易量__交易量 442.462509543|jiao yi liang;
交易者__交易者 120.46484039|jiao yi zhe;
交易商__交易商 145.587202159|jiao yi shang;
叫一声__叫一聲 185.402943996|jiao yi sheng;
交易日__交易日 1012.12795618|jiao yi ri;
交易所__交易所 932.214830498|jiao yi suo;
交易员__交易員 157.2815571|jiao yi yuan;
交易额__交易額 168.859844103|jiao yi e;
教育部__教育部 1657.87544242|jiao yu bu;
教育厅__教育廳 142.357889859|jiao yu ting;
教育家__教育家 194.151676652|jiao yu jia;
教育界__教育界 185.86560618|jiao yu jie;
教育局__教育局 954.550411286|jiao yu ju;
教育学__教育學 190.081867665|jiao yu xue;
教育者__教育者 113.32907693|jiao yu zhe;
教育网__教育網 579.130416613|jiao yu wang;
教务处__教務處 315.653350706|jiao wu chu;
江门市__江門市 212.907119447|jiang men shi;
将面临__將面臨 461.037428991|jiang mian lin;
将达到__將達到 727.472474808|jiang da dao;
讲道理__講道理 239.963779681|jiang dao li;
奖得主__獎得主 137.819369268|jiang de zhu;
讲的是__講的是 345.284462654|jiang de shi;
江南春__江南春 106.350610398|jiang nan chun;
降落伞__降落傘 106.350610398|jiang luo san;
讲故事__講故事 402.982545867|jiang gu shi;
蒋介石__蔣介石 1004.58849796|jiang jie shi;
蒋经国__蔣經國 123.967540162|jiang jing guo;
蒋勤勤__蔣勤勤 128.209578049|jiang qin qin;
奖学金__獎學金 1336.36083843|jiang xue jin;
江西省__江西省 784.92825478|jiang xi sheng;
将成为__將成為 1843.12238107|jiang cheng wei;
降水量__降水量 125.36572391|jiang shui liang;
江泽民__江澤民 566.990680223|jiang ze min;
江苏省__江蘇省 1822.5663337|jiang su sheng;
降雨量__降雨量 119.86585751|jiang yu liang;
蒋雯丽__蔣雯麗 117.207077876|jiang wen li;
接班人__接班人 421.998352644|jie ban ren;
解码器__解碼器 336.785179346|jie ma qi;
睫毛膏__睫毛膏 232.024158785|jie mao gao;
节目组__節目組 117.207077876|jie mu zu;
解放碑__解放碑 147.780672558|jie fang bei;
解放路__解放路 126.149295342|jie fang lu;
解放后__解放后 170.977284899|jie fang hou;
解放军__解放軍 1163.72451202|jie fang jun;
解放前__解放前 200.29551561|jie fang qian;
阶段性__階段性 706.917758081|jie duan xing;
姐弟恋__姐弟戀 125.36572391|jie di lian;
接电话__接電話 724.757896749|jie dian hua;
节能灯__節能燈 139.547573842|jie neng deng;
杰拉德__傑拉德 227.443722742|jie la de;
结了婚__結了婚 322.010219858|jie le hun;
结构图__結構圖 145.224802174|jie gou tu;
结构化__結構化 185.634130949|jie gou hua;
结构性__結構性 530.091629029|jie gou xing;
借款人__借款人 376.287731462|jie kuan ren;
杰克逊__傑克遜 371.627656329|jie ke xun;
结婚后__結婚後 330.548296374|jie hun hou;
结婚前__結婚前 167.810977762|jie hun qian;
结婚照__結婚照 183.106850936|jie hun zhao;
结婚证__結婚證 326.454673948|jie hun zheng;
结核病__結核病 165.939408926|jie he bing;
解决好__解決好 373.484720623|jie jue hao;
借记卡__借記卡 194.393772779|jie ji ka;
节假日__節假日 538.078184713|jie jia ri;
接下来__接下來 3830.36770325|jie xia lai;
接下去__接下去 229.436430673|jie xia qu;
介绍信__介紹信 145.768741141|jie shao xin;
接收机__接收機 193.90988203|jie shou ji;
接收器__接收器 208.184564378|jie shou qi;
解说员__解說員 210.532600599|jie shuo yuan;
届人大__屆人大 143.247667161|jie ren da;
接入点__接入點 120.164975734|jie ru dian;
节奏感__節奏感 135.098649108|jie zou gan;
解压缩__解壓縮 466.818670029|jie ya suo;
锦标赛__錦標賽 525.487661863|jin biao sai;
进不了__進不了 330.136634719|jin bu liao;
进不去__進不去 954.550411286|jin bu qu;
禁不住__禁不住 397.496217848|jin bu zhu;
金瓶梅__金瓶梅 191.031727675|jin ping mei;
紧迫感__緊迫感 193.186303435|jin po gan;
紧迫性__緊迫性 145.587202159|jin po xing;
金马奖__金馬獎 176.387781073|jin ma jiang;
仅代表__僅代表 1338.02720458|jin dai biao;
进度条__進度條 166.146325956|jin du tiao;
仅提供__僅提供 840.61307342|jin ti gong;
近年来__近年來 2974.24138187|jin nian lai;
今年初__今年初 205.862715427|jin nian chu;
金牛座__金牛座 253.488718522|jin niu zuo;
近两年__近兩年 595.22730595|jin liang nian;
金刚石__金剛石 164.293322714|jin gang shi;
尽可能__儘可能 2249.81438398|jin ke neng;
进口量__進口量 173.769702743|jin kou liang;
进口国__進口國 121.520271774|jin kou guo;
进口车__進口車 214.504991945|jin kou che;
进口商__進口商 195.60878915|jin kou shang;
进化论__進化論 180.164388413|jin hua lun;
金华市__金華市 149.261315371|jin hua shi;
金黄色__金黃色 333.029068427|jin huang se;
近几年__近幾年 970.140222547|jin ji nian;
紧接着__緊接着 617.901063897|jin jie zhe;
近距离__近距離 563.46883971|jin ju li;
金球奖__金球獎 181.516526012|jin qiu jiang;
金曲奖__金曲獎 115.323601467|jin qu jiang;
金喜善__金喜善 124.431860131|jin xi shan;
近现代__近現代 166.146325956|jin xian dai;
仅限于__僅限於 485.205278648|jin xian yu;
进销存__進銷存 206.119414554|jin xiao cun;
金像奖__金像獎 268.109857044|jin xiang jiang;
近些年__近些年 217.736803143|jin xie nian;
进行曲__進行曲 113.895394799|jin xing qu;
金正日__金正日 218.008308584|jin zheng ri;
金城武__金城武 300.304800557|jin cheng wu;
进出口__進出口 1173.92027842|jin chu kou;
金沙江__金沙江 134.762357541|jin sha jiang;
金士顿__金士頓 399.980682268|jin shi dun;
近十年__近十年 210.270405333|jin shi nian;
近视眼__近視眼 135.267109459|jin shi yan;
金手指__金手指 213.971039752|jin shou zhi;
金日成__金日成 132.762114633|jin ri cheng;
金融股__金融股 164.293322714|jin rong gu;
金融街__金融街 201.79873775|jin rong jie;
金融界__金融界 383.865702254|jin rong jie;
金融学__金融學 134.092283643|jin rong xue;
金融业__金融業 455.327784806|jin rong ye;
金字塔__金字塔 494.9767145|jin zi ta;
仅次于__僅次於 530.752623218|jin ci yu;
紧凑型__緊湊型 115.467403456|jin cou xing;
近三年__近三年 173.337150041|jin san nian;
进一步__進一步 12749.7474029|jin yi bu;
近一年__近一年 232.893204426|jin yi nian;
金银花__金銀花 122.432284019|jin yin hua;
仅有的__僅有的 345.284462654|jin you de;
劲舞团__勁舞團 363.837594448|jin wu tuan;
经办人__經辦人 115.899886195|jing ban ren;
经不起__經不起 367.025293151|jing bu qi;
经不住__經不住 131.937467932|jing bu zhu;
经贸委__經貿委 164.498187167|jing mao wei;
经得起__經得起 292.912705474|jing de qi;
景德镇__景德鎮 223.788782324|jing de zhen;
京东方__京東方 117.93965545|jing dong fang;
晶体管__晶體管 241.463621556|jing ti guan;
境内外__境內外 151.888225993|jing nei wai;
敬老院__敬老院 181.516526012|jing lao yuan;
净利润__凈利潤 1153.6172982|jing li run;
经理人__經理人 545.504855178|jing li ren;
井冈山__井岡山 275.561951728|jing gang shan;
精华区__精華區 117.353228453|jing hua qu;
经济法__經濟法 175.073848088|jing ji fa;
经济体__經濟體 309.4219738|jing ji ti;
荆棘谷__荊棘谷 168.859844103|jing ji gu;
经济圈__經濟圈 182.651055928|jing ji quan;
经济区__經濟區 297.696584607|jing ji qu;
经济学__經濟學 1777.70330251|jing ji xue;
经济型__經濟型 228.295612376|jing ji xing;
经济性__經濟性 259.238974004|jing ji xing;
竞技场__競技場 758.957532109|jing ji chang;
经济师__經濟師 120.164975734|jing ji shi;
经纪人__經紀人 1277.73391996|jing ji ren;
精简版__精簡版 131.117943492|jing jian ban;
警戒线__警戒線 157.085680168|jing jie xian;
静静的__靜靜的 683.528148986|jing jing de;
精确度__精確度 114.607273411|jing que du;
静悄悄__靜悄悄 222.398727024|jing qiao qiao;
精细化__精細化 118.23396695|jing xi hua;
经销商__經銷商 3314.82719055|jing xiao shang;
精装修__精裝修 215.040276584|jing zhuang xiu;
竞争力__競爭力 2561.13118731|jing zheng li;
竞争性__競爭性 216.924313917|jing zheng xing;
竞争者__競爭者 370.240920313|jing zheng zhe;
颈椎病__頸椎病 216.384339476|jing zhui bing;
警察局__警察局 257.3078729|jing cha ju;
经常性__經常性 415.216987933|jing chang xing;
精神病__精神病 513.831666385|jing shen bing;
镜子里__鏡子里 186.32942291|jing zi li;
净资产__凈資產 614.828697239|jing zi chan;
经验者__經驗者 111.646962678|jing yan zhe;
经验值__經驗值 292.912705474|jing yan zhi;
经营部__經營部 224.06783424|jing ying bu;
经营户__經營戶 185.86560618|jing ying hu;
经营权__經營權 422.52456065|jing ying quan;
经营性__經營性 322.411748334|jing ying xing;
经营者__經營者 1211.06843631|jing ying zhe;
静安区__靜安區 112.906187218|jing an qu;
静安寺__靜安寺 122.737806611|jing an si;
酒吧里__酒吧里 209.224885556|jiu ba li;
就不是__就不是 1274.55334676|jiu bu shi;
九点半__九點半 121.671800659|jiu dian ban;
九个月__九個月 107.282382453|jiu ge yue;
就够了__就夠了 744.902491688|jiu gou le;
九华山__九華山 109.30661816|jiu hua shan;
就好象__就好象 332.614317243|jiu hao xiang;
救护车__救護車 296.216358865|jiu hu che;
就会有__就會有 817.880151926|jiu hui you;
旧金山__舊金山 436.982903472|jiu jin shan;
就像是__就像是 774.242000696|jiu xiang shi;
九寨沟__九寨溝 520.923681206|jiu zhai gou;
旧社会__舊社會 191.269933402|jiu she hui;
救生圈__救生圈 112.765574943|jiu sheng quan;
九十九__九十九 119.56748386|jiu shi jiu;
就是指__就是指 271.133768339|jiu shi zhi;
救世主__救世主 227.727332161|jiu shi zhu;
就是爱__就是愛 135.604660605|jiu shi ai;
就让你__就讓你 111.646962678|jiu rang ni;
就让我__就讓我 363.837594448|jiu rang wo;
就在这__就在這 395.519762073|jiu zai zhe;
救援队__救援隊 142.003528374|jiu yuan dui;
九月份__九月份 201.547419552|jiu yue fen;
就业率__就業率 268.109857044|jiu ye lv;
就有了__就有了 910.401881269|jiu you le;
举报人__舉報人 189.608710238|ju bao ren;
聚丙烯__聚丙烯 117.646076559|ju bing xi;
居民楼__居民樓 127.73116145|ju min lou;
居民区__居民區 167.601987591|ju min qu;
具体化__具體化 128.049907079|ju ti hua;
俱乐部__俱樂部 4560.46281159|ju le bu;
聚合物__聚合物 288.565077751|ju he wu;
聚集地__聚集地 108.087539034|ju ji di;
局机关__局機關 131.117943492|ju ji guan;
狙击手__狙擊手 256.347723437|ju ji shou;
局局长__局局長 845.867144221|ju ju zhang;
局限性__局限性 449.128812644|ju xian xing;
巨蟹座__巨蟹座 255.073095111|ju xie zuo;
居住地__居住地 217.19480623|ju zhu di;
居住区__居住區 249.415244207|ju zhu qu;
居住证__居住證 215.576896995|ju zhu zheng;
剧场版__劇場版 252.54282031|ju chang ban;
居世界__居世界 173.986383704|ju shi jie;
聚乙烯__聚乙烯 155.915530766|ju yi xi;
局域网__局域網 1385.53861435|ju yu wang;
局外人__局外人 161.653186955|ju wai ren;
居委会__居委會 525.487661863|ju wei hui;
巨无霸__巨無霸 149.261315371|ju wu ba;
聚氨酯__聚氨酯 153.218967809|ju an zhi;
全明星__全明星 212.641966978|quan ming xing;
全方位__全方位 1295.36947746|quan fang wei;
全天候__全天候 218.552335545|quan tian hou;
权利人__權利人 989.677650042|quan li ren;
全流通__全流通 244.796354228|quan liu tong;
全攻略__全攻略 172.690339006|quan gong lue;
全国性__全國性 584.932834985|quan guo xing;
全家福__全家福 173.121277629|quan jia fu;
全家人__全家人 312.132919672|quan jia ren;
全聚德__全聚德 163.884358899|quan ju de;
全球通__全球通 421.998352644|quan qiu tong;
全球化__全球化 1018.45404378|quan qiu hua;
全球性__全球性 368.399985048|quan qiu xing;
全智贤__全智賢 111.369047744|quan zhi xian;
泉州市__泉州市 172.690339006|quan zhou shi;
全世界__全世界 3759.43359875|quan shi jie;
全人类__全人類 261.184568064|quan ren lei;
全日制__全日制 279.713669565|quan ri zhi;
全自动__全自動 455.895552723|quan zi dong;
犬夜叉__犬夜叉 177.711575153|quan ye cha;
权威性__權威性 357.99085261|quan wei xing;
却不能__卻不能 552.345286903|que bu neng;
却不知__卻不知 244.186999878|que bu zhi;
却不是__卻不是 350.486645516|que bu shi;
却没有__卻沒有 1766.66116773|que mei you;
确定性__確定性 123.044091616|que ding xing;
缺血性__缺血性 127.73116145|que xue xing;
群众性__群眾性 163.476413088|qun zhong xing;
起不来__起不來 321.609191441|qi bu lai;
岂不是__豈不是 1318.16721196|qi bu shi;
起跑线__起跑線 181.742866823|qi pao xian;
起名字__起名字 106.483223576|qi ming zi;
欺负人__欺負人 144.863304286|qi fu ren;
齐达内__齊達內 568.405572245|qi da nei;
启动盘__啟動盤 166.146325956|qi dong pan;
启动项__啟動項 206.89143407|qi dong xiang;
其他人__其他人 2564.32477261|qi ta ren;
汽轮机__汽輪機 112.625137786|qi lun ji;
其观点__其觀點 907.004698479|qi guan dian;
旗舰店__旗艦店 229.150692759|qi jian dian;
栖息地__棲息地 114.893269147|qi xi di;
旗下的__旗下的 623.314694733|qi xia de;
气象台__氣象台 204.07475061|qi xiang tai;
气象局__氣象局 291.819695868|qi xiang ju;
起重机__起重機 181.969489867|qi zhong ji;
其主要__其主要 310.194118206|qi zhu yao;
汽车站__汽車站 391.108593802|qi che zhan;
汽车业__汽車業 193.668388536|qi che ye;
启示录__啟示錄 105.0335283|qi shi lu;
企事业__企事業 113.47039186|qi shi ye;
七十二__七十二 159.85029497|qi shi er;
七彩虹__七彩虹 272.149298879|qi cai hong;
起诉书__起訴書 125.209594649|qi su shu;
七月份__七月份 157.870654598|qi yue fen;
企业版__企業版 261.510250403|qi ye ban;
企业级__企業級 276.938965124|qi ye ji;
企业家__企業家 1751.317311|qi ye jia;
企业间__企業間 122.432284019|qi ye jian;
企业界__企業界 193.668388536|qi ye jie;
企业主__企業主 137.647730357|qi ye zhu;
期望值__期望值 257.62872122|qi wang zhi;
洽谈会__洽談會 299.557272934|qia tan hui;
千百年__千百年 230.008975843|qian bai nian;
前不久__前不久 696.425160166|qian bu jiu;
前面板__前面板 116.47905068|qian mian ban;
签名档__簽名檔 432.109303457|qian ming dang;
千分之__千分之 160.249192015|qian fen zhi;
潜伏期__潛伏期 117.207077876|qian fu qi;
千岛湖__千島湖 228.8653107|qian dao hu;
钱塘江__錢塘江 128.369448119|qian tang jiang;
前女友__前女友 254.755429543|qian nv you;
前男友__前男友 234.056997396|qian nan you;
千里马__千里馬 207.149415951|qian li ma;
潜力股__潛力股 115.467403456|qian li gu;
前两天__前兩天 1359.87999657|qian liang tian;
前列腺__前列腺 448.56947196|qian lie xian;
潜规则__潛規則 524.833224606|qian gui ze;
签合同__簽合同 353.117055307|qian he tong;
前几天__前幾天 2996.56312723|qian ji tian;
前几年__前幾年 639.84183651|qian ji nian;
浅浅的__淺淺的 176.168109435|qian qian de;
钱学森__錢學森 127.096048509|qian xue sen;
前些年__前些年 168.859844103|qian xie nian;
前瞻性__前瞻性 290.730764849|qian zhan xing;
前阵子__前陣子 227.727332161|qian zhen zi;
钱钟书__錢鍾書 134.092283643|qian zhong shu;
前十名__前十名 191.269933402|qian shi ming;
潜水艇__潛水艇 125.522047856|qian shui ting;
潜水员__潛水員 205.350275845|qian shui yuan;
嵌入式__嵌入式 892.429452826|qian ru shi;
前总统__前總統 215.30841961|qian zong tong;
前总理__前總理 114.893269147|qian zong li;
前三名__前三名 237.879639313|qian san ming;
前苏联__前蘇聯 374.41672986|qian su lian;
前一天__前一天 730.197220308|qian yi tian;
潜意识__潛意識 614.828697239|qian yi shi;
千万别__千萬別 1116.83875458|qian wan bie;
千万元__千萬元 249.415244207|qian wan yuan;
瞧不起__瞧不起 430.496878967|qiao bu qi;
乔布斯__喬布斯 139.72158175|qiao bu si;
巧克力__巧克力 1706.08071057|qiao ke li;
悄悄的__悄悄的 247.557321202|qiao qiao de;
悄悄话__悄悄話 508.734557585|qiao qiao hua;
强迫症__強迫症 157.67404401|qiang po zheng;
枪击案__槍擊案 149.633788238|qiang ji an;
强奸了__強姦了 130.628674269|qiang jian le;
强企业__強企業 142.891090816|qiang qi ye;
强制性__強制性 471.495815538|qiang zhi xing;
强有力__強有力 686.943814365|qiang you li;
且不说__且不說 224.626982392|qie bu shuo;
切换到__切換到 255.709615075|qie huan dao;
切除术__切除術 216.11485651|qie chu shu;
切入点__切入點 333.029068427|qie ru dian;
切尔西__切爾西 1169.53977147|qie er xi;
亲民党__親民黨 145.043940608|qin min dang;
侵略者__侵略者 192.225730308|qin lue zhe;
禽流感__禽流感 844.813709452|qin liu gan;
秦皇岛__秦皇島 520.274927886|qin huang dao;
亲和力__親和力 324.83145542|qin he li;
亲切感__親切感 123.813152185|qin qie gan;
秦始皇__秦始皇 414.699880708|qin shi huang;
亲眼见__親眼見 120.46484039|qin yan jian;
请不要__請不要 1250.95005139|qing bu yao;
轻飘飘__輕飄飄 121.066816454|qing piao piao;
青霉素__青霉素 207.149415951|qing mei su;
清明节__清明節 214.2378495|qing ming jie;
请访问__請訪問 133.42554153|qing fang wen;
请大家__請大家 1988.69219664|qing da jia;
青岛市__青島市 509.368920718|qing dao shi;
请等待__請等待 2178.08791404|qing deng dai;
请登录__請登錄 163.884358899|qing deng lu;
请点击__請點擊 433.187606905|qing dian ji;
擎天柱__擎天柱 208.964318904|qing tian zhu;
青铜器__青銅器 128.209578049|qing tong qi;
青年队__青年隊 139.200207879|qing nian dui;
青年人__青年人 383.387639617|qing nian ren;
请立即__請立即 172.690339006|qing li ji;
请联系__請聯繫 520.923681206|qing lian xi;
请留言__請留言 110.401782066|qing liu yan;
青光眼__青光眼 129.979154132|qing guang yan;
请告知__請告知 107.416157498|qing gao zhi;
请高手__請高手 248.484546245|qing gao shou;
请各位__請各位 1004.58849796|qing ge wei;
请给我__請給我 194.636170786|qing gei wo;
轻工业__輕工業 139.547573842|qing gong ye;
青海湖__青海湖 166.560934377|qing hai hu;
青海省__青海省 300.304800557|qing hai sheng;
请记住__請記住 190.318888971|qing ji zhu;
请及时__請及時 318.418891685|qing ji shi;
清洁工__清潔工 194.878871049|qing jie gong;
清洁剂__清潔劑 136.963309627|qing jie ji;
请进来__請進來 120.015323434|qing jin lai;
请尽快__請儘快 192.945711079|qing jin kuai;
请确认__請確認 167.184787749|qing que ren;
请求权__請求權 125.835280772|qing qiu quan;
请选择__請選擇 295.111021611|qing xuan ze;
清晰度__清晰度 302.558594526|qing xi du;
倾向性__傾向性 123.967540162|qing xiang xing;
情绪化__情緒化 193.668388536|qing xu hua;
青壮年__青壯年 126.937764318|qing zhuang nian;
清真寺__清真寺 177.269210225|qing zhen si;
清政府__清政府 187.4940348|qing zheng fu;
请直接__請直接 157.2815571|qing zhi jie;
请注明__請註明 342.285588041|qing zhu ming;
请注意__請注意 887.99205879|qing zhu yi;
青春痘__青春痘 343.139741671|qing chun dou;
青春期__青春期 536.070335228|qing chun qi;
青城山__青城山 121.066816454|qing cheng shan;
青少年__青少年 2406.4213017|qing shao nian;
请稍候__請稍候 125.36572391|qing shao hou;
请使用__請使用 166.768626413|qing shi yong;
请输入__請輸入 2335.51567197|qing shu ru;
情人节__情人節 1235.45786087|qing ren jie;
请遵守__請遵守 184.71110921|qing zun shou;
请在此__請在此 128.689786556|qing zai ci;
请自行__請自行 332.614317243|qing zi xing;
请参考__請參考 233.765505073|qing can kao;
请参阅__請參閱 162.258658377|qing can yue;
清一色__清一色 243.275811214|qing yi se;
轻音乐__輕音樂 131.773154284|qing yin yue;
请与我__請與我 106.218162376|qing yu wo;
请务必__請務必 197.322580943|qing wu bi;
穷光蛋__窮光蛋 139.373782642|qiong guang dan;
球磨机__球磨機 105.821807183|qiu mo ji;
求发展__求發展 110.126966673|qiu fa zhan;
求求你__求求你 180.839193473|qiu qiu ni;
求职者__求職者 432.648119245|qiu zhi zhe;
去北京__去北京 417.291872914|qu bei jing;
去美国__去美國 256.347723437|qu mei guo;
去面对__去面對 361.12732612|qu mian dui;
渠道商__渠道商 140.419785869|qu dao shang;
驱动力__驅動力 138.680779525|qu dong li;
驱动器__驅動器 479.196331601|qu dong qi;
去那里__去那裡 367.025293151|qu na li;
去哪里__去哪裡 1029.9408079|qu na li;
去哪儿__去哪兒 310.968189453|qu na er;
去年底__去年底 271.471856767|qu nian di;
去角质__去角質 119.26985293|qu jiao zhi;
取景器__取景器 116.624293448|qu jing qi;
去香港__去香港 203.820597887|qu xiang gang;
区政府__區政府 573.385557088|qu zheng fu;
驱逐舰__驅逐艦 178.59961945|qu zhu jian;
屈臣氏__屈臣氏 172.905674062|qu chen shi;
去日本__去日本 150.944778196|qu ri ben;
去死吧__去死吧 232.024158785|qu si ba;
去死皮__去死皮 184.251320835|qu si pi;
区域性__區域性 407.020105042|qu yu xing;
趣味性__趣味性 151.888225993|qu wei xing;
选拔赛__選拔賽 161.854759309|xuan ba sai;
宣讲会__宣講會 117.499561272|xuan jiang hui;
选项卡__選項卡 300.679263607|xuan xiang ka;
选项中__選項中 132.596773978|xuan xiang zhong;
选修课__選修課 213.172602547|xuan xiu ke;
宣传部__宣傳部 489.456318842|xuan chuan bu;
宣传片__宣傳片 280.062456643|xuan chuan pian;
宣传单__宣傳單 156.499511818|xuan chuan dan;
宣传册__宣傳冊 139.373782642|xuan chuan ce;
悬赏分__懸賞分 1483.83226857|xuan shang fen;
选择题__選擇題 319.611528482|xuan ze ti;
选择好__選擇好 130.303509496|xuan ze hao;
选择权__選擇權 215.845709156|xuan ze quan;
选择性__選擇性 499.3133654|xuan ze xing;
轩辕剑__軒轅劍 177.048440864|xuan yuan jian;
宣武区__宣武區 145.768741141|xuan wu qu;
雪佛兰__雪佛蘭 145.043940608|xue fu lan;
雪铁龙__雪鐵龍 226.877563077|xue tie long;
血淋淋__血淋淋 167.393257695|xue lin lin;
血流量__血流量 145.950506492|xue liu liang;
血汗钱__血汗錢 297.696584607|xue han qian;
血精灵__血精靈 341.859308876|xue jing ling;
学习班__學習班 147.964946673|xue xi ban;
学习机__學習機 108.898738333|xue xi ji;
学习型__學習型 123.044091616|xue xi xing;
学习者__學習者 230.582949765|xue xi zhe;
血小板__血小板 263.801426189|xue xiao ban;
学校里__學校里 844.813709452|xue xiao li;
学什么__學什麼 252.228305921|xue shen me;
学生票__學生票 119.56748386|xue sheng piao;
学生会__學生會 665.872587905|xue sheng hui;
学生证__學生證 367.025293151|xue sheng zheng;
学术界__學術界 422.52456065|xue shu jie;
学杂费__學雜費 163.476413088|xue za fei;
学院路__學院路 105.164499152|xue yuan lu;
学研究__學研究 158.264611567|xue yan jiu;
学英语__學英語 393.063006485|xue ying yu;
学位证__學位證 181.742866823|xue wei zheng;
荨麻疹__蕁麻疹 242.972837869|xun ma zhen;
训练场__訓練場 168.649547684|xun lian chang;
训练师__訓練師 117.646076559|xun lian shi;
训练营__訓練營 219.37092252|xun lian ying;
巡回赛__巡迴賽 120.015323434|xun hui sai;
巡视员__巡視員 105.164499152|xun shi yuan;
巡洋舰__巡洋艦 107.684208225|xun yang jian;
薰衣草__薰衣草 233.183609039|xun yi cao;
西班牙__西班牙 2289.40978274|xi ban ya;
细胞膜__細胞膜 112.065135969|xi bao mo;
西北部__西北部 186.097370046|xi bei bu;
西门庆__西門慶 206.119414554|xi men qing;
西门子__西門子 1082.58098585|xi men zi;
洗面奶__洗面奶 327.677408739|xi mian nai;
洗发水__洗髮水 306.734573113|xi fa shui;
西方人__西方人 480.392137969|xi fang ren;
洗涤剂__洗滌劑 127.096048509|xi di ji;
希特勒__希特勒 476.813641365|xi te le;
系统盘__系統盤 225.468321935|xi tong pan;
系统化__系統化 166.768626413|xi tong hua;
系统性__系統性 294.009808944|xi tong xing;
西南部__西南部 163.884358899|xi nan bu;
希拉里__希拉里 240.562595233|xi la li;
希拉克__希拉克 172.04594156|xi la ke;
系列之__系列之 136.282292017|xi lie zhi;
膝关节__膝關節 192.465424888|xi guan jie;
习惯性__習慣性 528.113581536|xi guan xing;
洗干净__洗乾淨 455.327784806|xi gan jing;
喜欢听__喜歡聽 330.548296374|xi huan ting;
喜欢你__喜歡你 1244.72999861|xi huan ni;
喜欢吃__喜歡吃 707.799244422|xi huan chi;
西海岸__西海岸 110.539446825|xi hai an;
西红柿__西紅柿 760.851466162|xi hong shi;
细菌性__細菌性 105.690017726|xi jun xing;
习近平__習近平 163.476413088|xi jin ping;
喜剧片__喜劇片 159.651218957|xi ju pian;
戏剧性__戲劇性 323.216307961|xi ju xing;
吸血鬼__吸血鬼 515.113903202|xi xue gui;
细细的__細細的 229.722524886|xi xi de;
西西里__西西里 138.680779525|xi xi li;
嘻嘻嘻__嘻嘻嘻 205.094534596|xi xi xi;
西直门__西直門 326.454673948|xi zhi men;
系主任__系主任 256.987424161|xi zhu ren;
吸尘器__吸塵器 171.403948695|xi chen qi;
西城区__西城區 240.562595233|xi cheng qu;
洗刷刷__洗刷刷 297.325836157|xi shua shua;
牺牲品__犧牲品 257.94996962|xi sheng pin;
洗手间__洗手間 676.747684543|xi shou jian;
西餐厅__西餐廳 189.845141544|xi can ting;
西雅图__西雅圖 243.882891747|xi ya tu;
洗衣粉__洗衣粉 289.645897197|xi yi fen;
洗衣服__洗衣服 812.799921236|xi yi fu;
洗衣机__洗衣機 1116.83875458|xi yi ji;
吸引力__吸引力 1581.19770715|xi yin li;
吸引住__吸引住 144.863304286|xi yin zhu;
吸引人__吸引人 740.275558891|xi yin ren;
西游记__西遊記 455.327784806|xi you ji;
西安市__西安市 544.825488702|xi an shi;
希尔顿__希爾頓 266.444503116|xi er dun;
下半年__下半年 1983.741885|xia ban nian;
下半场__下半場 544.825488702|xia ban chang;
下半身__下半身 350.050152834|xia ban shen;
下辈子__下輩子 434.268601197|xia bei zi;
下不来__下不來 134.762357541|xia bu lai;
下不了__下不了 259.885889675|xia bu liao;
厦门市__廈門市 425.69561654|xia men shi;
下拉框__下拉框 115.036534536|xia la kuang;
夏令营__夏令營 261.184568064|xia ling ying;
下个月__下個月 1249.39213028|xia ge yue;
下工夫__下工夫 105.821807183|xia gong fu;
下划线__下劃線 176.387781073|xia hua xian;
下星期__下星期 304.449671797|xia xing qi;
下周一__下周一 670.869975958|xia zhou yi;
下水道__下水道 312.522131716|xia shui dao;
下一步__下一步 2300.85021536|xia yi bu;
下一篇__下一篇 324.02287532|xia yi pian;
下一代__下一代 933.377249507|xia yi dai;
吓一跳__嚇一跳 188.196293023|xia yi tiao;
下一站__下一站 201.547419552|xia yi zhan;
下意识__下意識 446.339066527|xia yi shi;
下一次__下一次 588.588831574|xia yi ci;
下一页__下一頁 524.179602378|xia yi ye;
下雨天__下雨天 209.485777119|xia yu tian;
下雨了__下雨了 319.611528482|xia yu le;
夏威夷__夏威夷 336.785179346|xia wei yi;
下午茶__下午茶 187.027319083|xia wu cha;
现代化__現代化 2532.56730325|xian dai hua;
现代性__現代性 173.337150041|xian dai xing;
现代人__現代人 675.063104121|xian dai ren;
先天性__先天性 380.057830188|xian tian xing;
限量版__限量版 228.011295226|xian liang ban;
线路板__線路板 110.677283245|xian lu ban;
县级市__縣級市 138.508067822|xian ji shi;
限价房__限價房 190.556205829|xian jia fang;
现阶段__現階段 767.517531652|xian jie duan;
现金流__現金流 414.183417482|xian jin liu;
先进性__先進性 573.385557088|xian jin xing;
先行者__先行者 144.682892926|xian xing zhe;
现状及__現狀及 293.277951001|xian zhuang ji;
县政府__縣政府 657.626195507|xian zheng fu;
限制性__限制性 120.615053212|xian zhi xing;
现场会__現場會 176.827946446|xian chang hui;
显示屏__顯示屏 702.526765976|xian shi ping;
显示卡__顯示卡 160.049619219|xian shi ka;
显示器__顯示器 3630.51911858|xian shi qi;
县市区__縣市區 118.381397999|xian shi qu;
显示出__顯示出 1035.08753546|xian shi chu;
仙人掌__仙人掌 270.458854115|xian ren zhang;
现如今__現如今 166.353500999|xian ru jin;
现在又__現在又 502.434215952|xian zai you;
嫌疑人__嫌疑人 445.783200166|xian yi ren;
显微镜__顯微鏡 273.509258874|xian wei jing;
纤维素__纖維素 242.066179876|xian wei su;
献爱心__獻愛心 173.553291634|xian ai xin;
小霸王__小霸王 113.32907693|xiao ba wang;
小白兔__小白兔 245.407229187|xiao bai tu;
小白脸__小白臉 196.831399718|xiao bai lian;
小白鼠__小白鼠 143.426288875|xiao bai shu;
小白菜__小白菜 112.204874836|xiao bai cai;
小宝宝__小寶寶 393.063006485|xiao bao bao;
小宝贝__小寶貝 222.121753798|xiao bao bei;
小不点__小不點 126.464093517|xiao bu dian;
小布什__小布什 133.093414711|xiao bu shi;
小盘股__小盤股 139.72158175|xiao pan gu;
小胖子__小胖子 121.217779906|xiao pang zi;
小朋友__小朋友 2445.72321123|xiao peng you;
小屁孩__小屁孩 204.839111844|xiao pi hai;
小马哥__小馬哥 127.254530072|xiao ma ge;
小卖部__小賣部 158.461958559|xiao mai bu;
校门口__校門口 174.638049069|xiao men kou;
小妹妹__小妹妹 562.76710106|xiao mei mei;
小美女__小美女 203.820597887|xiao mei nv;
笑眯眯__笑眯眯 215.040276584|xiao mi mi;
小蜜蜂__小蜜蜂 138.335571213|xiao mi feng;
小房间__小房間 119.41857567|xiao fang jian;
消防车__消防車 142.891090816|xiao fang che;
小房子__小房子 152.837570606|xiao fang zi;
小分队__小分隊 190.556205829|xiao fen dui;
消费品__消費品 619.442999798|xiao fei pin;
消费类__消費類 187.26053154|xiao fei lei;
消费量__消費量 264.789493468|xiao fei liang;
消费群__消費群 114.037415895|xiao fei qun;
消费者__消費者 11411.2834586|xiao fei zhe;
消费税__消費稅 266.776744296|xiao fei shui;
小肥羊__小肥羊 140.945727665|xiao fei yang;
小地方__小地方 187.961915178|xiao di fang;
小弟弟__小弟弟 421.998352644|xiao di di;
小电影__小電影 139.547573842|xiao dian ying;
小东西__小東西 428.356335222|xiao dong xi;
小动作__小動作 189.608710238|xiao dong zuo;
小动物__小動物 404.491915522|xiao dong wu;
小提琴__小提琴 502.434215952|xiao ti qin;
小甜甜__小甜甜 141.29744947|xiao tian tian;
小天使__小天使 154.368879448|xiao tian shi;
小天鹅__小天鵝 144.682892926|xiao tian e;
小兔子__小兔子 200.04606951|xiao tu zi;
小女孩__小女孩 1585.14349339|xiao nv hai;
小女生__小女生 427.82286438|xiao nv sheng;
小女人__小女人 386.264972075|xiao nv ren;
小女子__小女子 356.210827905|xiao nv zi;
小女儿__小女兒 189.136730609|xiao nv er;
小男孩__小男孩 668.366611253|xiao nan hai;
小男生__小男生 185.402943996|xiao nan sheng;
小男人__小男人 114.75018218|xiao nan ren;
小妮子__小妮子 194.393772779|xiao ni zi;
小牛队__小牛隊 106.350610398|xiao niu dui;
效率高__效率高 171.190483873|xiao lv gao;
小喇叭__小喇叭 114.893269147|xiao la ba;
小老板__小老闆 128.529517539|xiao lao ban;
小老婆__小老婆 120.164975734|xiao lao po;
小老鼠__小老鼠 199.051387821|xiao lao shu;
笑了笑__笑了笑 627.210588862|xiao le xiao;
小礼物__小禮物 134.762357541|xiao li wu;
小两口__小兩口 150.194241046|xiao liang kou;
校领导__校領導 146.679837233|xiao ling dao;
小灵通__小靈通 1336.36083843|xiao ling tong;
小龙女__小龍女 433.727767276|xiao long nv;
小龙虾__小龍蝦 215.576896995|xiao long xia;
小广告__小廣告 181.516526012|xiao guang gao;
小高层__小高層 129.655606164|xiao gao ceng;
小个子__小個子 107.416157498|xiao ge zi;
小工具__小工具 133.925286409|xiao gong ju;
小公主__小公主 216.384339476|xiao gong zhu;
小公司__小公司 477.408200926|xiao gong si;
小姑娘__小姑娘 1721.02823483|xiao gu niang;
小故事__小故事 234.348853194|xiao gu shi;
效果图__效果圖 516.399339766|xiao guo tu;
效果好__效果好 338.468131949|xiao guo hao;
小规模__小規模 298.439468992|xiao gui mo;
小可爱__小可愛 162.258658377|xiao ke ai;
消化道__消化道 245.71323808|xiao hua dao;
小混混__小混混 224.06783424|xiao hun hun;
小孩子__小孩子 2808.54161561|xiao hai zi;
小孩儿__小孩兒 210.270405333|xiao hai er;
消耗掉__消耗掉 154.561368684|xiao hao diao;
消耗量__消耗量 123.044091616|xiao hao liang;
笑呵呵__笑呵呵 105.426930997|xiao he he;
小和尚__小和尚 161.653186955|xiao he shang;
小猴子__小猴子 158.067510349|xiao hou zi;
小红帽__小紅帽 111.091824605|xiao hong mao;
小狐狸__小狐狸 185.172044961|xiao hu li;
小户型__小戶型 553.723632203|xiao hu xing;
小护士__小護士 141.826678552|xiao hu shi;
小伙伴__小夥伴 183.792676978|xiao huo ban;
小伙子__小夥子 1485.68252323|xiao huo zi;
小鸡鸡__小雞雞 127.254530072|xiao ji ji;
小技巧__小技巧 136.282292017|xiao ji qiao;
小家电__小家電 168.859844103|xiao jia dian;
小家伙__小傢伙 717.56844134|xiao jia huo;
小轿车__小轎車 162.86639759|xiao jiao che;
小精灵__小精靈 201.547419552|xiao jing ling;
小圈子__小圈子 132.10198647|xiao quan zi;
笑起来__笑起來 501.808489233|xiao qi lai;
小汽车__小汽車 192.945711079|xiao qi che;
小企业__小企業 417.812212206|xiao qi ye;
小青年__小青年 123.658956482|xiao qing nian;
小学生__小學生 1067.84239617|xiao xue sheng;
消息面__消息面 150.944778196|xiao xi mian;
小媳妇__小媳婦 110.264288753|xiao xi fu;
笑嘻嘻__笑嘻嘻 266.776744296|xiao xi xi;
小县城__小縣城 106.350610398|xiao xian cheng;
小小的__小小的 2297.98475873|xiao xiao de;
小小罗__小小羅 118.08671951|xiao xiao luo;
小心点__小心點 291.819695868|xiao xin dian;
小心眼__小心眼 208.964318904|xiao xin yan;
小型机__小型機 114.893269147|xiao xing ji;
小行星__小行星 139.895806636|xiao xing xing;
小型车__小型車 135.435779871|xiao xing che;
小兄弟__小兄弟 125.36572391|xiao xiong di;
笑着说__笑着說 847.977956119|xiao zhe shuo;
小猪猪__小豬豬 141.121478992|xiao zhu zhu;
小助手__小助手 129.655606164|xiao zhu shou;
小插曲__小插曲 114.607273411|xiao cha qu;
小程序__小程序 110.264288753|xiao cheng xu;
小城镇__小城鎮 268.109857044|xiao cheng zhen;
小城市__小城市 213.704562287|xiao cheng shi;
小帅哥__小帥哥 145.043940608|xiao shuai ge;
小商品__小商品 154.754097942|xiao shang pin;
小生意__小生意 126.306596357|xiao sheng yi;
小师妹__小師妹 145.950506492|xiao shi mei;
小市民__小市民 112.065135969|xiao shi min;
小石头__小石頭 119.121315407|xiao shi tou;
小时侯__小時侯 208.70407676|xiao shi hou;
小时候__小時候 3277.85745623|xiao shi hou;
小狮子__小獅子 110.126966673|xiao shi zi;
销售部__銷售部 334.276427588|xiao shou bu;
销售点__銷售點 112.204874836|xiao shou dian;
销售量__銷售量 536.070335228|xiao shou liang;
销售商__銷售商 290.368691563|xiao shou shang;
销售员__銷售員 257.62872122|xiao shou yuan;
销售额__銷售額 1067.84239617|xiao shou e;
小数点__小數點 127.73116145|xiao shu dian;
小说家__小說家 191.98633424|xiao shuo jia;
小人物__小人物 322.411748334|xiao ren wu;
小日本__小日本 834.351249399|xiao ri ben;
小日子__小日子 142.713135632|xiao ri zi;
小组赛__小組賽 424.635962376|xiao zu sai;
小作坊__小作坊 121.520271774|xiao zuo fang;
小册子__小冊子 184.251320835|xiao ce zi;
小聪明__小聰明 153.028150386|xiao cong ming;
校园里__校園裡 445.228026075|xiao yuan li;
校园网__校園網 532.740555233|xiao yuan wang;
小丫头__小丫頭 546.866130582|xiao ya tou;
萧亚轩__蕭亞軒 277.284292303|xiao ya xuan;
小眼睛__小眼睛 139.72158175|xiao yan jing;
小燕子__小燕子 200.29551561|xiao yan zi;
消炎药__消炎藥 148.704343794|xiao yan yao;
小妖精__小妖精 142.003528374|xiao yao jing;
笑一笑__笑一笑 151.510141313|xiao yi xiao;
小姨子__小姨子 130.791560815|xiao yi zi;
小意思__小意思 138.85370659|xiao yi si;
校友录__校友錄 268.778909483|xiao you lu;
校友会__校友會 134.594525802|xiao you hui;
小游戏__小遊戲 529.431458035|xiao you xi;
小宇宙__小宇宙 125.209594649|xiao yu zhou;
小语种__小語種 106.748946222|xiao yu zhong;
小鱼儿__小魚兒 224.907079496|xiao yu er;
小丸子__小丸子 152.647228173|xiao wan zi;
小王子__小王子 257.3078729|xiao wang zi;
小乌龟__小烏龜 111.786180106|xiao wu gui;
小儿科__小兒科 132.762114633|xiao er ke;
小儿子__小兒子 173.121277629|xiao er zi;
想办法__想辦法 1491.2471417|xiang ban fa;
想不到__想不到 1517.49220692|xiang bu dao;
想不通__想不通 532.740555233|xiang bu tong;
想不开__想不開 214.772467501|xiang bu kai;
香喷喷__香噴噴 135.604660605|xiang pen pen;
项目部__項目部 288.565077751|xiang mu bu;
项目组__項目組 651.914561431|xiang mu zu;
响当当__響噹噹 110.401782066|xiang dang dang;
想当年__想當年 331.37316028|xiang dang nian;
想当初__想當初 154.754097942|xiang dang chu;
想当然__想當然 203.060037258|xiang dang ran;
想得到__想得到 316.046952528|xiang de dao;
相对论__相對論 188.196293023|xiang dui lun;
相对人__相對人 113.187937993|xiang dui ren;
想太多__想太多 173.553291634|xiang tai duo;
想你了__想你了 166.768626413|xiang ni le;
想了想__想了想 471.495815538|xiang le xiang;
想了解__想了解 350.486645516|xiang liao jie;
相关性__相關性 465.65665114|xiang guan xing;
香港人__香港人 440.811451858|xiang gang ren;
想看看__想看看 501.183541788|xiang kan kan;
相互间__相互間 127.096048509|xiang hu jian;
想起来__想起來 1901.44712636|xiang qi lai;
详情请__詳情請 282.516174301|xiang qing qing;
乡下人__鄉下人 222.121753798|xiang xia ren;
想像力__想像力 320.409100324|xiang xiang li;
想象力__想象力 718.463208478|xiang xiang li;
想找个__想找個 374.41672986|xiang zhao ge;
乡政府__鄉政府 204.839111844|xiang zheng fu;
象征性__象徵性 254.755429543|xiang zheng xing;
想知道__想知道 1504.31243966|xiang zhi dao;
想成为__想成為 189.136730609|xiang cheng wei;
想什么__想什麼 459.317058623|xiang shen me;
向日葵__向日葵 322.010219858|xiang ri kui;
箱子里__箱子里 116.624293448|xiang zi li;
相似性__相似性 113.187937993|xiang si xing;
想要的__想要的 744.902491688|xiang yao de;
想一想__想一想 617.901063897|xiang yi xiang;
想拥有__想擁有 151.699065864|xiang yong you;
写博客__寫博客 414.699880708|xie bo ke;
携带者__攜帶者 139.026849285|xie dai zhe;
斜对面__斜對面 108.898738333|xie dui mian;
协调性__協調性 124.431860131|xie tiao xing;
谢霆锋__謝霆鋒 670.034480971|xie ting feng;
写论文__寫論文 246.326401069|xie lun wen;
协管员__協管員 131.937467932|xie guan yuan;
谢谢了__謝謝了 948.621258606|xie xie le;
写真集__寫真集 201.045721733|xie zhen ji;
谢长廷__謝長廷 215.845709156|xie chang ting;
写出来__寫出來 798.742526514|xie chu lai;
些什么__些什麼 2033.8046114|xie shen me;
写日记__寫日記 192.705418355|xie ri ji;
写字楼__寫字樓 1065.18429118|xie zi lou;
协奏曲__協奏曲 124.431860131|xie zou qu;
写作文__寫作文 113.753550575|xie zuo wen;
谢亚龙__謝亞龍 140.244908425|xie ya long;
写一篇__寫一篇 268.778909483|xie yi pian;
协议书__協議書 390.135034682|xie yi shu;
谢文东__謝文東 165.939408926|xie wen dong;
写文章__寫文章 379.111778956|xie wen zhang;
芯片组__芯片組 670.034480971|xin pian zu;
辛普森__辛普森 131.281440129|xin pu sen;
新媒体__新媒體 406.006938516|xin mei ti;
新大陆__新大陸 177.048440864|xin da lu;
新德里__新德里 109.852835359|xin de li;
信得过__信得過 164.293322714|xin de guo;
心电图__心電圖 224.347234118|xin dian tu;
新东方__新東方 769.432826682|xin dong fang;
新娘子__新娘子 131.937467932|xin niang zi;
新来的__新來的 458.173712968|xin lai de;
新浪网__新浪網 653.541376022|xin lang wang;
心里话__心裡話 364.745529846|xin li hua;
心理学__心理學 1136.49445424|xin li xue;
新快报__新快報 125.992190229|xin kuai bao;
新课标__新課標 105.953760973|xin ke biao;
新华社__新華社 1324.75423858|xin hua she;
新华网__新華網 2451.8263702|xin hua wang;
新纪元__新紀元 127.413209251|xin ji yuan;
新加坡__新加坡 3722.14075882|xin jia po;
心绞痛__心絞痛 178.59961945|xin jiao tong;
新疆人__新疆人 107.818484324|xin jiang ren;
新街口__新街口 251.287110964|xin jie kou;
新京报__新京報 224.347234118|xin jing bao;
心情好__心情好 282.516174301|xin qing hao;
心血管__心血管 201.296414343|xin xue guan;
信息部__信息部 118.08671951|xin xi bu;
新西兰__新西蘭 912.673735821|xin xi lan;
信息量__信息量 195.121873946|xin xi liang;
信息港__信息港 207.149415951|xin xi gang;
信息库__信息庫 110.539446825|xin xi ku;
信息化__信息化 2857.97028226|xin xi hua;
信息员__信息員 123.044091616|xin xi yuan;
信息网__信息網 555.105417084|xin xi wang;
新鲜感__新鮮感 278.669912425|xin xian gan;
新鲜事__新鮮事 168.649547684|xin xian shi;
新校区__新校區 185.634130949|xin xiao qu;
新中国__新中國 409.564096466|xin zhong guo;
信产部__信產部 341.433560596|xin chan bu;
新城区__新城區 163.680258901|xin cheng qu;
心上人__心上人 152.457122789|xin shang ren;
新生代__新生代 263.801426189|xin sheng dai;
新生儿__新生兒 635.075580657|xin sheng er;
新势力__新勢力 113.32907693|xin shi li;
新手机__新手機 118.23396695|xin shou ji;
信任度__信任度 109.579386421|xin ren du;
心脏病__心臟病 815.844260376|xin zang bing;
新赛季__新賽季 358.437246895|xin sai ji;
新四军__新四軍 168.020228531|xin si jun;
信乐团__信樂團 138.680779525|xin yue tuan;
新一轮__新一輪 1109.90155418|xin yi lun;
新一届__新一屆 359.779772295|xin yi jie;
新游戏__新遊戲 108.222318063|xin you xi;
信用卡__信用卡 3269.69811616|xin yong ka;
信用证__信用證 566.990680223|xin yong zheng;
信用社__信用社 283.927938713|xin yong she;
信誉度__信譽度 121.520271774|xin yu du;
新闻办__新聞辦 113.187937993|xin wen ban;
新闻稿__新聞稿 187.4940348|xin wen gao;
新闻界__新聞界 210.795122809|xin wen jie;
新闻网__新聞網 488.237949645|xin wen wang;
星巴克__星巴克 420.94790182|xing ba ke;
性伴侣__性伴侶 144.502706249|xing ban lv;
行不通__行不通 230.295783987|xing bu tong;
行不行__行不行 1165.17561047|xing bu xing;
兴奋剂__興奮劑 281.111429553|xing fen ji;
幸福感__幸福感 228.011295226|xing fu gan;
性能力__性能力 118.824795093|xing neng li;
行李箱__行李箱 176.60772663|xing li xiang;
性关系__性關係 166.97657743|xing guan xi;
性高潮__性高潮 173.337150041|xing gao chao;
性功能__性功能 192.705418355|xing gong neng;
性幻想__性幻想 108.087539034|xing huan xiang;
性疾病__性疾病 331.786363812|xing ji bing;
型基金__型基金 282.516174301|xing ji jin;
性价比__性價比 1961.61753092|xing jia bi;
性教育__性教育 250.037645335|xing jiao yu;
星期天__星期天 1238.54087357|xing qi tian;
星期六__星期六 1179.78648723|xing qi liu;
性器官__性器官 145.768741141|xing qi guan;
星期日__星期日 366.111682898|xing qi ri;
星期三__星期三 457.603107852|xing qi san;
星期四__星期四 451.935995467|xing qi si;
型企业__型企業 204.584007193|xing qi ye;
星期一__星期一 1196.07015327|xing qi yi;
星期五__星期五 936.87321059|xing qi wu;
星期二__星期二 449.128812644|xing qi er;
性取向__性取向 143.605133321|xing qu xiang;
性行为__性行為 510.640021015|xing xing wei;
行政部__行政部 148.889769675|xing zheng bu;
行政法__行政法 120.765453341|xing zheng fa;
行政区__行政區 125.522047856|xing zheng qu;
行政村__行政村 227.443722742|xing zheng cun;
性知识__性知識 131.445140637|xing zhi shi;
兴冲冲__興沖沖 163.272821143|xing chong chong;
性生活__性生活 1140.75119008|xing sheng huo;
行驶证__行駛證 118.23396695|xing shi zheng;
形容词__形容詞 354.43965395|xing rong ci;
幸存者__倖存者 264.789493468|xing cun zhe;
性骚扰__性騷擾 305.589986932|xing sao rao;
幸运星__幸運星 184.481071779|xing yun xing;
幸运儿__幸運兒 113.47039186|xing yun er;
性问题__性問題 106.350610398|xing wen ti;
行为人__行為人 175.073848088|xing wei ren;
兄弟连__兄弟連 110.401782066|xiong di lian;
匈牙利__匈牙利 348.309611377|xiong ya li;
修道院__修道院 129.979154132|xiu dao yuan;
修电脑__修電腦 123.197520618|xiu dian nao;
修理费__修理費 123.813152185|xiu li fei;
修理厂__修理廠 108.898738333|xiu li chang;
修改稿__修改稿 136.963309627|xiu gai gao;
修改器__修改器 222.67604562|xiu gai qi;
休息室__休息室 219.097720093|xiu xi shi;
休息日__休息日 155.140277726|xiu xi ri;
修正案__修正案 184.02185602|xiu zheng an;
休斯敦__休斯敦 127.572086295|xiu si dun;
休斯顿__休斯頓 144.322743975|xiu si dun;
畜牧业__畜牧業 401.478808454|xu mu ye;
蓄电池__蓄電池 308.267359529|xu dian chi;
许多人__許多人 1922.89284084|xu duo ren;
虚拟化__虛擬化 294.743493195|xu ni hua;
虚拟机__虛擬機 660.912425973|xu ni ji;
叙利亚__敘利亞 324.83145542|xu li ya;
序列化__序列化 137.819369268|xu lie hua;
序列号__序列號 1354.80557722|xu lie hao;
许可证__許可證 1200.55002966|xu ke zheng;
徐汇区__徐匯區 190.081867665|xu hui qu;
徐家汇__徐家匯 576.969379906|xu jia hui;
徐静蕾__徐靜蕾 651.102673334|xu jing lei;
需求量__需求量 614.828697239|xu qiu liang;
徐志摩__徐志摩 160.449013667|xu zhi mo;
徐州市__徐州市 180.613978088|xu zhou shi;
畜产品__畜產品 124.122120652|xu chan pin;
虚荣心__虛榮心 293.643651968|xu rong xin;
许茹芸__許茹芸 107.282382453|xu ru yun;
需要做__需要做 311.355949144|xu yao zuo;
需要用__需要用 356.210827905|xu yao yong;
许玮伦__許瑋倫 109.442917312|xu wei lun;
转变成__轉變成 213.971039752|zhuan bian cheng;
专卖店__專賣店 1220.1575309|zhuan mai dian;
赚大钱__賺大錢 208.70407676|zhuan da qian;
专利权__專利權 183.563783354|zhuan li quan;
转过头__轉過頭 340.583654043|zhuan guo tou;
转过身__轉過身 457.033213363|zhuan guo shen;
转化成__轉化成 298.811606079|zhuan hua cheng;
转换器__轉換器 311.355949144|zhuan huan qi;
转换成__轉換成 504.316081474|zhuan huan cheng;
转基因__轉基因 367.482952871|zhuan ji yin;
专家称__專家稱 234.64107292|zhuan jia cheng;
专家组__專家組 463.919044053|zhuan jia zu;
转型期__轉型期 146.132498493|zhuan xing qi;
转折点__轉折點 285.346757867|zhuan zhe dian;
专升本__專升本 244.796354228|zhuan sheng ben;
转载稿__轉載稿 307.117053725|zhuan zai gao;
转载自__轉載自 462.187920882|zhuan zai zi;
转眼间__轉眼間 200.29551561|zhuan yan jian;
专业版__專業版 333.444336783|zhuan ye ban;
专业课__專業課 435.895152658|zhuan ye ke;
专业化__專業化 910.401881269|zhuan ye hua;
专业户__專業戶 162.663565352|zhuan ye hu;
专业级__專業級 111.646962678|zhuan ye ji;
专业性__專業性 419.900065808|zhuan ye xing;
专营店__專營店 109.170488754|zhuan ying dian;
专案组__專案組 304.449671797|zhuan an zu;
状态栏__狀態欄 121.368931601|zhuang tai lan;
装甲车__裝甲車 131.937467932|zhuang jia che;
装系统__裝系統 130.954650472|zhuang xi tong;
装饰品__裝飾品 195.121873946|zhuang shi pin;
准备好__準備好 1395.93711137|zhun bei hao;
准备金__準備金 205.350275845|zhun bei jin;
准妈妈__准媽媽 266.776744296|zhun ma ma;
准考证__准考證 386.746622582|zhun kao zheng;
准确度__準確度 144.502706249|zhun que du;
准确率__準確率 203.820597887|zhun que lv;
准确性__準確性 689.516759915|zhun que xing;
扎卡维__扎卡維 120.164975734|zha ka wei;
炸酱面__炸醬麵 106.748946222|zha jiang mian;
宅基地__宅基地 206.376433771|zhai ji di;
宅急送__宅急送 144.682892926|zhai ji song;
债权人__債權人 438.073368704|zhai quan ren;
债务人__債務人 251.287110964|zhai wu ren;
占便宜__佔便宜 146.132498493|zhan pian yi;
詹姆斯__詹姆斯 573.385557088|zhan mu si;
战斗力__戰鬥力 644.643863216|zhan dou li;
战斗机__戰鬥機 664.215078095|zhan dou ji;
战略性__戰略性 458.173712968|zhan lue xing;
展览馆__展覽館 177.933171406|zhan lan guan;
展览会__展覽會 641.438524323|zhan lan hui;
战利品__戰利品 109.170488754|zhan li pin;
站起来__站起來 1422.27606545|zhan qi lai;
站起身__站起身 349.178797604|zhan qi shen;
站出来__站出來 658.446218066|zhan chu lai;
展示出__展示出 125.678566729|zhan shi chu;
占有率__佔有率 263.472890441|zhan you lv;
占用率__佔用率 129.332863581|zhan yong lv;
张柏芝__張柏芝 654.356305043|zhang bai zhi;
长不大__長不大 145.405889264|zhang bu da;
张曼玉__張曼玉 373.950434882|zhang man yu;
掌门人__掌門人 226.030964922|zhang men ren;
丈母娘__丈母娘 326.454673948|zhang mu niang;
张德江__張德江 107.684208225|zhang de jiang;
涨跌幅__漲跌幅 108.898738333|zhang die fu;
涨停板__漲停板 295.847453874|zhang ting ban;
张娜拉__張娜拉 145.587202159|zhang na la;
张老师__張老師 407.527636023|zhang lao shi;
张靓颖__張靚穎 909.268075561|zhang liang ying;
涨工资__漲工資 175.510734618|zhang gong zi;
张国立__張國立 158.461958559|zhang guo li;
张国荣__張國榮 771.352901218|zhang guo rong;
掌柜的__掌柜的 107.550099352|zhang gui de;
张含韵__張含韻 231.158356006|zhang han yun;
张惠妹__張惠妹 282.164331387|zhang hui mei;
张纪中__張紀中 315.653350706|zhang ji zhong;
张家港__張家港 297.696584607|zhang jia gang;
张家口__張家口 190.318888971|zhang jia kou;
张家界__張家界 444.673543393|zhang jia jie;
长见识__長見識 139.72158175|zhang jian shi;
张学良__張學良 212.377144726|zhang xue liang;
张学友__張學友 965.316430119|zhang xue you;
张先生__張先生 564.171453387|zhang xian sheng;
张信哲__張信哲 227.727332161|zhang xin zhe;
张震岳__張震岳 173.121277629|zhang zhen yue;
张朝阳__張朝陽 144.863304286|zhang chao yang;
长出来__長出來 146.679837233|zhang chu lai;
张韶涵__張韶涵 346.577724349|zhang shao han;
章子怡__章子怡 1073.17852213|zhang zi yi;
张三丰__張三丰 128.209578049|zhang san feng;
张亚东__張亞東 110.264288753|zhang ya dong;
张艺谋__張藝謀 772.314734527|zhang yi mou;
张怡宁__張怡寧 128.689786556|zhang yi ning;
张卫健__張衛健 105.164499152|zhang wei jian;
张维迎__張維迎 131.117943492|zhang wei ying;
张无忌__張無忌 159.85029497|zhang wu ji;
张爱玲__張愛玲 486.416079992|zhang ai ling;
障碍物__障礙物 148.704343794|zhang ai wu;
赵本山__趙本山 699.905273328|zhao ben shan;
招标人__招標人 111.230349808|zhao biao ren;
找不出__找不出 245.407229187|zhao bu chu;
招聘会__招聘會 590.793388895|zhao pin hui;
招待会__招待會 109.170488754|zhao dai hui;
招待所__招待所 370.702589737|zhao dai suo;
招投标__招投標 403.48504224|zhao tou biao;
找机会__找機會 267.775955618|zhao ji hui;
照镜子__照鏡子 213.438416689|zhao jing zi;
沼气池__沼氣池 132.762114633|zhao qi chi;
赵先生__趙先生 144.322743975|zhao xian sheng;
照相馆__照相館 133.42554153|zhao xiang guan;
照相机__照相機 590.793388895|zhao xiang ji;
赵忠祥__趙忠祥 121.217779906|zhao zhong xiang;
找上门__找上門 194.151676652|zhao shang men;
招商局__招商局 170.339279748|zhao shang ju;
招生办__招生辦 129.010924378|zhao sheng ban;
肇事者__肇事者 137.819369268|zhao shi zhe;
赵紫阳__趙紫陽 134.092283643|zhao zi yang;
赵雅芝__趙雅芝 177.269210225|zhao ya zhi;
这么慢__這麼慢 161.854759309|zhe me man;
这么大__這麼大 1824.83897052|zhe me da;
这么点__這麼點 155.72135507|zhe me dian;
这么多__這麼多 4957.57775917|zhe me duo;
这么难__這麼難 203.060037258|zhe me nan;
这么好__這麼好 1318.16721196|zhe me hao;
这么久__這麼久 1002.08784645|zhe me jiu;
这么些__這麼些 123.967540162|zhe me xie;
这么做__這麼做 933.377249507|zhe me zuo;
这段话__這段話 323.619340361|zhe duan hua;
折叠式__摺疊式 133.758497151|zhe die shi;
这都是__這都是 730.197220308|zhe dou shi;
这条路__這條路 604.195219728|zhe tiao lu;
这两天__這兩天 3563.28598523|zhe liang tian;
这两个__這兩個 3335.54580332|zhe liang ge;
这两种__這兩種 855.407364934|zhe liang zhong;
这个人__這個人 2801.55051046|zhe ge ren;
这个字__這個字 290.368691563|zhe ge zi;
这个词__這個詞 1083.93090293|zhe ge ci;
这个月__這個月 1119.62576025|zhe ge yue;
这回事__這回事 234.056997396|zhe hui shi;
这会儿__這會兒 365.655730945|zhe hui er;
这几天__這幾天 4969.94910399|zhe ji tian;
这几年__這幾年 1223.20236253|zhe ji nian;
这几个__這幾個 1181.25761405|zhe ji ge;
折价率__折價率 123.504952812|zhe jia lv;
这家伙__這傢伙 824.018360007|zhe jia huo;
这件事__這件事 2479.47960733|zhe jian shi;
浙江省__浙江省 1806.7369278|zhe jiang sheng;
浙江人__浙江人 163.272821143|zhe jiang ren;
这句话__這句話 3717.50524068|zhe ju hua;
哲学家__哲學家 489.456318842|zhe xue jia;
这学期__這學期 351.361264404|zhe xue qi;
这些话__這些話 503.060722916|zhe xie hua;
这些人__這些人 2353.04376718|zhe xie ren;
这种事__這種事 765.607004232|zhe zhong shi;
这种人__這種人 1132.25360251|zhe zhong ren;
折射出__折射出 249.104624871|zhe she chu;
这是他__這是他 431.033684153|zhe shi ta;
这是你__這是你 231.158356006|zhe shi ni;
这是个__這是個 1104.38283164|zhe shi ge;
这时候__這時候 2038.87985164|zhe shi hou;
这是我__這是我 2061.87561868|zhe shi wo;
这首歌__這首歌 1672.40062475|zhe shou ge;
这首诗__這首詩 322.010219858|zhe shou shi;
这才是__這才是 1009.60853723|zhe cai shi;
这三个__這三個 754.243296976|zhe san ge;
这样写__這樣寫 200.29551561|zhe yang xie;
这样做__這樣做 2221.95191814|zhe yang zuo;
这也是__這也是 3892.92564555|zhe ye shi;
这一步__這一步 476.813641365|zhe yi bu;
这一段__這一段 551.657401419|zhe yi duan;
这一天__這一天 1093.42757174|zhe yi tian;
这一年__這一年 703.402776999|zhe yi nian;
这一次__這一次 1382.08969051|zhe yi ci;
折优惠__折優惠 107.550099352|zhe you hui;
真漂亮__真漂亮 163.884358899|zhen piao liang;
真面目__真面目 225.749468142|zhen mian mu;
镇党委__鎮黨委 128.529517539|zhen dang wei;
真的吗__真的嗎 297.325836157|zhen de ma;
真的很__真的很 2545.22282076|zhen de hen;
真的爱__真的愛 163.272821143|zhen de ai;
针对性__針對性 751.428823061|zhen dui xing;
真功夫__真功夫 108.357265155|zhen gong fu;
震撼力__震撼力 131.445140637|zhen han li;
真心话__真心話 202.302314677|zhen xin hua;
镇政府__鎮政府 415.216987933|zhen zheng fu;
珍珠粉__珍珠粉 152.267254161|zhen zhu fen;
真主党__真主黨 168.859844103|zhen zhu dang;
珍珠港__珍珠港 115.467403456|zhen zhu gang;
真善美__真善美 139.895806636|zhen shan mei;
真是太__真是太 599.694499646|zhen shi tai;
真实性__真實性 1901.44712636|zhen shi xing;
真人版__真人版 151.321452046|zhen ren ban;
真人秀__真人秀 173.769702743|zhen ren xiu;
甄子丹__甄子丹 203.313241605|zhen zi dan;
真郁闷__真鬱悶 116.044406778|zhen yu men;
真恶心__真噁心 116.333988795|zhen e xin;
睁不开__睜不開 169.492308033|zheng bu kai;
证明书__證明書 134.930398555|zheng ming shu;
蒸发器__蒸發器 409.564096466|zheng fa qi;
政法委__政法委 157.67404401|zheng fa wei;
正方形__正方形 184.481071779|zheng fang xing;
争夺战__爭奪戰 199.051387821|zheng duo zhan;
整体性__整體性 189.372573382|zheng ti xing;
整个人__整個人 593.006203378|zheng ge ren;
证监会__證監會 1119.62576025|zheng jian hui;
证交所__證交所 147.229226029|zheng jiao suo;
证券法__證券法 112.484875527|zheng quan fa;
证券化__證券化 108.492380517|zheng quan hua;
证券业__證券業 108.627664361|zheng quan ye;
正确性__正確性 534.735933039|zheng que xing;
郑秀文__鄭秀文 211.057972369|zheng xiu wen;
正准备__正準備 576.250827814|zheng zhun bei;
政治部__政治部 154.368879448|zheng zhi bu;
政治家__政治家 511.276760152|zheng zhi jia;
政治局__政治局 145.405889264|zheng zhi ju;
政治学__政治學 172.260473089|zheng zhi xue;
郑州市__鄭州市 587.855808729|zheng zhou shi;
正常化__正常化 120.615053212|zheng chang hua;
正常人__正常人 575.5331706|zheng chang ren;
正处于__正處於 659.267263146|zheng chu yu;
郑少秋__鄭少秋 131.609045271|zheng shao qiu;
正式版__正式版 714.89082038|zheng shi ban;
政策面__政策面 133.42554153|zheng ce mian;
政策性__政策性 374.883606282|zheng ce xing;
正义感__正義感 204.07475061|zheng yi gan;
郑伊健__鄭伊健 161.250795044|zheng yi jian;
正因为__正因為 829.168709129|zheng yin wei;
值班室__值班室 150.569041974|zhi ban shi;
致病性__致病性 184.251320835|zhi bing xing;
直播员__直播員 210.532600599|zhi bo yuan;
指不定__指不定 108.087539034|zhi bu ding;
只不过__只不過 4442.66586373|zhi bu guo;
止不住__止不住 185.172044961|zhi bu zhu;
制片方__製片方 106.350610398|zhi pian fang;
制片人__製片人 465.65665114|zhi pian ren;
殖民地__殖民地 305.209408115|zhi min di;
知名度__知名度 1420.50477658|zhi ming du;
执法者__執法者 112.204874836|zhi fa zhe;
脂肪肝__脂肪肝 212.641966978|zhi fang gan;
脂肪酸__脂肪酸 212.377144726|zhi fang suan;
支付宝__支付寶 3946.65663992|zhi fu bao;
只代表__只代表 589.322768456|zhi dai biao;
脂蛋白__脂蛋白 113.187937993|zhi dan bai;
知道吗__知道嗎 863.977854874|zhi dao ma;
指导价__指導價 145.768741141|zhi dao jia;
指导性__指導性 201.296414343|zhi dao xing;
指导员__指導員 353.117055307|zhi dao yuan;
指的是__指的是 945.081459448|zhi de shi;
制定者__制定者 106.218162376|zhi ding zhe;
制度化__制度化 305.209408115|zhi du hua;
制度性__制度性 133.42554153|zhi du xing;
知多少__知多少 153.218967809|zhi duo shao;
只提供__只提供 152.837570606|zhi ti gong;
直通车__直通車 286.772667017|zhi tong che;
滞纳金__滯納金 168.439513167|zhi na jin;
指南针__指南針 217.736803143|zhi nan zhen;
智能卡__智能卡 158.264611567|zhi neng ka;
只能看__只能看 117.93965545|zhi neng kan;
智能化__智能化 453.628720089|zhi neng hua;
智能机__智能機 151.699065864|zhi neng ji;
只能用__只能用 644.643863216|zhi neng yong;
智能网__智能網 118.08671951|zhi neng wang;
质量好__質量好 242.670241844|zhi liang hao;
质量差__質量差 105.295633316|zhi liang cha;
只留下__只留下 302.181790975|zhi liu xia;
制高点__制高點 190.556205829|zhi gao dian;
只看到__只看到 473.261801395|zhi kan dao;
只可惜__只可惜 397.001179899|zhi ke xi;
只可以__只可以 109.716025699|zhi ke yi;
指环王__指環王 177.933171406|zhi huan wang;
指挥部__指揮部 667.534233933|zhi hui bu;
指挥官__指揮官 305.209408115|zhi hui guan;
指挥员__指揮員 127.890434962|zhi hui yuan;
只觉得__只覺得 462.187920882|zhi jue de;
芝加哥__芝加哥 538.749137684|zhi jia ge;
指甲油__指甲油 145.950506492|zhi jia you;
质监局__質監局 232.603161479|zhi jian ju;
支气管__支氣管 188.665925845|zhi qi guan;
知情权__知情權 288.205701591|zhi qing quan;
知情者__知情者 150.756793028|zhi qing zhe;
知情人__知情人 223.231720645|zhi qing ren;
支球队__支球隊 432.109303457|zhi qiu dui;
直辖市__直轄市 602.691239054|zhi xia shi;
只显示__只顯示 187.4940348|zhi xian shi;
只限于__只限於 181.516526012|zhi xian yu;
执行力__執行力 355.324137339|zhi xing li;
执行者__執行者 141.29744947|zhi xing zhe;
只需要__只需要 1802.23954462|zhi xu yao;
执政党__執政黨 337.625607028|zhi zheng dang;
只知道__只知道 1401.16558873|zhi zhi dao;
只支持__只支持 153.41002317|zhi zhi chi;
蜘蛛侠__蜘蛛俠 684.380469812|zhi zhu xia;
知春路__知春路 152.457122789|zhi chun lu;
直肠癌__直腸癌 117.061109314|zhi chang ai;
支持率__支持率 205.60633599|zhi chi lv;
支持者__支持者 524.179602378|zhi chi zhe;
直升机__直升機 801.734213733|zhi sheng ji;
只剩下__只剩下 1356.49494292|zhi sheng xia;
知识面__知識面 151.132997772|zhi shi mian;
指示灯__指示燈 329.725485744|zhi shi deng;
知识点__知識點 339.735863102|zhi shi dian;
只是个__只是個 703.402776999|zhi shi ge;
知识库__知識庫 208.184564378|zhi shi ku;
只属于__只屬於 187.961915178|zhi shu yu;
之日起__之日起 920.669965262|zhi ri qi;
至尊宝__至尊寶 108.627664361|zhi zun bao;
制造者__製造者 168.859844103|zhi zao zhe;
制造厂__製造廠 155.915530766|zhi zao chang;
制造出__製造出 296.585723861|zhi zao chu;
制造商__製造商 1137.91159836|zhi zao shang;
制造业__製造業 1575.29743635|zhi zao ye;
制作者__製作者 132.596773978|zhi zuo zhe;
制作成__製作成 152.457122789|zhi zuo cheng;
制作人__製作人 485.810302105|zhi zuo ren;
之所在__之所在 123.197520618|zhi suo zai;
之所以__之所以 3873.56899502|zhi suo yi;
支原体__支原體 120.015323434|zhi yuan ti;
志愿军__志願軍 188.901181552|zhi yuan jun;
志愿者__志願者 1861.58897661|zhi yuan zhe;
只允许__只允許 209.485777119|zhi yun xu;
制药厂__製藥廠 142.535402072|zhi yao chang;
职业病__職業病 232.893204426|zhi ye bing;
职业化__職業化 234.348853194|zhi ye hua;
只因为__只因為 291.819695868|zhi yin wei;
之我见__之我見 125.209594649|zhi wo jian;
植物人__植物人 126.621787068|zhi wu ren;
植物园__植物園 361.577631409|zhi wu yuan;
植物油__植物油 241.463621556|zhi wu you;
周笔畅__周筆暢 488.237949645|zhou bi chang;
皱眉头__皺眉頭 109.30661816|zhou mei tou;
周华健__周華健 217.736803143|zhou hua jian;
周慧敏__周慧敏 123.658956482|zhou hui min;
周杰伦__周杰倫 2077.35003942|zhou jie lun;
周期性__周期性 400.479435488|zhou qi xing;
周小川__周小川 207.149415951|zhou xiao chuan;
周星星__周星星 119.86585751|zhou xing xing;
周星驰__周星馳 770.392265767|zhou xing chi;
州政府__州政府 143.963491517|zhou zheng fu;
周正毅__周正毅 119.56748386|zhou zheng yi;
周润发__周潤發 439.714170908|zhou run fa;
周总理__周總理 305.589986932|zhou zong li;
周作人__周作人 107.818484324|zhou zuo ren;
周恩来__周恩來 803.734894488|zhou en lai;
种不同__種不同 164.703307075|zhong bu tong;
种方法__種方法 129.171793682|zhong fang fa;
中低端__中低端 263.144763849|zhong di duan;
中低档__中低檔 116.18910757|zhong di dang;
钟点工__鐘點工 112.765574943|zhong dian gong;
终点站__終點站 201.296414343|zhong dian zhan;
重头戏__重頭戲 192.945711079|zhong tou xi;
中南海__中南海 356.655002599|zhong nan hai;
中年人__中年人 388.679238014|zhong nian ren;
中老年__中老年 175.948711373|zhong lao nian;
种类型__種類型 142.891090816|zhong lei xing;
重量级__重量級 397.001179899|zhong liang ji;
中关村__中關村 1797.75335645|zhong guan cun;
中高端__中高端 257.94996962|zhong gao duan;
中高档__中高檔 282.516174301|zhong gao dang;
中高级__中高級 249.415244207|zhong gao ji;
重工业__重工業 175.510734618|zhong gong ye;
中国版__中國版 126.464093517|zhong guo ban;
中国队__中國隊 1986.21549859|zhong guo dui;
中国话__中國話 207.149415951|zhong guo hua;
中国画__中國畫 219.37092252|zhong guo hua;
中国区__中國區 461.61231651|zhong guo qu;
中国驻__中國駐 409.564096466|zhong guo zhu;
中国式__中國式 268.109857044|zhong guo shi;
中国人__中國人 9244.23863766|zhong guo ren;
中科院__中科院 834.351249399|zhong ke yuan;
中控台__中控台 110.677283245|zhong kong tai;
中华网__中華網 147.964946673|zhong hua wang;
中海油__中海油 274.876014738|zhong hai you;
中后期__中後期 156.89004718|zhong hou qi;
中后卫__中後衛 123.504952812|zhong hou wei;
中级车__中級車 193.186303435|zhong ji che;
中纪委__中紀委 263.472890441|zhong ji wei;
中间价__中間價 114.46454262|zhong jian jia;
中间件__中間件 342.712398751|zhong jian jian;
中间商__中間商 137.134095104|zhong jian shang;
中间人__中間人 124.587019602|zhong jian ren;
中介费__中介費 156.694657831|zhong jie fei;
终结者__終結者 304.829303266|zhong jie zhe;
重金属__重金屬 361.12732612|zhong jin shu;
中签率__中籤率 151.510141313|zhong qian lv;
中青年__中青年 203.060037258|zhong qing nian;
中情局__中情局 134.930398555|zhong qing ju;
中秋节__中秋節 781.999279332|zhong qiu jie;
中宣部__中宣部 172.04594156|zhong xuan bu;
中学生__中學生 816.861571886|zhong xue sheng;
中西部__中西部 254.438159592|zhong xi bu;
中下旬__中下旬 120.015323434|zhong xia xun;
中下游__中下游 164.498187167|zhong xia you;
中小板__中小板 353.557372243|zhong xiao ban;
中小学__中小學 825.045864155|zhong xiao xue;
中小型__中小型 323.216307961|zhong xiao xing;
中心区__中心區 265.450260135|zhong xin qu;
中新社__中新社 554.41409416|zhong xin she;
中心组__中心組 107.550099352|zhong xin zu;
中新网__中新網 286.772667017|zhong xin wang;
种植业__種植業 169.915266157|zhong zhi ye;
重重地__重重地 179.045304336|zhong zhong de;
中长期__中長期 447.452879516|zhong chang qi;
中长线__中長線 201.296414343|zhong chang xian;
忠诚度__忠誠度 271.133768339|zhong cheng du;
中成药__中成藥 206.89143407|zhong cheng yao;
中山路__中山路 168.859844103|zhong shan lu;
中山市__中山市 318.022335873|zhong shan shi;
中石化__中石化 825.045864155|zhong shi hua;
中世纪__中世紀 336.785179346|zhong shi ji;
中日韩__中日韓 117.93965545|zhong ri han;
重灾区__重災區 187.961915178|zhong zai qu;
中组部__中組部 116.044406778|zhong zu bu;
中餐馆__中餐館 113.187937993|zhong can guan;
重仓股__重倉股 162.663565352|zhong cang gu;
中草药__中草藥 491.289575698|zhong cao yao;
种颜色__種顏色 110.401782066|zhong yan se;
中央台__中央台 273.509258874|zhong yang tai;
中央社__中央社 112.484875527|zhong yang she;
重要性__重要性 1991.17198299|zhong yao xing;
中药材__中藥材 222.398727024|zhong yao cai;
中移动__中移動 342.712398751|zhong yi dong;
中医学__中醫學 121.368931601|zhong yi xue;
众议院__眾議院 202.554574186|zhong yi yuan;
中医院__中醫院 260.534419685|zhong yi yuan;
中医药__中醫藥 662.561694208|zhong yi yao;
中英文__中英文 413.152419826|zhong ying wen;
中文版__中文版 1143.59786783|zhong wen ban;
中文名__中文名 242.066179876|zhong wen ming;
中文系__中文系 357.545014261|zhong wen xi;
中文网__中文網 260.209952636|zhong wen wang;
猪八戒__豬八戒 353.117055307|zhu ba jie;
主办方__主辦方 725.661628731|zhu ban fang;
祝福你__祝福你 354.43965395|zhu fu ni;
主打歌__主打歌 151.888225993|zhu da ge;
祝大家__祝大家 348.309611377|zhu da jia;
主动权__主動權 327.677408739|zhu dong quan;
主动性__主動性 377.226735448|zhu dong xing;
主题歌__主題歌 264.789493468|zhu ti ge;
主题曲__主題曲 818.900002077|zhu ti qu;
主体性__主體性 118.08671951|zhu ti xing;
主力军__主力軍 216.11485651|zhu li jun;
朱丽叶__朱麗葉 115.323601467|zhu li ye;
朱广沪__朱廣滬 355.767206381|zhu guang hu;
主干道__主幹道 213.971039752|zhu gan dao;
诸葛亮__諸葛亮 849.035336524|zhu ge liang;
珠海市__珠海市 257.62872122|zhu hai shi;
主会场__主會場 107.282382453|zhu hui chang;
主教练__主教練 999.59341964|zhu jiao lian;
珠江路__珠江路 107.684208225|zhu jiang lu;
主旋律__主旋律 400.978810625|zhu xuan lv;
助学金__助學金 160.849404779|zhu xue jin;
主席团__主席團 204.329220247|zhu xi tuan;
主席台__主席台 202.050369328|zhu xi tai;
住宅楼__住宅樓 149.075426771|zhu zhai lou;
住宅区__住宅區 217.736803143|zhu zhai qu;
主产区__主產區 164.088713397|zhu chan qu;
主城区__主城區 182.196395498|zhu cheng qu;
主程序__主程序 161.854759309|zhu cheng xu;
主持人__主持人 3594.50508488|zhu chi ren;
注射器__注射器 110.95347192|zhu she qi;
注射液__注射液 373.484720623|zhu she ye;
主人公__主人公 1010.8674618|zhu ren gong;
主人翁__主人翁 139.373782642|zhu ren weng;
著作权__著作權 451.935995467|zhu zuo quan;
主裁判__主裁判 163.680258901|zhu cai pan;
主菜单__主菜單 135.94305409|zhu cai dan;
注册表__註冊表 1208.05380881|zhu ce biao;
注册码__註冊碼 880.279644448|zhu ce ma;
注册机__註冊機 415.734739962|zhu ce ji;
注册商__註冊商 239.664931108|zhu ce shang;
珠三角__珠三角 643.841029976|zhu san jiao;
主色调__主色調 125.053659829|zhu se diao;
住宿费__住宿費 246.633556117|zhu su fei;
朱元璋__朱元璋 355.324137339|zhu yuan zhang;
注意点__注意點 203.313241605|zhu yi dian;
注意力__注意力 1263.48355913|zhu yi li;
主义者__主義者 346.1460998|zhu yi zhe;
捉迷藏__捉迷藏 118.23396695|zhuo mi cang;
着力点__着力點 145.224802174|zhuo li dian;
卓越网__卓越網 124.431860131|zhuo yue wang;
追不上__追不上 114.037415895|zhui bu shang;
追悼会__追悼會 166.768626413|zhui dao hui;
追究其__追究其 430.496878967|zhui jiu qi;
追求者__追求者 155.140277726|zhui qiu zhe;
追随者__追隨者 166.560934377|zhui sui zhe;
传播学__傳播學 121.671800659|chuan bo xue;
穿透力__穿透力 121.217779906|chuan tou li;
传感器__傳感器 1100.26180506|chuan gan qi;
船公司__船公司 164.293322714|chuan gong si;
传教士__傳教士 185.86560618|chuan jiao shi;
穿裙子__穿裙子 123.197520618|chuan qun zi;
传真机__傳真機 254.755429543|chuan zhen ji;
穿什么__穿什麼 174.638049069|chuan shen me;
传染病__傳染病 695.557838999|chuan ran bing;
传染性__傳染性 281.111429553|chuan ran xing;
穿衣服__穿衣服 364.745529846|chuan yi fu;
创办人__創辦人 128.689786556|chuang ban ren;
床头柜__床頭櫃 107.282382453|chuang tou gui;
窗口中__窗口中 347.875829952|chuang kou zhong;
闯红灯__闖紅燈 144.502706249|chuang hong deng;
创纪录__創紀錄 153.41002317|chuang ji lu;
创新高__創新高 574.81640715|chuang xin gao;
创新型__創新型 165.526347625|chuang xin xing;
创新性__創新性 207.666345181|chuang xin xing;
创世纪__創世紀 130.791560815|chuang shi ji;
创始人__創始人 856.474009391|chuang shi ren;
创造力__創造力 596.712660816|chuang zao li;
创造性__創造性 856.474009391|chuang zao xing;
创造者__創造者 146.862738669|chuang zao zhe;
创造出__創造出 657.626195507|chuang zao chu;
创作者__創作者 176.60772663|chuang zuo zhe;
创业板__創業板 254.438159592|chuang ye ban;
创业者__創業者 643.841029976|chuang ye zhe;
创业园__創業園 105.821807183|chuang ye yuan;
纯天然__純天然 202.807148249|chun tian ran;
春节前__春節前 388.679238014|chun jie qian;
纯净水__純凈水 265.78126155|chun jing shui;
纯收入__純收入 115.036534536|chun shou ru;
查不到__查不到 376.756940916|cha bu dao;
差不多__差不多 18575.6900157|cha bu duo;
差点儿__差點兒 109.852835359|cha dian er;
刹那间__剎那間 257.3078729|cha na jian;
插进去__插進去 128.529517539|cha jin qu;
茶餐厅__茶餐廳 109.034528882|cha can ting;
差一点__差一點 436.982903472|cha yi dian;
差异化__差異化 430.496878967|cha yi hua;
差异性__差異性 224.06783424|cha yi xing;
茶文化__茶文化 110.677283245|cha wen hua;
查韦斯__查韋斯 131.117943492|cha wei si;
查尔顿__查爾頓 176.387781073|cha er dun;
查尔斯__查爾斯 261.510250403|cha er si;
差旅费__差旅費 190.793818607|chai lv fei;
拆迁户__拆遷戶 162.258658377|chai qian hu;
拆迁人__拆遷人 159.452390871|chai qian ren;
柴油机__柴油機 276.594068012|chai you ji;
产品部__產品部 136.282292017|chan pin bu;
产品线__產品線 611.009712747|chan pin xian;
产权房__產權房 114.46454262|chan quan fang;
产权证__產權證 158.067510349|chan quan zheng;
产学研__產學研 147.964946673|chan xue yan;
产销量__產銷量 112.204874836|chan xiao liang;
产业链__產業鏈 1194.58057905|chan ye lian;
产业化__產業化 1125.22065338|chan ye hua;
产业园__產業園 125.522047856|chan ye yuan;
长白山__長白山 260.209952636|chang bai shan;
场比赛__場比賽 1884.93262272|chang bi sai;
昌平区__昌平區 124.742372548|chang ping qu;
长方形__長方形 263.801426189|chang fang xing;
唱的歌__唱的歌 107.14877401|chang de ge;
长头发__長頭髮 166.97657743|chang tou fa;
长宁区__長寧區 123.967540162|chang ning qu;
常规赛__常規賽 247.866011137|chang gui sai;
常见病__常見病 180.164388413|chang jian bing;
长颈鹿__長頸鹿 105.821807183|chang jing lu;
长距离__長距離 114.75018218|chang ju li;
长期性__長期性 116.624293448|chang qi xing;
畅销书__暢銷書 229.722524886|chang xiao shu;
常州市__常州市 234.056997396|chang zhou shi;
长春市__長春市 388.679238014|chang chun shi;
长长的__長長的 859.681929668|chang chang de;
长沙市__長沙市 465.076726846|chang sha shi;
长时间__長時間 2865.10217964|chang shi jian;
长三角__長三角 564.874943184|chang san jiao;
倡议书__倡議書 105.164499152|chang yi shu;
常委会__常委會 444.119751258|chang wei hui;
长安街__長安街 169.28122395|chang an jie;
超负荷__超負荷 137.305093541|chao fu he;
超大型__超大型 110.126966673|chao da xing;
超低价__超低價 200.29551561|chao di jia;
超能力__超能力 130.303509496|chao neng li;
超链接__超鏈接 212.641966978|chao lian jie;
炒股票__炒股票 206.376433771|chao gu piao;
超喜欢__超喜歡 187.4940348|chao xi huan;
朝鲜族__朝鮮族 158.857391092|chao xian zu;
超声波__超聲波 334.69325133|chao sheng bo;
超市里__超市裡 171.617679695|chao shi li;
朝阳区__朝陽區 685.233853433|chao yang qu;
超音速__超音速 176.168109435|chao yin su;
车牌号__車牌號 123.044091616|che pai hao;
车管所__車管所 178.59961945|che guan suo;
车友会__車友會 176.387781073|che you hui;
陈道明__陳道明 199.548108896|chen dao ming;
沉甸甸__沉甸甸 191.269933402|chen dian dian;
陈独秀__陳獨秀 134.594525802|chen du xiu;
陈天桥__陳天橋 207.666345181|chen tian qiao;
陈良宇__陳良宇 234.64107292|chen liang yu;
陈冠希__陳冠希 524.833224606|chen guan xi;
陈凯歌__陳凱歌 375.819106356|chen kai ge;
陈可辛__陳可辛 144.682892926|chen ke xin;
陈慧琳__陳慧琳 204.329220247|chen hui lin;
陈绮贞__陳綺貞 147.596627936|chen qi zhen;
沉下去__沉下去 134.259489114|chen xia qu;
陈先生__陳先生 386.264972075|chen xian sheng;
陈小姐__陳小姐 133.42554153|chen xiao jie;
陈晓旭__陳曉旭 232.024158785|chen xiao xu;
陈小春__陳小春 148.704343794|chen xiao chun;
陈水扁__陳水扁 1467.28332601|chen shui bian;
陈云林__陳雲林 121.823518492|chen yun lin;
陈逸飞__陳逸飛 118.676811842|chen yi fei;
陈奕迅__陳奕迅 479.196331601|chen yi xun;
承包商__承包商 204.07475061|cheng bao shang;
承包人__承包人 118.972962872|cheng bao ren;
成本低__成本低 224.907079496|cheng ben di;
成本价__成本價 306.734573113|cheng ben jia;
成不了__成不了 165.114314527|cheng bu liao;
撑不住__撐不住 158.264611567|cheng bu zhu;
成品油__成品油 546.185068786|cheng pin you;
乘飞机__乘飛機 139.373782642|cheng fei ji;
称得上__稱得上 424.107124851|cheng de shang;
成都市__成都市 895.772044085|cheng du shi;
成都人__成都人 135.435779871|cheng du ren;
成年人__成年人 772.314734527|cheng nian ren;
承诺书__承諾書 121.975425508|cheng nuo shu;
城里人__城裡人 322.010219858|cheng li ren;
成功率__成功率 676.747684543|cheng gong lv;
成功者__成功者 243.882891747|cheng gong zhe;
城隍庙__城隍廟 184.481071779|cheng huang miao;
成活率__成活率 113.046974828|cheng huo lv;
乘火车__乘火車 108.763116896|cheng huo che;
成绩单__成績單 461.037428991|cheng ji dan;
成交量__成交量 1509.94683642|cheng jiao liang;
成交价__成交價 231.446597362|cheng jiao jia;
成交额__成交額 210.008536601|cheng jiao e;
成就感__成就感 602.691239054|cheng jiu gan;
呈现出__呈現出 1061.20953474|cheng xian chu;
承销商__承銷商 171.190483873|cheng xiao shang;
诚信通__誠信通 136.282292017|cheng xin tong;
程序员__程序員 1470.94484558|cheng xu yuan;
成长性__成長性 401.478808454|cheng zhang xing;
城镇化__城鎮化 330.960471347|cheng zhen hua;
成正比__成正比 287.488291405|cheng zheng bi;
称之为__稱之為 1313.24844471|cheng zhi wei;
城中村__城中村 147.964946673|cheng zhong cun;
城市里__城市裡 593.006203378|cheng shi li;
城市化__城市化 583.476802811|cheng shi hua;
城市群__城市群 203.566761683|cheng shi qun;
承受力__承受力 143.784200776|cheng shou li;
成熟度__成熟度 171.190483873|cheng shu du;
成熟期__成熟期 123.658956482|cheng shu qi;
承载力__承載力 119.26985293|cheng zai li;
承租人__承租人 165.73274959|cheng zu ren;
成员国__成員國 517.043260448|cheng yuan guo;
承运人__承運人 151.321452046|cheng yun ren;
乘用车__乘用車 235.519920202|cheng yong che;
城域网__城域網 155.72135507|cheng yu wang;
成问题__成問題 193.668388536|cheng wen ti;
乘务员__乘務員 173.769702743|cheng wu yuan;
吃饱了__吃飽了 425.165459331|chi bao le;
吃不了__吃不了 176.60772663|chi bu liao;
吃不下__吃不下 261.83633885|chi bu xia;
吃不消__吃不消 409.564096466|chi bu xiao;
吃螃蟹__吃螃蟹 106.085879302|chi pang xie;
吃东西__吃東西 765.607004232|chi dong xi;
吃多了__吃多了 265.450260135|chi duo le;
吃零食__吃零食 119.41857567|chi ling shi;
赤裸裸__赤裸裸 439.166555128|chi luo luo;
持卡人__持卡人 261.184568064|chi ka ren;
吃海鲜__吃海鮮 116.915322539|chi hai xian;
吃火锅__吃火鍋 199.548108896|chi huo guo;
持久战__持久戰 132.266710153|chi jiu zhan;
吃西瓜__吃西瓜 116.915322539|chi xi gua;
吃下去__吃下去 137.305093541|chi xia qu;
持续性__持續性 278.322859608|chi xu xing;
吃什么__吃什麼 904.746955463|chi shen me;
吃水果__吃水果 208.184564378|chi shui guo;
吃早餐__吃早餐 199.796934068|chi zao can;
持有者__持有者 153.601316766|chi you zhe;
持有人__持有人 407.020105042|chi you ren;
吃晚饭__吃晚飯 321.208662461|chi wan fan;
吃完饭__吃完飯 997.105202031|chi wan fan;
臭豆腐__臭豆腐 210.270405333|chou dou fu;
丑小鸭__醜小鴨 106.350610398|chou xiao ya;
重命名__重命名 187.26053154|chong ming ming;
冲锋枪__衝鋒槍 140.770195218|chong feng qiang;
重复性__重複性 116.47905068|chong fu xing;
充电器__充電器 899.127155009|chong dian qi;
重定向__重定向 162.056583012|chong ding xiang;
冲击波__衝擊波 238.473254015|chong ji bo;
冲击力__衝擊力 371.164834837|chong ji li;
充其量__充其量 289.285174995|chong qi liang;
重启后__重啟后 132.266710153|chong qi hou;
重庆市__重慶市 1243.1798239|chong qing shi;
充值卡__充值卡 382.433299725|chong zhi ka;
冲上去__衝上去 222.953710017|chong shang qu;
重阳节__重陽節 105.558392399|chong yang jie;
崇文门__崇文門 106.218162376|chong wen men;
崇文区__崇文區 106.350610398|chong wen qu;
出版商__出版商 178.155043976|chu ban shang;
出版社__出版社 2188.97205903|chu ban she;
出版业__出版業 120.164975734|chu ban ye;
出版物__出版物 328.086003878|chu ban wu;
出不来__出不來 354.43965395|chu bu lai;
出不了__出不了 161.250795044|chu bu liao;
触摸板__觸摸板 113.046974828|chu mo ban;
触摸屏__觸摸屏 450.811022973|chu mo ping;
出发点__出發點 746.761352211|chu fa dian;
触发器__觸發器 201.547419552|chu fa qi;
厨房里__廚房裡 241.463621556|chu fang li;
处方药__處方葯 108.627664361|chu fang yao;
处女膜__處女膜 294.376422496|chu nv mo;
处女作__處女作 172.475272126|chu nv zuo;
处女座__處女座 397.496217848|chu nv zuo;
出来混__出來混 149.633788238|chu lai hun;
处理器__處理器 2937.40736593|chu li qi;
楚留香__楚留香 218.280152578|chu liu xiang;
出口量__出口量 255.073095111|chu kou liang;
出口国__出口國 126.779677253|chu kou guo;
出口商__出口商 211.848489234|chu kou shang;
出口额__出口額 185.172044961|chu kou e;
出货量__出貨量 223.231720645|chu huo liang;
出家人__出家人 106.218162376|chu jia ren;
出境游__出境游 132.10198647|chu jing you;
出去玩__出去玩 683.528148986|chu qu wan;
初学者__初學者 515.113903202|chu xue zhe;
初中生__初中生 234.64107292|chu zhong sheng;
出主意__出主意 197.814987883|chu zhu yi;
出厂价__出廠價 152.647228173|chu chang jia;
出车祸__出車禍 117.061109314|chu che huo;
处处长__處處長 384.344361008|chu chu zhang;
出什么__出什麼 419.900065808|chu shen me;
出生地__出生地 208.964318904|chu sheng di;
初始化__初始化 1331.37418129|chu shi hua;
出入口__出入口 173.986383704|chu ru kou;
出入境__出入境 363.384474622|chu ru jing;
出资人__出資人 159.253810404|chu zi ren;
出租房__出租房 134.259489114|chu zu fang;
出租车__出租車 1710.33813502|chu zu che;
出租屋__出租屋 194.878871049|chu zu wu;
出问题__出問題 1149.31255222|chu wen ti;
吹风机__吹風機 108.763116896|chui feng ji;
双胞胎__雙胞胎 480.392137969|shuang bao tai;
双飞燕__雙飛燕 114.893269147|shuang fei yan;
爽肤水__爽膚水 140.244908425|shuang fu shui;
双通道__雙通道 237.879639313|shuang tong dao;
双核心__雙核心 112.906187218|shuang he xin;
双绞线__雙絞線 118.08671951|shuang jiao xian;
双休日__雙休日 391.108593802|shuang xiu ri;
双刃剑__雙刃劍 166.353500999|shuang ren jian;
双子座__雙子座 326.048110451|shuang zi zuo;
双色球__雙色球 356.210827905|shuang se qiu;
双眼皮__雙眼皮 201.045721733|shuang yan pi;
双鱼座__雙魚座 291.819695868|shuang yu zuo;
顺风车__順風車 108.627664361|shun feng che;
顺德区__順德區 136.282292017|shun de qu;
顺口溜__順口溜 116.624293448|shun kou liu;
顺时针__順時針 172.475272126|shun shi zhen;
沙坪坝__沙坪壩 124.89791921|sha ping ba;
傻孩子__傻孩子 117.499561272|sha hai zi;
傻乎乎__傻乎乎 234.348853194|sha hu hu;
沙尘暴__沙塵暴 270.122027271|sha chen bao;
杀虫剂__殺蟲劑 187.727829225|sha chong ji;
傻傻的__傻傻的 273.850309404|sha sha de;
杀伤力__殺傷力 415.734739962|sha shang li;
杀伤性__殺傷性 110.539446825|sha shang xing;
啥时候__啥時候 2172.66615296|sha shi hou;
杀手锏__殺手鐧 169.492308033|sha shou jian;
杀人犯__殺人犯 163.884358899|sha ren fan;
杀人案__殺人案 125.209594649|sha ren an;
傻丫头__傻丫頭 195.365179853|sha ya tou;
啥意思__啥意思 824.018360007|sha yi si;
晒太阳__曬太陽 385.78392141|shai tai yang;
山东省__山東省 1546.12469848|shan dong sheng;
山东人__山東人 238.770616634|shan dong ren;
汕头市__汕頭市 206.119414554|shan tou shi;
闪光灯__閃光燈 517.043260448|shan guang deng;
闪光点__閃光點 107.952927857|shan guang dian;
山海关__山海關 150.569041974|shan hai guan;
珊瑚虫__珊瑚蟲 527.455873984|shan hu chong;
山脚下__山腳下 227.443722742|shan jiao xia;
山西省__山西省 865.055186245|shan xi sheng;
陕西省__陝西省 950.988487375|shan xi sheng;
山水画__山水畫 129.010924378|shan shui hua;
上百万__上百萬 206.89143407|shang bai wan;
上半年__上半年 2529.4132684|shang ban nian;
上半场__上半場 475.034401746|shang ban chang;
上半身__上半身 229.150692759|shang ban shen;
上班族__上班族 446.339066527|shang ban zu;
上辈子__上輩子 168.229740225|shang bei zi;
上不了__上不了 559.271495144|shang bu liao;
上不去__上不去 814.828215816|shang bu qu;
商品房__商品房 1272.96603034|shang pin fang;
商品化__商品化 143.963491517|shang pin hua;
上分器__上分器 110.539446825|shang fen qi;
尚福林__尚福林 132.927661458|shang fu lin;
伤脑筋__傷腦筋 121.520271774|shang nao jin;
上个月__上個月 934.541117987|shang ge yue;
伤害到__傷害到 169.28122395|shang hai dao;
上海滩__上海灘 343.567617462|shang hai tan;
上海话__上海話 209.224885556|shang hai hua;
上海站__上海站 119.86585751|shang hai zhan;
上海市__上海市 3091.3879652|shang hai shi;
上海人__上海人 872.634214191|shang hai ren;
上交所__上交所 139.200207879|shang jiao suo;
上进心__上進心 162.460985719|shang jin xin;
上千万__上千萬 182.651055928|shang qian wan;
商学院__商學院 555.105417084|shang xue yuan;
上下班__上下班 520.274927886|shang xia ban;
上下游__上下游 199.796934068|shang xia you;
上下文__上下文 336.785179346|shang xia wen;
上星期__上星期 204.329220247|shang xing qi;
上证所__上證所 141.826678552|shang zheng suo;
上周末__上周末 331.37316028|shang zhou mo;
上周四__上周四 109.989815613|shang zhou si;
上传到__上傳到 220.742053181|shang chuan dao;
上诉人__上訴人 247.866011137|shang su ren;
商业片__商業片 108.357265155|shang ye pian;
商业化__商業化 534.069978074|shang ye hua;
商业街__商業街 352.238065853|shang ye jie;
商业区__商業區 183.335174792|shang ye qu;
商业性__商業性 279.365316864|shang ye xing;
上一篇__上一篇 337.205131359|shang yi pian;
上一年__上一年 112.484875527|shang yi nian;
上一层__上一層 159.253810404|shang yi ceng;
上一次__上一次 492.515560049|shang yi ci;
上一页__上一頁 397.991873082|shang yi ye;
商用车__商用車 177.933171406|shang yong che;
上网卡__上網卡 108.087539034|shang wang ka;
上网时__上網時 107.952927857|shang wang shi;
商务部__商務部 1269.79732551|shang wu bu;
商务厅__商務廳 154.561368684|shang wu ting;
商务局__商務局 226.877563077|shang wu ju;
商务车__商務車 107.818484324|shang wu che;
少部分__少部分 202.807148249|shao bu fen;
少不了__少不了 531.41444163|shao bu liao;
少林寺__少林寺 393.063006485|shao lin si;
邵佳一__邵佳一 198.308623594|shao jia yi;
少先队__少先隊 133.758497151|shao xian dui;
绍兴市__紹興市 149.820373083|shao xing shi;
少数人__少數人 510.640021015|shao shu ren;
少一点__少一點 214.772467501|shao yi dian;
舍不得__捨不得 1850.02578923|she bu de;
社科院__社科院 225.749468142|she ke yuan;
社会化__社會化 610.248767154|she hui hua;
社会学__社會學 460.463257431|she hui xue;
社会性__社會性 217.736803143|she hui xing;
设计图__設計圖 153.028150386|she ji tu;
设计者__設計者 360.677581637|she ji zhe;
设计师__設計師 2467.15098238|she ji shi;
设计院__設計院 488.237949645|she ji yuan;
社区网__社區網 108.087539034|she qu wang;
摄像头__攝像頭 3079.85238931|she xiang tou;
摄像机__攝像機 972.56115063|she xiang ji;
设置成__設置成 245.71323808|she zhi cheng;
设置为__設置為 600.442284667|she zhi wei;
奢侈品__奢侈品 532.740555233|she chi pin;
佘诗曼__佘詩曼 110.126966673|she shi man;
摄氏度__攝氏度 314.867617017|she shi du;
射手座__射手座 265.119670945|she shou zuo;
摄入量__攝入量 157.870654598|she ru liang;
摄影机__攝影機 185.172044961|she ying ji;
摄影家__攝影家 175.729586548|she ying jia;
摄影师__攝影師 938.041438335|she ying shi;
申报表__申報表 126.621787068|shen bao biao;
审批表__審批表 114.179614083|shen pi biao;
什么病__什麼病 195.60878915|shen me bing;
什么的__什麼的 1042.85588961|shen me de;
什么呢__什麼呢 2194.43451055|shen me ne;
什么歌__什麼歌 119.716577729|shen me ge;
什么话__什麼話 447.452879516|shen me hua;
什么好__什麼好 1324.75423858|shen me hao;
什么叫__什麼叫 1487.53508505|shen me jiao;
什么车__什麼車 120.015323434|shen me che;
什么书__什麼書 138.680779525|shen me shu;
什么人__什麼人 983.530305889|shen me ren;
什么样__什麼樣 5601.54012187|shen me yang;
什么药__什麼葯 167.810977762|shen me yao;
什么用__什麼用 562.76710106|shen me yong;
什么啊__什麼啊 630.344829195|shen me a;
审美观__審美觀 257.3078729|shen mei guan;
神秘感__神秘感 177.269210225|shen mi gan;
深发展__深發展 355.324137339|shen fa zhan;
身份证__身份證 3572.17795663|shen fen zheng;
神农架__神農架 111.786180106|shen nong jia;
深蓝色__深藍色 189.608710238|shen lan se;
肾功能__腎功能 165.939408926|shen gong neng;
申花队__申花隊 145.043940608|shen hua dui;
深呼吸__深呼吸 247.866011137|shen hu xi;
审计局__審計局 159.253810404|shen ji ju;
审计署__審計署 165.32020271|shen ji shu;
深加工__深加工 408.035799866|shen jia gong;
深交所__深交所 247.249015706|shen jiao suo;
肾结石__腎結石 134.259489114|shen jie shi;
神经病__神經病 890.207990943|shen jing bing;
神经痛__神經痛 130.141230764|shen jing tong;
神经质__神經質 251.287110964|shen jing zhi;
神经元__神經元 191.508436159|shen jing yuan;
申请表__申請表 593.006203378|shen qing biao;
申请单__申請單 125.678566729|shen qing dan;
申请者__申請者 220.19257551|shen qing zhe;
申请书__申請書 419.900065808|shen qing shu;
申请人__申請人 1277.73391996|shen qing ren;
深圳队__深圳隊 128.209578049|shen zhen dui;
深圳市__深圳市 2561.13118731|shen zhen shi;
甚至连__甚至連 755.18379558|shen zhi lian;
甚至于__甚至於 301.054193591|shen zhi yu;
神州行__神州行 324.426913464|shen zhou xing;
伸出手__伸出手 340.583654043|shen chu shou;
肾上腺__腎上腺 253.173026121|shen shang xian;
深层次__深層次 606.458230719|shen ceng ci;
圣保罗__聖保羅 108.627664361|sheng bao luo;
省部级__省部級 158.461958559|sheng bu ji;
生命力__生命力 808.758466182|sheng ming li;
生命线__生命線 169.492308033|sheng ming xian;
声明者__聲明者 324.426913464|sheng ming zhe;
圣诞节__聖誕節 1055.93292173|sheng dan jie;
圣诞树__聖誕樹 164.498187167|sheng dan shu;
圣斗士__聖鬥士 314.475483928|sheng dou shi;
生态学__生態學 142.713135632|sheng tai xue;
省略号__省略號 111.230349808|sheng lue hao;
生力军__生力軍 129.655606164|sheng li jun;
生理学__生理學 135.773751924|sheng li xue;
胜利者__勝利者 191.269933402|sheng li zhe;
生孩子__生孩子 743.974797322|sheng hai zi;
生活费__生活費 806.745280603|sheng huo fei;
生活里__生活里 245.407229187|sheng huo li;
生活化__生活化 106.483223576|sheng huo hua;
生活区__生活區 130.791560815|sheng huo qu;
生活照__生活照 160.249192015|sheng huo zhao;
升级版__升級版 231.158356006|sheng ji ban;
升级包__升級包 170.551683166|sheng ji bao;
省纪委__省紀委 106.218162376|sheng ji wei;
圣骑士__聖騎士 232.893204426|sheng qi shi;
升学率__升學率 116.915322539|sheng xue lv;
圣西罗__聖西羅 120.015323434|sheng xi luo;
生下来__生下來 407.020105042|sheng xia lai;
生小孩__生小孩 177.933171406|sheng xiao hai;
省政府__省政府 1176.84972769|sheng zheng fu;
省政协__省政協 123.044091616|sheng zheng xie;
生殖器__生殖器 503.688011099|sheng zhi qi;
生产部__生產部 128.049907079|sheng chan bu;
生产队__生產隊 115.611384758|sheng chan dui;
生产率__生產率 144.682892926|sheng chan lv;
生产力__生產力 1075.85657625|sheng chan li;
生产线__生產線 1395.93711137|sheng chan xian;
生产性__生產性 158.659551632|sheng chan xing;
生产者__生產者 333.444336783|sheng chan zhe;
生产厂__生產廠 148.704343794|sheng chan chang;
生产商__生產商 667.534233933|sheng chan shang;
生成器__生成器 139.895806636|sheng cheng qi;
省人大__省人大 111.786180106|sheng ren da;
生意人__生意人 180.164388413|sheng yi ren;
生与死__生與死 137.819369268|sheng yu si;
生物学__生物學 525.487661863|sheng wu xue;
生物质__生物質 105.953760973|sheng wu zhi;
生物钟__生物鐘 171.190483873|sheng wu zhong;
谁知道__誰知道 527.455873984|shei zhi dao;
十八条__十八條 217.465635832|shi ba tiao;
十八岁__十八歲 296.955549433|shi ba sui;
失败者__失敗者 208.70407676|shi bai zhe;
世博会__世博會 302.558594526|shi bo hui;
示波器__示波器 168.649547684|shi bo qi;
时不时__時不時 933.377249507|shi bu shi;
是不是__是不是 42122.6295884|shi bu shi;
适配器__適配器 353.998238229|shi pei qi;
使皮肤__使皮膚 420.423657369|shi pi fu;
视频网__視頻網 205.350275845|shi pin wang;
世乒赛__世乒賽 131.117943492|shi ping sai;
史密斯__史密斯 359.331706043|shi mi si;
使命感__使命感 255.391156791|shi ming gan;
实名制__實名制 334.276427588|shi ming zhi;
示范点__示範點 141.29744947|shi fan dian;
示范区__示範區 326.454673948|shi fan qu;
示范村__示範村 126.779677253|shi fan cun;
十分钟__十分鐘 881.377303227|shi fen zhong;
士大夫__士大夫 425.69561654|shi da fu;
十多年__十多年 607.9716117|shi duo nian;
十多岁__十多歲 278.322859608|shi duo sui;
是对的__是對的 298.811606079|shi dui de;
实体店__實體店 232.603161479|shi ti dian;
施耐德__施耐德 115.611384758|shi nai de;
十年来__十年來 359.331706043|shi nian lai;
十年后__十年後 231.158356006|shi nian hou;
十年前__十年前 598.94764591|shi nian qian;
实力派__實力派 243.882891747|shi li pai;
实例化__實例化 106.882056102|shi li hua;
失恋了__失戀了 106.882056102|shi lian le;
市领导__市領導 328.495108513|shi ling dao;
十六大__十六大 391.108593802|shi liu da;
十六条__十六條 248.484546245|shi liu tiao;
十六届__十六屆 469.736419493|shi liu jie;
十六岁__十六歲 212.377144726|shi liu sui;
湿漉漉__濕漉漉 164.088713397|shi lu lu;
施罗德__施羅德 111.646962678|shi luo de;
十个月__十個月 105.164499152|shi ge yue;
施工队__施工隊 150.944778196|shi gong dui;
施工图__施工圖 215.040276584|shi gong tu;
时刻表__時刻表 285.702569086|shi ke biao;
是空的__是空的 138.508067822|shi kong de;
适合做__適合做 250.974160423|shi he zuo;
世纪末__世紀末 256.028470459|shi ji mo;
世纪初__世紀初 280.411678639|shi ji chu;
实际上__實際上 6795.07025259|shi ji shang;
十几万__十幾萬 244.186999878|shi ji wan;
市纪委__市紀委 161.451865638|shi ji wei;
是假的__是假的 750.493000864|shi jia de;
石家庄__石家莊 1284.11889697|shi jia zhuang;
氏家族__氏家族 142.891090816|shi jia zu;
时间表__時間表 611.771607197|shi jian biao;
时间短__時間短 188.901181552|shi jian duan;
时间段__時間段 526.798985534|shi jian duan;
时间里__時間裡 1285.72012038|shi jian li;
时间差__時間差 117.207077876|shi jian cha;
时间长__時間長 797.747780288|shi jian chang;
市建委__市建委 180.839193473|shi jian wei;
市教委__市教委 156.109948588|shi jiao wei;
世界杯__世界盃 3011.53728293|shi jie bei;
世界里__世界里 865.055186245|shi jie li;
世界观__世界觀 460.463257431|shi jie guan;
世界级__世界級 524.179602378|shi jie ji;
世界性__世界性 238.473254015|shi jie xing;
世锦赛__世錦賽 642.238361775|shi jin sai;
石景山__石景山 178.822323044|shi jing shan;
十九日__十九日 116.333988795|shi jiu ri;
十九岁__十九歲 115.899886195|shi jiu sui;
十七大__十七大 2448.77288933|shi qi da;
十七岁__十七歲 207.149415951|shi qi sui;
世青赛__世青賽 124.742372548|shi qing sai;
史学家__史學家 119.86585751|shi xue jia;
实习生__實習生 962.913535809|shi xi sheng;
实效性__實效性 134.259489114|shi xiao xing;
时效性__時效性 147.596627936|shi xiao xing;
时装周__時裝周 112.765574943|shi zhuang zhou;
是真的__是真的 1797.75335645|shi zhen de;
市政府__市政府 2394.45594186|shi zheng fu;
市政协__市政協 279.713669565|shi zheng xie;
实质性__實質性 909.268075561|shi zhi xing;
十周年__十周年 295.479008313|shi zhou nian;
市中心__市中心 893.542261726|shi zhong xin;
室主任__室主任 162.056583012|shi zhu ren;
市场部__市場部 889.099334512|shi chang bu;
市场化__市場化 1279.32718167|shi chang hua;
市场价__市場價 358.884197808|shi chang jia;
史上最__史上最 370.240920313|shi shang zui;
试试看__試試看 1504.31243966|shi shi kan;
是谁在__是誰在 135.098649108|shi shui zai;
市人大__市人大 177.490254874|shi ren da;
实在太__實在太 1024.81967123|shi zai tai;
十字军__十字軍 199.796934068|shi zi jun;
十字架__十字架 289.645897197|shi zi jia;
十字星__十字星 140.945727665|shi zi xing;
十字绣__十字綉 143.963491517|shi zi xiu;
狮子座__獅子座 338.468131949|shi zi zuo;
十三条__十三條 271.133768339|shi san tiao;
十三岁__十三歲 115.755545596|shi san sui;
十四岁__十四歲 129.494134325|shi si sui;
十月份__十月份 208.184564378|shi yue fen;
十运会__十運會 157.870654598|shi yun hui;
试运行__試運行 312.522131716|shi yun xing;
实验班__實驗班 105.558392399|shi yan ban;
试验区__試驗區 147.596627936|shi yan qu;
实验性__實驗性 119.41857567|shi yan xing;
实验室__實驗室 4376.72452042|shi yan shi;
事业部__事業部 722.053448193|shi ye bu;
什叶派__什葉派 142.535402072|shi ye pai;
失业率__失業率 257.3078729|shi ye lv;
事业心__事業心 166.146325956|shi ye xin;
是一本__是一本 212.907119447|shi yi ben;
是一部__是一部 786.88699725|shi yi bu;
是一门__是一門 276.938965124|shi yi men;
是一名__是一名 785.907015785|shi yi ming;
十一点__十一點 320.010065926|shi yi dian;
示意图__示意圖 416.772181646|shi yi tu;
是一款__是一款 933.377249507|shi yi kuan;
是一件__是一件 1313.24844471|shi yi jian;
十一届__十一屆 234.056997396|shi yi jie;
是一项__是一項 696.425160166|shi yi xiang;
是一只__是一隻 434.268601197|shi yi zhi;
是一种__是一種 9620.32295112|shi yi zhong;
试一试__試一試 606.458230719|shi yi shi;
是一座__是一座 364.745529846|shi yi zuo;
十一月__十一月 469.151414294|shi yi yue;
是一位__是一位 1103.00744393|shi yi wei;
十一五__十一五 543.469292924|shi yi wu;
市盈率__市盈率 1062.53280282|shi ying lv;
适应性__適應性 371.627656329|shi ying xing;
试用版__試用版 150.381524744|shi yong ban;
使用费__使用費 192.465424888|shi yong fei;
使用率__使用率 234.64107292|shi yong lv;
使用量__使用量 173.337150041|shi yong liang;
食用菌__食用菌 241.764712994|shi yong jun;
使用权__使用權 550.970372621|shi yong quan;
试用期__試用期 796.754272909|shi yong qi;
使用前__使用前 431.033684153|shi yong qian;
适用性__適用性 111.507918629|shi yong xing;
实用性__實用性 494.360275282|shi yong xing;
使用者__使用者 1163.72451202|shi yong zhe;
食用油__食用油 284.636464248|shi yong you;
史玉柱__史玉柱 330.548296374|shi yu zhu;
十万元__十萬元 142.891090816|shi wan yuan;
视网膜__視網膜 248.484546245|shi wang mo;
是我的__是我的 2056.74313669|shi wo de;
事务所__事務所 624.870140032|shi wu suo;
十五岁__十五歲 188.665925845|shi wu sui;
十二点__十二點 330.136634719|shi er dian;
十二条__十二條 300.679263607|shi er tiao;
十二岁__十二歲 137.647730357|shi er sui;
十二月__十二月 492.515560049|shi er yue;
手把手__手把手 118.381397999|shou ba shou;
收不到__收不到 612.534451685|shou bu dao;
受不了__受不了 296.585723861|shou bu le;
受不了__受不了 2996.56312723|shou bu liao;
收盘价__收盤價 414.699880708|shou pan jia;
售票处__售票處 118.08671951|shou piao chu;
售票员__售票員 224.907079496|shou piao yuan;
守门员__守門員 279.017397997|shou men yuan;
受访者__受訪者 237.583386308|shou fang zhe;
收费站__收費站 392.573489614|shou fei zhan;
首付款__首付款 165.32020271|shou fu kuan;
手电筒__手電筒 225.187525865|shou dian tong;
受托人__受託人 107.952927857|shou tuo ren;
手拉手__手拉手 156.694657831|shou la shou;
手榴弹__手榴彈 183.106850936|shou liu dan;
售楼处__售樓處 214.2378495|shou lou chu;
首歌曲__首歌曲 248.175085992|shou ge qu;
收购价__收購價 232.024158785|shou gou jia;
受欢迎__受歡迎 938.041438335|shou huan ying;
受害者__受害者 1059.88791463|shou hai zhe;
受害人__受害人 536.738784525|shou hai ren;
守护者__守護者 123.658956482|shou hu zhe;
守护神__守護神 125.522047856|shou hu shen;
收货人__收貨人 175.292155245|shou huo ren;
售货员__售貨員 201.547419552|shou huo yuan;
受贿罪__受賄罪 146.497163581|shou hui zui;
手机报__手機報 178.155043976|shou ji bao;
手机费__手機費 155.333728851|shou ji fei;
手机里__手機里 229.150692759|shou ji li;
手机卡__手機卡 178.822323044|shou ji ka;
收件箱__收件箱 123.351140937|shou jian xiang;
收件人__收件人 267.109399762|shou jian ren;
受教育__受教育 384.344361008|shou jiao yu;
受精卵__受精卵 112.484875527|shou jing luan;
授权书__授權書 126.621787068|shou quan shu;
手牵手__手牽手 159.253810404|shou qian shou;
受限制__受限制 164.293322714|shou xian zhi;
手续费__手續費 1806.7369278|shou xu fei;
受伤了__受傷了 166.768626413|shou shang le;
收视率__收視率 725.661628731|shou shi lv;
收拾好__收拾好 169.915266157|shou shi hao;
手术室__手術室 258.593668656|shou shu shi;
首字母__首字母 181.742866823|shou zi mu;
收藏品__收藏品 142.357889859|shou cang pin;
收藏夹__收藏夾 480.991159713|shou cang jia;
收藏者__收藏者 105.690017726|shou cang zhe;
收益率__收益率 1026.09756322|shou yi lv;
受益者__受益者 282.868455943|shou yi zhe;
受益人__受益人 232.024158785|shou yi ren;
收音机__收音機 704.279880358|shou yin ji;
收银员__收銀員 128.369448119|shou yin yuan;
受影响__受影響 478.599545119|shou ying xiang;
首映式__首映式 111.230349808|shou ying shi;
守望者__守望者 115.467403456|shou wang zhe;
数百万__數百萬 271.810366771|shu bai wan;
鼠标垫__鼠標墊 224.06783424|shu biao dian;
数不清__數不清 246.633556117|shu bu qing;
殊不知__殊不知 267.775955618|shu bu zhi;
舒马赫__舒馬赫 279.713669565|shu ma he;
书法家__書法家 188.196293023|shu fa jia;
书呆子__書獃子 132.266710153|shu dai zi;
输尿管__輸尿管 117.353228453|shu niao guan;
输卵管__輸卵管 333.860122955|shu luan guan;
数量级__數量級 105.953760973|shu liang ji;
树林里__樹林里 143.247667161|shu lin li;
数据包__數據包 588.588831574|shu ju bao;
数据表__數據表 244.491487214|shu ju biao;
数据量__數據量 250.661599628|shu ju liang;
数据流__數據流 197.322580943|shu ju liu;
数据库__數據庫 10238.8177518|shu ju ku;
数据集__數據集 154.754097942|shu ju ji;
数据线__數據線 743.974797322|shu ju xian;
数据源__數據源 360.677581637|shu ju yuan;
数千万__數千萬 131.609045271|shu qian wan;
数学题__數學題 117.353228453|shu xue ti;
数学家__數學家 260.209952636|shu xue jia;
数学系__數學系 160.249192015|shu xue xi;
舒适度__舒適度 158.659551632|shu shi du;
舒适性__舒適性 281.812926654|shu shi xing;
数十亿__數十億 115.179978568|shu shi yi;
数十万__數十萬 256.987424161|shu shi wan;
输入法__輸入法 2665.32595143|shu ru fa;
输入您__輸入您 191.98633424|shu ru nin;
输入框__輸入框 740.275558891|shu ru kuang;
数字化__數字化 878.088426229|shu zi hua;
说白了__說白了 462.764242999|shuo bai le;
说不定__說不定 3750.07550505|shuo bu ding;
说不清__說不清 546.866130582|shuo bu qing;
说不出__說不出 1229.31483934|shuo bu chu;
说不上__說不上 304.070513117|shuo bu shang;
说明书__說明書 1548.05262827|shuo ming shu;
说服力__說服力 441.911471008|shuo fu li;
说到底__說到底 408.035799866|shuo dao di;
说得好__說得好 374.883606282|shuo de hao;
说了算__說了算 471.495815538|shuo le suan;
说出口__說出口 215.845709156|shuo chu kou;
硕士生__碩士生 221.017305999|shuo shi sheng;
说一句__說一句 592.267679181|shuo yi ju;
说一声__說一聲 522.223615731|shuo yi sheng;
睡不好__睡不好 187.027319083|shui bu hao;
睡不着__睡不着 1508.06636321|shui bu zhao;
水瓶座__水瓶座 284.281980745|shui ping zuo;
水电费__水電費 181.290467084|shui dian fei;
水电站__水電站 362.931919108|shui dian zhan;
谁都会__誰都會 122.127521944|shui dou hui;
水泥路__水泥路 106.616002115|shui ni lu;
水泥厂__水泥廠 160.649084484|shui ni chang;
睡懒觉__睡懶覺 180.389043185|shui lan jiao;
水利部__水利部 209.746993999|shui li bu;
水立方__水立方 109.989815613|shui li fang;
水利局__水利局 153.601316766|shui li ju;
水龙头__水龍頭 331.786363812|shui long tou;
水环境__水環境 143.426288875|shui huan jing;
水浒传__水滸傳 128.850255419|shui hu zhuan;
谁叫你__誰叫你 109.034528882|shui jiao ni;
睡觉前__睡覺前 240.562595233|shui jiao qian;
水蒸汽__水蒸汽 494.9767145|shui zheng qi;
谁知道__誰知道 1440.11088805|shui zhi dao;
水煮鱼__水煮魚 204.584007193|shui zhu yu;
水产品__水產品 352.238065853|shui chan pin;
水处理__水處理 163.680258901|shui chu li;
谁是谁__誰是誰 132.431639237|shui shi shui;
水水水__水水水 405.501301397|shui shui shui;
谁让你__誰讓你 241.463621556|shui rang ni;
水溶性__水溶性 134.092283643|shui rong xing;
水资源__水資源 862.9018652|shui zi yuan;
水源地__水源地 128.049907079|shui yuan di;
水元素__水元素 120.615053212|shui yuan su;
谁也不__誰也不 645.447697543|shui ye bu;
睡午觉__睡午覺 110.126966673|shui wu jiao;
税务局__稅務局 295.847453874|shui wu ju;
水污染__水污染 198.555903198|shui wu ran;
软绵绵__軟綿綿 109.034528882|ruan mian mian;
软环境__軟環境 107.015331962|ruan huan jing;
软件包__軟件包 260.859291326|ruan jian bao;
软件园__軟件園 309.807805448|ruan jian yuan;
软件业__軟件業 172.04594156|ruan jian ye;
软交换__軟交換 166.97657743|ruan jiao huan;
软实力__軟實力 126.306596357|ruan shi li;
软组织__軟組織 153.792848894|ruan zu zhi;
软硬件__軟硬件 379.111778956|ruan ying jian;
润滑剂__潤滑劑 149.075426771|run hua ji;
润滑油__潤滑油 381.006242235|run hua you;
燃料油__燃料油 156.109948588|ran liao you;
然后又__然後又 595.969520633|ran hou you;
然后按__然後按 142.713135632|ran hou an;
染色体__染色體 348.309611377|ran se ti;
燃油税__燃油稅 177.269210225|ran you shui;
让女人__讓女人 190.556205829|rang nv ren;
热电厂__熱電廠 111.091824605|re dian chang;
热力学__熱力學 109.716025699|re li xue;
热心人__熱心人 111.230349808|re xin ren;
热处理__熱處理 201.296414343|re chu li;
热身赛__熱身賽 247.249015706|re shen sai;
热水器__熱水器 738.432842998|re shui qi;
忍不住__忍不住 3095.24275062|ren bu zhu;
认不出__認不出 178.59961945|ren bu chu;
人民币__人民幣 6408.51491624|ren min bi;
人民路__人民路 127.254530072|ren min lu;
人民网__人民網 689.516759915|ren min wang;
任达华__任達華 117.207077876|ren da hua;
人多了__人多了 199.796934068|ren duo le;
任天堂__任天堂 291.819695868|ren tian tang;
认同感__認同感 146.132498493|ren tong gan;
人来说__人來說 928.736252253|ren lai shuo;
人类学__人類學 148.704343794|ren lei xue;
人流量__人流量 112.906187218|ren liu liang;
人和事__人和事 234.933657026|ren he shi;
任何人__任何人 2061.87561868|ren he ren;
人情味__人情味 195.60878915|ren qing wei;
任贤齐__任賢齊 216.11485651|ren xian qi;
人行道__人行道 308.651751439|ren xing dao;
人性化__人性化 1050.68254543|ren xing hua;
任正非__任正非 120.615053212|ren zheng fei;
人知道__人知道 499.935980841|ren zhi dao;
认知度__認知度 138.680779525|ren zhi du;
任志强__任志強 171.617679695|ren zhi qiang;
妊娠期__妊娠期 105.295633316|ren shen qi;
人身上__人身上 322.813777494|ren shen shang;
人生观__人生觀 370.702589737|ren sheng guan;
人事部__人事部 453.628720089|ren shi bu;
人世间__人世間 344.85444872|ren shi jian;
人事局__人事局 475.034401746|ren shi ju;
人事处__人事處 135.773751924|ren shi chu;
人是谁__人是誰 116.18910757|ren shi shui;
人说话__人說話 165.526347625|ren shuo hua;
任总统__任總統 179.045304336|ren zong tong;
人才网__人才網 322.813777494|ren cai wang;
人死亡__人死亡 368.85935893|ren si wang;
任意球__任意球 508.100984482|ren yi qiu;
人与人__人與人 742.122873174|ren yu ren;
任务栏__任務欄 291.819695868|ren wu lan;
任务书__任務書 116.624293448|ren wu shu;
日报社__日報社 174.42055653|ri bao she;
日本队__日本隊 240.862563142|ri ben dui;
日本车__日本車 313.302012384|ri ben che;
日本人__日本人 3343.86946243|ri ben ren;
日内瓦__日內瓦 196.586267794|ri nei wa;
日光灯__日光燈 107.550099352|ri guang deng;
日记本__日記本 191.269933402|ri ji ben;
日照市__日照市 117.499561272|ri zhao shi;
日程表__日程表 116.47905068|ri cheng biao;
日子里__日子裡 863.977854874|ri zi li;
日用品__日用品 255.391156791|ri yong pin;
容不下__容不下 118.676811842|rong bu xia;
容积率__容積率 173.769702743|rong ji lv;
荣辱观__榮辱觀 408.035799866|rong ru guan;
容祖儿__容祖兒 224.06783424|rong zu er;
溶液中__溶液中 107.14877401|rong ye zhong;
乳白色__乳白色 158.264611567|ru bai se;
入门级__入門級 339.735863102|ru men ji;
入口处__入口處 217.736803143|ru kou chu;
如何将__如何將 232.313479749|ru he jiang;
如何去__如何去 322.010219858|ru he qu;
如何做__如何做 174.203334854|ru he zuo;
如何用__如何用 166.97657743|ru he yong;
乳胶漆__乳膠漆 141.826678552|ru jiao qi;
入侵者__入侵者 113.32907693|ru qin zhe;
如下图__如下圖 241.162905094|ru xia tu;
乳腺癌__乳腺癌 456.464028614|ru xian ai;
乳制品__乳製品 200.545272755|ru zhi pin;
入场券__入場券 135.773751924|ru chang quan;
如是说__如是說 271.133768339|ru shi shuo;
如此多__如此多 228.011295226|ru ci duo;
如此之__如此之 447.452879516|ru ci zhi;
若不是__若不是 261.83633885|ruo bu shi;
若没有__若沒有 119.56748386|ruo mei you;
杂货店__雜貨店 125.053659829|za huo dian;
咋回事__咋回事 223.788782324|za hui shi;
杂志社__雜誌社 456.464028614|za zhi she;
在百度__在百度 265.450260135|zai bai du;
在梦里__在夢裡 238.473254015|zai meng li;
在梦中__在夢中 261.184568064|zai meng zhong;
在风中__在風中 266.444503116|zai feng zhong;
灾难性__災難性 128.689786556|zai nan xing;
在两个__在兩個 120.765453341|zai liang ge;
在干吗__在幹嗎 429.425273358|zai gan ma;
在乎你__在乎你 156.109948588|zai hu ni;
在酒吧__在酒吧 139.200207879|zai jiu ba;
再就业__再就業 491.902185928|zai jiu ye;
在线看__在線看 137.647730357|zai xian kan;
在校生__在校生 211.321149687|zai xiao sheng;
在新的__在新的 406.006938516|zai xin de;
在这一__在這一 714.89082038|zai zhe yi;
在床上__在床上 940.382265783|zai chuang shang;
在水里__在水裡 252.54282031|zai shui li;
再融资__再融資 227.160466527|zai rong zi;
载入中__載入中 754.243296976|zai ru zhong;
在页面__在頁面 147.596627936|zai ye mian;
在业界__在業界 143.605133321|zai ye jie;
在一家__在一家 471.495815538|zai yi jia;
在一次__在一次 446.895626023|zai yi ci;
再一次__再一次 1557.7283975|zai yi ci;
在雨中__在雨中 175.073848088|zai yu zhong;
在网吧__在網吧 276.938965124|zai wang ba;
在网站__在網站 469.736419493|zai wang zhan;
在我心__在我心 219.097720093|zai wo xin;
再而三__再而三 119.121315407|zai er san;
暂住证__暫住證 260.209952636|zan zhu zheng;
赞助商__贊助商 535.402718412|zan zhu shang;
暂时性__暫時性 144.502706249|zan shi xing;
藏羚羊__藏羚羊 132.266710153|zang ling yang;
脏兮兮__髒兮兮 111.786180106|zang xi xi;
造型师__造型師 156.499511818|zao xing shi;
早知道__早知道 1007.09538969|zao zhi dao;
早上好__早上好 552.345286903|zao shang hao;
则表示__則表示 435.895152658|ze biao shi;
则可以__則可以 381.957020988|ze ke yi;
责任感__責任感 964.114234362|ze ren gan;
责任险__責任險 113.046974828|ze ren xian;
责任心__責任心 610.248767154|ze ren xin;
责任制__責任制 647.865219539|ze ren zhi;
责任书__責任書 146.497163581|ze ren shu;
责任人__責任人 665.872587905|ze ren ren;
怎么把__怎麼把 195.121873946|zen me ba;
怎么办__怎麼辦 6006.40803223|zen me ban;
怎么打__怎麼打 175.948711373|zen me da;
怎么弄__怎麼弄 264.789493468|zen me nong;
怎么啦__怎麼啦 860.753904265|zen me la;
怎么改__怎麼改 133.42554153|zen me gai;
怎么搞__怎麼搞 275.905561849|zen me gao;
怎么看__怎麼看 1115.44785438|zen me kan;
怎么讲__怎麼講 134.092283643|zen me jiang;
怎么去__怎麼去 382.433299725|zen me qu;
怎么写__怎麼寫 315.260239073|zen me xie;
怎么找__怎麼找 141.826678552|zen me zhao;
怎么着__怎麼著 172.260473089|zen me zhao;
怎么着__怎麼著 212.907119447|zen me zhe;
怎么吃__怎麼吃 116.769717326|zen me chi;
怎么走__怎麼走 338.890182508|zen me zou;
怎么做__怎麼做 1033.79844744|zen me zuo;
怎么算__怎麼算 186.794397067|zen me suan;
怎么样__怎麼樣 15408.6457642|zen me yang;
怎么用__怎麼用 451.373158744|zen me yong;
怎么玩__怎麼玩 206.119414554|zen me wan;
怎能不__怎能不 190.318888971|zen neng bu;
怎样做__怎樣做 182.196395498|zen yang zuo;
曾道人__曾道人 180.389043185|zeng dao ren;
曾国藩__曾國藩 170.977284899|zeng guo fan;
增加值__增加值 252.228305921|zeng jia zhi;
曾庆红__曾慶紅 125.992190229|zeng qing hong;
增长点__增長點 266.444503116|zeng zhang dian;
增长率__增長率 838.520594407|zeng zhang lv;
增值税__增值稅 908.135681884|zeng zhi shui;
曾志伟__曾志偉 164.908682755|zeng zhi wei;
曾荫权__曾蔭權 160.049619219|zeng yin quan;
资本家__資本家 527.455873984|zi ben jia;
资本金__資本金 212.641966978|zi ben jin;
淄博市__淄博市 128.850255419|zi bo shi;
自民党__自民黨 187.727829225|zi min dang;
子目录__子目錄 177.490254874|zi mu lu;
字幕组__字幕組 162.86639759|zi mu zu;
字符集__字符集 204.329220247|zi fu ji;
字符串__字符串 1534.60743675|zi fu chuan;
自定义__自定義 1716.74420026|zi ding yi;
自动挡__自動擋 114.179614083|zi dong dang;
自动档__自動檔 195.60878915|zi dong dang;
自动化__自動化 1383.81307795|zi dong hua;
自来水__自來水 660.912425973|zi lai shui;
资料片__資料片 653.541376022|zi liao pian;
资料库__資料庫 244.186999878|zi liao ku;
紫罗兰__紫羅蘭 193.668388536|zi luo lan;
资格证__資格證 171.831677206|zi ge zheng;
资格赛__資格賽 127.254530072|zi ge sai;
自个儿__自個兒 202.807148249|zi ge er;
子宫内__子宮內 293.277951001|zi gong nei;
子宫颈__子宮頸 106.350610398|zi gong jing;
子公司__子公司 1150.74567978|zi gong si;
自顾自__自顧自 133.925286409|zi gu zi;
自豪感__自豪感 176.827946446|zi hao gan;
紫红色__紫紅色 113.47039186|zi hong se;
自觉性__自覺性 244.796354228|zi jue xing;
自己写__自己寫 301.805456692|zi ji xie;
自己人__自己人 185.402943996|zi ji ren;
自己做__自己做 767.517531652|zi ji zuo;
自驾车__自駕車 185.86560618|zi jia che;
自驾游__自駕游 304.449671797|zi jia you;
资金链__資金鏈 183.563783354|zi jin lian;
资金量__資金量 127.73116145|zi jin liang;
紫禁城__紫禁城 162.258658377|zi jin cheng;
咨询师__諮詢師 176.168109435|zi xun shi;
资讯网__資訊網 234.056997396|zi xun wang;
子系统__子系統 520.923681206|zi xi tong;
仔细看__仔細看 611.771607197|zi xi kan;
自习室__自習室 132.266710153|zi xi shi;
自信心__自信心 413.667597456|zi xin xin;
自行车__自行車 2580.3525318|zi xing che;
自制力__自制力 114.75018218|zi zhi li;
自治区__自治區 1793.27833544|zi zhi qu;
自治县__自治縣 302.935867929|zi zhi xian;
自治州__自治州 323.216307961|zi zhi zhou;
自主权__自主權 217.736803143|zi zhu quan;
自主性__自主性 140.070248771|zi zhu xing;
自助餐__自助餐 302.935867929|zi zhu can;
自助游__自助游 253.173026121|zi zhu you;
资生堂__資生堂 158.461958559|zi sheng tang;
自适应__自適應 310.194118206|zi shi ying;
自然界__自然界 490.677728407|zi ran jie;
自然醒__自然醒 108.763116896|zi ran xing;
自然人__自然人 294.376422496|zi ran ren;
自然村__自然村 106.882056102|zi ran cun;
自认为__自認為 490.677728407|zi ren wei;
自尊心__自尊心 357.99085261|zi zun xin;
资源库__資源庫 123.197520618|zi yuan ku;
自以为__自以為 563.46883971|zi yi wei;
自由度__自由度 204.07475061|zi you du;
自由化__自由化 144.682892926|zi you hua;
自由基__自由基 217.19480623|zi you ji;
自由行__自由行 173.769702743|zi you xing;
自由人__自由人 139.72158175|zi you ren;
紫外线__紫外線 531.41444163|zi wai xian;
自卫队__自衛隊 208.184564378|zi wei dui;
走多远__走多遠 140.244908425|zou duo yuan;
走天涯__走天涯 149.633788238|zou tian ya;
走过来__走過來 661.736546275|zou guo lai;
走过去__走過去 545.504855178|zou guo qu;
走下去__走下去 499.3133654|zou xia qu;
走出来__走出來 664.215078095|zou chu lai;
走出了__走出了 461.037428991|zou chu le;
走出去__走出去 535.402718412|zou chu qu;
走上了__走上了 397.496217848|zou shang le;
走势图__走勢圖 108.222318063|zou shi tu;
走一步__走一步 176.827946446|zou yi bu;
总编辑__總編輯 227.443722742|zong bian ji;
总面积__總面積 443.56664881|zong mian ji;
总动员__總動員 230.295783987|zong dong yuan;
总统府__總統府 175.729586548|zong tong fu;
棕榈油__棕櫚油 191.98633424|zong lv you;
总工会__總工會 296.585723861|zong gong hui;
总公司__總公司 1380.36844936|zong gong si;
综合楼__綜合樓 162.258658377|zong he lou;
综合性__綜合性 940.382265783|zong he xing;
综合症__綜合症 318.022335873|zong he zheng;
综合征__綜合征 557.879339939|zong he zheng;
总决赛__總決賽 716.674788535|zong jue sai;
总经理__總經理 4200.38893397|zong jing li;
宗庆后__宗慶后 141.826678552|zong qing hou;
总指挥__總指揮 216.654158472|zong zhi hui;
总产量__總產量 231.158356006|zong chan liang;
总产值__總產值 205.094534596|zong chan zhi;
总成绩__總成績 183.563783354|zong cheng ji;
总收入__總收入 398.48814637|zong shou ru;
总书记__總書記 574.10053635|zong shu ji;
总人口__總人口 242.066179876|zong ren kou;
总司令__總司令 208.184564378|zong si ling;
租房子__租房子 349.178797604|zu fang zi;
足球队__足球隊 283.221176861|zu qiu dui;
足球场__足球場 258.916120291|zu qiu chang;
足球赛__足球賽 174.203334854|zu qiu sai;
组织部__組織部 343.139741671|zu zhi bu;
组织者__組織者 428.356335222|zu zhi zhe;
组成员__組成員 214.504991945|zu cheng yuan;
租出去__租出去 110.815291538|zu chu qu;
组组长__組組長 242.670241844|zu zu zhang;
组策略__組策略 150.569041974|zu ce lue;
组委会__組委會 1087.99076217|zu wei hui;
作弊器__作弊器 113.046974828|zuo bi qi;
坐标系__坐標系 132.10198647|zuo biao xi;
做不到__做不到 1111.28553845|zuo bu dao;
做不了__做不了 520.274927886|zuo bu liao;
坐不住__坐不住 171.617679695|zuo bu zhu;
做朋友__做朋友 330.136634719|zuo peng you;
作品集__作品集 155.915530766|zuo pin ji;
坐飞机__坐飛機 350.486645516|zuo fei ji;
做得好__做得好 291.093289619|zuo de hao;
作斗争__作鬥爭 119.86585751|zuo dou zheng;
座谈会__座談會 1114.0586864|zuo tan hui;
做女人__做女人 111.925571131|zuo nv ren;
做广告__做廣告 520.274927886|zuo guang gao;
作贡献__作貢獻 117.792774542|zuo gong xian;
做贡献__做貢獻 223.231720645|zuo gong xian;
做股票__做股票 166.146325956|zuo gu piao;
做好事__做好事 207.666345181|zuo hao shi;
坐火车__坐火車 371.164834837|zuo huo che;
做家务__做家務 195.121873946|zuo jia wu;
作曲家__作曲家 285.346757867|zuo qu jia;
做学问__做學問 125.053659829|zuo xue wen;
坐下来__坐下來 585.662213047|zuo xia lai;
左下角__左下角 255.391156791|zuo xia jiao;
做销售__做銷售 145.587202159|zuo xiao shou;
做准备__做準備 381.957020988|zuo zhun bei;
座城市__座城市 346.577724349|zuo cheng shi;
做出来__做出來 744.902491688|zuo chu lai;
坐沙发__坐沙發 176.827946446|zuo sha fa;
左上角__左上角 331.37316028|zuo shang jiao;
做什么__做什麼 4360.39268552|zuo shen me;
做生意__做生意 1108.5192935|zuo sheng yi;
做事情__做事情 477.408200926|zuo shi qing;
做实验__做實驗 298.06779536|zuo shi yan;
做手术__做手術 322.010219858|zuo shou shu;
做自己__做自己 219.37092252|zuo zi ji;
做作业__做作業 253.488718522|zuo zuo ye;
做一名__做一名 112.765574943|zuo yi ming;
做一些__做一些 821.967189047|zuo yi xie;
做一次__做一次 327.26932246|zuo yi ci;
座右铭__座右銘 229.436430673|zuo you ming;
做游戏__做遊戲 107.684208225|zuo you xi;
昨晚上__昨晚上 174.638049069|zuo wan shang;
做网站__做網站 183.792676978|zuo wang zhan;
做文章__做文章 193.186303435|zuo wen zhang;
最短的__最短的 275.561951728|zui duan de;
最大的__最大的 8816.68704672|zui da de;
最大化__最大化 778.110973173|zui da hua;
最大值__最大值 233.183609039|zui da zhi;
最低点__最低點 237.287502254|zui di dian;
最低价__最低價 417.291872914|zui di jia;
最底层__最底層 177.269210225|zui di ceng;
最多的__最多的 1859.27057168|zui duo de;
最厉害__最厲害 234.64107292|zui li hai;
最高分__最高分 125.992190229|zui gao fen;
最高峰__最高峰 222.398727024|zui gao feng;
最高点__最高點 329.314848809|zui gao dian;
最高价__最高價 187.961915178|zui gao jia;
最快的__最快的 776.174076244|zui kuai de;
最好的__最好的 5728.60805208|zui hao de;
最好用__最好用 279.713669565|zui hao yong;
最经典__最經典 258.916120291|zui jing dian;
最全的__最全的 115.611384758|zui quan de;
最前沿__最前沿 146.679837233|zui qian yan;
最小的__最小的 599.694499646|zui xiao de;
最小化__最小化 282.516174301|zui xiao hua;
最小值__最小值 114.607273411|zui xiao zhi;
最新版__最新版 436.438689186|zui xin ban;
最新款__最新款 123.351140937|zui xin kuan;
最性感__最性感 108.222318063|zui xing gan;
最专业__最專業 218.824857909|zui zhuan ye;
最差的__最差的 215.576896995|zui cha de;
最长的__最長的 276.594068012|zui chang de;
最少的__最少的 220.467143161|zui shao de;
最深的__最深的 538.749137684|zui shen de;
最让人__最讓人 253.488718522|zui rang ren;
最热门__最熱門 233.765505073|zui re men;
最早的__最早的 645.447697543|zui zao de;
最恶心__最噁心 116.044406778|zui e xin;
村里人__村裡人 121.823518492|cun li ren;
村干部__村幹部 476.813641365|cun gan bu;
村支书__村支書 153.028150386|cun zhi shu;
存储卡__存儲卡 493.129699012|cun chu ka;
存储器__存儲器 414.183417482|cun chu qi;
村村通__村村通 158.067510349|cun cun tong;
村委会__村委會 614.828697239|cun wei hui;
擦边球__擦邊球 121.066816454|ca bian qiu;
才不会__才不會 465.65665114|cai bu hui;
裁判员__裁判員 172.905674062|cai pan yuan;
才明白__才明白 434.268601197|cai ming bai;
才发现__才發現 2106.02207003|cai fa xian;
财付通__財付通 148.149450567|cai fu tong;
菜单栏__菜單欄 123.351140937|cai dan lan;
菜单中__菜單中 250.661599628|cai dan zhong;
才能够__才能夠 680.129467195|cai neng gou;
才能让__才能讓 291.093289619|cai neng rang;
采购部__採購部 149.261315371|cai gou bu;
采购商__採購商 180.839193473|cai gou shang;
采矿权__採礦權 112.204874836|cai kuang quan;
才开始__才開始 763.701232553|cai kai shi;
蔡康永__蔡康永 141.826678552|cai kang yong;
才可以__才可以 1532.69625148|cai ke yi;
彩虹岛__彩虹島 120.46484039|cai hong dao;
才会有__才會有 577.688827991|cai hui you;
财政部__財政部 1109.90155418|cai zheng bu;
财政局__財政局 527.455873984|cai zheng ju;
才知道__才知道 2933.74914717|cai zhi dao;
财产权__財產權 151.699065864|cai chan quan;
蔡少芬__蔡少芬 116.18910757|cai shao fen;
菜市场__菜市場 338.046607007|cai shi chang;
才算是__才算是 151.132997772|cai suan shi;
蔡依林__蔡依林 603.442760838|cai yi lin;
财务部__財務部 441.361118731|cai wu bu;
参谋长__參謀長 297.696584607|can mou zhang;
残留物__殘留物 215.040276584|can liu wu;
参观者__參觀者 202.807148249|can guan zhe;
参考书__參考書 196.341441156|can kao shu;
残疾人__殘疾人 1232.38252249|can ji ren;
参加者__參加者 160.249192015|can jia zhe;
参展商__參展商 208.184564378|can zhan shang;
参赛者__參賽者 225.187525865|can sai zhe;
参议员__參議員 194.151676652|can yi yuan;
参议院__參議院 209.224885556|can yi yuan;
餐饮业__餐飲業 318.418891685|can yin ye;
参与者__參與者 702.526765976|can yu zhe;
残奥会__殘奧會 264.789493468|can ao hui;
藏起来__藏起來 190.556205829|cang qi lai;
操盘手__操盤手 335.528458728|cao pan shou;
操控性__操控性 156.499511818|cao kong xing;
曹雪芹__曹雪芹 224.347234118|cao xue qin;
操作性__操作性 192.705418355|cao zuo xing;
操作者__操作者 117.061109314|cao zuo zhe;
操作员__操作員 244.186999878|cao zuo yuan;
侧边栏__側邊欄 116.044406778|ce bian lan;
策划人__策劃人 124.122120652|ce hua ren;
侧重点__側重點 133.093414711|ce zhong dian;
测试版__測試版 245.101601395|ce shi ban;
测试仪__測試儀 183.335174792|ce shi yi;
厕所里__廁所里 168.439513167|ce suo li;
曾经的__曾經的 346.1460998|ceng jing de;
层次感__層次感 132.927661458|ceng ci gan;
此功能__此功能 153.41002317|ci gong neng;
词汇量__詞彙量 121.520271774|ci hui liang;
次会议__次會議 699.905273328|ci hui yi;
刺激性__刺激性 310.968189453|ci ji xing;
次级债__次級債 158.659551632|ci ji zhai;
雌激素__雌激素 335.528458728|ci ji su;
次全会__次全會 223.788782324|ci quan hui;
磁悬浮__磁懸浮 195.60878915|ci xuan fu;
慈溪市__慈溪市 105.558392399|ci xi shi;
此操作__此操作 259.238974004|ci cao zuo;
此问题__此問題 260.859291326|ci wen ti;
此文件__此文件 117.792774542|ci wen jian;
凑热闹__湊熱鬧 288.205701591|cou re nao;
聪明人__聰明人 255.709615075|cong ming ren;
从业者__從業者 219.918349804|cong ye zhe;
促进会__促進會 184.941433485|cu jin hui;
促销员__促銷員 170.339279748|cu xiao yuan;
错别字__錯別字 462.187920882|cuo bie zi;
催化剂__催化劑 546.185068786|cui hua ji;
崔永元__崔永元 145.768741141|cui yong yuan;
算不上__算不上 533.404852483|suan bu shang;
算不算__算不算 711.336195135|suan bu suan;
算起来__算起來 158.264611567|suan qi lai;
算什么__算什麼 568.405572245|suan shen me;
孙继海__孫繼海 194.393772779|sun ji hai;
孙中山__孫中山 563.46883971|sun zhong shan;
孙燕姿__孫燕姿 524.833224606|sun yan zi;
孙悟空__孫悟空 578.409173188|sun wu kong;
萨达姆__薩達姆 892.429452826|sa da mu;
萨克斯__薩克斯 128.529517539|sa ke si;
赛拉图__賽拉圖 123.967540162|sai la tu;
三百多__三百多 162.460985719|san bai duo;
三部曲__三部曲 298.811606079|san bu qu;
三门峡__三門峽 146.497163581|san men xia;
三明治__三明治 157.477678279|san ming zhi;
散发出__散發出 423.051424808|san fa chu;
三方面__三方面 282.164331387|san fang mian;
三分球__三分球 192.945711079|san fen qiu;
三分钟__三分鐘 396.012952778|san fen zhong;
三等奖__三等獎 312.522131716|san deng jiang;
三年内__三年內 246.94109417|san nian nei;
三年来__三年來 169.28122395|san nian lai;
三年后__三年後 206.119414554|san nian hou;
三年级__三年級 278.322859608|san nian ji;
三年前__三年前 399.980682268|san nian qian;
三轮车__三輪車 336.785179346|san lun che;
三里屯__三里屯 133.758497151|san li tun;
三个人__三個人 1059.88791463|san ge ren;
三个字__三個字 529.431458035|san ge zi;
三个月__三個月 2244.21407924|san ge yue;
三国志__三國志 355.324137339|san guo zhi;
三合一__三合一 106.882056102|san he yi;
三季报__三季報 168.649547684|san ji bao;
三级片__三級片 394.043872187|san ji pian;
三季度__三季度 526.798985534|san ji du;
三极管__三極管 126.464093517|san ji guan;
三剑客__三劍客 146.314717429|san jian ke;
三脚架__三腳架 212.377144726|san jiao jia;
三角形__三角形 505.574572707|san jiao xing;
三角洲__三角洲 166.97657743|san jiao zhou;
三句话__三句話 165.114314527|san ju hua;
三千多__三千多 114.607273411|san qian duo;
三十八__三十八 105.953760973|san shi ba;
三十六__三十六 219.37092252|san shi liu;
三十日__三十日 129.655606164|san shi ri;
三十岁__三十歲 357.099731154|san shi sui;
三十万__三十萬 134.092283643|san shi wan;
三十五__三十五 149.633788238|san shi wu;
三十二__三十二 137.819369268|san shi er;
散热片__散熱片 214.772467501|san re pian;
散热器__散熱器 606.458230719|san re qi;
三人行__三人行 139.547573842|san ren xing;
散散心__散散心 126.621787068|san san xin;
三元桥__三元橋 108.627664361|san yuan qiao;
三月份__三月份 188.196293023|san yue fen;
三亚市__三亞市 135.773751924|san ya shi;
三文鱼__三文魚 134.762357541|san wen yu;
桑塔纳__桑塔納 276.938965124|sang ta na;
桑拿浴__桑拿浴 568.405572245|sang na yu;
扫描仪__掃描儀 423.051424808|sao miao yi;
森林狼__森林狼 106.350610398|sen lin lang;
森林里__森林裡 174.203334854|sen lin li;
斯巴达__斯巴達 201.045721733|si ba da;
司马迁__司馬遷 195.60878915|si ma qian;
司马懿__司馬懿 116.769717326|si ma yi;
司法部__司法部 241.162905094|si fa bu;
司法局__司法局 202.807148249|si fa ju;
私房钱__私房錢 112.906187218|si fang qian;
四分之__四分之 485.205278648|si fen zhi;
伺服器__伺服器 110.126966673|si fu qi;
斯大林__斯大林 408.544597361|si da lin;
斯达康__斯達康 130.46599058|si da kang;
斯蒂芬__斯蒂芬 139.373782642|si di fen;
私底下__私底下 178.155043976|si di xia;
斯坦福__斯坦福 147.596627936|si tan fu;
四年级__四年級 172.260473089|si nian ji;
斯诺克__斯諾克 280.411678639|si nuo ke;
司令部__司令部 341.859308876|si ling bu;
司令员__司令員 353.998238229|si ling yuan;
四六级__四六級 193.668388536|si liu ji;
四个人__四個人 530.752623218|si ge ren;
四个字__四個字 448.56947196|si ge zi;
四个月__四個月 418.854838101|si ge yue;
斯柯达__斯柯達 162.056583012|si ke da;
四合院__四合院 224.06783424|si he yuan;
四季度__四季度 264.130371602|si ji du;
私家车__私家車 344.424970321|si jia che;
思想家__思想家 317.626273928|si xiang jia;
四川省__四川省 1354.80557722|si chuan sheng;
四川人__四川人 238.473254015|si chuan ren;
私生活__私生活 226.030964922|si sheng huo;
私生子__私生子 142.357889859|si sheng zi;
四十岁__四十歲 228.295612376|si shi sui;
四十五__四十五 139.547573842|si shi wu;
四人帮__四人幫 159.651218957|si ren bang;
司司长__司司長 268.109857044|si si zhang;
四月份__四月份 202.050369328|si yue fen;
四叶草__四葉草 115.467403456|si ye cao;
私有化__私有化 334.276427588|si you hua;
私有制__私有制 138.508067822|si you zhi;
死亡率__死亡率 345.284462654|si wang lv;
死我了__死我了 313.69268222|si wo le;
搜房网__搜房網 439.714170908|sou fang wang;
宋美龄__宋美齡 113.611883002|song mei ling;
宋丹丹__宋丹丹 163.884358899|song dan dan;
松岛枫__松島楓 130.46599058|song dao feng;
送礼物__送禮物 111.786180106|song li wu;
松花江__松花江 188.196293023|song hua jiang;
宋慧乔__宋慧喬 160.849404779|song hui qiao;
宋庆龄__宋慶齡 135.435779871|song qing ling;
送出去__送出去 110.677283245|song chu qu;
宋楚瑜__宋楚瑜 219.644465616|song chu yu;
送上门__送上門 132.596773978|song shang men;
宋祖德__宋祖德 435.352293046|song zu de;
宋祖英__宋祖英 182.651055928|song zu ying;
送温暖__送溫暖 118.529012887|song wen nuan;
苏泊尔__蘇泊爾 115.755545596|su bo er;
苏丹红__蘇丹紅 151.888225993|su dan hong;
苏东坡__蘇東坡 209.485777119|su dong po;
速度慢__速度慢 239.068350048|su du man;
速度快__速度快 533.404852483|su du kuai;
苏黎世__蘇黎世 105.426930997|su li shi;
塑料袋__塑料袋 567.697685436|su liao dai;
苏格兰__蘇格蘭 477.408200926|su ge lan;
俗话说__俗話說 453.063775264|su hua shuo;
苏贞昌__蘇貞昌 128.850255419|su zhen chang;
苏州市__蘇州市 365.20034683|su zhou shi;
宿舍楼__宿舍樓 258.593668656|su she lou;
苏有朋__蘇有朋 124.276893895|su you peng;
苏维埃__蘇維埃 158.659551632|su wei ai;
所包含__所包含 137.819369268|suo bao han;
索马里__索馬里 132.10198647|suo ma li;
所面临__所面臨 376.756940916|suo mian lin;
所发生__所發生 263.472890441|suo fa sheng;
所大学__所大學 302.181790975|suo da xue;
所得税__所得稅 660.912425973|suo de shui;
所提供__所提供 546.185068786|suo ti gong;
缩略图__縮略圖 200.545272755|suo lue tu;
索罗斯__索羅斯 167.393257695|suo luo si;
所高校__所高校 226.030964922|suo gao xiao;
所具有__所具有 269.114061535|suo ju you;
所取得__所取得 326.048110451|suo qu de;
所学校__所學校 417.291872914|suo xue xiao;
所需要__所需要 977.421145723|suo xu yao;
所涉及__所涉及 299.1842072|suo she ji;
所使用__所使用 428.890471272|suo shi yong;
所造成__所造成 483.997491267|suo zao cheng;
所采用__所採用 242.066179876|suo cai yong;
所所长__所所長 327.26932246|suo suo chang;
所要求__所要求 179.268563673|suo yao qiu;
所以然__所以然 148.334184528|suo yi ran;
所引起__所引起 266.444503116|suo yin qi;
所有权__所有權 761.800204777|suo you quan;
所有者__所有者 538.078184713|suo you zhe;
所有制__所有制 291.456266438|suo you zhi;
所有人__所有人 2391.47390956|suo you ren;
所拥有__所擁有 390.135034682|suo yong you;
随风飘__隨風飄 123.658956482|sui feng piao;
岁那年__歲那年 220.467143161|sui na nian;
随机数__隨機數 108.898738333|sui ji shu;
岁少女__歲少女 291.456266438|sui shao nv;
随身听__隨身聽 221.017305999|sui shen ting;
岁生日__歲生日 235.226605969|sui sheng ri;
岁左右__歲左右 301.054193591|sui zuo you;
岁以下__歲以下 435.352293046|sui yi xia;
随意性__隨意性 135.773751924|sui yi xing;
岁以上__歲以上 504.944935018|sui yi shang;
圆明园__圓明園 443.56664881|yuan ming yuan;
原发性__原發性 240.562595233|yuan fa xing;
源代码__源代碼 1038.96445205|yuan dai ma;
原单位__原單位 147.964946673|yuan dan wei;
原动力__原動力 138.85370659|yuan dong li;
原理图__原理圖 175.073848088|yuan li tu;
原料药__原料葯 119.56748386|yuan liao yao;
袁隆平__袁隆平 111.369047744|yuan long ping;
远距离__遠距離 268.444174826|yuan ju li;
元器件__元器件 314.475483928|yuan qi jian;
元宵节__元宵節 192.945711079|yuan xiao jie;
圆珠笔__圓珠筆 134.594525802|yuan zhu bi;
原住民__原住民 138.85370659|yuan zhu min;
原创性__原創性 367.941183266|yuan chuang xing;
原产地__原產地 191.031727675|yuan chan di;
源程序__源程序 158.659551632|yuan cheng xu;
袁崇焕__袁崇煥 116.769717326|yuan chong huan;
原生态__原生態 233.474375771|yuan sheng tai;
袁世凯__袁世凱 225.468321935|yuan shi kai;
元数据__元數據 212.641966978|yuan shu ju;
原则性__原則性 158.659551632|yuan ze xing;
原子弹__原子彈 422.52456065|yuan zi dan;
原子能__原子能 203.060037258|yuan zi neng;
院子里__院子里 546.185068786|yuan zi li;
原作者__原作者 416.253137598|yuan zuo zhe;
元左右__元左右 878.088426229|yuan zuo you;
原材料__原材料 1238.54087357|yuan cai liao;
圆圆的__圓圓的 166.768626413|yuan yuan de;
元以下__元以下 296.955549433|yuan yi xia;
元以上__元以上 485.205278648|yuan yi shang;
源文件__源文件 399.980682268|yuan wen jian;
阅读器__閱讀器 319.213487372|yue du qi;
越来越__越來越 10289.9822508|yue lai yue;
阅览室__閱覽室 147.596627936|yue lan shi;
月工资__月工資 259.562230298|yue gong zi;
约翰逊__約翰遜 248.794392378|yue han xun;
越秀区__越秀區 120.314814642|yue xiu qu;
月中旬__月中旬 800.735741689|yue zhong xun;
月出生__月出生 117.061109314|yue chu sheng;
月上旬__月上旬 248.484546245|yue shang xun;
月收入__月收入 376.287731462|yue shou ru;
约束力__約束力 179.492101402|yue shu li;
月租费__月租費 133.591915611|yue zu fei;
约瑟夫__約瑟夫 113.47039186|yue se fu;
越野车__越野車 301.054193591|yue ye che;
月以来__月以來 276.938965124|yue yi lai;
运动服__運動服 121.823518492|yun dong fu;
运动量__運動量 438.619621343|yun dong liang;
运动会__運動會 739.353626862|yun dong hui;
运动鞋__運動鞋 298.811606079|yun dong xie;
运动型__運動型 142.535402072|yun dong xing;
运动场__運動場 150.194241046|yun dong chang;
运动员__運動員 2379.58287209|yun dong yuan;
云南省__雲南省 826.074649543|yun nan sheng;
运输机__運輸機 139.026849285|yun shu ji;
运算符__運算符 145.768741141|yun suan fu;
运营商__運營商 2952.08591378|yun ying shang;
亚马逊__亞馬遜 299.557272934|ya ma xun;
雅典娜__雅典娜 172.260473089|ya dian na;
亚太区__亞太區 237.879639313|ya tai qu;
压力大__壓力大 306.352568839|ya li da;
雅戈尔__雅戈爾 322.010219858|ya ge er;
雅加达__雅加達 110.539446825|ya jia da;
亚健康__亞健康 177.269210225|ya jian kang;
亚洲杯__亞洲杯 397.991873082|ya zhou bei;
亚洲区__亞洲區 131.445140637|ya zhou qu;
亚洲人__亞洲人 184.941433485|ya zhou ren;
亚热带__亞熱帶 168.229740225|ya re dai;
亚足联__亞足聯 127.413209251|ya zu lian;
压缩包__壓縮包 429.960742313|ya suo bao;
压缩机__壓縮機 351.799391968|ya suo ji;
压岁钱__壓歲錢 149.447435764|ya sui qian;
亚运会__亞運會 432.648119245|ya yun hui;
亚运村__亞運村 198.555903198|ya yun cun;
眼巴巴__眼巴巴 117.792774542|yan ba ba;
演播室__演播室 167.601987591|yan bo shi;
研发部__研發部 143.426288875|yan fa bu;
烟台市__煙台市 174.42055653|yan tai shi;
研讨会__研討會 1280.92243009|yan tao hui;
烟灰缸__煙灰缸 132.10198647|yan hui gang;
演讲稿__演講稿 128.689786556|yan jiang gao;
眼睛里__眼睛里 530.091629029|yan jing li;
研究部__研究部 124.431860131|yan jiu bu;
研究会__研究會 393.063006485|yan jiu hui;
研究型__研究型 109.034528882|yan jiu xing;
研究者__研究者 437.527796363|yan jiu zhe;
研究生__研究生 4056.35368459|yan jiu sheng;
研究室__研究室 382.910172354|yan jiu shi;
研究所__研究所 2526.26316155|yan jiu suo;
研究员__研究員 1123.81931445|yan jiu yuan;
研究院__研究院 1316.52557925|yan jiu yuan;
验证码__驗證碼 3510.3970506|yan zheng ma;
眼睁睁__眼睜睜 375.819106356|yan zheng zheng;
研制出__研製出 252.54282031|yan zhi chu;
严重性__嚴重性 219.37092252|yan zhong xing;
严重者__嚴重者 261.83633885|yan zhong zhe;
眼珠子__眼珠子 114.179614083|yan zhu zi;
演唱会__演唱會 2561.13118731|yan chang hui;
延长线__延長線 120.314814642|yan chang xian;
言承旭__言承旭 161.049974862|yan cheng xu;
延伸至__延伸至 106.085879302|yan shen zhi;
衍生品__衍生品 117.353228453|yan sheng pin;
衍生出__衍生出 130.628674269|yan sheng chu;
衍生物__衍生物 133.259374649|yan sheng wu;
严肃性__嚴肅性 110.677283245|yan su xing;
眼药水__眼藥水 188.430963124|yan yao shui;
演艺界__演藝界 151.132997772|yan yi jie;
演艺圈__演藝圈 336.785179346|yan yi quan;
样板房__樣板房 146.497163581|yang ban fang;
样板间__樣板間 137.134095104|yang ban jian;
杨浦区__楊浦區 145.405889264|yang pu qu;
羊毛衫__羊毛衫 107.416157498|yang mao shan;
样东西__樣東西 141.826678552|yang dong xi;
养老金__養老金 522.223615731|yang lao jin;
养老院__養老院 116.769717326|yang lao yuan;
杨丽娟__楊麗娟 250.974160423|yang li juan;
养路费__養路費 285.346757867|yang lu fei;
杨贵妃__楊貴妃 145.043940608|yang gui fei;
氧化铝__氧化鋁 234.64107292|yang hua lv;
氧化物__氧化物 149.075426771|yang hua wu;
杨振宁__楊振寧 241.764712994|yang zhen ning;
养殖户__養殖戶 253.804804573|yang zhi hu;
养殖场__養殖場 219.918349804|yang zhi chang;
养殖业__養殖業 236.991986692|yang zhi ye;
扬州市__揚州市 140.244908425|yang zhou shi;
杨丞琳__楊丞琳 289.285174995|yang cheng lin;
扬声器__揚聲器 423.051424808|yang sheng qi;
样式表__樣式表 108.087539034|yang shi biao;
羊肉串__羊肉串 169.070402749|yang rou chuan;
洋葱头__洋蔥頭 131.445140637|yang cong tou;
洋娃娃__洋娃娃 346.577724349|yang wa wa;
要不得__要不得 129.655606164|yao bu de;
要不是__要不是 1051.99268696|yao bu shi;
要不然__要不然 2132.4308179|yao bu ran;
要不要__要不要 4871.83632932|yao bu yao;
妖魔化__妖魔化 132.927661458|yao mo hua;
要多久__要多久 117.792774542|yao duo jiu;
摇滚乐__搖滾樂 276.938965124|yao gun yue;
遥控器__遙控器 660.089332023|yao kong qi;
药监局__葯監局 198.803491145|yao jian ju;
邀请函__邀請函 397.001179899|yao qing han;
邀请赛__邀請賽 165.939408926|yao qing sai;
要怎么__要怎麼 223.231720645|yao zen me;
摇摇头__搖搖頭 460.463257431|yao yao tou;
也不愿__也不願 320.409100324|ye bu yuan;
野蛮人__野蠻人 116.47905068|ye man ren;
夜猫子__夜貓子 223.231720645|ye mao zi;
业发展__業發展 137.647730357|ye fa zhan;
也都是__也都是 532.740555233|ye dou shi;
叶利钦__葉利欽 187.027319083|ye li qin;
液化气__液化氣 219.097720093|ye hua qi;
耶和华__耶和華 176.387781073|ye he hua;
也会有__也會有 743.974797322|ye hui you;
叶剑英__葉劍英 110.264288753|ye jian ying;
液晶屏__液晶屏 356.655002599|ye jing ping;
野战军__野戰軍 140.594881376|ye zhan jun;
夜生活__夜生活 232.893204426|ye sheng huo;
夜总会__夜總會 448.56947196|ye zong hui;
叶一茜__葉一茜 147.964946673|ye yi qian;
业委会__業委會 225.468321935|ye wei hui;
业务部__業務部 214.504991945|ye wu bu;
业务量__業務量 270.122027271|ye wu liang;
业务员__業務員 1058.56794047|ye wu yuan;
一把刀__一把刀 113.611883002|yi ba dao;
一把手__一把手 392.084582382|yi ba shou;
一百多__一百多 579.852559389|yi bai duo;
一百元__一百元 110.677283245|yi bai yuan;
一百万__一百萬 286.772667017|yi bai wan;
一般性__一般性 286.415523108|yi ban xing;
一般人__一般人 1274.55334676|yi ban ren;
一杯酒__一杯酒 129.494134325|yi bei jiu;
一杯水__一杯水 134.259489114|yi bei shui;
一辈子__一輩子 4122.60245218|yi bei zi;
一笔钱__一筆錢 184.02185602|yi bi qian;
一比一__一比一 162.86639759|yi bi yi;
一遍遍__一遍遍 201.045721733|yi bian bian;
一边倒__一邊倒 128.049907079|yi bian dao;
仪表盘__儀錶盤 106.483223576|yi biao pan;
一步步__一步步 765.607004232|yi bu bu;
一排排__一排排 133.42554153|yi pai pai;
一片片__一片片 176.168109435|yi pian pian;
移民局__移民局 168.020228531|yi min ju;
一幕幕__一幕幕 212.641966978|yi mu mu;
一番话__一番話 126.306596357|yi fan hua;
易方达__易方達 251.914183226|yi fang da;
一封信__一封信 568.405572245|yi feng xin;
一幅幅__一幅幅 118.676811842|yi fu fu;
一幅画__一幅畫 136.282292017|yi fu hua;
一段话__一段話 348.743933702|yi duan hua;
一大半__一大半 225.749468142|yi da ban;
一大堆__一大堆 1521.27901981|yi da dui;
意大利__意大利 4327.91161602|yi da li;
一大早__一大早 635.075580657|yi da zao;
一代人__一代人 404.491915522|yi dai ren;
一道道__一道道 173.553291634|yi dao dao;
一刀切__一刀切 138.680779525|yi dao qie;
胰岛素__胰島素 399.482550191|yi dao su;
一等奖__一等獎 697.293562832|yi deng jiang;
一滴泪__一滴淚 111.369047744|yi di lei;
一滴水__一滴水 126.621787068|yi di shui;
一点点__一點點 3931.92961191|yi dian dian;
伊甸园__伊甸園 205.350275845|yi dian yuan;
一点儿__一點兒 796.754272909|yi dian er;
一丁点__一丁點 156.694657831|yi ding dian;
一定量__一定量 153.41002317|yi ding liang;
移动到__移動到 180.613978088|yi dong dao;
一朵花__一朵花 209.746993999|yi duo hua;
一对一__一對一 386.264972075|yi dui yi;
一团糟__一團糟 125.835280772|yi tuan zao;
以太网__以太網 431.571158705|yi tai wang;
一体化__一體化 1243.1798239|yi ti hua;
一体机__一體機 337.625607028|yi ti ji;
一天天__一天天 470.908619205|yi tian tian;
一条条__一條條 197.076837307|yi tiao tiao;
一条腿__一條腿 182.651055928|yi tiao tui;
一条龙__一條龍 210.008536601|yi tiao long;
一条路__一條路 397.001179899|yi tiao lu;
一条狗__一條狗 148.334184528|yi tiao gou;
一条街__一條街 362.028498203|yi tiao jie;
一条线__一條線 186.561765129|yi tiao xian;
一条鱼__一條魚 109.170488754|yi tiao yu;
一男子__一男子 174.42055653|yi nan zi;
伊能静__伊能靜 159.651218957|yi neng jing;
一年半__一年半 372.555031371|yi nian ban;
一年的__一年的 784.92825478|yi nian de;
一年多__一年多 990.911721928|yi nian duo;
一年内__一年內 367.482952871|yi nian nei;
一年来__一年來 281.812926654|yi nian lai;
一年后__一年後 425.165459331|yi nian hou;
一年期__一年期 177.048440864|yi nian qi;
一年前__一年前 496.830647979|yi nian qian;
易拉罐__易拉罐 109.716025699|yi la guan;
伊拉克__伊拉克 3145.79455985|yi la ke;
依赖性__依賴性 267.44247003|yi lai xing;
一览表__一覽表 292.912705474|yi lan biao;
伊兰特__伊蘭特 224.907079496|yi lan te;
一揽子__一攬子 129.494134325|yi lan zi;
一脸的__一臉的 276.594068012|yi lian de;
一连串__一連串 484.601008682|yi lian chuan;
医疗费__醫療費 286.415523108|yi liao fei;
医疗队__醫療隊 108.222318063|yi liao dui;
一辆车__一輛車 385.78392141|yi liang che;
一个劲__一個勁 446.895626023|yi ge jin;
一根烟__一根煙 107.14877401|yi gen yan;
一块块__一塊塊 117.499561272|yi kuai kuai;
一块钱__一塊錢 322.010219858|yi kuai qian;
一块儿__一塊兒 403.988165198|yi kuai er;
一卡通__一卡通 424.635962376|yi ka tong;
一颗颗__一顆顆 118.824795093|yi ke ke;
一颗心__一顆心 179.045304336|yi ke xin;
一棵树__一棵樹 342.712398751|yi ke shu;
一口价__一口價 145.224802174|yi kou jia;
一口气__一口氣 1736.10671918|yi kou qi;
一号线__一號線 106.483223576|yi hao xian;
颐和园__頤和園 328.904723278|yi he yuan;
一回事__一回事 695.557838999|yi hui shi;
一会儿__一會兒 5422.95707874|yi hui er;
一季度__一季度 971.349932368|yi ji du;
一家子__一家子 142.180598718|yi jia zi;
易建联__易建聯 542.11647303|yi jian lian;
一件件__一件件 138.335571213|yi jian jian;
一件事__一件事 1463.63092081|yi jian shi;
意见书__意見書 125.835280772|yi jian shu;
一节课__一節課 225.187525865|yi jie ke;
已经很__已經很 673.382717005|yi jing hen;
一九八__一九八 172.260473089|yi jiu ba;
一九七__一九七 141.650048976|yi jiu qi;
一九四__一九四 132.762114633|yi jiu si;
一句话__一句話 4926.78395812|yi ju hua;
一群人__一群人 640.639682982|yi qun ren;
一起看__一起看 261.510250403|yi qi kan;
一起去__一起去 1528.88101848|yi qi qu;
一起吃__一起吃 341.433560596|yi qi chi;
一起走__一起走 272.828431509|yi qi zou;
一起做__一起做 212.112652282|yi qi zuo;
一起玩__一起玩 458.173712968|yi qi wan;
一千多__一千多 375.819106356|yi qian duo;
一千万__一千萬 170.339279748|yi qian wan;
医学界__醫學界 130.46599058|yi xue jie;
医学院__醫學院 778.110973173|yi xue yuan;
一系列__一系列 3603.47496171|yi xi lie;
一席话__一席話 120.765453341|yi xi hua;
一下吧__一下吧 770.392265767|yi xia ba;
一下下__一下下 251.287110964|yi xia xia;
一下子__一下子 3907.50658436|yi xia zi;
胰腺癌__胰腺癌 279.017397997|yi xian ai;
一小撮__一小撮 124.276893895|yi xiao cuo;
意向书__意向書 123.813152185|yi xiang shu;
一些人__一些人 1416.96881393|yi xie ren;
异性恋__異性戀 152.457122789|yi xing lian;
一转眼__一轉眼 141.826678552|yi zhuan yan;
一站式__一站式 179.71591787|yi zhan shi;
一张张__一張張 269.449631503|yi zhang zhang;
一张纸__一張紙 266.112675706|yi zhang zhi;
一张床__一張床 175.729586548|yi zhang chuang;
一阵风__一陣風 159.452390871|yi zhen feng;
一阵阵__一陣陣 328.495108513|yi zhen zhen;
一阵子__一陣子 812.799921236|yi zhen zi;
一整套__一整套 347.875829952|yi zheng tao;
一整天__一整天 566.284555508|yi zheng tian;
一只猫__一隻貓 128.689786556|yi zhi mao;
意志力__意志力 180.389043185|yi zhi li;
一枝花__一枝花 109.989815613|yi zhi hua;
抑制剂__抑製劑 132.596773978|yi zhi ji;
一只脚__一隻腳 149.447435764|yi zhi jiao;
一只小__一隻小 141.29744947|yi zhi xiao;
一致性__一致性 461.037428991|yi zhi xing;
一只手__一隻手 649.481929235|yi zhi shou;
一支烟__一支煙 188.901181552|yi zhi yan;
以至于__以至於 1295.36947746|yi zhi yu;
一周内__一周內 237.287502254|yi zhou nei;
易中天__易中天 377.697115787|yi zhong tian;
遗传学__遺傳學 120.916041011|yi chuan xue;
一串串__一串串 105.426930997|yi chuan chuan;
一刹那__一剎那 431.033684153|yi cha na;
一场梦__一場夢 120.46484039|yi chang meng;
宜昌市__宜昌市 110.95347192|yi chang shi;
一瞬间__一瞬間 714.000502259|yi shun jian;
一扇门__一扇門 113.046974828|yi shan men;
一时间__一時間 665.043316617|yi shi jian;
一首歌__一首歌 852.21539528|yi shou ge;
一首诗__一首詩 248.794392378|yi shou shi;
艺术品__藝術品 635.867483878|yi shu pin;
艺术团__藝術團 212.112652282|yi shu tuan;
艺术类__藝術類 167.810977762|yi shu lei;
艺术馆__藝術館 111.925571131|yi shu guan;
艺术家__藝術家 1775.48936799|yi shu jia;
艺术节__藝術節 280.761336094|yi shu jie;
艺术性__藝術性 182.651055928|yi shu xing;
艺术照__藝術照 172.475272126|yi shu zhao;
一日游__一日游 239.068350048|yi ri you;
一座座__一座座 126.779677253|yi zuo zuo;
一次性__一次性 2028.7420046|yi ci xing;
一次次__一次次 1010.8674618|yi ci ci;
以色列__以色列 1672.40062475|yi se lie;
伊斯兰__伊斯蘭 426.226434824|yi si lan;
一丝丝__一絲絲 163.884358899|yi si si;
一元钱__一元錢 127.890434962|yi yuan qian;
一月份__一月份 139.895806636|yi yue fen;
一样吗__一樣嗎 139.547573842|yi yang ma;
医药费__醫藥費 292.912705474|yi yao fei;
一夜情__一夜情 845.867144221|yi ye qing;
以一种__以一種 411.610733326|yi yi zhong;
易用性__易用性 203.566761683|yi yong xing;
抑郁症__抑鬱症 440.811451858|yi yu zheng;
一万元__一萬元 176.60772663|yi wan yuan;
意味着__意味着 5013.49243365|yi wei zhe;
一窝蜂__一窩蜂 110.539446825|yi wo feng;
义乌市__義烏市 154.561368684|yi wu shi;
一而再__一而再 133.591915611|yi er zai;
银白色__銀白色 132.10198647|yin bai se;
阴道炎__陰道炎 139.895806636|yin dao yan;
印度人__印度人 271.810366771|yin du ren;
印度洋__印度洋 201.296414343|yin du yang;
因特网__因特網 340.15949445|yin te wang;
印花税__印花稅 668.366611253|yin hua shui;
银行股__銀行股 476.219822262|yin hang gu;
银行卡__銀行卡 1005.84116282|yin hang ka;
银行家__銀行家 153.218967809|yin hang jia;
银行间__銀行間 224.626982392|yin hang jian;
银行业__銀行業 632.705783453|yin hang ye;
银河系__銀河系 150.944778196|yin he xi;
银灰色__銀灰色 125.36572391|yin hui se;
银监会__銀監會 430.496878967|yin jian hui;
音像店__音像店 105.821807183|yin xiang dian;
因扎吉__因扎吉 195.60878915|yin zha ji;
银川市__銀川市 131.609045271|yin chuan shi;
印刷品__印刷品 163.884358899|yin shua pin;
印刷厂__印刷廠 206.633773476|yin shua chang;
音视频__音視頻 482.191444969|yin shi pin;
饮水机__飲水機 244.796354228|yin shui ji;
隐私权__隱私權 180.613978088|yin si quan;
音乐厅__音樂廳 157.67404401|yin yue ting;
音乐盒__音樂盒 160.649084484|yin yue he;
音乐会__音樂會 622.538424634|yin yue hui;
音乐家__音樂家 325.236501817|yin yue jia;
音乐节__音樂節 237.287502254|yin yue jie;
音乐剧__音樂劇 310.580912674|yin yue ju;
音乐人__音樂人 327.677408739|yin yue ren;
饮用水__飲用水 476.813641365|yin yong shui;
因为那__因為那 285.702569086|yin wei na;
因为爱__因為愛 172.690339006|yin wei ai;
应包括__應包括 136.792736844|ying bao kuo;
硬盘盒__硬盤盒 119.716577729|ying pan he;
应聘者__應聘者 350.486645516|ying pin zhe;
影评人__影評人 133.259374649|ying ping ren;
应符合__應符合 150.381524744|ying fu he;
英特尔__英特爾 1639.38542435|ying te er;
应纳税__應納稅 123.658956482|ying na shui;
应该做__應該做 353.557372243|ying gai zuo;
应该用__應該用 239.068350048|ying gai yong;
英格兰__英格蘭 1096.15615618|ying ge lan;
应根据__應根據 342.285588041|ying gen ju;
英国人__英國人 544.146968302|ying guo ren;
应考虑__應考慮 191.269933402|ying kao lv;
萤火虫__螢火蟲 219.918349804|ying huo chong;
应届生__應屆生 233.474375771|ying jie sheng;
应具备__應具備 201.79873775|ying ju bei;
应具有__應具有 129.979154132|ying ju you;
营销部__營銷部 124.276893895|ying xiao bu;
影响力__影響力 2501.20312918|ying xiang li;
应注意__應注意 673.382717005|ying zhu yi;
应承担__應承擔 172.04594156|ying cheng dan;
硬生生__硬生生 172.475272126|ying sheng sheng;
影视剧__影視劇 238.176261728|ying shi ju;
影视圈__影視圈 107.550099352|ying shi quan;
应收款__應收款 105.426930997|ying shou kuan;
应如何__應如何 120.164975734|ying ru he;
应采取__應採取 178.59961945|ying cai qu;
营养品__營養品 123.504952812|ying yang pin;
营养师__營養師 129.332863581|ying yang shi;
营养素__營養素 276.594068012|ying yang su;
营业部__營業部 813.813436628|ying ye bu;
营业厅__營業廳 657.626195507|ying ye ting;
营业税__營業稅 384.344361008|ying ye shui;
营业员__營業員 387.711726118|ying ye yuan;
营业额__營業額 426.226434824|ying ye e;
婴幼儿__嬰幼兒 510.640021015|ying you er;
应用层__應用層 112.484875527|ying yong ceng;
英语课__英語課 129.171793682|ying yu ke;
英文版__英文版 721.154209805|ying wen ban;
英文名__英文名 404.491915522|ying wen ming;
英文歌__英文歌 154.754097942|ying wen ge;
迎奥运__迎奧運 179.045304336|ying ao yun;
有把握__有把握 177.490254874|you ba wo;
有病毒__有病毒 131.117943492|you bing du;
由不得__由不得 107.282382453|you bu de;
又不能__又不能 517.687984062|you bu neng;
又不是__又不是 2692.03036174|you bu shi;
有没有__有沒有 20142.9541807|you mei you;
幽默感__幽默感 223.510077937|you mo gan;
有的是__有的是 801.734213733|you de shi;
有的人__有的人 1356.49494292|you de ren;
有点像__有點像 811.787668067|you dian xiang;
有点儿__有點兒 734.761160623|you dian er;
有多大__有多大 1255.63548024|you duo da;
有多高__有多高 206.119414554|you duo gao;
有多个__有多個 197.076837307|you duo ge;
有多长__有多長 114.607273411|you duo chang;
有多深__有多深 107.550099352|you duo shen;
有多远__有多遠 270.796100963|you duo yuan;
有太多__有太多 741.198640518|you tai duo;
犹太人__猶太人 620.98878351|you tai ren;
尤纳斯__尤納斯 115.323601467|you na si;
有赖于__有賴於 128.529517539|you lai yu;
有了钱__有了錢 211.321149687|you le qian;
游乐场__遊樂場 207.666345181|you le chang;
游乐园__遊樂園 183.335174792|you le yuan;
有两个__有兩個 2033.8046114|you liang ge;
有两种__有兩種 955.740681497|you liang zhong;
有感觉__有感覺 207.149415951|you gan jue;
有过之__有過之 125.992190229|you guo zhi;
又开始__又開始 1212.57856995|you kai shi;
又可以__又可以 542.11647303|you ke yi;
有好感__有好感 204.584007193|you hao gan;
又何必__又何必 284.991389772|you he bi;
有很大__有很大 1755.68762073|you hen da;
有很强__有很強 324.83145542|you hen qiang;
诱惑力__誘惑力 267.109399762|you huo li;
又回到__又回到 610.248767154|you hui dao;
优惠价__優惠價 134.594525802|you hui jia;
优惠券__優惠券 271.133768339|you hui quan;
有几分__有幾分 348.743933702|you ji fen;
有机肥__有機肥 120.164975734|you ji fei;
游击队__游擊隊 275.905561849|you ji dui;
有几个__有幾個 2067.02090848|you ji ge;
有几家__有幾家 105.426930997|you ji jia;
游击战__游擊戰 114.75018218|you ji zhan;
有几种__有幾種 143.605133321|you ji zhong;
有几次__有幾次 180.613978088|you ji ci;
有机物__有機物 181.290467084|you ji wu;
有较大__有較大 582.750146437|you jiao da;
有较强__有較強 254.755429543|you jiao qiang;
优缺点__優缺點 266.776744296|you que dian;
有气质__有氣質 156.109948588|you qi zhi;
有钱了__有錢了 219.37092252|you qian le;
有钱人__有錢人 1236.99840673|you qian ren;
有情人__有情人 271.810366771|you qing ren;
游戏币__遊戲幣 209.485777119|you xi bi;
游戏里__遊戲里 311.355949144|you xi li;
游戏机__遊戲機 669.200026501|you xi ji;
右下角__右下角 579.130416613|you xia jiao;
有线通__有線通 125.835280772|you xian tong;
优先级__優先級 502.434215952|you xian ji;
优先权__優先權 135.94305409|you xian quan;
有限元__有限元 159.85029497|you xian yuan;
有效期__有效期 754.243296976|you xiao qi;
有效性__有效性 707.799244422|you xiao xing;
有些事__有些事 353.557372243|you xie shi;
有些人__有些人 2645.47163011|you xie ren;
有心人__有心人 221.017305999|you xin ren;
邮政局__郵政局 187.027319083|you zheng ju;
有助于__有助於 2227.49666896|you zhu yu;
又称为__又稱為 125.992190229|you cheng wei;
有冲突__有衝突 122.127521944|you chong tu;
又出现__又出現 381.006242235|you chu xian;
右上角__右上角 413.152419826|you shang jiao;
有时候__有時候 8010.00481377|you shi hou;
有人用__有人用 168.229740225|you ren yong;
又如何__又如何 537.40806734|you ru he;
油菜花__油菜花 166.353500999|you cai hua;
有三个__有三個 660.912425973|you san ge;
有三种__有三種 348.743933702|you san zhong;
有四个__有四個 260.534419685|you si ge;
有缘人__有緣人 106.085879302|you yuan ren;
优越感__優越感 209.485777119|you yue gan;
优越性__優越性 239.068350048|you yue xing;
有一份__有一份 240.862563142|you yi fen;
有一段__有一段 419.900065808|you yi duan;
有一套__有一套 347.00988711|you yi tao;
有一天__有一天 3041.71045076|you yi tian;
有一条__有一條 441.361118731|you yi tiao;
有一块__有一塊 172.04594156|you yi kuai;
有一颗__有一顆 276.249600432|you yi ke;
有意者__有意者 316.83562918|you yi zhe;
有一只__有一隻 261.510250403|you yi zhi;
有一种__有一種 3492.94243288|you yi zhong;
有意识__有意識 405.501301397|you yi shi;
有一座__有一座 180.613978088|you yi zuo;
又一次__又一次 1326.40613196|you yi ci;
有一次__有一次 2098.16340664|you yi ci;
友谊赛__友誼賽 177.711575153|you yi sai;
有意思__有意思 2289.40978274|you yi si;
有异味__有異味 140.945727665|you yi wei;
有一位__有一位 702.526765976|you yi wei;
有用吗__有用嗎 152.837570606|you yong ma;
游泳馆__游泳館 178.377193209|you yong guan;
游泳池__游泳池 540.093554591|you yong chi;
由于其__由於其 435.895152658|you yu qi;
忧郁症__憂鬱症 137.476305203|you yu zheng;
幼儿园__幼兒園 2332.60704332|you er yuan;
用不了__用不了 493.744603771|yong bu liao;
用不着__用不着 642.238361775|yong bu zhao;
用不用__用不用 255.073095111|yong bu yong;
用不完__用不完 115.467403456|yong bu wan;
用得着__用得着 245.101601395|yong de zhao;
用的是__用的是 1033.79844744|yong de shi;
用电脑__用電腦 280.062456643|yong dian nao;
雍和宫__雍和宮 108.087539034|yong he gong;
用户名__用戶名 2822.57620712|yong hu ming;
用户群__用戶群 246.633556117|yong hu qun;
用户数__用戶數 277.284292303|yong hu shu;
用户组__用戶組 158.067510349|yong hu zu;
永久性__永久性 285.702569086|yong jiu xing;
涌现出__湧現出 296.955549433|yong xian chu;
用什么__用什麼 984.756712384|yong shen me;
用手机__用手機 536.738784525|yong shou ji;
用鼠标__用鼠標 238.176261728|yong shu biao;
用水量__用水量 219.37092252|yong shui liang;
用英语__用英語 265.119670945|yong ying yu;
拥有者__擁有者 189.608710238|yong you zhe;
预备队__預備隊 129.655606164|yu bei dui;
预备役__預備役 118.23396695|yu bei yi;
羽毛球__羽毛球 1202.04704744|yu mao qiu;
郁闷的__鬱悶的 431.571158705|yu men de;
预付费__預付費 155.915530766|yu fu fei;
预付款__預付款 232.893204426|yu fu kuan;
遇难者__遇難者 238.176261728|yu nan zhe;
愈来愈__愈來愈 423.578945935|yu lai yu;
娱乐界__娛樂界 111.507918629|yu le jie;
娱乐圈__娛樂圈 1156.49608257|yu le quan;
娱乐性__娛樂性 192.945711079|yu le xing;
娱乐业__娛樂業 107.684208225|yu le ye;
预告片__預告片 317.230705235|yu gao pian;
宇航员__宇航員 326.454673948|yu hang yuan;
与会者__與會者 221.845125512|yu hui zhe;
遇见你__遇見你 149.633788238|yu jian ni;
郁金香__鬱金香 246.019628549|yu jin xiang;
与其说__與其說 411.098117295|yu qi shuo;
余秋雨__余秋雨 299.93080386|yu qiu yu;
预选赛__預選賽 322.010219858|yu xuan sai;
渝中区__渝中區 128.850255419|yu zhong qu;
预产期__預產期 192.225730308|yu chan qi;
预处理__預處理 226.877563077|yu chu li;
于是乎__於是乎 240.263000901|yu shi hu;
愚人节__愚人節 221.568841736|yu ren jie;
羽绒服__羽絨服 269.449631503|yu rong fu;
语言包__語言包 111.369047744|yu yan bao;
语言学__語言學 194.151676652|yu yan xue;
预应力__預應力 145.043940608|yu ying li;
余万元__余萬元 163.884358899|yu wan yuan;
语文课__語文課 161.451865638|yu wen ke;
娃哈哈__娃哈哈 974.988119996|wa ha ha;
挖掘机__挖掘機 181.064689688|wa jue ji;
娃娃脸__娃娃臉 105.164499152|wa wa lian;
外包装__外包裝 252.85772688|wai bao zhuang;
外婆家__外婆家 154.754097942|wai po jia;
外地人__外地人 674.222387052|wai di ren;
外来工__外來工 138.335571213|wai lai gong;
外高桥__外高橋 148.149450567|wai gao qiao;
外国人__外國人 1983.741885|wai guo ren;
外国语__外國語 161.451865638|wai guo yu;
外交部__外交部 651.914561431|wai jiao bu;
外交官__外交官 258.593668656|wai jiao guan;
外经贸__外經貿 244.491487214|wai jing mao;
外星人__外星人 628.775756137|wai xing ren;
外甥女__外甥女 130.791560815|wai sheng nv;
万美元__萬美元 1693.37191801|wan mei yuan;
万吨级__萬噸級 121.823518492|wan dun ji;
玩电脑__玩電腦 140.419785869|wan dian nao;
万年历__萬年曆 127.572086295|wan nian li;
万千瓦__萬千瓦 258.593668656|wan qian wa;
完整版__完整版 311.355949144|wan zheng ban;
完整性__完整性 678.436468738|wan zheng xing;
晚上好__晚上好 420.94790182|wan shang hao;
玩什么__玩什麼 349.178797604|wan shen me;
万圣节__萬聖節 220.742053181|wan sheng jie;
万人迷__萬人迷 117.792774542|wan ren mi;
万人次__萬人次 346.577724349|wan ren ci;
晚自习__晚自習 226.030964922|wan zi xi;
万左右__萬左右 196.096919422|wan zuo you;
万以上__萬以上 182.196395498|wan yi shang;
万亿元__萬億元 308.267359529|wan yi yuan;
玩意儿__玩意兒 522.223615731|wan yi er;
玩游戏__玩遊戲 1438.31738787|wan you xi;
万用表__萬用表 130.303509496|wan yong biao;
王八蛋__王八蛋 329.314848809|wang ba dan;
忘不了__忘不了 518.979844093|wang bu liao;
王府井__王府井 368.85935893|wang fu jing;
网论坛__網論壇 125.678566729|wang lun tan;
王老吉__王老吉 176.60772663|wang lao ji;
王老师__王老師 516.399339766|wang lao shi;
王力宏__王力宏 614.062995519|wang li hong;
王励勤__王勵勤 158.461958559|wang li qin;
网络版__網絡版 299.1842072|wang luo ban;
网络部__網絡部 131.445140637|wang luo bu;
网络化__網絡化 288.205701591|wang luo hua;
王家卫__王家衛 277.630050085|wang jia wei;
王金平__王金平 122.127521944|wang jin ping;
汪精卫__汪精衛 169.070402749|wang jing wei;
往前走__往前走 366.568203397|wang qian zou;
网球场__網球場 109.989815613|wang qiu chang;
王先生__王先生 553.723632203|wang xian sheng;
王小波__王小波 304.449671797|wang xiao bo;
王小丫__王小丫 153.028150386|wang xiao ya;
王心凌__王心凌 249.726250867|wang xin ling;
王治郅__王治郅 233.765505073|wang zhi zhi;
网上看__網上看 146.679837233|wang shang kan;
望远镜__望遠鏡 507.468200425|wang yuan jing;
王永庆__王永慶 106.350610398|wang yong qing;
王安石__王安石 135.267109459|wang an shi;
文本框__文本框 272.149298879|wen ben kuang;
文明办__文明辦 123.813152185|wen ming ban;
文档中__文檔中 160.449013667|wen dang zhong;
稳定性__穩定性 1746.95787997|wen ding xing;
温度计__溫度計 153.41002317|wen du ji;
温哥华__溫哥華 357.99085261|wen ge hua;
文工团__文工團 107.550099352|wen gong tuan;
文化部__文化部 342.712398751|wen hua bu;
文化馆__文化館 112.34478795|wen hua guan;
文化课__文化課 116.18910757|wen hua ke;
文化节__文化節 296.216358865|wen hua jie;
文化局__文化局 166.560934377|wen hua ju;
文化人__文化人 159.85029497|wen hua ren;
温家宝__溫家寶 1306.71862793|wen jia bao;
文件名__文件名 1041.55712696|wen jian ming;
文件夹__文件夾 3177.31287701|wen jian jia;
文学家__文學家 220.742053181|wen xue jia;
文学奖__文學獎 106.085879302|wen xue jiang;
文学史__文學史 144.863304286|wen xue shi;
文学院__文學院 138.85370659|wen xue yuan;
温州市__溫州市 361.12732612|wen zhou shi;
温州人__溫州人 233.474375771|wen zhou ren;
汶川县__汶川縣 125.678566729|wen chuan xian;
问自己__問自己 281.461959558|wen zi ji;
温总理__溫總理 381.006242235|wen zong li;
文言文__文言文 186.794397067|wen yan wen;
文艺片__文藝片 140.419785869|wen yi pian;
问一下__問一下 1859.27057168|wen yi xia;
文网文__文網文 387.22887368|wen wang wen;
翁美玲__翁美玲 110.264288753|weng mei ling;
微波炉__微波爐 560.667124391|wei bo lu;
未发现__未發現 191.508436159|wei fa xian;
潍坊市__濰坊市 125.992190229|wei fang shi;
为的是__為的是 138.163289429|wei de shi;
未登录__未登錄 455.895552723|wei deng lu;
微电子__微電子 234.056997396|wei dian zi;
维他命__維他命 262.489736092|wei ta ming;
委托书__委託書 227.160466527|wei tuo shu;
委托人__委託人 360.228397261|wei tuo ren;
维纳斯__維納斯 146.132498493|wei na si;
威尼斯__威尼斯 453.063775264|wei ni si;
伪科学__偽科學 151.510141313|wei ke xue;
胃溃疡__胃潰瘍 107.952927857|wei kui yang;
未婚夫__未婚夫 141.473639374|wei hun fu;
未婚妻__未婚妻 212.112652282|wei hun qi;
危害性__危害性 210.532600599|wei hai xing;
威海市__威海市 106.616002115|wei hai shi;
位会员__位會員 114.607273411|wei hui yuan;
伪君子__偽君子 162.663565352|wei jun zi;
微积分__微積分 132.431639237|wei ji fen;
危机感__危機感 161.049974862|wei ji gan;
未取得__未取得 137.647730357|wei qu de;
微循环__微循環 331.786363812|wei xun huan;
危险品__危險品 123.504952812|wei xian pin;
危险性__危險性 366.568203397|wei xian xing;
韦小宝__韋小寶 268.109857044|wei xiao bao;
维修站__維修站 224.347234118|wei xiu zhan;
未知数__未知數 213.704562287|wei zhi shu;
胃肠道__胃腸道 208.44415872|wei chang dao;
未成年__未成年 1276.14264248|wei cheng nian;
为什么__為什麼 50907.100939|wei shen me;
卫生部__衛生部 806.745280603|wei sheng bu;
卫生间__衛生間 1359.87999657|wei sheng jian;
卫生巾__衛生巾 263.472890441|wei sheng jin;
卫生局__衛生局 369.319305625|wei sheng ju;
卫生纸__衛生紙 206.376433771|wei sheng zhi;
维生素__維生素 2221.95191814|wei sheng su;
卫生院__衛生院 332.614317243|wei sheng yuan;
微生物__微生物 673.382717005|wei sheng wu;
威士忌__威士忌 168.859844103|wei shi ji;
委书记__委書記 294.743493195|wei shu ji;
委员会__委員會 5532.16874554|wei yuan hui;
委员长__委員長 341.008342538|wei yuan zhang;
违约金__違約金 482.191444969|wei yue jin;
维也纳__維也納 360.677581637|wei ye na;
未完成__未完成 324.426913464|wei wan cheng;
维吾尔__維吾爾 187.027319083|wei wu er;
维埃拉__維埃拉 111.091824605|wei ai la;
慰安妇__慰安婦 162.460985719|wei an fu;
威尔士__威爾士 130.954650472|wei er shi;
威尔斯__威爾斯 112.065135969|wei er si;
我帮你__我幫你 720.256091319|wo bang ni;
我并不__我並不 576.250827814|wo bing bu;
我不会__我不會 1746.95787997|wo bu hui;
我不想__我不想 1942.15867186|wo bu xiang;
我不在__我不在 181.064689688|wo bu zai;
我不要__我不要 433.187606905|wo bu yao;
我们俩__我們倆 561.366244489|wo men lia;
沃达丰__沃達豐 122.584950132|wo da feng;
我的梦__我的夢 112.765574943|wo de meng;
我的脸__我的臉 359.331706043|wo de lian;
我的家__我的家 191.747236314|wo de jia;
我的心__我的心 1727.4743398|wo de xin;
我的手__我的手 891.318029807|wo de shou;
我的爱__我的愛 356.210827905|wo de ai;
我等你__我等你 209.224885556|wo deng ni;
我对你__我對你 476.813641365|wo dui ni;
我讨厌__我討厭 287.488291405|wo tao yan;
我老婆__我老婆 822.992135502|wo lao po;
我给你__我給你 2143.08680935|wo gei ni;
我看你__我看你 579.130416613|wo kan ni;
我看过__我看過 490.066643104|wo kan guo;
我看看__我看看 1502.43898348|wo kan kan;
我看着__我看着 482.792710347|wo kan zhe;
我哭了__我哭了 151.888225993|wo ku le;
我还能__我還能 351.361264404|wo hai neng;
我好想__我好想 374.41672986|wo hao xiang;
我和他__我和他 604.948616891|wo he ta;
我和你__我和你 577.688827991|wo he ni;
我和我__我和我 463.341283758|wo he wo;
我很想__我很想 476.219822262|wo hen xiang;
我见过__我見過 410.586139672|wo jian guo;
我就不__我就不 940.382265783|wo jiu bu;
我想买__我想買 253.488718522|wo xiang mai;
我想你__我想你 591.530074736|wo xiang ni;
我想看__我想看 113.753550575|wo xiang kan;
我想说__我想說 496.830647979|wo xiang shuo;
我想做__我想做 141.121478992|wo xiang zuo;
我想要__我想要 684.380469812|wo xiang yao;
我想我__我想我 821.967189047|wo xiang wo;
我只想__我只想 680.977550057|wo zhi xiang;
我承认__我承認 521.573243485|wo cheng ren;
我是你__我是你 239.068350048|wo shi ni;
卧室里__卧室里 131.117943492|wo shi li;
我是个__我是個 857.541983893|wo shi ge;
我是谁__我是誰 273.509258874|wo shi shui;
我说过__我說過 384.344361008|wo shuo guo;
我说我__我說我 501.808489233|wo shuo wo;
握在手__握在手 110.126966673|wo zai shou;
我走了__我走了 480.991159713|wo zou le;
我最爱__我最愛 296.585723861|wo zui ai;
我错了__我錯了 534.735933039|wo cuo le;
我送你__我送你 154.754097942|wo song ni;
我要买__我要買 108.898738333|wo yao mai;
我要看__我要看 190.081867665|wo yao kan;
我要找__我要找 106.350610398|wo yao zhao;
我要做__我要做 195.852702213|wo yao zuo;
我也不__我也不 1303.46590513|wo ye bu;
我也来__我也來 249.726250867|wo ye lai;
我也想__我也想 1020.99553617|wo ye xiang;
我也是__我也是 3792.371211|wo ye shi;
我也要__我也要 892.429452826|wo ye yao;
我也有__我也有 523.526794166|wo ye you;
我一眼__我一眼 399.980682268|wo yi yan;
我有个__我有個 423.578945935|wo you ge;
我爱你__我愛你 1915.71752783|wo ai ni;
沃尔玛__沃爾瑪 879.183352683|wo er ma;
沃尔沃__沃爾沃 202.050369328|wo er wo;
五百万__五百萬 144.863304286|wu bai wan;
吴邦国__吳邦國 156.694657831|wu bang guo;
无不及__無不及 113.611883002|wu bu ji;
无名指__無名指 219.097720093|wu ming zhi;
五分钟__五分鐘 546.185068786|wu fen zhong;
无风险__無風險 106.882056102|wu feng xian;
武大郎__武大郎 109.716025699|wu da lang;
五道口__五道口 246.019628549|wu dao kou;
误导性__誤導性 121.975425508|wu dao xing;
舞台剧__舞台劇 203.313241605|wu tai ju;
五台山__五台山 218.824857909|wu tai shan;
武藤兰__武藤蘭 178.155043976|wu teng lan;
无条件__無條件 485.205278648|wu tiao jian;
梧桐树__梧桐樹 109.034528882|wu tong shu;
乌托邦__烏托邦 191.269933402|wu tuo bang;
五年内__五年內 161.250795044|wu nian nei;
五年来__五年來 148.889769675|wu nian lai;
五年级__五年級 142.713135632|wu nian ji;
乌拉圭__烏拉圭 142.713135632|wu la gui;
无厘头__無厘頭 273.850309404|wu li tou;
物理学__物理學 480.991159713|wu li xue;
物理系__物理系 160.649084484|wu li xi;
五粮液__五糧液 507.468200425|wu liang ye;
物流业__物流業 143.963491517|wu liu ye;
乌龙茶__烏龍茶 136.622376491|wu long cha;
五个人__五個人 202.554574186|wu ge ren;
五个月__五個月 185.86560618|wu ge yue;
无公害__無公害 460.463257431|wu gong hai;
乌克兰__烏克蘭 675.063104121|wu ke lan;
无愧于__無愧於 118.676811842|wu kui yu;
五花肉__五花肉 115.611384758|wu hua rou;
无害化__無害化 114.179614083|wu hai hua;
武汉队__武漢隊 134.259489114|wu han dui;
武汉市__武漢市 769.432826682|wu han shi;
武汉人__武漢人 121.066816454|wu han ren;
无极限__無極限 118.676811842|wu ji xian;
物价局__物價局 442.462509543|wu jia ju;
无间道__無間道 312.911829085|wu jian dao;
五角场__五角場 181.064689688|wu jiao chang;
吴敬琏__吳敬璉 122.737806611|wu jing lian;
物权法__物權法 402.982545867|wu quan fa;
无锡市__無錫市 334.276427588|wu xi shi;
无线电__無線電 475.034401746|wu xian dian;
无限期__無限期 139.547573842|wu xian qi;
无限制__無限制 397.496217848|wu xian zhi;
五星级__五星級 271.133768339|wu xing ji;
无形中__無形中 286.058823982|wu xing zhong;
无休止__無休止 225.468321935|wu xiu zhi;
无障碍__無障礙 177.933171406|wu zhang ai;
吴镇宇__吳鎮宇 105.426930997|wu zhen yu;
无止境__無止境 188.901181552|wu zhi jing;
五十多__五十多 121.217779906|wu shi duo;
五十岁__五十歲 124.587019602|wu shi sui;
五十万__五十萬 226.595011951|wu shi wan;
无数次__無數次 733.846096172|wu shu ci;
污染源__污染源 258.593668656|wu ran yuan;
污染物__污染物 468.567137655|wu ran wu;
无任何__無任何 392.084582382|wu ren he;
无人机__無人機 122.737806611|wu ren ji;
误认为__誤認為 217.19480623|wu ren wei;
武则天__武則天 341.859308876|wu ze tian;
屋子里__屋子裡 569.114341748|wu zi li;
五子棋__五子棋 141.121478992|wu zi qi;
吴宗宪__吳宗憲 305.97104031|wu zong xian;
误操作__誤操作 134.092283643|wu cao zuo;
吴三桂__吳三桂 111.925571131|wu san gui;
无所谓__無所謂 5939.41952983|wu suo wei;
五月份__五月份 207.666345181|wu yue fen;
五月天__五月天 473.851932013|wu yue tian;
乌鸦嘴__烏鴉嘴 162.056583012|wu ya zui;
吴彦祖__吳彥祖 226.312812713|wu yan zu;
物业费__物業費 205.350275845|wu ye fei;
物业税__物業稅 201.296414343|wu ye shui;
无意间__無意間 333.444336783|wu yi jian;
五一节__五一節 197.568631008|wu yi jie;
武夷山__武夷山 325.236501817|wu yi shan;
无意识__無意識 296.955549433|wu yi shi;
无意义__無意義 249.104624871|wu yi yi;
吴宇森__吳宇森 166.146325956|wu yu sen;
无污染__無污染 138.508067822|wu wu ran;
呜呜呜__嗚嗚嗚 393.063006485|wu wu wu;
阿巴斯__阿巴斯 161.854759309|a ba si;
阿波罗__阿波羅 211.321149687|a bo luo;
阿富汗__阿富汗 743.048258297|a fu han;
阿拉伯__阿拉伯 635.075580657|a la bo;
阿拉希__阿拉希 193.427195796|a la xi;
阿联酋__阿聯酋 257.3078729|a lian qiu;
阿隆索__阿隆索 232.024158785|a long suo;
阿根廷__阿根廷 1409.92327219|a gen ting;
阿奎那__阿奎那 147.412812521|a kui na;
阿修罗__阿修羅 120.015323434|a xiu luo;
阿森纳__阿森納 742.122873174|a sen na;
阿斯顿__阿斯頓 335.528458728|a si dun;
啊啊啊__啊啊啊 635.867483878|a a a;
阿尔法__阿爾法 167.184787749|a er fa;
爱不爱__愛不愛 144.143005824|ai bu ai;
爱普生__愛普生 231.446597362|ai pu sheng;
埃弗顿__埃弗頓 109.852835359|ai fu dun;
艾弗森__艾弗森 170.127140854|ai fu sen;
爱德华__愛德華 205.094534596|ai de hua;
爱的人__愛的人 982.305426747|ai de ren;
爱迪生__愛迪生 134.092283643|ai di sheng;
埃托奥__埃托奧 160.649084484|ai tuo ao;
爱立信__愛立信 396.012952778|ai li xin;
爱丽舍__愛麗舍 116.915322539|ai li she;
爱丽丝__愛麗絲 127.413209251|ai li si;
爱国者__愛國者 527.455873984|ai guo zhe;
爱好者__愛好者 1718.88488289|ai hao zhe;
爱琴海__愛琴海 107.952927857|ai qin hai;
爱情片__愛情片 112.906187218|ai qing pian;
爱情观__愛情觀 106.748946222|ai qing guan;
爱情是__愛情是 401.478808454|ai qing shi;
癌细胞__癌細胞 273.850309404|ai xi bao;
爱着你__愛着你 163.272821143|ai zhe ni;
爱上他__愛上他 131.117943492|ai shang ta;
爱上我__愛上我 115.179978568|ai shang wo;
爱生活__愛生活 116.333988795|ai sheng huo;
爱滋病__愛滋病 151.888225993|ai zi bing;
艾滋病__艾滋病 1434.73708553|ai zi bing;
爱自己__愛自己 390.621510938|ai zi ji;
哎呀呀__哎呀呀 148.334184528|ai ya ya;
艾薇儿__艾薇兒 125.678566729|ai wei er;
爱尔兰__愛爾蘭 598.201722298|ai er lan;
按比例__按比例 178.155043976|an bi li;
安排好__安排好 375.351064872|an pai hao;
安眠药__安眠藥 226.030964922|an mian yao;
按摩器__按摩器 123.658956482|an mo qi;
安德鲁__安德魯 130.46599058|an de lu;
安德森__安德森 120.015323434|an de sen;
暗地里__暗地裡 192.225730308|an di li;
安东尼__安東尼 271.810366771|an dong ni;
安徒生__安徒生 110.264288753|an tu sheng;
安乐死__安樂死 121.217779906|an le si;
安理会__安理會 331.786363812|an li hui;
按理说__按理說 218.824857909|an li shuo;
安哥拉__安哥拉 170.551683166|an ge la;
按规定__按規定 942.728934628|an gui ding;
暗红色__暗紅色 110.126966673|an hong se;
安徽省__安徽省 1036.37823089|an hui sheng;
氨基酸__氨基酸 526.798985534|an ji suan;
安监局__安監局 158.857391092|an jian ju;
安全带__安全帶 286.772667017|an quan dai;
安全套__安全套 431.571158705|an quan tao;
安全感__安全感 925.270654393|an quan gan;
安全期__安全期 174.203334854|an quan qi;
安全性__安全性 1682.85360433|an quan xing;
安装包__安裝包 261.184568064|an zhuang bao;
安装盘__安裝盤 193.90988203|an zhuang pan;
安装完__安裝完 122.127521944|an zhuang wan;
按顺序__按順序 129.332863581|an shun xu;
鞍山市__鞍山市 135.267109459|an shan shi;
按要求__按要求 241.764712994|an yao qiu;
奥地利__奧地利 573.385557088|ao di li;
奥特曼__奧特曼 206.376433771|ao te man;
奥尼尔__奧尼爾 304.070513117|ao ni er;
奥兰多__奧蘭多 112.765574943|ao lan duo;
奥克兰__奧克蘭 111.507918629|ao ke lan;
奥克斯__奧克斯 115.036534536|ao ke si;
奥组委__奧組委 192.945711079|ao zu wei;
奥斯卡__奧斯卡 758.012333731|ao si ka;
奥运会__奧運會 3768.81504502|ao yun hui;
奥委会__奧委會 150.756793028|ao wei hui;
峨眉山__峨眉山 208.184564378|e mei shan;
俄罗斯__俄羅斯 5402.72120617|e luo si;
恶狠狠__惡狠狠 253.804804573|e hen hen;
恶势力__惡勢力 196.096919422|e shi li;
恶作剧__惡作劇 356.655002599|e zuo ju;
恩格斯__恩格斯 161.451865638|en ge si;
二百五__二百五 122.279808036|er bai wu;
而不是__而不是 6104.50527935|er bu shi;
二等奖__二等獎 444.119751258|er deng jiang;
耳朵里__耳朵里 172.260473089|er duo li;
儿童节__兒童節 306.352568839|er tong jie;
二年级__二年級 283.927938713|er nian ji;
二零零__二零零 236.402059204|er ling ling;
二个月__二個月 113.046974828|er ge yue;
二锅头__二鍋頭 150.381524744|er guo tou;
二季度__二季度 323.216307961|er ji du;
二极管__二極管 257.62872122|er ji guan;
二进制__二進制 392.084582382|er jin zhi;
儿媳妇__兒媳婦 178.822323044|er xi fu;
二十八__二十八 271.810366771|er shi ba;
二十多__二十多 566.284555508|er shi duo;
二十六__二十六 196.831399718|er shi liu;
二十几__二十幾 198.803491145|er shi ji;
二十九__二十九 168.859844103|er shi jiu;
二十七__二十七 198.308623594|er shi qi;
二十三__二十三 211.057972369|er shi san;
二十四__二十四 354.43965395|er shi si;
二十岁__二十歲 251.287110964|er shi sui;
二十一__二十一 225.749468142|er shi yi;
二十万__二十萬 160.249192015|er shi wan;
二十五__二十五 388.195180646|er shi wu;
二十二__二十二 258.271618599|er shi er;
二手房__二手房 982.305426747|er shou fang;
二手车__二手車 569.823995046|er shou che;
二人转__二人轉 134.092283643|er ren zhuan;
二维码__二維碼 127.890434962|er wei ma;
哦哦哦__哦哦哦 288.924902033|o o o;
欧佩克__歐佩克 190.793818607|ou pei ke;
欧莱雅__歐萊雅 238.473254015|ou lai ya;
欧锦赛__歐錦賽 128.369448119|ou jin sai;
偶像剧__偶像劇 294.009808944|ou xiang ju;
欧洲杯__歐洲杯 277.630050085|ou zhou bei;
欧洲人__歐洲人 277.284292303|ou zhou ren;
偶然性__偶然性 112.625137786|ou ran xing;
欧元区__歐元區 181.742866823|ou yuan qu;
爸爸妈妈__爸爸媽媽 1313.24844471|ba ba ma ma;
巴勒斯坦__巴勒斯坦 541.441326411|ba le si tan;
八国联军__八國聯軍 112.204874836|ba guo lian jun;
巴基斯坦__巴基斯坦 1118.23138914|ba ji si tan;
八十年代__八十年代 583.476802811|ba shi nian dai;
巴塞罗那__巴塞羅那 433.187606905|ba sai luo na;
霸王别姬__霸王別姬 130.141230764|ba wang bie ji;
白马王子__白馬王子 177.269210225|bai ma wang zi;
百分之百__百分之百 395.027185582|bai fen zhi bai;
百分之十__百分之十 151.888225993|bai fen zhi shi;
百分之一__百分之一 134.930398555|bai fen zhi yi;
百度贴吧__百度貼吧 128.049907079|bai du tie ba;
百度知道__百度知道 545.504855178|bai du zhi dao;
百度搜索__百度搜索 140.594881376|bai du sou suo;
百科全书__百科全書 191.508436159|bai ke quan shu;
百花齐放__百花齊放 133.925286409|bai hua qi fang;
百货公司__百貨公司 147.045868173|bai huo gong si;
百家讲坛__百家講壇 221.017305999|bai jia jiang tan;
白雪公主__白雪公主 152.457122789|bai xue gong zhu;
百事可乐__百事可樂 165.73274959|bai shi ke le;
白手起家__白手起家 134.259489114|bai shou qi jia;
百万富翁__百萬富翁 241.162905094|bai wan fu weng;
百万像素__百萬像素 122.127521944|bai wan xiang su;
百无聊赖__百無聊賴 135.267109459|bai wu liao lai;
白俄罗斯__白俄羅斯 152.837570606|bai e luo si;
半壁江山__半壁江山 141.473639374|ban bi jiang shan;
半途而废__半途而廢 133.42554153|ban tu er fei;
半个小时__半個小時 919.523371782|ban ge xiao shi;
半个世纪__半個世紀 215.845709156|ban ge shi ji;
办公大楼__辦公大樓 168.859844103|ban gong da lou;
办公地点__辦公地點 108.763116896|ban gong di dian;
办公家具__辦公傢具 133.42554153|ban gong jia ju;
办公场所__辦公場所 107.818484324|ban gong chang suo;
办公设备__辦公設備 142.713135632|ban gong she bei;
办公软件__辦公軟件 173.337150041|ban gong ruan jian;
办公用品__辦公用品 225.187525865|ban gong yong pin;
搬家公司__搬家公司 277.630050085|ban jia gong si;
颁奖典礼__頒獎典禮 408.035799866|ban jiang dian li;
颁奖仪式__頒獎儀式 112.065135969|ban jiang yi shi;
版权保护__版權保護 129.171793682|ban quan bao hu;
版权声明__版權聲明 162.663565352|ban quan sheng ming;
版权所有__版權所有 1716.74420026|ban quan suo you;
版权问题__版權問題 138.163289429|ban quan wen ti;
办学条件__辦學條件 105.0335283|ban xue tiao jian;
办事机构__辦事機構 116.333988795|ban shi ji gou;
半数以上__半數以上 105.558392399|ban shu yi shang;
班子成员__班子成員 141.650048976|ban zi cheng yuan;
帮助别人__幫助別人 199.548108896|bang zhu bie ren;
帮助学生__幫助學生 136.282292017|bang zhu xue sheng;
帮助文件__幫助文件 316.83562918|bang zhu wen jian;
榜上有名__榜上有名 129.979154132|bang shang you ming;
报名时间__報名時間 131.117943492|bao ming shi jian;
报名人数__報名人數 110.126966673|bao ming ren shu;
报名参加__報名參加 356.655002599|bao ming can jia;
暴风影音__暴風影音 372.091054935|bao feng ying yin;
保费收入__保費收入 107.684208225|bao fei shou ru;
宝钢股份__寶鋼股份 130.954650472|bao gang gu fen;
宝贵意见__寶貴意見 163.069482749|bao gui yi jian;
保护动物__保護動物 126.621787068|bao hu dong wu;
保护条例__保護條例 792.79260104|bao hu tiao li;
保护工作__保護工作 119.26985293|bao hu gong zuo;
保护环境__保護環境 228.011295226|bao hu huan jing;
保护自己__保護自己 493.129699012|bao hu zi ji;
保护作用__保護作用 206.89143407|bao hu zuo yong;
保护措施__保護措施 167.601987591|bao hu cuo shi;
保加利亚__保加利亞 191.98633424|bao jia li ya;
保驾护航__保駕護航 125.209594649|bao jia hu hang;
保健食品__保健食品 271.810366771|bao jian shi pin;
保险公司__保險公司 1782.13945694|bao xian gong si;
保险合同__保險合同 137.476305203|bao xian he tong;
保险资金__保險資金 168.859844103|bao xian zi jin;
包装设计__包裝設計 119.56748386|bao zhuang she ji;
包装材料__包裝材料 133.591915611|bao zhuang cai liao;
爆炸事件__爆炸事件 148.704343794|bao zha shi jian;
保障体系__保障體系 207.925293333|bao zhang ti xi;
保障机制__保障機制 126.621787068|bao zhang ji zhi;
保障制度__保障制度 107.952927857|bao zhang zhi du;
保障措施__保障措施 116.769717326|bao zhang cuo shi;
保值增值__保值增值 129.494134325|bao zhi zeng zhi;
报业集团__報業集團 182.878811433|bao ye ji tuan;
本报记者__本報記者 1440.11088805|ben bao ji zhe;
本地连接__本地連接 119.41857567|ben di lian jie;
本来面目__本來面目 133.42554153|ben lai mian mu;
本来就是__本來就是 1241.63157975|ben lai jiu shi;
本科毕业__本科畢業 226.595011951|ben ke bi ye;
本科学历__本科學歷 112.765574943|ben ke xue li;
本职工作__本職工作 204.329220247|ben zhi gong zuo;
本场比赛__本場比賽 421.998352644|ben chang bi sai;
本身就是__本身就是 891.318029807|ben shen jiu shi;
本草纲目__本草綱目 109.034528882|ben cao gang mu;
蹦蹦跳跳__蹦蹦跳跳 110.95347192|beng beng tiao tiao;
被保险人__被保險人 244.796354228|bei bao xian ren;
北大青鸟__北大青鳥 123.351140937|bei da qing niao;
背道而驰__背道而馳 170.127140854|bei dao er chi;
贝克汉姆__貝克漢姆 544.825488702|bei ke han mu;
悲欢离合__悲歡離合 138.680779525|bei huan li he;
北京大学__北京大學 1150.74567978|bei jing da xue;
北京地区__北京地區 342.285588041|bei jing di qu;
北京国际__北京國際 152.457122789|bei jing guo ji;
北京现代__北京現代 236.107646363|bei jing xian dai;
北京车展__北京車展 144.322743975|bei jing che zhan;
北京市民__北京市民 108.357265155|bei jing shi min;
北京时间__北京時間 693.826435782|bei jing shi jian;
北京市场__北京市場 146.497163581|bei jing shi chang;
北京移动__北京移動 126.937764318|bei jing yi dong;
北京银行__北京銀行 139.547573842|bei jing yin hang;
背景音乐__背景音樂 462.187920882|bei jing yin yue;
北京奥运__北京奧運 518.979844093|bei jing ao yun;
被执行人__被執行人 151.888225993|bei zhi xing ren;
被认为是__被認為是 744.902491688|bei ren wei shi;
比比皆是__比比皆是 308.651751439|bi bi jie shi;
必不可少__必不可少 605.702953498|bi bu ke shao;
比较合适__比較合適 284.991389772|bi jiao he shi;
比较喜欢__比較喜歡 724.757896749|bi jiao xi huan;
比较容易__比較容易 584.932834985|bi jiao rong yi;
比较研究__比較研究 186.32942291|bi jiao yan jiu;
比较优势__比較優勢 234.056997396|bi jiao you shi;
必经之路__必經之路 121.975425508|bi jing zhi lu;
闭着眼睛__閉着眼睛 241.162905094|bi zhe yan jing;
闭上眼睛__閉上眼睛 446.895626023|bi shang yan jing;
必然要求__必然要求 162.86639759|bi ran yao qiu;
彼此彼此__彼此彼此 173.769702743|bi ci bi ci;
比赛项目__比賽項目 107.550099352|bi sai xiang mu;
必要条件__必要條件 234.056997396|bi yao tiao jian;
毕业典礼__畢業典禮 171.617679695|bi ye dian li;
毕业论文__畢業論文 393.553133755|bi ye lun wen;
毕业证书__畢業證書 251.914183226|bi ye zheng shu;
毕业设计__畢業設計 388.195180646|bi ye she ji;
必由之路__必由之路 144.322743975|bi you zhi lu;
比尔盖茨__比爾蓋茨 173.553291634|bi er gai ci;
变本加厉__變本加厲 146.679837233|bian ben jia li;
变得更加__變得更加 455.327784806|bian de geng jia;
遍地开花__遍地開花 109.579386421|bian di kai hua;
变更登记__變更登記 122.279808036|bian geng deng ji;
变化情况__變化情況 116.18910757|bian hua qing kuang;
辩护律师__辯護律師 150.756793028|bian hu lv shi;
变形金刚__變形金剛 1827.1144412|bian xing jin gang;
编程语言__編程語言 143.605133321|bian cheng yu yan;
表达方式__表達方式 244.796354228|biao da fang shi;
表达能力__表達能力 181.290467084|biao da neng li;
表达自己__表達自己 415.216987933|biao da zi ji;
标点符号__標點符號 136.792736844|biao dian fu hao;
表现形式__表現形式 372.555031371|biao xian xing shi;
表现出来__表現出來 666.702893247|biao xian chu lai;
表现手法__表現手法 126.779677253|biao xian shou fa;
标新立异__標新立異 113.611883002|biao xin li yi;
表彰大会__表彰大會 117.499561272|biao zhang da hui;
表示感谢__表示感謝 327.26932246|biao shi gan xie;
别具一格__別具一格 123.197520618|bie ju yi ge;
别出心裁__別出心裁 143.963491517|bie chu xin cai;
别有用心__別有用心 299.557272934|bie you yong xin;
别无选择__別無選擇 136.622376491|bie wu xuan ze;
彬彬有礼__彬彬有禮 111.786180106|bin bin you li;
滨海新区__濱海新區 334.69325133|bin hai xin qu;
并不代表__並不代表 966.520124945|bing bu dai biao;
并不知道__並不知道 456.464028614|bing bu zhi dao;
并不一定__並不一定 453.063775264|bing bu yi ding;
并非如此__並非如此 120.164975734|bing fei ru ci;
病毒感染__病毒感染 202.302314677|bing du gan ran;
冰天雪地__冰天雪地 124.742372548|bing tian xue di;
播放列表__播放列表 112.204874836|bo fang lie biao;
博大精深__博大精深 235.226605969|bo da jing shen;
波涛汹涌__波濤洶湧 105.164499152|bo tao xiong yong;
波澜不惊__波瀾不驚 137.476305203|bo lan bu jing;
波澜壮阔__波瀾壯闊 129.979154132|bo lan zhuang kuo;
博客首页__博客首頁 174.855812809|bo ke shou ye;
博客网站__博客網站 127.254530072|bo ke wang zhan;
博客文章__博客文章 173.121277629|bo ke wen zhang;
播种面积__播種面積 148.149450567|bo zhong mian ji;
博士论文__博士論文 109.034528882|bo shi lun wen;
博士学位__博士學位 429.425273358|bo shi xue wei;
薄弱环节__薄弱環節 211.584655172|bo ruo huan jie;
不怕不怕__不怕不怕 183.335174792|bu pa bu pa;
部门经理__部門經理 203.566761683|bu men jing li;
不明不白__不明不白 135.098649108|bu ming bu bai;
不谋而合__不謀而合 140.770195218|bu mou er he;
不法分子__不法分子 211.321149687|bu fa fen zi;
部分地区__部分地區 509.368920718|bu fen di qu;
部分内容__部分內容 1257.20118645|bu fen nei rong;
部分组成__部分組成 210.795122809|bu fen zu cheng;
不负责任__不負責任 748.624851411|bu fu ze ren;
不复存在__不復存在 237.879639313|bu fu cun zai;
不断发展__不斷發展 426.757915008|bu duan fa zhan;
不断提高__不斷提高 1202.04704744|bu duan ti gao;
不断更新__不斷更新 169.915266157|bu duan geng xin;
不断扩大__不斷擴大 469.151414294|bu duan kuo da;
不断加强__不斷加強 249.415244207|bu duan jia qiang;
不断创新__不斷創新 264.459727191|bu duan chuang xin;
不断增加__不斷增加 509.368920718|bu duan zeng jia;
不断增强__不斷增強 323.619340361|bu duan zeng qiang;
不断完善__不斷完善 458.745029596|bu duan wan shan;
不大不小__不大不小 129.817279349|bu da bu xiao;
布达拉宫__布達拉宮 167.810977762|bu da la gong;
不得好死__不得好死 140.244908425|bu de hao si;
不得其解__不得其解 129.332863581|bu de qi jie;
不得擅自__不得擅自 108.898738333|bu de shan zi;
不得而知__不得而知 297.325836157|bu de er zhi;
不动声色__不動聲色 227.443722742|bu dong sheng se;
不同凡响__不同凡響 117.061109314|bu tong fan xiang;
不同地区__不同地區 170.76435144|bu tong di qu;
不同类型__不同類型 397.001179899|bu tong lei xing;
不同国家__不同國家 132.266710153|bu tong guo jia;
不同阶段__不同階段 126.149295342|bu tong jie duan;
不同寻常__不同尋常 140.070248771|bu tong xun chang;
不同之处__不同之處 208.964318904|bu tong zhi chu;
不同程度__不同程度 852.21539528|bu tong cheng du;
不同时期__不同時期 163.680258901|bu tong shi qi;
不同层次__不同層次 193.427195796|bu tong ceng ci;
不同颜色__不同顏色 130.791560815|bu tong yan se;
不同意见__不同意見 257.94996962|bu tong yi jian;
不能通过__不能通過 128.850255419|bu neng tong guo;
不能接受__不能接受 422.52456065|bu neng jie shou;
不能确定__不能確定 226.595011951|bu neng que ding;
不能正常__不能正常 244.796354228|bu neng zheng chang;
不能超过__不能超過 245.71323808|bu neng chao guo;
不能承受__不能承受 137.647730357|bu neng cheng shou;
不能上网__不能上網 139.547573842|bu neng shang wang;
不能使用__不能使用 418.854838101|bu neng shi yong;
不能容忍__不能容忍 197.076837307|bu neng rong ren;
不能自拔__不能自拔 168.649547684|bu neng zi ba;
不能忘记__不能忘記 160.249192015|bu neng wang ji;
不伦不类__不倫不類 178.377193209|bu lun bu lei;
不离不弃__不離不棄 169.492308033|bu li bu qi;
不利因素__不利因素 156.694657831|bu li yin su;
不利影响__不利影響 255.073095111|bu li ying xiang;
不了了之__不了了之 242.066179876|bu liao liao zhi;
不良反应__不良反應 345.715012791|bu liang fan ying;
不良贷款__不良貸款 198.06165195|bu liang dai kuan;
不良资产__不良資產 226.030964922|bu liang zi chan;
不良影响__不良影響 239.366454718|bu liang ying xiang;
布鲁塞尔__布魯塞爾 135.94305409|bu lu sai er;
不管怎样__不管怎樣 312.132919672|bu guan zen yang;
不敢相信__不敢相信 424.107124851|bu gan xiang xin;
不感兴趣__不感興趣 461.037428991|bu gan xing qu;
不顾一切__不顧一切 353.998238229|bu gu yi qie;
不过如此__不過如此 179.71591787|bu guo ru ci;
不堪回首__不堪回首 130.791560815|bu kan hui shou;
不堪重负__不堪重負 140.070248771|bu kan zhong fu;
不堪设想__不堪設想 112.34478795|bu kan she xiang;
不堪一击__不堪一擊 155.527421199|bu kan yi ji;
不可避免__不可避免 966.520124945|bu ke bi mian;
不可分割__不可分割 153.41002317|bu ke fen ge;
不可多得__不可多得 199.796934068|bu ke duo de;
不可替代__不可替代 203.313241605|bu ke ti dai;
不可能的__不可能的 384.344361008|bu ke neng de;
不可逆转__不可逆轉 116.333988795|bu ke ni zhuan;
不可理喻__不可理喻 153.218967809|bu ke li yu;
不可告人__不可告人 119.716577729|bu ke gao ren;
不可估量__不可估量 105.0335283|bu ke gu liang;
不可开交__不可開交 143.247667161|bu ke kai jiao;
不可抗力__不可抗力 123.967540162|bu ke kang li;
不可抗拒__不可抗拒 112.625137786|bu ke kang ju;
不可忽视__不可忽視 260.859291326|bu ke hu shi;
不可或缺__不可或缺 523.526794166|bu ke huo que;
不可缺少__不可缺少 377.697115787|bu ke que shao;
不可想象__不可想象 115.899886195|bu ke xiang xiang;
不可思议__不可思議 1096.15615618|bu ke si yi;
不可一世__不可一世 129.655606164|bu ke yi shi;
不怀好意__不懷好意 130.303509496|bu huai hao yi;
不寒而栗__不寒而慄 115.323601467|bu han er li;
不好意思__不好意思 8751.01052505|bu hao yi si;
不合时宜__不合時宜 172.475272126|bu he shi yi;
不会出现__不會出現 561.366244489|bu hui chu xian;
不会说话__不會說話 109.034528882|bu hui shuo hua;
不会忘记__不會忘記 354.881620091|bu hui wang ji;
不绝于耳__不絕於耳 148.704343794|bu jue yu er;
不计其数__不計其數 194.393772779|bu ji qi shu;
不假思索__不假思索 115.899886195|bu jia si suo;
不紧不慢__不緊不慢 137.134095104|bu jin bu man;
不仅如此__不僅如此 216.384339476|bu jin ru ci;
不经意间__不經意間 352.238065853|bu jing yi jian;
不确定性__不確定性 579.852559389|bu que ding xing;
不起作用__不起作用 164.703307075|bu qi zuo yong;
不切实际__不切實際 261.510250403|bu qie shi ji;
不屈不挠__不屈不撓 113.47039186|bu qu bu nao;
不相上下__不相上下 166.560934377|bu xiang shang xia;
不懈努力__不懈努力 220.742053181|bu xie nu li;
不屑一顾__不屑一顧 262.489736092|bu xie yi gu;
不折不扣__不折不扣 305.589986932|bu zhe bu kou;
不正之风__不正之風 149.075426771|bu zheng zhi feng;
不知不觉__不知不覺 1276.14264248|bu zhi bu jue;
不置可否__不置可否 109.170488754|bu zhi ke fou;
不知所措__不知所措 549.598880816|bu zhi suo cuo;
不知所云__不知所云 189.372573382|bu zhi suo yun;
不止一次__不止一次 291.093289619|bu zhi yi ci;
不是别人__不是別人 110.95347192|bu shi bie ren;
不是没有__不是沒有 258.916120291|bu shi mei you;
不是很好__不是很好 707.799244422|bu shi hen hao;
不失时机__不失時機 117.93965545|bu shi shi ji;
不是滋味__不是滋味 153.028150386|bu shi zi wei;
布什总统__布什總統 212.907119447|bu shi zong tong;
不是一个__不是一個 1425.82527204|bu shi yi ge;
不容乐观__不容樂觀 250.661599628|bu rong le guan;
不容忽视__不容忽視 322.010219858|bu rong hu shi;
不容置疑__不容置疑 121.671800659|bu rong zhi yi;
哺乳动物__哺乳動物 144.863304286|bu ru dong wu;
不在话下__不在話下 140.770195218|bu zai hua xia;
不在少数__不在少數 244.796354228|bu zai shao shu;
不择手段__不擇手段 255.073095111|bu ze shou duan;
不怎么样__不怎麼樣 626.429466854|bu zen me yang;
部总经理__部總經理 207.925293333|bu zong jing li;
不足之处__不足之處 225.187525865|bu zu zhi chu;
不足为奇__不足為奇 151.888225993|bu zu wei qi;
不算什么__不算什麼 260.859291326|bu suan shen me;
不思进取__不思進取 118.529012887|bu si jin qu;
不约而同__不約而同 418.854838101|bu yue er tong;
不孕不育__不孕不育 114.179614083|bu yun bu yu;
不厌其烦__不厭其煩 210.532600599|bu yan qi fan;
不言而喻__不言而喻 280.062456643|bu yan er yu;
不要轻易__不要輕易 302.935867929|bu yao qing yi;
不要错过__不要錯過 171.617679695|bu yao cuo guo;
不要以为__不要以為 450.24958728|bu yao yi wei;
不要忘记__不要忘記 299.1842072|bu yao wang ji;
不依不饶__不依不饒 114.037415895|bu yi bu rao;
不亦乐乎__不亦樂乎 252.228305921|bu yi le hu;
不一会儿__不一會兒 172.04594156|bu yi hui er;
不遗余力__不遺餘力 292.54791482|bu yi yu li;
不以为然__不以為然 389.163898974|bu yi wei ran;
不由自主__不由自主 539.420927296|bu you zi zhu;
不用担心__不用擔心 698.163048348|bu yong dan xin;
不用客气__不用客氣 144.502706249|bu yong ke qi;
不用注册__不用註冊 369.779825848|bu yong zhu ce;
不闻不问__不聞不問 130.628674269|bu wen bu wen;
不为人知__不為人知 248.484546245|bu wei ren zhi;
不务正业__不務正業 153.218967809|bu wu zheng ye;
帕瓦罗蒂__帕瓦羅蒂 116.333988795|pa wa luo di;
排放标准__排放標準 133.093414711|pai fang biao zhun;
拍照手机__拍照手機 113.895394799|pai zhao shou ji;
排忧解难__排憂解難 124.587019602|pai you jie nan;
抛砖引玉__拋磚引玉 172.04594156|pao zhuan yin yu;
蓬勃发展__蓬勃發展 347.00988711|peng bo fa zhan;
朋友之间__朋友之間 115.899886195|peng you zhi jian;
朋友一起__朋友一起 262.162833911|peng you yi qi;
配套设施__配套設施 374.41672986|pei tao she shi;
赔礼道歉__賠禮道歉 126.149295342|pei li dao qian;
培训工作__培訓工作 273.168633085|pei xun gong zuo;
培训课程__培訓課程 145.405889264|pei xun ke cheng;
培训基地__培訓基地 171.831677206|pei xun ji di;
培训机构__培訓機構 330.960471347|pei xun ji gou;
培训计划__培訓計劃 124.742372548|pei xun ji hua;
培训学校__培訓學校 150.756793028|pei xun xue xiao;
培训中心__培訓中心 449.688850794|pei xun zhong xin;
配置文件__配置文件 488.846754671|pei zhi wen jian;
赔偿责任__賠償責任 267.109399762|pei chang ze ren;
配送中心__配送中心 126.779677253|pei song zhong xin;
培养孩子__培養孩子 144.682892926|pei yang hai zi;
培养学生__培養學生 493.744603771|pei yang xue sheng;
培养人才__培養人才 114.321989585|pei yang ren cai;
疲惫不堪__疲憊不堪 151.321452046|pi bei bu kan;
批发零售__批發零售 110.401782066|pi fa ling shou;
批发市场__批發市場 583.476802811|pi fa shi chang;
皮肤干燥__皮膚乾燥 169.915266157|pi fu gan zao;
皮肤过敏__皮膚過敏 253.804804573|pi fu guo min;
噼里啪啦__噼里啪啦 110.815291538|pi li pa la;
批量生产__批量生產 200.04606951|pi liang sheng chan;
皮下组织__皮下組織 198.06165195|pi xia zu zhi;
翩翩起舞__翩翩起舞 113.895394799|pian pian qi wu;
漂亮女人__漂亮女人 137.476305203|piao liang nv ren;
品牌价值__品牌價值 207.925293333|pin pai jia zhi;
品牌建设__品牌建設 158.264611567|pin pai jian she;
品牌效应__品牌效應 114.321989585|pin pai xiao ying;
品牌形象__品牌形象 368.399985048|pin pai xing xiang;
品牌战略__品牌戰略 174.638049069|pin pai zhan lue;
贫富差距__貧富差距 279.713669565|pin fu cha ju;
贫困地区__貧困地區 324.02287532|pin kun di qu;
贫困家庭__貧困家庭 161.451865638|pin kun jia ting;
贫困学生__貧困學生 167.810977762|pin kun xue sheng;
贫困人口__貧困人口 183.106850936|pin kun ren kou;
平板电视__平板電視 403.988165198|ping ban dian shi;
平平淡淡__平平淡淡 199.051387821|ping ping dan dan;
平平安安__平平安安 134.594525802|ping ping an an;
平面媒体__平面媒體 131.773154284|ping mian mei ti;
平面设计__平面設計 261.184568064|ping mian she ji;
平民百姓__平民百姓 139.72158175|ping min bai xing;
平方公里__平方公里 775.207436548|ping fang gong li;
评论内容__評論內容 177.711575153|ping lun nei rong;
评估报告__評估報告 132.762114633|ping gu bao gao;
苹果电脑__蘋果電腦 117.93965545|ping guo dian nao;
苹果公司__蘋果公司 173.769702743|ping guo gong si;
平均年龄__平均年齡 114.75018218|ping jun nian ling;
平均工资__平均工資 288.205701591|ping jun gong zi;
平均价格__平均價格 193.90988203|ping jun jia ge;
平均气温__平均氣溫 127.254530072|ping jun qi wen;
平均水平__平均水平 538.078184713|ping jun shui ping;
评价标准__評價標準 119.716577729|ping jia biao zhun;
评价体系__評價體系 182.878811433|ping jia ti xi;
评选活动__評選活動 295.111021611|ping xuan huo dong;
平易近人__平易近人 164.498187167|ping yi jin ren;
迫不得已__迫不得已 166.97657743|po bu de yi;
迫不及待__迫不及待 610.248767154|po bu ji dai;
婆婆妈妈__婆婆媽媽 108.898738333|po po ma ma;
破口大骂__破口大罵 167.601987591|po kou da ma;
迫切需要__迫切需要 338.046607007|po qie xu yao;
迫在眉睫__迫在眉睫 198.803491145|po zai mei jie;
普遍存在__普遍存在 361.577631409|pu bian cun zai;
普普通通__普普通通 179.71591787|pu pu tong tong;
扑面而来__撲面而來 205.094534596|pu mian er lai;
浦发银行__浦發銀行 177.048440864|pu fa yin hang;
浦东新区__浦東新區 250.037645335|pu dong xin qu;
铺天盖地__鋪天蓋地 382.433299725|pu tian gai di;
普通百姓__普通百姓 237.879639313|pu tong bai xing;
普通朋友__普通朋友 133.758497151|pu tong peng you;
普通高校__普通高校 186.794397067|pu tong gao xiao;
普通高中__普通高中 172.690339006|pu tong gao zhong;
普通住房__普通住房 108.222318063|pu tong zhu fang;
普通住宅__普通住宅 144.863304286|pu tong zhu zhai;
普通用户__普通用戶 221.845125512|pu tong yong hu;
扑朔迷离__撲朔迷離 194.151676652|pu shuo mi li;
马不停蹄__馬不停蹄 181.064689688|ma bu ting ti;
马马虎虎__馬馬虎虎 301.054193591|ma ma hu hu;
马特拉齐__馬特拉齊 150.756793028|ma te la qi;
马拉多纳__馬拉多納 282.516174301|ma la duo na;
马来西亚__馬來西亞 1394.19862478|ma lai xi ya;
马列主义__馬列主義 140.244908425|ma lie zhu yi;
马上就要__馬上就要 441.361118731|ma shang jiu yao;
马尔代夫__馬爾代夫 207.407719521|ma er dai fu;
马尔蒂尼__馬爾蒂尼 140.244908425|ma er di ni;
买卖合同__買賣合同 123.351140937|mai mai he tong;
买卖双方__買賣雙方 219.37092252|mai mai shuang fang;
麦克拉伦__麥克拉倫 106.748946222|mai ke la lun;
漫不经心__漫不經心 226.030964922|man bu jing xin;
满头大汗__滿頭大汗 128.369448119|man tou da han;
漫无目的__漫無目的 160.849404779|man wu mu di;
忙不过来__忙不過來 178.155043976|mang bu guo lai;
忙忙碌碌__忙忙碌碌 166.146325956|mang mang lu lu;
茫茫人海__茫茫人海 137.819369268|mang mang ren hai;
忙里偷闲__忙裡偷閒 125.209594649|mang li tou xian;
矛盾纠纷__矛盾糾紛 114.75018218|mao dun jiu fen;
毛骨悚然__毛骨悚然 168.859844103|mao gu song ran;
毛细血管__毛細血管 168.439513167|mao xi xue guan;
贸易壁垒__貿易壁壘 120.916041011|mao yi bi lei;
贸易摩擦__貿易摩擦 140.770195218|mao yi mo ca;
贸易逆差__貿易逆差 130.791560815|mao yi ni cha;
贸易公司__貿易公司 208.70407676|mao yi gong si;
贸易伙伴__貿易夥伴 146.132498493|mao yi huo ban;
贸易顺差__貿易順差 294.376422496|mao yi shun cha;
门当户对__門當戶對 125.992190229|men dang hu dui;
门户网站__門戶網站 936.87321059|men hu wang zhan;
梦寐以求__夢寐以求 274.533686805|meng mei yi qiu;
蒙特利尔__蒙特利爾 130.628674269|meng te li er;
蒙娜丽莎__蒙娜麗莎 114.893269147|meng na li sha;
梦幻西游__夢幻西遊 123.351140937|meng huan xi you;
梦想成真__夢想成真 109.034528882|meng xiang cheng zhen;
梦中情人__夢中情人 144.502706249|meng zhong qing ren;
煤炭行业__煤炭行業 112.765574943|mei tan hang ye;
煤炭企业__煤炭企業 118.529012887|mei tan qi ye;
煤炭资源__煤炭資源 126.464093517|mei tan zi yuan;
媒体报道__媒體報道 818.900002077|mei ti bao dao;
每天都要__每天都要 352.677286738|mei tian dou yao;
每天都有__每天都有 398.48814637|mei tian dou you;
每天晚上__每天晚上 466.237298568|mei tian wan shang;
每个人都__每個人都 1986.21549859|mei ge ren dou;
每股收益__每股收益 496.830647979|mei gu shou yi;
美国媒体__美國媒體 131.609045271|mei guo mei ti;
美国纽约__美國紐約 157.870654598|mei guo niu yue;
美国联邦__美國聯邦 159.85029497|mei guo lian bang;
美国公司__美國公司 133.093414711|mei guo gong si;
美国股市__美國股市 192.225730308|mei guo gu shi;
美国国会__美國國會 221.292902041|mei guo guo hui;
美国空军__美國空軍 108.627664361|mei guo kong jun;
美国海军__美國海軍 150.944778196|mei guo hai jun;
美国加州__美國加州 110.677283245|mei guo jia zhou;
美国经济__美國經濟 494.9767145|mei guo jing ji;
美国政府__美國政府 770.392265767|mei guo zheng fu;
美国著名__美國著名 170.977284899|mei guo zhu ming;
美国市场__美國市場 270.122027271|mei guo shi chang;
美国总统__美國總統 376.756940916|mei guo zong tong;
煤矿安全__煤礦安全 138.163289429|mei kuang an quan;
梅开二度__梅開二度 121.975425508|mei kai er du;
美好生活__美好生活 142.713135632|mei hao sheng huo;
美其名曰__美其名曰 142.180598718|mei qi ming yue;
没心没肺__沒心沒肺 177.933171406|mei xin mei fei;
美中不足__美中不足 120.314814642|mei zhong bu zu;
每时每刻__每時每刻 191.98633424|mei shi mei ke;
美术学院__美術學院 243.57916235|mei shu xue yuan;
没日没夜__沒日沒夜 107.952927857|mei ri mei ye;
美容美发__美容美髮 154.368879448|mei rong mei fa;
每一个人__每一個人 1123.81931445|mei yi ge ren;
没有办法__沒有辦法 1649.63204954|mei you ban fa;
没有必要__沒有必要 1170.99812122|mei you bi yao;
没有发现__沒有發現 565.579310193|mei you fa xian;
没有反应__沒有反應 176.168109435|mei you fan ying;
没有理由__沒有理由 410.586139672|mei you li you;
没有关系__沒有關係 722.953807881|mei you guan xi;
没有感觉__沒有感覺 194.393772779|mei you gan jue;
没有机会__沒有機會 453.063775264|mei you ji hui;
没有见过__沒有見過 393.553133755|mei you jian guo;
没有想到__沒有想到 1115.44785438|mei you xiang dao;
没有找到__沒有找到 684.380469812|mei you zhao dao;
没有什么__沒有什麼 4853.65697483|mei you shen me;
没有声音__沒有聲音 108.222318063|mei you sheng yin;
没有时间__沒有時間 732.019384688|mei you shi jian;
没有任何__沒有任何 3590.02852297|mei you ren he;
没有人会__沒有人會 350.92368248|mei you ren hui;
没有足够__沒有足夠 337.625607028|mei you zu gou;
没有意思__沒有意思 113.895394799|mei you yi si;
没有意义__沒有意義 324.02287532|mei you yi yi;
没有问题__沒有問題 1017.18567095|mei you wen ti;
没有安装__沒有安裝 249.415244207|mei you an zhuang;
密不可分__密不可分 213.438416689|mi bu ke fen;
密码保护__密碼保護 161.451865638|mi ma bao hu;
密密麻麻__密密麻麻 282.164331387|mi mi ma ma;
迷迷糊糊__迷迷糊糊 402.480675297|mi mi hu hu;
密切配合__密切配合 162.460985719|mi qie pei he;
密切联系__密切聯繫 155.915530766|mi qie lian xi;
密切关注__密切關注 399.980682268|mi qie guan zhu;
密切相关__密切相關 490.677728407|mi qie xiang guan;
面目全非__面目全非 197.568631008|mian mu quan fei;
免费电影__免費電影 195.365179853|mian fei dian ying;
免费提供__免費提供 347.442588754|mian fei ti gong;
免费下载__免費下載 366.111682898|mian fei xia zai;
免费注册__免費註冊 159.253810404|mian fei zhu ce;
免费使用__免費使用 134.092283643|mian fei shi yong;
免费赠送__免費贈送 143.605133321|mian fei zeng song;
面带微笑__面帶微笑 116.333988795|mian dai wei xiao;
面红耳赤__面紅耳赤 113.611883002|mian hong er chi;
面向对象__面向對象 290.730764849|mian xiang dui xiang;
面向全国__面向全國 174.42055653|mian xiang quan guo;
面向社会__面向社會 179.940013424|mian xiang she hui;
免责声明__免責聲明 236.696839161|mian ze sheng ming;
免疫功能__免疫功能 229.150692759|mian yi gong neng;
免疫系统__免疫系統 204.329220247|mian yi xi tong;
面无表情__面無表情 250.349428094|mian wu biao qing;
民办高校__民辦高校 115.467403456|min ban gao xiao;
民办教育__民辦教育 133.758497151|min ban jiao yu;
民办学校__民辦學校 200.29551561|min ban xue xiao;
民航总局__民航總局 165.73274959|min hang zong ju;
民间资本__民間資本 129.010924378|min jian zi ben;
民间组织__民間組織 206.376433771|min jian zu zhi;
民间艺术__民間藝術 122.432284019|min jian yi shu;
民政部门__民政部門 272.488653616|min zheng bu men;
民主党派__民主黨派 252.54282031|min zhu dang pai;
民主管理__民主管理 125.053659829|min zhu guan li;
民主监督__民主監督 130.303509496|min zhu jian du;
民主政治__民主政治 253.488718522|min zhu zheng zhi;
民主制度__民主制度 160.649084484|min zhu zhi du;
民生银行__民生銀行 374.883606282|min sheng yin hang;
民生问题__民生問題 177.269210225|min sheng wen ti;
民事责任__民事責任 134.42690308|min shi ze ren;
民事诉讼__民事訴訟 234.348853194|min shi su song;
民族品牌__民族品牌 142.713135632|min zu pin pai;
民族地区__民族地區 124.89791921|min zu di qu;
民族团结__民族團結 284.991389772|min zu tuan jie;
民族特色__民族特色 130.628674269|min zu te se;
民族精神__民族精神 231.158356006|min zu jing shen;
民族主义__民族主義 377.697115787|min zu zhu yi;
民族英雄__民族英雄 173.337150041|min zu ying xiong;
民族文化__民族文化 358.884197808|min zu wen hua;
民俗文化__民俗文化 106.748946222|min su wen hua;
民意调查__民意調查 154.754097942|min yi diao cha;
民营经济__民營經濟 334.69325133|min ying jing ji;
民营企业__民營企業 1208.05380881|min ying qi ye;
名牌大学__名牌大學 188.901181552|ming pai da xue;
名牌产品__名牌產品 196.096919422|ming pai chan pin;
明码标价__明碼標價 129.655606164|ming ma biao jia;
明明白白__明明白白 199.796934068|ming ming bai bai;
明明知道__明明知道 198.555903198|ming ming zhi dao;
明目张胆__明目張胆 232.603161479|ming mu zhang dan;
名副其实__名副其實 426.226434824|ming fu qi shi;
名列前茅__名列前茅 216.11485651|ming lie qian mao;
明确提出__明確提出 368.399985048|ming que ti chu;
明确规定__明確規定 590.057620516|ming que gui ding;
名正言顺__名正言順 180.389043185|ming zheng yan shun;
命中注定__命中注定 175.510734618|ming zhong zhu ding;
名胜古迹__名勝古迹 110.401782066|ming sheng gu ji;
明文规定__明文規定 160.649084484|ming wen gui ding;
莫名其妙__莫名其妙 1854.64242019|mo ming qi miao;
默默无闻__默默無聞 287.130256264|mo mo wu wen;
摩托罗拉__摩托羅拉 1105.75993438|mo tuo luo la;
摩根大通__摩根大通 111.091824605|mo gen da tong;
魔兽争霸__魔獸爭霸 234.348853194|mo shou zheng ba;
魔兽世界__魔獸世界 884.6784987|mo shou shi jie;
某种程度__某種程度 498.691525358|mou zhong cheng du;
目标管理__目標管理 164.498187167|mu biao guan li;
目标客户__目標客戶 149.261315371|mu biao ke hu;
目标市场__目標市場 111.507918629|mu biao shi chang;
目标任务__目標任務 275.905561849|mu biao ren wu;
目不转睛__目不轉睛 123.504952812|mu bu zhuan jing;
木马病毒__木馬病毒 109.989815613|mu ma bing du;
目瞪口呆__目瞪口呆 314.867617017|mu deng kou dai;
穆里尼奥__穆里尼奧 249.415244207|mu li ni ao;
穆罕默德__穆罕默德 117.646076559|mu han mo de;
募集资金__募集資金 427.290057918|mu ji zi jin;
目前国内__目前國內 714.000502259|mu qian guo nei;
目前市场__目前市場 631.130833438|mu qian shi chang;
穆沙拉夫__穆沙拉夫 161.653186955|mu sha la fu;
母乳喂养__母乳餵養 151.321452046|mu ru wei yang;
发表评论__發表評論 1173.92027842|fa biao ping lun;
发表论文__發表論文 190.081867665|fa biao lun wen;
发表声明__發表聲明 282.164331387|fa biao sheng ming;
发表言论__發表言論 2261.05695403|fa biao yan lun;
发表意见__發表意見 264.459727191|fa biao yi jian;
发表文章__發表文章 403.988165198|fa biao wen zhang;
发布广告__發布廣告 116.333988795|fa bu guang gao;
发布公告__發布公告 263.144763849|fa bu gong gao;
发布系统__發布系統 137.305093541|fa bu xi tong;
发布信息__發布信息 177.048440864|fa bu xin xi;
发布时间__發布時間 231.158356006|fa bu shi jian;
发布日期__發布日期 105.164499152|fa bu ri qi;
发明专利__發明專利 163.476413088|fa ming zhuan li;
发明创造__發明創造 106.218162376|fa ming chuang zao;
发达地区__發達地區 353.998238229|fa da di qu;
发达国家__發達國家 1641.42964497|fa da guo jia;
发电机组__發電機組 118.381397999|fa dian ji zu;
法定程序__法定程序 130.628674269|fa ding cheng xu;
法律保护__法律保護 253.173026121|fa lv bao hu;
法律法规__法律法規 1097.52300072|fa lv fa gui;
法律服务__法律服務 198.803491145|fa lv fu wu;
法律体系__法律體系 140.945727665|fa lv ti xi;
法律关系__法律關係 146.314717429|fa lv guan xi;
法律顾问__法律顧問 203.820597887|fa lv gu wen;
法律规范__法律規範 110.126966673|fa lv gui fan;
法律规定__法律規定 650.291796355|fa lv gui ding;
法律效力__法律效力 195.60878915|fa lv xiao li;
法律制度__法律制度 269.449631503|fa lv zhi du;
法律知识__法律知識 174.42055653|fa lv zhi shi;
法律程序__法律程序 144.502706249|fa lv cheng xu;
法律责任__法律責任 1753.50110433|fa lv ze ren;
法律咨询__法律諮詢 184.71110921|fa lv zi xun;
法律援助__法律援助 309.807805448|fa lv yuan zhu;
法律依据__法律依據 232.024158785|fa lv yi ju;
法律意识__法律意識 152.837570606|fa lv yi shi;
法律问题__法律問題 178.822323044|fa lv wen ti;
法律文书__法律文書 116.769717326|fa lv wen shu;
法兰克福__法蘭克福 311.744192349|fa lan ke fu;
法国巴黎__法國巴黎 124.122120652|fa guo ba li;
法国总统__法國總統 140.594881376|fa guo zong tong;
发挥作用__發揮作用 437.527796363|fa hui zuo yong;
发现自己__發現自己 1538.43695969|fa xian zi ji;
发现问题__發現問題 316.441045148|fa xian wen ti;
发行股票__發行股票 159.85029497|fa xing gu piao;
发行价格__發行價格 145.224802174|fa xing jia ge;
发展变化__發展變化 155.72135507|fa zhan bian hua;
发展模式__發展模式 323.619340361|fa zhan mo shi;
发展目标__發展目標 332.200082586|fa zhan mu biao;
发展方向__發展方向 749.558344131|fa zhan fang xiang;
发展道路__發展道路 258.916120291|fa zhan dao lu;
发展论坛__發展論壇 108.763116896|fa zhan lun tan;
发展历程__發展歷程 237.879639313|fa zhan li cheng;
发展历史__發展歷史 121.671800659|fa zhan li shi;
发展过程__發展過程 438.619621343|fa zhan guo cheng;
发展规律__發展規律 181.290467084|fa zhan gui lv;
发展规划__發展規劃 553.723632203|fa zhan gui hua;
发展空间__發展空間 550.970372621|fa zhan kong jian;
发展环境__發展環境 184.941433485|fa zhan huan jing;
发展计划__發展計劃 164.703307075|fa zhan ji hua;
发展机遇__發展機遇 280.062456643|fa zhan ji yu;
发展阶段__發展階段 390.621510938|fa zhan jie duan;
发展进程__發展進程 107.684208225|fa zhan jin cheng;
发展经济__發展經濟 256.987424161|fa zhan jing ji;
发展起来__發展起來 373.484720623|fa zhan qi lai;
发展潜力__發展潛力 341.008342538|fa zhan qian li;
发展前景__發展前景 575.5331706|fa zhan qian jing;
发展情况__發展情況 182.196395498|fa zhan qing kuang;
发展趋势__發展趨勢 977.421145723|fa zhan qu shi;
发展迅速__發展迅速 194.393772779|fa zhan xun su;
发展现状__發展現狀 195.852702213|fa zhan xian zhuang;
发展需要__發展需要 163.272821143|fa zhan xu yao;
发展壮大__發展壯大 381.481335404|fa zhan zhuang da;
发展状况__發展狀況 220.742053181|fa zhan zhuang kuang;
发展战略__發展戰略 781.025384985|fa zhan zhan lue;
发展中心__發展中心 123.658956482|fa zhan zhong xin;
发展成为__發展成為 388.195180646|fa zhan cheng wei;
发展水平__發展水平 220.742053181|fa zhan shui ping;
发展思路__發展思路 229.150692759|fa zhan si lu;
发展速度__發展速度 328.086003878|fa zhan su du;
法制建设__法制建設 159.055477247|fa zhi jian she;
法制教育__法制教育 110.264288753|fa zhi jiao yu;
发出通知__發出通知 171.403948695|fa chu tong zhi;
发生爆炸__發生爆炸 165.526347625|fa sheng bao zha;
发生变化__發生變化 649.481929235|fa sheng bian hua;
发生关系__發生關係 163.476413088|fa sheng guan xi;
发生火灾__發生火災 114.321989585|fa sheng huo zai;
发生重大__發生重大 189.136730609|fa sheng zhong da;
发生冲突__發生衝突 271.810366771|fa sheng chong tu;
发生什么__發生什麼 362.479927203|fa sheng shen me;
发生事故__發生事故 138.508067822|fa sheng shi gu;
发生意外__發生意外 131.445140637|fa sheng yi wai;
法人代表__法人代表 206.633773476|fa ren dai biao;
法人资格__法人資格 118.529012887|fa ren zi ge;
发自内心__發自內心 361.577631409|fa zi nei xin;
发送短信__發送短信 128.049907079|fa song duan xin;
发送邮件__發送郵件 121.217779906|fa song you jian;
法院判决__法院判決 171.190483873|fa yuan pan jue;
法院审理__法院審理 131.117943492|fa yuan shen li;
发扬光大__發揚光大 252.228305921|fa yang guang da;
反反复复__反反覆復 240.862563142|fan fan fu fu;
反复发作__反覆發作 131.281440129|fan fu fa zuo;
反腐倡廉__反腐倡廉 387.22887368|fan fu chang lian;
反对宪法__反對憲法 118.381397999|fan dui xian fa;
翻天覆地__翻天覆地 183.792676978|fan tian fu di;
翻来覆去__翻來覆去 212.641966978|fan lai fu qu;
反垄断法__反壟斷法 117.646076559|fan long duan fa;
反馈信息__反饋信息 122.279808036|fan kui xin xi;
番茄花园__番茄花園 178.377193209|fan qie hua yuan;
泛珠三角__泛珠三角 126.306596357|fan zhu san jiao;
犯罪分子__犯罪分子 348.743933702|fan zui fen zi;
犯罪行为__犯罪行為 221.292902041|fan zui xing wei;
犯罪案件__犯罪案件 121.066816454|fan zui an jian;
翻译公司__翻譯公司 177.933171406|fan yi gong si;
反应速度__反應速度 120.314814642|fan ying su du;
范围之内__範圍之內 295.111021611|fan wei zhi nei;
方便快捷__方便快捷 195.60878915|fang bian kuai jie;
防不胜防__防不勝防 125.36572391|fang bu sheng fang;
方法研究__方法研究 145.950506492|fang fa yan jiu;
防范措施__防範措施 137.819369268|fang fan cuo shi;
方方面面__方方面面 502.434215952|fang fang mian mian;
房地产商__房地產商 338.890182508|fang di chan shang;
房地产业__房地產業 715.782248677|fang di chan ye;
房价下跌__房價下跌 108.627664361|fang jia xia die;
方兴未艾__方興未艾 126.464093517|fang xing wei ai;
方针政策__方針政策 260.859291326|fang zhen zheng ce;
方正科技__方正科技 114.893269147|fang zheng ke ji;
纺织服装__紡織服裝 209.485777119|fang zhi fu zhuang;
防治工作__防治工作 194.636170786|fang zhi gong zuo;
房产中介__房產中介 120.314814642|fang chan zhong jie;
方式方法__方式方法 135.267109459|fang shi fang fa;
放在心上__放在心上 216.924313917|fang zai xin shang;
放在眼里__放在眼裡 165.939408926|fang zai yan li;
放在一起__放在一起 288.924902033|fang zai yi qi;
房屋拆迁__房屋拆遷 140.070248771|fang wu chai qian;
房屋租赁__房屋租賃 129.332863581|fang wu zu lin;
方案设计__方案設計 112.34478795|fang an she ji;
分辨率为__分辨率為 149.075426771|fen bian lv wei;
奋不顾身__奮不顧身 147.412812521|fen bu gu shen;
愤愤不平__憤憤不平 105.690017726|fen fen bu ping;
分道扬镳__分道揚鑣 117.93965545|fen dao yang biao;
奋斗目标__奮鬥目標 304.070513117|fen dou mu biao;
分类信息__分類信息 238.176261728|fen lei xin xi;
分期付款__分期付款 193.90988203|fen qi fu kuan;
分析报告__分析報告 221.292902041|fen xi bao gao;
分析方法__分析方法 223.231720645|fen xi fang fa;
分析研究__分析研究 150.381524744|fen xi yan jiu;
分析问题__分析問題 120.015323434|fen xi wen ti;
纷至沓来__紛至沓來 108.357265155|fen zhi ta lai;
分支机构__分支機構 493.129699012|fen zhi ji gou;
风平浪静__風平浪靜 149.447435764|feng ping lang jing;
凤毛麟角__鳳毛麟角 117.93965545|feng mao lin jiao;
风风火火__風風火火 131.937467932|feng feng huo huo;
风风雨雨__風風雨雨 209.746993999|feng feng yu yu;
丰富多彩__豐富多彩 609.488769235|feng fu duo cai;
风土人情__風土人情 139.026849285|feng tu ren qing;
逢年过节__逢年過節 117.499561272|feng nian guo jie;
风力发电__風力發電 122.737806611|feng li fa dian;
风口浪尖__風口浪尖 119.121315407|feng kou lang jian;
风花雪月__風花雪月 213.971039752|feng hua xue yue;
凤凰卫视__鳳凰衛視 394.043872187|feng huang wei shi;
封建迷信__封建迷信 169.492308033|feng jian mi xin;
封建社会__封建社會 247.866011137|feng jian she hui;
风起云涌__風起雲湧 166.768626413|feng qi yun yong;
风情万种__風情萬種 158.461958559|feng qing wan zhong;
风险投资__風險投資 617.901063897|feng xian tou zi;
风险管理__風險管理 372.091054935|feng xian guan li;
风险控制__風險控制 238.176261728|feng xian kong zhi;
奉献精神__奉獻精神 105.953760973|feng xian jing shen;
风吹草动__風吹草動 117.792774542|feng chui cao dong;
风云人物__風雲人物 172.905674062|feng yun ren wu;
沸沸扬扬__沸沸揚揚 344.424970321|fei fei yang yang;
非同寻常__非同尋常 106.616002115|fei tong xun chang;
非同一般__非同一般 122.432284019|fei tong yi ban;
飞来飞去__飛來飛去 168.020228531|fei lai fei qu;
非流通股__非流通股 258.916120291|fei liu tong gu;
非公有制__非公有制 423.578945935|fei gong you zhi;
非机动车__非機動車 160.249192015|fei ji dong che;
非洲国家__非洲國家 183.335174792|fei zhou guo jia;
非常不错__非常不錯 397.496217848|fei chang bu cuo;
非常漂亮__非常漂亮 218.008308584|fei chang piao liang;
非常方便__非常方便 248.794392378|fei chang fang bian;
非常感谢__非常感謝 845.867144221|fei chang gan xie;
非常喜欢__非常喜歡 662.561694208|fei chang xi huan;
非常重视__非常重視 402.982545867|fei chang zhong shi;
非常重要__非常重要 1561.61561744|fei chang zhong yao;
飞速发展__飛速發展 302.935867929|fei su fa zhan;
匪夷所思__匪夷所思 271.133768339|fei yi suo si;
佛罗伦萨__佛羅倫薩 207.666345181|fo luo lun sa;
腐败分子__腐敗分子 174.638049069|fu bai fen zi;
腐败现象__腐敗現象 164.703307075|fu bai xian xiang;
扶贫开发__扶貧開發 195.60878915|fu pin kai fa;
负面新闻__負面新聞 120.765453341|fu mian xin wen;
负面影响__負面影響 616.362966229|fu mian ying xiang;
复旦大学__復旦大學 515.113903202|fu dan da xue;
妇女儿童__婦女兒童 140.770195218|fu nv er tong;
弗朗西斯__弗朗西斯 130.303509496|fu lang xi si;
父老乡亲__父老鄉親 106.483223576|fu lao xiang qin;
福利待遇__福利待遇 151.699065864|fu li dai yu;
福利彩票__福利彩票 181.516526012|fu li cai piao;
弗洛伊德__弗洛伊德 154.754097942|fu luo yi de;
覆盖范围__覆蓋範圍 135.94305409|fu gai fan wei;
付款方式__付款方式 158.067510349|fu kuan fang shi;
符合条件__符合條件 448.56947196|fu he tiao jian;
符合国家__符合國家 244.796354228|fu he guo jia;
复合材料__複合材料 294.009808944|fu he cai liao;
弗吉尼亚__弗吉尼亞 117.792774542|fu ji ni ya;
夫妻关系__夫妻關係 111.369047744|fu qi guan xi;
夫妻之间__夫妻之間 129.171793682|fu qi zhi jian;
夫妻双方__夫妻雙方 161.049974862|fu qi shuang fang;
夫妻生活__夫妻生活 106.350610398|fu qi sheng huo;
服装设计__服裝設計 170.339279748|fu zhuang she ji;
扶持政策__扶持政策 158.067510349|fu chi zheng ce;
浮出水面__浮出水面 383.865702254|fu chu shui mian;
附属医院__附屬醫院 181.516526012|fu shu yi yuan;
芙蓉姐姐__芙蓉姐姐 525.487661863|fu rong jie jie;
负载均衡__負載均衡 124.122120652|fu zai jun heng;
服务平台__服務平台 249.415244207|fu wu ping tai;
服务贸易__服務貿易 147.964946673|fu wu mao yi;
服务对象__服務對象 920.669965262|fu wu dui xiang;
服务态度__服務態度 227.727332161|fu wu tai du;
服务体系__服務體系 452.499534015|fu wu ti xi;
服务内容__服務內容 134.930398555|fu wu nei rong;
服务理念__服務理念 120.916041011|fu wu li nian;
服务功能__服務功能 164.908682755|fu wu gong neng;
服务公司__服務公司 192.225730308|fu wu gong si;
服务行业__服務行業 231.158356006|fu wu hang ye;
服务机构__服務機構 366.568203397|fu wu ji gou;
服务器端__服務器端 366.111682898|fu wu qi duan;
服务器上__服務器上 515.113903202|fu wu qi shang;
服务项目__服務項目 241.463621556|fu wu xiang mu;
服务质量__服務質量 548.914415679|fu wu zhi liang;
服务中心__服務中心 972.56115063|fu wu zhong xin;
服务设施__服務設施 118.676811842|fu wu she shi;
服务水平__服務水平 314.083839199|fu wu shui ping;
服务热线__服務熱線 194.878871049|fu wu re xian;
服务人员__服務人員 263.801426189|fu wu ren yuan;
服务意识__服務意識 176.60772663|fu wu yi shi;
服务外包__服務外包 129.979154132|fu wu wai bao;
福尔摩斯__福爾摩斯 120.615053212|fu er mo si;
短篇小说__短篇小說 138.163289429|duan pian xiao shuo;
断断续续__斷斷續續 421.472799973|duan duan xu xu;
锻炼身体__鍛煉身體 288.924902033|duan lian shen ti;
断章取义__斷章取義 144.682892926|duan zhang qu yi;
短时间内__短時間內 782.974388071|duan shi jian nei;
大不相同__大不相同 142.357889859|da bu xiang tong;
大不一样__大不一樣 114.321989585|da bu yi yang;
大名鼎鼎__大名鼎鼎 247.249015706|da ming ding ding;
大法弟子__大法弟子 126.464093517|da fa di zi;
大幅增长__大幅增長 343.996026791|da fu zeng zhang;
大大提高__大大提高 562.76710106|da da ti gao;
大大咧咧__大大咧咧 161.250795044|da da lie lie;
大大小小__大大小小 540.767020614|da da xiao xiao;
大打折扣__大打折扣 274.533686805|da da zhe kou;
大打出手__大打出手 137.476305203|da da chu shou;
达到高潮__達到高潮 119.121315407|da dao gao chao;
大刀阔斧__大刀闊斧 109.579386421|da dao kuo fu;
大多数人__大多數人 1163.72451202|da duo shu ren;
大唐电信__大唐電信 120.765453341|da tang dian xin;
大庭广众__大庭廣眾 108.222318063|da ting guang zhong;
大同小异__大同小異 243.882891747|da tong xiao yi;
达赖喇嘛__達賴喇嘛 238.176261728|da lai la ma;
大力发展__大力發展 801.734213733|da li fa zhan;
大力推进__大力推進 374.883606282|da li tui jin;
大力开展__大力開展 169.492308033|da li kai zhan;
大力加强__大力加強 158.659551632|da li jia qiang;
大力支持__大力支持 761.800204777|da li zhi chi;
大连实德__大連實德 151.321452046|da lian shi de;
打个电话__打個電話 535.402718412|da ge dian hua;
大功告成__大功告成 124.587019602|da gong gao cheng;
打开电脑__打開電腦 223.788782324|da kai dian nao;
大开眼界__大開眼界 137.305093541|da kai yan jie;
打开网页__打開網頁 108.357265155|da kai wang ye;
大可不必__大可不必 199.548108896|da ke bu bi;
大话西游__大話西遊 255.073095111|da hua xi you;
大汗淋漓__大汗淋漓 178.59961945|da han lin li;
大红大紫__大紅大紫 122.890853693|da hong da zi;
打击报复__打擊報復 110.677283245|da ji bao fu;
答记者问__答記者問 114.46454262|da ji zhe wen;
大家分享__大家分享 544.825488702|da jia fen xiang;
大家都来__大家都來 203.313241605|da jia dou lai;
大家都是__大家都是 515.113903202|da jia dou shi;
大家看看__大家看看 348.309611377|da jia kan kan;
大家一起__大家一起 776.174076244|da jia yi qi;
大江南北__大江南北 188.196293023|da jiang nan bei;
大街小巷__大街小巷 289.645897197|da jie xiao xiang;
大惊小怪__大驚小怪 244.796354228|da jing xiao guai;
大起大落__大起大落 223.788782324|da qi da luo;
大气污染__大氣污染 109.034528882|da qi wu ran;
大千世界__大千世界 130.628674269|da qian shi jie;
打情骂俏__打情罵俏 106.616002115|da qing ma qiao;
大学本科__大學本科 191.747236314|da xue ben ke;
大学毕业__大學畢業 787.868200695|da xue bi ye;
大学同学__大學同學 230.582949765|da xue tong xue;
大学老师__大學老師 122.127521944|da xue lao shi;
大学教授__大學教授 248.484546245|da xue jiao shou;
大学教育__大學教育 132.431639237|da xue jiao yu;
大学校长__大學校長 158.659551632|da xue xiao zhang;
大学校园__大學校園 220.467143161|da xue xiao yuan;
大学生活__大學生活 328.495108513|da xue sheng huo;
大学时代__大學時代 109.579386421|da xue shi dai;
大学四年__大學四年 129.010924378|da xue si nian;
大学英语__大學英語 153.028150386|da xue ying yu;
大相径庭__大相徑庭 182.423584067|da xiang jing ting;
大型活动__大型活動 154.754097942|da xing huo dong;
大行其道__大行其道 184.481071779|da xing qi dao;
大型企业__大型企業 458.173712968|da xing qi ye;
大型超市__大型超市 106.616002115|da xing chao shi;
大专院校__大專院校 146.314717429|da zhuan yuan xiao;
大张旗鼓__大張旗鼓 211.584655172|da zhang qi gu;
打折机票__打折機票 152.837570606|da zhe ji piao;
大中华区__大中華區 191.98633424|da zhong hua qu;
大众汽车__大眾汽車 124.431860131|da zhong qi che;
大中城市__大中城市 290.0070692|da zhong cheng shi;
大肠杆菌__大腸桿菌 137.476305203|da chang gan jun;
达成协议__達成協議 339.31275934|da cheng xie yi;
大吃一惊__大吃一驚 313.302012384|da chi yi jing;
大势所趋__大勢所趨 198.308623594|da shi suo qu;
打扫卫生__打掃衛生 170.76435144|da sao wei sheng;
大言不惭__大言不慚 108.087539034|da yan bu can;
打印出来__打印出來 204.329220247|da yin chu lai;
大有可为__大有可為 111.925571131|da you ke wei;
大有人在__大有人在 178.822323044|da you ren zai;
打羽毛球__打羽毛球 140.945727665|da yu mao qiu;
达尔富尔__達爾富爾 136.112567367|da er fu er;
代表大会__代表大會 352.677286738|dai biao da hui;
代表人物__代表人物 277.630050085|dai biao ren wu;
代理公司__代理公司 139.72158175|dai li gong si;
代理机构__代理機構 144.502706249|dai li ji gou;
贷款利率__貸款利率 354.881620091|dai kuan li lv;
待机时间__待機時間 130.141230764|dai ji shi jian;
带薪休假__帶薪休假 121.823518492|dai xin xiu jia;
带着孩子__帶着孩子 140.770195218|dai zhe hai zi;
戴尔公司__戴爾公司 108.357265155|dai er gong si;
担保公司__擔保公司 111.646962678|dan bao gong si;
弹道导弹__彈道導彈 130.628674269|dan dao dao dan;
单机游戏__單機遊戲 128.529517539|dan ji you xi;
单向收费__單向收費 173.337150041|dan xiang shou fei;
胆战心惊__膽戰心驚 108.492380517|dan zhan xin jing;
单元测试__單元測試 113.611883002|dan yuan ce shi;
单位领导__單位領導 129.494134325|dan wei ling dao;
当代中国__當代中國 356.210827905|dang dai zhong guo;
当代艺术__當代藝術 211.584655172|dang dai yi shu;
当地政府__當地政府 560.667124391|dang di zheng fu;
当地时间__當地時間 301.054193591|dang di shi jian;
党内民主__黨內民主 135.098649108|dang nei min zhu;
党和国家__黨和國家 496.21189989|dang he guo jia;
党和政府__黨和政府 406.006938516|dang he zheng fu;
党和人民__黨和人民 227.443722742|dang he ren min;
当家作主__當家作主 122.279808036|dang jia zuo zhu;
党建工作__黨建工作 281.461959558|dang jian gong zuo;
当今中国__當今中國 132.431639237|dang jin zhong guo;
当今社会__當今社會 211.057972369|dang jin she hui;
当今世界__當今世界 311.744192349|dang jin shi jie;
荡气回肠__蕩氣迴腸 108.087539034|dang qi hui chang;
党政领导__黨政領導 144.863304286|dang zheng ling dao;
党政机关__黨政機關 238.473254015|dang zheng ji guan;
当之无愧__當之無愧 261.83633885|dang zhi wu kui;
荡然无存__蕩然無存 160.049619219|dang ran wu cun;
当仁不让__當仁不讓 149.075426771|dang ren bu rang;
党组书记__黨組書記 239.068350048|dang zu shu ji;
党员干部__黨員幹部 722.953807881|dang yuan gan bu;
党委书记__黨委書記 677.591550514|dang wei shu ji;
当务之急__當務之急 367.025293151|dang wu zhi ji;
档案管理__檔案管理 161.451865638|dang an guan li;
档案工作__檔案工作 116.624293448|dang an gong zuo;
道貌岸然__道貌岸然 136.112567367|dao mao an ran;
道德规范__道德規範 139.547573842|dao de gui fan;
道德教育__道德教育 124.122120652|dao de jiao yu;
到底是谁__到底是誰 202.554574186|dao di shi shui;
道听途说__道聽途說 213.704562287|dao ting tu shuo;
到哪里去__到哪裡去 512.55262135|dao na li qu;
道路交通__道路交通 175.073848088|dao lu jiao tong;
道路运输__道路運輸 122.279808036|dao lu yun shu;
导航系统__導航系統 120.765453341|dao hang xi tong;
到处都是__到處都是 582.750146437|dao chu dou shi;
倒数第二__倒數第二 120.164975734|dao shu di er;
的帮助下__的幫助下 458.173712968|de bang zhu xia;
得不偿失__得不償失 198.555903198|de bu chang shi;
得到什么__得到什麼 123.197520618|de dao shen me;
得天独厚__得天獨厚 278.669912425|de tian du hou;
德高望重__德高望重 107.818484324|de gao wang zhong;
的基础上__的基礎上 3773.51454358|de ji chu shang;
得心应手__得心應手 243.882891747|de xin ying shou;
得意洋洋__得意洋洋 118.676811842|de yi yang yang;
等等等等__等等等等 245.101601395|deng deng deng deng;
等离子体__等離子體 130.303509496|deng li zi ti;
灯红酒绿__燈紅酒綠 123.351140937|deng hong jiu lv;
等级考试__等級考試 119.56748386|deng ji kao shi;
登记机关__登記機關 109.170488754|deng ji ji guan;
登记结算__登記結算 110.264288753|deng ji jie suan;
登记注册__登記註冊 152.837570606|deng ji zhu ce;
登记手续__登記手續 153.028150386|deng ji shou xu;
等一系列__等一系列 660.089332023|deng yi xi lie;
地方特色__地方特色 141.826678552|di fang te se;
地方经济__地方經濟 111.091824605|di fang jing ji;
地方政府__地方政府 1569.41918253|di fang zheng fu;
地方财政__地方財政 155.333728851|di fang cai zheng;
地地道道__地地道道 116.769717326|di di dao dao;
地理环境__地理環境 127.73116145|di li huan jing;
地理位置__地理位置 555.105417084|di li wei zhi;
帝国主义__帝國主義 520.274927886|di guo zhu yi;
帝国时代__帝國時代 108.492380517|di guo shi dai;
抵制日货__抵制日貨 286.415523108|di zhi ri huo;
地质灾害__地質災害 318.022335873|di zhi zai hai;
第十八条__第十八條 148.704343794|di shi ba tiao;
第十六条__第十六條 160.049619219|di shi liu tiao;
第十九条__第十九條 148.334184528|di shi jiu tiao;
第十七条__第十七條 153.41002317|di shi qi tiao;
第十三条__第十三條 179.940013424|di shi san tiao;
第十四条__第十四條 183.563783354|di shi si tiao;
第十一条__第十一條 197.568631008|di shi yi tiao;
第十一届__第十一屆 150.569041974|di shi yi jie;
第十五条__第十五條 164.293322714|di shi wu tiao;
第十二条__第十二條 190.318888971|di shi er tiao;
第十二届__第十二屆 115.323601467|di shi er jie;
低收入者__低收入者 110.677283245|di shou ru zhe;
第三部分__第三部分 135.267109459|di san bu fen;
第三季度__第三季度 609.488769235|di san ji du;
第三阶段__第三階段 159.253810404|di san jie duan;
第三产业__第三產業 364.745529846|di san chan ye;
第三世界__第三世界 144.322743975|di san shi jie;
第四季度__第四季度 380.531740742|di si ji du;
抵押贷款__抵押貸款 284.636464248|di ya dai kuan;
第一部分__第一部分 293.277951001|di yi bu fen;
第一品牌__第一品牌 161.451865638|di yi pin pai;
第一美女__第一美女 111.369047744|di yi mei nv;
第一桶金__第一桶金 134.42690308|di yi tong jin;
第一个月__第一個月 170.339279748|di yi ge yue;
第一季度__第一季度 483.394725468|di yi ji du;
第一件事__第一件事 316.441045148|di yi jian shi;
第一阶段__第一階段 467.983588668|di yi jie duan;
第一句话__第一句話 298.811606079|di yi ju hua;
第一学期__第一學期 119.121315407|di yi xue qi;
第一时间__第一時間 1458.16935282|di yi shi jian;
第一要务__第一要務 147.964946673|di yi yao wu;
第一印象__第一印象 255.391156791|di yi yin xiang;
第二部分__第二部分 233.474375771|di er bu fen;
第二季度__第二季度 324.83145542|di er ji du;
第二阶段__第二階段 419.377126323|di er jie duan;
第二十条__第二十條 137.991222203|di er shi tiao;
第二十九__第二十九 140.244908425|di er shi jiu;
第二十七__第二十七 138.680779525|di er shi qi;
第二十四__第二十四 158.067510349|di er shi si;
第二十五__第二十五 154.176629937|di er shi wu;
点点滴滴__點點滴滴 506.83620443|dian dian di di;
电动汽车__電動汽車 192.225730308|dian dong qi che;
电脑屏幕__電腦屏幕 159.85029497|dian nao ping mu;
电脑公司__電腦公司 126.464093517|dian nao gong si;
电脑系统__電腦系統 105.953760973|dian nao xi tong;
电脑知识__電腦知識 111.786180106|dian nao zhi shi;
电脑游戏__電腦遊戲 142.180598718|dian nao you xi;
电力公司__電力公司 226.595011951|dian li gong si;
电力供应__電力供應 110.126966673|dian li gong ying;
电力行业__電力行業 159.055477247|dian li hang ye;
电力企业__電力企業 112.204874836|dian li qi ye;
电力系统__電力系統 206.376433771|dian li xi tong;
电话联系__電話聯繫 248.175085992|dian hua lian xi;
电话号码__電話號碼 834.351249399|dian hua hao ma;
点击图片__點擊圖片 124.276893895|dian ji tu pian;
点击进入__點擊進入 265.450260135|dian ji jin ru;
点击这里__點擊這裡 1238.54087357|dian ji zhe li;
点击查看__點擊查看 640.639682982|dian ji cha kan;
点击此处__點擊此處 157.67404401|dian ji ci chu;
电信公司__電信公司 172.04594156|dian xin gong si;
电信行业__電信行業 122.737806611|dian xin hang ye;
电信企业__電信企業 127.254530072|dian xin qi ye;
电信业务__電信業務 134.594525802|dian xin ye wu;
典型案例__典型案例 116.333988795|dian xing an li;
电视频道__電視頻道 109.989815613|dian shi pin dao;
电视媒体__電視媒體 131.281440129|dian shi mei ti;
电视广告__電視廣告 223.510077937|dian shi guang gao;
电视购物__電視購物 225.749468142|dian shi gou wu;
电视节目__電視節目 697.293562832|dian shi jie mu;
电热水器__電熱水器 117.499561272|dian re shui qi;
电子地图__電子地圖 213.438416689|dian zi di tu;
电子技术__電子技術 132.266710153|dian zi ji shu;
电子竞技__電子競技 244.186999878|dian zi jing ji;
电子信息__電子信息 226.877563077|dian zi xin xi;
电子信箱__電子信箱 143.605133321|dian zi xin xiang;
电子政务__電子政務 526.798985534|dian zi zheng wu;
电子支付__電子支付 116.18910757|dian zi zhi fu;
电子产品__電子產品 484.601008682|dian zi chan pin;
电子商务__電子商務 2018.65456559|dian zi shang wu;
电子设备__電子設備 181.742866823|dian zi she bei;
电子杂志__電子雜誌 266.112675706|dian zi za zhi;
电子邮件__電子郵件 1334.69654755|dian zi you jian;
电子游戏__電子遊戲 119.26985293|dian zi you xi;
电子邮箱__電子郵箱 203.566761683|dian zi you xiang;
电磁辐射__電磁輻射 159.85029497|dian ci fu she;
电源管理__電源管理 136.622376491|dian yuan guan li;
电影频道__電影頻道 110.95347192|dian ying pin dao;
电影免费__電影免費 118.972962872|dian ying mian fei;
电影公司__電影公司 215.30841961|dian ying gong si;
电影学院__電影學院 106.748946222|dian ying xue yuan;
电影下载__電影下載 105.0335283|dian ying xia zai;
调查报告__調查報告 498.070459751|diao cha bao gao;
调查工作__調查工作 127.413209251|diao cha gong zuo;
调查结果__調查結果 420.94790182|diao cha jie guo;
调查取证__調查取證 136.963309627|diao cha qu zheng;
调查显示__調查顯示 547.548041623|diao cha xian shi;
调查研究__調查研究 497.450167612|diao cha yan jiu;
调查问卷__調查問卷 154.561368684|diao cha wen juan;
调研报告__調研報告 152.077621994|diao yan bao gao;
掉以轻心__掉以輕心 142.180598718|diao yi qing xin;
跌宕起伏__跌宕起伏 152.457122789|die dang qi fu;
喋喋不休__喋喋不休 176.60772663|die die bu xiu;
跌跌撞撞__跌跌撞撞 142.891090816|die die zhuang zhuang;
顶顶顶顶__頂頂頂頂 2124.47360974|ding ding ding ding;
顶级域名__頂級域名 133.758497151|ding ji yu ming;
定期检查__定期檢查 108.087539034|ding qi jian cha;
定期存款__定期存款 114.75018218|ding qi cun kuan;
定向增发__定向增發 336.365750338|ding xiang zeng fa;
丢人现眼__丟人現眼 116.624293448|diu ren xian yan;
都不知道__都不知道 2350.1133092|dou bu zhi dao;
都是这样__都是這樣 626.429466854|dou shi zhe yang;
都有自己__都有自己 601.940653207|dou you zi ji;
东北大学__東北大學 109.034528882|dong bei da xue;
东北地区__東北地區 277.976239008|dong bei di qu;
东部地区__東部地區 199.548108896|dong bu di qu;
动脉硬化__動脈硬化 144.682892926|dong mai ying hua;
动漫产业__動漫產業 130.46599058|dong man chan ye;
东方不败__東方不敗 143.784200776|dong fang bu bai;
东方明珠__東方明珠 184.02185602|dong fang ming zhu;
东方神起__東方神起 171.403948695|dong fang shen qi;
东方卫视__東方衛視 204.584007193|dong fang wei shi;
东风日产__東風日產 195.121873946|dong feng ri chan;
懂得珍惜__懂得珍惜 151.699065864|dong de zhen xi;
东南大学__東南大學 147.964946673|dong nan da xue;
东南西北__東南西北 131.281440129|dong nan xi bei;
动感地带__動感地帶 334.69325133|dong gan di dai;
东张西望__東張西望 111.786180106|dong zhang xi wang;
冬虫夏草__冬蟲夏草 109.442917312|dong chong xia cao;
董事长兼__董事長兼 204.329220247|dong shi zhang jian;
动手能力__動手能力 126.149295342|dong shou neng li;
动员大会__動員大會 216.11485651|dong yuan da hui;
动物防疫__動物防疫 112.765574943|dong wu fang yi;
毒副作用__毒副作用 110.677283245|du fu zuo yong;
独立董事__獨立董事 278.322859608|du li dong shi;
独立显卡__獨立顯卡 249.415244207|du li xian ka;
独立自主__獨立自主 165.526347625|du li zi zhu;
独立思考__獨立思考 173.553291634|du li si kao;
都江堰市__都江堰市 113.046974828|du jiang yan shi;
独具特色__獨具特色 164.293322714|du ju te se;
独生子女__獨生子女 391.596284031|du sheng zi nv;
独树一帜__獨樹一幟 182.878811433|du shu yi zhi;
读研究生__讀研究生 142.003528374|du yan jiu sheng;
独一无二__獨一無二 569.823995046|du yi wu er;
咄咄逼人__咄咄逼人 173.337150041|duo duo bi ren;
多多少少__多多少少 237.287502254|duo duo shao shao;
多多益善__多多益善 113.753550575|duo duo yi shan;
多年以后__多年以後 154.561368684|duo nian yi hou;
多种方式__多種方式 207.925293333|duo zhong fang shi;
多种多样__多種多樣 287.488291405|duo zhong duo yang;
多种形式__多種形式 444.119751258|duo zhong xing shi;
多长时间__多長時間 708.681829926|duo chang shi jian;
多愁善感__多愁善感 230.870473623|duo chou shan gan;
多少时间__多少時間 248.175085992|duo shao shi jian;
多姿多彩__多姿多彩 182.423584067|duo zi duo cai;
多才多艺__多才多藝 136.452228303|duo cai duo yi;
对话框中__對話框中 273.850309404|dui hua kuang zhong;
对号入座__對號入座 153.218967809|dui hao ru zuo;
对症下药__對症下藥 136.963309627|dui zheng xia yao;
对冲基金__對沖基金 196.586267794|dui chong ji jin;
对策研究__對策研究 141.650048976|dui ce yan jiu;
对外贸易__對外貿易 405.501301397|dui wai mao yi;
对外投资__對外投資 130.303509496|dui wai tou zi;
对外开放__對外開放 703.402776999|dui wai kai fang;
对外宣传__對外宣傳 109.170488754|dui wai xuan chuan;
队伍建设__隊伍建設 379.111778956|dui wu jian she;
团队精神__團隊精神 196.586267794|tuan dui jing shen;
团结起来__團結起來 198.308623594|tuan jie qi lai;
团结一致__團結一致 117.353228453|tuan jie yi zhi;
吞吞吐吐__吞吞吐吐 106.218162376|tun tun tu tu;
踏踏实实__踏踏實實 335.528458728|ta ta shi shi;
太平天国__太平天國 144.322743975|tai ping tian guo;
台式电脑__台式電腦 122.127521944|tai shi dian nao;
台资企业__台資企業 107.550099352|tai zi qi ye;
台湾当局__台灣當局 243.275811214|tai wan dang ju;
台湾地区__台灣地區 369.779825848|tai wan di qu;
台湾同胞__台灣同胞 204.584007193|tai wan tong bao;
台湾海峡__台灣海峽 135.94305409|tai wan hai xia;
台湾问题__台灣問題 230.870473623|tai wan wen ti;
忐忑不安__忐忑不安 176.387781073|tan te bu an;
贪官污吏__貪官污吏 127.096048509|tan guan wu li;
昙花一现__曇花一現 167.393257695|tan hua yi xian;
谈情说爱__談情說愛 130.628674269|tan qing shuo ai;
弹出窗口__彈出窗口 125.835280772|tan chu chuang kou;
弹出一个__彈出一個 118.08671951|tan chu yi ge;
叹为观止__嘆為觀止 177.933171406|tan wei guan zhi;
贪污腐败__貪污腐敗 129.655606164|tan wu fu bai;
贪污受贿__貪污受賄 108.357265155|tan wu shou hui;
堂堂正正__堂堂正正 112.906187218|tang tang zheng zheng;
堂而皇之__堂而皇之 154.368879448|tang er huang zhi;
淘汰落后__淘汰落後 155.72135507|tao tai luo hou;
滔滔不绝__滔滔不絕 213.704562287|tao tao bu jue;
讨价还价__討價還價 374.41672986|tao jia huan jia;
讨人喜欢__討人喜歡 142.180598718|tao ren xi huan;
特别关注__特別關注 181.290467084|te bie guan zhu;
特别节目__特別節目 115.323601467|te bie jie mu;
特别注意__特別注意 384.823616623|te bie zhu yi;
特别是在__特別是在 895.772044085|te bie shi zai;
特立独行__特立獨行 169.915266157|te li du xing;
特价机票__特價機票 264.459727191|te jia ji piao;
特许经营__特許經營 229.150692759|te xu jing ying;
特种部队__特種部隊 232.024158785|te zhong bu dui;
特种设备__特種設備 136.963309627|te zhong she bei;
特殊情况__特殊情況 403.988165198|te shu qing kuang;
特殊要求__特殊要求 139.547573842|te shu yao qiu;
特色产业__特色產業 153.028150386|te se chan ye;
特异功能__特異功能 108.898738333|te yi gong neng;
腾讯公司__騰訊公司 139.895806636|teng xun gong si;
体力劳动__體力勞動 148.149450567|ti li lao dong;
提高警惕__提高警惕 126.779677253|ti gao jing ti;
提高企业__提高企業 186.097370046|ti gao qi ye;
提高学生__提高學生 162.663565352|ti gao xue sheng;
提高效率__提高效率 159.651218957|ti gao xiao lv;
提高自己__提高自己 282.868455943|ti gao zi ji;
提高自身__提高自身 129.655606164|ti gao zi shen;
提供免费__提供免費 259.562230298|ti gong mian fei;
提供服务__提供服務 434.268601197|ti gong fu wu;
提供担保__提供擔保 136.963309627|ti gong dan bao;
提供各种__提供各種 157.2815571|ti gong ge zhong;
提供支持__提供支持 107.416157498|ti gong zhi chi;
提交日期__提交日期 357.545014261|ti jiao ri qi;
提起公诉__提起公訴 106.616002115|ti qi gong su;
提起诉讼__提起訴訟 245.71323808|ti qi su song;
提前还贷__提前還貸 140.244908425|ti qian huan dai;
体系建设__體系建設 504.944935018|ti xi jian she;
体系结构__體系結構 255.709615075|ti xi jie gou;
提心吊胆__提心弔膽 232.893204426|ti xin diao dan;
体制改革__體制改革 707.799244422|ti zhi gai ge;
提出建议__提出建議 162.86639759|ti chu jian yi;
提出申请__提出申請 306.352568839|ti chu shen qing;
提出要求__提出要求 180.839193473|ti chu yao qiu;
提出问题__提出問題 125.36572391|ti chu wen ti;
提示信息__提示信息 153.601316766|ti shi xin xi;
体育频道__體育頻道 106.085879302|ti yu pin dao;
体育锻炼__體育鍛煉 195.121873946|ti yu duan lian;
体育活动__體育活動 196.831399718|ti yu huo dong;
体育中心__體育中心 223.231720645|ti yu zhong xin;
体育彩票__體育彩票 108.087539034|ti yu cai piao;
体育运动__體育運動 313.69268222|ti yu yun dong;
体育用品__體育用品 139.547573842|ti yu yong pin;
填报志愿__填報志願 151.510141313|tian bao zhi yuan;
天马行空__天馬行空 186.097370046|tian ma xing kong;
天翻地覆__天翻地覆 119.86585751|tian fan di fu;
天方夜谭__天方夜譚 106.085879302|tian fang ye tan;
天天向上__天天向上 125.36572391|tian tian xiang shang;
天南地北__天南地北 106.748946222|tian nan di bei;
天龙八部__天龍八部 383.387639617|tian long ba bu;
天花乱坠__天花亂墜 115.467403456|tian hua luan zhui;
天津大学__天津大學 119.26985293|tian jin da xue;
天经地义__天經地義 225.749468142|tian jing di yi;
天气预报__天氣預報 574.10053635|tian qi yu bao;
天下第一__天下第一 362.028498203|tian xia di yi;
天下无敌__天下無敵 121.671800659|tian xia wu di;
天下无贼__天下無賊 110.264288753|tian xia wu zei;
天长地久__天長地久 310.580912674|tian chang di jiu;
天上人间__天上人間 162.460985719|tian shang ren jian;
天生丽质__天生麗質 119.121315407|tian sheng li zhi;
天壤之别__天壤之別 168.020228531|tian rang zhi bie;
天人合一__天人合一 189.136730609|tian ren he yi;
天涯海角__天涯海角 215.040276584|tian ya hai jiao;
天涯社区__天涯社區 256.987424161|tian ya she qu;
天涯杂谈__天涯雜談 302.935867929|tian ya za tan;
甜言蜜语__甜言蜜語 280.761336094|tian yan mi yu;
天衣无缝__天衣無縫 134.930398555|tian yi wu feng;
天文学家__天文學家 147.412812521|tian wen xue jia;
天文数字__天文數字 118.824795093|tian wen shu zi;
条件反射__條件反射 148.334184528|tiao jian fan she;
铁路建设__鐵路建設 148.704343794|tie lu jian she;
铁路运输__鐵路運輸 188.901181552|tie lu yun shu;
听天由命__聽天由命 106.616002115|ting tian you ming;
停滞不前__停滯不前 124.276893895|ting zhi bu qian;
挺身而出__挺身而出 205.350275845|ting shen er chu;
头破血流__頭破血流 135.267109459|tou po xue liu;
头等大事__頭等大事 118.529012887|tou deng da shi;
偷偷摸摸__偷偷摸摸 212.907119447|tou tou mo mo;
偷工减料__偷工減料 136.112567367|tou gong jian liao;
投入使用__投入使用 363.837594448|tou ru shi yong;
投资风险__投資風險 213.172602547|tou zi feng xian;
投资理念__投資理念 165.939408926|tou zi li nian;
投资理财__投資理財 161.653186955|tou zi li cai;
投资管理__投資管理 179.268563673|tou zi guan li;
投资公司__投資公司 383.387639617|tou zi gong si;
投资规模__投資規模 148.704343794|tou zi gui mo;
投资环境__投資環境 425.165459331|tou zi huan jing;
投资回报__投資回報 196.831399718|tou zi hui bao;
投资决策__投資決策 108.627664361|tou zi jue ce;
投资集团__投資集團 111.786180106|tou zi ji tuan;
投资机构__投資機構 146.314717429|tou zi ji gou;
投资计划__投資計劃 124.122120652|tou zi ji hua;
投资机会__投資機會 303.313611771|tou zi ji hui;
投资基金__投資基金 248.484546245|tou zi ji jin;
投资价值__投資價值 446.895626023|tou zi jia zhi;
投资建议__投資建議 391.108593802|tou zi jian yi;
投资企业__投資企業 112.34478795|tou zi qi ye;
投资渠道__投資渠道 108.492380517|tou zi qu dao;
投资项目__投資項目 399.980682268|tou zi xiang mu;
投资主体__投資主體 111.786180106|tou zi zhu ti;
投资成本__投資成本 107.818484324|tou zi cheng ben;
投资收益__投資收益 400.978810625|tou zi shou yi;
投资总额__投資總額 139.373782642|tou zi zong e;
投资组合__投資組合 227.160466527|tou zi zu he;
投资策略__投資策略 239.068350048|tou zi ce lue;
投资银行__投資銀行 320.010065926|tou zi yin hang;
投诉电话__投訴電話 130.303509496|tou su dian hua;
同班同学__同班同學 173.337150041|tong ban tong xue;
通报批评__通報批評 117.499561272|tong bao pi ping;
同比增长__同比增長 989.677650042|tong bi zeng zhang;
同病相怜__同病相憐 112.906187218|tong bing xiang lian;
痛不欲生__痛不欲生 136.963309627|tong bu yu sheng;
同类产品__同類產品 347.442588754|tong lei chan pin;
通过学习__通過學習 123.967540162|tong guo xue xi;
通过手机__通過手機 149.075426771|tong guo shou ji;
通过网络__通過網絡 508.100984482|tong guo wang luo;
同归于尽__同歸於盡 127.73116145|tong gui yu jin;
痛哭流涕__痛哭流涕 106.218162376|tong ku liu ti;
童话故事__童話故事 125.678566729|tong hua gu shi;
通货膨胀__通貨膨脹 1059.88791463|tong huo peng zhang;
统计报告__統計報告 163.476413088|tong ji bao gao;
统计分析__統計分析 224.907079496|tong ji fen xi;
同济大学__同濟大學 269.114061535|tong ji da xue;
统计工作__統計工作 186.32942291|tong ji gong zuo;
统计数据__統計數據 553.034030141|tong ji shu ju;
统计数字__統計數字 177.048440864|tong ji shu zi;
统计资料__統計資料 147.964946673|tong ji zi liao;
同学聚会__同學聚會 153.218967809|tong xue ju hui;
通信行业__通信行業 133.758497151|tong xin hang ye;
痛心疾首__痛心疾首 123.813152185|tong xin ji shou;
通信技术__通信技術 145.950506492|tong xin ji shu;
通信系统__通信系統 114.321989585|tong xin xi tong;
通信设备__通信設備 153.601316766|tong xin she bei;
统治阶级__統治階級 158.067510349|tong zhi jie ji;
同时进行__同時進行 217.465635832|tong shi jin xing;
同时使用__同時使用 137.134095104|tong shi shi yong;
通俗易懂__通俗易懂 134.762357541|tong su yi dong;
统一管理__統一管理 256.347723437|tong yi guan li;
统一战线__統一戰線 210.270405333|tong yi zhan xian;
同一首歌__同一首歌 165.73274959|tong yi shou ge;
统一思想__統一思想 123.967540162|tong yi si xiang;
通用汽车__通用汽車 168.649547684|tong yong qi che;
土木工程__土木工程 118.381397999|tu mu gong cheng;
突发事件__突發事件 536.070335228|tu fa shi jian;
突飞猛进__突飛猛進 227.443722742|tu fei meng jin;
土地面积__土地面積 114.46454262|tu di mian ji;
土地利用__土地利用 282.164331387|tu di li yong;
土地管理__土地管理 121.975425508|tu di guan li;
土地供应__土地供應 173.769702743|tu di gong ying;
土地开发__土地開發 145.768741141|tu di kai fa;
土地承包__土地承包 168.859844103|tu di cheng bao;
土地储备__土地儲備 207.666345181|tu di chu bei;
土地出让__土地出讓 168.229740225|tu di chu rang;
土地市场__土地市場 116.624293448|tu di shi chang;
土地资源__土地資源 271.133768339|tu di zi yuan;
图像处理__圖像處理 155.527421199|tu xiang chu li;
图形界面__圖形界面 119.86585751|tu xing jie mian;
突出贡献__突出貢獻 240.562595233|tu chu gong xian;
突出重点__突出重點 133.758497151|tu chu zhong dian;
突出问题__突出問題 412.637883794|tu chu wen ti;
土生土长__土生土長 161.854759309|tu sheng tu zhang;
突然觉得__突然覺得 402.982545867|tu ran jue de;
突然想起__突然想起 454.194369369|tu ran xiang qi;
突然出现__突然出現 373.484720623|tu ran chu xian;
突如其来__突如其來 436.438689186|tu ru qi lai;
图文并茂__圖文並茂 165.526347625|tu wen bing mao;
脱贫致富__脫貧致富 120.916041011|tuo pin zhi fu;
脱胎换骨__脫胎換骨 167.184787749|tuo tai huan gu;
脱口而出__脫口而出 217.465635832|tuo kou er chu;
拓展训练__拓展訓練 115.323601467|tuo zhan xun lian;
妥善解决__妥善解決 147.780672558|tuo shan jie jue;
妥善处理__妥善處理 245.407229187|tuo shan chu li;
脱颖而出__脫穎而出 536.070335228|tuo ying er chu;
推波助澜__推波助瀾 197.076837307|tui bo zhu lan;
推动作用__推動作用 302.558594526|tui dong zuo yong;
推广应用__推廣應用 246.633556117|tui guang ying yong;
退耕还林__退耕還林 217.465635832|tui geng huan lin;
推荐使用__推薦使用 148.889769675|tui jian shi yong;
退休年龄__退休年齡 122.890853693|tui xiu nian ling;
退休人员__退休人員 227.160466527|tui xiu ren yuan;
推陈出新__推陳出新 130.791560815|tui chen chu xin;
退伍军人__退伍軍人 106.085879302|tui wu jun ren;
女大学生__女大學生 557.184562398|nv da xue sheng;
女性朋友__女性朋友 291.819695868|nv xing peng you;
女主人公__女主人公 165.939408926|nv zhu ren gong;
女生宿舍__女生宿舍 133.591915611|nv sheng su she;
纳米技术__納米技術 127.890434962|na mi ji shu;
那天晚上__那天晚上 455.327784806|na tian wan shang;
哪个地方__哪個地方 157.67404401|na ge di fang;
那个地方__那個地方 402.480675297|na ge di fang;
那个女孩__那個女孩 305.209408115|na ge nv hai;
那个女人__那個女人 399.482550191|na ge nv ren;
那个男人__那個男人 427.82286438|na ge nan ren;
哪个国家__哪個國家 193.90988203|na ge guo jia;
那个时候__那個時候 1540.35530331|na ge shi hou;
哪些方面__哪些方面 173.337150041|na xie fang mian;
哪些地方__哪些地方 105.558392399|na xie di fang;
那种感觉__那種感覺 395.027185582|na zhong gan jue;
纳税申报__納稅申報 108.763116896|na shui shen bao;
纳斯达克__納斯達克 423.578945935|na si da ke;
那一瞬间__那一瞬間 246.019628549|na yi shun jian;
耐人寻味__耐人尋味 214.2378495|nai ren xun wei;
南方周末__南方周末 246.633556117|nan fang zhou mo;
难得一见__難得一見 215.576896995|nan de yi jian;
男女朋友__男女朋友 129.494134325|nan nv peng you;
男女平等__男女平等 143.963491517|nan nv ping deng;
男女老少__男女老少 118.676811842|nan nv lao shao;
男女关系__男女關係 113.046974828|nan nv guan xi;
男女之间__男女之間 166.768626413|nan nv zhi jian;
男女主角__男女主角 179.940013424|nan nv zhu jue;
男男女女__男男女女 171.190483873|nan nan nv nv;
喃喃自语__喃喃自語 111.646962678|nan nan zi yu;
难能可贵__難能可貴 184.02185602|nan neng ke gui;
南开大学__南開大學 224.347234118|nan kai da xue;
南京大学__南京大學 264.459727191|nan jing da xue;
南京西路__南京西路 109.170488754|nan jing xi lu;
南水北调__南水北調 143.605133321|nan shui bei diao;
南斯拉夫__南斯拉夫 178.155043976|nan si la fu;
难以想象__難以想象 250.661599628|nan yi xiang xiang;
难以置信__難以置信 294.743493195|nan yi zhi xin;
难以忍受__難以忍受 150.944778196|nan yi ren shou;
难以忘怀__難以忘懷 130.791560815|nan yi wang huai;
恼羞成怒__惱羞成怒 161.049974862|nao xiu cheng nu;
能力建设__能力建設 179.940013424|neng li jian she;
能做什么__能做什麼 143.605133321|neng zuo shen me;
能源消耗__能源消耗 121.217779906|neng yuan xiao hao;
内部管理__內部管理 193.90988203|nei bu guan li;
内部控制__內部控制 162.056583012|nei bu kong zhi;
内部结构__內部結構 133.42554153|nei bu jie gou;
内部审计__內部審計 152.647228173|nei bu shen ji;
内心世界__內心世界 256.347723437|nei xin shi jie;
内容包括__內容包括 320.010065926|nei rong bao kuo;
尼日利亚__尼日利亞 321.609191441|ni ri li ya;
你死我活__你死我活 121.671800659|ni si wo huo;
年复一年__年復一年 112.065135969|nian fu yi nian;
年代以来__年代以來 128.850255419|nian dai yi lai;
年度报告__年度報告 149.075426771|nian du bao gao;
年度考核__年度考核 105.426930997|nian du kao he;
年度中国__年度中國 119.56748386|nian du zhong guo;
年度最佳__年度最佳 166.560934377|nian du zui jia;
念念不忘__念念不忘 254.121284766|nian nian bu wang;
年均增长__年均增長 165.32020271|nian jun zeng zhang;
年轻一代__年輕一代 172.04594156|nian qing yi dai;
年销售额__年銷售額 128.689786556|nian xiao shou e;
您还没有__您還沒有 291.819695868|nin hai mei you;
纽卡斯尔__紐卡斯爾 119.41857567|niu ka si er;
纽约时报__紐約時報 167.393257695|niu yue shi bao;
农贸市场__農貿市場 248.794392378|nong mao shi chang;
农民负担__農民負擔 112.625137786|nong min fu dan;
农民致富__農民致富 123.351140937|nong min zhi fu;
农民收入__農民收入 204.839111844|nong min shou ru;
农民增收__農民增收 438.619621343|nong min zeng shou;
农副产品__農副產品 254.755429543|nong fu chan pin;
农田水利__農田水利 138.680779525|nong tian shui li;
弄虚作假__弄虛作假 230.295783987|nong xu zuo jia;
农村发展__農村發展 139.026849285|nong cun fa zhan;
农村妇女__農村婦女 124.742372548|nong cun fu nv;
农村地区__農村地區 198.555903198|nong cun di qu;
农村改革__農村改革 134.259489114|nong cun gai ge;
农村工作__農村工作 176.60772663|nong cun gong zuo;
农村基层__農村基層 170.977284899|nong cun ji ceng;
农村教育__農村教育 129.655606164|nong cun jiao yu;
农村金融__農村金融 128.369448119|nong cun jin rong;
农村经济__農村經濟 308.651751439|nong cun jing ji;
农村居民__農村居民 222.953710017|nong cun ju min;
农村市场__農村市場 168.649547684|nong cun shi chang;
农村人口__農村人口 165.526347625|nong cun ren kou;
农药残留__農藥殘留 115.467403456|nong yao can liu;
农业保险__農業保險 115.467403456|nong ye bao xian;
农业部门__農業部門 151.510141313|nong ye bu men;
农业普查__農業普查 150.007190589|nong ye pu cha;
农业发展__農業發展 219.37092252|nong ye fa zhan;
农业大学__農業大學 145.587202159|nong ye da xue;
农业科技__農業科技 349.178797604|nong ye ke ji;
农业合作__農業合作 151.321452046|nong ye he zuo;
农业机械__農業機械 174.203334854|nong ye ji xie;
农业技术__農業技術 117.207077876|nong ye ji shu;
农业生产__農業生產 611.771607197|nong ye sheng chan;
农业银行__農業銀行 238.176261728|nong ye yin hang;
努力奋斗__努力奮鬥 189.608710238|nu li fen dou;
努力提高__努力提高 297.325836157|nu li ti gao;
努力工作__努力工作 285.346757867|nu li gong zuo;
努力学习__努力學習 246.019628549|nu li xue xi;
努力实现__努力實現 235.813600182|nu li shi xian;
诺贝尔奖__諾貝爾獎 268.444174826|nuo bei er jiang;
诺维茨基__諾維茨基 116.044406778|nuo wei ci ji;
乱七八糟__亂七八糟 1579.22849881|luan qi ba zao;
论坛会员__論壇會員 116.47905068|lun tan hui yuan;
伦理道德__倫理道德 128.689786556|lun li dao de;
屡见不鲜__屢見不鮮 183.792676978|lv jian bu xian;
履行职责__履行職責 232.313479749|lv xing zhi ze;
绿色通道__綠色通道 185.86560618|lv se tong dao;
绿色环保__綠色環保 161.854759309|lv se huan bao;
绿色食品__綠色食品 325.642053285|lv se shi pin;
旅游度假__旅遊度假 118.529012887|lv you du jia;
旅游开发__旅遊開發 118.824795093|lv you kai fa;
旅游景点__旅遊景點 350.486645516|lv you jing dian;
旅游景区__旅遊景區 174.203334854|lv you jing qu;
旅游线路__旅遊線路 173.553291634|lv you xian lu;
旅游项目__旅遊項目 116.18910757|lv you xiang mu;
旅游产品__旅遊產品 146.862738669|lv you chan pin;
旅游产业__旅遊產業 148.889769675|lv you chan ye;
旅游城市__旅遊城市 146.497163581|lv you cheng shi;
旅游胜地__旅遊勝地 129.655606164|lv you sheng di;
旅游市场__旅遊市場 189.845141544|lv you shi chang;
旅游资源__旅遊資源 338.468131949|lv you zi yuan;
蜡笔小新__蠟筆小新 158.857391092|la bi xiao xin;
拉丁美洲__拉丁美洲 130.141230764|la ding mei zhou;
垃圾处理__垃圾處理 148.889769675|la ji chu li;
垃圾邮件__垃圾郵件 418.854838101|la ji you jian;
来到这里__來到這裡 346.577724349|lai dao zhe li;
来电显示__來電顯示 112.484875527|lai dian xian shi;
来来回回__來來回回 128.529517539|lai lai hui hui;
来来往往__來來往往 187.727829225|lai lai wang wang;
来龙去脉__來龍去脈 188.430963124|lai long qu mai;
来之不易__來之不易 236.107646363|lai zhi bu yi;
来自北京__來自北京 261.184568064|lai zi bei jing;
来自中国__來自中國 316.046952528|lai zi zhong guo;
兰博基尼__蘭博基尼 110.539446825|lan bo ji ni;
蓝天白云__藍天白雲 153.218967809|lan tian bai yun;
蓝牙耳机__藍牙耳機 177.269210225|lan ya er ji;
滥用职权__濫用職權 137.647730357|lan yong zhi quan;
浪漫满屋__浪漫滿屋 122.584950132|lang man man wu;
浪漫主义__浪漫主義 189.845141544|lang man zhu yi;
浪费时间__浪費時間 495.593922384|lang fei shi jian;
浪迹天涯__浪跡天涯 111.925571131|lang ji tian ya;
老爸老妈__老爸老媽 232.603161479|lao ba lao ma;
劳动保障__勞動保障 745.831342837|lao dong bao zhang;
劳动报酬__勞動報酬 141.650048976|lao dong bao chou;
劳动部门__勞動部門 182.878811433|lao dong bu men;
劳动模范__勞動模範 116.769717326|lao dong mo fan;
劳动关系__勞動關係 392.573489614|lao dong guan xi;
劳动合同__勞動合同 1014.65366219|lao dong he tong;
劳动就业__勞動就業 133.758497151|lao dong jiu ye;
劳动争议__勞動爭議 187.027319083|lao dong zheng yi;
劳动人民__勞動人民 230.295783987|lao dong ren min;
老老实实__老老實實 605.702953498|lao lao shi shi;
牢固树立__牢固樹立 241.162905094|lao gu shu li;
劳斯莱斯__勞斯萊斯 148.704343794|lao si lai si;
劳逸结合__勞逸結合 112.484875527|lao yi jie he;
劳务派遣__勞務派遣 122.737806611|lao wu pai qian;
劳务输出__勞務輸出 269.785619908|lao wu shu chu;
乐在其中__樂在其中 109.170488754|le zai qi zhong;
乐此不疲__樂此不疲 223.231720645|le ci bu pi;
冷嘲热讽__冷嘲熱諷 121.520271774|leng chao re feng;
雷曼兄弟__雷曼兄弟 121.975425508|lei man xiong di;
泪流满面__淚流滿面 403.48504224|lei liu man mian;
雷克萨斯__雷克薩斯 127.413209251|lei ke sa si;
力不从心__力不從心 312.522131716|li bu cong xin;
理论体系__理論體系 264.789493468|li lun ti xi;
理论基础__理論基礎 241.162905094|li lun ji chu;
理论学习__理論學習 153.792848894|li lun xue xi;
理论知识__理論知識 213.172602547|li lun zhi shi;
理论创新__理論創新 116.47905068|li lun chuang xin;
理论研究__理論研究 331.37316028|li lun yan jiu;
历历在目__歷歷在目 177.490254874|li li zai mu;
立竿见影__立竿見影 147.596627936|li gan jian ying;
理工大学__理工大學 593.006203378|li gong da xue;
理工学院__理工學院 125.678566729|li gong xue yuan;
里克尔梅__里克爾梅 134.930398555|li ke er mei;
利害关系__利害關係 131.937467932|li hai guan xi;
离家出走__離家出走 249.104624871|li jia chu zou;
理想信念__理想信念 107.416157498|li xiang xin nian;
理想主义__理想主義 202.807148249|li xiang zhu yi;
理直气壮__理直氣壯 375.351064872|li zhi qi zhuang;
历史背景__歷史背景 141.650048976|li shi bei jing;
历史条件__歷史條件 132.596773978|li shi tiao jian;
历史记录__歷史記錄 186.794397067|li shi ji lu;
历史进程__歷史進程 139.547573842|li shi jin cheng;
历史经验__歷史經驗 110.539446825|li shi jing yan;
历史学家__歷史學家 227.443722742|li shi xue jia;
历史上最__歷史上最 551.657401419|li shi shang zui;
历史使命__歷史使命 171.190483873|li shi shi ming;
历史事件__歷史事件 153.41002317|li shi shi jian;
历史时期__歷史時期 202.302314677|li shi shi qi;
历史人物__歷史人物 170.977284899|li shi ren wu;
历史遗留__歷史遺留 113.32907693|li shi yi liu;
历史意义__歷史意義 140.070248771|li shi yi yi;
历史悠久__歷史悠久 288.924902033|li shi you jiu;
历史问题__歷史問題 125.522047856|li shi wen ti;
历史文化__歷史文化 439.166555128|li shi wen hua;
利润分配__利潤分配 105.426930997|li run fen pei;
利润增长__利潤增長 209.485777119|li run zeng zhang;
利润总额__利潤總額 153.218967809|li run zong e;
理财产品__理財產品 326.048110451|li cai chan pin;
理所当然__理所當然 665.872587905|li suo dang ran;
力所能及__力所能及 252.85772688|li suo neng ji;
利益分配__利益分配 106.218162376|li yi fen pei;
利益关系__利益關係 203.820597887|li yi guan xi;
利益集团__利益集團 308.267359529|li yi ji tuan;
利益冲突__利益衝突 129.979154132|li yi chong tu;
利用效率__利用效率 109.852835359|li yong xiao lv;
利用网络__利用網絡 131.937467932|li yong wang luo;
联邦政府__聯邦政府 171.831677206|lian bang zheng fu;
连带责任__連帶責任 173.986383704|lian dai ze ren;
恋恋不舍__戀戀不捨 125.678566729|lian lian bu she;
联合起来__聯合起來 254.438159592|lian he qi lai;
链接地址__鏈接地址 135.098649108|lian jie di zhi;
连接起来__連接起來 146.862738669|lian jie qi lai;
廉洁自律__廉潔自律 110.815291538|lian jie zi lv;
联系方式__聯繫方式 1295.36947746|lian xi fang shi;
联系电话__聯繫電話 934.541117987|lian xi dian hua;
联席会议__聯席會議 247.249015706|lian xi hui yi;
联系起来__聯繫起來 376.756940916|lian xi qi lai;
联想集团__聯想集團 179.71591787|lian xiang ji tuan;
廉政建设__廉政建設 118.23396695|lian zheng jian she;
连在一起__連在一起 215.30841961|lian zai yi qi;
廉租住房__廉租住房 377.226735448|lian zu zhu fang;
连锁反应__連鎖反應 111.369047744|lian suo fan ying;
连锁经营__連鎖經營 205.350275845|lian suo jing ying;
连锁企业__連鎖企業 113.611883002|lian suo qi ye;
疗法治疗__療法治療 106.616002115|liao fa zhi liao;
聊天记录__聊天記錄 449.128812644|liao tian ji lu;
寥寥无几__寥寥無幾 165.939408926|liao liao wu ji;
了解自己__了解自己 289.285174995|liao jie zi ji;
了解一下__了解一下 500.559372647|liao jie yi xia;
疗效观察__療效觀察 326.861744407|liao xiao guan cha;
了如指掌__了如指掌 166.353500999|liao ru zhi zhang;
量力而行__量力而行 117.499561272|liang li er xing;
两个方面__兩個方面 516.399339766|liang ge fang mian;
两个女人__兩個女人 174.42055653|liang ge nv ren;
两个男人__兩個男人 168.020228531|liang ge nan ren;
两个孩子__兩個孩子 332.200082586|liang ge hai zi;
良好形象__良好形象 139.200207879|liang hao xing xiang;
两极分化__兩極分化 161.854759309|liang ji fen hua;
良性循环__良性循環 192.465424888|liang xing xun huan;
量身定做__量身定做 190.318888971|liang shen ding zuo;
粮食生产__糧食生產 233.765505073|liang shi sheng chan;
粮食安全__糧食安全 130.791560815|liang shi an quan;
良莠不齐__良莠不齊 121.975425508|liang you bu qi;
两岸关系__兩岸關係 327.677408739|liang an guan xi;
两岸经贸__兩岸經貿 150.007190589|liang an jing mao;
烈士陵园__烈士陵園 117.646076559|lie shi ling yuan;
淋巴细胞__淋巴細胞 180.839193473|lin ba xi bao;
琳琅满目__琳琅滿目 176.827946446|lin lang man mu;
淋漓尽致__淋漓盡致 526.142915167|lin li jin zhi;
临床表现__臨床表現 233.474375771|lin chuang biao xian;
临床症状__臨床癥狀 130.791560815|lin chuang zheng zhuang;
临床试验__臨床試驗 160.049619219|lin chuang shi yan;
临床研究__臨床研究 292.183578474|lin chuang yan jiu;
临床医学__臨床醫學 106.483223576|lin chuang yi xue;
临床意义__臨床意義 161.451865638|lin chuang yi yi;
临床应用__臨床應用 288.205701591|lin chuang ying yong;
临时文件__臨時文件 139.547573842|lin shi wen jian;
另当别论__另當別論 124.89791921|ling dang bie lun;
领导班子__領導班子 675.063104121|ling dao ban zi;
领导干部__領導幹部 1546.12469848|ling dao gan bu;
领导集体__領導集體 123.658956482|ling dao ji ti;
领导小组__領導小組 1411.68136652|ling dao xiao zu;
领军人物__領軍人物 175.729586548|ling jun ren wu;
零售价格__零售價格 191.031727675|ling shou jia ge;
零售企业__零售企業 177.711575153|ling shou qi ye;
零售市场__零售市場 139.026849285|ling shou shi chang;
零售总额__零售總額 122.737806611|ling shou zong e;
令人满意__令人滿意 275.905561849|ling ren man yi;
令人发指__令人髮指 140.945727665|ling ren fa zhi;
令人担忧__令人擔憂 131.773154284|ling ren dan you;
令人感动__令人感動 116.044406778|ling ren gan dong;
令人羡慕__令人羨慕 108.898738333|ling ren xian mu;
令人信服__令人信服 111.230349808|ling ren xin fu;
令人震惊__令人震驚 116.915322539|ling ren zhen jing;
令人瞩目__令人矚目 107.818484324|ling ren zhu mu;
令人吃惊__令人吃驚 113.32907693|ling ren chi jing;
另一方面__另一方面 2619.22907324|ling yi fang mian;
另一个人__另一個人 395.519762073|ling yi ge ren;
流氓软件__流氓軟件 426.757915008|liu mang ruan jian;
六方会谈__六方會談 372.091054935|liu fang hui tan;
流动人口__流動人口 396.506758465|liu dong ren kou;
流动资金__流動資金 261.510250403|liu dong zi jin;
流通领域__流通領域 133.758497151|liu tong ling yu;
流通股东__流通股東 274.191785204|liu tong gu dong;
浏览网页__瀏覽網頁 170.339279748|liu lan wang ye;
流连忘返__流連忘返 109.716025699|liu lian wang fan;
流光飞舞__流光飛舞 158.067510349|liu guang fei wu;
留学人员__留學人員 200.04606951|liu xue ren yuan;
流行病学__流行病學 129.332863581|liu xing bing xue;
流行歌曲__流行歌曲 222.398727024|liu xing ge qu;
流行趋势__流行趨勢 157.870654598|liu xing qu shi;
流行音乐__流行音樂 366.568203397|liu xing yin yue;
六中全会__六中全會 204.839111844|liu zhong quan hui;
六十年代__六十年代 233.183609039|liu shi nian dai;
留守儿童__留守兒童 116.47905068|liu shou er tong;
垄断行业__壟斷行業 185.402943996|long duan hang ye;
龙头企业__龍頭企業 769.432826682|long tou qi ye;
隆重推出__隆重推出 133.758497151|long zhong tui chu;
隆重举行__隆重舉行 299.1842072|long zhong ju xing;
陆陆续续__陸陸續續 157.085680168|lu lu xu xu;
路公交车__路公交車 145.405889264|lu gong jiao che;
鲁迅先生__魯迅先生 202.302314677|lu xun xian sheng;
罗马帝国__羅馬帝國 136.622376491|luo ma di guo;
罗马尼亚__羅馬尼亞 297.696584607|luo ma ni ya;
落到实处__落到實處 344.424970321|luo dao shi chu;
罗纳尔多__羅納爾多 564.874943184|luo na er duo;
落井下石__落井下石 120.164975734|luo jing xia shi;
落实情况__落實情況 180.389043185|luo shi qing kuang;
络绎不绝__絡繹不絕 197.568631008|luo yi bu jue;
刮目相看__刮目相看 239.068350048|gua mu xiang kan;
冠冕堂皇__冠冕堂皇 182.196395498|guan mian tang huang;
官方论坛__官方論壇 105.690017726|guan fang lun tan;
官方网站__官方網站 1425.82527204|guan fang wang zhan;
灌篮高手__灌籃高手 106.350610398|guan lan gao shou;
管理办法__管理辦法 967.72532071|guan li ban fa;
管理部门__管理部門 1160.82773443|guan li bu men;
管理平台__管理平台 113.611883002|guan li ping tai;
管理模式__管理模式 533.404852483|guan li mo shi;
管理方法__管理方法 154.368879448|guan li fang fa;
管理方式__管理方式 236.696839161|guan li fang shi;
管理费用__管理費用 176.60772663|guan li fei yong;
管理服务__管理服務 153.218967809|guan li fu wu;
管理团队__管理團隊 260.209952636|guan li tuan dui;
管理体系__管理體系 342.285588041|guan li ti xi;
管理体制__管理體制 571.245957438|guan li ti zhi;
管理条例__管理條例 288.205701591|guan li tiao li;
管理能力__管理能力 245.101601395|guan li neng li;
管理理念__管理理念 169.28122395|guan li li nian;
管理功能__管理功能 150.381524744|guan li gong neng;
管理工具__管理工具 221.292902041|guan li gong ju;
管理工作__管理工作 1031.22508566|guan li gong zuo;
管理公司__管理公司 118.824795093|guan li gong si;
管理规定__管理規定 596.712660816|guan li gui ding;
管理机构__管理機構 438.073368704|guan li ji gou;
管理机制__管理機制 217.736803143|guan li ji zhi;
管理技术__管理技術 125.678566729|guan li ji shu;
管理经验__管理經驗 302.181790975|guan li jing yan;
管理权限__管理權限 124.276893895|guan li quan xian;
管理学院__管理學院 257.62872122|guan li xue yuan;
管理系统__管理系統 959.320404733|guan li xi tong;
管理制度__管理制度 729.287839744|guan li zhi du;
管理职能__管理職能 116.624293448|guan li zhi neng;
管理中心__管理中心 544.825488702|guan li zhong xin;
管理创新__管理創新 110.677283245|guan li chuang xin;
管理水平__管理水平 494.360275282|guan li shui ping;
管理软件__管理軟件 407.020105042|guan li ruan jian;
管理人才__管理人才 150.007190589|guan li ren cai;
管理人员__管理人員 1364.97342214|guan li ren yuan;
管理咨询__管理諮詢 148.704343794|guan li zi xun;
关联交易__關聯交易 305.209408115|guan lian jiao yi;
官僚主义__官僚主義 109.170488754|guan liao zhu yi;
灌灌水水__灌灌水水 361.577631409|guan guan shui shui;
冠军联赛__冠軍聯賽 125.522047856|guan jun lian sai;
关键环节__關鍵環節 174.203334854|guan jian huan jie;
关键技术__關鍵技術 375.819106356|guan jian ji shu;
关键时刻__關鍵時刻 632.705783453|guan jian shi ke;
关键时期__關鍵時期 219.097720093|guan jian shi qi;
关键在于__關鍵在於 546.185068786|guan jian zai yu;
关键因素__關鍵因素 219.644465616|guan jian yin su;
关键问题__關鍵問題 223.788782324|guan jian wen ti;
关节疼痛__關節疼痛 118.529012887|guan jie teng tong;
冠状动脉__冠狀動脈 164.088713397|guan zhuang dong mai;
贯彻落实__貫徹落實 1388.99614478|guan che luo shi;
贯彻执行__貫徹執行 252.54282031|guan che zhi xing;
贯彻实施__貫徹實施 147.045868173|guan che shi shi;
关于开展__關於開展 192.945711079|guan yu kai zhan;
关于加强__關於加強 331.37316028|guan yu jia qiang;
关于中国__關於中國 128.529517539|guan yu zhong guo;
关于做好__關於做好 110.95347192|guan yu zuo hao;
关于印发__關於印發 173.121277629|guan yu yin fa;
广播电台__廣播電台 204.584007193|guang bo dian tai;
广播电视__廣播電視 528.772109212|guang bo dian shi;
光明正大__光明正大 201.045721733|guang ming zheng da;
广发证券__廣發證券 173.337150041|guang fa zheng quan;
广泛开展__廣泛開展 221.017305999|guang fan kai zhan;
广泛应用__廣泛應用 513.191745392|guang fan ying yong;
广大党员__廣大黨員 209.224885556|guang da dang yuan;
广大客户__廣大客戶 194.151676652|guang da ke hu;
广大群众__廣大群眾 326.861744407|guang da qun zhong;
广大人民__廣大人民 226.877563077|guang da ren min;
光大银行__光大銀行 155.333728851|guang da yin hang;
广大用户__廣大用戶 228.8653107|guang da yong hu;
广电总局__廣電總局 302.558594526|guang dian zong ju;
光天化日__光天化日 132.431639237|guang tian hua ri;
广告投放__廣告投放 142.535402072|guang gao tou fang;
广告公司__廣告公司 523.526794166|guang gao gong si;
广告合作__廣告合作 151.699065864|guang gao he zuo;
广告宣传__廣告宣傳 246.94109417|guang gao xuan chuan;
广告收入__廣告收入 184.71110921|guang gao shou ru;
光合作用__光合作用 120.615053212|guang he zuo yong;
光学变焦__光學變焦 172.260473089|guang xue bian jiao;
广州本田__廣州本田 182.878811433|guang zhou ben tian;
广州车展__廣州車展 112.625137786|guang zhou che zhan;
广州日报__廣州日報 118.824795093|guang zhou ri bao;
改变自己__改變自己 421.472799973|gai bian zi ji;
改头换面__改頭換面 122.890853693|gai tou huan mian;
改革发展__改革發展 466.237298568|gai ge fa zhan;
改革方案__改革方案 190.081867665|gai ge fang an;
改革开放__改革開放 1906.19207626|gai ge kai fang;
改革创新__改革創新 219.097720093|gai ge chuang xin;
改革试点__改革試點 127.413209251|gai ge shi dian;
改善睡眠__改善睡眠 268.778909483|gai shan shui mian;
改造工程__改造工程 251.914183226|gai zao gong cheng;
该怎么办__該怎麼辦 847.977956119|gai zen me ban;
该怎么做__該怎麼做 193.186303435|gai zen me zuo;
干部队伍__幹部隊伍 206.376433771|gan bu dui wu;
干部群众__幹部群眾 407.527636023|gan bu qun zhong;
干部职工__幹部職工 488.846754671|gan bu zhi gong;
感同身受__感同身受 122.890853693|gan tong shen shou;
干干净净__乾乾淨淨 344.85444872|gan gan jing jing;
感慨万千__感慨萬千 118.972962872|gan kai wan qian;
感觉不到__感覺不到 348.743933702|gan jue bu dao;
感觉真好__感覺真好 106.350610398|gan jue zhen hao;
感激不尽__感激不盡 136.112567367|gan ji bu jin;
感情生活__感情生活 131.773154284|gan qing sheng huo;
钢铁行业__鋼鐵行業 187.961915178|gang tie hang ye;
钢铁企业__鋼鐵企業 226.312812713|gang tie qi ye;
刚刚开始__剛剛開始 441.911471008|gang gang kai shi;
钢材价格__鋼材價格 107.818484324|gang cai jia ge;
岗位职责__崗位職責 120.314814642|gang wei zhi ze;
高分辨率__高分辨率 188.901181552|gao fen bian lv;
高峰论坛__高峰論壇 210.008536601|gao feng lun tan;
高附加值__高附加值 168.439513167|gao fu jia zhi;
高端产品__高端產品 202.807148249|gao duan chan pin;
高等教育__高等教育 1166.62851836|gao deng jiao yu;
高等学校__高等學校 413.667597456|gao deng xue xiao;
高等数学__高等數學 105.690017726|gao deng shu xue;
高等院校__高等院校 329.725485744|gao deng yuan xiao;
高度评价__高度評價 344.424970321|gao du ping jia;
高度重视__高度重視 1461.808129|gao du zhong shi;
高楼大厦__高樓大廈 160.649084484|gao lou da sha;
高高兴兴__高高興興 194.636170786|gao gao xing xing;
高高在上__高高在上 293.277951001|gao gao zai shang;
高考成绩__高考成績 181.064689688|gao kao cheng ji;
高级官员__高級官員 154.368879448|gao ji guan yuan;
高级中学__高級中學 129.817279349|gao ji zhong xue;
高级人才__高級人才 113.753550575|gao ji ren cai;
高血压病__高血壓病 131.773154284|gao xue ya bing;
高校学生__高校學生 135.604660605|gao xiao xue sheng;
高校招生__高校招生 116.18910757|gao xiao zhao sheng;
高新技术__高新技術 611.771607197|gao xin ji shu;
高性价比__高性價比 256.028470459|gao xing jia bi;
高瞻远瞩__高瞻遠矚 122.127521944|gao zhan yuan zhu;
高职院校__高職院校 105.558392399|gao zhi yuan xiao;
高中毕业__高中畢業 300.679263607|gao zhong bi ye;
高中同学__高中同學 211.321149687|gao zhong tong xue;
高中阶段__高中階段 133.758497151|gao zhong jie duan;
高层领导__高層領導 140.945727665|gao ceng ling dao;
高层建筑__高層建築 153.41002317|gao ceng jian zhu;
高速发展__高速發展 474.442798491|gao su fa zhan;
告诉大家__告訴大家 649.481929235|gao su da jia;
高速铁路__高速鐵路 120.916041011|gao su tie lu;
高速公路__高速公路 1951.86385246|gao su gong lu;
告诉记者__告訴記者 3327.2428637|gao su ji zhe;
高速增长__高速增長 535.402718412|gao su zeng zhang;
告诉自己__告訴自己 405.501301397|gao su zi ji;
告一段落__告一段落 294.009808944|gao yi duan luo;
高尔夫球__高爾夫球 246.633556117|gao er fu qiu;
哥本哈根__哥本哈根 106.350610398|ge ben ha gen;
各不相同__各不相同 314.083839199|ge bu xiang tong;
各大城市__各大城市 132.762114633|ge da cheng shi;
哥伦比亚__哥倫比亞 366.568203397|ge lun bi ya;
格林斯潘__格林斯潘 157.870654598|ge lin si pan;
格鲁吉亚__格魯吉亞 228.011295226|ge lu ji ya;
格格不入__格格不入 213.971039752|ge ge bu ru;
各个方面__各個方面 555.797602048|ge ge fang mian;
各个国家__各個國家 130.46599058|ge ge guo jia;
各个环节__各個環節 294.743493195|ge ge huan jie;
各行各业__各行各業 343.139741671|ge hang ge ye;
各级党委__各級黨委 243.57916235|ge ji dang wei;
各级领导__各級領導 250.974160423|ge ji ling dao;
各级政府__各級政府 722.053448193|ge ji zheng fu;
各界人士__各界人士 270.796100963|ge jie ren shi;
各具特色__各具特色 155.527421199|ge ju te se;
各项工作__各項工作 922.967443217|ge xiang gong zuo;
各项指标__各項指標 148.889769675|ge xiang zhi biao;
个性签名__個性簽名 231.735198139|ge xing qian ming;
各种类型__各種類型 205.094534596|ge zhong lei xing;
各种各样__各種各樣 1333.03432936|ge zhong ge yang;
各种形式__各種形式 268.778909483|ge zhong xing shi;
各式各样__各式各樣 445.783200166|ge shi ge yang;
个人博客__個人博客 190.793818607|ge ren bo ke;
个人魅力__個人魅力 117.499561272|ge ren mei li;
个人档案__個人檔案 118.23396695|ge ren dang an;
个人电脑__個人電腦 274.876014738|ge ren dian nao;
个人能力__個人能力 159.055477247|ge ren neng li;
个人利益__個人利益 189.608710238|ge ren li yi;
个人观点__個人觀點 1363.27349742|ge ren guan dian;
个人空间__個人空間 651.914561431|ge ren kong jian;
个人简历__個人簡歷 180.389043185|ge ren jian li;
个人信息__個人信息 459.889800938|ge ren xin xi;
个人行为__個人行為 146.497163581|ge ren xing wei;
个人专辑__個人專輯 125.209594649|ge ren zhuan ji;
个人账户__個人賬戶 195.852702213|ge ren zhang hu;
个人主页__個人主頁 352.238065853|ge ren zhu ye;
个人主义__個人主義 128.529517539|ge ren zhu yi;
个人认为__個人認為 898.007390736|ge ren ren wei;
个人日记__個人日記 266.444503116|ge ren ri ji;
个人资料__個人資料 680.977550057|ge ren zi liao;
个人意见__個人意見 641.438524323|ge ren yi jian;
个人隐私__個人隱私 177.269210225|ge ren yin si;
个人用户__個人用戶 162.460985719|ge ren yong hu;
个人网站__個人網站 303.313611771|ge ren wang zhan;
各族人民__各族人民 145.768741141|ge zu ren min;
各有千秋__各有千秋 109.579386421|ge you qian qiu;
各位朋友__各位朋友 324.426913464|ge wei peng you;
各位领导__各位領導 133.42554153|ge wei ling dao;
根本利益__根本利益 333.029068427|gen ben li yi;
根本原因__根本原因 440.811451858|gen ben yuan yin;
根目录下__根目錄下 126.149295342|gen mu lu xia;
根据需要__根據需要 213.971039752|gen ju xu yao;
根深蒂固__根深蒂固 249.726250867|gen shen di gu;
更不用说__更不用說 336.365750338|geng bu yong shuo;
更多关于__更多關於 129.332863581|geng duo guan yu;
更多精彩__更多精彩 188.196293023|geng duo jing cai;
更多信息__更多信息 1087.99076217|geng duo xin xi;
耿耿于怀__耿耿於懷 225.187525865|geng geng yu huai;
更进一步__更進一步 353.117055307|geng jin yi bu;
更新换代__更新換代 199.299593609|geng xin huan dai;
购房合同__購房合同 105.558392399|gou fang he tong;
沟通能力__溝通能力 153.601316766|gou tong neng li;
构建和谐__構建和諧 718.463208478|gou jian he xie;
勾心斗角__勾心鬥角 139.72158175|gou xin dou jiao;
构成犯罪__構成犯罪 149.447435764|gou cheng fan zui;
构造函数__構造函數 155.527421199|gou zao han shu;
购物中心__購物中心 404.996293994|gou wu zhong xin;
功不可没__功不可沒 185.402943996|gong bu ke mo;
供不应求__供不應求 395.519762073|gong bu ying qiu;
公平公正__公平公正 124.742372548|gong ping gong zheng;
公平竞争__公平競爭 250.349428094|gong ping jing zheng;
公平正义__公平正義 157.2815571|gong ping zheng yi;
公民权利__公民權利 106.085879302|gong min quan li;
供大于求__供大於求 142.357889859|gong da yu qiu;
供电公司__供電公司 113.895394799|gong dian gong si;
共同发展__共同發展 300.679263607|gong tong fa zhan;
共同富裕__共同富裕 110.815291538|gong tong fu yu;
共同努力__共同努力 604.195219728|gong tong nu li;
共同语言__共同語言 178.822323044|gong tong yu yan;
功能模块__功能模塊 119.121315407|gong neng mo kuai;
功能强大__功能強大 320.409100324|gong neng qiang da;
功能障碍__功能障礙 152.647228173|gong neng zhang ai;
公立医院__公立醫院 139.72158175|gong li yi yuan;
公路建设__公路建設 170.977284899|gong lu jian she;
公共服务__公共服務 622.538424634|gong gong fu wu;
公共利益__公共利益 270.122027271|gong gong li yi;
公共管理__公共管理 126.779677253|gong gong guan li;
公共关系__公共關係 173.986383704|gong gong guan xi;
公共交通__公共交通 277.630050085|gong gong jiao tong;
公共汽车__公共汽車 451.373158744|gong gong qi che;
公共政策__公共政策 136.792736844|gong gong zheng ce;
公共产品__公共產品 153.028150386|gong gong chan pin;
公共场合__公共場合 145.405889264|gong gong chang he;
公共场所__公共場所 372.091054935|gong gong chang suo;
公共设施__公共設施 182.423584067|gong gong she shi;
公共事务__公共事務 113.753550575|gong gong shi wu;
公共财政__公共財政 209.746993999|gong gong cai zheng;
公共卫生__公共衛生 417.812212206|gong gong wei sheng;
公共安全__公共安全 186.097370046|gong gong an quan;
公开发行__公開發行 316.046952528|gong kai fa xing;
公开选拔__公開選拔 105.164499152|gong kai xuan ba;
公开招标__公開招標 157.870654598|gong kai zhao biao;
公开招聘__公開招聘 153.601316766|gong kai zhao pin;
公开场合__公開場合 159.452390871|gong kai chang he;
工会主席__工會主席 107.684208225|gong hui zhu xi;
工会组织__工會組織 155.915530766|gong hui zu zhi;
公交公司__公交公司 111.786180106|gong jiao gong si;
公交线路__公交線路 196.586267794|gong jiao xian lu;
宫颈糜烂__宮頸糜爛 202.050369328|gong jing mi lan;
工具软件__工具軟件 115.899886195|gong ju ruan jian;
供求发布__供求發布 127.096048509|gong qiu fa bu;
供求关系__供求關係 265.78126155|gong qiu guan xi;
供求信息__供求信息 245.71323808|gong qiu xin xi;
恭喜恭喜__恭喜恭喜 324.83145542|gong xi gong xi;
工薪阶层__工薪階層 171.190483873|gong xin jie ceng;
公职人员__公職人員 114.321989585|gong zhi ren yuan;
公众人物__公眾人物 160.849404779|gong zhong ren wu;
公众参与__公眾參與 115.323601467|gong zhong can yu;
共产党人__共產黨人 186.794397067|gong chan dang ren;
共产党员__共產黨員 587.123698784|gong chan dang yuan;
共产主义__共產主義 739.353626862|gong chan zhu yi;
功成名就__功成名就 109.716025699|gong cheng ming jiu;
工程公司__工程公司 120.765453341|gong cheng gong si;
工程机械__工程機械 241.463621556|gong cheng ji xie;
工程技术__工程技術 272.149298879|gong cheng ji shu;
工程监理__工程監理 121.975425508|gong cheng jian li;
工程建设__工程建設 854.342048866|gong cheng jian she;
工程学院__工程學院 185.86560618|gong cheng xue yuan;
工程项目__工程項目 410.07479966|gong cheng xiang mu;
工程质量__工程質量 221.017305999|gong cheng zhi liang;
工程设计__工程設計 205.350275845|gong cheng she ji;
工程施工__工程施工 249.415244207|gong cheng shi gong;
工程造价__工程造價 115.755545596|gong cheng zao jia;
工伤保险__工傷保險 242.972837869|gong shang bao xian;
工商部门__工商部門 377.697115787|gong shang bu men;
工商管理__工商管理 234.348853194|gong shang guan li;
工商银行__工商銀行 825.045864155|gong shang yin hang;
工人阶级__工人階級 243.57916235|gong ren jie ji;
工资待遇__工資待遇 134.762357541|gong zi dai yu;
工资收入__工資收入 146.314717429|gong zi shou ru;
工资水平__工資水平 153.41002317|gong zi shui ping;
工资总额__工資總額 121.217779906|gong zi zong e;
工作报告__工作報告 348.309611377|gong zuo bao gao;
工作部署__工作部署 117.646076559|gong zuo bu shu;
工作目标__工作目標 202.554574186|gong zuo mu biao;
工作方法__工作方法 133.259374649|gong zuo fang fa;
工作方式__工作方式 210.532600599|gong zuo fang shi;
工作方案__工作方案 168.649547684|gong zuo fang an;
工作单位__工作單位 245.71323808|gong zuo dan wei;
工作地点__工作地點 155.527421199|gong zuo di dian;
工作态度__工作態度 160.449013667|gong zuo tai du;
工作能力__工作能力 227.727332161|gong zuo neng li;
工作内容__工作內容 168.859844103|gong zuo nei rong;
工作力度__工作力度 195.365179853|gong zuo li du;
工作流程__工作流程 203.566761683|gong zuo liu cheng;
工作岗位__工作崗位 476.813641365|gong zuo gang wei;
工作环境__工作環境 388.195180646|gong zuo huan jing;
工作汇报__工作彙報 143.426288875|gong zuo hui bao;
工作会议__工作會議 763.701232553|gong zuo hui yi;
工作计划__工作計劃 288.205701591|gong zuo ji hua;
工作机会__工作機會 115.755545596|gong zuo ji hui;
工作机制__工作機制 265.119670945|gong zuo ji zhi;
工作经历__工作經歷 214.504991945|gong zuo jing li;
工作经验__工作經驗 884.6784987|gong zuo jing yan;
工作情况__工作情況 290.368691563|gong zuo qing kuang;
工作效率__工作效率 381.481335404|gong zuo xiao lv;
工作小组__工作小組 164.088713397|gong zuo xiao zu;
工作性质__工作性質 115.899886195|gong zuo xing zhi;
工作需要__工作需要 243.57916235|gong zuo xu yao;
工作状态__工作狀態 191.98633424|gong zuo zhuang tai;
工作制度__工作制度 119.41857567|gong zuo zhi du;
工作职责__工作職責 164.703307075|gong zuo zhi ze;
工作重点__工作重點 329.314848809|gong zuo zhong dian;
工作顺利__工作順利 172.690339006|gong zuo shun li;
工作时间__工作時間 558.574983827|gong zuo shi jian;
工作人员__工作人員 5622.52066996|gong zuo ren yuan;
工作任务__工作任務 337.205131359|gong zuo ren wu;
工作总结__工作總結 195.852702213|gong zuo zong jie;
工作作风__工作作風 228.8653107|gong zuo zuo feng;
工作思路__工作思路 202.050369328|gong zuo si lu;
工作原理__工作原理 256.347723437|gong zuo yuan li;
工作压力__工作壓力 245.101601395|gong zuo ya li;
工作安排__工作安排 167.184787749|gong zuo an pai;
公司名称__公司名稱 174.855812809|gong si ming cheng;
公司发展__公司發展 110.539446825|gong si fa zhan;
公司内部__公司內部 301.429591092|gong si nei bu;
公司简介__公司簡介 114.46454262|gong si jian jie;
公司经理__公司經理 108.898738333|gong si jing li;
公司债券__公司債券 106.085879302|gong si zhai quan;
公司章程__公司章程 213.172602547|gong si zhang cheng;
公司治理__公司治理 306.352568839|gong si zhi li;
公司注册__公司註冊 318.418891685|gong si zhu ce;
公司产品__公司產品 178.377193209|gong si chan pin;
公司成立__公司成立 207.149415951|gong si cheng li;
公司生产__公司生產 220.19257551|gong si sheng chan;
公司总部__公司總部 147.780672558|gong si zong bu;
公司总裁__公司總裁 177.048440864|gong si zong cai;
公司员工__公司員工 154.176629937|gong si yuan gong;
公司业绩__公司業績 220.742053181|gong si ye ji;
公司业务__公司業務 162.258658377|gong si ye wu;
公司网站__公司網站 156.499511818|gong si wang zhan;
公司网址__公司網址 188.196293023|gong si wang zhi;
公允价值__公允價值 129.494134325|gong yun jia zhi;
工业发展__工業發展 221.568841736|gong ye fa zhan;
工业大学__工業大學 404.491915522|gong ye da xue;
工业革命__工業革命 132.266710153|gong ye ge ming;
工业经济__工業經濟 258.593668656|gong ye jing ji;
工业企业__工業企業 480.991159713|gong ye qi ye;
工业项目__工業項目 130.303509496|gong ye xiang mu;
工业协会__工業協會 201.547419552|gong ye xie hui;
工业产品__工業產品 116.47905068|gong ye chan pin;
工业设计__工業設計 283.927938713|gong ye she ji;
工业生产__工業生產 200.545272755|gong ye sheng chan;
工业园区__工業園區 517.687984062|gong ye yuan qu;
工业用地__工業用地 123.197520618|gong ye yong di;
工艺美术__工藝美術 127.413209251|gong yi mei shu;
工艺流程__工藝流程 125.209594649|gong yi liu cheng;
公益广告__公益廣告 143.0692679|gong yi guang gao;
公益活动__公益活動 234.64107292|gong yi huo dong;
工艺技术__工藝技術 135.267109459|gong yi ji shu;
公益事业__公益事業 349.614203755|gong yi shi ye;
公用事业__公用事業 161.854759309|gong yong shi ye;
公务员法__公務員法 105.426930997|gong wu yuan fa;
公安部门__公安部門 403.48504224|gong an bu men;
公安民警__公安民警 114.179614083|gong an min jing;
公安分局__公安分局 349.178797604|gong an fen ju;
公安机关__公安機關 1515.60233678|gong an ji guan;
公安局长__公安局長 134.930398555|gong an ju zhang;
股票投资__股票投資 170.76435144|gu piao tou zi;
股票基金__股票基金 130.791560815|gu piao ji jin;
股票价格__股票價格 202.302314677|gu piao jia ge;
股票交易__股票交易 201.045721733|gu piao jiao yi;
股票市场__股票市場 559.968874971|gu piao shi chang;
顾名思义__顧名思義 209.224885556|gu ming si yi;
股份公司__股份公司 403.48504224|gu fen gong si;
古典音乐__古典音樂 219.644465616|gu dian yin yue;
固定不变__固定不變 298.439468992|gu ding bu bian;
固定电话__固定電話 312.522131716|gu ding dian hua;
固定利率__固定利率 124.122120652|gu ding li lv;
固定资产__固定資產 659.267263146|gu ding zi chan;
股东大会__股東大會 870.462027204|gu dong da hui;
鼓励学生__鼓勵學生 108.627664361|gu li xue sheng;
孤陋寡闻__孤陋寡聞 175.948711373|gu lou gua wen;
股改方案__股改方案 207.666345181|gu gai fang an;
骨干教师__骨幹教師 129.332863581|gu gan jiao shi;
骨干企业__骨幹企業 177.269210225|gu gan qi ye;
古今中外__古今中外 183.335174792|gu jin zhong wai;
股权分置__股權分置 211.321149687|gu quan fen zhi;
股权投资__股權投資 176.168109435|gu quan tou zi;
股权激励__股權激勵 204.584007193|gu quan ji li;
股权结构__股權結構 109.034528882|gu quan jie gou;
股权转让__股權轉讓 328.495108513|gu quan zhuan rang;
故障诊断__故障診斷 126.937764318|gu zhang zhen duan;
股指期货__股指期貨 1004.58849796|gu zhi qi huo;
骨质疏松__骨質疏鬆 137.819369268|gu zhi shu song;
故事情节__故事情節 307.500011268|gu shi qing jie;
古往今来__古往今來 113.47039186|gu wang jin lai;
国美电器__國美電器 163.680258901|guo mei dian qi;
过敏反应__過敏反應 132.10198647|guo min fan ying;
国民经济__國民經濟 1103.00744393|guo min jing ji;
国民政府__國民政府 211.848489234|guo min zheng fu;
国防部长__國防部長 269.114061535|guo fang bu zhang;
国泰君安__國泰君安 222.121753798|guo tai jun an;
国土资源__國土資源 317.626273928|guo tu zi yuan;
国内企业__國內企業 366.568203397|guo nei qi ye;
国内知名__國內知名 180.839193473|guo nei zhi ming;
国内著名__國內著名 125.36572391|guo nei zhu ming;
国内市场__國內市場 761.800204777|guo nei shi chang;
国内最大__國內最大 235.519920202|guo nei zui da;
国际标准__國際標準 415.734739962|guo ji biao zhun;
国际品牌__國際品牌 280.761336094|guo ji pin pai;
国际贸易__國際貿易 665.872587905|guo ji mao yi;
国际米兰__國際米蘭 504.944935018|guo ji mi lan;
国计民生__國計民生 120.314814642|guo ji min sheng;
国际惯例__國際慣例 194.393772779|guo ji guan li;
国际关系__國際關係 203.566761683|guo ji guan xi;
国际国内__國際國內 201.296414343|guo ji guo nei;
国际环境__國際環境 109.30661816|guo ji huan jing;
国际合作__國際合作 294.743493195|guo ji he zuo;
国际会议__國際會議 174.855812809|guo ji hui yi;
国际机票__國際機票 176.60772663|guo ji ji piao;
国际机场__國際機場 308.651751439|guo ji ji chang;
国际交流__國際交流 121.823518492|guo ji jiao liu;
国际金融__國際金融 222.67604562|guo ji jin rong;
国际经济__國際經濟 181.290467084|guo ji jing ji;
国际竞争__國際競爭 170.339279748|guo ji jing zheng;
国际象棋__國際象棋 151.888225993|guo ji xiang qi;
国际形势__國際形勢 107.818484324|guo ji xing shi;
国际政治__國際政治 126.621787068|guo ji zheng zhi;
国际知名__國際知名 223.788782324|guo ji zhi ming;
国际著名__國際著名 137.476305203|guo ji zhu ming;
国际社会__國際社會 692.962351041|guo ji she hui;
国际市场__國際市場 1220.1575309|guo ji shi chang;
国际事务__國際事務 106.616002115|guo ji shi wu;
国际收支__國際收支 125.835280772|guo ji shou zhi;
国际资本__國際資本 127.572086295|guo ji zi ben;
国际足联__國際足聯 270.122027271|guo ji zu lian;
国际组织__國際組織 239.366454718|guo ji zu zhi;
国际油价__國際油價 267.775955618|guo ji you jia;
国际域名__國際域名 241.764712994|guo ji yu ming;
国家标准__國家標準 575.5331706|guo jia biao zhun;
国家法律__國家法律 182.423584067|guo jia fa lv;
国家发展__國家發展 232.603161479|guo jia fa zhan;
国家地理__國家地理 110.815291538|guo jia di li;
国家统一__國家統一 167.184787749|guo jia tong yi;
国家利益__國家利益 362.479927203|guo jia li yi;
国家规定__國家規定 421.472799973|guo jia gui ding;
国家机关__國家機關 324.02287532|guo jia ji guan;
国家计委__國家計委 109.034528882|guo jia ji wei;
国家经济__國家經濟 193.186303435|guo jia jing ji;
国家权力__國家權力 128.689786556|guo jia quan li;
国家战略__國家戰略 105.953760973|guo jia zhan lue;
国家政权__國家政權 106.882056102|guo jia zheng quan;
国家政策__國家政策 266.444503116|guo jia zheng ce;
国家重点__國家重點 246.94109417|guo jia zhong dian;
国家财政__國家財政 135.604660605|guo jia cai zheng;
国家一级__國家一級 152.837570606|guo jia yi ji;
国家安全__國家安全 667.534233933|guo jia an quan;
国企改革__國企改革 180.839193473|guo qi gai ge;
国产品牌__國產品牌 195.121873946|guo chan pin pai;
国产手机__國產手機 313.302012384|guo chan shou ji;
过意不去__過意不去 151.132997772|guo yi bu qu;
国营企业__國營企業 107.14877401|guo ying qi ye;
国有土地__國有土地 109.989815613|guo you tu di;
国有经济__國有經濟 159.253810404|guo you jing ji;
国有企业__國有企業 1409.92327219|guo you qi ye;
国有资本__國有資本 160.849404779|guo you zi ben;
国有资产__國有資產 794.770968525|guo you zi chan;
国有银行__國有銀行 235.226605969|guo you yin hang;
规模最大__規模最大 528.113581536|gui mo zui da;
规模以上__規模以上 252.228305921|gui mo yi shang;
规范管理__規範管理 146.862738669|gui fan guan li;
轨道交通__軌道交通 358.437246895|gui dao jiao tong;
规格型号__規格型號 143.247667161|gui ge xing hao;
归根到底__歸根到底 143.784200776|gui gen dao di;
归根结底__歸根結底 196.586267794|gui gen jie di;
规划编制__規劃編製 114.46454262|gui hua bian zhi;
规划纲要__規劃綱要 130.141230764|gui hua gang yao;
规划建设__規劃建設 281.111429553|gui hua jian she;
规划设计__規劃設計 284.636464248|gui hua she ji;
规章制度__規章制度 499.935980841|gui zhang zhi du;
跨国公司__跨國公司 911.537100768|kua guo gong si;
跨国企业__跨國企業 182.878811433|kua guo qi ye;
宽带接入__寬帶接入 126.306596357|kuan dai jie ru;
宽带上网__寬帶上網 165.114314527|kuan dai shang wang;
狂风暴雨__狂風暴雨 121.975425508|kuang feng bao yu;
框架协议__框架協議 105.558392399|kuang jia xie yi;
矿产资源__礦產資源 478.003501869|kuang chan zi yuan;
困难群体__困難群體 186.794397067|kun nan qun ti;
困难群众__困難群眾 246.019628549|kun nan qun zhong;
困难重重__困難重重 116.915322539|kun nan chong chong;
快递公司__快遞公司 191.508436159|kuai di gong si;
快快乐乐__快快樂樂 150.381524744|kuai kuai le le;
会计报表__會計報表 107.550099352|kuai ji bao biao;
会计核算__會計核算 131.445140637|kuai ji he suan;
会计准则__會計準則 148.334184528|kuai ji zhun ze;
快捷方式__快捷方式 313.302012384|kuai jie fang shi;
脍炙人口__膾炙人口 147.229226029|kuai zhi ren kou;
快速发展__快速發展 1284.11889697|kuai su fa zhan;
快速反应__快速反應 153.984619852|kuai su fan ying;
快速增长__快速增長 843.76158662|kuai su zeng zhang;
卡巴斯基__卡巴斯基 1563.56286353|ka ba si ji;
卡纳瓦罗__卡納瓦羅 132.10198647|ka na wa luo;
卡斯特罗__卡斯特羅 138.163289429|ka si te luo;
开发利用__開發利用 448.010827873|kai fa li yong;
开发工具__開發工具 189.372573382|kai fa gong ju;
开发公司__開發公司 177.048440864|kai fa gong si;
开发过程__開發過程 128.850255419|kai fa guo cheng;
开发环境__開發環境 152.077621994|kai fa huan jing;
开发建设__開發建設 370.702589737|kai fa jian she;
开发企业__開發企業 132.762114633|kai fa qi ye;
开发项目__開發項目 213.704562287|kai fa xiang mu;
开发人员__開發人員 584.204365283|kai fa ren yuan;
凯迪拉克__凱迪拉克 159.651218957|kai di la ke;
开题报告__開題報告 109.579386421|kai ti bao gao;
开庭审理__開庭審理 206.119414554|kai ting shen li;
开拓创新__開拓創新 168.439513167|kai tuo chuang xin;
开拓市场__開拓市場 137.647730357|kai tuo shi chang;
开关电源__開關電源 113.47039186|kai guan dian yuan;
开工建设__開工建設 357.99085261|kai gong jian she;
开开心心__開開心心 344.424970321|kai kai xin xin;
开心就好__開心就好 119.41857567|kai xin jiu hao;
开展工作__開展工作 305.209408115|kai zhan gong zuo;
开展业务__開展業務 113.046974828|kai zhan ye wu;
开始实施__開始實施 236.991986692|kai shi shi shi;
开始使用__開始使用 139.547573842|kai shi shi yong;
开始菜单__開始菜單 148.519148841|kai shi cai dan;
开源软件__開源軟件 164.088713397|kai yuan ruan jian;
凯尔特人__凱爾特人 238.473254015|kai er te ren;
看不清楚__看不清楚 364.745529846|kan bu qing chu;
看不下去__看不下去 350.486645516|kan bu xia qu;
看不出来__看不出來 874.811821743|kan bu chu lai;
侃侃而谈__侃侃而談 116.769717326|kan kan er tan;
勘察设计__勘察設計 105.953760973|kan cha she ji;
抗美援朝__抗美援朝 117.353228453|kang mei yuan chao;
抗震救灾__抗震救災 481.590928402|kang zhen jiu zai;
抗日战争__抗日戰爭 379.111778956|kang ri zhan zheng;
考公务员__考公務員 116.18910757|kao gong wu yuan;
考古学家__考古學家 126.937764318|kao gu xue jia;
考上大学__考上大學 208.964318904|kao shang da xue;
考试大纲__考試大綱 151.699065864|kao shi da gang;
考试科目__考試科目 119.26985293|kao shi ke mu;
考试中心__考試中心 147.780672558|kao shi zhong xin;
考试成绩__考試成績 321.609191441|kao shi cheng ji;
考试试题__考試試題 117.646076559|kao shi shi ti;
考试时间__考試時間 162.663565352|kao shi shi jian;
可不可以__可不可以 1298.60199609|ke bu ke yi;
刻不容缓__刻不容緩 137.305093541|ke bu rong huan;
客服电话__客服電話 130.141230764|ke fu dian hua;
克服困难__克服困難 122.127521944|ke fu kun nan;
客服中心__客服中心 133.758497151|ke fu zhong xin;
客服人员__客服人員 125.053659829|ke fu ren yuan;
课堂教学__課堂教學 402.982545867|ke tang jiao xue;
科特布斯__科特布斯 105.295633316|ke te bu si;
科特迪瓦__科特迪瓦 113.753550575|ke te di wa;
课题研究__課題研究 170.76435144|ke ti yan jiu;
可能没有__可能沒有 121.823518492|ke neng mei you;
可能发生__可能發生 478.003501869|ke neng fa sheng;
可能成为__可能成為 523.526794166|ke neng cheng wei;
可能出现__可能出現 786.88699725|ke neng chu xian;
克拉玛依__克拉瑪依 119.716577729|ke la ma yi;
克莱斯勒__克萊斯勒 307.117053725|ke lai si le;
克雷斯波__克雷斯波 118.381397999|ke lei si bo;
克林斯曼__克林斯曼 148.889769675|ke lin si man;
克罗地亚__克羅地亞 212.907119447|ke luo di ya;
客观规律__客觀規律 139.547573842|ke guan gui lv;
客观存在__客觀存在 179.268563673|ke guan cun zai;
刻骨铭心__刻骨銘心 410.586139672|ke gu ming xin;
可可西里__可可西里 131.773154284|ke ke xi li;
可口可乐__可口可樂 554.41409416|ke kou ke le;
可扩展性__可擴展性 107.684208225|ke kuo zhan xing;
客户服务__客戶服務 445.783200166|ke hu fu wu;
客户提供__客戶提供 742.122873174|ke hu ti gong;
客户关系__客戶關係 111.369047744|ke hu guan xi;
客户经理__客戶經理 247.249015706|ke hu jing li;
客户需求__客戶需求 218.824857909|ke hu xu qiu;
客户资源__客戶資源 117.646076559|ke hu zi yuan;
客户要求__客戶要求 110.95347192|ke hu yao qiu;
科技发展__科技發展 356.655002599|ke ji fa zhan;
科技大学__科技大學 202.554574186|ke ji da xue;
科技工作__科技工作 114.321989585|ke ji gong zuo;
科技公司__科技公司 188.430963124|ke ji gong si;
科技含量__科技含量 261.510250403|ke ji han liang;
科技合作__科技合作 118.529012887|ke ji he zuo;
科技进步__科技進步 420.423657369|ke ji jin bu;
科技创新__科技創新 626.429466854|ke ji chuang xin;
科技成果__科技成果 355.767206381|ke ji cheng guo;
科技人才__科技人才 107.952927857|ke ji ren cai;
科技人员__科技人員 243.882891747|ke ji ren yuan;
科技园区__科技園區 139.373782642|ke ji yuan qu;
可见一斑__可見一斑 265.78126155|ke jian yi ban;
可圈可点__可圈可點 152.077621994|ke quan ke dian;
科学发展__科學發展 640.639682982|ke xue fa zhan;
科学管理__科學管理 133.42554153|ke xue guan li;
科学技术__科學技術 946.259922413|ke xue ji shu;
科学精神__科學精神 112.484875527|ke xue jing shen;
科学知识__科學知識 156.304608838|ke xue zhi shi;
科学研究__科學研究 553.723632203|ke xue yan jiu;
科学依据__科學依據 138.163289429|ke xue yi ju;
可想而知__可想而知 542.792461517|ke xiang er zhi;
课程改革__課程改革 201.547419552|ke cheng gai ge;
课程设计__課程設計 122.890853693|ke cheng she ji;
课程设置__課程設置 118.676811842|ke cheng she zhi;
可持续性__可持續性 134.259489114|ke chi xu xing;
可操作性__可操作性 271.471856767|ke cao zuo xing;
客运专线__客運專線 109.852835359|ke yun zhuan xian;
科研单位__科研單位 129.171793682|ke yan dan wei;
科研工作__科研工作 169.492308033|ke yan gong zuo;
科研机构__科研機構 252.85772688|ke yan ji gou;
科研项目__科研項目 185.86560618|ke yan xiang mu;
科研成果__科研成果 290.0070692|ke yan cheng guo;
科研人员__科研人員 263.144763849|ke yan ren yuan;
科研院所__科研院所 213.971039752|ke yan yuan suo;
可以帮助__可以幫助 611.771607197|ke yi bang zhu;
可以买到__可以買到 326.861744407|ke yi mai dao;
可以满足__可以滿足 363.384474622|ke yi man zu;
可以分为__可以分為 280.062456643|ke yi fen wei;
可以达到__可以達到 547.548041623|ke yi da dao;
可以得到__可以得到 762.750126416|ke yi de dao;
可以提供__可以提供 402.982545867|ke yi ti gong;
可以通过__可以通過 2952.08591378|ke yi tong guo;
可以理解__可以理解 817.880151926|ke yi li jie;
可以利用__可以利用 574.81640715|ke yi li yong;
可以根据__可以根據 881.377303227|ke yi gen ju;
可以看到__可以看到 2448.77288933|ke yi kan dao;
可以看见__可以看見 302.181790975|ke yi kan jian;
可以看出__可以看出 1532.69625148|ke yi kan chu;
可以考虑__可以考慮 839.566182019|ke yi kao lv;
可以获得__可以獲得 580.575602636|ke yi huo de;
可以接受__可以接受 474.442798491|ke yi jie shou;
可以选择__可以選擇 1459.98760728|ke yi xuan ze;
可以下载__可以下載 351.361264404|ke yi xia zai;
可以显示__可以顯示 117.061109314|ke yi xian shi;
可以享受__可以享受 383.387639617|ke yi xiang shou;
可以找到__可以找到 572.671468255|ke yi zhao dao;
可以直接__可以直接 1316.52557925|ke yi zhi jie;
可以查看__可以查看 156.499511818|ke yi cha kan;
可以上网__可以上網 263.472890441|ke yi shang wang;
可以申请__可以申請 260.209952636|ke yi shen qing;
可以实现__可以實現 670.034480971|ke yi shi xian;
可以使用__可以使用 1458.16935282|ke yi shi yong;
可以说是__可以說是 1932.50174796|ke yi shuo shi;
可以增加__可以增加 234.056997396|ke yi zeng jia;
可以作为__可以作為 409.054029297|ke yi zuo wei;
可以采用__可以採用 259.885889675|ke yi cai yong;
可以随时__可以隨時 496.21189989|ke yi sui shi;
可以用来__可以用來 412.637883794|ke yi yong lai;
可以用于__可以用於 153.41002317|ke yi yong yu;
可有可无__可有可無 177.490254874|ke you ke wu;
口口声声__口口聲聲 268.444174826|kou kou sheng sheng;
口腔溃疡__口腔潰瘍 162.056583012|kou qiang kui yang;
恐怖分子__恐怖分子 492.515560049|kong bu fen zi;
恐怖袭击__恐怖襲擊 257.3078729|kong bu xi ji;
恐怖主义__恐怖主義 333.444336783|kong bu zhu yi;
恐怖组织__恐怖組織 126.621787068|kong bu zu zhi;
空调维修__空調維修 122.279808036|kong tiao wei xiu;
控股公司__控股公司 193.668388536|kong gu gong si;
控股股东__控股股東 450.811022973|kong gu gu dong;
控股集团__控股集團 114.179614083|kong gu ji tuan;
空气质量__空氣質量 245.101601395|kong qi zhi liang;
空气污染__空氣污染 142.713135632|kong qi wu ran;
空穴来风__空穴來風 120.46484039|kong xue lai feng;
控制面板__控制面板 546.866130582|kong zhi mian ban;
控制技术__控制技術 131.281440129|kong zhi ji shu;
控制系统__控制系統 636.660374558|kong zhi xi tong;
控制中心__控制中心 147.229226029|kong zhi zhong xin;
孔子学院__孔子學院 106.350610398|kong zi xue yuan;
空无一人__空無一人 113.187937993|kong wu yi ren;
苦不堪言__苦不堪言 118.824795093|ku bu kan yan;
苦口婆心__苦口婆心 112.906187218|ku kou po xin;
哭笑不得__哭笑不得 291.093289619|ku xiao bu de;
扩大内需__擴大內需 119.716577729|kuo da nei xu;
扩大会议__擴大會議 115.611384758|kuo da hui yi;
扩建工程__擴建工程 111.786180106|kuo jian gong cheng;
华北地区__華北地區 113.611883002|hua bei di qu;
华东地区__華東地區 146.679837233|hua dong di qu;
花多少钱__花多少錢 108.087539034|hua duo shao qian;
华南地区__華南地區 124.587019602|hua nan di qu;
化工产品__化工產品 113.753550575|hua gong chan pin;
花花绿绿__花花綠綠 133.925286409|hua hua lv lv;
花花公子__花花公子 225.468321935|hua hua gong zi;
花花草草__花花草草 115.611384758|hua hua cao cao;
花旗银行__花旗銀行 135.267109459|hua qi yin hang;
华侨华人__華僑華人 152.267254161|hua qiao hua ren;
化学反应__化學反應 181.290467084|hua xue fan ying;
化学成分__化學成分 182.878811433|hua xue cheng fen;
化学物质__化學物質 211.848489234|hua xue wu zhi;
华夏银行__華夏銀行 140.244908425|hua xia yin hang;
哗众取宠__嘩眾取寵 215.30841961|hua zhong qu chong;
花言巧语__花言巧語 116.47905068|hua yan qiao yu;
花样年华__花樣年華 125.835280772|hua yang nian hua;
环保部门__環保部門 258.916120291|huan bao bu men;
环保总局__環保總局 132.431639237|huan bao zong ju;
环保意识__環保意識 118.23396695|huan bao yi shi;
患得患失__患得患失 140.070248771|huan de huan shi;
欢天喜地__歡天喜地 113.611883002|huan tian xi di;
换届选举__換屆選舉 231.735198139|huan jie xuan ju;
缓解压力__緩解壓力 203.313241605|huan jie ya li;
环境保护__環境保護 1156.49608257|huan jing bao hu;
环境变量__環境變量 139.373782642|huan jing bian liang;
环境条件__環境條件 115.755545596|huan jing tiao jian;
环境监测__環境監測 136.792736844|huan jing jian ce;
环境质量__環境質量 177.269210225|huan jing zhi liang;
环境因素__環境因素 116.044406778|huan jing yin su;
环境影响__環境影響 148.704343794|huan jing ying xiang;
环境优美__環境優美 106.748946222|huan jing you mei;
环境友好__環境友好 155.72135507|huan jing you hao;
环境问题__環境問題 228.8653107|huan jing wen ti;
环境卫生__環境衛生 268.109857044|huan jing wei sheng;
环境污染__環境污染 462.764242999|huan jing wu ran;
换句话说__換句話說 360.228397261|huan ju hua shuo;
环球时报__環球時報 110.539446825|huan qiu shi bao;
欢声笑语__歡聲笑語 115.036534536|huan sheng xiao yu;
焕然一新__煥然一新 143.784200776|huan ran yi xin;
欢迎访问__歡迎訪問 387.711726118|huan ying fang wen;
欢迎大家__歡迎大家 862.9018652|huan ying da jia;
欢迎来到__歡迎來到 284.991389772|huan ying lai dao;
欢迎广大__歡迎廣大 146.497163581|huan ying guang da;
欢迎光临__歡迎光臨 546.866130582|huan ying guang lin;
欢迎加入__歡迎加入 177.269210225|huan ying jia ru;
换位思考__換位思考 124.122120652|huan wei si kao;
黄土高原__黃土高原 119.56748386|huang tu gao yuan;
晃晃悠悠__晃晃悠悠 105.426930997|huang huang you you;
黄金价格__黃金價格 121.520271774|huang jin jia ge;
黄金时段__黃金時段 110.677283245|huang jin shi duan;
黄金时代__黃金時代 123.197520618|huang jin shi dai;
恍然大悟__恍然大悟 278.322859608|huang ran da wu;
昏昏沉沉__昏昏沉沉 116.044406778|hun hun chen chen;
昏昏欲睡__昏昏欲睡 128.209578049|hun hun yu shui;
浑浑噩噩__渾渾噩噩 132.431639237|hun hun e e;
混合动力__混合動力 133.925286409|hun he dong li;
婚纱摄影__婚紗攝影 182.878811433|hun sha she ying;
混在一起__混在一起 167.184787749|hun zai yi qi;
婚姻状况__婚姻狀況 151.510141313|hun yin zhuang kuang;
婚姻生活__婚姻生活 162.86639759|hun yin sheng huo;
混为一谈__混為一談 113.32907693|hun wei yi tan;
怀孕期间__懷孕期間 116.18910757|huai yun qi jian;
哈佛大学__哈佛大學 243.57916235|ha fo da xue;
哈利波特__哈利波特 628.775756137|ha li bo te;
哈根达斯__哈根達斯 255.391156791|ha gen da si;
哈哈大笑__哈哈大笑 370.702589737|ha ha da xiao;
哈哈哈哈__哈哈哈哈 4409.57193181|ha ha ha ha;
哈尔滨市__哈爾濱市 437.527796363|ha er bin shi;
还不知道__還不知道 1727.4743398|hai bu zhi dao;
海通证券__海通證券 175.292155245|hai tong zheng quan;
海关总署__海關總署 128.689786556|hai guan zong shu;
海阔天空__海闊天空 236.107646363|hai kuo tian kong;
还记得我__還記得我 164.908682755|hai ji de wo;
海峡两岸__海峽兩岸 308.651751439|hai xia liang an;
海峡西岸__海峽西岸 119.86585751|hai xia xi an;
还是没有__還是沒有 681.82669043|hai shi mei you;
还有没有__還有沒有 620.98878351|hai you mei you;
还有很多__還有很多 1326.40613196|hai you hen duo;
还有什么__還有什麼 1494.96846157|hai you shen me;
还有一些__還有一些 1116.83875458|hai you yi xie;
海外投资__海外投資 119.121315407|hai wai tou zi;
海外华人__海外華人 151.510141313|hai wai hua ren;
海外上市__海外上市 184.941433485|hai wai shang shi;
海外市场__海外市場 329.314848809|hai wai shi chang;
汉密尔顿__漢密爾頓 197.814987883|han mi er dun;
韩国电影__韓國電影 117.93965545|han guo dian ying;
汉语拼音__漢語拼音 145.405889264|han yu pin yin;
航班查询__航班查詢 106.085879302|hang ban cha xun;
航天飞机__航天飛機 216.384339476|hang tian fei ji;
航空母舰__航空母艦 218.280152578|hang kong mu jian;
航空公司__航空公司 1209.56018338|hang kong gong si;
航空航天__航空航天 142.003528374|hang kong hang tian;
航空运输__航空運輸 129.494134325|hang kong yun shu;
行业标准__行業標準 280.411678639|hang ye biao zhun;
行业发展__行業發展 309.807805448|hang ye fa zhan;
行业龙头__行業龍頭 124.276893895|hang ye long tou;
行业管理__行業管理 111.646962678|hang ye guan li;
行业协会__行業協會 620.215410078|hang ye xie hui;
行业自律__行業自律 107.550099352|hang ye zi lv;
行业资讯__行業資訊 121.520271774|hang ye zi xun;
毫不留情__毫不留情 157.2815571|hao bu liu qing;
毫不客气__毫不客氣 132.431639237|hao bu ke qi;
好不容易__好不容易 1637.34374958|hao bu rong yi;
毫不犹豫__毫不猶豫 604.195219728|hao bu you yu;
浩浩荡荡__浩浩蕩蕩 179.71591787|hao hao dang dang;
好好学习__好好學習 538.749137684|hao hao xue xi;
好久不见__好久不見 582.750146437|hao jiu bu jian;
好久没有__好久沒有 407.527636023|hao jiu mei you;
毫无意义__毫無意義 267.44247003|hao wu yi yi;
毫无疑问__毫無疑問 612.534451685|hao wu yi wen;
和平发展__和平發展 149.075426771|he ping fa zhan;
和平统一__和平統一 185.634130949|he ping tong yi;
合法权益__合法權益 1163.72451202|he fa quan yi;
合理利用__合理利用 161.653186955|he li li yong;
合理使用__合理使用 108.627664361|he li shi yong;
合理安排__合理安排 158.659551632|he li an pai;
合格产品__合格產品 111.369047744|he ge chan pin;
赫赫有名__赫赫有名 115.323601467|he he you ming;
合情合理__合情合理 173.769702743|he qing he li;
何去何从__何去何從 253.488718522|he qu he cong;
和谐发展__和諧發展 299.1842072|he xie fa zhan;
和谐相处__和諧相處 125.36572391|he xie xiang chu;
和谐社会__和諧社會 1493.10664229|he xie she hui;
核心内容__核心內容 150.944778196|he xin nei rong;
核心技术__核心技術 503.688011099|he xin ji shu;
核心价值__核心價值 236.991986692|he xin jia zhi;
核心业务__核心業務 166.560934377|he xin ye wu;
合在一起__合在一起 449.128812644|he zai yi qi;
合资公司__合資公司 411.610733326|he zi gong si;
合资企业__合資企業 329.314848809|he zi qi ye;
合作方式__合作方式 127.73116145|he zuo fang shi;
合作关系__合作關係 611.771607197|he zuo guan xi;
合作开发__合作開發 168.439513167|he zuo kai fa;
合作伙伴__合作夥伴 1613.0410787|he zuo huo ban;
合作建房__合作建房 181.516526012|he zuo jian fang;
合作项目__合作項目 248.175085992|he zuo xiang mu;
合作协议__合作協議 408.544597361|he zuo xie yi;
合作组织__合作組織 133.591915611|he zuo zu zhi;
合作医疗__合作醫療 138.335571213|he zuo yi liao;
合作愉快__合作愉快 156.304608838|he zuo yu kuai;
合影留念__合影留念 113.32907693|he ying liu nian;
合二为一__合二為一 118.23396695|he er wei yi;
很多东西__很多東西 798.742526514|hen duo dong xi;
很多时候__很多時候 1027.37704867|hen duo shi hou;
很多事情__很多事情 816.861571886|hen duo shi qing;
很多人都__很多人都 1118.23138914|hen duo ren dou;
很久没有__很久沒有 413.152419826|hen jiu mei you;
很久以前__很久以前 315.260239073|hen jiu yi qian;
很长时间__很長時間 908.135681884|hen chang shi jian;
很早以前__很早以前 162.258658377|hen zao yi qian;
很有可能__很有可能 893.542261726|hen you ke neng;
很有意思__很有意思 647.865219539|hen you yi si;
横空出世__橫空出世 175.073848088|heng kong chu shi;
黑龙江省__黑龍江省 860.753904265|hei long jiang sheng;
黑客帝国__黑客帝國 114.46454262|hei ke di guo;
黑色幽默__黑色幽默 142.891090816|hei se you mo;
后顾之忧__後顧之憂 293.277951001|hou gu zhi you;
后悔莫及__後悔莫及 105.953760973|hou hui mo ji;
后期制作__後期製作 129.010924378|hou qi zhi zuo;
宏观调控__宏觀調控 1328.06008516|hong guan tiao kong;
宏观经济__宏觀經濟 571.958268741|hong guan jing ji;
宏观政策__宏觀政策 105.164499152|hong guan zheng ce;
轰轰烈烈__轟轟烈烈 468.567137655|hong hong lie lie;
红红火火__紅紅火火 118.529012887|hong hong huo huo;
红杏出墙__紅杏出牆 146.132498493|hong xing chu qiang;
红十字会__紅十字會 409.564096466|hong shi zi hui;
红色旅游__紅色旅遊 119.56748386|hong se lv you;
红颜知己__紅顏知己 241.764712994|hong yan zhi ji;
呼风唤雨__呼風喚雨 118.08671951|hu feng huan yu;
虎胆龙威__虎膽龍威 121.975425508|hu dan long wei;
湖南大学__湖南大學 107.015331962|hu nan da xue;
湖南卫视__湖南衛視 599.694499646|hu nan wei shi;
糊里糊涂__糊裡糊塗 178.59961945|hu li hu tu;
互联互通__互聯互通 176.827946446|hu lian hu tong;
互联星空__互聯星空 160.249192015|hu lian xing kong;
胡萝卜素__胡蘿蔔素 149.447435764|hu luo bo su;
呼和浩特__呼和浩特 281.461959558|hu he hao te;
呼叫转移__呼叫轉移 126.464093517|hu jiao zhuan yi;
呼叫中心__呼叫中心 305.209408115|hu jiao zhong xin;
胡锦涛在__胡錦濤在 195.121873946|hu jin tao zai;
呼吸困难__呼吸困難 157.67404401|hu xi kun nan;
互相帮助__互相幫助 127.572086295|hu xiang bang zhu;
呼之欲出__呼之欲出 145.224802174|hu zhi yu chu;
沪深股市__滬深股市 168.020228531|hu shen gu shi;
虎视眈眈__虎視眈眈 134.259489114|hu shi dan dan;
胡说八道__胡說八道 397.991873082|hu shuo ba dao;
胡思乱想__胡思亂想 472.67240572|hu si luan xiang;
胡言乱语__胡言亂語 191.98633424|hu yan luan yu;
户外广告__戶外廣告 168.020228531|hu wai guang gao;
户外活动__戶外活動 165.73274959|hu wai huo dong;
户外运动__戶外運動 182.423584067|hu wai yun dong;
伙伴关系__夥伴關係 256.347723437|huo ban guan xi;
活蹦乱跳__活蹦亂跳 114.321989585|huo beng luan tiao;
货币基金__貨幣基金 122.890853693|huo bi ji jin;
货币政策__貨幣政策 860.753904265|huo bi zheng ce;
货币市场__貨幣市場 134.42690308|huo bi shi chang;
活不下去__活不下去 110.677283245|huo bu xia qu;
货到付款__貨到付款 182.196395498|huo dao fu kuan;
获得更多__獲得更多 313.302012384|huo de geng duo;
获得成功__獲得成功 293.277951001|huo de cheng gong;
活动内容__活動內容 113.187937993|huo dong nei rong;
活动中心__活動中心 179.940013424|huo dong zhong xin;
活动场所__活動場所 145.768741141|huo dong chang suo;
活动时间__活動時間 107.550099352|huo dong shi jian;
获奖名单__獲獎名單 130.46599058|huo jiang ming dan;
获奖作品__獲獎作品 114.321989585|huo jiang zuo pin;
或者其他__或者其他 487.62990282|huo zhe qi ta;
货真价实__貨真價實 165.32020271|huo zhen jia shi;
豁然开朗__豁然開朗 157.2815571|huo ran kai lang;
火影忍者__火影忍者 412.637883794|huo ying ren zhe;
货物运输__貨物運輸 132.927661458|huo wu yun shu;
汇丰银行__滙豐銀行 134.259489114|hui feng yin hang;
灰飞烟灭__灰飛煙滅 137.476305203|hui fei yan mie;
恢复正常__恢復正常 500.559372647|hui fu zheng chang;
回复日期__回復日期 199248.884539|hui fu ri qi;
回答问题__回答問題 269.785619908|hui da wen ti;
回家过年__回家過年 148.889769675|hui jia guo nian;
会展中心__會展中心 181.290467084|hui zhan zhong xin;
挥之不去__揮之不去 224.06783424|hui zhi bu qu;
会员单位__會員單位 120.46484039|hui yuan dan wei;
会员资料__會員資料 164.908682755|hui yuan zi liao;
会议记录__會議記錄 108.087539034|hui yi ji lu;
会议纪要__會議紀要 185.86560618|hui yi ji yao;
会议精神__會議精神 264.459727191|hui yi jing shen;
会议召开__會議召開 158.067510349|hui yi zhao kai;
会议中心__會議中心 106.748946222|hui yi zhong xin;
回味无穷__回味無窮 121.368931601|hui wei wu qiong;
卷土重来__捲土重來 166.146325956|juan tu chong lai;
绝大部分__絕大部分 1041.55712696|jue da bu fen;
绝大多数__絕大多數 2046.51646869|jue da duo shu;
觉得自己__覺得自己 2554.75594355|jue de zi ji;
绝对不能__絕對不能 380.531740742|jue dui bu neng;
绝对不会__絕對不會 774.242000696|jue dui bu hui;
绝对不是__絕對不是 611.771607197|jue dui bu shi;
绝对优势__絕對優勢 202.554574186|jue dui you shi;
绝无仅有__絕無僅有 151.510141313|jue wu jin you;
竣工验收__竣工驗收 141.121478992|jun gong yan shou;
军国主义__軍國主義 197.322580943|jun guo zhu yi;
军事力量__軍事力量 148.704343794|jun shi li liang;
军事基地__軍事基地 118.08671951|jun shi ji di;
军事训练__軍事訓練 112.34478795|jun shi xun lian;
军事行动__軍事行動 189.136730609|jun shi xing dong;
军事演习__軍事演習 131.117943492|jun shi yan xi;
基本特征__基本特徵 158.067510349|ji ben te zheng;
基本条件__基本條件 212.641966978|ji ben tiao jian;
基本内容__基本內容 116.18910757|ji ben nei rong;
基本农田__基本農田 112.204874836|ji ben nong tian;
基本理论__基本理論 167.184787749|ji ben li lun;
基本概念__基本概念 182.651055928|ji ben gai nian;
基本功能__基本功能 156.499511818|ji ben gong neng;
基本工资__基本工資 170.339279748|ji ben gong zi;
基本建设__基本建設 207.149415951|ji ben jian she;
基本权利__基本權利 115.899886195|ji ben quan li;
基本情况__基本情況 462.764242999|ji ben qing kuang;
基本信息__基本信息 184.02185602|ji ben xin xi;
基本知识__基本知識 246.326401069|ji ben zhi shi;
基本原理__基本原理 248.794392378|ji ben yuan li;
基本原则__基本原則 536.070335228|ji ben yuan ze;
基本要求__基本要求 389.163898974|ji ben yao qiu;
基本完成__基本完成 337.625607028|ji ben wan cheng;
鸡皮疙瘩__雞皮疙瘩 160.449013667|ji pi ge da;
机票价格__機票價格 128.850255419|ji piao jia ge;
极品飞车__極品飛車 317.230705235|ji pin fei che;
集贸市场__集貿市場 121.823518492|ji mao shi chang;
鸡毛蒜皮__雞毛蒜皮 128.369448119|ji mao suan pi;
激发学生__激發學生 139.373782642|ji fa xue sheng;
亟待解决__亟待解決 106.350610398|ji dai jie jue;
既得利益__既得利益 163.884358899|ji de li yi;
基地建设__基地建設 256.347723437|ji di jian she;
机电产品__機電產品 188.901181552|ji dian chan pin;
机电设备__機電設備 117.207077876|ji dian she bei;
几点思考__幾點思考 157.477678279|ji dian si kao;
机动车辆__機動車輛 109.034528882|ji dong che liang;
激动人心__激動人心 210.270405333|ji dong ren xin;
集团公司__集團公司 1334.69654755|ji tuan gong si;
集团总裁__集團總裁 167.810977762|ji tuan zong cai;
集体土地__集體土地 111.091824605|ji ti tu di;
集体经济__集體經濟 222.398727024|ji ti jing ji;
集体企业__集體企業 113.753550575|ji ti qi ye;
暨南大学__暨南大學 118.529012887|ji nan da xue;
技能培训__技能培訓 242.670241844|ji neng pei xun;
纪念活动__紀念活動 134.092283643|ji nian huo dong;
纪律检查__紀律檢查 146.314717429|ji lv jian cha;
激励机制__激勵機制 287.130256264|ji li ji zhi;
吉林大学__吉林大學 174.203334854|ji lin da xue;
记录下来__記錄下來 336.785179346|ji lu xia lai;
机关干部__機關幹部 213.438416689|ji guan gan bu;
几个方面__幾個方面 522.874798954|ji ge fang mian;
几个小时__幾個小時 656.807194196|ji ge xiao shi;
几个问题__幾個問題 478.599545119|ji ge wen ti;
机构改革__機構改革 130.628674269|ji gou gai ge;
急功近利__急功近利 267.44247003|ji gong jin li;
技工学校__技工學校 110.539446825|ji gong xue xiao;
疾控中心__疾控中心 155.333728851|ji kong zhong xin;
计划经济__計劃經濟 435.352293046|ji hua jing ji;
计划生育__計劃生育 1226.25479235|ji hua sheng yu;
几乎没有__幾乎沒有 999.59341964|ji hu mei you;
几乎所有__幾乎所有 995.863416846|ji hu suo you;
急急忙忙__急急忙忙 158.461958559|ji ji mang mang;
积极分子__積極分子 118.08671951|ji ji fen zi;
积极探索__積極探索 401.478808454|ji ji tan suo;
积极开展__積極開展 467.983588668|ji ji kai zhan;
积极向上__積極向上 216.384339476|ji ji xiang shang;
叽叽喳喳__嘰嘰喳喳 111.230349808|ji ji zha zha;
积极主动__積極主動 276.594068012|ji ji zhu dong;
积极作用__積極作用 332.614317243|ji ji zuo yong;
积极参加__積极參加 247.866011137|ji ji can jia;
积极参与__積极參与 736.594714048|ji ji can yu;
积极意义__積極意義 123.504952812|ji ji yi yi;
纪检监察__紀檢監察 225.749468142|ji jian jian cha;
即将到来__即將到來 362.028498203|ji jiang dao lai;
即将推出__即將推出 201.296414343|ji jiang tui chu;
即将来临__即將來臨 189.845141544|ji jiang lai lin;
即将结束__即將結束 132.927661458|ji jiang jie shu;
即将上市__即將上市 133.591915611|ji jiang shang shi;
基金投资__基金投資 203.313241605|ji jin tou zi;
基金管理__基金管理 378.168082664|ji jin guan li;
基金公司__基金公司 845.867144221|ji jin gong si;
基金经理__基金經理 618.67155147|ji jin jing li;
基金净值__基金凈值 178.59961945|ji jin jing zhi;
及其相关__及其相關 113.187937993|ji qi xiang guan;
及其应用__及其應用 218.008308584|ji qi ying yong;
绩效管理__績效管理 166.97657743|ji xiao guan li;
绩效考核__績效考核 244.491487214|ji xiao kao he;
机械工业__機械工業 139.200207879|ji xie gong ye;
机械行业__機械行業 111.230349808|ji xie hang ye;
机械制造__機械製造 179.268563673|ji xie zhi zao;
机械设备__機械設備 287.488291405|ji xie she bei;
继续努力__繼續努力 460.463257431|ji xu nu li;
继续教育__繼續教育 227.443722742|ji xu jiao yu;
基准利率__基準利率 168.020228531|ji zhun li lv;
记者采访__記者採訪 672.544092675|ji zhe cai fang;
集中体现__集中體現 164.293322714|ji zhong ti xian;
集中精力__集中精力 239.963779681|ji zhong jing li;
集中学习__集中學習 109.989815613|ji zhong xue xi;
集中采购__集中採購 123.813152185|ji zhong cai gou;
集成电路__集成電路 402.982545867|ji cheng dian lu;
集成显卡__集成顯卡 170.127140854|ji cheng xian ka;
基础理论__基礎理論 136.452228303|ji chu li lun;
基础工作__基礎工作 135.267109459|ji chu gong zuo;
基础建设__基礎建設 181.516526012|ji chu jian she;
基础教育__基礎教育 367.482952871|ji chu jiao yu;
基础知识__基礎知識 481.590928402|ji chu zhi shi;
基础设施__基礎設施 1349.75009317|ji chu she shi;
基础研究__基礎研究 204.584007193|ji chu yan jiu;
计生工作__計生工作 146.497163581|ji sheng gong zuo;
即时通讯__即時通訊 205.350275845|ji shi tong xun;
即时通信__即時通信 128.369448119|ji shi tong xin;
技术标准__技術標準 316.046952528|ji shu biao zhun;
技术培训__技術培訓 226.312812713|ji shu pei xun;
技术发展__技術發展 208.184564378|ji shu fa zhan;
技术分析__技術分析 256.667374505|ji shu fen xi;
技术服务__技術服務 398.985038482|ji shu fu wu;
技术条件__技術條件 107.952927857|ji shu tiao jian;
技术推广__技術推廣 110.815291538|ji shu tui guang;
技术力量__技術力量 166.97657743|ji shu li liang;
技术领域__技術領域 147.412812521|ji shu ling yu;
技术改造__技術改造 309.807805448|ji shu gai zao;
技术工人__技術工人 131.281440129|ji shu gong ren;
技术规范__技術規範 143.784200776|ji shu gui fan;
技术开发__技術開發 311.355949144|ji shu kai fa;
技术含量__技術含量 593.006203378|ji shu han liang;
技术合作__技術合作 105.295633316|ji shu he zuo;
技术交流__技術交流 204.584007193|ji shu jiao liu;
技术进步__技術進步 265.450260135|ji shu jin bu;
技术转让__技術轉讓 111.091824605|ji shu zhuan rang;
技术装备__技術裝備 136.792736844|ji shu zhuang bei;
技术指标__技術指標 309.807805448|ji shu zhi biao;
技术指导__技術指導 161.854759309|ji shu zhi dao;
技术支持__技術支持 831.23785106|ji shu zhi chi;
技术中心__技術中心 209.746993999|ji shu zhong xin;
技术创新__技術創新 726.566487616|ji shu chuang xin;
技术手段__技術手段 222.953710017|ji shu shou duan;
技术水平__技術水平 452.499534015|ji shu shui ping;
技术人才__技術人才 149.633788238|ji shu ren cai;
技术人员__技術人員 1019.7239982|ji shu ren yuan;
技术资料__技術資料 132.596773978|ji shu zi liao;
技术参数__技術參數 124.742372548|ji shu can shu;
技术研发__技術研發 176.60772663|ji shu yan fa;
技术研究__技術研究 350.92368248|ji shu yan jiu;
技术要求__技術要求 200.29551561|ji shu yao qiu;
技术优势__技術優勢 200.29551561|ji shu you shi;
技术问题__技術問題 268.444174826|ji shu wen ti;
既然如此__既然如此 138.680779525|ji ran ru ci;
基层单位__基層單位 122.279808036|ji ceng dan wei;
基层干部__基層幹部 165.114314527|ji ceng gan bu;
基层组织__基層組織 136.963309627|ji ceng zu zhi;
计算方法__計算方法 302.935867929|ji suan fang fa;
计算公式__計算公式 153.601316766|ji suan gong shi;
计算机系__計算機系 155.915530766|ji suan ji xi;
计算结果__計算結果 121.217779906|ji suan jie guo;
记忆犹新__記憶猶新 237.287502254|ji yi you xin;
极为重要__極為重要 154.368879448|ji wei zhong yao;
纪委书记__紀委書記 213.172602547|ji wei shu ji;
加班加点__加班加點 169.28122395|jia ban jia dian;
假冒伪劣__假冒偽劣 187.727829225|jia mao wei lie;
家电连锁__家電連鎖 138.163289429|jia dian lian suo;
家庭暴力__家庭暴力 189.608710238|jia ting bao li;
家庭教育__家庭教育 276.594068012|jia ting jiao yu;
家庭经济__家庭經濟 139.026849285|jia ting jing ji;
家庭主妇__家庭主婦 221.845125512|jia ting zhu fu;
家庭成员__家庭成員 298.439468992|jia ting cheng yuan;
家庭生活__家庭生活 276.938965124|jia ting sheng huo;
家庭收入__家庭收入 109.442917312|jia ting shou ru;
家庭影院__家庭影院 171.190483873|jia ting ying yuan;
价廉物美__價廉物美 116.624293448|jia lian wu mei;
价格波动__價格波動 133.758497151|jia ge bo dong;
价格便宜__價格便宜 218.552335545|jia ge pian yi;
价格指数__價格指數 150.194241046|jia ge zhi shu;
价格上涨__價格上漲 912.673735821|jia ge shang zhang;
价格走势__價格走勢 136.622376491|jia ge zou shi;
加工贸易__加工貿易 280.062456643|jia gong mao yi;
加工工艺__加工工藝 121.368931601|jia gong gong yi;
加工企业__加工企業 293.643651968|jia gong qi ye;
加快发展__加快發展 544.825488702|jia kuai fa zhan;
加快推进__加快推進 362.028498203|jia kuai tui jin;
加快建设__加快建設 171.190483873|jia kuai jian she;
家家户户__家家戶戶 158.461958559|jia jia hu hu;
加强管理__加強管理 163.884358899|jia qiang guan li;
家政服务__家政服務 135.098649108|jia zheng fu wu;
价值投资__價值投資 254.438159592|jia zhi tou zi;
价值观念__價值觀念 184.251320835|jia zhi guan nian;
价值取向__價值取向 253.488718522|jia zhi qu xiang;
家常便饭__家常便飯 179.045304336|jia chang bian fan;
加入时间__加入時間 106.350610398|jia ru shi jian;
家族企业__家族企業 141.826678552|jia zu qi ye;
家用电器__家用電器 253.804804573|jia yong dian qi;
家喻户晓__家喻戶曉 276.249600432|jia yu hu xiao;
见不得人__見不得人 138.335571213|jian bu de ren;
减肥瘦身__減肥瘦身 184.251320835|jian fei shou shen;
坚定不移__堅定不移 418.333200332|jian ding bu yi;
监督管理__監督管理 618.67155147|jian du guan li;
监督工作__監督工作 118.824795093|jian du gong zuo;
监督机制__監督機制 167.393257695|jian du ji zhi;
监督检查__監督檢查 606.458230719|jian du jian cha;
简体中文__簡體中文 309.4219738|jian ti zhong wen;
建立健全__建立健全 798.742526514|jian li jian quan;
建立自己__建立自己 256.028470459|jian li zi ji;
监管部门__監管部門 516.399339766|jian guan bu men;
监管工作__監管工作 178.59961945|jian guan gong zuo;
监管机构__監管機構 210.008536601|jian guan ji gou;
见怪不怪__見怪不怪 145.768741141|jian guai bu guai;
建国以来__建國以來 121.975425508|jian guo yi lai;
健康发展__健康發展 973.773879211|jian kang fa zhan;
健康快乐__健康快樂 123.658956482|jian kang kuai le;
健康教育__健康教育 253.173026121|jian kang jiao yu;
健康状况__健康狀況 250.037645335|jian kang zhuang kuang;
健康成长__健康成長 288.924902033|jian kang cheng zhang;
监控系统__監控系統 334.276427588|jian kong xi tong;
艰苦奋斗__艱苦奮鬥 250.974160423|jian ku fen dou;
坚决反对__堅決反對 297.325836157|jian jue fan dui;
简简单单__簡簡單單 263.144763849|jian jian dan dan;
剑桥大学__劍橋大學 111.369047744|jian qiao da xue;
建筑面积__建築面積 747.692521253|jian zhu mian ji;
建筑风格__建築風格 167.810977762|jian zhu feng ge;
建筑工地__建築工地 175.292155245|jian zhu gong di;
建筑工程__建築工程 320.010065926|jian zhu gong cheng;
建筑公司__建築公司 140.770195218|jian zhu gong si;
建筑节能__建築節能 210.532600599|jian zhu jie neng;
建筑设计__建築設計 301.054193591|jian zhu she ji;
建筑施工__建築施工 112.34478795|jian zhu shi gong;
建筑材料__建築材料 219.918349804|jian zhu cai liao;
检查工作__檢查工作 137.134095104|jian cha gong zuo;
检察机关__檢察機關 557.879339939|jian cha ji guan;
检查结果__檢查結果 174.203334854|jian cha jie guo;
坚持不懈__堅持不懈 312.911829085|jian chi bu xie;
坚持到底__堅持到底 146.132498493|jian chi dao di;
建设单位__建設單位 291.093289619|jian she dan wei;
建设工程__建設工程 505.574572707|jian she gong cheng;
建设工作__建設工作 207.925293333|jian she gong zuo;
建设规划__建設規劃 191.269933402|jian she gui hua;
建设和谐__建設和諧 142.003528374|jian she he xie;
建设项目__建設項目 826.074649543|jian she xiang mu;
建设成为__建設成為 226.595011951|jian she cheng wei;
建设资金__建設資金 141.29744947|jian she zi jin;
建设银行__建設銀行 449.128812644|jian she yin hang;
建设用地__建設用地 495.593922384|jian she yong di;
见仁见智__見仁見智 116.624293448|jian ren jian zhi;
尖锐湿疣__尖銳濕疣 165.73274959|jian rui shi you;
建材市场__建材市場 122.890853693|jian cai shi chang;
检测报告__檢測報告 108.492380517|jian ce bao gao;
检测方法__檢測方法 124.742372548|jian ce fang fa;
检测结果__檢測結果 174.855812809|jian ce jie guo;
监测系统__監測系統 131.773154284|jian ce xi tong;
检测中心__檢測中心 129.655606164|jian ce zhong xin;
检验检疫__檢驗檢疫 296.585723861|jian yan jian yi;
见义勇为__見義勇為 288.565077751|jian yi yong wei;
脚本语言__腳本語言 111.646962678|jiao ben yu yan;
交付使用__交付使用 115.899886195|jiao fu shi yong;
脚踏实地__腳踏實地 280.411678639|jiao ta shi di;
焦头烂额__焦頭爛額 175.510734618|jiao tou lan e;
交通便利__交通便利 134.259489114|jiao tong bian li;
交通部门__交通部門 157.870654598|jiao tong bu men;
交通管理__交通管理 108.222318063|jiao tong guan li;
交通管制__交通管制 113.32907693|jiao tong guan zhi;
交通工具__交通工具 404.491915522|jiao tong gong ju;
交通事故__交通事故 621.763121294|jiao tong shi gu;
交通枢纽__交通樞紐 156.694657831|jiao tong shu niu;
交通运输__交通運輸 386.746622582|jiao tong yun shu;
交通银行__交通銀行 420.94790182|jiao tong yin hang;
交通安全__交通安全 233.474375771|jiao tong an quan;
交流平台__交流平台 2391.47390956|jiao liu ping tai;
交流活动__交流活動 128.049907079|jiao liu huo dong;
绞尽脑汁__絞盡腦汁 186.794397067|jiao jin nao zhi;
交警大队__交警大隊 134.259489114|jiao jing da dui;
交警支队__交警支隊 119.86585751|jiao jing zhi dui;
教学模式__教學模式 187.027319083|jiao xue mo shi;
教学目标__教學目標 108.492380517|jiao xue mu biao;
教学方法__教學方法 257.62872122|jiao xue fang fa;
教学内容__教學內容 234.056997396|jiao xue nei rong;
教学改革__教學改革 211.321149687|jiao xue gai ge;
教学工作__教學工作 189.845141544|jiao xue gong zuo;
教学过程__教學過程 175.729586548|jiao xue guo cheng;
教学活动__教學活動 122.737806611|jiao xue huo dong;
教学计划__教學計劃 123.967540162|jiao xue ji hua;
教学质量__教學質量 277.976239008|jiao xue zhi liang;
教学设计__教學設計 125.209594649|jiao xue she ji;
交响乐团__交響樂團 154.176629937|jiao xiang yue tuan;
轿车市场__轎車市場 172.905674062|jiao che shi chang;
教师队伍__教師隊伍 156.304608838|jiao shi dui wu;
胶原蛋白__膠原蛋白 199.051387821|jiao yuan dan bai;
交易平台__交易平台 193.427195796|jiao yi ping tai;
交易方式__交易方式 118.676811842|jiao yi fang shi;
交易价格__交易價格 145.950506492|jiao yi jia ge;
交易系统__交易系統 187.027319083|jiao yi xi tong;
交易中心__交易中心 220.467143161|jiao yi zhong xin;
交易成本__交易成本 168.229740225|jiao yi cheng ben;
交易市场__交易市場 340.15949445|jiao yi shi chang;
教育部门__教育部門 282.868455943|jiao yu bu men;
教育培训__教育培訓 292.54791482|jiao yu pei xun;
教育发展__教育發展 133.259374649|jiao yu fa zhan;
教育体系__教育體系 109.989815613|jiao yu ti xi;
教育体制__教育體制 137.476305203|jiao yu ti zhi;
教育理念__教育理念 121.066816454|jiao yu li nian;
教育改革__教育改革 223.788782324|jiao yu gai ge;
教育工作__教育工作 242.670241844|jiao yu gong zuo;
教育孩子__教育孩子 159.651218957|jiao yu hai zi;
教育活动__教育活動 394.535222541|jiao yu huo dong;
教育机构__教育機構 158.067510349|jiao yu ji gou;
教育教学__教育教學 336.785179346|jiao yu jiao xue;
教育经费__教育經費 146.314717429|jiao yu jing fei;
教育学院__教育學院 170.76435144|jiao yu xue yuan;
教育系统__教育系統 182.196395498|jiao yu xi tong;
教育制度__教育制度 123.813152185|jiao yu zhi du;
教育质量__教育質量 123.197520618|jiao yu zhi liang;
教育事业__教育事業 324.83145542|jiao yu shi ye;
教育资源__教育資源 293.277951001|jiao yu zi yuan;
教育思想__教育思想 117.207077876|jiao yu si xiang;
降低成本__降低成本 357.545014261|jiang di cheng ben;
讲话精神__講話精神 113.753550575|jiang hua jing shen;
解放战争__解放戰爭 158.067510349|jie fang zhan zheng;
解放思想__解放思想 485.810302105|jie fang si xiang;
皆大欢喜__皆大歡喜 152.837570606|jie da huan xi;
街头篮球__街頭籃球 117.646076559|jie tou lan qiu;
节能环保__節能環保 197.322580943|jie neng huan bao;
节能降耗__節能降耗 185.172044961|jie neng jiang hao;
结构调整__結構調整 483.394725468|jie gou tiao zheng;
结构设计__結構設計 182.878811433|jie gou she ji;
结果表明__結果表明 260.209952636|jie guo biao ming;
结果显示__結果顯示 333.029068427|jie guo xian shi;
借壳上市__借殼上市 137.647730357|jie ke shang shi;
结合起来__結合起來 964.114234362|jie he qi lai;
结合实际__結合實際 168.859844103|jie he shi ji;
解决办法__解決辦法 692.099342424|jie jue ban fa;
解决方法__解決方法 556.490650127|jie jue fang fa;
解决方案__解決方案 2766.85515694|jie jue fang an;
解决问题__解決問題 1740.43907177|jie jue wen ti;
阶级斗争__階級鬥爭 205.350275845|jie ji dou zheng;
竭尽全力__竭盡全力 192.705418355|jie jin quan li;
截止时间__截止時間 127.413209251|jie zhi shi jian;
截止日期__截止日期 140.419785869|jie zhi ri qi;
接踵而来__接踵而來 119.26985293|jie zhong er lai;
接踵而至__接踵而至 123.967540162|jie zhong er zhi;
接触不良__接觸不良 107.416157498|jie chu bu liang;
解除合同__解除合同 115.899886195|jie chu he tong;
介绍一下__介紹一下 896.889021007|jie shao yi xia;
接受采访__接受採訪 647.058374454|jie shou cai fang;
截然不同__截然不同 455.327784806|jie ran bu tong;
节日快乐__節日快樂 399.482550191|jie ri kuai le;
节日期间__節日期間 180.164388413|jie ri qi jian;
借此机会__藉此機會 142.357889859|jie ci ji hui;
节约能源__節約能源 132.266710153|jie yue neng yuan;
接二连三__接二連三 197.568631008|jie er lian san;
金碧辉煌__金碧輝煌 109.442917312|jin bi hui huang;
筋疲力尽__筋疲力盡 115.899886195|jin pi li jin;
紧密联系__緊密聯繫 216.11485651|jin mi lian xi;
紧密结合__緊密結合 403.988165198|jin mi jie he;
今年夏天__今年夏天 184.251320835|jin nian xia tian;
今年春节__今年春節 117.061109314|jin nian chun jie;
今年以来__今年以來 643.039196578|jin nian yi lai;
进来看看__進來看看 158.264611567|jin lai kan kan;
尽量避免__盡量避免 334.69325133|jin liang bi mian;
紧锣密鼓__緊鑼密鼓 211.321149687|jin luo mi gu;
尽管如此__儘管如此 225.468321935|jin guan ru ci;
仅供参考__僅供參考 786.88699725|jin gong can kao;
紧急通知__緊急通知 222.398727024|jin ji tong zhi;
近几年来__近幾年來 283.221176861|jin ji nian lai;
紧急情况__緊急情況 174.42055653|jin ji qing kuang;
津津乐道__津津樂道 281.812926654|jin jin le dao;
斤斤计较__斤斤計較 191.269933402|jin jin ji jiao;
紧紧抓住__緊緊抓住 246.019628549|jin jin zhua zhu;
进进出出__進進出出 155.527421199|jin jin chu chu;
津津有味__津津有味 201.296414343|jin jin you wei;
紧紧围绕__緊緊圍繞 352.238065853|jin jin wei rao;
尽心尽力__盡心儘力 152.647228173|jin xin jin li;
进行比较__進行比較 235.226605969|jin xing bi jiao;
进行分析__進行分析 520.274927886|jin xing fen xi;
进行到底__進行到底 305.589986932|jin xing dao di;
进行调查__進行調查 450.24958728|jin xing diao cha;
进行调整__進行調整 403.48504224|jin xing tiao zheng;
进行检查__進行檢查 403.988165198|jin xing jian cha;
进行交流__進行交流 318.022335873|jin xing jiao liu;
进行交易__進行交易 168.020228531|jin xing jiao yi;
进行全面__進行全面 425.69561654|jin xing quan mian;
进行修改__進行修改 238.473254015|jin xing xiu gai;
进行研究__進行研究 272.149298879|jin xing yan jiu;
进展情况__進展情況 352.238065853|jin zhan qing kuang;
进展顺利__進展順利 254.755429543|jin zhan shun li;
尽职尽责__盡職盡責 106.085879302|jin zhi jin ze;
禁止下载__禁止下載 108.898738333|jin zhi xia zai;
禁止使用__禁止使用 119.121315407|jin zhi shi yong;
进城务工__進城務工 208.70407676|jin cheng wu gong;
金山毒霸__金山毒霸 256.347723437|jin shan du ba;
尽善尽美__盡善盡美 158.659551632|jin shan jin mei;
金山词霸__金山詞霸 386.264972075|jin shan ci ba;
锦上添花__錦上添花 213.971039752|jin shang tian hua;
尽收眼底__盡收眼底 107.684208225|jin shou yan di;
金属材料__金屬材料 110.401782066|jin shu cai liao;
金融风暴__金融風暴 172.690339006|jin rong feng bao;
金融风险__金融風險 158.264611567|jin rong feng xian;
金融服务__金融服務 338.890182508|jin rong fu wu;
金融体系__金融體系 239.366454718|jin rong ti xi;
金融改革__金融改革 120.615053212|jin rong gai ge;
金融行业__金融行業 124.431860131|jin rong hang ye;
金融机构__金融機構 1498.69906777|jin rong ji gou;
金融监管__金融監管 112.065135969|jin rong jian guan;
金融企业__金融企業 136.112567367|jin rong qi ye;
金融系统__金融系統 110.126966673|jin rong xi tong;
金融中心__金融中心 176.827946446|jin rong zhong xin;
金融创新__金融創新 142.535402072|jin rong chuang xin;
金融产品__金融產品 149.820373083|jin rong chan pin;
金融市场__金融市場 630.344829195|jin rong shi chang;
金融资产__金融資產 199.796934068|jin rong zi chan;
金融危机__金融危機 866.133860988|jin rong wei ji;
进入系统__進入系統 116.47905068|jin ru xi tong;
进入中国__進入中國 511.914293268|jin ru zhong guo;
进入市场__進入市場 248.794392378|jin ru shi chang;
尽如人意__盡如人意 196.341441156|jin ru ren yi;
进入游戏__進入遊戲 146.862738669|jin ru you xi;
近在咫尺__近在咫尺 189.608710238|jin zai zhi chi;
仅此而已__僅此而已 184.02185602|jin ci er yi;
经贸关系__經貿關係 144.682892926|jing mao guan xi;
经贸合作__經貿合作 271.133768339|jing mao he zuo;
精打细算__精打細算 130.141230764|jing da xi suan;
经典之作__經典之作 151.888225993|jing dian zhi zuo;
惊天动地__驚天動地 293.277951001|jing tian dong di;
精力充沛__精力充沛 136.792736844|jing li chong pei;
景观设计__景觀設計 120.015323434|jing guan she ji;
靖国神社__靖國神社 220.742053181|jing guo shen she;
惊慌失措__驚慌失措 135.098649108|jing huang shi cuo;
经济补偿__經濟補償 130.46599058|jing ji bu chang;
经济普查__經濟普查 150.381524744|jing ji pu cha;
经济贸易__經濟貿易 110.401782066|jing ji mao yi;
经济发展__經濟發展 3394.2494311|jing ji fa zhan;
经济特区__經濟特區 163.680258901|jing ji te qu;
经济体制__經濟體制 203.566761683|jing ji ti zhi;
竞技体育__競技體育 109.30661816|jing ji ti yu;
经济利益__經濟利益 380.531740742|jing ji li yi;
经济管理__經濟管理 152.647228173|jing ji guan li;
经济改革__經濟改革 156.499511818|jing ji gai ge;
经济工作__經濟工作 219.097720093|jing ji gong zuo;
经纪公司__經紀公司 376.287731462|jing ji gong si;
经济过热__經濟過熱 115.036534536|jing ji guo re;
经济困难__經濟困難 134.762357541|jing ji kun nan;
经济环境__經濟環境 169.492308033|jing ji huan jing;
经济合作__經濟合作 291.456266438|jing ji he zuo;
经济活动__經濟活動 249.104624871|jing ji huo dong;
经济基础__經濟基礎 275.561951728|jing ji ji chu;
经济价值__經濟價值 112.34478795|jing ji jia zhi;
经济建设__經濟建設 741.198640518|jing ji jian she;
经济结构__經濟結構 321.609191441|jing ji jie gou;
经济学家__經濟學家 1271.38069074|jing ji xue jia;
经济学院__經濟學院 140.945727665|jing ji xue yuan;
经济效益__經濟效益 999.59341964|jing ji xiao yi;
经济形势__經濟形勢 258.916120291|jing ji xing shi;
经济状况__經濟狀況 212.112652282|jing ji zhuang kuang;
经济政策__經濟政策 226.030964922|jing ji zheng ce;
经济指标__經濟指標 124.587019602|jing ji zhi biao;
经济制度__經濟制度 106.483223576|jing ji zhi du;
经济秩序__經濟秩序 135.604660605|jing ji zhi xu;
经济衰退__經濟衰退 155.140277726|jing ji shuai tui;
经济社会__經濟社會 810.776675547|jing ji she hui;
经济生活__經濟生活 106.616002115|jing ji sheng huo;
经济实力__經濟實力 452.499534015|jing ji shi li;
经济数据__經濟數據 113.611883002|jing ji shu ju;
经济增长__經濟增長 1682.85360433|jing ji zeng zhang;
经济总量__經濟總量 224.06783424|jing ji zong liang;
经济组织__經濟組織 259.238974004|jing ji zu zhi;
经济作物__經濟作物 106.350610398|jing ji zuo wu;
经济损失__經濟損失 512.55262135|jing ji sun shi;
经济运行__經濟運行 380.531740742|jing ji yun xing;
经济问题__經濟問題 212.641966978|jing ji wen ti;
经济危机__經濟危機 326.048110451|jing ji wei ji;
竞价排名__競價排名 114.46454262|jing jia pai ming;
兢兢业业__兢兢業業 171.403948695|jing jing ye ye;
井井有条__井井有條 106.350610398|jing jing you tiao;
精细化工__精細化工 106.882056102|jing xi hua gong;
惊心动魄__驚心動魄 330.136634719|jing xin dong po;
精心设计__精心設計 210.795122809|jing xin she ji;
精心组织__精心組織 139.026849285|jing xin zu zhi;
竞争对手__競爭對手 1571.37615922|jing zheng dui shou;
竞争能力__競爭能力 230.582949765|jing zheng neng li;
竞争格局__競爭格局 107.282382453|jing zheng ge ju;
竞争环境__競爭環境 116.333988795|jing zheng huan jing;
竞争激烈__競爭激烈 369.779825848|jing zheng ji lie;
竞争优势__競爭優勢 584.932834985|jing zheng you shi;
经常出现__經常出現 295.479008313|jing chang chu xian;
精神病人__精神病人 121.066816454|jing shen bing ren;
精神病院__精神病院 181.516526012|jing shen bing yuan;
精神面貌__精神面貌 130.46599058|jing shen mian mao;
精神状态__精神狀態 321.609191441|jing shen zhuang tai;
精神生活__精神生活 140.070248771|jing shen sheng huo;
精神世界__精神世界 153.601316766|jing shen shi jie;
精神实质__精神實質 114.893269147|jing shen shi zhi;
精神文明__精神文明 236.696839161|jing shen wen ming;
精神文化__精神文化 115.899886195|jing shen wen hua;
惊世骇俗__驚世駭俗 115.611384758|jing shi hai su;
精彩纷呈__精彩紛呈 117.792774542|jing cai fen cheng;
精彩瞬间__精彩瞬間 134.594525802|jing cai shun jian;
经验丰富__經驗豐富 429.425273358|jing yan feng fu;
经验交流__經驗交流 159.452390871|jing yan jiao liu;
经验教训__經驗教訓 236.107646363|jing yan jiao xun;
敬业精神__敬業精神 166.146325956|jing ye jing shen;
精益求精__精益求精 201.045721733|jing yi qiu jing;
经营模式__經營模式 286.772667017|jing ying mo shi;
经营范围__經營範圍 244.491487214|jing ying fan wei;
经营方式__經營方式 155.915530766|jing ying fang shi;
经营单位__經營單位 188.196293023|jing ying dan wei;
晶莹剔透__晶瑩剔透 162.056583012|jing ying ti tou;
经营理念__經營理念 321.609191441|jing ying li nian;
经营管理__經營管理 651.102673334|jing ying guan li;
经营活动__經營活動 373.019586361|jing ying huo dong;
经营企业__經營企業 245.101601395|jing ying qi ye;
经营情况__經營情況 112.625137786|jing ying qing kuang;
经营行为__經營行為 114.179614083|jing ying xing wei;
经营状况__經營狀況 199.051387821|jing ying zhuang kuang;
经营业绩__經營業績 207.666345181|jing ying ye ji;
境外投资__境外投資 124.587019602|jing wai tou zi;
敬而远之__敬而遠之 113.611883002|jing er yuan zhi;
救命稻草__救命稻草 106.748946222|jiu ming dao cao;
就会出现__就會出現 508.734557585|jiu hui chu xian;
纠缠不清__糾纏不清 107.952927857|jiu chan bu qing;
旧城改造__舊城改造 111.507918629|jiu cheng gai zao;
就是那个__就是那個 530.752623218|jiu shi na ge;
九十年代__九十年代 407.020105042|jiu shi nian dai;
就事论事__就事論事 180.613978088|jiu shi lun shi;
就是这样__就是這樣 2183.52320481|jiu shi zhe yang;
就在这里__就在這裡 310.580912674|jiu zai zhe li;
就业服务__就業服務 208.184564378|jiu ye fu wu;
就业岗位__就業崗位 207.666345181|jiu ye gang wei;
就业工作__就業工作 112.906187218|jiu ye gong zuo;
就业机会__就業機會 257.94996962|jiu ye ji hui;
就业形势__就業形勢 132.927661458|jiu ye xing shi;
就业指导__就業指導 116.18910757|jiu ye zhi dao;
就业援助__就業援助 120.164975734|jiu ye yuan zhu;
就业压力__就業壓力 140.419785869|jiu ye ya li;
就业问题__就業問題 168.229740225|jiu ye wen ti;
久而久之__久而久之 219.918349804|jiu er jiu zhi;
举报电话__舉報電話 2140.41782974|ju bao dian hua;
局部地区__局部地區 134.42690308|ju bu di qu;
居民消费__居民消費 223.510077937|ju min xiao fei;
居民生活__居民生活 112.065135969|ju min sheng huo;
居民收入__居民收入 131.117943492|ju min shou ru;
局副局长__局副局長 1170.99812122|ju fu ju zhang;
巨大变化__巨大變化 129.010924378|ju da bian hua;
具体表现__具體表現 142.713135632|ju ti biao xian;
具体方法__具體方法 190.318888971|ju ti fang fa;
具体内容__具體內容 265.450260135|ju ti nei rong;
具体工作__具體工作 170.551683166|ju ti gong zuo;
具体规定__具體規定 135.604660605|ju ti gui ding;
具体情况__具體情況 733.846096172|ju ti qing kuang;
具体实施__具體實施 135.604660605|ju ti shi shi;
具体操作__具體操作 200.29551561|ju ti cao zuo;
具体措施__具體措施 180.839193473|ju ti cuo shi;
具体要求__具體要求 280.761336094|ju ti yao qiu;
具体问题__具體問題 203.566761683|ju ti wen ti;
具体位置__具體位置 109.579386421|ju ti wei zhi;
居高不下__居高不下 353.998238229|ju gao bu xia;
居高临下__居高臨下 134.594525802|ju gao lin xia;
聚精会神__聚精會神 130.141230764|ju jing hui shen;
剧情介绍__劇情介紹 160.849404779|ju qing jie shao;
拒之门外__拒之門外 138.335571213|ju zhi men wai;
居住环境__居住環境 172.905674062|ju zhu huan jing;
举世瞩目__舉世矚目 136.622376491|ju shi zhu mu;
举手投足__舉手投足 129.171793682|ju shou tou zu;
举手之劳__舉手之勞 117.792774542|ju shou zhi lao;
举足轻重__舉足輕重 303.691826638|ju zu qing zhong;
举一反三__舉一反三 119.26985293|ju yi fan san;
具有良好__具有良好 386.746622582|ju you liang hao;
具有较强__具有較強 284.636464248|ju you jiao qiang;
全部内容__全部內容 179.268563673|quan bu nei rong;
全面发展__全面發展 513.831666385|quan mian fa zhan;
全面提高__全面提高 256.028470459|quan mian ti gao;
全面提升__全面提升 242.36802267|quan mian ti sheng;
全面推进__全面推進 418.854838101|quan mian tui jin;
全面推行__全面推行 151.510141313|quan mian tui xing;
全面落实__全面落實 230.870473623|quan mian luo shi;
全面贯彻__全面貫徹 108.087539034|quan mian guan che;
全面实施__全面實施 181.290467084|quan mian shi shi;
全民健身__全民健身 140.770195218|quan min jian shen;
全体会议__全體會議 230.008975843|quan ti hui yi;
全体员工__全體員工 246.326401069|quan ti yuan gong;
全力支持__全力支持 228.8653107|quan li zhi chi;
全力以赴__全力以赴 420.423657369|quan li yi fu;
权利义务__權利義務 136.452228303|quan li yi wu;
全国统一__全國統一 227.160466527|quan guo tong yi;
全国各大__全國各大 152.457122789|quan guo ge da;
全国各地__全國各地 1296.98472971|quan guo ge di;
全国政协__全國政協 225.187525865|quan guo zheng xie;
全国人民__全國人民 713.111292931|quan guo ren min;
全国人大__全國人大 534.069978074|quan guo ren da;
全国最大__全國最大 202.554574186|quan guo zui da;
全军覆没__全軍覆沒 114.893269147|quan jun fu mo;
全球变暖__全球變暖 142.180598718|quan qiu bian nuan;
全球第一__全球第一 143.247667161|quan qiu di yi;
全球领先__全球領先 116.915322539|quan qiu ling xian;
全球华人__全球華人 135.773751924|quan qiu hua ren;
全球经济__全球經濟 410.586139672|quan qiu jing ji;
全球市场__全球市場 218.008308584|quan qiu shi chang;
全球最大__全球最大 520.274927886|quan qiu zui da;
全心全意__全心全意 426.226434824|quan xin quan yi;
全神贯注__全神貫注 120.46484039|quan shen guan zhu;
权威机构__權威機構 153.984619852|quan wei ji gou;
权威人士__權威人士 127.73116145|quan wei ren shi;
却不知道__卻不知道 373.484720623|que bu zhi dao;
确确实实__確確實實 118.676811842|que que shi shi;
缺一不可__缺一不可 111.369047744|que yi bu ke;
群发软件__群發軟件 438.073368704|qun fa ruan jian;
群众利益__群眾利益 170.977284899|qun zhong li yi;
群众演员__群眾演員 105.558392399|qun zhong yan yuan;
泣不成声__泣不成聲 116.624293448|qi bu cheng sheng;
期末考试__期末考試 203.820597887|qi mo kao shi;
启动仪式__啟動儀式 213.704562287|qi dong yi shi;
其他品牌__其他品牌 150.381524744|qi ta pin pai;
其它媒体__其它媒體 488.846754671|qi ta mei ti;
其他媒体__其他媒體 609.488769235|qi ta mei ti;
其他地方__其他地方 2013.62967073|qi ta di fang;
其他地区__其他地區 286.415523108|qi ta di qu;
其他国家__其他國家 713.111292931|qi ta guo jia;
其他行业__其他行業 176.827946446|qi ta hang ye;
其他组织__其他組織 107.550099352|qi ta zu zhi;
其他用户__其他用戶 124.276893895|qi ta yong hu;
其它问题__其它問題 336.365750338|qi ta wen ti;
其他文章__其他文章 166.146325956|qi ta wen zhang;
器官移植__器官移植 111.369047744|qi guan yi zhi;
气候变化__氣候變化 425.165459331|qi hou bian hua;
气候条件__氣候條件 113.753550575|qi hou tiao jian;
期货公司__期貨公司 274.533686805|qi huo gong si;
期货价格__期貨價格 128.209578049|qi huo jia ge;
期货交易__期貨交易 170.977284899|qi huo jiao yi;
期货市场__期貨市場 370.702589737|qi huo shi chang;
气急败坏__氣急敗壞 161.451865638|qi ji bai huai;
迄今为止__迄今為止 462.764242999|qi jin wei zhi;
齐齐哈尔__齊齊哈爾 196.586267794|qi qi ha er;
气象部门__氣象部門 132.431639237|qi xiang bu men;
齐心协力__齊心協力 190.081867665|qi xin xie li;
旗帜鲜明__旗幟鮮明 113.32907693|qi zhi xian ming;
其中一位__其中一位 146.132498493|qi zhong yi wei;
气喘吁吁__氣喘吁吁 165.32020271|qi chuan xu xu;
汽车配件__汽車配件 124.431860131|qi che pei jian;
汽车品牌__汽車品牌 138.680779525|qi che pin pai;
汽车电子__汽車電子 110.677283245|qi che dian zi;
汽车公司__汽車公司 230.582949765|qi che gong si;
汽车工业__汽車工業 322.813777494|qi che gong ye;
汽车行业__汽車行業 246.326401069|qi che hang ye;
汽车企业__汽車企業 205.60633599|qi che qi ye;
汽车消费__汽車消費 110.126966673|qi che xiao fei;
汽车销售__汽車銷售 200.795341333|qi che xiao shou;
汽车之家__汽車之家 229.436430673|qi che zhi jia;
汽车产业__汽車產業 206.376433771|qi che chan ye;
汽车厂商__汽車廠商 116.18910757|qi che chang shang;
汽车市场__汽車市場 271.810366771|qi che shi chang;
汽车维修__汽車維修 120.46484039|qi che wei xiu;
七十年代__七十年代 314.475483928|qi shi nian dai;
杞人忧天__杞人憂天 117.207077876|qi ren you tian;
骑自行车__騎自行車 399.482550191|qi zi xing che;
起死回生__起死回生 110.815291538|qi si hui sheng;
企业品牌__企業品牌 109.034528882|qi ye pin pai;
企业名录__企業名錄 145.043940608|qi ye ming lu;
企业名称__企業名稱 242.670241844|qi ye ming cheng;
企业发展__企業發展 584.932834985|qi ye fa zhan;
企业法人__企業法人 145.587202159|qi ye fa ren;
企业单位__企業單位 123.197520618|qi ye dan wei;
企业内部__企業內部 389.649164279|qi ye nei bu;
企业年金__企業年金 209.485777119|qi ye nian jin;
企业管理__企業管理 582.024395035|qi ye guan li;
企业改革__企業改革 107.952927857|qi ye gai ge;
企业改制__企業改制 134.930398555|qi ye gai zhi;
企业规模__企業規模 111.091824605|qi ye gui mo;
企业集团__企業集團 334.276427588|qi ye ji tuan;
企业经营__企業經營 267.775955618|qi ye jing ying;
企业形象__企業形象 207.666345181|qi ye xing xiang;
企业战略__企業戰略 112.625137786|qi ye zhan lue;
企业职工__企業職工 209.746993999|qi ye zhi gong;
企业员工__企業員工 135.098649108|qi ye yuan gong;
企业用户__企業用戶 150.194241046|qi ye yong hu;
企业网站__企業網站 183.563783354|qi ye wang zhan;
企业文化__企業文化 872.634214191|qi ye wen hua;
恰到好处__恰到好處 350.486645516|qia dao hao chu;
恰恰相反__恰恰相反 187.4940348|qia qia xiang fan;
恰如其分__恰如其分 124.587019602|qia ru qi fen;
千变万化__千變萬化 137.819369268|qian bian wan hua;
千篇一律__千篇一律 202.302314677|qian pian yi lv;
千方百计__千方百計 505.574572707|qian fang bai ji;
前段时间__前段時間 1103.00744393|qian duan shi jian;
前端总线__前端總線 154.754097942|qian duan zong xian;
签订合同__簽訂合同 218.552335545|qian ding he tong;
前提条件__前提條件 207.925293333|qian ti tiao jian;
千里迢迢__千里迢迢 127.890434962|qian li tiao tiao;
千里之外__千里之外 299.557272934|qian li zhi wai;
前列腺炎__前列腺炎 225.187525865|qian lie xian yan;
千家万户__千家萬戶 191.508436159|qian jia wan hu;
千奇百怪__千奇百怪 130.303509496|qian qi bai guai;
前期工作__前期工作 197.076837307|qian qi gong zuo;
前前后后__前前後後 146.314717429|qian qian hou hou;
千千静听__千千靜聽 263.472890441|qian qian jing ting;
千千万万__千千萬萬 252.54282031|qian qian wan wan;
千辛万苦__千辛萬苦 158.264611567|qian xin wan ku;
千差万别__千差萬別 110.815291538|qian cha wan bie;
前车之鉴__前車之鑒 118.972962872|qian che zhi jian;
千载难逢__千載難逢 117.499561272|qian zai nan feng;
签字仪式__簽字儀式 116.624293448|qian zi yi shi;
前三季度__前三季度 376.287731462|qian san ji du;
千丝万缕__千絲萬縷 135.773751924|qian si wan lv;
前所未有__前所未有 1053.30446216|qian suo wei you;
签约仪式__簽約儀式 169.703655326|qian yue yi shi;
千言万语__千言萬語 117.646076559|qian yan wan yu;
潜移默化__潛移默化 255.391156791|qian yi mo hua;
千万不能__千萬不能 317.230705235|qian wan bu neng;
千万不要__千萬不要 1500.56786049|qian wan bu yao;
前无古人__前無古人 111.507918629|qian wu gu ren;
巧言令色__巧言令色 449.688850794|qiao yan ling se;
悄无声息__悄無聲息 172.690339006|qiao wu sheng xi;
强烈推荐__強烈推薦 280.411678639|qiang lie tui jian;
强烈建议__強烈建議 317.230705235|qiang lie jian yi;
强烈要求__強烈要求 648.673070715|qiang lie yao qiu;
强制执行__強制執行 199.548108896|qiang zhi zhi xing;
强制措施__強制措施 121.975425508|qiang zhi cuo shi;
切身利益__切身利益 358.884197808|qie shen li yi;
切实可行__切實可行 230.295783987|qie shi ke xing;
切实加强__切實加強 469.151414294|qie shi jia qiang;
切实做好__切實做好 202.050369328|qie shi zuo hao;
锲而不舍__鍥而不捨 107.14877401|qie er bu she;
亲朋好友__親朋好友 382.433299725|qin peng hao you;
亲密接触__親密接觸 286.058823982|qin mi jie chu;
侵犯了您__侵犯了您 184.71110921|qin fan le nin;
勤工俭学__勤工儉學 135.435779871|qin gong jian xue;
侵华日军__侵華日軍 117.792774542|qin hua ri jun;
侵权行为__侵權行為 219.097720093|qin quan xing wei;
亲身体验__親身體驗 194.151676652|qin shen ti yan;
亲身经历__親身經歷 328.495108513|qin shen jing li;
禽兽不如__禽獸不如 117.499561272|qin shou bu ru;
亲眼目睹__親眼目睹 188.901181552|qin yan mu du;
情不自禁__情不自禁 429.425273358|qing bu zi jin;
青梅竹马__青梅竹馬 213.971039752|qing mei zhu ma;
轻描淡写__輕描淡寫 209.746993999|qing miao dan xie;
青岛啤酒__青島啤酒 132.762114633|qing dao pi jiu;
青年教师__青年教師 178.377193209|qing nian jiao shi;
青年学生__青年學生 110.126966673|qing nian xue sheng;
清理整顿__清理整頓 131.609045271|qing li zheng dun;
情理之中__情理之中 207.149415951|qing li zhi zhong;
情感天地__情感天地 114.321989585|qing gan tian di;
请告诉我__請告訴我 231.158356006|qing gao su wo;
情况分析__情況分析 105.690017726|qing kuang fen xi;
情况汇报__情況彙報 122.737806611|qing kuang hui bao;
清华大学__清華大學 1179.78648723|qing hua da xue;
清华同方__清華同方 201.79873775|qing hua tong fang;
倾家荡产__傾家蕩產 184.481071779|qing jia dang chan;
清洁能源__清潔能源 120.615053212|qing jie neng yuan;
清洁生产__清潔生產 173.769702743|qing jie sheng chan;
情节严重__情節嚴重 163.884358899|qing jie yan zhong;
清清楚楚__清清楚楚 331.37316028|qing qing chu chu;
轻轻松松__輕輕鬆鬆 201.296414343|qing qing song song;
清晰可见__清晰可見 132.266710153|qing xi ke jian;
庆祝活动__慶祝活動 152.837570606|qing zhu huo dong;
青山绿水__青山綠水 115.467403456|qing shan lv shui;
清热解毒__清熱解毒 133.42554153|qing re jie du;
青藏铁路__青藏鐵路 346.1460998|qing zang tie lu;
青藏高原__青藏高原 304.449671797|qing zang gao yuan;
轻松愉快__輕鬆愉快 111.507918629|qing song yu kuai;
情有独钟__情有獨鍾 242.972837869|qing you du zhong;
轻而易举__輕而易舉 296.216358865|qing er yi ju;
求真务实__求真務實 197.568631008|qiu zhen wu shi;
取得联系__取得聯繫 351.361264404|qu de lian xi;
取得成功__取得成功 297.696584607|qu de cheng gong;
驱动之家__驅動之家 126.306596357|qu dong zhi jia;
驱动程序__驅動程序 714.89082038|qu dong cheng xu;
去年同期__去年同期 802.733930815|qu nian tong qi;
屈指可数__屈指可數 172.04594156|qu zhi ke shu;
区域发展__區域發展 137.991222203|qu yu fa zhan;
区域合作__區域合作 160.249192015|qu yu he zuo;
区域经济__區域經濟 270.122027271|qu yu jing ji;
区域市场__區域市場 130.303509496|qu yu shi chang;
区委书记__區委書記 145.043940608|qu wei shu ji;
区位优势__區位優勢 170.977284899|qu wei you shi;
取而代之__取而代之 298.439468992|qu er dai zhi;
选举产生__選舉產生 189.608710238|xuan ju chan sheng;
宣传报道__宣傳報道 123.504952812|xuan chuan bao dao;
宣传部长__宣傳部長 140.945727665|xuan chuan bu zhang;
宣传推广__宣傳推廣 106.748946222|xuan chuan tui guang;
宣传工作__宣傳工作 288.565077751|xuan chuan gong zuo;
宣传活动__宣傳活動 339.735863102|xuan chuan huo dong;
宣传教育__宣傳教育 330.960471347|xuan chuan jiao yu;
宣传资料__宣傳資料 167.601987591|xuan chuan zi liao;
轩然大波__軒然大波 168.649547684|xuan ran da bo;
学历教育__學歷教育 118.972962872|xue li jiao yu;
学科建设__學科建設 113.32907693|xue ke jian she;
血红蛋白__血紅蛋白 117.499561272|xue hong dan bai;
学习方法__學習方法 227.727332161|xue xi fang fa;
学习方式__學習方式 125.053659829|xue xi fang shi;
学习能力__學習能力 192.465424888|xue xi neng li;
学习贯彻__學習貫徹 423.578945935|xue xi guan che;
学习过程__學習過程 161.049974862|xue xi guo cheng;
学习环境__學習環境 110.677283245|xue xi huan jing;
学习活动__學習活動 131.937467932|xue xi huo dong;
学习兴趣__學習興趣 129.332863581|xue xi xing qu;
学习成绩__學習成績 391.596284031|xue xi cheng ji;
学习生活__學習生活 127.254530072|xue xi sheng huo;
学习英语__學習英語 191.031727675|xue xi ying yu;
学校领导__學校領導 141.473639374|xue xiao ling dao;
学校教育__學校教育 200.29551561|xue xiao jiao yu;
雪上加霜__雪上加霜 187.26053154|xue shang jia shuang;
学生家长__學生家長 234.348853194|xue sheng jia zhang;
学生进行__學生進行 192.705418355|xue sheng jin xing;
学生学习__學生學習 230.582949765|xue sheng xue xi;
学生时代__學生時代 179.492101402|xue sheng shi dai;
学生宿舍__學生宿舍 126.464093517|xue sheng su she;
学士学位__學士學位 276.938965124|xue shi xue wei;
学术论文__學術論文 154.947067523|xue shu lun wen;
学术会议__學術會議 121.975425508|xue shu hui yi;
学术交流__學術交流 207.925293333|xue shu jiao liu;
学术研究__學術研究 239.366454718|xue shu yan jiu;
血缘关系__血緣關係 149.820373083|xue yuan guan xi;
学院院长__學院院長 228.8653107|xue yuan yuan zhang;
血液循环__血液循環 1285.72012038|xue ye xun huan;
迅猛发展__迅猛發展 229.722524886|xun meng fa zhan;
迅雷下载__迅雷下載 175.729586548|xun lei xia zai;
训练基地__訓練基地 122.584950132|xun lian ji di;
训练有素__訓練有素 105.821807183|xun lian you su;
循环经济__循環經濟 450.811022973|xun huan jing ji;
循环系统__循環系統 414.183417482|xun huan xi tong;
巡航导弹__巡航導彈 114.893269147|xun hang dao dan;
循序渐进__循序漸進 268.444174826|xun xu jian jin;
迅速发展__迅速發展 414.699880708|xun su fa zhan;
西班牙人__西班牙人 155.915530766|xi ban ya ren;
西班牙语__西班牙語 230.295783987|xi ban ya yu;
细胞凋亡__細胞凋亡 122.890853693|xi bao diao wang;
西北地区__西北地區 157.085680168|xi bei di qu;
西伯利亚__西伯利亞 236.991986692|xi bo li ya;
西部地区__西部地區 431.033684153|xi bu di qu;
西方国家__西方國家 576.969379906|xi fang guo jia;
西方文化__西方文化 193.90988203|xi fang wen hua;
细分市场__細分市場 236.402059204|xi fen shi chang;
系统提示__系統提示 113.753550575|xi tong ti shi;
系统管理__系統管理 146.314717429|xi tong guan li;
系统工程__系統工程 301.054193591|xi tong gong cheng;
系统还原__系統還原 145.950506492|xi tong huan yuan;
系统集成__系統集成 256.347723437|xi tong ji cheng;
系统启动__系統啟動 132.431639237|xi tong qi dong;
系统性能__系統性能 109.442917312|xi tong xing neng;
系统设计__系統設計 227.443722742|xi tong she ji;
系统软件__系統軟件 107.015331962|xi tong ruan jian;
系统资源__系統資源 176.60772663|xi tong zi yuan;
系统文件__系統文件 205.862715427|xi tong wen jian;
系统维护__系統維護 106.218162376|xi tong wei hu;
西南地区__西南地區 169.070402749|xi nan di qu;
喜怒哀乐__喜怒哀樂 263.144763849|xi nu ai le;
稀里哗啦__稀里嘩啦 107.14877401|xi li hua la;
稀里糊涂__稀里糊塗 239.366454718|xi li hu tu;
系列活动__系列活動 248.794392378|xi lie huo dong;
系列产品__系列產品 711.336195135|xi lie chan pin;
喜欢什么__喜歡什麼 126.779677253|xi huan shen me;
喜欢自己__喜歡自己 117.499561272|xi huan zi ji;
细菌感染__細菌感染 119.56748386|xi jun gan ran;
稀奇古怪__稀奇古怪 130.954650472|xi qi gu guai;
嘻嘻哈哈__嘻嘻哈哈 195.365179853|xi xi ha ha;
息息相关__息息相關 348.309611377|xi xi xiang guan;
熙熙攘攘__熙熙攘攘 163.884358899|xi xi rang rang;
喜新厌旧__喜新厭舊 134.930398555|xi xin yan jiu;
喜出望外__喜出望外 116.044406778|xi chu wang wai;
西双版纳__西雙版納 177.490254874|xi shuang ban na;
习以为常__習以為常 198.06165195|xi yi wei chang;
吸引外资__吸引外資 112.625137786|xi yin wai zi;
希望大家__希望大家 1623.12304424|xi wang da jia;
希望能够__希望能夠 800.735741689|xi wang neng gou;
希望工程__希望工程 177.269210225|xi wang gong cheng;
希望小学__希望小學 149.447435764|xi wang xiao xue;
喜闻乐见__喜聞樂見 132.927661458|xi wen le jian;
厦门大学__廈門大學 199.051387821|xia men da xue;
下定决心__下定決心 361.12732612|xia ding jue xin;
下拉菜单__下拉菜單 119.86585751|xia la cai dan;
下落不明__下落不明 112.34478795|xia luo bu ming;
下岗工人__下崗工人 139.895806636|xia gang gong ren;
下岗职工__下崗職工 303.691826638|xia gang zhi gong;
下载地址__下載地址 626.429466854|xia zai di zhi;
下载软件__下載軟件 141.473639374|xia zai ruan jian;
下载速度__下載速度 182.651055928|xia zai su du;
下载安装__下載安裝 121.368931601|xia zai an zhuang;
现代都市__現代都市 105.690017726|xian dai du shi;
现代农业__現代農業 378.168082664|xian dai nong ye;
现代科技__現代科技 204.839111844|xian dai ke ji;
现代科学__現代科學 132.431639237|xian dai ke xue;
现代企业__現代企業 159.651218957|xian dai qi ye;
现代社会__現代社會 485.810302105|xian dai she hui;
现代生活__現代生活 119.121315407|xian dai sheng huo;
现代医学__現代醫學 175.510734618|xian dai yi xue;
现代文明__現代文明 184.941433485|xian dai wen ming;
现代物流__現代物流 158.461958559|xian dai wu liu;
县公安局__縣公安局 162.460985719|xian gong an ju;
显卡驱动__顯卡驅動 125.053659829|xian ka qu dong;
现货市场__現貨市場 144.143005824|xian huo shi chang;
先决条件__先決條件 122.127521944|xian jue tiao jian;
县级以上__縣級以上 442.462509543|xian ji yi shang;
先进单位__先進單位 225.187525865|xian jin dan wei;
先进典型__先進典型 114.037415895|xian jin dian xing;
现金流量__現金流量 141.826678552|xian jin liu liang;
先进个人__先進個人 208.70407676|xian jin ge ren;
先进集体__先進集體 175.292155245|xian jin ji ti;
先进技术__先進技術 397.991873082|xian jin ji shu;
先进经验__先進經驗 108.087539034|xian jin jing yan;
先进事迹__先進事迹 142.003528374|xian jin shi ji;
先进文化__先進文化 219.918349804|xian jin wen hua;
贤妻良母__賢妻良母 140.070248771|xian qi liang mu;
现场直播__現場直播 237.879639313|xian chang zhi bo;
显示效果__顯示效果 242.670241844|xian shi xiao guo;
现实主义__現實主義 266.112675706|xian shi zhu yi;
显示出来__顯示出來 270.796100963|xian shi chu lai;
现实生活__現實生活 912.673735821|xian shi sheng huo;
现实意义__現實意義 253.173026121|xian shi yi yi;
先入为主__先入為主 150.756793028|xian ru wei zhu;
现在流行__現在流行 131.117943492|xian zai liu xing;
现在开始__現在開始 215.845709156|xian zai kai shi;
县域经济__縣域經濟 237.583386308|xian yu jing ji;
县委书记__縣委書記 366.111682898|xian wei shu ji;
鲜为人知__鮮為人知 189.845141544|xian wei ren zhi;
显而易见__顯而易見 414.183417482|xian er yi jian;
小麦价格__小麥價格 135.267109459|xiao mai jia ge;
消防安全__消防安全 240.562595233|xiao fang an quan;
消费电子__消費電子 218.824857909|xiao fei dian zi;
消费能力__消費能力 176.168109435|xiao fei neng li;
消费观念__消費觀念 109.989815613|xiao fei guan nian;
消费群体__消費群體 265.78126155|xiao fei qun ti;
消费习惯__消費習慣 109.034528882|xiao fei xi guan;
消费需求__消費需求 307.883446338|xiao fei xu qiu;
消费支出__消費支出 114.607273411|xiao fei zhi chu;
消费市场__消費市場 311.355949144|xiao fei shi chang;
消费水平__消費水平 204.07475061|xiao fei shui ping;
小道消息__小道消息 197.322580943|xiao dao xiao xi;
效果如何__效果如何 113.32907693|xiao guo ru he;
小康社会__小康社會 137.819369268|xiao kang she hui;
消化不良__消化不良 224.626982392|xiao hua bu liang;
消化系统__消化系統 141.29744947|xiao hua xi tong;
消化吸收__消化吸收 220.742053181|xiao hua xi shou;
小学毕业__小學畢業 107.14877401|xiao xue bi ye;
小学教师__小學教師 114.607273411|xiao xue jiao shi;
小小年纪__小小年紀 134.594525802|xiao xiao nian ji;
小心谨慎__小心謹慎 140.070248771|xiao xin jin shen;
小心翼翼__小心翼翼 781.025384985|xiao xin yi yi;
消除疲劳__消除疲勞 143.0692679|xiao chu pi lao;
销声匿迹__銷聲匿跡 143.426288875|xiao sheng ni ji;
销售模式__銷售模式 122.279808036|xiao shou mo shi;
销售代表__銷售代表 111.230349808|xiao shou dai biao;
销售公司__銷售公司 175.729586548|xiao shou gong si;
销售价格__銷售價格 333.029068427|xiao shou jia ge;
销售经理__銷售經理 188.430963124|xiao shou jing li;
销售情况__銷售情況 200.29551561|xiao shou qing kuang;
销售渠道__銷售渠道 289.645897197|xiao shou qu dao;
销售收入__銷售收入 676.747684543|xiao shou shou ru;
销售人员__銷售人員 766.561672733|xiao shou ren yuan;
销售业绩__銷售業績 186.794397067|xiao shou ye ji;
销售网络__銷售網絡 189.136730609|xiao shou wang luo;
小组成员__小組成員 141.473639374|xiao zu cheng yuan;
校园招聘__校園招聘 114.46454262|xiao yuan zhao pin;
校园文化__校園文化 105.0335283|xiao yuan wen hua;
小有名气__小有名氣 134.42690308|xiao you ming qi;
笑傲江湖__笑傲江湖 211.584655172|xiao ao jiang hu;
小额贷款__小額貸款 145.043940608|xiao e dai kuan;
相比之下__相比之下 385.303469841|xiang bi zhi xia;
项目投资__項目投資 117.499561272|xiang mu tou zi;
项目管理__項目管理 490.066643104|xiang mu guan li;
项目开发__項目開發 152.267254161|xiang mu kai fa;
项目建设__項目建設 552.345286903|xiang mu jian she;
项目经理__項目經理 525.487661863|xiang mu jing li;
项目实施__項目實施 208.70407676|xiang mu shi shi;
想方设法__想方設法 408.035799866|xiang fang she fa;
相辅相成__相輔相成 184.251320835|xiang fu xiang cheng;
相得益彰__相得益彰 157.870654598|xiang de yi zhang;
相对来说__相對來說 389.163898974|xiang dui lai shuo;
相对湿度__相對濕度 115.611384758|xiang dui shi du;
相对而言__相對而言 185.172044961|xiang dui er yan;
相提并论__相提並論 331.786363812|xiang ti bing lun;
想来想去__想來想去 140.594881376|xiang lai xiang qu;
相关报道__相關報道 160.649084484|xiang guan bao dao;
相关部门__相關部門 1344.71347376|xiang guan bu men;
相关法律__相關法律 255.709615075|xiang guan fa lv;
相关内容__相關內容 595.22730595|xiang guan nei rong;
相关链接__相關鏈接 123.044091616|xiang guan lian jie;
相关规定__相關規定 1031.22508566|xiang guan gui ding;
相关企业__相關企業 153.028150386|xiang guan qi ye;
相关信息__相關信息 595.969520633|xiang guan xin xi;
相关新闻__相關新聞 124.89791921|xiang guan xin wen;
相关专业__相關專業 269.785619908|xiang guan zhuan ye;
相关政策__相關政策 283.574337601|xiang guan zheng ce;
相关知识__相關知識 212.377144726|xiang guan zhi shi;
相关产品__相關產品 224.626982392|xiang guan chan pin;
相关事宜__相關事宜 123.813152185|xiang guan shi yi;
相关手续__相關手續 148.704343794|xiang guan shou xu;
相关数据__相關數據 109.170488754|xiang guan shu ju;
相关资料__相關資料 432.648119245|xiang guan zi liao;
相关文件__相關文件 163.884358899|xiang guan wen jian;
相关文章__相關文章 149.633788238|xiang guan wen zhang;
香港媒体__香港媒體 110.677283245|xiang gang mei ti;
香港大学__香港大學 112.484875527|xiang gang da xue;
香港电影__香港電影 302.935867929|xiang gang dian ying;
香港特区__香港特區 135.94305409|xiang gang te qu;
香港股市__香港股市 124.89791921|xiang gang gu shi;
香港回归__香港回歸 140.770195218|xiang gang hui gui;
香港政府__香港政府 124.587019602|xiang gang zheng fu;
香港上市__香港上市 183.792676978|xiang gang shang shi;
香格里拉__香格里拉 510.004074866|xiang ge li la;
相互关系__相互關係 145.587202159|xiang hu guan xi;
相互之间__相互之間 204.584007193|xiang hu zhi jian;
相互作用__相互作用 351.361264404|xiang hu zuo yong;
相结合的__相結合的 699.905273328|xiang jie he de;
相去甚远__相去甚遠 120.314814642|xiang qu shen yuan;
详细内容__詳細內容 111.646962678|xiang xi nei rong;
详细介绍__詳細介紹 410.586139672|xiang xi jie shao;
详细情况__詳細情況 175.073848088|xiang xi qing kuang;
详细信息__詳細信息 376.287731462|xiang xi xin xi;
详细说明__詳細說明 199.548108896|xiang xi shuo ming;
详细资料__詳細資料 208.964318904|xiang xi zi liao;
相信自己__相信自己 590.057620516|xiang xin zi ji;
相信爱情__相信愛情 125.522047856|xiang xin ai qing;
乡镇企业__鄉鎮企業 358.884197808|xiang zhen qi ye;
象征意义__象徵意義 128.369448119|xiang zheng yi yi;
相差无几__相差無幾 125.835280772|xiang cha wu ji;
享受生活__享受生活 213.704562287|xiang shou sheng huo;
想入非非__想入非非 121.066816454|xiang ru fei fei;
相濡以沫__相濡以沫 139.373782642|xiang ru yi mo;
相似之处__相似之處 196.586267794|xiang si zhi chu;
相依为命__相依為命 157.870654598|xiang yi wei ming;
响应时间__響應時間 185.172044961|xiang ying shi jian;
谢天谢地__謝天謝地 115.323601467|xie tian xie di;
协调发展__協調發展 621.763121294|xie tiao fa zhan;
协调机制__協調機制 115.467403456|xie tiao ji zhi;
协会会长__協會會長 220.742053181|xie hui hui zhang;
协会会员__協會會員 120.615053212|xie hui hui yuan;
谢谢大家__謝謝大家 680.129467195|xie xie da jia;
谢谢合作__謝謝合作 200.795341333|xie xie he zuo;
歇斯底里__歇斯底里 269.785619908|xie si di li;
心不在焉__心不在焉 225.468321935|xin bu zai yan;
心平气和__心平氣和 253.488718522|xin ping qi he;
心满意足__心滿意足 206.633773476|xin man yi zu;
信访工作__信訪工作 196.831399718|xin fang gong zuo;
心得体会__心得體會 158.461958559|xin de ti hui;
信托公司__信託公司 150.007190589|xin tuo gong si;
新年快乐__新年快樂 343.996026791|xin nian kuai le;
心律失常__心律失常 136.282292017|xin lv shi chang;
新浪博客__新浪博客 291.819695868|xin lang bo ke;
新浪体育__新浪體育 291.456266438|xin lang ti yu;
新浪科技__新浪科技 120.015323434|xin lang ke ji;
新浪财经__新浪財經 114.179614083|xin lang cai jing;
新浪娱乐__新浪娛樂 307.117053725|xin lang yu le;
心理健康__心理健康 292.183578474|xin li jian kang;
心理学家__心理學家 267.109399762|xin li xue jia;
心理状态__心理狀態 184.481071779|xin li zhuang tai;
心理准备__心理準備 417.291872914|xin li zhun bei;
心理障碍__心理障礙 179.940013424|xin li zhang ai;
心理治疗__心理治療 127.572086295|xin li zhi liao;
心力衰竭__心力衰竭 144.863304286|xin li shuai jie;
心理咨询__心理諮詢 273.850309404|xin li zi xun;
心理测试__心理測試 128.689786556|xin li ce shi;
心理素质__心理素質 346.1460998|xin li su zhi;
心理压力__心理壓力 267.109399762|xin li ya li;
心理医生__心理醫生 292.183578474|xin li yi sheng;
心理因素__心理因素 113.895394799|xin li yin su;
心理问题__心理問題 209.224885556|xin li wen ti;
心路历程__心路歷程 134.930398555|xin lu li cheng;
心甘情愿__心甘情願 430.496878967|xin gan qing yuan;
新股发行__新股發行 189.608710238|xin gu fa xing;
新股申购__新股申購 111.786180106|xin gu shen gou;
心旷神怡__心曠神怡 128.369448119|xin kuang shen yi;
新华书店__新華書店 259.885889675|xin hua shu dian;
辛亥革命__辛亥革命 150.194241046|xin hai ge ming;
心灰意冷__心灰意冷 169.070402749|xin hui yi leng;
心肌梗塞__心肌梗塞 121.066816454|xin ji geng se;
心急如焚__心急如焚 105.295633316|xin ji ru fen;
心惊肉跳__心驚肉跳 119.56748386|xin jing rou tiao;
辛勤劳动__辛勤勞動 111.507918629|xin qin lao dong;
心情不好__心情不好 462.187920882|xin qing bu hao;
心血来潮__心血來潮 210.270405333|xin xue lai chao;
信息披露__信息披露 380.057830188|xin xi pi lu;
信息平台__信息平台 188.901181552|xin xi ping tai;
信息发布__信息發布 354.43965395|xin xi fa bu;
信息服务__信息服務 845.867144221|xin xi fu wu;
信息内容__信息內容 142.713135632|xin xi nei rong;
信息来源__信息來源 108.763116896|xin xi lai yuan;
信息管理__信息管理 206.119414554|xin xi guan li;
信息共享__信息共享 156.109948588|xin xi gong xiang;
信息技术__信息技術 1027.37704867|xin xi ji shu;
信息交流__信息交流 186.561765129|xin xi jiao liu;
信息系统__信息系統 747.692521253|xin xi xi tong;
信息中心__信息中心 630.344829195|xin xi zhong xin;
信息传播__信息傳播 114.607273411|xin xi chuan bo;
信息传递__信息傳遞 138.163289429|xin xi chuan di;
信息产业__信息產業 330.548296374|xin xi chan ye;
信息处理__信息處理 111.230349808|xin xi chu li;
信息时代__信息時代 176.60772663|xin xi shi dai;
欣喜若狂__欣喜若狂 140.594881376|xin xi ruo kuang;
信息资源__信息資源 383.387639617|xin xi zi yuan;
信息网络__信息網絡 242.066179876|xin xi wang luo;
信息安全__信息安全 410.07479966|xin xi an quan;
心想事成__心想事成 120.916041011|xin xiang shi cheng;
辛辛苦苦__辛辛苦苦 406.006938516|xin xin ku ku;
欣欣向荣__欣欣向榮 132.10198647|xin xin xiang rong;
信心十足__信心十足 156.109948588|xin xin shi zu;
新兴产业__新興產業 116.47905068|xin xing chan ye;
新形势下__新形勢下 365.655730945|xin xing shi xia;
新兴市场__新興市場 282.868455943|xin xing shi chang;
心照不宣__心照不宣 115.036534536|xin zhao bu xuan;
心知肚明__心知肚明 158.067510349|xin zhi du ming;
心中有数__心中有數 120.615053212|xin zhong you shu;
新陈代谢__新陳代謝 790.819158167|xin chen dai xie;
新生事物__新生事物 120.314814642|xin sheng shi wu;
信誓旦旦__信誓旦旦 224.06783424|xin shi dan dan;
心有灵犀__心有靈犀 157.67404401|xin you ling xi;
心有余悸__心有餘悸 146.679837233|xin you yu ji;
信用担保__信用擔保 105.821807183|xin yong dan bao;
信用体系__信用體系 138.680779525|xin yong ti xi;
新闻报道__新聞報道 376.287731462|xin wen bao dao;
新闻频道__新聞頻道 120.164975734|xin wen pin dao;
新闻媒体__新聞媒體 644.643863216|xin wen mei ti;
新闻发布__新聞發布 124.587019602|xin wen fa bu;
新闻联播__新聞聯播 360.677581637|xin wen lian bo;
新闻记者__新聞記者 138.680779525|xin wen ji zhe;
新闻中心__新聞中心 307.117053725|xin wen zhong xin;
新闻出版__新聞出版 155.72135507|xin wen chu ban;
新闻自由__新聞自由 113.895394799|xin wen zi you;
新闻网站__新聞網站 115.899886195|xin wen wang zhan;
心安理得__心安理得 189.845141544|xin an li de;
新奥尔良__新奧爾良 125.678566729|xin ao er liang;
兴奋不已__興奮不已 139.200207879|xing fen bu yi;
幸福生活__幸福生活 327.677408739|xing fu sheng huo;
行动计划__行動計劃 205.094534596|xing dong ji hua;
型糖尿病__型糖尿病 108.222318063|xing tang niao bing;
形同虚设__形同虛設 124.276893895|xing tong xu she;
性能指标__性能指標 123.967540162|xing neng zhi biao;
性能测试__性能測試 121.217779906|xing neng ce shi;
性能研究__性能研究 107.015331962|xing neng yan jiu;
性关节炎__性關節炎 184.251320835|xing guan jie yan;
星光大道__星光大道 178.155043976|xing guang da dao;
兴高采烈__興高采烈 245.407229187|xing gao cai lie;
星级酒店__星級酒店 149.447435764|xing ji jiu dian;
星际争霸__星際爭霸 253.804804573|xing ji zheng ba;
性价比高__性價比高 113.753550575|xing jia bi gao;
性情中人__性情中人 131.937467932|xing qing zhong ren;
兴趣爱好__興趣愛好 185.402943996|xing qu ai hao;
刑讯逼供__刑訊逼供 117.061109314|xing xun bi gong;
形象大使__形象大使 131.117943492|xing xiang da shi;
形形色色__形形色色 311.355949144|xing xing se se;
行政部门__行政部門 868.29524729|xing zheng bu men;
行政法规__行政法規 263.801426189|xing zheng fa gui;
行政复议__行政複議 276.249600432|xing zheng fu yi;
行政管理__行政管理 631.130833438|xing zheng guan li;
行政机关__行政機關 595.969520633|xing zheng ji guan;
行政权力__行政權力 138.680779525|xing zheng quan li;
行政区划__行政區劃 167.601987591|xing zheng qu hua;
行政区域__行政區域 317.626273928|xing zheng qu yu;
行政行为__行政行為 168.439513167|xing zheng xing wei;
行政许可__行政許可 445.228026075|xing zheng xu ke;
行政长官__行政長官 157.2815571|xing zheng zhang guan;
行政执法__行政執法 634.284663664|xing zheng zhi fa;
行政主管__行政主管 279.365316864|xing zheng zhu guan;
行政处罚__行政處罰 490.066643104|xing zheng chu fa;
行政处分__行政處分 116.624293448|xing zheng chu fen;
行政审批__行政審批 256.347723437|xing zheng shen pi;
行政事业__行政事業 128.369448119|xing zheng shi ye;
行政诉讼__行政訴訟 227.160466527|xing zheng su song;
兴致勃勃__興緻勃勃 261.510250403|xing zhi bo bo;
行之有效__行之有效 290.368691563|xing zhi you xiao;
形成机制__形成機制 127.572086295|xing cheng ji zhi;
刑事犯罪__刑事犯罪 109.989815613|xing shi fan zui;
形式多样__形式多樣 153.41002317|xing shi duo yang;
刑事拘留__刑事拘留 180.839193473|xing shi ju liu;
形式主义__形式主義 159.452390871|xing shi zhu yi;
刑事责任__刑事責任 214.2378495|xing shi ze ren;
行尸走肉__行屍走肉 111.091824605|xing shi zou rou;
刑事诉讼__刑事訴訟 115.323601467|xing shi su song;
刑事案件__刑事案件 269.449631503|xing shi an jian;
幸灾乐祸__幸災樂禍 277.284292303|xing zai le huo;
行云流水__行雲流水 120.015323434|xing yun liu shui;
兴业银行__興業銀行 241.764712994|xing ye yin hang;
性阴道炎__性陰道炎 167.601987591|xing yin dao yan;
行为规范__行為規範 171.403948695|xing wei gui fan;
行为准则__行為準則 121.520271774|xing wei zhun ze;
行为艺术__行為藝術 157.085680168|xing wei yi shu;
形而上学__形而上學 128.850255419|xing er shang xue;
兄弟姐妹__兄弟姐妹 740.275558891|xiong di jie mei;
雄心勃勃__雄心勃勃 126.621787068|xiong xin bo bo;
胸有成竹__胸有成竹 110.815291538|xiong you cheng zhu;
休息时间__休息時間 220.742053181|xiu xi shi jian;
休息一下__休息一下 316.83562918|xiu xi yi xia;
休闲度假__休閑度假 113.046974828|xiu xian du jia;
休闲娱乐__休閑娛樂 224.347234118|xiu xian yu le;
修身养性__修身養性 106.748946222|xiu shen yang xing;
需不需要__需不需要 217.465635832|xu bu xu yao;
畜牧兽医__畜牧獸醫 111.925571131|xu mu shou yi;
虚拟内存__虛擬內存 236.402059204|xu ni nei cun;
虚拟光驱__虛擬光驅 205.350275845|xu ni guang qu;
虚拟货币__虛擬貨幣 113.47039186|xu ni huo bi;
虚拟主机__虛擬主機 542.11647303|xu ni zhu ji;
虚拟世界__虛擬世界 197.568631008|xu ni shi jie;
虚假广告__虛假廣告 127.413209251|xu jia guang gao;
需求分析__需求分析 139.373782642|xu qiu fen xi;
许许多多__許許多多 401.478808454|xu xu duo duo;
栩栩如生__栩栩如生 167.184787749|xu xu ru sheng;
蓄势待发__蓄勢待發 115.467403456|xu shi dai fa;
需要帮助__需要幫助 418.854838101|xu yao bang zhu;
需要注意__需要注意 461.61231651|xu yao zhu yi;
需要什么__需要什麼 324.83145542|xu yao shen me;
需要时间__需要時間 288.924902033|xu yao shi jian;
抓紧时间__抓緊時間 370.702589737|zhua jin shi jian;
抓住机遇__抓住機遇 145.224802174|zhua zhu ji yu;
专门从事__專門從事 175.948711373|zhuan men cong shi;
专题讲座__專題講座 105.426930997|zhuan ti jiang zuo;
专题研究__專題研究 125.36572391|zhuan ti yan jiu;
转来转去__轉來轉去 125.053659829|zhuan lai zhuan qu;
专利技术__專利技術 222.953710017|zhuan li ji shu;
专利申请__專利申請 164.293322714|zhuan li shen qing;
专辑介绍__專輯介紹 154.561368684|zhuan ji jie shao;
专家分析__專家分析 132.431639237|zhuan jia fen xi;
专家提醒__專家提醒 160.049619219|zhuan jia ti xing;
专家建议__專家建議 217.19480623|zhuan jia jian yi;
专家介绍__專家介紹 140.419785869|zhuan jia jie shao;
专家学者__專家學者 472.083744072|zhuan jia xue zhe;
专家认为__專家認為 395.519762073|zhuan jia ren wei;
专项检查__專項檢查 229.150692759|zhuan xiang jian cha;
专项整治__專項整治 423.051424808|zhuan xiang zheng zhi;
专项治理__專項治理 155.72135507|zhuan xiang zhi li;
专项资金__專項資金 401.979429753|zhuan xiang zi jin;
专业毕业__專業畢業 124.431860131|zhuan ye bi ye;
专业培训__專業培訓 117.353228453|zhuan ye pei xun;
专业服务__專業服務 160.849404779|zhuan ye fu wu;
专业技能__專業技能 156.89004718|zhuan ye ji neng;
专业技术__專業技術 330.136634719|zhuan ye ji shu;
专业知识__專業知識 611.009712747|zhuan ye zhi shi;
专业生产__專業生產 354.881620091|zhuan ye sheng chan;
专业市场__專業市場 137.819369268|zhuan ye shi chang;
专业人士__專業人士 690.376548199|zhuan ye ren shi;
专业人才__專業人才 258.271618599|zhuan ye ren cai;
专业人员__專業人員 487.62990282|zhuan ye ren yuan;
专业从事__專業從事 231.446597362|zhuan ye cong shi;
转移支付__轉移支付 203.313241605|zhuan yi zhi fu;
专用发票__專用發票 155.527421199|zhuan yong fa piao;
装机容量__裝機容量 157.870654598|zhuang ji rong liang;
装修公司__裝修公司 250.661599628|zhuang xiu gong si;
装饰公司__裝飾公司 242.670241844|zhuang shi gong si;
装饰装修__裝飾裝修 106.085879302|zhuang shi zhuang xiu;
装饰材料__裝飾材料 137.819369268|zhuang shi cai liao;
准备工作__準備工作 796.754272909|zhun bei gong zuo;
准备金率__準備金率 174.203334854|zhun bei jin lv;
扎扎实实__扎紮實實 220.742053181|zha zha shi shi;
扎实推进__紮實推進 212.641966978|zha shi tui jin;
债券基金__債券基金 108.087539034|zhai quan ji jin;
债券市场__債券市場 206.376433771|zhai quan shi chang;
债务重组__債務重組 111.925571131|zhai wu chong zu;
占地面积__佔地面積 272.828431509|zhan di mian ji;
斩钉截铁__斬釘截鐵 111.925571131|zhan ding jie tie;
战略目标__戰略目標 287.130256264|zhan lue mu biao;
战略规划__戰略規劃 153.028150386|zhan lue gui hua;
战略合作__戰略合作 199.299593609|zhan lue he zuo;
战略决策__戰略決策 125.053659829|zhan lue jue ce;
战略思想__戰略思想 163.680258901|zhan lue si xiang;
战略意义__戰略意義 126.149295342|zhan lue yi yi;
崭露头角__嶄露頭角 118.972962872|zhan lu tou jiao;
战战兢兢__戰戰兢兢 179.268563673|zhan zhan jing jing;
沾沾自喜__沾沾自喜 166.146325956|zhan zhan zi xi;
占用空间__佔用空間 199.299593609|zhan yong kong jian;
掌上电脑__掌上電腦 120.314814642|zhang shang dian nao;
招标投标__招標投標 118.676811842|zhao biao tou biao;
招标公告__招標公告 214.2378495|zhao biao gong gao;
招标文件__招標文件 194.636170786|zhao biao wen jian;
找不到了__找不到了 286.058823982|zhao bu dao le;
招聘信息__招聘信息 217.19480623|zhao pin xin xi;
召开会议__召開會議 213.704562287|zhao kai hui yi;
朝夕相处__朝夕相處 131.117943492|zhao xi xiang chu;
招商证券__招商證券 154.754097942|zhao shang zheng quan;
招商银行__招商銀行 852.21539528|zhao shang yin hang;
招商引资__招商引資 939.211122794|zhao shang yin zi;
招生考试__招生考試 130.141230764|zhao sheng kao shi;
招生计划__招生計劃 258.593668656|zhao sheng ji hua;
招生简章__招生簡章 140.945727665|zhao sheng jian zhang;
这部电影__這部電影 811.787668067|zhe bu dian ying;
这篇文章__這篇文章 1344.71347376|zhe pian wen zhang;
这么多年__這麼多年 1054.61787307|zhe me duo nian;
这么多人__這麼多人 653.541376022|zhe me duo ren;
这么简单__這麼簡單 493.744603771|zhe me jian dan;
这段时间__這段時間 1561.61561744|zhe duan shi jian;
这个名字__這個名字 887.99205879|zhe ge ming zi;
这个地方__這個地方 777.141921285|zhe ge di fang;
这个东西__這個東西 816.861571886|zhe ge dong xi;
这个女孩__這個女孩 244.491487214|zhe ge nv hai;
这个女人__這個女人 538.078184713|zhe ge nv ren;
这个男人__這個男人 508.100984482|zhe ge nan ren;
这个故事__這個故事 623.314694733|zhe ge gu shi;
这个国家__這個國家 479.196331601|zhe ge guo jia;
这个机会__這個機會 362.479927203|zhe ge ji hui;
这个家伙__這個傢伙 852.21539528|zhe ge jia huo;
这个夏天__這個夏天 127.890434962|zhe ge xia tian;
这个消息__這個消息 463.919044053|zhe ge xiao xi;
这个城市__這個城市 753.303969661|zhe ge cheng shi;
这个时代__這個時代 409.054029297|zhe ge shi dai;
这个时候__這個時候 2238.62771494|zhe ge shi hou;
这个世界__這個世界 1701.83388383|zhe ge shi jie;
这个数字__這個數字 422.52456065|zhe ge shu zi;
这个游戏__這個遊戲 412.637883794|zhe ge you xi;
这个网站__這個網站 578.409173188|zhe ge wang zhan;
这个问题__這個問題 4153.542672|zhe ge wen ti;
这个文件__這個文件 348.309611377|zhe ge wen jian;
这件事情__這件事情 1085.28250327|zhe jian shi qing;
浙江大学__浙江大學 415.734739962|zhe jiang da xue;
这就是说__這就是說 107.282382453|zhe jiu shi shuo;
这些都是__這些都是 1046.76190254|zhe xie dou shi;
这些东西__這些東西 981.082073059|zhe xie dong xi;
这些问题__這些問題 1130.84350481|zhe xie wen ti;
这张专辑__這張專輯 415.734739962|zhe zhang zhuan ji;
遮遮掩掩__遮遮掩掩 119.716577729|zhe zhe yan yan;
这种方法__這種方法 679.282440527|zhe zhong fang fa;
这种方式__這種方式 738.432842998|zhe zhong fang shi;
这种感觉__這種感覺 604.948616891|zhe zhong gan jue;
这种情况__這種情況 2470.2273797|zhe zhong qing kuang;
这种事情__這種事情 703.402776999|zhe zhong shi qing;
这主要是__這主要是 248.175085992|zhe zhu yao shi;
这是什么__這是什麼 524.179602378|zhe shi shen me;
这是一个__這是一個 2865.10217964|zhe shi yi ge;
这是一种__這是一種 983.530305889|zhe shi yi zhong;
这首歌曲__這首歌曲 136.282292017|zhe shou ge qu;
这样才能__這樣才能 661.736546275|zhe yang cai neng;
这样一来__這樣一來 457.603107852|zhe yang yi lai;
这一切都__這一切都 516.399339766|zhe yi qie dou;
真不知道__真不知道 842.710774091|zhen bu zhi dao;
针锋相对__針鋒相對 159.85029497|zhen feng xiang dui;
珍惜生命__珍惜生命 110.126966673|zhen xi sheng ming;
真真切切__真真切切 110.677283245|zhen zhen qie qie;
真正做到__真正做到 303.691826638|zhen zheng zuo dao;
真正原因__真正原因 143.605133321|zhen zheng yuan yin;
真实情况__真實情況 194.878871049|zhen shi qing kuang;
真实写照__真實寫照 117.499561272|zhen shi xie zhao;
真实姓名__真實姓名 163.272821143|zhen shi xing ming;
真实身份__真實身份 149.633788238|zhen shi shen fen;
证明材料__證明材料 212.907119447|zheng ming cai liao;
证明文件__證明文件 141.650048976|zheng ming wen jian;
政府部门__政府部門 1162.27522076|zheng fu bu men;
政府投资__政府投資 123.967540162|zheng fu tou zi;
政府官员__政府官員 533.404852483|zheng fu guan yuan;
政府工作__政府工作 137.305093541|zheng fu gong zuo;
政府机关__政府機關 281.111429553|zheng fu ji guan;
政府机构__政府機構 261.184568064|zheng fu ji gou;
政府职能__政府職能 131.937467932|zheng fu zhi neng;
政府采购__政府採購 768.474582473|zheng fu cai gou;
政府网站__政府網站 227.160466527|zheng fu wang zhan;
整体规划__整體規劃 105.426930997|zheng ti gui hua;
整体上市__整體上市 584.204365283|zheng ti shang shi;
整体素质__整體素質 245.407229187|zheng ti su zhi;
整改措施__整改措施 130.791560815|zheng gai cuo shi;
整个过程__整個過程 426.757915008|zheng ge guo cheng;
整个世界__整個世界 429.425273358|zheng ge shi jie;
睁开眼睛__睜開眼睛 339.31275934|zheng kai yan jing;
证券投资__證券投資 505.574572707|zheng quan tou zi;
证券公司__證券公司 874.811821743|zheng quan gong si;
证券交易__證券交易 254.438159592|zheng quan jiao yi;
证券市场__證券市場 769.432826682|zheng quan shi chang;
正确答案__正確答案 143.605133321|zheng que da an;
正确对待__正確對待 119.121315407|zheng que dui dai;
正确处理__正確處理 253.804804573|zheng que chu li;
正确认识__正確認識 223.788782324|zheng que ren shi;
征求意见__徵求意見 318.418891685|zheng qiu yi jian;
争先恐后__爭先恐後 193.90988203|zheng xian kong hou;
政协工作__政協工作 151.699065864|zheng xie gong zuo;
政协主席__政協主席 141.650048976|zheng xie zhu xi;
政协委员__政協委員 765.607004232|zheng xie wei yuan;
整整齐齐__整整齊齊 114.46454262|zheng zheng qi qi;
蒸蒸日上__蒸蒸日上 154.561368684|zheng zheng ri shang;
政治斗争__政治鬥爭 110.539446825|zheng zhi dou zheng;
政治体制__政治體制 151.888225993|zheng zhi ti zhi;
整治工作__整治工作 165.32020271|zheng zhi gong zuo;
政治经济__政治經濟 129.494134325|zheng zhi jing ji;
政治权利__政治權利 122.890853693|zheng zhi quan li;
政治制度__政治制度 200.29551561|zheng zhi zhi du;
政治生活__政治生活 118.824795093|zheng zhi sheng huo;
政治人物__政治人物 120.615053212|zheng zhi ren wu;
政治任务__政治任務 121.368931601|zheng zhi ren wu;
政治文明__政治文明 121.368931601|zheng zhi wen ming;
政治委员__政治委員 121.520271774|zheng zhi wei yuan;
郑重声明__鄭重聲明 676.747684543|zheng zhong sheng ming;
正常工作__正常工作 315.260239073|zheng chang gong zuo;
正常使用__正常使用 324.83145542|zheng chang shi yong;
正常运行__正常運行 322.010219858|zheng chang yun xing;
正式发布__正式發布 253.488718522|zheng shi fa bu;
正式开始__正式開始 358.884197808|zheng shi kai shi;
正式启动__正式啟動 440.262469534|zheng shi qi dong;
正式成立__正式成立 242.670241844|zheng shi cheng li;
正式实施__正式實施 143.426288875|zheng shi shi shi;
正在进行__正在進行 709.565515965|zheng zai jin xing;
正在运行__正在運行 116.044406778|zheng zai yun xing;
政策法规__政策法規 332.200082586|zheng ce fa gui;
政策规定__政策規定 163.680258901|zheng ce gui ding;
政策环境__政策環境 105.821807183|zheng ce huan jing;
政策措施__政策措施 367.482952871|zheng ce cuo shi;
政务公开__政務公開 287.488291405|zheng wu gong kai;
正儿八经__正兒八經 116.769717326|zheng er ba jing;
指标体系__指標體系 224.907079496|zhi biao ti xi;
知不知道__知不知道 540.767020614|zhi bu zhi dao;
支部书记__支部書記 140.070248771|zhi bu shu ji;
知名品牌__知名品牌 409.054029297|zhi ming pin pai;
知名企业__知名企業 286.415523108|zhi ming qi ye;
知名人士__知名人士 136.112567367|zhi ming ren shi;
执法部门__執法部門 210.532600599|zhi fa bu men;
执法检查__執法檢查 215.30841961|zhi fa jian cha;
执法人员__執法人員 635.075580657|zhi fa ren yuan;
指导老师__指導老師 105.558392399|zhi dao lao shi;
指导工作__指導工作 169.492308033|zhi dao gong zuo;
指导学生__指導學生 113.187937993|zhi dao xue sheng;
直到现在__直到現在 476.219822262|zhi dao xian zai;
知道自己__知道自己 1887.28302677|zhi dao zi ji;
指导思想__指導思想 502.434215952|zhi dao si xiang;
指导意见__指導意見 190.793818607|zhi dao yi jian;
指导意义__指導意義 157.477678279|zhi dao yi yi;
值得关注__值得關注 397.496217848|zhi de guan zhu;
值得期待__值得期待 271.133768339|zhi de qi dai;
值得信赖__值得信賴 169.492308033|zhi de xin lai;
值得注意__值得注意 415.216987933|zhi de zhu yi;
值得一提__值得一提 484.601008682|zhi de yi ti;
值得一看__值得一看 145.768741141|zhi de yi kan;
制度改革__制度改革 365.20034683|zhi du gai ge;
制度建设__制度建設 396.506758465|zhi du jian she;
制度创新__制度創新 199.051387821|zhi du chuang xin;
志同道合__志同道合 324.426913464|zhi tong dao he;
职能部门__職能部門 595.22730595|zhi neng bu men;
智能手机__智能手機 703.402776999|zhi neng shou ji;
支离破碎__支離破碎 179.71591787|zhi li po sui;
治理结构__治理結構 116.333988795|zhi li jie gou;
治疗慢性__治療慢性 197.568631008|zhi liao man xing;
治疗方法__治療方法 385.78392141|zhi liao fang fa;
治疗方案__治療方案 149.633788238|zhi liao fang an;
治疗效果__治療效果 227.443722742|zhi liao xiao guo;
治疗小儿__治療小兒 136.282292017|zhi liao xiao er;
质量保证__質量保證 189.608710238|zhi liang bao zheng;
质量标准__質量標準 232.603161479|zhi liang biao zhun;
质量管理__質量管理 345.284462654|zhi liang guan li;
质量控制__質量控制 291.819695868|zhi liang kong zhi;
质量监督__質量監督 169.703655326|zhi liang jian du;
质量检测__質量檢測 109.30661816|zhi liang jian ce;
质量问题__質量問題 620.215410078|zhi liang wen ti;
质量安全__質量安全 328.086003878|zhi liang an quan;
至关重要__至關重要 789.834279627|zhi guan zhong yao;
至高无上__至高無上 166.560934377|zhi gao wu shang;
职工工资__職工工資 106.483223576|zhi gong gong zi;
指挥中心__指揮中心 225.749468142|zhi hui zhong xin;
知己知彼__知己知彼 115.467403456|zhi ji zhi bi;
直接点击__直接點擊 115.323601467|zhi jie dian ji;
直接投资__直接投資 256.028470459|zhi jie tou zi;
直截了当__直截了當 148.149450567|zhi jie liao dang;
直接关系__直接關係 380.531740742|zhi jie guan xi;
直接进入__直接進入 241.764712994|zhi jie jin ru;
直接影响__直接影響 710.450303909|zhi jie ying xiang;
支气管炎__支氣管炎 118.529012887|zhi qi guan yan;
执行董事__執行董事 172.690339006|zhi xing dong shi;
执行过程__執行過程 109.442917312|zhi xing guo cheng;
执行情况__執行情況 224.626982392|zhi xing qing kuang;
执政能力__執政能力 217.465635832|zhi zheng neng li;
执政为民__執政為民 136.452228303|zhi zheng wei min;
置之不理__置之不理 131.117943492|zhi zhi bu li;
指指点点__指指點點 123.197520618|zhi zhi dian dian;
支柱产业__支柱產業 381.481335404|zhi zhu chan ye;
纸上谈兵__紙上談兵 125.678566729|zhi shang tan bing;
直升飞机__直升飛機 132.266710153|zhi sheng fei ji;
知识分子__知識分子 1240.08526378|zhi shi fen zi;
知识管理__知識管理 194.636170786|zhi shi guan li;
知识结构__知識結構 149.820373083|zhi shi jie gou;
知识经济__知識經濟 149.447435764|zhi shi jing ji;
知识竞赛__知識競賽 135.098649108|zhi shi jing sai;
知识产权__知識產權 1629.20244568|zhi shi chan quan;
炙手可热__炙手可熱 181.516526012|zhi shou ke re;
指手画脚__指手畫腳 123.504952812|zhi shou hua jiao;
指数基金__指數基金 133.259374649|zhi shu ji jin;
指日可待__指日可待 155.333728851|zhi ri ke dai;
制造工艺__製造工藝 151.510141313|zhi zao gong yi;
制造技术__製造技術 136.452228303|zhi zao ji shu;
制造企业__製造企業 245.101601395|zhi zao qi ye;
制作方法__製作方法 166.560934377|zhi zuo fang fa;
制作工艺__製作工藝 134.42690308|zhi zuo gong yi;
制作过程__製作過程 143.963491517|zhi zuo guo cheng;
志愿服务__志願服務 238.473254015|zhi yuan fu wu;
直言不讳__直言不諱 133.093414711|zhi yan bu hui;
职业培训__職業培訓 202.807148249|zhi ye pei xun;
职业发展__職業發展 152.457122789|zhi ye fa zhan;
职业道德__職業道德 478.599545119|zhi ye dao de;
职业规划__職業規劃 141.29744947|zhi ye gui hua;
职业技能__職業技能 146.679837233|zhi ye ji neng;
职业教育__職業教育 590.057620516|zhi ye jiao yu;
职业介绍__職業介紹 145.405889264|zhi ye jie shao;
职业学校__職業學校 173.553291634|zhi ye xue xiao;
职业学院__職業學院 148.519148841|zhi ye xue yuan;
职业生涯__職業生涯 587.855808729|zhi ye sheng ya;
质优价廉__質優價廉 133.591915611|zhi you jia lian;
只有一次__只有一次 184.251320835|zhi you yi ci;
指纹识别__指紋識別 110.264288753|zhi wen shi bie;
职务犯罪__職務犯罪 150.007190589|zhi wu fan zui;
周边地区__周邊地區 292.912705474|zhou bian di qu;
周边国家__周邊國家 142.180598718|zhou bian guo jia;
周边环境__周邊環境 145.768741141|zhou bian huan jing;
周年纪念__周年紀念 187.26053154|zhou nian ji nian;
周年庆典__周年慶典 108.492380517|zhou nian qing dian;
州立大学__州立大學 108.087539034|zhou li da xue;
周围环境__周圍環境 159.651218957|zhou wei huan jing;
周而复始__周而復始 109.852835359|zhou er fu shi;
中部地区__中部地區 181.516526012|zhong bu di qu;
中部崛起__中部崛起 112.065135969|zhong bu jue qi;
中美关系__中美關係 210.795122809|zhong mei guan xi;
重大突破__重大突破 194.636170786|zhong da tu po;
重大决策__重大決策 191.747236314|zhong da jue ce;
重大项目__重大項目 226.030964922|zhong da xiang mu;
重大事件__重大事件 158.659551632|zhong da shi jian;
重大事项__重大事項 235.226605969|zhong da shi xiang;
重大意义__重大意義 215.040276584|zhong da yi yi;
重大影响__重大影響 227.727332161|zhong da ying xiang;
重大问题__重大問題 450.811022973|zhong da wen ti;
中低收入__中低收入 192.945711079|zhong di shou ru;
重点大学__重點大學 153.41002317|zhong dian da xue;
重点领域__重點領域 112.065135969|zhong dian ling yu;
重点工程__重點工程 251.287110964|zhong dian gong cheng;
重点工作__重點工作 215.040276584|zhong dian gong zuo;
重点建设__重點建設 129.979154132|zhong dian jian she;
重点企业__重點企業 177.933171406|zhong dian qi ye;
重点项目__重點項目 362.931919108|zhong dian xiang mu;
重点中学__重點中學 149.447435764|zhong dian zhong xue;
中东地区__中東地區 150.756793028|zhong dong di qu;
中南大学__中南大學 121.520271774|zhong nan da xue;
中年妇女__中年婦女 225.749468142|zhong nian fu nv;
中年男人__中年男人 150.569041974|zhong nian nan ren;
中年男子__中年男子 238.473254015|zhong nian nan zi;
中老年人__中老年人 166.353500999|zhong lao nian ren;
中共党员__中共黨員 125.678566729|zhong gong dang yuan;
中共中央__中共中央 857.541983893|zhong gong zhong yang;
中国北方__中國北方 111.786180106|zhong guo bei fang;
中国平安__中國平安 242.066179876|zhong guo ping an;
中国媒体__中國媒體 115.755545596|zhong guo mei ti;
中国发展__中國發展 173.769702743|zhong guo fa zhan;
中国大陆__中國大陸 1155.05579352|zhong guo da lu;
中国当代__中國當代 150.007190589|zhong guo dang dai;
中国第一__中國第一 550.284199441|zhong guo di yi;
中国电信__中國電信 803.734894488|zhong guo dian xin;
中国电影__中國電影 504.316081474|zhong guo dian ying;
中国台湾__中國台灣 138.508067822|zhong guo tai wan;
中国特色__中國特色 1777.70330251|zhong guo te se;
中国体育__中國體育 137.819369268|zhong guo ti yu;
中国女排__中國女排 222.121753798|zhong guo nv pai;
中国女人__中國女人 125.992190229|zhong guo nv ren;
中国女足__中國女足 278.669912425|zhong guo nv zu;
中国男篮__中國男籃 214.504991945|zhong guo nan lan;
中国男人__中國男人 184.251320835|zhong guo nan ren;
中国内地__中國內地 487.02261325|zhong guo nei di;
中国农民__中國農民 129.010924378|zhong guo nong min;
中国农村__中國農村 155.72135507|zhong guo nong cun;
中国铝业__中國鋁業 204.07475061|zhong guo lv ye;
中国历史__中國歷史 222.121753798|zhong guo li shi;
中国联通__中國聯通 633.494731672|zhong guo lian tong;
中国革命__中國革命 214.772467501|zhong guo ge ming;
中国公民__中國公民 307.500011268|zhong guo gong min;
中国公司__中國公司 252.85772688|zhong guo gong si;
中国古代__中國古代 612.534451685|zhong guo gu dai;
中国股市__中國股市 1005.84116282|zhong guo gu shi;
中国国际__中國國際 506.204995518|zhong guo guo ji;
中国国情__中國國情 213.438416689|zhong guo guo qing;
中国海军__中國海軍 175.292155245|zhong guo hai jun;
中国军队__中國軍隊 271.471856767|zhong guo jun dui;
中国建筑__中國建築 125.209594649|zhong guo jian zhu;
中国教育__中國教育 311.355949144|zhong guo jiao yu;
中国近代__中國近代 116.044406778|zhong guo jin dai;
中国进口__中國進口 114.037415895|zhong guo jin kou;
中国金融__中國金融 146.862738669|zhong guo jin rong;
中国经济__中國經濟 1611.03221293|zhong guo jing ji;
中国汽车__中國汽車 267.109399762|zhong guo qi che;
中国企业__中國企業 1244.72999861|zhong guo qi ye;
中国青年__中國青年 180.389043185|zhong guo qing nian;
中国学生__中國學生 342.285588041|zhong guo xue sheng;
中国西部__中國西部 128.369448119|zhong guo xi bu;
中国现代__中國現代 131.609045271|zhong guo xian dai;
中国政府__中國政府 1623.12304424|zhong guo zheng fu;
中国证券__中國證券 166.146325956|zhong guo zheng quan;
中国制造__中國製造 248.794392378|zhong guo zhi zao;
中国重汽__中國重汽 108.087539034|zhong guo zhong qi;
中国传统__中國傳統 503.060722916|zhong guo chuan tong;
中国城市__中國城市 147.964946673|zhong guo cheng shi;
中国出口__中國出口 171.190483873|zhong guo chu kou;
中国社会__中國社會 518.979844093|zhong guo she hui;
中国十大__中國十大 185.402943996|zhong guo shi da;
中国石化__中國石化 388.679238014|zhong guo shi hua;
中国市场__中國市場 1540.35530331|zhong guo shi chang;
中国石油__中國石油 567.697685436|zhong guo shi you;
中国人民__中國人民 1364.97342214|zhong guo ren min;
中国人口__中國人口 138.335571213|zhong guo ren kou;
中国人寿__中國人壽 369.319305625|zhong guo ren shou;
中国足球__中國足球 881.377303227|zhong guo zu qiu;
中国足协__中國足協 398.48814637|zhong guo zu xie;
中国最大__中國最大 329.314848809|zhong guo zui da;
中国最具__中國最具 118.972962872|zhong guo zui ju;
中国移动__中國移動 1250.95005139|zhong guo yi dong;
中国银行__中國銀行 863.977854874|zhong guo yin hang;
中国游客__中國遊客 119.56748386|zhong guo you ke;
中国邮政__中國郵政 109.034528882|zhong guo you zheng;
中国网民__中國網民 152.647228173|zhong guo wang min;
中国网通__中國網通 285.346757867|zhong guo wang tong;
中国文化__中國文化 785.907015785|zhong guo wen hua;
中国文学__中國文學 118.972962872|zhong guo wen xue;
中国未来__中國未來 108.898738333|zhong guo wei lai;
中华民国__中華民國 322.010219858|zhong hua min guo;
中华民族__中華民族 1703.95597413|zhong hua min zu;
中华文明__中華文明 166.768626413|zhong hua wen ming;
中华文化__中華文化 326.454673948|zhong hua wen hua;
中华儿女__中華兒女 110.95347192|zhong hua er nv;
终极目标__終極目標 105.295633316|zhong ji mu biao;
中级法院__中級法院 131.937467932|zhong ji fa yuan;
中介服务__中介服務 141.650048976|zhong jie fu wu;
中介公司__中介公司 299.1842072|zhong jie gong si;
中介机构__中介機構 440.811451858|zhong jie ji gou;
中介组织__中介組織 111.786180106|zhong jie zu zhi;
中金公司__中金公司 122.890853693|zhong jin gong si;
中青在线__中青在線 134.762357541|zhong qing zai xian;
中秋快乐__中秋快樂 260.859291326|zhong qiu kuai le;
中小企业__中小企業 2467.15098238|zhong xiao qi ye;
中小学校__中小學校 186.561765129|zhong xiao xue xiao;
中小学生__中小學生 497.450167612|zhong xiao xue sheng;
中小城市__中小城市 137.476305203|zhong xiao cheng shi;
中信泰富__中信泰富 105.558392399|zhong xin tai fu;
中心工作__中心工作 147.412812521|zhong xin gong zuo;
中心小学__中心小學 175.073848088|zhong xin xiao xue;
中信证券__中信證券 339.31275934|zhong xin zheng quan;
中心主任__中心主任 457.603107852|zhong xin zhu ren;
中心城市__中心城市 295.847453874|zhong xin cheng shi;
中心医院__中心醫院 157.085680168|zhong xin yi yuan;
中信银行__中信銀行 232.893204426|zhong xin yin hang;
中兴通讯__中興通訊 255.073095111|zhong xing tong xun;
种植面积__種植面積 267.44247003|zhong zhi mian ji;
众志成城__眾志成城 127.572086295|zhong zhi cheng cheng;
重中之重__重中之重 367.482952871|zhong zhong zhi zhong;
中产阶级__中產階級 315.653350706|zhong chan jie ji;
中超联赛__中超聯賽 159.253810404|zhong chao lian sai;
中山大学__中山大學 369.319305625|zhong shan da xue;
中山公园__中山公園 177.933171406|zhong shan gong yuan;
众说纷纭__眾說紛紜 142.357889859|zhong shuo fen yun;
中日关系__中日關係 284.281980745|zhong ri guan xi;
中资银行__中資銀行 147.780672558|zhong zi yin hang;
种族歧视__種族歧視 129.979154132|zhong zu qi shi;
中层干部__中層幹部 127.73116145|zhong ceng gan bu;
众所周知__眾所周知 563.46883971|zhong suo zhou zhi;
中央党校__中央黨校 184.02185602|zhong yang dang xiao;
中央领导__中央領導 228.8653107|zhong yang ling dao;
中央空调__中央空調 215.576896995|zhong yang kong tiao;
中央军委__中央軍委 273.168633085|zhong yang jun wei;
中央纪委__中央紀委 146.314717429|zhong yang ji wei;
中央企业__中央企業 275.218769535|zhong yang qi ye;
中央政府__中央政府 582.024395035|zhong yang zheng fu;
中央财政__中央財政 236.696839161|zhong yang cai zheng;
中央银行__中央銀行 268.444174826|zhong yang yin hang;
中央委员__中央委員 118.972962872|zhong yang wei yuan;
重要标志__重要標誌 150.569041974|zhong yao biao zhi;
重要地位__重要地位 201.547419552|zhong yao di wei;
重要途径__重要途徑 187.4940348|zhong yao tu jing;
重要内容__重要內容 530.091629029|zhong yao nei rong;
重要讲话__重要講話 459.317058623|zhong yao jiang hua;
重要举措__重要舉措 219.097720093|zhong yao ju cuo;
重要任务__重要任務 192.945711079|zhong yao ren wu;
重要作用__重要作用 734.761160623|zhong yao zuo yong;
重要思想__重要思想 508.734557585|zhong yao si xiang;
重要原因__重要原因 593.006203378|zhong yao yuan yin;
重要意义__重要意義 515.756221017|zhong yao yi yi;
重要因素__重要因素 524.833224606|zhong yao yin su;
重要问题__重要問題 152.647228173|zhong yao wen ti;
终于明白__終於明白 325.642053285|zhong yu ming bai;
终于找到__終於找到 414.183417482|zhong yu zhao dao;
中外合资__中外合資 141.826678552|zhong wai he zi;
中文论坛__中文論壇 105.164499152|zhong wen lun tan;
中文字幕__中文字幕 133.591915611|zhong wen zi mu;
中文域名__中文域名 105.690017726|zhong wen yu ming;
主办单位__主辦單位 245.407229187|zhu ban dan wei;
著名品牌__著名品牌 117.499561272|zhu ming pin pai;
著名导演__著名導演 141.650048976|zhu ming dao yan;
注明出处__註明出處 364.291279287|zhu ming chu chu;
著名作家__著名作家 159.253810404|zhu ming zuo jia;
住房贷款__住房貸款 121.823518492|zhu fang dai kuan;
住房问题__住房問題 167.810977762|zhu fang wen ti;
主导地位__主導地位 304.070513117|zhu dao di wei;
主导产品__主導產品 123.044091616|zhu dao chan pin;
主导产业__主導產業 184.02185602|zhu dao chan ye;
主导作用__主導作用 143.247667161|zhu dao zuo yong;
主题公园__主題公園 142.357889859|zhu ti gong yuan;
主题活动__主題活動 134.930398555|zhu ti huo dong;
主流媒体__主流媒體 248.175085992|zhu liu mei ti;
主管部门__主管部門 2412.42638506|zhu guan bu men;
主管机关__主管機關 116.044406778|zhu guan ji guan;
助学贷款__助學貸款 158.067510349|zhu xue dai kuan;
住宅小区__住宅小區 224.347234118|zhu zhai xiao qu;
主持会议__主持會議 182.196395498|zhu chi hui yi;
株式会社__株式會社 233.765505073|zhu shi hui she;
主任医师__主任醫師 203.313241605|zhu ren yi shi;
主任委员__主任委員 165.73274959|zhu ren wei yuan;
猪肉价格__豬肉價格 120.164975734|zhu rou jia ge;
诸如此类__諸如此類 191.031727675|zhu ru ci lei;
著作权人__著作權人 131.445140637|zhu zuo quan ren;
注册登记__註冊登記 210.532600599|zhu ce deng ji;
注册公司__註冊公司 111.925571131|zhu ce gong si;
注册会员__註冊會員 175.292155245|zhu ce hui yuan;
注册帐号__註冊帳號 170.339279748|zhu ce zhang hao;
注册商标__註冊商標 231.446597362|zhu ce shang biao;
注册日期__註冊日期 136.452228303|zhu ce ri qi;
注册资本__註冊資本 443.014235191|zhu ce zi ben;
注册资金__註冊資金 169.28122395|zhu ce zi jin;
注册用户__註冊用戶 462.764242999|zhu ce yong hu;
蛛丝马迹__蛛絲馬跡 160.649084484|zhu si ma ji;
主要包括__主要包括 579.852559389|zhu yao bao kuo;
主要表现__主要表現 461.61231651|zhu yao biao xian;
主要矛盾__主要矛盾 141.650048976|zhu yao mao dun;
主要目标__主要目標 186.561765129|zhu yao mu biao;
主要分布__主要分佈 168.859844103|zhu yao fen bu;
主要特点__主要特點 165.939408926|zhu yao te dian;
主要特征__主要特徵 130.954650472|zhu yao te zheng;
主要体现__主要體現 252.228305921|zhu yao ti xian;
主要内容__主要內容 759.903909096|zhu yao nei rong;
主要来源__主要來源 173.769702743|zhu yao lai yuan;
主要领导__主要領導 430.496878967|zhu yao ling dao;
主要功能__主要功能 203.820597887|zhu yao gong neng;
主要工作__主要工作 159.253810404|zhu yao gong zuo;
主要经营__主要經營 180.164388413|zhu yao jing ying;
主要职责__主要職責 118.08671951|zhu yao zhi ze;
主要产品__主要產品 236.991986692|zhu yao chan pin;
主要成分__主要成分 187.4940348|zhu yao cheng fen;
主要是指__主要是指 161.854759309|zhu yao shi zhi;
主要任务__主要任務 380.531740742|zhu yao ren wu;
主要责任__主要責任 123.044091616|zhu yao ze ren;
主要原料__主要原料 123.504952812|zhu yao yuan liao;
主要原因__主要原因 1502.43898348|zhu yao yuan yin;
主要演员__主要演員 105.558392399|zhu yao yan yuan;
主要业务__主要業務 138.163289429|zhu yao ye wu;
主要因素__主要因素 316.83562918|zhu yao yin su;
主要用于__主要用於 523.526794166|zhu yao yong yu;
主要问题__主要問題 372.555031371|zhu yao wen ti;
驻伊美军__駐伊美軍 116.47905068|zhu yi mei jun;
注意事项__注意事項 758.957532109|zhu yi shi xiang;
注意安全__注意安全 221.845125512|zhu yi an quan;
主营业务__主營業務 400.479435488|zhu ying ye wu;
捉襟见肘__捉襟見肘 122.127521944|zhuo jin jian zhou;
茁壮成长__茁壯成長 114.75018218|zhuo zhuang cheng zhang;
卓有成效__卓有成效 163.884358899|zhuo you cheng xiao;
追究责任__追究責任 434.268601197|zhui jiu ze ren;
追求完美__追求完美 151.888225993|zhui qiu wan mei;
喘不过气__喘不過氣 221.017305999|chuan bu guo qi;
传媒集团__傳媒集團 141.473639374|chuan mei ji tuan;
传递信息__傳遞信息 125.053659829|chuan di xin xi;
传统美德__傳統美德 150.194241046|chuan tong mei de;
传统媒体__傳統媒體 299.1842072|chuan tong mei ti;
传统观念__傳統觀念 154.561368684|chuan tong guan nian;
传统节日__傳統節日 228.8653107|chuan tong jie ri;
传统产业__傳統產業 199.299593609|chuan tong chan ye;
传统文化__傳統文化 748.624851411|chuan tong wen hua;
传世私服__傳世私服 113.32907693|chuan shi si fu;
传输速度__傳輸速度 125.992190229|chuan shu su du;
传输速率__傳輸速率 126.621787068|chuan shu su lv;
穿越时空__穿越時空 150.944778196|chuan yue shi kong;
创建工作__創建工作 166.146325956|chuang jian gong zuo;
创建活动__創建活動 174.42055653|chuang jian huo dong;
创建一个__創建一個 410.586139672|chuang jian yi ge;
创新发展__創新發展 118.08671951|chuang xin fa zhan;
创新能力__創新能力 447.452879516|chuang xin neng li;
创新精神__創新精神 266.444503116|chuang xin jing shen;
创新意识__創新意識 151.888225993|chuang xin yi shi;
床上用品__床上用品 117.93965545|chuang shang yong pin;
创造条件__創造條件 291.819695868|chuang zao tiao jian;
创造良好__創造良好 255.391156791|chuang zao liang hao;
创造价值__創造價值 172.260473089|chuang zao jia zhi;
创造财富__創造財富 150.756793028|chuang zao cai fu;
创业投资__創業投資 216.11485651|chuang ye tou zi;
创意产业__創意產業 177.711575153|chuang yi chan ye;
春暖花开__春暖花開 172.475272126|chun nuan hua kai;
春节包机__春節包機 128.689786556|chun jie bao ji;
春节期间__春節期間 365.20034683|chun jie qi jian;
春节晚会__春節晚會 170.977284899|chun jie wan hui;
春夏秋冬__春夏秋冬 139.026849285|chun xia qiu dong;
蠢蠢欲动__蠢蠢欲動 217.465635832|chun chun yu dong;
查看更多__查看更多 177.048440864|cha kan geng duo;
差强人意__差強人意 132.762114633|cha qiang ren yi;
查询结果__查詢結果 140.770195218|cha xun jie guo;
茶余饭后__茶餘飯後 111.646962678|cha yu fan hou;
产品开发__產品開發 300.679263607|chan pin kai fa;
产品价格__產品價格 532.077085292|chan pin jia ge;
产品结构__產品結構 239.366454718|chan pin jie gou;
产品介绍__產品介紹 126.937764318|chan pin jie shao;
产品经理__產品經理 139.895806636|chan pin jing li;
产品系列__產品系列 139.026849285|chan pin xi lie;
产品销售__產品銷售 249.415244207|chan pin xiao shou;
产品信息__產品信息 151.132997772|chan pin xin xi;
产品展示__產品展示 212.907119447|chan pin zhan shi;
产品质量__產品質量 1125.22065338|chan pin zhi liang;
产品创新__產品創新 121.671800659|chan pin chuang xin;
产品出口__產品出口 242.670241844|chan pin chu kou;
产品设计__產品設計 298.439468992|chan pin she ji;
产品市场__產品市場 123.351140937|chan pin shi chang;
产品研发__產品研發 170.551683166|chan pin yan fa;
产能过剩__產能過剩 159.651218957|chan neng guo sheng;
产生影响__產生影響 258.593668656|chan sheng ying xiang;
产业发展__產業發展 896.889021007|chan ye fa zhan;
产业基地__產業基地 220.742053181|chan ye ji di;
产业集群__產業集群 310.968189453|chan ye ji qun;
产业结构__產業結構 594.486015613|chan ye jie gou;
产业转移__產業轉移 197.076837307|chan ye zhuan yi;
产业政策__產業政策 237.287502254|chan ye zheng ce;
产业升级__產業升級 174.638049069|chan ye sheng ji;
长篇大论__長篇大論 119.56748386|chang pian da lun;
唱片公司__唱片公司 568.405572245|chang pian gong si;
长篇小说__長篇小說 283.927938713|chang pian xiao shuo;
长途电话__長途電話 105.821807183|chang tu dian hua;
厂家直销__廠家直銷 120.765453341|chang jia zhi xiao;
常见问题__常見問題 175.292155245|chang jian wen ti;
长江大桥__長江大橋 109.034528882|chang jiang da qiao;
长江电力__長江電力 150.381524744|chang jiang dian li;
长江流域__長江流域 134.762357541|chang jiang liu yu;
长江证券__長江證券 136.282292017|chang jiang zheng quan;
长期投资__長期投資 195.365179853|chang qi tou zi;
长期使用__長期使用 178.155043976|chang qi shi yong;
长期以来__長期以來 674.222387052|chang qi yi lai;
长效机制__長效機制 381.957020988|chang xiao ji zhi;
长此以往__長此以往 110.677283245|chang ci yi wang;
畅所欲言__暢所欲言 179.71591787|chang suo yu yan;
常务理事__常務理事 158.264611567|chang wu li shi;
常务会议__常務會議 180.164388413|chang wu hui yi;
长安福特__長安福特 174.42055653|chang an fu te;
朝核问题__朝核問題 124.587019602|chao he wen ti;
超级大国__超級大國 108.222318063|chao ji da guo;
超级兔子__超級兔子 188.430963124|chao ji tu zi;
超级女生__超級女生 124.122120652|chao ji nv sheng;
超级女声__超級女聲 385.303469841|chao ji nv sheng;
超级无敌__超級無敵 113.32907693|chao ji wu di;
朝鲜半岛__朝鮮半島 243.57916235|chao xian ban dao;
朝鲜战争__朝鮮戰爭 163.272821143|chao xian zhan zheng;
彻底解决__徹底解決 222.953710017|che di jie jue;
彻头彻尾__徹頭徹尾 151.321452046|che tou che wei;
车水马龙__車水馬龍 119.41857567|che shui ma long;
尘埃落定__塵埃落定 200.04606951|chen ai luo ding;
成百上千__成百上千 112.625137786|cheng bai shang qian;
成本控制__成本控制 171.403948695|cheng ben kong zhi;
成本核算__成本核算 118.529012887|cheng ben he suan;
瞠目结舌__瞠目結舌 146.862738669|cheng mu jie she;
承担责任__承擔責任 448.56947196|cheng dan ze ren;
成套设备__成套設備 109.30661816|cheng tao she bei;
成立以来__成立以來 252.54282031|cheng li yi lai;
城管执法__城管執法 113.47039186|cheng guan zhi fa;
成功经验__成功經驗 334.69325133|cheng gong jing yan;
成功举办__成功舉辦 296.216358865|cheng gong ju ban;
成功人士__成功人士 249.104624871|cheng gong ren shi;
成功案例__成功案例 149.820373083|cheng gong an li;
成吉思汗__成吉思汗 262.489736092|cheng ji si han;
成交价格__成交價格 156.89004718|cheng jiao jia ge;
成千上万__成千上萬 480.991159713|cheng qian shang wan;
城乡统筹__城鄉統籌 106.218162376|cheng xiang tong chou;
城乡规划__城鄉規劃 144.682892926|cheng xiang gui hua;
城乡居民__城鄉居民 290.368691563|cheng xiang ju min;
程序设计__程序設計 282.164331387|cheng xu she ji;
程序运行__程序運行 111.369047744|cheng xu yun xing;
成长过程__成長過程 182.651055928|cheng zhang guo cheng;
城镇居民__城鎮居民 466.818670029|cheng zhen ju min;
城镇职工__城鎮職工 121.823518492|cheng zhen zhi gong;
城市发展__城市發展 310.580912674|cheng shi fa zhan;
城市道路__城市道路 140.419785869|cheng shi dao lu;
城市管理__城市管理 270.122027271|cheng shi guan li;
城市规划__城市規劃 555.797602048|cheng shi gui hua;
城市环境__城市環境 122.432284019|cheng shi huan jing;
城市建设__城市建設 634.284663664|cheng shi jian she;
城市交通__城市交通 141.650048976|cheng shi jiao tong;
城市居民__城市居民 366.568203397|cheng shi ju min;
城市生活__城市生活 140.070248771|cheng shi sheng huo;
诚实守信__誠實守信 107.14877401|cheng shi shou xin;
城市人口__城市人口 109.852835359|cheng shi ren kou;
承受能力__承受能力 438.073368704|cheng shou neng li;
成人电影__成人電影 127.572086295|cheng ren dian ying;
成为现实__成為現實 170.127140854|cheng wei xian shi;
成为中国__成為中國 641.438524323|cheng wei zhong guo;
成为世界__成為世界 497.450167612|cheng wei shi jie;
成为一名__成為一名 286.058823982|cheng wei yi ming;
成为一种__成為一種 670.034480971|cheng wei yi zhong;
驰名商标__馳名商標 113.32907693|chi ming shang biao;
持股比例__持股比例 184.02185602|chi gu bi li;
吃苦耐劳__吃苦耐勞 162.663565352|chi ku nai lao;
吃喝玩乐__吃喝玩樂 226.595011951|chi he wan le;
持续发展__持續發展 400.978810625|chi xu fa zhan;
持续时间__持續時間 216.11485651|chi xu shi jian;
持续增长__持續增長 350.050152834|chi xu zeng zhang;
嗤之以鼻__嗤之以鼻 150.007190589|chi zhi yi bi;
持之以恒__持之以恆 241.764712994|chi zhi yi heng;
筹备工作__籌備工作 222.398727024|chou bei gong zuo;
筹集资金__籌集資金 128.689786556|chou ji zi jin;
抽样调查__抽樣調查 188.665925845|chou yang diao cha;
充满活力__充滿活力 269.114061535|chong man huo li;
充满希望__充滿希望 154.176629937|chong man xi wang;
充满信心__充滿信心 309.807805448|chong man xin xin;
充分发挥__充分發揮 1777.70330251|chong fen fa hui;
充分体现__充分體現 542.11647303|chong fen ti xian;
充分利用__充分利用 1236.99840673|chong fen li yong;
充分考虑__充分考慮 400.978810625|chong fen kao lv;
充分肯定__充分肯定 445.783200166|chong fen ken ding;
充分认识__充分認識 424.635962376|chong fen ren shi;
重复建设__重複建設 107.550099352|chong fu jian she;
重新开始__重新開始 353.998238229|chong xin kai shi;
重新回到__重新回到 271.471856767|chong xin hui dao;
重新启动__重新啟動 627.992684885|chong xin qi dong;
重新认识__重新認識 135.94305409|chong xin ren shi;
重新安装__重新安裝 269.114061535|chong xin an zhuang;
重装系统__重裝系統 320.010065926|chong zhuang xi tong;
重出江湖__重出江湖 110.401782066|chong chu jiang hu;
崇洋媚外__崇洋媚外 123.658956482|chong yang mei wai;
出版发行__出版發行 141.29744947|chu ban fa xing;
初步形成__初步形成 260.534419685|chu bu xing cheng;
初步研究__初步研究 138.680779525|chu bu yan jiu;
出门在外__出門在外 122.279808036|chu men zai wai;
出谋划策__出謀劃策 181.969489867|chu mou hua ce;
触目惊心__觸目驚心 255.709615075|chu mu jing xin;
初来乍到__初來乍到 107.952927857|chu lai zha dao;
出类拔萃__出類拔萃 166.146325956|chu lei ba cui;
处理方法__處理方法 231.735198139|chu li fang fa;
处理方式__處理方式 169.915266157|chu li fang shi;
处理能力__處理能力 215.30841961|chu li neng li;
处理技术__處理技術 109.852835359|chu li ji shu;
处理结果__處理結果 164.498187167|chu li jie guo;
处理意见__處理意見 138.335571213|chu li yi jian;
处理问题__處理問題 140.070248771|chu li wen ti;
初恋情人__初戀情人 108.087539034|chu lian qing ren;
出国留学__出國留學 279.365316864|chu guo liu xue;
出口退税__出口退稅 292.183578474|chu kou tui shui;
出口企业__出口企業 309.036622663|chu kou qi ye;
出口创汇__出口創匯 117.353228453|chu kou chuang hui;
出口产品__出口產品 181.969489867|chu kou chan pin;
出口商品__出口商品 128.049907079|chu kou shang pin;
出口日本__出口日本 204.329220247|chu kou ri ben;
出乎意料__出乎意料 298.06779536|chu hu yi liao;
初级阶段__初級階段 330.136634719|chu ji jie duan;
初具规模__初具規模 122.737806611|chu ju gui mo;
出其不意__出其不意 107.818484324|chu qi bu yi;
出席会议__出席會議 433.187606905|chu xi hui yi;
出现故障__出現故障 177.048440864|chu xian gu zhang;
出现错误__出現錯誤 134.930398555|chu xian cuo wu;
出现问题__出現問題 627.992684885|chu xian wen ti;
储蓄存款__儲蓄存款 118.23396695|chu xu cun kuan;
初中毕业__初中畢業 185.172044961|chu zhong bi ye;
出厂价格__出廠價格 156.499511818|chu chang jia ge;
出神入化__出神入化 119.26985293|chu shen ru hua;
出生年月__出生年月 118.381397999|chu sheng nian yue;
出生日期__出生日期 193.668388536|chu sheng ri qi;
出人头地__出人頭地 145.950506492|chu ren tou di;
出人意料__出人意料 339.31275934|chu ren yi liao;
出租汽车__出租汽車 162.86639759|chu zu qi che;
除此之外__除此之外 562.066236349|chu ci zhi wai;
绰绰有余__綽綽有餘 135.604660605|chuo chuo you yu;
垂头丧气__垂頭喪氣 110.126966673|chui tou sang qi;
顺利通过__順利通過 284.636464248|shun li tong guo;
顺利进行__順利進行 354.881620091|shun li jin xing;
顺理成章__順理成章 309.036622663|shun li cheng zhang;
顺利完成__順利完成 333.444336783|shun li wan cheng;
顺其自然__順其自然 520.274927886|shun qi zi ran;
杀毒软件__殺毒軟件 1467.28332601|sha du ruan jian;
莎士比亚__莎士比亞 246.019628549|sha shi bi ya;
山东大学__山東大學 168.020228531|shan dong da xue;
山东鲁能__山東魯能 147.412812521|shan dong lu neng;
闪亮登场__閃亮登場 116.044406778|shan liang deng chang;
善解人意__善解人意 254.121284766|shan jie ren yi;
闪闪发光__閃閃發光 116.044406778|shan shan fa guang;
上班时间__上班時間 279.017397997|shang ban shi jian;
商标注册__商標註冊 140.594881376|shang biao zhu ce;
上皮细胞__上皮細胞 107.818484324|shang pi xi bao;
商品价格__商品價格 195.60878915|shang pin jia ge;
商品经济__商品經濟 107.952927857|shang pin jing ji;
商品住房__商品住房 143.426288875|shang pin zhu fang;
商品住宅__商品住宅 212.377144726|shang pin zhu zhai;
商品市场__商品市場 110.539446825|shang pin shi chang;
上门服务__上門服務 153.41002317|shang men fu wu;
上当受骗__上當受騙 223.788782324|shang dang shou pian;
上投摩根__上投摩根 111.091824605|shang tou mo gen;
上流社会__上流社會 146.497163581|shang liu she hui;
上纲上线__上綱上線 115.323601467|shang gang shang xian;
上个世纪__上個世紀 391.108593802|shang ge shi ji;
上海浦东__上海浦東 134.092283643|shang hai pu dong;
上海大学__上海大學 107.550099352|shang hai da xue;
上海大众__上海大眾 399.482550191|shang hai da zhong;
上海地区__上海地區 159.253810404|shang hai di qu;
上海通用__上海通用 204.07475061|shang hai tong yong;
上海楼市__上海樓市 114.321989585|shang hai lou shi;
上海国际__上海國際 200.795341333|shang hai guo ji;
上海交大__上海交大 146.497163581|shang hai jiao da;
上海汽车__上海汽車 125.992190229|shang hai qi che;
上海车展__上海車展 165.526347625|shang hai che zhan;
伤痕累累__傷痕纍纍 181.290467084|shang hen lei lei;
上级领导__上級領導 153.028150386|shang ji ling dao;
赏心悦目__賞心悅目 224.626982392|shang xin yue mu;
上证指数__上證指數 407.527636023|shang zheng zhi shu;
上传图片__上傳圖片 117.646076559|shang chuan tu pian;
上上下下__上上下下 240.562595233|shang shang xia xia;
上市公司__上市公司 4279.6431141|shang shi gong si;
上市交易__上市交易 145.224802174|shang shi jiao yi;
上市时间__上市時間 112.906187218|shang shi shi jian;
上层建筑__上層建築 134.42690308|shang ceng jian zhu;
商业秘密__商業秘密 182.196395498|shang ye mi mi;
商业模式__商業模式 491.902185928|shang ye mo shi;
商业地产__商業地產 413.667597456|shang ye di chan;
商业公司__商業公司 135.604660605|shang ye gong si;
商业活动__商業活動 161.854759309|shang ye huo dong;
商业贿赂__商業賄賂 343.139741671|shang ye hui lu;
商业价值__商業價值 184.941433485|shang ye jia zhi;
商业企业__商業企業 116.624293448|shang ye qi ye;
商业中心__商業中心 201.296414343|shang ye zhong xin;
商业银行__商業銀行 1613.0410787|shang ye yin hang;
商业用途__商業用途 203.820597887|shang ye yong tu;
上网时间__上網時間 113.187937993|shang wang shi jian;
商务中心__商務中心 111.925571131|shang wu zhong xin;
商务人士__商務人士 193.668388536|shang wu ren shi;
少男少女__少男少女 142.180598718|shao nan shao nv;
少年儿童__少年兒童 244.186999878|shao nian er tong;
少数民族__少數民族 942.728934628|shao shu min zu;
社保基金__社保基金 321.609191441|she bao ji jin;
舍甫琴科__舍甫琴科 116.044406778|she fu qin ke;
社会保险__社會保險 585.662213047|she hui bao xian;
社会保障__社會保障 1087.99076217|she hui bao zhang;
社会矛盾__社會矛盾 234.348853194|she hui mao dun;
社会发展__社會發展 1058.56794047|she hui fa zhan;
社会风气__社會風氣 184.941433485|she hui feng qi;
社会福利__社會福利 278.322859608|she hui fu li;
社会服务__社會服務 129.979154132|she hui fu wu;
社会地位__社會地位 263.144763849|she hui di wei;
社会团体__社會團體 251.287110964|she hui tuan ti;
社会力量__社會力量 183.106850936|she hui li liang;
社会管理__社會管理 147.229226029|she hui guan li;
社会关系__社會關係 283.221176861|she hui guan xi;
社会各界__社會各界 900.248315564|she hui ge jie;
社会公平__社會公平 160.649084484|she hui gong ping;
社会公众__社會公眾 310.968189453|she hui gong zhong;
社会工作__社會工作 139.72158175|she hui gong zuo;
社会科学__社會科學 291.093289619|she hui ke xue;
社会环境__社會環境 340.583654043|she hui huan jing;
社会和谐__社會和諧 443.56664881|she hui he xie;
社会活动__社會活動 152.077621994|she hui huo dong;
社会结构__社會結構 151.699065864|she hui jie gou;
社会阶层__社會階層 116.044406778|she hui jie ceng;
社会进步__社會進步 253.488718522|she hui jin bu;
社会经济__社會經濟 397.496217848|she hui jing ji;
社会救助__社會救助 129.171793682|she hui jiu zhu;
社会学家__社會學家 123.658956482|she hui xue jia;
社会现象__社會現象 175.292155245|she hui xian xiang;
社会效益__社會效益 324.426913464|she hui xiao yi;
社会制度__社會制度 175.510734618|she hui zhi du;
社会秩序__社會秩序 222.67604562|she hui zhi xu;
社会治安__社會治安 423.051424808|she hui zhi an;
社会主义__社會主義 5511.52534746|she hui zhu yi;
社会生活__社會生活 433.727767276|she hui sheng huo;
社会实践__社會實踐 279.713669565|she hui shi jian;
社会事业__社會事業 233.765505073|she hui shi ye;
社会责任__社會責任 541.441326411|she hui ze ren;
社会资源__社會資源 181.290467084|she hui zi yuan;
社会组织__社會組織 148.704343794|she hui zu zhi;
社会影响__社會影響 146.497163581|she hui ying xiang;
社会稳定__社會穩定 559.968874971|she hui wen ding;
社会问题__社會問題 424.635962376|she hui wen ti;
社会文化__社會文化 147.229226029|she hui wen hua;
设计模式__設計模式 168.649547684|she ji mo shi;
设计方法__設計方法 116.47905068|she ji fang fa;
设计方案__設計方案 378.63963681|she ji fang an;
设计风格__設計風格 220.742053181|she ji feng ge;
设计大赛__設計大賽 115.899886195|she ji da sai;
设计单位__設計單位 112.34478795|she ji dan wei;
设计理念__設計理念 413.152419826|she ji li nian;
设计公司__設計公司 170.76435144|she ji gong si;
设计制作__設計製作 137.134095104|she ji zhi zuo;
设计人员__設計人員 216.654158472|she ji ren yuan;
设计要求__設計要求 105.164499152|she ji yao qiu;
社区服务__社區服務 161.250795044|she qu fu wu;
社区建设__社區建設 178.822323044|she qu jian she;
社区居民__社區居民 209.485777119|she qu ju min;
设身处地__設身處地 105.0335283|she shen chu di;
设施建设__設施建設 201.79873775|she shi jian she;
摄影记者__攝影記者 163.476413088|she ying ji zhe;
摄影作品__攝影作品 170.977284899|she ying zuo pin;
深不可测__深不可測 107.952927857|shen bu ke ce;
身不由己__身不由己 232.893204426|shen bu you ji;
审批程序__審批程序 116.769717326|shen pi cheng xu;
审批手续__審批手續 121.975425508|shen pi shou xu;
什么牌子__什麼牌子 196.096919422|shen me pai zi;
什么名字__什麼名字 175.292155245|shen me ming zi;
什么地方__什麼地方 1208.05380881|shen me di fang;
什么东东__什麼東東 151.699065864|shen me dong dong;
什么东西__什麼東西 1753.50110433|shen me dong xi;
什么关系__什麼關係 634.284663664|shen me guan xi;
什么叫做__什麼叫做 216.11485651|shen me jiao zuo;
什么情况__什麼情況 308.267359529|shen me qing kuang;
什么程度__什麼程度 259.885889675|shen me cheng du;
什么时候__什麼時候 6871.70932104|shen me shi hou;
什么时间__什麼時間 273.850309404|shen me shi jian;
什么事情__什麼事情 1123.81931445|shen me shi qing;
什么作用__什麼作用 140.070248771|shen me zuo yong;
什么原因__什麼原因 824.018360007|shen me yuan yin;
什么颜色__什麼顏色 160.849404779|shen me yan se;
什么样子__什麼樣子 807.751246202|shen me yang zi;
什么意思__什麼意思 2561.13118731|shen me yi si;
什么问题__什麼問題 987.214115061|shen me wen ti;
审美疲劳__審美疲勞 141.826678552|shen mei pi lao;
神秘面纱__神秘面紗 112.34478795|shen mi mian sha;
身份证明__身份證明 147.596627936|shen fen zheng ming;
身份证号__身份證號 181.742866823|shen fen zheng hao;
身份证件__身份證件 140.594881376|shen fen zheng jian;
身份验证__身份驗證 139.026849285|shen fen yan zheng;
神雕侠侣__神鵰俠侶 156.109948588|shen diao xia lv;
身体力行__身體力行 157.67404401|shen ti li xing;
身体健康__身體健康 932.214830498|shen ti jian kang;
身体状况__身體狀況 273.509258874|shen ti zhuang kuang;
身体素质__身體素質 234.056997396|shen ti su zhi;
身临其境__身臨其境 144.863304286|shen lin qi jing;
深刻理解__深刻理解 137.476305203|shen ke li jie;
深刻认识__深刻認識 156.304608838|shen ke ren shi;
深化改革__深化改革 188.430963124|shen hua gai ge;
审计报告__審計報告 169.492308033|shen ji bao gao;
审计工作__審計工作 193.668388536|shen ji gong zuo;
审计机关__審計機關 169.492308033|shen ji ji guan;
审计人员__審計人員 108.763116896|shen ji ren yuan;
神经末梢__神經末梢 129.171793682|shen jing mo shao;
神经系统__神經系統 272.828431509|shen jing xi tong;
神经衰弱__神經衰弱 154.947067523|shen jing shuai ruo;
神经网络__神經網絡 230.870473623|shen jing wang luo;
申请加入__申請加入 109.30661816|shen qing jia ru;
申请材料__申請材料 184.71110921|shen qing cai liao;
深信不疑__深信不疑 105.295633316|shen xin bu yi;
身心健康__身心健康 282.164331387|shen xin jian kang;
神州数码__神州數碼 221.568841736|shen zhou shu ma;
深入开展__深入開展 482.792710347|shen ru kai zhan;
深入浅出__深入淺出 142.357889859|shen ru qian chu;
深入人心__深入人心 365.20034683|shen ru ren xin;
深入研究__深入研究 301.805456692|shen ru yan jiu;
神采飞扬__神采飛揚 168.439513167|shen cai fei yang;
深层清洁__深層清潔 198.803491145|shen ceng qing jie;
深思熟虑__深思熟慮 162.258658377|shen si shu lv;
申银万国__申銀萬國 133.093414711|shen yin wan guo;
深有感触__深有感觸 133.42554153|shen you gan chu;
深恶痛绝__深惡痛絕 151.699065864|shen wu tong jue;
圣彼得堡__聖彼得堡 131.281440129|sheng bi de bao;
生不如死__生不如死 113.32907693|sheng bu ru si;
生命科学__生命科學 155.333728851|sheng ming ke xue;
生命周期__生命周期 286.415523108|sheng ming zhou qi;
生命中最__生命中最 207.925293333|sheng ming zhong zui;
生命危险__生命危險 269.449631503|sheng ming wei xian;
生命安全__生命安全 209.746993999|sheng ming an quan;
圣诞老人__聖誕老人 225.187525865|sheng dan lao ren;
圣诞快乐__聖誕快樂 169.915266157|sheng dan kuai le;
生态保护__生態保護 127.096048509|sheng tai bao hu;
生态农业__生態農業 147.045868173|sheng tai nong ye;
生态旅游__生態旅遊 181.290467084|sheng tai lv you;
生态环境__生態環境 1013.39002232|sheng tai huan jing;
生态建设__生態建設 175.948711373|sheng tai jian she;
生态系统__生態系統 351.799391968|sheng tai xi tong;
生态文明__生態文明 165.32020271|sheng tai wen ming;
省公安厅__省公安廳 323.216307961|sheng gong an ting;
生化危机__生化危機 242.972837869|sheng hua wei ji;
生活方式__生活方式 1224.72762648|sheng huo fang shi;
生活态度__生活態度 192.945711079|sheng huo tai du;
生活条件__生活條件 254.438159592|sheng huo tiao jian;
生活垃圾__生活垃圾 121.066816454|sheng huo la ji;
生活困难__生活困難 126.937764318|sheng huo kun nan;
生活环境__生活環境 368.399985048|sheng huo huan jing;
生活习惯__生活習慣 426.757915008|sheng huo xi guan;
生活质量__生活質量 507.468200425|sheng huo zhi liang;
生活水平__生活水平 512.55262135|sheng huo shui ping;
生活用品__生活用品 195.365179853|sheng huo yong pin;
省会城市__省會城市 177.490254874|sheng hui cheng shi;
生机勃勃__生機勃勃 130.46599058|sheng ji bo bo;
升级换代__升級換代 110.677283245|sheng ji huan dai;
省教育厅__省教育廳 302.935867929|sheng jiao yu ting;
生长发育__生長發育 353.117055307|sheng zhang fa yu;
生长因子__生長因子 118.08671951|sheng zhang yin zi;
生殖健康__生殖健康 120.765453341|sheng zhi jian kang;
生产方式__生產方式 213.172602547|sheng chan fang shi;
生产能力__生產能力 769.432826682|sheng chan neng li;
生产管理__生產管理 125.835280772|sheng chan guan li;
生产关系__生產關係 154.561368684|sheng chan guan xi;
生产工艺__生產工藝 321.208662461|sheng chan gong yi;
生产过程__生產過程 391.596284031|sheng chan guo cheng;
生产规模__生產規模 220.19257551|sheng chan gui mo;
生产基地__生產基地 850.094035423|sheng chan ji di;
生产计划__生產計劃 116.044406778|sheng chan ji hua;
生产技术__生產技術 333.444336783|sheng chan ji shu;
生产加工__生產加工 159.651218957|sheng chan jia gong;
生产经营__生產經營 758.012333731|sheng chan jing ying;
生产企业__生產企業 1119.62576025|sheng chan qi ye;
生产效率__生產效率 143.0692679|sheng chan xiao lv;
生产销售__生產銷售 170.76435144|sheng chan xiao shou;
生产制造__生產製造 118.676811842|sheng chan zhi zao;
生产厂家__生產廠家 519.626982517|sheng chan chang jia;
生产厂商__生產廠商 165.114314527|sheng chan chang shang;
生产车间__生產車間 120.314814642|sheng chan che jian;
生产成本__生產成本 424.635962376|sheng chan cheng ben;
生产设备__生產設備 244.491487214|sheng chan she bei;
生产日期__生產日期 147.045868173|sheng chan ri qi;
生产资料__生產資料 304.070513117|sheng chan zi liao;
生产总值__生產總值 214.2378495|sheng chan zong zhi;
生产要素__生產要素 242.066179876|sheng chan yao su;
省吃俭用__省吃儉用 120.615053212|sheng chi jian yong;
生生不息__生生不息 106.616002115|sheng sheng bu xi;
声势浩大__聲勢浩大 127.413209251|sheng shi hao da;
省人事厅__省人事廳 116.333988795|sheng ren shi ting;
生日礼物__生日禮物 294.009808944|sheng ri li wu;
生日快乐__生日快樂 1169.53977147|sheng ri kuai le;
生存空间__生存空間 190.793818607|sheng cun kong jian;
生存环境__生存環境 208.184564378|sheng cun huan jing;
生存状态__生存狀態 126.937764318|sheng cun zhuang tai;
省财政厅__省財政廳 139.373782642|sheng cai zheng ting;
声嘶力竭__聲嘶力竭 128.049907079|sheng si li jie;
生育保险__生育保險 119.86585751|sheng yu bao xian;
剩余价值__剩餘價值 121.671800659|sheng yu jia zhi;
省委常委__省委常委 177.048440864|sheng wei chang wei;
省卫生厅__省衛生廳 187.4940348|sheng wei sheng ting;
省委书记__省委書記 355.767206381|sheng wei shu ji;
生物工程__生物工程 144.863304286|sheng wu gong cheng;
生物化学__生物化學 114.75018218|sheng wu hua xue;
生物技术__生物技術 363.837594448|sheng wu ji shu;
生物柴油__生物柴油 151.510141313|sheng wu chai you;
生物医药__生物醫藥 120.615053212|sheng wu yi yao;
事半功倍__事半功倍 202.050369328|shi ban gong bei;
是不可能__是不可能 1260.33845835|shi bu ke neng;
视频播放__視頻播放 361.12732612|shi pin bo fang;
视频聊天__視頻聊天 135.773751924|shi pin liao tian;
视频格式__視頻格式 105.690017726|shi pin ge shi;
食品工业__食品工業 112.765574943|shi pin gong ye;
视频会议__視頻會議 181.969489867|shi pin hui yi;
食品加工__食品加工 150.194241046|shi pin jia gong;
视频教程__視頻教程 120.46484039|shi pin jiao cheng;
食品生产__食品生產 140.770195218|shi pin sheng chan;
食品药品__食品藥品 288.924902033|shi pin yao pin;
视频文件__視頻文件 242.36802267|shi pin wen jian;
食品卫生__食品衛生 178.155043976|shi pin wei sheng;
食品安全__食品安全 1220.1575309|shi pin an quan;
世贸组织__世貿組織 161.854759309|shi mao zu zhi;
十面埋伏__十面埋伏 145.405889264|shi mian mai fu;
市民政局__市民政局 109.30661816|shi min zheng ju;
实木地板__實木地板 148.704343794|shi mu di ban;
拭目以待__拭目以待 264.789493468|shi mu yi dai;
师范大学__師範大學 1058.56794047|shi fan da xue;
示范工程__示範工程 152.837570606|shi fan gong cheng;
示范基地__示範基地 191.031727675|shi fan ji di;
师范学院__師範學院 169.492308033|shi fan xue yuan;
十分之一__十分之一 231.735198139|shi fen zhi yi;
十分重要__十分重要 595.969520633|shi fen zhong yao;
是否符合__是否符合 253.488718522|shi fou fu he;
是否能够__是否能夠 314.867617017|shi fou neng gou;
是否正确__是否正確 227.727332161|shi fou zheng que;
是否存在__是否存在 373.950434882|shi fou cun zai;
时代背景__時代背景 116.624293448|shi dai bei jing;
时代广场__時代廣場 107.416157498|shi dai guang chang;
时代精神__時代精神 109.034528882|shi dai jing shen;
适得其反__適得其反 151.699065864|shi de qi fan;
失地农民__失地農民 183.106850936|shi di nong min;
试点工作__試點工作 415.734739962|shi dian gong zuo;
室内空气__室內空氣 130.46599058|shi nei kong qi;
室内设计__室內設計 200.04606951|shi nei she ji;
实力雄厚__實力雄厚 211.848489234|shi li xiong hou;
施工单位__施工單位 306.734573113|shi gong dan wei;
施工技术__施工技術 113.611883002|shi gong ji shu;
施工企业__施工企業 133.093414711|shi gong qi ye;
施工现场__施工現場 188.665925845|shi gong xian chang;
市工商局__市工商局 244.491487214|shi gong shang ju;
施工人员__施工人員 129.817279349|shi gong ren yuan;
事故现场__事故現場 135.435779871|shi gu xian chang;
适可而止__適可而止 127.254530072|shi ke er zhi;
实话实说__實話實說 361.577631409|shi hua shi shuo;
适合自己__適合自己 649.481929235|shi he zi ji;
视觉效果__視覺效果 304.070513117|shi jue xiao guo;
视觉冲击__視覺衝擊 125.36572391|shi jue chong ji;
实际工作__實際工作 294.009808944|shi ji gong zuo;
实际控制__實際控制 234.933657026|shi ji kong zhi;
实际情况__實際情況 1413.4416531|shi ji qing kuang;
实际行动__實際行動 473.851932013|shi ji xing dong;
实际出发__實際出發 212.907119447|shi ji chu fa;
实际操作__實際操作 316.046952528|shi ji cao zuo;
实际意义__實際意義 182.651055928|shi ji yi yi;
实际应用__實際應用 236.991986692|shi ji ying yong;
实际问题__實際問題 249.726250867|shi ji wen ti;
释迦牟尼__釋迦牟尼 120.765453341|shi jia mou ni;
石家庄市__石家莊市 250.661599628|shi jia zhuang shi;
时间比较__時間比較 137.476305203|shi jian bi jiao;
事件发生__事件發生 387.711726118|shi jian fa sheng;
实践能力__實踐能力 129.817279349|shi jian neng li;
实践活动__實踐活動 265.119670945|shi jian huo dong;
时间间隔__時間間隔 119.26985293|shi jian jian ge;
实践经验__實踐經驗 297.696584607|shi jian jing yan;
时间限制__時間限制 123.967540162|shi jian xian zhi;
实践证明__實踐證明 220.742053181|shi jian zheng ming;
时间最长__時間最長 138.335571213|shi jian zui chang;
时间安排__時間安排 205.350275845|shi jian an pai;
世界杯赛__世界盃賽 184.71110921|shi jie bei sai;
世界排名__世界排名 250.037645335|shi jie pai ming;
世界末日__世界末日 159.055477247|shi jie mo ri;
世界大战__世界大戰 154.176629937|shi jie da zhan;
世界第一__世界第一 499.935980841|shi jie di yi;
世界顶级__世界頂級 160.249192015|shi jie ding ji;
世界冠军__世界冠軍 351.799391968|shi jie guan jun;
世界各地__世界各地 953.361623425|shi jie ge di;
世界各国__世界各國 699.033618062|shi jie ge guo;
世界和平__世界和平 216.654158472|shi jie he ping;
世界纪录__世界紀錄 246.019628549|shi jie ji lu;
世界经济__世界經濟 517.043260448|shi jie jing ji;
世界知名__世界知名 123.504952812|shi jie zhi ming;
世界之窗__世界之窗 129.494134325|shi jie zhi chuang;
世界著名__世界著名 243.57916235|shi jie zhu ming;
世界上最__世界上最 1112.67124847|shi jie shang zui;
世界最大__世界最大 216.384339476|shi jie zui da;
世界一流__世界一流 300.304800557|shi jie yi liu;
世界遗产__世界遺產 127.73116145|shi jie yi chan;
世界银行__世界銀行 247.866011137|shi jie yin hang;
十九世纪__十九世紀 136.452228303|shi jiu shi ji;
十全十美__十全十美 176.387781073|shi quan shi mei;
诗情画意__詩情畫意 130.628674269|shi qing hua yi;
是真是假__是真是假 180.613978088|shi zhen shi jia;
市政工程__市政工程 108.087539034|shi zheng gong cheng;
时至今日__時至今日 175.510734618|shi zhi jin ri;
始终保持__始終保持 374.41672986|shi zhong bao chi;
是中国人__是中國人 590.793388895|shi zhong guo ren;
始终坚持__始終堅持 338.890182508|shi zhong jian chi;
市场分析__市場分析 175.948711373|shi chang fen xi;
市场份额__市場份額 1152.18059436|shi chang fen e;
市场风险__市場風險 189.372573382|shi chang feng xian;
市场调查__市場調查 232.313479749|shi chang diao cha;
市场调研__市場調研 166.768626413|shi chang diao yan;
市场定位__市場定位 203.566761683|shi chang ding wei;
市场推广__市場推廣 222.121753798|shi chang tui guang;
市场规模__市場規模 238.176261728|shi chang gui mo;
市场开发__市場開發 139.026849285|shi chang kai fa;
市场开拓__市場開拓 124.587019602|shi chang kai tuo;
市场环境__市場環境 340.15949445|shi chang huan jing;
市场行情__市場行情 270.122027271|shi chang hang qing;
市场机制__市場機制 239.664931108|shi chang ji zhi;
市场价格__市場價格 780.052703516|shi chang jia ge;
市场价值__市場價值 125.522047856|shi chang jia zhi;
市场监管__市場監管 153.984619852|shi chang jian guan;
市场交易__市場交易 138.680779525|shi chang jiao yi;
市场经济__市場經濟 2043.96775685|shi chang jing ji;
市场竞争__市場競爭 926.424414408|shi chang jing zheng;
市场潜力__市場潛力 162.460985719|shi chang qian li;
市场前景__市場前景 289.645897197|shi chang qian jing;
市场情况__市場情況 116.333988795|shi chang qing kuang;
市场销售__市場銷售 227.727332161|shi chang xiao shou;
市场信息__市場信息 130.141230764|shi chang xin xi;
市场需求__市場需求 882.476330723|shi chang xu qiu;
市场准入__市場准入 226.312812713|shi chang zhun ru;
市场秩序__市場秩序 283.221176861|shi chang zhi xu;
市场主体__市場主體 185.402943996|shi chang zhu ti;
市场走势__市場走勢 108.087539034|shi chang zou shi;
市场运作__市場運作 144.502706249|shi chang yun zuo;
市场营销__市場營銷 565.579310193|shi chang ying xiao;
时尚杂志__時尚雜誌 145.950506492|shi shang za zhi;
实施办法__實施辦法 244.796354228|shi shi ban fa;
实施方案__實施方案 429.960742313|shi shi fang an;
实施过程__實施過程 161.653186955|shi shi guo cheng;
时时刻刻__時時刻刻 317.230705235|shi shi ke ke;
实时监控__實時監控 146.862738669|shi shi jian kong;
是世界上__是世界上 583.476802811|shi shi jie shang;
实施情况__實施情況 107.015331962|shi shi qing kuang;
实事求是__實事求是 638.24912322|shi shi qiu shi;
实施细则__實施細則 326.861744407|shi shi xi ze;
事实证明__事實證明 381.957020988|shi shi zheng ming;
实实在在__實實在在 828.13607043|shi shi zai zai;
实施意见__實施意見 239.664931108|shi shi yi jian;
势在必行__勢在必行 204.584007193|shi zai bi xing;
是怎么了__是怎麼了 177.490254874|shi zen me le;
十字路口__十字路口 385.78392141|shi zi lu kou;
始作俑者__始作俑者 117.646076559|shi zuo yong zhe;
实验教学__實驗教學 115.323601467|shi yan jiao xue;
试验结果__試驗結果 109.034528882|shi yan jie guo;
实验学校__實驗學校 111.646962678|shi yan xue xiao;
实验小学__實驗小學 135.267109459|shi yan xiao xue;
实验中学__實驗中學 120.765453341|shi yan zhong xue;
试验研究__試驗研究 259.885889675|shi yan yan jiu;
实验研究__實驗研究 413.667597456|shi yan yan jiu;
失业保险__失業保險 218.008308584|shi ye bao xian;
事业发展__事業發展 496.21189989|shi ye fa zhan;
事业单位__事業單位 1173.92027842|shi ye dan wei;
实业公司__實業公司 113.47039186|shi ye gong si;
失业人员__失業人員 210.270405333|shi ye ren yuan;
事业有成__事業有成 150.756793028|shi ye you cheng;
是一样的__是一樣的 1153.6172982|shi yi yang de;
适应能力__適應能力 175.073848088|shi ying neng li;
时应注意__時應注意 155.72135507|shi ying zhu yi;
十有八九__十有八九 161.451865638|shi you ba jiu;
时有发生__時有發生 246.019628549|shi you fa sheng;
石油公司__石油公司 332.200082586|shi you gong si;
石油化工__石油化工 182.651055928|shi you hua gong;
石油价格__石油價格 167.601987591|shi you jia ge;
适用范围__適用範圍 177.490254874|shi yong fan wei;
使用方法__使用方法 435.352293046|shi yong fang fa;
使用电脑__使用電腦 219.918349804|shi yong dian nao;
实用技术__實用技術 159.055477247|shi yong ji shu;
使用价值__使用價值 127.413209251|shi yong jia zhi;
使用情况__使用情況 280.761336094|shi yong qing kuang;
实用主义__實用主義 107.550099352|shi yong zhu yi;
使用时间__使用時間 124.587019602|shi yong shi jian;
使用寿命__使用壽命 353.557372243|shi yong shou ming;
使用说明__使用說明 153.218967809|shi yong shuo ming;
使用作品__使用作品 662.561694208|shi yong zuo pin;
食欲不振__食欲不振 106.882056102|shi yu bu zhen;
事与愿违__事與願違 115.899886195|shi yu yuan wei;
世外桃源__世外桃源 166.560934377|shi wai tao yuan;
市委常委__市委常委 268.778909483|shi wei chang wei;
市卫生局__市衛生局 240.862563142|shi wei sheng ju;
市委书记__市委書記 813.813436628|shi wei shu ji;
史无前例__史無前例 226.877563077|shi wu qian li;
食物中毒__食物中毒 228.8653107|shi wu zhong du;
视而不见__視而不見 337.205131359|shi er bu jian;
十二星座__十二星座 127.73116145|shi er xing zuo;
十二生肖__十二生肖 109.034528882|shi er sheng xiao;
手忙脚乱__手忙腳亂 227.160466527|shou mang jiao luan;
首发阵容__首發陣容 109.716025699|shou fa zhen rong;
收费标准__收費標準 604.195219728|shou fei biao zhun;
收费项目__收費項目 180.613978088|shou fei xiang mu;
首当其冲__首當其衝 192.705418355|shou dang qi chong;
受到限制__受到限制 138.335571213|shou dao xian zhi;
受到影响__受到影響 440.262469534|shou dao ying xiang;
首都机场__首都機場 217.736803143|shou du ji chang;
手提电脑__手提電腦 114.179614083|shou ti dian nao;
首脑会议__首腦會議 154.754097942|shou nao hui yi;
收购价格__收購價格 242.670241844|shou gou jia ge;
售后服务__售後服務 1121.02187006|shou hou fu wu;
手机短信__手機短信 401.478808454|shou ji duan xin;
手机电池__手機電池 110.401782066|shou ji dian chi;
手机电视__手機電視 274.191785204|shou ji dian shi;
手机铃声__手機鈴聲 188.665925845|shou ji ling sheng;
手机号码__手機號碼 613.298247397|shou ji hao ma;
手机厂商__手機廠商 190.556205829|shou ji chang shang;
手机上网__手機上網 158.461958559|shou ji shang wang;
手机市场__手機市場 284.636464248|shou ji shi chang;
手机游戏__手機遊戲 221.845125512|shou ji you xi;
手机用户__手機用戶 293.643651968|shou ji yong hu;
手脚冰凉__手腳冰涼 194.878871049|shou jiao bing liang;
首届中国__首屆中國 266.776744296|shou jie zhong guo;
首屈一指__首屈一指 149.633788238|shou qu yi zhi;
受宠若惊__受寵若驚 147.596627936|shou chong ruo jing;
手术治疗__手術治療 309.807805448|shou shu zhi liao;
收入分配__收入分配 305.97104031|shou ru fen pei;
收入来源__收入來源 165.114314527|shou ru lai yuan;
收入差距__收入差距 230.295783987|shou ru cha ju;
收入水平__收入水平 239.068350048|shou ru shui ping;
收入增长__收入增長 197.076837307|shou ru zeng zhang;
手足无措__手足無措 159.253810404|shou zu wu cuo;
收藏价值__收藏價值 121.217779906|shou cang jia zhi;
首要任务__首要任務 205.350275845|shou yao ren wu;
受益匪浅__受益匪淺 193.186303435|shou yi fei qian;
手舞足蹈__手舞足蹈 131.609045271|shou wu zu dao;
鼠标右键__鼠標右鍵 244.796354228|shu biao you jian;
数不胜数__數不勝數 156.304608838|shu bu sheng shu;
数码单反__數碼單反 133.259374649|shu ma dan fan;
数码相机__數碼相機 1703.95597413|shu ma xiang ji;
数码照片__數碼照片 142.891090816|shu ma zhao pian;
数码产品__數碼產品 315.260239073|shu ma chan pin;
书面形式__書面形式 143.605133321|shu mian xing shi;
树立正确__樹立正確 138.163289429|shu li zheng que;
熟练掌握__熟練掌握 153.792848894|shu lian zhang wo;
数控机床__數控機床 148.889769675|shu kong ji chuang;
数据分析__數據分析 193.668388536|shu ju fen xi;
数据统计__數據統計 126.779677253|shu ju tong ji;
数据类型__數據類型 237.287502254|shu ju lei xing;
数据恢复__數據恢復 179.268563673|shu ju hui fu;
数据交换__數據交換 134.594525802|shu ju jiao huan;
数据结构__數據結構 362.028498203|shu ju jie gou;
数据显示__數據顯示 950.988487375|shu ju xian shi;
数据中心__數據中心 331.786363812|shu ju zhong xin;
数据传输__數據傳輸 363.384474622|shu ju chuan shu;
数据处理__數據處理 224.907079496|shu ju chu li;
数据存储__數據存儲 125.835280772|shu ju cun chu;
数据采集__數據採集 167.393257695|shu ju cai ji;
数据仓库__數據倉庫 172.260473089|shu ju cang ku;
数据业务__數據業務 168.859844103|shu ju ye wu;
数据挖掘__數據挖掘 160.249192015|shu ju wa jue;
数据文件__數據文件 144.682892926|shu ju wen jian;
数学模型__數學模型 157.870654598|shu xue mo xing;
输出功率__輸出功率 132.431639237|shu chu gong lv;
束手无策__束手無策 193.668388536|shu shou wu ce;
舒舒服服__舒舒服服 126.149295342|shu shu fu fu;
输入密码__輸入密碼 153.028150386|shu ru mi ma;
输入输出__輸入輸出 117.061109314|shu ru shu chu;
数字电视__數字電視 881.377303227|shu zi dian shi;
数字家庭__數字家庭 120.314814642|shu zi jia ting;
数字信号__數字信號 123.504952812|shu zi xin hao;
数一数二__數一數二 155.915530766|shu yi shu er;
数以万计__數以萬計 126.779677253|shu yi wan ji;
属于自己__屬於自己 1002.08784645|shu yu zi ji;
说不过去__說不過去 168.649547684|shuo bu guo qu;
说不清楚__說不清楚 524.833224606|shuo bu qing chu;
说明什么__說明什麼 151.888225993|shuo ming shen me;
说来说去__說來說去 111.925571131|shuo lai shuo qu;
硕士学位__碩士學位 349.178797604|shuo shi xue wei;
说三道四__說三道四 135.435779871|shuo san dao si;
睡眠不足__睡眠不足 135.773751924|shui mian bu zu;
睡眠时间__睡眠時間 124.431860131|shui mian shi jian;
水到渠成__水到渠成 175.292155245|shui dao qu cheng;
水土保持__水土保持 228.8653107|shui tu bao chi;
水土不服__水土不服 121.823518492|shui tu bu fu;
水土流失__水土流失 181.969489867|shui tu liu shi;
水利工程__水利工程 271.471856767|shui li gong cheng;
水利建设__水利建設 105.558392399|shui li jian she;
水落石出__水落石出 129.494134325|shui luo shi chu;
水涨船高__水漲船高 168.229740225|shui zhang chuan gao;
水产养殖__水產養殖 135.098649108|shui chan yang zhi;
水深火热__水深火熱 144.502706249|shui shen huo re;
税收征管__稅收征管 113.895394799|shui shou zheng guan;
税收政策__稅收政策 223.231720645|shui shou zheng ce;
税收收入__稅收收入 113.32907693|shui shou shou ru;
税收优惠__稅收優惠 130.46599058|shui shou you hui;
水水灌灌__水水灌灌 418.333200332|shui shui guan guan;
税务登记__稅務登記 108.087539034|shui wu deng ji;
税务机关__稅務機關 556.490650127|shui wu ji guan;
软件工具__軟件工具 141.121478992|ruan jian gong ju;
软件工程__軟件工程 218.008308584|ruan jian gong cheng;
软件公司__軟件公司 301.805456692|ruan jian gong si;
软件开发__軟件開發 566.990680223|ruan jian kai fa;
软件企业__軟件企業 222.953710017|ruan jian qi ye;
软件学院__軟件學院 111.369047744|ruan jian xue yuan;
软件系统__軟件系統 161.451865638|ruan jian xi tong;
软件下载__軟件下載 229.150692759|ruan jian xia zai;
软件产品__軟件產品 194.878871049|ruan jian chan pin;
软件产业__軟件產業 207.149415951|ruan jian chan ye;
软件厂商__軟件廠商 128.209578049|ruan jian chang shang;
软件测试__軟件測試 170.127140854|ruan jian ce shi;
软件外包__軟件外包 133.42554153|ruan jian wai bao;
燃料电池__燃料電池 186.32942291|ran liao dian chi;
然后单击__然後單擊 123.658956482|ran hou dan ji;
让人感动__讓人感動 175.948711373|rang ren gan dong;
热门话题__熱門話題 158.264611567|re men hua ti;
热带风暴__熱帶風暴 121.671800659|re dai feng bao;
热带雨林__熱帶雨林 131.445140637|re dai yu lin;
热点问题__熱點問題 250.661599628|re dian wen ti;
热闹非凡__熱鬧非凡 125.835280772|re nao fei fan;
热泪盈眶__熱淚盈眶 184.251320835|re lei ying kuang;
热烈祝贺__熱烈祝賀 154.754097942|re lie zhu he;
热火朝天__熱火朝天 185.172044961|re huo chao tian;
热情洋溢__熱情洋溢 127.890434962|re qing yang yi;
热血沸腾__熱血沸騰 215.576896995|re xue fei teng;
热血江湖__熱血江湖 121.823518492|re xue jiang hu;
热线电话__熱線電話 199.299593609|re xian dian hua;
热热闹闹__熱熱鬧鬧 107.952927857|re re nao nao;
热爱生活__熱愛生活 140.244908425|re ai sheng huo;
人满为患__人滿為患 143.784200776|ren man wei huan;
人民法院__人民法院 1206.54931027|ren min fa yuan;
人民大学__人民大學 132.927661458|ren min da xue;
人民广场__人民廣場 258.593668656|ren min guang chang;
人民警察__人民警察 215.576896995|ren min jing cha;
人民群众__人民群眾 1944.58043354|ren min qun zhong;
人民政府__人民政府 2665.32595143|ren min zheng fu;
人民政协__人民政協 145.224802174|ren min zheng xie;
人民生活__人民生活 216.654158472|ren min sheng huo;
人民日报__人民日報 367.025293151|ren min ri bao;
人民医院__人民醫院 585.662213047|ren min yi yuan;
人民银行__人民銀行 299.93080386|ren min yin hang;
人大代表__人大代表 961.714332594|ren da dai biao;
人大工作__人大工作 137.647730357|ren da gong zuo;
人道主义__人道主義 271.810366771|ren dao zhu yi;
人都知道__人都知道 701.651845929|ren dou zhi dao;
人体健康__人體健康 109.30661816|ren ti jian kang;
人体艺术__人體藝術 193.427195796|ren ti yi shu;
人来人往__人來人往 150.944778196|ren lai ren wang;
人类历史__人類歷史 199.796934068|ren lei li shi;
人类社会__人類社會 496.21189989|ren lei she hui;
人类文明__人類文明 256.987424161|ren lei wen ming;
人力资本__人力資本 220.467143161|ren li zi ben;
人力资源__人力資源 1461.808129|ren li zi yuan;
人格魅力__人格魅力 171.617679695|ren ge mei li;
认购权证__認購權證 142.180598718|ren gou quan zheng;
人工流产__人工流產 147.596627936|ren gong liu chan;
人工智能__人工智能 209.485777119|ren gong zhi neng;
认沽权证__認沽權證 188.665925845|ren gu quan zheng;
任何地方__任何地方 243.275811214|ren he di fang;
任何东西__任何東西 291.456266438|ren he dong xi;
任何时候__任何時候 439.166555128|ren he shi hou;
任何事情__任何事情 388.679238014|ren he shi qing;
任何一种__任何一種 280.062456643|ren he yi zhong;
人均收入__人均收入 252.228305921|ren jun shou ru;
人际关系__人際關係 775.207436548|ren ji guan xi;
人际交往__人際交往 147.412812521|ren ji jiao wang;
人见人爱__人見人愛 154.754097942|ren jian ren ai;
人居环境__人居環境 154.947067523|ren ju huan jing;
忍气吞声__忍氣吞聲 116.47905068|ren qi tun sheng;
仁者见仁__仁者見仁 124.276893895|ren zhe jian ren;
忍者神龟__忍者神龜 195.121873946|ren zhe shen gui;
认真负责__認真負責 154.368879448|ren zhen fu ze;
认真落实__認真落實 287.130256264|ren zhen luo shi;
认真贯彻__認真貫徹 278.322859608|ren zhen guan che;
认真学习__認真學習 483.997491267|ren zhen xue xi;
认真做好__認真做好 304.829303266|ren zhen zuo hao;
认证机构__認證機構 112.906187218|ren zheng ji gou;
人之常情__人之常情 107.684208225|ren zhi chang qing;
任职资格__任職資格 144.682892926|ren zhi zi ge;
任重道远__任重道遠 144.682892926|ren zhong dao yuan;
人山人海__人山人海 195.365179853|ren shan ren hai;
人身攻击__人身攻擊 392.573489614|ren shen gong ji;
人身自由__人身自由 122.737806611|ren shen zi you;
人身安全__人身安全 190.556205829|ren shen an quan;
人生目标__人生目標 111.369047744|ren sheng mu biao;
人生经历__人生經歷 109.716025699|ren sheng jing li;
人事变动__人事變動 129.494134325|ren shi bian dong;
人事部门__人事部門 250.661599628|ren shi bu men;
认识自己__認識自己 121.217779906|ren shi zi ji;
人寿保险__人壽保險 126.621787068|ren shou bao xian;
人数最多__人數最多 110.815291538|ren shu zui duo;
人人都有__人人都有 133.925286409|ren ren dou you;
认认真真__認認真真 200.795341333|ren ren zhen zhen;
忍辱负重__忍辱負重 105.558392399|ren ru fu zhong;
人才培养__人才培養 496.830647979|ren cai pei yang;
人才队伍__人才隊伍 118.972962872|ren cai dui wu;
人才招聘__人才招聘 105.558392399|ren cai zhao pin;
人才市场__人才市場 491.289575698|ren cai shi chang;
人才资源__人才資源 133.42554153|ren cai zi yuan;
人员名单__人員名單 139.026849285|ren yuan ming dan;
人员伤亡__人員傷亡 203.313241605|ren yuan shang wang;
人云亦云__人云亦云 138.508067822|ren yun yi yun;
人与自然__人與自然 311.355949144|ren yu zi ran;
人文关怀__人文關懷 173.986383704|ren wen guan huai;
人文景观__人文景觀 123.504952812|ren wen jing guan;
人文精神__人文精神 174.638049069|ren wen jing shen;
认为自己__認為自己 824.018360007|ren wei zi ji;
忍无可忍__忍無可忍 296.955549433|ren wu ke ren;
人物形象__人物形象 164.293322714|ren wu xing xiang;
日本东京__日本東京 148.519148841|ri ben dong jing;
日本鬼子__日本鬼子 217.736803143|ri ben gui zi;
日本经济__日本經濟 210.270405333|ri ben jing ji;
日本企业__日本企業 145.768741141|ri ben qi ye;
日本政府__日本政府 433.187606905|ri ben zheng fu;
日本首相__日本首相 176.168109435|ri ben shou xiang;
日复一日__日復一日 171.617679695|ri fu yi ri;
日新月异__日新月異 243.275811214|ri xin yue yi;
日志文件__日誌文件 127.572086295|ri zhi wen jian;
日常管理__日常管理 145.043940608|ri chang guan li;
日常工作__日常工作 334.69325133|ri chang gong zuo;
日常生活__日常生活 708.681829926|ri chang sheng huo;
日程安排__日程安排 110.95347192|ri cheng an pai;
日日夜夜__日日夜夜 133.591915611|ri ri ye ye;
融资渠道__融資渠道 145.768741141|rong zi qu dao;
容易引起__容易引起 246.633556117|rong yi yin qi;
荣誉称号__榮譽稱號 186.097370046|rong yu cheng hao;
融为一体__融為一體 280.411678639|rong wei yi ti;
如何面对__如何面對 169.703655326|ru he mian dui;
如何对待__如何對待 105.953760973|ru he dui dai;
如何提高__如何提高 181.969489867|ru he ti gao;
如何利用__如何利用 167.393257695|ru he li yong;
如何看待__如何看待 317.230705235|ru he kan dai;
如何解决__如何解決 298.811606079|ru he jie jue;
如何进行__如何進行 303.313611771|ru he jin xing;
如何选择__如何選擇 228.580284053|ru he xuan ze;
如何处理__如何處理 369.319305625|ru he chu li;
如何是好__如何是好 159.85029497|ru he shi hao;
如何实现__如何實現 225.187525865|ru he shi xian;
如何使用__如何使用 274.191785204|ru he shi yong;
如何做好__如何做好 111.369047744|ru he zuo hao;
如何才能__如何才能 359.331706043|ru he cai neng;
如何操作__如何操作 168.439513167|ru he cao zuo;
如何应对__如何應對 217.19480623|ru he ying dui;
如火如荼__如火如荼 325.236501817|ru huo ru tu;
儒家思想__儒家思想 112.906187218|ru jia si xiang;
入学考试__入學考試 140.244908425|ru xue kao shi;
如出一辙__如出一轍 193.668388536|ru chu yi zhe;
如日中天__如日中天 140.770195218|ru ri zhong tian;
如此这般__如此這般 122.279808036|ru ci zhe ban;
如此一来__如此一來 135.098649108|ru ci yi lai;
如愿以偿__如願以償 190.793818607|ru yuan yi chang;
如有问题__如有問題 132.266710153|ru you wen ti;
如鱼得水__如魚得水 132.10198647|ru yu de shui;
若干意见__若干意見 147.045868173|ruo gan yi jian;
若干问题__若干問題 224.06783424|ruo gan wen ti;
若即若离__若即若離 108.087539034|ruo ji ruo li;
弱势群体__弱勢群體 575.5331706|ruo shi qun ti;
若隐若现__若隱若現 179.045304336|ruo yin ruo xian;
若有所思__若有所思 153.601316766|ruo you suo si;
若无其事__若無其事 199.796934068|ruo wu qi shi;
遵纪守法__遵紀守法 2482.57137774|zun ji shou fa;
尊重网上__尊重網上 1066.51251556|zun zhong wang shang;
杂七杂八__雜七雜八 177.269210225|za qi za ba;
栽培技术__栽培技術 335.946843682|zai pei ji shu;
在飞机上__在飛機上 140.070248771|zai fei ji shang;
在你面前__在你面前 257.3078729|zai ni mian qian;
在你身边__在你身邊 290.368691563|zai ni shen bian;
再来一次__再來一次 154.947067523|zai lai yi ci;
在历史上__在歷史上 235.813600182|zai li shi shang;
在两周内__在兩周內 305.209408115|zai liang zhou nei;
在工作中__在工作中 434.810109507|zai gong zuo zhong;
在国际上__在國際上 391.108593802|zai guo ji shang;
在黑暗中__在黑暗中 249.415244207|zai hei an zhong;
在火车上__在火車上 135.267109459|zai huo che shang;
再接再厉__再接再厲 262.162833911|zai jie zai li;
在线播放__在線播放 133.259374649|zai xian bo fang;
在线服务__在線服務 142.357889859|zai xian fu wu;
在线观看__在線觀看 305.589986932|zai xian guan kan;
在线人数__在線人數 189.608710238|zai xian ren shu;
在校学生__在校學生 190.318888971|zai xiao xue sheng;
在新窗口__在新窗口 107.684208225|zai xin chuang kou;
在这方面__在這方面 907.004698479|zai zhe fang mian;
在这样的__在這樣的 933.377249507|zai zhe yang de;
在桌面上__在桌面上 136.622376491|zai zhuo mian shang;
在社会上__在社會上 411.610733326|zai she hui shang;
在生活中__在生活中 456.464028614|zai sheng huo zhong;
在实践中__在實踐中 368.399985048|zai shi jian zhong;
在世界上__在世界上 399.980682268|zai shi jie shang;
载人航天__載人航天 216.11485651|zai ren hang tian;
在此之前__在此之前 360.677581637|zai ci zhi qian;
在思想上__在思想上 116.333988795|zai si xiang shang;
在所难免__在所難免 226.312812713|zai suo nan mian;
在阳光下__在陽光下 283.221176861|zai yang guang xia;
再也没有__再也沒有 714.89082038|zai ye mei you;
在网络上__在網絡上 702.526765976|zai wang luo shang;
赞不绝口__讚不絕口 153.218967809|zan bu jue kou;
暂行办法__暫行辦法 155.72135507|zan xing ban fa;
暂行规定__暫行規定 137.819369268|zan xing gui ding;
暂时没有__暫時沒有 225.468321935|zan shi mei you;
藏传佛教__藏傳佛教 137.305093541|zang chuan fo jiao;
造型设计__造型設計 107.952927857|zao xing she ji;
造成损失__造成損失 121.823518492|zao cheng sun shi;
早上起来__早上起來 282.164331387|zao shang qi lai;
早上起床__早上起床 114.321989585|zao shang qi chuang;
早睡早起__早睡早起 141.29744947|zao shui zao qi;
早日康复__早日康復 159.85029497|zao ri kang fu;
责任编辑__責任編輯 259.238974004|ze ren bian ji;
责任追究__責任追究 149.820373083|ze ren zhui jiu;
责任人员__責任人員 107.282382453|ze ren ren yuan;
责任意识__責任意識 139.200207879|ze ren yi shi;
怎么办啊__怎麼辦啊 245.101601395|zen me ban a;
怎么能够__怎麼能夠 169.703655326|zen me neng gou;
怎么可能__怎麼可能 1054.61787307|zen me ke neng;
怎么回事__怎麼回事 1838.53442614|zen me hui shi;
怎么解决__怎麼解決 196.586267794|zen me jie jue;
怎么这么__怎麼這麼 656.807194196|zen me zhe me;
怎么处理__怎麼處理 212.907119447|zen me chu li;
怎样才能__怎樣才能 569.114341748|zen yang cai neng;
增长方式__增長方式 180.164388413|zeng zhang fang shi;
增长幅度__增長幅度 207.666345181|zeng zhang fu du;
增长速度__增長速度 635.867483878|zeng zhang su du;
增值服务__增值服務 314.475483928|zeng zhi fu wu;
增值业务__增值業務 274.191785204|zeng zhi ye wu;
增资扩股__增資擴股 138.335571213|zeng zi kuo gu;
自暴自弃__自暴自棄 124.276893895|zi bao zi qi;
资本主义__資本主義 1212.57856995|zi ben zhu yi;
资本市场__資本市場 1536.52100517|zi ben shi chang;
资本运作__資本運作 210.008536601|zi ben yun zuo;
自动播放__自動播放 140.770195218|zi dong bo fang;
自动对焦__自動對焦 189.608710238|zi dong dui jiao;
自动关闭__自動關閉 130.628674269|zi dong guan bi;
自动关机__自動關機 137.819369268|zi dong guan ji;
自动更新__自動更新 252.228305921|zi dong geng xin;
自动控制__自動控制 141.826678552|zi dong kong zhi;
自动生成__自動生成 230.870473623|zi dong sheng cheng;
自动识别__自動識別 140.244908425|zi dong shi bie;
自动运行__自動運行 153.984619852|zi dong yun xing;
自力更生__自力更生 176.168109435|zi li geng sheng;
字里行间__字裡行間 207.407719521|zi li hang jian;
资料图片__資料圖片 155.333728851|zi liao tu pian;
资格考试__資格考試 236.402059204|zi ge kao shi;
资格证书__資格證書 255.709615075|zi ge zheng shu;
资格审查__資格審查 198.308623594|zi ge shen cha;
自古以来__自古以來 259.885889675|zi gu yi lai;
自觉遵守__自覺遵守 151.510141313|zi jue zun shou;
自己动手__自己動手 284.281980745|zi ji dong shou;
自己喜欢__自己喜歡 941.55486912|zi ji xi huan;
自给自足__自給自足 111.091824605|zi ji zi zu;
资金投入__資金投入 308.651751439|zi jin tou ru;
资金来源__資金來源 248.175085992|zi jin lai yuan;
资金管理__資金管理 126.779677253|zi jin guan li;
资金使用__資金使用 108.357265155|zi jin shi yong;
自欺欺人__自欺欺人 281.812926654|zi qi qi ren;
自强不息__自強不息 188.196293023|zi qiang bu xi;
自学考试__自學考試 288.924902033|zi xue kao shi;
咨询服务__諮詢服務 393.553133755|zi xun fu wu;
咨询电话__諮詢電話 344.85444872|zi xun dian hua;
咨询公司__諮詢公司 367.482952871|zi xun gong si;
咨询顾问__諮詢顧問 107.015331962|zi xun gu wen;
咨询机构__諮詢機構 438.073368704|zi xun ji gou;
仔细阅读__仔細閱讀 529.431458035|zi xi yue du;
自相矛盾__自相矛盾 138.85370659|zi xiang mao dun;
自知之明__自知之明 207.149415951|zi zhi zhi ming;
自主品牌__自主品牌 672.544092675|zi zhu pin pai;
自主开发__自主開發 196.586267794|zi zhu kai fa;
自主学习__自主學習 111.230349808|zi zhu xue xi;
自主招生__自主招生 194.636170786|zi zhu zhao sheng;
自主创新__自主創新 858.611290099|zi zhu chuang xin;
自主创业__自主創業 147.045868173|zi zhu chuang ye;
自主研发__自主研發 363.384474622|zi zhu yan fa;
资产评估__資產評估 181.290467084|zi chan ping gu;
资产管理__資產管理 307.500011268|zi chan guan li;
资产规模__資產規模 116.47905068|zi chan gui mo;
资产阶级__資產階級 523.526794166|zi chan jie ji;
资产重组__資產重組 278.669912425|zi chan chong zu;
自身建设__自身建設 185.172044961|zi shen jian she;
自生自灭__自生自滅 112.484875527|zi sheng zi mie;
自始至终__自始至終 255.073095111|zi shi zhi zhong;
自然风光__自然風光 149.820373083|zi ran feng guang;
自然条件__自然條件 154.754097942|zi ran tiao jian;
自然规律__自然規律 151.132997772|zi ran gui lv;
自然科学__自然科學 332.614317243|zi ran ke xue;
自然环境__自然環境 326.861744407|zi ran huan jing;
自然景观__自然景觀 169.703655326|zi ran jing guan;
自然灾害__自然災害 441.361118731|zi ran zai hai;
自然资源__自然資源 354.881620091|zi ran zi yuan;
自然而然__自然而然 446.895626023|zi ran er ran;
孜孜不倦__孜孜不倦 135.098649108|zi zi bu juan;
自作多情__自作多情 175.292155245|zi zuo duo qing;
子孙后代__子孫後代 131.773154284|zi sun hou dai;
资源配置__資源配置 330.136634719|zi yuan pei zhi;
资源丰富__資源豐富 186.561765129|zi yuan feng fu;
资源共享__資源共享 319.611528482|zi yuan gong xiang;
资源开发__資源開發 196.341441156|zi yuan kai fa;
资源节约__資源節約 107.416157498|zi yuan jie yue;
资源整合__資源整合 234.348853194|zi yuan zheng he;
资源优势__資源優勢 357.099731154|zi yuan you shi;
自言自语__自言自語 415.734739962|zi yan zi yu;
自以为是__自以為是 551.657401419|zi yi wei shi;
自有品牌__自有品牌 135.098649108|zi you pin pai;
自由贸易__自由貿易 129.655606164|zi you mao yi;
自由选择__自由選擇 178.822323044|zi you xuan ze;
自由主义__自由主義 310.968189453|zi you zhu yi;
自有资金__自有資金 139.026849285|zi you zi jin;
自由自在__自由自在 310.968189453|zi you zi zai;
自娱自乐__自娛自樂 243.275811214|zi yu zi le;
走马观花__走馬觀花 116.915322539|zou ma guan hua;
走到一起__走到一起 198.555903198|zou dao yi qi;
走投无路__走投無路 135.604660605|zou tou wu lu;
走来走去__走來走去 195.852702213|zou lai zou qu;
走火入魔__走火入魔 136.282292017|zou huo ru mo;
走向世界__走向世界 230.870473623|zou xiang shi jie;
走在路上__走在路上 151.510141313|zou zai lu shang;
总体目标__總體目標 109.716025699|zong ti mu biao;
总体规划__總體規劃 419.900065808|zong ti gui hua;
总体要求__總體要求 123.658956482|zong ti yao qiu;
总工程师__總工程師 196.831399718|zong gong cheng shi;
综合评价__綜合評價 178.59961945|zong he ping jia;
综合分析__綜合分析 183.106850936|zong he fen xi;
综合服务__綜合服務 109.989815613|zong he fu wu;
综合能力__綜合能力 145.043940608|zong he neng li;
综合利用__綜合利用 256.028470459|zong he li yong;
综合管理__綜合管理 126.149295342|zong he guan li;
综合国力__綜合國力 173.337150041|zong he guo li;
综合开发__綜合開發 122.127521944|zong he kai fa;
综合治理__綜合治理 401.478808454|zong he zhi li;
综合指数__綜合指數 133.259374649|zong he zhi shu;
综合实力__綜合實力 264.130371602|zong he shi li;
综合素质__綜合素質 427.290057918|zong he su zhi;
纵横交错__縱橫交錯 112.765574943|zong heng jiao cuo;
宗教信仰__宗教信仰 209.224885556|zong jiao xin yang;
宗教政策__宗教政策 147.780672558|zong jiao zheng ce;
总结经验__總結經驗 149.447435764|zong jie jing yan;
综上所述__綜上所述 181.516526012|zong shang suo shu;
综艺节目__綜藝節目 203.060037258|zong yi jie mu;
总有一天__總有一天 417.291872914|zong you yi tian;
总有一种__總有一種 114.46454262|zong you yi zhong;
总而言之__總而言之 174.855812809|zong er yan zhi;
足不出户__足不出戶 224.626982392|zu bu chu hu;
足球比赛__足球比賽 140.594881376|zu qiu bi sai;
组织部门__組織部門 134.762357541|zu zhi bu men;
组织部长__組織部長 107.015331962|zu zhi bu zhang;
组织领导__組織領導 193.668388536|zu zhi ling dao;
组织工作__組織工作 185.86560618|zu zhi gong zuo;
组织开展__組織開展 415.216987933|zu zhi kai zhan;
组织机构__組織機構 261.184568064|zu zhi ji gou;
组织架构__組織架構 116.18910757|zu zhi jia gou;
组织建设__組織建設 122.279808036|zu zhi jian she;
组织结构__組織結構 292.54791482|zu zhi jie gou;
组织协调__組織協調 154.561368684|zu zhi xie tiao;
组织形式__組織形式 177.269210225|zu zhi xing shi;
组织实施__組織實施 493.744603771|zu zhi shi shi;
组成部分__組成部分 1196.07015327|zu cheng bu fen;
作品内容__作品內容 1249.39213028|zuo pin nei rong;
作风建设__作風建設 239.963779681|zuo feng jian she;
做大做强__做大做強 439.166555128|zuo da zuo qiang;
做得更好__做得更好 202.807148249|zuo de geng hao;
做好准备__做好準備 339.735863102|zuo hao zhun bei;
作息时间__作息時間 128.529517539|zuo xi shi jian;
作出决定__作出決定 155.333728851|zuo chu jue ding;
左侧排名__左側排名 272.488653616|zuo ce pai ming;
左右为难__左右為難 111.786180106|zuo you wei nan;
作为一名__作為一名 465.076726846|zuo wei yi ming;
最便宜的__最便宜的 313.302012384|zui pian yi de;
最大功率__最大功率 118.23396695|zui da gong lv;
最大规模__最大規模 141.29744947|zui da gui mo;
最大限度__最大限度 1002.08784645|zui da xian du;
最低工资__最低工資 140.070248771|zui di gong zi;
最流行的__最流行的 288.565077751|zui liu xing de;
最高法院__最高法院 275.218769535|zui gao fa yuan;
最高境界__最高境界 292.54791482|zui gao jing jie;
最高气温__最高氣溫 125.522047856|zui gao qi wen;
最高学历__最高學歷 107.14877401|zui gao xue li;
罪魁祸首__罪魁禍首 231.158356006|zui kui huo shou;
最后更新__最後更新 1029.9408079|zui hou geng xin;
最后还是__最後還是 538.078184713|zui hou hai shi;
最后时刻__最後時刻 237.287502254|zui hou shi ke;
最后一天__最後一天 433.187606905|zui hou yi tian;
最后一场__最後一場 226.595011951|zui hou yi chang;
最后一次__最後一次 1153.6172982|zui hou yi ci;
最佳答案__最佳答案 111.230349808|zui jia da an;
最佳选择__最佳選擇 332.200082586|zui jia xuan ze;
最佳时机__最佳時機 142.535402072|zui jia shi ji;
最佳时间__最佳時間 296.585723861|zui jia shi jian;
最简单的__最簡單的 601.191002133|zui jian dan de;
最近几年__最近幾年 258.916120291|zui jin ji nian;
最喜欢的__最喜歡的 1326.40613196|zui xi huan de;
最新版本__最新版本 322.010219858|zui xin ban ben;
最新动态__最新動態 174.855812809|zui xin dong tai;
最新推出__最新推出 124.587019602|zui xin tui chu;
最新进展__最新進展 110.126966673|zui xin jin zhan;
最新消息__最新消息 315.260239073|zui xin xiao xi;
最终目标__最終目標 127.73116145|zui zhong mu biao;
最终幻想__最終幻想 162.056583012|zui zhong huan xiang;
最终还是__最終還是 508.100984482|zui zhong hai shi;
最重要的__最重要的 3892.92564555|zui zhong yao de;
最终用户__最終用戶 152.457122789|zui zhong yong hu;
最主要的__最主要的 1019.7239982|zui zhu yao de;
最受关注__最受關注 113.895394799|zui shou guan zhu;
最受欢迎__最受歡迎 514.472385324|zui shou huan ying;
最有价值__最有價值 179.492101402|zui you jia zhi;
最优秀的__最優秀的 410.586139672|zui you xiu de;
存款利率__存款利率 156.694657831|cun kuan li lv;
存储过程__存儲過程 285.346757867|cun chu guo cheng;
存储空间__存儲空間 924.118331259|cun chu kong jian;
存储设备__存儲設備 143.784200776|cun chu she bei;
存在问题__存在問題 408.544597361|cun zai wen ti;
擦肩而过__擦肩而過 377.697115787|ca jian er guo;
擦身而过__擦身而過 124.276893895|ca shen er guo;
才华横溢__才華橫溢 145.043940608|cai hua heng yi;
财经大学__財經大學 210.532600599|cai jing da xue;
采取行动__採取行動 234.933657026|cai qu xing dong;
采取措施__採取措施 570.534533242|cai qu cuo shi;
财政部门__財政部門 371.627656329|cai zheng bu men;
财政补贴__財政補貼 121.520271774|cai zheng bu tie;
财政部长__財政部長 131.937467932|cai zheng bu zhang;
财政政策__財政政策 246.633556117|cai zheng zheng ce;
财政支出__財政支出 186.561765129|cai zheng zhi chu;
财政收入__財政收入 520.274927886|cai zheng shou ru;
财政资金__財政資金 152.267254161|cai zheng zi jin;
财政预算__財政預算 229.436430673|cai zheng yu suan;
财产损失__財產損失 151.888225993|cai chan sun shi;
才是真正__才是真正 637.454253928|cai shi zhen zheng;
财务报表__財務報表 243.57916235|cai wu bao biao;
财务报告__財務報告 156.89004718|cai wu bao gao;
财务管理__財務管理 429.960742313|cai wu guan li;
财务状况__財務狀況 205.862715427|cai wu zhuang kuang;
财务软件__財務軟件 109.170488754|cai wu ruan jian;
财务人员__財務人員 115.467403456|cai wu ren yuan;
财务总监__財務總監 135.435779871|cai wu zong jian;
惨不忍睹__慘不忍睹 310.580912674|can bu ren du;
参考价格__參考價格 115.755545596|can kao jia ge;
参考资料__參考資料 167.184787749|can kao zi liao;
参考文献__參考文獻 237.583386308|can kao wen xian;
参加高考__參加高考 148.704343794|can jia gao kao;
参加工作__參加工作 263.472890441|can jia gong zuo;
参加活动__參加活動 413.152419826|can jia huo dong;
参加会议__參加會議 239.068350048|can jia hui yi;
参展企业__參展企業 106.748946222|can zhan qi ye;
参政议政__參政議政 150.381524744|can zheng yi zheng;
参赛选手__參賽選手 185.402943996|can sai xuan shou;
餐饮企业__餐飲企業 108.492380517|can yin qi ye;
操作方法__操作方法 162.258658377|cao zuo fang fa;
操作方式__操作方式 133.093414711|cao zuo fang shi;
操作过程__操作過程 113.046974828|cao zuo guo cheng;
操作规程__操作規程 113.611883002|cao zuo gui cheng;
操作界面__操作界面 117.499561272|cao zuo jie mian;
操作权限__操作權限 284.991389772|cao zuo quan xian;
操作系统__操作系統 3169.40381549|cao zuo xi tong;
操作人员__操作人員 153.792848894|cao zuo ren yuan;
测试结果__測試結果 214.2378495|ce shi jie guo;
测试用例__測試用例 107.684208225|ce shi yong li;
参差不齐__參差不齊 201.547419552|cen ci bu qi;
曾几何时__曾幾何時 131.609045271|ceng ji he shi;
曾经说过__曾經說過 296.955549433|ceng jing shuo guo;
曾经拥有__曾經擁有 140.070248771|ceng jing yong you;
层出不穷__層出不窮 467.400766428|ceng chu bu qiong;
磁盘阵列__磁盤陣列 107.550099352|ci pan zhen lie;
此篇文章__此篇文章 274.876014738|ci pian wen zhang;
此起彼伏__此起彼伏 249.104624871|ci qi bi fu;
慈善机构__慈善機構 128.850255419|ci shan ji gou;
慈善事业__慈善事業 249.104624871|ci shan shi ye;
此时此刻__此時此刻 290.730764849|ci shi ci ke;
聪明才智__聰明才智 152.647228173|cong ming cai zhi;
从天而降__從天而降 175.292155245|cong tian er jiang;
从头到尾__從頭到尾 362.028498203|cong tou dao wei;
从头开始__從頭開始 105.295633316|cong tou kai shi;
从哪里来__從哪裡來 211.057972369|cong na li lai;
从来没有__從來沒有 2545.22282076|cong lai mei you;
从零开始__從零開始 125.992190229|cong ling kai shi;
从根本上__從根本上 776.174076244|cong gen ben shang;
从今天起__從今天起 130.141230764|cong jin tian qi;
从此以后__從此以後 231.158356006|cong ci yi hou;
匆匆忙忙__匆匆忙忙 159.651218957|cong cong mang mang;
从业人员__從業人員 821.967189047|cong ye ren yuan;
从一开始__從一開始 513.831666385|cong yi kai shi;
促进作用__促進作用 263.144763849|cu jin zuo yong;
促销活动__促銷活動 449.688850794|cu xiao huo dong;
措手不及__措手不及 219.37092252|cuo shou bu ji;
错综复杂__錯綜複雜 225.468321935|cuo zong fu za;
错误信息__錯誤信息 260.209952636|cuo wu xin xi;
酸甜苦辣__酸甜苦辣 203.820597887|suan tian ku la;
损害赔偿__損害賠償 136.622376491|sun hai pei chang;
孙子兵法__孫子兵法 108.087539034|sun zi bing fa;
赛门铁克__賽門鐵克 167.393257695|sai men tie ke;
塞维利亚__塞維利亞 139.373782642|sai wei li ya;
塞尔维亚__塞爾維亞 182.423584067|sai er wei ya;
散布谣言__散布謠言 119.121315407|san bu yao yan;
三分之一__三分之一 899.127155009|san fen zhi yi;
三分之二__三分之二 395.519762073|san fen zhi er;
三天两头__三天兩頭 121.823518492|san tian liang tou;
三个方面__三個方面 458.173712968|san ge fang mian;
三个代表__三個代表 472.083744072|san ge dai biao;
三个阶段__三個階段 218.280152578|san ge jie duan;
三国演义__三國演義 249.104624871|san guo yan yi;
三国无双__三國無雙 105.558392399|san guo wu shuang;
三聚氰胺__三聚氰胺 493.129699012|san ju qing an;
三峡大坝__三峽大壩 124.431860131|san xia da ba;
三峡工程__三峽工程 239.664931108|san xia gong cheng;
三峡库区__三峽庫區 132.10198647|san xia ku qu;
三星电子__三星電子 129.332863581|san xing dian zi;
三中全会__三中全會 287.130256264|san zhong quan hui;
三十年代__三十年代 141.826678552|san shi nian dai;
三次会议__三次會議 111.646962678|san ci hui yi;
三三两两__三三兩兩 111.646962678|san san liang liang;
三位一体__三位一體 133.093414711|san wei yi ti;
色即是空__色即是空 110.815291538|se ji shi kong;
森林防火__森林防火 147.045868173|sen lin fang huo;
森林公园__森林公園 276.249600432|sen lin gong yuan;
森林资源__森林資源 151.321452046|sen lin zi yuan;
四面八方__四面八方 233.183609039|si mian ba fang;
私募基金__私募基金 251.600451735|si mu ji jin;
司法部门__司法部門 111.925571131|si fa bu men;
司法公正__司法公正 110.264288753|si fa gong zheng;
司法考试__司法考試 264.459727191|si fa kao shi;
司法机关__司法機關 362.931919108|si fa ji guan;
司法鉴定__司法鑒定 161.653186955|si fa jian ding;
司法解释__司法解釋 247.557321202|si fa jie shi;
司法行政__司法行政 123.658956482|si fa xing zheng;
四大天王__四大天王 150.194241046|si da tian wang;
斯图加特__斯圖加特 138.335571213|si tu jia te;
斯里兰卡__斯里蘭卡 184.941433485|si li lan ka;
私立学校__私立學校 105.295633316|si li xue xiao;
司空见惯__司空見慣 179.045304336|si kong jian guan;
丝毫没有__絲毫沒有 377.697115787|si hao mei you;
死去活来__死去活來 199.548108896|si qu huo lai;
思想道德__思想道德 117.061109314|si xiang dao de;
思想观念__思想觀念 225.187525865|si xiang guan nian;
思想工作__思想工作 166.560934377|si xiang gong zuo;
思想教育__思想教育 155.333728851|si xiang jiao yu;
思想政治__思想政治 124.742372548|si xiang zheng zhi;
思想认识__思想認識 142.713135632|si xiang ren shi;
死心塌地__死心塌地 145.587202159|si xin ta di;
撕心裂肺__撕心裂肺 173.769702743|si xin lie fei;
四中全会__四中全會 129.494134325|si zhong quan hui;
四川大学__四川大學 179.940013424|si chuan da xue;
丝绸之路__絲綢之路 202.554574186|si chou zhi lu;
似是而非__似是而非 116.18910757|si shi er fei;
似曾相识__似曾相識 241.162905094|si ceng xiang shi;
私营企业__私營企業 403.988165198|si ying qi ye;
私有财产__私有財產 141.473639374|si you cai chan;
死亡笔记__死亡筆記 249.726250867|si wang bi ji;
死亡人数__死亡人數 283.574337601|si wang ren shu;
思维模式__思維模式 116.18910757|si wei mo shi;
思维方式__思維方式 462.187920882|si wei fang shi;
思维能力__思維能力 145.405889264|si wei neng li;
肆无忌惮__肆無忌憚 384.823616623|si wu ji dan;
搜狐博客__搜狐博客 656.807194196|sou hu bo ke;
搜狐体育__搜狐體育 133.591915611|sou hu ti yu;
搜索功能__搜索功能 122.127521944|sou suo gong neng;
搜索结果__搜索結果 395.519762073|sou suo jie guo;
搜索引擎__搜索引擎 2108.64816008|sou suo yin qing;
送货上门__送貨上門 164.088713397|song huo shang men;
素不相识__素不相識 106.085879302|su bu xiang shi;
速度最快__速度最快 129.655606164|su du zui kuai;
苏宁电器__蘇寧電器 205.862715427|su ning dian qi;
塑料制品__塑料製品 118.529012887|su liao zhi pin;
苏格拉底__蘇格拉底 172.260473089|su ge la di;
素质教育__素質教育 615.595353746|su zhi jiao yu;
诉讼请求__訴訟請求 171.190483873|su song qing qiu;
所见所闻__所見所聞 106.882056102|suo jian suo wen;
所剩无几__所剩無幾 117.061109314|suo sheng wu ji;
所在单位__所在單位 279.017397997|suo zai dan wei;
所在地区__所在地區 162.86639759|suo zai di qu;
所在城市__所在城市 164.293322714|suo zai cheng shi;
所作所为__所作所為 301.429591092|suo zuo suo wei;
所有内容__所有內容 184.251320835|suo you nei rong;
所有权利__所有權利 108.898738333|suo you quan li;
所有信息__所有信息 129.010924378|suo you xin xi;
所有人都__所有人都 825.045864155|suo you ren dou;
所有作品__所有作品 582.024395035|suo you zuo pin;
所有文件__所有文件 170.339279748|suo you wen jian;
所有文章__所有文章 124.431860131|suo you wen zhang;
所有文字__所有文字 238.176261728|suo you wen zi;
随波逐流__隨波逐流 163.069482749|sui bo zhu liu;
随心所欲__隨心所欲 435.895152658|sui xin suo yu;
随之而来__隨之而來 280.411678639|sui zhi er lai;
随处可见__隨處可見 360.228397261|sui chu ke jian;
随身携带__隨身攜帶 335.110594827|sui shen xie dai;
随时随地__隨時隨地 538.078184713|sui shi sui di;
随随便便__隨隨便便 168.439513167|sui sui bian bian;
随遇而安__隨遇而安 107.818484324|sui yu er an;
圆满结束__圓滿結束 210.270405333|yuan man jie shu;
圆满成功__圓滿成功 206.376433771|yuan man cheng gong;
圆满完成__圓滿完成 254.121284766|yuan man wan cheng;
院副院长__院副院長 465.65665114|yuan fu yuan zhang;
怨天尤人__怨天尤人 115.899886195|yuan tian you ren;
原来如此__原來如此 409.564096466|yuan lai ru ci;
园林绿化__園林綠化 129.010924378|yuan lin lv hua;
原汁原味__原汁原味 224.06783424|yuan zhi yuan wei;
原创作品__原創作品 216.11485651|yuan chuang zuo pin;
原创文章__原創文章 121.823518492|yuan chuang wen zhang;
远程控制__遠程控制 146.314717429|yuan cheng kong zhi;
远程教育__遠程教育 354.43965395|yuan cheng jiao yu;
远程协助__遠程協助 116.624293448|yuan cheng xie zhu;
原始森林__原始森林 165.526347625|yuan shi sen lin;
元人民币__元人民幣 706.917758081|yuan ren min bi;
源源不断__源源不斷 391.108593802|yuan yuan bu duan;
源远流长__源遠流長 147.045868173|yuan yuan liu chang;
远远超过__遠遠超過 458.745029596|yuan yuan chao guo;
原因分析__原因分析 202.302314677|yuan yin fen xi;
原因之一__原因之一 543.469292924|yuan yin zhi yi;
原油价格__原油價格 245.71323808|yuan you jia ge;
原油期货__原油期貨 145.587202159|yuan you qi huo;
阅读理解__閱讀理解 116.769717326|yue du li jie;
阅读全文__閱讀全文 450.811022973|yue du quan wen;
越多越好__越多越好 227.160466527|yue duo yue hao;
越来越大__越來越大 1050.68254543|yue lai yue da;
越来越多__越來越多 3816.07460972|yue lai yue duo;
越来越高__越來越高 570.534533242|yue lai yue gao;
越来越好__越來越好 426.226434824|yue lai yue hao;
越来越小__越來越小 224.347234118|yue lai yue xiao;
越来越少__越來越少 750.493000864|yue lai yue shao;
约束机制__約束機制 115.467403456|yue shu ji zhi;
跃跃欲试__躍躍欲試 171.190483873|yue yue yu shi;
晕头转向__暈頭轉向 143.247667161|yun tou zhuan xiang;
运行机制__運行機制 267.775955618|yun xing ji zhi;
运行情况__運行情況 172.260473089|yun xing qing kuang;
运行速度__運行速度 163.069482749|yun xing su du;
运载火箭__運載火箭 137.991222203|yun zai huo jian;
运作模式__運作模式 161.451865638|yun zuo mo shi;
运作方式__運作方式 106.748946222|yun zuo fang shi;
芸芸众生__芸芸眾生 119.121315407|yun yun zhong sheng;
运营模式__運營模式 130.46599058|yun ying mo shi;
运营成本__運營成本 151.888225993|yun ying cheng ben;
鸦片战争__鴉片戰爭 127.572086295|ya pian zhan zheng;
亚太地区__亞太地區 338.046607007|ya tai di qu;
亚特兰大__亞特蘭大 199.299593609|ya te lan da;
亚历山大__亞歷山大 256.987424161|ya li shan da;
雅虎中国__雅虎中國 211.321149687|ya hu zhong guo;
亚洲第一__亞洲第一 107.550099352|ya zhou di yi;
亚洲国家__亞洲國家 211.321149687|ya zhou guo jia;
亚洲最大__亞洲最大 154.947067523|ya zhou zui da;
压缩文件__壓縮文件 134.930398555|ya suo wen jian;
研发中心__研發中心 398.985038482|yan fa zhong xin;
研发人员__研發人員 113.046974828|yan fa ren yuan;
延年益寿__延年益壽 150.756793028|yan nian yi shou;
言论自由__言論自由 362.479927203|yan lun zi you;
严厉打击__嚴厲打擊 285.702569086|yan li da ji;
严格控制__嚴格控制 386.264972075|yan ge kong zhi;
严格执行__嚴格執行 514.472385324|yan ge zhi xing;
严格遵守__嚴格遵守 246.94109417|yan ge zun shou;
严格要求__嚴格要求 230.582949765|yan ge yao qiu;
严格按照__嚴格按照 546.866130582|yan ge an zhao;
烟花爆竹__煙花爆竹 296.585723861|yan hua bao zhu;
眼花缭乱__眼花繚亂 314.083839199|yan hua liao luan;
延缓衰老__延緩衰老 147.045868173|yan huan shuai lao;
炎黄子孙__炎黃子孫 122.432284019|yan huang zi sun;
沿海地区__沿海地區 288.205701591|yan hai di qu;
研究报告__研究報告 637.454253928|yan jiu bao gao;
研究发现__研究發現 284.281980745|yan jiu fa xian;
研究方法__研究方法 219.644465616|yan jiu fang fa;
研究方向__研究方向 242.36802267|yan jiu fang xiang;
研究对象__研究對象 156.694657831|yan jiu dui xiang;
研究领域__研究領域 210.532600599|yan jiu ling yu;
研究工作__研究工作 324.83145542|yan jiu gong zuo;
研究开发__研究開發 321.208662461|yan jiu kai fa;
研究课题__研究課題 135.94305409|yan jiu ke ti;
研究机构__研究機構 398.985038482|yan jiu ji gou;
研究进展__研究進展 653.541376022|yan jiu jin zhan;
研究现状__研究現狀 109.442917312|yan jiu xian zhuang;
研究小组__研究小組 159.253810404|yan jiu xiao zu;
研究项目__研究項目 122.432284019|yan jiu xiang mu;
研究中心__研究中心 1057.24961018|yan jiu zhong xin;
研究成果__研究成果 598.201722298|yan jiu cheng guo;
研究生院__研究生院 285.702569086|yan jiu sheng yuan;
研究人员__研究人員 718.463208478|yan jiu ren yuan;
言情小说__言情小說 134.930398555|yan qing xiao shuo;
烟消云散__煙消雲散 175.510734618|yan xiao yun san;
研制成功__研製成功 179.268563673|yan zhi cheng gong;
严重后果__嚴重後果 193.427195796|yan zhong hou guo;
严重影响__嚴重影響 619.442999798|yan zhong ying xiang;
严肃处理__嚴肅處理 168.020228531|yan su chu li;
严严实实__嚴嚴實實 125.835280772|yan yan shi shi;
奄奄一息__奄奄一息 143.247667161|yan yan yi xi;
养老保险__養老保險 515.756221017|yang lao bao xian;
阳光明媚__陽光明媚 171.617679695|yang guang ming mei;
养家糊口__養家糊口 170.977284899|yang jia hu kou;
养成良好__養成良好 129.817279349|yang cheng liang hao;
央视春晚__央視春晚 128.369448119|yang shi chun wan;
仰卧起坐__仰卧起坐 128.049907079|yang wo qi zuo;
遥不可及__遙不可及 175.948711373|yao bu ke ji;
要多少钱__要多少錢 169.070402749|yao duo shao qian;
摇身一变__搖身一變 141.473639374|yao shen yi bian;
要做什么__要做什麼 158.067510349|yao zuo shen me;
腰酸背疼__腰酸背疼 105.558392399|yao suan bei teng;
咬牙切齿__咬牙切齒 219.918349804|yao ya qie chi;
遥遥领先__遙遙領先 138.335571213|yao yao ling xian;
摇摇欲坠__搖搖欲墜 107.818484324|yao yao yu zhui;
遥遥无期__遙遙無期 164.498187167|yao yao wu qi;
药物治疗__藥物治療 317.230705235|yao wu zhi liao;
也不例外__也不例外 476.219822262|ye bu li wai;
也不可能__也不可能 820.943519051|ye bu ke neng;
也不知道__也不知道 3241.3000394|ye bu zhi dao;
业内人士__業內人士 1179.78648723|ye nei ren shi;
耶鲁大学__耶魯大學 116.333988795|ye lu da xue;
耶路撒冷__耶路撒冷 179.268563673|ye lu sa leng;
业绩增长__業績增長 281.461959558|ye ji zeng zhang;
液晶面板__液晶面板 180.164388413|ye jing mian ban;
液晶电视__液晶電視 859.681929668|ye jing dian shi;
也就是说__也就是說 2385.52098173|ye jiu shi shuo;
业主大会__業主大會 128.689786556|ye zhu da hui;
业主论坛__業主論壇 158.857391092|ye zhu lun tan;
夜深人静__夜深人靜 195.852702213|ye shen ren jing;
野生动物__野生動物 419.377126323|ye sheng dong wu;
也是一种__也是一種 1027.37704867|ye shi yi zhong;
爷爷奶奶__爺爺奶奶 320.010065926|ye ye nai nai;
业余时间__業餘時間 229.150692759|ye yu shi jian;
业务部门__業務部門 242.972837869|ye wu bu men;
业务培训__業務培訓 126.464093517|ye wu pei xun;
业务模式__業務模式 117.207077876|ye wu mo shi;
业务发展__業務發展 262.817045902|ye wu fa zhan;
业务范围__業務範圍 200.04606951|ye wu fan wei;
业务能力__業務能力 110.539446825|ye wu neng li;
业务流程__業務流程 349.178797604|ye wu liu cheng;
业务逻辑__業務邏輯 122.279808036|ye wu luo ji;
业务工作__業務工作 113.187937993|ye wu gong zuo;
业务系统__業務系統 133.925286409|ye wu xi tong;
业务收入__業務收入 159.253810404|ye wu shou ru;
业务水平__業務水平 108.898738333|ye wu shui ping;
业务人员__業務人員 207.149415951|ye wu ren yuan;
业务素质__業務素質 117.353228453|ye wu su zhi;
一百五十__一百五十 135.773751924|yi bai wu shi;
一百二十__一百二十 126.779677253|yi bai er shi;
一般来说__一般來說 938.041438335|yi ban lai shuo;
一般说来__一般說來 110.126966673|yi ban shuo lai;
一般而言__一般而言 164.908682755|yi ban er yan;
一本正经__一本正經 252.228305921|yi ben zheng jing;
一波三折__一波三折 119.26985293|yi bo san zhe;
一步到位__一步到位 174.638049069|yi bu dao wei;
一不小心__一不小心 685.233853433|yi bu xiao xin;
义不容辞__義不容辭 177.490254874|yi bu rong ci;
一步一步__一步一步 660.912425973|yi bu yi bu;
一片空白__一片空白 272.149298879|yi pian kong bai;
一篇文章__一篇文章 755.18379558|yi pian wen zhang;
一脉相承__一脈相承 137.991222203|yi mai xiang cheng;
一鸣惊人__一鳴驚人 108.763116896|yi ming jing ren;
一模一样__一模一樣 739.353626862|yi mo yi yang;
一目了然__一目了然 381.481335404|yi mu liao ran;
一模一样__一模一樣 150.756793028|yi mu yi yang;
依法行政__依法行政 372.555031371|yi fa xing zheng;
依法治国__依法治國 179.71591787|yi fa zhi guo;
一帆风顺__一帆風順 286.772667017|yi fan feng shun;
义愤填膺__義憤填膺 137.305093541|yi fen tian ying;
一分为二__一分為二 139.200207879|yi fen wei er;
一段时间__一段時間 4537.78699065|yi duan shi jian;
意大利队__意大利隊 232.893204426|yi da li dui;
意大利人__意大利人 215.040276584|yi da li ren;
意大利语__意大利語 124.587019602|yi da li yu;
一点也不__一點也不 941.55486912|yi dian ye bu;
一点一滴__一點一滴 189.845141544|yi dian yi di;
一点一点__一點一點 441.911471008|yi dian yi dian;
一定程度__一定程度 1666.16002844|yi ding cheng du;
一定要把__一定要把 354.881620091|yi ding yao ba;
一定要看__一定要看 183.335174792|yi ding yao kan;
一动不动__一動不動 303.313611771|yi dong bu dong;
移动电话__移動電話 357.099731154|yi dong dian hua;
移动电视__移動電視 119.56748386|yi dong dian shi;
移动通信__移動通信 553.723632203|yi dong tong xin;
移动公司__移動公司 168.649547684|yi dong gong si;
移动设备__移動設備 140.770195218|yi dong she bei;
移动硬盘__移動硬盤 619.442999798|yi dong ying pan;
移动用户__移動用戶 208.70407676|yi dong yong hu;
一塌糊涂__一塌糊塗 880.279644448|yi ta hu tu;
一台电脑__一台電腦 270.458854115|yi tai dian nao;
一天到晚__一天到晚 479.196331601|yi tian dao wan;
一天一天__一天一天 138.335571213|yi tian yi tian;
一头雾水__一頭霧水 218.552335545|yi tou wu shui;
一男一女__一男一女 201.045721733|yi nan yi nv;
疑难问题__疑難問題 188.196293023|yi nan wen ti;
一年四季__一年四季 228.011295226|yi nian si ji;
一年一度__一年一度 328.904723278|yi nian yi du;
议论纷纷__議論紛紛 131.445140637|yi lun fen fen;
伊拉克人__伊拉克人 125.835280772|yi la ke ren;
伊莱克斯__伊萊克斯 127.572086295|yi lai ke si;
一劳永逸__一勞永逸 129.171793682|yi lao yong yi;
伊丽莎白__伊麗莎白 230.582949765|yi li sha bai;
一帘幽梦__一簾幽夢 141.121478992|yi lian you meng;
医疗保健__醫療保健 175.948711373|yi liao bao jian;
医疗保险__醫療保險 613.298247397|yi liao bao xian;
医疗保障__醫療保障 193.668388536|yi liao bao zhang;
医疗费用__醫療費用 315.260239073|yi liao fei yong;
医疗服务__醫療服務 362.028498203|yi liao fu wu;
医疗机构__醫療機構 759.903909096|yi liao ji gou;
医疗救助__醫療救助 157.870654598|yi liao jiu zhu;
医疗器械__醫療器械 494.360275282|yi liao qi xie;
意料之中__意料之中 189.608710238|yi liao zhi zhong;
意料之外__意料之外 153.41002317|yi liao zhi wai;
医疗设备__醫療設備 157.477678279|yi liao she bei;
医疗事故__醫療事故 152.457122789|yi liao shi gu;
医疗卫生__醫療衛生 539.420927296|yi liao wei sheng;
遗留问题__遺留問題 107.282382453|yi liu wen ti;
一路顺风__一路順風 186.794397067|yi lu shun feng;
一路走来__一路走來 186.794397067|yi lu zou lai;
乙肝病毒__乙肝病毒 196.831399718|yi gan bing du;
乙肝疫苗__乙肝疫苗 113.895394799|yi gan yi miao;
一干二净__一乾二淨 140.244908425|yi gan er jing;
一个女生__一個女生 226.595011951|yi ge nv sheng;
一个人住__一個人住 120.314814642|yi ge ren zhu;
一个人走__一個人走 157.67404401|yi ge ren zou;
一个月内__一個月內 269.114061535|yi ge yue nei;
一个月后__一個月後 298.811606079|yi ge yue hou;
一国两制__一國兩制 120.46484039|yi guo liang zhi;
医科大学__醫科大學 418.854838101|yi ke da xue;
异口同声__異口同聲 156.304608838|yi kou tong sheng;
一口一口__一口一口 882.476330723|yi kou yi kou;
医护人员__醫護人員 341.433560596|yi hu ren yuan;
一蹶不振__一蹶不振 105.690017726|yi jue bu zhen;
异军突起__異軍突起 149.820373083|yi jun tu qi;
以及其他__以及其他 628.775756137|yi ji qi ta;
一技之长__一技之長 117.353228453|yi ji zhi chang;
一级市场__一級市場 134.092283643|yi ji shi chang;
意见建议__意見建議 566.990680223|yi jian jian yi;
一见钟情__一見鍾情 427.82286438|yi jian zhong qing;
一件事情__一件事情 763.701232553|yi jian shi qing;
一举两得__一舉兩得 119.121315407|yi ju liang de;
一举一动__一舉一動 322.813777494|yi ju yi dong;
一起分享__一起分享 389.649164279|yi qi fen xiang;
意气风发__意氣風發 163.476413088|yi qi feng fa;
一汽丰田__一汽豐田 142.357889859|yi qi feng tian;
一汽大众__一汽大眾 211.321149687|yi qi da zhong;
一气呵成__一氣呵成 142.003528374|yi qi he cheng;
一气之下__一氣之下 150.569041974|yi qi zhi xia;
仪器设备__儀器設備 181.064689688|yi qi she bei;
一起走过__一起走過 114.179614083|yi qi zou guo;
仪器仪表__儀器儀錶 157.085680168|yi qi yi biao;
一窍不通__一竅不通 190.556205829|yi qiao bu tong;
一切都是__一切都是 686.943814365|yi qie dou shi;
一清二楚__一清二楚 164.703307075|yi qing er chu;
异曲同工__異曲同工 159.651218957|yi qu tong gong;
医学专家__醫學專家 205.094534596|yi xue zhuan jia;
一系列的__一系列的 668.366611253|yi xi lie de;
一席之地__一席之地 261.184568064|yi xi zhi di;
以下内容__以下內容 166.768626413|yi xia nei rong;
以下几点__以下幾點 273.509258874|yi xia ji dian;
以下简称__以下簡稱 738.432842998|yi xia jian cheng;
意想不到__意想不到 546.866130582|yi xiang bu dao;
异想天开__異想天開 112.906187218|yi xiang tian kai;
一厢情愿__一廂情願 282.868455943|yi xiang qing yuan;
一些东西__一些東西 455.895552723|yi xie dong xi;
一些事情__一些事情 377.226735448|yi xie shi qing;
一些问题__一些問題 728.379591714|yi xie wen ti;
一心一意__一心一意 263.144763849|yi xin yi yi;
一张照片__一張照片 264.130371602|yi zhang zhao pian;
一朝一夕__一朝一夕 110.126966673|yi zhao yi xi;
一针见血__一針見血 116.769717326|yi zhen jian xie;
一知半解__一知半解 120.916041011|yi zhi ban jie;
一直没有__一直沒有 1223.20236253|yi zhi mei you;
一直都在__一直都在 335.110594827|yi zhi dou zai;
一枝独秀__一枝獨秀 122.279808036|yi zhi du xiu;
一直以来__一直以來 1038.96445205|yi zhi yi lai;
一直以为__一直以為 408.035799866|yi zhi yi wei;
一种特殊__一種特殊 251.600451735|yi zhong te shu;
遗传算法__遺傳算法 112.484875527|yi chuan suan fa;
一成不变__一成不變 225.749468142|yi cheng bu bian;
易初莲花__易初蓮花 118.08671951|yi chu lian hua;
一触即发__一觸即發 132.762114633|yi chu ji fa;
一闪而过__一閃而過 117.207077876|yi shan er guo;
以上学历__以上學歷 386.264972075|yi shang xue li;
一审判决__一審判決 226.030964922|yi shen pan jue;
以身相许__以身相許 106.483223576|yi shen xiang xu;
以身作则__以身作則 133.925286409|yi shen zuo ze;
一声不吭__一聲不吭 109.579386421|yi sheng bu keng;
一声叹息__一聲嘆息 152.457122789|yi sheng tan xi;
一生一世__一生一世 222.121753798|yi sheng yi shi;
一视同仁__一視同仁 181.064689688|yi shi tong ren;
意识形态__意識形態 772.314734527|yi shi xing tai;
衣食住行__衣食住行 159.253810404|yi shi zhu xing;
议事日程__議事日程 199.796934068|yi shi ri cheng;
一室一厅__一室一廳 108.087539034|yi shi yi ting;
一事无成__一事無成 135.267109459|yi shi wu cheng;
衣食无忧__衣食無憂 109.989815613|yi shi wu you;
艺术学院__藝術學院 208.44415872|yi shu xue yuan;
艺术形式__藝術形式 124.431860131|yi shu xing shi;
艺术中心__藝術中心 122.127521944|yi shu zhong xin;
艺术创作__藝術創作 139.547573842|yi shu chuang zuo;
艺术设计__藝術設計 142.535402072|yi shu she ji;
艺术作品__藝術作品 169.915266157|yi shu zuo pin;
以人为本__以人為本 830.202635471|yi ren wei ben;
一日三餐__一日三餐 117.646076559|yi ri san can;
一如既往__一如既往 726.566487616|yi ru ji wang;
一次会议__一次會議 207.925293333|yi ci hui yi;
一蹴而就__一蹴而就 115.179978568|yi cu er jiu;
一丝不挂__一絲不掛 156.304608838|yi si bu gua;
一丝不苟__一絲不苟 185.634130949|yi si bu gou;
伊斯兰教__伊斯蘭教 247.249015706|yi si lan jiao;
医院检查__醫院檢查 359.779772295|yi yuan jian cha;
医院治疗__醫院治療 134.42690308|yi yuan zhi liao;
一言不发__一言不發 184.481071779|yi yan bu fa;
一言难尽__一言難盡 125.992190229|yi yan nan jin;
一言一行__一言一行 116.333988795|yi yan yi xing;
一氧化碳__一氧化碳 129.332863581|yi yang hua tan;
医药行业__醫藥行業 152.267254161|yi yao hang ye;
一夜暴富__一夜暴富 108.357265155|yi ye bao fu;
一夜之间__一夜之間 413.667597456|yi ye zhi jian;
依依不舍__依依不捨 181.516526012|yi yi bu she;
一意孤行__一意孤行 116.624293448|yi yi gu xing;
一应俱全__一應俱全 201.79873775|yi ying ju quan;
意犹未尽__意猶未盡 186.794397067|yi you wei jin;
亿万富翁__億萬富翁 183.335174792|yi wan fu weng;
一网打尽__一網打盡 167.184787749|yi wang da jin;
一望无际__一望無際 128.850255419|yi wang wu ji;
一文不值__一文不值 107.952927857|yi wen bu zhi;
意味深长__意味深長 191.747236314|yi wei shen chang;
以为自己__以為自己 744.902491688|yi wei zi ji;
义无返顾__義無返顧 113.47039186|yi wu fan gu;
义无反顾__義無反顧 263.472890441|yi wu fan gu;
义务教育__義務教育 582.024395035|yi wu jiao yu;
一无是处__一無是處 205.350275845|yi wu shi chu;
医务人员__醫務人員 348.309611377|yi wu ren yuan;
一无所获__一無所獲 130.954650472|yi wu suo huo;
一无所知__一無所知 357.99085261|yi wu suo zhi;
一无所有__一無所有 383.865702254|yi wu suo you;
引导学生__引導學生 322.010219858|yin dao xue sheng;
因地制宜__因地制宜 230.295783987|yin di zhi yi;
印第安人__印第安人 145.405889264|yin di an ren;
因果关系__因果關係 213.172602547|yin guo guan xi;
银行贷款__銀行貸款 421.472799973|yin hang dai kuan;
银行账户__銀行賬戶 121.217779906|yin hang zhang hu;
银行存款__銀行存款 229.722524886|yin hang cun kuan;
银河证券__銀河證券 125.053659829|yin he zheng quan;
引进外资__引進外資 113.895394799|yin jin wai zi;
音像制品__音像製品 172.475272126|yin xiang zhi pin;
隐形眼镜__隱形眼鏡 226.877563077|yin xing yan jing;
阴差阳错__陰差陽錯 117.93965545|yin cha yang cuo;
饮食习惯__飲食習慣 208.70407676|yin shi xi guan;
饮食文化__飲食文化 125.209594649|yin shi wen hua;
引人关注__引人關注 110.401782066|yin ren guan zhu;
引人注目__引人注目 528.113581536|yin ren zhu mu;
引人入胜__引人入勝 155.527421199|yin ren ru sheng;
因人而异__因人而異 264.789493468|yin ren er yi;
因素分析__因素分析 131.117943492|yin su fen xi;
音乐播放__音樂播放 154.947067523|yin yue bo fang;
音乐风格__音樂風格 114.179614083|yin yue feng ge;
音乐学院__音樂學院 246.94109417|yin yue xue yuan;
音乐手机__音樂手機 210.795122809|yin yue shou ji;
隐隐约约__隱隱約約 191.508436159|yin yin yue yue;
引用通告__引用通告 129.655606164|yin yong tong gao;
应变能力__應變能力 108.357265155|ying bian neng li;
硬盘空间__硬盤空間 105.558392399|ying pan kong jian;
应当按照__應當按照 283.574337601|ying dang an zhao;
应对措施__應對措施 139.200207879|ying dui cuo shi;
盈利模式__盈利模式 263.472890441|ying li mo shi;
盈利能力__盈利能力 429.960742313|ying li neng li;
应该可以__應該可以 426.757915008|ying gai ke yi;
应该注意__應該注意 280.062456643|ying gai zhu yi;
应该如何__應該如何 242.670241844|ying gai ru he;
应该怎么__應該怎麼 227.443722742|ying gai zen me;
应该怎样__應該怎樣 201.79873775|ying gai zen yang;
英格兰队__英格蘭隊 177.711575153|ying ge lan dui;
英国伦敦__英國倫敦 127.413209251|ying guo lun dun;
英国政府__英國政府 161.854759309|ying guo zheng fu;
英国首相__英國首相 105.0335283|ying guo shou xiang;
应急救援__應急救援 134.259489114|ying ji jiu yuan;
应急预案__應急預案 333.444336783|ying ji yu an;
硬件配置__硬件配置 142.891090816|ying jian pei zhi;
硬件设备__硬件設備 131.117943492|ying jian she bei;
硬件设施__硬件設施 130.791560815|ying jian she shi;
硬件维护__硬件維護 135.94305409|ying jian wei hu;
营销模式__營銷模式 164.703307075|ying xiao mo shi;
营销活动__營銷活動 106.748946222|ying xiao huo dong;
营销人员__營銷人員 158.264611567|ying xiao ren yuan;
营销策略__營銷策略 193.186303435|ying xiao ce lue;
营销策划__營銷策劃 147.229226029|ying xiao ce hua;
营销网络__營銷網絡 113.046974828|ying xiao wang luo;
影响因素__影響因素 276.938965124|ying xiang yin su;
英雄无敌__英雄無敵 129.332863581|ying xiong wu di;
硬着头皮__硬着頭皮 243.275811214|ying zhe tou pi;
应试教育__應試教育 189.372573382|ying shi jiao yu;
影视作品__影視作品 200.795341333|ying shi zuo pin;
应收账款__應收賬款 191.269933402|ying shou zhang kuan;
迎刃而解__迎刃而解 150.194241046|ying ren er jie;
映入眼帘__映入眼帘 114.179614083|ying ru yan lian;
应运而生__應運而生 249.726250867|ying yun er sheng;
营养不良__營養不良 280.062456643|ying yang bu liang;
营养价值__營養價值 224.347234118|ying yang jia zhi;
营养成分__營養成分 264.789493468|ying yang cheng fen;
营养物质__營養物質 177.048440864|ying yang wu zhi;
营业执照__營業執照 501.808489233|ying ye zhi zhao;
营业收入__營業收入 297.696584607|ying ye shou ru;
营业网点__營業網點 117.792774542|ying ye wang dian;
应有尽有__應有盡有 290.730764849|ying you jin you;
应用范围__應用範圍 111.230349808|ying yong fan wei;
应用领域__應用領域 171.403948695|ying yong ling yu;
应用技术__應用技術 136.622376491|ying yong ji shu;
应用前景__應用前景 125.835280772|ying yong qian jing;
应用系统__應用系統 309.4219738|ying yong xi tong;
应用程序__應用程序 2221.95191814|ying yong cheng xu;
应用软件__應用軟件 487.62990282|ying yong ruan jian;
应用研究__應用研究 262.489736092|ying yong yan jiu;
英语老师__英語老師 117.93965545|ying yu lao shi;
英语口语__英語口語 168.439513167|ying yu kou yu;
英语教学__英語教學 175.510734618|ying yu jiao xue;
英语学习__英語學習 254.438159592|ying yu xue xi;
英语专业__英語專業 142.357889859|ying yu zhuan ye;
英语水平__英語水平 195.852702213|ying yu shui ping;
英语四级__英語四級 131.117943492|ying yu si ji;
英文名称__英文名稱 108.627664361|ying wen ming cheng;
英文名字__英文名字 122.890853693|ying wen ming zi;
英文字母__英文字母 137.476305203|ying wen zi mu;
有没有人__有沒有人 524.179602378|you mei you ren;
有目共睹__有目共睹 295.847453874|you mu gong du;
有丰富的__有豐富的 390.621510938|you feng fu de;
有的放矢__有的放矢 131.281440129|you di fang shi;
有多少个__有多少個 165.32020271|you duo shao ge;
有多少人__有多少人 772.314734527|you duo shao ren;
有条不紊__有條不紊 197.322580943|you tiao bu wen;
有条件的__有條件的 384.344361008|you tiao jian de;
由来已久__由來已久 156.109948588|you lai yi jiu;
有利条件__有利條件 194.636170786|you li tiao jian;
有利可图__有利可圖 114.607273411|you li ke tu;
有良好的__有良好的 377.697115787|you liang hao de;
优良传统__優良傳統 232.024158785|you liang chuan tong;
有关部门__有關部門 4132.89016505|you guan bu men;
有关法律__有關法律 627.210588862|you guan fa lv;
有关方面__有關方面 516.399339766|you guan fang mian;
有关单位__有關單位 364.291279287|you guan dan wei;
有关规定__有關規定 3510.3970506|you guan gui ding;
有关情况__有關情況 269.114061535|you guan qing kuang;
有关政策__有關政策 175.292155245|you guan zheng ce;
有关事项__有關事項 162.460985719|you guan shi xiang;
有关人士__有關人士 586.392500602|you guan ren shi;
有关人员__有關人員 381.006242235|you guan ren yuan;
有关资料__有關資料 196.831399718|you guan zi liao;
有关问题__有關問題 403.988165198|you guan wen ti;
有关文件__有關文件 146.862738669|you guan wen jian;
有感而发__有感而發 126.621787068|you gan er fa;
优化配置__優化配置 126.149295342|you hua pei zhi;
优化大师__優化大師 332.200082586|you hua da shi;
优化设计__優化設計 137.476305203|you hua she ji;
忧患意识__憂患意識 121.368931601|you huan yi shi;
有害物质__有害物質 234.348853194|you hai wu zhi;
友好合作__友好合作 131.445140637|you hao he zuo;
有很多人__有很多人 695.557838999|you hen duo ren;
又回来了__又回來了 199.548108896|you hui lai le;
优惠活动__優惠活動 149.633788238|you hui huo dong;
优惠政策__優惠政策 878.088426229|you hui zheng ce;
有机结合__有機結合 299.93080386|you ji jie he;
有机食品__有機食品 113.47039186|you ji shi pin;
油价上涨__油價上漲 155.333728851|you jia shang zhang;
邮件地址__郵件地址 239.963779681|you jian di zhi;
右键菜单__右鍵菜單 123.967540162|you jian cai dan;
有经验的__有經驗的 389.163898974|you jing yan de;
有期徒刑__有期徒刑 481.590928402|you qi tu xing;
友情提示__友情提示 137.819369268|you qing ti shi;
友情连接__友情連接 105.164499152|you qing lian jie;
友情链接__友情鏈接 416.253137598|you qing lian jie;
游戏规则__遊戲規則 447.452879516|you xi gui ze;
游戏画面__遊戲畫面 105.821807183|you xi hua mian;
游戏玩家__遊戲玩家 200.29551561|you xi wan jia;
优先发展__優先發展 146.862738669|you xian fa zhan;
有线电视__有線電視 499.3133654|you xian dian shi;
有限公司__有限公司 10602.3833536|you xian gong si;
优先考虑__優先考慮 206.633773476|you xian kao lv;
有限责任__有限責任 111.786180106|you xian ze ren;
有效途径__有效途徑 221.568841736|you xiao tu jing;
有效利用__有效利用 119.41857567|you xiao li yong;
有效控制__有效控制 232.603161479|you xiao kong zhi;
有效成分__有效成分 288.205701591|you xiao cheng fen;
有效措施__有效措施 268.778909483|you xiao cuo shi;
邮箱地址__郵箱地址 201.547419552|you xiang di zhi;
有些事情__有些事情 486.416079992|you xie shi qing;
忧心忡忡__憂心忡忡 170.339279748|you xin chong chong;
优秀教师__優秀教師 147.412812521|you xiu jiao shi;
优秀学生__優秀學生 113.046974828|you xiu xue sheng;
优秀人才__優秀人才 267.44247003|you xiu ren cai;
优秀作品__優秀作品 143.605133321|you xiu zuo pin;
有朝一日__有朝一日 195.365179853|you zhao yi ri;
有针对性__有針對性 655.989212862|you zhen dui xing;
邮政编码__郵政編碼 190.556205829|you zheng bian ma;
邮政储蓄__郵政儲蓄 122.127521944|you zheng chu xu;
优质服务__優質服務 480.991159713|you zhi fu wu;
有偿使用__有償使用 111.646962678|you chang shi yong;
优胜劣汰__優勝劣汰 137.134095104|you sheng lie tai;
有生之年__有生之年 166.353500999|you sheng zhi nian;
有声有色__有聲有色 152.837570606|you sheng you se;
优势互补__優勢互補 146.497163581|you shi hu bu;
有识之士__有識之士 211.584655172|you shi zhi shi;
优势产业__優勢產業 166.768626413|you shi chan ye;
有史以来__有史以來 478.003501869|you shi yi lai;
又是一个__又是一個 600.442284667|you shi yi ge;
有谁知道__有誰知道 225.187525865|you shui zhi dao;
油然而生__油然而生 154.754097942|you ran er sheng;
有人认为__有人認為 454.760723981|you ren ren wei;
游刃有余__遊刃有餘 217.465635832|you ren you yu;
优柔寡断__優柔寡斷 118.972962872|you rou gua duan;
由此可见__由此可見 370.702589737|you ci ke jian;
有色金属__有色金屬 518.979844093|you se jin shu;
有所不同__有所不同 564.171453387|you suo bu tong;
有所作为__有所作為 190.556205829|you suo zuo wei;
有一个人__有一個人 674.222387052|you yi ge ren;
有意无意__有意無意 268.778909483|you yi wu yi;
有影响的__有影響的 196.586267794|you ying xiang de;
犹豫不决__猶豫不決 203.060037258|you yu bu jue;
尤文图斯__尤文圖斯 341.433560596|you wen tu si;
用户提供__用戶提供 771.352901218|yong hu ti gong;
用户体验__用戶體驗 281.812926654|yong hu ti yan;
用户列表__用戶列表 105.164499152|yong hu lie biao;
用户可以__用戶可以 598.201722298|yong hu ke yi;
用户界面__用戶界面 253.804804573|yong hu jie mian;
用户需求__用戶需求 198.06165195|yong hu xu qiu;
用心良苦__用心良苦 112.484875527|yong xin liang ku;
涌上心头__湧上心頭 108.492380517|yong shang xin tou;
用人单位__用人單位 1637.34374958|yong ren dan wei;
永远不会__永遠不會 699.905273328|yong yuan bu hui;
勇往直前__勇往直前 174.855812809|yong wang zhi qian;
用武之地__用武之地 121.671800659|yong wu zhi di;
欲罢不能__欲罷不能 156.89004718|yu ba bu neng;
玉米价格__玉米價格 137.476305203|yu mi jia ge;
域名交易__域名交易 291.819695868|yu ming jiao yi;
域名解析__域名解析 172.690339006|yu ming jie xi;
域名注册__域名註冊 241.764712994|yu ming zhu ce;
预防措施__預防措施 138.508067822|yu fang cuo shi;
遇到困难__遇到困難 173.553291634|yu dao kun nan;
遇到问题__遇到問題 219.097720093|yu dao wen ti;
舆论监督__輿論監督 227.727332161|yu lun jian du;
娱乐八卦__娛樂八卦 419.900065808|yu le ba gua;
娱乐活动__娛樂活動 142.535402072|yu le huo dong;
娱乐节目__娛樂節目 211.321149687|yu le jie mu;
娱乐新闻__娛樂新聞 116.47905068|yu le xin wen;
娱乐场所__娛樂場所 357.99085261|yu le chang suo;
育龄妇女__育齡婦女 107.416157498|yu ling fu nv;
鱼龙混杂__魚龍混雜 114.607273411|yu long hun za;
玉龙雪山__玉龍雪山 107.14877401|yu long xue shan;
欲哭无泪__欲哭無淚 165.526347625|yu ku wu lei;
雨后春笋__雨後春筍 187.26053154|yu hou chun sun;
与众不同__與眾不同 875.902662456|yu zhong bu tong;
语重心长__語重心長 140.070248771|yu zhong xin chang;
与世隔绝__與世隔絕 133.758497151|yu shi ge jue;
与时俱进__與時俱進 635.075580657|yu shi ju jin;
与日俱增__與日俱增 168.229740225|yu ri ju zeng;
与此同时__與此同時 935.706437745|yu ci tong shi;
语言表达__語言表達 138.85370659|yu yan biao da;
欲言又止__欲言又止 116.624293448|yu yan you zhi;
愈演愈烈__愈演愈烈 321.609191441|yu yan yu lie;
语言文明__語言文明 2933.74914717|yu yan wen ming;
语言文字__語言文字 220.467143161|yu yan wen zi;
郁郁葱葱__鬱鬱蔥蔥 107.14877401|yu yu cong cong;
语文老师__語文老師 177.048440864|yu wen lao shi;
语文教学__語文教學 158.461958559|yu wen jiao xue;
语无伦次__語無倫次 178.377193209|yu wu lun ci;
瓦伦西亚__瓦倫西亞 171.190483873|wa lun xi ya;
哇哈哈哈__哇哈哈哈 406.513206136|wa ha ha ha;
外部环境__外部環境 246.633556117|wai bu huan jing;
外贸公司__外貿公司 324.83145542|wai mao gong si;
外贸企业__外貿企業 113.187937993|wai mao qi ye;
外贸出口__外貿出口 156.89004718|wai mao chu kou;
外来人口__外來人口 157.2815571|wai lai ren kou;
外来人员__外來人員 108.087539034|wai lai ren yuan;
外观设计__外觀設計 371.627656329|wai guan she ji;
外国公司__外國公司 117.061109314|wai guo gong si;
外国企业__外國企業 110.677283245|wai guo qi ye;
外科手术__外科手術 119.56748386|wai ke shou shu;
外汇交易__外匯交易 145.587202159|wai hui jiao yi;
外汇储备__外匯儲備 562.066236349|wai hui chu bei;
外汇市场__外匯市場 218.280152578|wai hui shi chang;
外交部长__外交部長 136.792736844|wai jiao bu zhang;
外交政策__外交政策 179.940013424|wai jiao zheng ce;
外出务工__外出務工 185.634130949|wai chu wu gong;
外商投资__外商投資 304.070513117|wai shang tou zi;
外资并购__外資併購 119.86585751|wai zi bing gou;
外资企业__外資企業 522.223615731|wai zi qi ye;
外资银行__外資銀行 490.066643104|wai zi yin hang;
完美世界__完美世界 107.952927857|wan mei shi jie;
万分之一__萬分之一 125.209594649|wan fen zhi yi;
完全不同__完全不同 790.819158167|wan quan bu tong;
完全没有__完全沒有 739.353626862|wan quan mei you;
完全免费__完全免費 170.76435144|wan quan mian fei;
完全可以__完全可以 1532.69625148|wan quan ke yi;
完全相同__完全相同 266.776744296|wan quan xiang tong;
晚些时候__晚些時候 117.792774542|wan xie shi hou;
完成情况__完成情況 164.293322714|wan cheng qing kuang;
完成任务__完成任務 399.482550191|wan cheng ren wu;
晚上睡觉__晚上睡覺 221.568841736|wan shang shui jiao;
玩世不恭__玩世不恭 131.281440129|wan shi bu gong;
万事如意__萬事如意 135.098649108|wan shi ru yi;
万元左右__萬元左右 216.11485651|wan yuan zuo you;
万元以下__萬元以下 163.884358899|wan yuan yi xia;
万元以上__萬元以上 387.711726118|wan yuan yi shang;
完完全全__完完全全 171.190483873|wan wan quan quan;
万无一失__萬無一失 139.200207879|wan wu yi shi;
网络平台__網絡平台 192.945711079|wang luo ping tai;
网络媒体__網絡媒體 350.92368248|wang luo mei ti;
网络服务__網絡服務 296.216358865|wang luo fu wu;
网络道德__網絡道德 141.29744947|wang luo dao de;
网络电话__網絡電話 233.183609039|wang luo dian hua;
网络电视__網絡電視 287.130256264|wang luo dian shi;
网络推广__網絡推廣 175.948711373|wang luo tui guang;
网络连接__網絡連接 259.238974004|wang luo lian jie;
网络管理__網絡管理 148.149450567|wang luo guan li;
网络广告__網絡廣告 325.642053285|wang luo guang gao;
网络公司__網絡公司 286.772667017|wang luo gong si;
网络环境__網絡環境 286.772667017|wang luo huan jing;
网络技术__網絡技術 330.548296374|wang luo ji shu;
网络建设__網絡建設 225.187525865|wang luo jian she;
网络系统__網絡系統 178.822323044|wang luo xi tong;
网络信息__網絡信息 125.678566729|wang luo xin xi;
网络中心__網絡中心 141.29744947|wang luo zhong xin;
网络传播__網絡傳播 867.213880777|wang luo chuan bo;
网络设备__網絡設備 250.661599628|wang luo she bei;
网络视频__網絡視頻 164.293322714|wang luo shi pin;
网络时代__網絡時代 172.04594156|wang luo shi dai;
网络世界__網絡世界 127.890434962|wang luo shi jie;
网络资源__網絡資源 215.576896995|wang luo zi yuan;
网络硬盘__網絡硬盤 117.792774542|wang luo ying pan;
网络营销__網絡營銷 628.775756137|wang luo ying xiao;
网络应用__網絡應用 186.561765129|wang luo ying yong;
网络游戏__網絡遊戲 1528.88101848|wang luo you xi;
网络安全__網絡安全 450.24958728|wang luo an quan;
忘记密码__忘記密碼 170.76435144|wang ji mi ma;
网站地址__網站地址 148.334184528|wang zhan di zhi;
网站推广__網站推廣 174.42055653|wang zhan tui guang;
网站内容__網站內容 144.322743975|wang zhan nei rong;
网站建设__網站建設 330.548296374|wang zhan jian she;
网站系统__網站系統 141.121478992|wang zhan xi tong;
网站设计__網站設計 116.333988795|wang zhan she ji;
网站源码__網站源碼 155.140277726|wang zhan yuan ma;
网站优化__網站優化 116.915322539|wang zhan you hua;
望尘莫及__望塵莫及 108.087539034|wang chen mo ji;
网上报名__網上報名 226.877563077|wang shang bao ming;
网上邻居__網上鄰居 130.954650472|wang shang lin ju;
网上购物__網上購物 263.801426189|wang shang gou wu;
网上交易__網上交易 256.028470459|wang shang jiao yi;
网上下载__網上下載 219.37092252|wang shang xia zai;
网上支付__網上支付 152.267254161|wang shang zhi fu;
网上商城__網上商城 107.684208225|wang shang shang cheng;
网上银行__網上銀行 475.034401746|wang shang yin hang;
网页制作__網頁製作 136.963309627|wang ye zhi zuo;
网页设计__網頁設計 252.54282031|wang ye she ji;
网友评论__網友評論 255.391156791|wang you ping lun;
网友观点__網友觀點 108.357265155|wang you guan dian;
网友上传__網友上傳 116.47905068|wang you shang chuan;
望而却步__望而卻步 151.888225993|wang er que bu;
文本文件__文本文件 183.106850936|wen ben wen jian;
文明单位__文明單位 111.369047744|wen ming dan wei;
文明用语__文明用語 707.799244422|wen ming yong yu;
稳定发展__穩定發展 225.187525865|wen ding fa zhan;
问题解决__問題解決 282.868455943|wen ti jie jue;
文化背景__文化背景 207.666345181|wen hua bei jing;
文化发展__文化發展 143.426288875|wen hua fa zhan;
文化氛围__文化氛圍 153.984619852|wen hua fen wei;
文化底蕴__文化底蘊 270.458854115|wen hua di yun;
文化内涵__文化內涵 231.158356006|wen hua nei han;
文化广场__文化廣場 115.179978568|wen hua guang chang;
文化活动__文化活動 233.183609039|wen hua huo dong;
文化建设__文化建設 465.076726846|wen hua jian she;
文化交流__文化交流 324.02287532|wen hua jiao liu;
文化教育__文化教育 126.306596357|wen hua jiao yu;
文化知识__文化知識 107.818484324|wen hua zhi shi;
文化中心__文化中心 180.839193473|wen hua zhong xin;
文化传播__文化傳播 150.381524744|wen hua chuan bo;
文化传统__文化傳統 185.86560618|wen hua chuan tong;
文化产业__文化產業 526.142915167|wen hua chan ye;
文化程度__文化程度 232.603161479|wen hua cheng du;
文化生活__文化生活 186.561765129|wen hua sheng huo;
文化市场__文化市場 156.499511818|wen hua shi chang;
文化事业__文化事業 154.561368684|wen hua shi ye;
文化水平__文化水平 143.605133321|wen hua shui ping;
文化素质__文化素質 190.556205829|wen hua su zhi;
文化遗产__文化遺產 566.990680223|wen hua yi chan;
文化艺术__文化藝術 282.516174301|wen hua yi shu;
问卷调查__問卷調查 266.444503116|wen juan diao cha;
文件大小__文件大小 116.915322539|wen jian da xiao;
文件类型__文件類型 115.036534536|wen jian lei xing;
文件列表__文件列表 157.477678279|wen jian lie biao;
文件格式__文件格式 226.312812713|wen jian ge shi;
文件夹里__文件夾里 116.47905068|wen jian jia li;
文件夹下__文件夾下 131.773154284|wen jian jia xia;
文件夹中__文件夾中 176.387781073|wen jian jia zhong;
文件精神__文件精神 122.584950132|wen jian jing shen;
文件系统__文件系統 473.851932013|wen jian xi tong;
文学创作__文學創作 150.194241046|wen xue chuang zuo;
文学作品__文學作品 329.314848809|wen xue zuo pin;
文学艺术__文學藝術 156.499511818|wen xue yi shu;
温馨提示__溫馨提示 871.547443971|wen xin ti shi;
问心无愧__問心無愧 174.638049069|wen xin wu kui;
文章内容__文章內容 329.314848809|wen zhang nei rong;
文章来源__文章來源 368.85935893|wen zhang lai yuan;
文章类型__文章類型 528.772109212|wen zhang lei xing;
温室气体__溫室氣體 179.940013424|wen shi qi ti;
文艺复兴__文藝復興 167.184787749|wen yi fu xing;
文艺演出__文藝演出 138.163289429|wen yi yan chu;
文艺晚会__文藝晚會 115.755545596|wen yi wan hui;
温文尔雅__溫文爾雅 119.56748386|wen wen er ya;
文物保护__文物保護 146.679837233|wen wu bao hu;
微不足道__微不足道 342.712398751|wei bu zu dao;
违法犯罪__違法犯罪 392.573489614|wei fa fan zui;
违法行为__違法行為 813.813436628|wei fa xing wei;
违法所得__違法所得 115.611384758|wei fa suo de;
违法违规__違法違規 248.794392378|wei fa wei gui;
违法违纪__違法違紀 130.628674269|wei fa wei ji;
违法案件__違法案件 142.003528374|wei fa an jian;
违反规定__違反規定 159.452390871|wei fan gui ding;
伟大复兴__偉大復興 145.950506492|wei da fu xing;
维多利亚__維多利亞 343.139741671|wei duo li ya;
委内瑞拉__委內瑞拉 301.805456692|wei nei rui la;
为您服务__為您服務 134.594525802|wei nin fu wu;
为您提供__為您提供 546.185068786|wei nin ti gong;
未来发展__未來發展 365.655730945|wei lai fa zhan;
威廉姆斯__威廉姆斯 245.407229187|wei lian mu si;
微量元素__微量元素 361.577631409|wei liang yuan su;
违规行为__違規行為 198.308623594|wei gui xing wei;
维和部队__維和部隊 113.895394799|wei he bu dui;
为何如此__為何如此 110.539446825|wei he ru ci;
微乎其微__微乎其微 175.729586548|wei hu qi wei;
维基百科__維基百科 202.807148249|wei ji bai ke;
为基础的__為基礎的 407.527636023|wei ji chu de;
未经许可__未經許可 548.230802969|wei jing xu ke;
未经授权__未經授權 354.881620091|wei jing shou quan;
未经允许__未經允許 123.351140937|wei jing yun xu;
危险因素__危險因素 144.143005824|wei xian yin su;
卫星发射__衛星發射 132.10198647|wei xing fa she;
卫星电视__衛星電視 142.180598718|wei xing dian shi;
维修人员__維修人員 115.755545596|wei xiu ren yuan;
为中心的__為中心的 455.895552723|wei zhong xin de;
微处理器__微處理器 165.939408926|wei chu li qi;
卫生部门__衛生部門 221.292902041|wei sheng bu men;
卫生监督__衛生監督 219.918349804|wei sheng jian du;
卫生系统__衛生系統 106.882056102|wei sheng xi tong;
为数不多__為數不多 324.426913464|wei shu bu duo;
微软公司__微軟公司 315.260239073|wei ruan gong si;
为人处世__為人處世 119.86585751|wei ren chu shi;
为所欲为__為所欲為 159.452390871|wei suo yu wei;
违约责任__違約責任 131.609045271|wei yue ze ren;
危言耸听__危言聳聽 118.972962872|wei yan song ting;
未雨绸缪__未雨綢繆 167.601987591|wei yu chou mou;
娓娓道来__娓娓道來 122.737806611|wei wei dao lai;
微微一笑__微微一笑 216.654158472|wei wei yi xiao;
唯物主义__唯物主義 136.282292017|wei wu zhu yi;
我告诉你__我告訴你 455.895552723|wo gao su ni;
卧虎藏龙__卧虎藏龍 121.671800659|wo hu cang long;
我亲爱的__我親愛的 179.940013424|wo qin ai de;
我学会了__我學會了 110.126966673|wo xue hui le;
我行我素__我行我素 172.690339006|wo xing wo su;
我知道你__我知道你 641.438524323|wo zhi dao ni;
我一定会__我一定會 411.098117295|wo yi ding hui;
我爱我家__我愛我家 133.925286409|wo ai wo jia;
无边无际__無邊無際 110.401782066|wu bian wu ji;
无病呻吟__無病呻吟 128.049907079|wu bing shen yin;
物美价廉__物美價廉 186.32942291|wu mei jia lian;
无法访问__無法訪問 137.476305203|wu fa fang wen;
无法打开__無法打開 135.94305409|wu fa da kai;
无法改变__無法改變 214.772467501|wu fa gai bian;
无法抗拒__無法抗拒 106.483223576|wu fa kang ju;
无法控制__無法控制 234.056997396|wu fa kong zhi;
无法进入__無法進入 125.835280772|wu fa jin ru;
无法启动__無法啟動 123.197520618|wu fa qi dong;
无法显示__無法顯示 175.292155245|wu fa xian shi;
无法找到__無法找到 135.94305409|wu fa zhao dao;
无法正常__無法正常 262.817045902|wu fa zheng chang;
无法使用__無法使用 647.865219539|wu fa shi yong;
无法完成__無法完成 115.323601467|wu fa wan cheng;
无法忘记__無法忘記 110.677283245|wu fa wang ji;
无法无天__無法無天 125.209594649|wu fa wu tian;
五分之一__五分之一 152.077621994|wu fen zhi yi;
无地自容__無地自容 132.762114633|wu di zi rong;
无动于衷__無動於衷 291.819695868|wu dong yu zhong;
五体投地__五體投地 160.049619219|wu ti tou di;
无能为力__無能為力 511.914293268|wu neng wei li;
无论如何__無論如何 1159.38205078|wu lun ru he;
无理取闹__無理取鬧 206.376433771|wu li qu nao;
物理学家__物理學家 200.795341333|wu li xue jia;
武林外传__武林外傳 310.194118206|wu lin wai zhuan;
物流管理__物流管理 122.127521944|wu liu guan li;
物流公司__物流公司 148.334184528|wu liu gong si;
物流企业__物流企業 173.121277629|wu liu qi ye;
物流中心__物流中心 178.822323044|wu liu zhong xin;
乌鲁木齐__烏魯木齊 748.624851411|wu lu mu qi;
无关紧要__無關緊要 216.11485651|wu guan jin yao;
五个方面__五個方面 155.140277726|wu ge fang mian;
务工人员__務工人員 105.558392399|wu gong ren yuan;
无可挑剔__無可挑剔 137.476305203|wu ke tiao ti;
无可奈何__無可奈何 480.991159713|wu ke nai he;
无可厚非__無可厚非 328.495108513|wu ke hou fei;
无可救药__無可救藥 125.522047856|wu ke jiu yao;
五花八门__五花八門 313.69268222|wu hua ba men;
武汉大学__武漢大學 347.875829952|wu han da xue;
五湖四海__五湖四海 117.93965545|wu hu si hai;
无稽之谈__無稽之談 105.558392399|wu ji zhi tan;
无济于事__無濟於事 185.172044961|wu ji yu shi;
无家可归__無家可歸 151.510141313|wu jia ke gui;
物价指数__物價指數 119.716577729|wu jia zhi shu;
物价上涨__物價上漲 234.056997396|wu jia shang zhang;
五角大楼__五角大樓 189.608710238|wu jiao da lou;
武警部队__武警部隊 106.748946222|wu jing bu dui;
无精打采__無精打采 114.179614083|wu jing da cai;
无拘无束__無拘無束 144.863304286|wu ju wu shu;
无期徒刑__無期徒刑 142.891090816|wu qi tu xing;
武器装备__武器裝備 247.866011137|wu qi zhuang bei;
无穷无尽__無窮無盡 146.679837233|wu qiong wu jin;
武侠小说__武俠小說 288.205701591|wu xia xiao shuo;
无线通信__無線通信 116.333988795|wu xian tong xin;
无线上网__無線上網 238.176261728|wu xian shang wang;
无线网络__無線網絡 461.037428991|wu xian wang luo;
无线网卡__無線網卡 375.819106356|wu xian wang ka;
无懈可击__無懈可擊 120.916041011|wu xie ke ji;
五星红旗__五星紅旗 153.41002317|wu xing hong qi;
无形资产__無形資產 276.249600432|wu xing zi chan;
武装力量__武裝力量 116.769717326|wu zhuang li liang;
物质基础__物質基礎 177.490254874|wu zhi ji chu;
物质生活__物質生活 173.121277629|wu zhi sheng huo;
物质文明__物質文明 149.447435764|wu zhi wen ming;
五中全会__五中全會 160.649084484|wu zhong quan hui;
无中生有__無中生有 143.963491517|wu zhong sheng you;
无产阶级__無產階級 390.135034682|wu chan jie ji;
无偿献血__無償獻血 124.431860131|wu chang xian xue;
无处不在__無處不在 419.377126323|wu chu bu zai;
无声无息__無聲無息 182.878811433|wu sheng wu xi;
五十年代__五十年代 143.247667161|wu shi nian dai;
物是人非__物是人非 122.432284019|wu shi ren fei;
无时无刻__無時無刻 220.19257551|wu shi wu ke;
污水处理__污水處理 288.565077751|wu shui chu li;
污染防治__污染防治 160.049619219|wu ran fang zhi;
污染环境__污染環境 132.762114633|wu ran huan jing;
污染治理__污染治理 123.197520618|wu ran zhi li;
误人子弟__誤人子弟 110.401782066|wu ren zi di;
无人问津__無人問津 124.587019602|wu ren wen jin;
五彩缤纷__五彩繽紛 135.267109459|wu cai bin fen;
五次会议__五次會議 180.389043185|wu ci hui yi;
无私奉献__無私奉獻 181.516526012|wu si feng xian;
无所不能__無所不能 148.149450567|wu suo bu neng;
无所不在__無所不在 119.26985293|wu suo bu zai;
无所事事__無所事事 359.331706043|wu suo shi shi;
无所适从__無所適從 211.848489234|wu suo shi cong;
无缘无故__無緣無故 305.209408115|wu yuan wu gu;
无怨无悔__無怨無悔 206.119414554|wu yuan wu hui;
五颜六色__五顏六色 200.29551561|wu yan liu se;
乌烟瘴气__烏煙瘴氣 108.222318063|wu yan zhang qi;
无言以对__無言以對 105.295633316|wu yan yi dui;
物业服务__物業服務 141.29744947|wu ye fu wu;
物业管理__物業管理 741.198640518|wu ye guan li;
物业公司__物業公司 417.812212206|wu ye gong si;
五一期间__五一期間 154.561368684|wu yi qi jian;
五一长假__五一長假 134.594525802|wu yi chang jia;
无影无踪__無影無蹤 200.795341333|wu ying wu zong;
物有所值__物有所值 132.431639237|wu you suo zhi;
无忧无虑__無憂無慮 300.679263607|wu you wu lv;
毋庸置疑__毋庸置疑 195.60878915|wu yong zhi yi;
无与伦比__無與倫比 277.976239008|wu yu lun bi;
舞文弄墨__舞文弄墨 127.73116145|wu wen nong mo;
无微不至__無微不至 168.439513167|wu wei bu zhi;
阿迪达斯__阿迪達斯 181.742866823|a di da si;
阿拉伯人__阿拉伯人 139.200207879|a la bo ren;
阿拉法特__阿拉法特 177.269210225|a la fa te;
阿拉斯加__阿拉斯加 135.267109459|a la si jia;
阿里巴巴__阿里巴巴 1786.58668154|a li ba ba;
阿根廷队__阿根廷隊 130.954650472|a gen ting dui;
阿司匹林__阿司匹林 121.823518492|a si pi lin;
啊啊啊啊__啊啊啊啊 638.24912322|a a a a;
阿尔卡特__阿爾卡特 248.794392378|a er ka te;
阿尔斯通__阿爾斯通 181.742866823|a er si tong;
爱不释手__愛不釋手 191.508436159|ai bu shi shou;
埃里克森__埃里克森 106.350610398|ai li ke sen;
爱国主义__愛國主義 302.935867929|ai guo zhu yi;
爱情故事__愛情故事 544.825488702|ai qing gu shi;
爱上一个__愛上一個 107.282382453|ai shang yi ge;
艾泽拉斯__艾澤拉斯 122.432284019|ai ze la si;
爱一个人__愛一個人 646.252534205|ai yi ge ren;
埃因霍温__埃因霍溫 111.091824605|ai yin huo wen;
爱因斯坦__愛因斯坦 460.463257431|ai yin si tan;
按部就班__按部就班 190.318888971|an bu jiu ban;
按捺不住__按捺不住 136.282292017|an na bu zhu;
案例分析__案例分析 161.250795044|an li fen xi;
按揭贷款__按揭貸款 159.253810404|an jie dai kuan;
安居乐业__安居樂業 161.250795044|an ju le ye;
安全保障__安全保障 208.964318904|an quan bao zhang;
安全方面__安全方面 108.627664361|an quan fang mian;
安全防范__安全防範 138.335571213|an quan fang fan;
安全防护__安全防護 138.680779525|an quan fang hu;
安全第一__安全第一 136.112567367|an quan di yi;
安全漏洞__安全漏洞 137.134095104|an quan lou dong;
安全管理__安全管理 354.881620091|an quan guan li;
安全工作__安全工作 195.852702213|an quan gong zuo;
安全可靠__安全可靠 167.393257695|an quan ke kao;
安全技术__安全技術 136.622376491|an quan ji shu;
安全监管__安全監管 159.055477247|an quan jian guan;
安全检查__安全檢查 162.258658377|an quan jian cha;
安全教育__安全教育 116.18910757|an quan jiao yu;
安全气囊__安全氣囊 142.357889859|an quan qi nang;
安全性能__安全性能 153.601316766|an quan xing neng;
安全生产__安全生產 1282.5196677|an quan sheng chan;
安全事故__安全事故 270.122027271|an quan shi gu;
安全措施__安全措施 165.114314527|an quan cuo shi;
安全意识__安全意識 154.176629937|an quan yi shi;
安全隐患__安全隱患 465.65665114|an quan yin huan;
安全问题__安全問題 457.603107852|an quan wen ti;
安全卫士__安全衛士 387.711726118|an quan wei shi;
安切洛蒂__安切洛蒂 122.127521944|an qie luo di;
暗箱操作__暗箱操作 107.684208225|an xiang cao zuo;
安装目录__安裝目錄 155.527421199|an zhuang mu lu;
安装过程__安裝過程 179.268563673|an zhuang guo cheng;
安装程序__安裝程序 363.384474622|an zhuang cheng xu;
安装文件__安裝文件 157.870654598|an zhuang wen jian;
按照规定__按照規定 282.516174301|an zhao gui ding;
安然无恙__安然無恙 110.677283245|an ran wu yang;
安安静静__安安靜靜 156.694657831|an an jing jing;
澳大利亚__澳大利亞 2596.48046905|ao da li ya;
奥林巴斯__奧林巴斯 272.149298879|ao lin ba si;
奥林匹克__奧林匹克 644.643863216|ao lin pi ke;
奥运冠军__奧運冠軍 184.941433485|ao yun guan jun;
奥运火炬__奧運火炬 217.19480623|ao yun huo ju;
奥运场馆__奧運場館 139.200207879|ao yun chang guan;
奥运圣火__奧運聖火 187.26053154|ao yun sheng huo;
阿弥陀佛__阿彌陀佛 296.216358865|e mi tuo fo;
俄罗斯人__俄羅斯人 179.045304336|e luo si ren;
厄瓜多尔__厄瓜多爾 144.502706249|e gua duo er;
恶性竞争__惡性競爭 146.314717429|e xing jing zheng;
恶性循环__惡性循環 259.238974004|e xing xun huan;
恶性肿瘤__惡性腫瘤 251.287110964|e xing zhong liu;
恶意软件__惡意軟件 222.121753798|e yi ruan jian;
鄂尔多斯__鄂爾多斯 152.457122789|e er duo si;
耳目一新__耳目一新 239.963779681|er mu yi xin;
二分之一__二分之一 124.587019602|er fen zhi yi;
儿童医院__兒童醫院 131.281440129|er tong yi yuan;
二话不说__二話不說 141.473639374|er hua bu shuo;
二级缓存__二級緩存 159.85029497|er ji huan cun;
二级市场__二級市場 584.204365283|er ji shi chang;
二级域名__二級域名 113.895394799|er ji yu ming;
二期工程__二期工程 207.407719521|er qi gong cheng;
二十世纪__二十世紀 336.785179346|er shi shi ji;
耳熟能详__耳熟能詳 228.8653107|er shu neng xiang;
二次开发__二次開發 126.306596357|er ci kai fa;
二氧化碳__二氧化碳 532.740555233|er yang hua tan;
二氧化硫__二氧化硫 196.831399718|er yang hua liu;
欧美国家__歐美國家 141.29744947|ou mei guo jia;
欧洲国家__歐洲國家 193.90988203|ou zhou guo jia;
欧洲市场__歐洲市場 170.551683166|ou zhou shi chang`;

export { words };
